/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.router = undefined;
	
	var _vue = __webpack_require__(212);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(711);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueDoctitle = __webpack_require__(634);
	
	var _vueDoctitle2 = _interopRequireDefault(_vueDoctitle);
	
	var _vueResource = __webpack_require__(710);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueSortable = __webpack_require__(712);
	
	var _vueSortable2 = _interopRequireDefault(_vueSortable);
	
	var _accounting = __webpack_require__(102);
	
	var _accounting2 = _interopRequireDefault(_accounting);
	
	var _vueValidator = __webpack_require__(731);
	
	var _vueValidator2 = _interopRequireDefault(_vueValidator);
	
	var _es6Promise = __webpack_require__(598);
	
	var _es6Promise2 = _interopRequireDefault(_es6Promise);
	
	var _vueLazyload = __webpack_require__(675);
	
	var _vueLazyload2 = _interopRequireDefault(_vueLazyload);
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	__webpack_require__(612);
	
	__webpack_require__(610);
	
	__webpack_require__(276);
	
	__webpack_require__(614);
	
	__webpack_require__(613);
	
	__webpack_require__(611);
	
	var _jquery = __webpack_require__(10);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _App = __webpack_require__(676);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Hello = __webpack_require__(684);
	
	var _Hello2 = _interopRequireDefault(_Hello);
	
	var _Gastenboek = __webpack_require__(683);
	
	var _Gastenboek2 = _interopRequireDefault(_Gastenboek);
	
	var _About = __webpack_require__(677);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Product = __webpack_require__(685);
	
	var _Product2 = _interopRequireDefault(_Product);
	
	var _Categorie = __webpack_require__(678);
	
	var _Categorie2 = _interopRequireDefault(_Categorie);
	
	var _login = __webpack_require__(702);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _order = __webpack_require__(707);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _Search = __webpack_require__(686);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _algemeneVoorwaarden = __webpack_require__(690);
	
	var _algemeneVoorwaarden2 = _interopRequireDefault(_algemeneVoorwaarden);
	
	var _giftService = __webpack_require__(691);
	
	var _giftService2 = _interopRequireDefault(_giftService);
	
	var _paying = __webpack_require__(692);
	
	var _paying2 = _interopRequireDefault(_paying);
	
	var _shipping = __webpack_require__(693);
	
	var _shipping2 = _interopRequireDefault(_shipping);
	
	var _betalen = __webpack_require__(687);
	
	var _betalen2 = _interopRequireDefault(_betalen);
	
	var _betalingSuccesvol = __webpack_require__(689);
	
	var _betalingSuccesvol2 = _interopRequireDefault(_betalingSuccesvol);
	
	var _betalingGeannuleerd = __webpack_require__(688);
	
	var _betalingGeannuleerd2 = _interopRequireDefault(_betalingGeannuleerd);
	
	var _dashboard = __webpack_require__(698);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _addProduct = __webpack_require__(695);
	
	var _addProduct2 = _interopRequireDefault(_addProduct);
	
	var _addEditRubrics = __webpack_require__(694);
	
	var _addEditRubrics2 = _interopRequireDefault(_addEditRubrics);
	
	var _adminconfig = __webpack_require__(696);
	
	var _adminconfig2 = _interopRequireDefault(_adminconfig);
	
	var _guestbook = __webpack_require__(699);
	
	var _guestbook2 = _interopRequireDefault(_guestbook);
	
	var _orderOverzicht = __webpack_require__(700);
	
	var _orderOverzicht2 = _interopRequireDefault(_orderOverzicht);
	
	var _analytics = __webpack_require__(697);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_es6Promise2.default.polyfill();
	
	window.$ = _jquery2.default;
	__webpack_provided_window_dot_jQuery = _jquery2.default;
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueDoctitle2.default);
	_vue2.default.use(_vueSortable2.default);
	_vue2.default.use(_vueValidator2.default);
	_vue2.default.use(_vueLazyload2.default, { loading: './assets/img/ajax_loader.gif' });
	
	_vue2.default.directive('echarts', __webpack_require__(233));
	
	_vue2.default.filter('currencyDisplay', {
	  read: function read(val) {
	    return _accounting2.default.formatMoney(val, '€ ', 2, '.', ',');
	  },
	
	  write: function write(val, oldVal) {
	    return _accounting2.default.unformat(val, ',');
	  }
	});
	
	function generateSlug(value) {
	  return value.toLowerCase().replace(/-+/g, '').replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
	}
	
	_vue2.default.filter('slugurl', generateSlug);
	
	_vue2.default.validator('email', function (val) {
	  return (/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(val)
	  );
	});
	
	_vue2.default.validator('dutchzip', function (val) {
	  return (/^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i.test(val)
	  );
	});
	
	_vue2.default.validator('housenumber', function (val) {
	  return (/^\d+[a-zA-Z]*$/.test(val)
	  );
	});
	var router = exports.router = new _vueRouter2.default({
	  hashbang: false,
	  history: true,
	  mode: 'html5',
	  linkActiveClass: 'active' });
	
	_vueDoctitle2.default.wrap(router, { defTitle: 'Catootjes kraam', filter: function filter(title) {
	    return 'Catootjes kraam - ' + title;
	  } });
	
	router.map({
	  '/': {
	    name: 'Welkom',
	    component: _Hello2.default,
	    doctitle: 'Welkom'
	  },
	  '/index': {
	    name: 'Welkom',
	    component: _Hello2.default,
	    doctitle: 'Welkom'
	  },
	  '/gastenboek': {
	    name: 'Gastenboek',
	    component: _Gastenboek2.default,
	    doctitle: 'Gastenboek'
	
	  },
	  'over-ons': {
	    name: 'about-us',
	    component: _About2.default,
	    doctitle: 'Over Ons'
	  },
	  '/categorie/:id/:cname': {
	    name: 'categorie',
	    component: _Categorie2.default
	  },
	  '/product/:id/:pname': {
	    name: 'Product',
	    component: _Product2.default
	  },
	
	  '/klantenservice/algemene-voorwaarden': {
	    name: 'algemeneVoorwaarden',
	    component: _algemeneVoorwaarden2.default,
	    doctitle: 'Algemene Voorwaarden'
	  },
	  '/klantenservice/kado-service': {
	    name: 'giftService',
	    component: _giftService2.default,
	    doctitle: 'Kado Service'
	  },
	  '/klantenservice/betaling': {
	    name: 'paying',
	    component: _paying2.default,
	    doctitle: 'Betaling'
	  },
	  '/klantenservice/verzenden-en-ophalen': {
	    name: 'shipping',
	    component: _shipping2.default,
	    doctitle: 'Verzenden en Ophalen'
	  },
	  '/login': {
	    name: 'Login',
	    component: _login2.default
	  },
	  '/bestelling': {
	    name: 'order',
	    component: _order2.default
	  },
	  '/search/:term': {
	    name: 'Search',
	    component: _Search2.default
	  },
	  '/betalen/:burl': {
	    name: 'Betalen',
	    component: _betalen2.default
	  },
	  '/bevestiging/:burl/:date': {
	    name: 'Bevestiging',
	    component: _betalingSuccesvol2.default
	  },
	  '/annulering': {
	    name: 'Annulering',
	    component: _betalingGeannuleerd2.default
	  },
	
	  '/dashboard': {
	    name: 'Dashboard',
	    component: _dashboard2.default,
	    auth: true,
	    doctitle: 'Dashboard'
	  },
	  '/addProduct': {
	    name: 'AddProduct',
	    component: _addProduct2.default,
	    auth: true,
	    doctitle: 'Nieuw Product'
	  },
	  '/addProduct/:id': {
	    name: 'AddProduct',
	    component: _addProduct2.default,
	    auth: true,
	    doctitle: 'Product Aanpassen'
	  },
	  '/addRubrics': {
	    name: 'addRubrics',
	    component: _addEditRubrics2.default,
	    auth: true,
	    doctitle: 'Nieuw Rubriek'
	  },
	  '/banner': {
	    name: 'banner',
	    component: _adminconfig2.default,
	    auth: true,
	    doctitle: 'Banner'
	  },
	  '/admin-gastenboek': {
	    name: 'admin-gastenboek',
	    component: _guestbook2.default,
	    auth: true,
	    doctitle: 'Gastenboek goedkeuren'
	  },
	  '/admin-order-overzicht': {
	    name: 'admin-order-overzicht',
	    component: _orderOverzicht2.default,
	    auth: true,
	    doctitle: 'Overzicht orders'
	  },
	  '/admin-gebruikers-overzicht': {
	    name: 'admin-gebruikers-overzicht',
	    component: _analytics2.default,
	    auth: true,
	    doctitle: 'Overzicht Gebruikers'
	  }
	});
	
	router.beforeEach(function (transition) {
	  window.scrollTo(0, 0);
	  var isAuthenticated = _store2.default.isLoggedIn();
	  if (transition.to.auth && !isAuthenticated) {
	    transition.redirect('/login?path=' + transition.to.path);
	  } else {
	    transition.next();
	  }
	});
	
	router.start(_App2.default, 'app');
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	/**
	 * @module zrender/core/util
	 */
	// 用于处理merge时无法遍历Date等对象的问题
	var BUILTIN_OBJECT = {
	  '[object Function]': 1,
	  '[object RegExp]': 1,
	  '[object Date]': 1,
	  '[object Error]': 1,
	  '[object CanvasGradient]': 1,
	  '[object CanvasPattern]': 1,
	  // For node-canvas
	  '[object Image]': 1,
	  '[object Canvas]': 1
	};
	var TYPED_ARRAY = {
	  '[object Int8Array]': 1,
	  '[object Uint8Array]': 1,
	  '[object Uint8ClampedArray]': 1,
	  '[object Int16Array]': 1,
	  '[object Uint16Array]': 1,
	  '[object Int32Array]': 1,
	  '[object Uint32Array]': 1,
	  '[object Float32Array]': 1,
	  '[object Float64Array]': 1
	};
	var objToString = Object.prototype.toString;
	var arrayProto = Array.prototype;
	var nativeForEach = arrayProto.forEach;
	var nativeFilter = arrayProto.filter;
	var nativeSlice = arrayProto.slice;
	var nativeMap = arrayProto.map;
	var nativeReduce = arrayProto.reduce; // Avoid assign to an exported variable, for transforming to cjs.
	
	var methods = {};
	
	function $override(name, fn) {
	  methods[name] = fn;
	}
	/**
	 * Those data types can be cloned:
	 *     Plain object, Array, TypedArray, number, string, null, undefined.
	 * Those data types will be assgined using the orginal data:
	 *     BUILTIN_OBJECT
	 * Instance of user defined class will be cloned to a plain object, without
	 * properties in prototype.
	 * Other data types is not supported (not sure what will happen).
	 *
	 * Caution: do not support clone Date, for performance consideration.
	 * (There might be a large number of date in `series.data`).
	 * So date should not be modified in and out of echarts.
	 *
	 * @param {*} source
	 * @return {*} new
	 */
	
	
	function clone(source) {
	  if (source == null || typeof source != 'object') {
	    return source;
	  }
	
	  var result = source;
	  var typeStr = objToString.call(source);
	
	  if (typeStr === '[object Array]') {
	    result = [];
	
	    for (var i = 0, len = source.length; i < len; i++) {
	      result[i] = clone(source[i]);
	    }
	  } else if (TYPED_ARRAY[typeStr]) {
	    var Ctor = source.constructor;
	
	    if (source.constructor.from) {
	      result = Ctor.from(source);
	    } else {
	      result = new Ctor(source.length);
	
	      for (var i = 0, len = source.length; i < len; i++) {
	        result[i] = clone(source[i]);
	      }
	    }
	  } else if (!BUILTIN_OBJECT[typeStr] && !isPrimitive(source) && !isDom(source)) {
	    result = {};
	
	    for (var key in source) {
	      if (source.hasOwnProperty(key)) {
	        result[key] = clone(source[key]);
	      }
	    }
	  }
	
	  return result;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} target
	 * @param {*} source
	 * @param {boolean} [overwrite=false]
	 */
	
	
	function merge(target, source, overwrite) {
	  // We should escapse that source is string
	  // and enter for ... in ...
	  if (!isObject(source) || !isObject(target)) {
	    return overwrite ? clone(source) : target;
	  }
	
	  for (var key in source) {
	    if (source.hasOwnProperty(key)) {
	      var targetProp = target[key];
	      var sourceProp = source[key];
	
	      if (isObject(sourceProp) && isObject(targetProp) && !isArray(sourceProp) && !isArray(targetProp) && !isDom(sourceProp) && !isDom(targetProp) && !isBuiltInObject(sourceProp) && !isBuiltInObject(targetProp) && !isPrimitive(sourceProp) && !isPrimitive(targetProp)) {
	        // 如果需要递归覆盖，就递归调用merge
	        merge(targetProp, sourceProp, overwrite);
	      } else if (overwrite || !(key in target)) {
	        // 否则只处理overwrite为true，或者在目标对象中没有此属性的情况
	        // NOTE，在 target[key] 不存在的时候也是直接覆盖
	        target[key] = clone(source[key], true);
	      }
	    }
	  }
	
	  return target;
	}
	/**
	 * @param {Array} targetAndSources The first item is target, and the rests are source.
	 * @param {boolean} [overwrite=false]
	 * @return {*} target
	 */
	
	
	function mergeAll(targetAndSources, overwrite) {
	  var result = targetAndSources[0];
	
	  for (var i = 1, len = targetAndSources.length; i < len; i++) {
	    result = merge(result, targetAndSources[i], overwrite);
	  }
	
	  return result;
	}
	/**
	 * @param {*} target
	 * @param {*} source
	 * @memberOf module:zrender/core/util
	 */
	
	
	function extend(target, source) {
	  for (var key in source) {
	    if (source.hasOwnProperty(key)) {
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	/**
	 * @param {*} target
	 * @param {*} source
	 * @param {boolean} [overlay=false]
	 * @memberOf module:zrender/core/util
	 */
	
	
	function defaults(target, source, overlay) {
	  for (var key in source) {
	    if (source.hasOwnProperty(key) && (overlay ? source[key] != null : target[key] == null)) {
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	var createCanvas = function () {
	  return methods.createCanvas();
	};
	
	methods.createCanvas = function () {
	  return document.createElement('canvas');
	}; // FIXME
	
	
	var _ctx;
	
	function getContext() {
	  if (!_ctx) {
	    // Use util.createCanvas instead of createCanvas
	    // because createCanvas may be overwritten in different environment
	    _ctx = createCanvas().getContext('2d');
	  }
	
	  return _ctx;
	}
	/**
	 * 查询数组中元素的index
	 * @memberOf module:zrender/core/util
	 */
	
	
	function indexOf(array, value) {
	  if (array) {
	    if (array.indexOf) {
	      return array.indexOf(value);
	    }
	
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === value) {
	        return i;
	      }
	    }
	  }
	
	  return -1;
	}
	/**
	 * 构造类继承关系
	 *
	 * @memberOf module:zrender/core/util
	 * @param {Function} clazz 源类
	 * @param {Function} baseClazz 基类
	 */
	
	
	function inherits(clazz, baseClazz) {
	  var clazzPrototype = clazz.prototype;
	
	  function F() {}
	
	  F.prototype = baseClazz.prototype;
	  clazz.prototype = new F();
	
	  for (var prop in clazzPrototype) {
	    clazz.prototype[prop] = clazzPrototype[prop];
	  }
	
	  clazz.prototype.constructor = clazz;
	  clazz.superClass = baseClazz;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Object|Function} target
	 * @param {Object|Function} sorce
	 * @param {boolean} overlay
	 */
	
	
	function mixin(target, source, overlay) {
	  target = 'prototype' in target ? target.prototype : target;
	  source = 'prototype' in source ? source.prototype : source;
	  defaults(target, source, overlay);
	}
	/**
	 * Consider typed array.
	 * @param {Array|TypedArray} data
	 */
	
	
	function isArrayLike(data) {
	  if (!data) {
	    return;
	  }
	
	  if (typeof data == 'string') {
	    return false;
	  }
	
	  return typeof data.length == 'number';
	}
	/**
	 * 数组或对象遍历
	 * @memberOf module:zrender/core/util
	 * @param {Object|Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 */
	
	
	function each(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.forEach && obj.forEach === nativeForEach) {
	    obj.forEach(cb, context);
	  } else if (obj.length === +obj.length) {
	    for (var i = 0, len = obj.length; i < len; i++) {
	      cb.call(context, obj[i], i, obj);
	    }
	  } else {
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        cb.call(context, obj[key], key, obj);
	      }
	    }
	  }
	}
	/**
	 * 数组映射
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function map(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.map && obj.map === nativeMap) {
	    return obj.map(cb, context);
	  } else {
	    var result = [];
	
	    for (var i = 0, len = obj.length; i < len; i++) {
	      result.push(cb.call(context, obj[i], i, obj));
	    }
	
	    return result;
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {Object} [memo]
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function reduce(obj, cb, memo, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.reduce && obj.reduce === nativeReduce) {
	    return obj.reduce(cb, memo, context);
	  } else {
	    for (var i = 0, len = obj.length; i < len; i++) {
	      memo = cb.call(context, memo, obj[i], i, obj);
	    }
	
	    return memo;
	  }
	}
	/**
	 * 数组过滤
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function filter(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.filter && obj.filter === nativeFilter) {
	    return obj.filter(cb, context);
	  } else {
	    var result = [];
	
	    for (var i = 0, len = obj.length; i < len; i++) {
	      if (cb.call(context, obj[i], i, obj)) {
	        result.push(obj[i]);
	      }
	    }
	
	    return result;
	  }
	}
	/**
	 * 数组项查找
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {*}
	 */
	
	
	function find(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  for (var i = 0, len = obj.length; i < len; i++) {
	    if (cb.call(context, obj[i], i, obj)) {
	      return obj[i];
	    }
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Function} func
	 * @param {*} context
	 * @return {Function}
	 */
	
	
	function bind(func, context) {
	  var args = nativeSlice.call(arguments, 2);
	  return function () {
	    return func.apply(context, args.concat(nativeSlice.call(arguments)));
	  };
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Function} func
	 * @return {Function}
	 */
	
	
	function curry(func) {
	  var args = nativeSlice.call(arguments, 1);
	  return function () {
	    return func.apply(this, args.concat(nativeSlice.call(arguments)));
	  };
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isArray(value) {
	  return objToString.call(value) === '[object Array]';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isFunction(value) {
	  return typeof value === 'function';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isString(value) {
	  return objToString.call(value) === '[object String]';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return type === 'function' || !!value && type == 'object';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isBuiltInObject(value) {
	  return !!BUILTIN_OBJECT[objToString.call(value)];
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isDom(value) {
	  return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
	}
	/**
	 * Whether is exactly NaN. Notice isNaN('a') returns true.
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function eqNaN(value) {
	  return value !== value;
	}
	/**
	 * If value1 is not null, then return value1, otherwise judget rest of values.
	 * Low performance.
	 * @memberOf module:zrender/core/util
	 * @return {*} Final value
	 */
	
	
	function retrieve(values) {
	  for (var i = 0, len = arguments.length; i < len; i++) {
	    if (arguments[i] != null) {
	      return arguments[i];
	    }
	  }
	}
	
	function retrieve2(value0, value1) {
	  return value0 != null ? value0 : value1;
	}
	
	function retrieve3(value0, value1, value2) {
	  return value0 != null ? value0 : value1 != null ? value1 : value2;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Array} arr
	 * @param {number} startIndex
	 * @param {number} endIndex
	 * @return {Array}
	 */
	
	
	function slice() {
	  return Function.call.apply(nativeSlice, arguments);
	}
	/**
	 * Normalize css liked array configuration
	 * e.g.
	 *  3 => [3, 3, 3, 3]
	 *  [4, 2] => [4, 2, 4, 2]
	 *  [4, 3, 2] => [4, 3, 2, 3]
	 * @param {number|Array.<number>} val
	 * @return {Array.<number>}
	 */
	
	
	function normalizeCssArray(val) {
	  if (typeof val === 'number') {
	    return [val, val, val, val];
	  }
	
	  var len = val.length;
	
	  if (len === 2) {
	    // vertical | horizontal
	    return [val[0], val[1], val[0], val[1]];
	  } else if (len === 3) {
	    // top | horizontal | bottom
	    return [val[0], val[1], val[2], val[1]];
	  }
	
	  return val;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {boolean} condition
	 * @param {string} message
	 */
	
	
	function assert(condition, message) {
	  if (!condition) {
	    throw new Error(message);
	  }
	}
	
	var primitiveKey = '__ec_primitive__';
	/**
	 * Set an object as primitive to be ignored traversing children in clone or merge
	 */
	
	function setAsPrimitive(obj) {
	  obj[primitiveKey] = true;
	}
	
	function isPrimitive(obj) {
	  return obj[primitiveKey];
	}
	/**
	 * @constructor
	 * @param {Object} obj Only apply `ownProperty`.
	 */
	
	
	function HashMap(obj) {
	  obj && each(obj, function (value, key) {
	    this.set(key, value);
	  }, this);
	} // Add prefix to avoid conflict with Object.prototype.
	
	
	var HASH_MAP_PREFIX = '_ec_';
	var HASH_MAP_PREFIX_LENGTH = 4;
	HashMap.prototype = {
	  constructor: HashMap,
	  // Do not provide `has` method to avoid defining what is `has`.
	  // (We usually treat `null` and `undefined` as the same, different
	  // from ES6 Map).
	  get: function (key) {
	    return this[HASH_MAP_PREFIX + key];
	  },
	  set: function (key, value) {
	    this[HASH_MAP_PREFIX + key] = value; // Comparing with invocation chaining, `return value` is more commonly
	    // used in this case: `var someVal = map.set('a', genVal());`
	
	    return value;
	  },
	  // Although util.each can be performed on this hashMap directly, user
	  // should not use the exposed keys, who are prefixed.
	  each: function (cb, context) {
	    context !== void 0 && (cb = bind(cb, context));
	
	    for (var prefixedKey in this) {
	      this.hasOwnProperty(prefixedKey) && cb(this[prefixedKey], prefixedKey.slice(HASH_MAP_PREFIX_LENGTH));
	    }
	  },
	  // Do not use this method if performance sensitive.
	  removeKey: function (key) {
	    delete this[HASH_MAP_PREFIX + key];
	  }
	};
	
	function createHashMap(obj) {
	  return new HashMap(obj);
	}
	
	function noop() {}
	
	exports.$override = $override;
	exports.clone = clone;
	exports.merge = merge;
	exports.mergeAll = mergeAll;
	exports.extend = extend;
	exports.defaults = defaults;
	exports.createCanvas = createCanvas;
	exports.getContext = getContext;
	exports.indexOf = indexOf;
	exports.inherits = inherits;
	exports.mixin = mixin;
	exports.isArrayLike = isArrayLike;
	exports.each = each;
	exports.map = map;
	exports.reduce = reduce;
	exports.filter = filter;
	exports.find = find;
	exports.bind = bind;
	exports.curry = curry;
	exports.isArray = isArray;
	exports.isFunction = isFunction;
	exports.isString = isString;
	exports.isObject = isObject;
	exports.isBuiltInObject = isBuiltInObject;
	exports.isDom = isDom;
	exports.eqNaN = eqNaN;
	exports.retrieve = retrieve;
	exports.retrieve2 = retrieve2;
	exports.retrieve3 = retrieve3;
	exports.slice = slice;
	exports.normalizeCssArray = normalizeCssArray;
	exports.assert = assert;
	exports.setAsPrimitive = setAsPrimitive;
	exports.isPrimitive = isPrimitive;
	exports.createHashMap = createHashMap;
	exports.noop = noop;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var zrender = __webpack_require__(101);
	
	var zrUtil = __webpack_require__(1);
	
	var colorTool = __webpack_require__(31);
	
	var env = __webpack_require__(18);
	
	var timsort = __webpack_require__(137);
	
	var Eventful = __webpack_require__(49);
	
	var GlobalModel = __webpack_require__(582);
	
	var ExtensionAPI = __webpack_require__(346);
	
	var CoordinateSystemManager = __webpack_require__(26);
	
	var OptionManager = __webpack_require__(583);
	
	var backwardCompat = __webpack_require__(590);
	
	var ComponentModel = __webpack_require__(16);
	
	var SeriesModel = __webpack_require__(20);
	
	var ComponentView = __webpack_require__(131);
	
	var ChartView = __webpack_require__(37);
	
	var graphic = __webpack_require__(3);
	
	var modelUtil = __webpack_require__(6);
	
	var _throttle = __webpack_require__(45);
	
	var throttle = _throttle.throttle;
	
	var seriesColor = __webpack_require__(597);
	
	var loadingDefault = __webpack_require__(581);
	
	/*!
	 * ECharts, a javascript interactive chart library.
	 *
	 * Copyright (c) 2015, Baidu Inc.
	 * All rights reserved.
	 *
	 * LICENSE
	 * https://github.com/ecomfe/echarts/blob/master/LICENSE.txt
	 */
	var each = zrUtil.each;
	var parseClassType = ComponentModel.parseClassType;
	var version = '3.8.5';
	var dependencies = {
	  zrender: '3.7.4'
	};
	var PRIORITY_PROCESSOR_FILTER = 1000;
	var PRIORITY_PROCESSOR_STATISTIC = 5000;
	var PRIORITY_VISUAL_LAYOUT = 1000;
	var PRIORITY_VISUAL_GLOBAL = 2000;
	var PRIORITY_VISUAL_CHART = 3000;
	var PRIORITY_VISUAL_COMPONENT = 4000; // FIXME
	// necessary?
	
	var PRIORITY_VISUAL_BRUSH = 5000;
	var PRIORITY = {
	  PROCESSOR: {
	    FILTER: PRIORITY_PROCESSOR_FILTER,
	    STATISTIC: PRIORITY_PROCESSOR_STATISTIC
	  },
	  VISUAL: {
	    LAYOUT: PRIORITY_VISUAL_LAYOUT,
	    GLOBAL: PRIORITY_VISUAL_GLOBAL,
	    CHART: PRIORITY_VISUAL_CHART,
	    COMPONENT: PRIORITY_VISUAL_COMPONENT,
	    BRUSH: PRIORITY_VISUAL_BRUSH
	  }
	}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
	// where they must not be invoked nestedly, except the only case: invoke
	// dispatchAction with updateMethod "none" in main process.
	// This flag is used to carry out this rule.
	// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
	
	var IN_MAIN_PROCESS = '__flagInMainProcess';
	var HAS_GRADIENT_OR_PATTERN_BG = '__hasGradientOrPatternBg';
	var OPTION_UPDATED = '__optionUpdated';
	var ACTION_REG = /^[a-zA-Z0-9_]+$/;
	
	function createRegisterEventWithLowercaseName(method) {
	  return function (eventName, handler, context) {
	    // Event name is all lowercase
	    eventName = eventName && eventName.toLowerCase();
	    Eventful.prototype[method].call(this, eventName, handler, context);
	  };
	}
	/**
	 * @module echarts~MessageCenter
	 */
	
	
	function MessageCenter() {
	  Eventful.call(this);
	}
	
	MessageCenter.prototype.on = createRegisterEventWithLowercaseName('on');
	MessageCenter.prototype.off = createRegisterEventWithLowercaseName('off');
	MessageCenter.prototype.one = createRegisterEventWithLowercaseName('one');
	zrUtil.mixin(MessageCenter, Eventful);
	/**
	 * @module echarts~ECharts
	 */
	
	function ECharts(dom, theme, opts) {
	  opts = opts || {}; // Get theme by name
	
	  if (typeof theme === 'string') {
	    theme = themeStorage[theme];
	  }
	  /**
	   * @type {string}
	   */
	
	
	  this.id;
	  /**
	   * Group id
	   * @type {string}
	   */
	
	  this.group;
	  /**
	   * @type {HTMLElement}
	   * @private
	   */
	
	  this._dom = dom;
	  var defaultRenderer = 'canvas';
	
	  /**
	   * @type {module:zrender/ZRender}
	   * @private
	   */
	  var zr = this._zr = zrender.init(dom, {
	    renderer: opts.renderer || defaultRenderer,
	    devicePixelRatio: opts.devicePixelRatio,
	    width: opts.width,
	    height: opts.height
	  });
	  /**
	   * Expect 60 pfs.
	   * @type {Function}
	   * @private
	   */
	
	  this._throttledZrFlush = throttle(zrUtil.bind(zr.flush, zr), 17);
	  var theme = zrUtil.clone(theme);
	  theme && backwardCompat(theme, true);
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._theme = theme;
	  /**
	   * @type {Array.<module:echarts/view/Chart>}
	   * @private
	   */
	
	  this._chartsViews = [];
	  /**
	   * @type {Object.<string, module:echarts/view/Chart>}
	   * @private
	   */
	
	  this._chartsMap = {};
	  /**
	   * @type {Array.<module:echarts/view/Component>}
	   * @private
	   */
	
	  this._componentsViews = [];
	  /**
	   * @type {Object.<string, module:echarts/view/Component>}
	   * @private
	   */
	
	  this._componentsMap = {};
	  /**
	   * @type {module:echarts/CoordinateSystem}
	   * @private
	   */
	
	  this._coordSysMgr = new CoordinateSystemManager();
	  /**
	   * @type {module:echarts/ExtensionAPI}
	   * @private
	   */
	
	  this._api = createExtensionAPI(this);
	  Eventful.call(this);
	  /**
	   * @type {module:echarts~MessageCenter}
	   * @private
	   */
	
	  this._messageCenter = new MessageCenter(); // Init mouse events
	
	  this._initEvents(); // In case some people write `window.onresize = chart.resize`
	
	
	  this.resize = zrUtil.bind(this.resize, this); // Can't dispatch action during rendering procedure
	
	  this._pendingActions = []; // Sort on demand
	
	  function prioritySortFunc(a, b) {
	    return a.prio - b.prio;
	  }
	
	  timsort(visualFuncs, prioritySortFunc);
	  timsort(dataProcessorFuncs, prioritySortFunc);
	  zr.animation.on('frame', this._onframe, this); // ECharts instance can be used as value.
	
	  zrUtil.setAsPrimitive(this);
	}
	
	var echartsProto = ECharts.prototype;
	
	echartsProto._onframe = function () {
	  // Lazy update
	  if (this[OPTION_UPDATED]) {
	    var silent = this[OPTION_UPDATED].silent;
	    this[IN_MAIN_PROCESS] = true;
	    updateMethods.prepareAndUpdate.call(this);
	    this[IN_MAIN_PROCESS] = false;
	    this[OPTION_UPDATED] = false;
	    flushPendingActions.call(this, silent);
	    triggerUpdatedEvent.call(this, silent);
	  }
	};
	/**
	 * @return {HTMLElement}
	 */
	
	
	echartsProto.getDom = function () {
	  return this._dom;
	};
	/**
	 * @return {module:zrender~ZRender}
	 */
	
	
	echartsProto.getZr = function () {
	  return this._zr;
	};
	/**
	 * Usage:
	 * chart.setOption(option, notMerge, lazyUpdate);
	 * chart.setOption(option, {
	 *     notMerge: ...,
	 *     lazyUpdate: ...,
	 *     silent: ...
	 * });
	 *
	 * @param {Object} option
	 * @param {Object|boolean} [opts] opts or notMerge.
	 * @param {boolean} [opts.notMerge=false]
	 * @param {boolean} [opts.lazyUpdate=false] Useful when setOption frequently.
	 */
	
	
	echartsProto.setOption = function (option, notMerge, lazyUpdate) {
	  var silent;
	
	  if (zrUtil.isObject(notMerge)) {
	    lazyUpdate = notMerge.lazyUpdate;
	    silent = notMerge.silent;
	    notMerge = notMerge.notMerge;
	  }
	
	  this[IN_MAIN_PROCESS] = true;
	
	  if (!this._model || notMerge) {
	    var optionManager = new OptionManager(this._api);
	    var theme = this._theme;
	    var ecModel = this._model = new GlobalModel(null, null, theme, optionManager);
	    ecModel.init(null, null, theme, optionManager);
	  }
	
	  this._model.setOption(option, optionPreprocessorFuncs);
	
	  if (lazyUpdate) {
	    this[OPTION_UPDATED] = {
	      silent: silent
	    };
	    this[IN_MAIN_PROCESS] = false;
	  } else {
	    updateMethods.prepareAndUpdate.call(this); // Ensure zr refresh sychronously, and then pixel in canvas can be
	    // fetched after `setOption`.
	
	    this._zr.flush();
	
	    this[OPTION_UPDATED] = false;
	    this[IN_MAIN_PROCESS] = false;
	    flushPendingActions.call(this, silent);
	    triggerUpdatedEvent.call(this, silent);
	  }
	};
	/**
	 * @DEPRECATED
	 */
	
	
	echartsProto.setTheme = function () {
	  console.log('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
	};
	/**
	 * @return {module:echarts/model/Global}
	 */
	
	
	echartsProto.getModel = function () {
	  return this._model;
	};
	/**
	 * @return {Object}
	 */
	
	
	echartsProto.getOption = function () {
	  return this._model && this._model.getOption();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getWidth = function () {
	  return this._zr.getWidth();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getHeight = function () {
	  return this._zr.getHeight();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getDevicePixelRatio = function () {
	  return this._zr.painter.dpr || window.devicePixelRatio || 1;
	};
	/**
	 * Get canvas which has all thing rendered
	 * @param {Object} opts
	 * @param {string} [opts.backgroundColor]
	 * @return {string}
	 */
	
	
	echartsProto.getRenderedCanvas = function (opts) {
	  if (!env.canvasSupported) {
	    return;
	  }
	
	  opts = opts || {};
	  opts.pixelRatio = opts.pixelRatio || 1;
	  opts.backgroundColor = opts.backgroundColor || this._model.get('backgroundColor');
	  var zr = this._zr;
	  var list = zr.storage.getDisplayList(); // Stop animations
	
	  zrUtil.each(list, function (el) {
	    el.stopAnimation(true);
	  });
	  return zr.painter.getRenderedCanvas(opts);
	};
	/**
	 * Get svg data url
	 * @return {string}
	 */
	
	
	echartsProto.getSvgDataUrl = function () {
	  if (!env.svgSupported) {
	    return;
	  }
	
	  var zr = this._zr;
	  var list = zr.storage.getDisplayList(); // Stop animations
	
	  zrUtil.each(list, function (el) {
	    el.stopAnimation(true);
	  });
	  return zr.painter.pathToSvg();
	};
	/**
	 * @return {string}
	 * @param {Object} opts
	 * @param {string} [opts.type='png']
	 * @param {string} [opts.pixelRatio=1]
	 * @param {string} [opts.backgroundColor]
	 * @param {string} [opts.excludeComponents]
	 */
	
	
	echartsProto.getDataURL = function (opts) {
	  opts = opts || {};
	  var excludeComponents = opts.excludeComponents;
	  var ecModel = this._model;
	  var excludesComponentViews = [];
	  var self = this;
	  each(excludeComponents, function (componentType) {
	    ecModel.eachComponent({
	      mainType: componentType
	    }, function (component) {
	      var view = self._componentsMap[component.__viewId];
	
	      if (!view.group.ignore) {
	        excludesComponentViews.push(view);
	        view.group.ignore = true;
	      }
	    });
	  });
	  var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataUrl() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
	  each(excludesComponentViews, function (view) {
	    view.group.ignore = false;
	  });
	  return url;
	};
	/**
	 * @return {string}
	 * @param {Object} opts
	 * @param {string} [opts.type='png']
	 * @param {string} [opts.pixelRatio=1]
	 * @param {string} [opts.backgroundColor]
	 */
	
	
	echartsProto.getConnectedDataURL = function (opts) {
	  if (!env.canvasSupported) {
	    return;
	  }
	
	  var groupId = this.group;
	  var mathMin = Math.min;
	  var mathMax = Math.max;
	  var MAX_NUMBER = Infinity;
	
	  if (connectedGroups[groupId]) {
	    var left = MAX_NUMBER;
	    var top = MAX_NUMBER;
	    var right = -MAX_NUMBER;
	    var bottom = -MAX_NUMBER;
	    var canvasList = [];
	    var dpr = opts && opts.pixelRatio || 1;
	    zrUtil.each(instances, function (chart, id) {
	      if (chart.group === groupId) {
	        var canvas = chart.getRenderedCanvas(zrUtil.clone(opts));
	        var boundingRect = chart.getDom().getBoundingClientRect();
	        left = mathMin(boundingRect.left, left);
	        top = mathMin(boundingRect.top, top);
	        right = mathMax(boundingRect.right, right);
	        bottom = mathMax(boundingRect.bottom, bottom);
	        canvasList.push({
	          dom: canvas,
	          left: boundingRect.left,
	          top: boundingRect.top
	        });
	      }
	    });
	    left *= dpr;
	    top *= dpr;
	    right *= dpr;
	    bottom *= dpr;
	    var width = right - left;
	    var height = bottom - top;
	    var targetCanvas = zrUtil.createCanvas();
	    targetCanvas.width = width;
	    targetCanvas.height = height;
	    var zr = zrender.init(targetCanvas);
	    each(canvasList, function (item) {
	      var img = new graphic.Image({
	        style: {
	          x: item.left * dpr - left,
	          y: item.top * dpr - top,
	          image: item.dom
	        }
	      });
	      zr.add(img);
	    });
	    zr.refreshImmediately();
	    return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
	  } else {
	    return this.getDataURL(opts);
	  }
	};
	/**
	 * Convert from logical coordinate system to pixel coordinate system.
	 * See CoordinateSystem#convertToPixel.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId, geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName,
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {Array|number} result
	 */
	
	
	echartsProto.convertToPixel = zrUtil.curry(doConvertPixel, 'convertToPixel');
	/**
	 * Convert from pixel coordinate system to logical coordinate system.
	 * See CoordinateSystem#convertFromPixel.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId / geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {Array|number} result
	 */
	
	echartsProto.convertFromPixel = zrUtil.curry(doConvertPixel, 'convertFromPixel');
	
	function doConvertPixel(methodName, finder, value) {
	  var ecModel = this._model;
	
	  var coordSysList = this._coordSysMgr.getCoordinateSystems();
	
	  var result;
	  finder = modelUtil.parseFinder(ecModel, finder);
	
	  for (var i = 0; i < coordSysList.length; i++) {
	    var coordSys = coordSysList[i];
	
	    if (coordSys[methodName] && (result = coordSys[methodName](ecModel, finder, value)) != null) {
	      return result;
	    }
	  }
	}
	/**
	 * Is the specified coordinate systems or components contain the given pixel point.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId / geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName,
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {boolean} result
	 */
	
	
	echartsProto.containPixel = function (finder, value) {
	  var ecModel = this._model;
	  var result;
	  finder = modelUtil.parseFinder(ecModel, finder);
	  zrUtil.each(finder, function (models, key) {
	    key.indexOf('Models') >= 0 && zrUtil.each(models, function (model) {
	      var coordSys = model.coordinateSystem;
	
	      if (coordSys && coordSys.containPoint) {
	        result |= !!coordSys.containPoint(value);
	      } else if (key === 'seriesModels') {
	        var view = this._chartsMap[model.__viewId];
	
	        if (view && view.containPoint) {
	          result |= view.containPoint(value, model);
	        } else {}
	      } else {}
	    }, this);
	  }, this);
	  return !!result;
	};
	/**
	 * Get visual from series or data.
	 * @param {string|Object} finder
	 *        If string, e.g., 'series', means {seriesIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            dataIndex / dataIndexInside
	 *        }
	 *        If dataIndex is not specified, series visual will be fetched,
	 *        but not data item visual.
	 *        If all of seriesIndex, seriesId, seriesName are not specified,
	 *        visual will be fetched from first series.
	 * @param {string} visualType 'color', 'symbol', 'symbolSize'
	 */
	
	
	echartsProto.getVisual = function (finder, visualType) {
	  var ecModel = this._model;
	  finder = modelUtil.parseFinder(ecModel, finder, {
	    defaultMainType: 'series'
	  });
	  var seriesModel = finder.seriesModel;
	  var data = seriesModel.getData();
	  var dataIndexInside = finder.hasOwnProperty('dataIndexInside') ? finder.dataIndexInside : finder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(finder.dataIndex) : null;
	  return dataIndexInside != null ? data.getItemVisual(dataIndexInside, visualType) : data.getVisual(visualType);
	};
	/**
	 * Get view of corresponding component model
	 * @param  {module:echarts/model/Component} componentModel
	 * @return {module:echarts/view/Component}
	 */
	
	
	echartsProto.getViewOfComponentModel = function (componentModel) {
	  return this._componentsMap[componentModel.__viewId];
	};
	/**
	 * Get view of corresponding series model
	 * @param  {module:echarts/model/Series} seriesModel
	 * @return {module:echarts/view/Chart}
	 */
	
	
	echartsProto.getViewOfSeriesModel = function (seriesModel) {
	  return this._chartsMap[seriesModel.__viewId];
	};
	
	var updateMethods = {
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  update: function (payload) {
	    // console.profile && console.profile('update');
	    var ecModel = this._model;
	    var api = this._api;
	    var coordSysMgr = this._coordSysMgr;
	    var zr = this._zr; // update before setOption
	
	    if (!ecModel) {
	      return;
	    } // Fixme First time update ?
	
	
	    ecModel.restoreData(); // TODO
	    // Save total ecModel here for undo/redo (after restoring data and before processing data).
	    // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
	    // Create new coordinate system each update
	    // In LineView may save the old coordinate system and use it to get the orignal point
	
	    coordSysMgr.create(this._model, this._api);
	    processData.call(this, ecModel, api);
	    stackSeriesData.call(this, ecModel);
	    coordSysMgr.update(ecModel, api);
	    doVisualEncoding.call(this, ecModel, payload);
	    doRender.call(this, ecModel, payload); // Set background
	
	    var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
	    var painter = zr.painter; // TODO all use clearColor ?
	
	    if (painter.isSingleCanvas && painter.isSingleCanvas()) {
	      zr.configLayer(0, {
	        clearColor: backgroundColor
	      });
	    } else {
	      // In IE8
	      if (!env.canvasSupported) {
	        var colorArr = colorTool.parse(backgroundColor);
	        backgroundColor = colorTool.stringify(colorArr, 'rgb');
	
	        if (colorArr[3] === 0) {
	          backgroundColor = 'transparent';
	        }
	      }
	
	      if (backgroundColor.colorStops || backgroundColor.image) {
	        // Gradient background
	        // FIXME Fixed layer？
	        zr.configLayer(0, {
	          clearColor: backgroundColor
	        });
	        this[HAS_GRADIENT_OR_PATTERN_BG] = true;
	        this._dom.style.background = 'transparent';
	      } else {
	        if (this[HAS_GRADIENT_OR_PATTERN_BG]) {
	          zr.configLayer(0, {
	            clearColor: null
	          });
	        }
	
	        this[HAS_GRADIENT_OR_PATTERN_BG] = false;
	        this._dom.style.background = backgroundColor;
	      }
	    }
	
	    each(postUpdateFuncs, function (func) {
	      func(ecModel, api);
	    }); // console.profile && console.profileEnd('update');
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateView: function (payload) {
	    var ecModel = this._model; // update before setOption
	
	    if (!ecModel) {
	      return;
	    }
	
	    ecModel.eachSeries(function (seriesModel) {
	      seriesModel.getData().clearAllVisual();
	    });
	    doVisualEncoding.call(this, ecModel, payload);
	    invokeUpdateMethod.call(this, 'updateView', ecModel, payload);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateVisual: function (payload) {
	    var ecModel = this._model; // update before setOption
	
	    if (!ecModel) {
	      return;
	    }
	
	    ecModel.eachSeries(function (seriesModel) {
	      seriesModel.getData().clearAllVisual();
	    });
	    doVisualEncoding.call(this, ecModel, payload, true);
	    invokeUpdateMethod.call(this, 'updateVisual', ecModel, payload);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateLayout: function (payload) {
	    var ecModel = this._model; // update before setOption
	
	    if (!ecModel) {
	      return;
	    }
	
	    doLayout.call(this, ecModel, payload);
	    invokeUpdateMethod.call(this, 'updateLayout', ecModel, payload);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  prepareAndUpdate: function (payload) {
	    var ecModel = this._model;
	    prepareView.call(this, 'component', ecModel);
	    prepareView.call(this, 'chart', ecModel);
	    updateMethods.update.call(this, payload);
	  }
	};
	/**
	 * @private
	 */
	
	function updateDirectly(ecIns, method, payload, mainType, subType) {
	  var ecModel = ecIns._model; // broadcast
	
	  if (!mainType) {
	    each(ecIns._componentsViews.concat(ecIns._chartsViews), callView);
	    return;
	  }
	
	  var query = {};
	  query[mainType + 'Id'] = payload[mainType + 'Id'];
	  query[mainType + 'Index'] = payload[mainType + 'Index'];
	  query[mainType + 'Name'] = payload[mainType + 'Name'];
	  var condition = {
	    mainType: mainType,
	    query: query
	  };
	  subType && (condition.subType = subType); // subType may be '' by parseClassType;
	  // If dispatchAction before setOption, do nothing.
	
	  ecModel && ecModel.eachComponent(condition, function (model, index) {
	    callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
	  }, ecIns);
	
	  function callView(view) {
	    view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
	  }
	}
	/**
	 * Resize the chart
	 * @param {Object} opts
	 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
	 * @param {boolean} [opts.silent=false]
	 */
	
	
	echartsProto.resize = function (opts) {
	  this[IN_MAIN_PROCESS] = true;
	
	  this._zr.resize(opts);
	
	  var optionChanged = this._model && this._model.resetOption('media');
	
	  var updateMethod = optionChanged ? 'prepareAndUpdate' : 'update';
	  updateMethods[updateMethod].call(this); // Resize loading effect
	
	  this._loadingFX && this._loadingFX.resize();
	  this[IN_MAIN_PROCESS] = false;
	  var silent = opts && opts.silent;
	  flushPendingActions.call(this, silent);
	  triggerUpdatedEvent.call(this, silent);
	};
	/**
	 * Show loading effect
	 * @param  {string} [name='default']
	 * @param  {Object} [cfg]
	 */
	
	
	echartsProto.showLoading = function (name, cfg) {
	  if (zrUtil.isObject(name)) {
	    cfg = name;
	    name = '';
	  }
	
	  name = name || 'default';
	  this.hideLoading();
	
	  if (!loadingEffects[name]) {
	    return;
	  }
	
	  var el = loadingEffects[name](this._api, cfg);
	  var zr = this._zr;
	  this._loadingFX = el;
	  zr.add(el);
	};
	/**
	 * Hide loading effect
	 */
	
	
	echartsProto.hideLoading = function () {
	  this._loadingFX && this._zr.remove(this._loadingFX);
	  this._loadingFX = null;
	};
	/**
	 * @param {Object} eventObj
	 * @return {Object}
	 */
	
	
	echartsProto.makeActionFromEvent = function (eventObj) {
	  var payload = zrUtil.extend({}, eventObj);
	  payload.type = eventActionMap[eventObj.type];
	  return payload;
	};
	/**
	 * @pubilc
	 * @param {Object} payload
	 * @param {string} [payload.type] Action type
	 * @param {Object|boolean} [opt] If pass boolean, means opt.silent
	 * @param {boolean} [opt.silent=false] Whether trigger events.
	 * @param {boolean} [opt.flush=undefined]
	 *                  true: Flush immediately, and then pixel in canvas can be fetched
	 *                      immediately. Caution: it might affect performance.
	 *                  false: Not not flush.
	 *                  undefined: Auto decide whether perform flush.
	 */
	
	
	echartsProto.dispatchAction = function (payload, opt) {
	  if (!zrUtil.isObject(opt)) {
	    opt = {
	      silent: !!opt
	    };
	  }
	
	  if (!actions[payload.type]) {
	    return;
	  } // Avoid dispatch action before setOption. Especially in `connect`.
	
	
	  if (!this._model) {
	    return;
	  } // May dispatchAction in rendering procedure
	
	
	  if (this[IN_MAIN_PROCESS]) {
	    this._pendingActions.push(payload);
	
	    return;
	  }
	
	  doDispatchAction.call(this, payload, opt.silent);
	
	  if (opt.flush) {
	    this._zr.flush(true);
	  } else if (opt.flush !== false && env.browser.weChat) {
	    // In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
	    // hang when sliding page (on touch event), which cause that zr does not
	    // refresh util user interaction finished, which is not expected.
	    // But `dispatchAction` may be called too frequently when pan on touch
	    // screen, which impacts performance if do not throttle them.
	    this._throttledZrFlush();
	  }
	
	  flushPendingActions.call(this, opt.silent);
	  triggerUpdatedEvent.call(this, opt.silent);
	};
	
	function doDispatchAction(payload, silent) {
	  var payloadType = payload.type;
	  var escapeConnect = payload.escapeConnect;
	  var actionWrap = actions[payloadType];
	  var actionInfo = actionWrap.actionInfo;
	  var cptType = (actionInfo.update || 'update').split(':');
	  var updateMethod = cptType.pop();
	  cptType = cptType[0] != null && parseClassType(cptType[0]);
	  this[IN_MAIN_PROCESS] = true;
	  var payloads = [payload];
	  var batched = false; // Batch action
	
	  if (payload.batch) {
	    batched = true;
	    payloads = zrUtil.map(payload.batch, function (item) {
	      item = zrUtil.defaults(zrUtil.extend({}, item), payload);
	      item.batch = null;
	      return item;
	    });
	  }
	
	  var eventObjBatch = [];
	  var eventObj;
	  var isHighDown = payloadType === 'highlight' || payloadType === 'downplay';
	  each(payloads, function (batchItem) {
	    // Action can specify the event by return it.
	    eventObj = actionWrap.action(batchItem, this._model, this._api); // Emit event outside
	
	    eventObj = eventObj || zrUtil.extend({}, batchItem); // Convert type to eventType
	
	    eventObj.type = actionInfo.event || eventObj.type;
	    eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.
	
	    if (isHighDown) {
	      // method, payload, mainType, subType
	      updateDirectly(this, updateMethod, batchItem, 'series');
	    } else if (cptType) {
	      updateDirectly(this, updateMethod, batchItem, cptType.main, cptType.sub);
	    }
	  }, this);
	
	  if (updateMethod !== 'none' && !isHighDown && !cptType) {
	    // Still dirty
	    if (this[OPTION_UPDATED]) {
	      // FIXME Pass payload ?
	      updateMethods.prepareAndUpdate.call(this, payload);
	      this[OPTION_UPDATED] = false;
	    } else {
	      updateMethods[updateMethod].call(this, payload);
	    }
	  } // Follow the rule of action batch
	
	
	  if (batched) {
	    eventObj = {
	      type: actionInfo.event || payloadType,
	      escapeConnect: escapeConnect,
	      batch: eventObjBatch
	    };
	  } else {
	    eventObj = eventObjBatch[0];
	  }
	
	  this[IN_MAIN_PROCESS] = false;
	  !silent && this._messageCenter.trigger(eventObj.type, eventObj);
	}
	
	function flushPendingActions(silent) {
	  var pendingActions = this._pendingActions;
	
	  while (pendingActions.length) {
	    var payload = pendingActions.shift();
	    doDispatchAction.call(this, payload, silent);
	  }
	}
	
	function triggerUpdatedEvent(silent) {
	  !silent && this.trigger('updated');
	}
	/**
	 * Register event
	 * @method
	 */
	
	
	echartsProto.on = createRegisterEventWithLowercaseName('on');
	echartsProto.off = createRegisterEventWithLowercaseName('off');
	echartsProto.one = createRegisterEventWithLowercaseName('one');
	/**
	 * @param {string} methodName
	 * @private
	 */
	
	function invokeUpdateMethod(methodName, ecModel, payload) {
	  var api = this._api; // Update all components
	
	  each(this._componentsViews, function (component) {
	    var componentModel = component.__model;
	    component[methodName](componentModel, ecModel, api, payload);
	    updateZ(componentModel, component);
	  }, this); // Upate all charts
	
	  ecModel.eachSeries(function (seriesModel, idx) {
	    var chart = this._chartsMap[seriesModel.__viewId];
	    chart[methodName](seriesModel, ecModel, api, payload);
	    updateZ(seriesModel, chart);
	    updateProgressiveAndBlend(seriesModel, chart);
	  }, this); // If use hover layer
	
	  updateHoverLayerStatus(this._zr, ecModel); // Post render
	
	  each(postUpdateFuncs, function (func) {
	    func(ecModel, api);
	  });
	}
	/**
	 * Prepare view instances of charts and components
	 * @param  {module:echarts/model/Global} ecModel
	 * @private
	 */
	
	
	function prepareView(type, ecModel) {
	  var isComponent = type === 'component';
	  var viewList = isComponent ? this._componentsViews : this._chartsViews;
	  var viewMap = isComponent ? this._componentsMap : this._chartsMap;
	  var zr = this._zr;
	
	  for (var i = 0; i < viewList.length; i++) {
	    viewList[i].__alive = false;
	  }
	
	  ecModel[isComponent ? 'eachComponent' : 'eachSeries'](function (componentType, model) {
	    if (isComponent) {
	      if (componentType === 'series') {
	        return;
	      }
	    } else {
	      model = componentType;
	    } // Consider: id same and type changed.
	
	
	    var viewId = '_ec_' + model.id + '_' + model.type;
	    var view = viewMap[viewId];
	
	    if (!view) {
	      var classType = parseClassType(model.type);
	      var Clazz = isComponent ? ComponentView.getClass(classType.main, classType.sub) : ChartView.getClass(classType.sub);
	
	      if (Clazz) {
	        view = new Clazz();
	        view.init(ecModel, this._api);
	        viewMap[viewId] = view;
	        viewList.push(view);
	        zr.add(view.group);
	      } else {
	        // Error
	        return;
	      }
	    }
	
	    model.__viewId = view.__id = viewId;
	    view.__alive = true;
	    view.__model = model;
	    view.group.__ecComponentInfo = {
	      mainType: model.mainType,
	      index: model.componentIndex
	    };
	  }, this);
	
	  for (var i = 0; i < viewList.length;) {
	    var view = viewList[i];
	
	    if (!view.__alive) {
	      zr.remove(view.group);
	      view.dispose(ecModel, this._api);
	      viewList.splice(i, 1);
	      delete viewMap[view.__id];
	      view.__id = view.group.__ecComponentInfo = null;
	    } else {
	      i++;
	    }
	  }
	}
	/**
	 * Processor data in each series
	 *
	 * @param {module:echarts/model/Global} ecModel
	 * @private
	 */
	
	
	function processData(ecModel, api) {
	  each(dataProcessorFuncs, function (process) {
	    process.func(ecModel, api);
	  });
	}
	/**
	 * @private
	 */
	
	
	function stackSeriesData(ecModel) {
	  var stackedDataMap = {};
	  ecModel.eachSeries(function (series) {
	    var stack = series.get('stack');
	    var data = series.getData();
	
	    if (stack && data.type === 'list') {
	      var previousStack = stackedDataMap[stack]; // Avoid conflict with Object.prototype
	
	      if (stackedDataMap.hasOwnProperty(stack) && previousStack) {
	        data.stackedOn = previousStack;
	      }
	
	      stackedDataMap[stack] = data;
	    }
	  });
	}
	/**
	 * Layout before each chart render there series, special visual encoding stage
	 *
	 * @param {module:echarts/model/Global} ecModel
	 * @private
	 */
	
	
	function doLayout(ecModel, payload) {
	  var api = this._api;
	  each(visualFuncs, function (visual) {
	    if (visual.isLayout) {
	      visual.func(ecModel, api, payload);
	    }
	  });
	}
	/**
	 * Encode visual infomation from data after data processing
	 *
	 * @param {module:echarts/model/Global} ecModel
	 * @param {object} layout
	 * @param {boolean} [excludesLayout]
	 * @private
	 */
	
	
	function doVisualEncoding(ecModel, payload, excludesLayout) {
	  var api = this._api;
	  ecModel.clearColorPalette();
	  ecModel.eachSeries(function (seriesModel) {
	    seriesModel.clearColorPalette();
	  });
	  each(visualFuncs, function (visual) {
	    (!excludesLayout || !visual.isLayout) && visual.func(ecModel, api, payload);
	  });
	}
	/**
	 * Render each chart and component
	 * @private
	 */
	
	
	function doRender(ecModel, payload) {
	  var api = this._api; // Render all components
	
	  each(this._componentsViews, function (componentView) {
	    var componentModel = componentView.__model;
	    componentView.render(componentModel, ecModel, api, payload);
	    updateZ(componentModel, componentView);
	  }, this);
	  each(this._chartsViews, function (chart) {
	    chart.__alive = false;
	  }, this); // Render all charts
	
	  ecModel.eachSeries(function (seriesModel, idx) {
	    var chartView = this._chartsMap[seriesModel.__viewId];
	    chartView.__alive = true;
	    chartView.render(seriesModel, ecModel, api, payload);
	    chartView.group.silent = !!seriesModel.get('silent');
	    updateZ(seriesModel, chartView);
	    updateProgressiveAndBlend(seriesModel, chartView);
	  }, this); // If use hover layer
	
	  updateHoverLayerStatus(this._zr, ecModel); // Remove groups of unrendered charts
	
	  each(this._chartsViews, function (chart) {
	    if (!chart.__alive) {
	      chart.remove(ecModel, api);
	    }
	  }, this);
	}
	
	var MOUSE_EVENT_NAMES = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousemove', 'mousedown', 'mouseup', 'globalout', 'contextmenu'];
	/**
	 * @private
	 */
	
	echartsProto._initEvents = function () {
	  each(MOUSE_EVENT_NAMES, function (eveName) {
	    this._zr.on(eveName, function (e) {
	      var ecModel = this.getModel();
	      var el = e.target;
	      var params; // no e.target when 'globalout'.
	
	      if (eveName === 'globalout') {
	        params = {};
	      } else if (el && el.dataIndex != null) {
	        var dataModel = el.dataModel || ecModel.getSeriesByIndex(el.seriesIndex);
	        params = dataModel && dataModel.getDataParams(el.dataIndex, el.dataType) || {};
	      } // If element has custom eventData of components
	      else if (el && el.eventData) {
	          params = zrUtil.extend({}, el.eventData);
	        }
	
	      if (params) {
	        params.event = e;
	        params.type = eveName;
	        this.trigger(eveName, params);
	      }
	    }, this);
	  }, this);
	  each(eventActionMap, function (actionType, eventType) {
	    this._messageCenter.on(eventType, function (event) {
	      this.trigger(eventType, event);
	    }, this);
	  }, this);
	};
	/**
	 * @return {boolean}
	 */
	
	
	echartsProto.isDisposed = function () {
	  return this._disposed;
	};
	/**
	 * Clear
	 */
	
	
	echartsProto.clear = function () {
	  this.setOption({
	    series: []
	  }, true);
	};
	/**
	 * Dispose instance
	 */
	
	
	echartsProto.dispose = function () {
	  if (this._disposed) {
	    return;
	  }
	
	  this._disposed = true;
	  var api = this._api;
	  var ecModel = this._model;
	  each(this._componentsViews, function (component) {
	    component.dispose(ecModel, api);
	  });
	  each(this._chartsViews, function (chart) {
	    chart.dispose(ecModel, api);
	  }); // Dispose after all views disposed
	
	  this._zr.dispose();
	
	  delete instances[this.id];
	};
	
	zrUtil.mixin(ECharts, Eventful);
	
	function updateHoverLayerStatus(zr, ecModel) {
	  var storage = zr.storage;
	  var elCount = 0;
	  storage.traverse(function (el) {
	    if (!el.isGroup) {
	      elCount++;
	    }
	  });
	
	  if (elCount > ecModel.get('hoverLayerThreshold') && !env.node) {
	    storage.traverse(function (el) {
	      if (!el.isGroup) {
	        el.useHoverLayer = true;
	      }
	    });
	  }
	}
	/**
	 * Update chart progressive and blend.
	 * @param {module:echarts/model/Series|module:echarts/model/Component} model
	 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
	 */
	
	
	function updateProgressiveAndBlend(seriesModel, chartView) {
	  // Progressive configuration
	  var elCount = 0;
	  chartView.group.traverse(function (el) {
	    if (el.type !== 'group' && !el.ignore) {
	      elCount++;
	    }
	  });
	  var frameDrawNum = +seriesModel.get('progressive');
	  var needProgressive = elCount > seriesModel.get('progressiveThreshold') && frameDrawNum && !env.node;
	
	  if (needProgressive) {
	    chartView.group.traverse(function (el) {
	      // FIXME marker and other components
	      if (!el.isGroup) {
	        el.progressive = needProgressive ? Math.floor(elCount++ / frameDrawNum) : -1;
	
	        if (needProgressive) {
	          el.stopAnimation(true);
	        }
	      }
	    });
	  } // Blend configration
	
	
	  var blendMode = seriesModel.get('blendMode') || null;
	  chartView.group.traverse(function (el) {
	    // FIXME marker and other components
	    if (!el.isGroup) {
	      el.setStyle('blend', blendMode);
	    }
	  });
	}
	/**
	 * @param {module:echarts/model/Series|module:echarts/model/Component} model
	 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
	 */
	
	
	function updateZ(model, view) {
	  var z = model.get('z');
	  var zlevel = model.get('zlevel'); // Set z and zlevel
	
	  view.group.traverse(function (el) {
	    if (el.type !== 'group') {
	      z != null && (el.z = z);
	      zlevel != null && (el.zlevel = zlevel);
	    }
	  });
	}
	
	function createExtensionAPI(ecInstance) {
	  var coordSysMgr = ecInstance._coordSysMgr;
	  return zrUtil.extend(new ExtensionAPI(ecInstance), {
	    // Inject methods
	    getCoordinateSystems: zrUtil.bind(coordSysMgr.getCoordinateSystems, coordSysMgr),
	    getComponentByElement: function (el) {
	      while (el) {
	        var modelInfo = el.__ecComponentInfo;
	
	        if (modelInfo != null) {
	          return ecInstance._model.getComponent(modelInfo.mainType, modelInfo.index);
	        }
	
	        el = el.parent;
	      }
	    }
	  });
	}
	/**
	 * @type {Object} key: actionType.
	 * @inner
	 */
	
	
	var actions = {};
	/**
	 * Map eventType to actionType
	 * @type {Object}
	 */
	
	var eventActionMap = {};
	/**
	 * Data processor functions of each stage
	 * @type {Array.<Object.<string, Function>>}
	 * @inner
	 */
	
	var dataProcessorFuncs = [];
	/**
	 * @type {Array.<Function>}
	 * @inner
	 */
	
	var optionPreprocessorFuncs = [];
	/**
	 * @type {Array.<Function>}
	 * @inner
	 */
	
	var postUpdateFuncs = [];
	/**
	 * Visual encoding functions of each stage
	 * @type {Array.<Object.<string, Function>>}
	 * @inner
	 */
	
	var visualFuncs = [];
	/**
	 * Theme storage
	 * @type {Object.<key, Object>}
	 */
	
	var themeStorage = {};
	/**
	 * Loading effects
	 */
	
	var loadingEffects = {};
	var instances = {};
	var connectedGroups = {};
	var idBase = new Date() - 0;
	var groupIdBase = new Date() - 0;
	var DOM_ATTRIBUTE_KEY = '_echarts_instance_';
	var mapDataStores = {};
	
	function enableConnect(chart) {
	  var STATUS_PENDING = 0;
	  var STATUS_UPDATING = 1;
	  var STATUS_UPDATED = 2;
	  var STATUS_KEY = '__connectUpdateStatus';
	
	  function updateConnectedChartsStatus(charts, status) {
	    for (var i = 0; i < charts.length; i++) {
	      var otherChart = charts[i];
	      otherChart[STATUS_KEY] = status;
	    }
	  }
	
	  zrUtil.each(eventActionMap, function (actionType, eventType) {
	    chart._messageCenter.on(eventType, function (event) {
	      if (connectedGroups[chart.group] && chart[STATUS_KEY] !== STATUS_PENDING) {
	        if (event && event.escapeConnect) {
	          return;
	        }
	
	        var action = chart.makeActionFromEvent(event);
	        var otherCharts = [];
	        zrUtil.each(instances, function (otherChart) {
	          if (otherChart !== chart && otherChart.group === chart.group) {
	            otherCharts.push(otherChart);
	          }
	        });
	        updateConnectedChartsStatus(otherCharts, STATUS_PENDING);
	        each(otherCharts, function (otherChart) {
	          if (otherChart[STATUS_KEY] !== STATUS_UPDATING) {
	            otherChart.dispatchAction(action);
	          }
	        });
	        updateConnectedChartsStatus(otherCharts, STATUS_UPDATED);
	      }
	    });
	  });
	}
	/**
	 * @param {HTMLElement} dom
	 * @param {Object} [theme]
	 * @param {Object} opts
	 * @param {number} [opts.devicePixelRatio] Use window.devicePixelRatio by default
	 * @param {string} [opts.renderer] Currently only 'canvas' is supported.
	 * @param {number} [opts.width] Use clientWidth of the input `dom` by default.
	 *                              Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Use clientHeight of the input `dom` by default.
	 *                               Can be 'auto' (the same as null/undefined)
	 */
	
	
	function init(dom, theme, opts) {
	  var existInstance = getInstanceByDom(dom);
	
	  if (existInstance) {
	    return existInstance;
	  }
	
	  var chart = new ECharts(dom, theme, opts);
	  chart.id = 'ec_' + idBase++;
	  instances[chart.id] = chart;
	
	  if (dom.setAttribute) {
	    dom.setAttribute(DOM_ATTRIBUTE_KEY, chart.id);
	  } else {
	    dom[DOM_ATTRIBUTE_KEY] = chart.id;
	  }
	
	  enableConnect(chart);
	  return chart;
	}
	/**
	 * @return {string|Array.<module:echarts~ECharts>} groupId
	 */
	
	
	function connect(groupId) {
	  // Is array of charts
	  if (zrUtil.isArray(groupId)) {
	    var charts = groupId;
	    groupId = null; // If any chart has group
	
	    zrUtil.each(charts, function (chart) {
	      if (chart.group != null) {
	        groupId = chart.group;
	      }
	    });
	    groupId = groupId || 'g_' + groupIdBase++;
	    zrUtil.each(charts, function (chart) {
	      chart.group = groupId;
	    });
	  }
	
	  connectedGroups[groupId] = true;
	  return groupId;
	}
	/**
	 * @DEPRECATED
	 * @return {string} groupId
	 */
	
	
	function disConnect(groupId) {
	  connectedGroups[groupId] = false;
	}
	/**
	 * @return {string} groupId
	 */
	
	
	var disconnect = disConnect;
	/**
	 * Dispose a chart instance
	 * @param  {module:echarts~ECharts|HTMLDomElement|string} chart
	 */
	
	function dispose(chart) {
	  if (typeof chart === 'string') {
	    chart = instances[chart];
	  } else if (!(chart instanceof ECharts)) {
	    // Try to treat as dom
	    chart = getInstanceByDom(chart);
	  }
	
	  if (chart instanceof ECharts && !chart.isDisposed()) {
	    chart.dispose();
	  }
	}
	/**
	 * @param  {HTMLElement} dom
	 * @return {echarts~ECharts}
	 */
	
	
	function getInstanceByDom(dom) {
	  var key;
	
	  if (dom.getAttribute) {
	    key = dom.getAttribute(DOM_ATTRIBUTE_KEY);
	  } else {
	    key = dom[DOM_ATTRIBUTE_KEY];
	  }
	
	  return instances[key];
	}
	/**
	 * @param {string} key
	 * @return {echarts~ECharts}
	 */
	
	
	function getInstanceById(key) {
	  return instances[key];
	}
	/**
	 * Register theme
	 */
	
	
	function registerTheme(name, theme) {
	  themeStorage[name] = theme;
	}
	/**
	 * Register option preprocessor
	 * @param {Function} preprocessorFunc
	 */
	
	
	function registerPreprocessor(preprocessorFunc) {
	  optionPreprocessorFuncs.push(preprocessorFunc);
	}
	/**
	 * @param {number} [priority=1000]
	 * @param {Function} processorFunc
	 */
	
	
	function registerProcessor(priority, processorFunc) {
	  if (typeof priority === 'function') {
	    processorFunc = priority;
	    priority = PRIORITY_PROCESSOR_FILTER;
	  }
	
	  dataProcessorFuncs.push({
	    prio: priority,
	    func: processorFunc
	  });
	}
	/**
	 * Register postUpdater
	 * @param {Function} postUpdateFunc
	 */
	
	
	function registerPostUpdate(postUpdateFunc) {
	  postUpdateFuncs.push(postUpdateFunc);
	}
	/**
	 * Usage:
	 * registerAction('someAction', 'someEvent', function () { ... });
	 * registerAction('someAction', function () { ... });
	 * registerAction(
	 *     {type: 'someAction', event: 'someEvent', update: 'updateView'},
	 *     function () { ... }
	 * );
	 *
	 * @param {(string|Object)} actionInfo
	 * @param {string} actionInfo.type
	 * @param {string} [actionInfo.event]
	 * @param {string} [actionInfo.update]
	 * @param {string} [eventName]
	 * @param {Function} action
	 */
	
	
	function registerAction(actionInfo, eventName, action) {
	  if (typeof eventName === 'function') {
	    action = eventName;
	    eventName = '';
	  }
	
	  var actionType = zrUtil.isObject(actionInfo) ? actionInfo.type : [actionInfo, actionInfo = {
	    event: eventName
	  }][0]; // Event name is all lowercase
	
	  actionInfo.event = (actionInfo.event || actionType).toLowerCase();
	  eventName = actionInfo.event; // Validate action type and event name.
	
	  zrUtil.assert(ACTION_REG.test(actionType) && ACTION_REG.test(eventName));
	
	  if (!actions[actionType]) {
	    actions[actionType] = {
	      action: action,
	      actionInfo: actionInfo
	    };
	  }
	
	  eventActionMap[eventName] = actionType;
	}
	/**
	 * @param {string} type
	 * @param {*} CoordinateSystem
	 */
	
	
	function registerCoordinateSystem(type, CoordinateSystem) {
	  CoordinateSystemManager.register(type, CoordinateSystem);
	}
	/**
	 * Get dimensions of specified coordinate system.
	 * @param {string} type
	 * @return {Array.<string|Object>}
	 */
	
	
	function getCoordinateSystemDimensions(type) {
	  var coordSysCreator = CoordinateSystemManager.get(type);
	
	  if (coordSysCreator) {
	    return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
	  }
	}
	/**
	 * Layout is a special stage of visual encoding
	 * Most visual encoding like color are common for different chart
	 * But each chart has it's own layout algorithm
	 *
	 * @param {number} [priority=1000]
	 * @param {Function} layoutFunc
	 */
	
	
	function registerLayout(priority, layoutFunc) {
	  if (typeof priority === 'function') {
	    layoutFunc = priority;
	    priority = PRIORITY_VISUAL_LAYOUT;
	  }
	
	  visualFuncs.push({
	    prio: priority,
	    func: layoutFunc,
	    isLayout: true
	  });
	}
	/**
	 * @param {number} [priority=3000]
	 * @param {Function} visualFunc
	 */
	
	
	function registerVisual(priority, visualFunc) {
	  if (typeof priority === 'function') {
	    visualFunc = priority;
	    priority = PRIORITY_VISUAL_CHART;
	  }
	
	  visualFuncs.push({
	    prio: priority,
	    func: visualFunc
	  });
	}
	/**
	 * @param {string} name
	 */
	
	
	function registerLoading(name, loadingFx) {
	  loadingEffects[name] = loadingFx;
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendComponentModel(opts
	/*, superClass*/
	) {
	  // var Clazz = ComponentModel;
	  // if (superClass) {
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
	  // }
	  return ComponentModel.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendComponentView(opts
	/*, superClass*/
	) {
	  // var Clazz = ComponentView;
	  // if (superClass) {
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentView.getClass(classType.main, classType.sub, true);
	  // }
	  return ComponentView.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendSeriesModel(opts
	/*, superClass*/
	) {
	  // var Clazz = SeriesModel;
	  // if (superClass) {
	  //     superClass = 'series.' + superClass.replace('series.', '');
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
	  // }
	  return SeriesModel.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendChartView(opts
	/*, superClass*/
	) {
	  // var Clazz = ChartView;
	  // if (superClass) {
	  //     superClass = superClass.replace('series.', '');
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ChartView.getClass(classType.main, true);
	  // }
	  return ChartView.extend(opts);
	}
	/**
	 * ZRender need a canvas context to do measureText.
	 * But in node environment canvas may be created by node-canvas.
	 * So we need to specify how to create a canvas instead of using document.createElement('canvas')
	 *
	 * Be careful of using it in the browser.
	 *
	 * @param {Function} creator
	 * @example
	 *     var Canvas = require('canvas');
	 *     var echarts = require('echarts');
	 *     echarts.setCanvasCreator(function () {
	 *         // Small size is enough.
	 *         return new Canvas(32, 32);
	 *     });
	 */
	
	
	function setCanvasCreator(creator) {
	  zrUtil.$override('createCanvas', creator);
	}
	/**
	 * @param {string} mapName
	 * @param {Object|string} geoJson
	 * @param {Object} [specialAreas]
	 *
	 * @example
	 *     $.get('USA.json', function (geoJson) {
	 *         echarts.registerMap('USA', geoJson);
	 *         // Or
	 *         echarts.registerMap('USA', {
	 *             geoJson: geoJson,
	 *             specialAreas: {}
	 *         })
	 *     });
	 */
	
	
	function registerMap(mapName, geoJson, specialAreas) {
	  if (geoJson.geoJson && !geoJson.features) {
	    specialAreas = geoJson.specialAreas;
	    geoJson = geoJson.geoJson;
	  }
	
	  if (typeof geoJson === 'string') {
	    geoJson = typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(geoJson) : new Function('return (' + geoJson + ');')();
	  }
	
	  mapDataStores[mapName] = {
	    geoJson: geoJson,
	    specialAreas: specialAreas
	  };
	}
	/**
	 * @param {string} mapName
	 * @return {Object}
	 */
	
	
	function getMap(mapName) {
	  return mapDataStores[mapName];
	}
	
	registerVisual(PRIORITY_VISUAL_GLOBAL, seriesColor);
	registerPreprocessor(backwardCompat);
	registerLoading('default', loadingDefault); // Default actions
	
	registerAction({
	  type: 'highlight',
	  event: 'highlight',
	  update: 'highlight'
	}, zrUtil.noop);
	registerAction({
	  type: 'downplay',
	  event: 'downplay',
	  update: 'downplay'
	}, zrUtil.noop); // For backward compatibility, where the namespace `dataTool` will
	// be mounted on `echarts` is the extension `dataTool` is imported.
	
	var dataTool = {};
	exports.version = version;
	exports.dependencies = dependencies;
	exports.PRIORITY = PRIORITY;
	exports.init = init;
	exports.connect = connect;
	exports.disConnect = disConnect;
	exports.disconnect = disconnect;
	exports.dispose = dispose;
	exports.getInstanceByDom = getInstanceByDom;
	exports.getInstanceById = getInstanceById;
	exports.registerTheme = registerTheme;
	exports.registerPreprocessor = registerPreprocessor;
	exports.registerProcessor = registerProcessor;
	exports.registerPostUpdate = registerPostUpdate;
	exports.registerAction = registerAction;
	exports.registerCoordinateSystem = registerCoordinateSystem;
	exports.getCoordinateSystemDimensions = getCoordinateSystemDimensions;
	exports.registerLayout = registerLayout;
	exports.registerVisual = registerVisual;
	exports.registerLoading = registerLoading;
	exports.extendComponentModel = extendComponentModel;
	exports.extendComponentView = extendComponentView;
	exports.extendSeriesModel = extendSeriesModel;
	exports.extendChartView = extendChartView;
	exports.setCanvasCreator = setCanvasCreator;
	exports.registerMap = registerMap;
	exports.getMap = getMap;
	exports.dataTool = dataTool;
	var ___ec_export = __webpack_require__(201);
	(function () {
	    for (var key in ___ec_export) {
	        if (___ec_export.hasOwnProperty(key)) {
	            exports[key] = ___ec_export[key];
	        }
	    }
	})();

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var pathTool = __webpack_require__(764);
	
	var colorTool = __webpack_require__(31);
	
	var matrix = __webpack_require__(23);
	
	var vector = __webpack_require__(8);
	
	var Path = __webpack_require__(19);
	
	var Transformable = __webpack_require__(139);
	
	var Image = __webpack_require__(75);
	
	exports.Image = Image;
	
	var Group = __webpack_require__(97);
	
	exports.Group = Group;
	
	var Text = __webpack_require__(76);
	
	exports.Text = Text;
	
	var Circle = __webpack_require__(751);
	
	exports.Circle = Circle;
	
	var Sector = __webpack_require__(757);
	
	exports.Sector = Sector;
	
	var Ring = __webpack_require__(756);
	
	exports.Ring = Ring;
	
	var Polygon = __webpack_require__(753);
	
	exports.Polygon = Polygon;
	
	var Polyline = __webpack_require__(754);
	
	exports.Polyline = Polyline;
	
	var Rect = __webpack_require__(755);
	
	exports.Rect = Rect;
	
	var Line = __webpack_require__(752);
	
	exports.Line = Line;
	
	var BezierCurve = __webpack_require__(750);
	
	exports.BezierCurve = BezierCurve;
	
	var Arc = __webpack_require__(749);
	
	exports.Arc = Arc;
	
	var CompoundPath = __webpack_require__(745);
	
	exports.CompoundPath = CompoundPath;
	
	var LinearGradient = __webpack_require__(223);
	
	exports.LinearGradient = LinearGradient;
	
	var RadialGradient = __webpack_require__(746);
	
	exports.RadialGradient = RadialGradient;
	
	var BoundingRect = __webpack_require__(13);
	
	exports.BoundingRect = BoundingRect;
	var round = Math.round;
	var mathMax = Math.max;
	var mathMin = Math.min;
	var EMPTY_OBJ = {};
	/**
	 * Extend shape with parameters
	 */
	
	function extendShape(opts) {
	  return Path.extend(opts);
	}
	/**
	 * Extend path
	 */
	
	
	function extendPath(pathData, opts) {
	  return pathTool.extendFromString(pathData, opts);
	}
	/**
	 * Create a path element from path data string
	 * @param {string} pathData
	 * @param {Object} opts
	 * @param {module:zrender/core/BoundingRect} rect
	 * @param {string} [layout=cover] 'center' or 'cover'
	 */
	
	
	function makePath(pathData, opts, rect, layout) {
	  var path = pathTool.createFromString(pathData, opts);
	  var boundingRect = path.getBoundingRect();
	
	  if (rect) {
	    if (layout === 'center') {
	      rect = centerGraphic(rect, boundingRect);
	    }
	
	    resizePath(path, rect);
	  }
	
	  return path;
	}
	/**
	 * Create a image element from image url
	 * @param {string} imageUrl image url
	 * @param {Object} opts options
	 * @param {module:zrender/core/BoundingRect} rect constrain rect
	 * @param {string} [layout=cover] 'center' or 'cover'
	 */
	
	
	function makeImage(imageUrl, rect, layout) {
	  var path = new Image({
	    style: {
	      image: imageUrl,
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    onload: function (img) {
	      if (layout === 'center') {
	        var boundingRect = {
	          width: img.width,
	          height: img.height
	        };
	        path.setStyle(centerGraphic(rect, boundingRect));
	      }
	    }
	  });
	  return path;
	}
	/**
	 * Get position of centered element in bounding box.
	 *
	 * @param  {Object} rect         element local bounding box
	 * @param  {Object} boundingRect constraint bounding box
	 * @return {Object} element position containing x, y, width, and height
	 */
	
	
	function centerGraphic(rect, boundingRect) {
	  // Set rect to center, keep width / height ratio.
	  var aspect = boundingRect.width / boundingRect.height;
	  var width = rect.height * aspect;
	  var height;
	
	  if (width <= rect.width) {
	    height = rect.height;
	  } else {
	    width = rect.width;
	    height = width / aspect;
	  }
	
	  var cx = rect.x + rect.width / 2;
	  var cy = rect.y + rect.height / 2;
	  return {
	    x: cx - width / 2,
	    y: cy - height / 2,
	    width: width,
	    height: height
	  };
	}
	
	var mergePath = pathTool.mergePath;
	/**
	 * Resize a path to fit the rect
	 * @param {module:zrender/graphic/Path} path
	 * @param {Object} rect
	 */
	
	function resizePath(path, rect) {
	  if (!path.applyTransform) {
	    return;
	  }
	
	  var pathRect = path.getBoundingRect();
	  var m = pathRect.calculateTransform(rect);
	  path.applyTransform(m);
	}
	/**
	 * Sub pixel optimize line for canvas
	 *
	 * @param {Object} param
	 * @param {Object} [param.shape]
	 * @param {number} [param.shape.x1]
	 * @param {number} [param.shape.y1]
	 * @param {number} [param.shape.x2]
	 * @param {number} [param.shape.y2]
	 * @param {Object} [param.style]
	 * @param {number} [param.style.lineWidth]
	 * @return {Object} Modified param
	 */
	
	
	function subPixelOptimizeLine(param) {
	  var shape = param.shape;
	  var lineWidth = param.style.lineWidth;
	
	  if (round(shape.x1 * 2) === round(shape.x2 * 2)) {
	    shape.x1 = shape.x2 = subPixelOptimize(shape.x1, lineWidth, true);
	  }
	
	  if (round(shape.y1 * 2) === round(shape.y2 * 2)) {
	    shape.y1 = shape.y2 = subPixelOptimize(shape.y1, lineWidth, true);
	  }
	
	  return param;
	}
	/**
	 * Sub pixel optimize rect for canvas
	 *
	 * @param {Object} param
	 * @param {Object} [param.shape]
	 * @param {number} [param.shape.x]
	 * @param {number} [param.shape.y]
	 * @param {number} [param.shape.width]
	 * @param {number} [param.shape.height]
	 * @param {Object} [param.style]
	 * @param {number} [param.style.lineWidth]
	 * @return {Object} Modified param
	 */
	
	
	function subPixelOptimizeRect(param) {
	  var shape = param.shape;
	  var lineWidth = param.style.lineWidth;
	  var originX = shape.x;
	  var originY = shape.y;
	  var originWidth = shape.width;
	  var originHeight = shape.height;
	  shape.x = subPixelOptimize(shape.x, lineWidth, true);
	  shape.y = subPixelOptimize(shape.y, lineWidth, true);
	  shape.width = Math.max(subPixelOptimize(originX + originWidth, lineWidth, false) - shape.x, originWidth === 0 ? 0 : 1);
	  shape.height = Math.max(subPixelOptimize(originY + originHeight, lineWidth, false) - shape.y, originHeight === 0 ? 0 : 1);
	  return param;
	}
	/**
	 * Sub pixel optimize for canvas
	 *
	 * @param {number} position Coordinate, such as x, y
	 * @param {number} lineWidth Should be nonnegative integer.
	 * @param {boolean=} positiveOrNegative Default false (negative).
	 * @return {number} Optimized position.
	 */
	
	
	function subPixelOptimize(position, lineWidth, positiveOrNegative) {
	  // Assure that (position + lineWidth / 2) is near integer edge,
	  // otherwise line will be fuzzy in canvas.
	  var doubledPosition = round(position * 2);
	  return (doubledPosition + round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
	}
	
	function hasFillOrStroke(fillOrStroke) {
	  return fillOrStroke != null && fillOrStroke != 'none';
	}
	
	function liftColor(color) {
	  return typeof color === 'string' ? colorTool.lift(color, -0.1) : color;
	}
	/**
	 * @private
	 */
	
	
	function cacheElementStl(el) {
	  if (el.__hoverStlDirty) {
	    var stroke = el.style.stroke;
	    var fill = el.style.fill; // Create hoverStyle on mouseover
	
	    var hoverStyle = el.__hoverStl;
	    hoverStyle.fill = hoverStyle.fill || (hasFillOrStroke(fill) ? liftColor(fill) : null);
	    hoverStyle.stroke = hoverStyle.stroke || (hasFillOrStroke(stroke) ? liftColor(stroke) : null);
	    var normalStyle = {};
	
	    for (var name in hoverStyle) {
	      // See comment in `doSingleEnterHover`.
	      if (hoverStyle[name] != null) {
	        normalStyle[name] = el.style[name];
	      }
	    }
	
	    el.__normalStl = normalStyle;
	    el.__hoverStlDirty = false;
	  }
	}
	/**
	 * @private
	 */
	
	
	function doSingleEnterHover(el) {
	  if (el.__isHover) {
	    return;
	  }
	
	  cacheElementStl(el);
	
	  if (el.useHoverLayer) {
	    el.__zr && el.__zr.addHover(el, el.__hoverStl);
	  } else {
	    var style = el.style;
	    var insideRollbackOpt = style.insideRollbackOpt; // Consider case: only `position: 'top'` is set on emphasis, then text
	    // color should be returned to `autoColor`, rather than remain '#fff'.
	    // So we should rollback then apply again after style merging.
	
	    insideRollbackOpt && rollbackInsideStyle(style); // styles can be:
	    // {
	    //     label: {
	    //         normal: {
	    //             show: false,
	    //             position: 'outside',
	    //             fontSize: 18
	    //         },
	    //         emphasis: {
	    //             show: true
	    //         }
	    //     }
	    // },
	    // where properties of `emphasis` may not appear in `normal`. We previously use
	    // module:echarts/util/model#defaultEmphasis to merge `normal` to `emphasis`.
	    // But consider rich text and setOption in merge mode, it is impossible to cover
	    // all properties in merge. So we use merge mode when setting style here, where
	    // only properties that is not `null/undefined` can be set. The disadventage:
	    // null/undefined can not be used to remove style any more in `emphasis`.
	
	    style.extendFrom(el.__hoverStl); // Do not save `insideRollback`.
	
	    if (insideRollbackOpt) {
	      applyInsideStyle(style, style.insideOriginalTextPosition, insideRollbackOpt); // textFill may be rollbacked to null.
	
	      if (style.textFill == null) {
	        style.textFill = insideRollbackOpt.autoColor;
	      }
	    }
	
	    el.dirty(false);
	    el.z2 += 1;
	  }
	
	  el.__isHover = true;
	}
	/**
	 * @inner
	 */
	
	
	function doSingleLeaveHover(el) {
	  if (!el.__isHover) {
	    return;
	  }
	
	  var normalStl = el.__normalStl;
	
	  if (el.useHoverLayer) {
	    el.__zr && el.__zr.removeHover(el);
	  } else {
	    // Consider null/undefined value, should use
	    // `setStyle` but not `extendFrom(stl, true)`.
	    normalStl && el.setStyle(normalStl);
	    el.z2 -= 1;
	  }
	
	  el.__isHover = false;
	}
	/**
	 * @inner
	 */
	
	
	function doEnterHover(el) {
	  el.type === 'group' ? el.traverse(function (child) {
	    if (child.type !== 'group') {
	      doSingleEnterHover(child);
	    }
	  }) : doSingleEnterHover(el);
	}
	
	function doLeaveHover(el) {
	  el.type === 'group' ? el.traverse(function (child) {
	    if (child.type !== 'group') {
	      doSingleLeaveHover(child);
	    }
	  }) : doSingleLeaveHover(el);
	}
	/**
	 * @inner
	 */
	
	
	function setElementHoverStl(el, hoverStl) {
	  // If element has sepcified hoverStyle, then use it instead of given hoverStyle
	  // Often used when item group has a label element and it's hoverStyle is different
	  el.__hoverStl = el.hoverStyle || hoverStl || {};
	  el.__hoverStlDirty = true;
	
	  if (el.__isHover) {
	    cacheElementStl(el);
	  }
	}
	/**
	 * @inner
	 */
	
	
	function onElementMouseOver(e) {
	  if (this.__hoverSilentOnTouch && e.zrByTouch) {
	    return;
	  } // Only if element is not in emphasis status
	
	
	  !this.__isEmphasis && doEnterHover(this);
	}
	/**
	 * @inner
	 */
	
	
	function onElementMouseOut(e) {
	  if (this.__hoverSilentOnTouch && e.zrByTouch) {
	    return;
	  } // Only if element is not in emphasis status
	
	
	  !this.__isEmphasis && doLeaveHover(this);
	}
	/**
	 * @inner
	 */
	
	
	function enterEmphasis() {
	  this.__isEmphasis = true;
	  doEnterHover(this);
	}
	/**
	 * @inner
	 */
	
	
	function leaveEmphasis() {
	  this.__isEmphasis = false;
	  doLeaveHover(this);
	}
	/**
	 * Set hover style of element.
	 * This method can be called repeatly without side-effects.
	 * @param {module:zrender/Element} el
	 * @param {Object} [hoverStyle]
	 * @param {Object} [opt]
	 * @param {boolean} [opt.hoverSilentOnTouch=false]
	 *        In touch device, mouseover event will be trigger on touchstart event
	 *        (see module:zrender/dom/HandlerProxy). By this mechanism, we can
	 *        conviniently use hoverStyle when tap on touch screen without additional
	 *        code for compatibility.
	 *        But if the chart/component has select feature, which usually also use
	 *        hoverStyle, there might be conflict between 'select-highlight' and
	 *        'hover-highlight' especially when roam is enabled (see geo for example).
	 *        In this case, hoverSilentOnTouch should be used to disable hover-highlight
	 *        on touch device.
	 */
	
	
	function setHoverStyle(el, hoverStyle, opt) {
	  el.__hoverSilentOnTouch = opt && opt.hoverSilentOnTouch;
	  el.type === 'group' ? el.traverse(function (child) {
	    if (child.type !== 'group') {
	      setElementHoverStl(child, hoverStyle);
	    }
	  }) : setElementHoverStl(el, hoverStyle); // Duplicated function will be auto-ignored, see Eventful.js.
	
	  el.on('mouseover', onElementMouseOver).on('mouseout', onElementMouseOut); // Emphasis, normal can be triggered manually
	
	  el.on('emphasis', enterEmphasis).on('normal', leaveEmphasis);
	}
	/**
	 * @param {Object|module:zrender/graphic/Style} normalStyle
	 * @param {Object} emphasisStyle
	 * @param {module:echarts/model/Model} normalModel
	 * @param {module:echarts/model/Model} emphasisModel
	 * @param {Object} opt Check `opt` of `setTextStyleCommon` to find other props.
	 * @param {Object} [opt.defaultText]
	 * @param {module:echarts/model/Model} [opt.labelFetcher] Fetch text by
	 *      `opt.labelFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
	 * @param {module:echarts/model/Model} [opt.labelDataIndex] Fetch text by
	 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
	 * @param {module:echarts/model/Model} [opt.labelDimIndex] Fetch text by
	 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
	 * @param {Object} [normalSpecified]
	 * @param {Object} [emphasisSpecified]
	 */
	
	
	function setLabelStyle(normalStyle, emphasisStyle, normalModel, emphasisModel, opt, normalSpecified, emphasisSpecified) {
	  opt = opt || EMPTY_OBJ;
	  var labelFetcher = opt.labelFetcher;
	  var labelDataIndex = opt.labelDataIndex;
	  var labelDimIndex = opt.labelDimIndex; // This scenario, `label.normal.show = true; label.emphasis.show = false`,
	  // is not supported util someone requests.
	
	  var showNormal = normalModel.getShallow('show');
	  var showEmphasis = emphasisModel.getShallow('show'); // Consider performance, only fetch label when necessary.
	  // If `normal.show` is `false` and `emphasis.show` is `true` and `emphasis.formatter` is not set,
	  // label should be displayed, where text is fetched by `normal.formatter` or `opt.defaultText`.
	
	  var baseText = showNormal || showEmphasis ? zrUtil.retrieve2(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex) : null, opt.defaultText) : null;
	  var normalStyleText = showNormal ? baseText : null;
	  var emphasisStyleText = showEmphasis ? zrUtil.retrieve2(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, 'emphasis', null, labelDimIndex) : null, baseText) : null; // Optimize: If style.text is null, text will not be drawn.
	
	  if (normalStyleText != null || emphasisStyleText != null) {
	    // Always set `textStyle` even if `normalStyle.text` is null, because default
	    // values have to be set on `normalStyle`.
	    // If we set default values on `emphasisStyle`, consider case:
	    // Firstly, `setOption(... label: {normal: {text: null}, emphasis: {show: true}} ...);`
	    // Secondly, `setOption(... label: {noraml: {show: true, text: 'abc', color: 'red'} ...);`
	    // Then the 'red' will not work on emphasis.
	    setTextStyle(normalStyle, normalModel, normalSpecified, opt);
	    setTextStyle(emphasisStyle, emphasisModel, emphasisSpecified, opt, true);
	  }
	
	  normalStyle.text = normalStyleText;
	  emphasisStyle.text = emphasisStyleText;
	}
	/**
	 * Set basic textStyle properties.
	 * @param {Object|module:zrender/graphic/Style} textStyle
	 * @param {module:echarts/model/Model} model
	 * @param {Object} [specifiedTextStyle] Can be overrided by settings in model.
	 * @param {Object} [opt] See `opt` of `setTextStyleCommon`.
	 * @param {boolean} [isEmphasis]
	 */
	
	
	function setTextStyle(textStyle, textStyleModel, specifiedTextStyle, opt, isEmphasis) {
	  setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis);
	  specifiedTextStyle && zrUtil.extend(textStyle, specifiedTextStyle);
	  textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
	  return textStyle;
	}
	/**
	 * Set text option in the style.
	 * @deprecated
	 * @param {Object} textStyle
	 * @param {module:echarts/model/Model} labelModel
	 * @param {string|boolean} defaultColor Default text color.
	 *        If set as false, it will be processed as a emphasis style.
	 */
	
	
	function setText(textStyle, labelModel, defaultColor) {
	  var opt = {
	    isRectText: true
	  };
	  var isEmphasis;
	
	  if (defaultColor === false) {
	    isEmphasis = true;
	  } else {
	    // Support setting color as 'auto' to get visual color.
	    opt.autoColor = defaultColor;
	  }
	
	  setTextStyleCommon(textStyle, labelModel, opt, isEmphasis);
	  textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
	}
	/**
	 * {
	 *      disableBox: boolean, Whether diable drawing box of block (outer most).
	 *      isRectText: boolean,
	 *      autoColor: string, specify a color when color is 'auto',
	 *              for textFill, textStroke, textBackgroundColor, and textBorderColor.
	 *              If autoColor specified, it is used as default textFill.
	 *      useInsideStyle:
	 *              `true`: Use inside style (textFill, textStroke, textStrokeWidth)
	 *                  if `textFill` is not specified.
	 *              `false`: Do not use inside style.
	 *              `null/undefined`: use inside style if `isRectText` is true and
	 *                  `textFill` is not specified and textPosition contains `'inside'`.
	 *      forceRich: boolean
	 * }
	 */
	
	
	function setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis) {
	  // Consider there will be abnormal when merge hover style to normal style if given default value.
	  opt = opt || EMPTY_OBJ;
	
	  if (opt.isRectText) {
	    var textPosition = textStyleModel.getShallow('position') || (isEmphasis ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
	    // in bar series, and magric type should be considered.
	
	    textPosition === 'outside' && (textPosition = 'top');
	    textStyle.textPosition = textPosition;
	    textStyle.textOffset = textStyleModel.getShallow('offset');
	    var labelRotate = textStyleModel.getShallow('rotate');
	    labelRotate != null && (labelRotate *= Math.PI / 180);
	    textStyle.textRotation = labelRotate;
	    textStyle.textDistance = zrUtil.retrieve2(textStyleModel.getShallow('distance'), isEmphasis ? null : 5);
	  }
	
	  var ecModel = textStyleModel.ecModel;
	  var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
	  // {
	  //     data: [{
	  //         value: 12,
	  //         label: {
	  //             normal: {
	  //                 rich: {
	  //                     // no 'a' here but using parent 'a'.
	  //                 }
	  //             }
	  //         }
	  //     }],
	  //     rich: {
	  //         a: { ... }
	  //     }
	  // }
	
	  var richItemNames = getRichItemNames(textStyleModel);
	  var richResult;
	
	  if (richItemNames) {
	    richResult = {};
	
	    for (var name in richItemNames) {
	      if (richItemNames.hasOwnProperty(name)) {
	        // Cascade is supported in rich.
	        var richTextStyle = textStyleModel.getModel(['rich', name]); // In rich, never `disableBox`.
	
	        setTokenTextStyle(richResult[name] = {}, richTextStyle, globalTextStyle, opt, isEmphasis);
	      }
	    }
	  }
	
	  textStyle.rich = richResult;
	  setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, true);
	
	  if (opt.forceRich && !opt.textStyle) {
	    opt.textStyle = {};
	  }
	
	  return textStyle;
	} // Consider case:
	// {
	//     data: [{
	//         value: 12,
	//         label: {
	//             normal: {
	//                 rich: {
	//                     // no 'a' here but using parent 'a'.
	//                 }
	//             }
	//         }
	//     }],
	//     rich: {
	//         a: { ... }
	//     }
	// }
	
	
	function getRichItemNames(textStyleModel) {
	  // Use object to remove duplicated names.
	  var richItemNameMap;
	
	  while (textStyleModel && textStyleModel !== textStyleModel.ecModel) {
	    var rich = (textStyleModel.option || EMPTY_OBJ).rich;
	
	    if (rich) {
	      richItemNameMap = richItemNameMap || {};
	
	      for (var name in rich) {
	        if (rich.hasOwnProperty(name)) {
	          richItemNameMap[name] = 1;
	        }
	      }
	    }
	
	    textStyleModel = textStyleModel.parentModel;
	  }
	
	  return richItemNameMap;
	}
	
	function setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, isBlock) {
	  // In merge mode, default value should not be given.
	  globalTextStyle = !isEmphasis && globalTextStyle || EMPTY_OBJ;
	  textStyle.textFill = getAutoColor(textStyleModel.getShallow('color'), opt) || globalTextStyle.color;
	  textStyle.textStroke = getAutoColor(textStyleModel.getShallow('textBorderColor'), opt) || globalTextStyle.textBorderColor;
	  textStyle.textStrokeWidth = zrUtil.retrieve2(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
	
	  if (!isEmphasis) {
	    if (isBlock) {
	      // Always set `insideRollback`, for clearing previous.
	      var originalTextPosition = textStyle.textPosition;
	      textStyle.insideRollback = applyInsideStyle(textStyle, originalTextPosition, opt); // Save original textPosition, because style.textPosition will be repalced by
	      // real location (like [10, 30]) in zrender.
	
	      textStyle.insideOriginalTextPosition = originalTextPosition;
	      textStyle.insideRollbackOpt = opt;
	    } // Set default finally.
	
	
	    if (textStyle.textFill == null) {
	      textStyle.textFill = opt.autoColor;
	    }
	  } // Do not use `getFont` here, because merge should be supported, where
	  // part of these properties may be changed in emphasis style, and the
	  // others should remain their original value got from normal style.
	
	
	  textStyle.fontStyle = textStyleModel.getShallow('fontStyle') || globalTextStyle.fontStyle;
	  textStyle.fontWeight = textStyleModel.getShallow('fontWeight') || globalTextStyle.fontWeight;
	  textStyle.fontSize = textStyleModel.getShallow('fontSize') || globalTextStyle.fontSize;
	  textStyle.fontFamily = textStyleModel.getShallow('fontFamily') || globalTextStyle.fontFamily;
	  textStyle.textAlign = textStyleModel.getShallow('align');
	  textStyle.textVerticalAlign = textStyleModel.getShallow('verticalAlign') || textStyleModel.getShallow('baseline');
	  textStyle.textLineHeight = textStyleModel.getShallow('lineHeight');
	  textStyle.textWidth = textStyleModel.getShallow('width');
	  textStyle.textHeight = textStyleModel.getShallow('height');
	  textStyle.textTag = textStyleModel.getShallow('tag');
	
	  if (!isBlock || !opt.disableBox) {
	    textStyle.textBackgroundColor = getAutoColor(textStyleModel.getShallow('backgroundColor'), opt);
	    textStyle.textPadding = textStyleModel.getShallow('padding');
	    textStyle.textBorderColor = getAutoColor(textStyleModel.getShallow('borderColor'), opt);
	    textStyle.textBorderWidth = textStyleModel.getShallow('borderWidth');
	    textStyle.textBorderRadius = textStyleModel.getShallow('borderRadius');
	    textStyle.textBoxShadowColor = textStyleModel.getShallow('shadowColor');
	    textStyle.textBoxShadowBlur = textStyleModel.getShallow('shadowBlur');
	    textStyle.textBoxShadowOffsetX = textStyleModel.getShallow('shadowOffsetX');
	    textStyle.textBoxShadowOffsetY = textStyleModel.getShallow('shadowOffsetY');
	  }
	
	  textStyle.textShadowColor = textStyleModel.getShallow('textShadowColor') || globalTextStyle.textShadowColor;
	  textStyle.textShadowBlur = textStyleModel.getShallow('textShadowBlur') || globalTextStyle.textShadowBlur;
	  textStyle.textShadowOffsetX = textStyleModel.getShallow('textShadowOffsetX') || globalTextStyle.textShadowOffsetX;
	  textStyle.textShadowOffsetY = textStyleModel.getShallow('textShadowOffsetY') || globalTextStyle.textShadowOffsetY;
	}
	
	function getAutoColor(color, opt) {
	  return color !== 'auto' ? color : opt && opt.autoColor ? opt.autoColor : null;
	}
	
	function applyInsideStyle(textStyle, textPosition, opt) {
	  var useInsideStyle = opt.useInsideStyle;
	  var insideRollback;
	
	  if (textStyle.textFill == null && useInsideStyle !== false && (useInsideStyle === true || opt.isRectText && textPosition // textPosition can be [10, 30]
	  && typeof textPosition === 'string' && textPosition.indexOf('inside') >= 0)) {
	    insideRollback = {
	      textFill: null,
	      textStroke: textStyle.textStroke,
	      textStrokeWidth: textStyle.textStrokeWidth
	    };
	    textStyle.textFill = '#fff'; // Consider text with #fff overflow its container.
	
	    if (textStyle.textStroke == null) {
	      textStyle.textStroke = opt.autoColor;
	      textStyle.textStrokeWidth == null && (textStyle.textStrokeWidth = 2);
	    }
	  }
	
	  return insideRollback;
	}
	
	function rollbackInsideStyle(style) {
	  var insideRollback = style.insideRollback;
	
	  if (insideRollback) {
	    style.textFill = insideRollback.textFill;
	    style.textStroke = insideRollback.textStroke;
	    style.textStrokeWidth = insideRollback.textStrokeWidth;
	  }
	}
	
	function getFont(opt, ecModel) {
	  // ecModel or default text style model.
	  var gTextStyleModel = ecModel || ecModel.getModel('textStyle');
	  return [// FIXME in node-canvas fontWeight is before fontStyle
	  opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '', opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '', (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px', opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'].join(' ');
	}
	
	function animateOrSetProps(isUpdate, el, props, animatableModel, dataIndex, cb) {
	  if (typeof dataIndex === 'function') {
	    cb = dataIndex;
	    dataIndex = null;
	  } // Do not check 'animation' property directly here. Consider this case:
	  // animation model is an `itemModel`, whose does not have `isAnimationEnabled`
	  // but its parent model (`seriesModel`) does.
	
	
	  var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
	
	  if (animationEnabled) {
	    var postfix = isUpdate ? 'Update' : '';
	    var duration = animatableModel.getShallow('animationDuration' + postfix);
	    var animationEasing = animatableModel.getShallow('animationEasing' + postfix);
	    var animationDelay = animatableModel.getShallow('animationDelay' + postfix);
	
	    if (typeof animationDelay === 'function') {
	      animationDelay = animationDelay(dataIndex, animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
	    }
	
	    if (typeof duration === 'function') {
	      duration = duration(dataIndex);
	    }
	
	    duration > 0 ? el.animateTo(props, duration, animationDelay || 0, animationEasing, cb, !!cb) : (el.stopAnimation(), el.attr(props), cb && cb());
	  } else {
	    el.stopAnimation();
	    el.attr(props);
	    cb && cb();
	  }
	}
	/**
	 * Update graphic element properties with or without animation according to the
	 * configuration in series.
	 *
	 * Caution: this method will stop previous animation.
	 * So if do not use this method to one element twice before
	 * animation starts, unless you know what you are doing.
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object} props
	 * @param {module:echarts/model/Model} [animatableModel]
	 * @param {number} [dataIndex]
	 * @param {Function} [cb]
	 * @example
	 *     graphic.updateProps(el, {
	 *         position: [100, 100]
	 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
	 *     // Or
	 *     graphic.updateProps(el, {
	 *         position: [100, 100]
	 *     }, seriesModel, function () { console.log('Animation done!'); });
	 */
	
	
	function updateProps(el, props, animatableModel, dataIndex, cb) {
	  animateOrSetProps(true, el, props, animatableModel, dataIndex, cb);
	}
	/**
	 * Init graphic element properties with or without animation according to the
	 * configuration in series.
	 *
	 * Caution: this method will stop previous animation.
	 * So if do not use this method to one element twice before
	 * animation starts, unless you know what you are doing.
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object} props
	 * @param {module:echarts/model/Model} [animatableModel]
	 * @param {number} [dataIndex]
	 * @param {Function} cb
	 */
	
	
	function initProps(el, props, animatableModel, dataIndex, cb) {
	  animateOrSetProps(false, el, props, animatableModel, dataIndex, cb);
	}
	/**
	 * Get transform matrix of target (param target),
	 * in coordinate of its ancestor (param ancestor)
	 *
	 * @param {module:zrender/mixin/Transformable} target
	 * @param {module:zrender/mixin/Transformable} [ancestor]
	 */
	
	
	function getTransform(target, ancestor) {
	  var mat = matrix.identity([]);
	
	  while (target && target !== ancestor) {
	    matrix.mul(mat, target.getLocalTransform(), mat);
	    target = target.parent;
	  }
	
	  return mat;
	}
	/**
	 * Apply transform to an vertex.
	 * @param {Array.<number>} target [x, y]
	 * @param {Array.<number>|TypedArray.<number>|Object} transform Can be:
	 *      + Transform matrix: like [1, 0, 0, 1, 0, 0]
	 *      + {position, rotation, scale}, the same as `zrender/Transformable`.
	 * @param {boolean=} invert Whether use invert matrix.
	 * @return {Array.<number>} [x, y]
	 */
	
	
	function applyTransform(target, transform, invert) {
	  if (transform && !zrUtil.isArrayLike(transform)) {
	    transform = Transformable.getLocalTransform(transform);
	  }
	
	  if (invert) {
	    transform = matrix.invert([], transform);
	  }
	
	  return vector.applyTransform([], target, transform);
	}
	/**
	 * @param {string} direction 'left' 'right' 'top' 'bottom'
	 * @param {Array.<number>} transform Transform matrix: like [1, 0, 0, 1, 0, 0]
	 * @param {boolean=} invert Whether use invert matrix.
	 * @return {string} Transformed direction. 'left' 'right' 'top' 'bottom'
	 */
	
	
	function transformDirection(direction, transform, invert) {
	  // Pick a base, ensure that transform result will not be (0, 0).
	  var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
	  var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
	  var vertex = [direction === 'left' ? -hBase : direction === 'right' ? hBase : 0, direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0];
	  vertex = applyTransform(vertex, transform, invert);
	  return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
	}
	/**
	 * Apply group transition animation from g1 to g2.
	 * If no animatableModel, no animation.
	 */
	
	
	function groupTransition(g1, g2, animatableModel, cb) {
	  if (!g1 || !g2) {
	    return;
	  }
	
	  function getElMap(g) {
	    var elMap = {};
	    g.traverse(function (el) {
	      if (!el.isGroup && el.anid) {
	        elMap[el.anid] = el;
	      }
	    });
	    return elMap;
	  }
	
	  function getAnimatableProps(el) {
	    var obj = {
	      position: vector.clone(el.position),
	      rotation: el.rotation
	    };
	
	    if (el.shape) {
	      obj.shape = zrUtil.extend({}, el.shape);
	    }
	
	    return obj;
	  }
	
	  var elMap1 = getElMap(g1);
	  g2.traverse(function (el) {
	    if (!el.isGroup && el.anid) {
	      var oldEl = elMap1[el.anid];
	
	      if (oldEl) {
	        var newProp = getAnimatableProps(el);
	        el.attr(getAnimatableProps(oldEl));
	        updateProps(el, newProp, animatableModel, el.dataIndex);
	      } // else {
	      //     if (el.previousProps) {
	      //         graphic.updateProps
	      //     }
	      // }
	
	    }
	  });
	}
	/**
	 * @param {Array.<Array.<number>>} points Like: [[23, 44], [53, 66], ...]
	 * @param {Object} rect {x, y, width, height}
	 * @return {Array.<Array.<number>>} A new clipped points.
	 */
	
	
	function clipPointsByRect(points, rect) {
	  return zrUtil.map(points, function (point) {
	    var x = point[0];
	    x = mathMax(x, rect.x);
	    x = mathMin(x, rect.x + rect.width);
	    var y = point[1];
	    y = mathMax(y, rect.y);
	    y = mathMin(y, rect.y + rect.height);
	    return [x, y];
	  });
	}
	/**
	 * @param {Object} targetRect {x, y, width, height}
	 * @param {Object} rect {x, y, width, height}
	 * @return {Object} A new clipped rect. If rect size are negative, return undefined.
	 */
	
	
	function clipRectByRect(targetRect, rect) {
	  var x = mathMax(targetRect.x, rect.x);
	  var x2 = mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
	  var y = mathMax(targetRect.y, rect.y);
	  var y2 = mathMin(targetRect.y + targetRect.height, rect.y + rect.height);
	
	  if (x2 >= x && y2 >= y) {
	    return {
	      x: x,
	      y: y,
	      width: x2 - x,
	      height: y2 - y
	    };
	  }
	}
	/**
	 * @param {string} iconStr Support 'image://' or 'path://' or direct svg path.
	 * @param {Object} [opt] Properties of `module:zrender/Element`, except `style`.
	 * @param {Object} [rect] {x, y, width, height}
	 * @return {module:zrender/Element} Icon path or image element.
	 */
	
	
	function createIcon(iconStr, opt, rect) {
	  opt = zrUtil.extend({
	    rectHover: true
	  }, opt);
	  var style = opt.style = {
	    strokeNoScale: true
	  };
	  rect = rect || {
	    x: -1,
	    y: -1,
	    width: 2,
	    height: 2
	  };
	
	  if (iconStr) {
	    return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), zrUtil.defaults(style, rect), new Image(opt)) : makePath(iconStr.replace('path://', ''), opt, rect, 'center');
	  }
	}
	
	exports.extendShape = extendShape;
	exports.extendPath = extendPath;
	exports.makePath = makePath;
	exports.makeImage = makeImage;
	exports.mergePath = mergePath;
	exports.resizePath = resizePath;
	exports.subPixelOptimizeLine = subPixelOptimizeLine;
	exports.subPixelOptimizeRect = subPixelOptimizeRect;
	exports.subPixelOptimize = subPixelOptimize;
	exports.setHoverStyle = setHoverStyle;
	exports.setLabelStyle = setLabelStyle;
	exports.setTextStyle = setTextStyle;
	exports.setText = setText;
	exports.getFont = getFont;
	exports.updateProps = updateProps;
	exports.initProps = initProps;
	exports.getTransform = getTransform;
	exports.applyTransform = applyTransform;
	exports.transformDirection = transformDirection;
	exports.groupTransition = groupTransition;
	exports.clipPointsByRect = clipPointsByRect;
	exports.clipRectByRect = clipRectByRect;
	exports.createIcon = createIcon;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var RADIAN_EPSILON = 1e-4;
	
	function _trim(str) {
	  return str.replace(/^\s+/, '').replace(/\s+$/, '');
	}
	/**
	 * Linear mapping a value from domain to range
	 * @memberOf module:echarts/util/number
	 * @param  {(number|Array.<number>)} val
	 * @param  {Array.<number>} domain Domain extent domain[0] can be bigger than domain[1]
	 * @param  {Array.<number>} range  Range extent range[0] can be bigger than range[1]
	 * @param  {boolean} clamp
	 * @return {(number|Array.<number>}
	 */
	
	
	function linearMap(val, domain, range, clamp) {
	  var subDomain = domain[1] - domain[0];
	  var subRange = range[1] - range[0];
	
	  if (subDomain === 0) {
	    return subRange === 0 ? range[0] : (range[0] + range[1]) / 2;
	  } // Avoid accuracy problem in edge, such as
	  // 146.39 - 62.83 === 83.55999999999999.
	  // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
	  // It is a little verbose for efficiency considering this method
	  // is a hotspot.
	
	
	  if (clamp) {
	    if (subDomain > 0) {
	      if (val <= domain[0]) {
	        return range[0];
	      } else if (val >= domain[1]) {
	        return range[1];
	      }
	    } else {
	      if (val >= domain[0]) {
	        return range[0];
	      } else if (val <= domain[1]) {
	        return range[1];
	      }
	    }
	  } else {
	    if (val === domain[0]) {
	      return range[0];
	    }
	
	    if (val === domain[1]) {
	      return range[1];
	    }
	  }
	
	  return (val - domain[0]) / subDomain * subRange + range[0];
	}
	/**
	 * Convert a percent string to absolute number.
	 * Returns NaN if percent is not a valid string or number
	 * @memberOf module:echarts/util/number
	 * @param {string|number} percent
	 * @param {number} all
	 * @return {number}
	 */
	
	
	function parsePercent(percent, all) {
	  switch (percent) {
	    case 'center':
	    case 'middle':
	      percent = '50%';
	      break;
	
	    case 'left':
	    case 'top':
	      percent = '0%';
	      break;
	
	    case 'right':
	    case 'bottom':
	      percent = '100%';
	      break;
	  }
	
	  if (typeof percent === 'string') {
	    if (_trim(percent).match(/%$/)) {
	      return parseFloat(percent) / 100 * all;
	    }
	
	    return parseFloat(percent);
	  }
	
	  return percent == null ? NaN : +percent;
	}
	/**
	 * (1) Fix rounding error of float numbers.
	 * (2) Support return string to avoid scientific notation like '3.5e-7'.
	 *
	 * @param {number} x
	 * @param {number} [precision]
	 * @param {boolean} [returnStr]
	 * @return {number|string}
	 */
	
	
	function round(x, precision, returnStr) {
	  if (precision == null) {
	    precision = 10;
	  } // Avoid range error
	
	
	  precision = Math.min(Math.max(0, precision), 20);
	  x = (+x).toFixed(precision);
	  return returnStr ? x : +x;
	}
	
	function asc(arr) {
	  arr.sort(function (a, b) {
	    return a - b;
	  });
	  return arr;
	}
	/**
	 * Get precision
	 * @param {number} val
	 */
	
	
	function getPrecision(val) {
	  val = +val;
	
	  if (isNaN(val)) {
	    return 0;
	  } // It is much faster than methods converting number to string as follows
	  //      var tmp = val.toString();
	  //      return tmp.length - 1 - tmp.indexOf('.');
	  // especially when precision is low
	
	
	  var e = 1;
	  var count = 0;
	
	  while (Math.round(val * e) / e !== val) {
	    e *= 10;
	    count++;
	  }
	
	  return count;
	}
	/**
	 * @param {string|number} val
	 * @return {number}
	 */
	
	
	function getPrecisionSafe(val) {
	  var str = val.toString(); // Consider scientific notation: '3.4e-12' '3.4e+12'
	
	  var eIndex = str.indexOf('e');
	
	  if (eIndex > 0) {
	    var precision = +str.slice(eIndex + 1);
	    return precision < 0 ? -precision : 0;
	  } else {
	    var dotIndex = str.indexOf('.');
	    return dotIndex < 0 ? 0 : str.length - 1 - dotIndex;
	  }
	}
	/**
	 * Minimal dicernible data precisioin according to a single pixel.
	 *
	 * @param {Array.<number>} dataExtent
	 * @param {Array.<number>} pixelExtent
	 * @return {number} precision
	 */
	
	
	function getPixelPrecision(dataExtent, pixelExtent) {
	  var log = Math.log;
	  var LN10 = Math.LN10;
	  var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
	  var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.
	
	  var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
	  return !isFinite(precision) ? 20 : precision;
	}
	/**
	 * Get a data of given precision, assuring the sum of percentages
	 * in valueList is 1.
	 * The largest remainer method is used.
	 * https://en.wikipedia.org/wiki/Largest_remainder_method
	 *
	 * @param {Array.<number>} valueList a list of all data
	 * @param {number} idx index of the data to be processed in valueList
	 * @param {number} precision integer number showing digits of precision
	 * @return {number} percent ranging from 0 to 100
	 */
	
	
	function getPercentWithPrecision(valueList, idx, precision) {
	  if (!valueList[idx]) {
	    return 0;
	  }
	
	  var sum = zrUtil.reduce(valueList, function (acc, val) {
	    return acc + (isNaN(val) ? 0 : val);
	  }, 0);
	
	  if (sum === 0) {
	    return 0;
	  }
	
	  var digits = Math.pow(10, precision);
	  var votesPerQuota = zrUtil.map(valueList, function (val) {
	    return (isNaN(val) ? 0 : val) / sum * digits * 100;
	  });
	  var targetSeats = digits * 100;
	  var seats = zrUtil.map(votesPerQuota, function (votes) {
	    // Assign automatic seats.
	    return Math.floor(votes);
	  });
	  var currentSum = zrUtil.reduce(seats, function (acc, val) {
	    return acc + val;
	  }, 0);
	  var remainder = zrUtil.map(votesPerQuota, function (votes, idx) {
	    return votes - seats[idx];
	  }); // Has remainding votes.
	
	  while (currentSum < targetSeats) {
	    // Find next largest remainder.
	    var max = Number.NEGATIVE_INFINITY;
	    var maxId = null;
	
	    for (var i = 0, len = remainder.length; i < len; ++i) {
	      if (remainder[i] > max) {
	        max = remainder[i];
	        maxId = i;
	      }
	    } // Add a vote to max remainder.
	
	
	    ++seats[maxId];
	    remainder[maxId] = 0;
	    ++currentSum;
	  }
	
	  return seats[idx] / digits;
	} // Number.MAX_SAFE_INTEGER, ie do not support.
	
	
	var MAX_SAFE_INTEGER = 9007199254740991;
	/**
	 * To 0 - 2 * PI, considering negative radian.
	 * @param {number} radian
	 * @return {number}
	 */
	
	function remRadian(radian) {
	  var pi2 = Math.PI * 2;
	  return (radian % pi2 + pi2) % pi2;
	}
	/**
	 * @param {type} radian
	 * @return {boolean}
	 */
	
	
	function isRadianAroundZero(val) {
	  return val > -RADIAN_EPSILON && val < RADIAN_EPSILON;
	}
	
	var TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d\d)(?::(\d\d)(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
	
	/**
	 * @param {string|Date|number} value These values can be accepted:
	 *   + An instance of Date, represent a time in its own time zone.
	 *   + Or string in a subset of ISO 8601, only including:
	 *     + only year, month, date: '2012-03', '2012-03-01', '2012-03-01 05', '2012-03-01 05:06',
	 *     + separated with T or space: '2012-03-01T12:22:33.123', '2012-03-01 12:22:33.123',
	 *     + time zone: '2012-03-01T12:22:33Z', '2012-03-01T12:22:33+8000', '2012-03-01T12:22:33-05:00',
	 *     all of which will be treated as local time if time zone is not specified
	 *     (see <https://momentjs.com/>).
	 *   + Or other string format, including (all of which will be treated as loacal time):
	 *     '2012', '2012-3-1', '2012/3/1', '2012/03/01',
	 *     '2009/6/12 2:00', '2009/6/12 2:05:08', '2009/6/12 2:05:08.123'
	 *   + a timestamp, which represent a time in UTC.
	 * @return {Date} date
	 */
	
	function parseDate(value) {
	  if (value instanceof Date) {
	    return value;
	  } else if (typeof value === 'string') {
	    // Different browsers parse date in different way, so we parse it manually.
	    // Some other issues:
	    // new Date('1970-01-01') is UTC,
	    // new Date('1970/01/01') and new Date('1970-1-01') is local.
	    // See issue #3623
	    var match = TIME_REG.exec(value);
	
	    if (!match) {
	      // return Invalid Date.
	      return new Date(NaN);
	    } // Use local time when no timezone offset specifed.
	
	
	    if (!match[8]) {
	      // match[n] can only be string or undefined.
	      // But take care of '12' + 1 => '121'.
	      return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, +match[7] || 0);
	    } // Timezoneoffset of Javascript Date has considered DST (Daylight Saving Time,
	    // https://tc39.github.io/ecma262/#sec-daylight-saving-time-adjustment).
	    // For example, system timezone is set as "Time Zone: America/Toronto",
	    // then these code will get different result:
	    // `new Date(1478411999999).getTimezoneOffset();  // get 240`
	    // `new Date(1478412000000).getTimezoneOffset();  // get 300`
	    // So we should not use `new Date`, but use `Date.UTC`.
	    else {
	        var hour = +match[4] || 0;
	
	        if (match[8].toUpperCase() !== 'Z') {
	          hour -= match[8].slice(0, 3);
	        }
	
	        return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, +match[7] || 0));
	      }
	  } else if (value == null) {
	    return new Date(NaN);
	  }
	
	  return new Date(Math.round(value));
	}
	/**
	 * Quantity of a number. e.g. 0.1, 1, 10, 100
	 *
	 * @param  {number} val
	 * @return {number}
	 */
	
	
	function quantity(val) {
	  return Math.pow(10, quantityExponent(val));
	}
	
	function quantityExponent(val) {
	  return Math.floor(Math.log(val) / Math.LN10);
	}
	/**
	 * find a “nice” number approximately equal to x. Round the number if round = true,
	 * take ceiling if round = false. The primary observation is that the “nicest”
	 * numbers in decimal are 1, 2, and 5, and all power-of-ten multiples of these numbers.
	 *
	 * See "Nice Numbers for Graph Labels" of Graphic Gems.
	 *
	 * @param  {number} val Non-negative value.
	 * @param  {boolean} round
	 * @return {number}
	 */
	
	
	function nice(val, round) {
	  var exponent = quantityExponent(val);
	  var exp10 = Math.pow(10, exponent);
	  var f = val / exp10; // 1 <= f < 10
	
	  var nf;
	
	  if (round) {
	    if (f < 1.5) {
	      nf = 1;
	    } else if (f < 2.5) {
	      nf = 2;
	    } else if (f < 4) {
	      nf = 3;
	    } else if (f < 7) {
	      nf = 5;
	    } else {
	      nf = 10;
	    }
	  } else {
	    if (f < 1) {
	      nf = 1;
	    } else if (f < 2) {
	      nf = 2;
	    } else if (f < 3) {
	      nf = 3;
	    } else if (f < 5) {
	      nf = 5;
	    } else {
	      nf = 10;
	    }
	  }
	
	  val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
	  // 20 is the uppper bound of toFixed.
	
	  return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
	}
	/**
	 * Order intervals asc, and split them when overlap.
	 * expect(numberUtil.reformIntervals([
	 *     {interval: [18, 62], close: [1, 1]},
	 *     {interval: [-Infinity, -70], close: [0, 0]},
	 *     {interval: [-70, -26], close: [1, 1]},
	 *     {interval: [-26, 18], close: [1, 1]},
	 *     {interval: [62, 150], close: [1, 1]},
	 *     {interval: [106, 150], close: [1, 1]},
	 *     {interval: [150, Infinity], close: [0, 0]}
	 * ])).toEqual([
	 *     {interval: [-Infinity, -70], close: [0, 0]},
	 *     {interval: [-70, -26], close: [1, 1]},
	 *     {interval: [-26, 18], close: [0, 1]},
	 *     {interval: [18, 62], close: [0, 1]},
	 *     {interval: [62, 150], close: [0, 1]},
	 *     {interval: [150, Infinity], close: [0, 0]}
	 * ]);
	 * @param {Array.<Object>} list, where `close` mean open or close
	 *        of the interval, and Infinity can be used.
	 * @return {Array.<Object>} The origin list, which has been reformed.
	 */
	
	
	function reformIntervals(list) {
	  list.sort(function (a, b) {
	    return littleThan(a, b, 0) ? -1 : 1;
	  });
	  var curr = -Infinity;
	  var currClose = 1;
	
	  for (var i = 0; i < list.length;) {
	    var interval = list[i].interval;
	    var close = list[i].close;
	
	    for (var lg = 0; lg < 2; lg++) {
	      if (interval[lg] <= curr) {
	        interval[lg] = curr;
	        close[lg] = !lg ? 1 - currClose : 1;
	      }
	
	      curr = interval[lg];
	      currClose = close[lg];
	    }
	
	    if (interval[0] === interval[1] && close[0] * close[1] !== 1) {
	      list.splice(i, 1);
	    } else {
	      i++;
	    }
	  }
	
	  return list;
	
	  function littleThan(a, b, lg) {
	    return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
	  }
	}
	/**
	 * parseFloat NaNs numeric-cast false positives (null|true|false|"")
	 * ...but misinterprets leading-number strings, particularly hex literals ("0x...")
	 * subtraction forces infinities to NaN
	 *
	 * @param {*} v
	 * @return {boolean}
	 */
	
	
	function isNumeric(v) {
	  return v - parseFloat(v) >= 0;
	}
	
	exports.linearMap = linearMap;
	exports.parsePercent = parsePercent;
	exports.round = round;
	exports.asc = asc;
	exports.getPrecision = getPrecision;
	exports.getPrecisionSafe = getPrecisionSafe;
	exports.getPixelPrecision = getPixelPrecision;
	exports.getPercentWithPrecision = getPercentWithPrecision;
	exports.MAX_SAFE_INTEGER = MAX_SAFE_INTEGER;
	exports.remRadian = remRadian;
	exports.isRadianAroundZero = isRadianAroundZero;
	exports.parseDate = parseDate;
	exports.quantity = quantity;
	exports.nice = nice;
	exports.reformIntervals = reformIntervals;
	exports.isNumeric = isNumeric;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// (1) The code `if (__DEV__) ...` can be removed by build tool.
	// (2) If intend to use `__DEV__`, this module should be imported. Use a global
	// variable `__DEV__` may cause that miss the declaration (see #6535), or the
	// declaration is behind of the using position (for example in `Model.extent`,
	// And tools like rollup can not analysis the dependency if not import).
	var dev; // In browser
	
	if (typeof window !== 'undefined') {
	  dev = window.__DEV__;
	} // In node
	else if (typeof global !== 'undefined') {
	    dev = global.__DEV__;
	  }
	
	if (typeof dev === 'undefined') {
	  dev = true;
	}
	
	var __DEV__ = dev;
	exports.__DEV__ = __DEV__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var formatUtil = __webpack_require__(9);
	
	var nubmerUtil = __webpack_require__(4);
	
	var Model = __webpack_require__(14);
	
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	/**
	 * If value is not array, then translate it to array.
	 * @param  {*} value
	 * @return {Array} [value] or value
	 */
	
	function normalizeToArray(value) {
	  return value instanceof Array ? value : value == null ? [] : [value];
	}
	/**
	 * Sync default option between normal and emphasis like `position` and `show`
	 * In case some one will write code like
	 *     label: {
	 *         normal: {
	 *             show: false,
	 *             position: 'outside',
	 *             fontSize: 18
	 *         },
	 *         emphasis: {
	 *             show: true
	 *         }
	 *     }
	 * @param {Object} opt
	 * @param {Array.<string>} subOpts
	 */
	
	
	function defaultEmphasis(opt, subOpts) {
	  if (opt) {
	    var emphasisOpt = opt.emphasis = opt.emphasis || {};
	    var normalOpt = opt.normal = opt.normal || {}; // Default emphasis option from normal
	
	    for (var i = 0, len = subOpts.length; i < len; i++) {
	      var subOptName = subOpts[i];
	
	      if (!emphasisOpt.hasOwnProperty(subOptName) && normalOpt.hasOwnProperty(subOptName)) {
	        emphasisOpt[subOptName] = normalOpt[subOptName];
	      }
	    }
	  }
	}
	
	var TEXT_STYLE_OPTIONS = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'rich', 'tag', 'color', 'textBorderColor', 'textBorderWidth', 'width', 'height', 'lineHeight', 'align', 'verticalAlign', 'baseline', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY', 'backgroundColor', 'borderColor', 'borderWidth', 'borderRadius', 'padding']; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
	//     'position', 'offset', 'rotate', 'origin', 'show', 'distance', 'formatter',
	//     'fontStyle', 'fontWeight', 'fontSize', 'fontFamily',
	//     // FIXME: deprecated, check and remove it.
	//     'textStyle'
	// ]);
	
	/**
	 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
	 * This helper method retieves value from data.
	 * @param {string|number|Date|Array|Object} dataItem
	 * @return {number|string|Date|Array.<number|string|Date>}
	 */
	
	function getDataItemValue(dataItem) {
	  // Performance sensitive.
	  return dataItem && (dataItem.value == null ? dataItem : dataItem.value);
	}
	/**
	 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
	 * This helper method determine if dataItem has extra option besides value
	 * @param {string|number|Date|Array|Object} dataItem
	 */
	
	
	function isDataItemOption(dataItem) {
	  return isObject(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
	  // && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
	}
	/**
	 * This helper method convert value in data.
	 * @param {string|number|Date} value
	 * @param {Object|string} [dimInfo] If string (like 'x'), dimType defaults 'number'.
	 */
	
	
	function converDataValue(value, dimInfo) {
	  // Performance sensitive.
	  var dimType = dimInfo && dimInfo.type;
	
	  if (dimType === 'ordinal') {
	    return value;
	  }
	
	  if (dimType === 'time' // spead up when using timestamp
	  && typeof value !== 'number' && value != null && value !== '-') {
	    value = +nubmerUtil.parseDate(value);
	  } // dimType defaults 'number'.
	  // If dimType is not ordinal and value is null or undefined or NaN or '-',
	  // parse to NaN.
	
	
	  return value == null || value === '' ? NaN : +value; // If string (like '-'), using '+' parse to NaN
	}
	/**
	 * Create a model proxy to be used in tooltip for edge data, markLine data, markPoint data.
	 * @param {module:echarts/data/List} data
	 * @param {Object} opt
	 * @param {string} [opt.seriesIndex]
	 * @param {Object} [opt.name]
	 * @param {Object} [opt.mainType]
	 * @param {Object} [opt.subType]
	 */
	
	
	function createDataFormatModel(data, opt) {
	  var model = new Model();
	  zrUtil.mixin(model, dataFormatMixin);
	  model.seriesIndex = opt.seriesIndex;
	  model.name = opt.name || '';
	  model.mainType = opt.mainType;
	  model.subType = opt.subType;
	
	  model.getData = function () {
	    return data;
	  };
	
	  return model;
	} // PENDING A little ugly
	
	
	var dataFormatMixin = {
	  /**
	   * Get params for formatter
	   * @param {number} dataIndex
	   * @param {string} [dataType]
	   * @return {Object}
	   */
	  getDataParams: function (dataIndex, dataType) {
	    var data = this.getData(dataType);
	    var rawValue = this.getRawValue(dataIndex, dataType);
	    var rawDataIndex = data.getRawIndex(dataIndex);
	    var name = data.getName(dataIndex, true);
	    var itemOpt = data.getRawDataItem(dataIndex);
	    var color = data.getItemVisual(dataIndex, 'color');
	    return {
	      componentType: this.mainType,
	      componentSubType: this.subType,
	      seriesType: this.mainType === 'series' ? this.subType : null,
	      seriesIndex: this.seriesIndex,
	      seriesId: this.id,
	      seriesName: this.name,
	      name: name,
	      dataIndex: rawDataIndex,
	      data: itemOpt,
	      dataType: dataType,
	      value: rawValue,
	      color: color,
	      marker: formatUtil.getTooltipMarker(color),
	      // Param name list for mapping `a`, `b`, `c`, `d`, `e`
	      $vars: ['seriesName', 'name', 'value']
	    };
	  },
	
	  /**
	   * Format label
	   * @param {number} dataIndex
	   * @param {string} [status='normal'] 'normal' or 'emphasis'
	   * @param {string} [dataType]
	   * @param {number} [dimIndex]
	   * @param {string} [labelProp='label']
	   * @return {string}
	   */
	  getFormattedLabel: function (dataIndex, status, dataType, dimIndex, labelProp) {
	    status = status || 'normal';
	    var data = this.getData(dataType);
	    var itemModel = data.getItemModel(dataIndex);
	    var params = this.getDataParams(dataIndex, dataType);
	
	    if (dimIndex != null && params.value instanceof Array) {
	      params.value = params.value[dimIndex];
	    }
	
	    var formatter = itemModel.get([labelProp || 'label', status, 'formatter']);
	
	    if (typeof formatter === 'function') {
	      params.status = status;
	      return formatter(params);
	    } else if (typeof formatter === 'string') {
	      return formatUtil.formatTpl(formatter, params);
	    }
	  },
	
	  /**
	   * Get raw value in option
	   * @param {number} idx
	   * @param {string} [dataType]
	   * @return {Object}
	   */
	  getRawValue: function (idx, dataType) {
	    var data = this.getData(dataType);
	    var dataItem = data.getRawDataItem(idx);
	
	    if (dataItem != null) {
	      return isObject(dataItem) && !(dataItem instanceof Array) ? dataItem.value : dataItem;
	    }
	  },
	
	  /**
	   * Should be implemented.
	   * @param {number} dataIndex
	   * @param {boolean} [multipleSeries=false]
	   * @param {number} [dataType]
	   * @return {string} tooltip string
	   */
	  formatTooltip: zrUtil.noop
	};
	/**
	 * Mapping to exists for merge.
	 *
	 * @public
	 * @param {Array.<Object>|Array.<module:echarts/model/Component>} exists
	 * @param {Object|Array.<Object>} newCptOptions
	 * @return {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
	 *                          index of which is the same as exists.
	 */
	
	function mappingToExists(exists, newCptOptions) {
	  // Mapping by the order by original option (but not order of
	  // new option) in merge mode. Because we should ensure
	  // some specified index (like xAxisIndex) is consistent with
	  // original option, which is easy to understand, espatially in
	  // media query. And in most case, merge option is used to
	  // update partial option but not be expected to change order.
	  newCptOptions = (newCptOptions || []).slice();
	  var result = zrUtil.map(exists || [], function (obj, index) {
	    return {
	      exist: obj
	    };
	  }); // Mapping by id or name if specified.
	
	  each(newCptOptions, function (cptOption, index) {
	    if (!isObject(cptOption)) {
	      return;
	    } // id has highest priority.
	
	
	    for (var i = 0; i < result.length; i++) {
	      if (!result[i].option // Consider name: two map to one.
	      && cptOption.id != null && result[i].exist.id === cptOption.id + '') {
	        result[i].option = cptOption;
	        newCptOptions[index] = null;
	        return;
	      }
	    }
	
	    for (var i = 0; i < result.length; i++) {
	      var exist = result[i].exist;
	
	      if (!result[i].option // Consider name: two map to one.
	      // Can not match when both ids exist but different.
	      && (exist.id == null || cptOption.id == null) && cptOption.name != null && !isIdInner(cptOption) && !isIdInner(exist) && exist.name === cptOption.name + '') {
	        result[i].option = cptOption;
	        newCptOptions[index] = null;
	        return;
	      }
	    }
	  }); // Otherwise mapping by index.
	
	  each(newCptOptions, function (cptOption, index) {
	    if (!isObject(cptOption)) {
	      return;
	    }
	
	    var i = 0;
	
	    for (; i < result.length; i++) {
	      var exist = result[i].exist;
	
	      if (!result[i].option // Existing model that already has id should be able to
	      // mapped to (because after mapping performed model may
	      // be assigned with a id, whish should not affect next
	      // mapping), except those has inner id.
	      && !isIdInner(exist) // Caution:
	      // Do not overwrite id. But name can be overwritten,
	      // because axis use name as 'show label text'.
	      // 'exist' always has id and name and we dont
	      // need to check it.
	      && cptOption.id == null) {
	        result[i].option = cptOption;
	        break;
	      }
	    }
	
	    if (i >= result.length) {
	      result.push({
	        option: cptOption
	      });
	    }
	  });
	  return result;
	}
	/**
	 * Make id and name for mapping result (result of mappingToExists)
	 * into `keyInfo` field.
	 *
	 * @public
	 * @param {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
	 *                          which order is the same as exists.
	 * @return {Array.<Object>} The input.
	 */
	
	
	function makeIdAndName(mapResult) {
	  // We use this id to hash component models and view instances
	  // in echarts. id can be specified by user, or auto generated.
	  // The id generation rule ensures new view instance are able
	  // to mapped to old instance when setOption are called in
	  // no-merge mode. So we generate model id by name and plus
	  // type in view id.
	  // name can be duplicated among components, which is convenient
	  // to specify multi components (like series) by one name.
	  // Ensure that each id is distinct.
	  var idMap = zrUtil.createHashMap();
	  each(mapResult, function (item, index) {
	    var existCpt = item.exist;
	    existCpt && idMap.set(existCpt.id, item);
	  });
	  each(mapResult, function (item, index) {
	    var opt = item.option;
	    zrUtil.assert(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
	    opt && opt.id != null && idMap.set(opt.id, item);
	    !item.keyInfo && (item.keyInfo = {});
	  }); // Make name and id.
	
	  each(mapResult, function (item, index) {
	    var existCpt = item.exist;
	    var opt = item.option;
	    var keyInfo = item.keyInfo;
	
	    if (!isObject(opt)) {
	      return;
	    } // name can be overwitten. Consider case: axis.name = '20km'.
	    // But id generated by name will not be changed, which affect
	    // only in that case: setOption with 'not merge mode' and view
	    // instance will be recreated, which can be accepted.
	
	
	    keyInfo.name = opt.name != null ? opt.name + '' : existCpt ? existCpt.name : '\0-'; // name may be displayed on screen, so use '-'.
	
	    if (existCpt) {
	      keyInfo.id = existCpt.id;
	    } else if (opt.id != null) {
	      keyInfo.id = opt.id + '';
	    } else {
	      // Consider this situatoin:
	      //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
	      //  optionB [{..}, {name: 'a'}, {name: 'a'}]
	      // Series with the same name between optionA and optionB
	      // should be mapped.
	      var idNum = 0;
	
	      do {
	        keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
	      } while (idMap.get(keyInfo.id));
	    }
	
	    idMap.set(keyInfo.id, item);
	  });
	}
	/**
	 * @public
	 * @param {Object} cptOption
	 * @return {boolean}
	 */
	
	
	function isIdInner(cptOption) {
	  return isObject(cptOption) && cptOption.id && (cptOption.id + '').indexOf('\0_ec_\0') === 0;
	}
	/**
	 * A helper for removing duplicate items between batchA and batchB,
	 * and in themselves, and categorize by series.
	 *
	 * @param {Array.<Object>} batchA Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
	 * @param {Array.<Object>} batchB Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
	 * @return {Array.<Array.<Object>, Array.<Object>>} result: [resultBatchA, resultBatchB]
	 */
	
	
	function compressBatches(batchA, batchB) {
	  var mapA = {};
	  var mapB = {};
	  makeMap(batchA || [], mapA);
	  makeMap(batchB || [], mapB, mapA);
	  return [mapToArray(mapA), mapToArray(mapB)];
	
	  function makeMap(sourceBatch, map, otherMap) {
	    for (var i = 0, len = sourceBatch.length; i < len; i++) {
	      var seriesId = sourceBatch[i].seriesId;
	      var dataIndices = normalizeToArray(sourceBatch[i].dataIndex);
	      var otherDataIndices = otherMap && otherMap[seriesId];
	
	      for (var j = 0, lenj = dataIndices.length; j < lenj; j++) {
	        var dataIndex = dataIndices[j];
	
	        if (otherDataIndices && otherDataIndices[dataIndex]) {
	          otherDataIndices[dataIndex] = null;
	        } else {
	          (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
	        }
	      }
	    }
	  }
	
	  function mapToArray(map, isData) {
	    var result = [];
	
	    for (var i in map) {
	      if (map.hasOwnProperty(i) && map[i] != null) {
	        if (isData) {
	          result.push(+i);
	        } else {
	          var dataIndices = mapToArray(map[i], true);
	          dataIndices.length && result.push({
	            seriesId: i,
	            dataIndex: dataIndices
	          });
	        }
	      }
	    }
	
	    return result;
	  }
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {Object} payload Contains dataIndex (means rawIndex) / dataIndexInside / name
	 *                         each of which can be Array or primary type.
	 * @return {number|Array.<number>} dataIndex If not found, return undefined/null.
	 */
	
	
	function queryDataIndex(data, payload) {
	  if (payload.dataIndexInside != null) {
	    return payload.dataIndexInside;
	  } else if (payload.dataIndex != null) {
	    return zrUtil.isArray(payload.dataIndex) ? zrUtil.map(payload.dataIndex, function (value) {
	      return data.indexOfRawIndex(value);
	    }) : data.indexOfRawIndex(payload.dataIndex);
	  } else if (payload.name != null) {
	    return zrUtil.isArray(payload.name) ? zrUtil.map(payload.name, function (value) {
	      return data.indexOfName(value);
	    }) : data.indexOfName(payload.name);
	  }
	}
	/**
	 * Enable property storage to any host object.
	 * Notice: Serialization is not supported.
	 *
	 * For example:
	 * var get = modelUitl.makeGetter();
	 *
	 * function some(hostObj) {
	 *      get(hostObj)._someProperty = 1212;
	 *      ...
	 * }
	 *
	 * @return {Function}
	 */
	
	
	var makeGetter = function () {
	  var index = 0;
	  return function () {
	    var key = '\0__ec_prop_getter_' + index++;
	    return function (hostObj) {
	      return hostObj[key] || (hostObj[key] = {});
	    };
	  };
	}();
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex, seriesId, seriesName,
	 *            geoIndex, geoId, geoName,
	 *            bmapIndex, bmapId, bmapName,
	 *            xAxisIndex, xAxisId, xAxisName,
	 *            yAxisIndex, yAxisId, yAxisName,
	 *            gridIndex, gridId, gridName,
	 *            ... (can be extended)
	 *        }
	 *        Each properties can be number|string|Array.<number>|Array.<string>
	 *        For example, a finder could be
	 *        {
	 *            seriesIndex: 3,
	 *            geoId: ['aa', 'cc'],
	 *            gridName: ['xx', 'rr']
	 *        }
	 *        xxxIndex can be set as 'all' (means all xxx) or 'none' (means not specify)
	 *        If nothing or null/undefined specified, return nothing.
	 * @param {Object} [opt]
	 * @param {string} [opt.defaultMainType]
	 * @param {Array.<string>} [opt.includeMainTypes]
	 * @return {Object} result like:
	 *        {
	 *            seriesModels: [seriesModel1, seriesModel2],
	 *            seriesModel: seriesModel1, // The first model
	 *            geoModels: [geoModel1, geoModel2],
	 *            geoModel: geoModel1, // The first model
	 *            ...
	 *        }
	 */
	
	
	function parseFinder(ecModel, finder, opt) {
	  if (zrUtil.isString(finder)) {
	    var obj = {};
	    obj[finder + 'Index'] = 0;
	    finder = obj;
	  }
	
	  var defaultMainType = opt && opt.defaultMainType;
	
	  if (defaultMainType && !has(finder, defaultMainType + 'Index') && !has(finder, defaultMainType + 'Id') && !has(finder, defaultMainType + 'Name')) {
	    finder[defaultMainType + 'Index'] = 0;
	  }
	
	  var result = {};
	  each(finder, function (value, key) {
	    var value = finder[key]; // Exclude 'dataIndex' and other illgal keys.
	
	    if (key === 'dataIndex' || key === 'dataIndexInside') {
	      result[key] = value;
	      return;
	    }
	
	    var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
	    var mainType = parsedKey[1];
	    var queryType = (parsedKey[2] || '').toLowerCase();
	
	    if (!mainType || !queryType || value == null || queryType === 'index' && value === 'none' || opt && opt.includeMainTypes && zrUtil.indexOf(opt.includeMainTypes, mainType) < 0) {
	      return;
	    }
	
	    var queryParam = {
	      mainType: mainType
	    };
	
	    if (queryType !== 'index' || value !== 'all') {
	      queryParam[queryType] = value;
	    }
	
	    var models = ecModel.queryComponents(queryParam);
	    result[mainType + 'Models'] = models;
	    result[mainType + 'Model'] = models[0];
	  });
	  return result;
	}
	/**
	 * @see {module:echarts/data/helper/completeDimensions}
	 * @param {module:echarts/data/List} data
	 * @param {string|number} dataDim
	 * @return {string}
	 */
	
	
	function dataDimToCoordDim(data, dataDim) {
	  var dimensions = data.dimensions;
	  dataDim = data.getDimension(dataDim);
	
	  for (var i = 0; i < dimensions.length; i++) {
	    var dimItem = data.getDimensionInfo(dimensions[i]);
	
	    if (dimItem.name === dataDim) {
	      return dimItem.coordDim;
	    }
	  }
	}
	/**
	 * @see {module:echarts/data/helper/completeDimensions}
	 * @param {module:echarts/data/List} data
	 * @param {string} coordDim
	 * @return {Array.<string>} data dimensions on the coordDim.
	 */
	
	
	function coordDimToDataDim(data, coordDim) {
	  var dataDim = [];
	  each(data.dimensions, function (dimName) {
	    var dimItem = data.getDimensionInfo(dimName);
	
	    if (dimItem.coordDim === coordDim) {
	      dataDim[dimItem.coordDimIndex] = dimItem.name;
	    }
	  });
	  return dataDim;
	}
	/**
	 * @see {module:echarts/data/helper/completeDimensions}
	 * @param {module:echarts/data/List} data
	 * @param {string} otherDim Can be `otherDims`
	 *                        like 'label' or 'tooltip'.
	 * @return {Array.<string>} data dimensions on the otherDim.
	 */
	
	
	function otherDimToDataDim(data, otherDim) {
	  var dataDim = [];
	  each(data.dimensions, function (dimName) {
	    var dimItem = data.getDimensionInfo(dimName);
	    var otherDims = dimItem.otherDims;
	    var dimIndex = otherDims[otherDim];
	
	    if (dimIndex != null && dimIndex !== false) {
	      dataDim[dimIndex] = dimItem.name;
	    }
	  });
	  return dataDim;
	}
	
	function has(obj, prop) {
	  return obj && obj.hasOwnProperty(prop);
	}
	
	exports.normalizeToArray = normalizeToArray;
	exports.defaultEmphasis = defaultEmphasis;
	exports.TEXT_STYLE_OPTIONS = TEXT_STYLE_OPTIONS;
	exports.getDataItemValue = getDataItemValue;
	exports.isDataItemOption = isDataItemOption;
	exports.converDataValue = converDataValue;
	exports.createDataFormatModel = createDataFormatModel;
	exports.dataFormatMixin = dataFormatMixin;
	exports.mappingToExists = mappingToExists;
	exports.makeIdAndName = makeIdAndName;
	exports.isIdInner = isIdInner;
	exports.compressBatches = compressBatches;
	exports.queryDataIndex = queryDataIndex;
	exports.makeGetter = makeGetter;
	exports.parseFinder = parseFinder;
	exports.dataDimToCoordDim = dataDimToCoordDim;
	exports.coordDimToDataDim = coordDimToDataDim;
	exports.otherDimToDataDim = otherDimToDataDim;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var BoundingRect = __webpack_require__(13);
	
	var _number = __webpack_require__(4);
	
	var parsePercent = _number.parsePercent;
	
	var formatUtil = __webpack_require__(9);
	
	// Layout helpers for each component positioning
	var each = zrUtil.each;
	/**
	 * @public
	 */
	
	var LOCATION_PARAMS = ['left', 'right', 'top', 'bottom', 'width', 'height'];
	/**
	 * @public
	 */
	
	var HV_NAMES = [['width', 'left', 'right'], ['height', 'top', 'bottom']];
	
	function boxLayout(orient, group, gap, maxWidth, maxHeight) {
	  var x = 0;
	  var y = 0;
	
	  if (maxWidth == null) {
	    maxWidth = Infinity;
	  }
	
	  if (maxHeight == null) {
	    maxHeight = Infinity;
	  }
	
	  var currentLineMaxSize = 0;
	  group.eachChild(function (child, idx) {
	    var position = child.position;
	    var rect = child.getBoundingRect();
	    var nextChild = group.childAt(idx + 1);
	    var nextChildRect = nextChild && nextChild.getBoundingRect();
	    var nextX;
	    var nextY;
	
	    if (orient === 'horizontal') {
	      var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
	      nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
	      // FIXME compare before adding gap?
	
	      if (nextX > maxWidth || child.newline) {
	        x = 0;
	        nextX = moveX;
	        y += currentLineMaxSize + gap;
	        currentLineMaxSize = rect.height;
	      } else {
	        // FIXME: consider rect.y is not `0`?
	        currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
	      }
	    } else {
	      var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
	      nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group
	
	      if (nextY > maxHeight || child.newline) {
	        x += currentLineMaxSize + gap;
	        y = 0;
	        nextY = moveY;
	        currentLineMaxSize = rect.width;
	      } else {
	        currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
	      }
	    }
	
	    if (child.newline) {
	      return;
	    }
	
	    position[0] = x;
	    position[1] = y;
	    orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
	  });
	}
	/**
	 * VBox or HBox layouting
	 * @param {string} orient
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	
	var box = boxLayout;
	/**
	 * VBox layouting
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	var vbox = zrUtil.curry(boxLayout, 'vertical');
	/**
	 * HBox layouting
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	var hbox = zrUtil.curry(boxLayout, 'horizontal');
	/**
	 * If x or x2 is not specified or 'center' 'left' 'right',
	 * the width would be as long as possible.
	 * If y or y2 is not specified or 'middle' 'top' 'bottom',
	 * the height would be as long as possible.
	 *
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.x]
	 * @param {number|string} [positionInfo.y]
	 * @param {number|string} [positionInfo.x2]
	 * @param {number|string} [positionInfo.y2]
	 * @param {Object} containerRect {width, height}
	 * @param {string|number} margin
	 * @return {Object} {width, height}
	 */
	
	function getAvailableSize(positionInfo, containerRect, margin) {
	  var containerWidth = containerRect.width;
	  var containerHeight = containerRect.height;
	  var x = parsePercent(positionInfo.x, containerWidth);
	  var y = parsePercent(positionInfo.y, containerHeight);
	  var x2 = parsePercent(positionInfo.x2, containerWidth);
	  var y2 = parsePercent(positionInfo.y2, containerHeight);
	  (isNaN(x) || isNaN(parseFloat(positionInfo.x))) && (x = 0);
	  (isNaN(x2) || isNaN(parseFloat(positionInfo.x2))) && (x2 = containerWidth);
	  (isNaN(y) || isNaN(parseFloat(positionInfo.y))) && (y = 0);
	  (isNaN(y2) || isNaN(parseFloat(positionInfo.y2))) && (y2 = containerHeight);
	  margin = formatUtil.normalizeCssArray(margin || 0);
	  return {
	    width: Math.max(x2 - x - margin[1] - margin[3], 0),
	    height: Math.max(y2 - y - margin[0] - margin[2], 0)
	  };
	}
	/**
	 * Parse position info.
	 *
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.left]
	 * @param {number|string} [positionInfo.top]
	 * @param {number|string} [positionInfo.right]
	 * @param {number|string} [positionInfo.bottom]
	 * @param {number|string} [positionInfo.width]
	 * @param {number|string} [positionInfo.height]
	 * @param {number|string} [positionInfo.aspect] Aspect is width / height
	 * @param {Object} containerRect
	 * @param {string|number} [margin]
	 *
	 * @return {module:zrender/core/BoundingRect}
	 */
	
	
	function getLayoutRect(positionInfo, containerRect, margin) {
	  margin = formatUtil.normalizeCssArray(margin || 0);
	  var containerWidth = containerRect.width;
	  var containerHeight = containerRect.height;
	  var left = parsePercent(positionInfo.left, containerWidth);
	  var top = parsePercent(positionInfo.top, containerHeight);
	  var right = parsePercent(positionInfo.right, containerWidth);
	  var bottom = parsePercent(positionInfo.bottom, containerHeight);
	  var width = parsePercent(positionInfo.width, containerWidth);
	  var height = parsePercent(positionInfo.height, containerHeight);
	  var verticalMargin = margin[2] + margin[0];
	  var horizontalMargin = margin[1] + margin[3];
	  var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right
	
	  if (isNaN(width)) {
	    width = containerWidth - right - horizontalMargin - left;
	  }
	
	  if (isNaN(height)) {
	    height = containerHeight - bottom - verticalMargin - top;
	  }
	
	  if (aspect != null) {
	    // If width and height are not given
	    // 1. Graph should not exceeds the container
	    // 2. Aspect must be keeped
	    // 3. Graph should take the space as more as possible
	    // FIXME
	    // Margin is not considered, because there is no case that both
	    // using margin and aspect so far.
	    if (isNaN(width) && isNaN(height)) {
	      if (aspect > containerWidth / containerHeight) {
	        width = containerWidth * 0.8;
	      } else {
	        height = containerHeight * 0.8;
	      }
	    } // Calculate width or height with given aspect
	
	
	    if (isNaN(width)) {
	      width = aspect * height;
	    }
	
	    if (isNaN(height)) {
	      height = width / aspect;
	    }
	  } // If left is not specified, calculate left from right and width
	
	
	  if (isNaN(left)) {
	    left = containerWidth - right - width - horizontalMargin;
	  }
	
	  if (isNaN(top)) {
	    top = containerHeight - bottom - height - verticalMargin;
	  } // Align left and top
	
	
	  switch (positionInfo.left || positionInfo.right) {
	    case 'center':
	      left = containerWidth / 2 - width / 2 - margin[3];
	      break;
	
	    case 'right':
	      left = containerWidth - width - horizontalMargin;
	      break;
	  }
	
	  switch (positionInfo.top || positionInfo.bottom) {
	    case 'middle':
	    case 'center':
	      top = containerHeight / 2 - height / 2 - margin[0];
	      break;
	
	    case 'bottom':
	      top = containerHeight - height - verticalMargin;
	      break;
	  } // If something is wrong and left, top, width, height are calculated as NaN
	
	
	  left = left || 0;
	  top = top || 0;
	
	  if (isNaN(width)) {
	    // Width may be NaN if only one value is given except width
	    width = containerWidth - horizontalMargin - left - (right || 0);
	  }
	
	  if (isNaN(height)) {
	    // Height may be NaN if only one value is given except height
	    height = containerHeight - verticalMargin - top - (bottom || 0);
	  }
	
	  var rect = new BoundingRect(left + margin[3], top + margin[0], width, height);
	  rect.margin = margin;
	  return rect;
	}
	/**
	 * Position a zr element in viewport
	 *  Group position is specified by either
	 *  {left, top}, {right, bottom}
	 *  If all properties exists, right and bottom will be igonred.
	 *
	 * Logic:
	 *     1. Scale (against origin point in parent coord)
	 *     2. Rotate (against origin point in parent coord)
	 *     3. Traslate (with el.position by this method)
	 * So this method only fixes the last step 'Traslate', which does not affect
	 * scaling and rotating.
	 *
	 * If be called repeatly with the same input el, the same result will be gotten.
	 *
	 * @param {module:zrender/Element} el Should have `getBoundingRect` method.
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.left]
	 * @param {number|string} [positionInfo.top]
	 * @param {number|string} [positionInfo.right]
	 * @param {number|string} [positionInfo.bottom]
	 * @param {number|string} [positionInfo.width] Only for opt.boundingModel: 'raw'
	 * @param {number|string} [positionInfo.height] Only for opt.boundingModel: 'raw'
	 * @param {Object} containerRect
	 * @param {string|number} margin
	 * @param {Object} [opt]
	 * @param {Array.<number>} [opt.hv=[1,1]] Only horizontal or only vertical.
	 * @param {Array.<number>} [opt.boundingMode='all']
	 *        Specify how to calculate boundingRect when locating.
	 *        'all': Position the boundingRect that is transformed and uioned
	 *               both itself and its descendants.
	 *               This mode simplies confine the elements in the bounding
	 *               of their container (e.g., using 'right: 0').
	 *        'raw': Position the boundingRect that is not transformed and only itself.
	 *               This mode is useful when you want a element can overflow its
	 *               container. (Consider a rotated circle needs to be located in a corner.)
	 *               In this mode positionInfo.width/height can only be number.
	 */
	
	
	function positionElement(el, positionInfo, containerRect, margin, opt) {
	  var h = !opt || !opt.hv || opt.hv[0];
	  var v = !opt || !opt.hv || opt.hv[1];
	  var boundingMode = opt && opt.boundingMode || 'all';
	
	  if (!h && !v) {
	    return;
	  }
	
	  var rect;
	
	  if (boundingMode === 'raw') {
	    rect = el.type === 'group' ? new BoundingRect(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
	  } else {
	    rect = el.getBoundingRect();
	
	    if (el.needLocalTransform()) {
	      var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
	      // which should not be modified.
	
	      rect = rect.clone();
	      rect.applyTransform(transform);
	    }
	  } // The real width and height can not be specified but calculated by the given el.
	
	
	  positionInfo = getLayoutRect(zrUtil.defaults({
	    width: rect.width,
	    height: rect.height
	  }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
	  // (see zrender/core/Transformable#getLocalTransfrom),
	  // we can just only modify el.position to get final result.
	
	  var elPos = el.position;
	  var dx = h ? positionInfo.x - rect.x : 0;
	  var dy = v ? positionInfo.y - rect.y : 0;
	  el.attr('position', boundingMode === 'raw' ? [dx, dy] : [elPos[0] + dx, elPos[1] + dy]);
	}
	/**
	 * @param {Object} option Contains some of the properties in HV_NAMES.
	 * @param {number} hvIdx 0: horizontal; 1: vertical.
	 */
	
	
	function sizeCalculable(option, hvIdx) {
	  return option[HV_NAMES[hvIdx][0]] != null || option[HV_NAMES[hvIdx][1]] != null && option[HV_NAMES[hvIdx][2]] != null;
	}
	/**
	 * Consider Case:
	 * When defulat option has {left: 0, width: 100}, and we set {right: 0}
	 * through setOption or media query, using normal zrUtil.merge will cause
	 * {right: 0} does not take effect.
	 *
	 * @example
	 * ComponentModel.extend({
	 *     init: function () {
	 *         ...
	 *         var inputPositionParams = layout.getLayoutParams(option);
	 *         this.mergeOption(inputPositionParams);
	 *     },
	 *     mergeOption: function (newOption) {
	 *         newOption && zrUtil.merge(thisOption, newOption, true);
	 *         layout.mergeLayoutParam(thisOption, newOption);
	 *     }
	 * });
	 *
	 * @param {Object} targetOption
	 * @param {Object} newOption
	 * @param {Object|string} [opt]
	 * @param {boolean|Array.<boolean>} [opt.ignoreSize=false] Used for the components
	 *  that width (or height) should not be calculated by left and right (or top and bottom).
	 */
	
	
	function mergeLayoutParam(targetOption, newOption, opt) {
	  !zrUtil.isObject(opt) && (opt = {});
	  var ignoreSize = opt.ignoreSize;
	  !zrUtil.isArray(ignoreSize) && (ignoreSize = [ignoreSize, ignoreSize]);
	  var hResult = merge(HV_NAMES[0], 0);
	  var vResult = merge(HV_NAMES[1], 1);
	  copy(HV_NAMES[0], targetOption, hResult);
	  copy(HV_NAMES[1], targetOption, vResult);
	
	  function merge(names, hvIdx) {
	    var newParams = {};
	    var newValueCount = 0;
	    var merged = {};
	    var mergedValueCount = 0;
	    var enoughParamNumber = 2;
	    each(names, function (name) {
	      merged[name] = targetOption[name];
	    });
	    each(names, function (name) {
	      // Consider case: newOption.width is null, which is
	      // set by user for removing width setting.
	      hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
	      hasValue(newParams, name) && newValueCount++;
	      hasValue(merged, name) && mergedValueCount++;
	    });
	
	    if (ignoreSize[hvIdx]) {
	      // Only one of left/right is premitted to exist.
	      if (hasValue(newOption, names[1])) {
	        merged[names[2]] = null;
	      } else if (hasValue(newOption, names[2])) {
	        merged[names[1]] = null;
	      }
	
	      return merged;
	    } // Case: newOption: {width: ..., right: ...},
	    // or targetOption: {right: ...} and newOption: {width: ...},
	    // There is no conflict when merged only has params count
	    // little than enoughParamNumber.
	
	
	    if (mergedValueCount === enoughParamNumber || !newValueCount) {
	      return merged;
	    } // Case: newOption: {width: ..., right: ...},
	    // Than we can make sure user only want those two, and ignore
	    // all origin params in targetOption.
	    else if (newValueCount >= enoughParamNumber) {
	        return newParams;
	      } else {
	        // Chose another param from targetOption by priority.
	        for (var i = 0; i < names.length; i++) {
	          var name = names[i];
	
	          if (!hasProp(newParams, name) && hasProp(targetOption, name)) {
	            newParams[name] = targetOption[name];
	            break;
	          }
	        }
	
	        return newParams;
	      }
	  }
	
	  function hasProp(obj, name) {
	    return obj.hasOwnProperty(name);
	  }
	
	  function hasValue(obj, name) {
	    return obj[name] != null && obj[name] !== 'auto';
	  }
	
	  function copy(names, target, source) {
	    each(names, function (name) {
	      target[name] = source[name];
	    });
	  }
	}
	/**
	 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
	 * @param {Object} source
	 * @return {Object} Result contains those props.
	 */
	
	
	function getLayoutParams(source) {
	  return copyLayoutParams({}, source);
	}
	/**
	 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
	 * @param {Object} source
	 * @return {Object} Result contains those props.
	 */
	
	
	function copyLayoutParams(target, source) {
	  source && target && each(LOCATION_PARAMS, function (name) {
	    source.hasOwnProperty(name) && (target[name] = source[name]);
	  });
	  return target;
	}
	
	exports.LOCATION_PARAMS = LOCATION_PARAMS;
	exports.HV_NAMES = HV_NAMES;
	exports.box = box;
	exports.vbox = vbox;
	exports.hbox = hbox;
	exports.getAvailableSize = getAvailableSize;
	exports.getLayoutRect = getLayoutRect;
	exports.positionElement = positionElement;
	exports.sizeCalculable = sizeCalculable;
	exports.mergeLayoutParam = mergeLayoutParam;
	exports.getLayoutParams = getLayoutParams;
	exports.copyLayoutParams = copyLayoutParams;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
	/**
	 * 创建一个向量
	 * @param {number} [x=0]
	 * @param {number} [y=0]
	 * @return {Vector2}
	 */
	
	function create(x, y) {
	  var out = new ArrayCtor(2);
	
	  if (x == null) {
	    x = 0;
	  }
	
	  if (y == null) {
	    y = 0;
	  }
	
	  out[0] = x;
	  out[1] = y;
	  return out;
	}
	/**
	 * 复制向量数据
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @return {Vector2}
	 */
	
	
	function copy(out, v) {
	  out[0] = v[0];
	  out[1] = v[1];
	  return out;
	}
	/**
	 * 克隆一个向量
	 * @param {Vector2} v
	 * @return {Vector2}
	 */
	
	
	function clone(v) {
	  var out = new ArrayCtor(2);
	  out[0] = v[0];
	  out[1] = v[1];
	  return out;
	}
	/**
	 * 设置向量的两个项
	 * @param {Vector2} out
	 * @param {number} a
	 * @param {number} b
	 * @return {Vector2} 结果
	 */
	
	
	function set(out, a, b) {
	  out[0] = a;
	  out[1] = b;
	  return out;
	}
	/**
	 * 向量相加
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function add(out, v1, v2) {
	  out[0] = v1[0] + v2[0];
	  out[1] = v1[1] + v2[1];
	  return out;
	}
	/**
	 * 向量缩放后相加
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @param {number} a
	 */
	
	
	function scaleAndAdd(out, v1, v2, a) {
	  out[0] = v1[0] + v2[0] * a;
	  out[1] = v1[1] + v2[1] * a;
	  return out;
	}
	/**
	 * 向量相减
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function sub(out, v1, v2) {
	  out[0] = v1[0] - v2[0];
	  out[1] = v1[1] - v2[1];
	  return out;
	}
	/**
	 * 向量长度
	 * @param {Vector2} v
	 * @return {number}
	 */
	
	
	function len(v) {
	  return Math.sqrt(lenSquare(v));
	}
	
	var length = len; // jshint ignore:line
	
	/**
	 * 向量长度平方
	 * @param {Vector2} v
	 * @return {number}
	 */
	
	function lenSquare(v) {
	  return v[0] * v[0] + v[1] * v[1];
	}
	
	var lengthSquare = lenSquare;
	/**
	 * 向量乘法
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	function mul(out, v1, v2) {
	  out[0] = v1[0] * v2[0];
	  out[1] = v1[1] * v2[1];
	  return out;
	}
	/**
	 * 向量除法
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function div(out, v1, v2) {
	  out[0] = v1[0] / v2[0];
	  out[1] = v1[1] / v2[1];
	  return out;
	}
	/**
	 * 向量点乘
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	
	function dot(v1, v2) {
	  return v1[0] * v2[0] + v1[1] * v2[1];
	}
	/**
	 * 向量缩放
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @param {number} s
	 */
	
	
	function scale(out, v, s) {
	  out[0] = v[0] * s;
	  out[1] = v[1] * s;
	  return out;
	}
	/**
	 * 向量归一化
	 * @param {Vector2} out
	 * @param {Vector2} v
	 */
	
	
	function normalize(out, v) {
	  var d = len(v);
	
	  if (d === 0) {
	    out[0] = 0;
	    out[1] = 0;
	  } else {
	    out[0] = v[0] / d;
	    out[1] = v[1] / d;
	  }
	
	  return out;
	}
	/**
	 * 计算向量间距离
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	
	function distance(v1, v2) {
	  return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
	}
	
	var dist = distance;
	/**
	 * 向量距离平方
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	function distanceSquare(v1, v2) {
	  return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
	}
	
	var distSquare = distanceSquare;
	/**
	 * 求负向量
	 * @param {Vector2} out
	 * @param {Vector2} v
	 */
	
	function negate(out, v) {
	  out[0] = -v[0];
	  out[1] = -v[1];
	  return out;
	}
	/**
	 * 插值两个点
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @param {number} t
	 */
	
	
	function lerp(out, v1, v2, t) {
	  out[0] = v1[0] + t * (v2[0] - v1[0]);
	  out[1] = v1[1] + t * (v2[1] - v1[1]);
	  return out;
	}
	/**
	 * 矩阵左乘向量
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @param {Vector2} m
	 */
	
	
	function applyTransform(out, v, m) {
	  var x = v[0];
	  var y = v[1];
	  out[0] = m[0] * x + m[2] * y + m[4];
	  out[1] = m[1] * x + m[3] * y + m[5];
	  return out;
	}
	/**
	 * 求两个向量最小值
	 * @param  {Vector2} out
	 * @param  {Vector2} v1
	 * @param  {Vector2} v2
	 */
	
	
	function min(out, v1, v2) {
	  out[0] = Math.min(v1[0], v2[0]);
	  out[1] = Math.min(v1[1], v2[1]);
	  return out;
	}
	/**
	 * 求两个向量最大值
	 * @param  {Vector2} out
	 * @param  {Vector2} v1
	 * @param  {Vector2} v2
	 */
	
	
	function max(out, v1, v2) {
	  out[0] = Math.max(v1[0], v2[0]);
	  out[1] = Math.max(v1[1], v2[1]);
	  return out;
	}
	
	exports.create = create;
	exports.copy = copy;
	exports.clone = clone;
	exports.set = set;
	exports.add = add;
	exports.scaleAndAdd = scaleAndAdd;
	exports.sub = sub;
	exports.len = len;
	exports.length = length;
	exports.lenSquare = lenSquare;
	exports.lengthSquare = lengthSquare;
	exports.mul = mul;
	exports.div = div;
	exports.dot = dot;
	exports.scale = scale;
	exports.normalize = normalize;
	exports.distance = distance;
	exports.dist = dist;
	exports.distanceSquare = distanceSquare;
	exports.distSquare = distSquare;
	exports.negate = negate;
	exports.lerp = lerp;
	exports.applyTransform = applyTransform;
	exports.min = min;
	exports.max = max;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var textContain = __webpack_require__(27);
	
	var numberUtil = __webpack_require__(4);
	
	/**
	 * 每三位默认加,格式化
	 * @param {string|number} x
	 * @return {string}
	 */
	function addCommas(x) {
	  if (isNaN(x)) {
	    return '-';
	  }
	
	  x = (x + '').split('.');
	  return x[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (x.length > 1 ? '.' + x[1] : '');
	}
	/**
	 * @param {string} str
	 * @param {boolean} [upperCaseFirst=false]
	 * @return {string} str
	 */
	
	
	function toCamelCase(str, upperCaseFirst) {
	  str = (str || '').toLowerCase().replace(/-(.)/g, function (match, group1) {
	    return group1.toUpperCase();
	  });
	
	  if (upperCaseFirst && str) {
	    str = str.charAt(0).toUpperCase() + str.slice(1);
	  }
	
	  return str;
	}
	
	var normalizeCssArray = zrUtil.normalizeCssArray;
	
	function encodeHTML(source) {
	  return String(source).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}
	
	var TPL_VAR_ALIAS = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];
	
	var wrapVar = function (varName, seriesIdx) {
	  return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
	};
	/**
	 * Template formatter
	 * @param {string} tpl
	 * @param {Array.<Object>|Object} paramsList
	 * @param {boolean} [encode=false]
	 * @return {string}
	 */
	
	
	function formatTpl(tpl, paramsList, encode) {
	  if (!zrUtil.isArray(paramsList)) {
	    paramsList = [paramsList];
	  }
	
	  var seriesLen = paramsList.length;
	
	  if (!seriesLen) {
	    return '';
	  }
	
	  var $vars = paramsList[0].$vars || [];
	
	  for (var i = 0; i < $vars.length; i++) {
	    var alias = TPL_VAR_ALIAS[i];
	    var val = wrapVar(alias, 0);
	    tpl = tpl.replace(wrapVar(alias), encode ? encodeHTML(val) : val);
	  }
	
	  for (var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++) {
	    for (var k = 0; k < $vars.length; k++) {
	      var val = paramsList[seriesIdx][$vars[k]];
	      tpl = tpl.replace(wrapVar(TPL_VAR_ALIAS[k], seriesIdx), encode ? encodeHTML(val) : val);
	    }
	  }
	
	  return tpl;
	}
	/**
	 * simple Template formatter
	 *
	 * @param {string} tpl
	 * @param {Object} param
	 * @param {boolean} [encode=false]
	 * @return {string}
	 */
	
	
	function formatTplSimple(tpl, param, encode) {
	  zrUtil.each(param, function (value, key) {
	    tpl = tpl.replace('{' + key + '}', encode ? encodeHTML(value) : value);
	  });
	  return tpl;
	}
	/**
	 * @param {string} color
	 * @param {string} [extraCssText]
	 * @return {string}
	 */
	
	
	function getTooltipMarker(color, extraCssText) {
	  return color ? '<span style="display:inline-block;margin-right:5px;' + 'border-radius:10px;width:9px;height:9px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>' : '';
	}
	/**
	 * @param {string} str
	 * @return {string}
	 * @inner
	 */
	
	
	var s2d = function (str) {
	  return str < 10 ? '0' + str : str;
	};
	/**
	 * ISO Date format
	 * @param {string} tpl
	 * @param {number} value
	 * @param {boolean} [isUTC=false] Default in local time.
	 *           see `module:echarts/scale/Time`
	 *           and `module:echarts/util/number#parseDate`.
	 * @inner
	 */
	
	
	function formatTime(tpl, value, isUTC) {
	  if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') {
	    tpl = 'MM-dd\nyyyy';
	  }
	
	  var date = numberUtil.parseDate(value);
	  var utc = isUTC ? 'UTC' : '';
	  var y = date['get' + utc + 'FullYear']();
	  var M = date['get' + utc + 'Month']() + 1;
	  var d = date['get' + utc + 'Date']();
	  var h = date['get' + utc + 'Hours']();
	  var m = date['get' + utc + 'Minutes']();
	  var s = date['get' + utc + 'Seconds']();
	  tpl = tpl.replace('MM', s2d(M)).replace('M', M).replace('yyyy', y).replace('yy', y % 100).replace('dd', s2d(d)).replace('d', d).replace('hh', s2d(h)).replace('h', h).replace('mm', s2d(m)).replace('m', m).replace('ss', s2d(s)).replace('s', s);
	  return tpl;
	}
	/**
	 * Capital first
	 * @param {string} str
	 * @return {string}
	 */
	
	
	function capitalFirst(str) {
	  return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
	}
	
	var truncateText = textContain.truncateText;
	var getTextRect = textContain.getBoundingRect;
	exports.addCommas = addCommas;
	exports.toCamelCase = toCamelCase;
	exports.normalizeCssArray = normalizeCssArray;
	exports.encodeHTML = encodeHTML;
	exports.formatTpl = formatTpl;
	exports.formatTplSimple = formatTplSimple;
	exports.getTooltipMarker = getTooltipMarker;
	exports.formatTime = formatTime;
	exports.capitalFirst = capitalFirst;
	exports.truncateText = truncateText;
	exports.getTextRect = getTextRect;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v2.2.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-05-20T17:23Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var arr = [];
	
	var document = window.document;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "2.2.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			// Not own constructor property must be Object
			if ( obj.constructor &&
					!hasOwn.call( obj, "constructor" ) &&
					!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
				return false;
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
	
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf( "use strict" ) === 1 ) {
					script = document.createElement( "script" );
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
	
					// Otherwise, avoid the DOM node creation, insertion
					// and removal by using an indirect global eval
	
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
	
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE9-10 only
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		register: function( owner, initial ) {
			var value = initial || {};
	
			// If it is a node unlikely to be stringify-ed or looped over
			// use plain assignment
			if ( owner.nodeType ) {
				owner[ this.expando ] = value;
	
			// Otherwise secure it in a non-enumerable, non-writable property
			// configurability must be true to allow the property to be
			// deleted with the delete operator
			} else {
				Object.defineProperty( owner, this.expando, {
					value: value,
					writable: true,
					configurable: true
				} );
			}
			return owner[ this.expando ];
		},
		cache: function( owner ) {
	
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( !acceptData( owner ) ) {
				return {};
			}
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
				owner[ this.expando ] && owner[ this.expando ][ key ];
		},
		access: function( owner, key, value ) {
			var stored;
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase( key ) );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key === undefined ) {
				this.register( owner );
	
			} else {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
	
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
	
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
	
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <= 35-45+
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://code.google.com/p/chromium/issues/detail?id=378607
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data, camelKey;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// with the key as-is
					data = dataUser.get( elem, key ) ||
	
						// Try to find dashed key if it exists (gh-2779)
						// This is for 2.2.x only
						dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );
	
					if ( data !== undefined ) {
						return data;
					}
	
					camelKey = jQuery.camelCase( key );
	
					// Attempt to get data from the cache
					// with the key camelized
					data = dataUser.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				camelKey = jQuery.camelCase( key );
				this.each( function() {
	
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = dataUser.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					dataUser.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
						dataUser.set( this, key, value );
					}
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE9-11+
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0-4.3, Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
				"screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
			div.style.cssText =
	
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
		}
	
		jQuery.extend( support, {
			pixelPosition: function() {
	
				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
				// since that compresses better and they're computed together anyway.
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			},
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;box-sizing:content-box;" +
					"display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				documentElement.appendChild( container );
	
				ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );
	
				documentElement.removeChild( container );
				div.removeChild( marginDiv );
	
				return ret;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE9-11+
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = dataPriv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = dataPriv.access(
						elem,
						"olddisplay",
						defaultDisplay( elem.nodeName )
					);
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					dataPriv.set(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
	
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
			opt.duration : opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// Handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE8-11+
				// IE throws exception if url is malformed, e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE8-11+
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		return !jQuery.expr.filters.visible( elem );
	};
	jQuery.expr.filters.visible = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		// Use OR instead of AND as the element is not visible if either is true
		// See tickets #10406 and #13132
		return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE9
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE9
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			box = elem.getBoundingClientRect();
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
		size: function() {
			return this.length;
		}
	} );
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  user: {},
	  cart: [],
	  root: (""),
	  auth: false,
	  banner: false,
	  token: localStorage.getItem('__token'),
	  selectedCat: '',
	  login: function login(username, password, callback) {
	    var self = this;
	    var loginData = {
	      grant_type: 'password',
	      username: username,
	      password: password
	    };
	    $.ajax({
	      type: 'POST',
	      url: self.root + 'api/token',
	      data: loginData
	    }).done(function (data) {
	      self.token = data.access_token;
	      self.auth = true;
	
	      localStorage.setItem('__token', data.access_token);
	      callback(true, data);
	    }).fail(function (message) {
	      console.log('error');
	      callback(false, message);
	    });
	  },
	  checkAuth: function checkAuth() {
	    if (this.token !== null) {
	      var self = this;
	      $.ajax({
	        type: 'GET',
	        url: self.root + 'api/account',
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + self.token);
	        }
	      }).done(function () {
	        self.auth = true;
	      }).fail(function () {
	        localStorage.removeItem('__token');
	      });
	    }
	  },
	  checkBanner: function checkBanner() {
	    var self = this;
	    $.ajax({
	      type: 'GET',
	      url: self.root + 'api/AdminConfigs'
	    }).done(function (response) {
	      for (var i = 0; i < response.length; i++) {
	        if (response[i].Enabled) {
	          self.banner = response[i];
	        }
	      }
	    }).fail(function () {
	      self.banner = false;
	    });
	  },
	  logout: function logout() {
	    var self = this;
	    localStorage.removeItem('__token');
	    self.token = null;
	    self.auth = false;
	    location.reload(true);
	  },
	  isLoggedIn: function isLoggedIn() {
	    if (localStorage.getItem('__token')) {
	      return true;
	    }
	    return false;
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var vec2 = __webpack_require__(8);
	
	var matrix = __webpack_require__(23);
	
	/**
	 * @module echarts/core/BoundingRect
	 */
	var v2ApplyTransform = vec2.applyTransform;
	var mathMin = Math.min;
	var mathMax = Math.max;
	/**
	 * @alias module:echarts/core/BoundingRect
	 */
	
	function BoundingRect(x, y, width, height) {
	  if (width < 0) {
	    x = x + width;
	    width = -width;
	  }
	
	  if (height < 0) {
	    y = y + height;
	    height = -height;
	  }
	  /**
	   * @type {number}
	   */
	
	
	  this.x = x;
	  /**
	   * @type {number}
	   */
	
	  this.y = y;
	  /**
	   * @type {number}
	   */
	
	  this.width = width;
	  /**
	   * @type {number}
	   */
	
	  this.height = height;
	}
	
	BoundingRect.prototype = {
	  constructor: BoundingRect,
	
	  /**
	   * @param {module:echarts/core/BoundingRect} other
	   */
	  union: function (other) {
	    var x = mathMin(other.x, this.x);
	    var y = mathMin(other.y, this.y);
	    this.width = mathMax(other.x + other.width, this.x + this.width) - x;
	    this.height = mathMax(other.y + other.height, this.y + this.height) - y;
	    this.x = x;
	    this.y = y;
	  },
	
	  /**
	   * @param {Array.<number>} m
	   * @methods
	   */
	  applyTransform: function () {
	    var lt = [];
	    var rb = [];
	    var lb = [];
	    var rt = [];
	    return function (m) {
	      // In case usage like this
	      // el.getBoundingRect().applyTransform(el.transform)
	      // And element has no transform
	      if (!m) {
	        return;
	      }
	
	      lt[0] = lb[0] = this.x;
	      lt[1] = rt[1] = this.y;
	      rb[0] = rt[0] = this.x + this.width;
	      rb[1] = lb[1] = this.y + this.height;
	      v2ApplyTransform(lt, lt, m);
	      v2ApplyTransform(rb, rb, m);
	      v2ApplyTransform(lb, lb, m);
	      v2ApplyTransform(rt, rt, m);
	      this.x = mathMin(lt[0], rb[0], lb[0], rt[0]);
	      this.y = mathMin(lt[1], rb[1], lb[1], rt[1]);
	      var maxX = mathMax(lt[0], rb[0], lb[0], rt[0]);
	      var maxY = mathMax(lt[1], rb[1], lb[1], rt[1]);
	      this.width = maxX - this.x;
	      this.height = maxY - this.y;
	    };
	  }(),
	
	  /**
	   * Calculate matrix of transforming from self to target rect
	   * @param  {module:zrender/core/BoundingRect} b
	   * @return {Array.<number>}
	   */
	  calculateTransform: function (b) {
	    var a = this;
	    var sx = b.width / a.width;
	    var sy = b.height / a.height;
	    var m = matrix.create(); // 矩阵右乘
	
	    matrix.translate(m, m, [-a.x, -a.y]);
	    matrix.scale(m, m, [sx, sy]);
	    matrix.translate(m, m, [b.x, b.y]);
	    return m;
	  },
	
	  /**
	   * @param {(module:echarts/core/BoundingRect|Object)} b
	   * @return {boolean}
	   */
	  intersect: function (b) {
	    if (!b) {
	      return false;
	    }
	
	    if (!(b instanceof BoundingRect)) {
	      // Normalize negative width/height.
	      b = BoundingRect.create(b);
	    }
	
	    var a = this;
	    var ax0 = a.x;
	    var ax1 = a.x + a.width;
	    var ay0 = a.y;
	    var ay1 = a.y + a.height;
	    var bx0 = b.x;
	    var bx1 = b.x + b.width;
	    var by0 = b.y;
	    var by1 = b.y + b.height;
	    return !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
	  },
	  contain: function (x, y) {
	    var rect = this;
	    return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
	  },
	
	  /**
	   * @return {module:echarts/core/BoundingRect}
	   */
	  clone: function () {
	    return new BoundingRect(this.x, this.y, this.width, this.height);
	  },
	
	  /**
	   * Copy from another rect
	   */
	  copy: function (other) {
	    this.x = other.x;
	    this.y = other.y;
	    this.width = other.width;
	    this.height = other.height;
	  },
	  plain: function () {
	    return {
	      x: this.x,
	      y: this.y,
	      width: this.width,
	      height: this.height
	    };
	  }
	};
	/**
	 * @param {Object|module:zrender/core/BoundingRect} rect
	 * @param {number} rect.x
	 * @param {number} rect.y
	 * @param {number} rect.width
	 * @param {number} rect.height
	 * @return {module:zrender/core/BoundingRect}
	 */
	
	BoundingRect.create = function (rect) {
	  return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
	};
	
	var _default = BoundingRect;
	module.exports = _default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var env = __webpack_require__(18);
	
	var clazzUtil = __webpack_require__(28);
	
	var lineStyleMixin = __webpack_require__(588);
	
	var areaStyleMixin = __webpack_require__(585);
	
	var textStyleMixin = __webpack_require__(589);
	
	var itemStyleMixin = __webpack_require__(587);
	
	/**
	 * @module echarts/model/Model
	 */
	var mixin = zrUtil.mixin;
	/**
	 * @alias module:echarts/model/Model
	 * @constructor
	 * @param {Object} option
	 * @param {module:echarts/model/Model} [parentModel]
	 * @param {module:echarts/model/Global} [ecModel]
	 */
	
	function Model(option, parentModel, ecModel) {
	  /**
	   * @type {module:echarts/model/Model}
	   * @readOnly
	   */
	  this.parentModel = parentModel;
	  /**
	   * @type {module:echarts/model/Global}
	   * @readOnly
	   */
	
	  this.ecModel = ecModel;
	  /**
	   * @type {Object}
	   * @protected
	   */
	
	  this.option = option; // Simple optimization
	  // if (this.init) {
	  //     if (arguments.length <= 4) {
	  //         this.init(option, parentModel, ecModel, extraOpt);
	  //     }
	  //     else {
	  //         this.init.apply(this, arguments);
	  //     }
	  // }
	}
	
	Model.prototype = {
	  constructor: Model,
	
	  /**
	   * Model 的初始化函数
	   * @param {Object} option
	   */
	  init: null,
	
	  /**
	   * 从新的 Option merge
	   */
	  mergeOption: function (option) {
	    zrUtil.merge(this.option, option, true);
	  },
	
	  /**
	   * @param {string|Array.<string>} path
	   * @param {boolean} [ignoreParent=false]
	   * @return {*}
	   */
	  get: function (path, ignoreParent) {
	    if (path == null) {
	      return this.option;
	    }
	
	    return doGet(this.option, this.parsePath(path), !ignoreParent && getParent(this, path));
	  },
	
	  /**
	   * @param {string} key
	   * @param {boolean} [ignoreParent=false]
	   * @return {*}
	   */
	  getShallow: function (key, ignoreParent) {
	    var option = this.option;
	    var val = option == null ? option : option[key];
	    var parentModel = !ignoreParent && getParent(this, key);
	
	    if (val == null && parentModel) {
	      val = parentModel.getShallow(key);
	    }
	
	    return val;
	  },
	
	  /**
	   * @param {string|Array.<string>} [path]
	   * @param {module:echarts/model/Model} [parentModel]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path, parentModel) {
	    var obj = path == null ? this.option : doGet(this.option, path = this.parsePath(path));
	    var thisParentModel;
	    parentModel = parentModel || (thisParentModel = getParent(this, path)) && thisParentModel.getModel(path);
	    return new Model(obj, parentModel, this.ecModel);
	  },
	
	  /**
	   * If model has option
	   */
	  isEmpty: function () {
	    return this.option == null;
	  },
	  restoreData: function () {},
	  // Pending
	  clone: function () {
	    var Ctor = this.constructor;
	    return new Ctor(zrUtil.clone(this.option));
	  },
	  setReadOnly: function (properties) {
	    clazzUtil.setReadOnly(this, properties);
	  },
	  // If path is null/undefined, return null/undefined.
	  parsePath: function (path) {
	    if (typeof path === 'string') {
	      path = path.split('.');
	    }
	
	    return path;
	  },
	
	  /**
	   * @param {Function} getParentMethod
	   *        param {Array.<string>|string} path
	   *        return {module:echarts/model/Model}
	   */
	  customizeGetParent: function (getParentMethod) {
	    clazzUtil.set(this, 'getParent', getParentMethod);
	  },
	  isAnimationEnabled: function () {
	    if (!env.node) {
	      if (this.option.animation != null) {
	        return !!this.option.animation;
	      } else if (this.parentModel) {
	        return this.parentModel.isAnimationEnabled();
	      }
	    }
	  }
	};
	
	function doGet(obj, pathArr, parentModel) {
	  for (var i = 0; i < pathArr.length; i++) {
	    // Ignore empty
	    if (!pathArr[i]) {
	      continue;
	    } // obj could be number/string/... (like 0)
	
	
	    obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
	
	    if (obj == null) {
	      break;
	    }
	  }
	
	  if (obj == null && parentModel) {
	    obj = parentModel.get(pathArr);
	  }
	
	  return obj;
	} // `path` can be null/undefined
	
	
	function getParent(model, path) {
	  var getParentMethod = clazzUtil.get(model, 'getParent');
	  return getParentMethod ? getParentMethod.call(model, path) : model.parentModel;
	} // Enable Model.extend.
	
	
	clazzUtil.enableClassExtend(Model);
	mixin(Model, lineStyleMixin);
	mixin(Model, areaStyleMixin);
	mixin(Model, textStyleMixin);
	mixin(Model, itemStyleMixin);
	var _default = Model;
	module.exports = _default;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(1);
	
	var Model = __webpack_require__(14);
	
	var DataDiffer = __webpack_require__(56);
	
	var modelUtil = __webpack_require__(6);
	
	/**
	 * List for data storage
	 * @module echarts/data/List
	 */
	var isObject = zrUtil.isObject;
	var UNDEFINED = 'undefined';
	var globalObj = typeof window === UNDEFINED ? global : window;
	var dataCtors = {
	  'float': typeof globalObj.Float64Array === UNDEFINED ? Array : globalObj.Float64Array,
	  'int': typeof globalObj.Int32Array === UNDEFINED ? Array : globalObj.Int32Array,
	  // Ordinal data type can be string or int
	  'ordinal': Array,
	  'number': Array,
	  'time': Array
	};
	var TRANSFERABLE_PROPERTIES = ['stackedOn', 'hasItemOption', '_nameList', '_idList', '_rawData'];
	
	function transferProperties(a, b) {
	  zrUtil.each(TRANSFERABLE_PROPERTIES.concat(b.__wrappedMethods || []), function (propName) {
	    if (b.hasOwnProperty(propName)) {
	      a[propName] = b[propName];
	    }
	  });
	  a.__wrappedMethods = b.__wrappedMethods;
	}
	
	function DefaultDataProvider(dataArray) {
	  this._array = dataArray || [];
	}
	
	DefaultDataProvider.prototype.pure = false;
	
	DefaultDataProvider.prototype.count = function () {
	  return this._array.length;
	};
	
	DefaultDataProvider.prototype.getItem = function (idx) {
	  return this._array[idx];
	};
	/**
	 * @constructor
	 * @alias module:echarts/data/List
	 *
	 * @param {Array.<string|Object>} dimensions
	 *      For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
	 *      Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
	 * @param {module:echarts/model/Model} hostModel
	 */
	
	
	var List = function (dimensions, hostModel) {
	  dimensions = dimensions || ['x', 'y'];
	  var dimensionInfos = {};
	  var dimensionNames = [];
	
	  for (var i = 0; i < dimensions.length; i++) {
	    var dimensionName;
	    var dimensionInfo = {};
	
	    if (typeof dimensions[i] === 'string') {
	      dimensionName = dimensions[i];
	      dimensionInfo = {
	        name: dimensionName,
	        coordDim: dimensionName,
	        coordDimIndex: 0,
	        stackable: false,
	        // Type can be 'float', 'int', 'number'
	        // Default is number, Precision of float may not enough
	        type: 'number'
	      };
	    } else {
	      dimensionInfo = dimensions[i];
	      dimensionName = dimensionInfo.name;
	      dimensionInfo.type = dimensionInfo.type || 'number';
	
	      if (!dimensionInfo.coordDim) {
	        dimensionInfo.coordDim = dimensionName;
	        dimensionInfo.coordDimIndex = 0;
	      }
	    }
	
	    dimensionInfo.otherDims = dimensionInfo.otherDims || {};
	    dimensionNames.push(dimensionName);
	    dimensionInfos[dimensionName] = dimensionInfo;
	  }
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	
	
	  this.dimensions = dimensionNames;
	  /**
	   * Infomation of each data dimension, like data type.
	   * @type {Object}
	   */
	
	  this._dimensionInfos = dimensionInfos;
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.hostModel = hostModel;
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.dataType;
	  /**
	   * Indices stores the indices of data subset after filtered.
	   * This data subset will be used in chart.
	   * @type {Array.<number>}
	   * @readOnly
	   */
	
	  this.indices = [];
	  /**
	   * Data storage
	   * @type {Object.<key, TypedArray|Array>}
	   * @private
	   */
	
	  this._storage = {};
	  /**
	   * @type {Array.<string>}
	   */
	
	  this._nameList = [];
	  /**
	   * @type {Array.<string>}
	   */
	
	  this._idList = [];
	  /**
	   * Models of data option is stored sparse for optimizing memory cost
	   * @type {Array.<module:echarts/model/Model>}
	   * @private
	   */
	
	  this._optionModels = [];
	  /**
	   * @param {module:echarts/data/List}
	   */
	
	  this.stackedOn = null;
	  /**
	   * Global visual properties after visual coding
	   * @type {Object}
	   * @private
	   */
	
	  this._visual = {};
	  /**
	   * Globel layout properties.
	   * @type {Object}
	   * @private
	   */
	
	  this._layout = {};
	  /**
	   * Item visual properties after visual coding
	   * @type {Array.<Object>}
	   * @private
	   */
	
	  this._itemVisuals = [];
	  /**
	   * Item layout properties after layout
	   * @type {Array.<Object>}
	   * @private
	   */
	
	  this._itemLayouts = [];
	  /**
	   * Graphic elemnents
	   * @type {Array.<module:zrender/Element>}
	   * @private
	   */
	
	  this._graphicEls = [];
	  /**
	   * @type {Array.<Array|Object>}
	   * @private
	   */
	
	  this._rawData;
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._extent;
	};
	
	var listProto = List.prototype;
	listProto.type = 'list';
	/**
	 * If each data item has it's own option
	 * @type {boolean}
	 */
	
	listProto.hasItemOption = true;
	/**
	 * Get dimension name
	 * @param {string|number} dim
	 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
	 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
	 * @return {string} Concrete dim name.
	 */
	
	listProto.getDimension = function (dim) {
	  if (!isNaN(dim)) {
	    dim = this.dimensions[dim] || dim;
	  }
	
	  return dim;
	};
	/**
	 * Get type and stackable info of particular dimension
	 * @param {string|number} dim
	 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
	 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
	 */
	
	
	listProto.getDimensionInfo = function (dim) {
	  return zrUtil.clone(this._dimensionInfos[this.getDimension(dim)]);
	};
	/**
	 * Initialize from data
	 * @param {Array.<Object|number|Array>} data
	 * @param {Array.<string>} [nameList]
	 * @param {Function} [dimValueGetter] (dataItem, dimName, dataIndex, dimIndex) => number
	 */
	
	
	listProto.initData = function (data, nameList, dimValueGetter) {
	  data = data || [];
	  var isDataArray = zrUtil.isArray(data);
	
	  if (isDataArray) {
	    data = new DefaultDataProvider(data);
	  }
	
	  this._rawData = data; // Clear
	
	  var storage = this._storage = {};
	  var indices = this.indices = [];
	  var dimensions = this.dimensions;
	  var dimensionInfoMap = this._dimensionInfos;
	  var size = data.count();
	  var idList = [];
	  var nameRepeatCount = {};
	  var nameDimIdx;
	  nameList = nameList || []; // Init storage
	
	  for (var i = 0; i < dimensions.length; i++) {
	    var dimInfo = dimensionInfoMap[dimensions[i]];
	    dimInfo.otherDims.itemName === 0 && (nameDimIdx = i);
	    var DataCtor = dataCtors[dimInfo.type];
	    storage[dimensions[i]] = new DataCtor(size);
	  }
	
	  var self = this;
	
	  if (!dimValueGetter) {
	    self.hasItemOption = false;
	  } // Default dim value getter
	
	
	  dimValueGetter = dimValueGetter || function (dataItem, dimName, dataIndex, dimIndex) {
	    var value = modelUtil.getDataItemValue(dataItem); // If any dataItem is like { value: 10 }
	
	    if (modelUtil.isDataItemOption(dataItem)) {
	      self.hasItemOption = true;
	    }
	
	    return modelUtil.converDataValue(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
	    : value, dimensionInfoMap[dimName]);
	  };
	
	  for (var i = 0; i < size; i++) {
	    // NOTICE: Try not to write things into dataItem
	    var dataItem = data.getItem(i); // Each data item is value
	    // [1, 2]
	    // 2
	    // Bar chart, line chart which uses category axis
	    // only gives the 'y' value. 'x' value is the indices of cateogry
	    // Use a tempValue to normalize the value to be a (x, y) value
	    // Store the data by dimensions
	
	    for (var k = 0; k < dimensions.length; k++) {
	      var dim = dimensions[k];
	      var dimStorage = storage[dim]; // PENDING NULL is empty or zero
	
	      dimStorage[i] = dimValueGetter(dataItem, dim, i, k);
	    }
	
	    indices.push(i);
	  } // Use the name in option and create id
	
	
	  for (var i = 0; i < size; i++) {
	    var dataItem = data.getItem(i);
	
	    if (!nameList[i] && dataItem) {
	      if (dataItem.name != null) {
	        nameList[i] = dataItem.name;
	      } else if (nameDimIdx != null) {
	        nameList[i] = storage[dimensions[nameDimIdx]][i];
	      }
	    }
	
	    var name = nameList[i] || ''; // Try using the id in option
	
	    var id = dataItem && dataItem.id;
	
	    if (!id && name) {
	      // Use name as id and add counter to avoid same name
	      nameRepeatCount[name] = nameRepeatCount[name] || 0;
	      id = name;
	
	      if (nameRepeatCount[name] > 0) {
	        id += '__ec__' + nameRepeatCount[name];
	      }
	
	      nameRepeatCount[name]++;
	    }
	
	    id && (idList[i] = id);
	  }
	
	  this._nameList = nameList;
	  this._idList = idList;
	};
	/**
	 * @return {number}
	 */
	
	
	listProto.count = function () {
	  return this.indices.length;
	};
	/**
	 * Get value. Return NaN if idx is out of range.
	 * @param {string} dim Dim must be concrete name.
	 * @param {number} idx
	 * @param {boolean} stack
	 * @return {number}
	 */
	
	
	listProto.get = function (dim, idx, stack) {
	  var storage = this._storage;
	  var dataIndex = this.indices[idx]; // If value not exists
	
	  if (dataIndex == null || !storage[dim]) {
	    return NaN;
	  }
	
	  var value = storage[dim][dataIndex]; // FIXME ordinal data type is not stackable
	
	  if (stack) {
	    var dimensionInfo = this._dimensionInfos[dim];
	
	    if (dimensionInfo && dimensionInfo.stackable) {
	      var stackedOn = this.stackedOn;
	
	      while (stackedOn) {
	        // Get no stacked data of stacked on
	        var stackedValue = stackedOn.get(dim, idx); // Considering positive stack, negative stack and empty data
	
	        if (value >= 0 && stackedValue > 0 || // Positive stack
	        value <= 0 && stackedValue < 0 // Negative stack
	        ) {
	            value += stackedValue;
	          }
	
	        stackedOn = stackedOn.stackedOn;
	      }
	    }
	  }
	
	  return value;
	};
	/**
	 * Get value for multi dimensions.
	 * @param {Array.<string>} [dimensions] If ignored, using all dimensions.
	 * @param {number} idx
	 * @param {boolean} stack
	 * @return {number}
	 */
	
	
	listProto.getValues = function (dimensions, idx, stack) {
	  var values = [];
	
	  if (!zrUtil.isArray(dimensions)) {
	    stack = idx;
	    idx = dimensions;
	    dimensions = this.dimensions;
	  }
	
	  for (var i = 0, len = dimensions.length; i < len; i++) {
	    values.push(this.get(dimensions[i], idx, stack));
	  }
	
	  return values;
	};
	/**
	 * If value is NaN. Inlcuding '-'
	 * @param {string} dim
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.hasValue = function (idx) {
	  var dimensions = this.dimensions;
	  var dimensionInfos = this._dimensionInfos;
	
	  for (var i = 0, len = dimensions.length; i < len; i++) {
	    if ( // Ordinal type can be string or number
	    dimensionInfos[dimensions[i]].type !== 'ordinal' && isNaN(this.get(dimensions[i], idx))) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Get extent of data in one dimension
	 * @param {string} dim
	 * @param {boolean} stack
	 * @param {Function} filter
	 */
	
	
	listProto.getDataExtent = function (dim, stack, filter) {
	  dim = this.getDimension(dim);
	  var dimData = this._storage[dim];
	  var dimInfo = this.getDimensionInfo(dim);
	  stack = dimInfo && dimInfo.stackable && stack;
	  var dimExtent = (this._extent || (this._extent = {}))[dim + !!stack];
	  var value;
	
	  if (dimExtent) {
	    return dimExtent;
	  } // var dimInfo = this._dimensionInfos[dim];
	
	
	  if (dimData) {
	    var min = Infinity;
	    var max = -Infinity; // var isOrdinal = dimInfo.type === 'ordinal';
	
	    for (var i = 0, len = this.count(); i < len; i++) {
	      value = this.get(dim, i, stack); // FIXME
	      // if (isOrdinal && typeof value === 'string') {
	      //     value = zrUtil.indexOf(dimData, value);
	      // }
	
	      if (!filter || filter(value, dim, i)) {
	        value < min && (min = value);
	        value > max && (max = value);
	      }
	    }
	
	    return this._extent[dim + !!stack] = [min, max];
	  } else {
	    return [Infinity, -Infinity];
	  }
	};
	/**
	 * Get sum of data in one dimension
	 * @param {string} dim
	 * @param {boolean} stack
	 */
	
	
	listProto.getSum = function (dim, stack) {
	  var dimData = this._storage[dim];
	  var sum = 0;
	
	  if (dimData) {
	    for (var i = 0, len = this.count(); i < len; i++) {
	      var value = this.get(dim, i, stack);
	
	      if (!isNaN(value)) {
	        sum += value;
	      }
	    }
	  }
	
	  return sum;
	};
	/**
	 * Retreive the index with given value
	 * @param {number} idx
	 * @param {number} value
	 * @return {number}
	 */
	// FIXME Precision of float value
	
	
	listProto.indexOf = function (dim, value) {
	  var storage = this._storage;
	  var dimData = storage[dim];
	  var indices = this.indices;
	
	  if (dimData) {
	    for (var i = 0, len = indices.length; i < len; i++) {
	      var rawIndex = indices[i];
	
	      if (dimData[rawIndex] === value) {
	        return i;
	      }
	    }
	  }
	
	  return -1;
	};
	/**
	 * Retreive the index with given name
	 * @param {number} idx
	 * @param {number} name
	 * @return {number}
	 */
	
	
	listProto.indexOfName = function (name) {
	  var indices = this.indices;
	  var nameList = this._nameList;
	
	  for (var i = 0, len = indices.length; i < len; i++) {
	    var rawIndex = indices[i];
	
	    if (nameList[rawIndex] === name) {
	      return i;
	    }
	  }
	
	  return -1;
	};
	/**
	 * Retreive the index with given raw data index
	 * @param {number} idx
	 * @param {number} name
	 * @return {number}
	 */
	
	
	listProto.indexOfRawIndex = function (rawIndex) {
	  // Indices are ascending
	  var indices = this.indices; // If rawIndex === dataIndex
	
	  var rawDataIndex = indices[rawIndex];
	
	  if (rawDataIndex != null && rawDataIndex === rawIndex) {
	    return rawIndex;
	  }
	
	  var left = 0;
	  var right = indices.length - 1;
	
	  while (left <= right) {
	    var mid = (left + right) / 2 | 0;
	
	    if (indices[mid] < rawIndex) {
	      left = mid + 1;
	    } else if (indices[mid] > rawIndex) {
	      right = mid - 1;
	    } else {
	      return mid;
	    }
	  }
	
	  return -1;
	};
	/**
	 * Retreive the index of nearest value
	 * @param {string} dim
	 * @param {number} value
	 * @param {boolean} stack If given value is after stacked
	 * @param {number} [maxDistance=Infinity]
	 * @return {Array.<number>} Considere multiple points has the same value.
	 */
	
	
	listProto.indicesOfNearest = function (dim, value, stack, maxDistance) {
	  var storage = this._storage;
	  var dimData = storage[dim];
	  var nearestIndices = [];
	
	  if (!dimData) {
	    return nearestIndices;
	  }
	
	  if (maxDistance == null) {
	    maxDistance = Infinity;
	  }
	
	  var minDist = Number.MAX_VALUE;
	  var minDiff = -1;
	
	  for (var i = 0, len = this.count(); i < len; i++) {
	    var diff = value - this.get(dim, i, stack);
	    var dist = Math.abs(diff);
	
	    if (diff <= maxDistance && dist <= minDist) {
	      // For the case of two data are same on xAxis, which has sequence data.
	      // Show the nearest index
	      // https://github.com/ecomfe/echarts/issues/2869
	      if (dist < minDist || diff >= 0 && minDiff < 0) {
	        minDist = dist;
	        minDiff = diff;
	        nearestIndices.length = 0;
	      }
	
	      nearestIndices.push(i);
	    }
	  }
	
	  return nearestIndices;
	};
	/**
	 * Get raw data index
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getRawIndex = function (idx) {
	  var rawIdx = this.indices[idx];
	  return rawIdx == null ? -1 : rawIdx;
	};
	/**
	 * Get raw data item
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getRawDataItem = function (idx) {
	  return this._rawData.getItem(this.getRawIndex(idx));
	};
	/**
	 * @param {number} idx
	 * @param {boolean} [notDefaultIdx=false]
	 * @return {string}
	 */
	
	
	listProto.getName = function (idx) {
	  return this._nameList[this.indices[idx]] || '';
	};
	/**
	 * @param {number} idx
	 * @param {boolean} [notDefaultIdx=false]
	 * @return {string}
	 */
	
	
	listProto.getId = function (idx) {
	  return this._idList[this.indices[idx]] || this.getRawIndex(idx) + '';
	};
	
	function normalizeDimensions(dimensions) {
	  if (!zrUtil.isArray(dimensions)) {
	    dimensions = [dimensions];
	  }
	
	  return dimensions;
	}
	/**
	 * Data iteration
	 * @param {string|Array.<string>}
	 * @param {Function} cb
	 * @param {boolean} [stack=false]
	 * @param {*} [context=this]
	 *
	 * @example
	 *  list.each('x', function (x, idx) {});
	 *  list.each(['x', 'y'], function (x, y, idx) {});
	 *  list.each(function (idx) {})
	 */
	
	
	listProto.each = function (dims, cb, stack, context) {
	  if (typeof dims === 'function') {
	    context = stack;
	    stack = cb;
	    cb = dims;
	    dims = [];
	  }
	
	  dims = zrUtil.map(normalizeDimensions(dims), this.getDimension, this);
	  var value = [];
	  var dimSize = dims.length;
	  var indices = this.indices;
	  context = context || this;
	
	  for (var i = 0; i < indices.length; i++) {
	    // Simple optimization
	    switch (dimSize) {
	      case 0:
	        cb.call(context, i);
	        break;
	
	      case 1:
	        cb.call(context, this.get(dims[0], i, stack), i);
	        break;
	
	      case 2:
	        cb.call(context, this.get(dims[0], i, stack), this.get(dims[1], i, stack), i);
	        break;
	
	      default:
	        for (var k = 0; k < dimSize; k++) {
	          value[k] = this.get(dims[k], i, stack);
	        } // Index
	
	
	        value[k] = i;
	        cb.apply(context, value);
	    }
	  }
	};
	/**
	 * Data filter
	 * @param {string|Array.<string>}
	 * @param {Function} cb
	 * @param {boolean} [stack=false]
	 * @param {*} [context=this]
	 */
	
	
	listProto.filterSelf = function (dimensions, cb, stack, context) {
	  if (typeof dimensions === 'function') {
	    context = stack;
	    stack = cb;
	    cb = dimensions;
	    dimensions = [];
	  }
	
	  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
	  var newIndices = [];
	  var value = [];
	  var dimSize = dimensions.length;
	  var indices = this.indices;
	  context = context || this;
	
	  for (var i = 0; i < indices.length; i++) {
	    var keep; // Simple optimization
	
	    if (!dimSize) {
	      keep = cb.call(context, i);
	    } else if (dimSize === 1) {
	      keep = cb.call(context, this.get(dimensions[0], i, stack), i);
	    } else {
	      for (var k = 0; k < dimSize; k++) {
	        value[k] = this.get(dimensions[k], i, stack);
	      }
	
	      value[k] = i;
	      keep = cb.apply(context, value);
	    }
	
	    if (keep) {
	      newIndices.push(indices[i]);
	    }
	  }
	
	  this.indices = newIndices; // Reset data extent
	
	  this._extent = {};
	  return this;
	};
	/**
	 * Data mapping to a plain array
	 * @param {string|Array.<string>} [dimensions]
	 * @param {Function} cb
	 * @param {boolean} [stack=false]
	 * @param {*} [context=this]
	 * @return {Array}
	 */
	
	
	listProto.mapArray = function (dimensions, cb, stack, context) {
	  if (typeof dimensions === 'function') {
	    context = stack;
	    stack = cb;
	    cb = dimensions;
	    dimensions = [];
	  }
	
	  var result = [];
	  this.each(dimensions, function () {
	    result.push(cb && cb.apply(this, arguments));
	  }, stack, context);
	  return result;
	};
	
	function cloneListForMapAndSample(original, excludeDimensions) {
	  var allDimensions = original.dimensions;
	  var list = new List(zrUtil.map(allDimensions, original.getDimensionInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked
	
	  transferProperties(list, original);
	  var storage = list._storage = {};
	  var originalStorage = original._storage; // Init storage
	
	  for (var i = 0; i < allDimensions.length; i++) {
	    var dim = allDimensions[i];
	    var dimStore = originalStorage[dim];
	
	    if (zrUtil.indexOf(excludeDimensions, dim) >= 0) {
	      storage[dim] = new dimStore.constructor(originalStorage[dim].length);
	    } else {
	      // Direct reference for other dimensions
	      storage[dim] = originalStorage[dim];
	    }
	  }
	
	  return list;
	}
	/**
	 * Data mapping to a new List with given dimensions
	 * @param {string|Array.<string>} dimensions
	 * @param {Function} cb
	 * @param {boolean} [stack=false]
	 * @param {*} [context=this]
	 * @return {Array}
	 */
	
	
	listProto.map = function (dimensions, cb, stack, context) {
	  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
	  var list = cloneListForMapAndSample(this, dimensions); // Following properties are all immutable.
	  // So we can reference to the same value
	
	  var indices = list.indices = this.indices;
	  var storage = list._storage;
	  var tmpRetValue = [];
	  this.each(dimensions, function () {
	    var idx = arguments[arguments.length - 1];
	    var retValue = cb && cb.apply(this, arguments);
	
	    if (retValue != null) {
	      // a number
	      if (typeof retValue === 'number') {
	        tmpRetValue[0] = retValue;
	        retValue = tmpRetValue;
	      }
	
	      for (var i = 0; i < retValue.length; i++) {
	        var dim = dimensions[i];
	        var dimStore = storage[dim];
	        var rawIdx = indices[idx];
	
	        if (dimStore) {
	          dimStore[rawIdx] = retValue[i];
	        }
	      }
	    }
	  }, stack, context);
	  return list;
	};
	/**
	 * Large data down sampling on given dimension
	 * @param {string} dimension
	 * @param {number} rate
	 * @param {Function} sampleValue
	 * @param {Function} sampleIndex Sample index for name and id
	 */
	
	
	listProto.downSample = function (dimension, rate, sampleValue, sampleIndex) {
	  var list = cloneListForMapAndSample(this, [dimension]);
	  var storage = this._storage;
	  var targetStorage = list._storage;
	  var originalIndices = this.indices;
	  var indices = list.indices = [];
	  var frameValues = [];
	  var frameIndices = [];
	  var frameSize = Math.floor(1 / rate);
	  var dimStore = targetStorage[dimension];
	  var len = this.count(); // Copy data from original data
	
	  for (var i = 0; i < storage[dimension].length; i++) {
	    targetStorage[dimension][i] = storage[dimension][i];
	  }
	
	  for (var i = 0; i < len; i += frameSize) {
	    // Last frame
	    if (frameSize > len - i) {
	      frameSize = len - i;
	      frameValues.length = frameSize;
	    }
	
	    for (var k = 0; k < frameSize; k++) {
	      var idx = originalIndices[i + k];
	      frameValues[k] = dimStore[idx];
	      frameIndices[k] = idx;
	    }
	
	    var value = sampleValue(frameValues);
	    var idx = frameIndices[sampleIndex(frameValues, value) || 0]; // Only write value on the filtered data
	
	    dimStore[idx] = value;
	    indices.push(idx);
	  }
	
	  return list;
	};
	/**
	 * Get model of one data item.
	 *
	 * @param {number} idx
	 */
	// FIXME Model proxy ?
	
	
	listProto.getItemModel = function (idx) {
	  var hostModel = this.hostModel;
	  idx = this.indices[idx];
	  return new Model(this._rawData.getItem(idx), hostModel, hostModel && hostModel.ecModel);
	};
	/**
	 * Create a data differ
	 * @param {module:echarts/data/List} otherList
	 * @return {module:echarts/data/DataDiffer}
	 */
	
	
	listProto.diff = function (otherList) {
	  var idList = this._idList;
	  var otherIdList = otherList && otherList._idList;
	  var val; // Use prefix to avoid index to be the same as otherIdList[idx],
	  // which will cause weird udpate animation.
	
	  var prefix = 'e\0\0';
	  return new DataDiffer(otherList ? otherList.indices : [], this.indices, function (idx) {
	    return (val = otherIdList[idx]) != null ? val : prefix + idx;
	  }, function (idx) {
	    return (val = idList[idx]) != null ? val : prefix + idx;
	  });
	};
	/**
	 * Get visual property.
	 * @param {string} key
	 */
	
	
	listProto.getVisual = function (key) {
	  var visual = this._visual;
	  return visual && visual[key];
	};
	/**
	 * Set visual property
	 * @param {string|Object} key
	 * @param {*} [value]
	 *
	 * @example
	 *  setVisual('color', color);
	 *  setVisual({
	 *      'color': color
	 *  });
	 */
	
	
	listProto.setVisual = function (key, val) {
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        this.setVisual(name, key[name]);
	      }
	    }
	
	    return;
	  }
	
	  this._visual = this._visual || {};
	  this._visual[key] = val;
	};
	/**
	 * Set layout property.
	 * @param {string|Object} key
	 * @param {*} [val]
	 */
	
	
	listProto.setLayout = function (key, val) {
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        this.setLayout(name, key[name]);
	      }
	    }
	
	    return;
	  }
	
	  this._layout[key] = val;
	};
	/**
	 * Get layout property.
	 * @param  {string} key.
	 * @return {*}
	 */
	
	
	listProto.getLayout = function (key) {
	  return this._layout[key];
	};
	/**
	 * Get layout of single data item
	 * @param {number} idx
	 */
	
	
	listProto.getItemLayout = function (idx) {
	  return this._itemLayouts[idx];
	};
	/**
	 * Set layout of single data item
	 * @param {number} idx
	 * @param {Object} layout
	 * @param {boolean=} [merge=false]
	 */
	
	
	listProto.setItemLayout = function (idx, layout, merge) {
	  this._itemLayouts[idx] = merge ? zrUtil.extend(this._itemLayouts[idx] || {}, layout) : layout;
	};
	/**
	 * Clear all layout of single data item
	 */
	
	
	listProto.clearItemLayouts = function () {
	  this._itemLayouts.length = 0;
	};
	/**
	 * Get visual property of single data item
	 * @param {number} idx
	 * @param {string} key
	 * @param {boolean} [ignoreParent=false]
	 */
	
	
	listProto.getItemVisual = function (idx, key, ignoreParent) {
	  var itemVisual = this._itemVisuals[idx];
	  var val = itemVisual && itemVisual[key];
	
	  if (val == null && !ignoreParent) {
	    // Use global visual property
	    return this.getVisual(key);
	  }
	
	  return val;
	};
	/**
	 * Set visual property of single data item
	 *
	 * @param {number} idx
	 * @param {string|Object} key
	 * @param {*} [value]
	 *
	 * @example
	 *  setItemVisual(0, 'color', color);
	 *  setItemVisual(0, {
	 *      'color': color
	 *  });
	 */
	
	
	listProto.setItemVisual = function (idx, key, value) {
	  var itemVisual = this._itemVisuals[idx] || {};
	  this._itemVisuals[idx] = itemVisual;
	
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        itemVisual[name] = key[name];
	      }
	    }
	
	    return;
	  }
	
	  itemVisual[key] = value;
	};
	/**
	 * Clear itemVisuals and list visual.
	 */
	
	
	listProto.clearAllVisual = function () {
	  this._visual = {};
	  this._itemVisuals = [];
	};
	
	var setItemDataAndSeriesIndex = function (child) {
	  child.seriesIndex = this.seriesIndex;
	  child.dataIndex = this.dataIndex;
	  child.dataType = this.dataType;
	};
	/**
	 * Set graphic element relative to data. It can be set as null
	 * @param {number} idx
	 * @param {module:zrender/Element} [el]
	 */
	
	
	listProto.setItemGraphicEl = function (idx, el) {
	  var hostModel = this.hostModel;
	
	  if (el) {
	    // Add data index and series index for indexing the data by element
	    // Useful in tooltip
	    el.dataIndex = idx;
	    el.dataType = this.dataType;
	    el.seriesIndex = hostModel && hostModel.seriesIndex;
	
	    if (el.type === 'group') {
	      el.traverse(setItemDataAndSeriesIndex, el);
	    }
	  }
	
	  this._graphicEls[idx] = el;
	};
	/**
	 * @param {number} idx
	 * @return {module:zrender/Element}
	 */
	
	
	listProto.getItemGraphicEl = function (idx) {
	  return this._graphicEls[idx];
	};
	/**
	 * @param {Function} cb
	 * @param {*} context
	 */
	
	
	listProto.eachItemGraphicEl = function (cb, context) {
	  zrUtil.each(this._graphicEls, function (el, idx) {
	    if (el) {
	      cb && cb.call(context, el, idx);
	    }
	  });
	};
	/**
	 * Shallow clone a new list except visual and layout properties, and graph elements.
	 * New list only change the indices.
	 */
	
	
	listProto.cloneShallow = function () {
	  var dimensionInfoList = zrUtil.map(this.dimensions, this.getDimensionInfo, this);
	  var list = new List(dimensionInfoList, this.hostModel); // FIXME
	
	  list._storage = this._storage;
	  transferProperties(list, this); // Clone will not change the data extent and indices
	
	  list.indices = this.indices.slice();
	
	  if (this._extent) {
	    list._extent = zrUtil.extend({}, this._extent);
	  }
	
	  return list;
	};
	/**
	 * Wrap some method to add more feature
	 * @param {string} methodName
	 * @param {Function} injectFunction
	 */
	
	
	listProto.wrapMethod = function (methodName, injectFunction) {
	  var originalMethod = this[methodName];
	
	  if (typeof originalMethod !== 'function') {
	    return;
	  }
	
	  this.__wrappedMethods = this.__wrappedMethods || [];
	
	  this.__wrappedMethods.push(methodName);
	
	  this[methodName] = function () {
	    var res = originalMethod.apply(this, arguments);
	    return injectFunction.apply(this, [res].concat(zrUtil.slice(arguments)));
	  };
	}; // Methods that create a new list based on this list should be listed here.
	// Notice that those method should `RETURN` the new list.
	
	
	listProto.TRANSFERABLE_METHODS = ['cloneShallow', 'downSample', 'map']; // Methods that change indices of this list should be listed here.
	
	listProto.CHANGABLE_METHODS = ['filterSelf'];
	var _default = List;
	module.exports = _default;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Model = __webpack_require__(14);
	
	var componentUtil = __webpack_require__(130);
	
	var clazzUtil = __webpack_require__(28);
	
	var layout = __webpack_require__(7);
	
	var boxLayoutMixin = __webpack_require__(586);
	
	/**
	 * Component model
	 *
	 * @module echarts/model/Component
	 */
	var arrayPush = Array.prototype.push;
	/**
	 * @alias module:echarts/model/Component
	 * @constructor
	 * @param {Object} option
	 * @param {module:echarts/model/Model} parentModel
	 * @param {module:echarts/model/Model} ecModel
	 */
	
	var ComponentModel = Model.extend({
	  type: 'component',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  id: '',
	
	  /**
	   * @readOnly
	   */
	  name: '',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  mainType: '',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  subType: '',
	
	  /**
	   * @readOnly
	   * @type {number}
	   */
	  componentIndex: 0,
	
	  /**
	   * @type {Object}
	   * @protected
	   */
	  defaultOption: null,
	
	  /**
	   * @type {module:echarts/model/Global}
	   * @readOnly
	   */
	  ecModel: null,
	
	  /**
	   * key: componentType
	   * value:  Component model list, can not be null.
	   * @type {Object.<string, Array.<module:echarts/model/Model>>}
	   * @readOnly
	   */
	  dependentModels: [],
	
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  uid: null,
	
	  /**
	   * Support merge layout params.
	   * Only support 'box' now (left/right/top/bottom/width/height).
	   * @type {string|Object} Object can be {ignoreSize: true}
	   * @readOnly
	   */
	  layoutMode: null,
	  $constructor: function (option, parentModel, ecModel, extraOpt) {
	    Model.call(this, option, parentModel, ecModel, extraOpt);
	    this.uid = componentUtil.getUID('componentModel');
	  },
	  init: function (option, parentModel, ecModel, extraOpt) {
	    this.mergeDefaultAndTheme(option, ecModel);
	  },
	  mergeDefaultAndTheme: function (option, ecModel) {
	    var layoutMode = this.layoutMode;
	    var inputPositionParams = layoutMode ? layout.getLayoutParams(option) : {};
	    var themeModel = ecModel.getTheme();
	    zrUtil.merge(option, themeModel.get(this.mainType));
	    zrUtil.merge(option, this.getDefaultOption());
	
	    if (layoutMode) {
	      layout.mergeLayoutParam(option, inputPositionParams, layoutMode);
	    }
	  },
	  mergeOption: function (option, extraOpt) {
	    zrUtil.merge(this.option, option, true);
	    var layoutMode = this.layoutMode;
	
	    if (layoutMode) {
	      layout.mergeLayoutParam(this.option, option, layoutMode);
	    }
	  },
	  // Hooker after init or mergeOption
	  optionUpdated: function (newCptOption, isInit) {},
	  getDefaultOption: function () {
	    if (!clazzUtil.hasOwn(this, '__defaultOption')) {
	      var optList = [];
	      var Class = this.constructor;
	
	      while (Class) {
	        var opt = Class.prototype.defaultOption;
	        opt && optList.push(opt);
	        Class = Class.superClass;
	      }
	
	      var defaultOption = {};
	
	      for (var i = optList.length - 1; i >= 0; i--) {
	        defaultOption = zrUtil.merge(defaultOption, optList[i], true);
	      }
	
	      clazzUtil.set(this, '__defaultOption', defaultOption);
	    }
	
	    return clazzUtil.get(this, '__defaultOption');
	  },
	  getReferringComponents: function (mainType) {
	    return this.ecModel.queryComponents({
	      mainType: mainType,
	      index: this.get(mainType + 'Index', true),
	      id: this.get(mainType + 'Id', true)
	    });
	  }
	}); // Reset ComponentModel.extend, add preConstruct.
	// clazzUtil.enableClassExtend(
	//     ComponentModel,
	//     function (option, parentModel, ecModel, extraOpt) {
	//         // Set dependentModels, componentIndex, name, id, mainType, subType.
	//         zrUtil.extend(this, extraOpt);
	//         this.uid = componentUtil.getUID('componentModel');
	//         // this.setReadOnly([
	//         //     'type', 'id', 'uid', 'name', 'mainType', 'subType',
	//         //     'dependentModels', 'componentIndex'
	//         // ]);
	//     }
	// );
	// Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	clazzUtil.enableClassManagement(ComponentModel, {
	  registerWhenExtend: true
	});
	componentUtil.enableSubTypeDefaulter(ComponentModel); // Add capability of ComponentModel.topologicalTravel.
	
	componentUtil.enableTopologicalTravel(ComponentModel, getDependencies);
	
	function getDependencies(componentType) {
	  var deps = [];
	  zrUtil.each(ComponentModel.getClassesByMainType(componentType), function (Clazz) {
	    arrayPush.apply(deps, Clazz.prototype.dependencies || []);
	  }); // Ensure main type
	
	  return zrUtil.map(deps, function (type) {
	    return clazzUtil.parseClassType(type).main;
	  });
	}
	
	zrUtil.mixin(ComponentModel, boxLayoutMixin);
	var _default = ComponentModel;
	module.exports = _default;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if (media) {
			styleElement.setAttribute("media", media);
		}
	
		if (sourceMap) {
			// https://developer.chrome.com/devtools/docs/javascript-debugging
			// this makes source maps inside style tags work properly in Chrome
			css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	/**
	 * echarts设备环境识别
	 *
	 * @desc echarts基于Canvas，纯Javascript图表库，提供直观，生动，可交互，可个性化定制的数据统计图表。
	 * @author firede[firede@firede.us]
	 * @desc thanks zepto.
	 */
	var env = {};
	
	if (typeof navigator === 'undefined') {
	  // In node
	  env = {
	    browser: {},
	    os: {},
	    node: true,
	    // Assume canvas is supported
	    canvasSupported: true,
	    svgSupported: true
	  };
	} else {
	  env = detect(navigator.userAgent);
	}
	
	var _default = env; // Zepto.js
	// (c) 2010-2013 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	
	function detect(ua) {
	  var os = {};
	  var browser = {}; // var webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/);
	  // var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
	  // var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  // var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	  // var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
	  // var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
	  // var touchpad = webos && ua.match(/TouchPad/);
	  // var kindle = ua.match(/Kindle\/([\d.]+)/);
	  // var silk = ua.match(/Silk\/([\d._]+)/);
	  // var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
	  // var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
	  // var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
	  // var playbook = ua.match(/PlayBook/);
	  // var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
	
	  var firefox = ua.match(/Firefox\/([\d.]+)/); // var safari = webkit && ua.match(/Mobile\//) && !chrome;
	  // var webview = ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/) && !chrome;
	
	  var ie = ua.match(/MSIE\s([\d.]+)/) // IE 11 Trident/7.0; rv:11.0
	  || ua.match(/Trident\/.+?rv:(([\d.]+))/);
	  var edge = ua.match(/Edge\/([\d.]+)/); // IE 12 and 12+
	
	  var weChat = /micromessenger/i.test(ua); // Todo: clean this up with a better OS/browser seperation:
	  // - discern (more) between multiple browsers on android
	  // - decide if kindle fire in silk mode is android or not
	  // - Firefox on Android doesn't specify the Android version
	  // - possibly devide in os, device and browser hashes
	  // if (browser.webkit = !!webkit) browser.version = webkit[1];
	  // if (android) os.android = true, os.version = android[2];
	  // if (iphone && !ipod) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.');
	  // if (ipad) os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.');
	  // if (ipod) os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
	  // if (webos) os.webos = true, os.version = webos[2];
	  // if (touchpad) os.touchpad = true;
	  // if (blackberry) os.blackberry = true, os.version = blackberry[2];
	  // if (bb10) os.bb10 = true, os.version = bb10[2];
	  // if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2];
	  // if (playbook) browser.playbook = true;
	  // if (kindle) os.kindle = true, os.version = kindle[1];
	  // if (silk) browser.silk = true, browser.version = silk[1];
	  // if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true;
	  // if (chrome) browser.chrome = true, browser.version = chrome[1];
	
	  if (firefox) {
	    browser.firefox = true;
	    browser.version = firefox[1];
	  } // if (safari && (ua.match(/Safari/) || !!os.ios)) browser.safari = true;
	  // if (webview) browser.webview = true;
	
	
	  if (ie) {
	    browser.ie = true;
	    browser.version = ie[1];
	  }
	
	  if (edge) {
	    browser.edge = true;
	    browser.version = edge[1];
	  } // It is difficult to detect WeChat in Win Phone precisely, because ua can
	  // not be set on win phone. So we do not consider Win Phone.
	
	
	  if (weChat) {
	    browser.weChat = true;
	  } // os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) ||
	  //     (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)));
	  // os.phone  = !!(!os.tablet && !os.ipod && (android || iphone || webos ||
	  //     (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
	  //     (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))));
	
	
	  return {
	    browser: browser,
	    os: os,
	    node: false,
	    // 原生canvas支持，改极端点了
	    // canvasSupported : !(browser.ie && parseFloat(browser.version) < 9)
	    canvasSupported: !!document.createElement('canvas').getContext,
	    svgSupported: typeof SVGRect !== 'undefined',
	    // @see <http://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript>
	    // works on most browsers
	    // IE10/11 does not support touch event, and MS Edge supports them but not by
	    // default, so we dont check navigator.maxTouchPoints for them here.
	    touchEventsSupported: 'ontouchstart' in window && !browser.ie && !browser.edge,
	    // <http://caniuse.com/#search=pointer%20event>.
	    pointerEventsSupported: 'onpointerdown' in window // Firefox supports pointer but not by default, only MS browsers are reliable on pointer
	    // events currently. So we dont use that on other browsers unless tested sufficiently.
	    // Although IE 10 supports pointer event, it use old style and is different from the
	    // standard. So we exclude that. (IE 10 is hardly used on touch device)
	    && (browser.edge || browser.ie && browser.version >= 11)
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(98);
	
	var zrUtil = __webpack_require__(1);
	
	var PathProxy = __webpack_require__(60);
	
	var pathContain = __webpack_require__(741);
	
	var Pattern = __webpack_require__(224);
	
	var getCanvasPattern = Pattern.prototype.getCanvasPattern;
	var abs = Math.abs;
	var pathProxyForDraw = new PathProxy(true);
	/**
	 * @alias module:zrender/graphic/Path
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	
	function Path(opts) {
	  Displayable.call(this, opts);
	  /**
	   * @type {module:zrender/core/PathProxy}
	   * @readOnly
	   */
	
	  this.path = null;
	}
	
	Path.prototype = {
	  constructor: Path,
	  type: 'path',
	  __dirtyPath: true,
	  strokeContainThreshold: 5,
	  brush: function (ctx, prevEl) {
	    var style = this.style;
	    var path = this.path || pathProxyForDraw;
	    var hasStroke = style.hasStroke();
	    var hasFill = style.hasFill();
	    var fill = style.fill;
	    var stroke = style.stroke;
	    var hasFillGradient = hasFill && !!fill.colorStops;
	    var hasStrokeGradient = hasStroke && !!stroke.colorStops;
	    var hasFillPattern = hasFill && !!fill.image;
	    var hasStrokePattern = hasStroke && !!stroke.image;
	    style.bind(ctx, this, prevEl);
	    this.setTransform(ctx);
	
	    if (this.__dirty) {
	      var rect; // Update gradient because bounding rect may changed
	
	      if (hasFillGradient) {
	        rect = rect || this.getBoundingRect();
	        this._fillGradient = style.getGradient(ctx, fill, rect);
	      }
	
	      if (hasStrokeGradient) {
	        rect = rect || this.getBoundingRect();
	        this._strokeGradient = style.getGradient(ctx, stroke, rect);
	      }
	    } // Use the gradient or pattern
	
	
	    if (hasFillGradient) {
	      // PENDING If may have affect the state
	      ctx.fillStyle = this._fillGradient;
	    } else if (hasFillPattern) {
	      ctx.fillStyle = getCanvasPattern.call(fill, ctx);
	    }
	
	    if (hasStrokeGradient) {
	      ctx.strokeStyle = this._strokeGradient;
	    } else if (hasStrokePattern) {
	      ctx.strokeStyle = getCanvasPattern.call(stroke, ctx);
	    }
	
	    var lineDash = style.lineDash;
	    var lineDashOffset = style.lineDashOffset;
	    var ctxLineDash = !!ctx.setLineDash; // Update path sx, sy
	
	    var scale = this.getGlobalScale();
	    path.setScale(scale[0], scale[1]); // Proxy context
	    // Rebuild path in following 2 cases
	    // 1. Path is dirty
	    // 2. Path needs javascript implemented lineDash stroking.
	    //    In this case, lineDash information will not be saved in PathProxy
	
	    if (this.__dirtyPath || lineDash && !ctxLineDash && hasStroke) {
	      path.beginPath(ctx); // Setting line dash before build path
	
	      if (lineDash && !ctxLineDash) {
	        path.setLineDash(lineDash);
	        path.setLineDashOffset(lineDashOffset);
	      }
	
	      this.buildPath(path, this.shape, false); // Clear path dirty flag
	
	      if (this.path) {
	        this.__dirtyPath = false;
	      }
	    } else {
	      // Replay path building
	      ctx.beginPath();
	      this.path.rebuildPath(ctx);
	    }
	
	    hasFill && path.fill(ctx);
	
	    if (lineDash && ctxLineDash) {
	      ctx.setLineDash(lineDash);
	      ctx.lineDashOffset = lineDashOffset;
	    }
	
	    hasStroke && path.stroke(ctx);
	
	    if (lineDash && ctxLineDash) {
	      // PENDING
	      // Remove lineDash
	      ctx.setLineDash([]);
	    }
	
	    this.restoreTransform(ctx); // Draw rect text
	
	    if (style.text != null) {
	      this.drawRectText(ctx, this.getBoundingRect());
	    }
	  },
	  // When bundling path, some shape may decide if use moveTo to begin a new subpath or closePath
	  // Like in circle
	  buildPath: function (ctx, shapeCfg, inBundle) {},
	  createPathProxy: function () {
	    this.path = new PathProxy();
	  },
	  getBoundingRect: function () {
	    var rect = this._rect;
	    var style = this.style;
	    var needsUpdateRect = !rect;
	
	    if (needsUpdateRect) {
	      var path = this.path;
	
	      if (!path) {
	        // Create path on demand.
	        path = this.path = new PathProxy();
	      }
	
	      if (this.__dirtyPath) {
	        path.beginPath();
	        this.buildPath(path, this.shape, false);
	      }
	
	      rect = path.getBoundingRect();
	    }
	
	    this._rect = rect;
	
	    if (style.hasStroke()) {
	      // Needs update rect with stroke lineWidth when
	      // 1. Element changes scale or lineWidth
	      // 2. Shape is changed
	      var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());
	
	      if (this.__dirty || needsUpdateRect) {
	        rectWithStroke.copy(rect); // FIXME Must after updateTransform
	
	        var w = style.lineWidth; // PENDING, Min line width is needed when line is horizontal or vertical
	
	        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Only add extra hover lineWidth when there are no fill
	
	        if (!style.hasFill()) {
	          w = Math.max(w, this.strokeContainThreshold || 4);
	        } // Consider line width
	        // Line scale can't be 0;
	
	
	        if (lineScale > 1e-10) {
	          rectWithStroke.width += w / lineScale;
	          rectWithStroke.height += w / lineScale;
	          rectWithStroke.x -= w / lineScale / 2;
	          rectWithStroke.y -= w / lineScale / 2;
	        }
	      } // Return rect with stroke
	
	
	      return rectWithStroke;
	    }
	
	    return rect;
	  },
	  contain: function (x, y) {
	    var localPos = this.transformCoordToLocal(x, y);
	    var rect = this.getBoundingRect();
	    var style = this.style;
	    x = localPos[0];
	    y = localPos[1];
	
	    if (rect.contain(x, y)) {
	      var pathData = this.path.data;
	
	      if (style.hasStroke()) {
	        var lineWidth = style.lineWidth;
	        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Line scale can't be 0;
	
	        if (lineScale > 1e-10) {
	          // Only add extra hover lineWidth when there are no fill
	          if (!style.hasFill()) {
	            lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
	          }
	
	          if (pathContain.containStroke(pathData, lineWidth / lineScale, x, y)) {
	            return true;
	          }
	        }
	      }
	
	      if (style.hasFill()) {
	        return pathContain.contain(pathData, x, y);
	      }
	    }
	
	    return false;
	  },
	
	  /**
	   * @param  {boolean} dirtyPath
	   */
	  dirty: function (dirtyPath) {
	    if (dirtyPath == null) {
	      dirtyPath = true;
	    } // Only mark dirty, not mark clean
	
	
	    if (dirtyPath) {
	      this.__dirtyPath = dirtyPath;
	      this._rect = null;
	    }
	
	    this.__dirty = true;
	    this.__zr && this.__zr.refresh(); // Used as a clipping path
	
	    if (this.__clipTarget) {
	      this.__clipTarget.dirty();
	    }
	  },
	
	  /**
	   * Alias for animate('shape')
	   * @param {boolean} loop
	   */
	  animateShape: function (loop) {
	    return this.animate('shape', loop);
	  },
	  // Overwrite attrKV
	  attrKV: function (key, value) {
	    // FIXME
	    if (key === 'shape') {
	      this.setShape(value);
	      this.__dirtyPath = true;
	      this._rect = null;
	    } else {
	      Displayable.prototype.attrKV.call(this, key, value);
	    }
	  },
	
	  /**
	   * @param {Object|string} key
	   * @param {*} value
	   */
	  setShape: function (key, value) {
	    var shape = this.shape; // Path from string may not have shape
	
	    if (shape) {
	      if (zrUtil.isObject(key)) {
	        for (var name in key) {
	          if (key.hasOwnProperty(name)) {
	            shape[name] = key[name];
	          }
	        }
	      } else {
	        shape[key] = value;
	      }
	
	      this.dirty(true);
	    }
	
	    return this;
	  },
	  getLineScale: function () {
	    var m = this.transform; // Get the line scale.
	    // Determinant of `m` means how much the area is enlarged by the
	    // transformation. So its square root can be used as a scale factor
	    // for width.
	
	    return m && abs(m[0] - 1) > 1e-10 && abs(m[3] - 1) > 1e-10 ? Math.sqrt(abs(m[0] * m[3] - m[2] * m[1])) : 1;
	  }
	};
	/**
	 * 扩展一个 Path element, 比如星形，圆等。
	 * Extend a path element
	 * @param {Object} props
	 * @param {string} props.type Path type
	 * @param {Function} props.init Initialize
	 * @param {Function} props.buildPath Overwrite buildPath method
	 * @param {Object} [props.style] Extended default style config
	 * @param {Object} [props.shape] Extended default shape config
	 */
	
	Path.extend = function (defaults) {
	  var Sub = function (opts) {
	    Path.call(this, opts);
	
	    if (defaults.style) {
	      // Extend default style
	      this.style.extendFrom(defaults.style, false);
	    } // Extend default shape
	
	
	    var defaultShape = defaults.shape;
	
	    if (defaultShape) {
	      this.shape = this.shape || {};
	      var thisShape = this.shape;
	
	      for (var name in defaultShape) {
	        if (!thisShape.hasOwnProperty(name) && defaultShape.hasOwnProperty(name)) {
	          thisShape[name] = defaultShape[name];
	        }
	      }
	    }
	
	    defaults.init && defaults.init.call(this, opts);
	  };
	
	  zrUtil.inherits(Sub, Path); // FIXME 不能 extend position, rotation 等引用对象
	
	  for (var name in defaults) {
	    // Extending prototype values and methods
	    if (name !== 'style' && name !== 'shape') {
	      Sub.prototype[name] = defaults[name];
	    }
	  }
	
	  return Sub;
	};
	
	zrUtil.inherits(Path, Displayable);
	var _default = Path;
	module.exports = _default;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(1);
	
	var env = __webpack_require__(18);
	
	var _format = __webpack_require__(9);
	
	var formatTime = _format.formatTime;
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	var getTooltipMarker = _format.getTooltipMarker;
	
	var _clazz = __webpack_require__(28);
	
	var set = _clazz.set;
	var get = _clazz.get;
	
	var modelUtil = __webpack_require__(6);
	
	var ComponentModel = __webpack_require__(16);
	
	var colorPaletteMixin = __webpack_require__(202);
	
	var _layout = __webpack_require__(7);
	
	var getLayoutParams = _layout.getLayoutParams;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	var SeriesModel = ComponentModel.extend({
	  type: 'series.__base__',
	
	  /**
	   * @readOnly
	   */
	  seriesIndex: 0,
	  // coodinateSystem will be injected in the echarts/CoordinateSystem
	  coordinateSystem: null,
	
	  /**
	   * @type {Object}
	   * @protected
	   */
	  defaultOption: null,
	
	  /**
	   * Data provided for legend
	   * @type {Function}
	   */
	  // PENDING
	  legendDataProvider: null,
	
	  /**
	   * Access path of color for visual
	   */
	  visualColorAccessPath: 'itemStyle.normal.color',
	
	  /**
	   * Support merge layout params.
	   * Only support 'box' now (left/right/top/bottom/width/height).
	   * @type {string|Object} Object can be {ignoreSize: true}
	   * @readOnly
	   */
	  layoutMode: null,
	  init: function (option, parentModel, ecModel, extraOpt) {
	    /**
	     * @type {number}
	     * @readOnly
	     */
	    this.seriesIndex = this.componentIndex;
	    this.mergeDefaultAndTheme(option, ecModel);
	    var data = this.getInitialData(option, ecModel);
	
	    /**
	     * @type {module:echarts/data/List|module:echarts/data/Tree|module:echarts/data/Graph}
	     * @private
	     */
	    set(this, 'dataBeforeProcessed', data); // If we reverse the order (make data firstly, and then make
	    // dataBeforeProcessed by cloneShallow), cloneShallow will
	    // cause data.graph.data !== data when using
	    // module:echarts/data/Graph or module:echarts/data/Tree.
	    // See module:echarts/data/helper/linkList
	
	    this.restoreData();
	  },
	
	  /**
	   * Util for merge default and theme to option
	   * @param  {Object} option
	   * @param  {module:echarts/model/Global} ecModel
	   */
	  mergeDefaultAndTheme: function (option, ecModel) {
	    var layoutMode = this.layoutMode;
	    var inputPositionParams = layoutMode ? getLayoutParams(option) : {}; // Backward compat: using subType on theme.
	    // But if name duplicate between series subType
	    // (for example: parallel) add component mainType,
	    // add suffix 'Series'.
	
	    var themeSubType = this.subType;
	
	    if (ComponentModel.hasClass(themeSubType)) {
	      themeSubType += 'Series';
	    }
	
	    zrUtil.merge(option, ecModel.getTheme().get(this.subType));
	    zrUtil.merge(option, this.getDefaultOption()); // Default label emphasis `show`
	
	    modelUtil.defaultEmphasis(option.label, ['show']);
	    this.fillDataTextStyle(option.data);
	
	    if (layoutMode) {
	      mergeLayoutParam(option, inputPositionParams, layoutMode);
	    }
	  },
	  mergeOption: function (newSeriesOption, ecModel) {
	    newSeriesOption = zrUtil.merge(this.option, newSeriesOption, true);
	    this.fillDataTextStyle(newSeriesOption.data);
	    var layoutMode = this.layoutMode;
	
	    if (layoutMode) {
	      mergeLayoutParam(this.option, newSeriesOption, layoutMode);
	    }
	
	    var data = this.getInitialData(newSeriesOption, ecModel); // TODO Merge data?
	
	    if (data) {
	      set(this, 'data', data);
	      set(this, 'dataBeforeProcessed', data.cloneShallow());
	    }
	  },
	  fillDataTextStyle: function (data) {
	    // Default data label emphasis `show`
	    // FIXME Tree structure data ?
	    // FIXME Performance ?
	    if (data) {
	      var props = ['show'];
	
	      for (var i = 0; i < data.length; i++) {
	        if (data[i] && data[i].label) {
	          modelUtil.defaultEmphasis(data[i].label, props);
	        }
	      }
	    }
	  },
	
	  /**
	   * Init a data structure from data related option in series
	   * Must be overwritten
	   */
	  getInitialData: function () {},
	
	  /**
	   * @param {string} [dataType]
	   * @return {module:echarts/data/List}
	   */
	  getData: function (dataType) {
	    var data = get(this, 'data');
	    return dataType == null ? data : data.getLinkedData(dataType);
	  },
	
	  /**
	   * @param {module:echarts/data/List} data
	   */
	  setData: function (data) {
	    set(this, 'data', data);
	  },
	
	  /**
	   * Get data before processed
	   * @return {module:echarts/data/List}
	   */
	  getRawData: function () {
	    return get(this, 'dataBeforeProcessed');
	  },
	
	  /**
	   * Coord dimension to data dimension.
	   *
	   * By default the result is the same as dimensions of series data.
	   * But in some series data dimensions are different from coord dimensions (i.e.
	   * candlestick and boxplot). Override this method to handle those cases.
	   *
	   * Coord dimension to data dimension can be one-to-many
	   *
	   * @param {string} coordDim
	   * @return {Array.<string>} dimensions on the axis.
	   */
	  coordDimToDataDim: function (coordDim) {
	    return modelUtil.coordDimToDataDim(this.getData(), coordDim);
	  },
	
	  /**
	   * Convert data dimension to coord dimension.
	   *
	   * @param {string|number} dataDim
	   * @return {string}
	   */
	  dataDimToCoordDim: function (dataDim) {
	    return modelUtil.dataDimToCoordDim(this.getData(), dataDim);
	  },
	
	  /**
	   * Get base axis if has coordinate system and has axis.
	   * By default use coordSys.getBaseAxis();
	   * Can be overrided for some chart.
	   * @return {type} description
	   */
	  getBaseAxis: function () {
	    var coordSys = this.coordinateSystem;
	    return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
	  },
	  // FIXME
	
	  /**
	   * Default tooltip formatter
	   *
	   * @param {number} dataIndex
	   * @param {boolean} [multipleSeries=false]
	   * @param {number} [dataType]
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType) {
	    function formatArrayValue(value) {
	      var vertially = zrUtil.reduce(value, function (vertially, val, idx) {
	        var dimItem = data.getDimensionInfo(idx);
	        return vertially |= dimItem && dimItem.tooltip !== false && dimItem.tooltipName != null;
	      }, 0);
	      var result = [];
	      var tooltipDims = modelUtil.otherDimToDataDim(data, 'tooltip');
	      tooltipDims.length ? zrUtil.each(tooltipDims, function (dimIdx) {
	        setEachItem(data.get(dimIdx, dataIndex), dimIdx);
	      }) // By default, all dims is used on tooltip.
	      : zrUtil.each(value, setEachItem);
	
	      function setEachItem(val, dimIdx) {
	        var dimInfo = data.getDimensionInfo(dimIdx); // If `dimInfo.tooltip` is not set, show tooltip.
	
	        if (!dimInfo || dimInfo.otherDims.tooltip === false) {
	          return;
	        }
	
	        var dimType = dimInfo.type;
	        var valStr = (vertially ? '- ' + (dimInfo.tooltipName || dimInfo.name) + ': ' : '') + (dimType === 'ordinal' ? val + '' : dimType === 'time' ? multipleSeries ? '' : formatTime('yyyy/MM/dd hh:mm:ss', val) : addCommas(val));
	        valStr && result.push(encodeHTML(valStr));
	      }
	
	      return (vertially ? '<br/>' : '') + result.join(vertially ? '<br/>' : ', ');
	    }
	
	    var data = get(this, 'data');
	    var value = this.getRawValue(dataIndex);
	    var formattedValue = zrUtil.isArray(value) ? formatArrayValue(value) : encodeHTML(addCommas(value));
	    var name = data.getName(dataIndex);
	    var color = data.getItemVisual(dataIndex, 'color');
	
	    if (zrUtil.isObject(color) && color.colorStops) {
	      color = (color.colorStops[0] || {}).color;
	    }
	
	    color = color || 'transparent';
	    var colorEl = getTooltipMarker(color);
	    var seriesName = this.name; // FIXME
	
	    if (seriesName === '\0-') {
	      // Not show '-'
	      seriesName = '';
	    }
	
	    seriesName = seriesName ? encodeHTML(seriesName) + (!multipleSeries ? '<br/>' : ': ') : '';
	    return !multipleSeries ? seriesName + colorEl + (name ? encodeHTML(name) + ': ' + formattedValue : formattedValue) : colorEl + seriesName + formattedValue;
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isAnimationEnabled: function () {
	    if (env.node) {
	      return false;
	    }
	
	    var animationEnabled = this.getShallow('animation');
	
	    if (animationEnabled) {
	      if (this.getData().count() > this.getShallow('animationThreshold')) {
	        animationEnabled = false;
	      }
	    }
	
	    return animationEnabled;
	  },
	  restoreData: function () {
	    set(this, 'data', get(this, 'dataBeforeProcessed').cloneShallow());
	  },
	  getColorFromPalette: function (name, scope) {
	    var ecModel = this.ecModel; // PENDING
	
	    var color = colorPaletteMixin.getColorFromPalette.call(this, name, scope);
	
	    if (!color) {
	      color = ecModel.getColorFromPalette(name, scope);
	    }
	
	    return color;
	  },
	
	  /**
	   * Get data indices for show tooltip content. See tooltip.
	   * @abstract
	   * @param {Array.<string>|string} dim
	   * @param {Array.<number>} value
	   * @param {module:echarts/coord/single/SingleAxis} baseAxis
	   * @return {Object} {dataIndices, nestestValue}.
	   */
	  getAxisTooltipData: null,
	
	  /**
	   * See tooltip.
	   * @abstract
	   * @param {number} dataIndex
	   * @return {Array.<number>} Point of tooltip. null/undefined can be returned.
	   */
	  getTooltipPosition: null
	});
	zrUtil.mixin(SeriesModel, modelUtil.dataFormatMixin);
	zrUtil.mixin(SeriesModel, colorPaletteMixin);
	var _default = SeriesModel;
	module.exports = _default;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(1);
	
	var textContain = __webpack_require__(27);
	
	var OrdinalScale = __webpack_require__(594);
	
	var IntervalScale = __webpack_require__(91);
	
	var Scale = __webpack_require__(92);
	
	var numberUtil = __webpack_require__(4);
	
	__webpack_require__(595);
	
	__webpack_require__(593);
	
	/**
	 * Get axis scale extent before niced.
	 * Item of returned array can only be number (including Infinity and NaN).
	 */
	function getScaleExtent(scale, model) {
	  var scaleType = scale.type;
	  var min = model.getMin();
	  var max = model.getMax();
	  var fixMin = min != null;
	  var fixMax = max != null;
	  var originalExtent = scale.getExtent();
	  var axisDataLen;
	  var boundaryGap;
	  var span;
	
	  if (scaleType === 'ordinal') {
	    axisDataLen = (model.get('data') || []).length;
	  } else {
	    boundaryGap = model.get('boundaryGap');
	
	    if (!zrUtil.isArray(boundaryGap)) {
	      boundaryGap = [boundaryGap || 0, boundaryGap || 0];
	    }
	
	    if (typeof boundaryGap[0] === 'boolean') {
	      boundaryGap = [0, 0];
	    }
	
	    boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], 1);
	    boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], 1);
	    span = originalExtent[1] - originalExtent[0] || Math.abs(originalExtent[0]);
	  } // Notice: When min/max is not set (that is, when there are null/undefined,
	  // which is the most common case), these cases should be ensured:
	  // (1) For 'ordinal', show all axis.data.
	  // (2) For others:
	  //      + `boundaryGap` is applied (if min/max set, boundaryGap is
	  //      disabled).
	  //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
	  //      be the result that originalExtent enlarged by boundaryGap.
	  // (3) If no data, it should be ensured that `scale.setBlank` is set.
	  // FIXME
	  // (1) When min/max is 'dataMin' or 'dataMax', should boundaryGap be able to used?
	  // (2) When `needCrossZero` and all data is positive/negative, should it be ensured
	  // that the results processed by boundaryGap are positive/negative?
	
	
	  if (min == null) {
	    min = scaleType === 'ordinal' ? axisDataLen ? 0 : NaN : originalExtent[0] - boundaryGap[0] * span;
	  }
	
	  if (max == null) {
	    max = scaleType === 'ordinal' ? axisDataLen ? axisDataLen - 1 : NaN : originalExtent[1] + boundaryGap[1] * span;
	  }
	
	  if (min === 'dataMin') {
	    min = originalExtent[0];
	  } else if (typeof min === 'function') {
	    min = min({
	      min: originalExtent[0],
	      max: originalExtent[1]
	    });
	  }
	
	  if (max === 'dataMax') {
	    max = originalExtent[1];
	  } else if (typeof max === 'function') {
	    max = max({
	      min: originalExtent[0],
	      max: originalExtent[1]
	    });
	  }
	
	  (min == null || !isFinite(min)) && (min = NaN);
	  (max == null || !isFinite(max)) && (max = NaN);
	  scale.setBlank(zrUtil.eqNaN(min) || zrUtil.eqNaN(max)); // Evaluate if axis needs cross zero
	
	  if (model.getNeedCrossZero()) {
	    // Axis is over zero and min is not set
	    if (min > 0 && max > 0 && !fixMin) {
	      min = 0;
	    } // Axis is under zero and max is not set
	
	
	    if (min < 0 && max < 0 && !fixMax) {
	      max = 0;
	    }
	  }
	
	  return [min, max];
	}
	
	function niceScaleExtent(scale, model) {
	  var extent = getScaleExtent(scale, model);
	  var fixMin = model.getMin() != null;
	  var fixMax = model.getMax() != null;
	  var splitNumber = model.get('splitNumber');
	
	  if (scale.type === 'log') {
	    scale.base = model.get('logBase');
	  }
	
	  var scaleType = scale.type;
	  scale.setExtent(extent[0], extent[1]);
	  scale.niceExtent({
	    splitNumber: splitNumber,
	    fixMin: fixMin,
	    fixMax: fixMax,
	    minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
	    maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
	  }); // If some one specified the min, max. And the default calculated interval
	  // is not good enough. He can specify the interval. It is often appeared
	  // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
	  // to be 60.
	  // FIXME
	
	  var interval = model.get('interval');
	
	  if (interval != null) {
	    scale.setInterval && scale.setInterval(interval);
	  }
	}
	/**
	 * @param {module:echarts/model/Model} model
	 * @param {string} [axisType] Default retrieve from model.type
	 * @return {module:echarts/scale/*}
	 */
	
	
	function createScaleByModel(model, axisType) {
	  axisType = axisType || model.get('type');
	
	  if (axisType) {
	    switch (axisType) {
	      // Buildin scale
	      case 'category':
	        return new OrdinalScale(model.getCategories(), [Infinity, -Infinity]);
	
	      case 'value':
	        return new IntervalScale();
	      // Extended scale, like time and log
	
	      default:
	        return (Scale.getClass(axisType) || IntervalScale).create(model);
	    }
	  }
	}
	/**
	 * Check if the axis corss 0
	 */
	
	
	function ifAxisCrossZero(axis) {
	  var dataExtent = axis.scale.getExtent();
	  var min = dataExtent[0];
	  var max = dataExtent[1];
	  return !(min > 0 && max > 0 || min < 0 && max < 0);
	}
	/**
	 * @param {Array.<number>} tickCoords In axis self coordinate.
	 * @param {Array.<string>} labels
	 * @param {string} font
	 * @param {number} axisRotate 0: towards right horizontally, clock-wise is negative.
	 * @param {number} [labelRotate=0] 0: towards right horizontally, clock-wise is negative.
	 * @return {number}
	 */
	
	
	function getAxisLabelInterval(tickCoords, labels, font, axisRotate, labelRotate) {
	  var textSpaceTakenRect;
	  var autoLabelInterval = 0;
	  var accumulatedLabelInterval = 0;
	  var rotation = (axisRotate - labelRotate) / 180 * Math.PI;
	  var step = 1;
	
	  if (labels.length > 40) {
	    // Simple optimization for large amount of labels
	    step = Math.floor(labels.length / 40);
	  }
	
	  for (var i = 0; i < tickCoords.length; i += step) {
	    var tickCoord = tickCoords[i]; // Not precise, do not consider align and vertical align
	    // and each distance from axis line yet.
	
	    var rect = textContain.getBoundingRect(labels[i], font, 'center', 'top');
	    rect.x += tickCoord * Math.cos(rotation);
	    rect.y += tickCoord * Math.sin(rotation); // Magic number
	
	    rect.width *= 1.3;
	    rect.height *= 1.3;
	
	    if (!textSpaceTakenRect) {
	      textSpaceTakenRect = rect.clone();
	    } // There is no space for current label;
	    else if (textSpaceTakenRect.intersect(rect)) {
	        accumulatedLabelInterval++;
	        autoLabelInterval = Math.max(autoLabelInterval, accumulatedLabelInterval);
	      } else {
	        textSpaceTakenRect.union(rect); // Reset
	
	        accumulatedLabelInterval = 0;
	      }
	  }
	
	  if (autoLabelInterval === 0 && step > 1) {
	    return step;
	  }
	
	  return (autoLabelInterval + 1) * step - 1;
	}
	/**
	 * @param {Object} axis
	 * @param {Function} labelFormatter
	 * @return {Array.<string>}
	 */
	
	
	function getFormattedLabels(axis, labelFormatter) {
	  var scale = axis.scale;
	  var labels = scale.getTicksLabels();
	  var ticks = scale.getTicks();
	
	  if (typeof labelFormatter === 'string') {
	    labelFormatter = function (tpl) {
	      return function (val) {
	        return tpl.replace('{value}', val != null ? val : '');
	      };
	    }(labelFormatter); // Consider empty array
	
	
	    return zrUtil.map(labels, labelFormatter);
	  } else if (typeof labelFormatter === 'function') {
	    return zrUtil.map(ticks, function (tick, idx) {
	      return labelFormatter(getAxisRawValue(axis, tick), idx);
	    }, this);
	  } else {
	    return labels;
	  }
	}
	
	function getAxisRawValue(axis, value) {
	  // In category axis with data zoom, tick is not the original
	  // index of axis.data. So tick should not be exposed to user
	  // in category axis.
	  return axis.type === 'category' ? axis.scale.getLabel(value) : value;
	}
	
	exports.getScaleExtent = getScaleExtent;
	exports.niceScaleExtent = niceScaleExtent;
	exports.createScaleByModel = createScaleByModel;
	exports.ifAxisCrossZero = ifAxisCrossZero;
	exports.getAxisLabelInterval = getAxisLabelInterval;
	exports.getFormattedLabels = getFormattedLabels;
	exports.getAxisRawValue = getAxisRawValue;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var BoundingRect = __webpack_require__(13);
	
	// Symbol factory
	
	/**
	 * Triangle shape
	 * @inner
	 */
	var Triangle = graphic.extendShape({
	  type: 'triangle',
	  shape: {
	    cx: 0,
	    cy: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var cx = shape.cx;
	    var cy = shape.cy;
	    var width = shape.width / 2;
	    var height = shape.height / 2;
	    path.moveTo(cx, cy - height);
	    path.lineTo(cx + width, cy + height);
	    path.lineTo(cx - width, cy + height);
	    path.closePath();
	  }
	});
	/**
	 * Diamond shape
	 * @inner
	 */
	
	var Diamond = graphic.extendShape({
	  type: 'diamond',
	  shape: {
	    cx: 0,
	    cy: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var cx = shape.cx;
	    var cy = shape.cy;
	    var width = shape.width / 2;
	    var height = shape.height / 2;
	    path.moveTo(cx, cy - height);
	    path.lineTo(cx + width, cy);
	    path.lineTo(cx, cy + height);
	    path.lineTo(cx - width, cy);
	    path.closePath();
	  }
	});
	/**
	 * Pin shape
	 * @inner
	 */
	
	var Pin = graphic.extendShape({
	  type: 'pin',
	  shape: {
	    // x, y on the cusp
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var x = shape.x;
	    var y = shape.y;
	    var w = shape.width / 5 * 3; // Height must be larger than width
	
	    var h = Math.max(w, shape.height);
	    var r = w / 2; // Dist on y with tangent point and circle center
	
	    var dy = r * r / (h - r);
	    var cy = y - h + r + dy;
	    var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center
	
	    var dx = Math.cos(angle) * r;
	    var tanX = Math.sin(angle);
	    var tanY = Math.cos(angle);
	    var cpLen = r * 0.6;
	    var cpLen2 = r * 0.7;
	    path.moveTo(x - dx, cy + dy);
	    path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
	    path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
	    path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
	    path.closePath();
	  }
	});
	/**
	 * Arrow shape
	 * @inner
	 */
	
	var Arrow = graphic.extendShape({
	  type: 'arrow',
	  shape: {
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (ctx, shape) {
	    var height = shape.height;
	    var width = shape.width;
	    var x = shape.x;
	    var y = shape.y;
	    var dx = width / 3 * 2;
	    ctx.moveTo(x, y);
	    ctx.lineTo(x + dx, y + height);
	    ctx.lineTo(x, y + height / 4 * 3);
	    ctx.lineTo(x - dx, y + height);
	    ctx.lineTo(x, y);
	    ctx.closePath();
	  }
	});
	/**
	 * Map of path contructors
	 * @type {Object.<string, module:zrender/graphic/Path>}
	 */
	
	var symbolCtors = {
	  line: graphic.Line,
	  rect: graphic.Rect,
	  roundRect: graphic.Rect,
	  square: graphic.Rect,
	  circle: graphic.Circle,
	  diamond: Diamond,
	  pin: Pin,
	  arrow: Arrow,
	  triangle: Triangle
	};
	var symbolShapeMakers = {
	  line: function (x, y, w, h, shape) {
	    // FIXME
	    shape.x1 = x;
	    shape.y1 = y + h / 2;
	    shape.x2 = x + w;
	    shape.y2 = y + h / 2;
	  },
	  rect: function (x, y, w, h, shape) {
	    shape.x = x;
	    shape.y = y;
	    shape.width = w;
	    shape.height = h;
	  },
	  roundRect: function (x, y, w, h, shape) {
	    shape.x = x;
	    shape.y = y;
	    shape.width = w;
	    shape.height = h;
	    shape.r = Math.min(w, h) / 4;
	  },
	  square: function (x, y, w, h, shape) {
	    var size = Math.min(w, h);
	    shape.x = x;
	    shape.y = y;
	    shape.width = size;
	    shape.height = size;
	  },
	  circle: function (x, y, w, h, shape) {
	    // Put circle in the center of square
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.r = Math.min(w, h) / 2;
	  },
	  diamond: function (x, y, w, h, shape) {
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  pin: function (x, y, w, h, shape) {
	    shape.x = x + w / 2;
	    shape.y = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  arrow: function (x, y, w, h, shape) {
	    shape.x = x + w / 2;
	    shape.y = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  triangle: function (x, y, w, h, shape) {
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  }
	};
	var symbolBuildProxies = {};
	zrUtil.each(symbolCtors, function (Ctor, name) {
	  symbolBuildProxies[name] = new Ctor();
	});
	var SymbolClz = graphic.extendShape({
	  type: 'symbol',
	  shape: {
	    symbolType: '',
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  beforeBrush: function () {
	    var style = this.style;
	    var shape = this.shape; // FIXME
	
	    if (shape.symbolType === 'pin' && style.textPosition === 'inside') {
	      style.textPosition = ['50%', '40%'];
	      style.textAlign = 'center';
	      style.textVerticalAlign = 'middle';
	    }
	  },
	  buildPath: function (ctx, shape, inBundle) {
	    var symbolType = shape.symbolType;
	    var proxySymbol = symbolBuildProxies[symbolType];
	
	    if (shape.symbolType !== 'none') {
	      if (!proxySymbol) {
	        // Default rect
	        symbolType = 'rect';
	        proxySymbol = symbolBuildProxies[symbolType];
	      }
	
	      symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
	      proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
	    }
	  }
	}); // Provide setColor helper method to avoid determine if set the fill or stroke outside
	
	function symbolPathSetColor(color, innerColor) {
	  if (this.type !== 'image') {
	    var symbolStyle = this.style;
	    var symbolShape = this.shape;
	
	    if (symbolShape && symbolShape.symbolType === 'line') {
	      symbolStyle.stroke = color;
	    } else if (this.__isEmptyBrush) {
	      symbolStyle.stroke = color;
	      symbolStyle.fill = innerColor || '#fff';
	    } else {
	      // FIXME 判断图形默认是填充还是描边，使用 onlyStroke ?
	      symbolStyle.fill && (symbolStyle.fill = color);
	      symbolStyle.stroke && (symbolStyle.stroke = color);
	    }
	
	    this.dirty(false);
	  }
	}
	/**
	 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
	 * @param {string} symbolType
	 * @param {number} x
	 * @param {number} y
	 * @param {number} w
	 * @param {number} h
	 * @param {string} color
	 * @param {boolean} [keepAspect=false] whether to keep the ratio of w/h,
	 *                            for path and image only.
	 */
	
	
	function createSymbol(symbolType, x, y, w, h, color, keepAspect) {
	  // TODO Support image object, DynamicImage.
	  var isEmpty = symbolType.indexOf('empty') === 0;
	
	  if (isEmpty) {
	    symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
	  }
	
	  var symbolPath;
	
	  if (symbolType.indexOf('image://') === 0) {
	    symbolPath = graphic.makeImage(symbolType.slice(8), new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
	  } else if (symbolType.indexOf('path://') === 0) {
	    symbolPath = graphic.makePath(symbolType.slice(7), {}, new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
	  } else {
	    symbolPath = new SymbolClz({
	      shape: {
	        symbolType: symbolType,
	        x: x,
	        y: y,
	        width: w,
	        height: h
	      }
	    });
	  }
	
	  symbolPath.__isEmptyBrush = isEmpty;
	  symbolPath.setColor = symbolPathSetColor;
	  symbolPath.setColor(color);
	  return symbolPath;
	}
	
	exports.createSymbol = createSymbol;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	/**
	 * 3x2矩阵操作类
	 * @exports zrender/tool/matrix
	 */
	var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
	/**
	 * 创建一个单位矩阵
	 * @return {Float32Array|Array.<number>}
	 */
	
	function create() {
	  var out = new ArrayCtor(6);
	  identity(out);
	  return out;
	}
	/**
	 * 设置矩阵为单位矩阵
	 * @param {Float32Array|Array.<number>} out
	 */
	
	
	function identity(out) {
	  out[0] = 1;
	  out[1] = 0;
	  out[2] = 0;
	  out[3] = 1;
	  out[4] = 0;
	  out[5] = 0;
	  return out;
	}
	/**
	 * 复制矩阵
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} m
	 */
	
	
	function copy(out, m) {
	  out[0] = m[0];
	  out[1] = m[1];
	  out[2] = m[2];
	  out[3] = m[3];
	  out[4] = m[4];
	  out[5] = m[5];
	  return out;
	}
	/**
	 * 矩阵相乘
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} m1
	 * @param {Float32Array|Array.<number>} m2
	 */
	
	
	function mul(out, m1, m2) {
	  // Consider matrix.mul(m, m2, m);
	  // where out is the same as m2.
	  // So use temp variable to escape error.
	  var out0 = m1[0] * m2[0] + m1[2] * m2[1];
	  var out1 = m1[1] * m2[0] + m1[3] * m2[1];
	  var out2 = m1[0] * m2[2] + m1[2] * m2[3];
	  var out3 = m1[1] * m2[2] + m1[3] * m2[3];
	  var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
	  var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
	  out[0] = out0;
	  out[1] = out1;
	  out[2] = out2;
	  out[3] = out3;
	  out[4] = out4;
	  out[5] = out5;
	  return out;
	}
	/**
	 * 平移变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {Float32Array|Array.<number>} v
	 */
	
	
	function translate(out, a, v) {
	  out[0] = a[0];
	  out[1] = a[1];
	  out[2] = a[2];
	  out[3] = a[3];
	  out[4] = a[4] + v[0];
	  out[5] = a[5] + v[1];
	  return out;
	}
	/**
	 * 旋转变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {number} rad
	 */
	
	
	function rotate(out, a, rad) {
	  var aa = a[0];
	  var ac = a[2];
	  var atx = a[4];
	  var ab = a[1];
	  var ad = a[3];
	  var aty = a[5];
	  var st = Math.sin(rad);
	  var ct = Math.cos(rad);
	  out[0] = aa * ct + ab * st;
	  out[1] = -aa * st + ab * ct;
	  out[2] = ac * ct + ad * st;
	  out[3] = -ac * st + ct * ad;
	  out[4] = ct * atx + st * aty;
	  out[5] = ct * aty - st * atx;
	  return out;
	}
	/**
	 * 缩放变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {Float32Array|Array.<number>} v
	 */
	
	
	function scale(out, a, v) {
	  var vx = v[0];
	  var vy = v[1];
	  out[0] = a[0] * vx;
	  out[1] = a[1] * vy;
	  out[2] = a[2] * vx;
	  out[3] = a[3] * vy;
	  out[4] = a[4] * vx;
	  out[5] = a[5] * vy;
	  return out;
	}
	/**
	 * 求逆矩阵
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 */
	
	
	function invert(out, a) {
	  var aa = a[0];
	  var ac = a[2];
	  var atx = a[4];
	  var ab = a[1];
	  var ad = a[3];
	  var aty = a[5];
	  var det = aa * ad - ab * ac;
	
	  if (!det) {
	    return null;
	  }
	
	  det = 1.0 / det;
	  out[0] = ad * det;
	  out[1] = -ab * det;
	  out[2] = -ac * det;
	  out[3] = aa * det;
	  out[4] = (ac * aty - ad * atx) * det;
	  out[5] = (ab * atx - aa * aty) * det;
	  return out;
	}
	
	exports.create = create;
	exports.identity = identity;
	exports.copy = copy;
	exports.mul = mul;
	exports.translate = translate;
	exports.rotate = rotate;
	exports.scale = scale;
	exports.invert = invert;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var _model = __webpack_require__(6);
	
	var normalizeToArray = _model.normalizeToArray;
	
	/**
	 * Complete dimensions by data (guess dimension).
	 */
	var each = zrUtil.each;
	var isString = zrUtil.isString;
	var defaults = zrUtil.defaults;
	var OTHER_DIMS = {
	  tooltip: 1,
	  label: 1,
	  itemName: 1
	};
	/**
	 * Complete the dimensions array, by user defined `dimension` and `encode`,
	 * and guessing from the data structure.
	 * If no 'value' dimension specified, the first no-named dimension will be
	 * named as 'value'.
	 *
	 * @param {Array.<string>} sysDims Necessary dimensions, like ['x', 'y'], which
	 *      provides not only dim template, but also default order.
	 *      `name` of each item provides default coord name.
	 *      [{dimsDef: []}, ...] can be specified to give names.
	 * @param {Array} data Data list. [[1, 2, 3], [2, 3, 4]].
	 * @param {Object} [opt]
	 * @param {Array.<Object|string>} [opt.dimsDef] option.series.dimensions User defined dimensions
	 *      For example: ['asdf', {name, type}, ...].
	 * @param {Object} [opt.encodeDef] option.series.encode {x: 2, y: [3, 1], tooltip: [1, 2], label: 3}
	 * @param {string} [opt.extraPrefix] Prefix of name when filling the left dimensions.
	 * @param {string} [opt.extraFromZero] If specified, extra dim names will be:
	 *                      extraPrefix + 0, extraPrefix + extraBaseIndex + 1 ...
	 *                      If not specified, extra dim names will be:
	 *                      extraPrefix, extraPrefix + 0, extraPrefix + 1 ...
	 * @param {number} [opt.dimCount] If not specified, guess by the first data item.
	 * @return {Array.<Object>} [{
	 *      name: string mandatory,
	 *      coordDim: string mandatory,
	 *      coordDimIndex: number mandatory,
	 *      type: string optional,
	 *      tooltipName: string optional,
	 *      otherDims: {
	 *          tooltip: number optional,
	 *          label: number optional
	 *      },
	 *      isExtraCoord: boolean true or undefined.
	 *      other props ...
	 * }]
	 */
	
	function completeDimensions(sysDims, data, opt) {
	  data = data || [];
	  opt = opt || {};
	  sysDims = (sysDims || []).slice();
	  var dimsDef = (opt.dimsDef || []).slice();
	  var encodeDef = zrUtil.createHashMap(opt.encodeDef);
	  var dataDimNameMap = zrUtil.createHashMap();
	  var coordDimNameMap = zrUtil.createHashMap(); // var valueCandidate;
	
	  var result = [];
	  var dimCount = opt.dimCount;
	
	  if (dimCount == null) {
	    var value0 = retrieveValue(data[0]);
	    dimCount = Math.max(zrUtil.isArray(value0) && value0.length || 1, sysDims.length, dimsDef.length);
	    each(sysDims, function (sysDimItem) {
	      var sysDimItemDimsDef = sysDimItem.dimsDef;
	      sysDimItemDimsDef && (dimCount = Math.max(dimCount, sysDimItemDimsDef.length));
	    });
	  } // Apply user defined dims (`name` and `type`) and init result.
	
	
	  for (var i = 0; i < dimCount; i++) {
	    var dimDefItem = isString(dimsDef[i]) ? {
	      name: dimsDef[i]
	    } : dimsDef[i] || {};
	    var userDimName = dimDefItem.name;
	    var resultItem = result[i] = {
	      otherDims: {}
	    }; // Name will be applied later for avoiding duplication.
	
	    if (userDimName != null && dataDimNameMap.get(userDimName) == null) {
	      // Only if `series.dimensions` is defined in option, tooltipName
	      // will be set, and dimension will be diplayed vertically in
	      // tooltip by default.
	      resultItem.name = resultItem.tooltipName = userDimName;
	      dataDimNameMap.set(userDimName, i);
	    }
	
	    dimDefItem.type != null && (resultItem.type = dimDefItem.type);
	  } // Set `coordDim` and `coordDimIndex` by `encodeDef` and normalize `encodeDef`.
	
	
	  encodeDef.each(function (dataDims, coordDim) {
	    dataDims = encodeDef.set(coordDim, normalizeToArray(dataDims).slice());
	    each(dataDims, function (resultDimIdx, coordDimIndex) {
	      // The input resultDimIdx can be dim name or index.
	      isString(resultDimIdx) && (resultDimIdx = dataDimNameMap.get(resultDimIdx));
	
	      if (resultDimIdx != null && resultDimIdx < dimCount) {
	        dataDims[coordDimIndex] = resultDimIdx;
	        applyDim(result[resultDimIdx], coordDim, coordDimIndex);
	      }
	    });
	  }); // Apply templetes and default order from `sysDims`.
	
	  var availDimIdx = 0;
	  each(sysDims, function (sysDimItem, sysDimIndex) {
	    var coordDim;
	    var sysDimItem;
	    var sysDimItemDimsDef;
	    var sysDimItemOtherDims;
	
	    if (isString(sysDimItem)) {
	      coordDim = sysDimItem;
	      sysDimItem = {};
	    } else {
	      coordDim = sysDimItem.name;
	      sysDimItem = zrUtil.clone(sysDimItem); // `coordDimIndex` should not be set directly.
	
	      sysDimItemDimsDef = sysDimItem.dimsDef;
	      sysDimItemOtherDims = sysDimItem.otherDims;
	      sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
	    }
	
	    var dataDims = normalizeToArray(encodeDef.get(coordDim)); // dimensions provides default dim sequences.
	
	    if (!dataDims.length) {
	      for (var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++) {
	        while (availDimIdx < result.length && result[availDimIdx].coordDim != null) {
	          availDimIdx++;
	        }
	
	        availDimIdx < result.length && dataDims.push(availDimIdx++);
	      }
	    } // Apply templates.
	
	
	    each(dataDims, function (resultDimIdx, coordDimIndex) {
	      var resultItem = result[resultDimIdx];
	      applyDim(defaults(resultItem, sysDimItem), coordDim, coordDimIndex);
	
	      if (resultItem.name == null && sysDimItemDimsDef) {
	        resultItem.name = resultItem.tooltipName = sysDimItemDimsDef[coordDimIndex];
	      }
	
	      sysDimItemOtherDims && defaults(resultItem.otherDims, sysDimItemOtherDims);
	    });
	  }); // Make sure the first extra dim is 'value'.
	
	  var extra = opt.extraPrefix || 'value'; // Set dim `name` and other `coordDim` and other props.
	
	  for (var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++) {
	    var resultItem = result[resultDimIdx] = result[resultDimIdx] || {};
	    var coordDim = resultItem.coordDim;
	    coordDim == null && (resultItem.coordDim = genName(extra, coordDimNameMap, opt.extraFromZero), resultItem.coordDimIndex = 0, resultItem.isExtraCoord = true);
	    resultItem.name == null && (resultItem.name = genName(resultItem.coordDim, dataDimNameMap));
	    resultItem.type == null && guessOrdinal(data, resultDimIdx) && (resultItem.type = 'ordinal');
	  }
	
	  return result;
	
	  function applyDim(resultItem, coordDim, coordDimIndex) {
	    if (OTHER_DIMS[coordDim]) {
	      resultItem.otherDims[coordDim] = coordDimIndex;
	    } else {
	      resultItem.coordDim = coordDim;
	      resultItem.coordDimIndex = coordDimIndex;
	      coordDimNameMap.set(coordDim, true);
	    }
	  }
	
	  function genName(name, map, fromZero) {
	    if (fromZero || map.get(name) != null) {
	      var i = 0;
	
	      while (map.get(name + i) != null) {
	        i++;
	      }
	
	      name += i;
	    }
	
	    map.set(name, true);
	    return name;
	  }
	} // The rule should not be complex, otherwise user might not
	// be able to known where the data is wrong.
	
	
	var guessOrdinal = completeDimensions.guessOrdinal = function (data, dimIndex) {
	  for (var i = 0, len = data.length; i < len; i++) {
	    var value = retrieveValue(data[i]);
	
	    if (!zrUtil.isArray(value)) {
	      return false;
	    }
	
	    var value = value[dimIndex]; // Consider usage convenience, '1', '2' will be treated as "number".
	    // `isFinit('')` get `true`.
	
	    if (value != null && isFinite(value) && value !== '') {
	      return false;
	    } else if (isString(value) && value !== '-') {
	      return true;
	    }
	  }
	
	  return false;
	};
	
	function retrieveValue(o) {
	  return zrUtil.isArray(o) ? o : zrUtil.isObject(o) ? o.value : o;
	}
	
	var _default = completeDimensions;
	module.exports = _default;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var coordinateSystemCreators = {};
	
	function CoordinateSystemManager() {
	  this._coordinateSystems = [];
	}
	
	CoordinateSystemManager.prototype = {
	  constructor: CoordinateSystemManager,
	  create: function (ecModel, api) {
	    var coordinateSystems = [];
	    zrUtil.each(coordinateSystemCreators, function (creater, type) {
	      var list = creater.create(ecModel, api);
	      coordinateSystems = coordinateSystems.concat(list || []);
	    });
	    this._coordinateSystems = coordinateSystems;
	  },
	  update: function (ecModel, api) {
	    zrUtil.each(this._coordinateSystems, function (coordSys) {
	      // FIXME MUST have
	      coordSys.update && coordSys.update(ecModel, api);
	    });
	  },
	  getCoordinateSystems: function () {
	    return this._coordinateSystems.slice();
	  }
	};
	
	CoordinateSystemManager.register = function (type, coordinateSystemCreator) {
	  coordinateSystemCreators[type] = coordinateSystemCreator;
	};
	
	CoordinateSystemManager.get = function (type) {
	  return coordinateSystemCreators[type];
	};
	
	var _default = CoordinateSystemManager;
	module.exports = _default;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var BoundingRect = __webpack_require__(13);
	
	var imageHelper = __webpack_require__(138);
	
	var _util = __webpack_require__(1);
	
	var getContext = _util.getContext;
	var extend = _util.extend;
	var retrieve2 = _util.retrieve2;
	var retrieve3 = _util.retrieve3;
	var textWidthCache = {};
	var textWidthCacheCounter = 0;
	var TEXT_CACHE_MAX = 5000;
	var STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
	var DEFAULT_FONT = '12px sans-serif'; // Avoid assign to an exported variable, for transforming to cjs.
	
	var methods = {};
	
	function $override(name, fn) {
	  methods[name] = fn;
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @return {number} width
	 */
	
	
	function getWidth(text, font) {
	  font = font || DEFAULT_FONT;
	  var key = text + ':' + font;
	
	  if (textWidthCache[key]) {
	    return textWidthCache[key];
	  }
	
	  var textLines = (text + '').split('\n');
	  var width = 0;
	
	  for (var i = 0, l = textLines.length; i < l; i++) {
	    // textContain.measureText may be overrided in SVG or VML
	    width = Math.max(measureText(textLines[i], font).width, width);
	  }
	
	  if (textWidthCacheCounter > TEXT_CACHE_MAX) {
	    textWidthCacheCounter = 0;
	    textWidthCache = {};
	  }
	
	  textWidthCacheCounter++;
	  textWidthCache[key] = width;
	  return width;
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @param {string} [textAlign='left']
	 * @param {string} [textVerticalAlign='top']
	 * @param {Array.<number>} [textPadding]
	 * @param {Object} [rich]
	 * @param {Object} [truncate]
	 * @return {Object} {x, y, width, height, lineHeight}
	 */
	
	
	function getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate) {
	  return rich ? getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate) : getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, truncate);
	}
	
	function getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, truncate) {
	  var contentBlock = parsePlainText(text, font, textPadding, truncate);
	  var outerWidth = getWidth(text, font);
	
	  if (textPadding) {
	    outerWidth += textPadding[1] + textPadding[3];
	  }
	
	  var outerHeight = contentBlock.outerHeight;
	  var x = adjustTextX(0, outerWidth, textAlign);
	  var y = adjustTextY(0, outerHeight, textVerticalAlign);
	  var rect = new BoundingRect(x, y, outerWidth, outerHeight);
	  rect.lineHeight = contentBlock.lineHeight;
	  return rect;
	}
	
	function getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate) {
	  var contentBlock = parseRichText(text, {
	    rich: rich,
	    truncate: truncate,
	    font: font,
	    textAlign: textAlign,
	    textPadding: textPadding
	  });
	  var outerWidth = contentBlock.outerWidth;
	  var outerHeight = contentBlock.outerHeight;
	  var x = adjustTextX(0, outerWidth, textAlign);
	  var y = adjustTextY(0, outerHeight, textVerticalAlign);
	  return new BoundingRect(x, y, outerWidth, outerHeight);
	}
	/**
	 * @public
	 * @param {number} x
	 * @param {number} width
	 * @param {string} [textAlign='left']
	 * @return {number} Adjusted x.
	 */
	
	
	function adjustTextX(x, width, textAlign) {
	  // FIXME Right to left language
	  if (textAlign === 'right') {
	    x -= width;
	  } else if (textAlign === 'center') {
	    x -= width / 2;
	  }
	
	  return x;
	}
	/**
	 * @public
	 * @param {number} y
	 * @param {number} height
	 * @param {string} [textVerticalAlign='top']
	 * @return {number} Adjusted y.
	 */
	
	
	function adjustTextY(y, height, textVerticalAlign) {
	  if (textVerticalAlign === 'middle') {
	    y -= height / 2;
	  } else if (textVerticalAlign === 'bottom') {
	    y -= height;
	  }
	
	  return y;
	}
	/**
	 * @public
	 * @param {stirng} textPosition
	 * @param {Object} rect {x, y, width, height}
	 * @param {number} distance
	 * @return {Object} {x, y, textAlign, textVerticalAlign}
	 */
	
	
	function adjustTextPositionOnRect(textPosition, rect, distance) {
	  var x = rect.x;
	  var y = rect.y;
	  var height = rect.height;
	  var width = rect.width;
	  var halfHeight = height / 2;
	  var textAlign = 'left';
	  var textVerticalAlign = 'top';
	
	  switch (textPosition) {
	    case 'left':
	      x -= distance;
	      y += halfHeight;
	      textAlign = 'right';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'right':
	      x += distance + width;
	      y += halfHeight;
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'top':
	      x += width / 2;
	      y -= distance;
	      textAlign = 'center';
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'bottom':
	      x += width / 2;
	      y += height + distance;
	      textAlign = 'center';
	      break;
	
	    case 'inside':
	      x += width / 2;
	      y += halfHeight;
	      textAlign = 'center';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideLeft':
	      x += distance;
	      y += halfHeight;
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideRight':
	      x += width - distance;
	      y += halfHeight;
	      textAlign = 'right';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideTop':
	      x += width / 2;
	      y += distance;
	      textAlign = 'center';
	      break;
	
	    case 'insideBottom':
	      x += width / 2;
	      y += height - distance;
	      textAlign = 'center';
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'insideTopLeft':
	      x += distance;
	      y += distance;
	      break;
	
	    case 'insideTopRight':
	      x += width - distance;
	      y += distance;
	      textAlign = 'right';
	      break;
	
	    case 'insideBottomLeft':
	      x += distance;
	      y += height - distance;
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'insideBottomRight':
	      x += width - distance;
	      y += height - distance;
	      textAlign = 'right';
	      textVerticalAlign = 'bottom';
	      break;
	  }
	
	  return {
	    x: x,
	    y: y,
	    textAlign: textAlign,
	    textVerticalAlign: textVerticalAlign
	  };
	}
	/**
	 * Show ellipsis if overflow.
	 *
	 * @public
	 * @param  {string} text
	 * @param  {string} containerWidth
	 * @param  {string} font
	 * @param  {number} [ellipsis='...']
	 * @param  {Object} [options]
	 * @param  {number} [options.maxIterations=3]
	 * @param  {number} [options.minChar=0] If truncate result are less
	 *                  then minChar, ellipsis will not show, which is
	 *                  better for user hint in some cases.
	 * @param  {number} [options.placeholder=''] When all truncated, use the placeholder.
	 * @return {string}
	 */
	
	
	function truncateText(text, containerWidth, font, ellipsis, options) {
	  if (!containerWidth) {
	    return '';
	  }
	
	  var textLines = (text + '').split('\n');
	  options = prepareTruncateOptions(containerWidth, font, ellipsis, options); // FIXME
	  // It is not appropriate that every line has '...' when truncate multiple lines.
	
	  for (var i = 0, len = textLines.length; i < len; i++) {
	    textLines[i] = truncateSingleLine(textLines[i], options);
	  }
	
	  return textLines.join('\n');
	}
	
	function prepareTruncateOptions(containerWidth, font, ellipsis, options) {
	  options = extend({}, options);
	  options.font = font;
	  var ellipsis = retrieve2(ellipsis, '...');
	  options.maxIterations = retrieve2(options.maxIterations, 2);
	  var minChar = options.minChar = retrieve2(options.minChar, 0); // FIXME
	  // Other languages?
	
	  options.cnCharWidth = getWidth('国', font); // FIXME
	  // Consider proportional font?
	
	  var ascCharWidth = options.ascCharWidth = getWidth('a', font);
	  options.placeholder = retrieve2(options.placeholder, ''); // Example 1: minChar: 3, text: 'asdfzxcv', truncate result: 'asdf', but not: 'a...'.
	  // Example 2: minChar: 3, text: '维度', truncate result: '维', but not: '...'.
	
	  var contentWidth = containerWidth = Math.max(0, containerWidth - 1); // Reserve some gap.
	
	  for (var i = 0; i < minChar && contentWidth >= ascCharWidth; i++) {
	    contentWidth -= ascCharWidth;
	  }
	
	  var ellipsisWidth = getWidth(ellipsis);
	
	  if (ellipsisWidth > contentWidth) {
	    ellipsis = '';
	    ellipsisWidth = 0;
	  }
	
	  contentWidth = containerWidth - ellipsisWidth;
	  options.ellipsis = ellipsis;
	  options.ellipsisWidth = ellipsisWidth;
	  options.contentWidth = contentWidth;
	  options.containerWidth = containerWidth;
	  return options;
	}
	
	function truncateSingleLine(textLine, options) {
	  var containerWidth = options.containerWidth;
	  var font = options.font;
	  var contentWidth = options.contentWidth;
	
	  if (!containerWidth) {
	    return '';
	  }
	
	  var lineWidth = getWidth(textLine, font);
	
	  if (lineWidth <= containerWidth) {
	    return textLine;
	  }
	
	  for (var j = 0;; j++) {
	    if (lineWidth <= contentWidth || j >= options.maxIterations) {
	      textLine += options.ellipsis;
	      break;
	    }
	
	    var subLength = j === 0 ? estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
	    textLine = textLine.substr(0, subLength);
	    lineWidth = getWidth(textLine, font);
	  }
	
	  if (textLine === '') {
	    textLine = options.placeholder;
	  }
	
	  return textLine;
	}
	
	function estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
	  var width = 0;
	  var i = 0;
	
	  for (var len = text.length; i < len && width < contentWidth; i++) {
	    var charCode = text.charCodeAt(i);
	    width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
	  }
	
	  return i;
	}
	/**
	 * @public
	 * @param {string} font
	 * @return {number} line height
	 */
	
	
	function getLineHeight(font) {
	  // FIXME A rough approach.
	  return getWidth('国', font);
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @return {Object} width
	 */
	
	
	function measureText(text, font) {
	  return methods.measureText(text, font);
	} // Avoid assign to an exported variable, for transforming to cjs.
	
	
	methods.measureText = function (text, font) {
	  var ctx = getContext();
	  ctx.font = font || DEFAULT_FONT;
	  return ctx.measureText(text);
	};
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @param {Object} [truncate]
	 * @return {Object} block: {lineHeight, lines, height, outerHeight}
	 *  Notice: for performance, do not calculate outerWidth util needed.
	 */
	
	
	function parsePlainText(text, font, padding, truncate) {
	  text != null && (text += '');
	  var lineHeight = getLineHeight(font);
	  var lines = text ? text.split('\n') : [];
	  var height = lines.length * lineHeight;
	  var outerHeight = height;
	
	  if (padding) {
	    outerHeight += padding[0] + padding[2];
	  }
	
	  if (text && truncate) {
	    var truncOuterHeight = truncate.outerHeight;
	    var truncOuterWidth = truncate.outerWidth;
	
	    if (truncOuterHeight != null && outerHeight > truncOuterHeight) {
	      text = '';
	      lines = [];
	    } else if (truncOuterWidth != null) {
	      var options = prepareTruncateOptions(truncOuterWidth - (padding ? padding[1] + padding[3] : 0), font, truncate.ellipsis, {
	        minChar: truncate.minChar,
	        placeholder: truncate.placeholder
	      }); // FIXME
	      // It is not appropriate that every line has '...' when truncate multiple lines.
	
	      for (var i = 0, len = lines.length; i < len; i++) {
	        lines[i] = truncateSingleLine(lines[i], options);
	      }
	    }
	  }
	
	  return {
	    lines: lines,
	    height: height,
	    outerHeight: outerHeight,
	    lineHeight: lineHeight
	  };
	}
	/**
	 * For example: 'some text {a|some text}other text{b|some text}xxx{c|}xxx'
	 * Also consider 'bbbb{a|xxx\nzzz}xxxx\naaaa'.
	 *
	 * @public
	 * @param {string} text
	 * @param {Object} style
	 * @return {Object} block
	 * {
	 *      width,
	 *      height,
	 *      lines: [{
	 *          lineHeight,
	 *          width,
	 *          tokens: [[{
	 *              styleName,
	 *              text,
	 *              width,      // include textPadding
	 *              height,     // include textPadding
	 *              textWidth, // pure text width
	 *              textHeight, // pure text height
	 *              lineHeihgt,
	 *              font,
	 *              textAlign,
	 *              textVerticalAlign
	 *          }], [...], ...]
	 *      }, ...]
	 * }
	 * If styleName is undefined, it is plain text.
	 */
	
	
	function parseRichText(text, style) {
	  var contentBlock = {
	    lines: [],
	    width: 0,
	    height: 0
	  };
	  text != null && (text += '');
	
	  if (!text) {
	    return contentBlock;
	  }
	
	  var lastIndex = STYLE_REG.lastIndex = 0;
	  var result;
	
	  while ((result = STYLE_REG.exec(text)) != null) {
	    var matchedIndex = result.index;
	
	    if (matchedIndex > lastIndex) {
	      pushTokens(contentBlock, text.substring(lastIndex, matchedIndex));
	    }
	
	    pushTokens(contentBlock, result[2], result[1]);
	    lastIndex = STYLE_REG.lastIndex;
	  }
	
	  if (lastIndex < text.length) {
	    pushTokens(contentBlock, text.substring(lastIndex, text.length));
	  }
	
	  var lines = contentBlock.lines;
	  var contentHeight = 0;
	  var contentWidth = 0; // For `textWidth: 100%`
	
	  var pendingList = [];
	  var stlPadding = style.textPadding;
	  var truncate = style.truncate;
	  var truncateWidth = truncate && truncate.outerWidth;
	  var truncateHeight = truncate && truncate.outerHeight;
	
	  if (stlPadding) {
	    truncateWidth != null && (truncateWidth -= stlPadding[1] + stlPadding[3]);
	    truncateHeight != null && (truncateHeight -= stlPadding[0] + stlPadding[2]);
	  } // Calculate layout info of tokens.
	
	
	  for (var i = 0; i < lines.length; i++) {
	    var line = lines[i];
	    var lineHeight = 0;
	    var lineWidth = 0;
	
	    for (var j = 0; j < line.tokens.length; j++) {
	      var token = line.tokens[j];
	      var tokenStyle = token.styleName && style.rich[token.styleName] || {}; // textPadding should not inherit from style.
	
	      var textPadding = token.textPadding = tokenStyle.textPadding; // textFont has been asigned to font by `normalizeStyle`.
	
	      var font = token.font = tokenStyle.font || style.font; // textHeight can be used when textVerticalAlign is specified in token.
	
	      var tokenHeight = token.textHeight = retrieve2( // textHeight should not be inherited, consider it can be specified
	      // as box height of the block.
	      tokenStyle.textHeight, getLineHeight(font));
	      textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
	      token.height = tokenHeight;
	      token.lineHeight = retrieve3(tokenStyle.textLineHeight, style.textLineHeight, tokenHeight);
	      token.textAlign = tokenStyle && tokenStyle.textAlign || style.textAlign;
	      token.textVerticalAlign = tokenStyle && tokenStyle.textVerticalAlign || 'middle';
	
	      if (truncateHeight != null && contentHeight + token.lineHeight > truncateHeight) {
	        return {
	          lines: [],
	          width: 0,
	          height: 0
	        };
	      }
	
	      token.textWidth = getWidth(token.text, font);
	      var tokenWidth = tokenStyle.textWidth;
	      var tokenWidthNotSpecified = tokenWidth == null || tokenWidth === 'auto'; // Percent width, can be `100%`, can be used in drawing separate
	      // line when box width is needed to be auto.
	
	      if (typeof tokenWidth === 'string' && tokenWidth.charAt(tokenWidth.length - 1) === '%') {
	        token.percentWidth = tokenWidth;
	        pendingList.push(token);
	        tokenWidth = 0; // Do not truncate in this case, because there is no user case
	        // and it is too complicated.
	      } else {
	        if (tokenWidthNotSpecified) {
	          tokenWidth = token.textWidth; // FIXME: If image is not loaded and textWidth is not specified, calling
	          // `getBoundingRect()` will not get correct result.
	
	          var textBackgroundColor = tokenStyle.textBackgroundColor;
	          var bgImg = textBackgroundColor && textBackgroundColor.image; // Use cases:
	          // (1) If image is not loaded, it will be loaded at render phase and call
	          // `dirty()` and `textBackgroundColor.image` will be replaced with the loaded
	          // image, and then the right size will be calculated here at the next tick.
	          // See `graphic/helper/text.js`.
	          // (2) If image loaded, and `textBackgroundColor.image` is image src string,
	          // use `imageHelper.findExistImage` to find cached image.
	          // `imageHelper.findExistImage` will always be called here before
	          // `imageHelper.createOrUpdateImage` in `graphic/helper/text.js#renderRichText`
	          // which ensures that image will not be rendered before correct size calcualted.
	
	          if (bgImg) {
	            bgImg = imageHelper.findExistImage(bgImg);
	
	            if (imageHelper.isImageReady(bgImg)) {
	              tokenWidth = Math.max(tokenWidth, bgImg.width * tokenHeight / bgImg.height);
	            }
	          }
	        }
	
	        var paddingW = textPadding ? textPadding[1] + textPadding[3] : 0;
	        tokenWidth += paddingW;
	        var remianTruncWidth = truncateWidth != null ? truncateWidth - lineWidth : null;
	
	        if (remianTruncWidth != null && remianTruncWidth < tokenWidth) {
	          if (!tokenWidthNotSpecified || remianTruncWidth < paddingW) {
	            token.text = '';
	            token.textWidth = tokenWidth = 0;
	          } else {
	            token.text = truncateText(token.text, remianTruncWidth - paddingW, font, truncate.ellipsis, {
	              minChar: truncate.minChar
	            });
	            token.textWidth = getWidth(token.text, font);
	            tokenWidth = token.textWidth + paddingW;
	          }
	        }
	      }
	
	      lineWidth += token.width = tokenWidth;
	      tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
	    }
	
	    line.width = lineWidth;
	    line.lineHeight = lineHeight;
	    contentHeight += lineHeight;
	    contentWidth = Math.max(contentWidth, lineWidth);
	  }
	
	  contentBlock.outerWidth = contentBlock.width = retrieve2(style.textWidth, contentWidth);
	  contentBlock.outerHeight = contentBlock.height = retrieve2(style.textHeight, contentHeight);
	
	  if (stlPadding) {
	    contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
	    contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
	  }
	
	  for (var i = 0; i < pendingList.length; i++) {
	    var token = pendingList[i];
	    var percentWidth = token.percentWidth; // Should not base on outerWidth, because token can not be placed out of padding.
	
	    token.width = parseInt(percentWidth, 10) / 100 * contentWidth;
	  }
	
	  return contentBlock;
	}
	
	function pushTokens(block, str, styleName) {
	  var isEmptyStr = str === '';
	  var strs = str.split('\n');
	  var lines = block.lines;
	
	  for (var i = 0; i < strs.length; i++) {
	    var text = strs[i];
	    var token = {
	      styleName: styleName,
	      text: text,
	      isLineHolder: !text && !isEmptyStr
	    }; // The first token should be appended to the last line.
	
	    if (!i) {
	      var tokens = (lines[lines.length - 1] || (lines[0] = {
	        tokens: []
	      })).tokens; // Consider cases:
	      // (1) ''.split('\n') => ['', '\n', ''], the '' at the first item
	      // (which is a placeholder) should be replaced by new token.
	      // (2) A image backage, where token likes {a|}.
	      // (3) A redundant '' will affect textAlign in line.
	      // (4) tokens with the same tplName should not be merged, because
	      // they should be displayed in different box (with border and padding).
	
	      var tokensLen = tokens.length;
	      tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : // Consider text is '', only insert when it is the "lineHolder" or
	      // "emptyStr". Otherwise a redundant '' will affect textAlign in line.
	      (text || !tokensLen || isEmptyStr) && tokens.push(token);
	    } // Other tokens always start a new line.
	    else {
	        // If there is '', insert it as a placeholder.
	        lines.push({
	          tokens: [token]
	        });
	      }
	  }
	}
	
	function makeFont(style) {
	  // FIXME in node-canvas fontWeight is before fontStyle
	  // Use `fontSize` `fontFamily` to check whether font properties are defined.
	  return (style.fontSize || style.fontFamily) && [style.fontStyle, style.fontWeight, (style.fontSize || 12) + 'px', // If font properties are defined, `fontFamily` should not be ignored.
	  style.fontFamily || 'sans-serif'].join(' ') || style.textFont || style.font;
	}
	
	exports.DEFAULT_FONT = DEFAULT_FONT;
	exports.$override = $override;
	exports.getWidth = getWidth;
	exports.getBoundingRect = getBoundingRect;
	exports.adjustTextX = adjustTextX;
	exports.adjustTextY = adjustTextY;
	exports.adjustTextPositionOnRect = adjustTextPositionOnRect;
	exports.truncateText = truncateText;
	exports.getLineHeight = getLineHeight;
	exports.measureText = measureText;
	exports.parsePlainText = parsePlainText;
	exports.parseRichText = parseRichText;
	exports.makeFont = makeFont;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(1);
	
	var TYPE_DELIMITER = '.';
	var IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
	var MEMBER_PRIFIX = '\0ec_\0';
	/**
	 * Hide private class member.
	 * The same behavior as `host[name] = value;` (can be right-value)
	 * @public
	 */
	
	function set(host, name, value) {
	  return host[MEMBER_PRIFIX + name] = value;
	}
	/**
	 * Hide private class member.
	 * The same behavior as `host[name];`
	 * @public
	 */
	
	
	function get(host, name) {
	  return host[MEMBER_PRIFIX + name];
	}
	/**
	 * For hidden private class member.
	 * The same behavior as `host.hasOwnProperty(name);`
	 * @public
	 */
	
	
	function hasOwn(host, name) {
	  return host.hasOwnProperty(MEMBER_PRIFIX + name);
	}
	/**
	 * Notice, parseClassType('') should returns {main: '', sub: ''}
	 * @public
	 */
	
	
	function parseClassType(componentType) {
	  var ret = {
	    main: '',
	    sub: ''
	  };
	
	  if (componentType) {
	    componentType = componentType.split(TYPE_DELIMITER);
	    ret.main = componentType[0] || '';
	    ret.sub = componentType[1] || '';
	  }
	
	  return ret;
	}
	/**
	 * @public
	 */
	
	
	function checkClassType(componentType) {
	  zrUtil.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
	}
	/**
	 * @public
	 */
	
	
	function enableClassExtend(RootClass, mandatoryMethods) {
	  RootClass.$constructor = RootClass;
	
	  RootClass.extend = function (proto) {
	    var superClass = this;
	
	    var ExtendedClass = function () {
	      if (!proto.$constructor) {
	        superClass.apply(this, arguments);
	      } else {
	        proto.$constructor.apply(this, arguments);
	      }
	    };
	
	    zrUtil.extend(ExtendedClass.prototype, proto);
	    ExtendedClass.extend = this.extend;
	    ExtendedClass.superCall = superCall;
	    ExtendedClass.superApply = superApply;
	    zrUtil.inherits(ExtendedClass, this);
	    ExtendedClass.superClass = superClass;
	    return ExtendedClass;
	  };
	} // superCall should have class info, which can not be fetch from 'this'.
	// Consider this case:
	// class A has method f,
	// class B inherits class A, overrides method f, f call superApply('f'),
	// class C inherits class B, do not overrides method f,
	// then when method of class C is called, dead loop occured.
	
	
	function superCall(context, methodName) {
	  var args = zrUtil.slice(arguments, 2);
	  return this.superClass.prototype[methodName].apply(context, args);
	}
	
	function superApply(context, methodName, args) {
	  return this.superClass.prototype[methodName].apply(context, args);
	}
	/**
	 * @param {Object} entity
	 * @param {Object} options
	 * @param {boolean} [options.registerWhenExtend]
	 * @public
	 */
	
	
	function enableClassManagement(entity, options) {
	  options = options || {};
	  /**
	   * Component model classes
	   * key: componentType,
	   * value:
	   *     componentClass, when componentType is 'xxx'
	   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
	   * @type {Object}
	   */
	
	  var storage = {};
	
	  entity.registerClass = function (Clazz, componentType) {
	    if (componentType) {
	      checkClassType(componentType);
	      componentType = parseClassType(componentType);
	
	      if (!componentType.sub) {
	        storage[componentType.main] = Clazz;
	      } else if (componentType.sub !== IS_CONTAINER) {
	        var container = makeContainer(componentType);
	        container[componentType.sub] = Clazz;
	      }
	    }
	
	    return Clazz;
	  };
	
	  entity.getClass = function (componentMainType, subType, throwWhenNotFound) {
	    var Clazz = storage[componentMainType];
	
	    if (Clazz && Clazz[IS_CONTAINER]) {
	      Clazz = subType ? Clazz[subType] : null;
	    }
	
	    if (throwWhenNotFound && !Clazz) {
	      throw new Error(!subType ? componentMainType + '.' + 'type should be specified.' : 'Component ' + componentMainType + '.' + (subType || '') + ' not exists. Load it first.');
	    }
	
	    return Clazz;
	  };
	
	  entity.getClassesByMainType = function (componentType) {
	    componentType = parseClassType(componentType);
	    var result = [];
	    var obj = storage[componentType.main];
	
	    if (obj && obj[IS_CONTAINER]) {
	      zrUtil.each(obj, function (o, type) {
	        type !== IS_CONTAINER && result.push(o);
	      });
	    } else {
	      result.push(obj);
	    }
	
	    return result;
	  };
	
	  entity.hasClass = function (componentType) {
	    // Just consider componentType.main.
	    componentType = parseClassType(componentType);
	    return !!storage[componentType.main];
	  };
	  /**
	   * @return {Array.<string>} Like ['aa', 'bb'], but can not be ['aa.xx']
	   */
	
	
	  entity.getAllClassMainTypes = function () {
	    var types = [];
	    zrUtil.each(storage, function (obj, type) {
	      types.push(type);
	    });
	    return types;
	  };
	  /**
	   * If a main type is container and has sub types
	   * @param  {string}  mainType
	   * @return {boolean}
	   */
	
	
	  entity.hasSubTypes = function (componentType) {
	    componentType = parseClassType(componentType);
	    var obj = storage[componentType.main];
	    return obj && obj[IS_CONTAINER];
	  };
	
	  entity.parseClassType = parseClassType;
	
	  function makeContainer(componentType) {
	    var container = storage[componentType.main];
	
	    if (!container || !container[IS_CONTAINER]) {
	      container = storage[componentType.main] = {};
	      container[IS_CONTAINER] = true;
	    }
	
	    return container;
	  }
	
	  if (options.registerWhenExtend) {
	    var originalExtend = entity.extend;
	
	    if (originalExtend) {
	      entity.extend = function (proto) {
	        var ExtendedClass = originalExtend.call(this, proto);
	        return entity.registerClass(ExtendedClass, proto.type);
	      };
	    }
	  }
	
	  return entity;
	}
	/**
	 * @param {string|Array.<string>} properties
	 */
	
	
	function setReadOnly(obj, properties) {// FIXME It seems broken in IE8 simulation of IE11
	  // if (!zrUtil.isArray(properties)) {
	  //     properties = properties != null ? [properties] : [];
	  // }
	  // zrUtil.each(properties, function (prop) {
	  //     var value = obj[prop];
	  //     Object.defineProperty
	  //         && Object.defineProperty(obj, prop, {
	  //             value: value, writable: false
	  //         });
	  //     zrUtil.isArray(obj[prop])
	  //         && Object.freeze
	  //         && Object.freeze(obj[prop]);
	  // });
	}
	
	exports.set = set;
	exports.get = get;
	exports.hasOwn = hasOwn;
	exports.parseClassType = parseClassType;
	exports.enableClassExtend = enableClassExtend;
	exports.enableClassManagement = enableClassManagement;
	exports.setReadOnly = setReadOnly;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(236)
	__vue_template__ = __webpack_require__(637)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var Eventful = __webpack_require__(49);
	
	exports.Dispatcher = Eventful;
	
	var env = __webpack_require__(18);
	
	/**
	 * 事件辅助类
	 * @module zrender/core/event
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 */
	var isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
	var MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
	
	function getBoundingClientRect(el) {
	  // BlackBerry 5, iOS 3 (original iPhone) don't have getBoundingRect
	  return el.getBoundingClientRect ? el.getBoundingClientRect() : {
	    left: 0,
	    top: 0
	  };
	} // `calculate` is optional, default false
	
	
	function clientToLocal(el, e, out, calculate) {
	  out = out || {}; // According to the W3C Working Draft, offsetX and offsetY should be relative
	  // to the padding edge of the target element. The only browser using this convention
	  // is IE. Webkit uses the border edge, Opera uses the content edge, and FireFox does
	  // not support the properties.
	  // (see http://www.jacklmoore.com/notes/mouse-position/)
	  // In zr painter.dom, padding edge equals to border edge.
	  // FIXME
	  // When mousemove event triggered on ec tooltip, target is not zr painter.dom, and
	  // offsetX/Y is relative to e.target, where the calculation of zrX/Y via offsetX/Y
	  // is too complex. So css-transfrom dont support in this case temporarily.
	
	  if (calculate || !env.canvasSupported) {
	    defaultGetZrXY(el, e, out);
	  } // Caution: In FireFox, layerX/layerY Mouse position relative to the closest positioned
	  // ancestor element, so we should make sure el is positioned (e.g., not position:static).
	  // BTW1, Webkit don't return the same results as FF in non-simple cases (like add
	  // zoom-factor, overflow / opacity layers, transforms ...)
	  // BTW2, (ev.offsetY || ev.pageY - $(ev.target).offset().top) is not correct in preserve-3d.
	  // <https://bugs.jquery.com/ticket/8523#comment:14>
	  // BTW3, In ff, offsetX/offsetY is always 0.
	  else if (env.browser.firefox && e.layerX != null && e.layerX !== e.offsetX) {
	      out.zrX = e.layerX;
	      out.zrY = e.layerY;
	    } // For IE6+, chrome, safari, opera. (When will ff support offsetX?)
	    else if (e.offsetX != null) {
	        out.zrX = e.offsetX;
	        out.zrY = e.offsetY;
	      } // For some other device, e.g., IOS safari.
	      else {
	          defaultGetZrXY(el, e, out);
	        }
	
	  return out;
	}
	
	function defaultGetZrXY(el, e, out) {
	  // This well-known method below does not support css transform.
	  var box = getBoundingClientRect(el);
	  out.zrX = e.clientX - box.left;
	  out.zrY = e.clientY - box.top;
	}
	/**
	 * 如果存在第三方嵌入的一些dom触发的事件，或touch事件，需要转换一下事件坐标.
	 * `calculate` is optional, default false.
	 */
	
	
	function normalizeEvent(el, e, calculate) {
	  e = e || window.event;
	
	  if (e.zrX != null) {
	    return e;
	  }
	
	  var eventType = e.type;
	  var isTouch = eventType && eventType.indexOf('touch') >= 0;
	
	  if (!isTouch) {
	    clientToLocal(el, e, e, calculate);
	    e.zrDelta = e.wheelDelta ? e.wheelDelta / 120 : -(e.detail || 0) / 3;
	  } else {
	    var touch = eventType != 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
	    touch && clientToLocal(el, touch, e, calculate);
	  } // Add which for click: 1 === left; 2 === middle; 3 === right; otherwise: 0;
	  // See jQuery: https://github.com/jquery/jquery/blob/master/src/event.js
	  // If e.which has been defined, if may be readonly,
	  // see: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/which
	
	
	  var button = e.button;
	
	  if (e.which == null && button !== undefined && MOUSE_EVENT_REG.test(e.type)) {
	    e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
	  }
	
	  return e;
	}
	
	function addEventListener(el, name, handler) {
	  if (isDomLevel2) {
	    el.addEventListener(name, handler);
	  } else {
	    el.attachEvent('on' + name, handler);
	  }
	}
	
	function removeEventListener(el, name, handler) {
	  if (isDomLevel2) {
	    el.removeEventListener(name, handler);
	  } else {
	    el.detachEvent('on' + name, handler);
	  }
	}
	/**
	 * preventDefault and stopPropagation.
	 * Notice: do not do that in zrender. Upper application
	 * do that if necessary.
	 *
	 * @memberOf module:zrender/core/event
	 * @method
	 * @param {Event} e : event对象
	 */
	
	
	var stop = isDomLevel2 ? function (e) {
	  e.preventDefault();
	  e.stopPropagation();
	  e.cancelBubble = true;
	} : function (e) {
	  e.returnValue = false;
	  e.cancelBubble = true;
	};
	
	function notLeftMouse(e) {
	  // If e.which is undefined, considered as left mouse event.
	  return e.which > 1;
	} // 做向上兼容
	
	
	exports.clientToLocal = clientToLocal;
	exports.normalizeEvent = normalizeEvent;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.stop = stop;
	exports.notLeftMouse = notLeftMouse;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var LRU = __webpack_require__(221);
	
	var kCSSColorTable = {
	  'transparent': [0, 0, 0, 0],
	  'aliceblue': [240, 248, 255, 1],
	  'antiquewhite': [250, 235, 215, 1],
	  'aqua': [0, 255, 255, 1],
	  'aquamarine': [127, 255, 212, 1],
	  'azure': [240, 255, 255, 1],
	  'beige': [245, 245, 220, 1],
	  'bisque': [255, 228, 196, 1],
	  'black': [0, 0, 0, 1],
	  'blanchedalmond': [255, 235, 205, 1],
	  'blue': [0, 0, 255, 1],
	  'blueviolet': [138, 43, 226, 1],
	  'brown': [165, 42, 42, 1],
	  'burlywood': [222, 184, 135, 1],
	  'cadetblue': [95, 158, 160, 1],
	  'chartreuse': [127, 255, 0, 1],
	  'chocolate': [210, 105, 30, 1],
	  'coral': [255, 127, 80, 1],
	  'cornflowerblue': [100, 149, 237, 1],
	  'cornsilk': [255, 248, 220, 1],
	  'crimson': [220, 20, 60, 1],
	  'cyan': [0, 255, 255, 1],
	  'darkblue': [0, 0, 139, 1],
	  'darkcyan': [0, 139, 139, 1],
	  'darkgoldenrod': [184, 134, 11, 1],
	  'darkgray': [169, 169, 169, 1],
	  'darkgreen': [0, 100, 0, 1],
	  'darkgrey': [169, 169, 169, 1],
	  'darkkhaki': [189, 183, 107, 1],
	  'darkmagenta': [139, 0, 139, 1],
	  'darkolivegreen': [85, 107, 47, 1],
	  'darkorange': [255, 140, 0, 1],
	  'darkorchid': [153, 50, 204, 1],
	  'darkred': [139, 0, 0, 1],
	  'darksalmon': [233, 150, 122, 1],
	  'darkseagreen': [143, 188, 143, 1],
	  'darkslateblue': [72, 61, 139, 1],
	  'darkslategray': [47, 79, 79, 1],
	  'darkslategrey': [47, 79, 79, 1],
	  'darkturquoise': [0, 206, 209, 1],
	  'darkviolet': [148, 0, 211, 1],
	  'deeppink': [255, 20, 147, 1],
	  'deepskyblue': [0, 191, 255, 1],
	  'dimgray': [105, 105, 105, 1],
	  'dimgrey': [105, 105, 105, 1],
	  'dodgerblue': [30, 144, 255, 1],
	  'firebrick': [178, 34, 34, 1],
	  'floralwhite': [255, 250, 240, 1],
	  'forestgreen': [34, 139, 34, 1],
	  'fuchsia': [255, 0, 255, 1],
	  'gainsboro': [220, 220, 220, 1],
	  'ghostwhite': [248, 248, 255, 1],
	  'gold': [255, 215, 0, 1],
	  'goldenrod': [218, 165, 32, 1],
	  'gray': [128, 128, 128, 1],
	  'green': [0, 128, 0, 1],
	  'greenyellow': [173, 255, 47, 1],
	  'grey': [128, 128, 128, 1],
	  'honeydew': [240, 255, 240, 1],
	  'hotpink': [255, 105, 180, 1],
	  'indianred': [205, 92, 92, 1],
	  'indigo': [75, 0, 130, 1],
	  'ivory': [255, 255, 240, 1],
	  'khaki': [240, 230, 140, 1],
	  'lavender': [230, 230, 250, 1],
	  'lavenderblush': [255, 240, 245, 1],
	  'lawngreen': [124, 252, 0, 1],
	  'lemonchiffon': [255, 250, 205, 1],
	  'lightblue': [173, 216, 230, 1],
	  'lightcoral': [240, 128, 128, 1],
	  'lightcyan': [224, 255, 255, 1],
	  'lightgoldenrodyellow': [250, 250, 210, 1],
	  'lightgray': [211, 211, 211, 1],
	  'lightgreen': [144, 238, 144, 1],
	  'lightgrey': [211, 211, 211, 1],
	  'lightpink': [255, 182, 193, 1],
	  'lightsalmon': [255, 160, 122, 1],
	  'lightseagreen': [32, 178, 170, 1],
	  'lightskyblue': [135, 206, 250, 1],
	  'lightslategray': [119, 136, 153, 1],
	  'lightslategrey': [119, 136, 153, 1],
	  'lightsteelblue': [176, 196, 222, 1],
	  'lightyellow': [255, 255, 224, 1],
	  'lime': [0, 255, 0, 1],
	  'limegreen': [50, 205, 50, 1],
	  'linen': [250, 240, 230, 1],
	  'magenta': [255, 0, 255, 1],
	  'maroon': [128, 0, 0, 1],
	  'mediumaquamarine': [102, 205, 170, 1],
	  'mediumblue': [0, 0, 205, 1],
	  'mediumorchid': [186, 85, 211, 1],
	  'mediumpurple': [147, 112, 219, 1],
	  'mediumseagreen': [60, 179, 113, 1],
	  'mediumslateblue': [123, 104, 238, 1],
	  'mediumspringgreen': [0, 250, 154, 1],
	  'mediumturquoise': [72, 209, 204, 1],
	  'mediumvioletred': [199, 21, 133, 1],
	  'midnightblue': [25, 25, 112, 1],
	  'mintcream': [245, 255, 250, 1],
	  'mistyrose': [255, 228, 225, 1],
	  'moccasin': [255, 228, 181, 1],
	  'navajowhite': [255, 222, 173, 1],
	  'navy': [0, 0, 128, 1],
	  'oldlace': [253, 245, 230, 1],
	  'olive': [128, 128, 0, 1],
	  'olivedrab': [107, 142, 35, 1],
	  'orange': [255, 165, 0, 1],
	  'orangered': [255, 69, 0, 1],
	  'orchid': [218, 112, 214, 1],
	  'palegoldenrod': [238, 232, 170, 1],
	  'palegreen': [152, 251, 152, 1],
	  'paleturquoise': [175, 238, 238, 1],
	  'palevioletred': [219, 112, 147, 1],
	  'papayawhip': [255, 239, 213, 1],
	  'peachpuff': [255, 218, 185, 1],
	  'peru': [205, 133, 63, 1],
	  'pink': [255, 192, 203, 1],
	  'plum': [221, 160, 221, 1],
	  'powderblue': [176, 224, 230, 1],
	  'purple': [128, 0, 128, 1],
	  'red': [255, 0, 0, 1],
	  'rosybrown': [188, 143, 143, 1],
	  'royalblue': [65, 105, 225, 1],
	  'saddlebrown': [139, 69, 19, 1],
	  'salmon': [250, 128, 114, 1],
	  'sandybrown': [244, 164, 96, 1],
	  'seagreen': [46, 139, 87, 1],
	  'seashell': [255, 245, 238, 1],
	  'sienna': [160, 82, 45, 1],
	  'silver': [192, 192, 192, 1],
	  'skyblue': [135, 206, 235, 1],
	  'slateblue': [106, 90, 205, 1],
	  'slategray': [112, 128, 144, 1],
	  'slategrey': [112, 128, 144, 1],
	  'snow': [255, 250, 250, 1],
	  'springgreen': [0, 255, 127, 1],
	  'steelblue': [70, 130, 180, 1],
	  'tan': [210, 180, 140, 1],
	  'teal': [0, 128, 128, 1],
	  'thistle': [216, 191, 216, 1],
	  'tomato': [255, 99, 71, 1],
	  'turquoise': [64, 224, 208, 1],
	  'violet': [238, 130, 238, 1],
	  'wheat': [245, 222, 179, 1],
	  'white': [255, 255, 255, 1],
	  'whitesmoke': [245, 245, 245, 1],
	  'yellow': [255, 255, 0, 1],
	  'yellowgreen': [154, 205, 50, 1]
	};
	
	function clampCssByte(i) {
	  // Clamp to integer 0 .. 255.
	  i = Math.round(i); // Seems to be what Chrome does (vs truncation).
	
	  return i < 0 ? 0 : i > 255 ? 255 : i;
	}
	
	function clampCssAngle(i) {
	  // Clamp to integer 0 .. 360.
	  i = Math.round(i); // Seems to be what Chrome does (vs truncation).
	
	  return i < 0 ? 0 : i > 360 ? 360 : i;
	}
	
	function clampCssFloat(f) {
	  // Clamp to float 0.0 .. 1.0.
	  return f < 0 ? 0 : f > 1 ? 1 : f;
	}
	
	function parseCssInt(str) {
	  // int or percentage.
	  if (str.length && str.charAt(str.length - 1) === '%') {
	    return clampCssByte(parseFloat(str) / 100 * 255);
	  }
	
	  return clampCssByte(parseInt(str, 10));
	}
	
	function parseCssFloat(str) {
	  // float or percentage.
	  if (str.length && str.charAt(str.length - 1) === '%') {
	    return clampCssFloat(parseFloat(str) / 100);
	  }
	
	  return clampCssFloat(parseFloat(str));
	}
	
	function cssHueToRgb(m1, m2, h) {
	  if (h < 0) {
	    h += 1;
	  } else if (h > 1) {
	    h -= 1;
	  }
	
	  if (h * 6 < 1) {
	    return m1 + (m2 - m1) * h * 6;
	  }
	
	  if (h * 2 < 1) {
	    return m2;
	  }
	
	  if (h * 3 < 2) {
	    return m1 + (m2 - m1) * (2 / 3 - h) * 6;
	  }
	
	  return m1;
	}
	
	function lerpNumber(a, b, p) {
	  return a + (b - a) * p;
	}
	
	function setRgba(out, r, g, b, a) {
	  out[0] = r;
	  out[1] = g;
	  out[2] = b;
	  out[3] = a;
	  return out;
	}
	
	function copyRgba(out, a) {
	  out[0] = a[0];
	  out[1] = a[1];
	  out[2] = a[2];
	  out[3] = a[3];
	  return out;
	}
	
	var colorCache = new LRU(20);
	var lastRemovedArr = null;
	
	function putToCache(colorStr, rgbaArr) {
	  // Reuse removed array
	  if (lastRemovedArr) {
	    copyRgba(lastRemovedArr, rgbaArr);
	  }
	
	  lastRemovedArr = colorCache.put(colorStr, lastRemovedArr || rgbaArr.slice());
	}
	/**
	 * @param {string} colorStr
	 * @param {Array.<number>} out
	 * @return {Array.<number>}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function parse(colorStr, rgbaArr) {
	  if (!colorStr) {
	    return;
	  }
	
	  rgbaArr = rgbaArr || [];
	  var cached = colorCache.get(colorStr);
	
	  if (cached) {
	    return copyRgba(rgbaArr, cached);
	  } // colorStr may be not string
	
	
	  colorStr = colorStr + ''; // Remove all whitespace, not compliant, but should just be more accepting.
	
	  var str = colorStr.replace(/ /g, '').toLowerCase(); // Color keywords (and transparent) lookup.
	
	  if (str in kCSSColorTable) {
	    copyRgba(rgbaArr, kCSSColorTable[str]);
	    putToCache(colorStr, rgbaArr);
	    return rgbaArr;
	  } // #abc and #abc123 syntax.
	
	
	  if (str.charAt(0) === '#') {
	    if (str.length === 4) {
	      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.
	
	      if (!(iv >= 0 && iv <= 0xfff)) {
	        setRgba(rgbaArr, 0, 0, 0, 1);
	        return; // Covers NaN.
	      }
	
	      setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, 1);
	      putToCache(colorStr, rgbaArr);
	      return rgbaArr;
	    } else if (str.length === 7) {
	      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.
	
	      if (!(iv >= 0 && iv <= 0xffffff)) {
	        setRgba(rgbaArr, 0, 0, 0, 1);
	        return; // Covers NaN.
	      }
	
	      setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, 1);
	      putToCache(colorStr, rgbaArr);
	      return rgbaArr;
	    }
	
	    return;
	  }
	
	  var op = str.indexOf('('),
	      ep = str.indexOf(')');
	
	  if (op !== -1 && ep + 1 === str.length) {
	    var fname = str.substr(0, op);
	    var params = str.substr(op + 1, ep - (op + 1)).split(',');
	    var alpha = 1; // To allow case fallthrough.
	
	    switch (fname) {
	      case 'rgba':
	        if (params.length !== 4) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        alpha = parseCssFloat(params.pop());
	      // jshint ignore:line
	      // Fall through.
	
	      case 'rgb':
	        if (params.length !== 3) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        setRgba(rgbaArr, parseCssInt(params[0]), parseCssInt(params[1]), parseCssInt(params[2]), alpha);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      case 'hsla':
	        if (params.length !== 4) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        params[3] = parseCssFloat(params[3]);
	        hsla2rgba(params, rgbaArr);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      case 'hsl':
	        if (params.length !== 3) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        hsla2rgba(params, rgbaArr);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      default:
	        return;
	    }
	  }
	
	  setRgba(rgbaArr, 0, 0, 0, 1);
	  return;
	}
	/**
	 * @param {Array.<number>} hsla
	 * @param {Array.<number>} rgba
	 * @return {Array.<number>} rgba
	 */
	
	
	function hsla2rgba(hsla, rgba) {
	  var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360; // 0 .. 1
	  // NOTE(deanm): According to the CSS spec s/l should only be
	  // percentages, but we don't bother and let float or percentage.
	
	  var s = parseCssFloat(hsla[1]);
	  var l = parseCssFloat(hsla[2]);
	  var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
	  var m1 = l * 2 - m2;
	  rgba = rgba || [];
	  setRgba(rgba, clampCssByte(cssHueToRgb(m1, m2, h + 1 / 3) * 255), clampCssByte(cssHueToRgb(m1, m2, h) * 255), clampCssByte(cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
	
	  if (hsla.length === 4) {
	    rgba[3] = hsla[3];
	  }
	
	  return rgba;
	}
	/**
	 * @param {Array.<number>} rgba
	 * @return {Array.<number>} hsla
	 */
	
	
	function rgba2hsla(rgba) {
	  if (!rgba) {
	    return;
	  } // RGB from 0 to 255
	
	
	  var R = rgba[0] / 255;
	  var G = rgba[1] / 255;
	  var B = rgba[2] / 255;
	  var vMin = Math.min(R, G, B); // Min. value of RGB
	
	  var vMax = Math.max(R, G, B); // Max. value of RGB
	
	  var delta = vMax - vMin; // Delta RGB value
	
	  var L = (vMax + vMin) / 2;
	  var H;
	  var S; // HSL results from 0 to 1
	
	  if (delta === 0) {
	    H = 0;
	    S = 0;
	  } else {
	    if (L < 0.5) {
	      S = delta / (vMax + vMin);
	    } else {
	      S = delta / (2 - vMax - vMin);
	    }
	
	    var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
	    var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
	    var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
	
	    if (R === vMax) {
	      H = deltaB - deltaG;
	    } else if (G === vMax) {
	      H = 1 / 3 + deltaR - deltaB;
	    } else if (B === vMax) {
	      H = 2 / 3 + deltaG - deltaR;
	    }
	
	    if (H < 0) {
	      H += 1;
	    }
	
	    if (H > 1) {
	      H -= 1;
	    }
	  }
	
	  var hsla = [H * 360, S, L];
	
	  if (rgba[3] != null) {
	    hsla.push(rgba[3]);
	  }
	
	  return hsla;
	}
	/**
	 * @param {string} color
	 * @param {number} level
	 * @return {string}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function lift(color, level) {
	  var colorArr = parse(color);
	
	  if (colorArr) {
	    for (var i = 0; i < 3; i++) {
	      if (level < 0) {
	        colorArr[i] = colorArr[i] * (1 - level) | 0;
	      } else {
	        colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
	      }
	    }
	
	    return stringify(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
	  }
	}
	/**
	 * @param {string} color
	 * @return {string}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function toHex(color) {
	  var colorArr = parse(color);
	
	  if (colorArr) {
	    return ((1 << 24) + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
	  }
	}
	/**
	 * Map value to color. Faster than lerp methods because color is represented by rgba array.
	 * @param {number} normalizedValue A float between 0 and 1.
	 * @param {Array.<Array.<number>>} colors List of rgba color array
	 * @param {Array.<number>} [out] Mapped gba color array
	 * @return {Array.<number>} will be null/undefined if input illegal.
	 */
	
	
	function fastLerp(normalizedValue, colors, out) {
	  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
	    return;
	  }
	
	  out = out || [];
	  var value = normalizedValue * (colors.length - 1);
	  var leftIndex = Math.floor(value);
	  var rightIndex = Math.ceil(value);
	  var leftColor = colors[leftIndex];
	  var rightColor = colors[rightIndex];
	  var dv = value - leftIndex;
	  out[0] = clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv));
	  out[1] = clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv));
	  out[2] = clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv));
	  out[3] = clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv));
	  return out;
	}
	/**
	 * @deprecated
	 */
	
	
	var fastMapToColor = fastLerp;
	/**
	 * @param {number} normalizedValue A float between 0 and 1.
	 * @param {Array.<string>} colors Color list.
	 * @param {boolean=} fullOutput Default false.
	 * @return {(string|Object)} Result color. If fullOutput,
	 *                           return {color: ..., leftIndex: ..., rightIndex: ..., value: ...},
	 * @memberOf module:zrender/util/color
	 */
	
	function lerp(normalizedValue, colors, fullOutput) {
	  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
	    return;
	  }
	
	  var value = normalizedValue * (colors.length - 1);
	  var leftIndex = Math.floor(value);
	  var rightIndex = Math.ceil(value);
	  var leftColor = parse(colors[leftIndex]);
	  var rightColor = parse(colors[rightIndex]);
	  var dv = value - leftIndex;
	  var color = stringify([clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv)), clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv)), clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv)), clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv))], 'rgba');
	  return fullOutput ? {
	    color: color,
	    leftIndex: leftIndex,
	    rightIndex: rightIndex,
	    value: value
	  } : color;
	}
	/**
	 * @deprecated
	 */
	
	
	var mapToColor = lerp;
	/**
	 * @param {string} color
	 * @param {number=} h 0 ~ 360, ignore when null.
	 * @param {number=} s 0 ~ 1, ignore when null.
	 * @param {number=} l 0 ~ 1, ignore when null.
	 * @return {string} Color string in rgba format.
	 * @memberOf module:zrender/util/color
	 */
	
	function modifyHSL(color, h, s, l) {
	  color = parse(color);
	
	  if (color) {
	    color = rgba2hsla(color);
	    h != null && (color[0] = clampCssAngle(h));
	    s != null && (color[1] = parseCssFloat(s));
	    l != null && (color[2] = parseCssFloat(l));
	    return stringify(hsla2rgba(color), 'rgba');
	  }
	}
	/**
	 * @param {string} color
	 * @param {number=} alpha 0 ~ 1
	 * @return {string} Color string in rgba format.
	 * @memberOf module:zrender/util/color
	 */
	
	
	function modifyAlpha(color, alpha) {
	  color = parse(color);
	
	  if (color && alpha != null) {
	    color[3] = clampCssFloat(alpha);
	    return stringify(color, 'rgba');
	  }
	}
	/**
	 * @param {Array.<number>} arrColor like [12,33,44,0.4]
	 * @param {string} type 'rgba', 'hsva', ...
	 * @return {string} Result color. (If input illegal, return undefined).
	 */
	
	
	function stringify(arrColor, type) {
	  if (!arrColor || !arrColor.length) {
	    return;
	  }
	
	  var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
	
	  if (type === 'rgba' || type === 'hsva' || type === 'hsla') {
	    colorStr += ',' + arrColor[3];
	  }
	
	  return type + '(' + colorStr + ')';
	}
	
	exports.parse = parse;
	exports.lift = lift;
	exports.toHex = toHex;
	exports.fastLerp = fastLerp;
	exports.fastMapToColor = fastMapToColor;
	exports.lerp = lerp;
	exports.mapToColor = mapToColor;
	exports.modifyHSL = modifyHSL;
	exports.modifyAlpha = modifyAlpha;
	exports.stringify = stringify;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(109)('wks');
	var uid = __webpack_require__(82);
	var Symbol = __webpack_require__(32).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(1);
	
	var List = __webpack_require__(15);
	
	var completeDimensions = __webpack_require__(25);
	
	var _model = __webpack_require__(6);
	
	var getDataItemValue = _model.getDataItemValue;
	var converDataValue = _model.converDataValue;
	var isDataItemOption = _model.isDataItemOption;
	
	var CoordinateSystem = __webpack_require__(26);
	
	function firstDataNotNull(data) {
	  var i = 0;
	
	  while (i < data.length && data[i] == null) {
	    i++;
	  }
	
	  return data[i];
	}
	
	function ifNeedCompleteOrdinalData(data) {
	  var sampleItem = firstDataNotNull(data);
	  return sampleItem != null && !zrUtil.isArray(getDataItemValue(sampleItem));
	}
	/**
	 * Helper function to create a list from option data
	 */
	
	
	function createListFromArray(data, seriesModel, ecModel) {
	  // If data is undefined
	  data = data || [];
	  var coordSysName = seriesModel.get('coordinateSystem');
	  var creator = creators[coordSysName];
	  var registeredCoordSys = CoordinateSystem.get(coordSysName);
	  var completeDimOpt = {
	    encodeDef: seriesModel.get('encode'),
	    dimsDef: seriesModel.get('dimensions')
	  }; // FIXME
	
	  var axesInfo = creator && creator(data, seriesModel, ecModel, completeDimOpt);
	  var dimensions = axesInfo && axesInfo.dimensions;
	
	  if (!dimensions) {
	    // Get dimensions from registered coordinate system
	    dimensions = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || ['x', 'y'];
	    dimensions = completeDimensions(dimensions, data, completeDimOpt);
	  }
	
	  var categoryIndex = axesInfo ? axesInfo.categoryIndex : -1;
	  var list = new List(dimensions, seriesModel);
	  var nameList = createNameList(axesInfo, data);
	  var categories = {};
	  var dimValueGetter = categoryIndex >= 0 && ifNeedCompleteOrdinalData(data) ? function (itemOpt, dimName, dataIndex, dimIndex) {
	    // If any dataItem is like { value: 10 }
	    if (isDataItemOption(itemOpt)) {
	      list.hasItemOption = true;
	    } // Use dataIndex as ordinal value in categoryAxis
	
	
	    return dimIndex === categoryIndex ? dataIndex : converDataValue(getDataItemValue(itemOpt), dimensions[dimIndex]);
	  } : function (itemOpt, dimName, dataIndex, dimIndex) {
	    var value = getDataItemValue(itemOpt);
	    var val = converDataValue(value && value[dimIndex], dimensions[dimIndex]); // If any dataItem is like { value: 10 }
	
	    if (isDataItemOption(itemOpt)) {
	      list.hasItemOption = true;
	    }
	
	    var categoryAxesModels = axesInfo && axesInfo.categoryAxesModels;
	
	    if (categoryAxesModels && categoryAxesModels[dimName]) {
	      // If given value is a category string
	      if (typeof val === 'string') {
	        // Lazy get categories
	        categories[dimName] = categories[dimName] || categoryAxesModels[dimName].getCategories();
	        val = zrUtil.indexOf(categories[dimName], val);
	
	        if (val < 0 && !isNaN(val)) {
	          // In case some one write '1', '2' istead of 1, 2
	          val = +val;
	        }
	      }
	    }
	
	    return val;
	  };
	  list.hasItemOption = false;
	  list.initData(data, nameList, dimValueGetter);
	  return list;
	}
	
	function isStackable(axisType) {
	  return axisType !== 'category' && axisType !== 'time';
	}
	
	function getDimTypeByAxis(axisType) {
	  return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
	}
	/**
	 * Creaters for each coord system.
	 */
	
	
	var creators = {
	  cartesian2d: function (data, seriesModel, ecModel, completeDimOpt) {
	    var axesModels = zrUtil.map(['xAxis', 'yAxis'], function (name) {
	      return ecModel.queryComponents({
	        mainType: name,
	        index: seriesModel.get(name + 'Index'),
	        id: seriesModel.get(name + 'Id')
	      })[0];
	    });
	    var xAxisModel = axesModels[0];
	    var yAxisModel = axesModels[1];
	    var xAxisType = xAxisModel.get('type');
	    var yAxisType = yAxisModel.get('type');
	    var dimensions = [{
	      name: 'x',
	      type: getDimTypeByAxis(xAxisType),
	      stackable: isStackable(xAxisType)
	    }, {
	      name: 'y',
	      // If two category axes
	      type: getDimTypeByAxis(yAxisType),
	      stackable: isStackable(yAxisType)
	    }];
	    var isXAxisCateogry = xAxisType === 'category';
	    var isYAxisCategory = yAxisType === 'category';
	    dimensions = completeDimensions(dimensions, data, completeDimOpt);
	    var categoryAxesModels = {};
	
	    if (isXAxisCateogry) {
	      categoryAxesModels.x = xAxisModel;
	    }
	
	    if (isYAxisCategory) {
	      categoryAxesModels.y = yAxisModel;
	    }
	
	    return {
	      dimensions: dimensions,
	      categoryIndex: isXAxisCateogry ? 0 : isYAxisCategory ? 1 : -1,
	      categoryAxesModels: categoryAxesModels
	    };
	  },
	  singleAxis: function (data, seriesModel, ecModel, completeDimOpt) {
	    var singleAxisModel = ecModel.queryComponents({
	      mainType: 'singleAxis',
	      index: seriesModel.get('singleAxisIndex'),
	      id: seriesModel.get('singleAxisId')
	    })[0];
	    var singleAxisType = singleAxisModel.get('type');
	    var isCategory = singleAxisType === 'category';
	    var dimensions = [{
	      name: 'single',
	      type: getDimTypeByAxis(singleAxisType),
	      stackable: isStackable(singleAxisType)
	    }];
	    dimensions = completeDimensions(dimensions, data, completeDimOpt);
	    var categoryAxesModels = {};
	
	    if (isCategory) {
	      categoryAxesModels.single = singleAxisModel;
	    }
	
	    return {
	      dimensions: dimensions,
	      categoryIndex: isCategory ? 0 : -1,
	      categoryAxesModels: categoryAxesModels
	    };
	  },
	  polar: function (data, seriesModel, ecModel, completeDimOpt) {
	    var polarModel = ecModel.queryComponents({
	      mainType: 'polar',
	      index: seriesModel.get('polarIndex'),
	      id: seriesModel.get('polarId')
	    })[0];
	    var angleAxisModel = polarModel.findAxisModel('angleAxis');
	    var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
	    var radiusAxisType = radiusAxisModel.get('type');
	    var angleAxisType = angleAxisModel.get('type');
	    var dimensions = [{
	      name: 'radius',
	      type: getDimTypeByAxis(radiusAxisType),
	      stackable: isStackable(radiusAxisType)
	    }, {
	      name: 'angle',
	      type: getDimTypeByAxis(angleAxisType),
	      stackable: isStackable(angleAxisType)
	    }];
	    var isAngleAxisCateogry = angleAxisType === 'category';
	    var isRadiusAxisCateogry = radiusAxisType === 'category';
	    dimensions = completeDimensions(dimensions, data, completeDimOpt);
	    var categoryAxesModels = {};
	
	    if (isRadiusAxisCateogry) {
	      categoryAxesModels.radius = radiusAxisModel;
	    }
	
	    if (isAngleAxisCateogry) {
	      categoryAxesModels.angle = angleAxisModel;
	    }
	
	    return {
	      dimensions: dimensions,
	      categoryIndex: isAngleAxisCateogry ? 1 : isRadiusAxisCateogry ? 0 : -1,
	      categoryAxesModels: categoryAxesModels
	    };
	  },
	  geo: function (data, seriesModel, ecModel, completeDimOpt) {
	    // TODO Region
	    // 多个散点图系列在同一个地区的时候
	    return {
	      dimensions: completeDimensions([{
	        name: 'lng'
	      }, {
	        name: 'lat'
	      }], data, completeDimOpt)
	    };
	  }
	};
	
	function createNameList(result, data) {
	  var nameList = [];
	  var categoryDim = result && result.dimensions[result.categoryIndex];
	  var categoryAxisModel;
	
	  if (categoryDim) {
	    categoryAxisModel = result.categoryAxesModels[categoryDim.name];
	  }
	
	  if (categoryAxisModel) {
	    // FIXME Two category axis
	    var categories = categoryAxisModel.getCategories();
	
	    if (categories) {
	      var dataLen = data.length; // Ordered data is given explicitly like
	      // [[3, 0.2], [1, 0.3], [2, 0.15]]
	      // or given scatter data,
	      // pick the category
	
	      if (zrUtil.isArray(data[0]) && data[0].length > 1) {
	        nameList = [];
	
	        for (var i = 0; i < dataLen; i++) {
	          nameList[i] = categories[data[i][result.categoryIndex || 0]];
	        }
	      } else {
	        nameList = categories.slice(0);
	      }
	    }
	  }
	
	  return nameList;
	}
	
	var _default = createListFromArray;
	module.exports = _default;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	var features = {};
	
	function register(name, ctor) {
	  features[name] = ctor;
	}
	
	function get(name) {
	  return features[name];
	}
	
	exports.register = register;
	exports.get = get;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var numberUtil = __webpack_require__(4);
	
	var axisHelper = __webpack_require__(21);
	
	var linearMap = numberUtil.linearMap;
	
	function fixExtentWithBands(extent, nTick) {
	  var size = extent[1] - extent[0];
	  var len = nTick;
	  var margin = size / len / 2;
	  extent[0] += margin;
	  extent[1] -= margin;
	}
	
	var normalizedExtent = [0, 1];
	/**
	 * @name module:echarts/coord/CartesianAxis
	 * @constructor
	 */
	
	var Axis = function (dim, scale, extent) {
	  /**
	   * Axis dimension. Such as 'x', 'y', 'z', 'angle', 'radius'
	   * @type {string}
	   */
	  this.dim = dim;
	  /**
	   * Axis scale
	   * @type {module:echarts/coord/scale/*}
	   */
	
	  this.scale = scale;
	  /**
	   * @type {Array.<number>}
	   * @private
	   */
	
	  this._extent = extent || [0, 0];
	  /**
	   * @type {boolean}
	   */
	
	  this.inverse = false;
	  /**
	   * Usually true when axis has a ordinal scale
	   * @type {boolean}
	   */
	
	  this.onBand = false;
	  /**
	   * @private
	   * @type {number}
	   */
	
	  this._labelInterval;
	};
	
	Axis.prototype = {
	  constructor: Axis,
	
	  /**
	   * If axis extent contain given coord
	   * @param {number} coord
	   * @return {boolean}
	   */
	  contain: function (coord) {
	    var extent = this._extent;
	    var min = Math.min(extent[0], extent[1]);
	    var max = Math.max(extent[0], extent[1]);
	    return coord >= min && coord <= max;
	  },
	
	  /**
	   * If axis extent contain given data
	   * @param {number} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this.contain(this.dataToCoord(data));
	  },
	
	  /**
	   * Get coord extent.
	   * @return {Array.<number>}
	   */
	  getExtent: function () {
	    return this._extent.slice();
	  },
	
	  /**
	   * Get precision used for formatting
	   * @param {Array.<number>} [dataExtent]
	   * @return {number}
	   */
	  getPixelPrecision: function (dataExtent) {
	    return numberUtil.getPixelPrecision(dataExtent || this.scale.getExtent(), this._extent);
	  },
	
	  /**
	   * Set coord extent
	   * @param {number} start
	   * @param {number} end
	   */
	  setExtent: function (start, end) {
	    var extent = this._extent;
	    extent[0] = start;
	    extent[1] = end;
	  },
	
	  /**
	   * Convert data to coord. Data is the rank if it has a ordinal scale
	   * @param {number} data
	   * @param  {boolean} clamp
	   * @return {number}
	   */
	  dataToCoord: function (data, clamp) {
	    var extent = this._extent;
	    var scale = this.scale;
	    data = scale.normalize(data);
	
	    if (this.onBand && scale.type === 'ordinal') {
	      extent = extent.slice();
	      fixExtentWithBands(extent, scale.count());
	    }
	
	    return linearMap(data, normalizedExtent, extent, clamp);
	  },
	
	  /**
	   * Convert coord to data. Data is the rank if it has a ordinal scale
	   * @param {number} coord
	   * @param  {boolean} clamp
	   * @return {number}
	   */
	  coordToData: function (coord, clamp) {
	    var extent = this._extent;
	    var scale = this.scale;
	
	    if (this.onBand && scale.type === 'ordinal') {
	      extent = extent.slice();
	      fixExtentWithBands(extent, scale.count());
	    }
	
	    var t = linearMap(coord, extent, normalizedExtent, clamp);
	    return this.scale.scale(t);
	  },
	
	  /**
	   * Convert pixel point to data in axis
	   * @param {Array.<number>} point
	   * @param  {boolean} clamp
	   * @return {number} data
	   */
	  pointToData: function (point, clamp) {// Should be implemented in derived class if necessary.
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getTicksCoords: function (alignWithLabel) {
	    if (this.onBand && !alignWithLabel) {
	      var bands = this.getBands();
	      var coords = [];
	
	      for (var i = 0; i < bands.length; i++) {
	        coords.push(bands[i][0]);
	      }
	
	      if (bands[i - 1]) {
	        coords.push(bands[i - 1][1]);
	      }
	
	      return coords;
	    } else {
	      return zrUtil.map(this.scale.getTicks(), this.dataToCoord, this);
	    }
	  },
	
	  /**
	   * Coords of labels are on the ticks or on the middle of bands
	   * @return {Array.<number>}
	   */
	  getLabelsCoords: function () {
	    return zrUtil.map(this.scale.getTicks(), this.dataToCoord, this);
	  },
	
	  /**
	   * Get bands.
	   *
	   * If axis has labels [1, 2, 3, 4]. Bands on the axis are
	   * |---1---|---2---|---3---|---4---|.
	   *
	   * @return {Array}
	   */
	  // FIXME Situation when labels is on ticks
	  getBands: function () {
	    var extent = this.getExtent();
	    var bands = [];
	    var len = this.scale.count();
	    var start = extent[0];
	    var end = extent[1];
	    var span = end - start;
	
	    for (var i = 0; i < len; i++) {
	      bands.push([span * i / len + start, span * (i + 1) / len + start]);
	    }
	
	    return bands;
	  },
	
	  /**
	   * Get width of band
	   * @return {number}
	   */
	  getBandWidth: function () {
	    var axisExtent = this._extent;
	    var dataExtent = this.scale.getExtent();
	    var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.
	
	    len === 0 && (len = 1);
	    var size = Math.abs(axisExtent[1] - axisExtent[0]);
	    return Math.abs(size) / len;
	  },
	
	  /**
	   * @abstract
	   * @return {boolean} Is horizontal
	   */
	  isHorizontal: null,
	
	  /**
	   * @abstract
	   * @return {number} Get axis rotate, by degree.
	   */
	  getRotate: null,
	
	  /**
	   * Get interval of the axis label.
	   * To get precise result, at least one of `getRotate` and `isHorizontal`
	   * should be implemented.
	   * @return {number}
	   */
	  getLabelInterval: function () {
	    var labelInterval = this._labelInterval;
	
	    if (!labelInterval) {
	      var axisModel = this.model;
	      var labelModel = axisModel.getModel('axisLabel');
	      labelInterval = labelModel.get('interval');
	
	      if (this.type === 'category' && (labelInterval == null || labelInterval === 'auto')) {
	        labelInterval = axisHelper.getAxisLabelInterval(zrUtil.map(this.scale.getTicks(), this.dataToCoord, this), axisModel.getFormattedLabels(), labelModel.getFont(), this.getRotate ? this.getRotate() : this.isHorizontal && !this.isHorizontal() ? 90 : 0, labelModel.get('rotate'));
	      }
	
	      this._labelInterval = labelInterval;
	    }
	
	    return labelInterval;
	  }
	};
	var _default = Axis;
	module.exports = _default;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Group = __webpack_require__(97);
	
	var componentUtil = __webpack_require__(130);
	
	var clazzUtil = __webpack_require__(28);
	
	var modelUtil = __webpack_require__(6);
	
	function Chart() {
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	  this.group = new Group();
	  /**
	   * @type {string}
	   * @readOnly
	   */
	
	  this.uid = componentUtil.getUID('viewChart');
	}
	
	Chart.prototype = {
	  type: 'chart',
	
	  /**
	   * Init the chart
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  init: function (ecModel, api) {},
	
	  /**
	   * Render the chart
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  render: function (seriesModel, ecModel, api, payload) {},
	
	  /**
	   * Highlight series or specified data item
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  highlight: function (seriesModel, ecModel, api, payload) {
	    toggleHighlight(seriesModel.getData(), payload, 'emphasis');
	  },
	
	  /**
	   * Downplay series or specified data item
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  downplay: function (seriesModel, ecModel, api, payload) {
	    toggleHighlight(seriesModel.getData(), payload, 'normal');
	  },
	
	  /**
	   * Remove self
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  remove: function (ecModel, api) {
	    this.group.removeAll();
	  },
	
	  /**
	   * Dispose self
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  dispose: function () {}
	  /**
	   * The view contains the given point.
	   * @interface
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  // containPoint: function () {}
	
	};
	var chartProto = Chart.prototype;
	
	chartProto.updateView = chartProto.updateLayout = chartProto.updateVisual = function (seriesModel, ecModel, api, payload) {
	  this.render(seriesModel, ecModel, api, payload);
	};
	/**
	 * Set state of single element
	 * @param  {module:zrender/Element} el
	 * @param  {string} state
	 */
	
	
	function elSetState(el, state) {
	  if (el) {
	    el.trigger(state);
	
	    if (el.type === 'group') {
	      for (var i = 0; i < el.childCount(); i++) {
	        elSetState(el.childAt(i), state);
	      }
	    }
	  }
	}
	/**
	 * @param  {module:echarts/data/List} data
	 * @param  {Object} payload
	 * @param  {string} state 'normal'|'emphasis'
	 * @inner
	 */
	
	
	function toggleHighlight(data, payload, state) {
	  var dataIndex = modelUtil.queryDataIndex(data, payload);
	
	  if (dataIndex != null) {
	    zrUtil.each(modelUtil.normalizeToArray(dataIndex), function (dataIdx) {
	      elSetState(data.getItemGraphicEl(dataIdx), state);
	    });
	  } else {
	    data.eachItemGraphicEl(function (el) {
	      elSetState(el, state);
	    });
	  }
	} // Enable Chart.extend.
	
	
	clazzUtil.enableClassExtend(Chart, ['dispose']); // Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	clazzUtil.enableClassManagement(Chart, {
	  registerWhenExtend: true
	});
	var _default = Chart;
	module.exports = _default;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Fizzy UI utils v2.0.7
	 * MIT license
	 */
	
	/*jshint browser: true, undef: true, unused: true, strict: true */
	
	( function( window, factory ) {
	  // universal module definition
	  /*jshint strict: false */ /*globals define, module, require */
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(339)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( matchesSelector ) {
	      return factory( window, matchesSelector );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('desandro-matches-selector')
	    );
	  } else {
	    // browser global
	    window.fizzyUIUtils = factory(
	      window,
	      window.matchesSelector
	    );
	  }
	
	}( window, function factory( window, matchesSelector ) {
	
	'use strict';
	
	var utils = {};
	
	// ----- extend ----- //
	
	// extends objects
	utils.extend = function( a, b ) {
	  for ( var prop in b ) {
	    a[ prop ] = b[ prop ];
	  }
	  return a;
	};
	
	// ----- modulo ----- //
	
	utils.modulo = function( num, div ) {
	  return ( ( num % div ) + div ) % div;
	};
	
	// ----- makeArray ----- //
	
	var arraySlice = Array.prototype.slice;
	
	// turn element or nodeList into an array
	utils.makeArray = function( obj ) {
	  if ( Array.isArray( obj ) ) {
	    // use object if already an array
	    return obj;
	  }
	  // return empty array if undefined or null. #6
	  if ( obj === null || obj === undefined ) {
	    return [];
	  }
	
	  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
	  if ( isArrayLike ) {
	    // convert nodeList to array
	    return arraySlice.call( obj );
	  }
	
	  // array of single index
	  return [ obj ];
	};
	
	// ----- removeFrom ----- //
	
	utils.removeFrom = function( ary, obj ) {
	  var index = ary.indexOf( obj );
	  if ( index != -1 ) {
	    ary.splice( index, 1 );
	  }
	};
	
	// ----- getParent ----- //
	
	utils.getParent = function( elem, selector ) {
	  while ( elem.parentNode && elem != document.body ) {
	    elem = elem.parentNode;
	    if ( matchesSelector( elem, selector ) ) {
	      return elem;
	    }
	  }
	};
	
	// ----- getQueryElement ----- //
	
	// use element as selector string
	utils.getQueryElement = function( elem ) {
	  if ( typeof elem == 'string' ) {
	    return document.querySelector( elem );
	  }
	  return elem;
	};
	
	// ----- handleEvent ----- //
	
	// enable .ontype to trigger from .addEventListener( elem, 'type' )
	utils.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	// ----- filterFindElements ----- //
	
	utils.filterFindElements = function( elems, selector ) {
	  // make array of elems
	  elems = utils.makeArray( elems );
	  var ffElems = [];
	
	  elems.forEach( function( elem ) {
	    // check that elem is an actual element
	    if ( !( elem instanceof HTMLElement ) ) {
	      return;
	    }
	    // add elem if no selector
	    if ( !selector ) {
	      ffElems.push( elem );
	      return;
	    }
	    // filter & find items if we have a selector
	    // filter
	    if ( matchesSelector( elem, selector ) ) {
	      ffElems.push( elem );
	    }
	    // find children
	    var childElems = elem.querySelectorAll( selector );
	    // concat childElems to filterFound array
	    for ( var i=0; i < childElems.length; i++ ) {
	      ffElems.push( childElems[i] );
	    }
	  });
	
	  return ffElems;
	};
	
	// ----- debounceMethod ----- //
	
	utils.debounceMethod = function( _class, methodName, threshold ) {
	  threshold = threshold || 100;
	  // original method
	  var method = _class.prototype[ methodName ];
	  var timeoutName = methodName + 'Timeout';
	
	  _class.prototype[ methodName ] = function() {
	    var timeout = this[ timeoutName ];
	    clearTimeout( timeout );
	
	    var args = arguments;
	    var _this = this;
	    this[ timeoutName ] = setTimeout( function() {
	      method.apply( _this, args );
	      delete _this[ timeoutName ];
	    }, threshold );
	  };
	};
	
	// ----- docReady ----- //
	
	utils.docReady = function( callback ) {
	  var readyState = document.readyState;
	  if ( readyState == 'complete' || readyState == 'interactive' ) {
	    // do async to allow for other scripts to run. metafizzy/flickity#441
	    setTimeout( callback );
	  } else {
	    document.addEventListener( 'DOMContentLoaded', callback );
	  }
	};
	
	// ----- htmlInit ----- //
	
	// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
	utils.toDashed = function( str ) {
	  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
	    return $1 + '-' + $2;
	  }).toLowerCase();
	};
	
	var console = window.console;
	/**
	 * allow user to initialize classes via [data-namespace] or .js-namespace class
	 * htmlInit( Widget, 'widgetName' )
	 * options are parsed from data-namespace-options
	 */
	utils.htmlInit = function( WidgetClass, namespace ) {
	  utils.docReady( function() {
	    var dashedNamespace = utils.toDashed( namespace );
	    var dataAttr = 'data-' + dashedNamespace;
	    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
	    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
	    var elems = utils.makeArray( dataAttrElems )
	      .concat( utils.makeArray( jsDashElems ) );
	    var dataOptionsAttr = dataAttr + '-options';
	    var jQuery = window.jQuery;
	
	    elems.forEach( function( elem ) {
	      var attr = elem.getAttribute( dataAttr ) ||
	        elem.getAttribute( dataOptionsAttr );
	      var options;
	      try {
	        options = attr && JSON.parse( attr );
	      } catch ( error ) {
	        // log error, do not initialize
	        if ( console ) {
	          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
	          ': ' + error );
	        }
	        return;
	      }
	      // initialize
	      var instance = new WidgetClass( elem, options );
	      // make available via $().data('namespace')
	      if ( jQuery ) {
	        jQuery.data( elem, namespace, instance );
	      }
	    });
	
	  });
	};
	
	// -----  ----- //
	
	return utils;
	
	}));


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(713)
	__vue_script__ = __webpack_require__(237)
	__vue_template__ = __webpack_require__(638)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(8);
	
	var v2Create = _vector.create;
	var v2DistSquare = _vector.distSquare;
	
	/**
	 * 曲线辅助模块
	 * @module zrender/core/curve
	 * @author pissang(https://www.github.com/pissang)
	 */
	var mathPow = Math.pow;
	var mathSqrt = Math.sqrt;
	var EPSILON = 1e-8;
	var EPSILON_NUMERIC = 1e-4;
	var THREE_SQRT = mathSqrt(3);
	var ONE_THIRD = 1 / 3; // 临时变量
	
	var _v0 = v2Create();
	
	var _v1 = v2Create();
	
	var _v2 = v2Create();
	
	function isAroundZero(val) {
	  return val > -EPSILON && val < EPSILON;
	}
	
	function isNotAroundZero(val) {
	  return val > EPSILON || val < -EPSILON;
	}
	/**
	 * 计算三次贝塞尔值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function cubicAt(p0, p1, p2, p3, t) {
	  var onet = 1 - t;
	  return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
	}
	/**
	 * 计算三次贝塞尔导数值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function cubicDerivativeAt(p0, p1, p2, p3, t) {
	  var onet = 1 - t;
	  return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
	}
	/**
	 * 计算三次贝塞尔方程根，使用盛金公式
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} val
	 * @param  {Array.<number>} roots
	 * @return {number} 有效根数目
	 */
	
	
	function cubicRootAt(p0, p1, p2, p3, val, roots) {
	  // Evaluate roots of cubic functions
	  var a = p3 + 3 * (p1 - p2) - p0;
	  var b = 3 * (p2 - p1 * 2 + p0);
	  var c = 3 * (p1 - p0);
	  var d = p0 - val;
	  var A = b * b - 3 * a * c;
	  var B = b * c - 9 * a * d;
	  var C = c * c - 3 * b * d;
	  var n = 0;
	
	  if (isAroundZero(A) && isAroundZero(B)) {
	    if (isAroundZero(b)) {
	      roots[0] = 0;
	    } else {
	      var t1 = -c / b; //t1, t2, t3, b is not zero
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    }
	  } else {
	    var disc = B * B - 4 * A * C;
	
	    if (isAroundZero(disc)) {
	      var K = B / A;
	      var t1 = -b / a + K; // t1, a is not zero
	
	      var t2 = -K / 2; // t2, t3
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var Y1 = A * b + 1.5 * a * (-B + discSqrt);
	      var Y2 = A * b + 1.5 * a * (-B - discSqrt);
	
	      if (Y1 < 0) {
	        Y1 = -mathPow(-Y1, ONE_THIRD);
	      } else {
	        Y1 = mathPow(Y1, ONE_THIRD);
	      }
	
	      if (Y2 < 0) {
	        Y2 = -mathPow(-Y2, ONE_THIRD);
	      } else {
	        Y2 = mathPow(Y2, ONE_THIRD);
	      }
	
	      var t1 = (-b - (Y1 + Y2)) / (3 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    } else {
	      var T = (2 * A * b - 3 * a * B) / (2 * mathSqrt(A * A * A));
	      var theta = Math.acos(T) / 3;
	      var ASqrt = mathSqrt(A);
	      var tmp = Math.cos(theta);
	      var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
	      var t2 = (-b + ASqrt * (tmp + THREE_SQRT * Math.sin(theta))) / (3 * a);
	      var t3 = (-b + ASqrt * (tmp - THREE_SQRT * Math.sin(theta))) / (3 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	
	      if (t3 >= 0 && t3 <= 1) {
	        roots[n++] = t3;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 计算三次贝塞尔方程极限值的位置
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {Array.<number>} extrema
	 * @return {number} 有效数目
	 */
	
	
	function cubicExtrema(p0, p1, p2, p3, extrema) {
	  var b = 6 * p2 - 12 * p1 + 6 * p0;
	  var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
	  var c = 3 * p1 - 3 * p0;
	  var n = 0;
	
	  if (isAroundZero(a)) {
	    if (isNotAroundZero(b)) {
	      var t1 = -c / b;
	
	      if (t1 >= 0 && t1 <= 1) {
	        extrema[n++] = t1;
	      }
	    }
	  } else {
	    var disc = b * b - 4 * a * c;
	
	    if (isAroundZero(disc)) {
	      extrema[0] = -b / (2 * a);
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var t1 = (-b + discSqrt) / (2 * a);
	      var t2 = (-b - discSqrt) / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        extrema[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        extrema[n++] = t2;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 细分三次贝塞尔曲线
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @param  {Array.<number>} out
	 */
	
	
	function cubicSubdivide(p0, p1, p2, p3, t, out) {
	  var p01 = (p1 - p0) * t + p0;
	  var p12 = (p2 - p1) * t + p1;
	  var p23 = (p3 - p2) * t + p2;
	  var p012 = (p12 - p01) * t + p01;
	  var p123 = (p23 - p12) * t + p12;
	  var p0123 = (p123 - p012) * t + p012; // Seg0
	
	  out[0] = p0;
	  out[1] = p01;
	  out[2] = p012;
	  out[3] = p0123; // Seg1
	
	  out[4] = p0123;
	  out[5] = p123;
	  out[6] = p23;
	  out[7] = p3;
	}
	/**
	 * 投射点到三次贝塞尔曲线上，返回投射距离。
	 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x3
	 * @param {number} y3
	 * @param {number} x
	 * @param {number} y
	 * @param {Array.<number>} [out] 投射点
	 * @return {number}
	 */
	
	
	function cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
	  // http://pomax.github.io/bezierinfo/#projections
	  var t;
	  var interval = 0.005;
	  var d = Infinity;
	  var prev;
	  var next;
	  var d1;
	  var d2;
	  _v0[0] = x;
	  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
	  // PENDING
	
	  for (var _t = 0; _t < 1; _t += 0.05) {
	    _v1[0] = cubicAt(x0, x1, x2, x3, _t);
	    _v1[1] = cubicAt(y0, y1, y2, y3, _t);
	    d1 = v2DistSquare(_v0, _v1);
	
	    if (d1 < d) {
	      t = _t;
	      d = d1;
	    }
	  }
	
	  d = Infinity; // At most 32 iteration
	
	  for (var i = 0; i < 32; i++) {
	    if (interval < EPSILON_NUMERIC) {
	      break;
	    }
	
	    prev = t - interval;
	    next = t + interval; // t - interval
	
	    _v1[0] = cubicAt(x0, x1, x2, x3, prev);
	    _v1[1] = cubicAt(y0, y1, y2, y3, prev);
	    d1 = v2DistSquare(_v1, _v0);
	
	    if (prev >= 0 && d1 < d) {
	      t = prev;
	      d = d1;
	    } else {
	      // t + interval
	      _v2[0] = cubicAt(x0, x1, x2, x3, next);
	      _v2[1] = cubicAt(y0, y1, y2, y3, next);
	      d2 = v2DistSquare(_v2, _v0);
	
	      if (next <= 1 && d2 < d) {
	        t = next;
	        d = d2;
	      } else {
	        interval *= 0.5;
	      }
	    }
	  } // t
	
	
	  if (out) {
	    out[0] = cubicAt(x0, x1, x2, x3, t);
	    out[1] = cubicAt(y0, y1, y2, y3, t);
	  } // console.log(interval, i);
	
	
	  return mathSqrt(d);
	}
	/**
	 * 计算二次方贝塞尔值
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function quadraticAt(p0, p1, p2, t) {
	  var onet = 1 - t;
	  return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
	}
	/**
	 * 计算二次方贝塞尔导数值
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function quadraticDerivativeAt(p0, p1, p2, t) {
	  return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
	}
	/**
	 * 计算二次方贝塞尔方程根
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @param  {Array.<number>} roots
	 * @return {number} 有效根数目
	 */
	
	
	function quadraticRootAt(p0, p1, p2, val, roots) {
	  var a = p0 - 2 * p1 + p2;
	  var b = 2 * (p1 - p0);
	  var c = p0 - val;
	  var n = 0;
	
	  if (isAroundZero(a)) {
	    if (isNotAroundZero(b)) {
	      var t1 = -c / b;
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    }
	  } else {
	    var disc = b * b - 4 * a * c;
	
	    if (isAroundZero(disc)) {
	      var t1 = -b / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var t1 = (-b + discSqrt) / (2 * a);
	      var t2 = (-b - discSqrt) / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 计算二次贝塞尔方程极限值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @return {number}
	 */
	
	
	function quadraticExtremum(p0, p1, p2) {
	  var divider = p0 + p2 - 2 * p1;
	
	  if (divider === 0) {
	    // p1 is center of p0 and p2
	    return 0.5;
	  } else {
	    return (p0 - p1) / divider;
	  }
	}
	/**
	 * 细分二次贝塞尔曲线
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @param  {Array.<number>} out
	 */
	
	
	function quadraticSubdivide(p0, p1, p2, t, out) {
	  var p01 = (p1 - p0) * t + p0;
	  var p12 = (p2 - p1) * t + p1;
	  var p012 = (p12 - p01) * t + p01; // Seg0
	
	  out[0] = p0;
	  out[1] = p01;
	  out[2] = p012; // Seg1
	
	  out[3] = p012;
	  out[4] = p12;
	  out[5] = p2;
	}
	/**
	 * 投射点到二次贝塞尔曲线上，返回投射距离。
	 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x
	 * @param {number} y
	 * @param {Array.<number>} out 投射点
	 * @return {number}
	 */
	
	
	function quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, out) {
	  // http://pomax.github.io/bezierinfo/#projections
	  var t;
	  var interval = 0.005;
	  var d = Infinity;
	  _v0[0] = x;
	  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
	  // PENDING
	
	  for (var _t = 0; _t < 1; _t += 0.05) {
	    _v1[0] = quadraticAt(x0, x1, x2, _t);
	    _v1[1] = quadraticAt(y0, y1, y2, _t);
	    var d1 = v2DistSquare(_v0, _v1);
	
	    if (d1 < d) {
	      t = _t;
	      d = d1;
	    }
	  }
	
	  d = Infinity; // At most 32 iteration
	
	  for (var i = 0; i < 32; i++) {
	    if (interval < EPSILON_NUMERIC) {
	      break;
	    }
	
	    var prev = t - interval;
	    var next = t + interval; // t - interval
	
	    _v1[0] = quadraticAt(x0, x1, x2, prev);
	    _v1[1] = quadraticAt(y0, y1, y2, prev);
	    var d1 = v2DistSquare(_v1, _v0);
	
	    if (prev >= 0 && d1 < d) {
	      t = prev;
	      d = d1;
	    } else {
	      // t + interval
	      _v2[0] = quadraticAt(x0, x1, x2, next);
	      _v2[1] = quadraticAt(y0, y1, y2, next);
	      var d2 = v2DistSquare(_v2, _v0);
	
	      if (next <= 1 && d2 < d) {
	        t = next;
	        d = d2;
	      } else {
	        interval *= 0.5;
	      }
	    }
	  } // t
	
	
	  if (out) {
	    out[0] = quadraticAt(x0, x1, x2, t);
	    out[1] = quadraticAt(y0, y1, y2, t);
	  } // console.log(interval, i);
	
	
	  return mathSqrt(d);
	}
	
	exports.cubicAt = cubicAt;
	exports.cubicDerivativeAt = cubicDerivativeAt;
	exports.cubicRootAt = cubicRootAt;
	exports.cubicExtrema = cubicExtrema;
	exports.cubicSubdivide = cubicSubdivide;
	exports.cubicProjectPoint = cubicProjectPoint;
	exports.quadraticAt = quadraticAt;
	exports.quadraticDerivativeAt = quadraticDerivativeAt;
	exports.quadraticRootAt = quadraticRootAt;
	exports.quadraticExtremum = quadraticExtremum;
	exports.quadraticSubdivide = quadraticSubdivide;
	exports.quadraticProjectPoint = quadraticProjectPoint;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(50)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(1);
	
	var retrieve = _util.retrieve;
	var defaults = _util.defaults;
	var extend = _util.extend;
	var each = _util.each;
	
	var formatUtil = __webpack_require__(9);
	
	var graphic = __webpack_require__(3);
	
	var Model = __webpack_require__(14);
	
	var _number = __webpack_require__(4);
	
	var isRadianAroundZero = _number.isRadianAroundZero;
	var remRadian = _number.remRadian;
	
	var _symbol = __webpack_require__(22);
	
	var createSymbol = _symbol.createSymbol;
	
	var matrixUtil = __webpack_require__(23);
	
	var _vector = __webpack_require__(8);
	
	var v2ApplyTransform = _vector.applyTransform;
	var PI = Math.PI;
	
	function makeAxisEventDataBase(axisModel) {
	  var eventData = {
	    componentType: axisModel.mainType
	  };
	  eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
	  return eventData;
	}
	/**
	 * A final axis is translated and rotated from a "standard axis".
	 * So opt.position and opt.rotation is required.
	 *
	 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
	 * for example: (0, 0) ------------> (0, 50)
	 *
	 * nameDirection or tickDirection or labelDirection is 1 means tick
	 * or label is below the standard axis, whereas is -1 means above
	 * the standard axis. labelOffset means offset between label and axis,
	 * which is useful when 'onZero', where axisLabel is in the grid and
	 * label in outside grid.
	 *
	 * Tips: like always,
	 * positive rotation represents anticlockwise, and negative rotation
	 * represents clockwise.
	 * The direction of position coordinate is the same as the direction
	 * of screen coordinate.
	 *
	 * Do not need to consider axis 'inverse', which is auto processed by
	 * axis extent.
	 *
	 * @param {module:zrender/container/Group} group
	 * @param {Object} axisModel
	 * @param {Object} opt Standard axis parameters.
	 * @param {Array.<number>} opt.position [x, y]
	 * @param {number} opt.rotation by radian
	 * @param {number} [opt.nameDirection=1] 1 or -1 Used when nameLocation is 'middle' or 'center'.
	 * @param {number} [opt.tickDirection=1] 1 or -1
	 * @param {number} [opt.labelDirection=1] 1 or -1
	 * @param {number} [opt.labelOffset=0] Usefull when onZero.
	 * @param {string} [opt.axisLabelShow] default get from axisModel.
	 * @param {string} [opt.axisName] default get from axisModel.
	 * @param {number} [opt.axisNameAvailableWidth]
	 * @param {number} [opt.labelRotate] by degree, default get from axisModel.
	 * @param {number} [opt.labelInterval] Default label interval when label
	 *                                     interval from model is null or 'auto'.
	 * @param {number} [opt.strokeContainThreshold] Default label interval when label
	 * @param {number} [opt.nameTruncateMaxWidth]
	 */
	
	
	var AxisBuilder = function (axisModel, opt) {
	  /**
	   * @readOnly
	   */
	  this.opt = opt;
	  /**
	   * @readOnly
	   */
	
	  this.axisModel = axisModel; // Default value
	
	  defaults(opt, {
	    labelOffset: 0,
	    nameDirection: 1,
	    tickDirection: 1,
	    labelDirection: 1,
	    silent: true
	  });
	  /**
	   * @readOnly
	   */
	
	  this.group = new graphic.Group(); // FIXME Not use a seperate text group?
	
	  var dumbGroup = new graphic.Group({
	    position: opt.position.slice(),
	    rotation: opt.rotation
	  }); // this.group.add(dumbGroup);
	  // this._dumbGroup = dumbGroup;
	
	  dumbGroup.updateTransform();
	  this._transform = dumbGroup.transform;
	  this._dumbGroup = dumbGroup;
	};
	
	AxisBuilder.prototype = {
	  constructor: AxisBuilder,
	  hasBuilder: function (name) {
	    return !!builders[name];
	  },
	  add: function (name) {
	    builders[name].call(this);
	  },
	  getGroup: function () {
	    return this.group;
	  }
	};
	var builders = {
	  /**
	   * @private
	   */
	  axisLine: function () {
	    var opt = this.opt;
	    var axisModel = this.axisModel;
	
	    if (!axisModel.get('axisLine.show')) {
	      return;
	    }
	
	    var extent = this.axisModel.axis.getExtent();
	    var matrix = this._transform;
	    var pt1 = [extent[0], 0];
	    var pt2 = [extent[1], 0];
	
	    if (matrix) {
	      v2ApplyTransform(pt1, pt1, matrix);
	      v2ApplyTransform(pt2, pt2, matrix);
	    }
	
	    var lineStyle = extend({
	      lineCap: 'round'
	    }, axisModel.getModel('axisLine.lineStyle').getLineStyle());
	    this.group.add(new graphic.Line(graphic.subPixelOptimizeLine({
	      // Id for animation
	      anid: 'line',
	      shape: {
	        x1: pt1[0],
	        y1: pt1[1],
	        x2: pt2[0],
	        y2: pt2[1]
	      },
	      style: lineStyle,
	      strokeContainThreshold: opt.strokeContainThreshold || 5,
	      silent: true,
	      z2: 1
	    })));
	    var arrows = axisModel.get('axisLine.symbol');
	    var arrowSize = axisModel.get('axisLine.symbolSize');
	
	    if (arrows != null) {
	      if (typeof arrows === 'string') {
	        // Use the same arrow for start and end point
	        arrows = [arrows, arrows];
	      }
	
	      if (typeof arrowSize === 'string' || typeof arrowSize === 'number') {
	        // Use the same size for width and height
	        arrowSize = [arrowSize, arrowSize];
	      }
	
	      var symbolWidth = arrowSize[0];
	      var symbolHeight = arrowSize[1];
	      each([[opt.rotation + Math.PI / 2, pt1], [opt.rotation - Math.PI / 2, pt2]], function (item, index) {
	        if (arrows[index] !== 'none' && arrows[index] != null) {
	          var symbol = createSymbol(arrows[index], -symbolWidth / 2, -symbolHeight / 2, symbolWidth, symbolHeight, lineStyle.stroke, true);
	          symbol.attr({
	            rotation: item[0],
	            position: item[1],
	            silent: true
	          });
	          this.group.add(symbol);
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @private
	   */
	  axisTickLabel: function () {
	    var axisModel = this.axisModel;
	    var opt = this.opt;
	    var tickEls = buildAxisTick(this, axisModel, opt);
	    var labelEls = buildAxisLabel(this, axisModel, opt);
	    fixMinMaxLabelShow(axisModel, labelEls, tickEls);
	  },
	
	  /**
	   * @private
	   */
	  axisName: function () {
	    var opt = this.opt;
	    var axisModel = this.axisModel;
	    var name = retrieve(opt.axisName, axisModel.get('name'));
	
	    if (!name) {
	      return;
	    }
	
	    var nameLocation = axisModel.get('nameLocation');
	    var nameDirection = opt.nameDirection;
	    var textStyleModel = axisModel.getModel('nameTextStyle');
	    var gap = axisModel.get('nameGap') || 0;
	    var extent = this.axisModel.axis.getExtent();
	    var gapSignal = extent[0] > extent[1] ? -1 : 1;
	    var pos = [nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2, // 'middle'
	    // Reuse labelOffset.
	    isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0];
	    var labelLayout;
	    var nameRotation = axisModel.get('nameRotate');
	
	    if (nameRotation != null) {
	      nameRotation = nameRotation * PI / 180; // To radian.
	    }
	
	    var axisNameAvailableWidth;
	
	    if (isNameLocationCenter(nameLocation)) {
	      labelLayout = innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
	      nameDirection);
	    } else {
	      labelLayout = endTextLayout(opt, nameLocation, nameRotation || 0, extent);
	      axisNameAvailableWidth = opt.axisNameAvailableWidth;
	
	      if (axisNameAvailableWidth != null) {
	        axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
	        !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
	      }
	    }
	
	    var textFont = textStyleModel.getFont();
	    var truncateOpt = axisModel.get('nameTruncate', true) || {};
	    var ellipsis = truncateOpt.ellipsis;
	    var maxWidth = retrieve(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth); // FIXME
	    // truncate rich text? (consider performance)
	
	    var truncatedText = ellipsis != null && maxWidth != null ? formatUtil.truncateText(name, maxWidth, textFont, ellipsis, {
	      minChar: 2,
	      placeholder: truncateOpt.placeholder
	    }) : name;
	    var tooltipOpt = axisModel.get('tooltip', true);
	    var mainType = axisModel.mainType;
	    var formatterParams = {
	      componentType: mainType,
	      name: name,
	      $vars: ['name']
	    };
	    formatterParams[mainType + 'Index'] = axisModel.componentIndex;
	    var textEl = new graphic.Text({
	      // Id for animation
	      anid: 'name',
	      __fullText: name,
	      __truncatedText: truncatedText,
	      position: pos,
	      rotation: labelLayout.rotation,
	      silent: isSilent(axisModel),
	      z2: 1,
	      tooltip: tooltipOpt && tooltipOpt.show ? extend({
	        content: name,
	        formatter: function () {
	          return name;
	        },
	        formatterParams: formatterParams
	      }, tooltipOpt) : null
	    });
	    graphic.setTextStyle(textEl.style, textStyleModel, {
	      text: truncatedText,
	      textFont: textFont,
	      textFill: textStyleModel.getTextColor() || axisModel.get('axisLine.lineStyle.color'),
	      textAlign: labelLayout.textAlign,
	      textVerticalAlign: labelLayout.textVerticalAlign
	    });
	
	    if (axisModel.get('triggerEvent')) {
	      textEl.eventData = makeAxisEventDataBase(axisModel);
	      textEl.eventData.targetType = 'axisName';
	      textEl.eventData.name = name;
	    } // FIXME
	
	
	    this._dumbGroup.add(textEl);
	
	    textEl.updateTransform();
	    this.group.add(textEl);
	    textEl.decomposeTransform();
	  }
	};
	/**
	 * @public
	 * @static
	 * @param {Object} opt
	 * @param {number} axisRotation in radian
	 * @param {number} textRotation in radian
	 * @param {number} direction
	 * @return {Object} {
	 *  rotation, // according to axis
	 *  textAlign,
	 *  textVerticalAlign
	 * }
	 */
	
	var innerTextLayout = AxisBuilder.innerTextLayout = function (axisRotation, textRotation, direction) {
	  var rotationDiff = remRadian(textRotation - axisRotation);
	  var textAlign;
	  var textVerticalAlign;
	
	  if (isRadianAroundZero(rotationDiff)) {
	    // Label is parallel with axis line.
	    textVerticalAlign = direction > 0 ? 'top' : 'bottom';
	    textAlign = 'center';
	  } else if (isRadianAroundZero(rotationDiff - PI)) {
	    // Label is inverse parallel with axis line.
	    textVerticalAlign = direction > 0 ? 'bottom' : 'top';
	    textAlign = 'center';
	  } else {
	    textVerticalAlign = 'middle';
	
	    if (rotationDiff > 0 && rotationDiff < PI) {
	      textAlign = direction > 0 ? 'right' : 'left';
	    } else {
	      textAlign = direction > 0 ? 'left' : 'right';
	    }
	  }
	
	  return {
	    rotation: rotationDiff,
	    textAlign: textAlign,
	    textVerticalAlign: textVerticalAlign
	  };
	};
	
	function endTextLayout(opt, textPosition, textRotate, extent) {
	  var rotationDiff = remRadian(textRotate - opt.rotation);
	  var textAlign;
	  var textVerticalAlign;
	  var inverse = extent[0] > extent[1];
	  var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
	
	  if (isRadianAroundZero(rotationDiff - PI / 2)) {
	    textVerticalAlign = onLeft ? 'bottom' : 'top';
	    textAlign = 'center';
	  } else if (isRadianAroundZero(rotationDiff - PI * 1.5)) {
	    textVerticalAlign = onLeft ? 'top' : 'bottom';
	    textAlign = 'center';
	  } else {
	    textVerticalAlign = 'middle';
	
	    if (rotationDiff < PI * 1.5 && rotationDiff > PI / 2) {
	      textAlign = onLeft ? 'left' : 'right';
	    } else {
	      textAlign = onLeft ? 'right' : 'left';
	    }
	  }
	
	  return {
	    rotation: rotationDiff,
	    textAlign: textAlign,
	    textVerticalAlign: textVerticalAlign
	  };
	}
	
	function isSilent(axisModel) {
	  var tooltipOpt = axisModel.get('tooltip');
	  return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
	  || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
	}
	
	function fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
	  // If min or max are user set, we need to check
	  // If the tick on min(max) are overlap on their neighbour tick
	  // If they are overlapped, we need to hide the min(max) tick label
	  var showMinLabel = axisModel.get('axisLabel.showMinLabel');
	  var showMaxLabel = axisModel.get('axisLabel.showMaxLabel'); // FIXME
	  // Have not consider onBand yet, where tick els is more than label els.
	
	  labelEls = labelEls || [];
	  tickEls = tickEls || [];
	  var firstLabel = labelEls[0];
	  var nextLabel = labelEls[1];
	  var lastLabel = labelEls[labelEls.length - 1];
	  var prevLabel = labelEls[labelEls.length - 2];
	  var firstTick = tickEls[0];
	  var nextTick = tickEls[1];
	  var lastTick = tickEls[tickEls.length - 1];
	  var prevTick = tickEls[tickEls.length - 2];
	
	  if (showMinLabel === false) {
	    ignoreEl(firstLabel);
	    ignoreEl(firstTick);
	  } else if (isTwoLabelOverlapped(firstLabel, nextLabel)) {
	    if (showMinLabel) {
	      ignoreEl(nextLabel);
	      ignoreEl(nextTick);
	    } else {
	      ignoreEl(firstLabel);
	      ignoreEl(firstTick);
	    }
	  }
	
	  if (showMaxLabel === false) {
	    ignoreEl(lastLabel);
	    ignoreEl(lastTick);
	  } else if (isTwoLabelOverlapped(prevLabel, lastLabel)) {
	    if (showMaxLabel) {
	      ignoreEl(prevLabel);
	      ignoreEl(prevTick);
	    } else {
	      ignoreEl(lastLabel);
	      ignoreEl(lastTick);
	    }
	  }
	}
	
	function ignoreEl(el) {
	  el && (el.ignore = true);
	}
	
	function isTwoLabelOverlapped(current, next, labelLayout) {
	  // current and next has the same rotation.
	  var firstRect = current && current.getBoundingRect().clone();
	  var nextRect = next && next.getBoundingRect().clone();
	
	  if (!firstRect || !nextRect) {
	    return;
	  } // When checking intersect of two rotated labels, we use mRotationBack
	  // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
	
	
	  var mRotationBack = matrixUtil.identity([]);
	  matrixUtil.rotate(mRotationBack, mRotationBack, -current.rotation);
	  firstRect.applyTransform(matrixUtil.mul([], mRotationBack, current.getLocalTransform()));
	  nextRect.applyTransform(matrixUtil.mul([], mRotationBack, next.getLocalTransform()));
	  return firstRect.intersect(nextRect);
	}
	
	function isNameLocationCenter(nameLocation) {
	  return nameLocation === 'middle' || nameLocation === 'center';
	}
	/**
	 * @static
	 */
	
	
	var ifIgnoreOnTick = AxisBuilder.ifIgnoreOnTick = function (axis, i, interval, ticksCnt, showMinLabel, showMaxLabel) {
	  if (i === 0 && showMinLabel || i === ticksCnt - 1 && showMaxLabel) {
	    return false;
	  } // FIXME
	  // Have not consider label overlap (if label is too long) yet.
	
	
	  var rawTick;
	  var scale = axis.scale;
	  return scale.type === 'ordinal' && (typeof interval === 'function' ? (rawTick = scale.getTicks()[i], !interval(rawTick, scale.getLabel(rawTick))) : i % (interval + 1));
	};
	/**
	 * @static
	 */
	
	
	var getInterval = AxisBuilder.getInterval = function (model, labelInterval) {
	  var interval = model.get('interval');
	
	  if (interval == null || interval == 'auto') {
	    interval = labelInterval;
	  }
	
	  return interval;
	};
	
	function buildAxisTick(axisBuilder, axisModel, opt) {
	  var axis = axisModel.axis;
	
	  if (!axisModel.get('axisTick.show') || axis.scale.isBlank()) {
	    return;
	  }
	
	  var tickModel = axisModel.getModel('axisTick');
	  var lineStyleModel = tickModel.getModel('lineStyle');
	  var tickLen = tickModel.get('length');
	  var tickInterval = getInterval(tickModel, opt.labelInterval);
	  var ticksCoords = axis.getTicksCoords(tickModel.get('alignWithLabel')); // FIXME
	  // Corresponds to ticksCoords ?
	
	  var ticks = axis.scale.getTicks();
	  var showMinLabel = axisModel.get('axisLabel.showMinLabel');
	  var showMaxLabel = axisModel.get('axisLabel.showMaxLabel');
	  var pt1 = [];
	  var pt2 = [];
	  var matrix = axisBuilder._transform;
	  var tickEls = [];
	  var ticksCnt = ticksCoords.length;
	
	  for (var i = 0; i < ticksCnt; i++) {
	    // Only ordinal scale support tick interval
	    if (ifIgnoreOnTick(axis, i, tickInterval, ticksCnt, showMinLabel, showMaxLabel)) {
	      continue;
	    }
	
	    var tickCoord = ticksCoords[i];
	    pt1[0] = tickCoord;
	    pt1[1] = 0;
	    pt2[0] = tickCoord;
	    pt2[1] = opt.tickDirection * tickLen;
	
	    if (matrix) {
	      v2ApplyTransform(pt1, pt1, matrix);
	      v2ApplyTransform(pt2, pt2, matrix);
	    } // Tick line, Not use group transform to have better line draw
	
	
	    var tickEl = new graphic.Line(graphic.subPixelOptimizeLine({
	      // Id for animation
	      anid: 'tick_' + ticks[i],
	      shape: {
	        x1: pt1[0],
	        y1: pt1[1],
	        x2: pt2[0],
	        y2: pt2[1]
	      },
	      style: defaults(lineStyleModel.getLineStyle(), {
	        stroke: axisModel.get('axisLine.lineStyle.color')
	      }),
	      z2: 2,
	      silent: true
	    }));
	    axisBuilder.group.add(tickEl);
	    tickEls.push(tickEl);
	  }
	
	  return tickEls;
	}
	
	function buildAxisLabel(axisBuilder, axisModel, opt) {
	  var axis = axisModel.axis;
	  var show = retrieve(opt.axisLabelShow, axisModel.get('axisLabel.show'));
	
	  if (!show || axis.scale.isBlank()) {
	    return;
	  }
	
	  var labelModel = axisModel.getModel('axisLabel');
	  var labelMargin = labelModel.get('margin');
	  var ticks = axis.scale.getTicks();
	  var labels = axisModel.getFormattedLabels(); // Special label rotate.
	
	  var labelRotation = (retrieve(opt.labelRotate, labelModel.get('rotate')) || 0) * PI / 180;
	  var labelLayout = innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
	  var categoryData = axisModel.get('data');
	  var labelEls = [];
	  var silent = isSilent(axisModel);
	  var triggerEvent = axisModel.get('triggerEvent');
	  var showMinLabel = axisModel.get('axisLabel.showMinLabel');
	  var showMaxLabel = axisModel.get('axisLabel.showMaxLabel');
	  each(ticks, function (tickVal, index) {
	    if (ifIgnoreOnTick(axis, index, opt.labelInterval, ticks.length, showMinLabel, showMaxLabel)) {
	      return;
	    }
	
	    var itemLabelModel = labelModel;
	
	    if (categoryData && categoryData[tickVal] && categoryData[tickVal].textStyle) {
	      itemLabelModel = new Model(categoryData[tickVal].textStyle, labelModel, axisModel.ecModel);
	    }
	
	    var textColor = itemLabelModel.getTextColor() || axisModel.get('axisLine.lineStyle.color');
	    var tickCoord = axis.dataToCoord(tickVal);
	    var pos = [tickCoord, opt.labelOffset + opt.labelDirection * labelMargin];
	    var labelStr = axis.scale.getLabel(tickVal);
	    var textEl = new graphic.Text({
	      // Id for animation
	      anid: 'label_' + tickVal,
	      position: pos,
	      rotation: labelLayout.rotation,
	      silent: silent,
	      z2: 10
	    });
	    graphic.setTextStyle(textEl.style, itemLabelModel, {
	      text: labels[index],
	      textAlign: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
	      textVerticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
	      textFill: typeof textColor === 'function' ? textColor( // (1) In category axis with data zoom, tick is not the original
	      // index of axis.data. So tick should not be exposed to user
	      // in category axis.
	      // (2) Compatible with previous version, which always returns labelStr.
	      // But in interval scale labelStr is like '223,445', which maked
	      // user repalce ','. So we modify it to return original val but remain
	      // it as 'string' to avoid error in replacing.
	      axis.type === 'category' ? labelStr : axis.type === 'value' ? tickVal + '' : tickVal, index) : textColor
	    }); // Pack data for mouse event
	
	    if (triggerEvent) {
	      textEl.eventData = makeAxisEventDataBase(axisModel);
	      textEl.eventData.targetType = 'axisLabel';
	      textEl.eventData.value = labelStr;
	    } // FIXME
	
	
	    axisBuilder._dumbGroup.add(textEl);
	
	    textEl.updateTransform();
	    labelEls.push(textEl);
	    axisBuilder.group.add(textEl);
	    textEl.decomposeTransform();
	  });
	  return labelEls;
	}
	
	var _default = AxisBuilder;
	module.exports = _default;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(2);
	
	var axisPointerModelHelper = __webpack_require__(85);
	
	/**
	 * Base class of AxisView.
	 */
	var AxisView = echarts.extendComponentView({
	  type: 'axis',
	
	  /**
	   * @private
	   */
	  _axisPointer: null,
	
	  /**
	   * @protected
	   * @type {string}
	   */
	  axisPointerClass: null,
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    // FIXME
	    // This process should proformed after coordinate systems updated
	    // (axis scale updated), and should be performed each time update.
	    // So put it here temporarily, although it is not appropriate to
	    // put a model-writing procedure in `view`.
	    this.axisPointerClass && axisPointerModelHelper.fixValue(axisModel);
	    AxisView.superApply(this, 'render', arguments);
	    updateAxisPointer(this, axisModel, ecModel, api, payload, true);
	  },
	
	  /**
	   * Action handler.
	   * @public
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/model/Global} ecModel
	   * @param {module:echarts/ExtensionAPI} api
	   * @param {Object} payload
	   */
	  updateAxisPointer: function (axisModel, ecModel, api, payload, force) {
	    updateAxisPointer(this, axisModel, ecModel, api, payload, false);
	  },
	
	  /**
	   * @override
	   */
	  remove: function (ecModel, api) {
	    var axisPointer = this._axisPointer;
	    axisPointer && axisPointer.remove(api);
	    AxisView.superApply(this, 'remove', arguments);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function (ecModel, api) {
	    disposeAxisPointer(this, api);
	    AxisView.superApply(this, 'dispose', arguments);
	  }
	});
	
	function updateAxisPointer(axisView, axisModel, ecModel, api, payload, forceRender) {
	  var Clazz = AxisView.getAxisPointerClass(axisView.axisPointerClass);
	
	  if (!Clazz) {
	    return;
	  }
	
	  var axisPointerModel = axisPointerModelHelper.getAxisPointerModel(axisModel);
	  axisPointerModel ? (axisView._axisPointer || (axisView._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : disposeAxisPointer(axisView, api);
	}
	
	function disposeAxisPointer(axisView, ecModel, api) {
	  var axisPointer = axisView._axisPointer;
	  axisPointer && axisPointer.dispose(ecModel, api);
	  axisView._axisPointer = null;
	}
	
	var axisPointerClazz = [];
	
	AxisView.registerAxisPointerClass = function (type, clazz) {
	  axisPointerClazz[type] = clazz;
	};
	
	AxisView.getAxisPointerClass = function (type) {
	  return type && axisPointerClazz[type];
	};
	
	var _default = AxisView;
	module.exports = _default;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	var ORIGIN_METHOD = '\0__throttleOriginMethod';
	var RATE = '\0__throttleRate';
	var THROTTLE_TYPE = '\0__throttleType';
	/**
	 * @public
	 * @param {(Function)} fn
	 * @param {number} [delay=0] Unit: ms.
	 * @param {boolean} [debounce=false]
	 *        true: If call interval less than `delay`, only the last call works.
	 *        false: If call interval less than `delay, call works on fixed rate.
	 * @return {(Function)} throttled fn.
	 */
	
	function throttle(fn, delay, debounce) {
	  var currCall;
	  var lastCall = 0;
	  var lastExec = 0;
	  var timer = null;
	  var diff;
	  var scope;
	  var args;
	  var debounceNextCall;
	  delay = delay || 0;
	
	  function exec() {
	    lastExec = new Date().getTime();
	    timer = null;
	    fn.apply(scope, args || []);
	  }
	
	  var cb = function () {
	    currCall = new Date().getTime();
	    scope = this;
	    args = arguments;
	    var thisDelay = debounceNextCall || delay;
	    var thisDebounce = debounceNextCall || debounce;
	    debounceNextCall = null;
	    diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
	    clearTimeout(timer);
	
	    if (thisDebounce) {
	      timer = setTimeout(exec, thisDelay);
	    } else {
	      if (diff >= 0) {
	        exec();
	      } else {
	        timer = setTimeout(exec, -diff);
	      }
	    }
	
	    lastCall = currCall;
	  };
	  /**
	   * Clear throttle.
	   * @public
	   */
	
	
	  cb.clear = function () {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  };
	  /**
	   * Enable debounce once.
	   */
	
	
	  cb.debounceNextCall = function (debounceDelay) {
	    debounceNextCall = debounceDelay;
	  };
	
	  return cb;
	}
	/**
	 * Create throttle method or update throttle rate.
	 *
	 * @example
	 * ComponentView.prototype.render = function () {
	 *     ...
	 *     throttle.createOrUpdate(
	 *         this,
	 *         '_dispatchAction',
	 *         this.model.get('throttle'),
	 *         'fixRate'
	 *     );
	 * };
	 * ComponentView.prototype.remove = function () {
	 *     throttle.clear(this, '_dispatchAction');
	 * };
	 * ComponentView.prototype.dispose = function () {
	 *     throttle.clear(this, '_dispatchAction');
	 * };
	 *
	 * @public
	 * @param {Object} obj
	 * @param {string} fnAttr
	 * @param {number} [rate]
	 * @param {string} [throttleType='fixRate'] 'fixRate' or 'debounce'
	 * @return {Function} throttled function.
	 */
	
	
	function createOrUpdate(obj, fnAttr, rate, throttleType) {
	  var fn = obj[fnAttr];
	
	  if (!fn) {
	    return;
	  }
	
	  var originFn = fn[ORIGIN_METHOD] || fn;
	  var lastThrottleType = fn[THROTTLE_TYPE];
	  var lastRate = fn[RATE];
	
	  if (lastRate !== rate || lastThrottleType !== throttleType) {
	    if (rate == null || !throttleType) {
	      return obj[fnAttr] = originFn;
	    }
	
	    fn = obj[fnAttr] = throttle(originFn, rate, throttleType === 'debounce');
	    fn[ORIGIN_METHOD] = originFn;
	    fn[THROTTLE_TYPE] = throttleType;
	    fn[RATE] = rate;
	  }
	
	  return fn;
	}
	/**
	 * Clear throttle. Example see throttle.createOrUpdate.
	 *
	 * @public
	 * @param {Object} obj
	 * @param {string} fnAttr
	 */
	
	
	function clear(obj, fnAttr) {
	  var fn = obj[fnAttr];
	
	  if (fn && fn[ORIGIN_METHOD]) {
	    obj[fnAttr] = fn[ORIGIN_METHOD];
	  }
	}
	
	exports.throttle = throttle;
	exports.createOrUpdate = createOrUpdate;
	exports.clear = clear;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var zrColor = __webpack_require__(31);
	
	var _number = __webpack_require__(4);
	
	var linearMap = _number.linearMap;
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var CATEGORY_DEFAULT_VISUAL_INDEX = -1;
	/**
	 * @param {Object} option
	 * @param {string} [option.type] See visualHandlers.
	 * @param {string} [option.mappingMethod] 'linear' or 'piecewise' or 'category' or 'fixed'
	 * @param {Array.<number>=} [option.dataExtent] [minExtent, maxExtent],
	 *                                              required when mappingMethod is 'linear'
	 * @param {Array.<Object>=} [option.pieceList] [
	 *                                             {value: someValue},
	 *                                             {interval: [min1, max1], visual: {...}},
	 *                                             {interval: [min2, max2]}
	 *                                             ],
	 *                                            required when mappingMethod is 'piecewise'.
	 *                                            Visual for only each piece can be specified.
	 * @param {Array.<string|Object>=} [option.categories] ['cate1', 'cate2']
	 *                                            required when mappingMethod is 'category'.
	 *                                            If no option.categories, categories is set
	 *                                            as [0, 1, 2, ...].
	 * @param {boolean} [option.loop=false] Whether loop mapping when mappingMethod is 'category'.
	 * @param {(Array|Object|*)} [option.visual]  Visual data.
	 *                                            when mappingMethod is 'category',
	 *                                            visual data can be array or object
	 *                                            (like: {cate1: '#222', none: '#fff'})
	 *                                            or primary types (which represents
	 *                                            defualt category visual), otherwise visual
	 *                                            can be array or primary (which will be
	 *                                            normalized to array).
	 *
	 */
	
	var VisualMapping = function (option) {
	  var mappingMethod = option.mappingMethod;
	  var visualType = option.type;
	  /**
	   * @readOnly
	   * @type {Object}
	   */
	
	  var thisOption = this.option = zrUtil.clone(option);
	  /**
	   * @readOnly
	   * @type {string}
	   */
	
	  this.type = visualType;
	  /**
	   * @readOnly
	   * @type {string}
	   */
	
	  this.mappingMethod = mappingMethod;
	  /**
	   * @private
	   * @type {Function}
	   */
	
	  this._normalizeData = normalizers[mappingMethod];
	  var visualHandler = visualHandlers[visualType];
	  /**
	   * @public
	   * @type {Function}
	   */
	
	  this.applyVisual = visualHandler.applyVisual;
	  /**
	   * @public
	   * @type {Function}
	   */
	
	  this.getColorMapper = visualHandler.getColorMapper;
	  /**
	   * @private
	   * @type {Function}
	   */
	
	  this._doMap = visualHandler._doMap[mappingMethod];
	
	  if (mappingMethod === 'piecewise') {
	    normalizeVisualRange(thisOption);
	    preprocessForPiecewise(thisOption);
	  } else if (mappingMethod === 'category') {
	    thisOption.categories ? preprocessForSpecifiedCategory(thisOption) // categories is ordinal when thisOption.categories not specified,
	    // which need no more preprocess except normalize visual.
	    : normalizeVisualRange(thisOption, true);
	  } else {
	    // mappingMethod === 'linear' or 'fixed'
	    zrUtil.assert(mappingMethod !== 'linear' || thisOption.dataExtent);
	    normalizeVisualRange(thisOption);
	  }
	};
	
	VisualMapping.prototype = {
	  constructor: VisualMapping,
	  mapValueToVisual: function (value) {
	    var normalized = this._normalizeData(value);
	
	    return this._doMap(normalized, value);
	  },
	  getNormalizer: function () {
	    return zrUtil.bind(this._normalizeData, this);
	  }
	};
	var visualHandlers = VisualMapping.visualHandlers = {
	  color: {
	    applyVisual: makeApplyVisual('color'),
	
	    /**
	     * Create a mapper function
	     * @return {Function}
	     */
	    getColorMapper: function () {
	      var thisOption = this.option;
	      return zrUtil.bind(thisOption.mappingMethod === 'category' ? function (value, isNormalized) {
	        !isNormalized && (value = this._normalizeData(value));
	        return doMapCategory.call(this, value);
	      } : function (value, isNormalized, out) {
	        // If output rgb array
	        // which will be much faster and useful in pixel manipulation
	        var returnRGBArray = !!out;
	        !isNormalized && (value = this._normalizeData(value));
	        out = zrColor.fastLerp(value, thisOption.parsedVisual, out);
	        return returnRGBArray ? out : zrColor.stringify(out, 'rgba');
	      }, this);
	    },
	    _doMap: {
	      linear: function (normalized) {
	        return zrColor.stringify(zrColor.fastLerp(normalized, this.option.parsedVisual), 'rgba');
	      },
	      category: doMapCategory,
	      piecewise: function (normalized, value) {
	        var result = getSpecifiedVisual.call(this, value);
	
	        if (result == null) {
	          result = zrColor.stringify(zrColor.fastLerp(normalized, this.option.parsedVisual), 'rgba');
	        }
	
	        return result;
	      },
	      fixed: doMapFixed
	    }
	  },
	  colorHue: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, value);
	  }),
	  colorSaturation: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, null, value);
	  }),
	  colorLightness: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, null, null, value);
	  }),
	  colorAlpha: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyAlpha(color, value);
	  }),
	  opacity: {
	    applyVisual: makeApplyVisual('opacity'),
	    _doMap: makeDoMap([0, 1])
	  },
	  symbol: {
	    applyVisual: function (value, getter, setter) {
	      var symbolCfg = this.mapValueToVisual(value);
	
	      if (zrUtil.isString(symbolCfg)) {
	        setter('symbol', symbolCfg);
	      } else if (isObject(symbolCfg)) {
	        for (var name in symbolCfg) {
	          if (symbolCfg.hasOwnProperty(name)) {
	            setter(name, symbolCfg[name]);
	          }
	        }
	      }
	    },
	    _doMap: {
	      linear: doMapToArray,
	      category: doMapCategory,
	      piecewise: function (normalized, value) {
	        var result = getSpecifiedVisual.call(this, value);
	
	        if (result == null) {
	          result = doMapToArray.call(this, normalized);
	        }
	
	        return result;
	      },
	      fixed: doMapFixed
	    }
	  },
	  symbolSize: {
	    applyVisual: makeApplyVisual('symbolSize'),
	    _doMap: makeDoMap([0, 1])
	  }
	};
	
	function preprocessForPiecewise(thisOption) {
	  var pieceList = thisOption.pieceList;
	  thisOption.hasSpecialVisual = false;
	  zrUtil.each(pieceList, function (piece, index) {
	    piece.originIndex = index; // piece.visual is "result visual value" but not
	    // a visual range, so it does not need to be normalized.
	
	    if (piece.visual != null) {
	      thisOption.hasSpecialVisual = true;
	    }
	  });
	}
	
	function preprocessForSpecifiedCategory(thisOption) {
	  // Hash categories.
	  var categories = thisOption.categories;
	  var visual = thisOption.visual;
	  var categoryMap = thisOption.categoryMap = {};
	  each(categories, function (cate, index) {
	    categoryMap[cate] = index;
	  }); // Process visual map input.
	
	  if (!zrUtil.isArray(visual)) {
	    var visualArr = [];
	
	    if (zrUtil.isObject(visual)) {
	      each(visual, function (v, cate) {
	        var index = categoryMap[cate];
	        visualArr[index != null ? index : CATEGORY_DEFAULT_VISUAL_INDEX] = v;
	      });
	    } else {
	      // Is primary type, represents default visual.
	      visualArr[CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
	    }
	
	    visual = setVisualToOption(thisOption, visualArr);
	  } // Remove categories that has no visual,
	  // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.
	
	
	  for (var i = categories.length - 1; i >= 0; i--) {
	    if (visual[i] == null) {
	      delete categoryMap[categories[i]];
	      categories.pop();
	    }
	  }
	}
	
	function normalizeVisualRange(thisOption, isCategory) {
	  var visual = thisOption.visual;
	  var visualArr = [];
	
	  if (zrUtil.isObject(visual)) {
	    each(visual, function (v) {
	      visualArr.push(v);
	    });
	  } else if (visual != null) {
	    visualArr.push(visual);
	  }
	
	  var doNotNeedPair = {
	    color: 1,
	    symbol: 1
	  };
	
	  if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) {
	    // Do not care visualArr.length === 0, which is illegal.
	    visualArr[1] = visualArr[0];
	  }
	
	  setVisualToOption(thisOption, visualArr);
	}
	
	function makePartialColorVisualHandler(applyValue) {
	  return {
	    applyVisual: function (value, getter, setter) {
	      value = this.mapValueToVisual(value); // Must not be array value
	
	      setter('color', applyValue(getter('color'), value));
	    },
	    _doMap: makeDoMap([0, 1])
	  };
	}
	
	function doMapToArray(normalized) {
	  var visual = this.option.visual;
	  return visual[Math.round(linearMap(normalized, [0, 1], [0, visual.length - 1], true))] || {};
	}
	
	function makeApplyVisual(visualType) {
	  return function (value, getter, setter) {
	    setter(visualType, this.mapValueToVisual(value));
	  };
	}
	
	function doMapCategory(normalized) {
	  var visual = this.option.visual;
	  return visual[this.option.loop && normalized !== CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
	}
	
	function doMapFixed() {
	  return this.option.visual[0];
	}
	
	function makeDoMap(sourceExtent) {
	  return {
	    linear: function (normalized) {
	      return linearMap(normalized, sourceExtent, this.option.visual, true);
	    },
	    category: doMapCategory,
	    piecewise: function (normalized, value) {
	      var result = getSpecifiedVisual.call(this, value);
	
	      if (result == null) {
	        result = linearMap(normalized, sourceExtent, this.option.visual, true);
	      }
	
	      return result;
	    },
	    fixed: doMapFixed
	  };
	}
	
	function getSpecifiedVisual(value) {
	  var thisOption = this.option;
	  var pieceList = thisOption.pieceList;
	
	  if (thisOption.hasSpecialVisual) {
	    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList);
	    var piece = pieceList[pieceIndex];
	
	    if (piece && piece.visual) {
	      return piece.visual[this.type];
	    }
	  }
	}
	
	function setVisualToOption(thisOption, visualArr) {
	  thisOption.visual = visualArr;
	
	  if (thisOption.type === 'color') {
	    thisOption.parsedVisual = zrUtil.map(visualArr, function (item) {
	      return zrColor.parse(item);
	    });
	  }
	
	  return visualArr;
	}
	/**
	 * Normalizers by mapping methods.
	 */
	
	
	var normalizers = {
	  linear: function (value) {
	    return linearMap(value, this.option.dataExtent, [0, 1], true);
	  },
	  piecewise: function (value) {
	    var pieceList = this.option.pieceList;
	    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList, true);
	
	    if (pieceIndex != null) {
	      return linearMap(pieceIndex, [0, pieceList.length - 1], [0, 1], true);
	    }
	  },
	  category: function (value) {
	    var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal
	
	    return index == null ? CATEGORY_DEFAULT_VISUAL_INDEX : index;
	  },
	  fixed: zrUtil.noop
	};
	/**
	 * List available visual types.
	 *
	 * @public
	 * @return {Array.<string>}
	 */
	
	VisualMapping.listVisualTypes = function () {
	  var visualTypes = [];
	  zrUtil.each(visualHandlers, function (handler, key) {
	    visualTypes.push(key);
	  });
	  return visualTypes;
	};
	/**
	 * @public
	 */
	
	
	VisualMapping.addVisualHandler = function (name, handler) {
	  visualHandlers[name] = handler;
	};
	/**
	 * @public
	 */
	
	
	VisualMapping.isValidType = function (visualType) {
	  return visualHandlers.hasOwnProperty(visualType);
	};
	/**
	 * Convinent method.
	 * Visual can be Object or Array or primary type.
	 *
	 * @public
	 */
	
	
	VisualMapping.eachVisual = function (visual, callback, context) {
	  if (zrUtil.isObject(visual)) {
	    zrUtil.each(visual, callback, context);
	  } else {
	    callback.call(context, visual);
	  }
	};
	
	VisualMapping.mapVisual = function (visual, callback, context) {
	  var isPrimary;
	  var newVisual = zrUtil.isArray(visual) ? [] : zrUtil.isObject(visual) ? {} : (isPrimary = true, null);
	  VisualMapping.eachVisual(visual, function (v, key) {
	    var newVal = callback.call(context, v, key);
	    isPrimary ? newVisual = newVal : newVisual[key] = newVal;
	  });
	  return newVisual;
	};
	/**
	 * @public
	 * @param {Object} obj
	 * @return {Object} new object containers visual values.
	 *                 If no visuals, return null.
	 */
	
	
	VisualMapping.retrieveVisuals = function (obj) {
	  var ret = {};
	  var hasVisual;
	  obj && each(visualHandlers, function (h, visualType) {
	    if (obj.hasOwnProperty(visualType)) {
	      ret[visualType] = obj[visualType];
	      hasVisual = true;
	    }
	  });
	  return hasVisual ? ret : null;
	};
	/**
	 * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
	 *
	 * @public
	 * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
	 *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
	 * @return {Array.<string>} Sorted visual types.
	 */
	
	
	VisualMapping.prepareVisualTypes = function (visualTypes) {
	  if (isObject(visualTypes)) {
	    var types = [];
	    each(visualTypes, function (item, type) {
	      types.push(type);
	    });
	    visualTypes = types;
	  } else if (zrUtil.isArray(visualTypes)) {
	    visualTypes = visualTypes.slice();
	  } else {
	    return [];
	  }
	
	  visualTypes.sort(function (type1, type2) {
	    // color should be front of colorSaturation, colorAlpha, ...
	    // symbol and symbolSize do not matter.
	    return type2 === 'color' && type1 !== 'color' && type1.indexOf('color') === 0 ? 1 : -1;
	  });
	  return visualTypes;
	};
	/**
	 * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
	 * Other visuals are only depends on themself.
	 *
	 * @public
	 * @param {string} visualType1
	 * @param {string} visualType2
	 * @return {boolean}
	 */
	
	
	VisualMapping.dependsOn = function (visualType1, visualType2) {
	  return visualType2 === 'color' ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
	};
	/**
	 * @param {number} value
	 * @param {Array.<Object>} pieceList [{value: ..., interval: [min, max]}, ...]
	 *                         Always from small to big.
	 * @param {boolean} [findClosestWhenOutside=false]
	 * @return {number} index
	 */
	
	
	VisualMapping.findPieceIndex = function (value, pieceList, findClosestWhenOutside) {
	  var possibleI;
	  var abs = Infinity; // value has the higher priority.
	
	  for (var i = 0, len = pieceList.length; i < len; i++) {
	    var pieceValue = pieceList[i].value;
	
	    if (pieceValue != null) {
	      if (pieceValue === value // FIXME
	      // It is supposed to compare value according to value type of dimension,
	      // but currently value type can exactly be string or number.
	      // Compromise for numeric-like string (like '12'), especially
	      // in the case that visualMap.categories is ['22', '33'].
	      || typeof pieceValue === 'string' && pieceValue === value + '') {
	        return i;
	      }
	
	      findClosestWhenOutside && updatePossible(pieceValue, i);
	    }
	  }
	
	  for (var i = 0, len = pieceList.length; i < len; i++) {
	    var piece = pieceList[i];
	    var interval = piece.interval;
	    var close = piece.close;
	
	    if (interval) {
	      if (interval[0] === -Infinity) {
	        if (littleThan(close[1], value, interval[1])) {
	          return i;
	        }
	      } else if (interval[1] === Infinity) {
	        if (littleThan(close[0], interval[0], value)) {
	          return i;
	        }
	      } else if (littleThan(close[0], interval[0], value) && littleThan(close[1], value, interval[1])) {
	        return i;
	      }
	
	      findClosestWhenOutside && updatePossible(interval[0], i);
	      findClosestWhenOutside && updatePossible(interval[1], i);
	    }
	  }
	
	  if (findClosestWhenOutside) {
	    return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
	  }
	
	  function updatePossible(val, index) {
	    var newAbs = Math.abs(val - value);
	
	    if (newAbs < abs) {
	      abs = newAbs;
	      possibleI = index;
	    }
	  }
	};
	
	function littleThan(close, a, b) {
	  return close ? a <= b : a < b;
	}
	
	var _default = VisualMapping;
	module.exports = _default;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	function _default(seriesType, defaultSymbolType, legendSymbol, ecModel, api) {
	  // Encoding visual for all series include which is filtered for legend drawing
	  ecModel.eachRawSeriesByType(seriesType, function (seriesModel) {
	    var data = seriesModel.getData();
	    var symbolType = seriesModel.get('symbol') || defaultSymbolType;
	    var symbolSize = seriesModel.get('symbolSize');
	    data.setVisual({
	      legendSymbol: legendSymbol || symbolType,
	      symbol: symbolType,
	      symbolSize: symbolSize
	    }); // Only visible series has each data be visual encoded
	
	    if (!ecModel.isSeriesFiltered(seriesModel)) {
	      if (typeof symbolSize === 'function') {
	        data.each(function (idx) {
	          var rawValue = seriesModel.getRawValue(idx); // FIXME
	
	          var params = seriesModel.getDataParams(idx);
	          data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
	        });
	      }
	
	      data.each(function (idx) {
	        var itemModel = data.getItemModel(idx);
	        var itemSymbolType = itemModel.getShallow('symbol', true);
	        var itemSymbolSize = itemModel.getShallow('symbolSize', true); // If has item symbol
	
	        if (itemSymbolType != null) {
	          data.setItemVisual(idx, 'symbol', itemSymbolType);
	        }
	
	        if (itemSymbolSize != null) {
	          // PENDING Transform symbolSize ?
	          data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
	        }
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity main
	/* eslint-disable max-params */
	( function( window, factory ) {
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(133),
	      __webpack_require__(206),
	      __webpack_require__(38),
	      __webpack_require__(601),
	      __webpack_require__(608),
	      __webpack_require__(600),
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter, getSize, utils, Cell, Slide, animatePrototype ) {
	      return factory( window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	        window,
	        require('ev-emitter'),
	        require('get-size'),
	        require('fizzy-ui-utils'),
	        require('./cell'),
	        require('./slide'),
	        require('./animate')
	    );
	  } else {
	    // browser global
	    var _Flickity = window.Flickity;
	
	    window.Flickity = factory(
	        window,
	        window.EvEmitter,
	        window.getSize,
	        window.fizzyUIUtils,
	        _Flickity.Cell,
	        _Flickity.Slide,
	        _Flickity.animatePrototype
	    );
	  }
	
	}( window, function factory( window, EvEmitter, getSize,
	    utils, Cell, Slide, animatePrototype ) {
	
	/* eslint-enable max-params */
	'use strict';
	
	// vars
	var jQuery = window.jQuery;
	var getComputedStyle = window.getComputedStyle;
	var console = window.console;
	
	function moveElements( elems, toElem ) {
	  elems = utils.makeArray( elems );
	  while ( elems.length ) {
	    toElem.appendChild( elems.shift() );
	  }
	}
	
	// -------------------------- Flickity -------------------------- //
	
	// globally unique identifiers
	var GUID = 0;
	// internal store of all Flickity intances
	var instances = {};
	
	function Flickity( element, options ) {
	  var queryElement = utils.getQueryElement( element );
	  if ( !queryElement ) {
	    if ( console ) {
	      console.error( 'Bad element for Flickity: ' + ( queryElement || element ) );
	    }
	    return;
	  }
	  this.element = queryElement;
	  // do not initialize twice on same element
	  if ( this.element.flickityGUID ) {
	    var instance = instances[ this.element.flickityGUID ];
	    if ( instance ) instance.option( options );
	    return instance;
	  }
	
	  // add jQuery
	  if ( jQuery ) {
	    this.$element = jQuery( this.element );
	  }
	  // options
	  this.options = utils.extend( {}, this.constructor.defaults );
	  this.option( options );
	
	  // kick things off
	  this._create();
	}
	
	Flickity.defaults = {
	  accessibility: true,
	  // adaptiveHeight: false,
	  cellAlign: 'center',
	  // cellSelector: undefined,
	  // contain: false,
	  freeScrollFriction: 0.075, // friction when free-scrolling
	  friction: 0.28, // friction when selecting
	  namespaceJQueryEvents: true,
	  // initialIndex: 0,
	  percentPosition: true,
	  resize: true,
	  selectedAttraction: 0.025,
	  setGallerySize: true,
	  // watchCSS: false,
	  // wrapAround: false
	};
	
	// hash of methods triggered on _create()
	Flickity.createMethods = [];
	
	var proto = Flickity.prototype;
	// inherit EventEmitter
	utils.extend( proto, EvEmitter.prototype );
	
	proto._create = function() {
	  // add id for Flickity.data
	  var id = this.guid = ++GUID;
	  this.element.flickityGUID = id; // expando
	  instances[ id ] = this; // associate via id
	  // initial properties
	  this.selectedIndex = 0;
	  // how many frames slider has been in same position
	  this.restingFrames = 0;
	  // initial physics properties
	  this.x = 0;
	  this.velocity = 0;
	  this.originSide = this.options.rightToLeft ? 'right' : 'left';
	  // create viewport & slider
	  this.viewport = document.createElement('div');
	  this.viewport.className = 'flickity-viewport';
	  this._createSlider();
	
	  if ( this.options.resize || this.options.watchCSS ) {
	    window.addEventListener( 'resize', this );
	  }
	
	  // add listeners from on option
	  for ( var eventName in this.options.on ) {
	    var listener = this.options.on[ eventName ];
	    this.on( eventName, listener );
	  }
	
	  Flickity.createMethods.forEach( function( method ) {
	    this[ method ]();
	  }, this );
	
	  if ( this.options.watchCSS ) {
	    this.watchCSS();
	  } else {
	    this.activate();
	  }
	
	};
	
	/**
	 * set options
	 * @param {Object} opts - options to extend
	 */
	proto.option = function( opts ) {
	  utils.extend( this.options, opts );
	};
	
	proto.activate = function() {
	  if ( this.isActive ) {
	    return;
	  }
	  this.isActive = true;
	  this.element.classList.add('flickity-enabled');
	  if ( this.options.rightToLeft ) {
	    this.element.classList.add('flickity-rtl');
	  }
	
	  this.getSize();
	  // move initial cell elements so they can be loaded as cells
	  var cellElems = this._filterFindCellElements( this.element.children );
	  moveElements( cellElems, this.slider );
	  this.viewport.appendChild( this.slider );
	  this.element.appendChild( this.viewport );
	  // get cells from children
	  this.reloadCells();
	
	  if ( this.options.accessibility ) {
	    // allow element to focusable
	    this.element.tabIndex = 0;
	    // listen for key presses
	    this.element.addEventListener( 'keydown', this );
	  }
	
	  this.emitEvent('activate');
	  this.selectInitialIndex();
	  // flag for initial activation, for using initialIndex
	  this.isInitActivated = true;
	  // ready event. #493
	  this.dispatchEvent('ready');
	};
	
	// slider positions the cells
	proto._createSlider = function() {
	  // slider element does all the positioning
	  var slider = document.createElement('div');
	  slider.className = 'flickity-slider';
	  slider.style[ this.originSide ] = 0;
	  this.slider = slider;
	};
	
	proto._filterFindCellElements = function( elems ) {
	  return utils.filterFindElements( elems, this.options.cellSelector );
	};
	
	// goes through all children
	proto.reloadCells = function() {
	  // collection of item elements
	  this.cells = this._makeCells( this.slider.children );
	  this.positionCells();
	  this._getWrapShiftCells();
	  this.setGallerySize();
	};
	
	/**
	 * turn elements into Flickity.Cells
	 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
	 * @returns {Array} items - collection of new Flickity Cells
	 */
	proto._makeCells = function( elems ) {
	  var cellElems = this._filterFindCellElements( elems );
	
	  // create new Flickity for collection
	  var cells = cellElems.map( function( cellElem ) {
	    return new Cell( cellElem, this );
	  }, this );
	
	  return cells;
	};
	
	proto.getLastCell = function() {
	  return this.cells[ this.cells.length - 1 ];
	};
	
	proto.getLastSlide = function() {
	  return this.slides[ this.slides.length - 1 ];
	};
	
	// positions all cells
	proto.positionCells = function() {
	  // size all cells
	  this._sizeCells( this.cells );
	  // position all cells
	  this._positionCells( 0 );
	};
	
	/**
	 * position certain cells
	 * @param {Integer} index - which cell to start with
	 */
	proto._positionCells = function( index ) {
	  index = index || 0;
	  // also measure maxCellHeight
	  // start 0 if positioning all cells
	  this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
	  var cellX = 0;
	  // get cellX
	  if ( index > 0 ) {
	    var startCell = this.cells[ index - 1 ];
	    cellX = startCell.x + startCell.size.outerWidth;
	  }
	  var len = this.cells.length;
	  for ( var i = index; i < len; i++ ) {
	    var cell = this.cells[i];
	    cell.setPosition( cellX );
	    cellX += cell.size.outerWidth;
	    this.maxCellHeight = Math.max( cell.size.outerHeight, this.maxCellHeight );
	  }
	  // keep track of cellX for wrap-around
	  this.slideableWidth = cellX;
	  // slides
	  this.updateSlides();
	  // contain slides target
	  this._containSlides();
	  // update slidesWidth
	  this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
	};
	
	/**
	 * cell.getSize() on multiple cells
	 * @param {Array} cells - cells to size
	 */
	proto._sizeCells = function( cells ) {
	  cells.forEach( function( cell ) {
	    cell.getSize();
	  } );
	};
	
	// --------------------------  -------------------------- //
	
	proto.updateSlides = function() {
	  this.slides = [];
	  if ( !this.cells.length ) {
	    return;
	  }
	
	  var slide = new Slide( this );
	  this.slides.push( slide );
	  var isOriginLeft = this.originSide == 'left';
	  var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';
	
	  var canCellFit = this._getCanCellFit();
	
	  this.cells.forEach( function( cell, i ) {
	    // just add cell if first cell in slide
	    if ( !slide.cells.length ) {
	      slide.addCell( cell );
	      return;
	    }
	
	    var slideWidth = ( slide.outerWidth - slide.firstMargin ) +
	      ( cell.size.outerWidth - cell.size[ nextMargin ] );
	
	    if ( canCellFit.call( this, i, slideWidth ) ) {
	      slide.addCell( cell );
	    } else {
	      // doesn't fit, new slide
	      slide.updateTarget();
	
	      slide = new Slide( this );
	      this.slides.push( slide );
	      slide.addCell( cell );
	    }
	  }, this );
	  // last slide
	  slide.updateTarget();
	  // update .selectedSlide
	  this.updateSelectedSlide();
	};
	
	proto._getCanCellFit = function() {
	  var groupCells = this.options.groupCells;
	  if ( !groupCells ) {
	    return function() {
	      return false;
	    };
	  } else if ( typeof groupCells == 'number' ) {
	    // group by number. 3 -> [0,1,2], [3,4,5], ...
	    var number = parseInt( groupCells, 10 );
	    return function( i ) {
	      return ( i % number ) !== 0;
	    };
	  }
	  // default, group by width of slide
	  // parse '75%
	  var percentMatch = typeof groupCells == 'string' &&
	    groupCells.match( /^(\d+)%$/ );
	  var percent = percentMatch ? parseInt( percentMatch[1], 10 ) / 100 : 1;
	  return function( i, slideWidth ) {
	    /* eslint-disable-next-line no-invalid-this */
	    return slideWidth <= ( this.size.innerWidth + 1 ) * percent;
	  };
	};
	
	// alias _init for jQuery plugin .flickity()
	proto._init =
	proto.reposition = function() {
	  this.positionCells();
	  this.positionSliderAtSelected();
	};
	
	proto.getSize = function() {
	  this.size = getSize( this.element );
	  this.setCellAlign();
	  this.cursorPosition = this.size.innerWidth * this.cellAlign;
	};
	
	var cellAlignShorthands = {
	  // cell align, then based on origin side
	  center: {
	    left: 0.5,
	    right: 0.5,
	  },
	  left: {
	    left: 0,
	    right: 1,
	  },
	  right: {
	    right: 0,
	    left: 1,
	  },
	};
	
	proto.setCellAlign = function() {
	  var shorthand = cellAlignShorthands[ this.options.cellAlign ];
	  this.cellAlign = shorthand ? shorthand[ this.originSide ] : this.options.cellAlign;
	};
	
	proto.setGallerySize = function() {
	  if ( this.options.setGallerySize ) {
	    var height = this.options.adaptiveHeight && this.selectedSlide ?
	      this.selectedSlide.height : this.maxCellHeight;
	    this.viewport.style.height = height + 'px';
	  }
	};
	
	proto._getWrapShiftCells = function() {
	  // only for wrap-around
	  if ( !this.options.wrapAround ) {
	    return;
	  }
	  // unshift previous cells
	  this._unshiftCells( this.beforeShiftCells );
	  this._unshiftCells( this.afterShiftCells );
	  // get before cells
	  // initial gap
	  var gapX = this.cursorPosition;
	  var cellIndex = this.cells.length - 1;
	  this.beforeShiftCells = this._getGapCells( gapX, cellIndex, -1 );
	  // get after cells
	  // ending gap between last cell and end of gallery viewport
	  gapX = this.size.innerWidth - this.cursorPosition;
	  // start cloning at first cell, working forwards
	  this.afterShiftCells = this._getGapCells( gapX, 0, 1 );
	};
	
	proto._getGapCells = function( gapX, cellIndex, increment ) {
	  // keep adding cells until the cover the initial gap
	  var cells = [];
	  while ( gapX > 0 ) {
	    var cell = this.cells[ cellIndex ];
	    if ( !cell ) {
	      break;
	    }
	    cells.push( cell );
	    cellIndex += increment;
	    gapX -= cell.size.outerWidth;
	  }
	  return cells;
	};
	
	// ----- contain ----- //
	
	// contain cell targets so no excess sliding
	proto._containSlides = function() {
	  if ( !this.options.contain || this.options.wrapAround || !this.cells.length ) {
	    return;
	  }
	  var isRightToLeft = this.options.rightToLeft;
	  var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
	  var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
	  var contentWidth = this.slideableWidth - this.getLastCell().size[ endMargin ];
	  // content is less than gallery size
	  var isContentSmaller = contentWidth < this.size.innerWidth;
	  // bounds
	  var beginBound = this.cursorPosition + this.cells[0].size[ beginMargin ];
	  var endBound = contentWidth - this.size.innerWidth * ( 1 - this.cellAlign );
	  // contain each cell target
	  this.slides.forEach( function( slide ) {
	    if ( isContentSmaller ) {
	      // all cells fit inside gallery
	      slide.target = contentWidth * this.cellAlign;
	    } else {
	      // contain to bounds
	      slide.target = Math.max( slide.target, beginBound );
	      slide.target = Math.min( slide.target, endBound );
	    }
	  }, this );
	};
	
	// -----  ----- //
	
	/**
	 * emits events via eventEmitter and jQuery events
	 * @param {String} type - name of event
	 * @param {Event} event - original event
	 * @param {Array} args - extra arguments
	 */
	proto.dispatchEvent = function( type, event, args ) {
	  var emitArgs = event ? [ event ].concat( args ) : args;
	  this.emitEvent( type, emitArgs );
	
	  if ( jQuery && this.$element ) {
	    // default trigger with type if no event
	    type += this.options.namespaceJQueryEvents ? '.flickity' : '';
	    var $event = type;
	    if ( event ) {
	      // create jQuery event
	      var jQEvent = new jQuery.Event( event );
	      jQEvent.type = type;
	      $event = jQEvent;
	    }
	    this.$element.trigger( $event, args );
	  }
	};
	
	// -------------------------- select -------------------------- //
	
	/**
	 * @param {Integer} index - index of the slide
	 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
	 * @param {Boolean} isInstant - will immediately set position at selected cell
	 */
	proto.select = function( index, isWrap, isInstant ) {
	  if ( !this.isActive ) {
	    return;
	  }
	  index = parseInt( index, 10 );
	  this._wrapSelect( index );
	
	  if ( this.options.wrapAround || isWrap ) {
	    index = utils.modulo( index, this.slides.length );
	  }
	  // bail if invalid index
	  if ( !this.slides[ index ] ) {
	    return;
	  }
	  var prevIndex = this.selectedIndex;
	  this.selectedIndex = index;
	  this.updateSelectedSlide();
	  if ( isInstant ) {
	    this.positionSliderAtSelected();
	  } else {
	    this.startAnimation();
	  }
	  if ( this.options.adaptiveHeight ) {
	    this.setGallerySize();
	  }
	  // events
	  this.dispatchEvent( 'select', null, [ index ] );
	  // change event if new index
	  if ( index != prevIndex ) {
	    this.dispatchEvent( 'change', null, [ index ] );
	  }
	  // old v1 event name, remove in v3
	  this.dispatchEvent('cellSelect');
	};
	
	// wraps position for wrapAround, to move to closest slide. #113
	proto._wrapSelect = function( index ) {
	  var len = this.slides.length;
	  var isWrapping = this.options.wrapAround && len > 1;
	  if ( !isWrapping ) {
	    return index;
	  }
	  var wrapIndex = utils.modulo( index, len );
	  // go to shortest
	  var delta = Math.abs( wrapIndex - this.selectedIndex );
	  var backWrapDelta = Math.abs( ( wrapIndex + len ) - this.selectedIndex );
	  var forewardWrapDelta = Math.abs( ( wrapIndex - len ) - this.selectedIndex );
	  if ( !this.isDragSelect && backWrapDelta < delta ) {
	    index += len;
	  } else if ( !this.isDragSelect && forewardWrapDelta < delta ) {
	    index -= len;
	  }
	  // wrap position so slider is within normal area
	  if ( index < 0 ) {
	    this.x -= this.slideableWidth;
	  } else if ( index >= len ) {
	    this.x += this.slideableWidth;
	  }
	};
	
	proto.previous = function( isWrap, isInstant ) {
	  this.select( this.selectedIndex - 1, isWrap, isInstant );
	};
	
	proto.next = function( isWrap, isInstant ) {
	  this.select( this.selectedIndex + 1, isWrap, isInstant );
	};
	
	proto.updateSelectedSlide = function() {
	  var slide = this.slides[ this.selectedIndex ];
	  // selectedIndex could be outside of slides, if triggered before resize()
	  if ( !slide ) {
	    return;
	  }
	  // unselect previous selected slide
	  this.unselectSelectedSlide();
	  // update new selected slide
	  this.selectedSlide = slide;
	  slide.select();
	  this.selectedCells = slide.cells;
	  this.selectedElements = slide.getCellElements();
	  // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
	  // Remove in v3?
	  this.selectedCell = slide.cells[0];
	  this.selectedElement = this.selectedElements[0];
	};
	
	proto.unselectSelectedSlide = function() {
	  if ( this.selectedSlide ) {
	    this.selectedSlide.unselect();
	  }
	};
	
	proto.selectInitialIndex = function() {
	  var initialIndex = this.options.initialIndex;
	  // already activated, select previous selectedIndex
	  if ( this.isInitActivated ) {
	    this.select( this.selectedIndex, false, true );
	    return;
	  }
	  // select with selector string
	  if ( initialIndex && typeof initialIndex == 'string' ) {
	    var cell = this.queryCell( initialIndex );
	    if ( cell ) {
	      this.selectCell( initialIndex, false, true );
	      return;
	    }
	  }
	
	  var index = 0;
	  // select with number
	  if ( initialIndex && this.slides[ initialIndex ] ) {
	    index = initialIndex;
	  }
	  // select instantly
	  this.select( index, false, true );
	};
	
	/**
	 * select slide from number or cell element
	 * @param {[Element, Number]} value - zero-based index or element to select
	 * @param {Boolean} isWrap - enables wrapping around for extra index
	 * @param {Boolean} isInstant - disables slide animation
	 */
	proto.selectCell = function( value, isWrap, isInstant ) {
	  // get cell
	  var cell = this.queryCell( value );
	  if ( !cell ) {
	    return;
	  }
	
	  var index = this.getCellSlideIndex( cell );
	  this.select( index, isWrap, isInstant );
	};
	
	proto.getCellSlideIndex = function( cell ) {
	  // get index of slides that has cell
	  for ( var i = 0; i < this.slides.length; i++ ) {
	    var slide = this.slides[i];
	    var index = slide.cells.indexOf( cell );
	    if ( index != -1 ) {
	      return i;
	    }
	  }
	};
	
	// -------------------------- get cells -------------------------- //
	
	/**
	 * get Flickity.Cell, given an Element
	 * @param {Element} elem - matching cell element
	 * @returns {Flickity.Cell} cell - matching cell
	 */
	proto.getCell = function( elem ) {
	  // loop through cells to get the one that matches
	  for ( var i = 0; i < this.cells.length; i++ ) {
	    var cell = this.cells[i];
	    if ( cell.element == elem ) {
	      return cell;
	    }
	  }
	};
	
	/**
	 * get collection of Flickity.Cells, given Elements
	 * @param {[Element, Array, NodeList]} elems - multiple elements
	 * @returns {Array} cells - Flickity.Cells
	 */
	proto.getCells = function( elems ) {
	  elems = utils.makeArray( elems );
	  var cells = [];
	  elems.forEach( function( elem ) {
	    var cell = this.getCell( elem );
	    if ( cell ) {
	      cells.push( cell );
	    }
	  }, this );
	  return cells;
	};
	
	/**
	 * get cell elements
	 * @returns {Array} cellElems
	 */
	proto.getCellElements = function() {
	  return this.cells.map( function( cell ) {
	    return cell.element;
	  } );
	};
	
	/**
	 * get parent cell from an element
	 * @param {Element} elem - child element
	 * @returns {Flickit.Cell} cell - parent cell
	 */
	proto.getParentCell = function( elem ) {
	  // first check if elem is cell
	  var cell = this.getCell( elem );
	  if ( cell ) {
	    return cell;
	  }
	  // try to get parent cell elem
	  elem = utils.getParent( elem, '.flickity-slider > *' );
	  return this.getCell( elem );
	};
	
	/**
	 * get cells adjacent to a slide
	 * @param {Integer} adjCount - number of adjacent slides
	 * @param {Integer} index - index of slide to start
	 * @returns {Array} cells - array of Flickity.Cells
	 */
	proto.getAdjacentCellElements = function( adjCount, index ) {
	  if ( !adjCount ) {
	    return this.selectedSlide.getCellElements();
	  }
	  index = index === undefined ? this.selectedIndex : index;
	
	  var len = this.slides.length;
	  if ( 1 + ( adjCount * 2 ) >= len ) {
	    return this.getCellElements();
	  }
	
	  var cellElems = [];
	  for ( var i = index - adjCount; i <= index + adjCount; i++ ) {
	    var slideIndex = this.options.wrapAround ? utils.modulo( i, len ) : i;
	    var slide = this.slides[ slideIndex ];
	    if ( slide ) {
	      cellElems = cellElems.concat( slide.getCellElements() );
	    }
	  }
	  return cellElems;
	};
	
	/**
	 * select slide from number or cell element
	 * @param {[Element, String, Number]} selector - element, selector string, or index
	 * @returns {Flickity.Cell} - matching cell
	 */
	proto.queryCell = function( selector ) {
	  if ( typeof selector == 'number' ) {
	    // use number as index
	    return this.cells[ selector ];
	  }
	  if ( typeof selector == 'string' ) {
	    // do not select invalid selectors from hash: #123, #/. #791
	    if ( selector.match( /^[#.]?[\d/]/ ) ) {
	      return;
	    }
	    // use string as selector, get element
	    selector = this.element.querySelector( selector );
	  }
	  // get cell from element
	  return this.getCell( selector );
	};
	
	// -------------------------- events -------------------------- //
	
	proto.uiChange = function() {
	  this.emitEvent('uiChange');
	};
	
	// keep focus on element when child UI elements are clicked
	proto.childUIPointerDown = function( event ) {
	  // HACK iOS does not allow touch events to bubble up?!
	  if ( event.type != 'touchstart' ) {
	    event.preventDefault();
	  }
	  this.focus();
	};
	
	// ----- resize ----- //
	
	proto.onresize = function() {
	  this.watchCSS();
	  this.resize();
	};
	
	utils.debounceMethod( Flickity, 'onresize', 150 );
	
	proto.resize = function() {
	  // #1177 disable resize behavior when animating or dragging for iOS 15
	  if ( !this.isActive || this.isAnimating || this.isDragging ) {
	    return;
	  }
	  this.getSize();
	  // wrap values
	  if ( this.options.wrapAround ) {
	    this.x = utils.modulo( this.x, this.slideableWidth );
	  }
	  this.positionCells();
	  this._getWrapShiftCells();
	  this.setGallerySize();
	  this.emitEvent('resize');
	  // update selected index for group slides, instant
	  // TODO: position can be lost between groups of various numbers
	  var selectedElement = this.selectedElements && this.selectedElements[0];
	  this.selectCell( selectedElement, false, true );
	};
	
	// watches the :after property, activates/deactivates
	proto.watchCSS = function() {
	  var watchOption = this.options.watchCSS;
	  if ( !watchOption ) {
	    return;
	  }
	
	  var afterContent = getComputedStyle( this.element, ':after' ).content;
	  // activate if :after { content: 'flickity' }
	  if ( afterContent.indexOf('flickity') != -1 ) {
	    this.activate();
	  } else {
	    this.deactivate();
	  }
	};
	
	// ----- keydown ----- //
	
	// go previous/next if left/right keys pressed
	proto.onkeydown = function( event ) {
	  // only work if element is in focus
	  var isNotFocused = document.activeElement && document.activeElement != this.element;
	  if ( !this.options.accessibility || isNotFocused ) {
	    return;
	  }
	
	  var handler = Flickity.keyboardHandlers[ event.keyCode ];
	  if ( handler ) {
	    handler.call( this );
	  }
	};
	
	Flickity.keyboardHandlers = {
	  // left arrow
	  37: function() {
	    var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
	    this.uiChange();
	    this[ leftMethod ]();
	  },
	  // right arrow
	  39: function() {
	    var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
	    this.uiChange();
	    this[ rightMethod ]();
	  },
	};
	
	// ----- focus ----- //
	
	proto.focus = function() {
	  // TODO remove scrollTo once focus options gets more support
	  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
	  //    #Browser_compatibility
	  var prevScrollY = window.pageYOffset;
	  this.element.focus({ preventScroll: true });
	  // hack to fix scroll jump after focus, #76
	  if ( window.pageYOffset != prevScrollY ) {
	    window.scrollTo( window.pageXOffset, prevScrollY );
	  }
	};
	
	// -------------------------- destroy -------------------------- //
	
	// deactivate all Flickity functionality, but keep stuff available
	proto.deactivate = function() {
	  if ( !this.isActive ) {
	    return;
	  }
	  this.element.classList.remove('flickity-enabled');
	  this.element.classList.remove('flickity-rtl');
	  this.unselectSelectedSlide();
	  // destroy cells
	  this.cells.forEach( function( cell ) {
	    cell.destroy();
	  } );
	  this.element.removeChild( this.viewport );
	  // move child elements back into element
	  moveElements( this.slider.children, this.element );
	  if ( this.options.accessibility ) {
	    this.element.removeAttribute('tabIndex');
	    this.element.removeEventListener( 'keydown', this );
	  }
	  // set flags
	  this.isActive = false;
	  this.emitEvent('deactivate');
	};
	
	proto.destroy = function() {
	  this.deactivate();
	  window.removeEventListener( 'resize', this );
	  this.allOff();
	  this.emitEvent('destroy');
	  if ( jQuery && this.$element ) {
	    jQuery.removeData( this.element, 'flickity' );
	  }
	  delete this.element.flickityGUID;
	  delete instances[ this.guid ];
	};
	
	// -------------------------- prototype -------------------------- //
	
	utils.extend( proto, animatePrototype );
	
	// -------------------------- extras -------------------------- //
	
	/**
	 * get Flickity instance from element
	 * @param {[Element, String]} elem - element or selector string
	 * @returns {Flickity} - Flickity instance
	 */
	Flickity.data = function( elem ) {
	  elem = utils.getQueryElement( elem );
	  var id = elem && elem.flickityGUID;
	  return id && instances[ id ];
	};
	
	utils.htmlInit( Flickity, 'flickity' );
	
	if ( jQuery && jQuery.bridget ) {
	  jQuery.bridget( 'flickity', Flickity );
	}
	
	// set internal jQuery, for Webpack + jQuery v3, #478
	Flickity.setJQuery = function( jq ) {
	  jQuery = jq;
	};
	
	Flickity.Cell = Cell;
	Flickity.Slide = Slide;
	
	return Flickity;
	
	} ) );


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	/**
	 * 事件扩展
	 * @module zrender/mixin/Eventful
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         pissang (https://www.github.com/pissang)
	 */
	var arrySlice = Array.prototype.slice;
	/**
	 * 事件分发器
	 * @alias module:zrender/mixin/Eventful
	 * @constructor
	 */
	
	var Eventful = function () {
	  this._$handlers = {};
	};
	
	Eventful.prototype = {
	  constructor: Eventful,
	
	  /**
	   * 单次触发绑定，trigger后销毁
	   *
	   * @param {string} event 事件名
	   * @param {Function} handler 响应函数
	   * @param {Object} context
	   */
	  one: function (event, handler, context) {
	    var _h = this._$handlers;
	
	    if (!handler || !event) {
	      return this;
	    }
	
	    if (!_h[event]) {
	      _h[event] = [];
	    }
	
	    for (var i = 0; i < _h[event].length; i++) {
	      if (_h[event][i].h === handler) {
	        return this;
	      }
	    }
	
	    _h[event].push({
	      h: handler,
	      one: true,
	      ctx: context || this
	    });
	
	    return this;
	  },
	
	  /**
	   * 绑定事件
	   * @param {string} event 事件名
	   * @param {Function} handler 事件处理函数
	   * @param {Object} [context]
	   */
	  on: function (event, handler, context) {
	    var _h = this._$handlers;
	
	    if (!handler || !event) {
	      return this;
	    }
	
	    if (!_h[event]) {
	      _h[event] = [];
	    }
	
	    for (var i = 0; i < _h[event].length; i++) {
	      if (_h[event][i].h === handler) {
	        return this;
	      }
	    }
	
	    _h[event].push({
	      h: handler,
	      one: false,
	      ctx: context || this
	    });
	
	    return this;
	  },
	
	  /**
	   * 是否绑定了事件
	   * @param  {string}  event
	   * @return {boolean}
	   */
	  isSilent: function (event) {
	    var _h = this._$handlers;
	    return _h[event] && _h[event].length;
	  },
	
	  /**
	   * 解绑事件
	   * @param {string} event 事件名
	   * @param {Function} [handler] 事件处理函数
	   */
	  off: function (event, handler) {
	    var _h = this._$handlers;
	
	    if (!event) {
	      this._$handlers = {};
	      return this;
	    }
	
	    if (handler) {
	      if (_h[event]) {
	        var newList = [];
	
	        for (var i = 0, l = _h[event].length; i < l; i++) {
	          if (_h[event][i]['h'] != handler) {
	            newList.push(_h[event][i]);
	          }
	        }
	
	        _h[event] = newList;
	      }
	
	      if (_h[event] && _h[event].length === 0) {
	        delete _h[event];
	      }
	    } else {
	      delete _h[event];
	    }
	
	    return this;
	  },
	
	  /**
	   * 事件分发
	   *
	   * @param {string} type 事件类型
	   */
	  trigger: function (type) {
	    if (this._$handlers[type]) {
	      var args = arguments;
	      var argLen = args.length;
	
	      if (argLen > 3) {
	        args = arrySlice.call(args, 1);
	      }
	
	      var _h = this._$handlers[type];
	      var len = _h.length;
	
	      for (var i = 0; i < len;) {
	        // Optimize advise from backbone
	        switch (argLen) {
	          case 1:
	            _h[i]['h'].call(_h[i]['ctx']);
	
	            break;
	
	          case 2:
	            _h[i]['h'].call(_h[i]['ctx'], args[1]);
	
	            break;
	
	          case 3:
	            _h[i]['h'].call(_h[i]['ctx'], args[1], args[2]);
	
	            break;
	
	          default:
	            // have more than 2 given arguments
	            _h[i]['h'].apply(_h[i]['ctx'], args);
	
	            break;
	        }
	
	        if (_h[i]['one']) {
	          _h.splice(i, 1);
	
	          len--;
	        } else {
	          i++;
	        }
	      }
	    }
	
	    return this;
	  },
	
	  /**
	   * 带有context的事件分发, 最后一个参数是事件回调的context
	   * @param {string} type 事件类型
	   */
	  triggerWithContext: function (type) {
	    if (this._$handlers[type]) {
	      var args = arguments;
	      var argLen = args.length;
	
	      if (argLen > 4) {
	        args = arrySlice.call(args, 1, args.length - 1);
	      }
	
	      var ctx = args[args.length - 1];
	      var _h = this._$handlers[type];
	      var len = _h.length;
	
	      for (var i = 0; i < len;) {
	        // Optimize advise from backbone
	        switch (argLen) {
	          case 1:
	            _h[i]['h'].call(ctx);
	
	            break;
	
	          case 2:
	            _h[i]['h'].call(ctx, args[1]);
	
	            break;
	
	          case 3:
	            _h[i]['h'].call(ctx, args[1], args[2]);
	
	            break;
	
	          default:
	            // have more than 2 given arguments
	            _h[i]['h'].apply(ctx, args);
	
	            break;
	        }
	
	        if (_h[i]['one']) {
	          _h.splice(i, 1);
	
	          len--;
	        } else {
	          i++;
	        }
	      }
	    }
	
	    return this;
	  }
	}; // 对象可以通过 onxxxx 绑定事件
	
	/**
	 * @event module:zrender/mixin/Eventful#onclick
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseover
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseout
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousemove
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousewheel
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousedown
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseup
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondrag
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragstart
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragend
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragenter
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragleave
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragover
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondrop
	 * @type {Function}
	 * @default null
	 */
	
	var _default = Eventful;
	module.exports = _default;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(53);
	var createDesc = __webpack_require__(80);
	module.exports = __webpack_require__(41) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(62);
	var IE8_DOM_DEFINE = __webpack_require__(144);
	var toPrimitive = __webpack_require__(111);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(41) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(145);
	var defined = __webpack_require__(104);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var axisHelper = __webpack_require__(21);
	
	function getName(obj) {
	  if (zrUtil.isObject(obj) && obj.value != null) {
	    return obj.value;
	  } else {
	    return obj + '';
	  }
	}
	
	var _default = {
	  /**
	   * Format labels
	   * @return {Array.<string>}
	   */
	  getFormattedLabels: function () {
	    return axisHelper.getFormattedLabels(this.axis, this.get('axisLabel.formatter'));
	  },
	
	  /**
	   * Get categories
	   */
	  getCategories: function () {
	    return this.get('type') === 'category' && zrUtil.map(this.get('data'), getName);
	  },
	
	  /**
	   * @param {boolean} origin
	   * @return {number|string} min value or 'dataMin' or null/undefined (means auto) or NaN
	   */
	  getMin: function (origin) {
	    var option = this.option;
	    var min = !origin && option.rangeStart != null ? option.rangeStart : option.min;
	
	    if (this.axis && min != null && min !== 'dataMin' && typeof min !== 'function' && !zrUtil.eqNaN(min)) {
	      min = this.axis.scale.parse(min);
	    }
	
	    return min;
	  },
	
	  /**
	   * @param {boolean} origin
	   * @return {number|string} max value or 'dataMax' or null/undefined (means auto) or NaN
	   */
	  getMax: function (origin) {
	    var option = this.option;
	    var max = !origin && option.rangeEnd != null ? option.rangeEnd : option.max;
	
	    if (this.axis && max != null && max !== 'dataMax' && typeof max !== 'function' && !zrUtil.eqNaN(max)) {
	      max = this.axis.scale.parse(max);
	    }
	
	    return max;
	  },
	
	  /**
	   * @return {boolean}
	   */
	  getNeedCrossZero: function () {
	    var option = this.option;
	    return option.rangeStart != null || option.rangeEnd != null ? false : !option.scale;
	  },
	
	  /**
	   * Should be implemented by each axis model if necessary.
	   * @return {module:echarts/model/Component} coordinate system model
	   */
	  getCoordSysModel: zrUtil.noop,
	
	  /**
	   * @param {number} rangeStart Can only be finite number or null/undefined or NaN.
	   * @param {number} rangeEnd Can only be finite number or null/undefined or NaN.
	   */
	  setRange: function (rangeStart, rangeEnd) {
	    this.option.rangeStart = rangeStart;
	    this.option.rangeEnd = rangeEnd;
	  },
	
	  /**
	   * Reset range
	   */
	  resetRange: function () {
	    // rangeStart and rangeEnd is readonly.
	    this.option.rangeStart = this.option.rangeEnd = null;
	  }
	};
	module.exports = _default;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	function defaultKeyGetter(item) {
	  return item;
	}
	/**
	 * @param {Array} oldArr
	 * @param {Array} newArr
	 * @param {Function} oldKeyGetter
	 * @param {Function} newKeyGetter
	 * @param {Object} [context] Can be visited by this.context in callback.
	 */
	
	
	function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context) {
	  this._old = oldArr;
	  this._new = newArr;
	  this._oldKeyGetter = oldKeyGetter || defaultKeyGetter;
	  this._newKeyGetter = newKeyGetter || defaultKeyGetter;
	  this.context = context;
	}
	
	DataDiffer.prototype = {
	  constructor: DataDiffer,
	
	  /**
	   * Callback function when add a data
	   */
	  add: function (func) {
	    this._add = func;
	    return this;
	  },
	
	  /**
	   * Callback function when update a data
	   */
	  update: function (func) {
	    this._update = func;
	    return this;
	  },
	
	  /**
	   * Callback function when remove a data
	   */
	  remove: function (func) {
	    this._remove = func;
	    return this;
	  },
	  execute: function () {
	    var oldArr = this._old;
	    var newArr = this._new;
	    var oldDataIndexMap = {};
	    var newDataIndexMap = {};
	    var oldDataKeyArr = [];
	    var newDataKeyArr = [];
	    var i;
	    initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter', this);
	    initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter', this); // Travel by inverted order to make sure order consistency
	    // when duplicate keys exists (consider newDataIndex.pop() below).
	    // For performance consideration, these code below do not look neat.
	
	    for (i = 0; i < oldArr.length; i++) {
	      var key = oldDataKeyArr[i];
	      var idx = newDataIndexMap[key]; // idx can never be empty array here. see 'set null' logic below.
	
	      if (idx != null) {
	        // Consider there is duplicate key (for example, use dataItem.name as key).
	        // We should make sure every item in newArr and oldArr can be visited.
	        var len = idx.length;
	
	        if (len) {
	          len === 1 && (newDataIndexMap[key] = null);
	          idx = idx.unshift();
	        } else {
	          newDataIndexMap[key] = null;
	        }
	
	        this._update && this._update(idx, i);
	      } else {
	        this._remove && this._remove(i);
	      }
	    }
	
	    for (var i = 0; i < newDataKeyArr.length; i++) {
	      var key = newDataKeyArr[i];
	
	      if (newDataIndexMap.hasOwnProperty(key)) {
	        var idx = newDataIndexMap[key];
	
	        if (idx == null) {
	          continue;
	        } // idx can never be empty array here. see 'set null' logic above.
	
	
	        if (!idx.length) {
	          this._add && this._add(idx);
	        } else {
	          for (var j = 0, len = idx.length; j < len; j++) {
	            this._add && this._add(idx[j]);
	          }
	        }
	      }
	    }
	  }
	};
	
	function initIndexMap(arr, map, keyArr, keyGetterName, dataDiffer) {
	  for (var i = 0; i < arr.length; i++) {
	    // Add prefix to avoid conflict with Object.prototype.
	    var key = '_ec_' + dataDiffer[keyGetterName](arr[i], i);
	    var existence = map[key];
	
	    if (existence == null) {
	      keyArr.push(key);
	      map[key] = i;
	    } else {
	      if (!existence.length) {
	        map[key] = existence = [existence];
	      }
	
	      existence.push(i);
	    }
	  }
	}
	
	var _default = DataDiffer;
	module.exports = _default;

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	var _default = {
	  toolbox: {
	    brush: {
	      title: {
	        rect: '矩形选择',
	        polygon: '圈选',
	        lineX: '横向选择',
	        lineY: '纵向选择',
	        keep: '保持选择',
	        clear: '清除选择'
	      }
	    },
	    dataView: {
	      title: '数据视图',
	      lang: ['数据视图', '关闭', '刷新']
	    },
	    dataZoom: {
	      title: {
	        zoom: '区域缩放',
	        back: '区域缩放还原'
	      }
	    },
	    magicType: {
	      title: {
	        line: '切换为折线图',
	        bar: '切换为柱状图',
	        stack: '切换为堆叠',
	        tiled: '切换为平铺'
	      }
	    },
	    restore: {
	      title: '还原'
	    },
	    saveAsImage: {
	      title: '保存为图片',
	      lang: ['右键另存为图片']
	    }
	  }
	};
	module.exports = _default;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	// TODO Parse shadow style
	// TODO Only shallow path support
	function _default(properties) {
	  // Normalize
	  for (var i = 0; i < properties.length; i++) {
	    if (!properties[i][1]) {
	      properties[i][1] = properties[i][0];
	    }
	  }
	
	  return function (model, excludes, includes) {
	    var style = {};
	
	    for (var i = 0; i < properties.length; i++) {
	      var propName = properties[i][1];
	
	      if (excludes && zrUtil.indexOf(excludes, propName) >= 0 || includes && zrUtil.indexOf(includes, propName) < 0) {
	        continue;
	      }
	
	      var val = model.getShallow(propName);
	
	      if (val != null) {
	        style[properties[i][0]] = val;
	      }
	    }
	
	    return style;
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var curve = __webpack_require__(40);
	
	var vec2 = __webpack_require__(8);
	
	var bbox = __webpack_require__(136);
	
	var BoundingRect = __webpack_require__(13);
	
	var _config = __webpack_require__(96);
	
	var dpr = _config.devicePixelRatio;
	
	/**
	 * Path 代理，可以在`buildPath`中用于替代`ctx`, 会保存每个path操作的命令到pathCommands属性中
	 * 可以用于 isInsidePath 判断以及获取boundingRect
	 *
	 * @module zrender/core/PathProxy
	 * @author Yi Shen (http://www.github.com/pissang)
	 */
	// TODO getTotalLength, getPointAtLength
	var CMD = {
	  M: 1,
	  L: 2,
	  C: 3,
	  Q: 4,
	  A: 5,
	  Z: 6,
	  // Rect
	  R: 7
	}; // var CMD_MEM_SIZE = {
	//     M: 3,
	//     L: 3,
	//     C: 7,
	//     Q: 5,
	//     A: 9,
	//     R: 5,
	//     Z: 1
	// };
	
	var min = [];
	var max = [];
	var min2 = [];
	var max2 = [];
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathCos = Math.cos;
	var mathSin = Math.sin;
	var mathSqrt = Math.sqrt;
	var mathAbs = Math.abs;
	var hasTypedArray = typeof Float32Array != 'undefined';
	/**
	 * @alias module:zrender/core/PathProxy
	 * @constructor
	 */
	
	var PathProxy = function (notSaveData) {
	  this._saveData = !(notSaveData || false);
	
	  if (this._saveData) {
	    /**
	     * Path data. Stored as flat array
	     * @type {Array.<Object>}
	     */
	    this.data = [];
	  }
	
	  this._ctx = null;
	};
	/**
	 * 快速计算Path包围盒（并不是最小包围盒）
	 * @return {Object}
	 */
	
	
	PathProxy.prototype = {
	  constructor: PathProxy,
	  _xi: 0,
	  _yi: 0,
	  _x0: 0,
	  _y0: 0,
	  // Unit x, Unit y. Provide for avoiding drawing that too short line segment
	  _ux: 0,
	  _uy: 0,
	  _len: 0,
	  _lineDash: null,
	  _dashOffset: 0,
	  _dashIdx: 0,
	  _dashSum: 0,
	
	  /**
	   * @readOnly
	   */
	  setScale: function (sx, sy) {
	    this._ux = mathAbs(1 / dpr / sx) || 0;
	    this._uy = mathAbs(1 / dpr / sy) || 0;
	  },
	  getContext: function () {
	    return this._ctx;
	  },
	
	  /**
	   * @param  {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  beginPath: function (ctx) {
	    this._ctx = ctx;
	    ctx && ctx.beginPath();
	    ctx && (this.dpr = ctx.dpr); // Reset
	
	    if (this._saveData) {
	      this._len = 0;
	    }
	
	    if (this._lineDash) {
	      this._lineDash = null;
	      this._dashOffset = 0;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param  {number} x
	   * @param  {number} y
	   * @return {module:zrender/core/PathProxy}
	   */
	  moveTo: function (x, y) {
	    this.addData(CMD.M, x, y);
	    this._ctx && this._ctx.moveTo(x, y); // x0, y0, xi, yi 是记录在 _dashedXXXXTo 方法中使用
	    // xi, yi 记录当前点, x0, y0 在 closePath 的时候回到起始点。
	    // 有可能在 beginPath 之后直接调用 lineTo，这时候 x0, y0 需要
	    // 在 lineTo 方法中记录，这里先不考虑这种情况，dashed line 也只在 IE10- 中不支持
	
	    this._x0 = x;
	    this._y0 = y;
	    this._xi = x;
	    this._yi = y;
	    return this;
	  },
	
	  /**
	   * @param  {number} x
	   * @param  {number} y
	   * @return {module:zrender/core/PathProxy}
	   */
	  lineTo: function (x, y) {
	    var exceedUnit = mathAbs(x - this._xi) > this._ux || mathAbs(y - this._yi) > this._uy // Force draw the first segment
	    || this._len < 5;
	    this.addData(CMD.L, x, y);
	
	    if (this._ctx && exceedUnit) {
	      this._needsDash() ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
	    }
	
	    if (exceedUnit) {
	      this._xi = x;
	      this._yi = y;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param  {number} x1
	   * @param  {number} y1
	   * @param  {number} x2
	   * @param  {number} y2
	   * @param  {number} x3
	   * @param  {number} y3
	   * @return {module:zrender/core/PathProxy}
	   */
	  bezierCurveTo: function (x1, y1, x2, y2, x3, y3) {
	    this.addData(CMD.C, x1, y1, x2, y2, x3, y3);
	
	    if (this._ctx) {
	      this._needsDash() ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
	    }
	
	    this._xi = x3;
	    this._yi = y3;
	    return this;
	  },
	
	  /**
	   * @param  {number} x1
	   * @param  {number} y1
	   * @param  {number} x2
	   * @param  {number} y2
	   * @return {module:zrender/core/PathProxy}
	   */
	  quadraticCurveTo: function (x1, y1, x2, y2) {
	    this.addData(CMD.Q, x1, y1, x2, y2);
	
	    if (this._ctx) {
	      this._needsDash() ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
	    }
	
	    this._xi = x2;
	    this._yi = y2;
	    return this;
	  },
	
	  /**
	   * @param  {number} cx
	   * @param  {number} cy
	   * @param  {number} r
	   * @param  {number} startAngle
	   * @param  {number} endAngle
	   * @param  {boolean} anticlockwise
	   * @return {module:zrender/core/PathProxy}
	   */
	  arc: function (cx, cy, r, startAngle, endAngle, anticlockwise) {
	    this.addData(CMD.A, cx, cy, r, r, startAngle, endAngle - startAngle, 0, anticlockwise ? 0 : 1);
	    this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
	    this._xi = mathCos(endAngle) * r + cx;
	    this._yi = mathSin(endAngle) * r + cx;
	    return this;
	  },
	  // TODO
	  arcTo: function (x1, y1, x2, y2, radius) {
	    if (this._ctx) {
	      this._ctx.arcTo(x1, y1, x2, y2, radius);
	    }
	
	    return this;
	  },
	  // TODO
	  rect: function (x, y, w, h) {
	    this._ctx && this._ctx.rect(x, y, w, h);
	    this.addData(CMD.R, x, y, w, h);
	    return this;
	  },
	
	  /**
	   * @return {module:zrender/core/PathProxy}
	   */
	  closePath: function () {
	    this.addData(CMD.Z);
	    var ctx = this._ctx;
	    var x0 = this._x0;
	    var y0 = this._y0;
	
	    if (ctx) {
	      this._needsDash() && this._dashedLineTo(x0, y0);
	      ctx.closePath();
	    }
	
	    this._xi = x0;
	    this._yi = y0;
	    return this;
	  },
	
	  /**
	   * Context 从外部传入，因为有可能是 rebuildPath 完之后再 fill。
	   * stroke 同样
	   * @param {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  fill: function (ctx) {
	    ctx && ctx.fill();
	    this.toStatic();
	  },
	
	  /**
	   * @param {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  stroke: function (ctx) {
	    ctx && ctx.stroke();
	    this.toStatic();
	  },
	
	  /**
	   * 必须在其它绘制命令前调用
	   * Must be invoked before all other path drawing methods
	   * @return {module:zrender/core/PathProxy}
	   */
	  setLineDash: function (lineDash) {
	    if (lineDash instanceof Array) {
	      this._lineDash = lineDash;
	      this._dashIdx = 0;
	      var lineDashSum = 0;
	
	      for (var i = 0; i < lineDash.length; i++) {
	        lineDashSum += lineDash[i];
	      }
	
	      this._dashSum = lineDashSum;
	    }
	
	    return this;
	  },
	
	  /**
	   * 必须在其它绘制命令前调用
	   * Must be invoked before all other path drawing methods
	   * @return {module:zrender/core/PathProxy}
	   */
	  setLineDashOffset: function (offset) {
	    this._dashOffset = offset;
	    return this;
	  },
	
	  /**
	   *
	   * @return {boolean}
	   */
	  len: function () {
	    return this._len;
	  },
	
	  /**
	   * 直接设置 Path 数据
	   */
	  setData: function (data) {
	    var len = data.length;
	
	    if (!(this.data && this.data.length == len) && hasTypedArray) {
	      this.data = new Float32Array(len);
	    }
	
	    for (var i = 0; i < len; i++) {
	      this.data[i] = data[i];
	    }
	
	    this._len = len;
	  },
	
	  /**
	   * 添加子路径
	   * @param {module:zrender/core/PathProxy|Array.<module:zrender/core/PathProxy>} path
	   */
	  appendPath: function (path) {
	    if (!(path instanceof Array)) {
	      path = [path];
	    }
	
	    var len = path.length;
	    var appendSize = 0;
	    var offset = this._len;
	
	    for (var i = 0; i < len; i++) {
	      appendSize += path[i].len();
	    }
	
	    if (hasTypedArray && this.data instanceof Float32Array) {
	      this.data = new Float32Array(offset + appendSize);
	    }
	
	    for (var i = 0; i < len; i++) {
	      var appendPathData = path[i].data;
	
	      for (var k = 0; k < appendPathData.length; k++) {
	        this.data[offset++] = appendPathData[k];
	      }
	    }
	
	    this._len = offset;
	  },
	
	  /**
	   * 填充 Path 数据。
	   * 尽量复用而不申明新的数组。大部分图形重绘的指令数据长度都是不变的。
	   */
	  addData: function (cmd) {
	    if (!this._saveData) {
	      return;
	    }
	
	    var data = this.data;
	
	    if (this._len + arguments.length > data.length) {
	      // 因为之前的数组已经转换成静态的 Float32Array
	      // 所以不够用时需要扩展一个新的动态数组
	      this._expandData();
	
	      data = this.data;
	    }
	
	    for (var i = 0; i < arguments.length; i++) {
	      data[this._len++] = arguments[i];
	    }
	
	    this._prevCmd = cmd;
	  },
	  _expandData: function () {
	    // Only if data is Float32Array
	    if (!(this.data instanceof Array)) {
	      var newData = [];
	
	      for (var i = 0; i < this._len; i++) {
	        newData[i] = this.data[i];
	      }
	
	      this.data = newData;
	    }
	  },
	
	  /**
	   * If needs js implemented dashed line
	   * @return {boolean}
	   * @private
	   */
	  _needsDash: function () {
	    return this._lineDash;
	  },
	  _dashedLineTo: function (x1, y1) {
	    var dashSum = this._dashSum;
	    var offset = this._dashOffset;
	    var lineDash = this._lineDash;
	    var ctx = this._ctx;
	    var x0 = this._xi;
	    var y0 = this._yi;
	    var dx = x1 - x0;
	    var dy = y1 - y0;
	    var dist = mathSqrt(dx * dx + dy * dy);
	    var x = x0;
	    var y = y0;
	    var dash;
	    var nDash = lineDash.length;
	    var idx;
	    dx /= dist;
	    dy /= dist;
	
	    if (offset < 0) {
	      // Convert to positive offset
	      offset = dashSum + offset;
	    }
	
	    offset %= dashSum;
	    x -= offset * dx;
	    y -= offset * dy;
	
	    while (dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx == 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)) {
	      idx = this._dashIdx;
	      dash = lineDash[idx];
	      x += dx * dash;
	      y += dy * dash;
	      this._dashIdx = (idx + 1) % nDash; // Skip positive offset
	
	      if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) {
	        continue;
	      }
	
	      ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? mathMin(x, x1) : mathMax(x, x1), dy >= 0 ? mathMin(y, y1) : mathMax(y, y1));
	    } // Offset for next lineTo
	
	
	    dx = x - x1;
	    dy = y - y1;
	    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
	  },
	  // Not accurate dashed line to
	  _dashedBezierTo: function (x1, y1, x2, y2, x3, y3) {
	    var dashSum = this._dashSum;
	    var offset = this._dashOffset;
	    var lineDash = this._lineDash;
	    var ctx = this._ctx;
	    var x0 = this._xi;
	    var y0 = this._yi;
	    var t;
	    var dx;
	    var dy;
	    var cubicAt = curve.cubicAt;
	    var bezierLen = 0;
	    var idx = this._dashIdx;
	    var nDash = lineDash.length;
	    var x;
	    var y;
	    var tmpLen = 0;
	
	    if (offset < 0) {
	      // Convert to positive offset
	      offset = dashSum + offset;
	    }
	
	    offset %= dashSum; // Bezier approx length
	
	    for (t = 0; t < 1; t += 0.1) {
	      dx = cubicAt(x0, x1, x2, x3, t + 0.1) - cubicAt(x0, x1, x2, x3, t);
	      dy = cubicAt(y0, y1, y2, y3, t + 0.1) - cubicAt(y0, y1, y2, y3, t);
	      bezierLen += mathSqrt(dx * dx + dy * dy);
	    } // Find idx after add offset
	
	
	    for (; idx < nDash; idx++) {
	      tmpLen += lineDash[idx];
	
	      if (tmpLen > offset) {
	        break;
	      }
	    }
	
	    t = (tmpLen - offset) / bezierLen;
	
	    while (t <= 1) {
	      x = cubicAt(x0, x1, x2, x3, t);
	      y = cubicAt(y0, y1, y2, y3, t); // Use line to approximate dashed bezier
	      // Bad result if dash is long
	
	      idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
	      t += lineDash[idx] / bezierLen;
	      idx = (idx + 1) % nDash;
	    } // Finish the last segment and calculate the new offset
	
	
	    idx % 2 !== 0 && ctx.lineTo(x3, y3);
	    dx = x3 - x;
	    dy = y3 - y;
	    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
	  },
	  _dashedQuadraticTo: function (x1, y1, x2, y2) {
	    // Convert quadratic to cubic using degree elevation
	    var x3 = x2;
	    var y3 = y2;
	    x2 = (x2 + 2 * x1) / 3;
	    y2 = (y2 + 2 * y1) / 3;
	    x1 = (this._xi + 2 * x1) / 3;
	    y1 = (this._yi + 2 * y1) / 3;
	
	    this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
	  },
	
	  /**
	   * 转成静态的 Float32Array 减少堆内存占用
	   * Convert dynamic array to static Float32Array
	   */
	  toStatic: function () {
	    var data = this.data;
	
	    if (data instanceof Array) {
	      data.length = this._len;
	
	      if (hasTypedArray) {
	        this.data = new Float32Array(data);
	      }
	    }
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function () {
	    min[0] = min[1] = min2[0] = min2[1] = Number.MAX_VALUE;
	    max[0] = max[1] = max2[0] = max2[1] = -Number.MAX_VALUE;
	    var data = this.data;
	    var xi = 0;
	    var yi = 0;
	    var x0 = 0;
	    var y0 = 0;
	
	    for (var i = 0; i < data.length;) {
	      var cmd = data[i++];
	
	      if (i == 1) {
	        // 如果第一个命令是 L, C, Q
	        // 则 previous point 同绘制命令的第一个 point
	        //
	        // 第一个命令为 Arc 的情况下会在后面特殊处理
	        xi = data[i];
	        yi = data[i + 1];
	        x0 = xi;
	        y0 = yi;
	      }
	
	      switch (cmd) {
	        case CMD.M:
	          // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
	          // 在 closePath 的时候使用
	          x0 = data[i++];
	          y0 = data[i++];
	          xi = x0;
	          yi = y0;
	          min2[0] = x0;
	          min2[1] = y0;
	          max2[0] = x0;
	          max2[1] = y0;
	          break;
	
	        case CMD.L:
	          bbox.fromLine(xi, yi, data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.C:
	          bbox.fromCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.Q:
	          bbox.fromQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.A:
	          // TODO Arc 判断的开销比较大
	          var cx = data[i++];
	          var cy = data[i++];
	          var rx = data[i++];
	          var ry = data[i++];
	          var startAngle = data[i++];
	          var endAngle = data[i++] + startAngle; // TODO Arc 旋转
	
	          var psi = data[i++];
	          var anticlockwise = 1 - data[i++];
	
	          if (i == 1) {
	            // 直接使用 arc 命令
	            // 第一个命令起点还未定义
	            x0 = mathCos(startAngle) * rx + cx;
	            y0 = mathSin(startAngle) * ry + cy;
	          }
	
	          bbox.fromArc(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, min2, max2);
	          xi = mathCos(endAngle) * rx + cx;
	          yi = mathSin(endAngle) * ry + cy;
	          break;
	
	        case CMD.R:
	          x0 = xi = data[i++];
	          y0 = yi = data[i++];
	          var width = data[i++];
	          var height = data[i++]; // Use fromLine
	
	          bbox.fromLine(x0, y0, x0 + width, y0 + height, min2, max2);
	          break;
	
	        case CMD.Z:
	          xi = x0;
	          yi = y0;
	          break;
	      } // Union
	
	
	      vec2.min(min, min, min2);
	      vec2.max(max, max, max2);
	    } // No data
	
	
	    if (i === 0) {
	      min[0] = min[1] = max[0] = max[1] = 0;
	    }
	
	    return new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	  },
	
	  /**
	   * Rebuild path from current data
	   * Rebuild path will not consider javascript implemented line dash.
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  rebuildPath: function (ctx) {
	    var d = this.data;
	    var x0, y0;
	    var xi, yi;
	    var x, y;
	    var ux = this._ux;
	    var uy = this._uy;
	    var len = this._len;
	
	    for (var i = 0; i < len;) {
	      var cmd = d[i++];
	
	      if (i == 1) {
	        // 如果第一个命令是 L, C, Q
	        // 则 previous point 同绘制命令的第一个 point
	        //
	        // 第一个命令为 Arc 的情况下会在后面特殊处理
	        xi = d[i];
	        yi = d[i + 1];
	        x0 = xi;
	        y0 = yi;
	      }
	
	      switch (cmd) {
	        case CMD.M:
	          x0 = xi = d[i++];
	          y0 = yi = d[i++];
	          ctx.moveTo(xi, yi);
	          break;
	
	        case CMD.L:
	          x = d[i++];
	          y = d[i++]; // Not draw too small seg between
	
	          if (mathAbs(x - xi) > ux || mathAbs(y - yi) > uy || i === len - 1) {
	            ctx.lineTo(x, y);
	            xi = x;
	            yi = y;
	          }
	
	          break;
	
	        case CMD.C:
	          ctx.bezierCurveTo(d[i++], d[i++], d[i++], d[i++], d[i++], d[i++]);
	          xi = d[i - 2];
	          yi = d[i - 1];
	          break;
	
	        case CMD.Q:
	          ctx.quadraticCurveTo(d[i++], d[i++], d[i++], d[i++]);
	          xi = d[i - 2];
	          yi = d[i - 1];
	          break;
	
	        case CMD.A:
	          var cx = d[i++];
	          var cy = d[i++];
	          var rx = d[i++];
	          var ry = d[i++];
	          var theta = d[i++];
	          var dTheta = d[i++];
	          var psi = d[i++];
	          var fs = d[i++];
	          var r = rx > ry ? rx : ry;
	          var scaleX = rx > ry ? 1 : rx / ry;
	          var scaleY = rx > ry ? ry / rx : 1;
	          var isEllipse = Math.abs(rx - ry) > 1e-3;
	          var endAngle = theta + dTheta;
	
	          if (isEllipse) {
	            ctx.translate(cx, cy);
	            ctx.rotate(psi);
	            ctx.scale(scaleX, scaleY);
	            ctx.arc(0, 0, r, theta, endAngle, 1 - fs);
	            ctx.scale(1 / scaleX, 1 / scaleY);
	            ctx.rotate(-psi);
	            ctx.translate(-cx, -cy);
	          } else {
	            ctx.arc(cx, cy, r, theta, endAngle, 1 - fs);
	          }
	
	          if (i == 1) {
	            // 直接使用 arc 命令
	            // 第一个命令起点还未定义
	            x0 = mathCos(theta) * rx + cx;
	            y0 = mathSin(theta) * ry + cy;
	          }
	
	          xi = mathCos(endAngle) * rx + cx;
	          yi = mathSin(endAngle) * ry + cy;
	          break;
	
	        case CMD.R:
	          x0 = xi = d[i];
	          y0 = yi = d[i + 1];
	          ctx.rect(d[i++], d[i++], d[i++], d[i++]);
	          break;
	
	        case CMD.Z:
	          ctx.closePath();
	          xi = x0;
	          yi = y0;
	      }
	    }
	  }
	};
	PathProxy.CMD = CMD;
	var _default = PathProxy;
	module.exports = _default;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(278), __esModule: true };

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(52);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(32);
	var core = __webpack_require__(24);
	var ctx = __webpack_require__(288);
	var hide = __webpack_require__(51);
	var has = __webpack_require__(42);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(149);
	var enumBugKeys = __webpack_require__(105);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var graphic = __webpack_require__(3);
	
	var SymbolClz = __webpack_require__(83);
	
	/**
	 * @module echarts/chart/helper/SymbolDraw
	 */
	
	/**
	 * @constructor
	 * @alias module:echarts/chart/helper/SymbolDraw
	 * @param {module:zrender/graphic/Group} [symbolCtor]
	 */
	function SymbolDraw(symbolCtor) {
	  this.group = new graphic.Group();
	  this._symbolCtor = symbolCtor || SymbolClz;
	}
	
	var symbolDrawProto = SymbolDraw.prototype;
	
	function symbolNeedsDraw(data, idx, isIgnore) {
	  var point = data.getItemLayout(idx); // Is an object
	  // if (point && point.hasOwnProperty('point')) {
	  //     point = point.point;
	  // }
	
	  return point && !isNaN(point[0]) && !isNaN(point[1]) && !(isIgnore && isIgnore(idx)) && data.getItemVisual(idx, 'symbol') !== 'none';
	}
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 * @param {Array.<boolean>} [isIgnore]
	 */
	
	
	symbolDrawProto.updateData = function (data, isIgnore) {
	  var group = this.group;
	  var seriesModel = data.hostModel;
	  var oldData = this._data;
	  var SymbolCtor = this._symbolCtor;
	  var seriesScope = {
	    itemStyle: seriesModel.getModel('itemStyle.normal').getItemStyle(['color']),
	    hoverItemStyle: seriesModel.getModel('itemStyle.emphasis').getItemStyle(),
	    symbolRotate: seriesModel.get('symbolRotate'),
	    symbolOffset: seriesModel.get('symbolOffset'),
	    hoverAnimation: seriesModel.get('hoverAnimation'),
	    labelModel: seriesModel.getModel('label.normal'),
	    hoverLabelModel: seriesModel.getModel('label.emphasis'),
	    cursorStyle: seriesModel.get('cursor')
	  };
	  data.diff(oldData).add(function (newIdx) {
	    var point = data.getItemLayout(newIdx);
	
	    if (symbolNeedsDraw(data, newIdx, isIgnore)) {
	      var symbolEl = new SymbolCtor(data, newIdx, seriesScope);
	      symbolEl.attr('position', point);
	      data.setItemGraphicEl(newIdx, symbolEl);
	      group.add(symbolEl);
	    }
	  }).update(function (newIdx, oldIdx) {
	    var symbolEl = oldData.getItemGraphicEl(oldIdx);
	    var point = data.getItemLayout(newIdx);
	
	    if (!symbolNeedsDraw(data, newIdx, isIgnore)) {
	      group.remove(symbolEl);
	      return;
	    }
	
	    if (!symbolEl) {
	      symbolEl = new SymbolCtor(data, newIdx);
	      symbolEl.attr('position', point);
	    } else {
	      symbolEl.updateData(data, newIdx, seriesScope);
	      graphic.updateProps(symbolEl, {
	        position: point
	      }, seriesModel);
	    } // Add back
	
	
	    group.add(symbolEl);
	    data.setItemGraphicEl(newIdx, symbolEl);
	  }).remove(function (oldIdx) {
	    var el = oldData.getItemGraphicEl(oldIdx);
	    el && el.fadeOut(function () {
	      group.remove(el);
	    });
	  }).execute();
	  this._data = data;
	};
	
	symbolDrawProto.updateLayout = function () {
	  var data = this._data;
	
	  if (data) {
	    // Not use animation
	    data.eachItemGraphicEl(function (el, idx) {
	      var point = data.getItemLayout(idx);
	      el.attr('position', point);
	    });
	  }
	};
	
	symbolDrawProto.remove = function (enableAnimation) {
	  var group = this.group;
	  var data = this._data;
	
	  if (data) {
	    if (enableAnimation) {
	      data.eachItemGraphicEl(function (el) {
	        el.fadeOut(function () {
	          group.remove(el);
	        });
	      });
	    } else {
	      group.removeAll();
	    }
	  }
	};
	
	var _default = SymbolDraw;
	module.exports = _default;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	function retrieveTargetInfo(payload, seriesModel) {
	  if (payload && (payload.type === 'treemapZoomToNode' || payload.type === 'treemapRootToNode')) {
	    var root = seriesModel.getData().tree.root;
	    var targetNode = payload.targetNode;
	
	    if (targetNode && root.contains(targetNode)) {
	      return {
	        node: targetNode
	      };
	    }
	
	    var targetNodeId = payload.targetNodeId;
	
	    if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) {
	      return {
	        node: targetNode
	      };
	    }
	  }
	} // Not includes the given node at the last item.
	
	
	function getPathToRoot(node) {
	  var path = [];
	
	  while (node) {
	    node = node.parentNode;
	    node && path.push(node);
	  }
	
	  return path.reverse();
	}
	
	function aboveViewRoot(viewRoot, node) {
	  var viewPath = getPathToRoot(viewRoot);
	  return zrUtil.indexOf(viewPath, node) >= 0;
	} // From root to the input node (the input node will be included).
	
	
	function wrapTreePathInfo(node, seriesModel) {
	  var treePathInfo = [];
	
	  while (node) {
	    var nodeDataIndex = node.dataIndex;
	    treePathInfo.push({
	      name: node.name,
	      dataIndex: nodeDataIndex,
	      value: seriesModel.getRawValue(nodeDataIndex)
	    });
	    node = node.parentNode;
	  }
	
	  treePathInfo.reverse();
	  return treePathInfo;
	}
	
	exports.retrieveTargetInfo = retrieveTargetInfo;
	exports.getPathToRoot = getPathToRoot;
	exports.aboveViewRoot = aboveViewRoot;
	exports.wrapTreePathInfo = wrapTreePathInfo;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var axisPointerModelHelper = __webpack_require__(85);
	
	var axisTrigger = __webpack_require__(469);
	
	__webpack_require__(465);
	
	__webpack_require__(466);
	
	__webpack_require__(169);
	
	// CartesianAxisPointer is not supposed to be required here. But consider
	// echarts.simple.js and online build tooltip, which only require gridSimple,
	// CartesianAxisPointer should be able to required somewhere.
	echarts.registerPreprocessor(function (option) {
	  // Always has a global axisPointerModel for default setting.
	  if (option) {
	    (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
	    var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
	    // is not set, remain null/undefined, otherwise it will
	    // override existent link setting.
	
	    if (link && !zrUtil.isArray(link)) {
	      option.axisPointer.link = [link];
	    }
	  }
	}); // This process should proformed after coordinate systems created
	// and series data processed. So put it on statistic processing stage.
	
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, function (ecModel, api) {
	  // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
	  // allAxesInfo should be updated when setOption performed.
	  ecModel.getComponent('axisPointer').coordSysAxesInfo = axisPointerModelHelper.collect(ecModel, api);
	}); // Broadcast to all views.
	
	echarts.registerAction({
	  type: 'updateAxisPointer',
	  event: 'updateAxisPointer',
	  update: ':updateAxisPointer'
	}, axisTrigger);

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var env = __webpack_require__(18);
	
	var modelUtil = __webpack_require__(6);
	
	var helper = __webpack_require__(119);
	
	var AxisProxy = __webpack_require__(480);
	
	var each = zrUtil.each;
	var eachAxisDim = helper.eachAxisDim;
	var DataZoomModel = echarts.extendComponentModel({
	  type: 'dataZoom',
	  dependencies: ['xAxis', 'yAxis', 'zAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'series'],
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    zlevel: 0,
	    z: 4,
	    // Higher than normal component (z: 2).
	    orient: null,
	    // Default auto by axisIndex. Possible value: 'horizontal', 'vertical'.
	    xAxisIndex: null,
	    // Default the first horizontal category axis.
	    yAxisIndex: null,
	    // Default the first vertical category axis.
	    filterMode: 'filter',
	    // Possible values: 'filter' or 'empty' or 'weakFilter'.
	    // 'filter': data items which are out of window will be removed. This option is
	    //          applicable when filtering outliers. For each data item, it will be
	    //          filtered if one of the relevant dimensions is out of the window.
	    // 'weakFilter': data items which are out of window will be removed. This option
	    //          is applicable when filtering outliers. For each data item, it will be
	    //          filtered only if all  of the relevant dimensions are out of the same
	    //          side of the window.
	    // 'empty': data items which are out of window will be set to empty.
	    //          This option is applicable when user should not neglect
	    //          that there are some data items out of window.
	    // 'none': Do not filter.
	    // Taking line chart as an example, line will be broken in
	    // the filtered points when filterModel is set to 'empty', but
	    // be connected when set to 'filter'.
	    throttle: null,
	    // Dispatch action by the fixed rate, avoid frequency.
	    // default 100. Do not throttle when use null/undefined.
	    // If animation === true and animationDurationUpdate > 0,
	    // default value is 100, otherwise 20.
	    start: 0,
	    // Start percent. 0 ~ 100
	    end: 100,
	    // End percent. 0 ~ 100
	    startValue: null,
	    // Start value. If startValue specified, start is ignored.
	    endValue: null,
	    // End value. If endValue specified, end is ignored.
	    minSpan: null,
	    // 0 ~ 100
	    maxSpan: null,
	    // 0 ~ 100
	    minValueSpan: null,
	    // The range of dataZoom can not be smaller than that.
	    maxValueSpan: null,
	    // The range of dataZoom can not be larger than that.
	    rangeMode: null // Array, can be 'value' or 'percent'.
	
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * key like x_0, y_1
	     * @private
	     * @type {Object}
	     */
	    this._dataIntervalByAxis = {};
	    /**
	     * @private
	     */
	
	    this._dataInfo = {};
	    /**
	     * key like x_0, y_1
	     * @private
	     */
	
	    this._axisProxies = {};
	    /**
	     * @readOnly
	     */
	
	    this.textStyleModel;
	    /**
	     * @private
	     */
	
	    this._autoThrottle = true;
	    /**
	     * 'percent' or 'value'
	     * @private
	     */
	
	    this._rangePropMode = ['percent', 'percent'];
	    var rawOption = retrieveRaw(option);
	    this.mergeDefaultAndTheme(option, ecModel);
	    this.doInit(rawOption);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (newOption) {
	    var rawOption = retrieveRaw(newOption); //FIX #2591
	
	    zrUtil.merge(this.option, newOption, true);
	    this.doInit(rawOption);
	  },
	
	  /**
	   * @protected
	   */
	  doInit: function (rawOption) {
	    var thisOption = this.option; // Disable realtime view update if canvas is not supported.
	
	    if (!env.canvasSupported) {
	      thisOption.realtime = false;
	    }
	
	    this._setDefaultThrottle(rawOption);
	
	    updateRangeUse(this, rawOption);
	    each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
	      // start/end has higher priority over startValue/endValue if they
	      // both set, but we should make chart.setOption({endValue: 1000})
	      // effective, rather than chart.setOption({endValue: 1000, end: null}).
	      if (this._rangePropMode[index] === 'value') {
	        thisOption[names[0]] = null;
	      } // Otherwise do nothing and use the merge result.
	
	    }, this);
	    this.textStyleModel = this.getModel('textStyle');
	
	    this._resetTarget();
	
	    this._giveAxisProxies();
	  },
	
	  /**
	   * @private
	   */
	  _giveAxisProxies: function () {
	    var axisProxies = this._axisProxies;
	    this.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel, ecModel) {
	      var axisModel = this.dependentModels[dimNames.axis][axisIndex]; // If exists, share axisProxy with other dataZoomModels.
	
	      var axisProxy = axisModel.__dzAxisProxy || ( // Use the first dataZoomModel as the main model of axisProxy.
	      axisModel.__dzAxisProxy = new AxisProxy(dimNames.name, axisIndex, this, ecModel)); // FIXME
	      // dispose __dzAxisProxy
	
	      axisProxies[dimNames.name + '_' + axisIndex] = axisProxy;
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _resetTarget: function () {
	    var thisOption = this.option;
	
	    var autoMode = this._judgeAutoMode();
	
	    eachAxisDim(function (dimNames) {
	      var axisIndexName = dimNames.axisIndex;
	      thisOption[axisIndexName] = modelUtil.normalizeToArray(thisOption[axisIndexName]);
	    }, this);
	
	    if (autoMode === 'axisIndex') {
	      this._autoSetAxisIndex();
	    } else if (autoMode === 'orient') {
	      this._autoSetOrient();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _judgeAutoMode: function () {
	    // Auto set only works for setOption at the first time.
	    // The following is user's reponsibility. So using merged
	    // option is OK.
	    var thisOption = this.option;
	    var hasIndexSpecified = false;
	    eachAxisDim(function (dimNames) {
	      // When user set axisIndex as a empty array, we think that user specify axisIndex
	      // but do not want use auto mode. Because empty array may be encountered when
	      // some error occured.
	      if (thisOption[dimNames.axisIndex] != null) {
	        hasIndexSpecified = true;
	      }
	    }, this);
	    var orient = thisOption.orient;
	
	    if (orient == null && hasIndexSpecified) {
	      return 'orient';
	    } else if (!hasIndexSpecified) {
	      if (orient == null) {
	        thisOption.orient = 'horizontal';
	      }
	
	      return 'axisIndex';
	    }
	  },
	
	  /**
	   * @private
	   */
	  _autoSetAxisIndex: function () {
	    var autoAxisIndex = true;
	    var orient = this.get('orient', true);
	    var thisOption = this.option;
	    var dependentModels = this.dependentModels;
	
	    if (autoAxisIndex) {
	      // Find axis that parallel to dataZoom as default.
	      var dimName = orient === 'vertical' ? 'y' : 'x';
	
	      if (dependentModels[dimName + 'Axis'].length) {
	        thisOption[dimName + 'AxisIndex'] = [0];
	        autoAxisIndex = false;
	      } else {
	        each(dependentModels.singleAxis, function (singleAxisModel) {
	          if (autoAxisIndex && singleAxisModel.get('orient', true) === orient) {
	            thisOption.singleAxisIndex = [singleAxisModel.componentIndex];
	            autoAxisIndex = false;
	          }
	        });
	      }
	    }
	
	    if (autoAxisIndex) {
	      // Find the first category axis as default. (consider polar)
	      eachAxisDim(function (dimNames) {
	        if (!autoAxisIndex) {
	          return;
	        }
	
	        var axisIndices = [];
	        var axisModels = this.dependentModels[dimNames.axis];
	
	        if (axisModels.length && !axisIndices.length) {
	          for (var i = 0, len = axisModels.length; i < len; i++) {
	            if (axisModels[i].get('type') === 'category') {
	              axisIndices.push(i);
	            }
	          }
	        }
	
	        thisOption[dimNames.axisIndex] = axisIndices;
	
	        if (axisIndices.length) {
	          autoAxisIndex = false;
	        }
	      }, this);
	    }
	
	    if (autoAxisIndex) {
	      // FIXME
	      // 这里是兼容ec2的写法（没指定xAxisIndex和yAxisIndex时把scatter和双数值轴折柱纳入dataZoom控制），
	      // 但是实际是否需要Grid.js#getScaleByOption来判断（考虑time，log等axis type）？
	      // If both dataZoom.xAxisIndex and dataZoom.yAxisIndex is not specified,
	      // dataZoom component auto adopts series that reference to
	      // both xAxis and yAxis which type is 'value'.
	      this.ecModel.eachSeries(function (seriesModel) {
	        if (this._isSeriesHasAllAxesTypeOf(seriesModel, 'value')) {
	          eachAxisDim(function (dimNames) {
	            var axisIndices = thisOption[dimNames.axisIndex];
	            var axisIndex = seriesModel.get(dimNames.axisIndex);
	            var axisId = seriesModel.get(dimNames.axisId);
	            var axisModel = seriesModel.ecModel.queryComponents({
	              mainType: dimNames.axis,
	              index: axisIndex,
	              id: axisId
	            })[0];
	            axisIndex = axisModel.componentIndex;
	
	            if (zrUtil.indexOf(axisIndices, axisIndex) < 0) {
	              axisIndices.push(axisIndex);
	            }
	          });
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _autoSetOrient: function () {
	    var dim; // Find the first axis
	
	    this.eachTargetAxis(function (dimNames) {
	      !dim && (dim = dimNames.name);
	    }, this);
	    this.option.orient = dim === 'y' ? 'vertical' : 'horizontal';
	  },
	
	  /**
	   * @private
	   */
	  _isSeriesHasAllAxesTypeOf: function (seriesModel, axisType) {
	    // FIXME
	    // 需要series的xAxisIndex和yAxisIndex都首先自动设置上。
	    // 例如series.type === scatter时。
	    var is = true;
	    eachAxisDim(function (dimNames) {
	      var seriesAxisIndex = seriesModel.get(dimNames.axisIndex);
	      var axisModel = this.dependentModels[dimNames.axis][seriesAxisIndex];
	
	      if (!axisModel || axisModel.get('type') !== axisType) {
	        is = false;
	      }
	    }, this);
	    return is;
	  },
	
	  /**
	   * @private
	   */
	  _setDefaultThrottle: function (rawOption) {
	    // When first time user set throttle, auto throttle ends.
	    if (rawOption.hasOwnProperty('throttle')) {
	      this._autoThrottle = false;
	    }
	
	    if (this._autoThrottle) {
	      var globalOption = this.ecModel.option;
	      this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
	    }
	  },
	
	  /**
	   * @public
	   */
	  getFirstTargetAxisModel: function () {
	    var firstAxisModel;
	    eachAxisDim(function (dimNames) {
	      if (firstAxisModel == null) {
	        var indices = this.get(dimNames.axisIndex);
	
	        if (indices.length) {
	          firstAxisModel = this.dependentModels[dimNames.axis][indices[0]];
	        }
	      }
	    }, this);
	    return firstAxisModel;
	  },
	
	  /**
	   * @public
	   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
	   */
	  eachTargetAxis: function (callback, context) {
	    var ecModel = this.ecModel;
	    eachAxisDim(function (dimNames) {
	      each(this.get(dimNames.axisIndex), function (axisIndex) {
	        callback.call(context, dimNames, axisIndex, this, ecModel);
	      }, this);
	    }, this);
	  },
	
	  /**
	   * @param {string} dimName
	   * @param {number} axisIndex
	   * @return {module:echarts/component/dataZoom/AxisProxy} If not found, return null/undefined.
	   */
	  getAxisProxy: function (dimName, axisIndex) {
	    return this._axisProxies[dimName + '_' + axisIndex];
	  },
	
	  /**
	   * @param {string} dimName
	   * @param {number} axisIndex
	   * @return {module:echarts/model/Model} If not found, return null/undefined.
	   */
	  getAxisModel: function (dimName, axisIndex) {
	    var axisProxy = this.getAxisProxy(dimName, axisIndex);
	    return axisProxy && axisProxy.getAxisModel();
	  },
	
	  /**
	   * If not specified, set to undefined.
	   *
	   * @public
	   * @param {Object} opt
	   * @param {number} [opt.start]
	   * @param {number} [opt.end]
	   * @param {number} [opt.startValue]
	   * @param {number} [opt.endValue]
	   * @param {boolean} [ignoreUpdateRangeUsg=false]
	   */
	  setRawRange: function (opt, ignoreUpdateRangeUsg) {
	    var option = this.option;
	    each([['start', 'startValue'], ['end', 'endValue']], function (names) {
	      // If only one of 'start' and 'startValue' is not null/undefined, the other
	      // should be cleared, which enable clear the option.
	      // If both of them are not set, keep option with the original value, which
	      // enable use only set start but not set end when calling `dispatchAction`.
	      // The same as 'end' and 'endValue'.
	      if (opt[names[0]] != null || opt[names[1]] != null) {
	        option[names[0]] = opt[names[0]];
	        option[names[1]] = opt[names[1]];
	      }
	    }, this);
	    !ignoreUpdateRangeUsg && updateRangeUse(this, opt);
	  },
	
	  /**
	   * @public
	   * @return {Array.<number>} [startPercent, endPercent]
	   */
	  getPercentRange: function () {
	    var axisProxy = this.findRepresentativeAxisProxy();
	
	    if (axisProxy) {
	      return axisProxy.getDataPercentWindow();
	    }
	  },
	
	  /**
	   * @public
	   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
	   *
	   * @param {string} [axisDimName]
	   * @param {number} [axisIndex]
	   * @return {Array.<number>} [startValue, endValue] value can only be '-' or finite number.
	   */
	  getValueRange: function (axisDimName, axisIndex) {
	    if (axisDimName == null && axisIndex == null) {
	      var axisProxy = this.findRepresentativeAxisProxy();
	
	      if (axisProxy) {
	        return axisProxy.getDataValueWindow();
	      }
	    } else {
	      return this.getAxisProxy(axisDimName, axisIndex).getDataValueWindow();
	    }
	  },
	
	  /**
	   * @public
	   * @param {module:echarts/model/Model} [axisModel] If axisModel given, find axisProxy
	   *      corresponding to the axisModel
	   * @return {module:echarts/component/dataZoom/AxisProxy}
	   */
	  findRepresentativeAxisProxy: function (axisModel) {
	    if (axisModel) {
	      return axisModel.__dzAxisProxy;
	    } // Find the first hosted axisProxy
	
	
	    var axisProxies = this._axisProxies;
	
	    for (var key in axisProxies) {
	      if (axisProxies.hasOwnProperty(key) && axisProxies[key].hostedBy(this)) {
	        return axisProxies[key];
	      }
	    } // If no hosted axis find not hosted axisProxy.
	    // Consider this case: dataZoomModel1 and dataZoomModel2 control the same axis,
	    // and the option.start or option.end settings are different. The percentRange
	    // should follow axisProxy.
	    // (We encounter this problem in toolbox data zoom.)
	
	
	    for (var key in axisProxies) {
	      if (axisProxies.hasOwnProperty(key) && !axisProxies[key].hostedBy(this)) {
	        return axisProxies[key];
	      }
	    }
	  },
	
	  /**
	   * @return {Array.<string>}
	   */
	  getRangePropMode: function () {
	    return this._rangePropMode.slice();
	  }
	});
	
	function retrieveRaw(option) {
	  var ret = {};
	  each(['start', 'end', 'startValue', 'endValue', 'throttle'], function (name) {
	    option.hasOwnProperty(name) && (ret[name] = option[name]);
	  });
	  return ret;
	}
	
	function updateRangeUse(dataZoomModel, rawOption) {
	  var rangePropMode = dataZoomModel._rangePropMode;
	  var rangeModeInOption = dataZoomModel.get('rangeMode');
	  each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
	    var percentSpecified = rawOption[names[0]] != null;
	    var valueSpecified = rawOption[names[1]] != null;
	
	    if (percentSpecified && !valueSpecified) {
	      rangePropMode[index] = 'percent';
	    } else if (!percentSpecified && valueSpecified) {
	      rangePropMode[index] = 'value';
	    } else if (rangeModeInOption) {
	      rangePropMode[index] = rangeModeInOption[index];
	    } else if (percentSpecified) {
	      // percentSpecified && valueSpecified
	      rangePropMode[index] = 'percent';
	    } // else remain its original setting.
	
	  });
	}
	
	var _default = DataZoomModel;
	module.exports = _default;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var ComponentView = __webpack_require__(131);
	
	var _default = ComponentView.extend({
	  type: 'dataZoom',
	  render: function (dataZoomModel, ecModel, api, payload) {
	    this.dataZoomModel = dataZoomModel;
	    this.ecModel = ecModel;
	    this.api = api;
	  },
	
	  /**
	   * Find the first target coordinate system.
	   *
	   * @protected
	   * @return {Object} {
	   *                   grid: [
	   *                       {model: coord0, axisModels: [axis1, axis3], coordIndex: 1},
	   *                       {model: coord1, axisModels: [axis0, axis2], coordIndex: 0},
	   *                       ...
	   *                   ],  // cartesians must not be null/undefined.
	   *                   polar: [
	   *                       {model: coord0, axisModels: [axis4], coordIndex: 0},
	   *                       ...
	   *                   ],  // polars must not be null/undefined.
	   *                   singleAxis: [
	   *                       {model: coord0, axisModels: [], coordIndex: 0}
	   *                   ]
	   */
	  getTargetCoordInfo: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var ecModel = this.ecModel;
	    var coordSysLists = {};
	    dataZoomModel.eachTargetAxis(function (dimNames, axisIndex) {
	      var axisModel = ecModel.getComponent(dimNames.axis, axisIndex);
	
	      if (axisModel) {
	        var coordModel = axisModel.getCoordSysModel();
	        coordModel && save(coordModel, axisModel, coordSysLists[coordModel.mainType] || (coordSysLists[coordModel.mainType] = []), coordModel.componentIndex);
	      }
	    }, this);
	
	    function save(coordModel, axisModel, store, coordIndex) {
	      var item;
	
	      for (var i = 0; i < store.length; i++) {
	        if (store[i].model === coordModel) {
	          item = store[i];
	          break;
	        }
	      }
	
	      if (!item) {
	        store.push(item = {
	          model: coordModel,
	          axisModels: [],
	          coordIndex: coordIndex
	        });
	      }
	
	      item.axisModels.push(axisModel);
	    }
	
	    return coordSysLists;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	__webpack_require__(126);
	
	__webpack_require__(458);
	
	// Grid view
	echarts.extendComponentView({
	  type: 'grid',
	  render: function (gridModel, ecModel) {
	    this.group.removeAll();
	
	    if (gridModel.get('show')) {
	      this.group.add(new graphic.Rect({
	        shape: gridModel.coordinateSystem.getRect(),
	        style: zrUtil.defaults({
	          fill: gridModel.get('backgroundColor')
	        }, gridModel.getItemStyle()),
	        silent: true,
	        z2: -1
	      }));
	    }
	  }
	});
	echarts.registerPreprocessor(function (option) {
	  // Only create grid when need
	  if (option.xAxis && option.yAxis && !option.grid) {
	    option.grid = {};
	  }
	});

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	/**
	 * Calculate slider move result.
	 * Usage:
	 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
	 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
	 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
	 *
	 * @param {number} delta Move length.
	 * @param {Array.<number>} handleEnds handleEnds[0] can be bigger then handleEnds[1].
	 *              handleEnds will be modified in this method.
	 * @param {Array.<number>} extent handleEnds is restricted by extent.
	 *              extent[0] should less or equals than extent[1].
	 * @param {number|string} handleIndex Can be 'all', means that both move the two handleEnds,
	 *              where the input minSpan and maxSpan will not work.
	 * @param {number} [minSpan] The range of dataZoom can not be smaller than that.
	 *              If not set, handle0 and cross handle1. If set as a non-negative
	 *              number (including `0`), handles will push each other when reaching
	 *              the minSpan.
	 * @param {number} [maxSpan] The range of dataZoom can not be larger than that.
	 * @return {Array.<number>} The input handleEnds.
	 */
	function _default(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
	  // Normalize firstly.
	  handleEnds[0] = restrict(handleEnds[0], extent);
	  handleEnds[1] = restrict(handleEnds[1], extent);
	  delta = delta || 0;
	  var extentSpan = extent[1] - extent[0]; // Notice maxSpan and minSpan can be null/undefined.
	
	  if (minSpan != null) {
	    minSpan = restrict(minSpan, [0, extentSpan]);
	  }
	
	  if (maxSpan != null) {
	    maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
	  }
	
	  if (handleIndex === 'all') {
	    minSpan = maxSpan = Math.abs(handleEnds[1] - handleEnds[0]);
	    handleIndex = 0;
	  }
	
	  var originalDistSign = getSpanSign(handleEnds, handleIndex);
	  handleEnds[handleIndex] += delta; // Restrict in extent.
	
	  var extentMinSpan = minSpan || 0;
	  var realExtent = extent.slice();
	  originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
	  handleEnds[handleIndex] = restrict(handleEnds[handleIndex], realExtent); // Expand span.
	
	  var currDistSign = getSpanSign(handleEnds, handleIndex);
	
	  if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) {
	    // If minSpan exists, 'cross' is forbinden.
	    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
	  } // Shrink span.
	
	
	  var currDistSign = getSpanSign(handleEnds, handleIndex);
	
	  if (maxSpan != null && currDistSign.span > maxSpan) {
	    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
	  }
	
	  return handleEnds;
	}
	
	function getSpanSign(handleEnds, handleIndex) {
	  var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex]; // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
	  // is at left of handleEnds[1] for non-cross case.
	
	  return {
	    span: Math.abs(dist),
	    sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
	  };
	}
	
	function restrict(value, extend) {
	  return Math.min(extend[1], Math.max(extend[0], value));
	}
	
	module.exports = _default;

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	module.exports = {"shipping_rates":[{"type":"Standaard","description":"0 – 10 kg","price":7.45,"dimensions":"100 x 50 x 50 cm"},{"type":"Standaard","description":"10 – 23 kg","price":17.45,"dimensions":"176 x 78 x 58 cm"},{"type":"Aangetekend","description":"0 – 10 kg","price":11.25,"dimensions":"100 x 50 x 50 cm"},{"type":"Aangetekend","description":"10 – 30 kg","price":21.25,"dimensions":"176 x 78 x 58 cm"}],"special_rate":{"type":"Free","description":"Above €99,95","price":99.95,"dimensions":"N/A"}}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ajax_loader.gif";

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(96);
	
	var debugMode = _config.debugMode;
	
	var log = function () {};
	
	if (debugMode === 1) {
	  log = function () {
	    for (var k in arguments) {
	      throw new Error(arguments[k]);
	    }
	  };
	} else if (debugMode > 1) {
	  log = function () {
	    for (var k in arguments) {
	      console.log(arguments[k]);
	    }
	  };
	}
	
	var _default = log;
	module.exports = _default;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(98);
	
	var BoundingRect = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(1);
	
	var imageHelper = __webpack_require__(138);
	
	/**
	 * @alias zrender/graphic/Image
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	function ZImage(opts) {
	  Displayable.call(this, opts);
	}
	
	ZImage.prototype = {
	  constructor: ZImage,
	  type: 'image',
	  brush: function (ctx, prevEl) {
	    var style = this.style;
	    var src = style.image; // Must bind each time
	
	    style.bind(ctx, this, prevEl);
	    var image = this._image = imageHelper.createOrUpdateImage(src, this._image, this, this.onload);
	
	    if (!image || !imageHelper.isImageReady(image)) {
	      return;
	    } // 图片已经加载完成
	    // if (image.nodeName.toUpperCase() == 'IMG') {
	    //     if (!image.complete) {
	    //         return;
	    //     }
	    // }
	    // Else is canvas
	
	
	    var x = style.x || 0;
	    var y = style.y || 0;
	    var width = style.width;
	    var height = style.height;
	    var aspect = image.width / image.height;
	
	    if (width == null && height != null) {
	      // Keep image/height ratio
	      width = height * aspect;
	    } else if (height == null && width != null) {
	      height = width / aspect;
	    } else if (width == null && height == null) {
	      width = image.width;
	      height = image.height;
	    } // 设置transform
	
	
	    this.setTransform(ctx);
	
	    if (style.sWidth && style.sHeight) {
	      var sx = style.sx || 0;
	      var sy = style.sy || 0;
	      ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
	    } else if (style.sx && style.sy) {
	      var sx = style.sx;
	      var sy = style.sy;
	      var sWidth = width - sx;
	      var sHeight = height - sy;
	      ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
	    } else {
	      ctx.drawImage(image, x, y, width, height);
	    }
	
	    this.restoreTransform(ctx); // Draw rect text
	
	    if (style.text != null) {
	      this.drawRectText(ctx, this.getBoundingRect());
	    }
	  },
	  getBoundingRect: function () {
	    var style = this.style;
	
	    if (!this._rect) {
	      this._rect = new BoundingRect(style.x || 0, style.y || 0, style.width || 0, style.height || 0);
	    }
	
	    return this._rect;
	  }
	};
	zrUtil.inherits(ZImage, Displayable);
	var _default = ZImage;
	module.exports = _default;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(98);
	
	var zrUtil = __webpack_require__(1);
	
	var textContain = __webpack_require__(27);
	
	var textHelper = __webpack_require__(100);
	
	/**
	 * @alias zrender/graphic/Text
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	var Text = function (opts) {
	  // jshint ignore:line
	  Displayable.call(this, opts);
	};
	
	Text.prototype = {
	  constructor: Text,
	  type: 'text',
	  brush: function (ctx, prevEl) {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true); // Use props with prefix 'text'.
	
	    style.fill = style.stroke = style.shadowBlur = style.shadowColor = style.shadowOffsetX = style.shadowOffsetY = null;
	    var text = style.text; // Convert to string
	
	    text != null && (text += ''); // Always bind style
	
	    style.bind(ctx, this, prevEl);
	
	    if (!textHelper.needDrawText(text, style)) {
	      return;
	    }
	
	    this.setTransform(ctx);
	    textHelper.renderText(this, ctx, text, style);
	    this.restoreTransform(ctx);
	  },
	  getBoundingRect: function () {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	
	    if (!this._rect) {
	      var text = style.text;
	      text != null ? text += '' : text = '';
	      var rect = textContain.getBoundingRect(style.text + '', style.font, style.textAlign, style.textVerticalAlign, style.textPadding, style.rich);
	      rect.x += style.x || 0;
	      rect.y += style.y || 0;
	
	      if (textHelper.getStroke(style.textStroke, style.textStrokeWidth)) {
	        var w = style.textStrokeWidth;
	        rect.x -= w / 2;
	        rect.y -= w / 2;
	        rect.width += w;
	        rect.height += w;
	      }
	
	      this._rect = rect;
	    }
	
	    return this._rect;
	  }
	};
	zrUtil.inherits(Text, Displayable);
	var _default = Text;
	module.exports = _default;

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(104);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var _symbol = __webpack_require__(22);
	
	var createSymbol = _symbol.createSymbol;
	
	var graphic = __webpack_require__(3);
	
	var _number = __webpack_require__(4);
	
	var parsePercent = _number.parsePercent;
	
	var _labelHelper = __webpack_require__(163);
	
	var findLabelValueDim = _labelHelper.findLabelValueDim;
	
	/**
	 * @module echarts/chart/helper/Symbol
	 */
	function getSymbolSize(data, idx) {
	  var symbolSize = data.getItemVisual(idx, 'symbolSize');
	  return symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
	}
	
	function getScale(symbolSize) {
	  return [symbolSize[0] / 2, symbolSize[1] / 2];
	}
	/**
	 * @constructor
	 * @alias {module:echarts/chart/helper/Symbol}
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @extends {module:zrender/graphic/Group}
	 */
	
	
	function SymbolClz(data, idx, seriesScope) {
	  graphic.Group.call(this);
	  this.updateData(data, idx, seriesScope);
	}
	
	var symbolProto = SymbolClz.prototype;
	
	function driftSymbol(dx, dy) {
	  this.parent.drift(dx, dy);
	}
	
	symbolProto._createSymbol = function (symbolType, data, idx, symbolSize) {
	  // Remove paths created before
	  this.removeAll();
	  var color = data.getItemVisual(idx, 'color'); // var symbolPath = createSymbol(
	  //     symbolType, -0.5, -0.5, 1, 1, color
	  // );
	  // If width/height are set too small (e.g., set to 1) on ios10
	  // and macOS Sierra, a circle stroke become a rect, no matter what
	  // the scale is set. So we set width/height as 2. See #4150.
	
	  var symbolPath = createSymbol(symbolType, -1, -1, 2, 2, color);
	  symbolPath.attr({
	    z2: 100,
	    culling: true,
	    scale: getScale(symbolSize)
	  }); // Rewrite drift method
	
	  symbolPath.drift = driftSymbol;
	  this._symbolType = symbolType;
	  this.add(symbolPath);
	};
	/**
	 * Stop animation
	 * @param {boolean} toLastFrame
	 */
	
	
	symbolProto.stopSymbolAnimation = function (toLastFrame) {
	  this.childAt(0).stopAnimation(toLastFrame);
	};
	/**
	 * FIXME:
	 * Caution: This method breaks the encapsulation of this module,
	 * but it indeed brings convenience. So do not use the method
	 * unless you detailedly know all the implements of `Symbol`,
	 * especially animation.
	 *
	 * Get symbol path element.
	 */
	
	
	symbolProto.getSymbolPath = function () {
	  return this.childAt(0);
	};
	/**
	 * Get scale(aka, current symbol size).
	 * Including the change caused by animation
	 */
	
	
	symbolProto.getScale = function () {
	  return this.childAt(0).scale;
	};
	/**
	 * Highlight symbol
	 */
	
	
	symbolProto.highlight = function () {
	  this.childAt(0).trigger('emphasis');
	};
	/**
	 * Downplay symbol
	 */
	
	
	symbolProto.downplay = function () {
	  this.childAt(0).trigger('normal');
	};
	/**
	 * @param {number} zlevel
	 * @param {number} z
	 */
	
	
	symbolProto.setZ = function (zlevel, z) {
	  var symbolPath = this.childAt(0);
	  symbolPath.zlevel = zlevel;
	  symbolPath.z = z;
	};
	
	symbolProto.setDraggable = function (draggable) {
	  var symbolPath = this.childAt(0);
	  symbolPath.draggable = draggable;
	  symbolPath.cursor = draggable ? 'move' : 'pointer';
	};
	/**
	 * Update symbol properties
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @param {Object} [seriesScope]
	 * @param {Object} [seriesScope.itemStyle]
	 * @param {Object} [seriesScope.hoverItemStyle]
	 * @param {Object} [seriesScope.symbolRotate]
	 * @param {Object} [seriesScope.symbolOffset]
	 * @param {module:echarts/model/Model} [seriesScope.labelModel]
	 * @param {module:echarts/model/Model} [seriesScope.hoverLabelModel]
	 * @param {boolean} [seriesScope.hoverAnimation]
	 * @param {Object} [seriesScope.cursorStyle]
	 * @param {module:echarts/model/Model} [seriesScope.itemModel]
	 * @param {string} [seriesScope.symbolInnerColor]
	 * @param {Object} [seriesScope.fadeIn=false]
	 */
	
	
	symbolProto.updateData = function (data, idx, seriesScope) {
	  this.silent = false;
	  var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
	  var seriesModel = data.hostModel;
	  var symbolSize = getSymbolSize(data, idx);
	  var isInit = symbolType !== this._symbolType;
	
	  if (isInit) {
	    this._createSymbol(symbolType, data, idx, symbolSize);
	  } else {
	    var symbolPath = this.childAt(0);
	    symbolPath.silent = false;
	    graphic.updateProps(symbolPath, {
	      scale: getScale(symbolSize)
	    }, seriesModel, idx);
	  }
	
	  this._updateCommon(data, idx, symbolSize, seriesScope);
	
	  if (isInit) {
	    var symbolPath = this.childAt(0);
	    var fadeIn = seriesScope && seriesScope.fadeIn;
	    var target = {
	      scale: symbolPath.scale.slice()
	    };
	    fadeIn && (target.style = {
	      opacity: symbolPath.style.opacity
	    });
	    symbolPath.scale = [0, 0];
	    fadeIn && (symbolPath.style.opacity = 0);
	    graphic.initProps(symbolPath, target, seriesModel, idx);
	  }
	
	  this._seriesModel = seriesModel;
	}; // Update common properties
	
	
	var normalStyleAccessPath = ['itemStyle', 'normal'];
	var emphasisStyleAccessPath = ['itemStyle', 'emphasis'];
	var normalLabelAccessPath = ['label', 'normal'];
	var emphasisLabelAccessPath = ['label', 'emphasis'];
	/**
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @param {Array.<number>} symbolSize
	 * @param {Object} [seriesScope]
	 */
	
	symbolProto._updateCommon = function (data, idx, symbolSize, seriesScope) {
	  var symbolPath = this.childAt(0);
	  var seriesModel = data.hostModel;
	  var color = data.getItemVisual(idx, 'color'); // Reset style
	
	  if (symbolPath.type !== 'image') {
	    symbolPath.useStyle({
	      strokeNoScale: true
	    });
	  }
	
	  var itemStyle = seriesScope && seriesScope.itemStyle;
	  var hoverItemStyle = seriesScope && seriesScope.hoverItemStyle;
	  var symbolRotate = seriesScope && seriesScope.symbolRotate;
	  var symbolOffset = seriesScope && seriesScope.symbolOffset;
	  var labelModel = seriesScope && seriesScope.labelModel;
	  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel;
	  var hoverAnimation = seriesScope && seriesScope.hoverAnimation;
	  var cursorStyle = seriesScope && seriesScope.cursorStyle;
	
	  if (!seriesScope || data.hasItemOption) {
	    var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx); // Color must be excluded.
	    // Because symbol provide setColor individually to set fill and stroke
	
	    itemStyle = itemModel.getModel(normalStyleAccessPath).getItemStyle(['color']);
	    hoverItemStyle = itemModel.getModel(emphasisStyleAccessPath).getItemStyle();
	    symbolRotate = itemModel.getShallow('symbolRotate');
	    symbolOffset = itemModel.getShallow('symbolOffset');
	    labelModel = itemModel.getModel(normalLabelAccessPath);
	    hoverLabelModel = itemModel.getModel(emphasisLabelAccessPath);
	    hoverAnimation = itemModel.getShallow('hoverAnimation');
	    cursorStyle = itemModel.getShallow('cursor');
	  } else {
	    hoverItemStyle = zrUtil.extend({}, hoverItemStyle);
	  }
	
	  var elStyle = symbolPath.style;
	  symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
	
	  if (symbolOffset) {
	    symbolPath.attr('position', [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])]);
	  }
	
	  cursorStyle && symbolPath.attr('cursor', cursorStyle); // PENDING setColor before setStyle!!!
	
	  symbolPath.setColor(color, seriesScope && seriesScope.symbolInnerColor);
	  symbolPath.setStyle(itemStyle);
	  var opacity = data.getItemVisual(idx, 'opacity');
	
	  if (opacity != null) {
	    elStyle.opacity = opacity;
	  }
	
	  var useNameLabel = seriesScope && seriesScope.useNameLabel;
	  var valueDim = !useNameLabel && findLabelValueDim(data);
	
	  if (useNameLabel || valueDim != null) {
	    graphic.setLabelStyle(elStyle, hoverItemStyle, labelModel, hoverLabelModel, {
	      labelFetcher: seriesModel,
	      labelDataIndex: idx,
	      defaultText: useNameLabel ? data.getName(idx) : data.get(valueDim, idx),
	      isRectText: true,
	      autoColor: color
	    });
	  }
	
	  symbolPath.off('mouseover').off('mouseout').off('emphasis').off('normal');
	  symbolPath.hoverStyle = hoverItemStyle; // FIXME
	  // Do not use symbol.trigger('emphasis'), but use symbol.highlight() instead.
	
	  graphic.setHoverStyle(symbolPath);
	  var scale = getScale(symbolSize);
	
	  if (hoverAnimation && seriesModel.isAnimationEnabled()) {
	    var onEmphasis = function () {
	      var ratio = scale[1] / scale[0];
	      this.animateTo({
	        scale: [Math.max(scale[0] * 1.1, scale[0] + 3), Math.max(scale[1] * 1.1, scale[1] + 3 * ratio)]
	      }, 400, 'elasticOut');
	    };
	
	    var onNormal = function () {
	      this.animateTo({
	        scale: scale
	      }, 400, 'elasticOut');
	    };
	
	    symbolPath.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal);
	  }
	};
	/**
	 * @param {Function} cb
	 * @param {Object} [opt]
	 * @param {Object} [opt.keepLabel=true]
	 */
	
	
	symbolProto.fadeOut = function (cb, opt) {
	  var symbolPath = this.childAt(0); // Avoid mistaken hover when fading out
	
	  this.silent = symbolPath.silent = true; // Not show text when animating
	
	  !(opt && opt.keepLabel) && (symbolPath.style.text = null);
	  graphic.updateProps(symbolPath, {
	    style: {
	      opacity: 0
	    },
	    scale: [0, 0]
	  }, this._seriesModel, this.dataIndex, cb);
	};
	
	zrUtil.inherits(SymbolClz, graphic.Group);
	var _default = SymbolClz;
	module.exports = _default;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var List = __webpack_require__(15);
	
	var completeDimensions = __webpack_require__(25);
	
	var WhiskerBoxDraw = __webpack_require__(398);
	
	var zrUtil = __webpack_require__(1);
	
	var seriesModelMixin = {
	  /**
	   * @private
	   * @type {string}
	   */
	  _baseAxisDim: null,
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    // When both types of xAxis and yAxis are 'value', layout is
	    // needed to be specified by user. Otherwise, layout can be
	    // judged by which axis is category.
	    var categories;
	    var xAxisModel = ecModel.getComponent('xAxis', this.get('xAxisIndex'));
	    var yAxisModel = ecModel.getComponent('yAxis', this.get('yAxisIndex'));
	    var xAxisType = xAxisModel.get('type');
	    var yAxisType = yAxisModel.get('type');
	    var addOrdinal; // FIXME
	    // 考虑时间轴
	
	    if (xAxisType === 'category') {
	      option.layout = 'horizontal';
	      categories = xAxisModel.getCategories();
	      addOrdinal = true;
	    } else if (yAxisType === 'category') {
	      option.layout = 'vertical';
	      categories = yAxisModel.getCategories();
	      addOrdinal = true;
	    } else {
	      option.layout = option.layout || 'horizontal';
	    }
	
	    var coordDims = ['x', 'y'];
	    var baseAxisDimIndex = option.layout === 'horizontal' ? 0 : 1;
	    var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
	    var otherAxisDim = coordDims[1 - baseAxisDimIndex];
	    var data = option.data;
	    addOrdinal && zrUtil.each(data, function (item, index) {
	      if (item.value && zrUtil.isArray(item.value)) {
	        item.value.unshift(index);
	      } else {
	        zrUtil.isArray(item) && item.unshift(index);
	      }
	    });
	    var defaultValueDimensions = this.defaultValueDimensions;
	    var dimensions = [{
	      name: baseAxisDim,
	      otherDims: {
	        tooltip: false
	      },
	      dimsDef: ['base']
	    }, {
	      name: otherAxisDim,
	      dimsDef: defaultValueDimensions.slice()
	    }];
	    dimensions = completeDimensions(dimensions, data, {
	      encodeDef: this.get('encode'),
	      dimsDef: this.get('dimensions'),
	      // Consider empty data entry.
	      dimCount: defaultValueDimensions.length + 1
	    });
	    var list = new List(dimensions, this);
	    list.initData(data, categories ? categories.slice() : null);
	    return list;
	  },
	
	  /**
	   * If horizontal, base axis is x, otherwise y.
	   * @override
	   */
	  getBaseAxis: function () {
	    var dim = this._baseAxisDim;
	    return this.ecModel.getComponent(dim + 'Axis', this.get(dim + 'AxisIndex')).axis;
	  }
	};
	var viewMixin = {
	  init: function () {
	    /**
	     * Old data.
	     * @private
	     * @type {module:echarts/chart/helper/WhiskerBoxDraw}
	     */
	    var whiskerBoxDraw = this._whiskerBoxDraw = new WhiskerBoxDraw(this.getStyleUpdater());
	    this.group.add(whiskerBoxDraw.group);
	  },
	  render: function (seriesModel, ecModel, api) {
	    this._whiskerBoxDraw.updateData(seriesModel.getData());
	  },
	  remove: function (ecModel) {
	    this._whiskerBoxDraw.remove();
	  }
	};
	exports.seriesModelMixin = seriesModelMixin;
	exports.viewMixin = viewMixin;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Model = __webpack_require__(14);
	
	var each = zrUtil.each;
	var curry = zrUtil.curry; // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
	// allAxesInfo should be updated when setOption performed.
	
	function collect(ecModel, api) {
	  var result = {
	    /**
	     * key: makeKey(axis.model)
	     * value: {
	     *      axis,
	     *      coordSys,
	     *      axisPointerModel,
	     *      triggerTooltip,
	     *      involveSeries,
	     *      snap,
	     *      seriesModels,
	     *      seriesDataCount
	     * }
	     */
	    axesInfo: {},
	    seriesInvolved: false,
	
	    /**
	     * key: makeKey(coordSys.model)
	     * value: Object: key makeKey(axis.model), value: axisInfo
	     */
	    coordSysAxesInfo: {},
	    coordSysMap: {}
	  };
	  collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.
	
	  result.seriesInvolved && collectSeriesInfo(result, ecModel);
	  return result;
	}
	
	function collectAxesInfo(result, ecModel, api) {
	  var globalTooltipModel = ecModel.getComponent('tooltip');
	  var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.
	
	  var linksOption = globalAxisPointerModel.get('link', true) || [];
	  var linkGroups = []; // Collect axes info.
	
	  each(api.getCoordinateSystems(), function (coordSys) {
	    // Some coordinate system do not support axes, like geo.
	    if (!coordSys.axisPointerEnabled) {
	      return;
	    }
	
	    var coordSysKey = makeKey(coordSys.model);
	    var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
	    result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
	    // for user. So we enable seting tooltip on coordSys model.
	
	    var coordSysModel = coordSys.model;
	    var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
	    each(coordSys.getAxes(), curry(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
	    // Notice this case: coordSys is `grid` but not `cartesian2D` here.
	
	    if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
	    // show but axisPointer will show as normal.
	    && baseTooltipModel.get('show')) {
	      // Compatible with previous logic. But series.tooltip.trigger: 'axis'
	      // or series.data[n].tooltip.trigger: 'axis' are not support any more.
	      var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
	      var cross = baseTooltipModel.get('axisPointer.type') === 'cross';
	      var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get('axisPointer.axis'));
	
	      if (triggerAxis || cross) {
	        each(tooltipAxes.baseAxes, curry(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
	      }
	
	      if (cross) {
	        each(tooltipAxes.otherAxes, curry(saveTooltipAxisInfo, 'cross', false));
	      }
	    } // fromTooltip: true | false | 'cross'
	    // triggerTooltip: true | false | null
	
	
	    function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
	      var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
	      var axisPointerShow = axisPointerModel.get('show');
	
	      if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !isHandleTrigger(axisPointerModel)) {
	        return;
	      }
	
	      if (triggerTooltip == null) {
	        triggerTooltip = axisPointerModel.get('triggerTooltip');
	      }
	
	      axisPointerModel = fromTooltip ? makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
	      var snap = axisPointerModel.get('snap');
	      var key = makeKey(axis.model);
	      var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).
	
	      var axisInfo = result.axesInfo[key] = {
	        key: key,
	        axis: axis,
	        coordSys: coordSys,
	        axisPointerModel: axisPointerModel,
	        triggerTooltip: triggerTooltip,
	        involveSeries: involveSeries,
	        snap: snap,
	        useHandle: isHandleTrigger(axisPointerModel),
	        seriesModels: []
	      };
	      axesInfoInCoordSys[key] = axisInfo;
	      result.seriesInvolved |= involveSeries;
	      var groupIndex = getLinkGroupIndex(linksOption, axis);
	
	      if (groupIndex != null) {
	        var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
	          axesInfo: {}
	        });
	        linkGroup.axesInfo[key] = axisInfo;
	        linkGroup.mapper = linksOption[groupIndex].mapper;
	        axisInfo.linkGroup = linkGroup;
	      }
	    }
	  });
	}
	
	function makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
	  var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
	  var volatileOption = {};
	  each(['type', 'snap', 'lineStyle', 'shadowStyle', 'label', 'animation', 'animationDurationUpdate', 'animationEasingUpdate', 'z'], function (field) {
	    volatileOption[field] = zrUtil.clone(tooltipAxisPointerModel.get(field));
	  }); // category axis do not auto snap, otherwise some tick that do not
	  // has value can not be hovered. value/time/log axis default snap if
	  // triggered from tooltip and trigger tooltip.
	
	  volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
	  // Only these properties can be overrided from tooltip to axisPointer.
	
	  if (tooltipAxisPointerModel.get('type') === 'cross') {
	    volatileOption.type = 'line';
	  }
	
	  var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.
	
	  labelOption.show == null && (labelOption.show = false);
	
	  if (fromTooltip === 'cross') {
	    // When 'cross', both axes show labels.
	    labelOption.show = true; // If triggerTooltip, this is a base axis, which should better not use cross style
	    // (cross style is dashed by default)
	
	    if (!triggerTooltip) {
	      var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
	      crossStyle && zrUtil.defaults(labelOption, crossStyle.textStyle);
	    }
	  }
	
	  return axis.model.getModel('axisPointer', new Model(volatileOption, globalAxisPointerModel, ecModel));
	}
	
	function collectSeriesInfo(result, ecModel) {
	  // Prepare data for axis trigger
	  ecModel.eachSeries(function (seriesModel) {
	    // Notice this case: this coordSys is `cartesian2D` but not `grid`.
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesTooltipTrigger = seriesModel.get('tooltip.trigger', true);
	    var seriesTooltipShow = seriesModel.get('tooltip.show', true);
	
	    if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get('axisPointer.show', true) === false) {
	      return;
	    }
	
	    each(result.coordSysAxesInfo[makeKey(coordSys.model)], function (axisInfo) {
	      var axis = axisInfo.axis;
	
	      if (coordSys.getAxis(axis.dim) === axis) {
	        axisInfo.seriesModels.push(seriesModel);
	        axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
	        axisInfo.seriesDataCount += seriesModel.getData().count();
	      }
	    });
	  }, this);
	}
	/**
	 * For example:
	 * {
	 *     axisPointer: {
	 *         links: [{
	 *             xAxisIndex: [2, 4],
	 *             yAxisIndex: 'all'
	 *         }, {
	 *             xAxisId: ['a5', 'a7'],
	 *             xAxisName: 'xxx'
	 *         }]
	 *     }
	 * }
	 */
	
	
	function getLinkGroupIndex(linksOption, axis) {
	  var axisModel = axis.model;
	  var dim = axis.dim;
	
	  for (var i = 0; i < linksOption.length; i++) {
	    var linkOption = linksOption[i] || {};
	
	    if (checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) {
	      return i;
	    }
	  }
	}
	
	function checkPropInLink(linkPropValue, axisPropValue) {
	  return linkPropValue === 'all' || zrUtil.isArray(linkPropValue) && zrUtil.indexOf(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
	}
	
	function fixValue(axisModel) {
	  var axisInfo = getAxisInfo(axisModel);
	
	  if (!axisInfo) {
	    return;
	  }
	
	  var axisPointerModel = axisInfo.axisPointerModel;
	  var scale = axisInfo.axis.scale;
	  var option = axisPointerModel.option;
	  var status = axisPointerModel.get('status');
	  var value = axisPointerModel.get('value'); // Parse init value for category and time axis.
	
	  if (value != null) {
	    value = scale.parse(value);
	  }
	
	  var useHandle = isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
	  // and status should be initialized.
	
	  if (status == null) {
	    option.status = useHandle ? 'show' : 'hide';
	  }
	
	  var extent = scale.getExtent().slice();
	  extent[0] > extent[1] && extent.reverse();
	
	  if ( // Pick a value on axis when initializing.
	  value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
	  // where we should re-pick a value to keep `handle` displaying normally.
	  || value > extent[1]) {
	    // Make handle displayed on the end of the axis when init, which looks better.
	    value = extent[1];
	  }
	
	  if (value < extent[0]) {
	    value = extent[0];
	  }
	
	  option.value = value;
	
	  if (useHandle) {
	    option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
	  }
	}
	
	function getAxisInfo(axisModel) {
	  var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
	  return coordSysAxesInfo && coordSysAxesInfo.axesInfo[makeKey(axisModel)];
	}
	
	function getAxisPointerModel(axisModel) {
	  var axisInfo = getAxisInfo(axisModel);
	  return axisInfo && axisInfo.axisPointerModel;
	}
	
	function isHandleTrigger(axisPointerModel) {
	  return !!axisPointerModel.get('handle.show');
	}
	/**
	 * @param {module:echarts/model/Model} model
	 * @return {string} unique key
	 */
	
	
	function makeKey(model) {
	  return model.type + '||' + model.id;
	}
	
	exports.collect = collect;
	exports.fixValue = fixValue;
	exports.getAxisInfo = getAxisInfo;
	exports.getAxisPointerModel = getAxisPointerModel;
	exports.makeKey = makeKey;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var textContain = __webpack_require__(27);
	
	var formatUtil = __webpack_require__(9);
	
	var matrix = __webpack_require__(23);
	
	var axisHelper = __webpack_require__(21);
	
	var AxisBuilder = __webpack_require__(43);
	
	/**
	 * @param {module:echarts/model/Model} axisPointerModel
	 */
	function buildElStyle(axisPointerModel) {
	  var axisPointerType = axisPointerModel.get('type');
	  var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
	  var style;
	
	  if (axisPointerType === 'line') {
	    style = styleModel.getLineStyle();
	    style.fill = null;
	  } else if (axisPointerType === 'shadow') {
	    style = styleModel.getAreaStyle();
	    style.stroke = null;
	  }
	
	  return style;
	}
	/**
	 * @param {Function} labelPos {align, verticalAlign, position}
	 */
	
	
	function buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos) {
	  var value = axisPointerModel.get('value');
	  var text = getValueLabel(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
	    precision: axisPointerModel.get('label.precision'),
	    formatter: axisPointerModel.get('label.formatter')
	  });
	  var labelModel = axisPointerModel.getModel('label');
	  var paddings = formatUtil.normalizeCssArray(labelModel.get('padding') || 0);
	  var font = labelModel.getFont();
	  var textRect = textContain.getBoundingRect(text, font);
	  var position = labelPos.position;
	  var width = textRect.width + paddings[1] + paddings[3];
	  var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.
	
	  var align = labelPos.align;
	  align === 'right' && (position[0] -= width);
	  align === 'center' && (position[0] -= width / 2);
	  var verticalAlign = labelPos.verticalAlign;
	  verticalAlign === 'bottom' && (position[1] -= height);
	  verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container
	
	  confineInContainer(position, width, height, api);
	  var bgColor = labelModel.get('backgroundColor');
	
	  if (!bgColor || bgColor === 'auto') {
	    bgColor = axisModel.get('axisLine.lineStyle.color');
	  }
	
	  elOption.label = {
	    shape: {
	      x: 0,
	      y: 0,
	      width: width,
	      height: height,
	      r: labelModel.get('borderRadius')
	    },
	    position: position.slice(),
	    // TODO: rich
	    style: {
	      text: text,
	      textFont: font,
	      textFill: labelModel.getTextColor(),
	      textPosition: 'inside',
	      fill: bgColor,
	      stroke: labelModel.get('borderColor') || 'transparent',
	      lineWidth: labelModel.get('borderWidth') || 0,
	      shadowBlur: labelModel.get('shadowBlur'),
	      shadowColor: labelModel.get('shadowColor'),
	      shadowOffsetX: labelModel.get('shadowOffsetX'),
	      shadowOffsetY: labelModel.get('shadowOffsetY')
	    },
	    // Lable should be over axisPointer.
	    z2: 10
	  };
	} // Do not overflow ec container
	
	
	function confineInContainer(position, width, height, api) {
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  position[0] = Math.min(position[0] + width, viewWidth) - width;
	  position[1] = Math.min(position[1] + height, viewHeight) - height;
	  position[0] = Math.max(position[0], 0);
	  position[1] = Math.max(position[1], 0);
	}
	/**
	 * @param {number} value
	 * @param {module:echarts/coord/Axis} axis
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} opt
	 * @param {Array.<Object>} seriesDataIndices
	 * @param {number|string} opt.precision 'auto' or a number
	 * @param {string|Function} opt.formatter label formatter
	 */
	
	
	function getValueLabel(value, axis, ecModel, seriesDataIndices, opt) {
	  var text = axis.scale.getLabel( // If `precision` is set, width can be fixed (like '12.00500'), which
	  // helps to debounce when when moving label.
	  value, {
	    precision: opt.precision
	  });
	  var formatter = opt.formatter;
	
	  if (formatter) {
	    var params = {
	      value: axisHelper.getAxisRawValue(axis, value),
	      seriesData: []
	    };
	    zrUtil.each(seriesDataIndices, function (idxItem) {
	      var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
	      var dataIndex = idxItem.dataIndexInside;
	      var dataParams = series && series.getDataParams(dataIndex);
	      dataParams && params.seriesData.push(dataParams);
	    });
	
	    if (zrUtil.isString(formatter)) {
	      text = formatter.replace('{value}', text);
	    } else if (zrUtil.isFunction(formatter)) {
	      text = formatter(params);
	    }
	  }
	
	  return text;
	}
	/**
	 * @param {module:echarts/coord/Axis} axis
	 * @param {number} value
	 * @param {Object} layoutInfo {
	 *  rotation, position, labelOffset, labelDirection, labelMargin
	 * }
	 */
	
	
	function getTransformedPosition(axis, value, layoutInfo) {
	  var transform = matrix.create();
	  matrix.rotate(transform, transform, layoutInfo.rotation);
	  matrix.translate(transform, transform, layoutInfo.position);
	  return graphic.applyTransform([axis.dataToCoord(value), (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)], transform);
	}
	
	function buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
	  var textLayout = AxisBuilder.innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
	  layoutInfo.labelMargin = axisPointerModel.get('label.margin');
	  buildLabelElOption(elOption, axisModel, axisPointerModel, api, {
	    position: getTransformedPosition(axisModel.axis, value, layoutInfo),
	    align: textLayout.textAlign,
	    verticalAlign: textLayout.textVerticalAlign
	  });
	}
	/**
	 * @param {Array.<number>} p1
	 * @param {Array.<number>} p2
	 * @param {number} [xDimIndex=0] or 1
	 */
	
	
	function makeLineShape(p1, p2, xDimIndex) {
	  xDimIndex = xDimIndex || 0;
	  return {
	    x1: p1[xDimIndex],
	    y1: p1[1 - xDimIndex],
	    x2: p2[xDimIndex],
	    y2: p2[1 - xDimIndex]
	  };
	}
	/**
	 * @param {Array.<number>} xy
	 * @param {Array.<number>} wh
	 * @param {number} [xDimIndex=0] or 1
	 */
	
	
	function makeRectShape(xy, wh, xDimIndex) {
	  xDimIndex = xDimIndex || 0;
	  return {
	    x: xy[xDimIndex],
	    y: xy[1 - xDimIndex],
	    width: wh[xDimIndex],
	    height: wh[1 - xDimIndex]
	  };
	}
	
	function makeSectorShape(cx, cy, r0, r, startAngle, endAngle) {
	  return {
	    cx: cx,
	    cy: cy,
	    r0: r0,
	    r: r,
	    startAngle: startAngle,
	    endAngle: endAngle,
	    clockwise: true
	  };
	}
	
	exports.buildElStyle = buildElStyle;
	exports.buildLabelElOption = buildLabelElOption;
	exports.getValueLabel = getValueLabel;
	exports.getTransformedPosition = getTransformedPosition;
	exports.buildCartesianSingleLabelElOption = buildCartesianSingleLabelElOption;
	exports.makeLineShape = makeLineShape;
	exports.makeRectShape = makeRectShape;
	exports.makeSectorShape = makeSectorShape;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Eventful = __webpack_require__(49);
	
	var eventTool = __webpack_require__(30);
	
	var interactionMutex = __webpack_require__(179);
	
	/**
	 * @alias module:echarts/component/helper/RoamController
	 * @constructor
	 * @mixin {module:zrender/mixin/Eventful}
	 *
	 * @param {module:zrender/zrender~ZRender} zr
	 */
	function RoamController(zr) {
	  /**
	   * @type {Function}
	   */
	  this.pointerChecker;
	  /**
	   * @type {module:zrender}
	   */
	
	  this._zr = zr;
	  /**
	   * @type {Object}
	   */
	
	  this._opt = {}; // Avoid two roamController bind the same handler
	
	  var bind = zrUtil.bind;
	  var mousedownHandler = bind(mousedown, this);
	  var mousemoveHandler = bind(mousemove, this);
	  var mouseupHandler = bind(mouseup, this);
	  var mousewheelHandler = bind(mousewheel, this);
	  var pinchHandler = bind(pinch, this);
	  Eventful.call(this);
	  /**
	   * @param {Function} pointerChecker
	   *                   input: x, y
	   *                   output: boolean
	   */
	
	  this.setPointerChecker = function (pointerChecker) {
	    this.pointerChecker = pointerChecker;
	  };
	  /**
	   * Notice: only enable needed types. For example, if 'zoom'
	   * is not needed, 'zoom' should not be enabled, otherwise
	   * default mousewheel behaviour (scroll page) will be disabled.
	   *
	   * @param  {boolean|string} [controlType=true] Specify the control type,
	   *                          which can be null/undefined or true/false
	   *                          or 'pan/move' or 'zoom'/'scale'
	   * @param {Object} [opt]
	   * @param {Object} [opt.zoomOnMouseWheel=true]
	   * @param {Object} [opt.moveOnMouseMove=true]
	   * @param {Object} [opt.preventDefaultMouseMove=true] When pan.
	   */
	
	
	  this.enable = function (controlType, opt) {
	    // Disable previous first
	    this.disable();
	    this._opt = zrUtil.defaults(zrUtil.clone(opt) || {}, {
	      zoomOnMouseWheel: true,
	      moveOnMouseMove: true,
	      preventDefaultMouseMove: true
	    });
	
	    if (controlType == null) {
	      controlType = true;
	    }
	
	    if (controlType === true || controlType === 'move' || controlType === 'pan') {
	      zr.on('mousedown', mousedownHandler);
	      zr.on('mousemove', mousemoveHandler);
	      zr.on('mouseup', mouseupHandler);
	    }
	
	    if (controlType === true || controlType === 'scale' || controlType === 'zoom') {
	      zr.on('mousewheel', mousewheelHandler);
	      zr.on('pinch', pinchHandler);
	    }
	  };
	
	  this.disable = function () {
	    zr.off('mousedown', mousedownHandler);
	    zr.off('mousemove', mousemoveHandler);
	    zr.off('mouseup', mouseupHandler);
	    zr.off('mousewheel', mousewheelHandler);
	    zr.off('pinch', pinchHandler);
	  };
	
	  this.dispose = this.disable;
	
	  this.isDragging = function () {
	    return this._dragging;
	  };
	
	  this.isPinching = function () {
	    return this._pinching;
	  };
	}
	
	zrUtil.mixin(RoamController, Eventful);
	
	function mousedown(e) {
	  if (eventTool.notLeftMouse(e) || e.target && e.target.draggable) {
	    return;
	  }
	
	  var x = e.offsetX;
	  var y = e.offsetY; // Only check on mosedown, but not mousemove.
	  // Mouse can be out of target when mouse moving.
	
	  if (this.pointerChecker && this.pointerChecker(e, x, y)) {
	    this._x = x;
	    this._y = y;
	    this._dragging = true;
	  }
	}
	
	function mousemove(e) {
	  if (eventTool.notLeftMouse(e) || !checkKeyBinding(this, 'moveOnMouseMove', e) || !this._dragging || e.gestureEvent === 'pinch' || interactionMutex.isTaken(this._zr, 'globalPan')) {
	    return;
	  }
	
	  var x = e.offsetX;
	  var y = e.offsetY;
	  var oldX = this._x;
	  var oldY = this._y;
	  var dx = x - oldX;
	  var dy = y - oldY;
	  this._x = x;
	  this._y = y;
	  this._opt.preventDefaultMouseMove && eventTool.stop(e.event);
	  this.trigger('pan', dx, dy, oldX, oldY, x, y);
	}
	
	function mouseup(e) {
	  if (!eventTool.notLeftMouse(e)) {
	    this._dragging = false;
	  }
	}
	
	function mousewheel(e) {
	  // wheelDelta maybe -0 in chrome mac.
	  if (!checkKeyBinding(this, 'zoomOnMouseWheel', e) || e.wheelDelta === 0) {
	    return;
	  } // Convenience:
	  // Mac and VM Windows on Mac: scroll up: zoom out.
	  // Windows: scroll up: zoom in.
	
	
	  var zoomDelta = e.wheelDelta > 0 ? 1.1 : 1 / 1.1;
	  zoom.call(this, e, zoomDelta, e.offsetX, e.offsetY);
	}
	
	function pinch(e) {
	  if (interactionMutex.isTaken(this._zr, 'globalPan')) {
	    return;
	  }
	
	  var zoomDelta = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
	  zoom.call(this, e, zoomDelta, e.pinchX, e.pinchY);
	}
	
	function zoom(e, zoomDelta, zoomX, zoomY) {
	  if (this.pointerChecker && this.pointerChecker(e, zoomX, zoomY)) {
	    // When mouse is out of roamController rect,
	    // default befavoius should not be be disabled, otherwise
	    // page sliding is disabled, contrary to expectation.
	    eventTool.stop(e.event);
	    this.trigger('zoom', zoomDelta, zoomX, zoomY);
	  }
	}
	
	function checkKeyBinding(roamController, prop, e) {
	  var setting = roamController._opt[prop];
	  return setting && (!zrUtil.isString(setting) || e.event[setting + 'Key']);
	}
	
	var _default = RoamController;
	module.exports = _default;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var axisDefault = __webpack_require__(194);
	
	var ComponentModel = __webpack_require__(16);
	
	var _layout = __webpack_require__(7);
	
	var getLayoutParams = _layout.getLayoutParams;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	// FIXME axisType is fixed ?
	var AXIS_TYPES = ['value', 'category', 'time', 'log'];
	/**
	 * Generate sub axis model class
	 * @param {string} axisName 'x' 'y' 'radius' 'angle' 'parallel'
	 * @param {module:echarts/model/Component} BaseAxisModelClass
	 * @param {Function} axisTypeDefaulter
	 * @param {Object} [extraDefaultOption]
	 */
	
	function _default(axisName, BaseAxisModelClass, axisTypeDefaulter, extraDefaultOption) {
	  zrUtil.each(AXIS_TYPES, function (axisType) {
	    BaseAxisModelClass.extend({
	      type: axisName + 'Axis.' + axisType,
	      mergeDefaultAndTheme: function (option, ecModel) {
	        var layoutMode = this.layoutMode;
	        var inputPositionParams = layoutMode ? getLayoutParams(option) : {};
	        var themeModel = ecModel.getTheme();
	        zrUtil.merge(option, themeModel.get(axisType + 'Axis'));
	        zrUtil.merge(option, this.getDefaultOption());
	        option.type = axisTypeDefaulter(axisName, option);
	
	        if (layoutMode) {
	          mergeLayoutParam(option, inputPositionParams, layoutMode);
	        }
	      },
	      defaultOption: zrUtil.mergeAll([{}, axisDefault[axisType + 'Axis'], extraDefaultOption], true)
	    });
	  });
	  ComponentModel.registerSubTypeDefaulter(axisName + 'Axis', zrUtil.curry(axisTypeDefaulter, axisName));
	}
	
	module.exports = _default;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var Geo = __webpack_require__(552);
	
	var layout = __webpack_require__(7);
	
	var numberUtil = __webpack_require__(4);
	
	/**
	 * Resize method bound to the geo
	 * @param {module:echarts/coord/geo/GeoModel|module:echarts/chart/map/MapModel} geoModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function resizeGeo(geoModel, api) {
	  var boundingCoords = geoModel.get('boundingCoords');
	
	  if (boundingCoords != null) {
	    var leftTop = boundingCoords[0];
	    var rightBottom = boundingCoords[1];
	
	    if (isNaN(leftTop[0]) || isNaN(leftTop[1]) || isNaN(rightBottom[0]) || isNaN(rightBottom[1])) {} else {
	      this.setBoundingRect(leftTop[0], leftTop[1], rightBottom[0] - leftTop[0], rightBottom[1] - leftTop[1]);
	    }
	  }
	
	  var rect = this.getBoundingRect();
	  var boxLayoutOption;
	  var center = geoModel.get('layoutCenter');
	  var size = geoModel.get('layoutSize');
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  var aspectScale = geoModel.get('aspectScale') || 0.75;
	  var aspect = rect.width / rect.height * aspectScale;
	  var useCenterAndSize = false;
	
	  if (center && size) {
	    center = [numberUtil.parsePercent(center[0], viewWidth), numberUtil.parsePercent(center[1], viewHeight)];
	    size = numberUtil.parsePercent(size, Math.min(viewWidth, viewHeight));
	
	    if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) {
	      useCenterAndSize = true;
	    } else {}
	  }
	
	  var viewRect;
	
	  if (useCenterAndSize) {
	    var viewRect = {};
	
	    if (aspect > 1) {
	      // Width is same with size
	      viewRect.width = size;
	      viewRect.height = size / aspect;
	    } else {
	      viewRect.height = size;
	      viewRect.width = size * aspect;
	    }
	
	    viewRect.y = center[1] - viewRect.height / 2;
	    viewRect.x = center[0] - viewRect.width / 2;
	  } else {
	    // Use left/top/width/height
	    boxLayoutOption = geoModel.getBoxLayoutParams(); // 0.75 rate
	
	    boxLayoutOption.aspect = aspect;
	    viewRect = layout.getLayoutRect(boxLayoutOption, {
	      width: viewWidth,
	      height: viewHeight
	    });
	  }
	
	  this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
	  this.setCenter(geoModel.get('center'));
	  this.setZoom(geoModel.get('zoom'));
	}
	/**
	 * @param {module:echarts/coord/Geo} geo
	 * @param {module:echarts/model/Model} model
	 * @inner
	 */
	
	
	function setGeoCoords(geo, model) {
	  zrUtil.each(model.get('geoCoord'), function (geoCoord, name) {
	    geo.addGeoCoord(name, geoCoord);
	  });
	}
	
	var geoCreator = {
	  // For deciding which dimensions to use when creating list data
	  dimensions: Geo.prototype.dimensions,
	  create: function (ecModel, api) {
	    var geoList = []; // FIXME Create each time may be slow
	
	    ecModel.eachComponent('geo', function (geoModel, idx) {
	      var name = geoModel.get('map');
	      var mapData = echarts.getMap(name);
	      var geo = new Geo(name + idx, name, mapData && mapData.geoJson, mapData && mapData.specialAreas, geoModel.get('nameMap'));
	      geo.zoomLimit = geoModel.get('scaleLimit');
	      geoList.push(geo);
	      setGeoCoords(geo, geoModel);
	      geoModel.coordinateSystem = geo;
	      geo.model = geoModel; // Inject resize method
	
	      geo.resize = resizeGeo;
	      geo.resize(geoModel, api);
	    });
	    ecModel.eachSeries(function (seriesModel) {
	      var coordSys = seriesModel.get('coordinateSystem');
	
	      if (coordSys === 'geo') {
	        var geoIndex = seriesModel.get('geoIndex') || 0;
	        seriesModel.coordinateSystem = geoList[geoIndex];
	      }
	    }); // If has map series
	
	    var mapModelGroupBySeries = {};
	    ecModel.eachSeriesByType('map', function (seriesModel) {
	      if (!seriesModel.getHostGeoModel()) {
	        var mapType = seriesModel.getMapType();
	        mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
	        mapModelGroupBySeries[mapType].push(seriesModel);
	      }
	    });
	    zrUtil.each(mapModelGroupBySeries, function (mapSeries, mapType) {
	      var mapData = echarts.getMap(mapType);
	      var nameMapList = zrUtil.map(mapSeries, function (singleMapSeries) {
	        return singleMapSeries.get('nameMap');
	      });
	      var geo = new Geo(mapType, mapType, mapData && mapData.geoJson, mapData && mapData.specialAreas, zrUtil.mergeAll(nameMapList));
	      geo.zoomLimit = zrUtil.retrieve.apply(null, zrUtil.map(mapSeries, function (singleMapSeries) {
	        return singleMapSeries.get('scaleLimit');
	      }));
	      geoList.push(geo); // Inject resize method
	
	      geo.resize = resizeGeo;
	      geo.resize(mapSeries[0], api);
	      zrUtil.each(mapSeries, function (singleMapSeries) {
	        singleMapSeries.coordinateSystem = geo;
	        setGeoCoords(geo, singleMapSeries);
	      });
	    });
	    return geoList;
	  },
	
	  /**
	   * Fill given regions array
	   * @param  {Array.<Object>} originRegionArr
	   * @param  {string} mapName
	   * @param  {Object} [nameMap]
	   * @return {Array}
	   */
	  getFilledRegions: function (originRegionArr, mapName, nameMap) {
	    // Not use the original
	    var regionsArr = (originRegionArr || []).slice();
	    nameMap = nameMap || {};
	    var map = echarts.getMap(mapName);
	    var geoJson = map && map.geoJson;
	
	    if (!geoJson) {
	      return originRegionArr;
	    }
	
	    var dataNameMap = zrUtil.createHashMap();
	    var features = geoJson.features;
	
	    for (var i = 0; i < regionsArr.length; i++) {
	      dataNameMap.set(regionsArr[i].name, regionsArr[i]);
	    }
	
	    for (var i = 0; i < features.length; i++) {
	      var name = features[i].properties.name;
	
	      if (!dataNameMap.get(name)) {
	        if (nameMap.hasOwnProperty(name)) {
	          name = nameMap[name];
	        }
	
	        regionsArr.push({
	          name: name
	        });
	      }
	    }
	
	    return regionsArr;
	  }
	};
	echarts.registerCoordinateSystem('geo', geoCreator);
	var _default = geoCreator;
	module.exports = _default;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	function _default(seriesType, ecModel) {
	  var legendModels = ecModel.findComponents({
	    mainType: 'legend'
	  });
	
	  if (!legendModels || !legendModels.length) {
	    return;
	  }
	
	  ecModel.eachSeriesByType(seriesType, function (series) {
	    var data = series.getData();
	    data.filterSelf(function (idx) {
	      var name = data.getName(idx); // If in any legend component the status is not selected.
	
	      for (var i = 0; i < legendModels.length; i++) {
	        if (!legendModels[i].isSelected(name)) {
	          return false;
	        }
	      }
	
	      return true;
	    }, this);
	  }, this);
	}
	
	module.exports = _default;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var numberUtil = __webpack_require__(4);
	
	var formatUtil = __webpack_require__(9);
	
	var Scale = __webpack_require__(92);
	
	var helper = __webpack_require__(203);
	
	/**
	 * Interval scale
	 * @module echarts/scale/Interval
	 */
	var roundNumber = numberUtil.round;
	/**
	 * @alias module:echarts/coord/scale/Interval
	 * @constructor
	 */
	
	var IntervalScale = Scale.extend({
	  type: 'interval',
	  _interval: 0,
	  _intervalPrecision: 2,
	  setExtent: function (start, end) {
	    var thisExtent = this._extent; //start,end may be a Number like '25',so...
	
	    if (!isNaN(start)) {
	      thisExtent[0] = parseFloat(start);
	    }
	
	    if (!isNaN(end)) {
	      thisExtent[1] = parseFloat(end);
	    }
	  },
	  unionExtent: function (other) {
	    var extent = this._extent;
	    other[0] < extent[0] && (extent[0] = other[0]);
	    other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes
	
	    IntervalScale.prototype.setExtent.call(this, extent[0], extent[1]);
	  },
	
	  /**
	   * Get interval
	   */
	  getInterval: function () {
	    return this._interval;
	  },
	
	  /**
	   * Set interval
	   */
	  setInterval: function (interval) {
	    this._interval = interval; // Dropped auto calculated niceExtent and use user setted extent
	    // We assume user wan't to set both interval, min, max to get a better result
	
	    this._niceExtent = this._extent.slice();
	    this._intervalPrecision = helper.getIntervalPrecision(interval);
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getTicks: function () {
	    return helper.intervalScaleGetTicks(this._interval, this._extent, this._niceExtent, this._intervalPrecision);
	  },
	
	  /**
	   * @return {Array.<string>}
	   */
	  getTicksLabels: function () {
	    var labels = [];
	    var ticks = this.getTicks();
	
	    for (var i = 0; i < ticks.length; i++) {
	      labels.push(this.getLabel(ticks[i]));
	    }
	
	    return labels;
	  },
	
	  /**
	   * @param {number} data
	   * @param {Object} [opt]
	   * @param {number|string} [opt.precision] If 'auto', use nice presision.
	   * @param {boolean} [opt.pad] returns 1.50 but not 1.5 if precision is 2.
	   * @return {string}
	   */
	  getLabel: function (data, opt) {
	    if (data == null) {
	      return '';
	    }
	
	    var precision = opt && opt.precision;
	
	    if (precision == null) {
	      precision = numberUtil.getPrecisionSafe(data) || 0;
	    } else if (precision === 'auto') {
	      // Should be more precise then tick.
	      precision = this._intervalPrecision;
	    } // (1) If `precision` is set, 12.005 should be display as '12.00500'.
	    // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
	
	
	    data = roundNumber(data, precision, true);
	    return formatUtil.addCommas(data);
	  },
	
	  /**
	   * Update interval and extent of intervals for nice ticks
	   *
	   * @param {number} [splitNumber = 5] Desired number of ticks
	   * @param {number} [minInterval]
	   * @param {number} [maxInterval]
	   */
	  niceTicks: function (splitNumber, minInterval, maxInterval) {
	    splitNumber = splitNumber || 5;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	
	    if (!isFinite(span)) {
	      return;
	    } // User may set axis min 0 and data are all negative
	    // FIXME If it needs to reverse ?
	
	
	    if (span < 0) {
	      span = -span;
	      extent.reverse();
	    }
	
	    var result = helper.intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
	    this._intervalPrecision = result.intervalPrecision;
	    this._interval = result.interval;
	    this._niceExtent = result.niceTickExtent;
	  },
	
	  /**
	   * Nice extent.
	   * @param {Object} opt
	   * @param {number} [opt.splitNumber = 5] Given approx tick number
	   * @param {boolean} [opt.fixMin=false]
	   * @param {boolean} [opt.fixMax=false]
	   * @param {boolean} [opt.minInterval]
	   * @param {boolean} [opt.maxInterval]
	   */
	  niceExtent: function (opt) {
	    var extent = this._extent; // If extent start and end are same, expand them
	
	    if (extent[0] === extent[1]) {
	      if (extent[0] !== 0) {
	        // Expand extent
	        var expandSize = extent[0]; // In the fowllowing case
	        //      Axis has been fixed max 100
	        //      Plus data are all 100 and axis extent are [100, 100].
	        // Extend to the both side will cause expanded max is larger than fixed max.
	        // So only expand to the smaller side.
	
	        if (!opt.fixMax) {
	          extent[1] += expandSize / 2;
	          extent[0] -= expandSize / 2;
	        } else {
	          extent[0] -= expandSize / 2;
	        }
	      } else {
	        extent[1] = 1;
	      }
	    }
	
	    var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]
	
	    if (!isFinite(span)) {
	      extent[0] = 0;
	      extent[1] = 1;
	    }
	
	    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;
	
	    var interval = this._interval;
	
	    if (!opt.fixMin) {
	      extent[0] = roundNumber(Math.floor(extent[0] / interval) * interval);
	    }
	
	    if (!opt.fixMax) {
	      extent[1] = roundNumber(Math.ceil(extent[1] / interval) * interval);
	    }
	  }
	});
	/**
	 * @return {module:echarts/scale/Time}
	 */
	
	IntervalScale.create = function () {
	  return new IntervalScale();
	};
	
	var _default = IntervalScale;
	module.exports = _default;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var clazzUtil = __webpack_require__(28);
	
	/**
	 * // Scale class management
	 * @module echarts/scale/Scale
	 */
	
	/**
	 * @param {Object} [setting]
	 */
	function Scale(setting) {
	  this._setting = setting || {};
	  /**
	   * Extent
	   * @type {Array.<number>}
	   * @protected
	   */
	
	  this._extent = [Infinity, -Infinity];
	  /**
	   * Step is calculated in adjustExtent
	   * @type {Array.<number>}
	   * @protected
	   */
	
	  this._interval = 0;
	  this.init && this.init.apply(this, arguments);
	}
	/**
	 * Parse input val to valid inner number.
	 * @param {*} val
	 * @return {number}
	 */
	
	
	Scale.prototype.parse = function (val) {
	  // Notice: This would be a trap here, If the implementation
	  // of this method depends on extent, and this method is used
	  // before extent set (like in dataZoom), it would be wrong.
	  // Nevertheless, parse does not depend on extent generally.
	  return val;
	};
	
	Scale.prototype.getSetting = function (name) {
	  return this._setting[name];
	};
	
	Scale.prototype.contain = function (val) {
	  var extent = this._extent;
	  return val >= extent[0] && val <= extent[1];
	};
	/**
	 * Normalize value to linear [0, 1], return 0.5 if extent span is 0
	 * @param {number} val
	 * @return {number}
	 */
	
	
	Scale.prototype.normalize = function (val) {
	  var extent = this._extent;
	
	  if (extent[1] === extent[0]) {
	    return 0.5;
	  }
	
	  return (val - extent[0]) / (extent[1] - extent[0]);
	};
	/**
	 * Scale normalized value
	 * @param {number} val
	 * @return {number}
	 */
	
	
	Scale.prototype.scale = function (val) {
	  var extent = this._extent;
	  return val * (extent[1] - extent[0]) + extent[0];
	};
	/**
	 * Set extent from data
	 * @param {Array.<number>} other
	 */
	
	
	Scale.prototype.unionExtent = function (other) {
	  var extent = this._extent;
	  other[0] < extent[0] && (extent[0] = other[0]);
	  other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
	  // this.setExtent(extent[0], extent[1]);
	};
	/**
	 * Set extent from data
	 * @param {module:echarts/data/List} data
	 * @param {string} dim
	 */
	
	
	Scale.prototype.unionExtentFromData = function (data, dim) {
	  this.unionExtent(data.getDataExtent(dim, true));
	};
	/**
	 * Get extent
	 * @return {Array.<number>}
	 */
	
	
	Scale.prototype.getExtent = function () {
	  return this._extent.slice();
	};
	/**
	 * Set extent
	 * @param {number} start
	 * @param {number} end
	 */
	
	
	Scale.prototype.setExtent = function (start, end) {
	  var thisExtent = this._extent;
	
	  if (!isNaN(start)) {
	    thisExtent[0] = start;
	  }
	
	  if (!isNaN(end)) {
	    thisExtent[1] = end;
	  }
	};
	/**
	 * @return {Array.<string>}
	 */
	
	
	Scale.prototype.getTicksLabels = function () {
	  var labels = [];
	  var ticks = this.getTicks();
	
	  for (var i = 0; i < ticks.length; i++) {
	    labels.push(this.getLabel(ticks[i]));
	  }
	
	  return labels;
	};
	/**
	 * When axis extent depends on data and no data exists,
	 * axis ticks should not be drawn, which is named 'blank'.
	 */
	
	
	Scale.prototype.isBlank = function () {
	  return this._isBlank;
	},
	/**
	 * When axis extent depends on data and no data exists,
	 * axis ticks should not be drawn, which is named 'blank'.
	 */
	Scale.prototype.setBlank = function (isBlank) {
	  this._isBlank = isBlank;
	};
	clazzUtil.enableClassExtend(Scale);
	clazzUtil.enableClassManagement(Scale, {
	  registerWhenExtend: true
	});
	var _default = Scale;
	module.exports = _default;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var VisualMapping = __webpack_require__(46);
	
	/**
	 * @file Visual solution, for consistent option specification.
	 */
	var each = zrUtil.each;
	
	function hasKeys(obj) {
	  if (obj) {
	    for (var name in obj) {
	      if (obj.hasOwnProperty(name)) {
	        return true;
	      }
	    }
	  }
	}
	/**
	 * @param {Object} option
	 * @param {Array.<string>} stateList
	 * @param {Function} [supplementVisualOption]
	 * @return {Object} visualMappings <state, <visualType, module:echarts/visual/VisualMapping>>
	 */
	
	
	function createVisualMappings(option, stateList, supplementVisualOption) {
	  var visualMappings = {};
	  each(stateList, function (state) {
	    var mappings = visualMappings[state] = createMappings();
	    each(option[state], function (visualData, visualType) {
	      if (!VisualMapping.isValidType(visualType)) {
	        return;
	      }
	
	      var mappingOption = {
	        type: visualType,
	        visual: visualData
	      };
	      supplementVisualOption && supplementVisualOption(mappingOption, state);
	      mappings[visualType] = new VisualMapping(mappingOption); // Prepare a alpha for opacity, for some case that opacity
	      // is not supported, such as rendering using gradient color.
	
	      if (visualType === 'opacity') {
	        mappingOption = zrUtil.clone(mappingOption);
	        mappingOption.type = 'colorAlpha';
	        mappings.__hidden.__alphaForOpacity = new VisualMapping(mappingOption);
	      }
	    });
	  });
	  return visualMappings;
	
	  function createMappings() {
	    var Creater = function () {}; // Make sure hidden fields will not be visited by
	    // object iteration (with hasOwnProperty checking).
	
	
	    Creater.prototype.__hidden = Creater.prototype;
	    var obj = new Creater();
	    return obj;
	  }
	}
	/**
	 * @param {Object} thisOption
	 * @param {Object} newOption
	 * @param {Array.<string>} keys
	 */
	
	
	function replaceVisualOption(thisOption, newOption, keys) {
	  // Visual attributes merge is not supported, otherwise it
	  // brings overcomplicated merge logic. See #2853. So if
	  // newOption has anyone of these keys, all of these keys
	  // will be reset. Otherwise, all keys remain.
	  var has;
	  zrUtil.each(keys, function (key) {
	    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
	      has = true;
	    }
	  });
	  has && zrUtil.each(keys, function (key) {
	    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
	      thisOption[key] = zrUtil.clone(newOption[key]);
	    } else {
	      delete thisOption[key];
	    }
	  });
	}
	/**
	 * @param {Array.<string>} stateList
	 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
	 * @param {module:echarts/data/List} list
	 * @param {Function} getValueState param: valueOrIndex, return: state.
	 * @param {object} [scope] Scope for getValueState
	 * @param {string} [dimension] Concrete dimension, if used.
	 */
	
	
	function applyVisual(stateList, visualMappings, data, getValueState, scope, dimension) {
	  var visualTypesMap = {};
	  zrUtil.each(stateList, function (state) {
	    var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
	    visualTypesMap[state] = visualTypes;
	  });
	  var dataIndex;
	
	  function getVisual(key) {
	    return data.getItemVisual(dataIndex, key);
	  }
	
	  function setVisual(key, value) {
	    data.setItemVisual(dataIndex, key, value);
	  }
	
	  if (dimension == null) {
	    data.each(eachItem, true);
	  } else {
	    data.each([dimension], eachItem, true);
	  }
	
	  function eachItem(valueOrIndex, index) {
	    dataIndex = dimension == null ? valueOrIndex : index;
	    var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
	
	    if (rawDataItem && rawDataItem.visualMap === false) {
	      return;
	    }
	
	    var valueState = getValueState.call(scope, valueOrIndex);
	    var mappings = visualMappings[valueState];
	    var visualTypes = visualTypesMap[valueState];
	
	    for (var i = 0, len = visualTypes.length; i < len; i++) {
	      var type = visualTypes[i];
	      mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
	    }
	  }
	}
	
	exports.createVisualMappings = createVisualMappings;
	exports.replaceVisualOption = replaceVisualOption;
	exports.applyVisual = applyVisual;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(714)
	__vue_script__ = __webpack_require__(240)
	__vue_template__ = __webpack_require__(639)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(715)
	__vue_script__ = __webpack_require__(244)
	__vue_template__ = __webpack_require__(641)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 96 */
/***/ (function(module, exports) {

	var dpr = 1; // If in browser environment
	
	if (typeof window !== 'undefined') {
	  dpr = Math.max(window.devicePixelRatio || 1, 1);
	}
	/**
	 * config默认配置项
	 * @exports zrender/config
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 */
	
	/**
	 * debug日志选项：catchBrushException为true下有效
	 * 0 : 不生成debug数据，发布用
	 * 1 : 异常抛出，调试用
	 * 2 : 控制台输出，调试用
	 */
	
	
	var debugMode = 0; // retina 屏幕优化
	
	var devicePixelRatio = dpr;
	exports.debugMode = debugMode;
	exports.devicePixelRatio = devicePixelRatio;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Element = __webpack_require__(213);
	
	var BoundingRect = __webpack_require__(13);
	
	/**
	 * Group是一个容器，可以插入子节点，Group的变换也会被应用到子节点上
	 * @module zrender/graphic/Group
	 * @example
	 *     var Group = require('zrender/container/Group');
	 *     var Circle = require('zrender/graphic/shape/Circle');
	 *     var g = new Group();
	 *     g.position[0] = 100;
	 *     g.position[1] = 100;
	 *     g.add(new Circle({
	 *         style: {
	 *             x: 100,
	 *             y: 100,
	 *             r: 20,
	 *         }
	 *     }));
	 *     zr.add(g);
	 */
	
	/**
	 * @alias module:zrender/graphic/Group
	 * @constructor
	 * @extends module:zrender/mixin/Transformable
	 * @extends module:zrender/mixin/Eventful
	 */
	var Group = function (opts) {
	  opts = opts || {};
	  Element.call(this, opts);
	
	  for (var key in opts) {
	    if (opts.hasOwnProperty(key)) {
	      this[key] = opts[key];
	    }
	  }
	
	  this._children = [];
	  this.__storage = null;
	  this.__dirty = true;
	};
	
	Group.prototype = {
	  constructor: Group,
	  isGroup: true,
	
	  /**
	   * @type {string}
	   */
	  type: 'group',
	
	  /**
	   * 所有子孙元素是否响应鼠标事件
	   * @name module:/zrender/container/Group#silent
	   * @type {boolean}
	   * @default false
	   */
	  silent: false,
	
	  /**
	   * @return {Array.<module:zrender/Element>}
	   */
	  children: function () {
	    return this._children.slice();
	  },
	
	  /**
	   * 获取指定 index 的儿子节点
	   * @param  {number} idx
	   * @return {module:zrender/Element}
	   */
	  childAt: function (idx) {
	    return this._children[idx];
	  },
	
	  /**
	   * 获取指定名字的儿子节点
	   * @param  {string} name
	   * @return {module:zrender/Element}
	   */
	  childOfName: function (name) {
	    var children = this._children;
	
	    for (var i = 0; i < children.length; i++) {
	      if (children[i].name === name) {
	        return children[i];
	      }
	    }
	  },
	
	  /**
	   * @return {number}
	   */
	  childCount: function () {
	    return this._children.length;
	  },
	
	  /**
	   * 添加子节点到最后
	   * @param {module:zrender/Element} child
	   */
	  add: function (child) {
	    if (child && child !== this && child.parent !== this) {
	      this._children.push(child);
	
	      this._doAdd(child);
	    }
	
	    return this;
	  },
	
	  /**
	   * 添加子节点在 nextSibling 之前
	   * @param {module:zrender/Element} child
	   * @param {module:zrender/Element} nextSibling
	   */
	  addBefore: function (child, nextSibling) {
	    if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
	      var children = this._children;
	      var idx = children.indexOf(nextSibling);
	
	      if (idx >= 0) {
	        children.splice(idx, 0, child);
	
	        this._doAdd(child);
	      }
	    }
	
	    return this;
	  },
	  _doAdd: function (child) {
	    if (child.parent) {
	      child.parent.remove(child);
	    }
	
	    child.parent = this;
	    var storage = this.__storage;
	    var zr = this.__zr;
	
	    if (storage && storage !== child.__storage) {
	      storage.addToStorage(child);
	
	      if (child instanceof Group) {
	        child.addChildrenToStorage(storage);
	      }
	    }
	
	    zr && zr.refresh();
	  },
	
	  /**
	   * 移除子节点
	   * @param {module:zrender/Element} child
	   */
	  remove: function (child) {
	    var zr = this.__zr;
	    var storage = this.__storage;
	    var children = this._children;
	    var idx = zrUtil.indexOf(children, child);
	
	    if (idx < 0) {
	      return this;
	    }
	
	    children.splice(idx, 1);
	    child.parent = null;
	
	    if (storage) {
	      storage.delFromStorage(child);
	
	      if (child instanceof Group) {
	        child.delChildrenFromStorage(storage);
	      }
	    }
	
	    zr && zr.refresh();
	    return this;
	  },
	
	  /**
	   * 移除所有子节点
	   */
	  removeAll: function () {
	    var children = this._children;
	    var storage = this.__storage;
	    var child;
	    var i;
	
	    for (i = 0; i < children.length; i++) {
	      child = children[i];
	
	      if (storage) {
	        storage.delFromStorage(child);
	
	        if (child instanceof Group) {
	          child.delChildrenFromStorage(storage);
	        }
	      }
	
	      child.parent = null;
	    }
	
	    children.length = 0;
	    return this;
	  },
	
	  /**
	   * 遍历所有子节点
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  eachChild: function (cb, context) {
	    var children = this._children;
	
	    for (var i = 0; i < children.length; i++) {
	      var child = children[i];
	      cb.call(context, child, i);
	    }
	
	    return this;
	  },
	
	  /**
	   * 深度优先遍历所有子孙节点
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      cb.call(context, child);
	
	      if (child.type === 'group') {
	        child.traverse(cb, context);
	      }
	    }
	
	    return this;
	  },
	  addChildrenToStorage: function (storage) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      storage.addToStorage(child);
	
	      if (child instanceof Group) {
	        child.addChildrenToStorage(storage);
	      }
	    }
	  },
	  delChildrenFromStorage: function (storage) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      storage.delFromStorage(child);
	
	      if (child instanceof Group) {
	        child.delChildrenFromStorage(storage);
	      }
	    }
	  },
	  dirty: function () {
	    this.__dirty = true;
	    this.__zr && this.__zr.refresh();
	    return this;
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function (includeChildren) {
	    // TODO Caching
	    var rect = null;
	    var tmpRect = new BoundingRect(0, 0, 0, 0);
	    var children = includeChildren || this._children;
	    var tmpMat = [];
	
	    for (var i = 0; i < children.length; i++) {
	      var child = children[i];
	
	      if (child.ignore || child.invisible) {
	        continue;
	      }
	
	      var childRect = child.getBoundingRect();
	      var transform = child.getLocalTransform(tmpMat); // TODO
	      // The boundingRect cacluated by transforming original
	      // rect may be bigger than the actual bundingRect when rotation
	      // is used. (Consider a circle rotated aginst its center, where
	      // the actual boundingRect should be the same as that not be
	      // rotated.) But we can not find better approach to calculate
	      // actual boundingRect yet, considering performance.
	
	      if (transform) {
	        tmpRect.copy(childRect);
	        tmpRect.applyTransform(transform);
	        rect = rect || tmpRect.clone();
	        rect.union(tmpRect);
	      } else {
	        rect = rect || childRect.clone();
	        rect.union(childRect);
	      }
	    }
	
	    return rect || tmpRect;
	  }
	};
	zrUtil.inherits(Group, Element);
	var _default = Group;
	module.exports = _default;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Style = __webpack_require__(225);
	
	var Element = __webpack_require__(213);
	
	var RectText = __webpack_require__(229);
	
	/**
	 * 可绘制的图形基类
	 * Base class of all displayable graphic objects
	 * @module zrender/graphic/Displayable
	 */
	
	/**
	 * @alias module:zrender/graphic/Displayable
	 * @extends module:zrender/Element
	 * @extends module:zrender/graphic/mixin/RectText
	 */
	function Displayable(opts) {
	  opts = opts || {};
	  Element.call(this, opts); // Extend properties
	
	  for (var name in opts) {
	    if (opts.hasOwnProperty(name) && name !== 'style') {
	      this[name] = opts[name];
	    }
	  }
	  /**
	   * @type {module:zrender/graphic/Style}
	   */
	
	
	  this.style = new Style(opts.style, this);
	  this._rect = null; // Shapes for cascade clipping.
	
	  this.__clipPaths = []; // FIXME Stateful must be mixined after style is setted
	  // Stateful.call(this, opts);
	}
	
	Displayable.prototype = {
	  constructor: Displayable,
	  type: 'displayable',
	
	  /**
	   * Displayable 是否为脏，Painter 中会根据该标记判断是否需要是否需要重新绘制
	   * Dirty flag. From which painter will determine if this displayable object needs brush
	   * @name module:zrender/graphic/Displayable#__dirty
	   * @type {boolean}
	   */
	  __dirty: true,
	
	  /**
	   * 图形是否可见，为true时不绘制图形，但是仍能触发鼠标事件
	   * If ignore drawing of the displayable object. Mouse event will still be triggered
	   * @name module:/zrender/graphic/Displayable#invisible
	   * @type {boolean}
	   * @default false
	   */
	  invisible: false,
	
	  /**
	   * @name module:/zrender/graphic/Displayable#z
	   * @type {number}
	   * @default 0
	   */
	  z: 0,
	
	  /**
	   * @name module:/zrender/graphic/Displayable#z
	   * @type {number}
	   * @default 0
	   */
	  z2: 0,
	
	  /**
	   * z层level，决定绘画在哪层canvas中
	   * @name module:/zrender/graphic/Displayable#zlevel
	   * @type {number}
	   * @default 0
	   */
	  zlevel: 0,
	
	  /**
	   * 是否可拖拽
	   * @name module:/zrender/graphic/Displayable#draggable
	   * @type {boolean}
	   * @default false
	   */
	  draggable: false,
	
	  /**
	   * 是否正在拖拽
	   * @name module:/zrender/graphic/Displayable#draggable
	   * @type {boolean}
	   * @default false
	   */
	  dragging: false,
	
	  /**
	   * 是否相应鼠标事件
	   * @name module:/zrender/graphic/Displayable#silent
	   * @type {boolean}
	   * @default false
	   */
	  silent: false,
	
	  /**
	   * If enable culling
	   * @type {boolean}
	   * @default false
	   */
	  culling: false,
	
	  /**
	   * Mouse cursor when hovered
	   * @name module:/zrender/graphic/Displayable#cursor
	   * @type {string}
	   */
	  cursor: 'pointer',
	
	  /**
	   * If hover area is bounding rect
	   * @name module:/zrender/graphic/Displayable#rectHover
	   * @type {string}
	   */
	  rectHover: false,
	
	  /**
	   * Render the element progressively when the value >= 0,
	   * usefull for large data.
	   * @type {number}
	   */
	  progressive: -1,
	  beforeBrush: function (ctx) {},
	  afterBrush: function (ctx) {},
	
	  /**
	   * 图形绘制方法
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  // Interface
	  brush: function (ctx, prevEl) {},
	
	  /**
	   * 获取最小包围盒
	   * @return {module:zrender/core/BoundingRect}
	   */
	  // Interface
	  getBoundingRect: function () {},
	
	  /**
	   * 判断坐标 x, y 是否在图形上
	   * If displayable element contain coord x, y
	   * @param  {number} x
	   * @param  {number} y
	   * @return {boolean}
	   */
	  contain: function (x, y) {
	    return this.rectContain(x, y);
	  },
	
	  /**
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {
	    cb.call(context, this);
	  },
	
	  /**
	   * 判断坐标 x, y 是否在图形的包围盒上
	   * If bounding rect of element contain coord x, y
	   * @param  {number} x
	   * @param  {number} y
	   * @return {boolean}
	   */
	  rectContain: function (x, y) {
	    var coord = this.transformCoordToLocal(x, y);
	    var rect = this.getBoundingRect();
	    return rect.contain(coord[0], coord[1]);
	  },
	
	  /**
	   * 标记图形元素为脏，并且在下一帧重绘
	   * Mark displayable element dirty and refresh next frame
	   */
	  dirty: function () {
	    this.__dirty = true;
	    this._rect = null;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * 图形是否会触发事件
	   * If displayable object binded any event
	   * @return {boolean}
	   */
	  // TODO, 通过 bind 绑定的事件
	  // isSilent: function () {
	  //     return !(
	  //         this.hoverable || this.draggable
	  //         || this.onmousemove || this.onmouseover || this.onmouseout
	  //         || this.onmousedown || this.onmouseup || this.onclick
	  //         || this.ondragenter || this.ondragover || this.ondragleave
	  //         || this.ondrop
	  //     );
	  // },
	
	  /**
	   * Alias for animate('style')
	   * @param {boolean} loop
	   */
	  animateStyle: function (loop) {
	    return this.animate('style', loop);
	  },
	  attrKV: function (key, value) {
	    if (key !== 'style') {
	      Element.prototype.attrKV.call(this, key, value);
	    } else {
	      this.style.set(value);
	    }
	  },
	
	  /**
	   * @param {Object|string} key
	   * @param {*} value
	   */
	  setStyle: function (key, value) {
	    this.style.set(key, value);
	    this.dirty(false);
	    return this;
	  },
	
	  /**
	   * Use given style object
	   * @param  {Object} obj
	   */
	  useStyle: function (obj) {
	    this.style = new Style(obj, this);
	    this.dirty(false);
	    return this;
	  }
	};
	zrUtil.inherits(Displayable, Element);
	zrUtil.mixin(Displayable, RectText); // zrUtil.mixin(Displayable, Stateful);
	
	var _default = Displayable;
	module.exports = _default;

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	/**
	 * @param {Array.<Object>} colorStops
	 */
	var Gradient = function (colorStops) {
	  this.colorStops = colorStops || [];
	};
	
	Gradient.prototype = {
	  constructor: Gradient,
	  addColorStop: function (offset, color) {
	    this.colorStops.push({
	      offset: offset,
	      color: color
	    });
	  }
	};
	var _default = Gradient;
	module.exports = _default;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(1);
	
	var retrieve2 = _util.retrieve2;
	var retrieve3 = _util.retrieve3;
	var each = _util.each;
	var normalizeCssArray = _util.normalizeCssArray;
	var isString = _util.isString;
	var isObject = _util.isObject;
	
	var textContain = __webpack_require__(27);
	
	var roundRectHelper = __webpack_require__(228);
	
	var imageHelper = __webpack_require__(138);
	
	// TODO: Have not support 'start', 'end' yet.
	var VALID_TEXT_ALIGN = {
	  left: 1,
	  right: 1,
	  center: 1
	};
	var VALID_TEXT_VERTICAL_ALIGN = {
	  top: 1,
	  bottom: 1,
	  middle: 1
	};
	/**
	 * @param {module:zrender/graphic/Style} style
	 * @return {module:zrender/graphic/Style} The input style.
	 */
	
	function normalizeTextStyle(style) {
	  normalizeStyle(style);
	  each(style.rich, normalizeStyle);
	  return style;
	}
	
	function normalizeStyle(style) {
	  if (style) {
	    style.font = textContain.makeFont(style);
	    var textAlign = style.textAlign;
	    textAlign === 'middle' && (textAlign = 'center');
	    style.textAlign = textAlign == null || VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left'; // Compatible with textBaseline.
	
	    var textVerticalAlign = style.textVerticalAlign || style.textBaseline;
	    textVerticalAlign === 'center' && (textVerticalAlign = 'middle');
	    style.textVerticalAlign = textVerticalAlign == null || VALID_TEXT_VERTICAL_ALIGN[textVerticalAlign] ? textVerticalAlign : 'top';
	    var textPadding = style.textPadding;
	
	    if (textPadding) {
	      style.textPadding = normalizeCssArray(style.textPadding);
	    }
	  }
	}
	/**
	 * @param {CanvasRenderingContext2D} ctx
	 * @param {string} text
	 * @param {module:zrender/graphic/Style} style
	 * @param {Object|boolean} [rect] {x, y, width, height}
	 *                  If set false, rect text is not used.
	 */
	
	
	function renderText(hostEl, ctx, text, style, rect) {
	  style.rich ? renderRichText(hostEl, ctx, text, style, rect) : renderPlainText(hostEl, ctx, text, style, rect);
	}
	
	function renderPlainText(hostEl, ctx, text, style, rect) {
	  var font = setCtx(ctx, 'font', style.font || textContain.DEFAULT_FONT);
	  var textPadding = style.textPadding;
	  var contentBlock = hostEl.__textCotentBlock;
	
	  if (!contentBlock || hostEl.__dirty) {
	    contentBlock = hostEl.__textCotentBlock = textContain.parsePlainText(text, font, textPadding, style.truncate);
	  }
	
	  var outerHeight = contentBlock.outerHeight;
	  var textLines = contentBlock.lines;
	  var lineHeight = contentBlock.lineHeight;
	  var boxPos = getBoxPosition(outerHeight, style, rect);
	  var baseX = boxPos.baseX;
	  var baseY = boxPos.baseY;
	  var textAlign = boxPos.textAlign;
	  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.
	
	  applyTextRotation(ctx, style, rect, baseX, baseY);
	  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
	  var textX = baseX;
	  var textY = boxY;
	  var needDrawBg = needDrawBackground(style);
	
	  if (needDrawBg || textPadding) {
	    // Consider performance, do not call getTextWidth util necessary.
	    var textWidth = textContain.getWidth(text, font);
	    var outerWidth = textWidth;
	    textPadding && (outerWidth += textPadding[1] + textPadding[3]);
	    var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
	    needDrawBg && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);
	
	    if (textPadding) {
	      textX = getTextXForPadding(baseX, textAlign, textPadding);
	      textY += textPadding[0];
	    }
	  }
	
	  setCtx(ctx, 'textAlign', textAlign || 'left'); // Force baseline to be "middle". Otherwise, if using "top", the
	  // text will offset downward a little bit in font "Microsoft YaHei".
	
	  setCtx(ctx, 'textBaseline', 'middle'); // Always set shadowBlur and shadowOffset to avoid leak from displayable.
	
	  setCtx(ctx, 'shadowBlur', style.textShadowBlur || 0);
	  setCtx(ctx, 'shadowColor', style.textShadowColor || 'transparent');
	  setCtx(ctx, 'shadowOffsetX', style.textShadowOffsetX || 0);
	  setCtx(ctx, 'shadowOffsetY', style.textShadowOffsetY || 0); // `textBaseline` is set as 'middle'.
	
	  textY += lineHeight / 2;
	  var textStrokeWidth = style.textStrokeWidth;
	  var textStroke = getStroke(style.textStroke, textStrokeWidth);
	  var textFill = getFill(style.textFill);
	
	  if (textStroke) {
	    setCtx(ctx, 'lineWidth', textStrokeWidth);
	    setCtx(ctx, 'strokeStyle', textStroke);
	  }
	
	  if (textFill) {
	    setCtx(ctx, 'fillStyle', textFill);
	  }
	
	  for (var i = 0; i < textLines.length; i++) {
	    // Fill after stroke so the outline will not cover the main part.
	    textStroke && ctx.strokeText(textLines[i], textX, textY);
	    textFill && ctx.fillText(textLines[i], textX, textY);
	    textY += lineHeight;
	  }
	}
	
	function renderRichText(hostEl, ctx, text, style, rect) {
	  var contentBlock = hostEl.__textCotentBlock;
	
	  if (!contentBlock || hostEl.__dirty) {
	    contentBlock = hostEl.__textCotentBlock = textContain.parseRichText(text, style);
	  }
	
	  drawRichText(hostEl, ctx, contentBlock, style, rect);
	}
	
	function drawRichText(hostEl, ctx, contentBlock, style, rect) {
	  var contentWidth = contentBlock.width;
	  var outerWidth = contentBlock.outerWidth;
	  var outerHeight = contentBlock.outerHeight;
	  var textPadding = style.textPadding;
	  var boxPos = getBoxPosition(outerHeight, style, rect);
	  var baseX = boxPos.baseX;
	  var baseY = boxPos.baseY;
	  var textAlign = boxPos.textAlign;
	  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.
	
	  applyTextRotation(ctx, style, rect, baseX, baseY);
	  var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
	  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
	  var xLeft = boxX;
	  var lineTop = boxY;
	
	  if (textPadding) {
	    xLeft += textPadding[3];
	    lineTop += textPadding[0];
	  }
	
	  var xRight = xLeft + contentWidth;
	  needDrawBackground(style) && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);
	
	  for (var i = 0; i < contentBlock.lines.length; i++) {
	    var line = contentBlock.lines[i];
	    var tokens = line.tokens;
	    var tokenCount = tokens.length;
	    var lineHeight = line.lineHeight;
	    var usedWidth = line.width;
	    var leftIndex = 0;
	    var lineXLeft = xLeft;
	    var lineXRight = xRight;
	    var rightIndex = tokenCount - 1;
	    var token;
	
	    while (leftIndex < tokenCount && (token = tokens[leftIndex], !token.textAlign || token.textAlign === 'left')) {
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft, 'left');
	      usedWidth -= token.width;
	      lineXLeft += token.width;
	      leftIndex++;
	    }
	
	    while (rightIndex >= 0 && (token = tokens[rightIndex], token.textAlign === 'right')) {
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXRight, 'right');
	      usedWidth -= token.width;
	      lineXRight -= token.width;
	      rightIndex--;
	    } // The other tokens are placed as textAlign 'center' if there is enough space.
	
	
	    lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - usedWidth) / 2;
	
	    while (leftIndex <= rightIndex) {
	      token = tokens[leftIndex]; // Consider width specified by user, use 'center' rather than 'left'.
	
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center');
	      lineXLeft += token.width;
	      leftIndex++;
	    }
	
	    lineTop += lineHeight;
	  }
	}
	
	function applyTextRotation(ctx, style, rect, x, y) {
	  // textRotation only apply in RectText.
	  if (rect && style.textRotation) {
	    var origin = style.textOrigin;
	
	    if (origin === 'center') {
	      x = rect.width / 2 + rect.x;
	      y = rect.height / 2 + rect.y;
	    } else if (origin) {
	      x = origin[0] + rect.x;
	      y = origin[1] + rect.y;
	    }
	
	    ctx.translate(x, y); // Positive: anticlockwise
	
	    ctx.rotate(-style.textRotation);
	    ctx.translate(-x, -y);
	  }
	}
	
	function placeToken(hostEl, ctx, token, style, lineHeight, lineTop, x, textAlign) {
	  var tokenStyle = style.rich[token.styleName] || {}; // 'ctx.textBaseline' is always set as 'middle', for sake of
	  // the bias of "Microsoft YaHei".
	
	  var textVerticalAlign = token.textVerticalAlign;
	  var y = lineTop + lineHeight / 2;
	
	  if (textVerticalAlign === 'top') {
	    y = lineTop + token.height / 2;
	  } else if (textVerticalAlign === 'bottom') {
	    y = lineTop + lineHeight - token.height / 2;
	  }
	
	  !token.isLineHolder && needDrawBackground(tokenStyle) && drawBackground(hostEl, ctx, tokenStyle, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
	  var textPadding = token.textPadding;
	
	  if (textPadding) {
	    x = getTextXForPadding(x, textAlign, textPadding);
	    y -= token.height / 2 - textPadding[2] - token.textHeight / 2;
	  }
	
	  setCtx(ctx, 'shadowBlur', retrieve3(tokenStyle.textShadowBlur, style.textShadowBlur, 0));
	  setCtx(ctx, 'shadowColor', tokenStyle.textShadowColor || style.textShadowColor || 'transparent');
	  setCtx(ctx, 'shadowOffsetX', retrieve3(tokenStyle.textShadowOffsetX, style.textShadowOffsetX, 0));
	  setCtx(ctx, 'shadowOffsetY', retrieve3(tokenStyle.textShadowOffsetY, style.textShadowOffsetY, 0));
	  setCtx(ctx, 'textAlign', textAlign); // Force baseline to be "middle". Otherwise, if using "top", the
	  // text will offset downward a little bit in font "Microsoft YaHei".
	
	  setCtx(ctx, 'textBaseline', 'middle');
	  setCtx(ctx, 'font', token.font || textContain.DEFAULT_FONT);
	  var textStroke = getStroke(tokenStyle.textStroke || style.textStroke, textStrokeWidth);
	  var textFill = getFill(tokenStyle.textFill || style.textFill);
	  var textStrokeWidth = retrieve2(tokenStyle.textStrokeWidth, style.textStrokeWidth); // Fill after stroke so the outline will not cover the main part.
	
	  if (textStroke) {
	    setCtx(ctx, 'lineWidth', textStrokeWidth);
	    setCtx(ctx, 'strokeStyle', textStroke);
	    ctx.strokeText(token.text, x, y);
	  }
	
	  if (textFill) {
	    setCtx(ctx, 'fillStyle', textFill);
	    ctx.fillText(token.text, x, y);
	  }
	}
	
	function needDrawBackground(style) {
	  return style.textBackgroundColor || style.textBorderWidth && style.textBorderColor;
	} // style: {textBackgroundColor, textBorderWidth, textBorderColor, textBorderRadius}
	// shape: {x, y, width, height}
	
	
	function drawBackground(hostEl, ctx, style, x, y, width, height) {
	  var textBackgroundColor = style.textBackgroundColor;
	  var textBorderWidth = style.textBorderWidth;
	  var textBorderColor = style.textBorderColor;
	  var isPlainBg = isString(textBackgroundColor);
	  setCtx(ctx, 'shadowBlur', style.textBoxShadowBlur || 0);
	  setCtx(ctx, 'shadowColor', style.textBoxShadowColor || 'transparent');
	  setCtx(ctx, 'shadowOffsetX', style.textBoxShadowOffsetX || 0);
	  setCtx(ctx, 'shadowOffsetY', style.textBoxShadowOffsetY || 0);
	
	  if (isPlainBg || textBorderWidth && textBorderColor) {
	    ctx.beginPath();
	    var textBorderRadius = style.textBorderRadius;
	
	    if (!textBorderRadius) {
	      ctx.rect(x, y, width, height);
	    } else {
	      roundRectHelper.buildPath(ctx, {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        r: textBorderRadius
	      });
	    }
	
	    ctx.closePath();
	  }
	
	  if (isPlainBg) {
	    setCtx(ctx, 'fillStyle', textBackgroundColor);
	    ctx.fill();
	  } else if (isObject(textBackgroundColor)) {
	    var image = textBackgroundColor.image;
	    image = imageHelper.createOrUpdateImage(image, null, hostEl, onBgImageLoaded, textBackgroundColor);
	
	    if (image && imageHelper.isImageReady(image)) {
	      ctx.drawImage(image, x, y, width, height);
	    }
	  }
	
	  if (textBorderWidth && textBorderColor) {
	    setCtx(ctx, 'lineWidth', textBorderWidth);
	    setCtx(ctx, 'strokeStyle', textBorderColor);
	    ctx.stroke();
	  }
	}
	
	function onBgImageLoaded(image, textBackgroundColor) {
	  // Replace image, so that `contain/text.js#parseRichText`
	  // will get correct result in next tick.
	  textBackgroundColor.image = image;
	}
	
	function getBoxPosition(blockHeiht, style, rect) {
	  var baseX = style.x || 0;
	  var baseY = style.y || 0;
	  var textAlign = style.textAlign;
	  var textVerticalAlign = style.textVerticalAlign; // Text position represented by coord
	
	  if (rect) {
	    var textPosition = style.textPosition;
	
	    if (textPosition instanceof Array) {
	      // Percent
	      baseX = rect.x + parsePercent(textPosition[0], rect.width);
	      baseY = rect.y + parsePercent(textPosition[1], rect.height);
	    } else {
	      var res = textContain.adjustTextPositionOnRect(textPosition, rect, style.textDistance);
	      baseX = res.x;
	      baseY = res.y; // Default align and baseline when has textPosition
	
	      textAlign = textAlign || res.textAlign;
	      textVerticalAlign = textVerticalAlign || res.textVerticalAlign;
	    } // textOffset is only support in RectText, otherwise
	    // we have to adjust boundingRect for textOffset.
	
	
	    var textOffset = style.textOffset;
	
	    if (textOffset) {
	      baseX += textOffset[0];
	      baseY += textOffset[1];
	    }
	  }
	
	  return {
	    baseX: baseX,
	    baseY: baseY,
	    textAlign: textAlign,
	    textVerticalAlign: textVerticalAlign
	  };
	}
	
	function setCtx(ctx, prop, value) {
	  // FIXME ??? performance try
	  // if (ctx.__currentValues[prop] !== value) {
	  // ctx[prop] = ctx.__currentValues[prop] = value;
	  ctx[prop] = value; // }
	
	  return ctx[prop];
	}
	/**
	 * @param {string} [stroke] If specified, do not check style.textStroke.
	 * @param {string} [lineWidth] If specified, do not check style.textStroke.
	 * @param {number} style
	 */
	
	
	function getStroke(stroke, lineWidth) {
	  return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null // TODO pattern and gradient?
	  : stroke.image || stroke.colorStops ? '#000' : stroke;
	}
	
	function getFill(fill) {
	  return fill == null || fill === 'none' ? null // TODO pattern and gradient?
	  : fill.image || fill.colorStops ? '#000' : fill;
	}
	
	function parsePercent(value, maxValue) {
	  if (typeof value === 'string') {
	    if (value.lastIndexOf('%') >= 0) {
	      return parseFloat(value) / 100 * maxValue;
	    }
	
	    return parseFloat(value);
	  }
	
	  return value;
	}
	
	function getTextXForPadding(x, textAlign, textPadding) {
	  return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
	}
	/**
	 * @param {string} text
	 * @param {module:zrender/Style} style
	 * @return {boolean}
	 */
	
	
	function needDrawText(text, style) {
	  return text != null && (text || style.textBackgroundColor || style.textBorderWidth && style.textBorderColor || style.textPadding);
	}
	
	exports.normalizeTextStyle = normalizeTextStyle;
	exports.renderText = renderText;
	exports.getStroke = getStroke;
	exports.getFill = getFill;
	exports.needDrawText = needDrawText;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var guid = __webpack_require__(222);
	
	var env = __webpack_require__(18);
	
	var zrUtil = __webpack_require__(1);
	
	var Handler = __webpack_require__(732);
	
	var Storage = __webpack_require__(735);
	
	var Painter = __webpack_require__(734);
	
	var Animation = __webpack_require__(736);
	
	var HandlerProxy = __webpack_require__(744);
	
	/*!
	* ZRender, a high performance 2d drawing library.
	*
	* Copyright (c) 2013, Baidu Inc.
	* All rights reserved.
	*
	* LICENSE
	* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
	*/
	var useVML = !env.canvasSupported;
	var painterCtors = {
	  canvas: Painter
	};
	var instances = {}; // ZRender实例map索引
	
	/**
	 * @type {string}
	 */
	
	var version = '3.7.4';
	/**
	 * Initializing a zrender instance
	 * @param {HTMLElement} dom
	 * @param {Object} opts
	 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
	 * @param {number} [opts.devicePixelRatio]
	 * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
	 * @return {module:zrender/ZRender}
	 */
	
	function init(dom, opts) {
	  var zr = new ZRender(guid(), dom, opts);
	  instances[zr.id] = zr;
	  return zr;
	}
	/**
	 * Dispose zrender instance
	 * @param {module:zrender/ZRender} zr
	 */
	
	
	function dispose(zr) {
	  if (zr) {
	    zr.dispose();
	  } else {
	    for (var key in instances) {
	      if (instances.hasOwnProperty(key)) {
	        instances[key].dispose();
	      }
	    }
	
	    instances = {};
	  }
	
	  return this;
	}
	/**
	 * Get zrender instance by id
	 * @param {string} id zrender instance id
	 * @return {module:zrender/ZRender}
	 */
	
	
	function getInstance(id) {
	  return instances[id];
	}
	
	function registerPainter(name, Ctor) {
	  painterCtors[name] = Ctor;
	}
	
	function delInstance(id) {
	  delete instances[id];
	}
	/**
	 * @module zrender/ZRender
	 */
	
	/**
	 * @constructor
	 * @alias module:zrender/ZRender
	 * @param {string} id
	 * @param {HTMLElement} dom
	 * @param {Object} opts
	 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
	 * @param {number} [opts.devicePixelRatio]
	 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
	 */
	
	
	var ZRender = function (id, dom, opts) {
	  opts = opts || {};
	  /**
	   * @type {HTMLDomElement}
	   */
	
	  this.dom = dom;
	  /**
	   * @type {string}
	   */
	
	  this.id = id;
	  var self = this;
	  var storage = new Storage();
	  var rendererType = opts.renderer; // TODO WebGL
	
	  if (useVML) {
	    if (!painterCtors.vml) {
	      throw new Error('You need to require \'zrender/vml/vml\' to support IE8');
	    }
	
	    rendererType = 'vml';
	  } else if (!rendererType || !painterCtors[rendererType]) {
	    rendererType = 'canvas';
	  }
	
	  var painter = new painterCtors[rendererType](dom, storage, opts);
	  this.storage = storage;
	  this.painter = painter;
	  var handerProxy = !env.node ? new HandlerProxy(painter.getViewportRoot()) : null;
	  this.handler = new Handler(storage, painter, handerProxy, painter.root);
	  /**
	   * @type {module:zrender/animation/Animation}
	   */
	
	  this.animation = new Animation({
	    stage: {
	      update: zrUtil.bind(this.flush, this)
	    }
	  });
	  this.animation.start();
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._needsRefresh; // 修改 storage.delFromStorage, 每次删除元素之前删除动画
	  // FIXME 有点ugly
	
	  var oldDelFromStorage = storage.delFromStorage;
	  var oldAddToStorage = storage.addToStorage;
	
	  storage.delFromStorage = function (el) {
	    oldDelFromStorage.call(storage, el);
	    el && el.removeSelfFromZr(self);
	  };
	
	  storage.addToStorage = function (el) {
	    oldAddToStorage.call(storage, el);
	    el.addSelfToZr(self);
	  };
	};
	
	ZRender.prototype = {
	  constructor: ZRender,
	
	  /**
	   * 获取实例唯一标识
	   * @return {string}
	   */
	  getId: function () {
	    return this.id;
	  },
	
	  /**
	   * 添加元素
	   * @param  {module:zrender/Element} el
	   */
	  add: function (el) {
	    this.storage.addRoot(el);
	    this._needsRefresh = true;
	  },
	
	  /**
	   * 删除元素
	   * @param  {module:zrender/Element} el
	   */
	  remove: function (el) {
	    this.storage.delRoot(el);
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Change configuration of layer
	   * @param {string} zLevel
	   * @param {Object} config
	   * @param {string} [config.clearColor=0] Clear color
	   * @param {string} [config.motionBlur=false] If enable motion blur
	   * @param {number} [config.lastFrameAlpha=0.7] Motion blur factor. Larger value cause longer trailer
	  */
	  configLayer: function (zLevel, config) {
	    this.painter.configLayer(zLevel, config);
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Repaint the canvas immediately
	   */
	  refreshImmediately: function () {
	    // var start = new Date();
	    // Clear needsRefresh ahead to avoid something wrong happens in refresh
	    // Or it will cause zrender refreshes again and again.
	    this._needsRefresh = false;
	    this.painter.refresh();
	    /**
	     * Avoid trigger zr.refresh in Element#beforeUpdate hook
	     */
	
	    this._needsRefresh = false; // var end = new Date();
	    // var log = document.getElementById('log');
	    // if (log) {
	    //     log.innerHTML = log.innerHTML + '<br>' + (end - start);
	    // }
	  },
	
	  /**
	   * Mark and repaint the canvas in the next frame of browser
	   */
	  refresh: function () {
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Perform all refresh
	   */
	  flush: function () {
	    if (this._needsRefresh) {
	      this.refreshImmediately();
	    }
	
	    if (this._needsRefreshHover) {
	      this.refreshHoverImmediately();
	    }
	  },
	
	  /**
	   * Add element to hover layer
	   * @param  {module:zrender/Element} el
	   * @param {Object} style
	   */
	  addHover: function (el, style) {
	    if (this.painter.addHover) {
	      this.painter.addHover(el, style);
	      this.refreshHover();
	    }
	  },
	
	  /**
	   * Add element from hover layer
	   * @param  {module:zrender/Element} el
	   */
	  removeHover: function (el) {
	    if (this.painter.removeHover) {
	      this.painter.removeHover(el);
	      this.refreshHover();
	    }
	  },
	
	  /**
	   * Clear all hover elements in hover layer
	   * @param  {module:zrender/Element} el
	   */
	  clearHover: function () {
	    if (this.painter.clearHover) {
	      this.painter.clearHover();
	      this.refreshHover();
	    }
	  },
	
	  /**
	   * Refresh hover in next frame
	   */
	  refreshHover: function () {
	    this._needsRefreshHover = true;
	  },
	
	  /**
	   * Refresh hover immediately
	   */
	  refreshHoverImmediately: function () {
	    this._needsRefreshHover = false;
	    this.painter.refreshHover && this.painter.refreshHover();
	  },
	
	  /**
	   * Resize the canvas.
	   * Should be invoked when container size is changed
	   * @param {Object} [opts]
	   * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
	   * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
	   */
	  resize: function (opts) {
	    opts = opts || {};
	    this.painter.resize(opts.width, opts.height);
	    this.handler.resize();
	  },
	
	  /**
	   * Stop and clear all animation immediately
	   */
	  clearAnimation: function () {
	    this.animation.clear();
	  },
	
	  /**
	   * Get container width
	   */
	  getWidth: function () {
	    return this.painter.getWidth();
	  },
	
	  /**
	   * Get container height
	   */
	  getHeight: function () {
	    return this.painter.getHeight();
	  },
	
	  /**
	   * Export the canvas as Base64 URL
	   * @param {string} type
	   * @param {string} [backgroundColor='#fff']
	   * @return {string} Base64 URL
	   */
	  // toDataURL: function(type, backgroundColor) {
	  //     return this.painter.getRenderedCanvas({
	  //         backgroundColor: backgroundColor
	  //     }).toDataURL(type);
	  // },
	
	  /**
	   * Converting a path to image.
	   * It has much better performance of drawing image rather than drawing a vector path.
	   * @param {module:zrender/graphic/Path} e
	   * @param {number} width
	   * @param {number} height
	   */
	  pathToImage: function (e, dpr) {
	    return this.painter.pathToImage(e, dpr);
	  },
	
	  /**
	   * Set default cursor
	   * @param {string} [cursorStyle='default'] 例如 crosshair
	   */
	  setCursorStyle: function (cursorStyle) {
	    this.handler.setCursorStyle(cursorStyle);
	  },
	
	  /**
	   * Find hovered element
	   * @param {number} x
	   * @param {number} y
	   * @return {Object} {target, topTarget}
	   */
	  findHover: function (x, y) {
	    return this.handler.findHover(x, y);
	  },
	
	  /**
	   * Bind event
	   *
	   * @param {string} eventName Event name
	   * @param {Function} eventHandler Handler function
	   * @param {Object} [context] Context object
	   */
	  on: function (eventName, eventHandler, context) {
	    this.handler.on(eventName, eventHandler, context);
	  },
	
	  /**
	   * Unbind event
	   * @param {string} eventName Event name
	   * @param {Function} [eventHandler] Handler function
	   */
	  off: function (eventName, eventHandler) {
	    this.handler.off(eventName, eventHandler);
	  },
	
	  /**
	   * Trigger event manually
	   *
	   * @param {string} eventName Event name
	   * @param {event=} event Event object
	   */
	  trigger: function (eventName, event) {
	    this.handler.trigger(eventName, event);
	  },
	
	  /**
	   * Clear all objects and the canvas.
	   */
	  clear: function () {
	    this.storage.delRoot();
	    this.painter.clear();
	  },
	
	  /**
	   * Dispose self.
	   */
	  dispose: function () {
	    this.animation.stop();
	    this.clear();
	    this.storage.dispose();
	    this.painter.dispose();
	    this.handler.dispose();
	    this.animation = this.storage = this.painter = this.handler = null;
	    delInstance(this.id);
	  }
	};
	exports.version = version;
	exports.init = init;
	exports.dispose = dispose;
	exports.getInstance = getInstance;
	exports.registerPainter = registerPainter;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * accounting.js v0.4.1
	 * Copyright 2014 Open Exchange Rates
	 *
	 * Freely distributable under the MIT license.
	 * Portions of accounting.js are inspired or borrowed from underscore.js
	 *
	 * Full details and documentation:
	 * http://openexchangerates.github.io/accounting.js/
	 */
	
	(function(root, undefined) {
	
		/* --- Setup --- */
	
		// Create the local library object, to be exported or referenced globally later
		var lib = {};
	
		// Current version
		lib.version = '0.4.1';
	
	
		/* --- Exposed settings --- */
	
		// The library's settings configuration object. Contains default parameters for
		// currency and number formatting
		lib.settings = {
			currency: {
				symbol : "$",		// default currency symbol is '$'
				format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
				decimal : ".",		// decimal point separator
				thousand : ",",		// thousands separator
				precision : 2,		// decimal places
				grouping : 3		// digit grouping (not implemented yet)
			},
			number: {
				precision : 0,		// default precision on numbers is 0
				grouping : 3,		// digit grouping (not implemented yet)
				thousand : ",",
				decimal : "."
			}
		};
	
	
		/* --- Internal Helper Methods --- */
	
		// Store reference to possibly-available ECMAScript 5 methods for later
		var nativeMap = Array.prototype.map,
			nativeIsArray = Array.isArray,
			toString = Object.prototype.toString;
	
		/**
		 * Tests whether supplied parameter is a string
		 * from underscore.js
		 */
		function isString(obj) {
			return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
		}
	
		/**
		 * Tests whether supplied parameter is a string
		 * from underscore.js, delegates to ECMA5's native Array.isArray
		 */
		function isArray(obj) {
			return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
		}
	
		/**
		 * Tests whether supplied parameter is a true object
		 */
		function isObject(obj) {
			return obj && toString.call(obj) === '[object Object]';
		}
	
		/**
		 * Extends an object with a defaults object, similar to underscore's _.defaults
		 *
		 * Used for abstracting parameter handling from API methods
		 */
		function defaults(object, defs) {
			var key;
			object = object || {};
			defs = defs || {};
			// Iterate over object non-prototype properties:
			for (key in defs) {
				if (defs.hasOwnProperty(key)) {
					// Replace values with defaults only if undefined (allow empty/zero values):
					if (object[key] == null) object[key] = defs[key];
				}
			}
			return object;
		}
	
		/**
		 * Implementation of `Array.map()` for iteration loops
		 *
		 * Returns a new Array as a result of calling `iterator` on each array value.
		 * Defers to native Array.map if available
		 */
		function map(obj, iterator, context) {
			var results = [], i, j;
	
			if (!obj) return results;
	
			// Use native .map method if it exists:
			if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
	
			// Fallback for native .map:
			for (i = 0, j = obj.length; i < j; i++ ) {
				results[i] = iterator.call(context, obj[i], i, obj);
			}
			return results;
		}
	
		/**
		 * Check and normalise the value of precision (must be positive integer)
		 */
		function checkPrecision(val, base) {
			val = Math.round(Math.abs(val));
			return isNaN(val)? base : val;
		}
	
	
		/**
		 * Parses a format string or object and returns format obj for use in rendering
		 *
		 * `format` is either a string with the default (positive) format, or object
		 * containing `pos` (required), `neg` and `zero` values (or a function returning
		 * either a string or object)
		 *
		 * Either string or format.pos must contain "%v" (value) to be valid
		 */
		function checkCurrencyFormat(format) {
			var defaults = lib.settings.currency.format;
	
			// Allow function as format parameter (should return string or object):
			if ( typeof format === "function" ) format = format();
	
			// Format can be a string, in which case `value` ("%v") must be present:
			if ( isString( format ) && format.match("%v") ) {
	
				// Create and return positive, negative and zero formats:
				return {
					pos : format,
					neg : format.replace("-", "").replace("%v", "-%v"),
					zero : format
				};
	
			// If no format, or object is missing valid positive value, use defaults:
			} else if ( !format || !format.pos || !format.pos.match("%v") ) {
	
				// If defaults is a string, casts it to an object for faster checking next time:
				return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
					pos : defaults,
					neg : defaults.replace("%v", "-%v"),
					zero : defaults
				};
	
			}
			// Otherwise, assume format was fine:
			return format;
		}
	
	
		/* --- API Methods --- */
	
		/**
		 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
		 * Alias: `accounting.parse(string)`
		 *
		 * Decimal must be included in the regular expression to match floats (defaults to
		 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
		 * separator, provide it as the second argument.
		 *
		 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
		 *
		 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
		 */
		var unformat = lib.unformat = lib.parse = function(value, decimal) {
			// Recursively unformat arrays:
			if (isArray(value)) {
				return map(value, function(val) {
					return unformat(val, decimal);
				});
			}
	
			// Fails silently (need decent errors):
			value = value || 0;
	
			// Return the value as-is if it's already a number:
			if (typeof value === "number") return value;
	
			// Default decimal point comes from settings, but could be set to eg. "," in opts:
			decimal = decimal || lib.settings.number.decimal;
	
			 // Build regex to strip out everything except digits, decimal point and minus sign:
			var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
				unformatted = parseFloat(
					("" + value)
					.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
					.replace(regex, '')         // strip out any cruft
					.replace(decimal, '.')      // make sure decimal point is standard
				);
	
			// This will fail silently which may cause trouble, let's wait and see:
			return !isNaN(unformatted) ? unformatted : 0;
		};
	
	
		/**
		 * Implementation of toFixed() that treats floats more like decimals
		 *
		 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
		 * problems for accounting- and finance-related software.
		 */
		var toFixed = lib.toFixed = function(value, precision) {
			precision = checkPrecision(precision, lib.settings.number.precision);
			var power = Math.pow(10, precision);
	
			// Multiply up by precision, round accurately, then divide and use native toFixed():
			return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
		};
	
	
		/**
		 * Format a number, with comma-separated thousands and custom precision/decimal places
		 * Alias: `accounting.format()`
		 *
		 * Localise by overriding the precision and thousand / decimal separators
		 * 2nd parameter `precision` can be an object matching `settings.number`
		 */
		var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
			// Resursively format arrays:
			if (isArray(number)) {
				return map(number, function(val) {
					return formatNumber(val, precision, thousand, decimal);
				});
			}
	
			// Clean up number:
			number = unformat(number);
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(precision) ? precision : {
						precision : precision,
						thousand : thousand,
						decimal : decimal
					}),
					lib.settings.number
				),
	
				// Clean up precision
				usePrecision = checkPrecision(opts.precision),
	
				// Do some calc:
				negative = number < 0 ? "-" : "",
				base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
				mod = base.length > 3 ? base.length % 3 : 0;
	
			// Format the number:
			return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
		};
	
	
		/**
		 * Format a number into currency
		 *
		 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
		 * defaults: (0, "$", 2, ",", ".", "%s%v")
		 *
		 * Localise by overriding the symbol, precision, thousand / decimal separators and format
		 * Second param can be an object matching `settings.currency` which is the easiest way.
		 *
		 * To do: tidy up the parameters
		 */
		var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
			// Resursively format arrays:
			if (isArray(number)) {
				return map(number, function(val){
					return formatMoney(val, symbol, precision, thousand, decimal, format);
				});
			}
	
			// Clean up number:
			number = unformat(number);
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(symbol) ? symbol : {
						symbol : symbol,
						precision : precision,
						thousand : thousand,
						decimal : decimal,
						format : format
					}),
					lib.settings.currency
				),
	
				// Check format (returns object with pos, neg and zero):
				formats = checkCurrencyFormat(opts.format),
	
				// Choose which format to use for this value:
				useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;
	
			// Return with currency symbol added:
			return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
		};
	
	
		/**
		 * Format a list of numbers into an accounting column, padding with whitespace
		 * to line up currency symbols, thousand separators and decimals places
		 *
		 * List should be an array of numbers
		 * Second parameter can be an object containing keys that match the params
		 *
		 * Returns array of accouting-formatted number strings of same length
		 *
		 * NB: `white-space:pre` CSS rule is required on the list container to prevent
		 * browsers from collapsing the whitespace in the output strings.
		 */
		lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
			if (!list) return [];
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(symbol) ? symbol : {
						symbol : symbol,
						precision : precision,
						thousand : thousand,
						decimal : decimal,
						format : format
					}),
					lib.settings.currency
				),
	
				// Check format (returns object with pos, neg and zero), only need pos for now:
				formats = checkCurrencyFormat(opts.format),
	
				// Whether to pad at start of string or after currency symbol:
				padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,
	
				// Store value for the length of the longest string in the column:
				maxLength = 0,
	
				// Format the list according to options, store the length of the longest string:
				formatted = map(list, function(val, i) {
					if (isArray(val)) {
						// Recursively format columns if list is a multi-dimensional array:
						return lib.formatColumn(val, opts);
					} else {
						// Clean up the value
						val = unformat(val);
	
						// Choose which format to use for this value (pos, neg or zero):
						var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,
	
							// Format this value, push into formatted list and save the length:
							fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	
						if (fVal.length > maxLength) maxLength = fVal.length;
						return fVal;
					}
				});
	
			// Pad each number in the list and send back the column of numbers:
			return map(formatted, function(val, i) {
				// Only if this is a string (not a nested array, which would have already been padded):
				if (isString(val) && val.length < maxLength) {
					// Depending on symbol position, pad after symbol or at index 0:
					return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
				}
				return val;
			});
		};
	
	
		/* --- Module Definition --- */
	
		// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
		// Otherwise, just add `accounting` to the global object
		if (true) {
			if (typeof module !== 'undefined' && module.exports) {
				exports = module.exports = lib;
			}
			exports.accounting = lib;
		} else if (typeof define === 'function' && define.amd) {
			// Return the library as an AMD module:
			define([], function() {
				return lib;
			});
		} else {
			// Use accounting.noConflict to restore `accounting` back to its original value.
			// Returns a reference to the library's `accounting` object;
			// e.g. `var numbers = accounting.noConflict();`
			lib.noConflict = (function(oldAccounting) {
				return function() {
					// Reset the value of the root's `accounting` variable:
					root.accounting = oldAccounting;
					// Delete the noConflict method:
					lib.noConflict = undefined;
					// Return reference to the library to re-assign it:
					return lib;
				};
			})(root.accounting);
	
			// Declare `fx` on the root (global/window) object:
			root['accounting'] = lib;
		}
	
		// Root will be `window` in browser or `global` on the server:
	}(this));


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 105 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 106 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(53).f;
	var has = __webpack_require__(42);
	var TAG = __webpack_require__(33)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(109)('keys');
	var uid = __webpack_require__(82);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(24);
	var global = __webpack_require__(32);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(78) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 110 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(52);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(32);
	var core = __webpack_require__(24);
	var LIBRARY = __webpack_require__(78);
	var wksExt = __webpack_require__(113);
	var defineProperty = __webpack_require__(53).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(33);


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isDOMElement = isDOMElement;
	exports.addClasses = addClasses;
	exports.removeClasses = removeClasses;
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	// This is not really a perfect check, but works fine.
	// From http://stackoverflow.com/questions/384286
	var HAS_DOM_2 = (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === "object";
	
	function isDOMElement(obj) {
	  return HAS_DOM_2 ? obj instanceof HTMLElement : obj && _typeof(obj) === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === "string";
	}
	
	function addClasses(el, classNames) {
	  classNames.forEach(function (className) {
	    el.classList.add(className);
	  });
	}
	
	function removeClasses(el, classNames) {
	  classNames.forEach(function (className) {
	    el.classList.remove(className);
	  });
	}
	//# sourceMappingURL=dom.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = throwIfMissing;
	
	function throwIfMissing() {
	  throw new Error("Missing parameter");
	}
	//# sourceMappingURL=throwIfMissing.js.map

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var vector = __webpack_require__(8);
	
	var symbolUtil = __webpack_require__(22);
	
	var LinePath = __webpack_require__(397);
	
	var graphic = __webpack_require__(3);
	
	var _number = __webpack_require__(4);
	
	var round = _number.round;
	
	/**
	 * @module echarts/chart/helper/Line
	 */
	var SYMBOL_CATEGORIES = ['fromSymbol', 'toSymbol'];
	
	function makeSymbolTypeKey(symbolCategory) {
	  return '_' + symbolCategory + 'Type';
	}
	/**
	 * @inner
	 */
	
	
	function createSymbol(name, lineData, idx) {
	  var color = lineData.getItemVisual(idx, 'color');
	  var symbolType = lineData.getItemVisual(idx, name);
	  var symbolSize = lineData.getItemVisual(idx, name + 'Size');
	
	  if (!symbolType || symbolType === 'none') {
	    return;
	  }
	
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [symbolSize, symbolSize];
	  }
	
	  var symbolPath = symbolUtil.createSymbol(symbolType, -symbolSize[0] / 2, -symbolSize[1] / 2, symbolSize[0], symbolSize[1], color);
	  symbolPath.name = name;
	  return symbolPath;
	}
	
	function createLine(points) {
	  var line = new LinePath({
	    name: 'line'
	  });
	  setLinePoints(line.shape, points);
	  return line;
	}
	
	function setLinePoints(targetShape, points) {
	  var p1 = points[0];
	  var p2 = points[1];
	  var cp1 = points[2];
	  targetShape.x1 = p1[0];
	  targetShape.y1 = p1[1];
	  targetShape.x2 = p2[0];
	  targetShape.y2 = p2[1];
	  targetShape.percent = 1;
	
	  if (cp1) {
	    targetShape.cpx1 = cp1[0];
	    targetShape.cpy1 = cp1[1];
	  } else {
	    targetShape.cpx1 = NaN;
	    targetShape.cpy1 = NaN;
	  }
	}
	
	function updateSymbolAndLabelBeforeLineUpdate() {
	  var lineGroup = this;
	  var symbolFrom = lineGroup.childOfName('fromSymbol');
	  var symbolTo = lineGroup.childOfName('toSymbol');
	  var label = lineGroup.childOfName('label'); // Quick reject
	
	  if (!symbolFrom && !symbolTo && label.ignore) {
	    return;
	  }
	
	  var invScale = 1;
	  var parentNode = this.parent;
	
	  while (parentNode) {
	    if (parentNode.scale) {
	      invScale /= parentNode.scale[0];
	    }
	
	    parentNode = parentNode.parent;
	  }
	
	  var line = lineGroup.childOfName('line'); // If line not changed
	  // FIXME Parent scale changed
	
	  if (!this.__dirty && !line.__dirty) {
	    return;
	  }
	
	  var percent = line.shape.percent;
	  var fromPos = line.pointAt(0);
	  var toPos = line.pointAt(percent);
	  var d = vector.sub([], toPos, fromPos);
	  vector.normalize(d, d);
	
	  if (symbolFrom) {
	    symbolFrom.attr('position', fromPos);
	    var tangent = line.tangentAt(0);
	    symbolFrom.attr('rotation', Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
	    symbolFrom.attr('scale', [invScale * percent, invScale * percent]);
	  }
	
	  if (symbolTo) {
	    symbolTo.attr('position', toPos);
	    var tangent = line.tangentAt(1);
	    symbolTo.attr('rotation', -Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
	    symbolTo.attr('scale', [invScale * percent, invScale * percent]);
	  }
	
	  if (!label.ignore) {
	    label.attr('position', toPos);
	    var textPosition;
	    var textAlign;
	    var textVerticalAlign;
	    var distance = 5 * invScale; // End
	
	    if (label.__position === 'end') {
	      textPosition = [d[0] * distance + toPos[0], d[1] * distance + toPos[1]];
	      textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
	      textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
	    } // Middle
	    else if (label.__position === 'middle') {
	        var halfPercent = percent / 2;
	        var tangent = line.tangentAt(halfPercent);
	        var n = [tangent[1], -tangent[0]];
	        var cp = line.pointAt(halfPercent);
	
	        if (n[1] > 0) {
	          n[0] = -n[0];
	          n[1] = -n[1];
	        }
	
	        textPosition = [cp[0] + n[0] * distance, cp[1] + n[1] * distance];
	        textAlign = 'center';
	        textVerticalAlign = 'bottom';
	        var rotation = -Math.atan2(tangent[1], tangent[0]);
	
	        if (toPos[0] < fromPos[0]) {
	          rotation = Math.PI + rotation;
	        }
	
	        label.attr('rotation', rotation);
	      } // Start
	      else {
	          textPosition = [-d[0] * distance + fromPos[0], -d[1] * distance + fromPos[1]];
	          textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
	          textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
	        }
	
	    label.attr({
	      style: {
	        // Use the user specified text align and baseline first
	        textVerticalAlign: label.__verticalAlign || textVerticalAlign,
	        textAlign: label.__textAlign || textAlign
	      },
	      position: textPosition,
	      scale: [invScale, invScale]
	    });
	  }
	}
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Line}
	 */
	
	
	function Line(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	
	  this._createLine(lineData, idx, seriesScope);
	}
	
	var lineProto = Line.prototype; // Update symbol position and rotation
	
	lineProto.beforeUpdate = updateSymbolAndLabelBeforeLineUpdate;
	
	lineProto._createLine = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var linePoints = lineData.getItemLayout(idx);
	  var line = createLine(linePoints);
	  line.shape.percent = 0;
	  graphic.initProps(line, {
	    shape: {
	      percent: 1
	    }
	  }, seriesModel, idx);
	  this.add(line);
	  var label = new graphic.Text({
	    name: 'label'
	  });
	  this.add(label);
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbol = createSymbol(symbolCategory, lineData, idx); // symbols must added after line to make sure
	    // it will be updated after line#update.
	    // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
	
	    this.add(symbol);
	    this[makeSymbolTypeKey(symbolCategory)] = lineData.getItemVisual(idx, symbolCategory);
	  }, this);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	lineProto.updateData = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childOfName('line');
	  var linePoints = lineData.getItemLayout(idx);
	  var target = {
	    shape: {}
	  };
	  setLinePoints(target.shape, linePoints);
	  graphic.updateProps(line, target, seriesModel, idx);
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbolType = lineData.getItemVisual(idx, symbolCategory);
	    var key = makeSymbolTypeKey(symbolCategory); // Symbol changed
	
	    if (this[key] !== symbolType) {
	      this.remove(this.childOfName(symbolCategory));
	      var symbol = createSymbol(symbolCategory, lineData, idx);
	      this.add(symbol);
	    }
	
	    this[key] = symbolType;
	  }, this);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	lineProto._updateCommonStl = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childOfName('line');
	  var lineStyle = seriesScope && seriesScope.lineStyle;
	  var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;
	  var labelModel = seriesScope && seriesScope.labelModel;
	  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel; // Optimization for large dataset
	
	  if (!seriesScope || lineData.hasItemOption) {
	    var itemModel = lineData.getItemModel(idx);
	    lineStyle = itemModel.getModel('lineStyle.normal').getLineStyle();
	    hoverLineStyle = itemModel.getModel('lineStyle.emphasis').getLineStyle();
	    labelModel = itemModel.getModel('label.normal');
	    hoverLabelModel = itemModel.getModel('label.emphasis');
	  }
	
	  var visualColor = lineData.getItemVisual(idx, 'color');
	  var visualOpacity = zrUtil.retrieve3(lineData.getItemVisual(idx, 'opacity'), lineStyle.opacity, 1);
	  line.useStyle(zrUtil.defaults({
	    strokeNoScale: true,
	    fill: 'none',
	    stroke: visualColor,
	    opacity: visualOpacity
	  }, lineStyle));
	  line.hoverStyle = hoverLineStyle; // Update symbol
	
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbol = this.childOfName(symbolCategory);
	
	    if (symbol) {
	      symbol.setColor(visualColor);
	      symbol.setStyle({
	        opacity: visualOpacity
	      });
	    }
	  }, this);
	  var showLabel = labelModel.getShallow('show');
	  var hoverShowLabel = hoverLabelModel.getShallow('show');
	  var label = this.childOfName('label');
	  var defaultLabelColor;
	  var defaultText;
	  var normalText;
	  var emphasisText;
	
	  if (showLabel || hoverShowLabel) {
	    var rawVal = seriesModel.getRawValue(idx);
	    defaultText = rawVal == null ? defaultText = lineData.getName(idx) : isFinite(rawVal) ? round(rawVal) : rawVal;
	    defaultLabelColor = visualColor || '#000';
	    normalText = zrUtil.retrieve2(seriesModel.getFormattedLabel(idx, 'normal', lineData.dataType), defaultText);
	    emphasisText = zrUtil.retrieve2(seriesModel.getFormattedLabel(idx, 'emphasis', lineData.dataType), normalText);
	  } // label.afterUpdate = lineAfterUpdate;
	
	
	  if (showLabel) {
	    var labelStyle = graphic.setTextStyle(label.style, labelModel, {
	      text: normalText
	    }, {
	      autoColor: defaultLabelColor
	    });
	    label.__textAlign = labelStyle.textAlign;
	    label.__verticalAlign = labelStyle.textVerticalAlign; // 'start', 'middle', 'end'
	
	    label.__position = labelModel.get('position') || 'middle';
	  } else {
	    label.setStyle('text', null);
	  }
	
	  if (hoverShowLabel) {
	    // Only these properties supported in this emphasis style here.
	    label.hoverStyle = {
	      text: emphasisText,
	      textFill: hoverLabelModel.getTextColor(true),
	      // For merging hover style to normal style, do not use
	      // `hoverLabelModel.getFont()` here.
	      fontStyle: hoverLabelModel.getShallow('fontStyle'),
	      fontWeight: hoverLabelModel.getShallow('fontWeight'),
	      fontSize: hoverLabelModel.getShallow('fontSize'),
	      fontFamily: hoverLabelModel.getShallow('fontFamily')
	    };
	  } else {
	    label.hoverStyle = {
	      text: null
	    };
	  }
	
	  label.ignore = !showLabel && !hoverShowLabel;
	  graphic.setHoverStyle(this);
	};
	
	lineProto.highlight = function () {
	  this.trigger('emphasis');
	};
	
	lineProto.downplay = function () {
	  this.trigger('normal');
	};
	
	lineProto.updateLayout = function (lineData, idx) {
	  this.setLinePoints(lineData.getItemLayout(idx));
	};
	
	lineProto.setLinePoints = function (points) {
	  var linePath = this.childOfName('line');
	  setLinePoints(linePath.shape, points);
	  linePath.dirty();
	};
	
	zrUtil.inherits(Line, graphic.Group);
	var _default = Line;
	module.exports = _default;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var graphic = __webpack_require__(3);
	
	var LineGroup = __webpack_require__(116);
	
	/**
	 * @module echarts/chart/helper/LineDraw
	 */
	function isPointNaN(pt) {
	  return isNaN(pt[0]) || isNaN(pt[1]);
	}
	
	function lineNeedsDraw(pts) {
	  return !isPointNaN(pts[0]) && !isPointNaN(pts[1]);
	}
	/**
	 * @alias module:echarts/component/marker/LineDraw
	 * @constructor
	 */
	
	
	function LineDraw(ctor) {
	  this._ctor = ctor || LineGroup;
	  this.group = new graphic.Group();
	}
	
	var lineDrawProto = LineDraw.prototype;
	/**
	 * @param {module:echarts/data/List} lineData
	 */
	
	lineDrawProto.updateData = function (lineData) {
	  var oldLineData = this._lineData;
	  var group = this.group;
	  var LineCtor = this._ctor;
	  var hostModel = lineData.hostModel;
	  var seriesScope = {
	    lineStyle: hostModel.getModel('lineStyle.normal').getLineStyle(),
	    hoverLineStyle: hostModel.getModel('lineStyle.emphasis').getLineStyle(),
	    labelModel: hostModel.getModel('label.normal'),
	    hoverLabelModel: hostModel.getModel('label.emphasis')
	  };
	  lineData.diff(oldLineData).add(function (idx) {
	    if (!lineNeedsDraw(lineData.getItemLayout(idx))) {
	      return;
	    }
	
	    var lineGroup = new LineCtor(lineData, idx, seriesScope);
	    lineData.setItemGraphicEl(idx, lineGroup);
	    group.add(lineGroup);
	  }).update(function (newIdx, oldIdx) {
	    var lineGroup = oldLineData.getItemGraphicEl(oldIdx);
	
	    if (!lineNeedsDraw(lineData.getItemLayout(newIdx))) {
	      group.remove(lineGroup);
	      return;
	    }
	
	    if (!lineGroup) {
	      lineGroup = new LineCtor(lineData, newIdx, seriesScope);
	    } else {
	      lineGroup.updateData(lineData, newIdx, seriesScope);
	    }
	
	    lineData.setItemGraphicEl(newIdx, lineGroup);
	    group.add(lineGroup);
	  }).remove(function (idx) {
	    group.remove(oldLineData.getItemGraphicEl(idx));
	  }).execute();
	  this._lineData = lineData;
	};
	
	lineDrawProto.updateLayout = function () {
	  var lineData = this._lineData;
	  lineData.eachItemGraphicEl(function (el, idx) {
	    el.updateLayout(lineData, idx);
	  }, this);
	};
	
	lineDrawProto.remove = function () {
	  this.group.removeAll();
	};
	
	var _default = LineDraw;
	module.exports = _default;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var clazzUtil = __webpack_require__(28);
	
	var graphic = __webpack_require__(3);
	
	var axisPointerModelHelper = __webpack_require__(85);
	
	var eventTool = __webpack_require__(30);
	
	var throttleUtil = __webpack_require__(45);
	
	var modelUtil = __webpack_require__(6);
	
	var get = modelUtil.makeGetter();
	var clone = zrUtil.clone;
	var bind = zrUtil.bind;
	/**
	 * Base axis pointer class in 2D.
	 * Implemenents {module:echarts/component/axis/IAxisPointer}.
	 */
	
	function BaseAxisPointer() {}
	
	BaseAxisPointer.prototype = {
	  /**
	   * @private
	   */
	  _group: null,
	
	  /**
	   * @private
	   */
	  _lastGraphicKey: null,
	
	  /**
	   * @private
	   */
	  _handle: null,
	
	  /**
	   * @private
	   */
	  _dragging: false,
	
	  /**
	   * @private
	   */
	  _lastValue: null,
	
	  /**
	   * @private
	   */
	  _lastStatus: null,
	
	  /**
	   * @private
	   */
	  _payloadInfo: null,
	
	  /**
	   * In px, arbitrary value. Do not set too small,
	   * no animation is ok for most cases.
	   * @protected
	   */
	  animationThreshold: 15,
	
	  /**
	   * @implement
	   */
	  render: function (axisModel, axisPointerModel, api, forceRender) {
	    var value = axisPointerModel.get('value');
	    var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
	    // be replaced when user calling setOption in not merge mode.
	
	    this._axisModel = axisModel;
	    this._axisPointerModel = axisPointerModel;
	    this._api = api; // Optimize: `render` will be called repeatly during mouse move.
	    // So it is power consuming if performing `render` each time,
	    // especially on mobile device.
	
	    if (!forceRender && this._lastValue === value && this._lastStatus === status) {
	      return;
	    }
	
	    this._lastValue = value;
	    this._lastStatus = status;
	    var group = this._group;
	    var handle = this._handle;
	
	    if (!status || status === 'hide') {
	      // Do not clear here, for animation better.
	      group && group.hide();
	      handle && handle.hide();
	      return;
	    }
	
	    group && group.show();
	    handle && handle.show(); // Otherwise status is 'show'
	
	    var elOption = {};
	    this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.
	
	    var graphicKey = elOption.graphicKey;
	
	    if (graphicKey !== this._lastGraphicKey) {
	      this.clear(api);
	    }
	
	    this._lastGraphicKey = graphicKey;
	    var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
	
	    if (!group) {
	      group = this._group = new graphic.Group();
	      this.createPointerEl(group, elOption, axisModel, axisPointerModel);
	      this.createLabelEl(group, elOption, axisModel, axisPointerModel);
	      api.getZr().add(group);
	    } else {
	      var doUpdateProps = zrUtil.curry(updateProps, axisPointerModel, moveAnimation);
	      this.updatePointerEl(group, elOption, doUpdateProps, axisPointerModel);
	      this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
	    }
	
	    updateMandatoryProps(group, axisPointerModel, true);
	
	    this._renderHandle(value);
	  },
	
	  /**
	   * @implement
	   */
	  remove: function (api) {
	    this.clear(api);
	  },
	
	  /**
	   * @implement
	   */
	  dispose: function (api) {
	    this.clear(api);
	  },
	
	  /**
	   * @protected
	   */
	  determineAnimation: function (axisModel, axisPointerModel) {
	    var animation = axisPointerModel.get('animation');
	    var axis = axisModel.axis;
	    var isCategoryAxis = axis.type === 'category';
	    var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.
	
	    if (!useSnap && !isCategoryAxis) {
	      return false;
	    }
	
	    if (animation === 'auto' || animation == null) {
	      var animationThreshold = this.animationThreshold;
	
	      if (isCategoryAxis && axis.getBandWidth() > animationThreshold) {
	        return true;
	      } // It is important to auto animation when snap used. Consider if there is
	      // a dataZoom, animation will be disabled when too many points exist, while
	      // it will be enabled for better visual effect when little points exist.
	
	
	      if (useSnap) {
	        var seriesDataCount = axisPointerModelHelper.getAxisInfo(axisModel).seriesDataCount;
	        var axisExtent = axis.getExtent(); // Approximate band width
	
	        return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
	      }
	
	      return false;
	    }
	
	    return animation === true;
	  },
	
	  /**
	   * add {pointer, label, graphicKey} to elOption
	   * @protected
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {// Shoule be implemenented by sub-class.
	  },
	
	  /**
	   * @protected
	   */
	  createPointerEl: function (group, elOption, axisModel, axisPointerModel) {
	    var pointerOption = elOption.pointer;
	
	    if (pointerOption) {
	      var pointerEl = get(group).pointerEl = new graphic[pointerOption.type](clone(elOption.pointer));
	      group.add(pointerEl);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  createLabelEl: function (group, elOption, axisModel, axisPointerModel) {
	    if (elOption.label) {
	      var labelEl = get(group).labelEl = new graphic.Rect(clone(elOption.label));
	      group.add(labelEl);
	      updateLabelShowHide(labelEl, axisPointerModel);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  updatePointerEl: function (group, elOption, updateProps) {
	    var pointerEl = get(group).pointerEl;
	
	    if (pointerEl) {
	      pointerEl.setStyle(elOption.pointer.style);
	      updateProps(pointerEl, {
	        shape: elOption.pointer.shape
	      });
	    }
	  },
	
	  /**
	   * @protected
	   */
	  updateLabelEl: function (group, elOption, updateProps, axisPointerModel) {
	    var labelEl = get(group).labelEl;
	
	    if (labelEl) {
	      labelEl.setStyle(elOption.label.style);
	      updateProps(labelEl, {
	        // Consider text length change in vertical axis, animation should
	        // be used on shape, otherwise the effect will be weird.
	        shape: elOption.label.shape,
	        position: elOption.label.position
	      });
	      updateLabelShowHide(labelEl, axisPointerModel);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderHandle: function (value) {
	    if (this._dragging || !this.updateHandleTransform) {
	      return;
	    }
	
	    var axisPointerModel = this._axisPointerModel;
	
	    var zr = this._api.getZr();
	
	    var handle = this._handle;
	    var handleModel = axisPointerModel.getModel('handle');
	    var status = axisPointerModel.get('status');
	
	    if (!handleModel.get('show') || !status || status === 'hide') {
	      handle && zr.remove(handle);
	      this._handle = null;
	      return;
	    }
	
	    var isInit;
	
	    if (!this._handle) {
	      isInit = true;
	      handle = this._handle = graphic.createIcon(handleModel.get('icon'), {
	        cursor: 'move',
	        draggable: true,
	        onmousemove: function (e) {
	          // Fot mobile devicem, prevent screen slider on the button.
	          eventTool.stop(e.event);
	        },
	        onmousedown: bind(this._onHandleDragMove, this, 0, 0),
	        drift: bind(this._onHandleDragMove, this),
	        ondragend: bind(this._onHandleDragEnd, this)
	      });
	      zr.add(handle);
	    }
	
	    updateMandatoryProps(handle, axisPointerModel, false); // update style
	
	    var includeStyles = ['color', 'borderColor', 'borderWidth', 'opacity', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'];
	    handle.setStyle(handleModel.getItemStyle(null, includeStyles)); // update position
	
	    var handleSize = handleModel.get('size');
	
	    if (!zrUtil.isArray(handleSize)) {
	      handleSize = [handleSize, handleSize];
	    }
	
	    handle.attr('scale', [handleSize[0] / 2, handleSize[1] / 2]);
	    throttleUtil.createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
	
	    this._moveHandleToValue(value, isInit);
	  },
	
	  /**
	   * @private
	   */
	  _moveHandleToValue: function (value, isInit) {
	    updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
	  },
	
	  /**
	   * @private
	   */
	  _onHandleDragMove: function (dx, dy) {
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    this._dragging = true; // Persistent for throttle.
	
	    var trans = this.updateHandleTransform(getHandleTransProps(handle), [dx, dy], this._axisModel, this._axisPointerModel);
	    this._payloadInfo = trans;
	    handle.stopAnimation();
	    handle.attr(getHandleTransProps(trans));
	    get(handle).lastProp = null;
	
	    this._doDispatchAxisPointer();
	  },
	
	  /**
	   * Throttled method.
	   * @private
	   */
	  _doDispatchAxisPointer: function () {
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    var payloadInfo = this._payloadInfo;
	    var axisModel = this._axisModel;
	
	    this._api.dispatchAction({
	      type: 'updateAxisPointer',
	      x: payloadInfo.cursorPoint[0],
	      y: payloadInfo.cursorPoint[1],
	      tooltipOption: payloadInfo.tooltipOption,
	      axesInfo: [{
	        axisDim: axisModel.axis.dim,
	        axisIndex: axisModel.componentIndex
	      }]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _onHandleDragEnd: function (moveAnimation) {
	    this._dragging = false;
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
	    // axisPointer. So move handle to align the exact value position when
	    // drag ended.
	
	
	    this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
	    // button, and will be hidden after finger left handle button.
	
	
	    this._api.dispatchAction({
	      type: 'hideTip'
	    });
	  },
	
	  /**
	   * Should be implemenented by sub-class if support `handle`.
	   * @protected
	   * @param {number} value
	   * @param {module:echarts/model/Model} axisModel
	   * @param {module:echarts/model/Model} axisPointerModel
	   * @return {Object} {position: [x, y], rotation: 0}
	   */
	  getHandleTransform: null,
	
	  /**
	   * * Should be implemenented by sub-class if support `handle`.
	   * @protected
	   * @param {Object} transform {position, rotation}
	   * @param {Array.<number>} delta [dx, dy]
	   * @param {module:echarts/model/Model} axisModel
	   * @param {module:echarts/model/Model} axisPointerModel
	   * @return {Object} {position: [x, y], rotation: 0, cursorPoint: [x, y]}
	   */
	  updateHandleTransform: null,
	
	  /**
	   * @private
	   */
	  clear: function (api) {
	    this._lastValue = null;
	    this._lastStatus = null;
	    var zr = api.getZr();
	    var group = this._group;
	    var handle = this._handle;
	
	    if (zr && group) {
	      this._lastGraphicKey = null;
	      group && zr.remove(group);
	      handle && zr.remove(handle);
	      this._group = null;
	      this._handle = null;
	      this._payloadInfo = null;
	    }
	  },
	
	  /**
	   * @protected
	   */
	  doClear: function () {// Implemented by sub-class if necessary.
	  },
	
	  /**
	   * @protected
	   * @param {Array.<number>} xy
	   * @param {Array.<number>} wh
	   * @param {number} [xDimIndex=0] or 1
	   */
	  buildLabel: function (xy, wh, xDimIndex) {
	    xDimIndex = xDimIndex || 0;
	    return {
	      x: xy[xDimIndex],
	      y: xy[1 - xDimIndex],
	      width: wh[xDimIndex],
	      height: wh[1 - xDimIndex]
	    };
	  }
	};
	BaseAxisPointer.prototype.constructor = BaseAxisPointer;
	
	function updateProps(animationModel, moveAnimation, el, props) {
	  // Animation optimize.
	  if (!propsEqual(get(el).lastProp, props)) {
	    get(el).lastProp = props;
	    moveAnimation ? graphic.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
	  }
	}
	
	function propsEqual(lastProps, newProps) {
	  if (zrUtil.isObject(lastProps) && zrUtil.isObject(newProps)) {
	    var equals = true;
	    zrUtil.each(newProps, function (item, key) {
	      equals = equals && propsEqual(lastProps[key], item);
	    });
	    return !!equals;
	  } else {
	    return lastProps === newProps;
	  }
	}
	
	function updateLabelShowHide(labelEl, axisPointerModel) {
	  labelEl[axisPointerModel.get('label.show') ? 'show' : 'hide']();
	}
	
	function getHandleTransProps(trans) {
	  return {
	    position: trans.position.slice(),
	    rotation: trans.rotation || 0
	  };
	}
	
	function updateMandatoryProps(group, axisPointerModel, silent) {
	  var z = axisPointerModel.get('z');
	  var zlevel = axisPointerModel.get('zlevel');
	  group && group.traverse(function (el) {
	    if (el.type !== 'group') {
	      z != null && (el.z = z);
	      zlevel != null && (el.zlevel = zlevel);
	      el.silent = silent;
	    }
	  });
	}
	
	clazzUtil.enableClassExtend(BaseAxisPointer);
	var _default = BaseAxisPointer;
	module.exports = _default;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var formatUtil = __webpack_require__(9);
	
	var AXIS_DIMS = ['x', 'y', 'z', 'radius', 'angle', 'single']; // Supported coords.
	
	var COORDS = ['cartesian2d', 'polar', 'singleAxis'];
	/**
	 * @param {string} coordType
	 * @return {boolean}
	 */
	
	function isCoordSupported(coordType) {
	  return zrUtil.indexOf(COORDS, coordType) >= 0;
	}
	/**
	 * Create "each" method to iterate names.
	 *
	 * @pubilc
	 * @param  {Array.<string>} names
	 * @param  {Array.<string>=} attrs
	 * @return {Function}
	 */
	
	
	function createNameEach(names, attrs) {
	  names = names.slice();
	  var capitalNames = zrUtil.map(names, formatUtil.capitalFirst);
	  attrs = (attrs || []).slice();
	  var capitalAttrs = zrUtil.map(attrs, formatUtil.capitalFirst);
	  return function (callback, context) {
	    zrUtil.each(names, function (name, index) {
	      var nameObj = {
	        name: name,
	        capital: capitalNames[index]
	      };
	
	      for (var j = 0; j < attrs.length; j++) {
	        nameObj[attrs[j]] = name + capitalAttrs[j];
	      }
	
	      callback.call(context, nameObj);
	    });
	  };
	}
	/**
	 * Iterate each dimension name.
	 *
	 * @public
	 * @param {Function} callback The parameter is like:
	 *                            {
	 *                                name: 'angle',
	 *                                capital: 'Angle',
	 *                                axis: 'angleAxis',
	 *                                axisIndex: 'angleAixs',
	 *                                index: 'angleIndex'
	 *                            }
	 * @param {Object} context
	 */
	
	
	var eachAxisDim = createNameEach(AXIS_DIMS, ['axisIndex', 'axis', 'index', 'id']);
	/**
	 * If tow dataZoomModels has the same axis controlled, we say that they are 'linked'.
	 * dataZoomModels and 'links' make up one or more graphics.
	 * This function finds the graphic where the source dataZoomModel is in.
	 *
	 * @public
	 * @param {Function} forEachNode Node iterator.
	 * @param {Function} forEachEdgeType edgeType iterator
	 * @param {Function} edgeIdGetter Giving node and edgeType, return an array of edge id.
	 * @return {Function} Input: sourceNode, Output: Like {nodes: [], dims: {}}
	 */
	
	function createLinkedNodesFinder(forEachNode, forEachEdgeType, edgeIdGetter) {
	  return function (sourceNode) {
	    var result = {
	      nodes: [],
	      records: {} // key: edgeType.name, value: Object (key: edge id, value: boolean).
	
	    };
	    forEachEdgeType(function (edgeType) {
	      result.records[edgeType.name] = {};
	    });
	
	    if (!sourceNode) {
	      return result;
	    }
	
	    absorb(sourceNode, result);
	    var existsLink;
	
	    do {
	      existsLink = false;
	      forEachNode(processSingleNode);
	    } while (existsLink);
	
	    function processSingleNode(node) {
	      if (!isNodeAbsorded(node, result) && isLinked(node, result)) {
	        absorb(node, result);
	        existsLink = true;
	      }
	    }
	
	    return result;
	  };
	
	  function isNodeAbsorded(node, result) {
	    return zrUtil.indexOf(result.nodes, node) >= 0;
	  }
	
	  function isLinked(node, result) {
	    var hasLink = false;
	    forEachEdgeType(function (edgeType) {
	      zrUtil.each(edgeIdGetter(node, edgeType) || [], function (edgeId) {
	        result.records[edgeType.name][edgeId] && (hasLink = true);
	      });
	    });
	    return hasLink;
	  }
	
	  function absorb(node, result) {
	    result.nodes.push(node);
	    forEachEdgeType(function (edgeType) {
	      zrUtil.each(edgeIdGetter(node, edgeType) || [], function (edgeId) {
	        result.records[edgeType.name][edgeId] = true;
	      });
	    });
	  }
	}
	
	exports.isCoordSupported = isCoordSupported;
	exports.createNameEach = createNameEach;
	exports.eachAxisDim = eachAxisDim;
	exports.createLinkedNodesFinder = createLinkedNodesFinder;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(1);
	
	var Eventful = __webpack_require__(49);
	
	var graphic = __webpack_require__(3);
	
	var interactionMutex = __webpack_require__(179);
	
	var DataDiffer = __webpack_require__(56);
	
	var curry = zrUtil.curry;
	var each = zrUtil.each;
	var map = zrUtil.map;
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathPow = Math.pow;
	var COVER_Z = 10000;
	var UNSELECT_THRESHOLD = 6;
	var MIN_RESIZE_LINE_WIDTH = 6;
	var MUTEX_RESOURCE_KEY = 'globalPan';
	var DIRECTION_MAP = {
	  w: [0, 0],
	  e: [0, 1],
	  n: [1, 0],
	  s: [1, 1]
	};
	var CURSOR_MAP = {
	  w: 'ew',
	  e: 'ew',
	  n: 'ns',
	  s: 'ns',
	  ne: 'nesw',
	  sw: 'nesw',
	  nw: 'nwse',
	  se: 'nwse'
	};
	var DEFAULT_BRUSH_OPT = {
	  brushStyle: {
	    lineWidth: 2,
	    stroke: 'rgba(0,0,0,0.3)',
	    fill: 'rgba(0,0,0,0.1)'
	  },
	  transformable: true,
	  brushMode: 'single',
	  removeOnClick: false
	};
	var baseUID = 0;
	/**
	 * @alias module:echarts/component/helper/BrushController
	 * @constructor
	 * @mixin {module:zrender/mixin/Eventful}
	 * @event module:echarts/component/helper/BrushController#brush
	 *        params:
	 *            areas: Array.<Array>, coord relates to container group,
	 *                                    If no container specified, to global.
	 *            opt {
	 *                isEnd: boolean,
	 *                removeOnClick: boolean
	 *            }
	 *
	 * @param {module:zrender/zrender~ZRender} zr
	 */
	
	function BrushController(zr) {
	  Eventful.call(this);
	  /**
	   * @type {module:zrender/zrender~ZRender}
	   * @private
	   */
	
	  this._zr = zr;
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	
	  this.group = new graphic.Group();
	  /**
	   * Only for drawing (after enabledBrush).
	   *     'line', 'rect', 'polygon' or false
	   *     If passing false/null/undefined, disable brush.
	   *     If passing 'auto', determined by panel.defaultBrushType
	   * @private
	   * @type {string}
	   */
	
	  this._brushType;
	  /**
	   * Only for drawing (after enabledBrush).
	   *
	   * @private
	   * @type {Object}
	   */
	
	  this._brushOption;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._panels;
	  /**
	   * @private
	   * @type {Array.<nubmer>}
	   */
	
	  this._track = [];
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._dragging;
	  /**
	   * @private
	   * @type {Array}
	   */
	
	  this._covers = [];
	  /**
	   * @private
	   * @type {moudule:zrender/container/Group}
	   */
	
	  this._creatingCover;
	  /**
	   * `true` means global panel
	   * @private
	   * @type {module:zrender/container/Group|boolean}
	   */
	
	  this._creatingPanel;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._enableGlobalPan;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  /**
	   * @private
	   * @type {string}
	   */
	  this._uid = 'brushController_' + baseUID++;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._handlers = {};
	  each(mouseHandlers, function (handler, eventName) {
	    this._handlers[eventName] = zrUtil.bind(handler, this);
	  }, this);
	}
	
	BrushController.prototype = {
	  constructor: BrushController,
	
	  /**
	   * If set to null/undefined/false, select disabled.
	   * @param {Object} brushOption
	   * @param {string|boolean} brushOption.brushType 'line', 'rect', 'polygon' or false
	   *                          If passing false/null/undefined, disable brush.
	   *                          If passing 'auto', determined by panel.defaultBrushType.
	   *                              ('auto' can not be used in global panel)
	   * @param {number} [brushOption.brushMode='single'] 'single' or 'multiple'
	   * @param {boolean} [brushOption.transformable=true]
	   * @param {boolean} [brushOption.removeOnClick=false]
	   * @param {Object} [brushOption.brushStyle]
	   * @param {number} [brushOption.brushStyle.width]
	   * @param {number} [brushOption.brushStyle.lineWidth]
	   * @param {string} [brushOption.brushStyle.stroke]
	   * @param {string} [brushOption.brushStyle.fill]
	   * @param {number} [brushOption.z]
	   */
	  enableBrush: function (brushOption) {
	    this._brushType && doDisableBrush(this);
	    brushOption.brushType && doEnableBrush(this, brushOption);
	    return this;
	  },
	
	  /**
	   * @param {Array.<Object>} panelOpts If not pass, it is global brush.
	   *        Each items: {
	   *            panelId, // mandatory.
	   *            clipPath, // mandatory. function.
	   *            isTargetByCursor, // mandatory. function.
	   *            defaultBrushType, // optional, only used when brushType is 'auto'.
	   *            getLinearBrushOtherExtent, // optional. function.
	   *        }
	   */
	  setPanels: function (panelOpts) {
	    if (panelOpts && panelOpts.length) {
	      var panels = this._panels = {};
	      zrUtil.each(panelOpts, function (panelOpts) {
	        panels[panelOpts.panelId] = zrUtil.clone(panelOpts);
	      });
	    } else {
	      this._panels = null;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param {Object} [opt]
	   * @return {boolean} [opt.enableGlobalPan=false]
	   */
	  mount: function (opt) {
	    opt = opt || {};
	    this._enableGlobalPan = opt.enableGlobalPan;
	    var thisGroup = this.group;
	
	    this._zr.add(thisGroup);
	
	    thisGroup.attr({
	      position: opt.position || [0, 0],
	      rotation: opt.rotation || 0,
	      scale: opt.scale || [1, 1]
	    });
	    this._transform = thisGroup.getLocalTransform();
	    return this;
	  },
	  eachCover: function (cb, context) {
	    each(this._covers, cb, context);
	  },
	
	  /**
	   * Update covers.
	   * @param {Array.<Object>} brushOptionList Like:
	   *        [
	   *            {id: 'xx', brushType: 'line', range: [23, 44], brushStyle, transformable},
	   *            {id: 'yy', brushType: 'rect', range: [[23, 44], [23, 54]]},
	   *            ...
	   *        ]
	   *        `brushType` is required in each cover info. (can not be 'auto')
	   *        `id` is not mandatory.
	   *        `brushStyle`, `transformable` is not mandatory, use DEFAULT_BRUSH_OPT by default.
	   *        If brushOptionList is null/undefined, all covers removed.
	   */
	  updateCovers: function (brushOptionList) {
	    brushOptionList = zrUtil.map(brushOptionList, function (brushOption) {
	      return zrUtil.merge(zrUtil.clone(DEFAULT_BRUSH_OPT), brushOption, true);
	    });
	    var tmpIdPrefix = '\0-brush-index-';
	    var oldCovers = this._covers;
	    var newCovers = this._covers = [];
	    var controller = this;
	    var creatingCover = this._creatingCover;
	    new DataDiffer(oldCovers, brushOptionList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
	    return this;
	
	    function getKey(brushOption, index) {
	      return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + '-' + brushOption.brushType;
	    }
	
	    function oldGetKey(cover, index) {
	      return getKey(cover.__brushOption, index);
	    }
	
	    function addOrUpdate(newIndex, oldIndex) {
	      var newBrushOption = brushOptionList[newIndex]; // Consider setOption in event listener of brushSelect,
	      // where updating cover when creating should be forbiden.
	
	      if (oldIndex != null && oldCovers[oldIndex] === creatingCover) {
	        newCovers[newIndex] = oldCovers[oldIndex];
	      } else {
	        var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushOption, oldCovers[oldIndex]) : endCreating(controller, createCover(controller, newBrushOption));
	        updateCoverAfterCreation(controller, cover);
	      }
	    }
	
	    function remove(oldIndex) {
	      if (oldCovers[oldIndex] !== creatingCover) {
	        controller.group.remove(oldCovers[oldIndex]);
	      }
	    }
	  },
	  unmount: function () {
	    this.enableBrush(false); // container may 'removeAll' outside.
	
	    clearCovers(this);
	
	    this._zr.remove(this.group);
	
	    return this;
	  },
	  dispose: function () {
	    this.unmount();
	    this.off();
	  }
	};
	zrUtil.mixin(BrushController, Eventful);
	
	function doEnableBrush(controller, brushOption) {
	  var zr = controller._zr; // Consider roam, which takes globalPan too.
	
	  if (!controller._enableGlobalPan) {
	    interactionMutex.take(zr, MUTEX_RESOURCE_KEY, controller._uid);
	  }
	
	  each(controller._handlers, function (handler, eventName) {
	    zr.on(eventName, handler);
	  });
	  controller._brushType = brushOption.brushType;
	  controller._brushOption = zrUtil.merge(zrUtil.clone(DEFAULT_BRUSH_OPT), brushOption, true);
	}
	
	function doDisableBrush(controller) {
	  var zr = controller._zr;
	  interactionMutex.release(zr, MUTEX_RESOURCE_KEY, controller._uid);
	  each(controller._handlers, function (handler, eventName) {
	    zr.off(eventName, handler);
	  });
	  controller._brushType = controller._brushOption = null;
	}
	
	function createCover(controller, brushOption) {
	  var cover = coverRenderers[brushOption.brushType].createCover(controller, brushOption);
	  cover.__brushOption = brushOption;
	  updateZ(cover, brushOption);
	  controller.group.add(cover);
	  return cover;
	}
	
	function endCreating(controller, creatingCover) {
	  var coverRenderer = getCoverRenderer(creatingCover);
	
	  if (coverRenderer.endCreating) {
	    coverRenderer.endCreating(controller, creatingCover);
	    updateZ(creatingCover, creatingCover.__brushOption);
	  }
	
	  return creatingCover;
	}
	
	function updateCoverShape(controller, cover) {
	  var brushOption = cover.__brushOption;
	  getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
	}
	
	function updateZ(cover, brushOption) {
	  var z = brushOption.z;
	  z == null && (z = COVER_Z);
	  cover.traverse(function (el) {
	    el.z = z;
	    el.z2 = z; // Consider in given container.
	  });
	}
	
	function updateCoverAfterCreation(controller, cover) {
	  getCoverRenderer(cover).updateCommon(controller, cover);
	  updateCoverShape(controller, cover);
	}
	
	function getCoverRenderer(cover) {
	  return coverRenderers[cover.__brushOption.brushType];
	} // return target panel or `true` (means global panel)
	
	
	function getPanelByPoint(controller, e, localCursorPoint) {
	  var panels = controller._panels;
	
	  if (!panels) {
	    return true; // Global panel
	  }
	
	  var panel;
	  var transform = controller._transform;
	  each(panels, function (pn) {
	    pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
	  });
	  return panel;
	} // Return a panel or true
	
	
	function getPanelByCover(controller, cover) {
	  var panels = controller._panels;
	
	  if (!panels) {
	    return true; // Global panel
	  }
	
	  var panelId = cover.__brushOption.panelId; // User may give cover without coord sys info,
	  // which is then treated as global panel.
	
	  return panelId != null ? panels[panelId] : true;
	}
	
	function clearCovers(controller) {
	  var covers = controller._covers;
	  var originalLength = covers.length;
	  each(covers, function (cover) {
	    controller.group.remove(cover);
	  }, controller);
	  covers.length = 0;
	  return !!originalLength;
	}
	
	function trigger(controller, opt) {
	  var areas = map(controller._covers, function (cover) {
	    var brushOption = cover.__brushOption;
	    var range = zrUtil.clone(brushOption.range);
	    return {
	      brushType: brushOption.brushType,
	      panelId: brushOption.panelId,
	      range: range
	    };
	  });
	  controller.trigger('brush', areas, {
	    isEnd: !!opt.isEnd,
	    removeOnClick: !!opt.removeOnClick
	  });
	}
	
	function shouldShowCover(controller) {
	  var track = controller._track;
	
	  if (!track.length) {
	    return false;
	  }
	
	  var p2 = track[track.length - 1];
	  var p1 = track[0];
	  var dx = p2[0] - p1[0];
	  var dy = p2[1] - p1[1];
	  var dist = mathPow(dx * dx + dy * dy, 0.5);
	  return dist > UNSELECT_THRESHOLD;
	}
	
	function getTrackEnds(track) {
	  var tail = track.length - 1;
	  tail < 0 && (tail = 0);
	  return [track[0], track[tail]];
	}
	
	function createBaseRectCover(doDrift, controller, brushOption, edgeNames) {
	  var cover = new graphic.Group();
	  cover.add(new graphic.Rect({
	    name: 'main',
	    style: makeStyle(brushOption),
	    silent: true,
	    draggable: true,
	    cursor: 'move',
	    drift: curry(doDrift, controller, cover, 'nswe'),
	    ondragend: curry(trigger, controller, {
	      isEnd: true
	    })
	  }));
	  each(edgeNames, function (name) {
	    cover.add(new graphic.Rect({
	      name: name,
	      style: {
	        opacity: 0
	      },
	      draggable: true,
	      silent: true,
	      invisible: true,
	      drift: curry(doDrift, controller, cover, name),
	      ondragend: curry(trigger, controller, {
	        isEnd: true
	      })
	    }));
	  });
	  return cover;
	}
	
	function updateBaseRect(controller, cover, localRange, brushOption) {
	  var lineWidth = brushOption.brushStyle.lineWidth || 0;
	  var handleSize = mathMax(lineWidth, MIN_RESIZE_LINE_WIDTH);
	  var x = localRange[0][0];
	  var y = localRange[1][0];
	  var xa = x - lineWidth / 2;
	  var ya = y - lineWidth / 2;
	  var x2 = localRange[0][1];
	  var y2 = localRange[1][1];
	  var x2a = x2 - handleSize + lineWidth / 2;
	  var y2a = y2 - handleSize + lineWidth / 2;
	  var width = x2 - x;
	  var height = y2 - y;
	  var widtha = width + lineWidth;
	  var heighta = height + lineWidth;
	  updateRectShape(controller, cover, 'main', x, y, width, height);
	
	  if (brushOption.transformable) {
	    updateRectShape(controller, cover, 'w', xa, ya, handleSize, heighta);
	    updateRectShape(controller, cover, 'e', x2a, ya, handleSize, heighta);
	    updateRectShape(controller, cover, 'n', xa, ya, widtha, handleSize);
	    updateRectShape(controller, cover, 's', xa, y2a, widtha, handleSize);
	    updateRectShape(controller, cover, 'nw', xa, ya, handleSize, handleSize);
	    updateRectShape(controller, cover, 'ne', x2a, ya, handleSize, handleSize);
	    updateRectShape(controller, cover, 'sw', xa, y2a, handleSize, handleSize);
	    updateRectShape(controller, cover, 'se', x2a, y2a, handleSize, handleSize);
	  }
	}
	
	function updateCommon(controller, cover) {
	  var brushOption = cover.__brushOption;
	  var transformable = brushOption.transformable;
	  var mainEl = cover.childAt(0);
	  mainEl.useStyle(makeStyle(brushOption));
	  mainEl.attr({
	    silent: !transformable,
	    cursor: transformable ? 'move' : 'default'
	  });
	  each(['w', 'e', 'n', 's', 'se', 'sw', 'ne', 'nw'], function (name) {
	    var el = cover.childOfName(name);
	    var globalDir = getGlobalDirection(controller, name);
	    el && el.attr({
	      silent: !transformable,
	      invisible: !transformable,
	      cursor: transformable ? CURSOR_MAP[globalDir] + '-resize' : null
	    });
	  });
	}
	
	function updateRectShape(controller, cover, name, x, y, w, h) {
	  var el = cover.childOfName(name);
	  el && el.setShape(pointsToRect(clipByPanel(controller, cover, [[x, y], [x + w, y + h]])));
	}
	
	function makeStyle(brushOption) {
	  return zrUtil.defaults({
	    strokeNoScale: true
	  }, brushOption.brushStyle);
	}
	
	function formatRectRange(x, y, x2, y2) {
	  var min = [mathMin(x, x2), mathMin(y, y2)];
	  var max = [mathMax(x, x2), mathMax(y, y2)];
	  return [[min[0], max[0]], // x range
	  [min[1], max[1]] // y range
	  ];
	}
	
	function getTransform(controller) {
	  return graphic.getTransform(controller.group);
	}
	
	function getGlobalDirection(controller, localDirection) {
	  if (localDirection.length > 1) {
	    localDirection = localDirection.split('');
	    var globalDir = [getGlobalDirection(controller, localDirection[0]), getGlobalDirection(controller, localDirection[1])];
	    (globalDir[0] === 'e' || globalDir[0] === 'w') && globalDir.reverse();
	    return globalDir.join('');
	  } else {
	    var map = {
	      w: 'left',
	      e: 'right',
	      n: 'top',
	      s: 'bottom'
	    };
	    var inverseMap = {
	      left: 'w',
	      right: 'e',
	      top: 'n',
	      bottom: 's'
	    };
	    var globalDir = graphic.transformDirection(map[localDirection], getTransform(controller));
	    return inverseMap[globalDir];
	  }
	}
	
	function driftRect(toRectRange, fromRectRange, controller, cover, name, dx, dy, e) {
	  var brushOption = cover.__brushOption;
	  var rectRange = toRectRange(brushOption.range);
	  var localDelta = toLocalDelta(controller, dx, dy);
	  each(name.split(''), function (namePart) {
	    var ind = DIRECTION_MAP[namePart];
	    rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
	  });
	  brushOption.range = fromRectRange(formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
	  updateCoverAfterCreation(controller, cover);
	  trigger(controller, {
	    isEnd: false
	  });
	}
	
	function driftPolygon(controller, cover, dx, dy, e) {
	  var range = cover.__brushOption.range;
	  var localDelta = toLocalDelta(controller, dx, dy);
	  each(range, function (point) {
	    point[0] += localDelta[0];
	    point[1] += localDelta[1];
	  });
	  updateCoverAfterCreation(controller, cover);
	  trigger(controller, {
	    isEnd: false
	  });
	}
	
	function toLocalDelta(controller, dx, dy) {
	  var thisGroup = controller.group;
	  var localD = thisGroup.transformCoordToLocal(dx, dy);
	  var localZero = thisGroup.transformCoordToLocal(0, 0);
	  return [localD[0] - localZero[0], localD[1] - localZero[1]];
	}
	
	function clipByPanel(controller, cover, data) {
	  var panel = getPanelByCover(controller, cover);
	  return panel && panel !== true ? panel.clipPath(data, controller._transform) : zrUtil.clone(data);
	}
	
	function pointsToRect(points) {
	  var xmin = mathMin(points[0][0], points[1][0]);
	  var ymin = mathMin(points[0][1], points[1][1]);
	  var xmax = mathMax(points[0][0], points[1][0]);
	  var ymax = mathMax(points[0][1], points[1][1]);
	  return {
	    x: xmin,
	    y: ymin,
	    width: xmax - xmin,
	    height: ymax - ymin
	  };
	}
	
	function resetCursor(controller, e, localCursorPoint) {
	  // Check active
	  if (!controller._brushType) {
	    return;
	  }
	
	  var zr = controller._zr;
	  var covers = controller._covers;
	  var currPanel = getPanelByPoint(controller, e, localCursorPoint); // Check whether in covers.
	
	  if (!controller._dragging) {
	    for (var i = 0; i < covers.length; i++) {
	      var brushOption = covers[i].__brushOption;
	
	      if (currPanel && (currPanel === true || brushOption.panelId === currPanel.panelId) && coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) {
	        // Use cursor style set on cover.
	        return;
	      }
	    }
	  }
	
	  currPanel && zr.setCursorStyle('crosshair');
	}
	
	function preventDefault(e) {
	  var rawE = e.event;
	  rawE.preventDefault && rawE.preventDefault();
	}
	
	function mainShapeContain(cover, x, y) {
	  return cover.childOfName('main').contain(x, y);
	}
	
	function updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
	  var creatingCover = controller._creatingCover;
	  var panel = controller._creatingPanel;
	  var thisBrushOption = controller._brushOption;
	  var eventParams;
	
	  controller._track.push(localCursorPoint.slice());
	
	  if (shouldShowCover(controller) || creatingCover) {
	    if (panel && !creatingCover) {
	      thisBrushOption.brushMode === 'single' && clearCovers(controller);
	      var brushOption = zrUtil.clone(thisBrushOption);
	      brushOption.brushType = determineBrushType(brushOption.brushType, panel);
	      brushOption.panelId = panel === true ? null : panel.panelId;
	      creatingCover = controller._creatingCover = createCover(controller, brushOption);
	
	      controller._covers.push(creatingCover);
	    }
	
	    if (creatingCover) {
	      var coverRenderer = coverRenderers[determineBrushType(controller._brushType, panel)];
	      var coverBrushOption = creatingCover.__brushOption;
	      coverBrushOption.range = coverRenderer.getCreatingRange(clipByPanel(controller, creatingCover, controller._track));
	
	      if (isEnd) {
	        endCreating(controller, creatingCover);
	        coverRenderer.updateCommon(controller, creatingCover);
	      }
	
	      updateCoverShape(controller, creatingCover);
	      eventParams = {
	        isEnd: isEnd
	      };
	    }
	  } else if (isEnd && thisBrushOption.brushMode === 'single' && thisBrushOption.removeOnClick) {
	    // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
	    // But a single click do not clear covers, because user may have casual
	    // clicks (for example, click on other component and do not expect covers
	    // disappear).
	    // Only some cover removed, trigger action, but not every click trigger action.
	    if (getPanelByPoint(controller, e, localCursorPoint) && clearCovers(controller)) {
	      eventParams = {
	        isEnd: isEnd,
	        removeOnClick: true
	      };
	    }
	  }
	
	  return eventParams;
	}
	
	function determineBrushType(brushType, panel) {
	  if (brushType === 'auto') {
	    return panel.defaultBrushType;
	  }
	
	  return brushType;
	}
	
	var mouseHandlers = {
	  mousedown: function (e) {
	    if (this._dragging) {
	      // In case some browser do not support globalOut,
	      // and release mose out side the browser.
	      handleDragEnd.call(this, e);
	    } else if (!e.target || !e.target.draggable) {
	      preventDefault(e);
	      var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
	      this._creatingCover = null;
	      var panel = this._creatingPanel = getPanelByPoint(this, e, localCursorPoint);
	
	      if (panel) {
	        this._dragging = true;
	        this._track = [localCursorPoint.slice()];
	      }
	    }
	  },
	  mousemove: function (e) {
	    var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
	    resetCursor(this, e, localCursorPoint);
	
	    if (this._dragging) {
	      preventDefault(e);
	      var eventParams = updateCoverByMouse(this, e, localCursorPoint, false);
	      eventParams && trigger(this, eventParams);
	    }
	  },
	  mouseup: handleDragEnd //,
	  // FIXME
	  // in tooltip, globalout should not be triggered.
	  // globalout: handleDragEnd
	
	};
	
	function handleDragEnd(e) {
	  if (this._dragging) {
	    preventDefault(e);
	    var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
	    var eventParams = updateCoverByMouse(this, e, localCursorPoint, true);
	    this._dragging = false;
	    this._track = [];
	    this._creatingCover = null; // trigger event shoule be at final, after procedure will be nested.
	
	    eventParams && trigger(this, eventParams);
	  }
	}
	/**
	 * key: brushType
	 * @type {Object}
	 */
	
	
	var coverRenderers = {
	  lineX: getLineRenderer(0),
	  lineY: getLineRenderer(1),
	  rect: {
	    createCover: function (controller, brushOption) {
	      return createBaseRectCover(curry(driftRect, function (range) {
	        return range;
	      }, function (range) {
	        return range;
	      }), controller, brushOption, ['w', 'e', 'n', 's', 'se', 'sw', 'ne', 'nw']);
	    },
	    getCreatingRange: function (localTrack) {
	      var ends = getTrackEnds(localTrack);
	      return formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      updateBaseRect(controller, cover, localRange, brushOption);
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  },
	  polygon: {
	    createCover: function (controller, brushOption) {
	      var cover = new graphic.Group(); // Do not use graphic.Polygon because graphic.Polyline do not close the
	      // border of the shape when drawing, which is a better experience for user.
	
	      cover.add(new graphic.Polyline({
	        name: 'main',
	        style: makeStyle(brushOption),
	        silent: true
	      }));
	      return cover;
	    },
	    getCreatingRange: function (localTrack) {
	      return localTrack;
	    },
	    endCreating: function (controller, cover) {
	      cover.remove(cover.childAt(0)); // Use graphic.Polygon close the shape.
	
	      cover.add(new graphic.Polygon({
	        name: 'main',
	        draggable: true,
	        drift: curry(driftPolygon, controller, cover),
	        ondragend: curry(trigger, controller, {
	          isEnd: true
	        })
	      }));
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      cover.childAt(0).setShape({
	        points: clipByPanel(controller, cover, localRange)
	      });
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  }
	};
	
	function getLineRenderer(xyIndex) {
	  return {
	    createCover: function (controller, brushOption) {
	      return createBaseRectCover(curry(driftRect, function (range) {
	        var rectRange = [range, [0, 100]];
	        xyIndex && rectRange.reverse();
	        return rectRange;
	      }, function (rectRange) {
	        return rectRange[xyIndex];
	      }), controller, brushOption, [['w', 'e'], ['n', 's']][xyIndex]);
	    },
	    getCreatingRange: function (localTrack) {
	      var ends = getTrackEnds(localTrack);
	      var min = mathMin(ends[0][xyIndex], ends[1][xyIndex]);
	      var max = mathMax(ends[0][xyIndex], ends[1][xyIndex]);
	      return [min, max];
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      var otherExtent; // If brushWidth not specified, fit the panel.
	
	      var panel = getPanelByCover(controller, cover);
	
	      if (panel !== true && panel.getLinearBrushOtherExtent) {
	        otherExtent = panel.getLinearBrushOtherExtent(xyIndex, controller._transform);
	      } else {
	        var zr = controller._zr;
	        otherExtent = [0, [zr.getWidth(), zr.getHeight()][1 - xyIndex]];
	      }
	
	      var rectRange = [localRange, otherExtent];
	      xyIndex && rectRange.reverse();
	      updateBaseRect(controller, cover, rectRange, brushOption);
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  };
	}
	
	var _default = BrushController;
	module.exports = _default;

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	var IRRELEVANT_EXCLUDES = {
	  'axisPointer': 1,
	  'tooltip': 1,
	  'brush': 1
	};
	/**
	 * Avoid that: mouse click on a elements that is over geo or graph,
	 * but roam is triggered.
	 */
	
	function onIrrelevantElement(e, api, targetCoordSysModel) {
	  var model = api.getComponentByElement(e.topTarget); // If model is axisModel, it works only if it is injected with coordinateSystem.
	
	  var coordSys = model && model.coordinateSystem;
	  return model && model !== targetCoordSysModel && !IRRELEVANT_EXCLUDES[model.mainType] && coordSys && coordSys.model !== targetCoordSysModel;
	}
	
	exports.onIrrelevantElement = onIrrelevantElement;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	/**
	 * Data selectable mixin for chart series.
	 * To eanble data select, option of series must have `selectedMode`.
	 * And each data item will use `selected` to toggle itself selected status
	 */
	var _default = {
	  updateSelectedMap: function (targetList) {
	    this._targetList = targetList.slice();
	    this._selectTargetMap = zrUtil.reduce(targetList || [], function (targetMap, target) {
	      targetMap.set(target.name, target);
	      return targetMap;
	    }, zrUtil.createHashMap());
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  // PENGING If selectedMode is null ?
	  select: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	    var selectedMode = this.get('selectedMode');
	
	    if (selectedMode === 'single') {
	      this._selectTargetMap.each(function (target) {
	        target.selected = false;
	      });
	    }
	
	    target && (target.selected = true);
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  unSelect: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name); // var selectedMode = this.get('selectedMode');
	    // selectedMode !== 'single' && target && (target.selected = false);
	
	    target && (target.selected = false);
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  toggleSelected: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	
	    if (target != null) {
	      this[target.selected ? 'unSelect' : 'select'](name, id);
	      return target.selected;
	    }
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  isSelected: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	    return target && target.selected;
	  }
	};
	module.exports = _default;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var env = __webpack_require__(18);
	
	var modelUtil = __webpack_require__(6);
	
	var formatUtil = __webpack_require__(9);
	
	var addCommas = formatUtil.addCommas;
	var encodeHTML = formatUtil.encodeHTML;
	
	function fillLabel(opt) {
	  modelUtil.defaultEmphasis(opt.label, ['show']);
	}
	
	var MarkerModel = echarts.extendComponentModel({
	  type: 'marker',
	  dependencies: ['series', 'grid', 'polar', 'geo'],
	
	  /**
	   * @overrite
	   */
	  init: function (option, parentModel, ecModel, extraOpt) {
	    this.mergeDefaultAndTheme(option, ecModel);
	    this.mergeOption(option, ecModel, extraOpt.createdBySelf, true);
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isAnimationEnabled: function () {
	    if (env.node) {
	      return false;
	    }
	
	    var hostSeries = this.__hostSeries;
	    return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
	  },
	  mergeOption: function (newOpt, ecModel, createdBySelf, isInit) {
	    var MarkerModel = this.constructor;
	    var modelPropName = this.mainType + 'Model';
	
	    if (!createdBySelf) {
	      ecModel.eachSeries(function (seriesModel) {
	        var markerOpt = seriesModel.get(this.mainType);
	        var markerModel = seriesModel[modelPropName];
	
	        if (!markerOpt || !markerOpt.data) {
	          seriesModel[modelPropName] = null;
	          return;
	        }
	
	        if (!markerModel) {
	          if (isInit) {
	            // Default label emphasis `position` and `show`
	            fillLabel(markerOpt);
	          }
	
	          zrUtil.each(markerOpt.data, function (item) {
	            // FIXME Overwrite fillLabel method ?
	            if (item instanceof Array) {
	              fillLabel(item[0]);
	              fillLabel(item[1]);
	            } else {
	              fillLabel(item);
	            }
	          });
	          markerModel = new MarkerModel(markerOpt, this, ecModel);
	          zrUtil.extend(markerModel, {
	            mainType: this.mainType,
	            // Use the same series index and name
	            seriesIndex: seriesModel.seriesIndex,
	            name: seriesModel.name,
	            createdBySelf: true
	          });
	          markerModel.__hostSeries = seriesModel;
	        } else {
	          markerModel.mergeOption(markerOpt, ecModel, true);
	        }
	
	        seriesModel[modelPropName] = markerModel;
	      }, this);
	    }
	  },
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var value = this.getRawValue(dataIndex);
	    var formattedValue = zrUtil.isArray(value) ? zrUtil.map(value, addCommas).join(', ') : addCommas(value);
	    var name = data.getName(dataIndex);
	    var html = encodeHTML(this.name);
	
	    if (value != null || name) {
	      html += '<br />';
	    }
	
	    if (name) {
	      html += encodeHTML(name);
	
	      if (value != null) {
	        html += ' : ';
	      }
	    }
	
	    if (value != null) {
	      html += encodeHTML(formattedValue);
	    }
	
	    return html;
	  },
	  getData: function () {
	    return this._data;
	  },
	  setData: function (data) {
	    this._data = data;
	  }
	});
	zrUtil.mixin(MarkerModel, modelUtil.dataFormatMixin);
	var _default = MarkerModel;
	module.exports = _default;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var _default = echarts.extendComponentView({
	  type: 'marker',
	  init: function () {
	    /**
	     * Markline grouped by series
	     * @private
	     * @type {module:zrender/core/util.HashMap}
	     */
	    this.markerGroupMap = zrUtil.createHashMap();
	  },
	  render: function (markerModel, ecModel, api) {
	    var markerGroupMap = this.markerGroupMap;
	    markerGroupMap.each(function (item) {
	      item.__keep = false;
	    });
	    var markerModelKey = this.type + 'Model';
	    ecModel.eachSeries(function (seriesModel) {
	      var markerModel = seriesModel[markerModelKey];
	      markerModel && this.renderSeries(seriesModel, markerModel, ecModel, api);
	    }, this);
	    markerGroupMap.each(function (item) {
	      !item.__keep && this.group.remove(item.group);
	    }, this);
	  },
	  renderSeries: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var numberUtil = __webpack_require__(4);
	
	var indexOf = zrUtil.indexOf;
	
	function hasXOrY(item) {
	  return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
	}
	
	function hasXAndY(item) {
	  return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
	}
	
	function getPrecision(data, valueAxisDim, dataIndex) {
	  var precision = -1;
	
	  do {
	    precision = Math.max(numberUtil.getPrecision(data.get(valueAxisDim, dataIndex)), precision);
	    data = data.stackedOn;
	  } while (data);
	
	  return precision;
	}
	
	function markerTypeCalculatorWithExtent(mlType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
	  var coordArr = [];
	  var value = numCalculate(data, targetDataDim, mlType);
	  var dataIndex = data.indicesOfNearest(targetDataDim, value, true)[0];
	  coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex, true);
	  coordArr[targetCoordIndex] = data.get(targetDataDim, dataIndex, true);
	  var precision = getPrecision(data, targetDataDim, dataIndex);
	  precision = Math.min(precision, 20);
	
	  if (precision >= 0) {
	    coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
	  }
	
	  return coordArr;
	}
	
	var curry = zrUtil.curry; // TODO Specified percent
	
	var markerTypeCalculator = {
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  min: curry(markerTypeCalculatorWithExtent, 'min'),
	
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  max: curry(markerTypeCalculatorWithExtent, 'max'),
	
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  average: curry(markerTypeCalculatorWithExtent, 'average')
	};
	/**
	 * Transform markPoint data item to format used in List by do the following
	 * 1. Calculate statistic like `max`, `min`, `average`
	 * 2. Convert `item.xAxis`, `item.yAxis` to `item.coord` array
	 * @param  {module:echarts/model/Series} seriesModel
	 * @param  {module:echarts/coord/*} [coordSys]
	 * @param  {Object} item
	 * @return {Object}
	 */
	
	function dataTransform(seriesModel, item) {
	  var data = seriesModel.getData();
	  var coordSys = seriesModel.coordinateSystem; // 1. If not specify the position with pixel directly
	  // 2. If `coord` is not a data array. Which uses `xAxis`,
	  // `yAxis` to specify the coord on each dimension
	  // parseFloat first because item.x and item.y can be percent string like '20%'
	
	  if (item && !hasXAndY(item) && !zrUtil.isArray(item.coord) && coordSys) {
	    var dims = coordSys.dimensions;
	    var axisInfo = getAxisInfo(item, data, coordSys, seriesModel); // Clone the option
	    // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
	
	    item = zrUtil.clone(item);
	
	    if (item.type && markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
	      var otherCoordIndex = indexOf(dims, axisInfo.baseAxis.dim);
	      var targetCoordIndex = indexOf(dims, axisInfo.valueAxis.dim);
	      item.coord = markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex); // Force to use the value of calculated value.
	
	      item.value = item.coord[targetCoordIndex];
	    } else {
	      // FIXME Only has one of xAxis and yAxis.
	      var coord = [item.xAxis != null ? item.xAxis : item.radiusAxis, item.yAxis != null ? item.yAxis : item.angleAxis]; // Each coord support max, min, average
	
	      for (var i = 0; i < 2; i++) {
	        if (markerTypeCalculator[coord[i]]) {
	          var dataDim = seriesModel.coordDimToDataDim(dims[i])[0];
	          coord[i] = numCalculate(data, dataDim, coord[i]);
	        }
	      }
	
	      item.coord = coord;
	    }
	  }
	
	  return item;
	}
	
	function getAxisInfo(item, data, coordSys, seriesModel) {
	  var ret = {};
	
	  if (item.valueIndex != null || item.valueDim != null) {
	    ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
	    ret.valueAxis = coordSys.getAxis(seriesModel.dataDimToCoordDim(ret.valueDataDim));
	    ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
	    ret.baseDataDim = seriesModel.coordDimToDataDim(ret.baseAxis.dim)[0];
	  } else {
	    ret.baseAxis = seriesModel.getBaseAxis();
	    ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
	    ret.baseDataDim = seriesModel.coordDimToDataDim(ret.baseAxis.dim)[0];
	    ret.valueDataDim = seriesModel.coordDimToDataDim(ret.valueAxis.dim)[0];
	  }
	
	  return ret;
	}
	/**
	 * Filter data which is out of coordinateSystem range
	 * [dataFilter description]
	 * @param  {module:echarts/coord/*} [coordSys]
	 * @param  {Object} item
	 * @return {boolean}
	 */
	
	
	function dataFilter(coordSys, item) {
	  // Alwalys return true if there is no coordSys
	  return coordSys && coordSys.containData && item.coord && !hasXOrY(item) ? coordSys.containData(item.coord) : true;
	}
	
	function dimValueGetter(item, dimName, dataIndex, dimIndex) {
	  // x, y, radius, angle
	  if (dimIndex < 2) {
	    return item.coord && item.coord[dimIndex];
	  }
	
	  return item.value;
	}
	
	function numCalculate(data, valueDataDim, type) {
	  if (type === 'average') {
	    var sum = 0;
	    var count = 0;
	    data.each(valueDataDim, function (val, idx) {
	      if (!isNaN(val)) {
	        sum += val;
	        count++;
	      }
	    }, true);
	    return sum / count;
	  } else {
	    return data.getDataExtent(valueDataDim, true)[type === 'max' ? 1 : 0];
	  }
	}
	
	exports.dataTransform = dataTransform;
	exports.getAxisInfo = getAxisInfo;
	exports.dataFilter = dataFilter;
	exports.dimValueGetter = dimValueGetter;
	exports.numCalculate = numCalculate;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(1);
	
	var BoundingRect = __webpack_require__(13);
	
	var _layout = __webpack_require__(7);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var axisHelper = __webpack_require__(21);
	
	var Cartesian2D = __webpack_require__(549);
	
	var Axis2D = __webpack_require__(547);
	
	var CoordinateSystem = __webpack_require__(26);
	
	__webpack_require__(550);
	
	/**
	 * Grid is a region which contains at most 4 cartesian systems
	 *
	 * TODO Default cartesian
	 */
	// Depends on GridModel, AxisModel, which performs preprocess.
	var each = zrUtil.each;
	var ifAxisCrossZero = axisHelper.ifAxisCrossZero;
	var niceScaleExtent = axisHelper.niceScaleExtent;
	/**
	 * Check if the axis is used in the specified grid
	 * @inner
	 */
	
	function isAxisUsedInTheGrid(axisModel, gridModel, ecModel) {
	  return axisModel.getCoordSysModel() === gridModel;
	}
	
	function rotateTextRect(textRect, rotate) {
	  var rotateRadians = rotate * Math.PI / 180;
	  var boundingBox = textRect.plain();
	  var beforeWidth = boundingBox.width;
	  var beforeHeight = boundingBox.height;
	  var afterWidth = beforeWidth * Math.cos(rotateRadians) + beforeHeight * Math.sin(rotateRadians);
	  var afterHeight = beforeWidth * Math.sin(rotateRadians) + beforeHeight * Math.cos(rotateRadians);
	  var rotatedRect = new BoundingRect(boundingBox.x, boundingBox.y, afterWidth, afterHeight);
	  return rotatedRect;
	}
	
	function getLabelUnionRect(axis) {
	  var axisModel = axis.model;
	  var labels = axisModel.getFormattedLabels();
	  var axisLabelModel = axisModel.getModel('axisLabel');
	  var rect;
	  var step = 1;
	  var labelCount = labels.length;
	
	  if (labelCount > 40) {
	    // Simple optimization for large amount of labels
	    step = Math.ceil(labelCount / 40);
	  }
	
	  for (var i = 0; i < labelCount; i += step) {
	    if (!axis.isLabelIgnored(i)) {
	      var unrotatedSingleRect = axisLabelModel.getTextRect(labels[i]);
	      var singleRect = rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
	      rect ? rect.union(singleRect) : rect = singleRect;
	    }
	  }
	
	  return rect;
	}
	
	function Grid(gridModel, ecModel, api) {
	  /**
	   * @type {Object.<string, module:echarts/coord/cartesian/Cartesian2D>}
	   * @private
	   */
	  this._coordsMap = {};
	  /**
	   * @type {Array.<module:echarts/coord/cartesian/Cartesian>}
	   * @private
	   */
	
	  this._coordsList = [];
	  /**
	   * @type {Object.<string, module:echarts/coord/cartesian/Axis2D>}
	   * @private
	   */
	
	  this._axesMap = {};
	  /**
	   * @type {Array.<module:echarts/coord/cartesian/Axis2D>}
	   * @private
	   */
	
	  this._axesList = [];
	
	  this._initCartesian(gridModel, ecModel, api);
	
	  this.model = gridModel;
	}
	
	var gridProto = Grid.prototype;
	gridProto.type = 'grid';
	gridProto.axisPointerEnabled = true;
	
	gridProto.getRect = function () {
	  return this._rect;
	};
	
	gridProto.update = function (ecModel, api) {
	  var axesMap = this._axesMap;
	
	  this._updateScale(ecModel, this.model);
	
	  each(axesMap.x, function (xAxis) {
	    niceScaleExtent(xAxis.scale, xAxis.model);
	  });
	  each(axesMap.y, function (yAxis) {
	    niceScaleExtent(yAxis.scale, yAxis.model);
	  });
	  each(axesMap.x, function (xAxis) {
	    fixAxisOnZero(axesMap, 'y', xAxis);
	  });
	  each(axesMap.y, function (yAxis) {
	    fixAxisOnZero(axesMap, 'x', yAxis);
	  }); // Resize again if containLabel is enabled
	  // FIXME It may cause getting wrong grid size in data processing stage
	
	  this.resize(this.model, api);
	};
	
	function fixAxisOnZero(axesMap, otherAxisDim, axis) {
	  // onZero can not be enabled in these two situations:
	  // 1. When any other axis is a category axis.
	  // 2. When no axis is cross 0 point.
	  var axes = axesMap[otherAxisDim];
	
	  if (!axis.onZero) {
	    return;
	  }
	
	  var onZeroAxisIndex = axis.onZeroAxisIndex; // If target axis is specified.
	
	  if (onZeroAxisIndex != null) {
	    var otherAxis = axes[onZeroAxisIndex];
	
	    if (otherAxis && canNotOnZeroToAxis(otherAxis)) {
	      axis.onZero = false;
	    }
	
	    return;
	  }
	
	  for (var idx in axes) {
	    if (axes.hasOwnProperty(idx)) {
	      var otherAxis = axes[idx];
	
	      if (otherAxis && !canNotOnZeroToAxis(otherAxis)) {
	        onZeroAxisIndex = +idx;
	        break;
	      }
	    }
	  }
	
	  if (onZeroAxisIndex == null) {
	    axis.onZero = false;
	  }
	
	  axis.onZeroAxisIndex = onZeroAxisIndex;
	}
	
	function canNotOnZeroToAxis(axis) {
	  return axis.type === 'category' || axis.type === 'time' || !ifAxisCrossZero(axis);
	}
	/**
	 * Resize the grid
	 * @param {module:echarts/coord/cartesian/GridModel} gridModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	gridProto.resize = function (gridModel, api, ignoreContainLabel) {
	  var gridRect = getLayoutRect(gridModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	  this._rect = gridRect;
	  var axesList = this._axesList;
	  adjustAxes(); // Minus label size
	
	  if (!ignoreContainLabel && gridModel.get('containLabel')) {
	    each(axesList, function (axis) {
	      if (!axis.model.get('axisLabel.inside')) {
	        var labelUnionRect = getLabelUnionRect(axis);
	
	        if (labelUnionRect) {
	          var dim = axis.isHorizontal() ? 'height' : 'width';
	          var margin = axis.model.get('axisLabel.margin');
	          gridRect[dim] -= labelUnionRect[dim] + margin;
	
	          if (axis.position === 'top') {
	            gridRect.y += labelUnionRect.height + margin;
	          } else if (axis.position === 'left') {
	            gridRect.x += labelUnionRect.width + margin;
	          }
	        }
	      }
	    });
	    adjustAxes();
	  }
	
	  function adjustAxes() {
	    each(axesList, function (axis) {
	      var isHorizontal = axis.isHorizontal();
	      var extent = isHorizontal ? [0, gridRect.width] : [0, gridRect.height];
	      var idx = axis.inverse ? 1 : 0;
	      axis.setExtent(extent[idx], extent[1 - idx]);
	      updateAxisTransfrom(axis, isHorizontal ? gridRect.x : gridRect.y);
	    });
	  }
	};
	/**
	 * @param {string} axisType
	 * @param {number} [axisIndex]
	 */
	
	
	gridProto.getAxis = function (axisType, axisIndex) {
	  var axesMapOnDim = this._axesMap[axisType];
	
	  if (axesMapOnDim != null) {
	    if (axisIndex == null) {
	      // Find first axis
	      for (var name in axesMapOnDim) {
	        if (axesMapOnDim.hasOwnProperty(name)) {
	          return axesMapOnDim[name];
	        }
	      }
	    }
	
	    return axesMapOnDim[axisIndex];
	  }
	};
	/**
	 * @return {Array.<module:echarts/coord/Axis>}
	 */
	
	
	gridProto.getAxes = function () {
	  return this._axesList.slice();
	};
	/**
	 * Usage:
	 *      grid.getCartesian(xAxisIndex, yAxisIndex);
	 *      grid.getCartesian(xAxisIndex);
	 *      grid.getCartesian(null, yAxisIndex);
	 *      grid.getCartesian({xAxisIndex: ..., yAxisIndex: ...});
	 *
	 * @param {number|Object} [xAxisIndex]
	 * @param {number} [yAxisIndex]
	 */
	
	
	gridProto.getCartesian = function (xAxisIndex, yAxisIndex) {
	  if (xAxisIndex != null && yAxisIndex != null) {
	    var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
	    return this._coordsMap[key];
	  }
	
	  if (zrUtil.isObject(xAxisIndex)) {
	    yAxisIndex = xAxisIndex.yAxisIndex;
	    xAxisIndex = xAxisIndex.xAxisIndex;
	  } // When only xAxisIndex or yAxisIndex given, find its first cartesian.
	
	
	  for (var i = 0, coordList = this._coordsList; i < coordList.length; i++) {
	    if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) {
	      return coordList[i];
	    }
	  }
	};
	
	gridProto.getCartesians = function () {
	  return this._coordsList.slice();
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.convertToPixel = function (ecModel, finder, value) {
	  var target = this._findConvertTarget(ecModel, finder);
	
	  return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.convertFromPixel = function (ecModel, finder, value) {
	  var target = this._findConvertTarget(ecModel, finder);
	
	  return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
	};
	/**
	 * @inner
	 */
	
	
	gridProto._findConvertTarget = function (ecModel, finder) {
	  var seriesModel = finder.seriesModel;
	  var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis')[0];
	  var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis')[0];
	  var gridModel = finder.gridModel;
	  var coordsList = this._coordsList;
	  var cartesian;
	  var axis;
	
	  if (seriesModel) {
	    cartesian = seriesModel.coordinateSystem;
	    zrUtil.indexOf(coordsList, cartesian) < 0 && (cartesian = null);
	  } else if (xAxisModel && yAxisModel) {
	    cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	  } else if (xAxisModel) {
	    axis = this.getAxis('x', xAxisModel.componentIndex);
	  } else if (yAxisModel) {
	    axis = this.getAxis('y', yAxisModel.componentIndex);
	  } // Lowest priority.
	  else if (gridModel) {
	      var grid = gridModel.coordinateSystem;
	
	      if (grid === this) {
	        cartesian = this._coordsList[0];
	      }
	    }
	
	  return {
	    cartesian: cartesian,
	    axis: axis
	  };
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.containPoint = function (point) {
	  var coord = this._coordsList[0];
	
	  if (coord) {
	    return coord.containPoint(point);
	  }
	};
	/**
	 * Initialize cartesian coordinate systems
	 * @private
	 */
	
	
	gridProto._initCartesian = function (gridModel, ecModel, api) {
	  var axisPositionUsed = {
	    left: false,
	    right: false,
	    top: false,
	    bottom: false
	  };
	  var axesMap = {
	    x: {},
	    y: {}
	  };
	  var axesCount = {
	    x: 0,
	    y: 0
	  }; /// Create axis
	
	  ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
	  ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
	
	  if (!axesCount.x || !axesCount.y) {
	    // Roll back when there no either x or y axis
	    this._axesMap = {};
	    this._axesList = [];
	    return;
	  }
	
	  this._axesMap = axesMap; /// Create cartesian2d
	
	  each(axesMap.x, function (xAxis, xAxisIndex) {
	    each(axesMap.y, function (yAxis, yAxisIndex) {
	      var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
	      var cartesian = new Cartesian2D(key);
	      cartesian.grid = this;
	      cartesian.model = gridModel;
	      this._coordsMap[key] = cartesian;
	
	      this._coordsList.push(cartesian);
	
	      cartesian.addAxis(xAxis);
	      cartesian.addAxis(yAxis);
	    }, this);
	  }, this);
	
	  function createAxisCreator(axisType) {
	    return function (axisModel, idx) {
	      if (!isAxisUsedInTheGrid(axisModel, gridModel, ecModel)) {
	        return;
	      }
	
	      var axisPosition = axisModel.get('position');
	
	      if (axisType === 'x') {
	        // Fix position
	        if (axisPosition !== 'top' && axisPosition !== 'bottom') {
	          // Default bottom of X
	          axisPosition = 'bottom';
	
	          if (axisPositionUsed[axisPosition]) {
	            axisPosition = axisPosition === 'top' ? 'bottom' : 'top';
	          }
	        }
	      } else {
	        // Fix position
	        if (axisPosition !== 'left' && axisPosition !== 'right') {
	          // Default left of Y
	          axisPosition = 'left';
	
	          if (axisPositionUsed[axisPosition]) {
	            axisPosition = axisPosition === 'left' ? 'right' : 'left';
	          }
	        }
	      }
	
	      axisPositionUsed[axisPosition] = true;
	      var axis = new Axis2D(axisType, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisPosition);
	      var isCategory = axis.type === 'category';
	      axis.onBand = isCategory && axisModel.get('boundaryGap');
	      axis.inverse = axisModel.get('inverse');
	      axis.onZero = axisModel.get('axisLine.onZero');
	      axis.onZeroAxisIndex = axisModel.get('axisLine.onZeroAxisIndex'); // Inject axis into axisModel
	
	      axisModel.axis = axis; // Inject axisModel into axis
	
	      axis.model = axisModel; // Inject grid info axis
	
	      axis.grid = this; // Index of axis, can be used as key
	
	      axis.index = idx;
	
	      this._axesList.push(axis);
	
	      axesMap[axisType][idx] = axis;
	      axesCount[axisType]++;
	    };
	  }
	};
	/**
	 * Update cartesian properties from series
	 * @param  {module:echarts/model/Option} option
	 * @private
	 */
	
	
	gridProto._updateScale = function (ecModel, gridModel) {
	  // Reset scale
	  zrUtil.each(this._axesList, function (axis) {
	    axis.scale.setExtent(Infinity, -Infinity);
	  });
	  ecModel.eachSeries(function (seriesModel) {
	    if (isCartesian2D(seriesModel)) {
	      var axesModels = findAxesModels(seriesModel, ecModel);
	      var xAxisModel = axesModels[0];
	      var yAxisModel = axesModels[1];
	
	      if (!isAxisUsedInTheGrid(xAxisModel, gridModel, ecModel) || !isAxisUsedInTheGrid(yAxisModel, gridModel, ecModel)) {
	        return;
	      }
	
	      var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	      var data = seriesModel.getData();
	      var xAxis = cartesian.getAxis('x');
	      var yAxis = cartesian.getAxis('y');
	
	      if (data.type === 'list') {
	        unionExtent(data, xAxis, seriesModel);
	        unionExtent(data, yAxis, seriesModel);
	      }
	    }
	  }, this);
	
	  function unionExtent(data, axis, seriesModel) {
	    each(seriesModel.coordDimToDataDim(axis.dim), function (dim) {
	      axis.scale.unionExtentFromData(data, dim);
	    });
	  }
	};
	/**
	 * @param {string} [dim] 'x' or 'y' or 'auto' or null/undefined
	 * @return {Object} {baseAxes: [], otherAxes: []}
	 */
	
	
	gridProto.getTooltipAxes = function (dim) {
	  var baseAxes = [];
	  var otherAxes = [];
	  each(this.getCartesians(), function (cartesian) {
	    var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
	    var otherAxis = cartesian.getOtherAxis(baseAxis);
	    zrUtil.indexOf(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
	    zrUtil.indexOf(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
	  });
	  return {
	    baseAxes: baseAxes,
	    otherAxes: otherAxes
	  };
	};
	/**
	 * @inner
	 */
	
	
	function updateAxisTransfrom(axis, coordBase) {
	  var axisExtent = axis.getExtent();
	  var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform
	
	  axis.toGlobalCoord = axis.dim === 'x' ? function (coord) {
	    return coord + coordBase;
	  } : function (coord) {
	    return axisExtentSum - coord + coordBase;
	  };
	  axis.toLocalCoord = axis.dim === 'x' ? function (coord) {
	    return coord - coordBase;
	  } : function (coord) {
	    return axisExtentSum - coord + coordBase;
	  };
	}
	
	var axesTypes = ['xAxis', 'yAxis'];
	/**
	 * @inner
	 */
	
	function findAxesModels(seriesModel, ecModel) {
	  return zrUtil.map(axesTypes, function (axisType) {
	    var axisModel = seriesModel.getReferringComponents(axisType)[0];
	    return axisModel;
	  });
	}
	/**
	 * @inner
	 */
	
	
	function isCartesian2D(seriesModel) {
	  return seriesModel.get('coordinateSystem') === 'cartesian2d';
	}
	
	Grid.create = function (ecModel, api) {
	  var grids = [];
	  ecModel.eachComponent('grid', function (gridModel, idx) {
	    var grid = new Grid(gridModel, ecModel, api);
	    grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
	    // should be performed in create stage.
	
	    grid.resize(gridModel, api, true);
	    gridModel.coordinateSystem = grid;
	    grids.push(grid);
	  }); // Inject the coordinateSystems into seriesModel
	
	  ecModel.eachSeries(function (seriesModel) {
	    if (!isCartesian2D(seriesModel)) {
	      return;
	    }
	
	    var axesModels = findAxesModels(seriesModel, ecModel);
	    var xAxisModel = axesModels[0];
	    var yAxisModel = axesModels[1];
	    var gridModel = xAxisModel.getCoordSysModel();
	    var grid = gridModel.coordinateSystem;
	    seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	  });
	  return grids;
	}; // For deciding which dimensions to use when creating list data
	
	
	Grid.dimensions = Grid.prototype.dimensions = Cartesian2D.prototype.dimensions;
	CoordinateSystem.register('cartesian2d', Grid);
	var _default = Grid;
	module.exports = _default;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(1);
	
	var Polar = __webpack_require__(566);
	
	var _number = __webpack_require__(4);
	
	var parsePercent = _number.parsePercent;
	
	var _axisHelper = __webpack_require__(21);
	
	var createScaleByModel = _axisHelper.createScaleByModel;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	
	var CoordinateSystem = __webpack_require__(26);
	
	__webpack_require__(567);
	
	// TODO Axis scale
	// 依赖 PolarModel 做预处理
	
	/**
	 * Resize method bound to the polar
	 * @param {module:echarts/coord/polar/PolarModel} polarModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function resizePolar(polar, polarModel, api) {
	  var center = polarModel.get('center');
	  var width = api.getWidth();
	  var height = api.getHeight();
	  polar.cx = parsePercent(center[0], width);
	  polar.cy = parsePercent(center[1], height);
	  var radiusAxis = polar.getRadiusAxis();
	  var size = Math.min(width, height) / 2;
	  var radius = parsePercent(polarModel.get('radius'), size);
	  radiusAxis.inverse ? radiusAxis.setExtent(radius, 0) : radiusAxis.setExtent(0, radius);
	}
	/**
	 * Update polar
	 */
	
	
	function updatePolarScale(ecModel, api) {
	  var polar = this;
	  var angleAxis = polar.getAngleAxis();
	  var radiusAxis = polar.getRadiusAxis(); // Reset scale
	
	  angleAxis.scale.setExtent(Infinity, -Infinity);
	  radiusAxis.scale.setExtent(Infinity, -Infinity);
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.coordinateSystem === polar) {
	      var data = seriesModel.getData();
	      radiusAxis.scale.unionExtentFromData(data, 'radius');
	      angleAxis.scale.unionExtentFromData(data, 'angle');
	    }
	  });
	  niceScaleExtent(angleAxis.scale, angleAxis.model);
	  niceScaleExtent(radiusAxis.scale, radiusAxis.model); // Fix extent of category angle axis
	
	  if (angleAxis.type === 'category' && !angleAxis.onBand) {
	    var extent = angleAxis.getExtent();
	    var diff = 360 / angleAxis.scale.count();
	    angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
	    angleAxis.setExtent(extent[0], extent[1]);
	  }
	}
	/**
	 * Set common axis properties
	 * @param {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	 * @param {module:echarts/coord/polar/AxisModel}
	 * @inner
	 */
	
	
	function setAxis(axis, axisModel) {
	  axis.type = axisModel.get('type');
	  axis.scale = createScaleByModel(axisModel);
	  axis.onBand = axisModel.get('boundaryGap') && axis.type === 'category';
	  axis.inverse = axisModel.get('inverse');
	
	  if (axisModel.mainType === 'angleAxis') {
	    axis.inverse ^= axisModel.get('clockwise');
	    var startAngle = axisModel.get('startAngle');
	    axis.setExtent(startAngle, startAngle + (axis.inverse ? -360 : 360));
	  } // Inject axis instance
	
	
	  axisModel.axis = axis;
	  axis.model = axisModel;
	}
	
	var polarCreator = {
	  dimensions: Polar.prototype.dimensions,
	  create: function (ecModel, api) {
	    var polarList = [];
	    ecModel.eachComponent('polar', function (polarModel, idx) {
	      var polar = new Polar(idx); // Inject resize and update method
	
	      polar.update = updatePolarScale;
	      var radiusAxis = polar.getRadiusAxis();
	      var angleAxis = polar.getAngleAxis();
	      var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
	      var angleAxisModel = polarModel.findAxisModel('angleAxis');
	      setAxis(radiusAxis, radiusAxisModel);
	      setAxis(angleAxis, angleAxisModel);
	      resizePolar(polar, polarModel, api);
	      polarList.push(polar);
	      polarModel.coordinateSystem = polar;
	      polar.model = polarModel;
	    }); // Inject coordinateSystem to series
	
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.get('coordinateSystem') === 'polar') {
	        var polarModel = ecModel.queryComponents({
	          mainType: 'polar',
	          index: seriesModel.get('polarIndex'),
	          id: seriesModel.get('polarId')
	        })[0];
	        seriesModel.coordinateSystem = polarModel.coordinateSystem;
	      }
	    });
	    return polarList;
	  }
	};
	CoordinateSystem.register('polar', polarCreator);

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var _number = __webpack_require__(4);
	
	var parsePercent = _number.parsePercent;
	var STACK_PREFIX = '__ec_stack_';
	
	function getSeriesStackId(seriesModel) {
	  return seriesModel.get('stack') || STACK_PREFIX + seriesModel.seriesIndex;
	}
	
	function getAxisKey(axis) {
	  return axis.dim + axis.index;
	}
	/**
	 * @param {Object} opt
	 * @param {module:echarts/coord/Axis} opt.axis Only support category axis currently.
	 * @param {number} opt.count Positive interger.
	 * @param {number} [opt.barWidth]
	 * @param {number} [opt.barMaxWidth]
	 * @param {number} [opt.barGap]
	 * @param {number} [opt.barCategoryGap]
	 * @return {Object} {width, offset, offsetCenter} If axis.type is not 'category', return undefined.
	 */
	
	
	function getLayoutOnAxis(opt, api) {
	  var params = [];
	  var baseAxis = opt.axis;
	  var axisKey = 'axis0';
	
	  if (baseAxis.type !== 'category') {
	    return;
	  }
	
	  var bandWidth = baseAxis.getBandWidth();
	
	  for (var i = 0; i < opt.count || 0; i++) {
	    params.push(zrUtil.defaults({
	      bandWidth: bandWidth,
	      axisKey: axisKey,
	      stackId: STACK_PREFIX + i
	    }, opt));
	  }
	
	  var widthAndOffsets = doCalBarWidthAndOffset(params, api);
	  var result = [];
	
	  for (var i = 0; i < opt.count; i++) {
	    var item = widthAndOffsets[axisKey][STACK_PREFIX + i];
	    item.offsetCenter = item.offset + item.width / 2;
	    result.push(item);
	  }
	
	  return result;
	}
	
	function calBarWidthAndOffset(barSeries, api) {
	  var seriesInfoList = zrUtil.map(barSeries, function (seriesModel) {
	    var data = seriesModel.getData();
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var axisExtent = baseAxis.getExtent();
	    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
	    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
	    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
	    var barGap = seriesModel.get('barGap');
	    var barCategoryGap = seriesModel.get('barCategoryGap');
	    return {
	      bandWidth: bandWidth,
	      barWidth: barWidth,
	      barMaxWidth: barMaxWidth,
	      barGap: barGap,
	      barCategoryGap: barCategoryGap,
	      axisKey: getAxisKey(baseAxis),
	      stackId: getSeriesStackId(seriesModel)
	    };
	  });
	  return doCalBarWidthAndOffset(seriesInfoList, api);
	}
	
	function doCalBarWidthAndOffset(seriesInfoList, api) {
	  // Columns info on each category axis. Key is cartesian name
	  var columnsMap = {};
	  zrUtil.each(seriesInfoList, function (seriesInfo, idx) {
	    var axisKey = seriesInfo.axisKey;
	    var bandWidth = seriesInfo.bandWidth;
	    var columnsOnAxis = columnsMap[axisKey] || {
	      bandWidth: bandWidth,
	      remainedWidth: bandWidth,
	      autoWidthCount: 0,
	      categoryGap: '20%',
	      gap: '30%',
	      stacks: {}
	    };
	    var stacks = columnsOnAxis.stacks;
	    columnsMap[axisKey] = columnsOnAxis;
	    var stackId = seriesInfo.stackId;
	
	    if (!stacks[stackId]) {
	      columnsOnAxis.autoWidthCount++;
	    }
	
	    stacks[stackId] = stacks[stackId] || {
	      width: 0,
	      maxWidth: 0
	    }; // Caution: In a single coordinate system, these barGrid attributes
	    // will be shared by series. Consider that they have default values,
	    // only the attributes set on the last series will work.
	    // Do not change this fact unless there will be a break change.
	    // TODO
	
	    var barWidth = seriesInfo.barWidth;
	
	    if (barWidth && !stacks[stackId].width) {
	      // See #6312, do not restrict width.
	      stacks[stackId].width = barWidth;
	      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
	      columnsOnAxis.remainedWidth -= barWidth;
	    }
	
	    var barMaxWidth = seriesInfo.barMaxWidth;
	    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
	    var barGap = seriesInfo.barGap;
	    barGap != null && (columnsOnAxis.gap = barGap);
	    var barCategoryGap = seriesInfo.barCategoryGap;
	    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
	  });
	  var result = {};
	  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
	    result[coordSysName] = {};
	    var stacks = columnsOnAxis.stacks;
	    var bandWidth = columnsOnAxis.bandWidth;
	    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
	    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
	    var remainedWidth = columnsOnAxis.remainedWidth;
	    var autoWidthCount = columnsOnAxis.autoWidthCount;
	    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
	
	    zrUtil.each(stacks, function (column, stack) {
	      var maxWidth = column.maxWidth;
	
	      if (maxWidth && maxWidth < autoWidth) {
	        maxWidth = Math.min(maxWidth, remainedWidth);
	
	        if (column.width) {
	          maxWidth = Math.min(maxWidth, column.width);
	        }
	
	        remainedWidth -= maxWidth;
	        column.width = maxWidth;
	        autoWidthCount--;
	      }
	    }); // Recalculate width again
	
	    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0);
	    var widthSum = 0;
	    var lastColumn;
	    zrUtil.each(stacks, function (column, idx) {
	      if (!column.width) {
	        column.width = autoWidth;
	      }
	
	      lastColumn = column;
	      widthSum += column.width * (1 + barGapPercent);
	    });
	
	    if (lastColumn) {
	      widthSum -= lastColumn.width * barGapPercent;
	    }
	
	    var offset = -widthSum / 2;
	    zrUtil.each(stacks, function (column, stackId) {
	      result[coordSysName][stackId] = result[coordSysName][stackId] || {
	        offset: offset,
	        width: column.width
	      };
	      offset += column.width * (1 + barGapPercent);
	    });
	  });
	  return result;
	}
	/**
	 * @param {string} seriesType
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	function barLayoutGrid(seriesType, ecModel, api) {
	  var barWidthAndOffset = calBarWidthAndOffset(zrUtil.filter(ecModel.getSeriesByType(seriesType), function (seriesModel) {
	    return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
	  }));
	  var lastStackCoords = {};
	  var lastStackCoordsOrigin = {};
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    // Check series coordinate, do layout for cartesian2d only
	    if (seriesModel.coordinateSystem.type !== 'cartesian2d') {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var stackId = getSeriesStackId(seriesModel);
	    var columnLayoutInfo = barWidthAndOffset[getAxisKey(baseAxis)][stackId];
	    var columnOffset = columnLayoutInfo.offset;
	    var columnWidth = columnLayoutInfo.width;
	    var valueAxis = cartesian.getOtherAxis(baseAxis);
	    var barMinHeight = seriesModel.get('barMinHeight') || 0;
	    var valueAxisStart = baseAxis.onZero ? valueAxis.toGlobalCoord(valueAxis.dataToCoord(0)) : valueAxis.getGlobalExtent()[0];
	    var coordDims = [seriesModel.coordDimToDataDim('x')[0], seriesModel.coordDimToDataDim('y')[0]];
	    var coords = data.mapArray(coordDims, function (x, y) {
	      return cartesian.dataToPoint([x, y]);
	    }, true);
	    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
	    lastStackCoordsOrigin[stackId] = lastStackCoordsOrigin[stackId] || []; // Fix #4243
	
	    data.setLayout({
	      offset: columnOffset,
	      size: columnWidth
	    });
	    data.each(seriesModel.coordDimToDataDim(valueAxis.dim)[0], function (value, idx) {
	      if (isNaN(value)) {
	        return;
	      }
	
	      if (!lastStackCoords[stackId][idx]) {
	        lastStackCoords[stackId][idx] = {
	          p: valueAxisStart,
	          // Positive stack
	          n: valueAxisStart // Negative stack
	
	        };
	        lastStackCoordsOrigin[stackId][idx] = {
	          p: valueAxisStart,
	          // Positive stack
	          n: valueAxisStart // Negative stack
	
	        };
	      }
	
	      var sign = value >= 0 ? 'p' : 'n';
	      var coord = coords[idx];
	      var lastCoord = lastStackCoords[stackId][idx][sign];
	      var lastCoordOrigin = lastStackCoordsOrigin[stackId][idx][sign];
	      var x;
	      var y;
	      var width;
	      var height;
	
	      if (valueAxis.isHorizontal()) {
	        x = lastCoord;
	        y = coord[1] + columnOffset;
	        width = coord[0] - lastCoordOrigin;
	        height = columnWidth;
	        lastStackCoordsOrigin[stackId][idx][sign] += width;
	
	        if (Math.abs(width) < barMinHeight) {
	          width = (width < 0 ? -1 : 1) * barMinHeight;
	        }
	
	        lastStackCoords[stackId][idx][sign] += width;
	      } else {
	        x = coord[0] + columnOffset;
	        y = lastCoord;
	        width = columnWidth;
	        height = coord[1] - lastCoordOrigin;
	        lastStackCoordsOrigin[stackId][idx][sign] += height;
	
	        if (Math.abs(height) < barMinHeight) {
	          // Include zero to has a positive bar
	          height = (height <= 0 ? -1 : 1) * barMinHeight;
	        }
	
	        lastStackCoords[stackId][idx][sign] += height;
	      }
	
	      data.setItemLayout(idx, {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }, true);
	  }, this);
	}
	
	barLayoutGrid.getLayoutOnAxis = getLayoutOnAxis;
	var _default = barLayoutGrid;
	module.exports = _default;

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	function _default(seriesType, ecModel) {
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    var data = seriesModel.getData();
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (!coordSys) {
	      return;
	    }
	
	    var dims = [];
	    var coordDims = coordSys.dimensions;
	
	    for (var i = 0; i < coordDims.length; i++) {
	      dims.push(seriesModel.coordDimToDataDim(coordSys.dimensions[i])[0]);
	    }
	
	    if (dims.length === 1) {
	      data.each(dims[0], function (x, idx) {
	        // Also {Array.<number>}, not undefined to avoid if...else... statement
	        data.setItemLayout(idx, isNaN(x) ? [NaN, NaN] : coordSys.dataToPoint(x));
	      });
	    } else if (dims.length === 2) {
	      data.each(dims, function (x, y, idx) {
	        // Also {Array.<number>}, not undefined to avoid if...else... statement
	        data.setItemLayout(idx, isNaN(x) || isNaN(y) ? [NaN, NaN] : coordSys.dataToPoint([x, y]));
	      }, true);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var _clazz = __webpack_require__(28);
	
	var parseClassType = _clazz.parseClassType;
	var base = 0;
	var DELIMITER = '_';
	/**
	 * @public
	 * @param {string} type
	 * @return {string}
	 */
	
	function getUID(type) {
	  // Considering the case of crossing js context,
	  // use Math.random to make id as unique as possible.
	  return [type || '', base++, Math.random()].join(DELIMITER);
	}
	/**
	 * @inner
	 */
	
	
	function enableSubTypeDefaulter(entity) {
	  var subTypeDefaulters = {};
	
	  entity.registerSubTypeDefaulter = function (componentType, defaulter) {
	    componentType = parseClassType(componentType);
	    subTypeDefaulters[componentType.main] = defaulter;
	  };
	
	  entity.determineSubType = function (componentType, option) {
	    var type = option.type;
	
	    if (!type) {
	      var componentTypeMain = parseClassType(componentType).main;
	
	      if (entity.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) {
	        type = subTypeDefaulters[componentTypeMain](option);
	      }
	    }
	
	    return type;
	  };
	
	  return entity;
	}
	/**
	 * Topological travel on Activity Network (Activity On Vertices).
	 * Dependencies is defined in Model.prototype.dependencies, like ['xAxis', 'yAxis'].
	 *
	 * If 'xAxis' or 'yAxis' is absent in componentTypeList, just ignore it in topology.
	 *
	 * If there is circle dependencey, Error will be thrown.
	 *
	 */
	
	
	function enableTopologicalTravel(entity, dependencyGetter) {
	  /**
	   * @public
	   * @param {Array.<string>} targetNameList Target Component type list.
	   *                                           Can be ['aa', 'bb', 'aa.xx']
	   * @param {Array.<string>} fullNameList By which we can build dependency graph.
	   * @param {Function} callback Params: componentType, dependencies.
	   * @param {Object} context Scope of callback.
	   */
	  entity.topologicalTravel = function (targetNameList, fullNameList, callback, context) {
	    if (!targetNameList.length) {
	      return;
	    }
	
	    var result = makeDepndencyGraph(fullNameList);
	    var graph = result.graph;
	    var stack = result.noEntryList;
	    var targetNameSet = {};
	    zrUtil.each(targetNameList, function (name) {
	      targetNameSet[name] = true;
	    });
	
	    while (stack.length) {
	      var currComponentType = stack.pop();
	      var currVertex = graph[currComponentType];
	      var isInTargetNameSet = !!targetNameSet[currComponentType];
	
	      if (isInTargetNameSet) {
	        callback.call(context, currComponentType, currVertex.originalDeps.slice());
	        delete targetNameSet[currComponentType];
	      }
	
	      zrUtil.each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
	    }
	
	    zrUtil.each(targetNameSet, function () {
	      throw new Error('Circle dependency may exists');
	    });
	
	    function removeEdge(succComponentType) {
	      graph[succComponentType].entryCount--;
	
	      if (graph[succComponentType].entryCount === 0) {
	        stack.push(succComponentType);
	      }
	    } // Consider this case: legend depends on series, and we call
	    // chart.setOption({series: [...]}), where only series is in option.
	    // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
	    // not be called, but only sereis.mergeOption is called. Thus legend
	    // have no chance to update its local record about series (like which
	    // name of series is available in legend).
	
	
	    function removeEdgeAndAdd(succComponentType) {
	      targetNameSet[succComponentType] = true;
	      removeEdge(succComponentType);
	    }
	  };
	  /**
	   * DepndencyGraph: {Object}
	   * key: conponentType,
	   * value: {
	   *     successor: [conponentTypes...],
	   *     originalDeps: [conponentTypes...],
	   *     entryCount: {number}
	   * }
	   */
	
	
	  function makeDepndencyGraph(fullNameList) {
	    var graph = {};
	    var noEntryList = [];
	    zrUtil.each(fullNameList, function (name) {
	      var thisItem = createDependencyGraphItem(graph, name);
	      var originalDeps = thisItem.originalDeps = dependencyGetter(name);
	      var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
	      thisItem.entryCount = availableDeps.length;
	
	      if (thisItem.entryCount === 0) {
	        noEntryList.push(name);
	      }
	
	      zrUtil.each(availableDeps, function (dependentName) {
	        if (zrUtil.indexOf(thisItem.predecessor, dependentName) < 0) {
	          thisItem.predecessor.push(dependentName);
	        }
	
	        var thatItem = createDependencyGraphItem(graph, dependentName);
	
	        if (zrUtil.indexOf(thatItem.successor, dependentName) < 0) {
	          thatItem.successor.push(name);
	        }
	      });
	    });
	    return {
	      graph: graph,
	      noEntryList: noEntryList
	    };
	  }
	
	  function createDependencyGraphItem(graph, name) {
	    if (!graph[name]) {
	      graph[name] = {
	        predecessor: [],
	        successor: []
	      };
	    }
	
	    return graph[name];
	  }
	
	  function getAvailableDependencies(originalDeps, fullNameList) {
	    var availableDeps = [];
	    zrUtil.each(originalDeps, function (dep) {
	      zrUtil.indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
	    });
	    return availableDeps;
	  }
	}
	
	exports.getUID = getUID;
	exports.enableSubTypeDefaulter = enableSubTypeDefaulter;
	exports.enableTopologicalTravel = enableTopologicalTravel;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var Group = __webpack_require__(97);
	
	var componentUtil = __webpack_require__(130);
	
	var clazzUtil = __webpack_require__(28);
	
	var Component = function () {
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	  this.group = new Group();
	  /**
	   * @type {string}
	   * @readOnly
	   */
	
	  this.uid = componentUtil.getUID('viewComponent');
	};
	
	Component.prototype = {
	  constructor: Component,
	  init: function (ecModel, api) {},
	  render: function (componentModel, ecModel, api, payload) {},
	  dispose: function () {}
	};
	var componentProto = Component.prototype;
	
	componentProto.updateView = componentProto.updateLayout = componentProto.updateVisual = function (seriesModel, ecModel, api, payload) {// Do nothing;
	}; // Enable Component.extend.
	
	
	clazzUtil.enableClassExtend(Component); // Enable capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	clazzUtil.enableClassManagement(Component, {
	  registerWhenExtend: true
	});
	var _default = Component;
	module.exports = _default;

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	// Pick color from palette for each data item.
	// Applicable for charts that require applying color palette
	// in data level (like pie, funnel, chord).
	function _default(seriesType, ecModel) {
	  // Pie and funnel may use diferrent scope
	  var paletteScope = {};
	  ecModel.eachRawSeriesByType(seriesType, function (seriesModel) {
	    var dataAll = seriesModel.getRawData();
	    var idxMap = {};
	
	    if (!ecModel.isSeriesFiltered(seriesModel)) {
	      var data = seriesModel.getData();
	      data.each(function (idx) {
	        var rawIdx = data.getRawIndex(idx);
	        idxMap[rawIdx] = idx;
	      });
	      dataAll.each(function (rawIdx) {
	        var filteredIdx = idxMap[rawIdx]; // If series.itemStyle.normal.color is a function. itemVisual may be encoded
	
	        var singleDataColor = filteredIdx != null && data.getItemVisual(filteredIdx, 'color', true);
	
	        if (!singleDataColor) {
	          // FIXME Performance
	          var itemModel = dataAll.getItemModel(rawIdx);
	          var color = itemModel.get('itemStyle.normal.color') || seriesModel.getColorFromPalette(dataAll.getName(rawIdx), paletteScope); // Legend may use the visual info in data before processed
	
	          dataAll.setItemVisual(rawIdx, 'color', color); // Data is not filtered
	
	          if (filteredIdx != null) {
	            data.setItemVisual(filteredIdx, 'color', color);
	          }
	        } else {
	          // Set data all color for legend
	          dataAll.setItemVisual(rawIdx, 'color', singleDataColor);
	        }
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * EvEmitter v1.1.0
	 * Lil' event emitter
	 * MIT License
	 */
	
	/* jshint unused: true, undef: true, strict: true */
	
	( function( global, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, window */
	  if ( true ) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory();
	  } else {
	    // Browser globals
	    global.EvEmitter = factory();
	  }
	
	}( typeof window != 'undefined' ? window : this, function() {
	
	"use strict";
	
	function EvEmitter() {}
	
	var proto = EvEmitter.prototype;
	
	proto.on = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // set events hash
	  var events = this._events = this._events || {};
	  // set listeners array
	  var listeners = events[ eventName ] = events[ eventName ] || [];
	  // only add once
	  if ( listeners.indexOf( listener ) == -1 ) {
	    listeners.push( listener );
	  }
	
	  return this;
	};
	
	proto.once = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // add event
	  this.on( eventName, listener );
	  // set once flag
	  // set onceEvents hash
	  var onceEvents = this._onceEvents = this._onceEvents || {};
	  // set onceListeners object
	  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
	  // set flag
	  onceListeners[ listener ] = true;
	
	  return this;
	};
	
	proto.off = function( eventName, listener ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  var index = listeners.indexOf( listener );
	  if ( index != -1 ) {
	    listeners.splice( index, 1 );
	  }
	
	  return this;
	};
	
	proto.emitEvent = function( eventName, args ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  // copy over to avoid interference if .off() in listener
	  listeners = listeners.slice(0);
	  args = args || [];
	  // once stuff
	  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];
	
	  for ( var i=0; i < listeners.length; i++ ) {
	    var listener = listeners[i]
	    var isOnce = onceListeners && onceListeners[ listener ];
	    if ( isOnce ) {
	      // remove listener
	      // remove before trigger to prevent recursion
	      this.off( eventName, listener );
	      // unset once flag
	      delete onceListeners[ listener ];
	    }
	    // trigger listener
	    listener.apply( this, args );
	  }
	
	  return this;
	};
	
	proto.allOff = function() {
	  delete this._events;
	  delete this._onceEvents;
	};
	
	return EvEmitter;
	
	}));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Unipointer v2.4.0
	 * base class for doing one thing with pointer event
	 * MIT license
	 */
	
	/*jshint browser: true, undef: true, unused: true, strict: true */
	
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /*global define, module, require */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(133)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter ) {
	      return factory( window, EvEmitter );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('ev-emitter')
	    );
	  } else {
	    // browser global
	    window.Unipointer = factory(
	      window,
	      window.EvEmitter
	    );
	  }
	
	}( window, function factory( window, EvEmitter ) {
	
	'use strict';
	
	function noop() {}
	
	function Unipointer() {}
	
	// inherit EvEmitter
	var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );
	
	proto.bindStartEvent = function( elem ) {
	  this._bindStartEvent( elem, true );
	};
	
	proto.unbindStartEvent = function( elem ) {
	  this._bindStartEvent( elem, false );
	};
	
	/**
	 * Add or remove start event
	 * @param {Boolean} isAdd - remove if falsey
	 */
	proto._bindStartEvent = function( elem, isAdd ) {
	  // munge isAdd, default to true
	  isAdd = isAdd === undefined ? true : isAdd;
	  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
	
	  // default to mouse events
	  var startEvent = 'mousedown';
	  if ( 'ontouchstart' in window ) {
	    // HACK prefer Touch Events as you can preventDefault on touchstart to
	    // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
	    startEvent = 'touchstart';
	  } else if ( window.PointerEvent ) {
	    // Pointer Events
	    startEvent = 'pointerdown';
	  }
	  elem[ bindMethod ]( startEvent, this );
	};
	
	// trigger handler methods for events
	proto.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	// returns the touch that we're keeping track of
	proto.getTouch = function( touches ) {
	  for ( var i=0; i < touches.length; i++ ) {
	    var touch = touches[i];
	    if ( touch.identifier == this.pointerIdentifier ) {
	      return touch;
	    }
	  }
	};
	
	// ----- start event ----- //
	
	proto.onmousedown = function( event ) {
	  // dismiss clicks from right or middle buttons
	  var button = event.button;
	  if ( button && ( button !== 0 && button !== 1 ) ) {
	    return;
	  }
	  this._pointerDown( event, event );
	};
	
	proto.ontouchstart = function( event ) {
	  this._pointerDown( event, event.changedTouches[0] );
	};
	
	proto.onpointerdown = function( event ) {
	  this._pointerDown( event, event );
	};
	
	/**
	 * pointer start
	 * @param {Event} event
	 * @param {Event or Touch} pointer
	 */
	proto._pointerDown = function( event, pointer ) {
	  // dismiss right click and other pointers
	  // button = 0 is okay, 1-4 not
	  if ( event.button || this.isPointerDown ) {
	    return;
	  }
	
	  this.isPointerDown = true;
	  // save pointer identifier to match up touch events
	  this.pointerIdentifier = pointer.pointerId !== undefined ?
	    // pointerId for pointer events, touch.indentifier for touch events
	    pointer.pointerId : pointer.identifier;
	
	  this.pointerDown( event, pointer );
	};
	
	proto.pointerDown = function( event, pointer ) {
	  this._bindPostStartEvents( event );
	  this.emitEvent( 'pointerDown', [ event, pointer ] );
	};
	
	// hash of events to be bound after start event
	var postStartEvents = {
	  mousedown: [ 'mousemove', 'mouseup' ],
	  touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
	  pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
	};
	
	proto._bindPostStartEvents = function( event ) {
	  if ( !event ) {
	    return;
	  }
	  // get proper events to match start event
	  var events = postStartEvents[ event.type ];
	  // bind events to node
	  events.forEach( function( eventName ) {
	    window.addEventListener( eventName, this );
	  }, this );
	  // save these arguments
	  this._boundPointerEvents = events;
	};
	
	proto._unbindPostStartEvents = function() {
	  // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
	  if ( !this._boundPointerEvents ) {
	    return;
	  }
	  this._boundPointerEvents.forEach( function( eventName ) {
	    window.removeEventListener( eventName, this );
	  }, this );
	
	  delete this._boundPointerEvents;
	};
	
	// ----- move event ----- //
	
	proto.onmousemove = function( event ) {
	  this._pointerMove( event, event );
	};
	
	proto.onpointermove = function( event ) {
	  if ( event.pointerId == this.pointerIdentifier ) {
	    this._pointerMove( event, event );
	  }
	};
	
	proto.ontouchmove = function( event ) {
	  var touch = this.getTouch( event.changedTouches );
	  if ( touch ) {
	    this._pointerMove( event, touch );
	  }
	};
	
	/**
	 * pointer move
	 * @param {Event} event
	 * @param {Event or Touch} pointer
	 * @private
	 */
	proto._pointerMove = function( event, pointer ) {
	  this.pointerMove( event, pointer );
	};
	
	// public
	proto.pointerMove = function( event, pointer ) {
	  this.emitEvent( 'pointerMove', [ event, pointer ] );
	};
	
	// ----- end event ----- //
	
	
	proto.onmouseup = function( event ) {
	  this._pointerUp( event, event );
	};
	
	proto.onpointerup = function( event ) {
	  if ( event.pointerId == this.pointerIdentifier ) {
	    this._pointerUp( event, event );
	  }
	};
	
	proto.ontouchend = function( event ) {
	  var touch = this.getTouch( event.changedTouches );
	  if ( touch ) {
	    this._pointerUp( event, touch );
	  }
	};
	
	/**
	 * pointer up
	 * @param {Event} event
	 * @param {Event or Touch} pointer
	 * @private
	 */
	proto._pointerUp = function( event, pointer ) {
	  this._pointerDone();
	  this.pointerUp( event, pointer );
	};
	
	// public
	proto.pointerUp = function( event, pointer ) {
	  this.emitEvent( 'pointerUp', [ event, pointer ] );
	};
	
	// ----- pointer done ----- //
	
	// triggered on pointer up & pointer cancel
	proto._pointerDone = function() {
	  this._pointerReset();
	  this._unbindPostStartEvents();
	  this.pointerDone();
	};
	
	proto._pointerReset = function() {
	  // reset properties
	  this.isPointerDown = false;
	  delete this.pointerIdentifier;
	};
	
	proto.pointerDone = noop;
	
	// ----- pointer cancel ----- //
	
	proto.onpointercancel = function( event ) {
	  if ( event.pointerId == this.pointerIdentifier ) {
	    this._pointerCancel( event, event );
	  }
	};
	
	proto.ontouchcancel = function( event ) {
	  var touch = this.getTouch( event.changedTouches );
	  if ( touch ) {
	    this._pointerCancel( event, touch );
	  }
	};
	
	/**
	 * pointer cancel
	 * @param {Event} event
	 * @param {Event or Touch} pointer
	 * @private
	 */
	proto._pointerCancel = function( event, pointer ) {
	  this._pointerDone();
	  this.pointerCancel( event, pointer );
	};
	
	// public
	proto.pointerCancel = function( event, pointer ) {
	  this.emitEvent( 'pointerCancel', [ event, pointer ] );
	};
	
	// -----  ----- //
	
	// utility function for getting x/y coords from event
	Unipointer.getPointerPoint = function( pointer ) {
	  return {
	    x: pointer.pageX,
	    y: pointer.pageY
	  };
	};
	
	// -----  ----- //
	
	return Unipointer;
	
	}));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(730)
	__vue_script__ = __webpack_require__(238)
	__vue_template__ = __webpack_require__(674)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var vec2 = __webpack_require__(8);
	
	var curve = __webpack_require__(40);
	
	/**
	 * @author Yi Shen(https://github.com/pissang)
	 */
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI2 = Math.PI * 2;
	var start = vec2.create();
	var end = vec2.create();
	var extremity = vec2.create();
	/**
	 * 从顶点数组中计算出最小包围盒，写入`min`和`max`中
	 * @module zrender/core/bbox
	 * @param {Array<Object>} points 顶点数组
	 * @param {number} min
	 * @param {number} max
	 */
	
	function fromPoints(points, min, max) {
	  if (points.length === 0) {
	    return;
	  }
	
	  var p = points[0];
	  var left = p[0];
	  var right = p[0];
	  var top = p[1];
	  var bottom = p[1];
	  var i;
	
	  for (i = 1; i < points.length; i++) {
	    p = points[i];
	    left = mathMin(left, p[0]);
	    right = mathMax(right, p[0]);
	    top = mathMin(top, p[1]);
	    bottom = mathMax(bottom, p[1]);
	  }
	
	  min[0] = left;
	  min[1] = top;
	  max[0] = right;
	  max[1] = bottom;
	}
	/**
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromLine(x0, y0, x1, y1, min, max) {
	  min[0] = mathMin(x0, x1);
	  min[1] = mathMin(y0, y1);
	  max[0] = mathMax(x0, x1);
	  max[1] = mathMax(y0, y1);
	}
	
	var xDim = [];
	var yDim = [];
	/**
	 * 从三阶贝塞尔曲线(p0, p1, p2, p3)中计算出最小包围盒，写入`min`和`max`中
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x3
	 * @param {number} y3
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	function fromCubic(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
	  var cubicExtrema = curve.cubicExtrema;
	  var cubicAt = curve.cubicAt;
	  var i;
	  var n = cubicExtrema(x0, x1, x2, x3, xDim);
	  min[0] = Infinity;
	  min[1] = Infinity;
	  max[0] = -Infinity;
	  max[1] = -Infinity;
	
	  for (i = 0; i < n; i++) {
	    var x = cubicAt(x0, x1, x2, x3, xDim[i]);
	    min[0] = mathMin(x, min[0]);
	    max[0] = mathMax(x, max[0]);
	  }
	
	  n = cubicExtrema(y0, y1, y2, y3, yDim);
	
	  for (i = 0; i < n; i++) {
	    var y = cubicAt(y0, y1, y2, y3, yDim[i]);
	    min[1] = mathMin(y, min[1]);
	    max[1] = mathMax(y, max[1]);
	  }
	
	  min[0] = mathMin(x0, min[0]);
	  max[0] = mathMax(x0, max[0]);
	  min[0] = mathMin(x3, min[0]);
	  max[0] = mathMax(x3, max[0]);
	  min[1] = mathMin(y0, min[1]);
	  max[1] = mathMax(y0, max[1]);
	  min[1] = mathMin(y3, min[1]);
	  max[1] = mathMax(y3, max[1]);
	}
	/**
	 * 从二阶贝塞尔曲线(p0, p1, p2)中计算出最小包围盒，写入`min`和`max`中
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromQuadratic(x0, y0, x1, y1, x2, y2, min, max) {
	  var quadraticExtremum = curve.quadraticExtremum;
	  var quadraticAt = curve.quadraticAt; // Find extremities, where derivative in x dim or y dim is zero
	
	  var tx = mathMax(mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
	  var ty = mathMax(mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
	  var x = quadraticAt(x0, x1, x2, tx);
	  var y = quadraticAt(y0, y1, y2, ty);
	  min[0] = mathMin(x0, x2, x);
	  min[1] = mathMin(y0, y2, y);
	  max[0] = mathMax(x0, x2, x);
	  max[1] = mathMax(y0, y2, y);
	}
	/**
	 * 从圆弧中计算出最小包围盒，写入`min`和`max`中
	 * @method
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x
	 * @param {number} y
	 * @param {number} rx
	 * @param {number} ry
	 * @param {number} startAngle
	 * @param {number} endAngle
	 * @param {number} anticlockwise
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromArc(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
	  var vec2Min = vec2.min;
	  var vec2Max = vec2.max;
	  var diff = Math.abs(startAngle - endAngle);
	
	  if (diff % PI2 < 1e-4 && diff > 1e-4) {
	    // Is a circle
	    min[0] = x - rx;
	    min[1] = y - ry;
	    max[0] = x + rx;
	    max[1] = y + ry;
	    return;
	  }
	
	  start[0] = mathCos(startAngle) * rx + x;
	  start[1] = mathSin(startAngle) * ry + y;
	  end[0] = mathCos(endAngle) * rx + x;
	  end[1] = mathSin(endAngle) * ry + y;
	  vec2Min(min, start, end);
	  vec2Max(max, start, end); // Thresh to [0, Math.PI * 2]
	
	  startAngle = startAngle % PI2;
	
	  if (startAngle < 0) {
	    startAngle = startAngle + PI2;
	  }
	
	  endAngle = endAngle % PI2;
	
	  if (endAngle < 0) {
	    endAngle = endAngle + PI2;
	  }
	
	  if (startAngle > endAngle && !anticlockwise) {
	    endAngle += PI2;
	  } else if (startAngle < endAngle && anticlockwise) {
	    startAngle += PI2;
	  }
	
	  if (anticlockwise) {
	    var tmp = endAngle;
	    endAngle = startAngle;
	    startAngle = tmp;
	  } // var number = 0;
	  // var step = (anticlockwise ? -Math.PI : Math.PI) / 2;
	
	
	  for (var angle = 0; angle < endAngle; angle += Math.PI / 2) {
	    if (angle > startAngle) {
	      extremity[0] = mathCos(angle) * rx + x;
	      extremity[1] = mathSin(angle) * ry + y;
	      vec2Min(min, extremity, min);
	      vec2Max(max, extremity, max);
	    }
	  }
	}
	
	exports.fromPoints = fromPoints;
	exports.fromLine = fromLine;
	exports.fromCubic = fromCubic;
	exports.fromQuadratic = fromQuadratic;
	exports.fromArc = fromArc;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	// https://github.com/mziccard/node-timsort
	var DEFAULT_MIN_MERGE = 32;
	var DEFAULT_MIN_GALLOPING = 7;
	var DEFAULT_TMP_STORAGE_LENGTH = 256;
	
	function minRunLength(n) {
	  var r = 0;
	
	  while (n >= DEFAULT_MIN_MERGE) {
	    r |= n & 1;
	    n >>= 1;
	  }
	
	  return n + r;
	}
	
	function makeAscendingRun(array, lo, hi, compare) {
	  var runHi = lo + 1;
	
	  if (runHi === hi) {
	    return 1;
	  }
	
	  if (compare(array[runHi++], array[lo]) < 0) {
	    while (runHi < hi && compare(array[runHi], array[runHi - 1]) < 0) {
	      runHi++;
	    }
	
	    reverseRun(array, lo, runHi);
	  } else {
	    while (runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0) {
	      runHi++;
	    }
	  }
	
	  return runHi - lo;
	}
	
	function reverseRun(array, lo, hi) {
	  hi--;
	
	  while (lo < hi) {
	    var t = array[lo];
	    array[lo++] = array[hi];
	    array[hi--] = t;
	  }
	}
	
	function binaryInsertionSort(array, lo, hi, start, compare) {
	  if (start === lo) {
	    start++;
	  }
	
	  for (; start < hi; start++) {
	    var pivot = array[start];
	    var left = lo;
	    var right = start;
	    var mid;
	
	    while (left < right) {
	      mid = left + right >>> 1;
	
	      if (compare(pivot, array[mid]) < 0) {
	        right = mid;
	      } else {
	        left = mid + 1;
	      }
	    }
	
	    var n = start - left;
	
	    switch (n) {
	      case 3:
	        array[left + 3] = array[left + 2];
	
	      case 2:
	        array[left + 2] = array[left + 1];
	
	      case 1:
	        array[left + 1] = array[left];
	        break;
	
	      default:
	        while (n > 0) {
	          array[left + n] = array[left + n - 1];
	          n--;
	        }
	
	    }
	
	    array[left] = pivot;
	  }
	}
	
	function gallopLeft(value, array, start, length, hint, compare) {
	  var lastOffset = 0;
	  var maxOffset = 0;
	  var offset = 1;
	
	  if (compare(value, array[start + hint]) > 0) {
	    maxOffset = length - hint;
	
	    while (offset < maxOffset && compare(value, array[start + hint + offset]) > 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    lastOffset += hint;
	    offset += hint;
	  } else {
	    maxOffset = hint + 1;
	
	    while (offset < maxOffset && compare(value, array[start + hint - offset]) <= 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    var tmp = lastOffset;
	    lastOffset = hint - offset;
	    offset = hint - tmp;
	  }
	
	  lastOffset++;
	
	  while (lastOffset < offset) {
	    var m = lastOffset + (offset - lastOffset >>> 1);
	
	    if (compare(value, array[start + m]) > 0) {
	      lastOffset = m + 1;
	    } else {
	      offset = m;
	    }
	  }
	
	  return offset;
	}
	
	function gallopRight(value, array, start, length, hint, compare) {
	  var lastOffset = 0;
	  var maxOffset = 0;
	  var offset = 1;
	
	  if (compare(value, array[start + hint]) < 0) {
	    maxOffset = hint + 1;
	
	    while (offset < maxOffset && compare(value, array[start + hint - offset]) < 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    var tmp = lastOffset;
	    lastOffset = hint - offset;
	    offset = hint - tmp;
	  } else {
	    maxOffset = length - hint;
	
	    while (offset < maxOffset && compare(value, array[start + hint + offset]) >= 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    lastOffset += hint;
	    offset += hint;
	  }
	
	  lastOffset++;
	
	  while (lastOffset < offset) {
	    var m = lastOffset + (offset - lastOffset >>> 1);
	
	    if (compare(value, array[start + m]) < 0) {
	      offset = m;
	    } else {
	      lastOffset = m + 1;
	    }
	  }
	
	  return offset;
	}
	
	function TimSort(array, compare) {
	  var minGallop = DEFAULT_MIN_GALLOPING;
	  var length = 0;
	  var tmpStorageLength = DEFAULT_TMP_STORAGE_LENGTH;
	  var stackLength = 0;
	  var runStart;
	  var runLength;
	  var stackSize = 0;
	  length = array.length;
	
	  if (length < 2 * DEFAULT_TMP_STORAGE_LENGTH) {
	    tmpStorageLength = length >>> 1;
	  }
	
	  var tmp = [];
	  stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
	  runStart = [];
	  runLength = [];
	
	  function pushRun(_runStart, _runLength) {
	    runStart[stackSize] = _runStart;
	    runLength[stackSize] = _runLength;
	    stackSize += 1;
	  }
	
	  function mergeRuns() {
	    while (stackSize > 1) {
	      var n = stackSize - 2;
	
	      if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
	        if (runLength[n - 1] < runLength[n + 1]) {
	          n--;
	        }
	      } else if (runLength[n] > runLength[n + 1]) {
	        break;
	      }
	
	      mergeAt(n);
	    }
	  }
	
	  function forceMergeRuns() {
	    while (stackSize > 1) {
	      var n = stackSize - 2;
	
	      if (n > 0 && runLength[n - 1] < runLength[n + 1]) {
	        n--;
	      }
	
	      mergeAt(n);
	    }
	  }
	
	  function mergeAt(i) {
	    var start1 = runStart[i];
	    var length1 = runLength[i];
	    var start2 = runStart[i + 1];
	    var length2 = runLength[i + 1];
	    runLength[i] = length1 + length2;
	
	    if (i === stackSize - 3) {
	      runStart[i + 1] = runStart[i + 2];
	      runLength[i + 1] = runLength[i + 2];
	    }
	
	    stackSize--;
	    var k = gallopRight(array[start2], array, start1, length1, 0, compare);
	    start1 += k;
	    length1 -= k;
	
	    if (length1 === 0) {
	      return;
	    }
	
	    length2 = gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
	
	    if (length2 === 0) {
	      return;
	    }
	
	    if (length1 <= length2) {
	      mergeLow(start1, length1, start2, length2);
	    } else {
	      mergeHigh(start1, length1, start2, length2);
	    }
	  }
	
	  function mergeLow(start1, length1, start2, length2) {
	    var i = 0;
	
	    for (i = 0; i < length1; i++) {
	      tmp[i] = array[start1 + i];
	    }
	
	    var cursor1 = 0;
	    var cursor2 = start2;
	    var dest = start1;
	    array[dest++] = array[cursor2++];
	
	    if (--length2 === 0) {
	      for (i = 0; i < length1; i++) {
	        array[dest + i] = tmp[cursor1 + i];
	      }
	
	      return;
	    }
	
	    if (length1 === 1) {
	      for (i = 0; i < length2; i++) {
	        array[dest + i] = array[cursor2 + i];
	      }
	
	      array[dest + length2] = tmp[cursor1];
	      return;
	    }
	
	    var _minGallop = minGallop;
	    var count1, count2, exit;
	
	    while (1) {
	      count1 = 0;
	      count2 = 0;
	      exit = false;
	
	      do {
	        if (compare(array[cursor2], tmp[cursor1]) < 0) {
	          array[dest++] = array[cursor2++];
	          count2++;
	          count1 = 0;
	
	          if (--length2 === 0) {
	            exit = true;
	            break;
	          }
	        } else {
	          array[dest++] = tmp[cursor1++];
	          count1++;
	          count2 = 0;
	
	          if (--length1 === 1) {
	            exit = true;
	            break;
	          }
	        }
	      } while ((count1 | count2) < _minGallop);
	
	      if (exit) {
	        break;
	      }
	
	      do {
	        count1 = gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
	
	        if (count1 !== 0) {
	          for (i = 0; i < count1; i++) {
	            array[dest + i] = tmp[cursor1 + i];
	          }
	
	          dest += count1;
	          cursor1 += count1;
	          length1 -= count1;
	
	          if (length1 <= 1) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest++] = array[cursor2++];
	
	        if (--length2 === 0) {
	          exit = true;
	          break;
	        }
	
	        count2 = gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
	
	        if (count2 !== 0) {
	          for (i = 0; i < count2; i++) {
	            array[dest + i] = array[cursor2 + i];
	          }
	
	          dest += count2;
	          cursor2 += count2;
	          length2 -= count2;
	
	          if (length2 === 0) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest++] = tmp[cursor1++];
	
	        if (--length1 === 1) {
	          exit = true;
	          break;
	        }
	
	        _minGallop--;
	      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
	
	      if (exit) {
	        break;
	      }
	
	      if (_minGallop < 0) {
	        _minGallop = 0;
	      }
	
	      _minGallop += 2;
	    }
	
	    minGallop = _minGallop;
	    minGallop < 1 && (minGallop = 1);
	
	    if (length1 === 1) {
	      for (i = 0; i < length2; i++) {
	        array[dest + i] = array[cursor2 + i];
	      }
	
	      array[dest + length2] = tmp[cursor1];
	    } else if (length1 === 0) {
	      throw new Error(); // throw new Error('mergeLow preconditions were not respected');
	    } else {
	      for (i = 0; i < length1; i++) {
	        array[dest + i] = tmp[cursor1 + i];
	      }
	    }
	  }
	
	  function mergeHigh(start1, length1, start2, length2) {
	    var i = 0;
	
	    for (i = 0; i < length2; i++) {
	      tmp[i] = array[start2 + i];
	    }
	
	    var cursor1 = start1 + length1 - 1;
	    var cursor2 = length2 - 1;
	    var dest = start2 + length2 - 1;
	    var customCursor = 0;
	    var customDest = 0;
	    array[dest--] = array[cursor1--];
	
	    if (--length1 === 0) {
	      customCursor = dest - (length2 - 1);
	
	      for (i = 0; i < length2; i++) {
	        array[customCursor + i] = tmp[i];
	      }
	
	      return;
	    }
	
	    if (length2 === 1) {
	      dest -= length1;
	      cursor1 -= length1;
	      customDest = dest + 1;
	      customCursor = cursor1 + 1;
	
	      for (i = length1 - 1; i >= 0; i--) {
	        array[customDest + i] = array[customCursor + i];
	      }
	
	      array[dest] = tmp[cursor2];
	      return;
	    }
	
	    var _minGallop = minGallop;
	
	    while (true) {
	      var count1 = 0;
	      var count2 = 0;
	      var exit = false;
	
	      do {
	        if (compare(tmp[cursor2], array[cursor1]) < 0) {
	          array[dest--] = array[cursor1--];
	          count1++;
	          count2 = 0;
	
	          if (--length1 === 0) {
	            exit = true;
	            break;
	          }
	        } else {
	          array[dest--] = tmp[cursor2--];
	          count2++;
	          count1 = 0;
	
	          if (--length2 === 1) {
	            exit = true;
	            break;
	          }
	        }
	      } while ((count1 | count2) < _minGallop);
	
	      if (exit) {
	        break;
	      }
	
	      do {
	        count1 = length1 - gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
	
	        if (count1 !== 0) {
	          dest -= count1;
	          cursor1 -= count1;
	          length1 -= count1;
	          customDest = dest + 1;
	          customCursor = cursor1 + 1;
	
	          for (i = count1 - 1; i >= 0; i--) {
	            array[customDest + i] = array[customCursor + i];
	          }
	
	          if (length1 === 0) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest--] = tmp[cursor2--];
	
	        if (--length2 === 1) {
	          exit = true;
	          break;
	        }
	
	        count2 = length2 - gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
	
	        if (count2 !== 0) {
	          dest -= count2;
	          cursor2 -= count2;
	          length2 -= count2;
	          customDest = dest + 1;
	          customCursor = cursor2 + 1;
	
	          for (i = 0; i < count2; i++) {
	            array[customDest + i] = tmp[customCursor + i];
	          }
	
	          if (length2 <= 1) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest--] = array[cursor1--];
	
	        if (--length1 === 0) {
	          exit = true;
	          break;
	        }
	
	        _minGallop--;
	      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
	
	      if (exit) {
	        break;
	      }
	
	      if (_minGallop < 0) {
	        _minGallop = 0;
	      }
	
	      _minGallop += 2;
	    }
	
	    minGallop = _minGallop;
	
	    if (minGallop < 1) {
	      minGallop = 1;
	    }
	
	    if (length2 === 1) {
	      dest -= length1;
	      cursor1 -= length1;
	      customDest = dest + 1;
	      customCursor = cursor1 + 1;
	
	      for (i = length1 - 1; i >= 0; i--) {
	        array[customDest + i] = array[customCursor + i];
	      }
	
	      array[dest] = tmp[cursor2];
	    } else if (length2 === 0) {
	      throw new Error(); // throw new Error('mergeHigh preconditions were not respected');
	    } else {
	      customCursor = dest - (length2 - 1);
	
	      for (i = 0; i < length2; i++) {
	        array[customCursor + i] = tmp[i];
	      }
	    }
	  }
	
	  this.mergeRuns = mergeRuns;
	  this.forceMergeRuns = forceMergeRuns;
	  this.pushRun = pushRun;
	}
	
	function sort(array, compare, lo, hi) {
	  if (!lo) {
	    lo = 0;
	  }
	
	  if (!hi) {
	    hi = array.length;
	  }
	
	  var remaining = hi - lo;
	
	  if (remaining < 2) {
	    return;
	  }
	
	  var runLength = 0;
	
	  if (remaining < DEFAULT_MIN_MERGE) {
	    runLength = makeAscendingRun(array, lo, hi, compare);
	    binaryInsertionSort(array, lo, hi, lo + runLength, compare);
	    return;
	  }
	
	  var ts = new TimSort(array, compare);
	  var minRun = minRunLength(remaining);
	
	  do {
	    runLength = makeAscendingRun(array, lo, hi, compare);
	
	    if (runLength < minRun) {
	      var force = remaining;
	
	      if (force > minRun) {
	        force = minRun;
	      }
	
	      binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
	      runLength = force;
	    }
	
	    ts.pushRun(lo, runLength);
	    ts.mergeRuns();
	    remaining -= runLength;
	    lo += runLength;
	  } while (remaining !== 0);
	
	  ts.forceMergeRuns();
	}
	
	module.exports = sort;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var LRU = __webpack_require__(221);
	
	var globalImageCache = new LRU(50);
	/**
	 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
	 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
	 */
	
	function findExistImage(newImageOrSrc) {
	  if (typeof newImageOrSrc === 'string') {
	    var cachedImgObj = globalImageCache.get(newImageOrSrc);
	    return cachedImgObj && cachedImgObj.image;
	  } else {
	    return newImageOrSrc;
	  }
	}
	/**
	 * Caution: User should cache loaded images, but not just count on LRU.
	 * Consider if required images more than LRU size, will dead loop occur?
	 *
	 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
	 * @param {HTMLImageElement|HTMLCanvasElement|Canvas} image Existent image.
	 * @param {module:zrender/Element} [hostEl] For calling `dirty`.
	 * @param {Function} [cb] params: (image, cbPayload)
	 * @param {Object} [cbPayload] Payload on cb calling.
	 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
	 */
	
	
	function createOrUpdateImage(newImageOrSrc, image, hostEl, cb, cbPayload) {
	  if (!newImageOrSrc) {
	    return image;
	  } else if (typeof newImageOrSrc === 'string') {
	    // Image should not be loaded repeatly.
	    if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) {
	      return image;
	    } // Only when there is no existent image or existent image src
	    // is different, this method is responsible for load.
	
	
	    var cachedImgObj = globalImageCache.get(newImageOrSrc);
	    var pendingWrap = {
	      hostEl: hostEl,
	      cb: cb,
	      cbPayload: cbPayload
	    };
	
	    if (cachedImgObj) {
	      image = cachedImgObj.image;
	      !isImageReady(image) && cachedImgObj.pending.push(pendingWrap);
	    } else {
	      !image && (image = new Image());
	      image.onload = imageOnLoad;
	      globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
	        image: image,
	        pending: [pendingWrap]
	      });
	      image.src = image.__zrImageSrc = newImageOrSrc;
	    }
	
	    return image;
	  } // newImageOrSrc is an HTMLImageElement or HTMLCanvasElement or Canvas
	  else {
	      return newImageOrSrc;
	    }
	}
	
	function imageOnLoad() {
	  var cachedImgObj = this.__cachedImgObj;
	  this.onload = this.__cachedImgObj = null;
	
	  for (var i = 0; i < cachedImgObj.pending.length; i++) {
	    var pendingWrap = cachedImgObj.pending[i];
	    var cb = pendingWrap.cb;
	    cb && cb(this, pendingWrap.cbPayload);
	    pendingWrap.hostEl.dirty();
	  }
	
	  cachedImgObj.pending.length = 0;
	}
	
	function isImageReady(image) {
	  return image && image.width && image.height;
	}
	
	exports.findExistImage = findExistImage;
	exports.createOrUpdateImage = createOrUpdateImage;
	exports.isImageReady = isImageReady;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var matrix = __webpack_require__(23);
	
	var vector = __webpack_require__(8);
	
	/**
	 * 提供变换扩展
	 * @module zrender/mixin/Transformable
	 * @author pissang (https://www.github.com/pissang)
	 */
	var mIdentity = matrix.identity;
	var EPSILON = 5e-5;
	
	function isNotAroundZero(val) {
	  return val > EPSILON || val < -EPSILON;
	}
	/**
	 * @alias module:zrender/mixin/Transformable
	 * @constructor
	 */
	
	
	var Transformable = function (opts) {
	  opts = opts || {}; // If there are no given position, rotation, scale
	
	  if (!opts.position) {
	    /**
	     * 平移
	     * @type {Array.<number>}
	     * @default [0, 0]
	     */
	    this.position = [0, 0];
	  }
	
	  if (opts.rotation == null) {
	    /**
	     * 旋转
	     * @type {Array.<number>}
	     * @default 0
	     */
	    this.rotation = 0;
	  }
	
	  if (!opts.scale) {
	    /**
	     * 缩放
	     * @type {Array.<number>}
	     * @default [1, 1]
	     */
	    this.scale = [1, 1];
	  }
	  /**
	   * 旋转和缩放的原点
	   * @type {Array.<number>}
	   * @default null
	   */
	
	
	  this.origin = this.origin || null;
	};
	
	var transformableProto = Transformable.prototype;
	transformableProto.transform = null;
	/**
	 * 判断是否需要有坐标变换
	 * 如果有坐标变换, 则从position, rotation, scale以及父节点的transform计算出自身的transform矩阵
	 */
	
	transformableProto.needLocalTransform = function () {
	  return isNotAroundZero(this.rotation) || isNotAroundZero(this.position[0]) || isNotAroundZero(this.position[1]) || isNotAroundZero(this.scale[0] - 1) || isNotAroundZero(this.scale[1] - 1);
	};
	
	transformableProto.updateTransform = function () {
	  var parent = this.parent;
	  var parentHasTransform = parent && parent.transform;
	  var needLocalTransform = this.needLocalTransform();
	  var m = this.transform;
	
	  if (!(needLocalTransform || parentHasTransform)) {
	    m && mIdentity(m);
	    return;
	  }
	
	  m = m || matrix.create();
	
	  if (needLocalTransform) {
	    this.getLocalTransform(m);
	  } else {
	    mIdentity(m);
	  } // 应用父节点变换
	
	
	  if (parentHasTransform) {
	    if (needLocalTransform) {
	      matrix.mul(m, parent.transform, m);
	    } else {
	      matrix.copy(m, parent.transform);
	    }
	  } // 保存这个变换矩阵
	
	
	  this.transform = m;
	  this.invTransform = this.invTransform || matrix.create();
	  matrix.invert(this.invTransform, m);
	};
	
	transformableProto.getLocalTransform = function (m) {
	  return Transformable.getLocalTransform(this, m);
	};
	/**
	 * 将自己的transform应用到context上
	 * @param {CanvasRenderingContext2D} ctx
	 */
	
	
	transformableProto.setTransform = function (ctx) {
	  var m = this.transform;
	  var dpr = ctx.dpr || 1;
	
	  if (m) {
	    ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
	  } else {
	    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	  }
	};
	
	transformableProto.restoreTransform = function (ctx) {
	  var dpr = ctx.dpr || 1;
	  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	};
	
	var tmpTransform = [];
	/**
	 * 分解`transform`矩阵到`position`, `rotation`, `scale`
	 */
	
	transformableProto.decomposeTransform = function () {
	  if (!this.transform) {
	    return;
	  }
	
	  var parent = this.parent;
	  var m = this.transform;
	
	  if (parent && parent.transform) {
	    // Get local transform and decompose them to position, scale, rotation
	    matrix.mul(tmpTransform, parent.invTransform, m);
	    m = tmpTransform;
	  }
	
	  var sx = m[0] * m[0] + m[1] * m[1];
	  var sy = m[2] * m[2] + m[3] * m[3];
	  var position = this.position;
	  var scale = this.scale;
	
	  if (isNotAroundZero(sx - 1)) {
	    sx = Math.sqrt(sx);
	  }
	
	  if (isNotAroundZero(sy - 1)) {
	    sy = Math.sqrt(sy);
	  }
	
	  if (m[0] < 0) {
	    sx = -sx;
	  }
	
	  if (m[3] < 0) {
	    sy = -sy;
	  }
	
	  position[0] = m[4];
	  position[1] = m[5];
	  scale[0] = sx;
	  scale[1] = sy;
	  this.rotation = Math.atan2(-m[1] / sy, m[0] / sx);
	};
	/**
	 * Get global scale
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.getGlobalScale = function () {
	  var m = this.transform;
	
	  if (!m) {
	    return [1, 1];
	  }
	
	  var sx = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
	  var sy = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
	
	  if (m[0] < 0) {
	    sx = -sx;
	  }
	
	  if (m[3] < 0) {
	    sy = -sy;
	  }
	
	  return [sx, sy];
	};
	/**
	 * 变换坐标位置到 shape 的局部坐标空间
	 * @method
	 * @param {number} x
	 * @param {number} y
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.transformCoordToLocal = function (x, y) {
	  var v2 = [x, y];
	  var invTransform = this.invTransform;
	
	  if (invTransform) {
	    vector.applyTransform(v2, v2, invTransform);
	  }
	
	  return v2;
	};
	/**
	 * 变换局部坐标位置到全局坐标空间
	 * @method
	 * @param {number} x
	 * @param {number} y
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.transformCoordToGlobal = function (x, y) {
	  var v2 = [x, y];
	  var transform = this.transform;
	
	  if (transform) {
	    vector.applyTransform(v2, v2, transform);
	  }
	
	  return v2;
	};
	/**
	 * @static
	 * @param {Object} target
	 * @param {Array.<number>} target.origin
	 * @param {number} target.rotation
	 * @param {Array.<number>} target.position
	 * @param {Array.<number>} [m]
	 */
	
	
	Transformable.getLocalTransform = function (target, m) {
	  m = m || [];
	  mIdentity(m);
	  var origin = target.origin;
	  var scale = target.scale || [1, 1];
	  var rotation = target.rotation || 0;
	  var position = target.position || [0, 0];
	
	  if (origin) {
	    // Translate to origin
	    m[4] -= origin[0];
	    m[5] -= origin[1];
	  }
	
	  matrix.scale(m, m, scale);
	
	  if (rotation) {
	    matrix.rotate(m, m, rotation);
	  }
	
	  if (origin) {
	    // Translate back from origin
	    m[4] += origin[0];
	    m[5] += origin[1];
	  }
	
	  m[4] += position[0];
	  m[5] += position[1];
	  return m;
	};
	
	var _default = Transformable;
	module.exports = _default;

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	var svgURI = 'http://www.w3.org/2000/svg';
	
	function createElement(name) {
	  return document.createElementNS(svgURI, name);
	}
	
	exports.createElement = createElement;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(140);
	
	var createElement = _core.createElement;
	
	var PathProxy = __webpack_require__(60);
	
	var BoundingRect = __webpack_require__(13);
	
	var textContain = __webpack_require__(27);
	
	var textHelper = __webpack_require__(100);
	
	var Text = __webpack_require__(76);
	
	// TODO
	// 1. shadow
	// 2. Image: sx, sy, sw, sh
	var CMD = PathProxy.CMD;
	var arrayJoin = Array.prototype.join;
	var NONE = 'none';
	var mathRound = Math.round;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI = Math.PI;
	var PI2 = Math.PI * 2;
	var degree = 180 / PI;
	var EPSILON = 1e-4;
	
	function round4(val) {
	  return mathRound(val * 1e4) / 1e4;
	}
	
	function isAroundZero(val) {
	  return val < EPSILON && val > -EPSILON;
	}
	
	function pathHasFill(style, isText) {
	  var fill = isText ? style.textFill : style.fill;
	  return fill != null && fill !== NONE;
	}
	
	function pathHasStroke(style, isText) {
	  var stroke = isText ? style.textStroke : style.stroke;
	  return stroke != null && stroke !== NONE;
	}
	
	function setTransform(svgEl, m) {
	  if (m) {
	    attr(svgEl, 'transform', 'matrix(' + arrayJoin.call(m, ',') + ')');
	  }
	}
	
	function attr(el, key, val) {
	  if (!val || val.type !== 'linear' && val.type !== 'radial') {
	    // Don't set attribute for gradient, since it need new dom nodes
	    el.setAttribute(key, val);
	  }
	}
	
	function attrXLink(el, key, val) {
	  el.setAttributeNS('http://www.w3.org/1999/xlink', key, val);
	}
	
	function bindStyle(svgEl, style, isText) {
	  if (pathHasFill(style, isText)) {
	    var fill = isText ? style.textFill : style.fill;
	    fill = fill === 'transparent' ? NONE : fill;
	    /**
	     * FIXME:
	     * This is a temporary fix for Chrome's clipping bug
	     * that happens when a clip-path is referring another one.
	     * This fix should be used before Chrome's bug is fixed.
	     * For an element that has clip-path, and fill is none,
	     * set it to be "rgba(0, 0, 0, 0.002)" will hide the element.
	     * Otherwise, it will show black fill color.
	     * 0.002 is used because this won't work for alpha values smaller
	     * than 0.002.
	     *
	     * See
	     * https://bugs.chromium.org/p/chromium/issues/detail?id=659790
	     * for more information.
	     */
	
	    if (svgEl.getAttribute('clip-path') !== 'none' && fill === NONE) {
	      fill = 'rgba(0, 0, 0, 0.002)';
	    }
	
	    attr(svgEl, 'fill', fill);
	    attr(svgEl, 'fill-opacity', style.opacity);
	  } else {
	    attr(svgEl, 'fill', NONE);
	  }
	
	  if (pathHasStroke(style, isText)) {
	    var stroke = isText ? style.textStroke : style.stroke;
	    stroke = stroke === 'transparent' ? NONE : stroke;
	    attr(svgEl, 'stroke', stroke);
	    var strokeWidth = isText ? style.textStrokeWidth : style.lineWidth;
	    var strokeScale = style.strokeNoScale ? style.host.getLineScale() : 1;
	    attr(svgEl, 'stroke-width', strokeWidth / strokeScale);
	    attr(svgEl, 'paint-order', 'stroke');
	    attr(svgEl, 'stroke-opacity', style.opacity);
	    var lineDash = style.lineDash;
	
	    if (lineDash) {
	      attr(svgEl, 'stroke-dasharray', style.lineDash.join(','));
	      attr(svgEl, 'stroke-dashoffset', mathRound(style.lineDashOffset || 0));
	    } else {
	      attr(svgEl, 'stroke-dasharray', '');
	    } // PENDING
	
	
	    style.lineCap && attr(svgEl, 'stroke-linecap', style.lineCap);
	    style.lineJoin && attr(svgEl, 'stroke-linejoin', style.lineJoin);
	    style.miterLimit && attr(svgEl, 'stroke-miterlimit', style.miterLimit);
	  } else {
	    attr(svgEl, 'stroke', NONE);
	  }
	}
	/***************************************************
	 * PATH
	 **************************************************/
	
	
	function pathDataToString(path) {
	  var str = [];
	  var data = path.data;
	  var dataLength = path.len();
	
	  for (var i = 0; i < dataLength;) {
	    var cmd = data[i++];
	    var cmdStr = '';
	    var nData = 0;
	
	    switch (cmd) {
	      case CMD.M:
	        cmdStr = 'M';
	        nData = 2;
	        break;
	
	      case CMD.L:
	        cmdStr = 'L';
	        nData = 2;
	        break;
	
	      case CMD.Q:
	        cmdStr = 'Q';
	        nData = 4;
	        break;
	
	      case CMD.C:
	        cmdStr = 'C';
	        nData = 6;
	        break;
	
	      case CMD.A:
	        var cx = data[i++];
	        var cy = data[i++];
	        var rx = data[i++];
	        var ry = data[i++];
	        var theta = data[i++];
	        var dTheta = data[i++];
	        var psi = data[i++];
	        var clockwise = data[i++];
	        var dThetaPositive = Math.abs(dTheta);
	        var isCircle = isAroundZero(dThetaPositive % PI2) && !isAroundZero(dThetaPositive);
	        var large = false;
	
	        if (dThetaPositive >= PI2) {
	          large = true;
	        } else if (isAroundZero(dThetaPositive)) {
	          large = false;
	        } else {
	          large = (dTheta > -PI && dTheta < 0 || dTheta > PI) === !!clockwise;
	        }
	
	        var x0 = round4(cx + rx * mathCos(theta));
	        var y0 = round4(cy + ry * mathSin(theta)); // It will not draw if start point and end point are exactly the same
	        // We need to shift the end point with a small value
	        // FIXME A better way to draw circle ?
	
	        if (isCircle) {
	          if (clockwise) {
	            dTheta = PI2 - 1e-4;
	          } else {
	            dTheta = -PI2 + 1e-4;
	          }
	
	          large = true;
	
	          if (i === 9) {
	            // Move to (x0, y0) only when CMD.A comes at the
	            // first position of a shape.
	            // For instance, when drawing a ring, CMD.A comes
	            // after CMD.M, so it's unnecessary to move to
	            // (x0, y0).
	            str.push('M', x0, y0);
	          }
	        }
	
	        var x = round4(cx + rx * mathCos(theta + dTheta));
	        var y = round4(cy + ry * mathSin(theta + dTheta)); // FIXME Ellipse
	
	        str.push('A', round4(rx), round4(ry), mathRound(psi * degree), +large, +clockwise, x, y);
	        break;
	
	      case CMD.Z:
	        cmdStr = 'Z';
	        break;
	
	      case CMD.R:
	        var x = round4(data[i++]);
	        var y = round4(data[i++]);
	        var w = round4(data[i++]);
	        var h = round4(data[i++]);
	        str.push('M', x, y, 'L', x + w, y, 'L', x + w, y + h, 'L', x, y + h, 'L', x, y);
	        break;
	    }
	
	    cmdStr && str.push(cmdStr);
	
	    for (var j = 0; j < nData; j++) {
	      // PENDING With scale
	      str.push(round4(data[i++]));
	    }
	  }
	
	  return str.join(' ');
	}
	
	var svgPath = {};
	
	svgPath.brush = function (el) {
	  var style = el.style;
	  var svgEl = el.__svgEl;
	
	  if (!svgEl) {
	    svgEl = createElement('path');
	    el.__svgEl = svgEl;
	  }
	
	  if (!el.path) {
	    el.createPathProxy();
	  }
	
	  var path = el.path;
	
	  if (el.__dirtyPath) {
	    path.beginPath();
	    el.buildPath(path, el.shape);
	    el.__dirtyPath = false;
	    var pathStr = pathDataToString(path);
	
	    if (pathStr.indexOf('NaN') < 0) {
	      // Ignore illegal path, which may happen such in out-of-range
	      // data in Calendar series.
	      attr(svgEl, 'd', pathStr);
	    }
	  }
	
	  bindStyle(svgEl, style);
	  setTransform(svgEl, el.transform);
	
	  if (style.text != null) {
	    svgTextDrawRectText(el, el.getBoundingRect());
	  }
	};
	/***************************************************
	 * IMAGE
	 **************************************************/
	
	
	var svgImage = {};
	
	svgImage.brush = function (el) {
	  var style = el.style;
	  var image = style.image;
	
	  if (image instanceof HTMLImageElement) {
	    var src = image.src;
	    image = src;
	  }
	
	  if (!image) {
	    return;
	  }
	
	  var x = style.x || 0;
	  var y = style.y || 0;
	  var dw = style.width;
	  var dh = style.height;
	  var svgEl = el.__svgEl;
	
	  if (!svgEl) {
	    svgEl = createElement('image');
	    el.__svgEl = svgEl;
	  }
	
	  if (image !== el.__imageSrc) {
	    attrXLink(svgEl, 'href', image); // Caching image src
	
	    el.__imageSrc = image;
	  }
	
	  attr(svgEl, 'width', dw);
	  attr(svgEl, 'height', dh);
	  attr(svgEl, 'x', x);
	  attr(svgEl, 'y', y);
	  setTransform(svgEl, el.transform);
	
	  if (style.text != null) {
	    svgTextDrawRectText(el, el.getBoundingRect());
	  }
	};
	/***************************************************
	 * TEXT
	 **************************************************/
	
	
	var svgText = {};
	var tmpRect = new BoundingRect();
	
	var svgTextDrawRectText = function (el, rect, textRect) {
	  var style = el.style;
	  el.__dirty && textHelper.normalizeTextStyle(style, true);
	  var text = style.text; // Convert to string
	
	  if (text == null) {
	    // Draw no text only when text is set to null, but not ''
	    return;
	  } else {
	    text += '';
	  }
	
	  var textSvgEl = el.__textSvgEl;
	
	  if (!textSvgEl) {
	    textSvgEl = createElement('text');
	    el.__textSvgEl = textSvgEl;
	  }
	
	  bindStyle(textSvgEl, style, true);
	
	  if (el instanceof Text || el.style.transformText) {
	    // Transform text with element
	    setTransform(textSvgEl, el.transform);
	  } else {
	    if (el.transform) {
	      tmpRect.copy(rect);
	      tmpRect.applyTransform(el.transform);
	      rect = tmpRect;
	    } else {
	      var pos = el.transformCoordToGlobal(rect.x, rect.y);
	      rect.x = pos[0];
	      rect.y = pos[1];
	    }
	  }
	
	  var x;
	  var y;
	  var textPosition = style.textPosition;
	  var distance = style.textDistance;
	  var align = style.textAlign || 'left';
	
	  if (typeof style.fontSize === 'number') {
	    style.fontSize += 'px';
	  }
	
	  var font = style.font || [style.fontStyle || '', style.fontWeight || '', style.fontSize || '', style.fontFamily || ''].join(' ') || textContain.DEFAULT_FONT;
	  var verticalAlign = getVerticalAlignForSvg(style.textVerticalAlign);
	  textRect = textContain.getBoundingRect(text, font, align, verticalAlign);
	  var lineHeight = textRect.lineHeight; // Text position represented by coord
	
	  if (textPosition instanceof Array) {
	    x = rect.x + textPosition[0];
	    y = rect.y + textPosition[1];
	  } else {
	    var newPos = textContain.adjustTextPositionOnRect(textPosition, rect, distance);
	    x = newPos.x;
	    y = newPos.y;
	    verticalAlign = getVerticalAlignForSvg(newPos.textVerticalAlign);
	    align = newPos.textAlign;
	  }
	
	  attr(textSvgEl, 'alignment-baseline', verticalAlign);
	
	  if (font) {
	    textSvgEl.style.font = font;
	  }
	
	  var textPadding = style.textPadding; // Make baseline top
	
	  attr(textSvgEl, 'x', x);
	  attr(textSvgEl, 'y', y);
	  var textLines = text.split('\n');
	  var nTextLines = textLines.length;
	  var textAnchor = align; // PENDING
	
	  if (textAnchor === 'left') {
	    textAnchor = 'start';
	    textPadding && (x += textPadding[3]);
	  } else if (textAnchor === 'right') {
	    textAnchor = 'end';
	    textPadding && (x -= textPadding[1]);
	  } else if (textAnchor === 'center') {
	    textAnchor = 'middle';
	    textPadding && (x += (textPadding[3] - textPadding[1]) / 2);
	  }
	
	  var dy = 0;
	
	  if (verticalAlign === 'baseline') {
	    dy = -textRect.height + lineHeight;
	    textPadding && (dy -= textPadding[2]);
	  } else if (verticalAlign === 'middle') {
	    dy = (-textRect.height + lineHeight) / 2;
	    textPadding && (y += (textPadding[0] - textPadding[2]) / 2);
	  } else {
	    textPadding && (dy += textPadding[0]);
	  } // Font may affect position of each tspan elements
	
	
	  if (el.__text !== text || el.__textFont !== font) {
	    var tspanList = el.__tspanList || [];
	    el.__tspanList = tspanList;
	
	    for (var i = 0; i < nTextLines; i++) {
	      // Using cached tspan elements
	      var tspan = tspanList[i];
	
	      if (!tspan) {
	        tspan = tspanList[i] = createElement('tspan');
	        textSvgEl.appendChild(tspan);
	        attr(tspan, 'alignment-baseline', verticalAlign);
	        attr(tspan, 'text-anchor', textAnchor);
	      } else {
	        tspan.innerHTML = '';
	      }
	
	      attr(tspan, 'x', x);
	      attr(tspan, 'y', y + i * lineHeight + dy);
	      tspan.appendChild(document.createTextNode(textLines[i]));
	    } // Remove unsed tspan elements
	
	
	    for (; i < tspanList.length; i++) {
	      textSvgEl.removeChild(tspanList[i]);
	    }
	
	    tspanList.length = nTextLines;
	    el.__text = text;
	    el.__textFont = font;
	  } else if (el.__tspanList.length) {
	    // Update span x and y
	    var len = el.__tspanList.length;
	
	    for (var i = 0; i < len; ++i) {
	      var tspan = el.__tspanList[i];
	
	      if (tspan) {
	        attr(tspan, 'x', x);
	        attr(tspan, 'y', y + i * lineHeight + dy);
	      }
	    }
	  }
	};
	
	function getVerticalAlignForSvg(verticalAlign) {
	  if (verticalAlign === 'middle') {
	    return 'middle';
	  } else if (verticalAlign === 'bottom') {
	    return 'baseline';
	  } else {
	    return 'hanging';
	  }
	}
	
	svgText.drawRectText = svgTextDrawRectText;
	
	svgText.brush = function (el) {
	  var style = el.style;
	
	  if (style.text != null) {
	    // 强制设置 textPosition
	    style.textPosition = [0, 0];
	    svgTextDrawRectText(el, {
	      x: style.x || 0,
	      y: style.y || 0,
	      width: 0,
	      height: 0
	    }, el.getBoundingRect());
	  }
	};
	
	exports.path = svgPath;
	exports.image = svgImage;
	exports.text = svgText;

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  translations: {
	    'en': {
	      'months': {
	        'original': ['January', 'Febrary', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	        'abbr': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
	      },
	      'days': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
	    },
	
	    'es': {
	      'months': {
	        'original': ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
	        'abbr': ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
	      },
	      'days': ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sab']
	    },
	
	    'fr': {
	      'months': {
	        'original': ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
	        'abbr': ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc']
	      },
	      'days': ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']
	    },
	
	    'nl': {
	      'months': {
	        'original': ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
	        'abbr': ['Jan', 'Feb', 'Maa', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec']
	      },
	      'days': ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za']
	    },
	
	    'pt-br': {
	      'months': {
	        'original': ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
	        'abbr': ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
	      },
	      'days': ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab']
	    },
	
	    'vi': {
	      'months': {
	        'original': ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
	        'abbr': ['T 01', 'T 02', 'T 03', 'T 04', 'T 05', 'T 06', 'T 07', 'T 08', 'T 09', 'T 10', 'T 11', 'T 12']
	      },
	      'days': ['CN', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7']
	    }
	  }
	
	};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(52);
	var document = __webpack_require__(32).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(41) && !__webpack_require__(50)(function () {
	  return Object.defineProperty(__webpack_require__(143)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(103);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(78);
	var $export = __webpack_require__(63);
	var redefine = __webpack_require__(150);
	var hide = __webpack_require__(51);
	var Iterators = __webpack_require__(77);
	var $iterCreate = __webpack_require__(293);
	var setToStringTag = __webpack_require__(107);
	var getPrototypeOf = __webpack_require__(300);
	var ITERATOR = __webpack_require__(33)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(62);
	var dPs = __webpack_require__(297);
	var enumBugKeys = __webpack_require__(105);
	var IE_PROTO = __webpack_require__(108)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(143)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(290).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(149);
	var hiddenKeys = __webpack_require__(105).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(42);
	var toIObject = __webpack_require__(54);
	var arrayIndexOf = __webpack_require__(286)(false);
	var IE_PROTO = __webpack_require__(108)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(51);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(302)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(146)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(307);
	var global = __webpack_require__(32);
	var hide = __webpack_require__(51);
	var Iterators = __webpack_require__(77);
	var TO_STRING_TAG = __webpack_require__(33)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	function _default(seriesType, actionInfos) {
	  zrUtil.each(actionInfos, function (actionInfo) {
	    actionInfo.update = 'updateView';
	    /**
	     * @payload
	     * @property {string} seriesName
	     * @property {string} name
	     */
	
	    echarts.registerAction(actionInfo, function (payload, ecModel) {
	      var selected = {};
	      ecModel.eachComponent({
	        mainType: 'series',
	        subType: seriesType,
	        query: payload
	      }, function (seriesModel) {
	        if (seriesModel[actionInfo.method]) {
	          seriesModel[actionInfo.method](payload.name, payload.dataIndex);
	        }
	
	        var data = seriesModel.getData(); // Create selected map
	
	        data.each(function (idx) {
	          var name = data.getName(idx);
	          selected[name] = seriesModel.isSelected(name) || false;
	        });
	      });
	      return {
	        name: payload.name,
	        selected: selected
	      };
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var _roamHelper = __webpack_require__(155);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	
	/**
	 * @payload
	 * @property {string} [componentType=series]
	 * @property {number} [dx]
	 * @property {number} [dy]
	 * @property {number} [zoom]
	 * @property {number} [originX]
	 * @property {number} [originY]
	 */
	echarts.registerAction({
	  type: 'geoRoam',
	  event: 'geoRoam',
	  update: 'updateLayout'
	}, function (payload, ecModel) {
	  var componentType = payload.componentType || 'series';
	  ecModel.eachComponent({
	    mainType: componentType,
	    query: payload
	  }, function (componentModel) {
	    var geo = componentModel.coordinateSystem;
	
	    if (geo.type !== 'geo') {
	      return;
	    }
	
	    var res = updateCenterAndZoom(geo, payload, componentModel.get('scaleLimit'));
	    componentModel.setCenter && componentModel.setCenter(res.center);
	    componentModel.setZoom && componentModel.setZoom(res.zoom); // All map series with same `map` use the same geo coordinate system
	    // So the center and zoom must be in sync. Include the series not selected by legend
	
	    if (componentType === 'series') {
	      zrUtil.each(componentModel.seriesGroup, function (seriesModel) {
	        seriesModel.setCenter(res.center);
	        seriesModel.setZoom(res.zoom);
	      });
	    }
	  });
	});

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	/**
	 * @param {module:echarts/coord/View} view
	 * @param {Object} payload
	 * @param {Object} [zoomLimit]
	 */
	function updateCenterAndZoom(view, payload, zoomLimit) {
	  var previousZoom = view.getZoom();
	  var center = view.getCenter();
	  var zoom = payload.zoom;
	  var point = view.dataToPoint(center);
	
	  if (payload.dx != null && payload.dy != null) {
	    point[0] -= payload.dx;
	    point[1] -= payload.dy;
	    var center = view.pointToData(point);
	    view.setCenter(center);
	  }
	
	  if (zoom != null) {
	    if (zoomLimit) {
	      var zoomMin = zoomLimit.min || 0;
	      var zoomMax = zoomLimit.max || Infinity;
	      zoom = Math.max(Math.min(previousZoom * zoom, zoomMax), zoomMin) / previousZoom;
	    } // Zoom on given point(originX, originY)
	
	
	    view.scale[0] *= zoom;
	    view.scale[1] *= zoom;
	    var position = view.position;
	    var fixX = (payload.originX - position[0]) * (zoom - 1);
	    var fixY = (payload.originY - position[1]) * (zoom - 1);
	    position[0] -= fixX;
	    position[1] -= fixY;
	    view.updateTransform(); // Get the new center
	
	    var center = view.pointToData(point);
	    view.setCenter(center);
	    view.setZoom(zoom * previousZoom);
	  }
	
	  return {
	    center: view.getCenter(),
	    zoom: view.getZoom()
	  };
	}
	
	exports.updateCenterAndZoom = updateCenterAndZoom;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var SeriesModel = __webpack_require__(20);
	
	var createListFromArray = __webpack_require__(34);
	
	var _default = SeriesModel.extend({
	  type: 'series.__base_bar__',
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(option.data, this, ecModel);
	  },
	  getMarkerPosition: function (value) {
	    var coordSys = this.coordinateSystem;
	
	    if (coordSys) {
	      // PENDING if clamp ?
	      var pt = coordSys.dataToPoint(value, true);
	      var data = this.getData();
	      var offset = data.getLayout('offset');
	      var size = data.getLayout('size');
	      var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
	      pt[offsetIndex] += offset + size / 2;
	      return pt;
	    }
	
	    return [NaN, NaN];
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    // stack: null
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // 最小高度改为0
	    barMinHeight: 0,
	    // 最小角度为0，仅对极坐标系下的柱状图有效
	    barMinAngle: 0,
	    // cursor: null,
	    // barMaxWidth: null,
	    // 默认自适应
	    // barWidth: null,
	    // 柱间距离，默认为柱形宽度的30%，可设固定值
	    // barGap: '30%',
	    // 类目间柱形距离，默认为类目间距的20%，可设固定值
	    // barCategoryGap: '20%',
	    // label: {
	    //     normal: {
	    //         show: false
	    //     }
	    // },
	    itemStyle: {// normal: {
	      // color: '各异'
	      // },
	      // emphasis: {}
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var graphic = __webpack_require__(3);
	
	function setLabel(normalStyle, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside) {
	  var labelModel = itemModel.getModel('label.normal');
	  var hoverLabelModel = itemModel.getModel('label.emphasis');
	  graphic.setLabelStyle(normalStyle, hoverStyle, labelModel, hoverLabelModel, {
	    labelFetcher: seriesModel,
	    labelDataIndex: dataIndex,
	    defaultText: seriesModel.getRawValue(dataIndex),
	    isRectText: true,
	    autoColor: color
	  });
	  fixPosition(normalStyle);
	  fixPosition(hoverStyle);
	}
	
	function fixPosition(style, labelPositionOutside) {
	  if (style.textPosition === 'outside') {
	    style.textPosition = labelPositionOutside;
	  }
	}
	
	exports.setLabel = setLabel;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var vec2 = __webpack_require__(8);
	
	function circularLayout(seriesModel) {
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (coordSys && coordSys.type !== 'view') {
	    return;
	  }
	
	  var rect = coordSys.getBoundingRect();
	  var nodeData = seriesModel.getData();
	  var graph = nodeData.graph;
	  var angle = 0;
	  var sum = nodeData.getSum('value');
	  var unitAngle = Math.PI * 2 / (sum || nodeData.count());
	  var cx = rect.width / 2 + rect.x;
	  var cy = rect.height / 2 + rect.y;
	  var r = Math.min(rect.width, rect.height) / 2;
	  graph.eachNode(function (node) {
	    var value = node.getValue('value');
	    angle += unitAngle * (sum ? value : 1) / 2;
	    node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
	    angle += unitAngle * (sum ? value : 1) / 2;
	  });
	  nodeData.setLayout({
	    cx: cx,
	    cy: cy
	  });
	  graph.eachEdge(function (edge) {
	    var curveness = edge.getModel().get('lineStyle.normal.curveness') || 0;
	    var p1 = vec2.clone(edge.node1.getLayout());
	    var p2 = vec2.clone(edge.node2.getLayout());
	    var cp1;
	    var x12 = (p1[0] + p2[0]) / 2;
	    var y12 = (p1[1] + p2[1]) / 2;
	
	    if (+curveness) {
	      curveness *= 3;
	      cp1 = [cx * curveness + x12 * (1 - curveness), cy * curveness + y12 * (1 - curveness)];
	    }
	
	    edge.setLayout([p1, p2, cp1]);
	  });
	}
	
	exports.circularLayout = circularLayout;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var vec2 = __webpack_require__(8);
	
	function simpleLayout(seriesModel) {
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (coordSys && coordSys.type !== 'view') {
	    return;
	  }
	
	  var graph = seriesModel.getGraph();
	  graph.eachNode(function (node) {
	    var model = node.getModel();
	    node.setLayout([+model.get('x'), +model.get('y')]);
	  });
	  simpleLayoutEdge(graph);
	}
	
	function simpleLayoutEdge(graph) {
	  graph.eachEdge(function (edge) {
	    var curveness = edge.getModel().get('lineStyle.normal.curveness') || 0;
	    var p1 = vec2.clone(edge.node1.getLayout());
	    var p2 = vec2.clone(edge.node2.getLayout());
	    var points = [p1, p2];
	
	    if (+curveness) {
	      points.push([(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness]);
	    }
	
	    edge.setLayout(points);
	  });
	}
	
	exports.simpleLayout = simpleLayout;
	exports.simpleLayoutEdge = simpleLayoutEdge;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	var graphic = __webpack_require__(3);
	
	var Line = __webpack_require__(116);
	
	var zrUtil = __webpack_require__(1);
	
	var _symbol = __webpack_require__(22);
	
	var createSymbol = _symbol.createSymbol;
	
	var vec2 = __webpack_require__(8);
	
	var curveUtil = __webpack_require__(40);
	
	/**
	 * Provide effect for line
	 * @module echarts/chart/helper/EffectLine
	 */
	
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Line}
	 */
	function EffectLine(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	  this.add(this.createLine(lineData, idx, seriesScope));
	
	  this._updateEffectSymbol(lineData, idx);
	}
	
	var effectLineProto = EffectLine.prototype;
	
	effectLineProto.createLine = function (lineData, idx, seriesScope) {
	  return new Line(lineData, idx, seriesScope);
	};
	
	effectLineProto._updateEffectSymbol = function (lineData, idx) {
	  var itemModel = lineData.getItemModel(idx);
	  var effectModel = itemModel.getModel('effect');
	  var size = effectModel.get('symbolSize');
	  var symbolType = effectModel.get('symbol');
	
	  if (!zrUtil.isArray(size)) {
	    size = [size, size];
	  }
	
	  var color = effectModel.get('color') || lineData.getItemVisual(idx, 'color');
	  var symbol = this.childAt(1);
	
	  if (this._symbolType !== symbolType) {
	    // Remove previous
	    this.remove(symbol);
	    symbol = createSymbol(symbolType, -0.5, -0.5, 1, 1, color);
	    symbol.z2 = 100;
	    symbol.culling = true;
	    this.add(symbol);
	  } // Symbol may be removed if loop is false
	
	
	  if (!symbol) {
	    return;
	  } // Shadow color is same with color in default
	
	
	  symbol.setStyle('shadowColor', color);
	  symbol.setStyle(effectModel.getItemStyle(['color']));
	  symbol.attr('scale', size);
	  symbol.setColor(color);
	  symbol.attr('scale', size);
	  this._symbolType = symbolType;
	
	  this._updateEffectAnimation(lineData, effectModel, idx);
	};
	
	effectLineProto._updateEffectAnimation = function (lineData, effectModel, idx) {
	  var symbol = this.childAt(1);
	
	  if (!symbol) {
	    return;
	  }
	
	  var self = this;
	  var points = lineData.getItemLayout(idx);
	  var period = effectModel.get('period') * 1000;
	  var loop = effectModel.get('loop');
	  var constantSpeed = effectModel.get('constantSpeed');
	  var delayExpr = zrUtil.retrieve(effectModel.get('delay'), function (idx) {
	    return idx / lineData.count() * period / 3;
	  });
	  var isDelayFunc = typeof delayExpr === 'function'; // Ignore when updating
	
	  symbol.ignore = true;
	  this.updateAnimationPoints(symbol, points);
	
	  if (constantSpeed > 0) {
	    period = this.getLineLength(symbol) / constantSpeed * 1000;
	  }
	
	  if (period !== this._period || loop !== this._loop) {
	    symbol.stopAnimation();
	    var delay = delayExpr;
	
	    if (isDelayFunc) {
	      delay = delayExpr(idx);
	    }
	
	    if (symbol.__t > 0) {
	      delay = -period * symbol.__t;
	    }
	
	    symbol.__t = 0;
	    var animator = symbol.animate('', loop).when(period, {
	      __t: 1
	    }).delay(delay).during(function () {
	      self.updateSymbolPosition(symbol);
	    });
	
	    if (!loop) {
	      animator.done(function () {
	        self.remove(symbol);
	      });
	    }
	
	    animator.start();
	  }
	
	  this._period = period;
	  this._loop = loop;
	};
	
	effectLineProto.getLineLength = function (symbol) {
	  // Not so accurate
	  return vec2.dist(symbol.__p1, symbol.__cp1) + vec2.dist(symbol.__cp1, symbol.__p2);
	};
	
	effectLineProto.updateAnimationPoints = function (symbol, points) {
	  symbol.__p1 = points[0];
	  symbol.__p2 = points[1];
	  symbol.__cp1 = points[2] || [(points[0][0] + points[1][0]) / 2, (points[0][1] + points[1][1]) / 2];
	};
	
	effectLineProto.updateData = function (lineData, idx, seriesScope) {
	  this.childAt(0).updateData(lineData, idx, seriesScope);
	
	  this._updateEffectSymbol(lineData, idx);
	};
	
	effectLineProto.updateSymbolPosition = function (symbol) {
	  var p1 = symbol.__p1;
	  var p2 = symbol.__p2;
	  var cp1 = symbol.__cp1;
	  var t = symbol.__t;
	  var pos = symbol.position;
	  var quadraticAt = curveUtil.quadraticAt;
	  var quadraticDerivativeAt = curveUtil.quadraticDerivativeAt;
	  pos[0] = quadraticAt(p1[0], cp1[0], p2[0], t);
	  pos[1] = quadraticAt(p1[1], cp1[1], p2[1], t); // Tangent
	
	  var tx = quadraticDerivativeAt(p1[0], cp1[0], p2[0], t);
	  var ty = quadraticDerivativeAt(p1[1], cp1[1], p2[1], t);
	  symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
	  symbol.ignore = false;
	};
	
	effectLineProto.updateLayout = function (lineData, idx) {
	  this.childAt(0).updateLayout(lineData, idx);
	  var effectModel = lineData.getItemModel(idx).getModel('effect');
	
	  this._updateEffectAnimation(lineData, effectModel, idx);
	};
	
	zrUtil.inherits(EffectLine, graphic.Group);
	var _default = EffectLine;
	module.exports = _default;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var graphic = __webpack_require__(3);
	
	var zrUtil = __webpack_require__(1);
	
	/**
	 * @module echarts/chart/helper/Line
	 */
	
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Polyline}
	 */
	function Polyline(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	
	  this._createPolyline(lineData, idx, seriesScope);
	}
	
	var polylineProto = Polyline.prototype;
	
	polylineProto._createPolyline = function (lineData, idx, seriesScope) {
	  // var seriesModel = lineData.hostModel;
	  var points = lineData.getItemLayout(idx);
	  var line = new graphic.Polyline({
	    shape: {
	      points: points
	    }
	  });
	  this.add(line);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	polylineProto.updateData = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childAt(0);
	  var target = {
	    shape: {
	      points: lineData.getItemLayout(idx)
	    }
	  };
	  graphic.updateProps(line, target, seriesModel, idx);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	polylineProto._updateCommonStl = function (lineData, idx, seriesScope) {
	  var line = this.childAt(0);
	  var itemModel = lineData.getItemModel(idx);
	  var visualColor = lineData.getItemVisual(idx, 'color');
	  var lineStyle = seriesScope && seriesScope.lineStyle;
	  var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;
	
	  if (!seriesScope || lineData.hasItemOption) {
	    lineStyle = itemModel.getModel('lineStyle.normal').getLineStyle();
	    hoverLineStyle = itemModel.getModel('lineStyle.emphasis').getLineStyle();
	  }
	
	  line.useStyle(zrUtil.defaults({
	    strokeNoScale: true,
	    fill: 'none',
	    stroke: visualColor
	  }, lineStyle));
	  line.hoverStyle = hoverLineStyle;
	  graphic.setHoverStyle(this);
	};
	
	polylineProto.updateLayout = function (lineData, idx) {
	  var polyline = this.childAt(0);
	  polyline.setShape('points', lineData.getItemLayout(idx));
	};
	
	zrUtil.inherits(Polyline, graphic.Group);
	var _default = Polyline;
	module.exports = _default;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var List = __webpack_require__(15);
	
	var Graph = __webpack_require__(578);
	
	var linkList = __webpack_require__(200);
	
	var completeDimensions = __webpack_require__(25);
	
	var CoordinateSystem = __webpack_require__(26);
	
	var createListFromArray = __webpack_require__(34);
	
	function _default(nodes, edges, hostModel, directed, beforeLink) {
	  var graph = new Graph(directed);
	
	  for (var i = 0; i < nodes.length; i++) {
	    graph.addNode(zrUtil.retrieve( // Id, name, dataIndex
	    nodes[i].id, nodes[i].name, i), i);
	  }
	
	  var linkNameList = [];
	  var validEdges = [];
	  var linkCount = 0;
	
	  for (var i = 0; i < edges.length; i++) {
	    var link = edges[i];
	    var source = link.source;
	    var target = link.target; // addEdge may fail when source or target not exists
	
	    if (graph.addEdge(source, target, linkCount)) {
	      validEdges.push(link);
	      linkNameList.push(zrUtil.retrieve(link.id, source + ' > ' + target));
	      linkCount++;
	    }
	  }
	
	  var coordSys = hostModel.get('coordinateSystem');
	  var nodeData;
	
	  if (coordSys === 'cartesian2d' || coordSys === 'polar') {
	    nodeData = createListFromArray(nodes, hostModel, hostModel.ecModel);
	  } else {
	    // FIXME
	    var coordSysCtor = CoordinateSystem.get(coordSys); // FIXME
	
	    var dimensionNames = completeDimensions((coordSysCtor && coordSysCtor.type !== 'view' ? coordSysCtor.dimensions || [] : []).concat(['value']), nodes);
	    nodeData = new List(dimensionNames, hostModel);
	    nodeData.initData(nodes);
	  }
	
	  var edgeData = new List(['value'], hostModel);
	  edgeData.initData(validEdges, linkNameList);
	  beforeLink && beforeLink(nodeData, edgeData);
	  linkList({
	    mainData: nodeData,
	    struct: graph,
	    structAttr: 'graph',
	    datas: {
	      node: nodeData,
	      edge: edgeData
	    },
	    datasAttr: {
	      node: 'data',
	      edge: 'edgeData'
	    }
	  }); // Update dataIndex of nodes and edges because invalid edge may be removed
	
	  graph.update();
	  return graph;
	}
	
	module.exports = _default;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var _model = __webpack_require__(6);
	
	var otherDimToDataDim = _model.otherDimToDataDim;
	
	/**
	 * @module echarts/chart/helper/Symbol
	 */
	function findLabelValueDim(data) {
	  var valueDim;
	  var labelDims = otherDimToDataDim(data, 'label');
	
	  if (labelDims.length) {
	    valueDim = labelDims[0];
	  } else {
	    // Get last value dim
	    var dimensions = data.dimensions.slice();
	    var dataType;
	
	    while (dimensions.length && (valueDim = dimensions.pop(), dataType = data.getDimensionInfo(valueDim).type, dataType === 'ordinal' || dataType === 'time')) {} // jshint ignore:line
	
	  }
	
	  return valueDim;
	}
	
	exports.findLabelValueDim = findLabelValueDim;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(19);
	
	var vec2 = __webpack_require__(8);
	
	var fixClipWithShadow = __webpack_require__(226);
	
	// Poly path support NaN point
	var vec2Min = vec2.min;
	var vec2Max = vec2.max;
	var scaleAndAdd = vec2.scaleAndAdd;
	var v2Copy = vec2.copy; // Temporary variable
	
	var v = [];
	var cp0 = [];
	var cp1 = [];
	
	function isPointNull(p) {
	  return isNaN(p[0]) || isNaN(p[1]);
	}
	
	function drawSegment(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
	  var prevIdx = 0;
	  var idx = start;
	
	  for (var k = 0; k < segLen; k++) {
	    var p = points[idx];
	
	    if (idx >= allLen || idx < 0) {
	      break;
	    }
	
	    if (isPointNull(p)) {
	      if (connectNulls) {
	        idx += dir;
	        continue;
	      }
	
	      break;
	    }
	
	    if (idx === start) {
	      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
	      v2Copy(cp0, p);
	    } else {
	      if (smooth > 0) {
	        var nextIdx = idx + dir;
	        var nextP = points[nextIdx];
	
	        if (connectNulls) {
	          // Find next point not null
	          while (nextP && isPointNull(points[nextIdx])) {
	            nextIdx += dir;
	            nextP = points[nextIdx];
	          }
	        }
	
	        var ratioNextSeg = 0.5;
	        var prevP = points[prevIdx];
	        var nextP = points[nextIdx]; // Last point
	
	        if (!nextP || isPointNull(nextP)) {
	          v2Copy(cp1, p);
	        } else {
	          // If next data is null in not connect case
	          if (isPointNull(nextP) && !connectNulls) {
	            nextP = p;
	          }
	
	          vec2.sub(v, nextP, prevP);
	          var lenPrevSeg;
	          var lenNextSeg;
	
	          if (smoothMonotone === 'x' || smoothMonotone === 'y') {
	            var dim = smoothMonotone === 'x' ? 0 : 1;
	            lenPrevSeg = Math.abs(p[dim] - prevP[dim]);
	            lenNextSeg = Math.abs(p[dim] - nextP[dim]);
	          } else {
	            lenPrevSeg = vec2.dist(p, prevP);
	            lenNextSeg = vec2.dist(p, nextP);
	          } // Use ratio of seg length
	
	
	          ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
	          scaleAndAdd(cp1, p, v, -smooth * (1 - ratioNextSeg));
	        } // Smooth constraint
	
	
	        vec2Min(cp0, cp0, smoothMax);
	        vec2Max(cp0, cp0, smoothMin);
	        vec2Min(cp1, cp1, smoothMax);
	        vec2Max(cp1, cp1, smoothMin);
	        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]); // cp0 of next segment
	
	        scaleAndAdd(cp0, p, v, smooth * ratioNextSeg);
	      } else {
	        ctx.lineTo(p[0], p[1]);
	      }
	    }
	
	    prevIdx = idx;
	    idx += dir;
	  }
	
	  return k;
	}
	
	function getBoundingBox(points, smoothConstraint) {
	  var ptMin = [Infinity, Infinity];
	  var ptMax = [-Infinity, -Infinity];
	
	  if (smoothConstraint) {
	    for (var i = 0; i < points.length; i++) {
	      var pt = points[i];
	
	      if (pt[0] < ptMin[0]) {
	        ptMin[0] = pt[0];
	      }
	
	      if (pt[1] < ptMin[1]) {
	        ptMin[1] = pt[1];
	      }
	
	      if (pt[0] > ptMax[0]) {
	        ptMax[0] = pt[0];
	      }
	
	      if (pt[1] > ptMax[1]) {
	        ptMax[1] = pt[1];
	      }
	    }
	  }
	
	  return {
	    min: smoothConstraint ? ptMin : ptMax,
	    max: smoothConstraint ? ptMax : ptMin
	  };
	}
	
	var Polyline = Path.extend({
	  type: 'ec-polyline',
	  shape: {
	    points: [],
	    smooth: 0,
	    smoothConstraint: true,
	    smoothMonotone: null,
	    connectNulls: false
	  },
	  style: {
	    fill: null,
	    stroke: '#000'
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var points = shape.points;
	    var i = 0;
	    var len = points.length;
	    var result = getBoundingBox(points, shape.smoothConstraint);
	
	    if (shape.connectNulls) {
	      // Must remove first and last null values avoid draw error in polygon
	      for (; len > 0; len--) {
	        if (!isPointNull(points[len - 1])) {
	          break;
	        }
	      }
	
	      for (; i < len; i++) {
	        if (!isPointNull(points[i])) {
	          break;
	        }
	      }
	    }
	
	    while (i < len) {
	      i += drawSegment(ctx, points, i, len, len, 1, result.min, result.max, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
	    }
	  }
	});
	var Polygon = Path.extend({
	  type: 'ec-polygon',
	  shape: {
	    points: [],
	    // Offset between stacked base points and points
	    stackedOnPoints: [],
	    smooth: 0,
	    stackedOnSmooth: 0,
	    smoothConstraint: true,
	    smoothMonotone: null,
	    connectNulls: false
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var points = shape.points;
	    var stackedOnPoints = shape.stackedOnPoints;
	    var i = 0;
	    var len = points.length;
	    var smoothMonotone = shape.smoothMonotone;
	    var bbox = getBoundingBox(points, shape.smoothConstraint);
	    var stackedOnBBox = getBoundingBox(stackedOnPoints, shape.smoothConstraint);
	
	    if (shape.connectNulls) {
	      // Must remove first and last null values avoid draw error in polygon
	      for (; len > 0; len--) {
	        if (!isPointNull(points[len - 1])) {
	          break;
	        }
	      }
	
	      for (; i < len; i++) {
	        if (!isPointNull(points[i])) {
	          break;
	        }
	      }
	    }
	
	    while (i < len) {
	      var k = drawSegment(ctx, points, i, len, len, 1, bbox.min, bbox.max, shape.smooth, smoothMonotone, shape.connectNulls);
	      drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, stackedOnBBox.min, stackedOnBBox.max, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
	      i += k + 1;
	      ctx.closePath();
	    }
	  }
	});
	exports.Polyline = Polyline;
	exports.Polygon = Polygon;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var _traversalHelper = __webpack_require__(448);
	
	var eachAfter = _traversalHelper.eachAfter;
	var eachBefore = _traversalHelper.eachBefore;
	
	var _layoutHelper = __webpack_require__(166);
	
	var init = _layoutHelper.init;
	var firstWalk = _layoutHelper.firstWalk;
	var secondWalk = _layoutHelper.secondWalk;
	var sep = _layoutHelper.separation;
	var radialCoordinate = _layoutHelper.radialCoordinate;
	var getViewRect = _layoutHelper.getViewRect;
	
	function _default(seriesModel, api) {
	  var layoutInfo = getViewRect(seriesModel, api);
	  seriesModel.layoutInfo = layoutInfo;
	  var layout = seriesModel.get('layout');
	  var width = 0;
	  var height = 0;
	  var separation = null;
	
	  if (layout === 'radial') {
	    width = 2 * Math.PI;
	    height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
	    separation = sep(function (node1, node2) {
	      return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
	    });
	  } else {
	    width = layoutInfo.width;
	    height = layoutInfo.height;
	    separation = sep();
	  }
	
	  var virtualRoot = seriesModel.getData().tree.root;
	  var realRoot = virtualRoot.children[0];
	  init(virtualRoot);
	  eachAfter(realRoot, firstWalk, separation);
	  virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
	  eachBefore(realRoot, secondWalk);
	  var left = realRoot;
	  var right = realRoot;
	  var bottom = realRoot;
	  eachBefore(realRoot, function (node) {
	    var x = node.getLayout().x;
	
	    if (x < left.getLayout().x) {
	      left = node;
	    }
	
	    if (x > right.getLayout().x) {
	      right = node;
	    }
	
	    if (node.depth > bottom.depth) {
	      bottom = node;
	    }
	  });
	  var delta = left === right ? 1 : separation(left, right) / 2;
	  var tx = delta - left.getLayout().x;
	  var kx = 0;
	  var ky = 0;
	  var coorX = 0;
	  var coorY = 0;
	
	  if (layout === 'radial') {
	    kx = width / (right.getLayout().x + delta + tx); // here we use (node.depth - 1), bucause the real root's depth is 1
	
	    ky = height / (bottom.depth - 1 || 1);
	    eachBefore(realRoot, function (node) {
	      coorX = (node.getLayout().x + tx) * kx;
	      coorY = (node.depth - 1) * ky;
	      var finalCoor = radialCoordinate(coorX, coorY);
	      node.setLayout({
	        x: finalCoor.x,
	        y: finalCoor.y,
	        rawX: coorX,
	        rawY: coorY
	      }, true);
	    });
	  } else {
	    if (seriesModel.get('orient') === 'horizontal') {
	      ky = height / (right.getLayout().x + delta + tx);
	      kx = width / (bottom.depth - 1 || 1);
	      eachBefore(realRoot, function (node) {
	        coorY = (node.getLayout().x + tx) * ky;
	        coorX = (node.depth - 1) * kx;
	        node.setLayout({
	          x: coorX,
	          y: coorY
	        }, true);
	      });
	    } else {
	      kx = width / (right.getLayout().x + delta + tx);
	      ky = height / (bottom.depth - 1 || 1);
	      eachBefore(realRoot, function (node) {
	        coorX = (node.getLayout().x + tx) * kx;
	        coorY = (node.depth - 1) * ky;
	        node.setLayout({
	          x: coorX,
	          y: coorY
	        }, true);
	      });
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var layout = __webpack_require__(7);
	
	/**
	 * @file The layout algorithm of node-link tree diagrams. Here we using Reingold-Tilford algorithm to drawing
	 *       the tree.
	 * @see https://github.com/d3/d3-hierarchy
	 */
	
	/**
	 * Initialize all computational message for following algorithm
	 * @param  {module:echarts/data/Tree~TreeNode} root   The virtual root of the tree
	 */
	function init(root) {
	  root.hierNode = {
	    defaultAncestor: null,
	    ancestor: root,
	    prelim: 0,
	    modifier: 0,
	    change: 0,
	    shift: 0,
	    i: 0,
	    thread: null
	  };
	  var nodes = [root];
	  var node;
	  var children;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    children = node.children;
	
	    if (node.isExpand && children.length) {
	      var n = children.length;
	
	      for (var i = n - 1; i >= 0; i--) {
	        var child = children[i];
	        child.hierNode = {
	          defaultAncestor: null,
	          ancestor: child,
	          prelim: 0,
	          modifier: 0,
	          change: 0,
	          shift: 0,
	          i: i,
	          thread: null
	        };
	        nodes.push(child);
	      }
	    }
	  }
	}
	/**
	 * Computes a preliminary x coordinate for node. Before that, this function is
	 * applied recursively to the children of node, as well as the function
	 * apportion(). After spacing out the children by calling executeShifts(), the
	 * node is placed to the midpoint of its outermost children.
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @param {Function} separation
	 */
	
	
	function firstWalk(node, separation) {
	  var children = node.isExpand ? node.children : [];
	  var siblings = node.parentNode.children;
	  var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;
	
	  if (children.length) {
	    executeShifts(node);
	    var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;
	
	    if (subtreeW) {
	      node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
	      node.hierNode.modifier = node.hierNode.prelim - midPoint;
	    } else {
	      node.hierNode.prelim = midPoint;
	    }
	  } else if (subtreeW) {
	    node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
	  }
	
	  node.parentNode.hierNode.defaultAncestor = apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
	}
	/**
	 * Computes all real x-coordinates by summing up the modifiers recursively.
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 */
	
	
	function secondWalk(node) {
	  var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
	  node.setLayout({
	    x: nodeX
	  }, true);
	  node.hierNode.modifier += node.parentNode.hierNode.modifier;
	}
	
	function separation(cb) {
	  return arguments.length ? cb : defaultSeparation;
	}
	/**
	 * Transform the common coordinate to radial coordinate
	 * @param  {number} x
	 * @param  {number} y
	 * @return {Object}
	 */
	
	
	function radialCoordinate(x, y) {
	  var radialCoor = {};
	  x -= Math.PI / 2;
	  radialCoor.x = y * Math.cos(x);
	  radialCoor.y = y * Math.sin(x);
	  return radialCoor;
	}
	/**
	 * Get the layout position of the whole view
	 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
	 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
	 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
	 */
	
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	/**
	 * All other shifts, applied to the smaller subtrees between w- and w+, are
	 * performed by this function.
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 */
	
	
	function executeShifts(node) {
	  var children = node.children;
	  var n = children.length;
	  var shift = 0;
	  var change = 0;
	
	  while (--n >= 0) {
	    var child = children[n];
	    child.hierNode.prelim += shift;
	    child.hierNode.modifier += shift;
	    change += child.hierNode.change;
	    shift += child.hierNode.shift + change;
	  }
	}
	/**
	 * The core of the algorithm. Here, a new subtree is combined with the
	 * previous subtrees. Threads are used to traverse the inside and outside
	 * contours of the left and right subtree up to the highest common level.
	 * Whenever two nodes of the inside contours conflict, we compute the left
	 * one of the greatest uncommon ancestors using the function nextAncestor()
	 * and call moveSubtree() to shift the subtree and prepare the shifts of
	 * smaller subtrees. Finally, we add a new thread (if necessary).
	 * @param  {module:echarts/data/Tree~TreeNode} subtreeV
	 * @param  {module:echarts/data/Tree~TreeNode} subtreeW
	 * @param  {module:echarts/data/Tree~TreeNode} ancestor
	 * @param  {Function} separation
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function apportion(subtreeV, subtreeW, ancestor, separation) {
	  if (subtreeW) {
	    var nodeOutRight = subtreeV;
	    var nodeInRight = subtreeV;
	    var nodeOutLeft = nodeInRight.parentNode.children[0];
	    var nodeInLeft = subtreeW;
	    var sumOutRight = nodeOutRight.hierNode.modifier;
	    var sumInRight = nodeInRight.hierNode.modifier;
	    var sumOutLeft = nodeOutLeft.hierNode.modifier;
	    var sumInLeft = nodeInLeft.hierNode.modifier;
	
	    while (nodeInLeft = nextRight(nodeInLeft), nodeInRight = nextLeft(nodeInRight), nodeInLeft && nodeInRight) {
	      nodeOutRight = nextRight(nodeOutRight);
	      nodeOutLeft = nextLeft(nodeOutLeft);
	      nodeOutRight.hierNode.ancestor = subtreeV;
	      var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);
	
	      if (shift > 0) {
	        moveSubtree(nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
	        sumInRight += shift;
	        sumOutRight += shift;
	      }
	
	      sumInLeft += nodeInLeft.hierNode.modifier;
	      sumInRight += nodeInRight.hierNode.modifier;
	      sumOutRight += nodeOutRight.hierNode.modifier;
	      sumOutLeft += nodeOutLeft.hierNode.modifier;
	    }
	
	    if (nodeInLeft && !nextRight(nodeOutRight)) {
	      nodeOutRight.hierNode.thread = nodeInLeft;
	      nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
	    }
	
	    if (nodeInRight && !nextLeft(nodeOutLeft)) {
	      nodeOutLeft.hierNode.thread = nodeInRight;
	      nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
	      ancestor = subtreeV;
	    }
	  }
	
	  return ancestor;
	}
	/**
	 * This function is used to traverse the right contour of a subtree.
	 * It returns the rightmost child of node or the thread of node. The function
	 * returns null if and only if node is on the highest depth of its subtree.
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextRight(node) {
	  var children = node.children;
	  return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
	}
	/**
	 * This function is used to traverse the left contour of a subtree (or a subforest).
	 * It returns the leftmost child of node or the thread of node. The function
	 * returns null if and only if node is on the highest depth of its subtree.
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextLeft(node) {
	  var children = node.children;
	  return children.length && node.isExpand ? children[0] : node.hierNode.thread;
	}
	/**
	 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
	 * Otherwise, returns the specified ancestor.
	 * @param  {module:echarts/data/Tree~TreeNode} nodeInLeft
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @param  {module:echarts/data/Tree~TreeNode} ancestor
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextAncestor(nodeInLeft, node, ancestor) {
	  return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
	}
	/**
	 * Shifts the current subtree rooted at wr. This is done by increasing prelim(w+) and modifier(w+) by shift.
	 * @param  {module:echarts/data/Tree~TreeNode} wl
	 * @param  {module:echarts/data/Tree~TreeNode} wr
	 * @param  {number} shift [description]
	 */
	
	
	function moveSubtree(wl, wr, shift) {
	  var change = shift / (wr.hierNode.i - wl.hierNode.i);
	  wr.hierNode.change -= change;
	  wr.hierNode.shift += shift;
	  wr.hierNode.modifier += shift;
	  wr.hierNode.prelim += shift;
	  wl.hierNode.change += change;
	}
	
	function defaultSeparation(node1, node2) {
	  return node1.parentNode === node2.parentNode ? 1 : 2;
	}
	
	exports.init = init;
	exports.firstWalk = firstWalk;
	exports.secondWalk = secondWalk;
	exports.separation = separation;
	exports.radialCoordinate = radialCoordinate;
	exports.getViewRect = getViewRect;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	/**
	 * @param {Object} opt {labelInside}
	 * @return {Object} {
	 *  position, rotation, labelDirection, labelOffset,
	 *  tickDirection, labelRotate, labelInterval, z2
	 * }
	 */
	function layout(gridModel, axisModel, opt) {
	  opt = opt || {};
	  var grid = gridModel.coordinateSystem;
	  var axis = axisModel.axis;
	  var layout = {};
	  var rawAxisPosition = axis.position;
	  var axisPosition = axis.onZero ? 'onZero' : rawAxisPosition;
	  var axisDim = axis.dim;
	  var rect = grid.getRect();
	  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
	  var idx = {
	    left: 0,
	    right: 1,
	    top: 0,
	    bottom: 1,
	    onZero: 2
	  };
	  var axisOffset = axisModel.get('offset') || 0;
	  var posBound = axisDim === 'x' ? [rectBound[2] - axisOffset, rectBound[3] + axisOffset] : [rectBound[0] - axisOffset, rectBound[1] + axisOffset];
	
	  if (axis.onZero) {
	    var otherAxis = grid.getAxis(axisDim === 'x' ? 'y' : 'x', axis.onZeroAxisIndex);
	    var onZeroCoord = otherAxis.toGlobalCoord(otherAxis.dataToCoord(0));
	    posBound[idx['onZero']] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
	  } // Axis position
	
	
	  layout.position = [axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0], axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]]; // Axis rotation
	
	  layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim
	
	  var dirMap = {
	    top: -1,
	    bottom: 1,
	    left: -1,
	    right: 1
	  };
	  layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
	  layout.labelOffset = axis.onZero ? posBound[idx[rawAxisPosition]] - posBound[idx['onZero']] : 0;
	
	  if (axisModel.get('axisTick.inside')) {
	    layout.tickDirection = -layout.tickDirection;
	  }
	
	  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
	    layout.labelDirection = -layout.labelDirection;
	  } // Special label rotation
	
	
	  var labelRotate = axisModel.get('axisLabel.rotate');
	  layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // label interval when auto mode.
	
	  layout.labelInterval = axis.getLabelInterval(); // Over splitLine and splitArea
	
	  layout.z2 = 1;
	  return layout;
	}
	
	exports.layout = layout;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	/**
	 * @param {Object} opt {labelInside}
	 * @return {Object} {
	 *  position, rotation, labelDirection, labelOffset,
	 *  tickDirection, labelRotate, labelInterval, z2
	 * }
	 */
	function layout(axisModel, opt) {
	  opt = opt || {};
	  var single = axisModel.coordinateSystem;
	  var axis = axisModel.axis;
	  var layout = {};
	  var axisPosition = axis.position;
	  var orient = axis.orient;
	  var rect = single.getRect();
	  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
	  var positionMap = {
	    horizontal: {
	      top: rectBound[2],
	      bottom: rectBound[3]
	    },
	    vertical: {
	      left: rectBound[0],
	      right: rectBound[1]
	    }
	  };
	  layout.position = [orient === 'vertical' ? positionMap.vertical[axisPosition] : rectBound[0], orient === 'horizontal' ? positionMap.horizontal[axisPosition] : rectBound[3]];
	  var r = {
	    horizontal: 0,
	    vertical: 1
	  };
	  layout.rotation = Math.PI / 2 * r[orient];
	  var directionMap = {
	    top: -1,
	    bottom: 1,
	    right: 1,
	    left: -1
	  };
	  layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];
	
	  if (axisModel.get('axisTick.inside')) {
	    layout.tickDirection = -layout.tickDirection;
	  }
	
	  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
	    layout.labelDirection = -layout.labelDirection;
	  }
	
	  var labelRotation = opt.rotate;
	  labelRotation == null && (labelRotation = axisModel.get('axisLabel.rotate'));
	  layout.labelRotation = axisPosition === 'top' ? -labelRotation : labelRotation;
	  layout.labelInterval = axis.getLabelInterval();
	  layout.z2 = 1;
	  return layout;
	}
	
	exports.layout = layout;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	var graphic = __webpack_require__(3);
	
	var BaseAxisPointer = __webpack_require__(118);
	
	var viewHelper = __webpack_require__(86);
	
	var cartesianAxisHelper = __webpack_require__(167);
	
	var AxisView = __webpack_require__(44);
	
	var CartesianAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	    var grid = axis.grid;
	    var axisPointerType = axisPointerModel.get('type');
	    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
	    var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent, elStyle);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var layoutInfo = cartesianAxisHelper.layout(grid.model, axisModel);
	    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
	  },
	
	  /**
	   * @override
	   */
	  getHandleTransform: function (value, axisModel, axisPointerModel) {
	    var layoutInfo = cartesianAxisHelper.layout(axisModel.axis.grid.model, axisModel, {
	      labelInside: false
	    });
	    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
	    return {
	      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
	      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
	    };
	  },
	
	  /**
	   * @override
	   */
	  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
	    var axis = axisModel.axis;
	    var grid = axis.grid;
	    var axisExtent = axis.getGlobalExtent(true);
	    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
	    var dimIndex = axis.dim === 'x' ? 0 : 1;
	    var currPosition = transform.position;
	    currPosition[dimIndex] += delta[dimIndex];
	    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
	    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
	    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
	    var cursorPoint = [cursorOtherValue, cursorOtherValue];
	    cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.
	
	    var tooltipOptions = [{
	      verticalAlign: 'middle'
	    }, {
	      align: 'center'
	    }];
	    return {
	      position: currPosition,
	      rotation: transform.rotation,
	      cursorPoint: cursorPoint,
	      tooltipOption: tooltipOptions[dimIndex]
	    };
	  }
	});
	
	function getCartesian(grid, axis) {
	  var opt = {};
	  opt[axis.dim + 'AxisIndex'] = axis.index;
	  return grid.getCartesian(opt);
	}
	
	var pointerShapeBuilder = {
	  line: function (axis, pixelValue, otherExtent, elStyle) {
	    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getAxisDimIndex(axis));
	    graphic.subPixelOptimizeLine({
	      shape: targetShape,
	      style: elStyle
	    });
	    return {
	      type: 'Line',
	      shape: targetShape
	    };
	  },
	  shadow: function (axis, pixelValue, otherExtent, elStyle) {
	    var bandWidth = axis.getBandWidth();
	    var span = otherExtent[1] - otherExtent[0];
	    return {
	      type: 'Rect',
	      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getAxisDimIndex(axis))
	    };
	  }
	};
	
	function getAxisDimIndex(axis) {
	  return axis.dim === 'x' ? 0 : 1;
	}
	
	AxisView.registerAxisPointerClass('CartesianAxisPointer', CartesianAxisPointer);
	var _default = CartesianAxisPointer;
	module.exports = _default;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var modelUtil = __webpack_require__(6);
	
	/**
	 * @param {Object} finder contains {seriesIndex, dataIndex, dataIndexInside}
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object} {point: [x, y], el: ...} point Will not be null.
	 */
	function _default(finder, ecModel) {
	  var point = [];
	  var seriesIndex = finder.seriesIndex;
	  var seriesModel;
	
	  if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) {
	    return {
	      point: []
	    };
	  }
	
	  var data = seriesModel.getData();
	  var dataIndex = modelUtil.queryDataIndex(data, finder);
	
	  if (dataIndex == null || zrUtil.isArray(dataIndex)) {
	    return {
	      point: []
	    };
	  }
	
	  var el = data.getItemGraphicEl(dataIndex);
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (seriesModel.getTooltipPosition) {
	    point = seriesModel.getTooltipPosition(dataIndex) || [];
	  } else if (coordSys && coordSys.dataToPoint) {
	    point = coordSys.dataToPoint(data.getValues(zrUtil.map(coordSys.dimensions, function (dim) {
	      return seriesModel.coordDimToDataDim(dim)[0];
	    }), dataIndex, true)) || [];
	  } else if (el) {
	    // Use graphic bounding rect
	    var rect = el.getBoundingRect().clone();
	    rect.applyTransform(el.transform);
	    point = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  }
	
	  return {
	    point: point,
	    el: el
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var env = __webpack_require__(18);
	
	var modelUtil = __webpack_require__(6);
	
	var get = modelUtil.makeGetter();
	var each = zrUtil.each;
	/**
	 * @param {string} key
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Function} handler
	 *      param: {string} currTrigger
	 *      param: {Array.<number>} point
	 */
	
	function register(key, api, handler) {
	  if (env.node) {
	    return;
	  }
	
	  var zr = api.getZr();
	  get(zr).records || (get(zr).records = {});
	  initGlobalListeners(zr, api);
	  var record = get(zr).records[key] || (get(zr).records[key] = {});
	  record.handler = handler;
	}
	
	function initGlobalListeners(zr, api) {
	  if (get(zr).initialized) {
	    return;
	  }
	
	  get(zr).initialized = true;
	  useHandler('click', zrUtil.curry(doEnter, 'click'));
	  useHandler('mousemove', zrUtil.curry(doEnter, 'mousemove')); // useHandler('mouseout', onLeave);
	
	  useHandler('globalout', onLeave);
	
	  function useHandler(eventType, cb) {
	    zr.on(eventType, function (e) {
	      var dis = makeDispatchAction(api);
	      each(get(zr).records, function (record) {
	        record && cb(record, e, dis.dispatchAction);
	      });
	      dispatchTooltipFinally(dis.pendings, api);
	    });
	  }
	}
	
	function dispatchTooltipFinally(pendings, api) {
	  var showLen = pendings.showTip.length;
	  var hideLen = pendings.hideTip.length;
	  var actuallyPayload;
	
	  if (showLen) {
	    actuallyPayload = pendings.showTip[showLen - 1];
	  } else if (hideLen) {
	    actuallyPayload = pendings.hideTip[hideLen - 1];
	  }
	
	  if (actuallyPayload) {
	    actuallyPayload.dispatchAction = null;
	    api.dispatchAction(actuallyPayload);
	  }
	}
	
	function onLeave(record, e, dispatchAction) {
	  record.handler('leave', null, dispatchAction);
	}
	
	function doEnter(currTrigger, record, e, dispatchAction) {
	  record.handler(currTrigger, e, dispatchAction);
	}
	
	function makeDispatchAction(api) {
	  var pendings = {
	    showTip: [],
	    hideTip: []
	  }; // FIXME
	  // better approach?
	  // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
	  // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
	  // So we have to add "final stage" to merge those dispatched actions.
	
	  var dispatchAction = function (payload) {
	    var pendingList = pendings[payload.type];
	
	    if (pendingList) {
	      pendingList.push(payload);
	    } else {
	      payload.dispatchAction = dispatchAction;
	      api.dispatchAction(payload);
	    }
	  };
	
	  return {
	    dispatchAction: dispatchAction,
	    pendings: pendings
	  };
	}
	/**
	 * @param {string} key
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	function unregister(key, api) {
	  if (env.node) {
	    return;
	  }
	
	  var zr = api.getZr();
	  var record = (get(zr).records || {})[key];
	
	  if (record) {
	    get(zr).records[key] = null;
	  }
	}
	
	exports.register = register;
	exports.unregister = unregister;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var helper = __webpack_require__(119);
	
	echarts.registerAction('dataZoom', function (payload, ecModel) {
	  var linkedNodesFinder = helper.createLinkedNodesFinder(zrUtil.bind(ecModel.eachComponent, ecModel, 'dataZoom'), helper.eachAxisDim, function (model, dimNames) {
	    return model.get(dimNames.axisIndex);
	  });
	  var effectedModels = [];
	  ecModel.eachComponent({
	    mainType: 'dataZoom',
	    query: payload
	  }, function (model, index) {
	    effectedModels.push.apply(effectedModels, linkedNodesFinder(model).nodes);
	  });
	  zrUtil.each(effectedModels, function (dataZoomModel, index) {
	    dataZoomModel.setRawRange({
	      start: payload.start,
	      end: payload.end,
	      startValue: payload.startValue,
	      endValue: payload.endValue
	    });
	  });
	});

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	echarts.registerProcessor(function (ecModel, api) {
	  ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	    // We calculate window and reset axis here but not in model
	    // init stage and not after action dispatch handler, because
	    // reset should be called after seriesData.restoreData.
	    dataZoomModel.eachTargetAxis(resetSingleAxis); // Caution: data zoom filtering is order sensitive when using
	    // percent range and no min/max/scale set on axis.
	    // For example, we have dataZoom definition:
	    // [
	    //      {xAxisIndex: 0, start: 30, end: 70},
	    //      {yAxisIndex: 0, start: 20, end: 80}
	    // ]
	    // In this case, [20, 80] of y-dataZoom should be based on data
	    // that have filtered by x-dataZoom using range of [30, 70],
	    // but should not be based on full raw data. Thus sliding
	    // x-dataZoom will change both ranges of xAxis and yAxis,
	    // while sliding y-dataZoom will only change the range of yAxis.
	    // So we should filter x-axis after reset x-axis immediately,
	    // and then reset y-axis and filter y-axis.
	
	    dataZoomModel.eachTargetAxis(filterSingleAxis);
	  });
	  ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	    // Fullfill all of the range props so that user
	    // is able to get them from chart.getOption().
	    var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
	    var percentRange = axisProxy.getDataPercentWindow();
	    var valueRange = axisProxy.getDataValueWindow();
	    dataZoomModel.setRawRange({
	      start: percentRange[0],
	      end: percentRange[1],
	      startValue: valueRange[0],
	      endValue: valueRange[1]
	    }, true);
	  });
	});
	
	function resetSingleAxis(dimNames, axisIndex, dataZoomModel) {
	  dataZoomModel.getAxisProxy(dimNames.name, axisIndex).reset(dataZoomModel);
	}
	
	function filterSingleAxis(dimNames, axisIndex, dataZoomModel) {
	  dataZoomModel.getAxisProxy(dimNames.name, axisIndex).filterData(dataZoomModel);
	}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var each = zrUtil.each;
	var ATTR = '\0_ec_hist_store';
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} newSnapshot {dataZoomId, batch: [payloadInfo, ...]}
	 */
	
	function push(ecModel, newSnapshot) {
	  var store = giveStore(ecModel); // If previous dataZoom can not be found,
	  // complete an range with current range.
	
	  each(newSnapshot, function (batchItem, dataZoomId) {
	    var i = store.length - 1;
	
	    for (; i >= 0; i--) {
	      var snapshot = store[i];
	
	      if (snapshot[dataZoomId]) {
	        break;
	      }
	    }
	
	    if (i < 0) {
	      // No origin range set, create one by current range.
	      var dataZoomModel = ecModel.queryComponents({
	        mainType: 'dataZoom',
	        subType: 'select',
	        id: dataZoomId
	      })[0];
	
	      if (dataZoomModel) {
	        var percentRange = dataZoomModel.getPercentRange();
	        store[0][dataZoomId] = {
	          dataZoomId: dataZoomId,
	          start: percentRange[0],
	          end: percentRange[1]
	        };
	      }
	    }
	  });
	  store.push(newSnapshot);
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object} snapshot
	 */
	
	
	function pop(ecModel) {
	  var store = giveStore(ecModel);
	  var head = store[store.length - 1];
	  store.length > 1 && store.pop(); // Find top for all dataZoom.
	
	  var snapshot = {};
	  each(head, function (batchItem, dataZoomId) {
	    for (var i = store.length - 1; i >= 0; i--) {
	      var batchItem = store[i][dataZoomId];
	
	      if (batchItem) {
	        snapshot[dataZoomId] = batchItem;
	        break;
	      }
	    }
	  });
	  return snapshot;
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 */
	
	
	function clear(ecModel) {
	  ecModel[ATTR] = null;
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @return {number} records. always >= 1.
	 */
	
	
	function count(ecModel) {
	  return giveStore(ecModel).length;
	}
	/**
	 * [{key: dataZoomId, value: {dataZoomId, range}}, ...]
	 * History length of each dataZoom may be different.
	 * this._history[0] is used to store origin range.
	 * @type {Array.<Object>}
	 */
	
	
	function giveStore(ecModel) {
	  var store = ecModel[ATTR];
	
	  if (!store) {
	    store = ecModel[ATTR] = [{}];
	  }
	
	  return store;
	}
	
	exports.push = push;
	exports.pop = pop;
	exports.clear = clear;
	exports.count = count;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(16);
	
	Component.registerSubTypeDefaulter('dataZoom', function () {
	  // Default 'slider' when no type specified.
	  return 'slider';
	});

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var modelUtil = __webpack_require__(6);
	
	var brushHelper = __webpack_require__(178);
	
	var each = zrUtil.each;
	var indexOf = zrUtil.indexOf;
	var curry = zrUtil.curry;
	var COORD_CONVERTS = ['dataToPoint', 'pointToData']; // FIXME
	// how to genarialize to more coordinate systems.
	
	var INCLUDE_FINDER_MAIN_TYPES = ['grid', 'xAxis', 'yAxis', 'geo', 'graph', 'polar', 'radiusAxis', 'angleAxis', 'bmap'];
	/**
	 * [option in constructor]:
	 * {
	 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
	 * }
	 *
	 *
	 * [targetInfo]:
	 *
	 * There can be multiple axes in a single targetInfo. Consider the case
	 * of `grid` component, a targetInfo represents a grid which contains one or more
	 * cartesian and one or more axes. And consider the case of parallel system,
	 * which has multiple axes in a coordinate system.
	 * Can be {
	 *     panelId: ...,
	 *     coordSys: <a representitive cartesian in grid (first cartesian by default)>,
	 *     coordSyses: all cartesians.
	 *     gridModel: <grid component>
	 *     xAxes: correspond to coordSyses on index
	 *     yAxes: correspond to coordSyses on index
	 * }
	 * or {
	 *     panelId: ...,
	 *     coordSys: <geo coord sys>
	 *     coordSyses: [<geo coord sys>]
	 *     geoModel: <geo component>
	 * }
	 *
	 *
	 * [panelOpt]:
	 *
	 * Make from targetInfo. Input to BrushController.
	 * {
	 *     panelId: ...,
	 *     rect: ...
	 * }
	 *
	 *
	 * [area]:
	 *
	 * Generated by BrushController or user input.
	 * {
	 *     panelId: Used to locate coordInfo directly. If user inpput, no panelId.
	 *     brushType: determine how to convert to/from coord('rect' or 'polygon' or 'lineX/Y').
	 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
	 *     range: pixel range.
	 *     coordRange: representitive coord range (the first one of coordRanges).
	 *     coordRanges: <Array> coord ranges, used in multiple cartesian in one grid.
	 * }
	 */
	
	/**
	 * @param {Object} option contains Index/Id/Name of xAxis/yAxis/geo/grid
	 *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} [opt]
	 * @param {Array.<string>} [opt.include] include coordinate system types.
	 */
	
	function BrushTargetManager(option, ecModel, opt) {
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	  var targetInfoList = this._targetInfoList = [];
	  var info = {};
	  var foundCpts = parseFinder(ecModel, option);
	  each(targetInfoBuilders, function (builder, type) {
	    if (!opt || !opt.include || indexOf(opt.include, type) >= 0) {
	      builder(foundCpts, targetInfoList, info);
	    }
	  });
	}
	
	var proto = BrushTargetManager.prototype;
	
	proto.setOutputRanges = function (areas, ecModel) {
	  this.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
	    (area.coordRanges || (area.coordRanges = [])).push(coordRange); // area.coordRange is the first of area.coordRanges
	
	    if (!area.coordRange) {
	      area.coordRange = coordRange; // In 'category' axis, coord to pixel is not reversible, so we can not
	      // rebuild range by coordRange accrately, which may bring trouble when
	      // brushing only one item. So we use __rangeOffset to rebuilding range
	      // by coordRange. And this it only used in brush component so it is no
	      // need to be adapted to coordRanges.
	
	      var result = coordConvert[area.brushType](0, coordSys, coordRange);
	      area.__rangeOffset = {
	        offset: diffProcessor[area.brushType](result.values, area.range, [1, 1]),
	        xyMinMax: result.xyMinMax
	      };
	    }
	  });
	};
	
	proto.matchOutputRanges = function (areas, ecModel, cb) {
	  each(areas, function (area) {
	    var targetInfo = this.findTargetInfo(area, ecModel);
	
	    if (targetInfo && targetInfo !== true) {
	      zrUtil.each(targetInfo.coordSyses, function (coordSys) {
	        var result = coordConvert[area.brushType](1, coordSys, area.range);
	        cb(area, result.values, coordSys, ecModel);
	      });
	    }
	  }, this);
	};
	
	proto.setInputRanges = function (areas, ecModel) {
	  each(areas, function (area) {
	    var targetInfo = this.findTargetInfo(area, ecModel);
	    area.range = area.range || []; // convert coordRange to global range and set panelId.
	
	    if (targetInfo && targetInfo !== true) {
	      area.panelId = targetInfo.panelId; // (1) area.range shoule always be calculate from coordRange but does
	      // not keep its original value, for the sake of the dataZoom scenario,
	      // where area.coordRange remains unchanged but area.range may be changed.
	      // (2) Only support converting one coordRange to pixel range in brush
	      // component. So do not consider `coordRanges`.
	      // (3) About __rangeOffset, see comment above.
	
	      var result = coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
	      var rangeOffset = area.__rangeOffset;
	      area.range = rangeOffset ? diffProcessor[area.brushType](result.values, rangeOffset.offset, getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
	    }
	  }, this);
	};
	
	proto.makePanelOpts = function (api, getDefaultBrushType) {
	  return zrUtil.map(this._targetInfoList, function (targetInfo) {
	    var rect = targetInfo.getPanelRect();
	    return {
	      panelId: targetInfo.panelId,
	      defaultBrushType: getDefaultBrushType && getDefaultBrushType(targetInfo),
	      clipPath: brushHelper.makeRectPanelClipPath(rect),
	      isTargetByCursor: brushHelper.makeRectIsTargetByCursor(rect, api, targetInfo.coordSysModel),
	      getLinearBrushOtherExtent: brushHelper.makeLinearBrushOtherExtent(rect)
	    };
	  });
	};
	
	proto.controlSeries = function (area, seriesModel, ecModel) {
	  // Check whether area is bound in coord, and series do not belong to that coord.
	  // If do not do this check, some brush (like lineX) will controll all axes.
	  var targetInfo = this.findTargetInfo(area, ecModel);
	  return targetInfo === true || targetInfo && indexOf(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
	};
	/**
	 * If return Object, a coord found.
	 * If reutrn true, global found.
	 * Otherwise nothing found.
	 *
	 * @param {Object} area
	 * @param {Array} targetInfoList
	 * @return {Object|boolean}
	 */
	
	
	proto.findTargetInfo = function (area, ecModel) {
	  var targetInfoList = this._targetInfoList;
	  var foundCpts = parseFinder(ecModel, area);
	
	  for (var i = 0; i < targetInfoList.length; i++) {
	    var targetInfo = targetInfoList[i];
	    var areaPanelId = area.panelId;
	
	    if (areaPanelId) {
	      if (targetInfo.panelId === areaPanelId) {
	        return targetInfo;
	      }
	    } else {
	      for (var i = 0; i < targetInfoMatchers.length; i++) {
	        if (targetInfoMatchers[i](foundCpts, targetInfo)) {
	          return targetInfo;
	        }
	      }
	    }
	  }
	
	  return true;
	};
	
	function formatMinMax(minMax) {
	  minMax[0] > minMax[1] && minMax.reverse();
	  return minMax;
	}
	
	function parseFinder(ecModel, option) {
	  return modelUtil.parseFinder(ecModel, option, {
	    includeMainTypes: INCLUDE_FINDER_MAIN_TYPES
	  });
	}
	
	var targetInfoBuilders = {
	  grid: function (foundCpts, targetInfoList) {
	    var xAxisModels = foundCpts.xAxisModels;
	    var yAxisModels = foundCpts.yAxisModels;
	    var gridModels = foundCpts.gridModels; // Remove duplicated.
	
	    var gridModelMap = zrUtil.createHashMap();
	    var xAxesHas = {};
	    var yAxesHas = {};
	
	    if (!xAxisModels && !yAxisModels && !gridModels) {
	      return;
	    }
	
	    each(xAxisModels, function (axisModel) {
	      var gridModel = axisModel.axis.grid.model;
	      gridModelMap.set(gridModel.id, gridModel);
	      xAxesHas[gridModel.id] = true;
	    });
	    each(yAxisModels, function (axisModel) {
	      var gridModel = axisModel.axis.grid.model;
	      gridModelMap.set(gridModel.id, gridModel);
	      yAxesHas[gridModel.id] = true;
	    });
	    each(gridModels, function (gridModel) {
	      gridModelMap.set(gridModel.id, gridModel);
	      xAxesHas[gridModel.id] = true;
	      yAxesHas[gridModel.id] = true;
	    });
	    gridModelMap.each(function (gridModel) {
	      var grid = gridModel.coordinateSystem;
	      var cartesians = [];
	      each(grid.getCartesians(), function (cartesian, index) {
	        if (indexOf(xAxisModels, cartesian.getAxis('x').model) >= 0 || indexOf(yAxisModels, cartesian.getAxis('y').model) >= 0) {
	          cartesians.push(cartesian);
	        }
	      });
	      targetInfoList.push({
	        panelId: 'grid--' + gridModel.id,
	        gridModel: gridModel,
	        coordSysModel: gridModel,
	        // Use the first one as the representitive coordSys.
	        coordSys: cartesians[0],
	        coordSyses: cartesians,
	        getPanelRect: panelRectBuilder.grid,
	        xAxisDeclared: xAxesHas[gridModel.id],
	        yAxisDeclared: yAxesHas[gridModel.id]
	      });
	    });
	  },
	  geo: function (foundCpts, targetInfoList) {
	    each(foundCpts.geoModels, function (geoModel) {
	      var coordSys = geoModel.coordinateSystem;
	      targetInfoList.push({
	        panelId: 'geo--' + geoModel.id,
	        geoModel: geoModel,
	        coordSysModel: geoModel,
	        coordSys: coordSys,
	        coordSyses: [coordSys],
	        getPanelRect: panelRectBuilder.geo
	      });
	    });
	  }
	};
	var targetInfoMatchers = [// grid
	function (foundCpts, targetInfo) {
	  var xAxisModel = foundCpts.xAxisModel;
	  var yAxisModel = foundCpts.yAxisModel;
	  var gridModel = foundCpts.gridModel;
	  !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
	  !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
	  return gridModel && gridModel === targetInfo.gridModel;
	}, // geo
	function (foundCpts, targetInfo) {
	  var geoModel = foundCpts.geoModel;
	  return geoModel && geoModel === targetInfo.geoModel;
	}];
	var panelRectBuilder = {
	  grid: function () {
	    // grid is not Transformable.
	    return this.coordSys.grid.getRect().clone();
	  },
	  geo: function () {
	    var coordSys = this.coordSys;
	    var rect = coordSys.getBoundingRect().clone(); // geo roam and zoom transform
	
	    rect.applyTransform(graphic.getTransform(coordSys));
	    return rect;
	  }
	};
	var coordConvert = {
	  lineX: curry(axisConvert, 0),
	  lineY: curry(axisConvert, 1),
	  rect: function (to, coordSys, rangeOrCoordRange) {
	    var xminymin = coordSys[COORD_CONVERTS[to]]([rangeOrCoordRange[0][0], rangeOrCoordRange[1][0]]);
	    var xmaxymax = coordSys[COORD_CONVERTS[to]]([rangeOrCoordRange[0][1], rangeOrCoordRange[1][1]]);
	    var values = [formatMinMax([xminymin[0], xmaxymax[0]]), formatMinMax([xminymin[1], xmaxymax[1]])];
	    return {
	      values: values,
	      xyMinMax: values
	    };
	  },
	  polygon: function (to, coordSys, rangeOrCoordRange) {
	    var xyMinMax = [[Infinity, -Infinity], [Infinity, -Infinity]];
	    var values = zrUtil.map(rangeOrCoordRange, function (item) {
	      var p = coordSys[COORD_CONVERTS[to]](item);
	      xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
	      xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
	      xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
	      xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
	      return p;
	    });
	    return {
	      values: values,
	      xyMinMax: xyMinMax
	    };
	  }
	};
	
	function axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
	  var axis = coordSys.getAxis(['x', 'y'][axisNameIndex]);
	  var values = formatMinMax(zrUtil.map([0, 1], function (i) {
	    return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i])) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
	  }));
	  var xyMinMax = [];
	  xyMinMax[axisNameIndex] = values;
	  xyMinMax[1 - axisNameIndex] = [NaN, NaN];
	  return {
	    values: values,
	    xyMinMax: xyMinMax
	  };
	}
	
	var diffProcessor = {
	  lineX: curry(axisDiffProcessor, 0),
	  lineY: curry(axisDiffProcessor, 1),
	  rect: function (values, refer, scales) {
	    return [[values[0][0] - scales[0] * refer[0][0], values[0][1] - scales[0] * refer[0][1]], [values[1][0] - scales[1] * refer[1][0], values[1][1] - scales[1] * refer[1][1]]];
	  },
	  polygon: function (values, refer, scales) {
	    return zrUtil.map(values, function (item, idx) {
	      return [item[0] - scales[0] * refer[idx][0], item[1] - scales[1] * refer[idx][1]];
	    });
	  }
	};
	
	function axisDiffProcessor(axisNameIndex, values, refer, scales) {
	  return [values[0] - scales[axisNameIndex] * refer[0], values[1] - scales[axisNameIndex] * refer[1]];
	} // We have to process scale caused by dataZoom manually,
	// although it might be not accurate.
	
	
	function getScales(xyMinMaxCurr, xyMinMaxOrigin) {
	  var sizeCurr = getSize(xyMinMaxCurr);
	  var sizeOrigin = getSize(xyMinMaxOrigin);
	  var scales = [sizeCurr[0] / sizeOrigin[0], sizeCurr[1] / sizeOrigin[1]];
	  isNaN(scales[0]) && (scales[0] = 1);
	  isNaN(scales[1]) && (scales[1] = 1);
	  return scales;
	}
	
	function getSize(xyMinMax) {
	  return xyMinMax ? [xyMinMax[0][1] - xyMinMax[0][0], xyMinMax[1][1] - xyMinMax[1][0]] : [NaN, NaN];
	}
	
	var _default = BrushTargetManager;
	module.exports = _default;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var RoamController = __webpack_require__(87);
	
	var roamHelper = __webpack_require__(181);
	
	var _cursorHelper = __webpack_require__(121);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphic = __webpack_require__(3);
	
	function getFixedItemStyle(model, scale) {
	  var itemStyle = model.getItemStyle();
	  var areaColor = model.get('areaColor'); // If user want the color not to be changed when hover,
	  // they should both set areaColor and color to be null.
	
	  if (areaColor != null) {
	    itemStyle.fill = areaColor;
	  }
	
	  return itemStyle;
	}
	
	function updateMapSelectHandler(mapDraw, mapOrGeoModel, group, api, fromView) {
	  group.off('click');
	  group.off('mousedown');
	
	  if (mapOrGeoModel.get('selectedMode')) {
	    group.on('mousedown', function () {
	      mapDraw._mouseDownFlag = true;
	    });
	    group.on('click', function (e) {
	      if (!mapDraw._mouseDownFlag) {
	        return;
	      }
	
	      mapDraw._mouseDownFlag = false;
	      var el = e.target;
	
	      while (!el.__regions) {
	        el = el.parent;
	      }
	
	      if (!el) {
	        return;
	      }
	
	      var action = {
	        type: (mapOrGeoModel.mainType === 'geo' ? 'geo' : 'map') + 'ToggleSelect',
	        batch: zrUtil.map(el.__regions, function (region) {
	          return {
	            name: region.name,
	            from: fromView.uid
	          };
	        })
	      };
	      action[mapOrGeoModel.mainType + 'Id'] = mapOrGeoModel.id;
	      api.dispatchAction(action);
	      updateMapSelected(mapOrGeoModel, group);
	    });
	  }
	}
	
	function updateMapSelected(mapOrGeoModel, group) {
	  // FIXME
	  group.eachChild(function (otherRegionEl) {
	    zrUtil.each(otherRegionEl.__regions, function (region) {
	      otherRegionEl.trigger(mapOrGeoModel.isSelected(region.name) ? 'emphasis' : 'normal');
	    });
	  });
	}
	/**
	 * @alias module:echarts/component/helper/MapDraw
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {boolean} updateGroup
	 */
	
	
	function MapDraw(api, updateGroup) {
	  var group = new graphic.Group();
	  /**
	   * @type {module:echarts/component/helper/RoamController}
	   * @private
	   */
	
	  this._controller = new RoamController(api.getZr());
	  /**
	   * @type {Object} {target, zoom, zoomLimit}
	   * @private
	   */
	
	  this._controllerHost = {
	    target: updateGroup ? group : null
	  };
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	
	  this.group = group;
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._updateGroup = updateGroup;
	  /**
	   * This flag is used to make sure that only one among
	   * `pan`, `zoom`, `click` can occurs, otherwise 'selected'
	   * action may be triggered when `pan`, which is unexpected.
	   * @type {booelan}
	   */
	
	  this._mouseDownFlag;
	}
	
	MapDraw.prototype = {
	  constructor: MapDraw,
	  draw: function (mapOrGeoModel, ecModel, api, fromView, payload) {
	    var isGeo = mapOrGeoModel.mainType === 'geo'; // Map series has data. GEO model that controlled by map series
	    // will be assigned with map data. Other GEO model has no data.
	
	    var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
	    isGeo && ecModel.eachComponent({
	      mainType: 'series',
	      subType: 'map'
	    }, function (mapSeries) {
	      if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) {
	        data = mapSeries.getData();
	      }
	    });
	    var geo = mapOrGeoModel.coordinateSystem;
	    var group = this.group;
	    var scale = geo.scale;
	    var groupNewProp = {
	      position: geo.position,
	      scale: scale
	    }; // No animation when first draw or in action
	
	    if (!group.childAt(0) || payload) {
	      group.attr(groupNewProp);
	    } else {
	      graphic.updateProps(group, groupNewProp, mapOrGeoModel);
	    }
	
	    group.removeAll();
	    var itemStyleAccessPath = ['itemStyle', 'normal'];
	    var hoverItemStyleAccessPath = ['itemStyle', 'emphasis'];
	    var labelAccessPath = ['label', 'normal'];
	    var hoverLabelAccessPath = ['label', 'emphasis'];
	    var nameMap = zrUtil.createHashMap();
	    zrUtil.each(geo.regions, function (region) {
	      // Consider in GeoJson properties.name may be duplicated, for example,
	      // there is multiple region named "United Kindom" or "France" (so many
	      // colonies). And it is not appropriate to merge them in geo, which
	      // will make them share the same label and bring trouble in label
	      // location calculation.
	      var regionGroup = nameMap.get(region.name) || nameMap.set(region.name, new graphic.Group());
	      var compoundPath = new graphic.CompoundPath({
	        shape: {
	          paths: []
	        }
	      });
	      regionGroup.add(compoundPath);
	      var regionModel = mapOrGeoModel.getRegionModel(region.name) || mapOrGeoModel;
	      var itemStyleModel = regionModel.getModel(itemStyleAccessPath);
	      var hoverItemStyleModel = regionModel.getModel(hoverItemStyleAccessPath);
	      var itemStyle = getFixedItemStyle(itemStyleModel, scale);
	      var hoverItemStyle = getFixedItemStyle(hoverItemStyleModel, scale);
	      var labelModel = regionModel.getModel(labelAccessPath);
	      var hoverLabelModel = regionModel.getModel(hoverLabelAccessPath);
	      var dataIdx; // Use the itemStyle in data if has data
	
	      if (data) {
	        dataIdx = data.indexOfName(region.name); // Only visual color of each item will be used. It can be encoded by dataRange
	        // But visual color of series is used in symbol drawing
	        //
	        // Visual color for each series is for the symbol draw
	
	        var visualColor = data.getItemVisual(dataIdx, 'color', true);
	
	        if (visualColor) {
	          itemStyle.fill = visualColor;
	        }
	      }
	
	      zrUtil.each(region.geometries, function (geometry) {
	        if (geometry.type !== 'polygon') {
	          return;
	        }
	
	        compoundPath.shape.paths.push(new graphic.Polygon({
	          shape: {
	            points: geometry.exterior
	          }
	        }));
	
	        for (var i = 0; i < (geometry.interiors ? geometry.interiors.length : 0); i++) {
	          compoundPath.shape.paths.push(new graphic.Polygon({
	            shape: {
	              points: geometry.interiors[i]
	            }
	          }));
	        }
	      });
	      compoundPath.setStyle(itemStyle);
	      compoundPath.style.strokeNoScale = true;
	      compoundPath.culling = true; // Label
	
	      var showLabel = labelModel.get('show');
	      var hoverShowLabel = hoverLabelModel.get('show');
	      var isDataNaN = data && isNaN(data.get('value', dataIdx));
	      var itemLayout = data && data.getItemLayout(dataIdx); // In the following cases label will be drawn
	      // 1. In map series and data value is NaN
	      // 2. In geo component
	      // 4. Region has no series legendSymbol, which will be add a showLabel flag in mapSymbolLayout
	
	      if (isGeo || isDataNaN && (showLabel || hoverShowLabel) || itemLayout && itemLayout.showLabel) {
	        var query = !isGeo ? dataIdx : region.name;
	        var labelFetcher; // Consider dataIdx not found.
	
	        if (!data || dataIdx >= 0) {
	          labelFetcher = mapOrGeoModel;
	        }
	
	        var textEl = new graphic.Text({
	          position: region.center.slice(),
	          scale: [1 / scale[0], 1 / scale[1]],
	          z2: 10,
	          silent: true
	        });
	        graphic.setLabelStyle(textEl.style, textEl.hoverStyle = {}, labelModel, hoverLabelModel, {
	          labelFetcher: labelFetcher,
	          labelDataIndex: query,
	          defaultText: region.name,
	          useInsideStyle: false
	        }, {
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        });
	        regionGroup.add(textEl);
	      } // setItemGraphicEl, setHoverStyle after all polygons and labels
	      // are added to the rigionGroup
	
	
	      if (data) {
	        data.setItemGraphicEl(dataIdx, regionGroup);
	      } else {
	        var regionModel = mapOrGeoModel.getRegionModel(region.name); // Package custom mouse event for geo component
	
	        compoundPath.eventData = {
	          componentType: 'geo',
	          geoIndex: mapOrGeoModel.componentIndex,
	          name: region.name,
	          region: regionModel && regionModel.option || {}
	        };
	      }
	
	      var groupRegions = regionGroup.__regions || (regionGroup.__regions = []);
	      groupRegions.push(region);
	      graphic.setHoverStyle(regionGroup, hoverItemStyle, {
	        hoverSilentOnTouch: !!mapOrGeoModel.get('selectedMode')
	      });
	      group.add(regionGroup);
	    });
	
	    this._updateController(mapOrGeoModel, ecModel, api);
	
	    updateMapSelectHandler(this, mapOrGeoModel, group, api, fromView);
	    updateMapSelected(mapOrGeoModel, group);
	  },
	  remove: function () {
	    this.group.removeAll();
	
	    this._controller.dispose();
	
	    this._controllerHost = {};
	  },
	  _updateController: function (mapOrGeoModel, ecModel, api) {
	    var geo = mapOrGeoModel.coordinateSystem;
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    controllerHost.zoomLimit = mapOrGeoModel.get('scaleLimit');
	    controllerHost.zoom = geo.getZoom(); // roamType is will be set default true if it is null
	
	    controller.enable(mapOrGeoModel.get('roam') || false);
	    var mainType = mapOrGeoModel.mainType;
	
	    function makeActionBase() {
	      var action = {
	        type: 'geoRoam',
	        componentType: mainType
	      };
	      action[mainType + 'Id'] = mapOrGeoModel.id;
	      return action;
	    }
	
	    controller.off('pan').on('pan', function (dx, dy) {
	      this._mouseDownFlag = false;
	      roamHelper.updateViewOnPan(controllerHost, dx, dy);
	      api.dispatchAction(zrUtil.extend(makeActionBase(), {
	        dx: dx,
	        dy: dy
	      }));
	    }, this);
	    controller.off('zoom').on('zoom', function (zoom, mouseX, mouseY) {
	      this._mouseDownFlag = false;
	      roamHelper.updateViewOnZoom(controllerHost, zoom, mouseX, mouseY);
	      api.dispatchAction(zrUtil.extend(makeActionBase(), {
	        zoom: zoom,
	        originX: mouseX,
	        originY: mouseY
	      }));
	
	      if (this._updateGroup) {
	        var group = this.group;
	        var scale = group.scale;
	        group.traverse(function (el) {
	          if (el.type === 'text') {
	            el.attr('scale', [1 / scale[0], 1 / scale[1]]);
	          }
	        });
	      }
	    }, this);
	    controller.setPointerChecker(function (e, x, y) {
	      return geo.getViewRectAfterRoam().contain(x, y) && !onIrrelevantElement(e, api, mapOrGeoModel);
	    });
	  }
	};
	var _default = MapDraw;
	module.exports = _default;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var BoundingRect = __webpack_require__(13);
	
	var _cursorHelper = __webpack_require__(121);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphicUtil = __webpack_require__(3);
	
	function makeRectPanelClipPath(rect) {
	  rect = normalizeRect(rect);
	  return function (localPoints, transform) {
	    return graphicUtil.clipPointsByRect(localPoints, rect);
	  };
	}
	
	function makeLinearBrushOtherExtent(rect, specifiedXYIndex) {
	  rect = normalizeRect(rect);
	  return function (xyIndex) {
	    var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
	    var brushWidth = idx ? rect.width : rect.height;
	    var base = idx ? rect.x : rect.y;
	    return [base, base + (brushWidth || 0)];
	  };
	}
	
	function makeRectIsTargetByCursor(rect, api, targetModel) {
	  rect = normalizeRect(rect);
	  return function (e, localCursorPoint, transform) {
	    return rect.contain(localCursorPoint[0], localCursorPoint[1]) && !onIrrelevantElement(e, api, targetModel);
	  };
	} // Consider width/height is negative.
	
	
	function normalizeRect(rect) {
	  return BoundingRect.create(rect);
	}
	
	exports.makeRectPanelClipPath = makeRectPanelClipPath;
	exports.makeLinearBrushOtherExtent = makeLinearBrushOtherExtent;
	exports.makeRectIsTargetByCursor = makeRectIsTargetByCursor;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var ATTR = '\0_ec_interaction_mutex';
	
	function take(zr, resourceKey, userKey) {
	  var store = getStore(zr);
	  store[resourceKey] = userKey;
	}
	
	function release(zr, resourceKey, userKey) {
	  var store = getStore(zr);
	  var uKey = store[resourceKey];
	
	  if (uKey === userKey) {
	    store[resourceKey] = null;
	  }
	}
	
	function isTaken(zr, resourceKey) {
	  return !!getStore(zr)[resourceKey];
	}
	
	function getStore(zr) {
	  return zr[ATTR] || (zr[ATTR] = {});
	}
	/**
	 * payload: {
	 *     type: 'takeGlobalCursor',
	 *     key: 'dataZoomSelect', or 'brush', or ...,
	 *         If no userKey, release global cursor.
	 * }
	 */
	
	
	echarts.registerAction({
	  type: 'takeGlobalCursor',
	  event: 'globalCursorTaken',
	  update: 'update'
	}, function () {});
	exports.take = take;
	exports.release = release;
	exports.isTaken = isTaken;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var _layout = __webpack_require__(7);
	
	var getLayoutRect = _layout.getLayoutRect;
	var layoutBox = _layout.box;
	var positionElement = _layout.positionElement;
	
	var formatUtil = __webpack_require__(9);
	
	var graphic = __webpack_require__(3);
	
	/**
	 * Layout list like component.
	 * It will box layout each items in group of component and then position the whole group in the viewport
	 * @param {module:zrender/group/Group} group
	 * @param {module:echarts/model/Component} componentModel
	 * @param {module:echarts/ExtensionAPI}
	 */
	function layout(group, componentModel, api) {
	  var boxLayoutParams = componentModel.getBoxLayoutParams();
	  var padding = componentModel.get('padding');
	  var viewportSize = {
	    width: api.getWidth(),
	    height: api.getHeight()
	  };
	  var rect = getLayoutRect(boxLayoutParams, viewportSize, padding);
	  layoutBox(componentModel.get('orient'), group, componentModel.get('itemGap'), rect.width, rect.height);
	  positionElement(group, boxLayoutParams, viewportSize, padding);
	}
	
	function makeBackground(rect, componentModel) {
	  var padding = formatUtil.normalizeCssArray(componentModel.get('padding'));
	  var style = componentModel.getItemStyle(['color', 'opacity']);
	  style.fill = componentModel.get('backgroundColor');
	  var rect = new graphic.Rect({
	    shape: {
	      x: rect.x - padding[3],
	      y: rect.y - padding[0],
	      width: rect.width + padding[1] + padding[3],
	      height: rect.height + padding[0] + padding[2],
	      r: componentModel.get('borderRadius')
	    },
	    style: style,
	    silent: true,
	    z2: -1
	  }); // FIXME
	  // `subPixelOptimizeRect` may bring some gap between edge of viewpart
	  // and background rect when setting like `left: 0`, `top: 0`.
	  // graphic.subPixelOptimizeRect(rect);
	
	  return rect;
	}
	
	exports.layout = layout;
	exports.makeBackground = makeBackground;

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	/**
	 * For geo and graph.
	 *
	 * @param {Object} controllerHost
	 * @param {module:zrender/Element} controllerHost.target
	 */
	function updateViewOnPan(controllerHost, dx, dy) {
	  var target = controllerHost.target;
	  var pos = target.position;
	  pos[0] += dx;
	  pos[1] += dy;
	  target.dirty();
	}
	/**
	 * For geo and graph.
	 *
	 * @param {Object} controllerHost
	 * @param {module:zrender/Element} controllerHost.target
	 * @param {number} controllerHost.zoom
	 * @param {number} controllerHost.zoomLimit like: {min: 1, max: 2}
	 */
	
	
	function updateViewOnZoom(controllerHost, zoomDelta, zoomX, zoomY) {
	  var target = controllerHost.target;
	  var zoomLimit = controllerHost.zoomLimit;
	  var pos = target.position;
	  var scale = target.scale;
	  var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
	  newZoom *= zoomDelta;
	
	  if (zoomLimit) {
	    var zoomMin = zoomLimit.min || 0;
	    var zoomMax = zoomLimit.max || Infinity;
	    newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
	  }
	
	  var zoomScale = newZoom / controllerHost.zoom;
	  controllerHost.zoom = newZoom; // Keep the mouse center when scaling
	
	  pos[0] -= (zoomX - pos[0]) * (zoomScale - 1);
	  pos[1] -= (zoomY - pos[1]) * (zoomScale - 1);
	  scale[0] *= zoomScale;
	  scale[1] *= zoomScale;
	  target.dirty();
	}
	
	exports.updateViewOnPan = updateViewOnPan;
	exports.updateViewOnZoom = updateViewOnZoom;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var Model = __webpack_require__(14);
	
	var LegendModel = echarts.extendComponentModel({
	  type: 'legend.plain',
	  dependencies: ['series'],
	  layoutMode: {
	    type: 'box',
	    // legend.width/height are maxWidth/maxHeight actually,
	    // whereas realy width/height is calculated by its content.
	    // (Setting {left: 10, right: 10} does not make sense).
	    // So consider the case:
	    // `setOption({legend: {left: 10});`
	    // then `setOption({legend: {right: 10});`
	    // The previous `left` should be cleared by setting `ignoreSize`.
	    ignoreSize: true
	  },
	  init: function (option, parentModel, ecModel) {
	    this.mergeDefaultAndTheme(option, ecModel);
	    option.selected = option.selected || {};
	  },
	  mergeOption: function (option) {
	    LegendModel.superCall(this, 'mergeOption', option);
	  },
	  optionUpdated: function () {
	    this._updateData(this.ecModel);
	
	    var legendData = this._data; // If selectedMode is single, try to select one
	
	    if (legendData[0] && this.get('selectedMode') === 'single') {
	      var hasSelected = false; // If has any selected in option.selected
	
	      for (var i = 0; i < legendData.length; i++) {
	        var name = legendData[i].get('name');
	
	        if (this.isSelected(name)) {
	          // Force to unselect others
	          this.select(name);
	          hasSelected = true;
	          break;
	        }
	      } // Try select the first if selectedMode is single
	
	
	      !hasSelected && this.select(legendData[0].get('name'));
	    }
	  },
	  _updateData: function (ecModel) {
	    var legendData = zrUtil.map(this.get('data') || [], function (dataItem) {
	      // Can be string or number
	      if (typeof dataItem === 'string' || typeof dataItem === 'number') {
	        dataItem = {
	          name: dataItem
	        };
	      }
	
	      return new Model(dataItem, this, this.ecModel);
	    }, this);
	    this._data = legendData;
	    var availableNames = zrUtil.map(ecModel.getSeries(), function (series) {
	      return series.name;
	    });
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.legendDataProvider) {
	        var data = seriesModel.legendDataProvider();
	        availableNames = availableNames.concat(data.mapArray(data.getName));
	      }
	    });
	    /**
	     * @type {Array.<string>}
	     * @private
	     */
	
	    this._availableNames = availableNames;
	  },
	
	  /**
	   * @return {Array.<module:echarts/model/Model>}
	   */
	  getData: function () {
	    return this._data;
	  },
	
	  /**
	   * @param {string} name
	   */
	  select: function (name) {
	    var selected = this.option.selected;
	    var selectedMode = this.get('selectedMode');
	
	    if (selectedMode === 'single') {
	      var data = this._data;
	      zrUtil.each(data, function (dataItem) {
	        selected[dataItem.get('name')] = false;
	      });
	    }
	
	    selected[name] = true;
	  },
	
	  /**
	   * @param {string} name
	   */
	  unSelect: function (name) {
	    if (this.get('selectedMode') !== 'single') {
	      this.option.selected[name] = false;
	    }
	  },
	
	  /**
	   * @param {string} name
	   */
	  toggleSelected: function (name) {
	    var selected = this.option.selected; // Default is true
	
	    if (!selected.hasOwnProperty(name)) {
	      selected[name] = true;
	    }
	
	    this[selected[name] ? 'unSelect' : 'select'](name);
	  },
	
	  /**
	   * @param {string} name
	   */
	  isSelected: function (name) {
	    var selected = this.option.selected;
	    return !(selected.hasOwnProperty(name) && !selected[name]) && zrUtil.indexOf(this._availableNames, name) >= 0;
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 4,
	    show: true,
	    // 布局方式，默认为水平布局，可选为：
	    // 'horizontal' | 'vertical'
	    orient: 'horizontal',
	    left: 'center',
	    // right: 'center',
	    top: 0,
	    // bottom: null,
	    // 水平对齐
	    // 'auto' | 'left' | 'right'
	    // 默认为 'auto', 根据 x 的位置判断是左对齐还是右对齐
	    align: 'auto',
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 图例边框颜色
	    borderColor: '#ccc',
	    borderRadius: 0,
	    // 图例边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 图例内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // 各个item之间的间隔，单位px，默认为10，
	    // 横向布局时为水平间隔，纵向布局时为纵向间隔
	    itemGap: 10,
	    // 图例图形宽度
	    itemWidth: 25,
	    // 图例图形高度
	    itemHeight: 14,
	    // 图例关闭时候的颜色
	    inactiveColor: '#ccc',
	    textStyle: {
	      // 图例文字颜色
	      color: '#333'
	    },
	    // formatter: '',
	    // 选择模式，默认开启图例开关
	    selectedMode: true,
	    // 配置默认选中状态，可配合LEGEND.SELECTED事件做动态数据载入
	    // selected: null,
	    // 图例内容（详见legend.data，数组中每一项代表一个item
	    // data: [],
	    // Tooltip 相关配置
	    tooltip: {
	      show: false
	    }
	  }
	});
	var _default = LegendModel;
	module.exports = _default;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var _symbol = __webpack_require__(22);
	
	var createSymbol = _symbol.createSymbol;
	
	var graphic = __webpack_require__(3);
	
	var _listComponent = __webpack_require__(180);
	
	var makeBackground = _listComponent.makeBackground;
	
	var layoutUtil = __webpack_require__(7);
	
	var curry = zrUtil.curry;
	var each = zrUtil.each;
	var Group = graphic.Group;
	
	var _default = echarts.extendComponentView({
	  type: 'legend.plain',
	  newlineDisabled: false,
	
	  /**
	   * @override
	   */
	  init: function () {
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	    this.group.add(this._contentGroup = new Group());
	    /**
	     * @private
	     * @type {module:zrender/Element}
	     */
	
	    this._backgroundEl;
	  },
	
	  /**
	   * @protected
	   */
	  getContentGroup: function () {
	    return this._contentGroup;
	  },
	
	  /**
	   * @override
	   */
	  render: function (legendModel, ecModel, api) {
	    this.resetInner();
	
	    if (!legendModel.get('show', true)) {
	      return;
	    }
	
	    var itemAlign = legendModel.get('align');
	
	    if (!itemAlign || itemAlign === 'auto') {
	      itemAlign = legendModel.get('left') === 'right' && legendModel.get('orient') === 'vertical' ? 'right' : 'left';
	    }
	
	    this.renderInner(itemAlign, legendModel, ecModel, api); // Perform layout.
	
	    var positionInfo = legendModel.getBoxLayoutParams();
	    var viewportSize = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    };
	    var padding = legendModel.get('padding');
	    var maxSize = layoutUtil.getLayoutRect(positionInfo, viewportSize, padding);
	    var mainRect = this.layoutInner(legendModel, itemAlign, maxSize); // Place mainGroup, based on the calculated `mainRect`.
	
	    var layoutRect = layoutUtil.getLayoutRect(zrUtil.defaults({
	      width: mainRect.width,
	      height: mainRect.height
	    }, positionInfo), viewportSize, padding);
	    this.group.attr('position', [layoutRect.x - mainRect.x, layoutRect.y - mainRect.y]); // Render background after group is layout.
	
	    this.group.add(this._backgroundEl = makeBackground(mainRect, legendModel));
	  },
	
	  /**
	   * @protected
	   */
	  resetInner: function () {
	    this.getContentGroup().removeAll();
	    this._backgroundEl && this.group.remove(this._backgroundEl);
	  },
	
	  /**
	   * @protected
	   */
	  renderInner: function (itemAlign, legendModel, ecModel, api) {
	    var contentGroup = this.getContentGroup();
	    var legendDrawnMap = zrUtil.createHashMap();
	    var selectMode = legendModel.get('selectedMode');
	    each(legendModel.getData(), function (itemModel, dataIndex) {
	      var name = itemModel.get('name'); // Use empty string or \n as a newline string
	
	      if (!this.newlineDisabled && (name === '' || name === '\n')) {
	        contentGroup.add(new Group({
	          newline: true
	        }));
	        return;
	      }
	
	      var seriesModel = ecModel.getSeriesByName(name)[0];
	
	      if (legendDrawnMap.get(name)) {
	        // Have been drawed
	        return;
	      } // Series legend
	
	
	      if (seriesModel) {
	        var data = seriesModel.getData();
	        var color = data.getVisual('color'); // If color is a callback function
	
	        if (typeof color === 'function') {
	          // Use the first data
	          color = color(seriesModel.getDataParams(0));
	        } // Using rect symbol defaultly
	
	
	        var legendSymbolType = data.getVisual('legendSymbol') || 'roundRect';
	        var symbolType = data.getVisual('symbol');
	
	        var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, selectMode);
	
	        itemGroup.on('click', curry(dispatchSelectAction, name, api)).on('mouseover', curry(dispatchHighlightAction, seriesModel, null, api)).on('mouseout', curry(dispatchDownplayAction, seriesModel, null, api));
	        legendDrawnMap.set(name, true);
	      } else {
	        // Data legend of pie, funnel
	        ecModel.eachRawSeries(function (seriesModel) {
	          // In case multiple series has same data name
	          if (legendDrawnMap.get(name)) {
	            return;
	          }
	
	          if (seriesModel.legendDataProvider) {
	            var data = seriesModel.legendDataProvider();
	            var idx = data.indexOfName(name);
	
	            if (idx < 0) {
	              return;
	            }
	
	            var color = data.getItemVisual(idx, 'color');
	            var legendSymbolType = 'roundRect';
	
	            var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, null, itemAlign, color, selectMode);
	
	            itemGroup.on('click', curry(dispatchSelectAction, name, api)) // FIXME Should not specify the series name
	            .on('mouseover', curry(dispatchHighlightAction, seriesModel, name, api)).on('mouseout', curry(dispatchDownplayAction, seriesModel, name, api));
	            legendDrawnMap.set(name, true);
	          }
	        }, this);
	      }
	    }, this);
	  },
	  _createItem: function (name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, selectMode) {
	    var itemWidth = legendModel.get('itemWidth');
	    var itemHeight = legendModel.get('itemHeight');
	    var inactiveColor = legendModel.get('inactiveColor');
	    var isSelected = legendModel.isSelected(name);
	    var itemGroup = new Group();
	    var textStyleModel = itemModel.getModel('textStyle');
	    var itemIcon = itemModel.get('icon');
	    var tooltipModel = itemModel.getModel('tooltip');
	    var legendGlobalTooltipModel = tooltipModel.parentModel; // Use user given icon first
	
	    legendSymbolType = itemIcon || legendSymbolType;
	    itemGroup.add(createSymbol(legendSymbolType, 0, 0, itemWidth, itemHeight, isSelected ? color : inactiveColor, true)); // Compose symbols
	    // PENDING
	
	    if (!itemIcon && symbolType // At least show one symbol, can't be all none
	    && (symbolType !== legendSymbolType || symbolType == 'none')) {
	      var size = itemHeight * 0.8;
	
	      if (symbolType === 'none') {
	        symbolType = 'circle';
	      } // Put symbol in the center
	
	
	      itemGroup.add(createSymbol(symbolType, (itemWidth - size) / 2, (itemHeight - size) / 2, size, size, isSelected ? color : inactiveColor));
	    }
	
	    var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
	    var textAlign = itemAlign;
	    var formatter = legendModel.get('formatter');
	    var content = name;
	
	    if (typeof formatter === 'string' && formatter) {
	      content = formatter.replace('{name}', name != null ? name : '');
	    } else if (typeof formatter === 'function') {
	      content = formatter(name);
	    }
	
	    itemGroup.add(new graphic.Text({
	      style: graphic.setTextStyle({}, textStyleModel, {
	        text: content,
	        x: textX,
	        y: itemHeight / 2,
	        textFill: isSelected ? textStyleModel.getTextColor() : inactiveColor,
	        textAlign: textAlign,
	        textVerticalAlign: 'middle'
	      })
	    })); // Add a invisible rect to increase the area of mouse hover
	
	    var hitRect = new graphic.Rect({
	      shape: itemGroup.getBoundingRect(),
	      invisible: true,
	      tooltip: tooltipModel.get('show') ? zrUtil.extend({
	        content: name,
	        // Defaul formatter
	        formatter: legendGlobalTooltipModel.get('formatter', true) || function () {
	          return name;
	        },
	        formatterParams: {
	          componentType: 'legend',
	          legendIndex: legendModel.componentIndex,
	          name: name,
	          $vars: ['name']
	        }
	      }, tooltipModel.option) : null
	    });
	    itemGroup.add(hitRect);
	    itemGroup.eachChild(function (child) {
	      child.silent = true;
	    });
	    hitRect.silent = !selectMode;
	    this.getContentGroup().add(itemGroup);
	    graphic.setHoverStyle(itemGroup);
	    itemGroup.__legendDataIndex = dataIndex;
	    return itemGroup;
	  },
	
	  /**
	   * @protected
	   */
	  layoutInner: function (legendModel, itemAlign, maxSize) {
	    var contentGroup = this.getContentGroup(); // Place items in contentGroup.
	
	    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
	    var contentRect = contentGroup.getBoundingRect();
	    contentGroup.attr('position', [-contentRect.x, -contentRect.y]);
	    return this.group.getBoundingRect();
	  }
	});
	
	function dispatchSelectAction(name, api) {
	  api.dispatchAction({
	    type: 'legendToggleSelect',
	    name: name
	  });
	}
	
	function dispatchHighlightAction(seriesModel, dataName, api) {
	  // If element hover will move to a hoverLayer.
	  var el = api.getZr().storage.getDisplayList()[0];
	
	  if (!(el && el.useHoverLayer)) {
	    seriesModel.get('legendHoverLink') && api.dispatchAction({
	      type: 'highlight',
	      seriesName: seriesModel.name,
	      name: dataName
	    });
	  }
	}
	
	function dispatchDownplayAction(seriesModel, dataName, api) {
	  // If element hover will move to a hoverLayer.
	  var el = api.getZr().storage.getDisplayList()[0];
	
	  if (!(el && el.useHoverLayer)) {
	    seriesModel.get('legendHoverLink') && api.dispatchAction({
	      type: 'downplay',
	      seriesName: seriesModel.name,
	      name: dataName
	    });
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var throttleUtil = __webpack_require__(45);
	
	var parallelPreprocessor = __webpack_require__(563);
	
	__webpack_require__(198);
	
	__webpack_require__(562);
	
	__webpack_require__(509);
	
	var CLICK_THRESHOLD = 5; // > 4
	// Parallel view
	
	echarts.extendComponentView({
	  type: 'parallel',
	  render: function (parallelModel, ecModel, api) {
	    this._model = parallelModel;
	    this._api = api;
	
	    if (!this._handlers) {
	      this._handlers = {};
	      zrUtil.each(handlers, function (handler, eventName) {
	        api.getZr().on(eventName, this._handlers[eventName] = zrUtil.bind(handler, this));
	      }, this);
	    }
	
	    throttleUtil.createOrUpdate(this, '_throttledDispatchExpand', parallelModel.get('axisExpandRate'), 'fixRate');
	  },
	  dispose: function (ecModel, api) {
	    zrUtil.each(this._handlers, function (handler, eventName) {
	      api.getZr().off(eventName, handler);
	    });
	    this._handlers = null;
	  },
	
	  /**
	   * @param {Object} [opt] If null, cancle the last action triggering for debounce.
	   */
	  _throttledDispatchExpand: function (opt) {
	    this._dispatchExpand(opt);
	  },
	  _dispatchExpand: function (opt) {
	    opt && this._api.dispatchAction(zrUtil.extend({
	      type: 'parallelAxisExpand'
	    }, opt));
	  }
	});
	var handlers = {
	  mousedown: function (e) {
	    if (checkTrigger(this, 'click')) {
	      this._mouseDownPoint = [e.offsetX, e.offsetY];
	    }
	  },
	  mouseup: function (e) {
	    var mouseDownPoint = this._mouseDownPoint;
	
	    if (checkTrigger(this, 'click') && mouseDownPoint) {
	      var point = [e.offsetX, e.offsetY];
	      var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);
	
	      if (dist > CLICK_THRESHOLD) {
	        return;
	      }
	
	      var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
	
	      result.behavior !== 'none' && this._dispatchExpand({
	        axisExpandWindow: result.axisExpandWindow
	      });
	    }
	
	    this._mouseDownPoint = null;
	  },
	  mousemove: function (e) {
	    // Should do nothing when brushing.
	    if (this._mouseDownPoint || !checkTrigger(this, 'mousemove')) {
	      return;
	    }
	
	    var model = this._model;
	    var result = model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
	    var behavior = result.behavior;
	    behavior === 'jump' && this._throttledDispatchExpand.debounceNextCall(model.get('axisExpandDebounce'));
	
	    this._throttledDispatchExpand(behavior === 'none' ? null // Cancle the last trigger, in case that mouse slide out of the area quickly.
	    : {
	      axisExpandWindow: result.axisExpandWindow,
	      // Jumping uses animation, and sliding suppresses animation.
	      animation: behavior === 'jump' ? null : false
	    });
	  }
	};
	
	function checkTrigger(view, triggerOn) {
	  var model = view._model;
	  return model.get('axisExpandable') && model.get('axisExpandTriggerOn') === triggerOn;
	}
	
	echarts.registerPreprocessor(parallelPreprocessor);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	__webpack_require__(577);
	
	__webpack_require__(463);
	
	__webpack_require__(573);
	
	__webpack_require__(67);
	
	__webpack_require__(468);
	
	echarts.extendComponentView({
	  type: 'single'
	});

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var env = __webpack_require__(18);
	
	var visualDefault = __webpack_require__(205);
	
	var VisualMapping = __webpack_require__(46);
	
	var visualSolution = __webpack_require__(93);
	
	var modelUtil = __webpack_require__(6);
	
	var numberUtil = __webpack_require__(4);
	
	var mapVisual = VisualMapping.mapVisual;
	var eachVisual = VisualMapping.eachVisual;
	var isArray = zrUtil.isArray;
	var each = zrUtil.each;
	var asc = numberUtil.asc;
	var linearMap = numberUtil.linearMap;
	var noop = zrUtil.noop;
	var DEFAULT_COLOR = ['#f6efa6', '#d88273', '#bf444c'];
	var VisualMapModel = echarts.extendComponentModel({
	  type: 'visualMap',
	  dependencies: ['series'],
	
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  stateList: ['inRange', 'outOfRange'],
	
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  replacableOptionKeys: ['inRange', 'outOfRange', 'target', 'controller', 'color'],
	
	  /**
	   * [lowerBound, upperBound]
	   *
	   * @readOnly
	   * @type {Array.<number>}
	   */
	  dataBound: [-Infinity, Infinity],
	
	  /**
	   * @readOnly
	   * @type {string|Object}
	   */
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    show: true,
	    zlevel: 0,
	    z: 4,
	    seriesIndex: 'all',
	    // 'all' or null/undefined: all series.
	    // A number or an array of number: the specified series.
	    // set min: 0, max: 200, only for campatible with ec2.
	    // In fact min max should not have default value.
	    min: 0,
	    // min value, must specified if pieces is not specified.
	    max: 200,
	    // max value, must specified if pieces is not specified.
	    dimension: null,
	    inRange: null,
	    // 'color', 'colorHue', 'colorSaturation', 'colorLightness', 'colorAlpha',
	    // 'symbol', 'symbolSize'
	    outOfRange: null,
	    // 'color', 'colorHue', 'colorSaturation',
	    // 'colorLightness', 'colorAlpha',
	    // 'symbol', 'symbolSize'
	    left: 0,
	    // 'center' ¦ 'left' ¦ 'right' ¦ {number} (px)
	    right: null,
	    // The same as left.
	    top: null,
	    // 'top' ¦ 'bottom' ¦ 'center' ¦ {number} (px)
	    bottom: 0,
	    // The same as top.
	    itemWidth: null,
	    itemHeight: null,
	    inverse: false,
	    orient: 'vertical',
	    // 'horizontal' ¦ 'vertical'
	    backgroundColor: 'rgba(0,0,0,0)',
	    borderColor: '#ccc',
	    // 值域边框颜色
	    contentColor: '#5793f3',
	    inactiveColor: '#aaa',
	    borderWidth: 0,
	    // 值域边框线宽，单位px，默认为0（无边框）
	    padding: 5,
	    // 值域内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    textGap: 10,
	    //
	    precision: 0,
	    // 小数精度，默认为0，无小数点
	    color: null,
	    //颜色（deprecated，兼容ec2，顺序同pieces，不同于inRange/outOfRange）
	    formatter: null,
	    text: null,
	    // 文本，如['高', '低']，兼容ec2，text[0]对应高值，text[1]对应低值
	    textStyle: {
	      color: '#333' // 值域文字颜色
	
	    }
	  },
	
	  /**
	   * @protected
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * @private
	     * @type {Array.<number>}
	     */
	    this._dataExtent;
	    /**
	     * @readOnly
	     */
	
	    this.targetVisuals = {};
	    /**
	     * @readOnly
	     */
	
	    this.controllerVisuals = {};
	    /**
	     * @readOnly
	     */
	
	    this.textStyleModel;
	    /**
	     * [width, height]
	     * @readOnly
	     * @type {Array.<number>}
	     */
	
	    this.itemSize;
	    this.mergeDefaultAndTheme(option, ecModel);
	  },
	
	  /**
	   * @protected
	   */
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option; // FIXME
	    // necessary?
	    // Disable realtime view update if canvas is not supported.
	
	    if (!env.canvasSupported) {
	      thisOption.realtime = false;
	    }
	
	    !isInit && visualSolution.replaceVisualOption(thisOption, newOption, this.replacableOptionKeys);
	    this.textStyleModel = this.getModel('textStyle');
	    this.resetItemSize();
	    this.completeVisualOption();
	  },
	
	  /**
	   * @protected
	   */
	  resetVisual: function (supplementVisualOption) {
	    var stateList = this.stateList;
	    supplementVisualOption = zrUtil.bind(supplementVisualOption, this);
	    this.controllerVisuals = visualSolution.createVisualMappings(this.option.controller, stateList, supplementVisualOption);
	    this.targetVisuals = visualSolution.createVisualMappings(this.option.target, stateList, supplementVisualOption);
	  },
	
	  /**
	   * @protected
	   * @return {Array.<number>} An array of series indices.
	   */
	  getTargetSeriesIndices: function () {
	    var optionSeriesIndex = this.option.seriesIndex;
	    var seriesIndices = [];
	
	    if (optionSeriesIndex == null || optionSeriesIndex === 'all') {
	      this.ecModel.eachSeries(function (seriesModel, index) {
	        seriesIndices.push(index);
	      });
	    } else {
	      seriesIndices = modelUtil.normalizeToArray(optionSeriesIndex);
	    }
	
	    return seriesIndices;
	  },
	
	  /**
	   * @public
	   */
	  eachTargetSeries: function (callback, context) {
	    zrUtil.each(this.getTargetSeriesIndices(), function (seriesIndex) {
	      callback.call(context, this.ecModel.getSeriesByIndex(seriesIndex));
	    }, this);
	  },
	
	  /**
	   * @pubilc
	   */
	  isTargetSeries: function (seriesModel) {
	    var is = false;
	    this.eachTargetSeries(function (model) {
	      model === seriesModel && (is = true);
	    });
	    return is;
	  },
	
	  /**
	   * @example
	   * this.formatValueText(someVal); // format single numeric value to text.
	   * this.formatValueText(someVal, true); // format single category value to text.
	   * this.formatValueText([min, max]); // format numeric min-max to text.
	   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
	   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
	   *
	   * @param {number|Array.<number>} value Real value, or this.dataBound[0 or 1].
	   * @param {boolean} [isCategory=false] Only available when value is number.
	   * @param {Array.<string>} edgeSymbols Open-close symbol when value is interval.
	   * @return {string}
	   * @protected
	   */
	  formatValueText: function (value, isCategory, edgeSymbols) {
	    var option = this.option;
	    var precision = option.precision;
	    var dataBound = this.dataBound;
	    var formatter = option.formatter;
	    var isMinMax;
	    var textValue;
	    edgeSymbols = edgeSymbols || ['<', '>'];
	
	    if (zrUtil.isArray(value)) {
	      value = value.slice();
	      isMinMax = true;
	    }
	
	    textValue = isCategory ? value : isMinMax ? [toFixed(value[0]), toFixed(value[1])] : toFixed(value);
	
	    if (zrUtil.isString(formatter)) {
	      return formatter.replace('{value}', isMinMax ? textValue[0] : textValue).replace('{value2}', isMinMax ? textValue[1] : textValue);
	    } else if (zrUtil.isFunction(formatter)) {
	      return isMinMax ? formatter(value[0], value[1]) : formatter(value);
	    }
	
	    if (isMinMax) {
	      if (value[0] === dataBound[0]) {
	        return edgeSymbols[0] + ' ' + textValue[1];
	      } else if (value[1] === dataBound[1]) {
	        return edgeSymbols[1] + ' ' + textValue[0];
	      } else {
	        return textValue[0] + ' - ' + textValue[1];
	      }
	    } else {
	      // Format single value (includes category case).
	      return textValue;
	    }
	
	    function toFixed(val) {
	      return val === dataBound[0] ? 'min' : val === dataBound[1] ? 'max' : (+val).toFixed(Math.min(precision, 20));
	    }
	  },
	
	  /**
	   * @protected
	   */
	  resetExtent: function () {
	    var thisOption = this.option; // Can not calculate data extent by data here.
	    // Because series and data may be modified in processing stage.
	    // So we do not support the feature "auto min/max".
	
	    var extent = asc([thisOption.min, thisOption.max]);
	    this._dataExtent = extent;
	  },
	
	  /**
	   * @public
	   * @param {module:echarts/data/List} list
	   * @return {string} Concrete dimention. If return null/undefined,
	   *                  no dimension used.
	   */
	  getDataDimension: function (list) {
	    var optDim = this.option.dimension;
	    return optDim != null ? optDim : list.dimensions.length - 1;
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  getExtent: function () {
	    return this._dataExtent.slice();
	  },
	
	  /**
	   * @protected
	   */
	  completeVisualOption: function () {
	    var thisOption = this.option;
	    var base = {
	      inRange: thisOption.inRange,
	      outOfRange: thisOption.outOfRange
	    };
	    var target = thisOption.target || (thisOption.target = {});
	    var controller = thisOption.controller || (thisOption.controller = {});
	    zrUtil.merge(target, base); // Do not override
	
	    zrUtil.merge(controller, base); // Do not override
	
	    var isCategory = this.isCategory();
	    completeSingle.call(this, target);
	    completeSingle.call(this, controller);
	    completeInactive.call(this, target, 'inRange', 'outOfRange'); // completeInactive.call(this, target, 'outOfRange', 'inRange');
	
	    completeController.call(this, controller);
	
	    function completeSingle(base) {
	      // Compatible with ec2 dataRange.color.
	      // The mapping order of dataRange.color is: [high value, ..., low value]
	      // whereas inRange.color and outOfRange.color is [low value, ..., high value]
	      // Notice: ec2 has no inverse.
	      if (isArray(thisOption.color) // If there has been inRange: {symbol: ...}, adding color is a mistake.
	      // So adding color only when no inRange defined.
	      && !base.inRange) {
	        base.inRange = {
	          color: thisOption.color.slice().reverse()
	        };
	      } // Compatible with previous logic, always give a defautl color, otherwise
	      // simple config with no inRange and outOfRange will not work.
	      // Originally we use visualMap.color as the default color, but setOption at
	      // the second time the default color will be erased. So we change to use
	      // constant DEFAULT_COLOR.
	      // If user do not want the defualt color, set inRange: {color: null}.
	
	
	      base.inRange = base.inRange || {
	        color: DEFAULT_COLOR
	      }; // If using shortcut like: {inRange: 'symbol'}, complete default value.
	
	      each(this.stateList, function (state) {
	        var visualType = base[state];
	
	        if (zrUtil.isString(visualType)) {
	          var defa = visualDefault.get(visualType, 'active', isCategory);
	
	          if (defa) {
	            base[state] = {};
	            base[state][visualType] = defa;
	          } else {
	            // Mark as not specified.
	            delete base[state];
	          }
	        }
	      }, this);
	    }
	
	    function completeInactive(base, stateExist, stateAbsent) {
	      var optExist = base[stateExist];
	      var optAbsent = base[stateAbsent];
	
	      if (optExist && !optAbsent) {
	        optAbsent = base[stateAbsent] = {};
	        each(optExist, function (visualData, visualType) {
	          if (!VisualMapping.isValidType(visualType)) {
	            return;
	          }
	
	          var defa = visualDefault.get(visualType, 'inactive', isCategory);
	
	          if (defa != null) {
	            optAbsent[visualType] = defa; // Compatibable with ec2:
	            // Only inactive color to rgba(0,0,0,0) can not
	            // make label transparent, so use opacity also.
	
	            if (visualType === 'color' && !optAbsent.hasOwnProperty('opacity') && !optAbsent.hasOwnProperty('colorAlpha')) {
	              optAbsent.opacity = [0, 0];
	            }
	          }
	        });
	      }
	    }
	
	    function completeController(controller) {
	      var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
	      var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
	      var inactiveColor = this.get('inactiveColor');
	      each(this.stateList, function (state) {
	        var itemSize = this.itemSize;
	        var visuals = controller[state]; // Set inactive color for controller if no other color
	        // attr (like colorAlpha) specified.
	
	        if (!visuals) {
	          visuals = controller[state] = {
	            color: isCategory ? inactiveColor : [inactiveColor]
	          };
	        } // Consistent symbol and symbolSize if not specified.
	
	
	        if (visuals.symbol == null) {
	          visuals.symbol = symbolExists && zrUtil.clone(symbolExists) || (isCategory ? 'roundRect' : ['roundRect']);
	        }
	
	        if (visuals.symbolSize == null) {
	          visuals.symbolSize = symbolSizeExists && zrUtil.clone(symbolSizeExists) || (isCategory ? itemSize[0] : [itemSize[0], itemSize[0]]);
	        } // Filter square and none.
	
	
	        visuals.symbol = mapVisual(visuals.symbol, function (symbol) {
	          return symbol === 'none' || symbol === 'square' ? 'roundRect' : symbol;
	        }); // Normalize symbolSize
	
	        var symbolSize = visuals.symbolSize;
	
	        if (symbolSize != null) {
	          var max = -Infinity; // symbolSize can be object when categories defined.
	
	          eachVisual(symbolSize, function (value) {
	            value > max && (max = value);
	          });
	          visuals.symbolSize = mapVisual(symbolSize, function (value) {
	            return linearMap(value, [0, max], [0, itemSize[0]], true);
	          });
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  resetItemSize: function () {
	    this.itemSize = [parseFloat(this.get('itemWidth')), parseFloat(this.get('itemHeight'))];
	  },
	
	  /**
	   * @public
	   */
	  isCategory: function () {
	    return !!this.option.categories;
	  },
	
	  /**
	   * @public
	   * @abstract
	   */
	  setSelected: noop,
	
	  /**
	   * @public
	   * @abstract
	   * @param {*|module:echarts/data/List} valueOrData
	   * @param {number} dataIndex
	   * @return {string} state See this.stateList
	   */
	  getValueState: noop,
	
	  /**
	   * FIXME
	   * Do not publish to thirt-part-dev temporarily
	   * util the interface is stable. (Should it return
	   * a function but not visual meta?)
	   *
	   * @pubilc
	   * @abstract
	   * @param {Function} getColorVisual
	   *        params: value, valueState
	   *        return: color
	   * @return {Object} visualMeta
	   *        should includes {stops, outerColors}
	   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
	   */
	  getVisualMeta: noop
	});
	var _default = VisualMapModel;
	module.exports = _default;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var formatUtil = __webpack_require__(9);
	
	var layout = __webpack_require__(7);
	
	var VisualMapping = __webpack_require__(46);
	
	var _default = echarts.extendComponentView({
	  type: 'visualMap',
	
	  /**
	   * @readOnly
	   * @type {Object}
	   */
	  autoPositionValues: {
	    left: 1,
	    right: 1,
	    top: 1,
	    bottom: 1
	  },
	  init: function (ecModel, api) {
	    /**
	     * @readOnly
	     * @type {module:echarts/model/Global}
	     */
	    this.ecModel = ecModel;
	    /**
	     * @readOnly
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this.api = api;
	    /**
	     * @readOnly
	     * @type {module:echarts/component/visualMap/visualMapModel}
	     */
	
	    this.visualMapModel;
	  },
	
	  /**
	   * @protected
	   */
	  render: function (visualMapModel, ecModel, api, payload) {
	    this.visualMapModel = visualMapModel;
	
	    if (visualMapModel.get('show') === false) {
	      this.group.removeAll();
	      return;
	    }
	
	    this.doRender.apply(this, arguments);
	  },
	
	  /**
	   * @protected
	   */
	  renderBackground: function (group) {
	    var visualMapModel = this.visualMapModel;
	    var padding = formatUtil.normalizeCssArray(visualMapModel.get('padding') || 0);
	    var rect = group.getBoundingRect();
	    group.add(new graphic.Rect({
	      z2: -1,
	      // Lay background rect on the lowest layer.
	      silent: true,
	      shape: {
	        x: rect.x - padding[3],
	        y: rect.y - padding[0],
	        width: rect.width + padding[3] + padding[1],
	        height: rect.height + padding[0] + padding[2]
	      },
	      style: {
	        fill: visualMapModel.get('backgroundColor'),
	        stroke: visualMapModel.get('borderColor'),
	        lineWidth: visualMapModel.get('borderWidth')
	      }
	    }));
	  },
	
	  /**
	   * @protected
	   * @param {number} targetValue can be Infinity or -Infinity
	   * @param {string=} visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
	   * @param {Object} [opts]
	   * @param {string=} [opts.forceState] Specify state, instead of using getValueState method.
	   * @param {string=} [opts.convertOpacityToAlpha=false] For color gradient in controller widget.
	   * @return {*} Visual value.
	   */
	  getControllerVisual: function (targetValue, visualCluster, opts) {
	    opts = opts || {};
	    var forceState = opts.forceState;
	    var visualMapModel = this.visualMapModel;
	    var visualObj = {}; // Default values.
	
	    if (visualCluster === 'symbol') {
	      visualObj.symbol = visualMapModel.get('itemSymbol');
	    }
	
	    if (visualCluster === 'color') {
	      var defaultColor = visualMapModel.get('contentColor');
	      visualObj.color = defaultColor;
	    }
	
	    function getter(key) {
	      return visualObj[key];
	    }
	
	    function setter(key, value) {
	      visualObj[key] = value;
	    }
	
	    var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
	    var visualTypes = VisualMapping.prepareVisualTypes(mappings);
	    zrUtil.each(visualTypes, function (type) {
	      var visualMapping = mappings[type];
	
	      if (opts.convertOpacityToAlpha && type === 'opacity') {
	        type = 'colorAlpha';
	        visualMapping = mappings.__alphaForOpacity;
	      }
	
	      if (VisualMapping.dependsOn(type, visualCluster)) {
	        visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
	      }
	    });
	    return visualObj[visualCluster];
	  },
	
	  /**
	   * @protected
	   */
	  positionGroup: function (group) {
	    var model = this.visualMapModel;
	    var api = this.api;
	    layout.positionElement(group, model.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	  },
	
	  /**
	   * @protected
	   * @abstract
	   */
	  doRender: zrUtil.noop
	});
	
	module.exports = _default;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var _layout = __webpack_require__(7);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	/**
	 * @param {module:echarts/component/visualMap/VisualMapModel} visualMapModel\
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Array.<number>} itemSize always [short, long]
	 * @return {string} 'left' or 'right' or 'top' or 'bottom'
	 */
	function getItemAlign(visualMapModel, api, itemSize) {
	  var modelOption = visualMapModel.option;
	  var itemAlign = modelOption.align;
	
	  if (itemAlign != null && itemAlign !== 'auto') {
	    return itemAlign;
	  } // Auto decision align.
	
	
	  var ecSize = {
	    width: api.getWidth(),
	    height: api.getHeight()
	  };
	  var realIndex = modelOption.orient === 'horizontal' ? 1 : 0;
	  var paramsSet = [['left', 'right', 'width'], ['top', 'bottom', 'height']];
	  var reals = paramsSet[realIndex];
	  var fakeValue = [0, null, 10];
	  var layoutInput = {};
	
	  for (var i = 0; i < 3; i++) {
	    layoutInput[paramsSet[1 - realIndex][i]] = fakeValue[i];
	    layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
	  }
	
	  var rParam = [['x', 'width', 3], ['y', 'height', 0]][realIndex];
	  var rect = getLayoutRect(layoutInput, ecSize, modelOption.padding);
	  return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
	}
	/**
	 * Prepare dataIndex for outside usage, where dataIndex means rawIndex, and
	 * dataIndexInside means filtered index.
	 */
	
	
	function convertDataIndex(batch) {
	  zrUtil.each(batch || [], function (batchItem) {
	    if (batch.dataIndex != null) {
	      batch.dataIndexInside = batch.dataIndex;
	      batch.dataIndex = null;
	    }
	  });
	  return batch;
	}
	
	exports.getItemAlign = getItemAlign;
	exports.convertDataIndex = convertDataIndex;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var each = zrUtil.each;
	
	function _default(option) {
	  var visualMap = option && option.visualMap;
	
	  if (!zrUtil.isArray(visualMap)) {
	    visualMap = visualMap ? [visualMap] : [];
	  }
	
	  each(visualMap, function (opt) {
	    if (!opt) {
	      return;
	    } // rename splitList to pieces
	
	
	    if (has(opt, 'splitList') && !has(opt, 'pieces')) {
	      opt.pieces = opt.splitList;
	      delete opt.splitList;
	    }
	
	    var pieces = opt.pieces;
	
	    if (pieces && zrUtil.isArray(pieces)) {
	      each(pieces, function (piece) {
	        if (zrUtil.isObject(piece)) {
	          if (has(piece, 'start') && !has(piece, 'min')) {
	            piece.min = piece.start;
	          }
	
	          if (has(piece, 'end') && !has(piece, 'max')) {
	            piece.max = piece.end;
	          }
	        }
	      });
	    }
	  });
	}
	
	function has(obj, name) {
	  return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
	}
	
	module.exports = _default;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(16);
	
	Component.registerSubTypeDefaulter('visualMap', function (option) {
	  // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
	  return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? 'continuous' : 'piecewise';
	});

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var visualSolution = __webpack_require__(93);
	
	var VisualMapping = __webpack_require__(46);
	
	echarts.registerVisual(echarts.PRIORITY.VISUAL.COMPONENT, function (ecModel) {
	  ecModel.eachComponent('visualMap', function (visualMapModel) {
	    processSingleVisualMap(visualMapModel, ecModel);
	  });
	  prepareVisualMeta(ecModel);
	});
	
	function processSingleVisualMap(visualMapModel, ecModel) {
	  visualMapModel.eachTargetSeries(function (seriesModel) {
	    var data = seriesModel.getData();
	    visualSolution.applyVisual(visualMapModel.stateList, visualMapModel.targetVisuals, data, visualMapModel.getValueState, visualMapModel, visualMapModel.getDataDimension(data));
	  });
	} // Only support color.
	
	
	function prepareVisualMeta(ecModel) {
	  ecModel.eachSeries(function (seriesModel) {
	    var data = seriesModel.getData();
	    var visualMetaList = [];
	    ecModel.eachComponent('visualMap', function (visualMapModel) {
	      if (visualMapModel.isTargetSeries(seriesModel)) {
	        var visualMeta = visualMapModel.getVisualMeta(zrUtil.bind(getColorVisual, null, seriesModel, visualMapModel)) || {
	          stops: [],
	          outerColors: []
	        };
	        visualMeta.dimension = visualMapModel.getDataDimension(data);
	        visualMetaList.push(visualMeta);
	      }
	    }); // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));
	
	    seriesModel.getData().setVisual('visualMeta', visualMetaList);
	  });
	} // FIXME
	// performance and export for heatmap?
	// value can be Infinity or -Infinity
	
	
	function getColorVisual(seriesModel, visualMapModel, value, valueState) {
	  var mappings = visualMapModel.targetVisuals[valueState];
	  var visualTypes = VisualMapping.prepareVisualTypes(mappings);
	  var resultVisual = {
	    color: seriesModel.getData().getVisual('color') // default color.
	
	  };
	
	  for (var i = 0, len = visualTypes.length; i < len; i++) {
	    var type = visualTypes[i];
	    var mapping = mappings[type === 'opacity' ? '__alphaForOpacity' : type];
	    mapping && mapping.applyVisual(value, getVisual, setVisual);
	  }
	
	  return resultVisual.color;
	
	  function getVisual(key) {
	    return resultVisual[key];
	  }
	
	  function setVisual(key, value) {
	    resultVisual[key] = value;
	  }
	}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var actionInfo = {
	  type: 'selectDataRange',
	  event: 'dataRangeSelected',
	  // FIXME use updateView appears wrong
	  update: 'update'
	};
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'visualMap',
	    query: payload
	  }, function (model) {
	    model.setSelected(payload.selected);
	  });
	});

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var vector = __webpack_require__(8);
	
	var matrix = __webpack_require__(23);
	
	var BoundingRect = __webpack_require__(13);
	
	var Transformable = __webpack_require__(139);
	
	/**
	 * Simple view coordinate system
	 * Mapping given x, y to transformd view x, y
	 */
	var v2ApplyTransform = vector.applyTransform; // Dummy transform node
	
	function TransformDummy() {
	  Transformable.call(this);
	}
	
	zrUtil.mixin(TransformDummy, Transformable);
	
	function View(name) {
	  /**
	   * @type {string}
	   */
	  this.name = name;
	  /**
	   * @type {Object}
	   */
	
	  this.zoomLimit;
	  Transformable.call(this);
	  this._roamTransform = new TransformDummy();
	  this._viewTransform = new TransformDummy();
	  this._center;
	  this._zoom;
	}
	
	View.prototype = {
	  constructor: View,
	  type: 'view',
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['x', 'y'],
	
	  /**
	   * Set bounding rect
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  // PENDING to getRect
	  setBoundingRect: function (x, y, width, height) {
	    this._rect = new BoundingRect(x, y, width, height);
	    return this._rect;
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  // PENDING to getRect
	  getBoundingRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  setViewRect: function (x, y, width, height) {
	    this.transformTo(x, y, width, height);
	    this._viewRect = new BoundingRect(x, y, width, height);
	  },
	
	  /**
	   * Transformed to particular position and size
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var viewTransform = this._viewTransform;
	    viewTransform.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
	    viewTransform.decomposeTransform();
	
	    this._updateTransform();
	  },
	
	  /**
	   * Set center of view
	   * @param {Array.<number>} [centerCoord]
	   */
	  setCenter: function (centerCoord) {
	    if (!centerCoord) {
	      return;
	    }
	
	    this._center = centerCoord;
	
	    this._updateCenterAndZoom();
	  },
	
	  /**
	   * @param {number} zoom
	   */
	  setZoom: function (zoom) {
	    zoom = zoom || 1;
	    var zoomLimit = this.zoomLimit;
	
	    if (zoomLimit) {
	      if (zoomLimit.max != null) {
	        zoom = Math.min(zoomLimit.max, zoom);
	      }
	
	      if (zoomLimit.min != null) {
	        zoom = Math.max(zoomLimit.min, zoom);
	      }
	    }
	
	    this._zoom = zoom;
	
	    this._updateCenterAndZoom();
	  },
	
	  /**
	   * Get default center without roam
	   */
	  getDefaultCenter: function () {
	    // Rect before any transform
	    var rawRect = this.getBoundingRect();
	    var cx = rawRect.x + rawRect.width / 2;
	    var cy = rawRect.y + rawRect.height / 2;
	    return [cx, cy];
	  },
	  getCenter: function () {
	    return this._center || this.getDefaultCenter();
	  },
	  getZoom: function () {
	    return this._zoom || 1;
	  },
	
	  /**
	   * @return {Array.<number}
	   */
	  getRoamTransform: function () {
	    return this._roamTransform;
	  },
	  _updateCenterAndZoom: function () {
	    // Must update after view transform updated
	    var viewTransformMatrix = this._viewTransform.getLocalTransform();
	
	    var roamTransform = this._roamTransform;
	    var defaultCenter = this.getDefaultCenter();
	    var center = this.getCenter();
	    var zoom = this.getZoom();
	    center = vector.applyTransform([], center, viewTransformMatrix);
	    defaultCenter = vector.applyTransform([], defaultCenter, viewTransformMatrix);
	    roamTransform.origin = center;
	    roamTransform.position = [defaultCenter[0] - center[0], defaultCenter[1] - center[1]];
	    roamTransform.scale = [zoom, zoom];
	
	    this._updateTransform();
	  },
	
	  /**
	   * Update transform from roam and mapLocation
	   * @private
	   */
	  _updateTransform: function () {
	    var roamTransform = this._roamTransform;
	    var viewTransform = this._viewTransform;
	    viewTransform.parent = roamTransform;
	    roamTransform.updateTransform();
	    viewTransform.updateTransform();
	    viewTransform.transform && matrix.copy(this.transform || (this.transform = []), viewTransform.transform);
	
	    if (this.transform) {
	      this.invTransform = this.invTransform || [];
	      matrix.invert(this.invTransform, this.transform);
	    } else {
	      this.invTransform = null;
	    }
	
	    this.decomposeTransform();
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getViewRect: function () {
	    return this._viewRect;
	  },
	
	  /**
	   * Get view rect after roam transform
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getViewRectAfterRoam: function () {
	    var rect = this.getBoundingRect().clone();
	    rect.applyTransform(this.transform);
	    return rect;
	  },
	
	  /**
	   * Convert a single (lon, lat) data item to (x, y) point.
	   * @param {Array.<number>} data
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data) {
	    var transform = this.transform;
	    return transform ? v2ApplyTransform([], data, transform) : [data[0], data[1]];
	  },
	
	  /**
	   * Convert a (x, y) point to (lon, lat) data
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToData: function (point) {
	    var invTransform = this.invTransform;
	    return invTransform ? v2ApplyTransform([], point, invTransform) : [point[0], point[1]];
	  },
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData'),
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  containPoint: function (point) {
	    return this.getViewRectAfterRoam().contain(point[0], point[1]);
	  }
	  /**
	   * @return {number}
	   */
	  // getScalarScale: function () {
	  //     // Use determinant square root of transform to mutiply scalar
	  //     var m = this.transform;
	  //     var det = Math.sqrt(Math.abs(m[0] * m[3] - m[2] * m[1]));
	  //     return det;
	  // }
	
	};
	zrUtil.mixin(View, Transformable);
	
	function doConvert(methodName, ecModel, finder, value) {
	  var seriesModel = finder.seriesModel;
	  var coordSys = seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.
	
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	var _default = View;
	module.exports = _default;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var defaultOption = {
	  show: true,
	  zlevel: 0,
	  // 一级层叠
	  z: 0,
	  // 二级层叠
	  // 反向坐标轴
	  inverse: false,
	  // 坐标轴名字，默认为空
	  name: '',
	  // 坐标轴名字位置，支持'start' | 'middle' | 'end'
	  nameLocation: 'end',
	  // 坐标轴名字旋转，degree。
	  nameRotate: null,
	  // Adapt to axis rotate, when nameLocation is 'middle'.
	  nameTruncate: {
	    maxWidth: null,
	    ellipsis: '...',
	    placeholder: '.'
	  },
	  // 坐标轴文字样式，默认取全局样式
	  nameTextStyle: {},
	  // 文字与轴线距离
	  nameGap: 15,
	  silent: false,
	  // Default false to support tooltip.
	  triggerEvent: false,
	  // Default false to avoid legacy user event listener fail.
	  tooltip: {
	    show: false
	  },
	  axisPointer: {},
	  // 坐标轴线
	  axisLine: {
	    // 默认显示，属性show控制显示与否
	    show: true,
	    onZero: true,
	    onZeroAxisIndex: null,
	    // 属性lineStyle控制线条样式
	    lineStyle: {
	      color: '#333',
	      width: 1,
	      type: 'solid'
	    },
	    // 坐标轴两端的箭头
	    symbol: ['none', 'none'],
	    symbolSize: [10, 15]
	  },
	  // 坐标轴小标记
	  axisTick: {
	    // 属性show控制显示与否，默认显示
	    show: true,
	    // 控制小标记是否在grid里
	    inside: false,
	    // 属性length控制线长
	    length: 5,
	    // 属性lineStyle控制线条样式
	    lineStyle: {
	      width: 1
	    }
	  },
	  // 坐标轴文本标签，详见axis.axisLabel
	  axisLabel: {
	    show: true,
	    // 控制文本标签是否在grid里
	    inside: false,
	    rotate: 0,
	    showMinLabel: null,
	    // true | false | null (auto)
	    showMaxLabel: null,
	    // true | false | null (auto)
	    margin: 8,
	    // formatter: null,
	    // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	    fontSize: 12
	  },
	  // 分隔线
	  splitLine: {
	    // 默认显示，属性show控制显示与否
	    show: true,
	    // 属性lineStyle（详见lineStyle）控制线条样式
	    lineStyle: {
	      color: ['#ccc'],
	      width: 1,
	      type: 'solid'
	    }
	  },
	  // 分隔区域
	  splitArea: {
	    // 默认不显示，属性show控制显示与否
	    show: false,
	    // 属性areaStyle（详见areaStyle）控制区域样式
	    areaStyle: {
	      color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
	    }
	  }
	};
	var axisDefault = {};
	axisDefault.categoryAxis = zrUtil.merge({
	  // 类目起始和结束两端空白策略
	  boundaryGap: true,
	  // splitArea: {
	  // show: false
	  // },
	  splitLine: {
	    show: false
	  },
	  // 坐标轴小标记
	  axisTick: {
	    // If tick is align with label when boundaryGap is true
	    alignWithLabel: false,
	    interval: 'auto'
	  },
	  // 坐标轴文本标签，详见axis.axisLabel
	  axisLabel: {
	    interval: 'auto'
	  }
	}, defaultOption);
	axisDefault.valueAxis = zrUtil.merge({
	  // 数值起始和结束两端空白策略
	  boundaryGap: [0, 0],
	  // 最小值, 设置成 'dataMin' 则从数据中计算最小值
	  // min: null,
	  // 最大值，设置成 'dataMax' 则从数据中计算最大值
	  // max: null,
	  // Readonly prop, specifies start value of the range when using data zoom.
	  // rangeStart: null
	  // Readonly prop, specifies end value of the range when using data zoom.
	  // rangeEnd: null
	  // 脱离0值比例，放大聚焦到最终_min，_max区间
	  // scale: false,
	  // 分割段数，默认为5
	  splitNumber: 5 // Minimum interval
	  // minInterval: null
	  // maxInterval: null
	
	}, defaultOption); // FIXME
	
	axisDefault.timeAxis = zrUtil.defaults({
	  scale: true,
	  min: 'dataMin',
	  max: 'dataMax'
	}, axisDefault.valueAxis);
	axisDefault.logAxis = zrUtil.defaults({
	  scale: true,
	  logBase: 10
	}, axisDefault.valueAxis);
	var _default = axisDefault;
	module.exports = _default;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var ComponentModel = __webpack_require__(16);
	
	var axisModelCreator = __webpack_require__(88);
	
	var axisModelCommonMixin = __webpack_require__(55);
	
	var AxisModel = ComponentModel.extend({
	  type: 'cartesian2dAxis',
	
	  /**
	   * @type {module:echarts/coord/cartesian/Axis2D}
	   */
	  axis: null,
	
	  /**
	   * @override
	   */
	  init: function () {
	    AxisModel.superApply(this, 'init', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function () {
	    AxisModel.superApply(this, 'mergeOption', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   */
	  restoreData: function () {
	    AxisModel.superApply(this, 'restoreData', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   * @return {module:echarts/model/Component}
	   */
	  getCoordSysModel: function () {
	    return this.ecModel.queryComponents({
	      mainType: 'grid',
	      index: this.option.gridIndex,
	      id: this.option.gridId
	    })[0];
	  }
	});
	
	function getAxisType(axisDim, option) {
	  // Default axis with data is category axis
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	var extraOption = {
	  // gridIndex: 0,
	  // gridId: '',
	  // Offset is for multiple axis on the same position
	  offset: 0
	};
	axisModelCreator('x', AxisModel, getAxisType, extraOption);
	axisModelCreator('y', AxisModel, getAxisType, extraOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var BoundingRect = __webpack_require__(13);
	
	var bbox = __webpack_require__(136);
	
	var vec2 = __webpack_require__(8);
	
	var polygonContain = __webpack_require__(217);
	
	/**
	 * @module echarts/coord/geo/Region
	 */
	
	/**
	 * @param {string} name
	 * @param {Array} geometries
	 * @param {Array.<number>} cp
	 */
	function Region(name, geometries, cp) {
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  this.name = name;
	  /**
	   * @type {Array.<Array>}
	   * @readOnly
	   */
	
	  this.geometries = geometries;
	
	  if (!cp) {
	    var rect = this.getBoundingRect();
	    cp = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  } else {
	    cp = [cp[0], cp[1]];
	  }
	  /**
	   * @type {Array.<number>}
	   */
	
	
	  this.center = cp;
	}
	
	Region.prototype = {
	  constructor: Region,
	  properties: null,
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function () {
	    var rect = this._rect;
	
	    if (rect) {
	      return rect;
	    }
	
	    var MAX_NUMBER = Number.MAX_VALUE;
	    var min = [MAX_NUMBER, MAX_NUMBER];
	    var max = [-MAX_NUMBER, -MAX_NUMBER];
	    var min2 = [];
	    var max2 = [];
	    var geometries = this.geometries;
	
	    for (var i = 0; i < geometries.length; i++) {
	      // Only support polygon
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      } // Doesn't consider hole
	
	
	      var exterior = geometries[i].exterior;
	      bbox.fromPoints(exterior, min2, max2);
	      vec2.min(min, min, min2);
	      vec2.max(max, max, max2);
	    } // No data
	
	
	    if (i === 0) {
	      min[0] = min[1] = max[0] = max[1] = 0;
	    }
	
	    return this._rect = new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	  },
	
	  /**
	   * @param {<Array.<number>} coord
	   * @return {boolean}
	   */
	  contain: function (coord) {
	    var rect = this.getBoundingRect();
	    var geometries = this.geometries;
	
	    if (!rect.contain(coord[0], coord[1])) {
	      return false;
	    }
	
	    loopGeo: for (var i = 0, len = geometries.length; i < len; i++) {
	      // Only support polygon.
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      }
	
	      var exterior = geometries[i].exterior;
	      var interiors = geometries[i].interiors;
	
	      if (polygonContain.contain(exterior, coord[0], coord[1])) {
	        // Not in the region if point is in the hole.
	        for (var k = 0; k < (interiors ? interiors.length : 0); k++) {
	          if (polygonContain.contain(interiors[k])) {
	            continue loopGeo;
	          }
	        }
	
	        return true;
	      }
	    }
	
	    return false;
	  },
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var aspect = rect.width / rect.height;
	
	    if (!width) {
	      width = aspect * height;
	    } else if (!height) {
	      height = width / aspect;
	    }
	
	    var target = new BoundingRect(x, y, width, height);
	    var transform = rect.calculateTransform(target);
	    var geometries = this.geometries;
	
	    for (var i = 0; i < geometries.length; i++) {
	      // Only support polygon.
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      }
	
	      var exterior = geometries[i].exterior;
	      var interiors = geometries[i].interiors;
	
	      for (var p = 0; p < exterior.length; p++) {
	        vec2.applyTransform(exterior[p], exterior[p], transform);
	      }
	
	      for (var h = 0; h < (interiors ? interiors.length : 0); h++) {
	        for (var p = 0; p < interiors[h].length; p++) {
	          vec2.applyTransform(interiors[h][p], interiors[h][p], transform);
	        }
	      }
	    }
	
	    rect = this._rect;
	    rect.copy(target); // Update center
	
	    this.center = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  }
	};
	var _default = Region;
	module.exports = _default;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Region = __webpack_require__(196);
	
	/**
	 * Parse and decode geo json
	 * @module echarts/coord/geo/parseGeoJson
	 */
	function decode(json) {
	  if (!json.UTF8Encoding) {
	    return json;
	  }
	
	  var encodeScale = json.UTF8Scale;
	
	  if (encodeScale == null) {
	    encodeScale = 1024;
	  }
	
	  var features = json.features;
	
	  for (var f = 0; f < features.length; f++) {
	    var feature = features[f];
	    var geometry = feature.geometry;
	    var coordinates = geometry.coordinates;
	    var encodeOffsets = geometry.encodeOffsets;
	
	    for (var c = 0; c < coordinates.length; c++) {
	      var coordinate = coordinates[c];
	
	      if (geometry.type === 'Polygon') {
	        coordinates[c] = decodePolygon(coordinate, encodeOffsets[c], encodeScale);
	      } else if (geometry.type === 'MultiPolygon') {
	        for (var c2 = 0; c2 < coordinate.length; c2++) {
	          var polygon = coordinate[c2];
	          coordinate[c2] = decodePolygon(polygon, encodeOffsets[c][c2], encodeScale);
	        }
	      }
	    }
	  } // Has been decoded
	
	
	  json.UTF8Encoding = false;
	  return json;
	}
	
	function decodePolygon(coordinate, encodeOffsets, encodeScale) {
	  var result = [];
	  var prevX = encodeOffsets[0];
	  var prevY = encodeOffsets[1];
	
	  for (var i = 0; i < coordinate.length; i += 2) {
	    var x = coordinate.charCodeAt(i) - 64;
	    var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding
	
	    x = x >> 1 ^ -(x & 1);
	    y = y >> 1 ^ -(y & 1); // Delta deocding
	
	    x += prevX;
	    y += prevY;
	    prevX = x;
	    prevY = y; // Dequantize
	
	    result.push([x / encodeScale, y / encodeScale]);
	  }
	
	  return result;
	}
	/**
	 * @alias module:echarts/coord/geo/parseGeoJson
	 * @param {Object} geoJson
	 * @return {module:zrender/container/Group}
	 */
	
	
	function _default(geoJson) {
	  decode(geoJson);
	  return zrUtil.map(zrUtil.filter(geoJson.features, function (featureObj) {
	    // Output of mapshaper may have geometry null
	    return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
	  }), function (featureObj) {
	    var properties = featureObj.properties;
	    var geo = featureObj.geometry;
	    var coordinates = geo.coordinates;
	    var geometries = [];
	
	    if (geo.type === 'Polygon') {
	      geometries.push({
	        type: 'polygon',
	        // According to the GeoJSON specification.
	        // First must be exterior, and the rest are all interior(holes).
	        exterior: coordinates[0],
	        interiors: coordinates.slice(1)
	      });
	    }
	
	    if (geo.type === 'MultiPolygon') {
	      zrUtil.each(coordinates, function (item) {
	        if (item[0]) {
	          geometries.push({
	            type: 'polygon',
	            exterior: item[0],
	            interiors: item.slice(1)
	          });
	        }
	      });
	    }
	
	    var region = new Region(properties.name, geometries, properties.cp);
	    region.properties = properties;
	    return region;
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var Parallel = __webpack_require__(560);
	
	var CoordinateSystem = __webpack_require__(26);
	
	/**
	 * Parallel coordinate system creater.
	 */
	function create(ecModel, api) {
	  var coordSysList = [];
	  ecModel.eachComponent('parallel', function (parallelModel, idx) {
	    var coordSys = new Parallel(parallelModel, ecModel, api);
	    coordSys.name = 'parallel_' + idx;
	    coordSys.resize(parallelModel, api);
	    parallelModel.coordinateSystem = coordSys;
	    coordSys.model = parallelModel;
	    coordSysList.push(coordSys);
	  }); // Inject the coordinateSystems into seriesModel
	
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.get('coordinateSystem') === 'parallel') {
	      var parallelModel = ecModel.queryComponents({
	        mainType: 'parallel',
	        index: seriesModel.get('parallelIndex'),
	        id: seriesModel.get('parallelId')
	      })[0];
	      seriesModel.coordinateSystem = parallelModel.coordinateSystem;
	    }
	  });
	  return coordSysList;
	}
	
	CoordinateSystem.register('parallel', {
	  create: create
	});

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Model = __webpack_require__(14);
	
	var List = __webpack_require__(15);
	
	var linkList = __webpack_require__(200);
	
	var completeDimensions = __webpack_require__(25);
	
	/**
	 * Tree data structure
	 *
	 * @module echarts/data/Tree
	 */
	
	/**
	 * @constructor module:echarts/data/Tree~TreeNode
	 * @param {string} name
	 * @param {module:echarts/data/Tree} hostTree
	 */
	var TreeNode = function (name, hostTree) {
	  /**
	   * @type {string}
	   */
	  this.name = name || '';
	  /**
	   * Depth of node
	   *
	   * @type {number}
	   * @readOnly
	   */
	
	  this.depth = 0;
	  /**
	   * Height of the subtree rooted at this node.
	   * @type {number}
	   * @readOnly
	   */
	
	  this.height = 0;
	  /**
	   * @type {module:echarts/data/Tree~TreeNode}
	   * @readOnly
	   */
	
	  this.parentNode = null;
	  /**
	   * Reference to list item.
	   * Do not persistent dataIndex outside,
	   * besause it may be changed by list.
	   * If dataIndex -1,
	   * this node is logical deleted (filtered) in list.
	   *
	   * @type {Object}
	   * @readOnly
	   */
	
	  this.dataIndex = -1;
	  /**
	   * @type {Array.<module:echarts/data/Tree~TreeNode>}
	   * @readOnly
	   */
	
	  this.children = [];
	  /**
	   * @type {Array.<module:echarts/data/Tree~TreeNode>}
	   * @pubilc
	   */
	
	  this.viewChildren = [];
	  /**
	   * @type {moduel:echarts/data/Tree}
	   * @readOnly
	   */
	
	  this.hostTree = hostTree;
	};
	
	TreeNode.prototype = {
	  constructor: TreeNode,
	
	  /**
	   * The node is removed.
	   * @return {boolean} is removed.
	   */
	  isRemoved: function () {
	    return this.dataIndex < 0;
	  },
	
	  /**
	   * Travel this subtree (include this node).
	   * Usage:
	   *    node.eachNode(function () { ... }); // preorder
	   *    node.eachNode('preorder', function () { ... }); // preorder
	   *    node.eachNode('postorder', function () { ... }); // postorder
	   *    node.eachNode(
	   *        {order: 'postorder', attr: 'viewChildren'},
	   *        function () { ... }
	   *    ); // postorder
	   *
	   * @param {(Object|string)} options If string, means order.
	   * @param {string=} options.order 'preorder' or 'postorder'
	   * @param {string=} options.attr 'children' or 'viewChildren'
	   * @param {Function} cb If in preorder and return false,
	   *                      its subtree will not be visited.
	   * @param {Object} [context]
	   */
	  eachNode: function (options, cb, context) {
	    if (typeof options === 'function') {
	      context = cb;
	      cb = options;
	      options = null;
	    }
	
	    options = options || {};
	
	    if (zrUtil.isString(options)) {
	      options = {
	        order: options
	      };
	    }
	
	    var order = options.order || 'preorder';
	    var children = this[options.attr || 'children'];
	    var suppressVisitSub;
	    order === 'preorder' && (suppressVisitSub = cb.call(context, this));
	
	    for (var i = 0; !suppressVisitSub && i < children.length; i++) {
	      children[i].eachNode(options, cb, context);
	    }
	
	    order === 'postorder' && cb.call(context, this);
	  },
	
	  /**
	   * Update depth and height of this subtree.
	   *
	   * @param  {number} depth
	   */
	  updateDepthAndHeight: function (depth) {
	    var height = 0;
	    this.depth = depth;
	
	    for (var i = 0; i < this.children.length; i++) {
	      var child = this.children[i];
	      child.updateDepthAndHeight(depth + 1);
	
	      if (child.height > height) {
	        height = child.height;
	      }
	    }
	
	    this.height = height + 1;
	  },
	
	  /**
	   * @param  {string} id
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeById: function (id) {
	    if (this.getId() === id) {
	      return this;
	    }
	
	    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
	      var res = children[i].getNodeById(id);
	
	      if (res) {
	        return res;
	      }
	    }
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~TreeNode} node
	   * @return {boolean}
	   */
	  contains: function (node) {
	    if (node === this) {
	      return true;
	    }
	
	    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
	      var res = children[i].contains(node);
	
	      if (res) {
	        return res;
	      }
	    }
	  },
	
	  /**
	   * @param {boolean} includeSelf Default false.
	   * @return {Array.<module:echarts/data/Tree~TreeNode>} order: [root, child, grandchild, ...]
	   */
	  getAncestors: function (includeSelf) {
	    var ancestors = [];
	    var node = includeSelf ? this : this.parentNode;
	
	    while (node) {
	      ancestors.push(node);
	      node = node.parentNode;
	    }
	
	    ancestors.reverse();
	    return ancestors;
	  },
	
	  /**
	   * @param {string|Array=} [dimension='value'] Default 'value'. can be 0, 1, 2, 3
	   * @return {number} Value.
	   */
	  getValue: function (dimension) {
	    var data = this.hostTree.data;
	    return data.get(data.getDimension(dimension || 'value'), this.dataIndex);
	  },
	
	  /**
	   * @param {Object} layout
	   * @param {boolean=} [merge=false]
	   */
	  setLayout: function (layout, merge) {
	    this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
	  },
	
	  /**
	   * @return {Object} layout
	   */
	  getLayout: function () {
	    return this.hostTree.data.getItemLayout(this.dataIndex);
	  },
	
	  /**
	   * @param {string} [path]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path) {
	    if (this.dataIndex < 0) {
	      return;
	    }
	
	    var hostTree = this.hostTree;
	    var itemModel = hostTree.data.getItemModel(this.dataIndex);
	    var levelModel = this.getLevelModel();
	    var leavesModel;
	
	    if (!levelModel && (this.children.length === 0 || this.children.length !== 0 && this.isExpand === false)) {
	      leavesModel = this.getLeavesModel();
	    }
	
	    return itemModel.getModel(path, (levelModel || leavesModel || hostTree.hostModel).getModel(path));
	  },
	
	  /**
	   * @return {module:echarts/model/Model}
	   */
	  getLevelModel: function () {
	    return (this.hostTree.levelModels || [])[this.depth];
	  },
	
	  /**
	   * @return {module:echarts/model/Model}
	   */
	  getLeavesModel: function () {
	    return this.hostTree.leavesModel;
	  },
	
	  /**
	   * @example
	   *  setItemVisual('color', color);
	   *  setItemVisual({
	   *      'color': color
	   *  });
	   */
	  setVisual: function (key, value) {
	    this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
	  },
	
	  /**
	   * Get item visual
	   */
	  getVisual: function (key, ignoreParent) {
	    return this.hostTree.data.getItemVisual(this.dataIndex, key, ignoreParent);
	  },
	
	  /**
	   * @public
	   * @return {number}
	   */
	  getRawIndex: function () {
	    return this.hostTree.data.getRawIndex(this.dataIndex);
	  },
	
	  /**
	   * @public
	   * @return {string}
	   */
	  getId: function () {
	    return this.hostTree.data.getId(this.dataIndex);
	  }
	};
	/**
	 * @constructor
	 * @alias module:echarts/data/Tree
	 * @param {module:echarts/model/Model} hostModel
	 * @param {Array.<Object>} levelOptions
	 * @param {Object} leavesOption
	 */
	
	function Tree(hostModel, levelOptions, leavesOption) {
	  /**
	   * @type {module:echarts/data/Tree~TreeNode}
	   * @readOnly
	   */
	  this.root;
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.data;
	  /**
	   * Index of each item is the same as the raw index of coresponding list item.
	   * @private
	   * @type {Array.<module:echarts/data/Tree~TreeNode}
	   */
	
	  this._nodes = [];
	  /**
	   * @private
	   * @readOnly
	   * @type {module:echarts/model/Model}
	   */
	
	  this.hostModel = hostModel;
	  /**
	   * @private
	   * @readOnly
	   * @type {Array.<module:echarts/model/Model}
	   */
	
	  this.levelModels = zrUtil.map(levelOptions || [], function (levelDefine) {
	    return new Model(levelDefine, hostModel, hostModel.ecModel);
	  });
	  this.leavesModel = new Model(leavesOption || {}, hostModel, hostModel.ecModel);
	}
	
	Tree.prototype = {
	  constructor: Tree,
	  type: 'tree',
	
	  /**
	   * Travel this subtree (include this node).
	   * Usage:
	   *    node.eachNode(function () { ... }); // preorder
	   *    node.eachNode('preorder', function () { ... }); // preorder
	   *    node.eachNode('postorder', function () { ... }); // postorder
	   *    node.eachNode(
	   *        {order: 'postorder', attr: 'viewChildren'},
	   *        function () { ... }
	   *    ); // postorder
	   *
	   * @param {(Object|string)} options If string, means order.
	   * @param {string=} options.order 'preorder' or 'postorder'
	   * @param {string=} options.attr 'children' or 'viewChildren'
	   * @param {Function} cb
	   * @param {Object}   [context]
	   */
	  eachNode: function (options, cb, context) {
	    this.root.eachNode(options, cb, context);
	  },
	
	  /**
	   * @param {number} dataIndex
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeByDataIndex: function (dataIndex) {
	    var rawIndex = this.data.getRawIndex(dataIndex);
	    return this._nodes[rawIndex];
	  },
	
	  /**
	   * @param {string} name
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeByName: function (name) {
	    return this.root.getNodeByName(name);
	  },
	
	  /**
	   * Update item available by list,
	   * when list has been performed options like 'filterSelf' or 'map'.
	   */
	  update: function () {
	    var data = this.data;
	    var nodes = this._nodes;
	
	    for (var i = 0, len = nodes.length; i < len; i++) {
	      nodes[i].dataIndex = -1;
	    }
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      nodes[data.getRawIndex(i)].dataIndex = i;
	    }
	  },
	
	  /**
	   * Clear all layouts
	   */
	  clearLayouts: function () {
	    this.data.clearItemLayouts();
	  }
	};
	/**
	 * data node format:
	 * {
	 *     name: ...
	 *     value: ...
	 *     children: [
	 *         {
	 *             name: ...
	 *             value: ...
	 *             children: ...
	 *         },
	 *         ...
	 *     ]
	 * }
	 *
	 * @static
	 * @param {Object} dataRoot Root node.
	 * @param {module:echarts/model/Model} hostModel
	 * @param {Object} treeOptions
	 * @param {Array.<Object>} treeOptions.levels
	 * @param {Array.<Object>} treeOptions.leaves
	 * @return module:echarts/data/Tree
	 */
	
	Tree.createTree = function (dataRoot, hostModel, treeOptions) {
	  var tree = new Tree(hostModel, treeOptions.levels, treeOptions.leaves);
	  var listData = [];
	  var dimMax = 1;
	  buildHierarchy(dataRoot);
	
	  function buildHierarchy(dataNode, parentNode) {
	    var value = dataNode.value;
	    dimMax = Math.max(dimMax, zrUtil.isArray(value) ? value.length : 1);
	    listData.push(dataNode);
	    var node = new TreeNode(dataNode.name, tree);
	    parentNode ? addChild(node, parentNode) : tree.root = node;
	
	    tree._nodes.push(node);
	
	    var children = dataNode.children;
	
	    if (children) {
	      for (var i = 0; i < children.length; i++) {
	        buildHierarchy(children[i], node);
	      }
	    }
	  }
	
	  tree.root.updateDepthAndHeight(0);
	  var dimensions = completeDimensions([{
	    name: 'value'
	  }], listData, {
	    dimCount: dimMax
	  });
	  var list = new List(dimensions, hostModel);
	  list.initData(listData);
	  linkList({
	    mainData: list,
	    struct: tree,
	    structAttr: 'tree'
	  });
	  tree.update();
	  return tree;
	};
	/**
	 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
	 * so this function is not ready and not necessary to be public.
	 *
	 * @param {(module:echarts/data/Tree~TreeNode|Object)} child
	 */
	
	
	function addChild(child, node) {
	  var children = node.children;
	
	  if (child.parentNode === node) {
	    return;
	  }
	
	  children.push(child);
	  child.parentNode = node;
	}
	
	var _default = Tree;
	module.exports = _default;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	/**
	 * Link lists and struct (graph or tree)
	 */
	var each = zrUtil.each;
	var DATAS = '\0__link_datas';
	var MAIN_DATA = '\0__link_mainData'; // Caution:
	// In most case, either list or its shallow clones (see list.cloneShallow)
	// is active in echarts process. So considering heap memory consumption,
	// we do not clone tree or graph, but share them among list and its shallow clones.
	// But in some rare case, we have to keep old list (like do animation in chart). So
	// please take care that both the old list and the new list share the same tree/graph.
	
	/**
	 * @param {Object} opt
	 * @param {module:echarts/data/List} opt.mainData
	 * @param {Object} [opt.struct] For example, instance of Graph or Tree.
	 * @param {string} [opt.structAttr] designation: list[structAttr] = struct;
	 * @param {Object} [opt.datas] {dataType: data},
	 *                 like: {node: nodeList, edge: edgeList}.
	 *                 Should contain mainData.
	 * @param {Object} [opt.datasAttr] {dataType: attr},
	 *                 designation: struct[datasAttr[dataType]] = list;
	 */
	
	function linkList(opt) {
	  var mainData = opt.mainData;
	  var datas = opt.datas;
	
	  if (!datas) {
	    datas = {
	      main: mainData
	    };
	    opt.datasAttr = {
	      main: 'data'
	    };
	  }
	
	  opt.datas = opt.mainData = null;
	  linkAll(mainData, datas, opt); // Porxy data original methods.
	
	  each(datas, function (data) {
	    each(mainData.TRANSFERABLE_METHODS, function (methodName) {
	      data.wrapMethod(methodName, zrUtil.curry(transferInjection, opt));
	    });
	  }); // Beyond transfer, additional features should be added to `cloneShallow`.
	
	  mainData.wrapMethod('cloneShallow', zrUtil.curry(cloneShallowInjection, opt)); // Only mainData trigger change, because struct.update may trigger
	  // another changable methods, which may bring about dead lock.
	
	  each(mainData.CHANGABLE_METHODS, function (methodName) {
	    mainData.wrapMethod(methodName, zrUtil.curry(changeInjection, opt));
	  }); // Make sure datas contains mainData.
	
	  zrUtil.assert(datas[mainData.dataType] === mainData);
	}
	
	function transferInjection(opt, res) {
	  if (isMainData(this)) {
	    // Transfer datas to new main data.
	    var datas = zrUtil.extend({}, this[DATAS]);
	    datas[this.dataType] = res;
	    linkAll(res, datas, opt);
	  } else {
	    // Modify the reference in main data to point newData.
	    linkSingle(res, this.dataType, this[MAIN_DATA], opt);
	  }
	
	  return res;
	}
	
	function changeInjection(opt, res) {
	  opt.struct && opt.struct.update(this);
	  return res;
	}
	
	function cloneShallowInjection(opt, res) {
	  // cloneShallow, which brings about some fragilities, may be inappropriate
	  // to be exposed as an API. So for implementation simplicity we can make
	  // the restriction that cloneShallow of not-mainData should not be invoked
	  // outside, but only be invoked here.
	  each(res[DATAS], function (data, dataType) {
	    data !== res && linkSingle(data.cloneShallow(), dataType, res, opt);
	  });
	  return res;
	}
	/**
	 * Supplement method to List.
	 *
	 * @public
	 * @param {string} [dataType] If not specified, return mainData.
	 * @return {module:echarts/data/List}
	 */
	
	
	function getLinkedData(dataType) {
	  var mainData = this[MAIN_DATA];
	  return dataType == null || mainData == null ? mainData : mainData[DATAS][dataType];
	}
	
	function isMainData(data) {
	  return data[MAIN_DATA] === data;
	}
	
	function linkAll(mainData, datas, opt) {
	  mainData[DATAS] = {};
	  each(datas, function (data, dataType) {
	    linkSingle(data, dataType, mainData, opt);
	  });
	}
	
	function linkSingle(data, dataType, mainData, opt) {
	  mainData[DATAS][dataType] = data;
	  data[MAIN_DATA] = mainData;
	  data.dataType = dataType;
	
	  if (opt.struct) {
	    data[opt.structAttr] = opt.struct;
	    opt.struct[opt.datasAttr[dataType]] = data;
	  } // Supplement method.
	
	
	  data.getLinkedData = getLinkedData;
	}
	
	var _default = linkList;
	module.exports = _default;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	var zrender = __webpack_require__(101);
	
	exports.zrender = zrender;
	
	var matrix = __webpack_require__(23);
	
	exports.matrix = matrix;
	
	var vector = __webpack_require__(8);
	
	exports.vector = vector;
	
	var zrUtil = __webpack_require__(1);
	
	var colorTool = __webpack_require__(31);
	
	exports.color = colorTool;
	
	var graphic = __webpack_require__(3);
	
	exports.graphic = graphic;
	
	var numberUtil = __webpack_require__(4);
	
	exports.number = numberUtil;
	
	var formatUtil = __webpack_require__(9);
	
	exports.format = formatUtil;
	
	var _throttle = __webpack_require__(45);
	
	var throttle = _throttle.throttle;
	exports.throttle = _throttle.throttle;
	
	var ecHelper = __webpack_require__(579);
	
	exports.helper = ecHelper;
	
	var _List = __webpack_require__(15);
	
	exports.List = _List;
	
	var _Model = __webpack_require__(14);
	
	exports.Model = _Model;
	
	var _Axis = __webpack_require__(36);
	
	exports.Axis = _Axis;
	
	var _env = __webpack_require__(18);
	
	exports.env = _env;
	
	var _parseGeoJson = __webpack_require__(197);
	
	exports.parseGeoJson = _parseGeoJson;
	
	/**
	 * Do not mount those modules on 'src/echarts' for better tree shaking.
	 */
	var ecUtil = {};
	zrUtil.each(['map', 'each', 'filter', 'indexOf', 'inherits', 'reduce', 'filter', 'bind', 'curry', 'isArray', 'isString', 'isObject', 'isFunction', 'extend', 'defaults', 'clone', 'merge'], function (name) {
	  ecUtil[name] = zrUtil[name];
	});
	exports.util = ecUtil;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var _clazz = __webpack_require__(28);
	
	var set = _clazz.set;
	var get = _clazz.get;
	var _default = {
	  clearColorPalette: function () {
	    set(this, 'colorIdx', 0);
	    set(this, 'colorNameMap', {});
	  },
	  getColorFromPalette: function (name, scope) {
	    scope = scope || this;
	    var colorIdx = get(scope, 'colorIdx') || 0;
	    var colorNameMap = get(scope, 'colorNameMap') || set(scope, 'colorNameMap', {}); // Use `hasOwnProperty` to avoid conflict with Object.prototype.
	
	    if (colorNameMap.hasOwnProperty(name)) {
	      return colorNameMap[name];
	    }
	
	    var colorPalette = this.get('color', true) || [];
	
	    if (!colorPalette.length) {
	      return;
	    }
	
	    var color = colorPalette[colorIdx];
	
	    if (name) {
	      colorNameMap[name] = color;
	    }
	
	    set(scope, 'colorIdx', (colorIdx + 1) % colorPalette.length);
	    return color;
	  }
	};
	module.exports = _default;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var numberUtil = __webpack_require__(4);
	
	/**
	 * For testable.
	 */
	var roundNumber = numberUtil.round;
	/**
	 * @param {Array.<number>} extent Both extent[0] and extent[1] should be valid number.
	 *                                Should be extent[0] < extent[1].
	 * @param {number} splitNumber splitNumber should be >= 1.
	 * @param {number} [minInterval]
	 * @param {number} [maxInterval]
	 * @return {Object} {interval, intervalPrecision, niceTickExtent}
	 */
	
	function intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval) {
	  var result = {};
	  var span = extent[1] - extent[0];
	  var interval = result.interval = numberUtil.nice(span / splitNumber, true);
	
	  if (minInterval != null && interval < minInterval) {
	    interval = result.interval = minInterval;
	  }
	
	  if (maxInterval != null && interval > maxInterval) {
	    interval = result.interval = maxInterval;
	  } // Tow more digital for tick.
	
	
	  var precision = result.intervalPrecision = getIntervalPrecision(interval); // Niced extent inside original extent
	
	  var niceTickExtent = result.niceTickExtent = [roundNumber(Math.ceil(extent[0] / interval) * interval, precision), roundNumber(Math.floor(extent[1] / interval) * interval, precision)];
	  fixExtent(niceTickExtent, extent);
	  return result;
	}
	/**
	 * @param {number} interval
	 * @return {number} interval precision
	 */
	
	
	function getIntervalPrecision(interval) {
	  // Tow more digital for tick.
	  return numberUtil.getPrecisionSafe(interval) + 2;
	}
	
	function clamp(niceTickExtent, idx, extent) {
	  niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
	} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.
	
	
	function fixExtent(niceTickExtent, extent) {
	  !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
	  !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
	  clamp(niceTickExtent, 0, extent);
	  clamp(niceTickExtent, 1, extent);
	
	  if (niceTickExtent[0] > niceTickExtent[1]) {
	    niceTickExtent[0] = niceTickExtent[1];
	  }
	}
	
	function intervalScaleGetTicks(interval, extent, niceTickExtent, intervalPrecision) {
	  var ticks = []; // If interval is 0, return [];
	
	  if (!interval) {
	    return ticks;
	  } // Consider this case: using dataZoom toolbox, zoom and zoom.
	
	
	  var safeLimit = 10000;
	
	  if (extent[0] < niceTickExtent[0]) {
	    ticks.push(extent[0]);
	  }
	
	  var tick = niceTickExtent[0];
	
	  while (tick <= niceTickExtent[1]) {
	    ticks.push(tick); // Avoid rounding error
	
	    tick = roundNumber(tick + interval, intervalPrecision);
	
	    if (tick === ticks[ticks.length - 1]) {
	      // Consider out of safe float point, e.g.,
	      // -3711126.9907707 + 2e-10 === -3711126.9907707
	      break;
	    }
	
	    if (ticks.length > safeLimit) {
	      return [];
	    }
	  } // Consider this case: the last item of ticks is smaller
	  // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
	
	
	  if (extent[1] > (ticks.length ? ticks[ticks.length - 1] : niceTickExtent[1])) {
	    ticks.push(extent[1]);
	  }
	
	  return ticks;
	}
	
	exports.intervalScaleNiceTicks = intervalScaleNiceTicks;
	exports.getIntervalPrecision = getIntervalPrecision;
	exports.fixExtent = fixExtent;
	exports.intervalScaleGetTicks = intervalScaleGetTicks;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	/**
	 * nest helper used to group by the array.
	 * can specified the keys and sort the keys.
	 */
	function nest() {
	  var keysFunction = [];
	  var sortKeysFunction = [];
	  /**
	   * map an Array into the mapObject.
	   * @param {Array} array
	   * @param {number} depth
	   */
	
	  function map(array, depth) {
	    if (depth >= keysFunction.length) {
	      return array;
	    }
	
	    var i = -1;
	    var n = array.length;
	    var keyFunction = keysFunction[depth++];
	    var mapObject = {};
	    var valuesByKey = {};
	
	    while (++i < n) {
	      var keyValue = keyFunction(array[i]);
	      var values = valuesByKey[keyValue];
	
	      if (values) {
	        values.push(array[i]);
	      } else {
	        valuesByKey[keyValue] = [array[i]];
	      }
	    }
	
	    zrUtil.each(valuesByKey, function (value, key) {
	      mapObject[key] = map(value, depth);
	    });
	    return mapObject;
	  }
	  /**
	   * transform the Map Object to multidimensional Array
	   * @param {Object} map
	   * @param {number} depth
	   */
	
	
	  function entriesMap(mapObject, depth) {
	    if (depth >= keysFunction.length) {
	      return mapObject;
	    }
	
	    var array = [];
	    var sortKeyFunction = sortKeysFunction[depth++];
	    zrUtil.each(mapObject, function (value, key) {
	      array.push({
	        key: key,
	        values: entriesMap(value, depth)
	      });
	    });
	
	    if (sortKeyFunction) {
	      return array.sort(function (a, b) {
	        return sortKeyFunction(a.key, b.key);
	      });
	    } else {
	      return array;
	    }
	  }
	
	  return {
	    /**
	     * specified the key to groupby the arrays.
	     * users can specified one more keys.
	     * @param {Function} d
	     */
	    key: function (d) {
	      keysFunction.push(d);
	      return this;
	    },
	
	    /**
	     * specified the comparator to sort the keys
	     * @param {Function} order
	     */
	    sortKeys: function (order) {
	      sortKeysFunction[keysFunction.length - 1] = order;
	      return this;
	    },
	
	    /**
	     * the array to be grouped by.
	     * @param {Array} array
	     */
	    entries: function (array) {
	      return entriesMap(map(array, 0), 0);
	    }
	  };
	}
	
	module.exports = nest;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	/**
	 * @file Visual mapping.
	 */
	var visualDefault = {
	  /**
	   * @public
	   */
	  get: function (visualType, key, isCategory) {
	    var value = zrUtil.clone((defaultOption[visualType] || {})[key]);
	    return isCategory ? zrUtil.isArray(value) ? value[value.length - 1] : value : value;
	  }
	};
	var defaultOption = {
	  color: {
	    active: ['#006edd', '#e0ffff'],
	    inactive: ['rgba(0,0,0,0)']
	  },
	  colorHue: {
	    active: [0, 360],
	    inactive: [0, 0]
	  },
	  colorSaturation: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  colorLightness: {
	    active: [0.9, 0.5],
	    inactive: [0, 0]
	  },
	  colorAlpha: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  opacity: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  symbol: {
	    active: ['circle', 'roundRect', 'diamond'],
	    inactive: ['none']
	  },
	  symbolSize: {
	    active: [10, 50],
	    inactive: [0, 0]
	  }
	};
	var _default = visualDefault;
	module.exports = _default;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * getSize v2.0.3
	 * measure size of elements
	 * MIT license
	 */
	
	/* jshint browser: true, strict: true, undef: true, unused: true */
	/* globals console: false */
	
	( function( window, factory ) {
	  /* jshint strict: false */ /* globals define, module */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // browser global
	    window.getSize = factory();
	  }
	
	})( window, function factory() {
	'use strict';
	
	// -------------------------- helpers -------------------------- //
	
	// get a number from a string, not a percentage
	function getStyleSize( value ) {
	  var num = parseFloat( value );
	  // not a percent like '100%', and a number
	  var isValid = value.indexOf('%') == -1 && !isNaN( num );
	  return isValid && num;
	}
	
	function noop() {}
	
	var logError = typeof console == 'undefined' ? noop :
	  function( message ) {
	    console.error( message );
	  };
	
	// -------------------------- measurements -------------------------- //
	
	var measurements = [
	  'paddingLeft',
	  'paddingRight',
	  'paddingTop',
	  'paddingBottom',
	  'marginLeft',
	  'marginRight',
	  'marginTop',
	  'marginBottom',
	  'borderLeftWidth',
	  'borderRightWidth',
	  'borderTopWidth',
	  'borderBottomWidth'
	];
	
	var measurementsLength = measurements.length;
	
	function getZeroSize() {
	  var size = {
	    width: 0,
	    height: 0,
	    innerWidth: 0,
	    innerHeight: 0,
	    outerWidth: 0,
	    outerHeight: 0
	  };
	  for ( var i=0; i < measurementsLength; i++ ) {
	    var measurement = measurements[i];
	    size[ measurement ] = 0;
	  }
	  return size;
	}
	
	// -------------------------- getStyle -------------------------- //
	
	/**
	 * getStyle, get style of element, check for Firefox bug
	 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	 */
	function getStyle( elem ) {
	  var style = getComputedStyle( elem );
	  if ( !style ) {
	    logError( 'Style returned ' + style +
	      '. Are you running this code in a hidden iframe on Firefox? ' +
	      'See https://bit.ly/getsizebug1' );
	  }
	  return style;
	}
	
	// -------------------------- setup -------------------------- //
	
	var isSetup = false;
	
	var isBoxSizeOuter;
	
	/**
	 * setup
	 * check isBoxSizerOuter
	 * do on first getSize() rather than on page load for Firefox bug
	 */
	function setup() {
	  // setup once
	  if ( isSetup ) {
	    return;
	  }
	  isSetup = true;
	
	  // -------------------------- box sizing -------------------------- //
	
	  /**
	   * Chrome & Safari measure the outer-width on style.width on border-box elems
	   * IE11 & Firefox<29 measures the inner-width
	   */
	  var div = document.createElement('div');
	  div.style.width = '200px';
	  div.style.padding = '1px 2px 3px 4px';
	  div.style.borderStyle = 'solid';
	  div.style.borderWidth = '1px 2px 3px 4px';
	  div.style.boxSizing = 'border-box';
	
	  var body = document.body || document.documentElement;
	  body.appendChild( div );
	  var style = getStyle( div );
	  // round value for browser zoom. desandro/masonry#928
	  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
	  getSize.isBoxSizeOuter = isBoxSizeOuter;
	
	  body.removeChild( div );
	}
	
	// -------------------------- getSize -------------------------- //
	
	function getSize( elem ) {
	  setup();
	
	  // use querySeletor if elem is string
	  if ( typeof elem == 'string' ) {
	    elem = document.querySelector( elem );
	  }
	
	  // do not proceed on non-objects
	  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
	    return;
	  }
	
	  var style = getStyle( elem );
	
	  // if hidden, everything is 0
	  if ( style.display == 'none' ) {
	    return getZeroSize();
	  }
	
	  var size = {};
	  size.width = elem.offsetWidth;
	  size.height = elem.offsetHeight;
	
	  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
	
	  // get all measurements
	  for ( var i=0; i < measurementsLength; i++ ) {
	    var measurement = measurements[i];
	    var value = style[ measurement ];
	    var num = parseFloat( value );
	    // any 'auto', 'medium' value will be 0
	    size[ measurement ] = !isNaN( num ) ? num : 0;
	  }
	
	  var paddingWidth = size.paddingLeft + size.paddingRight;
	  var paddingHeight = size.paddingTop + size.paddingBottom;
	  var marginWidth = size.marginLeft + size.marginRight;
	  var marginHeight = size.marginTop + size.marginBottom;
	  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
	  var borderHeight = size.borderTopWidth + size.borderBottomWidth;
	
	  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
	
	  // overwrite width and height if we can get it from style
	  var styleWidth = getStyleSize( style.width );
	  if ( styleWidth !== false ) {
	    size.width = styleWidth +
	      // add padding and border unless it's already including it
	      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
	  }
	
	  var styleHeight = getStyleSize( style.height );
	  if ( styleHeight !== false ) {
	    size.height = styleHeight +
	      // add padding and border unless it's already including it
	      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
	  }
	
	  size.innerWidth = size.width - ( paddingWidth + borderWidth );
	  size.innerHeight = size.height - ( paddingHeight + borderHeight );
	
	  size.outerWidth = size.width + marginWidth;
	  size.outerHeight = size.height + marginHeight;
	
	  return size;
	}
	
	return getSize;
	
	});


/***/ }),
/* 207 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(320);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(59)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!./wizard.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!./wizard.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "glyphicons-halflings-regular.eot";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "insta.png";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(249)
	__vue_template__ = __webpack_require__(644)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * Vue.js v1.0.28
	 * (c) 2016 Evan You
	 * Released under the MIT License.
	 */
	'use strict';
	
	function set(obj, key, val) {
	  if (hasOwn(obj, key)) {
	    obj[key] = val;
	    return;
	  }
	  if (obj._isVue) {
	    set(obj._data, key, val);
	    return;
	  }
	  var ob = obj.__ob__;
	  if (!ob) {
	    obj[key] = val;
	    return;
	  }
	  ob.convert(key, val);
	  ob.dep.notify();
	  if (ob.vms) {
	    var i = ob.vms.length;
	    while (i--) {
	      var vm = ob.vms[i];
	      vm._proxy(key);
	      vm._digest();
	    }
	  }
	  return val;
	}
	
	/**
	 * Delete a property and trigger change if necessary.
	 *
	 * @param {Object} obj
	 * @param {String} key
	 */
	
	function del(obj, key) {
	  if (!hasOwn(obj, key)) {
	    return;
	  }
	  delete obj[key];
	  var ob = obj.__ob__;
	  if (!ob) {
	    if (obj._isVue) {
	      delete obj._data[key];
	      obj._digest();
	    }
	    return;
	  }
	  ob.dep.notify();
	  if (ob.vms) {
	    var i = ob.vms.length;
	    while (i--) {
	      var vm = ob.vms[i];
	      vm._unproxy(key);
	      vm._digest();
	    }
	  }
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	 * Check whether the object has the property.
	 *
	 * @param {Object} obj
	 * @param {String} key
	 * @return {Boolean}
	 */
	
	function hasOwn(obj, key) {
	  return hasOwnProperty.call(obj, key);
	}
	
	/**
	 * Check if an expression is a literal value.
	 *
	 * @param {String} exp
	 * @return {Boolean}
	 */
	
	var literalValueRE = /^\s?(true|false|-?[\d\.]+|'[^']*'|"[^"]*")\s?$/;
	
	function isLiteral(exp) {
	  return literalValueRE.test(exp);
	}
	
	/**
	 * Check if a string starts with $ or _
	 *
	 * @param {String} str
	 * @return {Boolean}
	 */
	
	function isReserved(str) {
	  var c = (str + '').charCodeAt(0);
	  return c === 0x24 || c === 0x5F;
	}
	
	/**
	 * Guard text output, make sure undefined outputs
	 * empty string
	 *
	 * @param {*} value
	 * @return {String}
	 */
	
	function _toString(value) {
	  return value == null ? '' : value.toString();
	}
	
	/**
	 * Check and convert possible numeric strings to numbers
	 * before setting back to data
	 *
	 * @param {*} value
	 * @return {*|Number}
	 */
	
	function toNumber(value) {
	  if (typeof value !== 'string') {
	    return value;
	  } else {
	    var parsed = Number(value);
	    return isNaN(parsed) ? value : parsed;
	  }
	}
	
	/**
	 * Convert string boolean literals into real booleans.
	 *
	 * @param {*} value
	 * @return {*|Boolean}
	 */
	
	function toBoolean(value) {
	  return value === 'true' ? true : value === 'false' ? false : value;
	}
	
	/**
	 * Strip quotes from a string
	 *
	 * @param {String} str
	 * @return {String | false}
	 */
	
	function stripQuotes(str) {
	  var a = str.charCodeAt(0);
	  var b = str.charCodeAt(str.length - 1);
	  return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
	}
	
	/**
	 * Camelize a hyphen-delimited string.
	 *
	 * @param {String} str
	 * @return {String}
	 */
	
	var camelizeRE = /-(\w)/g;
	
	function camelize(str) {
	  return str.replace(camelizeRE, toUpper);
	}
	
	function toUpper(_, c) {
	  return c ? c.toUpperCase() : '';
	}
	
	/**
	 * Hyphenate a camelCase string.
	 *
	 * @param {String} str
	 * @return {String}
	 */
	
	var hyphenateRE = /([^-])([A-Z])/g;
	
	function hyphenate(str) {
	  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
	}
	
	/**
	 * Converts hyphen/underscore/slash delimitered names into
	 * camelized classNames.
	 *
	 * e.g. my-component => MyComponent
	 *      some_else    => SomeElse
	 *      some/comp    => SomeComp
	 *
	 * @param {String} str
	 * @return {String}
	 */
	
	var classifyRE = /(?:^|[-_\/])(\w)/g;
	
	function classify(str) {
	  return str.replace(classifyRE, toUpper);
	}
	
	/**
	 * Simple bind, faster than native
	 *
	 * @param {Function} fn
	 * @param {Object} ctx
	 * @return {Function}
	 */
	
	function bind(fn, ctx) {
	  return function (a) {
	    var l = arguments.length;
	    return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
	  };
	}
	
	/**
	 * Convert an Array-like object to a real Array.
	 *
	 * @param {Array-like} list
	 * @param {Number} [start] - start index
	 * @return {Array}
	 */
	
	function toArray(list, start) {
	  start = start || 0;
	  var i = list.length - start;
	  var ret = new Array(i);
	  while (i--) {
	    ret[i] = list[i + start];
	  }
	  return ret;
	}
	
	/**
	 * Mix properties into target object.
	 *
	 * @param {Object} to
	 * @param {Object} from
	 */
	
	function extend(to, from) {
	  var keys = Object.keys(from);
	  var i = keys.length;
	  while (i--) {
	    to[keys[i]] = from[keys[i]];
	  }
	  return to;
	}
	
	/**
	 * Quick object check - this is primarily used to tell
	 * Objects from primitive values when we know the value
	 * is a JSON-compliant type.
	 *
	 * @param {*} obj
	 * @return {Boolean}
	 */
	
	function isObject(obj) {
	  return obj !== null && typeof obj === 'object';
	}
	
	/**
	 * Strict object type check. Only returns true
	 * for plain JavaScript objects.
	 *
	 * @param {*} obj
	 * @return {Boolean}
	 */
	
	var toString = Object.prototype.toString;
	var OBJECT_STRING = '[object Object]';
	
	function isPlainObject(obj) {
	  return toString.call(obj) === OBJECT_STRING;
	}
	
	/**
	 * Array type check.
	 *
	 * @param {*} obj
	 * @return {Boolean}
	 */
	
	var isArray = Array.isArray;
	
	/**
	 * Define a property.
	 *
	 * @param {Object} obj
	 * @param {String} key
	 * @param {*} val
	 * @param {Boolean} [enumerable]
	 */
	
	function def(obj, key, val, enumerable) {
	  Object.defineProperty(obj, key, {
	    value: val,
	    enumerable: !!enumerable,
	    writable: true,
	    configurable: true
	  });
	}
	
	/**
	 * Debounce a function so it only gets called after the
	 * input stops arriving after the given wait period.
	 *
	 * @param {Function} func
	 * @param {Number} wait
	 * @return {Function} - the debounced function
	 */
	
	function _debounce(func, wait) {
	  var timeout, args, context, timestamp, result;
	  var later = function later() {
	    var last = Date.now() - timestamp;
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    }
	  };
	  return function () {
	    context = this;
	    args = arguments;
	    timestamp = Date.now();
	    if (!timeout) {
	      timeout = setTimeout(later, wait);
	    }
	    return result;
	  };
	}
	
	/**
	 * Manual indexOf because it's slightly faster than
	 * native.
	 *
	 * @param {Array} arr
	 * @param {*} obj
	 */
	
	function indexOf(arr, obj) {
	  var i = arr.length;
	  while (i--) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	}
	
	/**
	 * Make a cancellable version of an async callback.
	 *
	 * @param {Function} fn
	 * @return {Function}
	 */
	
	function cancellable(fn) {
	  var cb = function cb() {
	    if (!cb.cancelled) {
	      return fn.apply(this, arguments);
	    }
	  };
	  cb.cancel = function () {
	    cb.cancelled = true;
	  };
	  return cb;
	}
	
	/**
	 * Check if two values are loosely equal - that is,
	 * if they are plain objects, do they have the same shape?
	 *
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 */
	
	function looseEqual(a, b) {
	  /* eslint-disable eqeqeq */
	  return a == b || (isObject(a) && isObject(b) ? JSON.stringify(a) === JSON.stringify(b) : false);
	  /* eslint-enable eqeqeq */
	}
	
	var hasProto = ('__proto__' in {});
	
	// Browser environment sniffing
	var inBrowser = typeof window !== 'undefined' && Object.prototype.toString.call(window) !== '[object Object]';
	
	// detect devtools
	var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	// UA sniffing for working around browser-specific quirks
	var UA = inBrowser && window.navigator.userAgent.toLowerCase();
	var isIE = UA && UA.indexOf('trident') > 0;
	var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
	var isAndroid = UA && UA.indexOf('android') > 0;
	var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
	
	var transitionProp = undefined;
	var transitionEndEvent = undefined;
	var animationProp = undefined;
	var animationEndEvent = undefined;
	
	// Transition property/event sniffing
	if (inBrowser && !isIE9) {
	  var isWebkitTrans = window.ontransitionend === undefined && window.onwebkittransitionend !== undefined;
	  var isWebkitAnim = window.onanimationend === undefined && window.onwebkitanimationend !== undefined;
	  transitionProp = isWebkitTrans ? 'WebkitTransition' : 'transition';
	  transitionEndEvent = isWebkitTrans ? 'webkitTransitionEnd' : 'transitionend';
	  animationProp = isWebkitAnim ? 'WebkitAnimation' : 'animation';
	  animationEndEvent = isWebkitAnim ? 'webkitAnimationEnd' : 'animationend';
	}
	
	/* istanbul ignore next */
	function isNative(Ctor) {
	  return (/native code/.test(Ctor.toString())
	  );
	}
	
	/**
	 * Defer a task to execute it asynchronously. Ideally this
	 * should be executed as a microtask, so we leverage
	 * MutationObserver if it's available, and fallback to
	 * setTimeout(0).
	 *
	 * @param {Function} cb
	 * @param {Object} ctx
	 */
	
	var nextTick = (function () {
	  var callbacks = [];
	  var pending = false;
	  var timerFunc = undefined;
	
	  function nextTickHandler() {
	    pending = false;
	    var copies = callbacks.slice(0);
	    callbacks.length = 0;
	    for (var i = 0; i < copies.length; i++) {
	      copies[i]();
	    }
	  }
	
	  // the nextTick behavior leverages the microtask queue, which can be accessed
	  // via either native Promise.then or MutationObserver.
	  // MutationObserver has wider support, however it is seriously bugged in
	  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
	  // completely stops working after triggering a few times... so, if native
	  // Promise is available, we will use it:
	  /* istanbul ignore if */
	  if (typeof Promise !== 'undefined' && isNative(Promise)) {
	    var p = Promise.resolve();
	    var noop = function noop() {};
	    timerFunc = function () {
	      p.then(nextTickHandler);
	      // in problematic UIWebViews, Promise.then doesn't completely break, but
	      // it can get stuck in a weird state where callbacks are pushed into the
	      // microtask queue but the queue isn't being flushed, until the browser
	      // needs to do some other work, e.g. handle a timer. Therefore we can
	      // "force" the microtask queue to be flushed by adding an empty timer.
	      if (isIOS) setTimeout(noop);
	    };
	  } else if (typeof MutationObserver !== 'undefined') {
	    // use MutationObserver where native Promise is not available,
	    // e.g. IE11, iOS7, Android 4.4
	    var counter = 1;
	    var observer = new MutationObserver(nextTickHandler);
	    var textNode = document.createTextNode(String(counter));
	    observer.observe(textNode, {
	      characterData: true
	    });
	    timerFunc = function () {
	      counter = (counter + 1) % 2;
	      textNode.data = String(counter);
	    };
	  } else {
	    // fallback to setTimeout
	    /* istanbul ignore next */
	    timerFunc = setTimeout;
	  }
	
	  return function (cb, ctx) {
	    var func = ctx ? function () {
	      cb.call(ctx);
	    } : cb;
	    callbacks.push(func);
	    if (pending) return;
	    pending = true;
	    timerFunc(nextTickHandler, 0);
	  };
	})();
	
	var _Set = undefined;
	/* istanbul ignore if */
	if (typeof Set !== 'undefined' && isNative(Set)) {
	  // use native Set when available.
	  _Set = Set;
	} else {
	  // a non-standard Set polyfill that only works with primitive keys.
	  _Set = function () {
	    this.set = Object.create(null);
	  };
	  _Set.prototype.has = function (key) {
	    return this.set[key] !== undefined;
	  };
	  _Set.prototype.add = function (key) {
	    this.set[key] = 1;
	  };
	  _Set.prototype.clear = function () {
	    this.set = Object.create(null);
	  };
	}
	
	function Cache(limit) {
	  this.size = 0;
	  this.limit = limit;
	  this.head = this.tail = undefined;
	  this._keymap = Object.create(null);
	}
	
	var p = Cache.prototype;
	
	/**
	 * Put <value> into the cache associated with <key>.
	 * Returns the entry which was removed to make room for
	 * the new entry. Otherwise undefined is returned.
	 * (i.e. if there was enough room already).
	 *
	 * @param {String} key
	 * @param {*} value
	 * @return {Entry|undefined}
	 */
	
	p.put = function (key, value) {
	  var removed;
	
	  var entry = this.get(key, true);
	  if (!entry) {
	    if (this.size === this.limit) {
	      removed = this.shift();
	    }
	    entry = {
	      key: key
	    };
	    this._keymap[key] = entry;
	    if (this.tail) {
	      this.tail.newer = entry;
	      entry.older = this.tail;
	    } else {
	      this.head = entry;
	    }
	    this.tail = entry;
	    this.size++;
	  }
	  entry.value = value;
	
	  return removed;
	};
	
	/**
	 * Purge the least recently used (oldest) entry from the
	 * cache. Returns the removed entry or undefined if the
	 * cache was empty.
	 */
	
	p.shift = function () {
	  var entry = this.head;
	  if (entry) {
	    this.head = this.head.newer;
	    this.head.older = undefined;
	    entry.newer = entry.older = undefined;
	    this._keymap[entry.key] = undefined;
	    this.size--;
	  }
	  return entry;
	};
	
	/**
	 * Get and register recent use of <key>. Returns the value
	 * associated with <key> or undefined if not in cache.
	 *
	 * @param {String} key
	 * @param {Boolean} returnEntry
	 * @return {Entry|*}
	 */
	
	p.get = function (key, returnEntry) {
	  var entry = this._keymap[key];
	  if (entry === undefined) return;
	  if (entry === this.tail) {
	    return returnEntry ? entry : entry.value;
	  }
	  // HEAD--------------TAIL
	  //   <.older   .newer>
	  //  <--- add direction --
	  //   A  B  C  <D>  E
	  if (entry.newer) {
	    if (entry === this.head) {
	      this.head = entry.newer;
	    }
	    entry.newer.older = entry.older; // C <-- E.
	  }
	  if (entry.older) {
	    entry.older.newer = entry.newer; // C. --> E
	  }
	  entry.newer = undefined; // D --x
	  entry.older = this.tail; // D. --> E
	  if (this.tail) {
	    this.tail.newer = entry; // E. <-- D
	  }
	  this.tail = entry;
	  return returnEntry ? entry : entry.value;
	};
	
	var cache$1 = new Cache(1000);
	var reservedArgRE = /^in$|^-?\d+/;
	
	/**
	 * Parser state
	 */
	
	var str;
	var dir;
	var len;
	var index;
	var chr;
	var state;
	var startState = 0;
	var filterState = 1;
	var filterNameState = 2;
	var filterArgState = 3;
	
	var doubleChr = 0x22;
	var singleChr = 0x27;
	var pipeChr = 0x7C;
	var escapeChr = 0x5C;
	var spaceChr = 0x20;
	
	var expStartChr = { 0x5B: 1, 0x7B: 1, 0x28: 1 };
	var expChrPair = { 0x5B: 0x5D, 0x7B: 0x7D, 0x28: 0x29 };
	
	function peek() {
	  return str.charCodeAt(index + 1);
	}
	
	function next() {
	  return str.charCodeAt(++index);
	}
	
	function eof() {
	  return index >= len;
	}
	
	function eatSpace() {
	  while (peek() === spaceChr) {
	    next();
	  }
	}
	
	function isStringStart(chr) {
	  return chr === doubleChr || chr === singleChr;
	}
	
	function isExpStart(chr) {
	  return expStartChr[chr];
	}
	
	function isExpEnd(start, chr) {
	  return expChrPair[start] === chr;
	}
	
	function parseString() {
	  var stringQuote = next();
	  var chr;
	  while (!eof()) {
	    chr = next();
	    // escape char
	    if (chr === escapeChr) {
	      next();
	    } else if (chr === stringQuote) {
	      break;
	    }
	  }
	}
	
	function parseSpecialExp(chr) {
	  var inExp = 0;
	  var startChr = chr;
	
	  while (!eof()) {
	    chr = peek();
	    if (isStringStart(chr)) {
	      parseString();
	      continue;
	    }
	
	    if (startChr === chr) {
	      inExp++;
	    }
	    if (isExpEnd(startChr, chr)) {
	      inExp--;
	    }
	
	    next();
	
	    if (inExp === 0) {
	      break;
	    }
	  }
	}
	
	/**
	 * syntax:
	 * expression | filterName  [arg  arg [| filterName arg arg]]
	 */
	
	function parseExpression() {
	  var start = index;
	  while (!eof()) {
	    chr = peek();
	    if (isStringStart(chr)) {
	      parseString();
	    } else if (isExpStart(chr)) {
	      parseSpecialExp(chr);
	    } else if (chr === pipeChr) {
	      next();
	      chr = peek();
	      if (chr === pipeChr) {
	        next();
	      } else {
	        if (state === startState || state === filterArgState) {
	          state = filterState;
	        }
	        break;
	      }
	    } else if (chr === spaceChr && (state === filterNameState || state === filterArgState)) {
	      eatSpace();
	      break;
	    } else {
	      if (state === filterState) {
	        state = filterNameState;
	      }
	      next();
	    }
	  }
	
	  return str.slice(start + 1, index) || null;
	}
	
	function parseFilterList() {
	  var filters = [];
	  while (!eof()) {
	    filters.push(parseFilter());
	  }
	  return filters;
	}
	
	function parseFilter() {
	  var filter = {};
	  var args;
	
	  state = filterState;
	  filter.name = parseExpression().trim();
	
	  state = filterArgState;
	  args = parseFilterArguments();
	
	  if (args.length) {
	    filter.args = args;
	  }
	  return filter;
	}
	
	function parseFilterArguments() {
	  var args = [];
	  while (!eof() && state !== filterState) {
	    var arg = parseExpression();
	    if (!arg) {
	      break;
	    }
	    args.push(processFilterArg(arg));
	  }
	
	  return args;
	}
	
	/**
	 * Check if an argument is dynamic and strip quotes.
	 *
	 * @param {String} arg
	 * @return {Object}
	 */
	
	function processFilterArg(arg) {
	  if (reservedArgRE.test(arg)) {
	    return {
	      value: toNumber(arg),
	      dynamic: false
	    };
	  } else {
	    var stripped = stripQuotes(arg);
	    var dynamic = stripped === arg;
	    return {
	      value: dynamic ? arg : stripped,
	      dynamic: dynamic
	    };
	  }
	}
	
	/**
	 * Parse a directive value and extract the expression
	 * and its filters into a descriptor.
	 *
	 * Example:
	 *
	 * "a + 1 | uppercase" will yield:
	 * {
	 *   expression: 'a + 1',
	 *   filters: [
	 *     { name: 'uppercase', args: null }
	 *   ]
	 * }
	 *
	 * @param {String} s
	 * @return {Object}
	 */
	
	function parseDirective(s) {
	  var hit = cache$1.get(s);
	  if (hit) {
	    return hit;
	  }
	
	  // reset parser state
	  str = s;
	  dir = {};
	  len = str.length;
	  index = -1;
	  chr = '';
	  state = startState;
	
	  var filters;
	
	  if (str.indexOf('|') < 0) {
	    dir.expression = str.trim();
	  } else {
	    dir.expression = parseExpression().trim();
	    filters = parseFilterList();
	    if (filters.length) {
	      dir.filters = filters;
	    }
	  }
	
	  cache$1.put(s, dir);
	  return dir;
	}
	
	var directive = Object.freeze({
	  parseDirective: parseDirective
	});
	
	var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
	var cache = undefined;
	var tagRE = undefined;
	var htmlRE = undefined;
	/**
	 * Escape a string so it can be used in a RegExp
	 * constructor.
	 *
	 * @param {String} str
	 */
	
	function escapeRegex(str) {
	  return str.replace(regexEscapeRE, '\\$&');
	}
	
	function compileRegex() {
	  var open = escapeRegex(config.delimiters[0]);
	  var close = escapeRegex(config.delimiters[1]);
	  var unsafeOpen = escapeRegex(config.unsafeDelimiters[0]);
	  var unsafeClose = escapeRegex(config.unsafeDelimiters[1]);
	  tagRE = new RegExp(unsafeOpen + '((?:.|\\n)+?)' + unsafeClose + '|' + open + '((?:.|\\n)+?)' + close, 'g');
	  htmlRE = new RegExp('^' + unsafeOpen + '((?:.|\\n)+?)' + unsafeClose + '$');
	  // reset cache
	  cache = new Cache(1000);
	}
	
	/**
	 * Parse a template text string into an array of tokens.
	 *
	 * @param {String} text
	 * @return {Array<Object> | null}
	 *               - {String} type
	 *               - {String} value
	 *               - {Boolean} [html]
	 *               - {Boolean} [oneTime]
	 */
	
	function parseText(text) {
	  if (!cache) {
	    compileRegex();
	  }
	  var hit = cache.get(text);
	  if (hit) {
	    return hit;
	  }
	  if (!tagRE.test(text)) {
	    return null;
	  }
	  var tokens = [];
	  var lastIndex = tagRE.lastIndex = 0;
	  var match, index, html, value, first, oneTime;
	  /* eslint-disable no-cond-assign */
	  while (match = tagRE.exec(text)) {
	    /* eslint-enable no-cond-assign */
	    index = match.index;
	    // push text token
	    if (index > lastIndex) {
	      tokens.push({
	        value: text.slice(lastIndex, index)
	      });
	    }
	    // tag token
	    html = htmlRE.test(match[0]);
	    value = html ? match[1] : match[2];
	    first = value.charCodeAt(0);
	    oneTime = first === 42; // *
	    value = oneTime ? value.slice(1) : value;
	    tokens.push({
	      tag: true,
	      value: value.trim(),
	      html: html,
	      oneTime: oneTime
	    });
	    lastIndex = index + match[0].length;
	  }
	  if (lastIndex < text.length) {
	    tokens.push({
	      value: text.slice(lastIndex)
	    });
	  }
	  cache.put(text, tokens);
	  return tokens;
	}
	
	/**
	 * Format a list of tokens into an expression.
	 * e.g. tokens parsed from 'a {{b}} c' can be serialized
	 * into one single expression as '"a " + b + " c"'.
	 *
	 * @param {Array} tokens
	 * @param {Vue} [vm]
	 * @return {String}
	 */
	
	function tokensToExp(tokens, vm) {
	  if (tokens.length > 1) {
	    return tokens.map(function (token) {
	      return formatToken(token, vm);
	    }).join('+');
	  } else {
	    return formatToken(tokens[0], vm, true);
	  }
	}
	
	/**
	 * Format a single token.
	 *
	 * @param {Object} token
	 * @param {Vue} [vm]
	 * @param {Boolean} [single]
	 * @return {String}
	 */
	
	function formatToken(token, vm, single) {
	  return token.tag ? token.oneTime && vm ? '"' + vm.$eval(token.value) + '"' : inlineFilters(token.value, single) : '"' + token.value + '"';
	}
	
	/**
	 * For an attribute with multiple interpolation tags,
	 * e.g. attr="some-{{thing | filter}}", in order to combine
	 * the whole thing into a single watchable expression, we
	 * have to inline those filters. This function does exactly
	 * that. This is a bit hacky but it avoids heavy changes
	 * to directive parser and watcher mechanism.
	 *
	 * @param {String} exp
	 * @param {Boolean} single
	 * @return {String}
	 */
	
	var filterRE = /[^|]\|[^|]/;
	function inlineFilters(exp, single) {
	  if (!filterRE.test(exp)) {
	    return single ? exp : '(' + exp + ')';
	  } else {
	    var dir = parseDirective(exp);
	    if (!dir.filters) {
	      return '(' + exp + ')';
	    } else {
	      return 'this._applyFilters(' + dir.expression + // value
	      ',null,' + // oldValue (null for read)
	      JSON.stringify(dir.filters) + // filter descriptors
	      ',false)'; // write?
	    }
	  }
	}
	
	var text = Object.freeze({
	  compileRegex: compileRegex,
	  parseText: parseText,
	  tokensToExp: tokensToExp
	});
	
	var delimiters = ['{{', '}}'];
	var unsafeDelimiters = ['{{{', '}}}'];
	
	var config = Object.defineProperties({
	
	  /**
	   * Whether to print debug messages.
	   * Also enables stack trace for warnings.
	   *
	   * @type {Boolean}
	   */
	
	  debug: false,
	
	  /**
	   * Whether to suppress warnings.
	   *
	   * @type {Boolean}
	   */
	
	  silent: false,
	
	  /**
	   * Whether to use async rendering.
	   */
	
	  async: true,
	
	  /**
	   * Whether to warn against errors caught when evaluating
	   * expressions.
	   */
	
	  warnExpressionErrors: true,
	
	  /**
	   * Whether to allow devtools inspection.
	   * Disabled by default in production builds.
	   */
	
	  devtools: ("production") !== 'production',
	
	  /**
	   * Internal flag to indicate the delimiters have been
	   * changed.
	   *
	   * @type {Boolean}
	   */
	
	  _delimitersChanged: true,
	
	  /**
	   * List of asset types that a component can own.
	   *
	   * @type {Array}
	   */
	
	  _assetTypes: ['component', 'directive', 'elementDirective', 'filter', 'transition', 'partial'],
	
	  /**
	   * prop binding modes
	   */
	
	  _propBindingModes: {
	    ONE_WAY: 0,
	    TWO_WAY: 1,
	    ONE_TIME: 2
	  },
	
	  /**
	   * Max circular updates allowed in a batcher flush cycle.
	   */
	
	  _maxUpdateCount: 100
	
	}, {
	  delimiters: { /**
	                 * Interpolation delimiters. Changing these would trigger
	                 * the text parser to re-compile the regular expressions.
	                 *
	                 * @type {Array<String>}
	                 */
	
	    get: function get() {
	      return delimiters;
	    },
	    set: function set(val) {
	      delimiters = val;
	      compileRegex();
	    },
	    configurable: true,
	    enumerable: true
	  },
	  unsafeDelimiters: {
	    get: function get() {
	      return unsafeDelimiters;
	    },
	    set: function set(val) {
	      unsafeDelimiters = val;
	      compileRegex();
	    },
	    configurable: true,
	    enumerable: true
	  }
	});
	
	var warn = undefined;
	var formatComponentName = undefined;
	
	if (false) {
	  (function () {
	    var hasConsole = typeof console !== 'undefined';
	
	    warn = function (msg, vm) {
	      if (hasConsole && !config.silent) {
	        console.error('[Vue warn]: ' + msg + (vm ? formatComponentName(vm) : ''));
	      }
	    };
	
	    formatComponentName = function (vm) {
	      var name = vm._isVue ? vm.$options.name : vm.name;
	      return name ? ' (found in component: <' + hyphenate(name) + '>)' : '';
	    };
	  })();
	}
	
	/**
	 * Append with transition.
	 *
	 * @param {Element} el
	 * @param {Element} target
	 * @param {Vue} vm
	 * @param {Function} [cb]
	 */
	
	function appendWithTransition(el, target, vm, cb) {
	  applyTransition(el, 1, function () {
	    target.appendChild(el);
	  }, vm, cb);
	}
	
	/**
	 * InsertBefore with transition.
	 *
	 * @param {Element} el
	 * @param {Element} target
	 * @param {Vue} vm
	 * @param {Function} [cb]
	 */
	
	function beforeWithTransition(el, target, vm, cb) {
	  applyTransition(el, 1, function () {
	    before(el, target);
	  }, vm, cb);
	}
	
	/**
	 * Remove with transition.
	 *
	 * @param {Element} el
	 * @param {Vue} vm
	 * @param {Function} [cb]
	 */
	
	function removeWithTransition(el, vm, cb) {
	  applyTransition(el, -1, function () {
	    remove(el);
	  }, vm, cb);
	}
	
	/**
	 * Apply transitions with an operation callback.
	 *
	 * @param {Element} el
	 * @param {Number} direction
	 *                  1: enter
	 *                 -1: leave
	 * @param {Function} op - the actual DOM operation
	 * @param {Vue} vm
	 * @param {Function} [cb]
	 */
	
	function applyTransition(el, direction, op, vm, cb) {
	  var transition = el.__v_trans;
	  if (!transition ||
	  // skip if there are no js hooks and CSS transition is
	  // not supported
	  !transition.hooks && !transitionEndEvent ||
	  // skip transitions for initial compile
	  !vm._isCompiled ||
	  // if the vm is being manipulated by a parent directive
	  // during the parent's compilation phase, skip the
	  // animation.
	  vm.$parent && !vm.$parent._isCompiled) {
	    op();
	    if (cb) cb();
	    return;
	  }
	  var action = direction > 0 ? 'enter' : 'leave';
	  transition[action](op, cb);
	}
	
	var transition = Object.freeze({
	  appendWithTransition: appendWithTransition,
	  beforeWithTransition: beforeWithTransition,
	  removeWithTransition: removeWithTransition,
	  applyTransition: applyTransition
	});
	
	/**
	 * Query an element selector if it's not an element already.
	 *
	 * @param {String|Element} el
	 * @return {Element}
	 */
	
	function query(el) {
	  if (typeof el === 'string') {
	    var selector = el;
	    el = document.querySelector(el);
	    if (!el) {
	      ("production") !== 'production' && warn('Cannot find element: ' + selector);
	    }
	  }
	  return el;
	}
	
	/**
	 * Check if a node is in the document.
	 * Note: document.documentElement.contains should work here
	 * but always returns false for comment nodes in phantomjs,
	 * making unit tests difficult. This is fixed by doing the
	 * contains() check on the node's parentNode instead of
	 * the node itself.
	 *
	 * @param {Node} node
	 * @return {Boolean}
	 */
	
	function inDoc(node) {
	  if (!node) return false;
	  var doc = node.ownerDocument.documentElement;
	  var parent = node.parentNode;
	  return doc === node || doc === parent || !!(parent && parent.nodeType === 1 && doc.contains(parent));
	}
	
	/**
	 * Get and remove an attribute from a node.
	 *
	 * @param {Node} node
	 * @param {String} _attr
	 */
	
	function getAttr(node, _attr) {
	  var val = node.getAttribute(_attr);
	  if (val !== null) {
	    node.removeAttribute(_attr);
	  }
	  return val;
	}
	
	/**
	 * Get an attribute with colon or v-bind: prefix.
	 *
	 * @param {Node} node
	 * @param {String} name
	 * @return {String|null}
	 */
	
	function getBindAttr(node, name) {
	  var val = getAttr(node, ':' + name);
	  if (val === null) {
	    val = getAttr(node, 'v-bind:' + name);
	  }
	  return val;
	}
	
	/**
	 * Check the presence of a bind attribute.
	 *
	 * @param {Node} node
	 * @param {String} name
	 * @return {Boolean}
	 */
	
	function hasBindAttr(node, name) {
	  return node.hasAttribute(name) || node.hasAttribute(':' + name) || node.hasAttribute('v-bind:' + name);
	}
	
	/**
	 * Insert el before target
	 *
	 * @param {Element} el
	 * @param {Element} target
	 */
	
	function before(el, target) {
	  target.parentNode.insertBefore(el, target);
	}
	
	/**
	 * Insert el after target
	 *
	 * @param {Element} el
	 * @param {Element} target
	 */
	
	function after(el, target) {
	  if (target.nextSibling) {
	    before(el, target.nextSibling);
	  } else {
	    target.parentNode.appendChild(el);
	  }
	}
	
	/**
	 * Remove el from DOM
	 *
	 * @param {Element} el
	 */
	
	function remove(el) {
	  el.parentNode.removeChild(el);
	}
	
	/**
	 * Prepend el to target
	 *
	 * @param {Element} el
	 * @param {Element} target
	 */
	
	function prepend(el, target) {
	  if (target.firstChild) {
	    before(el, target.firstChild);
	  } else {
	    target.appendChild(el);
	  }
	}
	
	/**
	 * Replace target with el
	 *
	 * @param {Element} target
	 * @param {Element} el
	 */
	
	function replace(target, el) {
	  var parent = target.parentNode;
	  if (parent) {
	    parent.replaceChild(el, target);
	  }
	}
	
	/**
	 * Add event listener shorthand.
	 *
	 * @param {Element} el
	 * @param {String} event
	 * @param {Function} cb
	 * @param {Boolean} [useCapture]
	 */
	
	function on(el, event, cb, useCapture) {
	  el.addEventListener(event, cb, useCapture);
	}
	
	/**
	 * Remove event listener shorthand.
	 *
	 * @param {Element} el
	 * @param {String} event
	 * @param {Function} cb
	 */
	
	function off(el, event, cb) {
	  el.removeEventListener(event, cb);
	}
	
	/**
	 * For IE9 compat: when both class and :class are present
	 * getAttribute('class') returns wrong value...
	 *
	 * @param {Element} el
	 * @return {String}
	 */
	
	function getClass(el) {
	  var classname = el.className;
	  if (typeof classname === 'object') {
	    classname = classname.baseVal || '';
	  }
	  return classname;
	}
	
	/**
	 * In IE9, setAttribute('class') will result in empty class
	 * if the element also has the :class attribute; However in
	 * PhantomJS, setting `className` does not work on SVG elements...
	 * So we have to do a conditional check here.
	 *
	 * @param {Element} el
	 * @param {String} cls
	 */
	
	function setClass(el, cls) {
	  /* istanbul ignore if */
	  if (isIE9 && !/svg$/.test(el.namespaceURI)) {
	    el.className = cls;
	  } else {
	    el.setAttribute('class', cls);
	  }
	}
	
	/**
	 * Add class with compatibility for IE & SVG
	 *
	 * @param {Element} el
	 * @param {String} cls
	 */
	
	function addClass(el, cls) {
	  if (el.classList) {
	    el.classList.add(cls);
	  } else {
	    var cur = ' ' + getClass(el) + ' ';
	    if (cur.indexOf(' ' + cls + ' ') < 0) {
	      setClass(el, (cur + cls).trim());
	    }
	  }
	}
	
	/**
	 * Remove class with compatibility for IE & SVG
	 *
	 * @param {Element} el
	 * @param {String} cls
	 */
	
	function removeClass(el, cls) {
	  if (el.classList) {
	    el.classList.remove(cls);
	  } else {
	    var cur = ' ' + getClass(el) + ' ';
	    var tar = ' ' + cls + ' ';
	    while (cur.indexOf(tar) >= 0) {
	      cur = cur.replace(tar, ' ');
	    }
	    setClass(el, cur.trim());
	  }
	  if (!el.className) {
	    el.removeAttribute('class');
	  }
	}
	
	/**
	 * Extract raw content inside an element into a temporary
	 * container div
	 *
	 * @param {Element} el
	 * @param {Boolean} asFragment
	 * @return {Element|DocumentFragment}
	 */
	
	function extractContent(el, asFragment) {
	  var child;
	  var rawContent;
	  /* istanbul ignore if */
	  if (isTemplate(el) && isFragment(el.content)) {
	    el = el.content;
	  }
	  if (el.hasChildNodes()) {
	    trimNode(el);
	    rawContent = asFragment ? document.createDocumentFragment() : document.createElement('div');
	    /* eslint-disable no-cond-assign */
	    while (child = el.firstChild) {
	      /* eslint-enable no-cond-assign */
	      rawContent.appendChild(child);
	    }
	  }
	  return rawContent;
	}
	
	/**
	 * Trim possible empty head/tail text and comment
	 * nodes inside a parent.
	 *
	 * @param {Node} node
	 */
	
	function trimNode(node) {
	  var child;
	  /* eslint-disable no-sequences */
	  while ((child = node.firstChild, isTrimmable(child))) {
	    node.removeChild(child);
	  }
	  while ((child = node.lastChild, isTrimmable(child))) {
	    node.removeChild(child);
	  }
	  /* eslint-enable no-sequences */
	}
	
	function isTrimmable(node) {
	  return node && (node.nodeType === 3 && !node.data.trim() || node.nodeType === 8);
	}
	
	/**
	 * Check if an element is a template tag.
	 * Note if the template appears inside an SVG its tagName
	 * will be in lowercase.
	 *
	 * @param {Element} el
	 */
	
	function isTemplate(el) {
	  return el.tagName && el.tagName.toLowerCase() === 'template';
	}
	
	/**
	 * Create an "anchor" for performing dom insertion/removals.
	 * This is used in a number of scenarios:
	 * - fragment instance
	 * - v-html
	 * - v-if
	 * - v-for
	 * - component
	 *
	 * @param {String} content
	 * @param {Boolean} persist - IE trashes empty textNodes on
	 *                            cloneNode(true), so in certain
	 *                            cases the anchor needs to be
	 *                            non-empty to be persisted in
	 *                            templates.
	 * @return {Comment|Text}
	 */
	
	function createAnchor(content, persist) {
	  var anchor = config.debug ? document.createComment(content) : document.createTextNode(persist ? ' ' : '');
	  anchor.__v_anchor = true;
	  return anchor;
	}
	
	/**
	 * Find a component ref attribute that starts with $.
	 *
	 * @param {Element} node
	 * @return {String|undefined}
	 */
	
	var refRE = /^v-ref:/;
	
	function findRef(node) {
	  if (node.hasAttributes()) {
	    var attrs = node.attributes;
	    for (var i = 0, l = attrs.length; i < l; i++) {
	      var name = attrs[i].name;
	      if (refRE.test(name)) {
	        return camelize(name.replace(refRE, ''));
	      }
	    }
	  }
	}
	
	/**
	 * Map a function to a range of nodes .
	 *
	 * @param {Node} node
	 * @param {Node} end
	 * @param {Function} op
	 */
	
	function mapNodeRange(node, end, op) {
	  var next;
	  while (node !== end) {
	    next = node.nextSibling;
	    op(node);
	    node = next;
	  }
	  op(end);
	}
	
	/**
	 * Remove a range of nodes with transition, store
	 * the nodes in a fragment with correct ordering,
	 * and call callback when done.
	 *
	 * @param {Node} start
	 * @param {Node} end
	 * @param {Vue} vm
	 * @param {DocumentFragment} frag
	 * @param {Function} cb
	 */
	
	function removeNodeRange(start, end, vm, frag, cb) {
	  var done = false;
	  var removed = 0;
	  var nodes = [];
	  mapNodeRange(start, end, function (node) {
	    if (node === end) done = true;
	    nodes.push(node);
	    removeWithTransition(node, vm, onRemoved);
	  });
	  function onRemoved() {
	    removed++;
	    if (done && removed >= nodes.length) {
	      for (var i = 0; i < nodes.length; i++) {
	        frag.appendChild(nodes[i]);
	      }
	      cb && cb();
	    }
	  }
	}
	
	/**
	 * Check if a node is a DocumentFragment.
	 *
	 * @param {Node} node
	 * @return {Boolean}
	 */
	
	function isFragment(node) {
	  return node && node.nodeType === 11;
	}
	
	/**
	 * Get outerHTML of elements, taking care
	 * of SVG elements in IE as well.
	 *
	 * @param {Element} el
	 * @return {String}
	 */
	
	function getOuterHTML(el) {
	  if (el.outerHTML) {
	    return el.outerHTML;
	  } else {
	    var container = document.createElement('div');
	    container.appendChild(el.cloneNode(true));
	    return container.innerHTML;
	  }
	}
	
	var commonTagRE = /^(div|p|span|img|a|b|i|br|ul|ol|li|h1|h2|h3|h4|h5|h6|code|pre|table|th|td|tr|form|label|input|select|option|nav|article|section|header|footer)$/i;
	var reservedTagRE = /^(slot|partial|component)$/i;
	
	var isUnknownElement = undefined;
	if (false) {
	  isUnknownElement = function (el, tag) {
	    if (tag.indexOf('-') > -1) {
	      // http://stackoverflow.com/a/28210364/1070244
	      return el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
	    } else {
	      return (/HTMLUnknownElement/.test(el.toString()) &&
	        // Chrome returns unknown for several HTML5 elements.
	        // https://code.google.com/p/chromium/issues/detail?id=540526
	        // Firefox returns unknown for some "Interactive elements."
	        !/^(data|time|rtc|rb|details|dialog|summary)$/.test(tag)
	      );
	    }
	  };
	}
	
	/**
	 * Check if an element is a component, if yes return its
	 * component id.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Object|undefined}
	 */
	
	function checkComponentAttr(el, options) {
	  var tag = el.tagName.toLowerCase();
	  var hasAttrs = el.hasAttributes();
	  if (!commonTagRE.test(tag) && !reservedTagRE.test(tag)) {
	    if (resolveAsset(options, 'components', tag)) {
	      return { id: tag };
	    } else {
	      var is = hasAttrs && getIsBinding(el, options);
	      if (is) {
	        return is;
	      } else if (false) {
	        var expectedTag = options._componentNameMap && options._componentNameMap[tag];
	        if (expectedTag) {
	          warn('Unknown custom element: <' + tag + '> - ' + 'did you mean <' + expectedTag + '>? ' + 'HTML is case-insensitive, remember to use kebab-case in templates.');
	        } else if (isUnknownElement(el, tag)) {
	          warn('Unknown custom element: <' + tag + '> - did you ' + 'register the component correctly? For recursive components, ' + 'make sure to provide the "name" option.');
	        }
	      }
	    }
	  } else if (hasAttrs) {
	    return getIsBinding(el, options);
	  }
	}
	
	/**
	 * Get "is" binding from an element.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Object|undefined}
	 */
	
	function getIsBinding(el, options) {
	  // dynamic syntax
	  var exp = el.getAttribute('is');
	  if (exp != null) {
	    if (resolveAsset(options, 'components', exp)) {
	      el.removeAttribute('is');
	      return { id: exp };
	    }
	  } else {
	    exp = getBindAttr(el, 'is');
	    if (exp != null) {
	      return { id: exp, dynamic: true };
	    }
	  }
	}
	
	/**
	 * Option overwriting strategies are functions that handle
	 * how to merge a parent option value and a child option
	 * value into the final value.
	 *
	 * All strategy functions follow the same signature:
	 *
	 * @param {*} parentVal
	 * @param {*} childVal
	 * @param {Vue} [vm]
	 */
	
	var strats = config.optionMergeStrategies = Object.create(null);
	
	/**
	 * Helper that recursively merges two data objects together.
	 */
	
	function mergeData(to, from) {
	  var key, toVal, fromVal;
	  for (key in from) {
	    toVal = to[key];
	    fromVal = from[key];
	    if (!hasOwn(to, key)) {
	      set(to, key, fromVal);
	    } else if (isObject(toVal) && isObject(fromVal)) {
	      mergeData(toVal, fromVal);
	    }
	  }
	  return to;
	}
	
	/**
	 * Data
	 */
	
	strats.data = function (parentVal, childVal, vm) {
	  if (!vm) {
	    // in a Vue.extend merge, both should be functions
	    if (!childVal) {
	      return parentVal;
	    }
	    if (typeof childVal !== 'function') {
	      ("production") !== 'production' && warn('The "data" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
	      return parentVal;
	    }
	    if (!parentVal) {
	      return childVal;
	    }
	    // when parentVal & childVal are both present,
	    // we need to return a function that returns the
	    // merged result of both functions... no need to
	    // check if parentVal is a function here because
	    // it has to be a function to pass previous merges.
	    return function mergedDataFn() {
	      return mergeData(childVal.call(this), parentVal.call(this));
	    };
	  } else if (parentVal || childVal) {
	    return function mergedInstanceDataFn() {
	      // instance merge
	      var instanceData = typeof childVal === 'function' ? childVal.call(vm) : childVal;
	      var defaultData = typeof parentVal === 'function' ? parentVal.call(vm) : undefined;
	      if (instanceData) {
	        return mergeData(instanceData, defaultData);
	      } else {
	        return defaultData;
	      }
	    };
	  }
	};
	
	/**
	 * El
	 */
	
	strats.el = function (parentVal, childVal, vm) {
	  if (!vm && childVal && typeof childVal !== 'function') {
	    ("production") !== 'production' && warn('The "el" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
	    return;
	  }
	  var ret = childVal || parentVal;
	  // invoke the element factory if this is instance merge
	  return vm && typeof ret === 'function' ? ret.call(vm) : ret;
	};
	
	/**
	 * Hooks and param attributes are merged as arrays.
	 */
	
	strats.init = strats.created = strats.ready = strats.attached = strats.detached = strats.beforeCompile = strats.compiled = strats.beforeDestroy = strats.destroyed = strats.activate = function (parentVal, childVal) {
	  return childVal ? parentVal ? parentVal.concat(childVal) : isArray(childVal) ? childVal : [childVal] : parentVal;
	};
	
	/**
	 * Assets
	 *
	 * When a vm is present (instance creation), we need to do
	 * a three-way merge between constructor options, instance
	 * options and parent options.
	 */
	
	function mergeAssets(parentVal, childVal) {
	  var res = Object.create(parentVal || null);
	  return childVal ? extend(res, guardArrayAssets(childVal)) : res;
	}
	
	config._assetTypes.forEach(function (type) {
	  strats[type + 's'] = mergeAssets;
	});
	
	/**
	 * Events & Watchers.
	 *
	 * Events & watchers hashes should not overwrite one
	 * another, so we merge them as arrays.
	 */
	
	strats.watch = strats.events = function (parentVal, childVal) {
	  if (!childVal) return parentVal;
	  if (!parentVal) return childVal;
	  var ret = {};
	  extend(ret, parentVal);
	  for (var key in childVal) {
	    var parent = ret[key];
	    var child = childVal[key];
	    if (parent && !isArray(parent)) {
	      parent = [parent];
	    }
	    ret[key] = parent ? parent.concat(child) : [child];
	  }
	  return ret;
	};
	
	/**
	 * Other object hashes.
	 */
	
	strats.props = strats.methods = strats.computed = function (parentVal, childVal) {
	  if (!childVal) return parentVal;
	  if (!parentVal) return childVal;
	  var ret = Object.create(null);
	  extend(ret, parentVal);
	  extend(ret, childVal);
	  return ret;
	};
	
	/**
	 * Default strategy.
	 */
	
	var defaultStrat = function defaultStrat(parentVal, childVal) {
	  return childVal === undefined ? parentVal : childVal;
	};
	
	/**
	 * Make sure component options get converted to actual
	 * constructors.
	 *
	 * @param {Object} options
	 */
	
	function guardComponents(options) {
	  if (options.components) {
	    var components = options.components = guardArrayAssets(options.components);
	    var ids = Object.keys(components);
	    var def;
	    if (false) {
	      var map = options._componentNameMap = {};
	    }
	    for (var i = 0, l = ids.length; i < l; i++) {
	      var key = ids[i];
	      if (commonTagRE.test(key) || reservedTagRE.test(key)) {
	        ("production") !== 'production' && warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + key);
	        continue;
	      }
	      // record a all lowercase <-> kebab-case mapping for
	      // possible custom element case error warning
	      if (false) {
	        map[key.replace(/-/g, '').toLowerCase()] = hyphenate(key);
	      }
	      def = components[key];
	      if (isPlainObject(def)) {
	        components[key] = Vue.extend(def);
	      }
	    }
	  }
	}
	
	/**
	 * Ensure all props option syntax are normalized into the
	 * Object-based format.
	 *
	 * @param {Object} options
	 */
	
	function guardProps(options) {
	  var props = options.props;
	  var i, val;
	  if (isArray(props)) {
	    options.props = {};
	    i = props.length;
	    while (i--) {
	      val = props[i];
	      if (typeof val === 'string') {
	        options.props[val] = null;
	      } else if (val.name) {
	        options.props[val.name] = val;
	      }
	    }
	  } else if (isPlainObject(props)) {
	    var keys = Object.keys(props);
	    i = keys.length;
	    while (i--) {
	      val = props[keys[i]];
	      if (typeof val === 'function') {
	        props[keys[i]] = { type: val };
	      }
	    }
	  }
	}
	
	/**
	 * Guard an Array-format assets option and converted it
	 * into the key-value Object format.
	 *
	 * @param {Object|Array} assets
	 * @return {Object}
	 */
	
	function guardArrayAssets(assets) {
	  if (isArray(assets)) {
	    var res = {};
	    var i = assets.length;
	    var asset;
	    while (i--) {
	      asset = assets[i];
	      var id = typeof asset === 'function' ? asset.options && asset.options.name || asset.id : asset.name || asset.id;
	      if (!id) {
	        ("production") !== 'production' && warn('Array-syntax assets must provide a "name" or "id" field.');
	      } else {
	        res[id] = asset;
	      }
	    }
	    return res;
	  }
	  return assets;
	}
	
	/**
	 * Merge two option objects into a new one.
	 * Core utility used in both instantiation and inheritance.
	 *
	 * @param {Object} parent
	 * @param {Object} child
	 * @param {Vue} [vm] - if vm is present, indicates this is
	 *                     an instantiation merge.
	 */
	
	function mergeOptions(parent, child, vm) {
	  guardComponents(child);
	  guardProps(child);
	  if (false) {
	    if (child.propsData && !vm) {
	      warn('propsData can only be used as an instantiation option.');
	    }
	  }
	  var options = {};
	  var key;
	  if (child['extends']) {
	    parent = typeof child['extends'] === 'function' ? mergeOptions(parent, child['extends'].options, vm) : mergeOptions(parent, child['extends'], vm);
	  }
	  if (child.mixins) {
	    for (var i = 0, l = child.mixins.length; i < l; i++) {
	      var mixin = child.mixins[i];
	      var mixinOptions = mixin.prototype instanceof Vue ? mixin.options : mixin;
	      parent = mergeOptions(parent, mixinOptions, vm);
	    }
	  }
	  for (key in parent) {
	    mergeField(key);
	  }
	  for (key in child) {
	    if (!hasOwn(parent, key)) {
	      mergeField(key);
	    }
	  }
	  function mergeField(key) {
	    var strat = strats[key] || defaultStrat;
	    options[key] = strat(parent[key], child[key], vm, key);
	  }
	  return options;
	}
	
	/**
	 * Resolve an asset.
	 * This function is used because child instances need access
	 * to assets defined in its ancestor chain.
	 *
	 * @param {Object} options
	 * @param {String} type
	 * @param {String} id
	 * @param {Boolean} warnMissing
	 * @return {Object|Function}
	 */
	
	function resolveAsset(options, type, id, warnMissing) {
	  /* istanbul ignore if */
	  if (typeof id !== 'string') {
	    return;
	  }
	  var assets = options[type];
	  var camelizedId;
	  var res = assets[id] ||
	  // camelCase ID
	  assets[camelizedId = camelize(id)] ||
	  // Pascal Case ID
	  assets[camelizedId.charAt(0).toUpperCase() + camelizedId.slice(1)];
	  if (false) {
	    warn('Failed to resolve ' + type.slice(0, -1) + ': ' + id, options);
	  }
	  return res;
	}
	
	var uid$1 = 0;
	
	/**
	 * A dep is an observable that can have multiple
	 * directives subscribing to it.
	 *
	 * @constructor
	 */
	function Dep() {
	  this.id = uid$1++;
	  this.subs = [];
	}
	
	// the current target watcher being evaluated.
	// this is globally unique because there could be only one
	// watcher being evaluated at any time.
	Dep.target = null;
	
	/**
	 * Add a directive subscriber.
	 *
	 * @param {Directive} sub
	 */
	
	Dep.prototype.addSub = function (sub) {
	  this.subs.push(sub);
	};
	
	/**
	 * Remove a directive subscriber.
	 *
	 * @param {Directive} sub
	 */
	
	Dep.prototype.removeSub = function (sub) {
	  this.subs.$remove(sub);
	};
	
	/**
	 * Add self as a dependency to the target watcher.
	 */
	
	Dep.prototype.depend = function () {
	  Dep.target.addDep(this);
	};
	
	/**
	 * Notify all subscribers of a new value.
	 */
	
	Dep.prototype.notify = function () {
	  // stablize the subscriber list first
	  var subs = toArray(this.subs);
	  for (var i = 0, l = subs.length; i < l; i++) {
	    subs[i].update();
	  }
	};
	
	var arrayProto = Array.prototype;
	var arrayMethods = Object.create(arrayProto)
	
	/**
	 * Intercept mutating methods and emit events
	 */
	
	;['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse'].forEach(function (method) {
	  // cache original method
	  var original = arrayProto[method];
	  def(arrayMethods, method, function mutator() {
	    // avoid leaking arguments:
	    // http://jsperf.com/closure-with-arguments
	    var i = arguments.length;
	    var args = new Array(i);
	    while (i--) {
	      args[i] = arguments[i];
	    }
	    var result = original.apply(this, args);
	    var ob = this.__ob__;
	    var inserted;
	    switch (method) {
	      case 'push':
	        inserted = args;
	        break;
	      case 'unshift':
	        inserted = args;
	        break;
	      case 'splice':
	        inserted = args.slice(2);
	        break;
	    }
	    if (inserted) ob.observeArray(inserted);
	    // notify change
	    ob.dep.notify();
	    return result;
	  });
	});
	
	/**
	 * Swap the element at the given index with a new value
	 * and emits corresponding event.
	 *
	 * @param {Number} index
	 * @param {*} val
	 * @return {*} - replaced element
	 */
	
	def(arrayProto, '$set', function $set(index, val) {
	  if (index >= this.length) {
	    this.length = Number(index) + 1;
	  }
	  return this.splice(index, 1, val)[0];
	});
	
	/**
	 * Convenience method to remove the element at given index or target element reference.
	 *
	 * @param {*} item
	 */
	
	def(arrayProto, '$remove', function $remove(item) {
	  /* istanbul ignore if */
	  if (!this.length) return;
	  var index = indexOf(this, item);
	  if (index > -1) {
	    return this.splice(index, 1);
	  }
	});
	
	var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
	
	/**
	 * By default, when a reactive property is set, the new value is
	 * also converted to become reactive. However in certain cases, e.g.
	 * v-for scope alias and props, we don't want to force conversion
	 * because the value may be a nested value under a frozen data structure.
	 *
	 * So whenever we want to set a reactive property without forcing
	 * conversion on the new value, we wrap that call inside this function.
	 */
	
	var shouldConvert = true;
	
	function withoutConversion(fn) {
	  shouldConvert = false;
	  fn();
	  shouldConvert = true;
	}
	
	/**
	 * Observer class that are attached to each observed
	 * object. Once attached, the observer converts target
	 * object's property keys into getter/setters that
	 * collect dependencies and dispatches updates.
	 *
	 * @param {Array|Object} value
	 * @constructor
	 */
	
	function Observer(value) {
	  this.value = value;
	  this.dep = new Dep();
	  def(value, '__ob__', this);
	  if (isArray(value)) {
	    var augment = hasProto ? protoAugment : copyAugment;
	    augment(value, arrayMethods, arrayKeys);
	    this.observeArray(value);
	  } else {
	    this.walk(value);
	  }
	}
	
	// Instance methods
	
	/**
	 * Walk through each property and convert them into
	 * getter/setters. This method should only be called when
	 * value type is Object.
	 *
	 * @param {Object} obj
	 */
	
	Observer.prototype.walk = function (obj) {
	  var keys = Object.keys(obj);
	  for (var i = 0, l = keys.length; i < l; i++) {
	    this.convert(keys[i], obj[keys[i]]);
	  }
	};
	
	/**
	 * Observe a list of Array items.
	 *
	 * @param {Array} items
	 */
	
	Observer.prototype.observeArray = function (items) {
	  for (var i = 0, l = items.length; i < l; i++) {
	    observe(items[i]);
	  }
	};
	
	/**
	 * Convert a property into getter/setter so we can emit
	 * the events when the property is accessed/changed.
	 *
	 * @param {String} key
	 * @param {*} val
	 */
	
	Observer.prototype.convert = function (key, val) {
	  defineReactive(this.value, key, val);
	};
	
	/**
	 * Add an owner vm, so that when $set/$delete mutations
	 * happen we can notify owner vms to proxy the keys and
	 * digest the watchers. This is only called when the object
	 * is observed as an instance's root $data.
	 *
	 * @param {Vue} vm
	 */
	
	Observer.prototype.addVm = function (vm) {
	  (this.vms || (this.vms = [])).push(vm);
	};
	
	/**
	 * Remove an owner vm. This is called when the object is
	 * swapped out as an instance's $data object.
	 *
	 * @param {Vue} vm
	 */
	
	Observer.prototype.removeVm = function (vm) {
	  this.vms.$remove(vm);
	};
	
	// helpers
	
	/**
	 * Augment an target Object or Array by intercepting
	 * the prototype chain using __proto__
	 *
	 * @param {Object|Array} target
	 * @param {Object} src
	 */
	
	function protoAugment(target, src) {
	  /* eslint-disable no-proto */
	  target.__proto__ = src;
	  /* eslint-enable no-proto */
	}
	
	/**
	 * Augment an target Object or Array by defining
	 * hidden properties.
	 *
	 * @param {Object|Array} target
	 * @param {Object} proto
	 */
	
	function copyAugment(target, src, keys) {
	  for (var i = 0, l = keys.length; i < l; i++) {
	    var key = keys[i];
	    def(target, key, src[key]);
	  }
	}
	
	/**
	 * Attempt to create an observer instance for a value,
	 * returns the new observer if successfully observed,
	 * or the existing observer if the value already has one.
	 *
	 * @param {*} value
	 * @param {Vue} [vm]
	 * @return {Observer|undefined}
	 * @static
	 */
	
	function observe(value, vm) {
	  if (!value || typeof value !== 'object') {
	    return;
	  }
	  var ob;
	  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
	    ob = value.__ob__;
	  } else if (shouldConvert && (isArray(value) || isPlainObject(value)) && Object.isExtensible(value) && !value._isVue) {
	    ob = new Observer(value);
	  }
	  if (ob && vm) {
	    ob.addVm(vm);
	  }
	  return ob;
	}
	
	/**
	 * Define a reactive property on an Object.
	 *
	 * @param {Object} obj
	 * @param {String} key
	 * @param {*} val
	 */
	
	function defineReactive(obj, key, val) {
	  var dep = new Dep();
	
	  var property = Object.getOwnPropertyDescriptor(obj, key);
	  if (property && property.configurable === false) {
	    return;
	  }
	
	  // cater for pre-defined getter/setters
	  var getter = property && property.get;
	  var setter = property && property.set;
	
	  var childOb = observe(val);
	  Object.defineProperty(obj, key, {
	    enumerable: true,
	    configurable: true,
	    get: function reactiveGetter() {
	      var value = getter ? getter.call(obj) : val;
	      if (Dep.target) {
	        dep.depend();
	        if (childOb) {
	          childOb.dep.depend();
	        }
	        if (isArray(value)) {
	          for (var e, i = 0, l = value.length; i < l; i++) {
	            e = value[i];
	            e && e.__ob__ && e.__ob__.dep.depend();
	          }
	        }
	      }
	      return value;
	    },
	    set: function reactiveSetter(newVal) {
	      var value = getter ? getter.call(obj) : val;
	      if (newVal === value) {
	        return;
	      }
	      if (setter) {
	        setter.call(obj, newVal);
	      } else {
	        val = newVal;
	      }
	      childOb = observe(newVal);
	      dep.notify();
	    }
	  });
	}
	
	
	
	var util = Object.freeze({
		defineReactive: defineReactive,
		set: set,
		del: del,
		hasOwn: hasOwn,
		isLiteral: isLiteral,
		isReserved: isReserved,
		_toString: _toString,
		toNumber: toNumber,
		toBoolean: toBoolean,
		stripQuotes: stripQuotes,
		camelize: camelize,
		hyphenate: hyphenate,
		classify: classify,
		bind: bind,
		toArray: toArray,
		extend: extend,
		isObject: isObject,
		isPlainObject: isPlainObject,
		def: def,
		debounce: _debounce,
		indexOf: indexOf,
		cancellable: cancellable,
		looseEqual: looseEqual,
		isArray: isArray,
		hasProto: hasProto,
		inBrowser: inBrowser,
		devtools: devtools,
		isIE: isIE,
		isIE9: isIE9,
		isAndroid: isAndroid,
		isIOS: isIOS,
		get transitionProp () { return transitionProp; },
		get transitionEndEvent () { return transitionEndEvent; },
		get animationProp () { return animationProp; },
		get animationEndEvent () { return animationEndEvent; },
		nextTick: nextTick,
		get _Set () { return _Set; },
		query: query,
		inDoc: inDoc,
		getAttr: getAttr,
		getBindAttr: getBindAttr,
		hasBindAttr: hasBindAttr,
		before: before,
		after: after,
		remove: remove,
		prepend: prepend,
		replace: replace,
		on: on,
		off: off,
		setClass: setClass,
		addClass: addClass,
		removeClass: removeClass,
		extractContent: extractContent,
		trimNode: trimNode,
		isTemplate: isTemplate,
		createAnchor: createAnchor,
		findRef: findRef,
		mapNodeRange: mapNodeRange,
		removeNodeRange: removeNodeRange,
		isFragment: isFragment,
		getOuterHTML: getOuterHTML,
		mergeOptions: mergeOptions,
		resolveAsset: resolveAsset,
		checkComponentAttr: checkComponentAttr,
		commonTagRE: commonTagRE,
		reservedTagRE: reservedTagRE,
		get warn () { return warn; }
	});
	
	var uid = 0;
	
	function initMixin (Vue) {
	  /**
	   * The main init sequence. This is called for every
	   * instance, including ones that are created from extended
	   * constructors.
	   *
	   * @param {Object} options - this options object should be
	   *                           the result of merging class
	   *                           options and the options passed
	   *                           in to the constructor.
	   */
	
	  Vue.prototype._init = function (options) {
	    options = options || {};
	
	    this.$el = null;
	    this.$parent = options.parent;
	    this.$root = this.$parent ? this.$parent.$root : this;
	    this.$children = [];
	    this.$refs = {}; // child vm references
	    this.$els = {}; // element references
	    this._watchers = []; // all watchers as an array
	    this._directives = []; // all directives
	
	    // a uid
	    this._uid = uid++;
	
	    // a flag to avoid this being observed
	    this._isVue = true;
	
	    // events bookkeeping
	    this._events = {}; // registered callbacks
	    this._eventsCount = {}; // for $broadcast optimization
	
	    // fragment instance properties
	    this._isFragment = false;
	    this._fragment = // @type {DocumentFragment}
	    this._fragmentStart = // @type {Text|Comment}
	    this._fragmentEnd = null; // @type {Text|Comment}
	
	    // lifecycle state
	    this._isCompiled = this._isDestroyed = this._isReady = this._isAttached = this._isBeingDestroyed = this._vForRemoving = false;
	    this._unlinkFn = null;
	
	    // context:
	    // if this is a transcluded component, context
	    // will be the common parent vm of this instance
	    // and its host.
	    this._context = options._context || this.$parent;
	
	    // scope:
	    // if this is inside an inline v-for, the scope
	    // will be the intermediate scope created for this
	    // repeat fragment. this is used for linking props
	    // and container directives.
	    this._scope = options._scope;
	
	    // fragment:
	    // if this instance is compiled inside a Fragment, it
	    // needs to register itself as a child of that fragment
	    // for attach/detach to work properly.
	    this._frag = options._frag;
	    if (this._frag) {
	      this._frag.children.push(this);
	    }
	
	    // push self into parent / transclusion host
	    if (this.$parent) {
	      this.$parent.$children.push(this);
	    }
	
	    // merge options.
	    options = this.$options = mergeOptions(this.constructor.options, options, this);
	
	    // set ref
	    this._updateRef();
	
	    // initialize data as empty object.
	    // it will be filled up in _initData().
	    this._data = {};
	
	    // call init hook
	    this._callHook('init');
	
	    // initialize data observation and scope inheritance.
	    this._initState();
	
	    // setup event system and option events.
	    this._initEvents();
	
	    // call created hook
	    this._callHook('created');
	
	    // if `el` option is passed, start compilation.
	    if (options.el) {
	      this.$mount(options.el);
	    }
	  };
	}
	
	var pathCache = new Cache(1000);
	
	// actions
	var APPEND = 0;
	var PUSH = 1;
	var INC_SUB_PATH_DEPTH = 2;
	var PUSH_SUB_PATH = 3;
	
	// states
	var BEFORE_PATH = 0;
	var IN_PATH = 1;
	var BEFORE_IDENT = 2;
	var IN_IDENT = 3;
	var IN_SUB_PATH = 4;
	var IN_SINGLE_QUOTE = 5;
	var IN_DOUBLE_QUOTE = 6;
	var AFTER_PATH = 7;
	var ERROR = 8;
	
	var pathStateMachine = [];
	
	pathStateMachine[BEFORE_PATH] = {
	  'ws': [BEFORE_PATH],
	  'ident': [IN_IDENT, APPEND],
	  '[': [IN_SUB_PATH],
	  'eof': [AFTER_PATH]
	};
	
	pathStateMachine[IN_PATH] = {
	  'ws': [IN_PATH],
	  '.': [BEFORE_IDENT],
	  '[': [IN_SUB_PATH],
	  'eof': [AFTER_PATH]
	};
	
	pathStateMachine[BEFORE_IDENT] = {
	  'ws': [BEFORE_IDENT],
	  'ident': [IN_IDENT, APPEND]
	};
	
	pathStateMachine[IN_IDENT] = {
	  'ident': [IN_IDENT, APPEND],
	  '0': [IN_IDENT, APPEND],
	  'number': [IN_IDENT, APPEND],
	  'ws': [IN_PATH, PUSH],
	  '.': [BEFORE_IDENT, PUSH],
	  '[': [IN_SUB_PATH, PUSH],
	  'eof': [AFTER_PATH, PUSH]
	};
	
	pathStateMachine[IN_SUB_PATH] = {
	  "'": [IN_SINGLE_QUOTE, APPEND],
	  '"': [IN_DOUBLE_QUOTE, APPEND],
	  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
	  ']': [IN_PATH, PUSH_SUB_PATH],
	  'eof': ERROR,
	  'else': [IN_SUB_PATH, APPEND]
	};
	
	pathStateMachine[IN_SINGLE_QUOTE] = {
	  "'": [IN_SUB_PATH, APPEND],
	  'eof': ERROR,
	  'else': [IN_SINGLE_QUOTE, APPEND]
	};
	
	pathStateMachine[IN_DOUBLE_QUOTE] = {
	  '"': [IN_SUB_PATH, APPEND],
	  'eof': ERROR,
	  'else': [IN_DOUBLE_QUOTE, APPEND]
	};
	
	/**
	 * Determine the type of a character in a keypath.
	 *
	 * @param {Char} ch
	 * @return {String} type
	 */
	
	function getPathCharType(ch) {
	  if (ch === undefined) {
	    return 'eof';
	  }
	
	  var code = ch.charCodeAt(0);
	
	  switch (code) {
	    case 0x5B: // [
	    case 0x5D: // ]
	    case 0x2E: // .
	    case 0x22: // "
	    case 0x27: // '
	    case 0x30:
	      // 0
	      return ch;
	
	    case 0x5F: // _
	    case 0x24:
	      // $
	      return 'ident';
	
	    case 0x20: // Space
	    case 0x09: // Tab
	    case 0x0A: // Newline
	    case 0x0D: // Return
	    case 0xA0: // No-break space
	    case 0xFEFF: // Byte Order Mark
	    case 0x2028: // Line Separator
	    case 0x2029:
	      // Paragraph Separator
	      return 'ws';
	  }
	
	  // a-z, A-Z
	  if (code >= 0x61 && code <= 0x7A || code >= 0x41 && code <= 0x5A) {
	    return 'ident';
	  }
	
	  // 1-9
	  if (code >= 0x31 && code <= 0x39) {
	    return 'number';
	  }
	
	  return 'else';
	}
	
	/**
	 * Format a subPath, return its plain form if it is
	 * a literal string or number. Otherwise prepend the
	 * dynamic indicator (*).
	 *
	 * @param {String} path
	 * @return {String}
	 */
	
	function formatSubPath(path) {
	  var trimmed = path.trim();
	  // invalid leading 0
	  if (path.charAt(0) === '0' && isNaN(path)) {
	    return false;
	  }
	  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed;
	}
	
	/**
	 * Parse a string path into an array of segments
	 *
	 * @param {String} path
	 * @return {Array|undefined}
	 */
	
	function parse(path) {
	  var keys = [];
	  var index = -1;
	  var mode = BEFORE_PATH;
	  var subPathDepth = 0;
	  var c, newChar, key, type, transition, action, typeMap;
	
	  var actions = [];
	
	  actions[PUSH] = function () {
	    if (key !== undefined) {
	      keys.push(key);
	      key = undefined;
	    }
	  };
	
	  actions[APPEND] = function () {
	    if (key === undefined) {
	      key = newChar;
	    } else {
	      key += newChar;
	    }
	  };
	
	  actions[INC_SUB_PATH_DEPTH] = function () {
	    actions[APPEND]();
	    subPathDepth++;
	  };
	
	  actions[PUSH_SUB_PATH] = function () {
	    if (subPathDepth > 0) {
	      subPathDepth--;
	      mode = IN_SUB_PATH;
	      actions[APPEND]();
	    } else {
	      subPathDepth = 0;
	      key = formatSubPath(key);
	      if (key === false) {
	        return false;
	      } else {
	        actions[PUSH]();
	      }
	    }
	  };
	
	  function maybeUnescapeQuote() {
	    var nextChar = path[index + 1];
	    if (mode === IN_SINGLE_QUOTE && nextChar === "'" || mode === IN_DOUBLE_QUOTE && nextChar === '"') {
	      index++;
	      newChar = '\\' + nextChar;
	      actions[APPEND]();
	      return true;
	    }
	  }
	
	  while (mode != null) {
	    index++;
	    c = path[index];
	
	    if (c === '\\' && maybeUnescapeQuote()) {
	      continue;
	    }
	
	    type = getPathCharType(c);
	    typeMap = pathStateMachine[mode];
	    transition = typeMap[type] || typeMap['else'] || ERROR;
	
	    if (transition === ERROR) {
	      return; // parse error
	    }
	
	    mode = transition[0];
	    action = actions[transition[1]];
	    if (action) {
	      newChar = transition[2];
	      newChar = newChar === undefined ? c : newChar;
	      if (action() === false) {
	        return;
	      }
	    }
	
	    if (mode === AFTER_PATH) {
	      keys.raw = path;
	      return keys;
	    }
	  }
	}
	
	/**
	 * External parse that check for a cache hit first
	 *
	 * @param {String} path
	 * @return {Array|undefined}
	 */
	
	function parsePath(path) {
	  var hit = pathCache.get(path);
	  if (!hit) {
	    hit = parse(path);
	    if (hit) {
	      pathCache.put(path, hit);
	    }
	  }
	  return hit;
	}
	
	/**
	 * Get from an object from a path string
	 *
	 * @param {Object} obj
	 * @param {String} path
	 */
	
	function getPath(obj, path) {
	  return parseExpression$1(path).get(obj);
	}
	
	/**
	 * Warn against setting non-existent root path on a vm.
	 */
	
	var warnNonExistent;
	if (false) {
	  warnNonExistent = function (path, vm) {
	    warn('You are setting a non-existent path "' + path.raw + '" ' + 'on a vm instance. Consider pre-initializing the property ' + 'with the "data" option for more reliable reactivity ' + 'and better performance.', vm);
	  };
	}
	
	/**
	 * Set on an object from a path
	 *
	 * @param {Object} obj
	 * @param {String | Array} path
	 * @param {*} val
	 */
	
	function setPath(obj, path, val) {
	  var original = obj;
	  if (typeof path === 'string') {
	    path = parse(path);
	  }
	  if (!path || !isObject(obj)) {
	    return false;
	  }
	  var last, key;
	  for (var i = 0, l = path.length; i < l; i++) {
	    last = obj;
	    key = path[i];
	    if (key.charAt(0) === '*') {
	      key = parseExpression$1(key.slice(1)).get.call(original, original);
	    }
	    if (i < l - 1) {
	      obj = obj[key];
	      if (!isObject(obj)) {
	        obj = {};
	        if (false) {
	          warnNonExistent(path, last);
	        }
	        set(last, key, obj);
	      }
	    } else {
	      if (isArray(obj)) {
	        obj.$set(key, val);
	      } else if (key in obj) {
	        obj[key] = val;
	      } else {
	        if (false) {
	          warnNonExistent(path, obj);
	        }
	        set(obj, key, val);
	      }
	    }
	  }
	  return true;
	}
	
	var path = Object.freeze({
	  parsePath: parsePath,
	  getPath: getPath,
	  setPath: setPath
	});
	
	var expressionCache = new Cache(1000);
	
	var allowedKeywords = 'Math,Date,this,true,false,null,undefined,Infinity,NaN,' + 'isNaN,isFinite,decodeURI,decodeURIComponent,encodeURI,' + 'encodeURIComponent,parseInt,parseFloat';
	var allowedKeywordsRE = new RegExp('^(' + allowedKeywords.replace(/,/g, '\\b|') + '\\b)');
	
	// keywords that don't make sense inside expressions
	var improperKeywords = 'break,case,class,catch,const,continue,debugger,default,' + 'delete,do,else,export,extends,finally,for,function,if,' + 'import,in,instanceof,let,return,super,switch,throw,try,' + 'var,while,with,yield,enum,await,implements,package,' + 'protected,static,interface,private,public';
	var improperKeywordsRE = new RegExp('^(' + improperKeywords.replace(/,/g, '\\b|') + '\\b)');
	
	var wsRE = /\s/g;
	var newlineRE = /\n/g;
	var saveRE = /[\{,]\s*[\w\$_]+\s*:|('(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\"']|\\.)*`|`(?:[^`\\]|\\.)*`)|new |typeof |void /g;
	var restoreRE = /"(\d+)"/g;
	var pathTestRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?'\]|\[".*?"\]|\[\d+\]|\[[A-Za-z_$][\w$]*\])*$/;
	var identRE = /[^\w$\.](?:[A-Za-z_$][\w$]*)/g;
	var literalValueRE$1 = /^(?:true|false|null|undefined|Infinity|NaN)$/;
	
	function noop() {}
	
	/**
	 * Save / Rewrite / Restore
	 *
	 * When rewriting paths found in an expression, it is
	 * possible for the same letter sequences to be found in
	 * strings and Object literal property keys. Therefore we
	 * remove and store these parts in a temporary array, and
	 * restore them after the path rewrite.
	 */
	
	var saved = [];
	
	/**
	 * Save replacer
	 *
	 * The save regex can match two possible cases:
	 * 1. An opening object literal
	 * 2. A string
	 * If matched as a plain string, we need to escape its
	 * newlines, since the string needs to be preserved when
	 * generating the function body.
	 *
	 * @param {String} str
	 * @param {String} isString - str if matched as a string
	 * @return {String} - placeholder with index
	 */
	
	function save(str, isString) {
	  var i = saved.length;
	  saved[i] = isString ? str.replace(newlineRE, '\\n') : str;
	  return '"' + i + '"';
	}
	
	/**
	 * Path rewrite replacer
	 *
	 * @param {String} raw
	 * @return {String}
	 */
	
	function rewrite(raw) {
	  var c = raw.charAt(0);
	  var path = raw.slice(1);
	  if (allowedKeywordsRE.test(path)) {
	    return raw;
	  } else {
	    path = path.indexOf('"') > -1 ? path.replace(restoreRE, restore) : path;
	    return c + 'scope.' + path;
	  }
	}
	
	/**
	 * Restore replacer
	 *
	 * @param {String} str
	 * @param {String} i - matched save index
	 * @return {String}
	 */
	
	function restore(str, i) {
	  return saved[i];
	}
	
	/**
	 * Rewrite an expression, prefixing all path accessors with
	 * `scope.` and generate getter/setter functions.
	 *
	 * @param {String} exp
	 * @return {Function}
	 */
	
	function compileGetter(exp) {
	  if (improperKeywordsRE.test(exp)) {
	    ("production") !== 'production' && warn('Avoid using reserved keywords in expression: ' + exp);
	  }
	  // reset state
	  saved.length = 0;
	  // save strings and object literal keys
	  var body = exp.replace(saveRE, save).replace(wsRE, '');
	  // rewrite all paths
	  // pad 1 space here because the regex matches 1 extra char
	  body = (' ' + body).replace(identRE, rewrite).replace(restoreRE, restore);
	  return makeGetterFn(body);
	}
	
	/**
	 * Build a getter function. Requires eval.
	 *
	 * We isolate the try/catch so it doesn't affect the
	 * optimization of the parse function when it is not called.
	 *
	 * @param {String} body
	 * @return {Function|undefined}
	 */
	
	function makeGetterFn(body) {
	  try {
	    /* eslint-disable no-new-func */
	    return new Function('scope', 'return ' + body + ';');
	    /* eslint-enable no-new-func */
	  } catch (e) {
	    if (false) {
	      /* istanbul ignore if */
	      if (e.toString().match(/unsafe-eval|CSP/)) {
	        warn('It seems you are using the default build of Vue.js in an environment ' + 'with Content Security Policy that prohibits unsafe-eval. ' + 'Use the CSP-compliant build instead: ' + 'http://vuejs.org/guide/installation.html#CSP-compliant-build');
	      } else {
	        warn('Invalid expression. ' + 'Generated function body: ' + body);
	      }
	    }
	    return noop;
	  }
	}
	
	/**
	 * Compile a setter function for the expression.
	 *
	 * @param {String} exp
	 * @return {Function|undefined}
	 */
	
	function compileSetter(exp) {
	  var path = parsePath(exp);
	  if (path) {
	    return function (scope, val) {
	      setPath(scope, path, val);
	    };
	  } else {
	    ("production") !== 'production' && warn('Invalid setter expression: ' + exp);
	  }
	}
	
	/**
	 * Parse an expression into re-written getter/setters.
	 *
	 * @param {String} exp
	 * @param {Boolean} needSet
	 * @return {Function}
	 */
	
	function parseExpression$1(exp, needSet) {
	  exp = exp.trim();
	  // try cache
	  var hit = expressionCache.get(exp);
	  if (hit) {
	    if (needSet && !hit.set) {
	      hit.set = compileSetter(hit.exp);
	    }
	    return hit;
	  }
	  var res = { exp: exp };
	  res.get = isSimplePath(exp) && exp.indexOf('[') < 0
	  // optimized super simple getter
	  ? makeGetterFn('scope.' + exp)
	  // dynamic getter
	  : compileGetter(exp);
	  if (needSet) {
	    res.set = compileSetter(exp);
	  }
	  expressionCache.put(exp, res);
	  return res;
	}
	
	/**
	 * Check if an expression is a simple path.
	 *
	 * @param {String} exp
	 * @return {Boolean}
	 */
	
	function isSimplePath(exp) {
	  return pathTestRE.test(exp) &&
	  // don't treat literal values as paths
	  !literalValueRE$1.test(exp) &&
	  // Math constants e.g. Math.PI, Math.E etc.
	  exp.slice(0, 5) !== 'Math.';
	}
	
	var expression = Object.freeze({
	  parseExpression: parseExpression$1,
	  isSimplePath: isSimplePath
	});
	
	// we have two separate queues: one for directive updates
	// and one for user watcher registered via $watch().
	// we want to guarantee directive updates to be called
	// before user watchers so that when user watchers are
	// triggered, the DOM would have already been in updated
	// state.
	
	var queue = [];
	var userQueue = [];
	var has = {};
	var circular = {};
	var waiting = false;
	
	/**
	 * Reset the batcher's state.
	 */
	
	function resetBatcherState() {
	  queue.length = 0;
	  userQueue.length = 0;
	  has = {};
	  circular = {};
	  waiting = false;
	}
	
	/**
	 * Flush both queues and run the watchers.
	 */
	
	function flushBatcherQueue() {
	  var _again = true;
	
	  _function: while (_again) {
	    _again = false;
	
	    runBatcherQueue(queue);
	    runBatcherQueue(userQueue);
	    // user watchers triggered more watchers,
	    // keep flushing until it depletes
	    if (queue.length) {
	      _again = true;
	      continue _function;
	    }
	    // dev tool hook
	    /* istanbul ignore if */
	    if (devtools && config.devtools) {
	      devtools.emit('flush');
	    }
	    resetBatcherState();
	  }
	}
	
	/**
	 * Run the watchers in a single queue.
	 *
	 * @param {Array} queue
	 */
	
	function runBatcherQueue(queue) {
	  // do not cache length because more watchers might be pushed
	  // as we run existing watchers
	  for (var i = 0; i < queue.length; i++) {
	    var watcher = queue[i];
	    var id = watcher.id;
	    has[id] = null;
	    watcher.run();
	    // in dev build, check and stop circular updates.
	    if (false) {
	      circular[id] = (circular[id] || 0) + 1;
	      if (circular[id] > config._maxUpdateCount) {
	        warn('You may have an infinite update loop for watcher ' + 'with expression "' + watcher.expression + '"', watcher.vm);
	        break;
	      }
	    }
	  }
	  queue.length = 0;
	}
	
	/**
	 * Push a watcher into the watcher queue.
	 * Jobs with duplicate IDs will be skipped unless it's
	 * pushed when the queue is being flushed.
	 *
	 * @param {Watcher} watcher
	 *   properties:
	 *   - {Number} id
	 *   - {Function} run
	 */
	
	function pushWatcher(watcher) {
	  var id = watcher.id;
	  if (has[id] == null) {
	    // push watcher into appropriate queue
	    var q = watcher.user ? userQueue : queue;
	    has[id] = q.length;
	    q.push(watcher);
	    // queue the flush
	    if (!waiting) {
	      waiting = true;
	      nextTick(flushBatcherQueue);
	    }
	  }
	}
	
	var uid$2 = 0;
	
	/**
	 * A watcher parses an expression, collects dependencies,
	 * and fires callback when the expression value changes.
	 * This is used for both the $watch() api and directives.
	 *
	 * @param {Vue} vm
	 * @param {String|Function} expOrFn
	 * @param {Function} cb
	 * @param {Object} options
	 *                 - {Array} filters
	 *                 - {Boolean} twoWay
	 *                 - {Boolean} deep
	 *                 - {Boolean} user
	 *                 - {Boolean} sync
	 *                 - {Boolean} lazy
	 *                 - {Function} [preProcess]
	 *                 - {Function} [postProcess]
	 * @constructor
	 */
	function Watcher(vm, expOrFn, cb, options) {
	  // mix in options
	  if (options) {
	    extend(this, options);
	  }
	  var isFn = typeof expOrFn === 'function';
	  this.vm = vm;
	  vm._watchers.push(this);
	  this.expression = expOrFn;
	  this.cb = cb;
	  this.id = ++uid$2; // uid for batching
	  this.active = true;
	  this.dirty = this.lazy; // for lazy watchers
	  this.deps = [];
	  this.newDeps = [];
	  this.depIds = new _Set();
	  this.newDepIds = new _Set();
	  this.prevError = null; // for async error stacks
	  // parse expression for getter/setter
	  if (isFn) {
	    this.getter = expOrFn;
	    this.setter = undefined;
	  } else {
	    var res = parseExpression$1(expOrFn, this.twoWay);
	    this.getter = res.get;
	    this.setter = res.set;
	  }
	  this.value = this.lazy ? undefined : this.get();
	  // state for avoiding false triggers for deep and Array
	  // watchers during vm._digest()
	  this.queued = this.shallow = false;
	}
	
	/**
	 * Evaluate the getter, and re-collect dependencies.
	 */
	
	Watcher.prototype.get = function () {
	  this.beforeGet();
	  var scope = this.scope || this.vm;
	  var value;
	  try {
	    value = this.getter.call(scope, scope);
	  } catch (e) {
	    if (false) {
	      warn('Error when evaluating expression ' + '"' + this.expression + '": ' + e.toString(), this.vm);
	    }
	  }
	  // "touch" every property so they are all tracked as
	  // dependencies for deep watching
	  if (this.deep) {
	    traverse(value);
	  }
	  if (this.preProcess) {
	    value = this.preProcess(value);
	  }
	  if (this.filters) {
	    value = scope._applyFilters(value, null, this.filters, false);
	  }
	  if (this.postProcess) {
	    value = this.postProcess(value);
	  }
	  this.afterGet();
	  return value;
	};
	
	/**
	 * Set the corresponding value with the setter.
	 *
	 * @param {*} value
	 */
	
	Watcher.prototype.set = function (value) {
	  var scope = this.scope || this.vm;
	  if (this.filters) {
	    value = scope._applyFilters(value, this.value, this.filters, true);
	  }
	  try {
	    this.setter.call(scope, scope, value);
	  } catch (e) {
	    if (false) {
	      warn('Error when evaluating setter ' + '"' + this.expression + '": ' + e.toString(), this.vm);
	    }
	  }
	  // two-way sync for v-for alias
	  var forContext = scope.$forContext;
	  if (forContext && forContext.alias === this.expression) {
	    if (forContext.filters) {
	      ("production") !== 'production' && warn('It seems you are using two-way binding on ' + 'a v-for alias (' + this.expression + '), and the ' + 'v-for has filters. This will not work properly. ' + 'Either remove the filters or use an array of ' + 'objects and bind to object properties instead.', this.vm);
	      return;
	    }
	    forContext._withLock(function () {
	      if (scope.$key) {
	        // original is an object
	        forContext.rawValue[scope.$key] = value;
	      } else {
	        forContext.rawValue.$set(scope.$index, value);
	      }
	    });
	  }
	};
	
	/**
	 * Prepare for dependency collection.
	 */
	
	Watcher.prototype.beforeGet = function () {
	  Dep.target = this;
	};
	
	/**
	 * Add a dependency to this directive.
	 *
	 * @param {Dep} dep
	 */
	
	Watcher.prototype.addDep = function (dep) {
	  var id = dep.id;
	  if (!this.newDepIds.has(id)) {
	    this.newDepIds.add(id);
	    this.newDeps.push(dep);
	    if (!this.depIds.has(id)) {
	      dep.addSub(this);
	    }
	  }
	};
	
	/**
	 * Clean up for dependency collection.
	 */
	
	Watcher.prototype.afterGet = function () {
	  Dep.target = null;
	  var i = this.deps.length;
	  while (i--) {
	    var dep = this.deps[i];
	    if (!this.newDepIds.has(dep.id)) {
	      dep.removeSub(this);
	    }
	  }
	  var tmp = this.depIds;
	  this.depIds = this.newDepIds;
	  this.newDepIds = tmp;
	  this.newDepIds.clear();
	  tmp = this.deps;
	  this.deps = this.newDeps;
	  this.newDeps = tmp;
	  this.newDeps.length = 0;
	};
	
	/**
	 * Subscriber interface.
	 * Will be called when a dependency changes.
	 *
	 * @param {Boolean} shallow
	 */
	
	Watcher.prototype.update = function (shallow) {
	  if (this.lazy) {
	    this.dirty = true;
	  } else if (this.sync || !config.async) {
	    this.run();
	  } else {
	    // if queued, only overwrite shallow with non-shallow,
	    // but not the other way around.
	    this.shallow = this.queued ? shallow ? this.shallow : false : !!shallow;
	    this.queued = true;
	    // record before-push error stack in debug mode
	    /* istanbul ignore if */
	    if (false) {
	      this.prevError = new Error('[vue] async stack trace');
	    }
	    pushWatcher(this);
	  }
	};
	
	/**
	 * Batcher job interface.
	 * Will be called by the batcher.
	 */
	
	Watcher.prototype.run = function () {
	  if (this.active) {
	    var value = this.get();
	    if (value !== this.value ||
	    // Deep watchers and watchers on Object/Arrays should fire even
	    // when the value is the same, because the value may
	    // have mutated; but only do so if this is a
	    // non-shallow update (caused by a vm digest).
	    (isObject(value) || this.deep) && !this.shallow) {
	      // set new value
	      var oldValue = this.value;
	      this.value = value;
	      // in debug + async mode, when a watcher callbacks
	      // throws, we also throw the saved before-push error
	      // so the full cross-tick stack trace is available.
	      var prevError = this.prevError;
	      /* istanbul ignore if */
	      if (false) {
	        this.prevError = null;
	        try {
	          this.cb.call(this.vm, value, oldValue);
	        } catch (e) {
	          nextTick(function () {
	            throw prevError;
	          }, 0);
	          throw e;
	        }
	      } else {
	        this.cb.call(this.vm, value, oldValue);
	      }
	    }
	    this.queued = this.shallow = false;
	  }
	};
	
	/**
	 * Evaluate the value of the watcher.
	 * This only gets called for lazy watchers.
	 */
	
	Watcher.prototype.evaluate = function () {
	  // avoid overwriting another watcher that is being
	  // collected.
	  var current = Dep.target;
	  this.value = this.get();
	  this.dirty = false;
	  Dep.target = current;
	};
	
	/**
	 * Depend on all deps collected by this watcher.
	 */
	
	Watcher.prototype.depend = function () {
	  var i = this.deps.length;
	  while (i--) {
	    this.deps[i].depend();
	  }
	};
	
	/**
	 * Remove self from all dependencies' subcriber list.
	 */
	
	Watcher.prototype.teardown = function () {
	  if (this.active) {
	    // remove self from vm's watcher list
	    // this is a somewhat expensive operation so we skip it
	    // if the vm is being destroyed or is performing a v-for
	    // re-render (the watcher list is then filtered by v-for).
	    if (!this.vm._isBeingDestroyed && !this.vm._vForRemoving) {
	      this.vm._watchers.$remove(this);
	    }
	    var i = this.deps.length;
	    while (i--) {
	      this.deps[i].removeSub(this);
	    }
	    this.active = false;
	    this.vm = this.cb = this.value = null;
	  }
	};
	
	/**
	 * Recrusively traverse an object to evoke all converted
	 * getters, so that every nested property inside the object
	 * is collected as a "deep" dependency.
	 *
	 * @param {*} val
	 */
	
	var seenObjects = new _Set();
	function traverse(val, seen) {
	  var i = undefined,
	      keys = undefined;
	  if (!seen) {
	    seen = seenObjects;
	    seen.clear();
	  }
	  var isA = isArray(val);
	  var isO = isObject(val);
	  if ((isA || isO) && Object.isExtensible(val)) {
	    if (val.__ob__) {
	      var depId = val.__ob__.dep.id;
	      if (seen.has(depId)) {
	        return;
	      } else {
	        seen.add(depId);
	      }
	    }
	    if (isA) {
	      i = val.length;
	      while (i--) traverse(val[i], seen);
	    } else if (isO) {
	      keys = Object.keys(val);
	      i = keys.length;
	      while (i--) traverse(val[keys[i]], seen);
	    }
	  }
	}
	
	var text$1 = {
	
	  bind: function bind() {
	    this.attr = this.el.nodeType === 3 ? 'data' : 'textContent';
	  },
	
	  update: function update(value) {
	    this.el[this.attr] = _toString(value);
	  }
	};
	
	var templateCache = new Cache(1000);
	var idSelectorCache = new Cache(1000);
	
	var map = {
	  efault: [0, '', ''],
	  legend: [1, '<fieldset>', '</fieldset>'],
	  tr: [2, '<table><tbody>', '</tbody></table>'],
	  col: [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>']
	};
	
	map.td = map.th = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	map.option = map.optgroup = [1, '<select multiple="multiple">', '</select>'];
	
	map.thead = map.tbody = map.colgroup = map.caption = map.tfoot = [1, '<table>', '</table>'];
	
	map.g = map.defs = map.symbol = map.use = map.image = map.text = map.circle = map.ellipse = map.line = map.path = map.polygon = map.polyline = map.rect = [1, '<svg ' + 'xmlns="http://www.w3.org/2000/svg" ' + 'xmlns:xlink="http://www.w3.org/1999/xlink" ' + 'xmlns:ev="http://www.w3.org/2001/xml-events"' + 'version="1.1">', '</svg>'];
	
	/**
	 * Check if a node is a supported template node with a
	 * DocumentFragment content.
	 *
	 * @param {Node} node
	 * @return {Boolean}
	 */
	
	function isRealTemplate(node) {
	  return isTemplate(node) && isFragment(node.content);
	}
	
	var tagRE$1 = /<([\w:-]+)/;
	var entityRE = /&#?\w+?;/;
	var commentRE = /<!--/;
	
	/**
	 * Convert a string template to a DocumentFragment.
	 * Determines correct wrapping by tag types. Wrapping
	 * strategy found in jQuery & component/domify.
	 *
	 * @param {String} templateString
	 * @param {Boolean} raw
	 * @return {DocumentFragment}
	 */
	
	function stringToFragment(templateString, raw) {
	  // try a cache hit first
	  var cacheKey = raw ? templateString : templateString.trim();
	  var hit = templateCache.get(cacheKey);
	  if (hit) {
	    return hit;
	  }
	
	  var frag = document.createDocumentFragment();
	  var tagMatch = templateString.match(tagRE$1);
	  var entityMatch = entityRE.test(templateString);
	  var commentMatch = commentRE.test(templateString);
	
	  if (!tagMatch && !entityMatch && !commentMatch) {
	    // text only, return a single text node.
	    frag.appendChild(document.createTextNode(templateString));
	  } else {
	    var tag = tagMatch && tagMatch[1];
	    var wrap = map[tag] || map.efault;
	    var depth = wrap[0];
	    var prefix = wrap[1];
	    var suffix = wrap[2];
	    var node = document.createElement('div');
	
	    node.innerHTML = prefix + templateString + suffix;
	    while (depth--) {
	      node = node.lastChild;
	    }
	
	    var child;
	    /* eslint-disable no-cond-assign */
	    while (child = node.firstChild) {
	      /* eslint-enable no-cond-assign */
	      frag.appendChild(child);
	    }
	  }
	  if (!raw) {
	    trimNode(frag);
	  }
	  templateCache.put(cacheKey, frag);
	  return frag;
	}
	
	/**
	 * Convert a template node to a DocumentFragment.
	 *
	 * @param {Node} node
	 * @return {DocumentFragment}
	 */
	
	function nodeToFragment(node) {
	  // if its a template tag and the browser supports it,
	  // its content is already a document fragment. However, iOS Safari has
	  // bug when using directly cloned template content with touch
	  // events and can cause crashes when the nodes are removed from DOM, so we
	  // have to treat template elements as string templates. (#2805)
	  /* istanbul ignore if */
	  if (isRealTemplate(node)) {
	    return stringToFragment(node.innerHTML);
	  }
	  // script template
	  if (node.tagName === 'SCRIPT') {
	    return stringToFragment(node.textContent);
	  }
	  // normal node, clone it to avoid mutating the original
	  var clonedNode = cloneNode(node);
	  var frag = document.createDocumentFragment();
	  var child;
	  /* eslint-disable no-cond-assign */
	  while (child = clonedNode.firstChild) {
	    /* eslint-enable no-cond-assign */
	    frag.appendChild(child);
	  }
	  trimNode(frag);
	  return frag;
	}
	
	// Test for the presence of the Safari template cloning bug
	// https://bugs.webkit.org/showug.cgi?id=137755
	var hasBrokenTemplate = (function () {
	  /* istanbul ignore else */
	  if (inBrowser) {
	    var a = document.createElement('div');
	    a.innerHTML = '<template>1</template>';
	    return !a.cloneNode(true).firstChild.innerHTML;
	  } else {
	    return false;
	  }
	})();
	
	// Test for IE10/11 textarea placeholder clone bug
	var hasTextareaCloneBug = (function () {
	  /* istanbul ignore else */
	  if (inBrowser) {
	    var t = document.createElement('textarea');
	    t.placeholder = 't';
	    return t.cloneNode(true).value === 't';
	  } else {
	    return false;
	  }
	})();
	
	/**
	 * 1. Deal with Safari cloning nested <template> bug by
	 *    manually cloning all template instances.
	 * 2. Deal with IE10/11 textarea placeholder bug by setting
	 *    the correct value after cloning.
	 *
	 * @param {Element|DocumentFragment} node
	 * @return {Element|DocumentFragment}
	 */
	
	function cloneNode(node) {
	  /* istanbul ignore if */
	  if (!node.querySelectorAll) {
	    return node.cloneNode();
	  }
	  var res = node.cloneNode(true);
	  var i, original, cloned;
	  /* istanbul ignore if */
	  if (hasBrokenTemplate) {
	    var tempClone = res;
	    if (isRealTemplate(node)) {
	      node = node.content;
	      tempClone = res.content;
	    }
	    original = node.querySelectorAll('template');
	    if (original.length) {
	      cloned = tempClone.querySelectorAll('template');
	      i = cloned.length;
	      while (i--) {
	        cloned[i].parentNode.replaceChild(cloneNode(original[i]), cloned[i]);
	      }
	    }
	  }
	  /* istanbul ignore if */
	  if (hasTextareaCloneBug) {
	    if (node.tagName === 'TEXTAREA') {
	      res.value = node.value;
	    } else {
	      original = node.querySelectorAll('textarea');
	      if (original.length) {
	        cloned = res.querySelectorAll('textarea');
	        i = cloned.length;
	        while (i--) {
	          cloned[i].value = original[i].value;
	        }
	      }
	    }
	  }
	  return res;
	}
	
	/**
	 * Process the template option and normalizes it into a
	 * a DocumentFragment that can be used as a partial or a
	 * instance template.
	 *
	 * @param {*} template
	 *        Possible values include:
	 *        - DocumentFragment object
	 *        - Node object of type Template
	 *        - id selector: '#some-template-id'
	 *        - template string: '<div><span>{{msg}}</span></div>'
	 * @param {Boolean} shouldClone
	 * @param {Boolean} raw
	 *        inline HTML interpolation. Do not check for id
	 *        selector and keep whitespace in the string.
	 * @return {DocumentFragment|undefined}
	 */
	
	function parseTemplate(template, shouldClone, raw) {
	  var node, frag;
	
	  // if the template is already a document fragment,
	  // do nothing
	  if (isFragment(template)) {
	    trimNode(template);
	    return shouldClone ? cloneNode(template) : template;
	  }
	
	  if (typeof template === 'string') {
	    // id selector
	    if (!raw && template.charAt(0) === '#') {
	      // id selector can be cached too
	      frag = idSelectorCache.get(template);
	      if (!frag) {
	        node = document.getElementById(template.slice(1));
	        if (node) {
	          frag = nodeToFragment(node);
	          // save selector to cache
	          idSelectorCache.put(template, frag);
	        }
	      }
	    } else {
	      // normal string template
	      frag = stringToFragment(template, raw);
	    }
	  } else if (template.nodeType) {
	    // a direct node
	    frag = nodeToFragment(template);
	  }
	
	  return frag && shouldClone ? cloneNode(frag) : frag;
	}
	
	var template = Object.freeze({
	  cloneNode: cloneNode,
	  parseTemplate: parseTemplate
	});
	
	var html = {
	
	  bind: function bind() {
	    // a comment node means this is a binding for
	    // {{{ inline unescaped html }}}
	    if (this.el.nodeType === 8) {
	      // hold nodes
	      this.nodes = [];
	      // replace the placeholder with proper anchor
	      this.anchor = createAnchor('v-html');
	      replace(this.el, this.anchor);
	    }
	  },
	
	  update: function update(value) {
	    value = _toString(value);
	    if (this.nodes) {
	      this.swap(value);
	    } else {
	      this.el.innerHTML = value;
	    }
	  },
	
	  swap: function swap(value) {
	    // remove old nodes
	    var i = this.nodes.length;
	    while (i--) {
	      remove(this.nodes[i]);
	    }
	    // convert new value to a fragment
	    // do not attempt to retrieve from id selector
	    var frag = parseTemplate(value, true, true);
	    // save a reference to these nodes so we can remove later
	    this.nodes = toArray(frag.childNodes);
	    before(frag, this.anchor);
	  }
	};
	
	/**
	 * Abstraction for a partially-compiled fragment.
	 * Can optionally compile content with a child scope.
	 *
	 * @param {Function} linker
	 * @param {Vue} vm
	 * @param {DocumentFragment} frag
	 * @param {Vue} [host]
	 * @param {Object} [scope]
	 * @param {Fragment} [parentFrag]
	 */
	function Fragment(linker, vm, frag, host, scope, parentFrag) {
	  this.children = [];
	  this.childFrags = [];
	  this.vm = vm;
	  this.scope = scope;
	  this.inserted = false;
	  this.parentFrag = parentFrag;
	  if (parentFrag) {
	    parentFrag.childFrags.push(this);
	  }
	  this.unlink = linker(vm, frag, host, scope, this);
	  var single = this.single = frag.childNodes.length === 1 &&
	  // do not go single mode if the only node is an anchor
	  !frag.childNodes[0].__v_anchor;
	  if (single) {
	    this.node = frag.childNodes[0];
	    this.before = singleBefore;
	    this.remove = singleRemove;
	  } else {
	    this.node = createAnchor('fragment-start');
	    this.end = createAnchor('fragment-end');
	    this.frag = frag;
	    prepend(this.node, frag);
	    frag.appendChild(this.end);
	    this.before = multiBefore;
	    this.remove = multiRemove;
	  }
	  this.node.__v_frag = this;
	}
	
	/**
	 * Call attach/detach for all components contained within
	 * this fragment. Also do so recursively for all child
	 * fragments.
	 *
	 * @param {Function} hook
	 */
	
	Fragment.prototype.callHook = function (hook) {
	  var i, l;
	  for (i = 0, l = this.childFrags.length; i < l; i++) {
	    this.childFrags[i].callHook(hook);
	  }
	  for (i = 0, l = this.children.length; i < l; i++) {
	    hook(this.children[i]);
	  }
	};
	
	/**
	 * Insert fragment before target, single node version
	 *
	 * @param {Node} target
	 * @param {Boolean} withTransition
	 */
	
	function singleBefore(target, withTransition) {
	  this.inserted = true;
	  var method = withTransition !== false ? beforeWithTransition : before;
	  method(this.node, target, this.vm);
	  if (inDoc(this.node)) {
	    this.callHook(attach);
	  }
	}
	
	/**
	 * Remove fragment, single node version
	 */
	
	function singleRemove() {
	  this.inserted = false;
	  var shouldCallRemove = inDoc(this.node);
	  var self = this;
	  this.beforeRemove();
	  removeWithTransition(this.node, this.vm, function () {
	    if (shouldCallRemove) {
	      self.callHook(detach);
	    }
	    self.destroy();
	  });
	}
	
	/**
	 * Insert fragment before target, multi-nodes version
	 *
	 * @param {Node} target
	 * @param {Boolean} withTransition
	 */
	
	function multiBefore(target, withTransition) {
	  this.inserted = true;
	  var vm = this.vm;
	  var method = withTransition !== false ? beforeWithTransition : before;
	  mapNodeRange(this.node, this.end, function (node) {
	    method(node, target, vm);
	  });
	  if (inDoc(this.node)) {
	    this.callHook(attach);
	  }
	}
	
	/**
	 * Remove fragment, multi-nodes version
	 */
	
	function multiRemove() {
	  this.inserted = false;
	  var self = this;
	  var shouldCallRemove = inDoc(this.node);
	  this.beforeRemove();
	  removeNodeRange(this.node, this.end, this.vm, this.frag, function () {
	    if (shouldCallRemove) {
	      self.callHook(detach);
	    }
	    self.destroy();
	  });
	}
	
	/**
	 * Prepare the fragment for removal.
	 */
	
	Fragment.prototype.beforeRemove = function () {
	  var i, l;
	  for (i = 0, l = this.childFrags.length; i < l; i++) {
	    // call the same method recursively on child
	    // fragments, depth-first
	    this.childFrags[i].beforeRemove(false);
	  }
	  for (i = 0, l = this.children.length; i < l; i++) {
	    // Call destroy for all contained instances,
	    // with remove:false and defer:true.
	    // Defer is necessary because we need to
	    // keep the children to call detach hooks
	    // on them.
	    this.children[i].$destroy(false, true);
	  }
	  var dirs = this.unlink.dirs;
	  for (i = 0, l = dirs.length; i < l; i++) {
	    // disable the watchers on all the directives
	    // so that the rendered content stays the same
	    // during removal.
	    dirs[i]._watcher && dirs[i]._watcher.teardown();
	  }
	};
	
	/**
	 * Destroy the fragment.
	 */
	
	Fragment.prototype.destroy = function () {
	  if (this.parentFrag) {
	    this.parentFrag.childFrags.$remove(this);
	  }
	  this.node.__v_frag = null;
	  this.unlink();
	};
	
	/**
	 * Call attach hook for a Vue instance.
	 *
	 * @param {Vue} child
	 */
	
	function attach(child) {
	  if (!child._isAttached && inDoc(child.$el)) {
	    child._callHook('attached');
	  }
	}
	
	/**
	 * Call detach hook for a Vue instance.
	 *
	 * @param {Vue} child
	 */
	
	function detach(child) {
	  if (child._isAttached && !inDoc(child.$el)) {
	    child._callHook('detached');
	  }
	}
	
	var linkerCache = new Cache(5000);
	
	/**
	 * A factory that can be used to create instances of a
	 * fragment. Caches the compiled linker if possible.
	 *
	 * @param {Vue} vm
	 * @param {Element|String} el
	 */
	function FragmentFactory(vm, el) {
	  this.vm = vm;
	  var template;
	  var isString = typeof el === 'string';
	  if (isString || isTemplate(el) && !el.hasAttribute('v-if')) {
	    template = parseTemplate(el, true);
	  } else {
	    template = document.createDocumentFragment();
	    template.appendChild(el);
	  }
	  this.template = template;
	  // linker can be cached, but only for components
	  var linker;
	  var cid = vm.constructor.cid;
	  if (cid > 0) {
	    var cacheId = cid + (isString ? el : getOuterHTML(el));
	    linker = linkerCache.get(cacheId);
	    if (!linker) {
	      linker = compile(template, vm.$options, true);
	      linkerCache.put(cacheId, linker);
	    }
	  } else {
	    linker = compile(template, vm.$options, true);
	  }
	  this.linker = linker;
	}
	
	/**
	 * Create a fragment instance with given host and scope.
	 *
	 * @param {Vue} host
	 * @param {Object} scope
	 * @param {Fragment} parentFrag
	 */
	
	FragmentFactory.prototype.create = function (host, scope, parentFrag) {
	  var frag = cloneNode(this.template);
	  return new Fragment(this.linker, this.vm, frag, host, scope, parentFrag);
	};
	
	var ON = 700;
	var MODEL = 800;
	var BIND = 850;
	var TRANSITION = 1100;
	var EL = 1500;
	var COMPONENT = 1500;
	var PARTIAL = 1750;
	var IF = 2100;
	var FOR = 2200;
	var SLOT = 2300;
	
	var uid$3 = 0;
	
	var vFor = {
	
	  priority: FOR,
	  terminal: true,
	
	  params: ['track-by', 'stagger', 'enter-stagger', 'leave-stagger'],
	
	  bind: function bind() {
	    if (false) {
	      warn('<' + this.el.tagName.toLowerCase() + ' v-for="' + this.expression + '" v-if="' + this.el.getAttribute('v-if') + '">: ' + 'Using v-if and v-for on the same element is not recommended - ' + 'consider filtering the source Array instead.', this.vm);
	    }
	
	    // support "item in/of items" syntax
	    var inMatch = this.expression.match(/(.*) (?:in|of) (.*)/);
	    if (inMatch) {
	      var itMatch = inMatch[1].match(/\((.*),(.*)\)/);
	      if (itMatch) {
	        this.iterator = itMatch[1].trim();
	        this.alias = itMatch[2].trim();
	      } else {
	        this.alias = inMatch[1].trim();
	      }
	      this.expression = inMatch[2];
	    }
	
	    if (!this.alias) {
	      ("production") !== 'production' && warn('Invalid v-for expression "' + this.descriptor.raw + '": ' + 'alias is required.', this.vm);
	      return;
	    }
	
	    // uid as a cache identifier
	    this.id = '__v-for__' + ++uid$3;
	
	    // check if this is an option list,
	    // so that we know if we need to update the <select>'s
	    // v-model when the option list has changed.
	    // because v-model has a lower priority than v-for,
	    // the v-model is not bound here yet, so we have to
	    // retrive it in the actual updateModel() function.
	    var tag = this.el.tagName;
	    this.isOption = (tag === 'OPTION' || tag === 'OPTGROUP') && this.el.parentNode.tagName === 'SELECT';
	
	    // setup anchor nodes
	    this.start = createAnchor('v-for-start');
	    this.end = createAnchor('v-for-end');
	    replace(this.el, this.end);
	    before(this.start, this.end);
	
	    // cache
	    this.cache = Object.create(null);
	
	    // fragment factory
	    this.factory = new FragmentFactory(this.vm, this.el);
	  },
	
	  update: function update(data) {
	    this.diff(data);
	    this.updateRef();
	    this.updateModel();
	  },
	
	  /**
	   * Diff, based on new data and old data, determine the
	   * minimum amount of DOM manipulations needed to make the
	   * DOM reflect the new data Array.
	   *
	   * The algorithm diffs the new data Array by storing a
	   * hidden reference to an owner vm instance on previously
	   * seen data. This allows us to achieve O(n) which is
	   * better than a levenshtein distance based algorithm,
	   * which is O(m * n).
	   *
	   * @param {Array} data
	   */
	
	  diff: function diff(data) {
	    // check if the Array was converted from an Object
	    var item = data[0];
	    var convertedFromObject = this.fromObject = isObject(item) && hasOwn(item, '$key') && hasOwn(item, '$value');
	
	    var trackByKey = this.params.trackBy;
	    var oldFrags = this.frags;
	    var frags = this.frags = new Array(data.length);
	    var alias = this.alias;
	    var iterator = this.iterator;
	    var start = this.start;
	    var end = this.end;
	    var inDocument = inDoc(start);
	    var init = !oldFrags;
	    var i, l, frag, key, value, primitive;
	
	    // First pass, go through the new Array and fill up
	    // the new frags array. If a piece of data has a cached
	    // instance for it, we reuse it. Otherwise build a new
	    // instance.
	    for (i = 0, l = data.length; i < l; i++) {
	      item = data[i];
	      key = convertedFromObject ? item.$key : null;
	      value = convertedFromObject ? item.$value : item;
	      primitive = !isObject(value);
	      frag = !init && this.getCachedFrag(value, i, key);
	      if (frag) {
	        // reusable fragment
	        frag.reused = true;
	        // update $index
	        frag.scope.$index = i;
	        // update $key
	        if (key) {
	          frag.scope.$key = key;
	        }
	        // update iterator
	        if (iterator) {
	          frag.scope[iterator] = key !== null ? key : i;
	        }
	        // update data for track-by, object repeat &
	        // primitive values.
	        if (trackByKey || convertedFromObject || primitive) {
	          withoutConversion(function () {
	            frag.scope[alias] = value;
	          });
	        }
	      } else {
	        // new instance
	        frag = this.create(value, alias, i, key);
	        frag.fresh = !init;
	      }
	      frags[i] = frag;
	      if (init) {
	        frag.before(end);
	      }
	    }
	
	    // we're done for the initial render.
	    if (init) {
	      return;
	    }
	
	    // Second pass, go through the old fragments and
	    // destroy those who are not reused (and remove them
	    // from cache)
	    var removalIndex = 0;
	    var totalRemoved = oldFrags.length - frags.length;
	    // when removing a large number of fragments, watcher removal
	    // turns out to be a perf bottleneck, so we batch the watcher
	    // removals into a single filter call!
	    this.vm._vForRemoving = true;
	    for (i = 0, l = oldFrags.length; i < l; i++) {
	      frag = oldFrags[i];
	      if (!frag.reused) {
	        this.deleteCachedFrag(frag);
	        this.remove(frag, removalIndex++, totalRemoved, inDocument);
	      }
	    }
	    this.vm._vForRemoving = false;
	    if (removalIndex) {
	      this.vm._watchers = this.vm._watchers.filter(function (w) {
	        return w.active;
	      });
	    }
	
	    // Final pass, move/insert new fragments into the
	    // right place.
	    var targetPrev, prevEl, currentPrev;
	    var insertionIndex = 0;
	    for (i = 0, l = frags.length; i < l; i++) {
	      frag = frags[i];
	      // this is the frag that we should be after
	      targetPrev = frags[i - 1];
	      prevEl = targetPrev ? targetPrev.staggerCb ? targetPrev.staggerAnchor : targetPrev.end || targetPrev.node : start;
	      if (frag.reused && !frag.staggerCb) {
	        currentPrev = findPrevFrag(frag, start, this.id);
	        if (currentPrev !== targetPrev && (!currentPrev ||
	        // optimization for moving a single item.
	        // thanks to suggestions by @livoras in #1807
	        findPrevFrag(currentPrev, start, this.id) !== targetPrev)) {
	          this.move(frag, prevEl);
	        }
	      } else {
	        // new instance, or still in stagger.
	        // insert with updated stagger index.
	        this.insert(frag, insertionIndex++, prevEl, inDocument);
	      }
	      frag.reused = frag.fresh = false;
	    }
	  },
	
	  /**
	   * Create a new fragment instance.
	   *
	   * @param {*} value
	   * @param {String} alias
	   * @param {Number} index
	   * @param {String} [key]
	   * @return {Fragment}
	   */
	
	  create: function create(value, alias, index, key) {
	    var host = this._host;
	    // create iteration scope
	    var parentScope = this._scope || this.vm;
	    var scope = Object.create(parentScope);
	    // ref holder for the scope
	    scope.$refs = Object.create(parentScope.$refs);
	    scope.$els = Object.create(parentScope.$els);
	    // make sure point $parent to parent scope
	    scope.$parent = parentScope;
	    // for two-way binding on alias
	    scope.$forContext = this;
	    // define scope properties
	    // important: define the scope alias without forced conversion
	    // so that frozen data structures remain non-reactive.
	    withoutConversion(function () {
	      defineReactive(scope, alias, value);
	    });
	    defineReactive(scope, '$index', index);
	    if (key) {
	      defineReactive(scope, '$key', key);
	    } else if (scope.$key) {
	      // avoid accidental fallback
	      def(scope, '$key', null);
	    }
	    if (this.iterator) {
	      defineReactive(scope, this.iterator, key !== null ? key : index);
	    }
	    var frag = this.factory.create(host, scope, this._frag);
	    frag.forId = this.id;
	    this.cacheFrag(value, frag, index, key);
	    return frag;
	  },
	
	  /**
	   * Update the v-ref on owner vm.
	   */
	
	  updateRef: function updateRef() {
	    var ref = this.descriptor.ref;
	    if (!ref) return;
	    var hash = (this._scope || this.vm).$refs;
	    var refs;
	    if (!this.fromObject) {
	      refs = this.frags.map(findVmFromFrag);
	    } else {
	      refs = {};
	      this.frags.forEach(function (frag) {
	        refs[frag.scope.$key] = findVmFromFrag(frag);
	      });
	    }
	    hash[ref] = refs;
	  },
	
	  /**
	   * For option lists, update the containing v-model on
	   * parent <select>.
	   */
	
	  updateModel: function updateModel() {
	    if (this.isOption) {
	      var parent = this.start.parentNode;
	      var model = parent && parent.__v_model;
	      if (model) {
	        model.forceUpdate();
	      }
	    }
	  },
	
	  /**
	   * Insert a fragment. Handles staggering.
	   *
	   * @param {Fragment} frag
	   * @param {Number} index
	   * @param {Node} prevEl
	   * @param {Boolean} inDocument
	   */
	
	  insert: function insert(frag, index, prevEl, inDocument) {
	    if (frag.staggerCb) {
	      frag.staggerCb.cancel();
	      frag.staggerCb = null;
	    }
	    var staggerAmount = this.getStagger(frag, index, null, 'enter');
	    if (inDocument && staggerAmount) {
	      // create an anchor and insert it synchronously,
	      // so that we can resolve the correct order without
	      // worrying about some elements not inserted yet
	      var anchor = frag.staggerAnchor;
	      if (!anchor) {
	        anchor = frag.staggerAnchor = createAnchor('stagger-anchor');
	        anchor.__v_frag = frag;
	      }
	      after(anchor, prevEl);
	      var op = frag.staggerCb = cancellable(function () {
	        frag.staggerCb = null;
	        frag.before(anchor);
	        remove(anchor);
	      });
	      setTimeout(op, staggerAmount);
	    } else {
	      var target = prevEl.nextSibling;
	      /* istanbul ignore if */
	      if (!target) {
	        // reset end anchor position in case the position was messed up
	        // by an external drag-n-drop library.
	        after(this.end, prevEl);
	        target = this.end;
	      }
	      frag.before(target);
	    }
	  },
	
	  /**
	   * Remove a fragment. Handles staggering.
	   *
	   * @param {Fragment} frag
	   * @param {Number} index
	   * @param {Number} total
	   * @param {Boolean} inDocument
	   */
	
	  remove: function remove(frag, index, total, inDocument) {
	    if (frag.staggerCb) {
	      frag.staggerCb.cancel();
	      frag.staggerCb = null;
	      // it's not possible for the same frag to be removed
	      // twice, so if we have a pending stagger callback,
	      // it means this frag is queued for enter but removed
	      // before its transition started. Since it is already
	      // destroyed, we can just leave it in detached state.
	      return;
	    }
	    var staggerAmount = this.getStagger(frag, index, total, 'leave');
	    if (inDocument && staggerAmount) {
	      var op = frag.staggerCb = cancellable(function () {
	        frag.staggerCb = null;
	        frag.remove();
	      });
	      setTimeout(op, staggerAmount);
	    } else {
	      frag.remove();
	    }
	  },
	
	  /**
	   * Move a fragment to a new position.
	   * Force no transition.
	   *
	   * @param {Fragment} frag
	   * @param {Node} prevEl
	   */
	
	  move: function move(frag, prevEl) {
	    // fix a common issue with Sortable:
	    // if prevEl doesn't have nextSibling, this means it's
	    // been dragged after the end anchor. Just re-position
	    // the end anchor to the end of the container.
	    /* istanbul ignore if */
	    if (!prevEl.nextSibling) {
	      this.end.parentNode.appendChild(this.end);
	    }
	    frag.before(prevEl.nextSibling, false);
	  },
	
	  /**
	   * Cache a fragment using track-by or the object key.
	   *
	   * @param {*} value
	   * @param {Fragment} frag
	   * @param {Number} index
	   * @param {String} [key]
	   */
	
	  cacheFrag: function cacheFrag(value, frag, index, key) {
	    var trackByKey = this.params.trackBy;
	    var cache = this.cache;
	    var primitive = !isObject(value);
	    var id;
	    if (key || trackByKey || primitive) {
	      id = getTrackByKey(index, key, value, trackByKey);
	      if (!cache[id]) {
	        cache[id] = frag;
	      } else if (trackByKey !== '$index') {
	        ("production") !== 'production' && this.warnDuplicate(value);
	      }
	    } else {
	      id = this.id;
	      if (hasOwn(value, id)) {
	        if (value[id] === null) {
	          value[id] = frag;
	        } else {
	          ("production") !== 'production' && this.warnDuplicate(value);
	        }
	      } else if (Object.isExtensible(value)) {
	        def(value, id, frag);
	      } else if (false) {
	        warn('Frozen v-for objects cannot be automatically tracked, make sure to ' + 'provide a track-by key.');
	      }
	    }
	    frag.raw = value;
	  },
	
	  /**
	   * Get a cached fragment from the value/index/key
	   *
	   * @param {*} value
	   * @param {Number} index
	   * @param {String} key
	   * @return {Fragment}
	   */
	
	  getCachedFrag: function getCachedFrag(value, index, key) {
	    var trackByKey = this.params.trackBy;
	    var primitive = !isObject(value);
	    var frag;
	    if (key || trackByKey || primitive) {
	      var id = getTrackByKey(index, key, value, trackByKey);
	      frag = this.cache[id];
	    } else {
	      frag = value[this.id];
	    }
	    if (frag && (frag.reused || frag.fresh)) {
	      ("production") !== 'production' && this.warnDuplicate(value);
	    }
	    return frag;
	  },
	
	  /**
	   * Delete a fragment from cache.
	   *
	   * @param {Fragment} frag
	   */
	
	  deleteCachedFrag: function deleteCachedFrag(frag) {
	    var value = frag.raw;
	    var trackByKey = this.params.trackBy;
	    var scope = frag.scope;
	    var index = scope.$index;
	    // fix #948: avoid accidentally fall through to
	    // a parent repeater which happens to have $key.
	    var key = hasOwn(scope, '$key') && scope.$key;
	    var primitive = !isObject(value);
	    if (trackByKey || key || primitive) {
	      var id = getTrackByKey(index, key, value, trackByKey);
	      this.cache[id] = null;
	    } else {
	      value[this.id] = null;
	      frag.raw = null;
	    }
	  },
	
	  /**
	   * Get the stagger amount for an insertion/removal.
	   *
	   * @param {Fragment} frag
	   * @param {Number} index
	   * @param {Number} total
	   * @param {String} type
	   */
	
	  getStagger: function getStagger(frag, index, total, type) {
	    type = type + 'Stagger';
	    var trans = frag.node.__v_trans;
	    var hooks = trans && trans.hooks;
	    var hook = hooks && (hooks[type] || hooks.stagger);
	    return hook ? hook.call(frag, index, total) : index * parseInt(this.params[type] || this.params.stagger, 10);
	  },
	
	  /**
	   * Pre-process the value before piping it through the
	   * filters. This is passed to and called by the watcher.
	   */
	
	  _preProcess: function _preProcess(value) {
	    // regardless of type, store the un-filtered raw value.
	    this.rawValue = value;
	    return value;
	  },
	
	  /**
	   * Post-process the value after it has been piped through
	   * the filters. This is passed to and called by the watcher.
	   *
	   * It is necessary for this to be called during the
	   * watcher's dependency collection phase because we want
	   * the v-for to update when the source Object is mutated.
	   */
	
	  _postProcess: function _postProcess(value) {
	    if (isArray(value)) {
	      return value;
	    } else if (isPlainObject(value)) {
	      // convert plain object to array.
	      var keys = Object.keys(value);
	      var i = keys.length;
	      var res = new Array(i);
	      var key;
	      while (i--) {
	        key = keys[i];
	        res[i] = {
	          $key: key,
	          $value: value[key]
	        };
	      }
	      return res;
	    } else {
	      if (typeof value === 'number' && !isNaN(value)) {
	        value = range(value);
	      }
	      return value || [];
	    }
	  },
	
	  unbind: function unbind() {
	    if (this.descriptor.ref) {
	      (this._scope || this.vm).$refs[this.descriptor.ref] = null;
	    }
	    if (this.frags) {
	      var i = this.frags.length;
	      var frag;
	      while (i--) {
	        frag = this.frags[i];
	        this.deleteCachedFrag(frag);
	        frag.destroy();
	      }
	    }
	  }
	};
	
	/**
	 * Helper to find the previous element that is a fragment
	 * anchor. This is necessary because a destroyed frag's
	 * element could still be lingering in the DOM before its
	 * leaving transition finishes, but its inserted flag
	 * should have been set to false so we can skip them.
	 *
	 * If this is a block repeat, we want to make sure we only
	 * return frag that is bound to this v-for. (see #929)
	 *
	 * @param {Fragment} frag
	 * @param {Comment|Text} anchor
	 * @param {String} id
	 * @return {Fragment}
	 */
	
	function findPrevFrag(frag, anchor, id) {
	  var el = frag.node.previousSibling;
	  /* istanbul ignore if */
	  if (!el) return;
	  frag = el.__v_frag;
	  while ((!frag || frag.forId !== id || !frag.inserted) && el !== anchor) {
	    el = el.previousSibling;
	    /* istanbul ignore if */
	    if (!el) return;
	    frag = el.__v_frag;
	  }
	  return frag;
	}
	
	/**
	 * Create a range array from given number.
	 *
	 * @param {Number} n
	 * @return {Array}
	 */
	
	function range(n) {
	  var i = -1;
	  var ret = new Array(Math.floor(n));
	  while (++i < n) {
	    ret[i] = i;
	  }
	  return ret;
	}
	
	/**
	 * Get the track by key for an item.
	 *
	 * @param {Number} index
	 * @param {String} key
	 * @param {*} value
	 * @param {String} [trackByKey]
	 */
	
	function getTrackByKey(index, key, value, trackByKey) {
	  return trackByKey ? trackByKey === '$index' ? index : trackByKey.charAt(0).match(/\w/) ? getPath(value, trackByKey) : value[trackByKey] : key || value;
	}
	
	if (false) {
	  vFor.warnDuplicate = function (value) {
	    warn('Duplicate value found in v-for="' + this.descriptor.raw + '": ' + JSON.stringify(value) + '. Use track-by="$index" if ' + 'you are expecting duplicate values.', this.vm);
	  };
	}
	
	/**
	 * Find a vm from a fragment.
	 *
	 * @param {Fragment} frag
	 * @return {Vue|undefined}
	 */
	
	function findVmFromFrag(frag) {
	  var node = frag.node;
	  // handle multi-node frag
	  if (frag.end) {
	    while (!node.__vue__ && node !== frag.end && node.nextSibling) {
	      node = node.nextSibling;
	    }
	  }
	  return node.__vue__;
	}
	
	var vIf = {
	
	  priority: IF,
	  terminal: true,
	
	  bind: function bind() {
	    var el = this.el;
	    if (!el.__vue__) {
	      // check else block
	      var next = el.nextElementSibling;
	      if (next && getAttr(next, 'v-else') !== null) {
	        remove(next);
	        this.elseEl = next;
	      }
	      // check main block
	      this.anchor = createAnchor('v-if');
	      replace(el, this.anchor);
	    } else {
	      ("production") !== 'production' && warn('v-if="' + this.expression + '" cannot be ' + 'used on an instance root element.', this.vm);
	      this.invalid = true;
	    }
	  },
	
	  update: function update(value) {
	    if (this.invalid) return;
	    if (value) {
	      if (!this.frag) {
	        this.insert();
	      }
	    } else {
	      this.remove();
	    }
	  },
	
	  insert: function insert() {
	    if (this.elseFrag) {
	      this.elseFrag.remove();
	      this.elseFrag = null;
	    }
	    // lazy init factory
	    if (!this.factory) {
	      this.factory = new FragmentFactory(this.vm, this.el);
	    }
	    this.frag = this.factory.create(this._host, this._scope, this._frag);
	    this.frag.before(this.anchor);
	  },
	
	  remove: function remove() {
	    if (this.frag) {
	      this.frag.remove();
	      this.frag = null;
	    }
	    if (this.elseEl && !this.elseFrag) {
	      if (!this.elseFactory) {
	        this.elseFactory = new FragmentFactory(this.elseEl._context || this.vm, this.elseEl);
	      }
	      this.elseFrag = this.elseFactory.create(this._host, this._scope, this._frag);
	      this.elseFrag.before(this.anchor);
	    }
	  },
	
	  unbind: function unbind() {
	    if (this.frag) {
	      this.frag.destroy();
	    }
	    if (this.elseFrag) {
	      this.elseFrag.destroy();
	    }
	  }
	};
	
	var show = {
	
	  bind: function bind() {
	    // check else block
	    var next = this.el.nextElementSibling;
	    if (next && getAttr(next, 'v-else') !== null) {
	      this.elseEl = next;
	    }
	  },
	
	  update: function update(value) {
	    this.apply(this.el, value);
	    if (this.elseEl) {
	      this.apply(this.elseEl, !value);
	    }
	  },
	
	  apply: function apply(el, value) {
	    if (inDoc(el)) {
	      applyTransition(el, value ? 1 : -1, toggle, this.vm);
	    } else {
	      toggle();
	    }
	    function toggle() {
	      el.style.display = value ? '' : 'none';
	    }
	  }
	};
	
	var text$2 = {
	
	  bind: function bind() {
	    var self = this;
	    var el = this.el;
	    var isRange = el.type === 'range';
	    var lazy = this.params.lazy;
	    var number = this.params.number;
	    var debounce = this.params.debounce;
	
	    // handle composition events.
	    //   http://blog.evanyou.me/2014/01/03/composition-event/
	    // skip this for Android because it handles composition
	    // events quite differently. Android doesn't trigger
	    // composition events for language input methods e.g.
	    // Chinese, but instead triggers them for spelling
	    // suggestions... (see Discussion/#162)
	    var composing = false;
	    if (!isAndroid && !isRange) {
	      this.on('compositionstart', function () {
	        composing = true;
	      });
	      this.on('compositionend', function () {
	        composing = false;
	        // in IE11 the "compositionend" event fires AFTER
	        // the "input" event, so the input handler is blocked
	        // at the end... have to call it here.
	        //
	        // #1327: in lazy mode this is unecessary.
	        if (!lazy) {
	          self.listener();
	        }
	      });
	    }
	
	    // prevent messing with the input when user is typing,
	    // and force update on blur.
	    this.focused = false;
	    if (!isRange && !lazy) {
	      this.on('focus', function () {
	        self.focused = true;
	      });
	      this.on('blur', function () {
	        self.focused = false;
	        // do not sync value after fragment removal (#2017)
	        if (!self._frag || self._frag.inserted) {
	          self.rawListener();
	        }
	      });
	    }
	
	    // Now attach the main listener
	    this.listener = this.rawListener = function () {
	      if (composing || !self._bound) {
	        return;
	      }
	      var val = number || isRange ? toNumber(el.value) : el.value;
	      self.set(val);
	      // force update on next tick to avoid lock & same value
	      // also only update when user is not typing
	      nextTick(function () {
	        if (self._bound && !self.focused) {
	          self.update(self._watcher.value);
	        }
	      });
	    };
	
	    // apply debounce
	    if (debounce) {
	      this.listener = _debounce(this.listener, debounce);
	    }
	
	    // Support jQuery events, since jQuery.trigger() doesn't
	    // trigger native events in some cases and some plugins
	    // rely on $.trigger()
	    //
	    // We want to make sure if a listener is attached using
	    // jQuery, it is also removed with jQuery, that's why
	    // we do the check for each directive instance and
	    // store that check result on itself. This also allows
	    // easier test coverage control by unsetting the global
	    // jQuery variable in tests.
	    this.hasjQuery = typeof jQuery === 'function';
	    if (this.hasjQuery) {
	      var method = jQuery.fn.on ? 'on' : 'bind';
	      jQuery(el)[method]('change', this.rawListener);
	      if (!lazy) {
	        jQuery(el)[method]('input', this.listener);
	      }
	    } else {
	      this.on('change', this.rawListener);
	      if (!lazy) {
	        this.on('input', this.listener);
	      }
	    }
	
	    // IE9 doesn't fire input event on backspace/del/cut
	    if (!lazy && isIE9) {
	      this.on('cut', function () {
	        nextTick(self.listener);
	      });
	      this.on('keyup', function (e) {
	        if (e.keyCode === 46 || e.keyCode === 8) {
	          self.listener();
	        }
	      });
	    }
	
	    // set initial value if present
	    if (el.hasAttribute('value') || el.tagName === 'TEXTAREA' && el.value.trim()) {
	      this.afterBind = this.listener;
	    }
	  },
	
	  update: function update(value) {
	    // #3029 only update when the value changes. This prevent
	    // browsers from overwriting values like selectionStart
	    value = _toString(value);
	    if (value !== this.el.value) this.el.value = value;
	  },
	
	  unbind: function unbind() {
	    var el = this.el;
	    if (this.hasjQuery) {
	      var method = jQuery.fn.off ? 'off' : 'unbind';
	      jQuery(el)[method]('change', this.listener);
	      jQuery(el)[method]('input', this.listener);
	    }
	  }
	};
	
	var radio = {
	
	  bind: function bind() {
	    var self = this;
	    var el = this.el;
	
	    this.getValue = function () {
	      // value overwrite via v-bind:value
	      if (el.hasOwnProperty('_value')) {
	        return el._value;
	      }
	      var val = el.value;
	      if (self.params.number) {
	        val = toNumber(val);
	      }
	      return val;
	    };
	
	    this.listener = function () {
	      self.set(self.getValue());
	    };
	    this.on('change', this.listener);
	
	    if (el.hasAttribute('checked')) {
	      this.afterBind = this.listener;
	    }
	  },
	
	  update: function update(value) {
	    this.el.checked = looseEqual(value, this.getValue());
	  }
	};
	
	var select = {
	
	  bind: function bind() {
	    var _this = this;
	
	    var self = this;
	    var el = this.el;
	
	    // method to force update DOM using latest value.
	    this.forceUpdate = function () {
	      if (self._watcher) {
	        self.update(self._watcher.get());
	      }
	    };
	
	    // check if this is a multiple select
	    var multiple = this.multiple = el.hasAttribute('multiple');
	
	    // attach listener
	    this.listener = function () {
	      var value = getValue(el, multiple);
	      value = self.params.number ? isArray(value) ? value.map(toNumber) : toNumber(value) : value;
	      self.set(value);
	    };
	    this.on('change', this.listener);
	
	    // if has initial value, set afterBind
	    var initValue = getValue(el, multiple, true);
	    if (multiple && initValue.length || !multiple && initValue !== null) {
	      this.afterBind = this.listener;
	    }
	
	    // All major browsers except Firefox resets
	    // selectedIndex with value -1 to 0 when the element
	    // is appended to a new parent, therefore we have to
	    // force a DOM update whenever that happens...
	    this.vm.$on('hook:attached', function () {
	      nextTick(_this.forceUpdate);
	    });
	    if (!inDoc(el)) {
	      nextTick(this.forceUpdate);
	    }
	  },
	
	  update: function update(value) {
	    var el = this.el;
	    el.selectedIndex = -1;
	    var multi = this.multiple && isArray(value);
	    var options = el.options;
	    var i = options.length;
	    var op, val;
	    while (i--) {
	      op = options[i];
	      val = op.hasOwnProperty('_value') ? op._value : op.value;
	      /* eslint-disable eqeqeq */
	      op.selected = multi ? indexOf$1(value, val) > -1 : looseEqual(value, val);
	      /* eslint-enable eqeqeq */
	    }
	  },
	
	  unbind: function unbind() {
	    /* istanbul ignore next */
	    this.vm.$off('hook:attached', this.forceUpdate);
	  }
	};
	
	/**
	 * Get select value
	 *
	 * @param {SelectElement} el
	 * @param {Boolean} multi
	 * @param {Boolean} init
	 * @return {Array|*}
	 */
	
	function getValue(el, multi, init) {
	  var res = multi ? [] : null;
	  var op, val, selected;
	  for (var i = 0, l = el.options.length; i < l; i++) {
	    op = el.options[i];
	    selected = init ? op.hasAttribute('selected') : op.selected;
	    if (selected) {
	      val = op.hasOwnProperty('_value') ? op._value : op.value;
	      if (multi) {
	        res.push(val);
	      } else {
	        return val;
	      }
	    }
	  }
	  return res;
	}
	
	/**
	 * Native Array.indexOf uses strict equal, but in this
	 * case we need to match string/numbers with custom equal.
	 *
	 * @param {Array} arr
	 * @param {*} val
	 */
	
	function indexOf$1(arr, val) {
	  var i = arr.length;
	  while (i--) {
	    if (looseEqual(arr[i], val)) {
	      return i;
	    }
	  }
	  return -1;
	}
	
	var checkbox = {
	
	  bind: function bind() {
	    var self = this;
	    var el = this.el;
	
	    this.getValue = function () {
	      return el.hasOwnProperty('_value') ? el._value : self.params.number ? toNumber(el.value) : el.value;
	    };
	
	    function getBooleanValue() {
	      var val = el.checked;
	      if (val && el.hasOwnProperty('_trueValue')) {
	        return el._trueValue;
	      }
	      if (!val && el.hasOwnProperty('_falseValue')) {
	        return el._falseValue;
	      }
	      return val;
	    }
	
	    this.listener = function () {
	      var model = self._watcher.get();
	      if (isArray(model)) {
	        var val = self.getValue();
	        var i = indexOf(model, val);
	        if (el.checked) {
	          if (i < 0) {
	            self.set(model.concat(val));
	          }
	        } else if (i > -1) {
	          self.set(model.slice(0, i).concat(model.slice(i + 1)));
	        }
	      } else {
	        self.set(getBooleanValue());
	      }
	    };
	
	    this.on('change', this.listener);
	    if (el.hasAttribute('checked')) {
	      this.afterBind = this.listener;
	    }
	  },
	
	  update: function update(value) {
	    var el = this.el;
	    if (isArray(value)) {
	      el.checked = indexOf(value, this.getValue()) > -1;
	    } else {
	      if (el.hasOwnProperty('_trueValue')) {
	        el.checked = looseEqual(value, el._trueValue);
	      } else {
	        el.checked = !!value;
	      }
	    }
	  }
	};
	
	var handlers = {
	  text: text$2,
	  radio: radio,
	  select: select,
	  checkbox: checkbox
	};
	
	var model = {
	
	  priority: MODEL,
	  twoWay: true,
	  handlers: handlers,
	  params: ['lazy', 'number', 'debounce'],
	
	  /**
	   * Possible elements:
	   *   <select>
	   *   <textarea>
	   *   <input type="*">
	   *     - text
	   *     - checkbox
	   *     - radio
	   *     - number
	   */
	
	  bind: function bind() {
	    // friendly warning...
	    this.checkFilters();
	    if (this.hasRead && !this.hasWrite) {
	      ("production") !== 'production' && warn('It seems you are using a read-only filter with ' + 'v-model="' + this.descriptor.raw + '". ' + 'You might want to use a two-way filter to ensure correct behavior.', this.vm);
	    }
	    var el = this.el;
	    var tag = el.tagName;
	    var handler;
	    if (tag === 'INPUT') {
	      handler = handlers[el.type] || handlers.text;
	    } else if (tag === 'SELECT') {
	      handler = handlers.select;
	    } else if (tag === 'TEXTAREA') {
	      handler = handlers.text;
	    } else {
	      ("production") !== 'production' && warn('v-model does not support element type: ' + tag, this.vm);
	      return;
	    }
	    el.__v_model = this;
	    handler.bind.call(this);
	    this.update = handler.update;
	    this._unbind = handler.unbind;
	  },
	
	  /**
	   * Check read/write filter stats.
	   */
	
	  checkFilters: function checkFilters() {
	    var filters = this.filters;
	    if (!filters) return;
	    var i = filters.length;
	    while (i--) {
	      var filter = resolveAsset(this.vm.$options, 'filters', filters[i].name);
	      if (typeof filter === 'function' || filter.read) {
	        this.hasRead = true;
	      }
	      if (filter.write) {
	        this.hasWrite = true;
	      }
	    }
	  },
	
	  unbind: function unbind() {
	    this.el.__v_model = null;
	    this._unbind && this._unbind();
	  }
	};
	
	// keyCode aliases
	var keyCodes = {
	  esc: 27,
	  tab: 9,
	  enter: 13,
	  space: 32,
	  'delete': [8, 46],
	  up: 38,
	  left: 37,
	  right: 39,
	  down: 40
	};
	
	function keyFilter(handler, keys) {
	  var codes = keys.map(function (key) {
	    var charCode = key.charCodeAt(0);
	    if (charCode > 47 && charCode < 58) {
	      return parseInt(key, 10);
	    }
	    if (key.length === 1) {
	      charCode = key.toUpperCase().charCodeAt(0);
	      if (charCode > 64 && charCode < 91) {
	        return charCode;
	      }
	    }
	    return keyCodes[key];
	  });
	  codes = [].concat.apply([], codes);
	  return function keyHandler(e) {
	    if (codes.indexOf(e.keyCode) > -1) {
	      return handler.call(this, e);
	    }
	  };
	}
	
	function stopFilter(handler) {
	  return function stopHandler(e) {
	    e.stopPropagation();
	    return handler.call(this, e);
	  };
	}
	
	function preventFilter(handler) {
	  return function preventHandler(e) {
	    e.preventDefault();
	    return handler.call(this, e);
	  };
	}
	
	function selfFilter(handler) {
	  return function selfHandler(e) {
	    if (e.target === e.currentTarget) {
	      return handler.call(this, e);
	    }
	  };
	}
	
	var on$1 = {
	
	  priority: ON,
	  acceptStatement: true,
	  keyCodes: keyCodes,
	
	  bind: function bind() {
	    // deal with iframes
	    if (this.el.tagName === 'IFRAME' && this.arg !== 'load') {
	      var self = this;
	      this.iframeBind = function () {
	        on(self.el.contentWindow, self.arg, self.handler, self.modifiers.capture);
	      };
	      this.on('load', this.iframeBind);
	    }
	  },
	
	  update: function update(handler) {
	    // stub a noop for v-on with no value,
	    // e.g. @mousedown.prevent
	    if (!this.descriptor.raw) {
	      handler = function () {};
	    }
	
	    if (typeof handler !== 'function') {
	      ("production") !== 'production' && warn('v-on:' + this.arg + '="' + this.expression + '" expects a function value, ' + 'got ' + handler, this.vm);
	      return;
	    }
	
	    // apply modifiers
	    if (this.modifiers.stop) {
	      handler = stopFilter(handler);
	    }
	    if (this.modifiers.prevent) {
	      handler = preventFilter(handler);
	    }
	    if (this.modifiers.self) {
	      handler = selfFilter(handler);
	    }
	    // key filter
	    var keys = Object.keys(this.modifiers).filter(function (key) {
	      return key !== 'stop' && key !== 'prevent' && key !== 'self' && key !== 'capture';
	    });
	    if (keys.length) {
	      handler = keyFilter(handler, keys);
	    }
	
	    this.reset();
	    this.handler = handler;
	
	    if (this.iframeBind) {
	      this.iframeBind();
	    } else {
	      on(this.el, this.arg, this.handler, this.modifiers.capture);
	    }
	  },
	
	  reset: function reset() {
	    var el = this.iframeBind ? this.el.contentWindow : this.el;
	    if (this.handler) {
	      off(el, this.arg, this.handler);
	    }
	  },
	
	  unbind: function unbind() {
	    this.reset();
	  }
	};
	
	var prefixes = ['-webkit-', '-moz-', '-ms-'];
	var camelPrefixes = ['Webkit', 'Moz', 'ms'];
	var importantRE = /!important;?$/;
	var propCache = Object.create(null);
	
	var testEl = null;
	
	var style = {
	
	  deep: true,
	
	  update: function update(value) {
	    if (typeof value === 'string') {
	      this.el.style.cssText = value;
	    } else if (isArray(value)) {
	      this.handleObject(value.reduce(extend, {}));
	    } else {
	      this.handleObject(value || {});
	    }
	  },
	
	  handleObject: function handleObject(value) {
	    // cache object styles so that only changed props
	    // are actually updated.
	    var cache = this.cache || (this.cache = {});
	    var name, val;
	    for (name in cache) {
	      if (!(name in value)) {
	        this.handleSingle(name, null);
	        delete cache[name];
	      }
	    }
	    for (name in value) {
	      val = value[name];
	      if (val !== cache[name]) {
	        cache[name] = val;
	        this.handleSingle(name, val);
	      }
	    }
	  },
	
	  handleSingle: function handleSingle(prop, value) {
	    prop = normalize(prop);
	    if (!prop) return; // unsupported prop
	    // cast possible numbers/booleans into strings
	    if (value != null) value += '';
	    if (value) {
	      var isImportant = importantRE.test(value) ? 'important' : '';
	      if (isImportant) {
	        /* istanbul ignore if */
	        if (false) {
	          warn('It\'s probably a bad idea to use !important with inline rules. ' + 'This feature will be deprecated in a future version of Vue.');
	        }
	        value = value.replace(importantRE, '').trim();
	        this.el.style.setProperty(prop.kebab, value, isImportant);
	      } else {
	        this.el.style[prop.camel] = value;
	      }
	    } else {
	      this.el.style[prop.camel] = '';
	    }
	  }
	
	};
	
	/**
	 * Normalize a CSS property name.
	 * - cache result
	 * - auto prefix
	 * - camelCase -> dash-case
	 *
	 * @param {String} prop
	 * @return {String}
	 */
	
	function normalize(prop) {
	  if (propCache[prop]) {
	    return propCache[prop];
	  }
	  var res = prefix(prop);
	  propCache[prop] = propCache[res] = res;
	  return res;
	}
	
	/**
	 * Auto detect the appropriate prefix for a CSS property.
	 * https://gist.github.com/paulirish/523692
	 *
	 * @param {String} prop
	 * @return {String}
	 */
	
	function prefix(prop) {
	  prop = hyphenate(prop);
	  var camel = camelize(prop);
	  var upper = camel.charAt(0).toUpperCase() + camel.slice(1);
	  if (!testEl) {
	    testEl = document.createElement('div');
	  }
	  var i = prefixes.length;
	  var prefixed;
	  if (camel !== 'filter' && camel in testEl.style) {
	    return {
	      kebab: prop,
	      camel: camel
	    };
	  }
	  while (i--) {
	    prefixed = camelPrefixes[i] + upper;
	    if (prefixed in testEl.style) {
	      return {
	        kebab: prefixes[i] + prop,
	        camel: prefixed
	      };
	    }
	  }
	}
	
	// xlink
	var xlinkNS = 'http://www.w3.org/1999/xlink';
	var xlinkRE = /^xlink:/;
	
	// check for attributes that prohibit interpolations
	var disallowedInterpAttrRE = /^v-|^:|^@|^(?:is|transition|transition-mode|debounce|track-by|stagger|enter-stagger|leave-stagger)$/;
	// these attributes should also set their corresponding properties
	// because they only affect the initial state of the element
	var attrWithPropsRE = /^(?:value|checked|selected|muted)$/;
	// these attributes expect enumrated values of "true" or "false"
	// but are not boolean attributes
	var enumeratedAttrRE = /^(?:draggable|contenteditable|spellcheck)$/;
	
	// these attributes should set a hidden property for
	// binding v-model to object values
	var modelProps = {
	  value: '_value',
	  'true-value': '_trueValue',
	  'false-value': '_falseValue'
	};
	
	var bind$1 = {
	
	  priority: BIND,
	
	  bind: function bind() {
	    var attr = this.arg;
	    var tag = this.el.tagName;
	    // should be deep watch on object mode
	    if (!attr) {
	      this.deep = true;
	    }
	    // handle interpolation bindings
	    var descriptor = this.descriptor;
	    var tokens = descriptor.interp;
	    if (tokens) {
	      // handle interpolations with one-time tokens
	      if (descriptor.hasOneTime) {
	        this.expression = tokensToExp(tokens, this._scope || this.vm);
	      }
	
	      // only allow binding on native attributes
	      if (disallowedInterpAttrRE.test(attr) || attr === 'name' && (tag === 'PARTIAL' || tag === 'SLOT')) {
	        ("production") !== 'production' && warn(attr + '="' + descriptor.raw + '": ' + 'attribute interpolation is not allowed in Vue.js ' + 'directives and special attributes.', this.vm);
	        this.el.removeAttribute(attr);
	        this.invalid = true;
	      }
	
	      /* istanbul ignore if */
	      if (false) {
	        var raw = attr + '="' + descriptor.raw + '": ';
	        // warn src
	        if (attr === 'src') {
	          warn(raw + 'interpolation in "src" attribute will cause ' + 'a 404 request. Use v-bind:src instead.', this.vm);
	        }
	
	        // warn style
	        if (attr === 'style') {
	          warn(raw + 'interpolation in "style" attribute will cause ' + 'the attribute to be discarded in Internet Explorer. ' + 'Use v-bind:style instead.', this.vm);
	        }
	      }
	    }
	  },
	
	  update: function update(value) {
	    if (this.invalid) {
	      return;
	    }
	    var attr = this.arg;
	    if (this.arg) {
	      this.handleSingle(attr, value);
	    } else {
	      this.handleObject(value || {});
	    }
	  },
	
	  // share object handler with v-bind:class
	  handleObject: style.handleObject,
	
	  handleSingle: function handleSingle(attr, value) {
	    var el = this.el;
	    var interp = this.descriptor.interp;
	    if (this.modifiers.camel) {
	      attr = camelize(attr);
	    }
	    if (!interp && attrWithPropsRE.test(attr) && attr in el) {
	      var attrValue = attr === 'value' ? value == null // IE9 will set input.value to "null" for null...
	      ? '' : value : value;
	
	      if (el[attr] !== attrValue) {
	        el[attr] = attrValue;
	      }
	    }
	    // set model props
	    var modelProp = modelProps[attr];
	    if (!interp && modelProp) {
	      el[modelProp] = value;
	      // update v-model if present
	      var model = el.__v_model;
	      if (model) {
	        model.listener();
	      }
	    }
	    // do not set value attribute for textarea
	    if (attr === 'value' && el.tagName === 'TEXTAREA') {
	      el.removeAttribute(attr);
	      return;
	    }
	    // update attribute
	    if (enumeratedAttrRE.test(attr)) {
	      el.setAttribute(attr, value ? 'true' : 'false');
	    } else if (value != null && value !== false) {
	      if (attr === 'class') {
	        // handle edge case #1960:
	        // class interpolation should not overwrite Vue transition class
	        if (el.__v_trans) {
	          value += ' ' + el.__v_trans.id + '-transition';
	        }
	        setClass(el, value);
	      } else if (xlinkRE.test(attr)) {
	        el.setAttributeNS(xlinkNS, attr, value === true ? '' : value);
	      } else {
	        el.setAttribute(attr, value === true ? '' : value);
	      }
	    } else {
	      el.removeAttribute(attr);
	    }
	  }
	};
	
	var el = {
	
	  priority: EL,
	
	  bind: function bind() {
	    /* istanbul ignore if */
	    if (!this.arg) {
	      return;
	    }
	    var id = this.id = camelize(this.arg);
	    var refs = (this._scope || this.vm).$els;
	    if (hasOwn(refs, id)) {
	      refs[id] = this.el;
	    } else {
	      defineReactive(refs, id, this.el);
	    }
	  },
	
	  unbind: function unbind() {
	    var refs = (this._scope || this.vm).$els;
	    if (refs[this.id] === this.el) {
	      refs[this.id] = null;
	    }
	  }
	};
	
	var ref = {
	  bind: function bind() {
	    ("production") !== 'production' && warn('v-ref:' + this.arg + ' must be used on a child ' + 'component. Found on <' + this.el.tagName.toLowerCase() + '>.', this.vm);
	  }
	};
	
	var cloak = {
	  bind: function bind() {
	    var el = this.el;
	    this.vm.$once('pre-hook:compiled', function () {
	      el.removeAttribute('v-cloak');
	    });
	  }
	};
	
	// logic control
	// two-way binding
	// event handling
	// attributes
	// ref & el
	// cloak
	// must export plain object
	var directives = {
	  text: text$1,
	  html: html,
	  'for': vFor,
	  'if': vIf,
	  show: show,
	  model: model,
	  on: on$1,
	  bind: bind$1,
	  el: el,
	  ref: ref,
	  cloak: cloak
	};
	
	var vClass = {
	
	  deep: true,
	
	  update: function update(value) {
	    if (!value) {
	      this.cleanup();
	    } else if (typeof value === 'string') {
	      this.setClass(value.trim().split(/\s+/));
	    } else {
	      this.setClass(normalize$1(value));
	    }
	  },
	
	  setClass: function setClass(value) {
	    this.cleanup(value);
	    for (var i = 0, l = value.length; i < l; i++) {
	      var val = value[i];
	      if (val) {
	        apply(this.el, val, addClass);
	      }
	    }
	    this.prevKeys = value;
	  },
	
	  cleanup: function cleanup(value) {
	    var prevKeys = this.prevKeys;
	    if (!prevKeys) return;
	    var i = prevKeys.length;
	    while (i--) {
	      var key = prevKeys[i];
	      if (!value || value.indexOf(key) < 0) {
	        apply(this.el, key, removeClass);
	      }
	    }
	  }
	};
	
	/**
	 * Normalize objects and arrays (potentially containing objects)
	 * into array of strings.
	 *
	 * @param {Object|Array<String|Object>} value
	 * @return {Array<String>}
	 */
	
	function normalize$1(value) {
	  var res = [];
	  if (isArray(value)) {
	    for (var i = 0, l = value.length; i < l; i++) {
	      var _key = value[i];
	      if (_key) {
	        if (typeof _key === 'string') {
	          res.push(_key);
	        } else {
	          for (var k in _key) {
	            if (_key[k]) res.push(k);
	          }
	        }
	      }
	    }
	  } else if (isObject(value)) {
	    for (var key in value) {
	      if (value[key]) res.push(key);
	    }
	  }
	  return res;
	}
	
	/**
	 * Add or remove a class/classes on an element
	 *
	 * @param {Element} el
	 * @param {String} key The class name. This may or may not
	 *                     contain a space character, in such a
	 *                     case we'll deal with multiple class
	 *                     names at once.
	 * @param {Function} fn
	 */
	
	function apply(el, key, fn) {
	  key = key.trim();
	  if (key.indexOf(' ') === -1) {
	    fn(el, key);
	    return;
	  }
	  // The key contains one or more space characters.
	  // Since a class name doesn't accept such characters, we
	  // treat it as multiple classes.
	  var keys = key.split(/\s+/);
	  for (var i = 0, l = keys.length; i < l; i++) {
	    fn(el, keys[i]);
	  }
	}
	
	var component = {
	
	  priority: COMPONENT,
	
	  params: ['keep-alive', 'transition-mode', 'inline-template'],
	
	  /**
	   * Setup. Two possible usages:
	   *
	   * - static:
	   *   <comp> or <div v-component="comp">
	   *
	   * - dynamic:
	   *   <component :is="view">
	   */
	
	  bind: function bind() {
	    if (!this.el.__vue__) {
	      // keep-alive cache
	      this.keepAlive = this.params.keepAlive;
	      if (this.keepAlive) {
	        this.cache = {};
	      }
	      // check inline-template
	      if (this.params.inlineTemplate) {
	        // extract inline template as a DocumentFragment
	        this.inlineTemplate = extractContent(this.el, true);
	      }
	      // component resolution related state
	      this.pendingComponentCb = this.Component = null;
	      // transition related state
	      this.pendingRemovals = 0;
	      this.pendingRemovalCb = null;
	      // create a ref anchor
	      this.anchor = createAnchor('v-component');
	      replace(this.el, this.anchor);
	      // remove is attribute.
	      // this is removed during compilation, but because compilation is
	      // cached, when the component is used elsewhere this attribute
	      // will remain at link time.
	      this.el.removeAttribute('is');
	      this.el.removeAttribute(':is');
	      // remove ref, same as above
	      if (this.descriptor.ref) {
	        this.el.removeAttribute('v-ref:' + hyphenate(this.descriptor.ref));
	      }
	      // if static, build right now.
	      if (this.literal) {
	        this.setComponent(this.expression);
	      }
	    } else {
	      ("production") !== 'production' && warn('cannot mount component "' + this.expression + '" ' + 'on already mounted element: ' + this.el);
	    }
	  },
	
	  /**
	   * Public update, called by the watcher in the dynamic
	   * literal scenario, e.g. <component :is="view">
	   */
	
	  update: function update(value) {
	    if (!this.literal) {
	      this.setComponent(value);
	    }
	  },
	
	  /**
	   * Switch dynamic components. May resolve the component
	   * asynchronously, and perform transition based on
	   * specified transition mode. Accepts a few additional
	   * arguments specifically for vue-router.
	   *
	   * The callback is called when the full transition is
	   * finished.
	   *
	   * @param {String} value
	   * @param {Function} [cb]
	   */
	
	  setComponent: function setComponent(value, cb) {
	    this.invalidatePending();
	    if (!value) {
	      // just remove current
	      this.unbuild(true);
	      this.remove(this.childVM, cb);
	      this.childVM = null;
	    } else {
	      var self = this;
	      this.resolveComponent(value, function () {
	        self.mountComponent(cb);
	      });
	    }
	  },
	
	  /**
	   * Resolve the component constructor to use when creating
	   * the child vm.
	   *
	   * @param {String|Function} value
	   * @param {Function} cb
	   */
	
	  resolveComponent: function resolveComponent(value, cb) {
	    var self = this;
	    this.pendingComponentCb = cancellable(function (Component) {
	      self.ComponentName = Component.options.name || (typeof value === 'string' ? value : null);
	      self.Component = Component;
	      cb();
	    });
	    this.vm._resolveComponent(value, this.pendingComponentCb);
	  },
	
	  /**
	   * Create a new instance using the current constructor and
	   * replace the existing instance. This method doesn't care
	   * whether the new component and the old one are actually
	   * the same.
	   *
	   * @param {Function} [cb]
	   */
	
	  mountComponent: function mountComponent(cb) {
	    // actual mount
	    this.unbuild(true);
	    var self = this;
	    var activateHooks = this.Component.options.activate;
	    var cached = this.getCached();
	    var newComponent = this.build();
	    if (activateHooks && !cached) {
	      this.waitingFor = newComponent;
	      callActivateHooks(activateHooks, newComponent, function () {
	        if (self.waitingFor !== newComponent) {
	          return;
	        }
	        self.waitingFor = null;
	        self.transition(newComponent, cb);
	      });
	    } else {
	      // update ref for kept-alive component
	      if (cached) {
	        newComponent._updateRef();
	      }
	      this.transition(newComponent, cb);
	    }
	  },
	
	  /**
	   * When the component changes or unbinds before an async
	   * constructor is resolved, we need to invalidate its
	   * pending callback.
	   */
	
	  invalidatePending: function invalidatePending() {
	    if (this.pendingComponentCb) {
	      this.pendingComponentCb.cancel();
	      this.pendingComponentCb = null;
	    }
	  },
	
	  /**
	   * Instantiate/insert a new child vm.
	   * If keep alive and has cached instance, insert that
	   * instance; otherwise build a new one and cache it.
	   *
	   * @param {Object} [extraOptions]
	   * @return {Vue} - the created instance
	   */
	
	  build: function build(extraOptions) {
	    var cached = this.getCached();
	    if (cached) {
	      return cached;
	    }
	    if (this.Component) {
	      // default options
	      var options = {
	        name: this.ComponentName,
	        el: cloneNode(this.el),
	        template: this.inlineTemplate,
	        // make sure to add the child with correct parent
	        // if this is a transcluded component, its parent
	        // should be the transclusion host.
	        parent: this._host || this.vm,
	        // if no inline-template, then the compiled
	        // linker can be cached for better performance.
	        _linkerCachable: !this.inlineTemplate,
	        _ref: this.descriptor.ref,
	        _asComponent: true,
	        _isRouterView: this._isRouterView,
	        // if this is a transcluded component, context
	        // will be the common parent vm of this instance
	        // and its host.
	        _context: this.vm,
	        // if this is inside an inline v-for, the scope
	        // will be the intermediate scope created for this
	        // repeat fragment. this is used for linking props
	        // and container directives.
	        _scope: this._scope,
	        // pass in the owner fragment of this component.
	        // this is necessary so that the fragment can keep
	        // track of its contained components in order to
	        // call attach/detach hooks for them.
	        _frag: this._frag
	      };
	      // extra options
	      // in 1.0.0 this is used by vue-router only
	      /* istanbul ignore if */
	      if (extraOptions) {
	        extend(options, extraOptions);
	      }
	      var child = new this.Component(options);
	      if (this.keepAlive) {
	        this.cache[this.Component.cid] = child;
	      }
	      /* istanbul ignore if */
	      if (false) {
	        warn('Transitions will not work on a fragment instance. ' + 'Template: ' + child.$options.template, child);
	      }
	      return child;
	    }
	  },
	
	  /**
	   * Try to get a cached instance of the current component.
	   *
	   * @return {Vue|undefined}
	   */
	
	  getCached: function getCached() {
	    return this.keepAlive && this.cache[this.Component.cid];
	  },
	
	  /**
	   * Teardown the current child, but defers cleanup so
	   * that we can separate the destroy and removal steps.
	   *
	   * @param {Boolean} defer
	   */
	
	  unbuild: function unbuild(defer) {
	    if (this.waitingFor) {
	      if (!this.keepAlive) {
	        this.waitingFor.$destroy();
	      }
	      this.waitingFor = null;
	    }
	    var child = this.childVM;
	    if (!child || this.keepAlive) {
	      if (child) {
	        // remove ref
	        child._inactive = true;
	        child._updateRef(true);
	      }
	      return;
	    }
	    // the sole purpose of `deferCleanup` is so that we can
	    // "deactivate" the vm right now and perform DOM removal
	    // later.
	    child.$destroy(false, defer);
	  },
	
	  /**
	   * Remove current destroyed child and manually do
	   * the cleanup after removal.
	   *
	   * @param {Function} cb
	   */
	
	  remove: function remove(child, cb) {
	    var keepAlive = this.keepAlive;
	    if (child) {
	      // we may have a component switch when a previous
	      // component is still being transitioned out.
	      // we want to trigger only one lastest insertion cb
	      // when the existing transition finishes. (#1119)
	      this.pendingRemovals++;
	      this.pendingRemovalCb = cb;
	      var self = this;
	      child.$remove(function () {
	        self.pendingRemovals--;
	        if (!keepAlive) child._cleanup();
	        if (!self.pendingRemovals && self.pendingRemovalCb) {
	          self.pendingRemovalCb();
	          self.pendingRemovalCb = null;
	        }
	      });
	    } else if (cb) {
	      cb();
	    }
	  },
	
	  /**
	   * Actually swap the components, depending on the
	   * transition mode. Defaults to simultaneous.
	   *
	   * @param {Vue} target
	   * @param {Function} [cb]
	   */
	
	  transition: function transition(target, cb) {
	    var self = this;
	    var current = this.childVM;
	    // for devtool inspection
	    if (current) current._inactive = true;
	    target._inactive = false;
	    this.childVM = target;
	    switch (self.params.transitionMode) {
	      case 'in-out':
	        target.$before(self.anchor, function () {
	          self.remove(current, cb);
	        });
	        break;
	      case 'out-in':
	        self.remove(current, function () {
	          target.$before(self.anchor, cb);
	        });
	        break;
	      default:
	        self.remove(current);
	        target.$before(self.anchor, cb);
	    }
	  },
	
	  /**
	   * Unbind.
	   */
	
	  unbind: function unbind() {
	    this.invalidatePending();
	    // Do not defer cleanup when unbinding
	    this.unbuild();
	    // destroy all keep-alive cached instances
	    if (this.cache) {
	      for (var key in this.cache) {
	        this.cache[key].$destroy();
	      }
	      this.cache = null;
	    }
	  }
	};
	
	/**
	 * Call activate hooks in order (asynchronous)
	 *
	 * @param {Array} hooks
	 * @param {Vue} vm
	 * @param {Function} cb
	 */
	
	function callActivateHooks(hooks, vm, cb) {
	  var total = hooks.length;
	  var called = 0;
	  hooks[0].call(vm, next);
	  function next() {
	    if (++called >= total) {
	      cb();
	    } else {
	      hooks[called].call(vm, next);
	    }
	  }
	}
	
	var propBindingModes = config._propBindingModes;
	var empty = {};
	
	// regexes
	var identRE$1 = /^[$_a-zA-Z]+[\w$]*$/;
	var settablePathRE = /^[A-Za-z_$][\w$]*(\.[A-Za-z_$][\w$]*|\[[^\[\]]+\])*$/;
	
	/**
	 * Compile props on a root element and return
	 * a props link function.
	 *
	 * @param {Element|DocumentFragment} el
	 * @param {Array} propOptions
	 * @param {Vue} vm
	 * @return {Function} propsLinkFn
	 */
	
	function compileProps(el, propOptions, vm) {
	  var props = [];
	  var propsData = vm.$options.propsData;
	  var names = Object.keys(propOptions);
	  var i = names.length;
	  var options, name, attr, value, path, parsed, prop;
	  while (i--) {
	    name = names[i];
	    options = propOptions[name] || empty;
	
	    if (false) {
	      warn('Do not use $data as prop.', vm);
	      continue;
	    }
	
	    // props could contain dashes, which will be
	    // interpreted as minus calculations by the parser
	    // so we need to camelize the path here
	    path = camelize(name);
	    if (!identRE$1.test(path)) {
	      ("production") !== 'production' && warn('Invalid prop key: "' + name + '". Prop keys ' + 'must be valid identifiers.', vm);
	      continue;
	    }
	
	    prop = {
	      name: name,
	      path: path,
	      options: options,
	      mode: propBindingModes.ONE_WAY,
	      raw: null
	    };
	
	    attr = hyphenate(name);
	    // first check dynamic version
	    if ((value = getBindAttr(el, attr)) === null) {
	      if ((value = getBindAttr(el, attr + '.sync')) !== null) {
	        prop.mode = propBindingModes.TWO_WAY;
	      } else if ((value = getBindAttr(el, attr + '.once')) !== null) {
	        prop.mode = propBindingModes.ONE_TIME;
	      }
	    }
	    if (value !== null) {
	      // has dynamic binding!
	      prop.raw = value;
	      parsed = parseDirective(value);
	      value = parsed.expression;
	      prop.filters = parsed.filters;
	      // check binding type
	      if (isLiteral(value) && !parsed.filters) {
	        // for expressions containing literal numbers and
	        // booleans, there's no need to setup a prop binding,
	        // so we can optimize them as a one-time set.
	        prop.optimizedLiteral = true;
	      } else {
	        prop.dynamic = true;
	        // check non-settable path for two-way bindings
	        if (false) {
	          prop.mode = propBindingModes.ONE_WAY;
	          warn('Cannot bind two-way prop with non-settable ' + 'parent path: ' + value, vm);
	        }
	      }
	      prop.parentPath = value;
	
	      // warn required two-way
	      if (false) {
	        warn('Prop "' + name + '" expects a two-way binding type.', vm);
	      }
	    } else if ((value = getAttr(el, attr)) !== null) {
	      // has literal binding!
	      prop.raw = value;
	    } else if (propsData && (value = propsData[name] || propsData[path]) !== null) {
	      // has propsData
	      prop.raw = value;
	    } else if (false) {
	      // check possible camelCase prop usage
	      var lowerCaseName = path.toLowerCase();
	      value = /[A-Z\-]/.test(name) && (el.getAttribute(lowerCaseName) || el.getAttribute(':' + lowerCaseName) || el.getAttribute('v-bind:' + lowerCaseName) || el.getAttribute(':' + lowerCaseName + '.once') || el.getAttribute('v-bind:' + lowerCaseName + '.once') || el.getAttribute(':' + lowerCaseName + '.sync') || el.getAttribute('v-bind:' + lowerCaseName + '.sync'));
	      if (value) {
	        warn('Possible usage error for prop `' + lowerCaseName + '` - ' + 'did you mean `' + attr + '`? HTML is case-insensitive, remember to use ' + 'kebab-case for props in templates.', vm);
	      } else if (options.required && (!propsData || !(name in propsData) && !(path in propsData))) {
	        // warn missing required
	        warn('Missing required prop: ' + name, vm);
	      }
	    }
	    // push prop
	    props.push(prop);
	  }
	  return makePropsLinkFn(props);
	}
	
	/**
	 * Build a function that applies props to a vm.
	 *
	 * @param {Array} props
	 * @return {Function} propsLinkFn
	 */
	
	function makePropsLinkFn(props) {
	  return function propsLinkFn(vm, scope) {
	    // store resolved props info
	    vm._props = {};
	    var inlineProps = vm.$options.propsData;
	    var i = props.length;
	    var prop, path, options, value, raw;
	    while (i--) {
	      prop = props[i];
	      raw = prop.raw;
	      path = prop.path;
	      options = prop.options;
	      vm._props[path] = prop;
	      if (inlineProps && hasOwn(inlineProps, path)) {
	        initProp(vm, prop, inlineProps[path]);
	      }if (raw === null) {
	        // initialize absent prop
	        initProp(vm, prop, undefined);
	      } else if (prop.dynamic) {
	        // dynamic prop
	        if (prop.mode === propBindingModes.ONE_TIME) {
	          // one time binding
	          value = (scope || vm._context || vm).$get(prop.parentPath);
	          initProp(vm, prop, value);
	        } else {
	          if (vm._context) {
	            // dynamic binding
	            vm._bindDir({
	              name: 'prop',
	              def: propDef,
	              prop: prop
	            }, null, null, scope); // el, host, scope
	          } else {
	              // root instance
	              initProp(vm, prop, vm.$get(prop.parentPath));
	            }
	        }
	      } else if (prop.optimizedLiteral) {
	        // optimized literal, cast it and just set once
	        var stripped = stripQuotes(raw);
	        value = stripped === raw ? toBoolean(toNumber(raw)) : stripped;
	        initProp(vm, prop, value);
	      } else {
	        // string literal, but we need to cater for
	        // Boolean props with no value, or with same
	        // literal value (e.g. disabled="disabled")
	        // see https://github.com/vuejs/vue-loader/issues/182
	        value = options.type === Boolean && (raw === '' || raw === hyphenate(prop.name)) ? true : raw;
	        initProp(vm, prop, value);
	      }
	    }
	  };
	}
	
	/**
	 * Process a prop with a rawValue, applying necessary coersions,
	 * default values & assertions and call the given callback with
	 * processed value.
	 *
	 * @param {Vue} vm
	 * @param {Object} prop
	 * @param {*} rawValue
	 * @param {Function} fn
	 */
	
	function processPropValue(vm, prop, rawValue, fn) {
	  var isSimple = prop.dynamic && isSimplePath(prop.parentPath);
	  var value = rawValue;
	  if (value === undefined) {
	    value = getPropDefaultValue(vm, prop);
	  }
	  value = coerceProp(prop, value, vm);
	  var coerced = value !== rawValue;
	  if (!assertProp(prop, value, vm)) {
	    value = undefined;
	  }
	  if (isSimple && !coerced) {
	    withoutConversion(function () {
	      fn(value);
	    });
	  } else {
	    fn(value);
	  }
	}
	
	/**
	 * Set a prop's initial value on a vm and its data object.
	 *
	 * @param {Vue} vm
	 * @param {Object} prop
	 * @param {*} value
	 */
	
	function initProp(vm, prop, value) {
	  processPropValue(vm, prop, value, function (value) {
	    defineReactive(vm, prop.path, value);
	  });
	}
	
	/**
	 * Update a prop's value on a vm.
	 *
	 * @param {Vue} vm
	 * @param {Object} prop
	 * @param {*} value
	 */
	
	function updateProp(vm, prop, value) {
	  processPropValue(vm, prop, value, function (value) {
	    vm[prop.path] = value;
	  });
	}
	
	/**
	 * Get the default value of a prop.
	 *
	 * @param {Vue} vm
	 * @param {Object} prop
	 * @return {*}
	 */
	
	function getPropDefaultValue(vm, prop) {
	  // no default, return undefined
	  var options = prop.options;
	  if (!hasOwn(options, 'default')) {
	    // absent boolean value defaults to false
	    return options.type === Boolean ? false : undefined;
	  }
	  var def = options['default'];
	  // warn against non-factory defaults for Object & Array
	  if (isObject(def)) {
	    ("production") !== 'production' && warn('Invalid default value for prop "' + prop.name + '": ' + 'Props with type Object/Array must use a factory function ' + 'to return the default value.', vm);
	  }
	  // call factory function for non-Function types
	  return typeof def === 'function' && options.type !== Function ? def.call(vm) : def;
	}
	
	/**
	 * Assert whether a prop is valid.
	 *
	 * @param {Object} prop
	 * @param {*} value
	 * @param {Vue} vm
	 */
	
	function assertProp(prop, value, vm) {
	  if (!prop.options.required && ( // non-required
	  prop.raw === null || // abscent
	  value == null) // null or undefined
	  ) {
	      return true;
	    }
	  var options = prop.options;
	  var type = options.type;
	  var valid = !type;
	  var expectedTypes = [];
	  if (type) {
	    if (!isArray(type)) {
	      type = [type];
	    }
	    for (var i = 0; i < type.length && !valid; i++) {
	      var assertedType = assertType(value, type[i]);
	      expectedTypes.push(assertedType.expectedType);
	      valid = assertedType.valid;
	    }
	  }
	  if (!valid) {
	    if (false) {
	      warn('Invalid prop: type check failed for prop "' + prop.name + '".' + ' Expected ' + expectedTypes.map(formatType).join(', ') + ', got ' + formatValue(value) + '.', vm);
	    }
	    return false;
	  }
	  var validator = options.validator;
	  if (validator) {
	    if (!validator(value)) {
	      ("production") !== 'production' && warn('Invalid prop: custom validator check failed for prop "' + prop.name + '".', vm);
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * Force parsing value with coerce option.
	 *
	 * @param {*} value
	 * @param {Object} options
	 * @return {*}
	 */
	
	function coerceProp(prop, value, vm) {
	  var coerce = prop.options.coerce;
	  if (!coerce) {
	    return value;
	  }
	  if (typeof coerce === 'function') {
	    return coerce(value);
	  } else {
	    ("production") !== 'production' && warn('Invalid coerce for prop "' + prop.name + '": expected function, got ' + typeof coerce + '.', vm);
	    return value;
	  }
	}
	
	/**
	 * Assert the type of a value
	 *
	 * @param {*} value
	 * @param {Function} type
	 * @return {Object}
	 */
	
	function assertType(value, type) {
	  var valid;
	  var expectedType;
	  if (type === String) {
	    expectedType = 'string';
	    valid = typeof value === expectedType;
	  } else if (type === Number) {
	    expectedType = 'number';
	    valid = typeof value === expectedType;
	  } else if (type === Boolean) {
	    expectedType = 'boolean';
	    valid = typeof value === expectedType;
	  } else if (type === Function) {
	    expectedType = 'function';
	    valid = typeof value === expectedType;
	  } else if (type === Object) {
	    expectedType = 'object';
	    valid = isPlainObject(value);
	  } else if (type === Array) {
	    expectedType = 'array';
	    valid = isArray(value);
	  } else {
	    valid = value instanceof type;
	  }
	  return {
	    valid: valid,
	    expectedType: expectedType
	  };
	}
	
	/**
	 * Format type for output
	 *
	 * @param {String} type
	 * @return {String}
	 */
	
	function formatType(type) {
	  return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'custom type';
	}
	
	/**
	 * Format value
	 *
	 * @param {*} value
	 * @return {String}
	 */
	
	function formatValue(val) {
	  return Object.prototype.toString.call(val).slice(8, -1);
	}
	
	var bindingModes = config._propBindingModes;
	
	var propDef = {
	
	  bind: function bind() {
	    var child = this.vm;
	    var parent = child._context;
	    // passed in from compiler directly
	    var prop = this.descriptor.prop;
	    var childKey = prop.path;
	    var parentKey = prop.parentPath;
	    var twoWay = prop.mode === bindingModes.TWO_WAY;
	
	    var parentWatcher = this.parentWatcher = new Watcher(parent, parentKey, function (val) {
	      updateProp(child, prop, val);
	    }, {
	      twoWay: twoWay,
	      filters: prop.filters,
	      // important: props need to be observed on the
	      // v-for scope if present
	      scope: this._scope
	    });
	
	    // set the child initial value.
	    initProp(child, prop, parentWatcher.value);
	
	    // setup two-way binding
	    if (twoWay) {
	      // important: defer the child watcher creation until
	      // the created hook (after data observation)
	      var self = this;
	      child.$once('pre-hook:created', function () {
	        self.childWatcher = new Watcher(child, childKey, function (val) {
	          parentWatcher.set(val);
	        }, {
	          // ensure sync upward before parent sync down.
	          // this is necessary in cases e.g. the child
	          // mutates a prop array, then replaces it. (#1683)
	          sync: true
	        });
	      });
	    }
	  },
	
	  unbind: function unbind() {
	    this.parentWatcher.teardown();
	    if (this.childWatcher) {
	      this.childWatcher.teardown();
	    }
	  }
	};
	
	var queue$1 = [];
	var queued = false;
	
	/**
	 * Push a job into the queue.
	 *
	 * @param {Function} job
	 */
	
	function pushJob(job) {
	  queue$1.push(job);
	  if (!queued) {
	    queued = true;
	    nextTick(flush);
	  }
	}
	
	/**
	 * Flush the queue, and do one forced reflow before
	 * triggering transitions.
	 */
	
	function flush() {
	  // Force layout
	  var f = document.documentElement.offsetHeight;
	  for (var i = 0; i < queue$1.length; i++) {
	    queue$1[i]();
	  }
	  queue$1 = [];
	  queued = false;
	  // dummy return, so js linters don't complain about
	  // unused variable f
	  return f;
	}
	
	var TYPE_TRANSITION = 'transition';
	var TYPE_ANIMATION = 'animation';
	var transDurationProp = transitionProp + 'Duration';
	var animDurationProp = animationProp + 'Duration';
	
	/**
	 * If a just-entered element is applied the
	 * leave class while its enter transition hasn't started yet,
	 * and the transitioned property has the same value for both
	 * enter/leave, then the leave transition will be skipped and
	 * the transitionend event never fires. This function ensures
	 * its callback to be called after a transition has started
	 * by waiting for double raf.
	 *
	 * It falls back to setTimeout on devices that support CSS
	 * transitions but not raf (e.g. Android 4.2 browser) - since
	 * these environments are usually slow, we are giving it a
	 * relatively large timeout.
	 */
	
	var raf = inBrowser && window.requestAnimationFrame;
	var waitForTransitionStart = raf
	/* istanbul ignore next */
	? function (fn) {
	  raf(function () {
	    raf(fn);
	  });
	} : function (fn) {
	  setTimeout(fn, 50);
	};
	
	/**
	 * A Transition object that encapsulates the state and logic
	 * of the transition.
	 *
	 * @param {Element} el
	 * @param {String} id
	 * @param {Object} hooks
	 * @param {Vue} vm
	 */
	function Transition(el, id, hooks, vm) {
	  this.id = id;
	  this.el = el;
	  this.enterClass = hooks && hooks.enterClass || id + '-enter';
	  this.leaveClass = hooks && hooks.leaveClass || id + '-leave';
	  this.hooks = hooks;
	  this.vm = vm;
	  // async state
	  this.pendingCssEvent = this.pendingCssCb = this.cancel = this.pendingJsCb = this.op = this.cb = null;
	  this.justEntered = false;
	  this.entered = this.left = false;
	  this.typeCache = {};
	  // check css transition type
	  this.type = hooks && hooks.type;
	  /* istanbul ignore if */
	  if (false) {
	    if (this.type && this.type !== TYPE_TRANSITION && this.type !== TYPE_ANIMATION) {
	      warn('invalid CSS transition type for transition="' + this.id + '": ' + this.type, vm);
	    }
	  }
	  // bind
	  var self = this;['enterNextTick', 'enterDone', 'leaveNextTick', 'leaveDone'].forEach(function (m) {
	    self[m] = bind(self[m], self);
	  });
	}
	
	var p$1 = Transition.prototype;
	
	/**
	 * Start an entering transition.
	 *
	 * 1. enter transition triggered
	 * 2. call beforeEnter hook
	 * 3. add enter class
	 * 4. insert/show element
	 * 5. call enter hook (with possible explicit js callback)
	 * 6. reflow
	 * 7. based on transition type:
	 *    - transition:
	 *        remove class now, wait for transitionend,
	 *        then done if there's no explicit js callback.
	 *    - animation:
	 *        wait for animationend, remove class,
	 *        then done if there's no explicit js callback.
	 *    - no css transition:
	 *        done now if there's no explicit js callback.
	 * 8. wait for either done or js callback, then call
	 *    afterEnter hook.
	 *
	 * @param {Function} op - insert/show the element
	 * @param {Function} [cb]
	 */
	
	p$1.enter = function (op, cb) {
	  this.cancelPending();
	  this.callHook('beforeEnter');
	  this.cb = cb;
	  addClass(this.el, this.enterClass);
	  op();
	  this.entered = false;
	  this.callHookWithCb('enter');
	  if (this.entered) {
	    return; // user called done synchronously.
	  }
	  this.cancel = this.hooks && this.hooks.enterCancelled;
	  pushJob(this.enterNextTick);
	};
	
	/**
	 * The "nextTick" phase of an entering transition, which is
	 * to be pushed into a queue and executed after a reflow so
	 * that removing the class can trigger a CSS transition.
	 */
	
	p$1.enterNextTick = function () {
	  var _this = this;
	
	  // prevent transition skipping
	  this.justEntered = true;
	  waitForTransitionStart(function () {
	    _this.justEntered = false;
	  });
	  var enterDone = this.enterDone;
	  var type = this.getCssTransitionType(this.enterClass);
	  if (!this.pendingJsCb) {
	    if (type === TYPE_TRANSITION) {
	      // trigger transition by removing enter class now
	      removeClass(this.el, this.enterClass);
	      this.setupCssCb(transitionEndEvent, enterDone);
	    } else if (type === TYPE_ANIMATION) {
	      this.setupCssCb(animationEndEvent, enterDone);
	    } else {
	      enterDone();
	    }
	  } else if (type === TYPE_TRANSITION) {
	    removeClass(this.el, this.enterClass);
	  }
	};
	
	/**
	 * The "cleanup" phase of an entering transition.
	 */
	
	p$1.enterDone = function () {
	  this.entered = true;
	  this.cancel = this.pendingJsCb = null;
	  removeClass(this.el, this.enterClass);
	  this.callHook('afterEnter');
	  if (this.cb) this.cb();
	};
	
	/**
	 * Start a leaving transition.
	 *
	 * 1. leave transition triggered.
	 * 2. call beforeLeave hook
	 * 3. add leave class (trigger css transition)
	 * 4. call leave hook (with possible explicit js callback)
	 * 5. reflow if no explicit js callback is provided
	 * 6. based on transition type:
	 *    - transition or animation:
	 *        wait for end event, remove class, then done if
	 *        there's no explicit js callback.
	 *    - no css transition:
	 *        done if there's no explicit js callback.
	 * 7. wait for either done or js callback, then call
	 *    afterLeave hook.
	 *
	 * @param {Function} op - remove/hide the element
	 * @param {Function} [cb]
	 */
	
	p$1.leave = function (op, cb) {
	  this.cancelPending();
	  this.callHook('beforeLeave');
	  this.op = op;
	  this.cb = cb;
	  addClass(this.el, this.leaveClass);
	  this.left = false;
	  this.callHookWithCb('leave');
	  if (this.left) {
	    return; // user called done synchronously.
	  }
	  this.cancel = this.hooks && this.hooks.leaveCancelled;
	  // only need to handle leaveDone if
	  // 1. the transition is already done (synchronously called
	  //    by the user, which causes this.op set to null)
	  // 2. there's no explicit js callback
	  if (this.op && !this.pendingJsCb) {
	    // if a CSS transition leaves immediately after enter,
	    // the transitionend event never fires. therefore we
	    // detect such cases and end the leave immediately.
	    if (this.justEntered) {
	      this.leaveDone();
	    } else {
	      pushJob(this.leaveNextTick);
	    }
	  }
	};
	
	/**
	 * The "nextTick" phase of a leaving transition.
	 */
	
	p$1.leaveNextTick = function () {
	  var type = this.getCssTransitionType(this.leaveClass);
	  if (type) {
	    var event = type === TYPE_TRANSITION ? transitionEndEvent : animationEndEvent;
	    this.setupCssCb(event, this.leaveDone);
	  } else {
	    this.leaveDone();
	  }
	};
	
	/**
	 * The "cleanup" phase of a leaving transition.
	 */
	
	p$1.leaveDone = function () {
	  this.left = true;
	  this.cancel = this.pendingJsCb = null;
	  this.op();
	  removeClass(this.el, this.leaveClass);
	  this.callHook('afterLeave');
	  if (this.cb) this.cb();
	  this.op = null;
	};
	
	/**
	 * Cancel any pending callbacks from a previously running
	 * but not finished transition.
	 */
	
	p$1.cancelPending = function () {
	  this.op = this.cb = null;
	  var hasPending = false;
	  if (this.pendingCssCb) {
	    hasPending = true;
	    off(this.el, this.pendingCssEvent, this.pendingCssCb);
	    this.pendingCssEvent = this.pendingCssCb = null;
	  }
	  if (this.pendingJsCb) {
	    hasPending = true;
	    this.pendingJsCb.cancel();
	    this.pendingJsCb = null;
	  }
	  if (hasPending) {
	    removeClass(this.el, this.enterClass);
	    removeClass(this.el, this.leaveClass);
	  }
	  if (this.cancel) {
	    this.cancel.call(this.vm, this.el);
	    this.cancel = null;
	  }
	};
	
	/**
	 * Call a user-provided synchronous hook function.
	 *
	 * @param {String} type
	 */
	
	p$1.callHook = function (type) {
	  if (this.hooks && this.hooks[type]) {
	    this.hooks[type].call(this.vm, this.el);
	  }
	};
	
	/**
	 * Call a user-provided, potentially-async hook function.
	 * We check for the length of arguments to see if the hook
	 * expects a `done` callback. If true, the transition's end
	 * will be determined by when the user calls that callback;
	 * otherwise, the end is determined by the CSS transition or
	 * animation.
	 *
	 * @param {String} type
	 */
	
	p$1.callHookWithCb = function (type) {
	  var hook = this.hooks && this.hooks[type];
	  if (hook) {
	    if (hook.length > 1) {
	      this.pendingJsCb = cancellable(this[type + 'Done']);
	    }
	    hook.call(this.vm, this.el, this.pendingJsCb);
	  }
	};
	
	/**
	 * Get an element's transition type based on the
	 * calculated styles.
	 *
	 * @param {String} className
	 * @return {Number}
	 */
	
	p$1.getCssTransitionType = function (className) {
	  /* istanbul ignore if */
	  if (!transitionEndEvent ||
	  // skip CSS transitions if page is not visible -
	  // this solves the issue of transitionend events not
	  // firing until the page is visible again.
	  // pageVisibility API is supported in IE10+, same as
	  // CSS transitions.
	  document.hidden ||
	  // explicit js-only transition
	  this.hooks && this.hooks.css === false ||
	  // element is hidden
	  isHidden(this.el)) {
	    return;
	  }
	  var type = this.type || this.typeCache[className];
	  if (type) return type;
	  var inlineStyles = this.el.style;
	  var computedStyles = window.getComputedStyle(this.el);
	  var transDuration = inlineStyles[transDurationProp] || computedStyles[transDurationProp];
	  if (transDuration && transDuration !== '0s') {
	    type = TYPE_TRANSITION;
	  } else {
	    var animDuration = inlineStyles[animDurationProp] || computedStyles[animDurationProp];
	    if (animDuration && animDuration !== '0s') {
	      type = TYPE_ANIMATION;
	    }
	  }
	  if (type) {
	    this.typeCache[className] = type;
	  }
	  return type;
	};
	
	/**
	 * Setup a CSS transitionend/animationend callback.
	 *
	 * @param {String} event
	 * @param {Function} cb
	 */
	
	p$1.setupCssCb = function (event, cb) {
	  this.pendingCssEvent = event;
	  var self = this;
	  var el = this.el;
	  var onEnd = this.pendingCssCb = function (e) {
	    if (e.target === el) {
	      off(el, event, onEnd);
	      self.pendingCssEvent = self.pendingCssCb = null;
	      if (!self.pendingJsCb && cb) {
	        cb();
	      }
	    }
	  };
	  on(el, event, onEnd);
	};
	
	/**
	 * Check if an element is hidden - in that case we can just
	 * skip the transition alltogether.
	 *
	 * @param {Element} el
	 * @return {Boolean}
	 */
	
	function isHidden(el) {
	  if (/svg$/.test(el.namespaceURI)) {
	    // SVG elements do not have offset(Width|Height)
	    // so we need to check the client rect
	    var rect = el.getBoundingClientRect();
	    return !(rect.width || rect.height);
	  } else {
	    return !(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
	  }
	}
	
	var transition$1 = {
	
	  priority: TRANSITION,
	
	  update: function update(id, oldId) {
	    var el = this.el;
	    // resolve on owner vm
	    var hooks = resolveAsset(this.vm.$options, 'transitions', id);
	    id = id || 'v';
	    oldId = oldId || 'v';
	    el.__v_trans = new Transition(el, id, hooks, this.vm);
	    removeClass(el, oldId + '-transition');
	    addClass(el, id + '-transition');
	  }
	};
	
	var internalDirectives = {
	  style: style,
	  'class': vClass,
	  component: component,
	  prop: propDef,
	  transition: transition$1
	};
	
	// special binding prefixes
	var bindRE = /^v-bind:|^:/;
	var onRE = /^v-on:|^@/;
	var dirAttrRE = /^v-([^:]+)(?:$|:(.*)$)/;
	var modifierRE = /\.[^\.]+/g;
	var transitionRE = /^(v-bind:|:)?transition$/;
	
	// default directive priority
	var DEFAULT_PRIORITY = 1000;
	var DEFAULT_TERMINAL_PRIORITY = 2000;
	
	/**
	 * Compile a template and return a reusable composite link
	 * function, which recursively contains more link functions
	 * inside. This top level compile function would normally
	 * be called on instance root nodes, but can also be used
	 * for partial compilation if the partial argument is true.
	 *
	 * The returned composite link function, when called, will
	 * return an unlink function that tearsdown all directives
	 * created during the linking phase.
	 *
	 * @param {Element|DocumentFragment} el
	 * @param {Object} options
	 * @param {Boolean} partial
	 * @return {Function}
	 */
	
	function compile(el, options, partial) {
	  // link function for the node itself.
	  var nodeLinkFn = partial || !options._asComponent ? compileNode(el, options) : null;
	  // link function for the childNodes
	  var childLinkFn = !(nodeLinkFn && nodeLinkFn.terminal) && !isScript(el) && el.hasChildNodes() ? compileNodeList(el.childNodes, options) : null;
	
	  /**
	   * A composite linker function to be called on a already
	   * compiled piece of DOM, which instantiates all directive
	   * instances.
	   *
	   * @param {Vue} vm
	   * @param {Element|DocumentFragment} el
	   * @param {Vue} [host] - host vm of transcluded content
	   * @param {Object} [scope] - v-for scope
	   * @param {Fragment} [frag] - link context fragment
	   * @return {Function|undefined}
	   */
	
	  return function compositeLinkFn(vm, el, host, scope, frag) {
	    // cache childNodes before linking parent, fix #657
	    var childNodes = toArray(el.childNodes);
	    // link
	    var dirs = linkAndCapture(function compositeLinkCapturer() {
	      if (nodeLinkFn) nodeLinkFn(vm, el, host, scope, frag);
	      if (childLinkFn) childLinkFn(vm, childNodes, host, scope, frag);
	    }, vm);
	    return makeUnlinkFn(vm, dirs);
	  };
	}
	
	/**
	 * Apply a linker to a vm/element pair and capture the
	 * directives created during the process.
	 *
	 * @param {Function} linker
	 * @param {Vue} vm
	 */
	
	function linkAndCapture(linker, vm) {
	  /* istanbul ignore if */
	  if (true) {
	    // reset directives before every capture in production
	    // mode, so that when unlinking we don't need to splice
	    // them out (which turns out to be a perf hit).
	    // they are kept in development mode because they are
	    // useful for Vue's own tests.
	    vm._directives = [];
	  }
	  var originalDirCount = vm._directives.length;
	  linker();
	  var dirs = vm._directives.slice(originalDirCount);
	  sortDirectives(dirs);
	  for (var i = 0, l = dirs.length; i < l; i++) {
	    dirs[i]._bind();
	  }
	  return dirs;
	}
	
	/**
	 * sort directives by priority (stable sort)
	 *
	 * @param {Array} dirs
	 */
	function sortDirectives(dirs) {
	  if (dirs.length === 0) return;
	
	  var groupedMap = {};
	  var i, j, k, l;
	  var index = 0;
	  var priorities = [];
	  for (i = 0, j = dirs.length; i < j; i++) {
	    var dir = dirs[i];
	    var priority = dir.descriptor.def.priority || DEFAULT_PRIORITY;
	    var array = groupedMap[priority];
	    if (!array) {
	      array = groupedMap[priority] = [];
	      priorities.push(priority);
	    }
	    array.push(dir);
	  }
	
	  priorities.sort(function (a, b) {
	    return a > b ? -1 : a === b ? 0 : 1;
	  });
	  for (i = 0, j = priorities.length; i < j; i++) {
	    var group = groupedMap[priorities[i]];
	    for (k = 0, l = group.length; k < l; k++) {
	      dirs[index++] = group[k];
	    }
	  }
	}
	
	/**
	 * Linker functions return an unlink function that
	 * tearsdown all directives instances generated during
	 * the process.
	 *
	 * We create unlink functions with only the necessary
	 * information to avoid retaining additional closures.
	 *
	 * @param {Vue} vm
	 * @param {Array} dirs
	 * @param {Vue} [context]
	 * @param {Array} [contextDirs]
	 * @return {Function}
	 */
	
	function makeUnlinkFn(vm, dirs, context, contextDirs) {
	  function unlink(destroying) {
	    teardownDirs(vm, dirs, destroying);
	    if (context && contextDirs) {
	      teardownDirs(context, contextDirs);
	    }
	  }
	  // expose linked directives
	  unlink.dirs = dirs;
	  return unlink;
	}
	
	/**
	 * Teardown partial linked directives.
	 *
	 * @param {Vue} vm
	 * @param {Array} dirs
	 * @param {Boolean} destroying
	 */
	
	function teardownDirs(vm, dirs, destroying) {
	  var i = dirs.length;
	  while (i--) {
	    dirs[i]._teardown();
	    if (false) {
	      vm._directives.$remove(dirs[i]);
	    }
	  }
	}
	
	/**
	 * Compile link props on an instance.
	 *
	 * @param {Vue} vm
	 * @param {Element} el
	 * @param {Object} props
	 * @param {Object} [scope]
	 * @return {Function}
	 */
	
	function compileAndLinkProps(vm, el, props, scope) {
	  var propsLinkFn = compileProps(el, props, vm);
	  var propDirs = linkAndCapture(function () {
	    propsLinkFn(vm, scope);
	  }, vm);
	  return makeUnlinkFn(vm, propDirs);
	}
	
	/**
	 * Compile the root element of an instance.
	 *
	 * 1. attrs on context container (context scope)
	 * 2. attrs on the component template root node, if
	 *    replace:true (child scope)
	 *
	 * If this is a fragment instance, we only need to compile 1.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @param {Object} contextOptions
	 * @return {Function}
	 */
	
	function compileRoot(el, options, contextOptions) {
	  var containerAttrs = options._containerAttrs;
	  var replacerAttrs = options._replacerAttrs;
	  var contextLinkFn, replacerLinkFn;
	
	  // only need to compile other attributes for
	  // non-fragment instances
	  if (el.nodeType !== 11) {
	    // for components, container and replacer need to be
	    // compiled separately and linked in different scopes.
	    if (options._asComponent) {
	      // 2. container attributes
	      if (containerAttrs && contextOptions) {
	        contextLinkFn = compileDirectives(containerAttrs, contextOptions);
	      }
	      if (replacerAttrs) {
	        // 3. replacer attributes
	        replacerLinkFn = compileDirectives(replacerAttrs, options);
	      }
	    } else {
	      // non-component, just compile as a normal element.
	      replacerLinkFn = compileDirectives(el.attributes, options);
	    }
	  } else if (false) {
	    // warn container directives for fragment instances
	    var names = containerAttrs.filter(function (attr) {
	      // allow vue-loader/vueify scoped css attributes
	      return attr.name.indexOf('_v-') < 0 &&
	      // allow event listeners
	      !onRE.test(attr.name) &&
	      // allow slots
	      attr.name !== 'slot';
	    }).map(function (attr) {
	      return '"' + attr.name + '"';
	    });
	    if (names.length) {
	      var plural = names.length > 1;
	
	      var componentName = options.el.tagName.toLowerCase();
	      if (componentName === 'component' && options.name) {
	        componentName += ':' + options.name;
	      }
	
	      warn('Attribute' + (plural ? 's ' : ' ') + names.join(', ') + (plural ? ' are' : ' is') + ' ignored on component ' + '<' + componentName + '> because ' + 'the component is a fragment instance: ' + 'http://vuejs.org/guide/components.html#Fragment-Instance');
	    }
	  }
	
	  options._containerAttrs = options._replacerAttrs = null;
	  return function rootLinkFn(vm, el, scope) {
	    // link context scope dirs
	    var context = vm._context;
	    var contextDirs;
	    if (context && contextLinkFn) {
	      contextDirs = linkAndCapture(function () {
	        contextLinkFn(context, el, null, scope);
	      }, context);
	    }
	
	    // link self
	    var selfDirs = linkAndCapture(function () {
	      if (replacerLinkFn) replacerLinkFn(vm, el);
	    }, vm);
	
	    // return the unlink function that tearsdown context
	    // container directives.
	    return makeUnlinkFn(vm, selfDirs, context, contextDirs);
	  };
	}
	
	/**
	 * Compile a node and return a nodeLinkFn based on the
	 * node type.
	 *
	 * @param {Node} node
	 * @param {Object} options
	 * @return {Function|null}
	 */
	
	function compileNode(node, options) {
	  var type = node.nodeType;
	  if (type === 1 && !isScript(node)) {
	    return compileElement(node, options);
	  } else if (type === 3 && node.data.trim()) {
	    return compileTextNode(node, options);
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Compile an element and return a nodeLinkFn.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Function|null}
	 */
	
	function compileElement(el, options) {
	  // preprocess textareas.
	  // textarea treats its text content as the initial value.
	  // just bind it as an attr directive for value.
	  if (el.tagName === 'TEXTAREA') {
	    // a textarea which has v-pre attr should skip complie.
	    if (getAttr(el, 'v-pre') !== null) {
	      return skip;
	    }
	    var tokens = parseText(el.value);
	    if (tokens) {
	      el.setAttribute(':value', tokensToExp(tokens));
	      el.value = '';
	    }
	  }
	  var linkFn;
	  var hasAttrs = el.hasAttributes();
	  var attrs = hasAttrs && toArray(el.attributes);
	  // check terminal directives (for & if)
	  if (hasAttrs) {
	    linkFn = checkTerminalDirectives(el, attrs, options);
	  }
	  // check element directives
	  if (!linkFn) {
	    linkFn = checkElementDirectives(el, options);
	  }
	  // check component
	  if (!linkFn) {
	    linkFn = checkComponent(el, options);
	  }
	  // normal directives
	  if (!linkFn && hasAttrs) {
	    linkFn = compileDirectives(attrs, options);
	  }
	  return linkFn;
	}
	
	/**
	 * Compile a textNode and return a nodeLinkFn.
	 *
	 * @param {TextNode} node
	 * @param {Object} options
	 * @return {Function|null} textNodeLinkFn
	 */
	
	function compileTextNode(node, options) {
	  // skip marked text nodes
	  if (node._skip) {
	    return removeText;
	  }
	
	  var tokens = parseText(node.wholeText);
	  if (!tokens) {
	    return null;
	  }
	
	  // mark adjacent text nodes as skipped,
	  // because we are using node.wholeText to compile
	  // all adjacent text nodes together. This fixes
	  // issues in IE where sometimes it splits up a single
	  // text node into multiple ones.
	  var next = node.nextSibling;
	  while (next && next.nodeType === 3) {
	    next._skip = true;
	    next = next.nextSibling;
	  }
	
	  var frag = document.createDocumentFragment();
	  var el, token;
	  for (var i = 0, l = tokens.length; i < l; i++) {
	    token = tokens[i];
	    el = token.tag ? processTextToken(token, options) : document.createTextNode(token.value);
	    frag.appendChild(el);
	  }
	  return makeTextNodeLinkFn(tokens, frag, options);
	}
	
	/**
	 * Linker for an skipped text node.
	 *
	 * @param {Vue} vm
	 * @param {Text} node
	 */
	
	function removeText(vm, node) {
	  remove(node);
	}
	
	/**
	 * Process a single text token.
	 *
	 * @param {Object} token
	 * @param {Object} options
	 * @return {Node}
	 */
	
	function processTextToken(token, options) {
	  var el;
	  if (token.oneTime) {
	    el = document.createTextNode(token.value);
	  } else {
	    if (token.html) {
	      el = document.createComment('v-html');
	      setTokenType('html');
	    } else {
	      // IE will clean up empty textNodes during
	      // frag.cloneNode(true), so we have to give it
	      // something here...
	      el = document.createTextNode(' ');
	      setTokenType('text');
	    }
	  }
	  function setTokenType(type) {
	    if (token.descriptor) return;
	    var parsed = parseDirective(token.value);
	    token.descriptor = {
	      name: type,
	      def: directives[type],
	      expression: parsed.expression,
	      filters: parsed.filters
	    };
	  }
	  return el;
	}
	
	/**
	 * Build a function that processes a textNode.
	 *
	 * @param {Array<Object>} tokens
	 * @param {DocumentFragment} frag
	 */
	
	function makeTextNodeLinkFn(tokens, frag) {
	  return function textNodeLinkFn(vm, el, host, scope) {
	    var fragClone = frag.cloneNode(true);
	    var childNodes = toArray(fragClone.childNodes);
	    var token, value, node;
	    for (var i = 0, l = tokens.length; i < l; i++) {
	      token = tokens[i];
	      value = token.value;
	      if (token.tag) {
	        node = childNodes[i];
	        if (token.oneTime) {
	          value = (scope || vm).$eval(value);
	          if (token.html) {
	            replace(node, parseTemplate(value, true));
	          } else {
	            node.data = _toString(value);
	          }
	        } else {
	          vm._bindDir(token.descriptor, node, host, scope);
	        }
	      }
	    }
	    replace(el, fragClone);
	  };
	}
	
	/**
	 * Compile a node list and return a childLinkFn.
	 *
	 * @param {NodeList} nodeList
	 * @param {Object} options
	 * @return {Function|undefined}
	 */
	
	function compileNodeList(nodeList, options) {
	  var linkFns = [];
	  var nodeLinkFn, childLinkFn, node;
	  for (var i = 0, l = nodeList.length; i < l; i++) {
	    node = nodeList[i];
	    nodeLinkFn = compileNode(node, options);
	    childLinkFn = !(nodeLinkFn && nodeLinkFn.terminal) && node.tagName !== 'SCRIPT' && node.hasChildNodes() ? compileNodeList(node.childNodes, options) : null;
	    linkFns.push(nodeLinkFn, childLinkFn);
	  }
	  return linkFns.length ? makeChildLinkFn(linkFns) : null;
	}
	
	/**
	 * Make a child link function for a node's childNodes.
	 *
	 * @param {Array<Function>} linkFns
	 * @return {Function} childLinkFn
	 */
	
	function makeChildLinkFn(linkFns) {
	  return function childLinkFn(vm, nodes, host, scope, frag) {
	    var node, nodeLinkFn, childrenLinkFn;
	    for (var i = 0, n = 0, l = linkFns.length; i < l; n++) {
	      node = nodes[n];
	      nodeLinkFn = linkFns[i++];
	      childrenLinkFn = linkFns[i++];
	      // cache childNodes before linking parent, fix #657
	      var childNodes = toArray(node.childNodes);
	      if (nodeLinkFn) {
	        nodeLinkFn(vm, node, host, scope, frag);
	      }
	      if (childrenLinkFn) {
	        childrenLinkFn(vm, childNodes, host, scope, frag);
	      }
	    }
	  };
	}
	
	/**
	 * Check for element directives (custom elements that should
	 * be resovled as terminal directives).
	 *
	 * @param {Element} el
	 * @param {Object} options
	 */
	
	function checkElementDirectives(el, options) {
	  var tag = el.tagName.toLowerCase();
	  if (commonTagRE.test(tag)) {
	    return;
	  }
	  var def = resolveAsset(options, 'elementDirectives', tag);
	  if (def) {
	    return makeTerminalNodeLinkFn(el, tag, '', options, def);
	  }
	}
	
	/**
	 * Check if an element is a component. If yes, return
	 * a component link function.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Function|undefined}
	 */
	
	function checkComponent(el, options) {
	  var component = checkComponentAttr(el, options);
	  if (component) {
	    var ref = findRef(el);
	    var descriptor = {
	      name: 'component',
	      ref: ref,
	      expression: component.id,
	      def: internalDirectives.component,
	      modifiers: {
	        literal: !component.dynamic
	      }
	    };
	    var componentLinkFn = function componentLinkFn(vm, el, host, scope, frag) {
	      if (ref) {
	        defineReactive((scope || vm).$refs, ref, null);
	      }
	      vm._bindDir(descriptor, el, host, scope, frag);
	    };
	    componentLinkFn.terminal = true;
	    return componentLinkFn;
	  }
	}
	
	/**
	 * Check an element for terminal directives in fixed order.
	 * If it finds one, return a terminal link function.
	 *
	 * @param {Element} el
	 * @param {Array} attrs
	 * @param {Object} options
	 * @return {Function} terminalLinkFn
	 */
	
	function checkTerminalDirectives(el, attrs, options) {
	  // skip v-pre
	  if (getAttr(el, 'v-pre') !== null) {
	    return skip;
	  }
	  // skip v-else block, but only if following v-if
	  if (el.hasAttribute('v-else')) {
	    var prev = el.previousElementSibling;
	    if (prev && prev.hasAttribute('v-if')) {
	      return skip;
	    }
	  }
	
	  var attr, name, value, modifiers, matched, dirName, rawName, arg, def, termDef;
	  for (var i = 0, j = attrs.length; i < j; i++) {
	    attr = attrs[i];
	    name = attr.name.replace(modifierRE, '');
	    if (matched = name.match(dirAttrRE)) {
	      def = resolveAsset(options, 'directives', matched[1]);
	      if (def && def.terminal) {
	        if (!termDef || (def.priority || DEFAULT_TERMINAL_PRIORITY) > termDef.priority) {
	          termDef = def;
	          rawName = attr.name;
	          modifiers = parseModifiers(attr.name);
	          value = attr.value;
	          dirName = matched[1];
	          arg = matched[2];
	        }
	      }
	    }
	  }
	
	  if (termDef) {
	    return makeTerminalNodeLinkFn(el, dirName, value, options, termDef, rawName, arg, modifiers);
	  }
	}
	
	function skip() {}
	skip.terminal = true;
	
	/**
	 * Build a node link function for a terminal directive.
	 * A terminal link function terminates the current
	 * compilation recursion and handles compilation of the
	 * subtree in the directive.
	 *
	 * @param {Element} el
	 * @param {String} dirName
	 * @param {String} value
	 * @param {Object} options
	 * @param {Object} def
	 * @param {String} [rawName]
	 * @param {String} [arg]
	 * @param {Object} [modifiers]
	 * @return {Function} terminalLinkFn
	 */
	
	function makeTerminalNodeLinkFn(el, dirName, value, options, def, rawName, arg, modifiers) {
	  var parsed = parseDirective(value);
	  var descriptor = {
	    name: dirName,
	    arg: arg,
	    expression: parsed.expression,
	    filters: parsed.filters,
	    raw: value,
	    attr: rawName,
	    modifiers: modifiers,
	    def: def
	  };
	  // check ref for v-for, v-if and router-view
	  if (dirName === 'for' || dirName === 'router-view') {
	    descriptor.ref = findRef(el);
	  }
	  var fn = function terminalNodeLinkFn(vm, el, host, scope, frag) {
	    if (descriptor.ref) {
	      defineReactive((scope || vm).$refs, descriptor.ref, null);
	    }
	    vm._bindDir(descriptor, el, host, scope, frag);
	  };
	  fn.terminal = true;
	  return fn;
	}
	
	/**
	 * Compile the directives on an element and return a linker.
	 *
	 * @param {Array|NamedNodeMap} attrs
	 * @param {Object} options
	 * @return {Function}
	 */
	
	function compileDirectives(attrs, options) {
	  var i = attrs.length;
	  var dirs = [];
	  var attr, name, value, rawName, rawValue, dirName, arg, modifiers, dirDef, tokens, matched;
	  while (i--) {
	    attr = attrs[i];
	    name = rawName = attr.name;
	    value = rawValue = attr.value;
	    tokens = parseText(value);
	    // reset arg
	    arg = null;
	    // check modifiers
	    modifiers = parseModifiers(name);
	    name = name.replace(modifierRE, '');
	
	    // attribute interpolations
	    if (tokens) {
	      value = tokensToExp(tokens);
	      arg = name;
	      pushDir('bind', directives.bind, tokens);
	      // warn against mixing mustaches with v-bind
	      if (false) {
	        if (name === 'class' && Array.prototype.some.call(attrs, function (attr) {
	          return attr.name === ':class' || attr.name === 'v-bind:class';
	        })) {
	          warn('class="' + rawValue + '": Do not mix mustache interpolation ' + 'and v-bind for "class" on the same element. Use one or the other.', options);
	        }
	      }
	    } else
	
	      // special attribute: transition
	      if (transitionRE.test(name)) {
	        modifiers.literal = !bindRE.test(name);
	        pushDir('transition', internalDirectives.transition);
	      } else
	
	        // event handlers
	        if (onRE.test(name)) {
	          arg = name.replace(onRE, '');
	          pushDir('on', directives.on);
	        } else
	
	          // attribute bindings
	          if (bindRE.test(name)) {
	            dirName = name.replace(bindRE, '');
	            if (dirName === 'style' || dirName === 'class') {
	              pushDir(dirName, internalDirectives[dirName]);
	            } else {
	              arg = dirName;
	              pushDir('bind', directives.bind);
	            }
	          } else
	
	            // normal directives
	            if (matched = name.match(dirAttrRE)) {
	              dirName = matched[1];
	              arg = matched[2];
	
	              // skip v-else (when used with v-show)
	              if (dirName === 'else') {
	                continue;
	              }
	
	              dirDef = resolveAsset(options, 'directives', dirName, true);
	              if (dirDef) {
	                pushDir(dirName, dirDef);
	              }
	            }
	  }
	
	  /**
	   * Push a directive.
	   *
	   * @param {String} dirName
	   * @param {Object|Function} def
	   * @param {Array} [interpTokens]
	   */
	
	  function pushDir(dirName, def, interpTokens) {
	    var hasOneTimeToken = interpTokens && hasOneTime(interpTokens);
	    var parsed = !hasOneTimeToken && parseDirective(value);
	    dirs.push({
	      name: dirName,
	      attr: rawName,
	      raw: rawValue,
	      def: def,
	      arg: arg,
	      modifiers: modifiers,
	      // conversion from interpolation strings with one-time token
	      // to expression is differed until directive bind time so that we
	      // have access to the actual vm context for one-time bindings.
	      expression: parsed && parsed.expression,
	      filters: parsed && parsed.filters,
	      interp: interpTokens,
	      hasOneTime: hasOneTimeToken
	    });
	  }
	
	  if (dirs.length) {
	    return makeNodeLinkFn(dirs);
	  }
	}
	
	/**
	 * Parse modifiers from directive attribute name.
	 *
	 * @param {String} name
	 * @return {Object}
	 */
	
	function parseModifiers(name) {
	  var res = Object.create(null);
	  var match = name.match(modifierRE);
	  if (match) {
	    var i = match.length;
	    while (i--) {
	      res[match[i].slice(1)] = true;
	    }
	  }
	  return res;
	}
	
	/**
	 * Build a link function for all directives on a single node.
	 *
	 * @param {Array} directives
	 * @return {Function} directivesLinkFn
	 */
	
	function makeNodeLinkFn(directives) {
	  return function nodeLinkFn(vm, el, host, scope, frag) {
	    // reverse apply because it's sorted low to high
	    var i = directives.length;
	    while (i--) {
	      vm._bindDir(directives[i], el, host, scope, frag);
	    }
	  };
	}
	
	/**
	 * Check if an interpolation string contains one-time tokens.
	 *
	 * @param {Array} tokens
	 * @return {Boolean}
	 */
	
	function hasOneTime(tokens) {
	  var i = tokens.length;
	  while (i--) {
	    if (tokens[i].oneTime) return true;
	  }
	}
	
	function isScript(el) {
	  return el.tagName === 'SCRIPT' && (!el.hasAttribute('type') || el.getAttribute('type') === 'text/javascript');
	}
	
	var specialCharRE = /[^\w\-:\.]/;
	
	/**
	 * Process an element or a DocumentFragment based on a
	 * instance option object. This allows us to transclude
	 * a template node/fragment before the instance is created,
	 * so the processed fragment can then be cloned and reused
	 * in v-for.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Element|DocumentFragment}
	 */
	
	function transclude(el, options) {
	  // extract container attributes to pass them down
	  // to compiler, because they need to be compiled in
	  // parent scope. we are mutating the options object here
	  // assuming the same object will be used for compile
	  // right after this.
	  if (options) {
	    options._containerAttrs = extractAttrs(el);
	  }
	  // for template tags, what we want is its content as
	  // a documentFragment (for fragment instances)
	  if (isTemplate(el)) {
	    el = parseTemplate(el);
	  }
	  if (options) {
	    if (options._asComponent && !options.template) {
	      options.template = '<slot></slot>';
	    }
	    if (options.template) {
	      options._content = extractContent(el);
	      el = transcludeTemplate(el, options);
	    }
	  }
	  if (isFragment(el)) {
	    // anchors for fragment instance
	    // passing in `persist: true` to avoid them being
	    // discarded by IE during template cloning
	    prepend(createAnchor('v-start', true), el);
	    el.appendChild(createAnchor('v-end', true));
	  }
	  return el;
	}
	
	/**
	 * Process the template option.
	 * If the replace option is true this will swap the $el.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Element|DocumentFragment}
	 */
	
	function transcludeTemplate(el, options) {
	  var template = options.template;
	  var frag = parseTemplate(template, true);
	  if (frag) {
	    var replacer = frag.firstChild;
	    if (!replacer) {
	      return frag;
	    }
	    var tag = replacer.tagName && replacer.tagName.toLowerCase();
	    if (options.replace) {
	      /* istanbul ignore if */
	      if (el === document.body) {
	        ("production") !== 'production' && warn('You are mounting an instance with a template to ' + '<body>. This will replace <body> entirely. You ' + 'should probably use `replace: false` here.');
	      }
	      // there are many cases where the instance must
	      // become a fragment instance: basically anything that
	      // can create more than 1 root nodes.
	      if (
	      // multi-children template
	      frag.childNodes.length > 1 ||
	      // non-element template
	      replacer.nodeType !== 1 ||
	      // single nested component
	      tag === 'component' || resolveAsset(options, 'components', tag) || hasBindAttr(replacer, 'is') ||
	      // element directive
	      resolveAsset(options, 'elementDirectives', tag) ||
	      // for block
	      replacer.hasAttribute('v-for') ||
	      // if block
	      replacer.hasAttribute('v-if')) {
	        return frag;
	      } else {
	        options._replacerAttrs = extractAttrs(replacer);
	        mergeAttrs(el, replacer);
	        return replacer;
	      }
	    } else {
	      el.appendChild(frag);
	      return el;
	    }
	  } else {
	    ("production") !== 'production' && warn('Invalid template option: ' + template);
	  }
	}
	
	/**
	 * Helper to extract a component container's attributes
	 * into a plain object array.
	 *
	 * @param {Element} el
	 * @return {Array}
	 */
	
	function extractAttrs(el) {
	  if (el.nodeType === 1 && el.hasAttributes()) {
	    return toArray(el.attributes);
	  }
	}
	
	/**
	 * Merge the attributes of two elements, and make sure
	 * the class names are merged properly.
	 *
	 * @param {Element} from
	 * @param {Element} to
	 */
	
	function mergeAttrs(from, to) {
	  var attrs = from.attributes;
	  var i = attrs.length;
	  var name, value;
	  while (i--) {
	    name = attrs[i].name;
	    value = attrs[i].value;
	    if (!to.hasAttribute(name) && !specialCharRE.test(name)) {
	      to.setAttribute(name, value);
	    } else if (name === 'class' && !parseText(value) && (value = value.trim())) {
	      value.split(/\s+/).forEach(function (cls) {
	        addClass(to, cls);
	      });
	    }
	  }
	}
	
	/**
	 * Scan and determine slot content distribution.
	 * We do this during transclusion instead at compile time so that
	 * the distribution is decoupled from the compilation order of
	 * the slots.
	 *
	 * @param {Element|DocumentFragment} template
	 * @param {Element} content
	 * @param {Vue} vm
	 */
	
	function resolveSlots(vm, content) {
	  if (!content) {
	    return;
	  }
	  var contents = vm._slotContents = Object.create(null);
	  var el, name;
	  for (var i = 0, l = content.children.length; i < l; i++) {
	    el = content.children[i];
	    /* eslint-disable no-cond-assign */
	    if (name = el.getAttribute('slot')) {
	      (contents[name] || (contents[name] = [])).push(el);
	    }
	    /* eslint-enable no-cond-assign */
	    if (false) {
	      warn('The "slot" attribute must be static.', vm.$parent);
	    }
	  }
	  for (name in contents) {
	    contents[name] = extractFragment(contents[name], content);
	  }
	  if (content.hasChildNodes()) {
	    var nodes = content.childNodes;
	    if (nodes.length === 1 && nodes[0].nodeType === 3 && !nodes[0].data.trim()) {
	      return;
	    }
	    contents['default'] = extractFragment(content.childNodes, content);
	  }
	}
	
	/**
	 * Extract qualified content nodes from a node list.
	 *
	 * @param {NodeList} nodes
	 * @return {DocumentFragment}
	 */
	
	function extractFragment(nodes, parent) {
	  var frag = document.createDocumentFragment();
	  nodes = toArray(nodes);
	  for (var i = 0, l = nodes.length; i < l; i++) {
	    var node = nodes[i];
	    if (isTemplate(node) && !node.hasAttribute('v-if') && !node.hasAttribute('v-for')) {
	      parent.removeChild(node);
	      node = parseTemplate(node, true);
	    }
	    frag.appendChild(node);
	  }
	  return frag;
	}
	
	
	
	var compiler = Object.freeze({
		compile: compile,
		compileAndLinkProps: compileAndLinkProps,
		compileRoot: compileRoot,
		transclude: transclude,
		resolveSlots: resolveSlots
	});
	
	function stateMixin (Vue) {
	  /**
	   * Accessor for `$data` property, since setting $data
	   * requires observing the new object and updating
	   * proxied properties.
	   */
	
	  Object.defineProperty(Vue.prototype, '$data', {
	    get: function get() {
	      return this._data;
	    },
	    set: function set(newData) {
	      if (newData !== this._data) {
	        this._setData(newData);
	      }
	    }
	  });
	
	  /**
	   * Setup the scope of an instance, which contains:
	   * - observed data
	   * - computed properties
	   * - user methods
	   * - meta properties
	   */
	
	  Vue.prototype._initState = function () {
	    this._initProps();
	    this._initMeta();
	    this._initMethods();
	    this._initData();
	    this._initComputed();
	  };
	
	  /**
	   * Initialize props.
	   */
	
	  Vue.prototype._initProps = function () {
	    var options = this.$options;
	    var el = options.el;
	    var props = options.props;
	    if (props && !el) {
	      ("production") !== 'production' && warn('Props will not be compiled if no `el` option is ' + 'provided at instantiation.', this);
	    }
	    // make sure to convert string selectors into element now
	    el = options.el = query(el);
	    this._propsUnlinkFn = el && el.nodeType === 1 && props
	    // props must be linked in proper scope if inside v-for
	    ? compileAndLinkProps(this, el, props, this._scope) : null;
	  };
	
	  /**
	   * Initialize the data.
	   */
	
	  Vue.prototype._initData = function () {
	    var dataFn = this.$options.data;
	    var data = this._data = dataFn ? dataFn() : {};
	    if (!isPlainObject(data)) {
	      data = {};
	      ("production") !== 'production' && warn('data functions should return an object.', this);
	    }
	    var props = this._props;
	    // proxy data on instance
	    var keys = Object.keys(data);
	    var i, key;
	    i = keys.length;
	    while (i--) {
	      key = keys[i];
	      // there are two scenarios where we can proxy a data key:
	      // 1. it's not already defined as a prop
	      // 2. it's provided via a instantiation option AND there are no
	      //    template prop present
	      if (!props || !hasOwn(props, key)) {
	        this._proxy(key);
	      } else if (false) {
	        warn('Data field "' + key + '" is already defined ' + 'as a prop. To provide default value for a prop, use the "default" ' + 'prop option; if you want to pass prop values to an instantiation ' + 'call, use the "propsData" option.', this);
	      }
	    }
	    // observe data
	    observe(data, this);
	  };
	
	  /**
	   * Swap the instance's $data. Called in $data's setter.
	   *
	   * @param {Object} newData
	   */
	
	  Vue.prototype._setData = function (newData) {
	    newData = newData || {};
	    var oldData = this._data;
	    this._data = newData;
	    var keys, key, i;
	    // unproxy keys not present in new data
	    keys = Object.keys(oldData);
	    i = keys.length;
	    while (i--) {
	      key = keys[i];
	      if (!(key in newData)) {
	        this._unproxy(key);
	      }
	    }
	    // proxy keys not already proxied,
	    // and trigger change for changed values
	    keys = Object.keys(newData);
	    i = keys.length;
	    while (i--) {
	      key = keys[i];
	      if (!hasOwn(this, key)) {
	        // new property
	        this._proxy(key);
	      }
	    }
	    oldData.__ob__.removeVm(this);
	    observe(newData, this);
	    this._digest();
	  };
	
	  /**
	   * Proxy a property, so that
	   * vm.prop === vm._data.prop
	   *
	   * @param {String} key
	   */
	
	  Vue.prototype._proxy = function (key) {
	    if (!isReserved(key)) {
	      // need to store ref to self here
	      // because these getter/setters might
	      // be called by child scopes via
	      // prototype inheritance.
	      var self = this;
	      Object.defineProperty(self, key, {
	        configurable: true,
	        enumerable: true,
	        get: function proxyGetter() {
	          return self._data[key];
	        },
	        set: function proxySetter(val) {
	          self._data[key] = val;
	        }
	      });
	    }
	  };
	
	  /**
	   * Unproxy a property.
	   *
	   * @param {String} key
	   */
	
	  Vue.prototype._unproxy = function (key) {
	    if (!isReserved(key)) {
	      delete this[key];
	    }
	  };
	
	  /**
	   * Force update on every watcher in scope.
	   */
	
	  Vue.prototype._digest = function () {
	    for (var i = 0, l = this._watchers.length; i < l; i++) {
	      this._watchers[i].update(true); // shallow updates
	    }
	  };
	
	  /**
	   * Setup computed properties. They are essentially
	   * special getter/setters
	   */
	
	  function noop() {}
	  Vue.prototype._initComputed = function () {
	    var computed = this.$options.computed;
	    if (computed) {
	      for (var key in computed) {
	        var userDef = computed[key];
	        var def = {
	          enumerable: true,
	          configurable: true
	        };
	        if (typeof userDef === 'function') {
	          def.get = makeComputedGetter(userDef, this);
	          def.set = noop;
	        } else {
	          def.get = userDef.get ? userDef.cache !== false ? makeComputedGetter(userDef.get, this) : bind(userDef.get, this) : noop;
	          def.set = userDef.set ? bind(userDef.set, this) : noop;
	        }
	        Object.defineProperty(this, key, def);
	      }
	    }
	  };
	
	  function makeComputedGetter(getter, owner) {
	    var watcher = new Watcher(owner, getter, null, {
	      lazy: true
	    });
	    return function computedGetter() {
	      if (watcher.dirty) {
	        watcher.evaluate();
	      }
	      if (Dep.target) {
	        watcher.depend();
	      }
	      return watcher.value;
	    };
	  }
	
	  /**
	   * Setup instance methods. Methods must be bound to the
	   * instance since they might be passed down as a prop to
	   * child components.
	   */
	
	  Vue.prototype._initMethods = function () {
	    var methods = this.$options.methods;
	    if (methods) {
	      for (var key in methods) {
	        this[key] = bind(methods[key], this);
	      }
	    }
	  };
	
	  /**
	   * Initialize meta information like $index, $key & $value.
	   */
	
	  Vue.prototype._initMeta = function () {
	    var metas = this.$options._meta;
	    if (metas) {
	      for (var key in metas) {
	        defineReactive(this, key, metas[key]);
	      }
	    }
	  };
	}
	
	var eventRE = /^v-on:|^@/;
	
	function eventsMixin (Vue) {
	  /**
	   * Setup the instance's option events & watchers.
	   * If the value is a string, we pull it from the
	   * instance's methods by name.
	   */
	
	  Vue.prototype._initEvents = function () {
	    var options = this.$options;
	    if (options._asComponent) {
	      registerComponentEvents(this, options.el);
	    }
	    registerCallbacks(this, '$on', options.events);
	    registerCallbacks(this, '$watch', options.watch);
	  };
	
	  /**
	   * Register v-on events on a child component
	   *
	   * @param {Vue} vm
	   * @param {Element} el
	   */
	
	  function registerComponentEvents(vm, el) {
	    var attrs = el.attributes;
	    var name, value, handler;
	    for (var i = 0, l = attrs.length; i < l; i++) {
	      name = attrs[i].name;
	      if (eventRE.test(name)) {
	        name = name.replace(eventRE, '');
	        // force the expression into a statement so that
	        // it always dynamically resolves the method to call (#2670)
	        // kinda ugly hack, but does the job.
	        value = attrs[i].value;
	        if (isSimplePath(value)) {
	          value += '.apply(this, $arguments)';
	        }
	        handler = (vm._scope || vm._context).$eval(value, true);
	        handler._fromParent = true;
	        vm.$on(name.replace(eventRE), handler);
	      }
	    }
	  }
	
	  /**
	   * Register callbacks for option events and watchers.
	   *
	   * @param {Vue} vm
	   * @param {String} action
	   * @param {Object} hash
	   */
	
	  function registerCallbacks(vm, action, hash) {
	    if (!hash) return;
	    var handlers, key, i, j;
	    for (key in hash) {
	      handlers = hash[key];
	      if (isArray(handlers)) {
	        for (i = 0, j = handlers.length; i < j; i++) {
	          register(vm, action, key, handlers[i]);
	        }
	      } else {
	        register(vm, action, key, handlers);
	      }
	    }
	  }
	
	  /**
	   * Helper to register an event/watch callback.
	   *
	   * @param {Vue} vm
	   * @param {String} action
	   * @param {String} key
	   * @param {Function|String|Object} handler
	   * @param {Object} [options]
	   */
	
	  function register(vm, action, key, handler, options) {
	    var type = typeof handler;
	    if (type === 'function') {
	      vm[action](key, handler, options);
	    } else if (type === 'string') {
	      var methods = vm.$options.methods;
	      var method = methods && methods[handler];
	      if (method) {
	        vm[action](key, method, options);
	      } else {
	        ("production") !== 'production' && warn('Unknown method: "' + handler + '" when ' + 'registering callback for ' + action + ': "' + key + '".', vm);
	      }
	    } else if (handler && type === 'object') {
	      register(vm, action, key, handler.handler, handler);
	    }
	  }
	
	  /**
	   * Setup recursive attached/detached calls
	   */
	
	  Vue.prototype._initDOMHooks = function () {
	    this.$on('hook:attached', onAttached);
	    this.$on('hook:detached', onDetached);
	  };
	
	  /**
	   * Callback to recursively call attached hook on children
	   */
	
	  function onAttached() {
	    if (!this._isAttached) {
	      this._isAttached = true;
	      this.$children.forEach(callAttach);
	    }
	  }
	
	  /**
	   * Iterator to call attached hook
	   *
	   * @param {Vue} child
	   */
	
	  function callAttach(child) {
	    if (!child._isAttached && inDoc(child.$el)) {
	      child._callHook('attached');
	    }
	  }
	
	  /**
	   * Callback to recursively call detached hook on children
	   */
	
	  function onDetached() {
	    if (this._isAttached) {
	      this._isAttached = false;
	      this.$children.forEach(callDetach);
	    }
	  }
	
	  /**
	   * Iterator to call detached hook
	   *
	   * @param {Vue} child
	   */
	
	  function callDetach(child) {
	    if (child._isAttached && !inDoc(child.$el)) {
	      child._callHook('detached');
	    }
	  }
	
	  /**
	   * Trigger all handlers for a hook
	   *
	   * @param {String} hook
	   */
	
	  Vue.prototype._callHook = function (hook) {
	    this.$emit('pre-hook:' + hook);
	    var handlers = this.$options[hook];
	    if (handlers) {
	      for (var i = 0, j = handlers.length; i < j; i++) {
	        handlers[i].call(this);
	      }
	    }
	    this.$emit('hook:' + hook);
	  };
	}
	
	function noop$1() {}
	
	/**
	 * A directive links a DOM element with a piece of data,
	 * which is the result of evaluating an expression.
	 * It registers a watcher with the expression and calls
	 * the DOM update function when a change is triggered.
	 *
	 * @param {Object} descriptor
	 *                 - {String} name
	 *                 - {Object} def
	 *                 - {String} expression
	 *                 - {Array<Object>} [filters]
	 *                 - {Object} [modifiers]
	 *                 - {Boolean} literal
	 *                 - {String} attr
	 *                 - {String} arg
	 *                 - {String} raw
	 *                 - {String} [ref]
	 *                 - {Array<Object>} [interp]
	 *                 - {Boolean} [hasOneTime]
	 * @param {Vue} vm
	 * @param {Node} el
	 * @param {Vue} [host] - transclusion host component
	 * @param {Object} [scope] - v-for scope
	 * @param {Fragment} [frag] - owner fragment
	 * @constructor
	 */
	function Directive(descriptor, vm, el, host, scope, frag) {
	  this.vm = vm;
	  this.el = el;
	  // copy descriptor properties
	  this.descriptor = descriptor;
	  this.name = descriptor.name;
	  this.expression = descriptor.expression;
	  this.arg = descriptor.arg;
	  this.modifiers = descriptor.modifiers;
	  this.filters = descriptor.filters;
	  this.literal = this.modifiers && this.modifiers.literal;
	  // private
	  this._locked = false;
	  this._bound = false;
	  this._listeners = null;
	  // link context
	  this._host = host;
	  this._scope = scope;
	  this._frag = frag;
	  // store directives on node in dev mode
	  if (false) {
	    this.el._vue_directives = this.el._vue_directives || [];
	    this.el._vue_directives.push(this);
	  }
	}
	
	/**
	 * Initialize the directive, mixin definition properties,
	 * setup the watcher, call definition bind() and update()
	 * if present.
	 */
	
	Directive.prototype._bind = function () {
	  var name = this.name;
	  var descriptor = this.descriptor;
	
	  // remove attribute
	  if ((name !== 'cloak' || this.vm._isCompiled) && this.el && this.el.removeAttribute) {
	    var attr = descriptor.attr || 'v-' + name;
	    this.el.removeAttribute(attr);
	  }
	
	  // copy def properties
	  var def = descriptor.def;
	  if (typeof def === 'function') {
	    this.update = def;
	  } else {
	    extend(this, def);
	  }
	
	  // setup directive params
	  this._setupParams();
	
	  // initial bind
	  if (this.bind) {
	    this.bind();
	  }
	  this._bound = true;
	
	  if (this.literal) {
	    this.update && this.update(descriptor.raw);
	  } else if ((this.expression || this.modifiers) && (this.update || this.twoWay) && !this._checkStatement()) {
	    // wrapped updater for context
	    var dir = this;
	    if (this.update) {
	      this._update = function (val, oldVal) {
	        if (!dir._locked) {
	          dir.update(val, oldVal);
	        }
	      };
	    } else {
	      this._update = noop$1;
	    }
	    var preProcess = this._preProcess ? bind(this._preProcess, this) : null;
	    var postProcess = this._postProcess ? bind(this._postProcess, this) : null;
	    var watcher = this._watcher = new Watcher(this.vm, this.expression, this._update, // callback
	    {
	      filters: this.filters,
	      twoWay: this.twoWay,
	      deep: this.deep,
	      preProcess: preProcess,
	      postProcess: postProcess,
	      scope: this._scope
	    });
	    // v-model with inital inline value need to sync back to
	    // model instead of update to DOM on init. They would
	    // set the afterBind hook to indicate that.
	    if (this.afterBind) {
	      this.afterBind();
	    } else if (this.update) {
	      this.update(watcher.value);
	    }
	  }
	};
	
	/**
	 * Setup all param attributes, e.g. track-by,
	 * transition-mode, etc...
	 */
	
	Directive.prototype._setupParams = function () {
	  if (!this.params) {
	    return;
	  }
	  var params = this.params;
	  // swap the params array with a fresh object.
	  this.params = Object.create(null);
	  var i = params.length;
	  var key, val, mappedKey;
	  while (i--) {
	    key = hyphenate(params[i]);
	    mappedKey = camelize(key);
	    val = getBindAttr(this.el, key);
	    if (val != null) {
	      // dynamic
	      this._setupParamWatcher(mappedKey, val);
	    } else {
	      // static
	      val = getAttr(this.el, key);
	      if (val != null) {
	        this.params[mappedKey] = val === '' ? true : val;
	      }
	    }
	  }
	};
	
	/**
	 * Setup a watcher for a dynamic param.
	 *
	 * @param {String} key
	 * @param {String} expression
	 */
	
	Directive.prototype._setupParamWatcher = function (key, expression) {
	  var self = this;
	  var called = false;
	  var unwatch = (this._scope || this.vm).$watch(expression, function (val, oldVal) {
	    self.params[key] = val;
	    // since we are in immediate mode,
	    // only call the param change callbacks if this is not the first update.
	    if (called) {
	      var cb = self.paramWatchers && self.paramWatchers[key];
	      if (cb) {
	        cb.call(self, val, oldVal);
	      }
	    } else {
	      called = true;
	    }
	  }, {
	    immediate: true,
	    user: false
	  });(this._paramUnwatchFns || (this._paramUnwatchFns = [])).push(unwatch);
	};
	
	/**
	 * Check if the directive is a function caller
	 * and if the expression is a callable one. If both true,
	 * we wrap up the expression and use it as the event
	 * handler.
	 *
	 * e.g. on-click="a++"
	 *
	 * @return {Boolean}
	 */
	
	Directive.prototype._checkStatement = function () {
	  var expression = this.expression;
	  if (expression && this.acceptStatement && !isSimplePath(expression)) {
	    var fn = parseExpression$1(expression).get;
	    var scope = this._scope || this.vm;
	    var handler = function handler(e) {
	      scope.$event = e;
	      fn.call(scope, scope);
	      scope.$event = null;
	    };
	    if (this.filters) {
	      handler = scope._applyFilters(handler, null, this.filters);
	    }
	    this.update(handler);
	    return true;
	  }
	};
	
	/**
	 * Set the corresponding value with the setter.
	 * This should only be used in two-way directives
	 * e.g. v-model.
	 *
	 * @param {*} value
	 * @public
	 */
	
	Directive.prototype.set = function (value) {
	  /* istanbul ignore else */
	  if (this.twoWay) {
	    this._withLock(function () {
	      this._watcher.set(value);
	    });
	  } else if (false) {
	    warn('Directive.set() can only be used inside twoWay' + 'directives.');
	  }
	};
	
	/**
	 * Execute a function while preventing that function from
	 * triggering updates on this directive instance.
	 *
	 * @param {Function} fn
	 */
	
	Directive.prototype._withLock = function (fn) {
	  var self = this;
	  self._locked = true;
	  fn.call(self);
	  nextTick(function () {
	    self._locked = false;
	  });
	};
	
	/**
	 * Convenience method that attaches a DOM event listener
	 * to the directive element and autometically tears it down
	 * during unbind.
	 *
	 * @param {String} event
	 * @param {Function} handler
	 * @param {Boolean} [useCapture]
	 */
	
	Directive.prototype.on = function (event, handler, useCapture) {
	  on(this.el, event, handler, useCapture);(this._listeners || (this._listeners = [])).push([event, handler]);
	};
	
	/**
	 * Teardown the watcher and call unbind.
	 */
	
	Directive.prototype._teardown = function () {
	  if (this._bound) {
	    this._bound = false;
	    if (this.unbind) {
	      this.unbind();
	    }
	    if (this._watcher) {
	      this._watcher.teardown();
	    }
	    var listeners = this._listeners;
	    var i;
	    if (listeners) {
	      i = listeners.length;
	      while (i--) {
	        off(this.el, listeners[i][0], listeners[i][1]);
	      }
	    }
	    var unwatchFns = this._paramUnwatchFns;
	    if (unwatchFns) {
	      i = unwatchFns.length;
	      while (i--) {
	        unwatchFns[i]();
	      }
	    }
	    if (false) {
	      this.el._vue_directives.$remove(this);
	    }
	    this.vm = this.el = this._watcher = this._listeners = null;
	  }
	};
	
	function lifecycleMixin (Vue) {
	  /**
	   * Update v-ref for component.
	   *
	   * @param {Boolean} remove
	   */
	
	  Vue.prototype._updateRef = function (remove) {
	    var ref = this.$options._ref;
	    if (ref) {
	      var refs = (this._scope || this._context).$refs;
	      if (remove) {
	        if (refs[ref] === this) {
	          refs[ref] = null;
	        }
	      } else {
	        refs[ref] = this;
	      }
	    }
	  };
	
	  /**
	   * Transclude, compile and link element.
	   *
	   * If a pre-compiled linker is available, that means the
	   * passed in element will be pre-transcluded and compiled
	   * as well - all we need to do is to call the linker.
	   *
	   * Otherwise we need to call transclude/compile/link here.
	   *
	   * @param {Element} el
	   */
	
	  Vue.prototype._compile = function (el) {
	    var options = this.$options;
	
	    // transclude and init element
	    // transclude can potentially replace original
	    // so we need to keep reference; this step also injects
	    // the template and caches the original attributes
	    // on the container node and replacer node.
	    var original = el;
	    el = transclude(el, options);
	    this._initElement(el);
	
	    // handle v-pre on root node (#2026)
	    if (el.nodeType === 1 && getAttr(el, 'v-pre') !== null) {
	      return;
	    }
	
	    // root is always compiled per-instance, because
	    // container attrs and props can be different every time.
	    var contextOptions = this._context && this._context.$options;
	    var rootLinker = compileRoot(el, options, contextOptions);
	
	    // resolve slot distribution
	    resolveSlots(this, options._content);
	
	    // compile and link the rest
	    var contentLinkFn;
	    var ctor = this.constructor;
	    // component compilation can be cached
	    // as long as it's not using inline-template
	    if (options._linkerCachable) {
	      contentLinkFn = ctor.linker;
	      if (!contentLinkFn) {
	        contentLinkFn = ctor.linker = compile(el, options);
	      }
	    }
	
	    // link phase
	    // make sure to link root with prop scope!
	    var rootUnlinkFn = rootLinker(this, el, this._scope);
	    var contentUnlinkFn = contentLinkFn ? contentLinkFn(this, el) : compile(el, options)(this, el);
	
	    // register composite unlink function
	    // to be called during instance destruction
	    this._unlinkFn = function () {
	      rootUnlinkFn();
	      // passing destroying: true to avoid searching and
	      // splicing the directives
	      contentUnlinkFn(true);
	    };
	
	    // finally replace original
	    if (options.replace) {
	      replace(original, el);
	    }
	
	    this._isCompiled = true;
	    this._callHook('compiled');
	  };
	
	  /**
	   * Initialize instance element. Called in the public
	   * $mount() method.
	   *
	   * @param {Element} el
	   */
	
	  Vue.prototype._initElement = function (el) {
	    if (isFragment(el)) {
	      this._isFragment = true;
	      this.$el = this._fragmentStart = el.firstChild;
	      this._fragmentEnd = el.lastChild;
	      // set persisted text anchors to empty
	      if (this._fragmentStart.nodeType === 3) {
	        this._fragmentStart.data = this._fragmentEnd.data = '';
	      }
	      this._fragment = el;
	    } else {
	      this.$el = el;
	    }
	    this.$el.__vue__ = this;
	    this._callHook('beforeCompile');
	  };
	
	  /**
	   * Create and bind a directive to an element.
	   *
	   * @param {Object} descriptor - parsed directive descriptor
	   * @param {Node} node   - target node
	   * @param {Vue} [host] - transclusion host component
	   * @param {Object} [scope] - v-for scope
	   * @param {Fragment} [frag] - owner fragment
	   */
	
	  Vue.prototype._bindDir = function (descriptor, node, host, scope, frag) {
	    this._directives.push(new Directive(descriptor, this, node, host, scope, frag));
	  };
	
	  /**
	   * Teardown an instance, unobserves the data, unbind all the
	   * directives, turn off all the event listeners, etc.
	   *
	   * @param {Boolean} remove - whether to remove the DOM node.
	   * @param {Boolean} deferCleanup - if true, defer cleanup to
	   *                                 be called later
	   */
	
	  Vue.prototype._destroy = function (remove, deferCleanup) {
	    if (this._isBeingDestroyed) {
	      if (!deferCleanup) {
	        this._cleanup();
	      }
	      return;
	    }
	
	    var destroyReady;
	    var pendingRemoval;
	
	    var self = this;
	    // Cleanup should be called either synchronously or asynchronoysly as
	    // callback of this.$remove(), or if remove and deferCleanup are false.
	    // In any case it should be called after all other removing, unbinding and
	    // turning of is done
	    var cleanupIfPossible = function cleanupIfPossible() {
	      if (destroyReady && !pendingRemoval && !deferCleanup) {
	        self._cleanup();
	      }
	    };
	
	    // remove DOM element
	    if (remove && this.$el) {
	      pendingRemoval = true;
	      this.$remove(function () {
	        pendingRemoval = false;
	        cleanupIfPossible();
	      });
	    }
	
	    this._callHook('beforeDestroy');
	    this._isBeingDestroyed = true;
	    var i;
	    // remove self from parent. only necessary
	    // if parent is not being destroyed as well.
	    var parent = this.$parent;
	    if (parent && !parent._isBeingDestroyed) {
	      parent.$children.$remove(this);
	      // unregister ref (remove: true)
	      this._updateRef(true);
	    }
	    // destroy all children.
	    i = this.$children.length;
	    while (i--) {
	      this.$children[i].$destroy();
	    }
	    // teardown props
	    if (this._propsUnlinkFn) {
	      this._propsUnlinkFn();
	    }
	    // teardown all directives. this also tearsdown all
	    // directive-owned watchers.
	    if (this._unlinkFn) {
	      this._unlinkFn();
	    }
	    i = this._watchers.length;
	    while (i--) {
	      this._watchers[i].teardown();
	    }
	    // remove reference to self on $el
	    if (this.$el) {
	      this.$el.__vue__ = null;
	    }
	
	    destroyReady = true;
	    cleanupIfPossible();
	  };
	
	  /**
	   * Clean up to ensure garbage collection.
	   * This is called after the leave transition if there
	   * is any.
	   */
	
	  Vue.prototype._cleanup = function () {
	    if (this._isDestroyed) {
	      return;
	    }
	    // remove self from owner fragment
	    // do it in cleanup so that we can call $destroy with
	    // defer right when a fragment is about to be removed.
	    if (this._frag) {
	      this._frag.children.$remove(this);
	    }
	    // remove reference from data ob
	    // frozen object may not have observer.
	    if (this._data && this._data.__ob__) {
	      this._data.__ob__.removeVm(this);
	    }
	    // Clean up references to private properties and other
	    // instances. preserve reference to _data so that proxy
	    // accessors still work. The only potential side effect
	    // here is that mutating the instance after it's destroyed
	    // may affect the state of other components that are still
	    // observing the same object, but that seems to be a
	    // reasonable responsibility for the user rather than
	    // always throwing an error on them.
	    this.$el = this.$parent = this.$root = this.$children = this._watchers = this._context = this._scope = this._directives = null;
	    // call the last hook...
	    this._isDestroyed = true;
	    this._callHook('destroyed');
	    // turn off all instance listeners.
	    this.$off();
	  };
	}
	
	function miscMixin (Vue) {
	  /**
	   * Apply a list of filter (descriptors) to a value.
	   * Using plain for loops here because this will be called in
	   * the getter of any watcher with filters so it is very
	   * performance sensitive.
	   *
	   * @param {*} value
	   * @param {*} [oldValue]
	   * @param {Array} filters
	   * @param {Boolean} write
	   * @return {*}
	   */
	
	  Vue.prototype._applyFilters = function (value, oldValue, filters, write) {
	    var filter, fn, args, arg, offset, i, l, j, k;
	    for (i = 0, l = filters.length; i < l; i++) {
	      filter = filters[write ? l - i - 1 : i];
	      fn = resolveAsset(this.$options, 'filters', filter.name, true);
	      if (!fn) continue;
	      fn = write ? fn.write : fn.read || fn;
	      if (typeof fn !== 'function') continue;
	      args = write ? [value, oldValue] : [value];
	      offset = write ? 2 : 1;
	      if (filter.args) {
	        for (j = 0, k = filter.args.length; j < k; j++) {
	          arg = filter.args[j];
	          args[j + offset] = arg.dynamic ? this.$get(arg.value) : arg.value;
	        }
	      }
	      value = fn.apply(this, args);
	    }
	    return value;
	  };
	
	  /**
	   * Resolve a component, depending on whether the component
	   * is defined normally or using an async factory function.
	   * Resolves synchronously if already resolved, otherwise
	   * resolves asynchronously and caches the resolved
	   * constructor on the factory.
	   *
	   * @param {String|Function} value
	   * @param {Function} cb
	   */
	
	  Vue.prototype._resolveComponent = function (value, cb) {
	    var factory;
	    if (typeof value === 'function') {
	      factory = value;
	    } else {
	      factory = resolveAsset(this.$options, 'components', value, true);
	    }
	    /* istanbul ignore if */
	    if (!factory) {
	      return;
	    }
	    // async component factory
	    if (!factory.options) {
	      if (factory.resolved) {
	        // cached
	        cb(factory.resolved);
	      } else if (factory.requested) {
	        // pool callbacks
	        factory.pendingCallbacks.push(cb);
	      } else {
	        factory.requested = true;
	        var cbs = factory.pendingCallbacks = [cb];
	        factory.call(this, function resolve(res) {
	          if (isPlainObject(res)) {
	            res = Vue.extend(res);
	          }
	          // cache resolved
	          factory.resolved = res;
	          // invoke callbacks
	          for (var i = 0, l = cbs.length; i < l; i++) {
	            cbs[i](res);
	          }
	        }, function reject(reason) {
	          ("production") !== 'production' && warn('Failed to resolve async component' + (typeof value === 'string' ? ': ' + value : '') + '. ' + (reason ? '\nReason: ' + reason : ''));
	        });
	      }
	    } else {
	      // normal component
	      cb(factory);
	    }
	  };
	}
	
	var filterRE$1 = /[^|]\|[^|]/;
	
	function dataAPI (Vue) {
	  /**
	   * Get the value from an expression on this vm.
	   *
	   * @param {String} exp
	   * @param {Boolean} [asStatement]
	   * @return {*}
	   */
	
	  Vue.prototype.$get = function (exp, asStatement) {
	    var res = parseExpression$1(exp);
	    if (res) {
	      if (asStatement) {
	        var self = this;
	        return function statementHandler() {
	          self.$arguments = toArray(arguments);
	          var result = res.get.call(self, self);
	          self.$arguments = null;
	          return result;
	        };
	      } else {
	        try {
	          return res.get.call(this, this);
	        } catch (e) {}
	      }
	    }
	  };
	
	  /**
	   * Set the value from an expression on this vm.
	   * The expression must be a valid left-hand
	   * expression in an assignment.
	   *
	   * @param {String} exp
	   * @param {*} val
	   */
	
	  Vue.prototype.$set = function (exp, val) {
	    var res = parseExpression$1(exp, true);
	    if (res && res.set) {
	      res.set.call(this, this, val);
	    }
	  };
	
	  /**
	   * Delete a property on the VM
	   *
	   * @param {String} key
	   */
	
	  Vue.prototype.$delete = function (key) {
	    del(this._data, key);
	  };
	
	  /**
	   * Watch an expression, trigger callback when its
	   * value changes.
	   *
	   * @param {String|Function} expOrFn
	   * @param {Function} cb
	   * @param {Object} [options]
	   *                 - {Boolean} deep
	   *                 - {Boolean} immediate
	   * @return {Function} - unwatchFn
	   */
	
	  Vue.prototype.$watch = function (expOrFn, cb, options) {
	    var vm = this;
	    var parsed;
	    if (typeof expOrFn === 'string') {
	      parsed = parseDirective(expOrFn);
	      expOrFn = parsed.expression;
	    }
	    var watcher = new Watcher(vm, expOrFn, cb, {
	      deep: options && options.deep,
	      sync: options && options.sync,
	      filters: parsed && parsed.filters,
	      user: !options || options.user !== false
	    });
	    if (options && options.immediate) {
	      cb.call(vm, watcher.value);
	    }
	    return function unwatchFn() {
	      watcher.teardown();
	    };
	  };
	
	  /**
	   * Evaluate a text directive, including filters.
	   *
	   * @param {String} text
	   * @param {Boolean} [asStatement]
	   * @return {String}
	   */
	
	  Vue.prototype.$eval = function (text, asStatement) {
	    // check for filters.
	    if (filterRE$1.test(text)) {
	      var dir = parseDirective(text);
	      // the filter regex check might give false positive
	      // for pipes inside strings, so it's possible that
	      // we don't get any filters here
	      var val = this.$get(dir.expression, asStatement);
	      return dir.filters ? this._applyFilters(val, null, dir.filters) : val;
	    } else {
	      // no filter
	      return this.$get(text, asStatement);
	    }
	  };
	
	  /**
	   * Interpolate a piece of template text.
	   *
	   * @param {String} text
	   * @return {String}
	   */
	
	  Vue.prototype.$interpolate = function (text) {
	    var tokens = parseText(text);
	    var vm = this;
	    if (tokens) {
	      if (tokens.length === 1) {
	        return vm.$eval(tokens[0].value) + '';
	      } else {
	        return tokens.map(function (token) {
	          return token.tag ? vm.$eval(token.value) : token.value;
	        }).join('');
	      }
	    } else {
	      return text;
	    }
	  };
	
	  /**
	   * Log instance data as a plain JS object
	   * so that it is easier to inspect in console.
	   * This method assumes console is available.
	   *
	   * @param {String} [path]
	   */
	
	  Vue.prototype.$log = function (path) {
	    var data = path ? getPath(this._data, path) : this._data;
	    if (data) {
	      data = clean(data);
	    }
	    // include computed fields
	    if (!path) {
	      var key;
	      for (key in this.$options.computed) {
	        data[key] = clean(this[key]);
	      }
	      if (this._props) {
	        for (key in this._props) {
	          data[key] = clean(this[key]);
	        }
	      }
	    }
	    console.log(data);
	  };
	
	  /**
	   * "clean" a getter/setter converted object into a plain
	   * object copy.
	   *
	   * @param {Object} - obj
	   * @return {Object}
	   */
	
	  function clean(obj) {
	    return JSON.parse(JSON.stringify(obj));
	  }
	}
	
	function domAPI (Vue) {
	  /**
	   * Convenience on-instance nextTick. The callback is
	   * auto-bound to the instance, and this avoids component
	   * modules having to rely on the global Vue.
	   *
	   * @param {Function} fn
	   */
	
	  Vue.prototype.$nextTick = function (fn) {
	    nextTick(fn, this);
	  };
	
	  /**
	   * Append instance to target
	   *
	   * @param {Node} target
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition] - defaults to true
	   */
	
	  Vue.prototype.$appendTo = function (target, cb, withTransition) {
	    return insert(this, target, cb, withTransition, append, appendWithTransition);
	  };
	
	  /**
	   * Prepend instance to target
	   *
	   * @param {Node} target
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition] - defaults to true
	   */
	
	  Vue.prototype.$prependTo = function (target, cb, withTransition) {
	    target = query(target);
	    if (target.hasChildNodes()) {
	      this.$before(target.firstChild, cb, withTransition);
	    } else {
	      this.$appendTo(target, cb, withTransition);
	    }
	    return this;
	  };
	
	  /**
	   * Insert instance before target
	   *
	   * @param {Node} target
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition] - defaults to true
	   */
	
	  Vue.prototype.$before = function (target, cb, withTransition) {
	    return insert(this, target, cb, withTransition, beforeWithCb, beforeWithTransition);
	  };
	
	  /**
	   * Insert instance after target
	   *
	   * @param {Node} target
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition] - defaults to true
	   */
	
	  Vue.prototype.$after = function (target, cb, withTransition) {
	    target = query(target);
	    if (target.nextSibling) {
	      this.$before(target.nextSibling, cb, withTransition);
	    } else {
	      this.$appendTo(target.parentNode, cb, withTransition);
	    }
	    return this;
	  };
	
	  /**
	   * Remove instance from DOM
	   *
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition] - defaults to true
	   */
	
	  Vue.prototype.$remove = function (cb, withTransition) {
	    if (!this.$el.parentNode) {
	      return cb && cb();
	    }
	    var inDocument = this._isAttached && inDoc(this.$el);
	    // if we are not in document, no need to check
	    // for transitions
	    if (!inDocument) withTransition = false;
	    var self = this;
	    var realCb = function realCb() {
	      if (inDocument) self._callHook('detached');
	      if (cb) cb();
	    };
	    if (this._isFragment) {
	      removeNodeRange(this._fragmentStart, this._fragmentEnd, this, this._fragment, realCb);
	    } else {
	      var op = withTransition === false ? removeWithCb : removeWithTransition;
	      op(this.$el, this, realCb);
	    }
	    return this;
	  };
	
	  /**
	   * Shared DOM insertion function.
	   *
	   * @param {Vue} vm
	   * @param {Element} target
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition]
	   * @param {Function} op1 - op for non-transition insert
	   * @param {Function} op2 - op for transition insert
	   * @return vm
	   */
	
	  function insert(vm, target, cb, withTransition, op1, op2) {
	    target = query(target);
	    var targetIsDetached = !inDoc(target);
	    var op = withTransition === false || targetIsDetached ? op1 : op2;
	    var shouldCallHook = !targetIsDetached && !vm._isAttached && !inDoc(vm.$el);
	    if (vm._isFragment) {
	      mapNodeRange(vm._fragmentStart, vm._fragmentEnd, function (node) {
	        op(node, target, vm);
	      });
	      cb && cb();
	    } else {
	      op(vm.$el, target, vm, cb);
	    }
	    if (shouldCallHook) {
	      vm._callHook('attached');
	    }
	    return vm;
	  }
	
	  /**
	   * Check for selectors
	   *
	   * @param {String|Element} el
	   */
	
	  function query(el) {
	    return typeof el === 'string' ? document.querySelector(el) : el;
	  }
	
	  /**
	   * Append operation that takes a callback.
	   *
	   * @param {Node} el
	   * @param {Node} target
	   * @param {Vue} vm - unused
	   * @param {Function} [cb]
	   */
	
	  function append(el, target, vm, cb) {
	    target.appendChild(el);
	    if (cb) cb();
	  }
	
	  /**
	   * InsertBefore operation that takes a callback.
	   *
	   * @param {Node} el
	   * @param {Node} target
	   * @param {Vue} vm - unused
	   * @param {Function} [cb]
	   */
	
	  function beforeWithCb(el, target, vm, cb) {
	    before(el, target);
	    if (cb) cb();
	  }
	
	  /**
	   * Remove operation that takes a callback.
	   *
	   * @param {Node} el
	   * @param {Vue} vm - unused
	   * @param {Function} [cb]
	   */
	
	  function removeWithCb(el, vm, cb) {
	    remove(el);
	    if (cb) cb();
	  }
	}
	
	function eventsAPI (Vue) {
	  /**
	   * Listen on the given `event` with `fn`.
	   *
	   * @param {String} event
	   * @param {Function} fn
	   */
	
	  Vue.prototype.$on = function (event, fn) {
	    (this._events[event] || (this._events[event] = [])).push(fn);
	    modifyListenerCount(this, event, 1);
	    return this;
	  };
	
	  /**
	   * Adds an `event` listener that will be invoked a single
	   * time then automatically removed.
	   *
	   * @param {String} event
	   * @param {Function} fn
	   */
	
	  Vue.prototype.$once = function (event, fn) {
	    var self = this;
	    function on() {
	      self.$off(event, on);
	      fn.apply(this, arguments);
	    }
	    on.fn = fn;
	    this.$on(event, on);
	    return this;
	  };
	
	  /**
	   * Remove the given callback for `event` or all
	   * registered callbacks.
	   *
	   * @param {String} event
	   * @param {Function} fn
	   */
	
	  Vue.prototype.$off = function (event, fn) {
	    var cbs;
	    // all
	    if (!arguments.length) {
	      if (this.$parent) {
	        for (event in this._events) {
	          cbs = this._events[event];
	          if (cbs) {
	            modifyListenerCount(this, event, -cbs.length);
	          }
	        }
	      }
	      this._events = {};
	      return this;
	    }
	    // specific event
	    cbs = this._events[event];
	    if (!cbs) {
	      return this;
	    }
	    if (arguments.length === 1) {
	      modifyListenerCount(this, event, -cbs.length);
	      this._events[event] = null;
	      return this;
	    }
	    // specific handler
	    var cb;
	    var i = cbs.length;
	    while (i--) {
	      cb = cbs[i];
	      if (cb === fn || cb.fn === fn) {
	        modifyListenerCount(this, event, -1);
	        cbs.splice(i, 1);
	        break;
	      }
	    }
	    return this;
	  };
	
	  /**
	   * Trigger an event on self.
	   *
	   * @param {String|Object} event
	   * @return {Boolean} shouldPropagate
	   */
	
	  Vue.prototype.$emit = function (event) {
	    var isSource = typeof event === 'string';
	    event = isSource ? event : event.name;
	    var cbs = this._events[event];
	    var shouldPropagate = isSource || !cbs;
	    if (cbs) {
	      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
	      // this is a somewhat hacky solution to the question raised
	      // in #2102: for an inline component listener like <comp @test="doThis">,
	      // the propagation handling is somewhat broken. Therefore we
	      // need to treat these inline callbacks differently.
	      var hasParentCbs = isSource && cbs.some(function (cb) {
	        return cb._fromParent;
	      });
	      if (hasParentCbs) {
	        shouldPropagate = false;
	      }
	      var args = toArray(arguments, 1);
	      for (var i = 0, l = cbs.length; i < l; i++) {
	        var cb = cbs[i];
	        var res = cb.apply(this, args);
	        if (res === true && (!hasParentCbs || cb._fromParent)) {
	          shouldPropagate = true;
	        }
	      }
	    }
	    return shouldPropagate;
	  };
	
	  /**
	   * Recursively broadcast an event to all children instances.
	   *
	   * @param {String|Object} event
	   * @param {...*} additional arguments
	   */
	
	  Vue.prototype.$broadcast = function (event) {
	    var isSource = typeof event === 'string';
	    event = isSource ? event : event.name;
	    // if no child has registered for this event,
	    // then there's no need to broadcast.
	    if (!this._eventsCount[event]) return;
	    var children = this.$children;
	    var args = toArray(arguments);
	    if (isSource) {
	      // use object event to indicate non-source emit
	      // on children
	      args[0] = { name: event, source: this };
	    }
	    for (var i = 0, l = children.length; i < l; i++) {
	      var child = children[i];
	      var shouldPropagate = child.$emit.apply(child, args);
	      if (shouldPropagate) {
	        child.$broadcast.apply(child, args);
	      }
	    }
	    return this;
	  };
	
	  /**
	   * Recursively propagate an event up the parent chain.
	   *
	   * @param {String} event
	   * @param {...*} additional arguments
	   */
	
	  Vue.prototype.$dispatch = function (event) {
	    var shouldPropagate = this.$emit.apply(this, arguments);
	    if (!shouldPropagate) return;
	    var parent = this.$parent;
	    var args = toArray(arguments);
	    // use object event to indicate non-source emit
	    // on parents
	    args[0] = { name: event, source: this };
	    while (parent) {
	      shouldPropagate = parent.$emit.apply(parent, args);
	      parent = shouldPropagate ? parent.$parent : null;
	    }
	    return this;
	  };
	
	  /**
	   * Modify the listener counts on all parents.
	   * This bookkeeping allows $broadcast to return early when
	   * no child has listened to a certain event.
	   *
	   * @param {Vue} vm
	   * @param {String} event
	   * @param {Number} count
	   */
	
	  var hookRE = /^hook:/;
	  function modifyListenerCount(vm, event, count) {
	    var parent = vm.$parent;
	    // hooks do not get broadcasted so no need
	    // to do bookkeeping for them
	    if (!parent || !count || hookRE.test(event)) return;
	    while (parent) {
	      parent._eventsCount[event] = (parent._eventsCount[event] || 0) + count;
	      parent = parent.$parent;
	    }
	  }
	}
	
	function lifecycleAPI (Vue) {
	  /**
	   * Set instance target element and kick off the compilation
	   * process. The passed in `el` can be a selector string, an
	   * existing Element, or a DocumentFragment (for block
	   * instances).
	   *
	   * @param {Element|DocumentFragment|string} el
	   * @public
	   */
	
	  Vue.prototype.$mount = function (el) {
	    if (this._isCompiled) {
	      ("production") !== 'production' && warn('$mount() should be called only once.', this);
	      return;
	    }
	    el = query(el);
	    if (!el) {
	      el = document.createElement('div');
	    }
	    this._compile(el);
	    this._initDOMHooks();
	    if (inDoc(this.$el)) {
	      this._callHook('attached');
	      ready.call(this);
	    } else {
	      this.$once('hook:attached', ready);
	    }
	    return this;
	  };
	
	  /**
	   * Mark an instance as ready.
	   */
	
	  function ready() {
	    this._isAttached = true;
	    this._isReady = true;
	    this._callHook('ready');
	  }
	
	  /**
	   * Teardown the instance, simply delegate to the internal
	   * _destroy.
	   *
	   * @param {Boolean} remove
	   * @param {Boolean} deferCleanup
	   */
	
	  Vue.prototype.$destroy = function (remove, deferCleanup) {
	    this._destroy(remove, deferCleanup);
	  };
	
	  /**
	   * Partially compile a piece of DOM and return a
	   * decompile function.
	   *
	   * @param {Element|DocumentFragment} el
	   * @param {Vue} [host]
	   * @param {Object} [scope]
	   * @param {Fragment} [frag]
	   * @return {Function}
	   */
	
	  Vue.prototype.$compile = function (el, host, scope, frag) {
	    return compile(el, this.$options, true)(this, el, host, scope, frag);
	  };
	}
	
	/**
	 * The exposed Vue constructor.
	 *
	 * API conventions:
	 * - public API methods/properties are prefixed with `$`
	 * - internal methods/properties are prefixed with `_`
	 * - non-prefixed properties are assumed to be proxied user
	 *   data.
	 *
	 * @constructor
	 * @param {Object} [options]
	 * @public
	 */
	
	function Vue(options) {
	  this._init(options);
	}
	
	// install internals
	initMixin(Vue);
	stateMixin(Vue);
	eventsMixin(Vue);
	lifecycleMixin(Vue);
	miscMixin(Vue);
	
	// install instance APIs
	dataAPI(Vue);
	domAPI(Vue);
	eventsAPI(Vue);
	lifecycleAPI(Vue);
	
	var slot = {
	
	  priority: SLOT,
	  params: ['name'],
	
	  bind: function bind() {
	    // this was resolved during component transclusion
	    var name = this.params.name || 'default';
	    var content = this.vm._slotContents && this.vm._slotContents[name];
	    if (!content || !content.hasChildNodes()) {
	      this.fallback();
	    } else {
	      this.compile(content.cloneNode(true), this.vm._context, this.vm);
	    }
	  },
	
	  compile: function compile(content, context, host) {
	    if (content && context) {
	      if (this.el.hasChildNodes() && content.childNodes.length === 1 && content.childNodes[0].nodeType === 1 && content.childNodes[0].hasAttribute('v-if')) {
	        // if the inserted slot has v-if
	        // inject fallback content as the v-else
	        var elseBlock = document.createElement('template');
	        elseBlock.setAttribute('v-else', '');
	        elseBlock.innerHTML = this.el.innerHTML;
	        // the else block should be compiled in child scope
	        elseBlock._context = this.vm;
	        content.appendChild(elseBlock);
	      }
	      var scope = host ? host._scope : this._scope;
	      this.unlink = context.$compile(content, host, scope, this._frag);
	    }
	    if (content) {
	      replace(this.el, content);
	    } else {
	      remove(this.el);
	    }
	  },
	
	  fallback: function fallback() {
	    this.compile(extractContent(this.el, true), this.vm);
	  },
	
	  unbind: function unbind() {
	    if (this.unlink) {
	      this.unlink();
	    }
	  }
	};
	
	var partial = {
	
	  priority: PARTIAL,
	
	  params: ['name'],
	
	  // watch changes to name for dynamic partials
	  paramWatchers: {
	    name: function name(value) {
	      vIf.remove.call(this);
	      if (value) {
	        this.insert(value);
	      }
	    }
	  },
	
	  bind: function bind() {
	    this.anchor = createAnchor('v-partial');
	    replace(this.el, this.anchor);
	    this.insert(this.params.name);
	  },
	
	  insert: function insert(id) {
	    var partial = resolveAsset(this.vm.$options, 'partials', id, true);
	    if (partial) {
	      this.factory = new FragmentFactory(this.vm, partial);
	      vIf.insert.call(this);
	    }
	  },
	
	  unbind: function unbind() {
	    if (this.frag) {
	      this.frag.destroy();
	    }
	  }
	};
	
	var elementDirectives = {
	  slot: slot,
	  partial: partial
	};
	
	var convertArray = vFor._postProcess;
	
	/**
	 * Limit filter for arrays
	 *
	 * @param {Number} n
	 * @param {Number} offset (Decimal expected)
	 */
	
	function limitBy(arr, n, offset) {
	  offset = offset ? parseInt(offset, 10) : 0;
	  n = toNumber(n);
	  return typeof n === 'number' ? arr.slice(offset, offset + n) : arr;
	}
	
	/**
	 * Filter filter for arrays
	 *
	 * @param {String} search
	 * @param {String} [delimiter]
	 * @param {String} ...dataKeys
	 */
	
	function filterBy(arr, search, delimiter) {
	  arr = convertArray(arr);
	  if (search == null) {
	    return arr;
	  }
	  if (typeof search === 'function') {
	    return arr.filter(search);
	  }
	  // cast to lowercase string
	  search = ('' + search).toLowerCase();
	  // allow optional `in` delimiter
	  // because why not
	  var n = delimiter === 'in' ? 3 : 2;
	  // extract and flatten keys
	  var keys = Array.prototype.concat.apply([], toArray(arguments, n));
	  var res = [];
	  var item, key, val, j;
	  for (var i = 0, l = arr.length; i < l; i++) {
	    item = arr[i];
	    val = item && item.$value || item;
	    j = keys.length;
	    if (j) {
	      while (j--) {
	        key = keys[j];
	        if (key === '$key' && contains(item.$key, search) || contains(getPath(val, key), search)) {
	          res.push(item);
	          break;
	        }
	      }
	    } else if (contains(item, search)) {
	      res.push(item);
	    }
	  }
	  return res;
	}
	
	/**
	 * Order filter for arrays
	 *
	 * @param {String|Array<String>|Function} ...sortKeys
	 * @param {Number} [order]
	 */
	
	function orderBy(arr) {
	  var comparator = null;
	  var sortKeys = undefined;
	  arr = convertArray(arr);
	
	  // determine order (last argument)
	  var args = toArray(arguments, 1);
	  var order = args[args.length - 1];
	  if (typeof order === 'number') {
	    order = order < 0 ? -1 : 1;
	    args = args.length > 1 ? args.slice(0, -1) : args;
	  } else {
	    order = 1;
	  }
	
	  // determine sortKeys & comparator
	  var firstArg = args[0];
	  if (!firstArg) {
	    return arr;
	  } else if (typeof firstArg === 'function') {
	    // custom comparator
	    comparator = function (a, b) {
	      return firstArg(a, b) * order;
	    };
	  } else {
	    // string keys. flatten first
	    sortKeys = Array.prototype.concat.apply([], args);
	    comparator = function (a, b, i) {
	      i = i || 0;
	      return i >= sortKeys.length - 1 ? baseCompare(a, b, i) : baseCompare(a, b, i) || comparator(a, b, i + 1);
	    };
	  }
	
	  function baseCompare(a, b, sortKeyIndex) {
	    var sortKey = sortKeys[sortKeyIndex];
	    if (sortKey) {
	      if (sortKey !== '$key') {
	        if (isObject(a) && '$value' in a) a = a.$value;
	        if (isObject(b) && '$value' in b) b = b.$value;
	      }
	      a = isObject(a) ? getPath(a, sortKey) : a;
	      b = isObject(b) ? getPath(b, sortKey) : b;
	    }
	    return a === b ? 0 : a > b ? order : -order;
	  }
	
	  // sort on a copy to avoid mutating original array
	  return arr.slice().sort(comparator);
	}
	
	/**
	 * String contain helper
	 *
	 * @param {*} val
	 * @param {String} search
	 */
	
	function contains(val, search) {
	  var i;
	  if (isPlainObject(val)) {
	    var keys = Object.keys(val);
	    i = keys.length;
	    while (i--) {
	      if (contains(val[keys[i]], search)) {
	        return true;
	      }
	    }
	  } else if (isArray(val)) {
	    i = val.length;
	    while (i--) {
	      if (contains(val[i], search)) {
	        return true;
	      }
	    }
	  } else if (val != null) {
	    return val.toString().toLowerCase().indexOf(search) > -1;
	  }
	}
	
	var digitsRE = /(\d{3})(?=\d)/g;
	
	// asset collections must be a plain object.
	var filters = {
	
	  orderBy: orderBy,
	  filterBy: filterBy,
	  limitBy: limitBy,
	
	  /**
	   * Stringify value.
	   *
	   * @param {Number} indent
	   */
	
	  json: {
	    read: function read(value, indent) {
	      return typeof value === 'string' ? value : JSON.stringify(value, null, arguments.length > 1 ? indent : 2);
	    },
	    write: function write(value) {
	      try {
	        return JSON.parse(value);
	      } catch (e) {
	        return value;
	      }
	    }
	  },
	
	  /**
	   * 'abc' => 'Abc'
	   */
	
	  capitalize: function capitalize(value) {
	    if (!value && value !== 0) return '';
	    value = value.toString();
	    return value.charAt(0).toUpperCase() + value.slice(1);
	  },
	
	  /**
	   * 'abc' => 'ABC'
	   */
	
	  uppercase: function uppercase(value) {
	    return value || value === 0 ? value.toString().toUpperCase() : '';
	  },
	
	  /**
	   * 'AbC' => 'abc'
	   */
	
	  lowercase: function lowercase(value) {
	    return value || value === 0 ? value.toString().toLowerCase() : '';
	  },
	
	  /**
	   * 12345 => $12,345.00
	   *
	   * @param {String} sign
	   * @param {Number} decimals Decimal places
	   */
	
	  currency: function currency(value, _currency, decimals) {
	    value = parseFloat(value);
	    if (!isFinite(value) || !value && value !== 0) return '';
	    _currency = _currency != null ? _currency : '$';
	    decimals = decimals != null ? decimals : 2;
	    var stringified = Math.abs(value).toFixed(decimals);
	    var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
	    var i = _int.length % 3;
	    var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
	    var _float = decimals ? stringified.slice(-1 - decimals) : '';
	    var sign = value < 0 ? '-' : '';
	    return sign + _currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
	  },
	
	  /**
	   * 'item' => 'items'
	   *
	   * @params
	   *  an array of strings corresponding to
	   *  the single, double, triple ... forms of the word to
	   *  be pluralized. When the number to be pluralized
	   *  exceeds the length of the args, it will use the last
	   *  entry in the array.
	   *
	   *  e.g. ['single', 'double', 'triple', 'multiple']
	   */
	
	  pluralize: function pluralize(value) {
	    var args = toArray(arguments, 1);
	    var length = args.length;
	    if (length > 1) {
	      var index = value % 10 - 1;
	      return index in args ? args[index] : args[length - 1];
	    } else {
	      return args[0] + (value === 1 ? '' : 's');
	    }
	  },
	
	  /**
	   * Debounce a handler function.
	   *
	   * @param {Function} handler
	   * @param {Number} delay = 300
	   * @return {Function}
	   */
	
	  debounce: function debounce(handler, delay) {
	    if (!handler) return;
	    if (!delay) {
	      delay = 300;
	    }
	    return _debounce(handler, delay);
	  }
	};
	
	function installGlobalAPI (Vue) {
	  /**
	   * Vue and every constructor that extends Vue has an
	   * associated options object, which can be accessed during
	   * compilation steps as `this.constructor.options`.
	   *
	   * These can be seen as the default options of every
	   * Vue instance.
	   */
	
	  Vue.options = {
	    directives: directives,
	    elementDirectives: elementDirectives,
	    filters: filters,
	    transitions: {},
	    components: {},
	    partials: {},
	    replace: true
	  };
	
	  /**
	   * Expose useful internals
	   */
	
	  Vue.util = util;
	  Vue.config = config;
	  Vue.set = set;
	  Vue['delete'] = del;
	  Vue.nextTick = nextTick;
	
	  /**
	   * The following are exposed for advanced usage / plugins
	   */
	
	  Vue.compiler = compiler;
	  Vue.FragmentFactory = FragmentFactory;
	  Vue.internalDirectives = internalDirectives;
	  Vue.parsers = {
	    path: path,
	    text: text,
	    template: template,
	    directive: directive,
	    expression: expression
	  };
	
	  /**
	   * Each instance constructor, including Vue, has a unique
	   * cid. This enables us to create wrapped "child
	   * constructors" for prototypal inheritance and cache them.
	   */
	
	  Vue.cid = 0;
	  var cid = 1;
	
	  /**
	   * Class inheritance
	   *
	   * @param {Object} extendOptions
	   */
	
	  Vue.extend = function (extendOptions) {
	    extendOptions = extendOptions || {};
	    var Super = this;
	    var isFirstExtend = Super.cid === 0;
	    if (isFirstExtend && extendOptions._Ctor) {
	      return extendOptions._Ctor;
	    }
	    var name = extendOptions.name || Super.options.name;
	    if (false) {
	      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
	        warn('Invalid component name: "' + name + '". Component names ' + 'can only contain alphanumeric characaters and the hyphen.');
	        name = null;
	      }
	    }
	    var Sub = createClass(name || 'VueComponent');
	    Sub.prototype = Object.create(Super.prototype);
	    Sub.prototype.constructor = Sub;
	    Sub.cid = cid++;
	    Sub.options = mergeOptions(Super.options, extendOptions);
	    Sub['super'] = Super;
	    // allow further extension
	    Sub.extend = Super.extend;
	    // create asset registers, so extended classes
	    // can have their private assets too.
	    config._assetTypes.forEach(function (type) {
	      Sub[type] = Super[type];
	    });
	    // enable recursive self-lookup
	    if (name) {
	      Sub.options.components[name] = Sub;
	    }
	    // cache constructor
	    if (isFirstExtend) {
	      extendOptions._Ctor = Sub;
	    }
	    return Sub;
	  };
	
	  /**
	   * A function that returns a sub-class constructor with the
	   * given name. This gives us much nicer output when
	   * logging instances in the console.
	   *
	   * @param {String} name
	   * @return {Function}
	   */
	
	  function createClass(name) {
	    /* eslint-disable no-new-func */
	    return new Function('return function ' + classify(name) + ' (options) { this._init(options) }')();
	    /* eslint-enable no-new-func */
	  }
	
	  /**
	   * Plugin system
	   *
	   * @param {Object} plugin
	   */
	
	  Vue.use = function (plugin) {
	    /* istanbul ignore if */
	    if (plugin.installed) {
	      return;
	    }
	    // additional parameters
	    var args = toArray(arguments, 1);
	    args.unshift(this);
	    if (typeof plugin.install === 'function') {
	      plugin.install.apply(plugin, args);
	    } else {
	      plugin.apply(null, args);
	    }
	    plugin.installed = true;
	    return this;
	  };
	
	  /**
	   * Apply a global mixin by merging it into the default
	   * options.
	   */
	
	  Vue.mixin = function (mixin) {
	    Vue.options = mergeOptions(Vue.options, mixin);
	  };
	
	  /**
	   * Create asset registration methods with the following
	   * signature:
	   *
	   * @param {String} id
	   * @param {*} definition
	   */
	
	  config._assetTypes.forEach(function (type) {
	    Vue[type] = function (id, definition) {
	      if (!definition) {
	        return this.options[type + 's'][id];
	      } else {
	        /* istanbul ignore if */
	        if (false) {
	          if (type === 'component' && (commonTagRE.test(id) || reservedTagRE.test(id))) {
	            warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + id);
	          }
	        }
	        if (type === 'component' && isPlainObject(definition)) {
	          if (!definition.name) {
	            definition.name = id;
	          }
	          definition = Vue.extend(definition);
	        }
	        this.options[type + 's'][id] = definition;
	        return definition;
	      }
	    };
	  });
	
	  // expose internal transition API
	  extend(Vue.transition, transition);
	}
	
	installGlobalAPI(Vue);
	
	Vue.version = '1.0.28';
	
	// devtools global hook
	/* istanbul ignore next */
	setTimeout(function () {
	  if (config.devtools) {
	    if (devtools) {
	      devtools.emit('init', Vue);
	    } else if (false) {
	      console.log('Download the Vue Devtools for a better development experience:\n' + 'https://github.com/vuejs/vue-devtools');
	    }
	  }
	}, 0);
	
	module.exports = Vue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var guid = __webpack_require__(222);
	
	var Eventful = __webpack_require__(49);
	
	var Transformable = __webpack_require__(139);
	
	var Animatable = __webpack_require__(758);
	
	var zrUtil = __webpack_require__(1);
	
	/**
	 * @alias module:zrender/Element
	 * @constructor
	 * @extends {module:zrender/mixin/Animatable}
	 * @extends {module:zrender/mixin/Transformable}
	 * @extends {module:zrender/mixin/Eventful}
	 */
	var Element = function (opts) {
	  // jshint ignore:line
	  Transformable.call(this, opts);
	  Eventful.call(this, opts);
	  Animatable.call(this, opts);
	  /**
	   * 画布元素ID
	   * @type {string}
	   */
	
	  this.id = opts.id || guid();
	};
	
	Element.prototype = {
	  /**
	   * 元素类型
	   * Element type
	   * @type {string}
	   */
	  type: 'element',
	
	  /**
	   * 元素名字
	   * Element name
	   * @type {string}
	   */
	  name: '',
	
	  /**
	   * ZRender 实例对象，会在 element 添加到 zrender 实例中后自动赋值
	   * ZRender instance will be assigned when element is associated with zrender
	   * @name module:/zrender/Element#__zr
	   * @type {module:zrender/ZRender}
	   */
	  __zr: null,
	
	  /**
	   * 图形是否忽略，为true时忽略图形的绘制以及事件触发
	   * If ignore drawing and events of the element object
	   * @name module:/zrender/Element#ignore
	   * @type {boolean}
	   * @default false
	   */
	  ignore: false,
	
	  /**
	   * 用于裁剪的路径(shape)，所有 Group 内的路径在绘制时都会被这个路径裁剪
	   * 该路径会继承被裁减对象的变换
	   * @type {module:zrender/graphic/Path}
	   * @see http://www.w3.org/TR/2dcontext/#clipping-region
	   * @readOnly
	   */
	  clipPath: null,
	
	  /**
	   * Drift element
	   * @param  {number} dx dx on the global space
	   * @param  {number} dy dy on the global space
	   */
	  drift: function (dx, dy) {
	    switch (this.draggable) {
	      case 'horizontal':
	        dy = 0;
	        break;
	
	      case 'vertical':
	        dx = 0;
	        break;
	    }
	
	    var m = this.transform;
	
	    if (!m) {
	      m = this.transform = [1, 0, 0, 1, 0, 0];
	    }
	
	    m[4] += dx;
	    m[5] += dy;
	    this.decomposeTransform();
	    this.dirty(false);
	  },
	
	  /**
	   * Hook before update
	   */
	  beforeUpdate: function () {},
	
	  /**
	   * Hook after update
	   */
	  afterUpdate: function () {},
	
	  /**
	   * Update each frame
	   */
	  update: function () {
	    this.updateTransform();
	  },
	
	  /**
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {},
	
	  /**
	   * @protected
	   */
	  attrKV: function (key, value) {
	    if (key === 'position' || key === 'scale' || key === 'origin') {
	      // Copy the array
	      if (value) {
	        var target = this[key];
	
	        if (!target) {
	          target = this[key] = [];
	        }
	
	        target[0] = value[0];
	        target[1] = value[1];
	      }
	    } else {
	      this[key] = value;
	    }
	  },
	
	  /**
	   * Hide the element
	   */
	  hide: function () {
	    this.ignore = true;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * Show the element
	   */
	  show: function () {
	    this.ignore = false;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * @param {string|Object} key
	   * @param {*} value
	   */
	  attr: function (key, value) {
	    if (typeof key === 'string') {
	      this.attrKV(key, value);
	    } else if (zrUtil.isObject(key)) {
	      for (var name in key) {
	        if (key.hasOwnProperty(name)) {
	          this.attrKV(name, key[name]);
	        }
	      }
	    }
	
	    this.dirty(false);
	    return this;
	  },
	
	  /**
	   * @param {module:zrender/graphic/Path} clipPath
	   */
	  setClipPath: function (clipPath) {
	    var zr = this.__zr;
	
	    if (zr) {
	      clipPath.addSelfToZr(zr);
	    } // Remove previous clip path
	
	
	    if (this.clipPath && this.clipPath !== clipPath) {
	      this.removeClipPath();
	    }
	
	    this.clipPath = clipPath;
	    clipPath.__zr = zr;
	    clipPath.__clipTarget = this;
	    this.dirty(false);
	  },
	
	  /**
	   */
	  removeClipPath: function () {
	    var clipPath = this.clipPath;
	
	    if (clipPath) {
	      if (clipPath.__zr) {
	        clipPath.removeSelfFromZr(clipPath.__zr);
	      }
	
	      clipPath.__zr = null;
	      clipPath.__clipTarget = null;
	      this.clipPath = null;
	      this.dirty(false);
	    }
	  },
	
	  /**
	   * Add self from zrender instance.
	   * Not recursively because it will be invoked when element added to storage.
	   * @param {module:zrender/ZRender} zr
	   */
	  addSelfToZr: function (zr) {
	    this.__zr = zr; // 添加动画
	
	    var animators = this.animators;
	
	    if (animators) {
	      for (var i = 0; i < animators.length; i++) {
	        zr.animation.addAnimator(animators[i]);
	      }
	    }
	
	    if (this.clipPath) {
	      this.clipPath.addSelfToZr(zr);
	    }
	  },
	
	  /**
	   * Remove self from zrender instance.
	   * Not recursively because it will be invoked when element added to storage.
	   * @param {module:zrender/ZRender} zr
	   */
	  removeSelfFromZr: function (zr) {
	    this.__zr = null; // 移除动画
	
	    var animators = this.animators;
	
	    if (animators) {
	      for (var i = 0; i < animators.length; i++) {
	        zr.animation.removeAnimator(animators[i]);
	      }
	    }
	
	    if (this.clipPath) {
	      this.clipPath.removeSelfFromZr(zr);
	    }
	  }
	};
	zrUtil.mixin(Element, Animatable);
	zrUtil.mixin(Element, Transformable);
	zrUtil.mixin(Element, Eventful);
	var _default = Element;
	module.exports = _default;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var Clip = __webpack_require__(737);
	
	var color = __webpack_require__(31);
	
	var _util = __webpack_require__(1);
	
	var isArrayLike = _util.isArrayLike;
	
	/**
	 * @module echarts/animation/Animator
	 */
	var arraySlice = Array.prototype.slice;
	
	function defaultGetter(target, key) {
	  return target[key];
	}
	
	function defaultSetter(target, key, value) {
	  target[key] = value;
	}
	/**
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} percent
	 * @return {number}
	 */
	
	
	function interpolateNumber(p0, p1, percent) {
	  return (p1 - p0) * percent + p0;
	}
	/**
	 * @param  {string} p0
	 * @param  {string} p1
	 * @param  {number} percent
	 * @return {string}
	 */
	
	
	function interpolateString(p0, p1, percent) {
	  return percent > 0.5 ? p1 : p0;
	}
	/**
	 * @param  {Array} p0
	 * @param  {Array} p1
	 * @param  {number} percent
	 * @param  {Array} out
	 * @param  {number} arrDim
	 */
	
	
	function interpolateArray(p0, p1, percent, out, arrDim) {
	  var len = p0.length;
	
	  if (arrDim == 1) {
	    for (var i = 0; i < len; i++) {
	      out[i] = interpolateNumber(p0[i], p1[i], percent);
	    }
	  } else {
	    var len2 = len && p0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        out[i][j] = interpolateNumber(p0[i][j], p1[i][j], percent);
	      }
	    }
	  }
	} // arr0 is source array, arr1 is target array.
	// Do some preprocess to avoid error happened when interpolating from arr0 to arr1
	
	
	function fillArr(arr0, arr1, arrDim) {
	  var arr0Len = arr0.length;
	  var arr1Len = arr1.length;
	
	  if (arr0Len !== arr1Len) {
	    // FIXME Not work for TypedArray
	    var isPreviousLarger = arr0Len > arr1Len;
	
	    if (isPreviousLarger) {
	      // Cut the previous
	      arr0.length = arr1Len;
	    } else {
	      // Fill the previous
	      for (var i = arr0Len; i < arr1Len; i++) {
	        arr0.push(arrDim === 1 ? arr1[i] : arraySlice.call(arr1[i]));
	      }
	    }
	  } // Handling NaN value
	
	
	  var len2 = arr0[0] && arr0[0].length;
	
	  for (var i = 0; i < arr0.length; i++) {
	    if (arrDim === 1) {
	      if (isNaN(arr0[i])) {
	        arr0[i] = arr1[i];
	      }
	    } else {
	      for (var j = 0; j < len2; j++) {
	        if (isNaN(arr0[i][j])) {
	          arr0[i][j] = arr1[i][j];
	        }
	      }
	    }
	  }
	}
	/**
	 * @param  {Array} arr0
	 * @param  {Array} arr1
	 * @param  {number} arrDim
	 * @return {boolean}
	 */
	
	
	function isArraySame(arr0, arr1, arrDim) {
	  if (arr0 === arr1) {
	    return true;
	  }
	
	  var len = arr0.length;
	
	  if (len !== arr1.length) {
	    return false;
	  }
	
	  if (arrDim === 1) {
	    for (var i = 0; i < len; i++) {
	      if (arr0[i] !== arr1[i]) {
	        return false;
	      }
	    }
	  } else {
	    var len2 = arr0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        if (arr0[i][j] !== arr1[i][j]) {
	          return false;
	        }
	      }
	    }
	  }
	
	  return true;
	}
	/**
	 * Catmull Rom interpolate array
	 * @param  {Array} p0
	 * @param  {Array} p1
	 * @param  {Array} p2
	 * @param  {Array} p3
	 * @param  {number} t
	 * @param  {number} t2
	 * @param  {number} t3
	 * @param  {Array} out
	 * @param  {number} arrDim
	 */
	
	
	function catmullRomInterpolateArray(p0, p1, p2, p3, t, t2, t3, out, arrDim) {
	  var len = p0.length;
	
	  if (arrDim == 1) {
	    for (var i = 0; i < len; i++) {
	      out[i] = catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
	    }
	  } else {
	    var len2 = p0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        out[i][j] = catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
	      }
	    }
	  }
	}
	/**
	 * Catmull Rom interpolate number
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @param  {number} t2
	 * @param  {number} t3
	 * @return {number}
	 */
	
	
	function catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
	  var v0 = (p2 - p0) * 0.5;
	  var v1 = (p3 - p1) * 0.5;
	  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
	}
	
	function cloneValue(value) {
	  if (isArrayLike(value)) {
	    var len = value.length;
	
	    if (isArrayLike(value[0])) {
	      var ret = [];
	
	      for (var i = 0; i < len; i++) {
	        ret.push(arraySlice.call(value[i]));
	      }
	
	      return ret;
	    }
	
	    return arraySlice.call(value);
	  }
	
	  return value;
	}
	
	function rgba2String(rgba) {
	  rgba[0] = Math.floor(rgba[0]);
	  rgba[1] = Math.floor(rgba[1]);
	  rgba[2] = Math.floor(rgba[2]);
	  return 'rgba(' + rgba.join(',') + ')';
	}
	
	function getArrayDim(keyframes) {
	  var lastValue = keyframes[keyframes.length - 1].value;
	  return isArrayLike(lastValue && lastValue[0]) ? 2 : 1;
	}
	
	function createTrackClip(animator, easing, oneTrackDone, keyframes, propName, forceAnimate) {
	  var getter = animator._getter;
	  var setter = animator._setter;
	  var useSpline = easing === 'spline';
	  var trackLen = keyframes.length;
	
	  if (!trackLen) {
	    return;
	  } // Guess data type
	
	
	  var firstVal = keyframes[0].value;
	  var isValueArray = isArrayLike(firstVal);
	  var isValueColor = false;
	  var isValueString = false; // For vertices morphing
	
	  var arrDim = isValueArray ? getArrayDim(keyframes) : 0;
	  var trackMaxTime; // Sort keyframe as ascending
	
	  keyframes.sort(function (a, b) {
	    return a.time - b.time;
	  });
	  trackMaxTime = keyframes[trackLen - 1].time; // Percents of each keyframe
	
	  var kfPercents = []; // Value of each keyframe
	
	  var kfValues = [];
	  var prevValue = keyframes[0].value;
	  var isAllValueEqual = true;
	
	  for (var i = 0; i < trackLen; i++) {
	    kfPercents.push(keyframes[i].time / trackMaxTime); // Assume value is a color when it is a string
	
	    var value = keyframes[i].value; // Check if value is equal, deep check if value is array
	
	    if (!(isValueArray && isArraySame(value, prevValue, arrDim) || !isValueArray && value === prevValue)) {
	      isAllValueEqual = false;
	    }
	
	    prevValue = value; // Try converting a string to a color array
	
	    if (typeof value == 'string') {
	      var colorArray = color.parse(value);
	
	      if (colorArray) {
	        value = colorArray;
	        isValueColor = true;
	      } else {
	        isValueString = true;
	      }
	    }
	
	    kfValues.push(value);
	  }
	
	  if (!forceAnimate && isAllValueEqual) {
	    return;
	  }
	
	  var lastValue = kfValues[trackLen - 1]; // Polyfill array and NaN value
	
	  for (var i = 0; i < trackLen - 1; i++) {
	    if (isValueArray) {
	      fillArr(kfValues[i], lastValue, arrDim);
	    } else {
	      if (isNaN(kfValues[i]) && !isNaN(lastValue) && !isValueString && !isValueColor) {
	        kfValues[i] = lastValue;
	      }
	    }
	  }
	
	  isValueArray && fillArr(getter(animator._target, propName), lastValue, arrDim); // Cache the key of last frame to speed up when
	  // animation playback is sequency
	
	  var lastFrame = 0;
	  var lastFramePercent = 0;
	  var start;
	  var w;
	  var p0;
	  var p1;
	  var p2;
	  var p3;
	
	  if (isValueColor) {
	    var rgba = [0, 0, 0, 0];
	  }
	
	  var onframe = function (target, percent) {
	    // Find the range keyframes
	    // kf1-----kf2---------current--------kf3
	    // find kf2 and kf3 and do interpolation
	    var frame; // In the easing function like elasticOut, percent may less than 0
	
	    if (percent < 0) {
	      frame = 0;
	    } else if (percent < lastFramePercent) {
	      // Start from next key
	      // PENDING start from lastFrame ?
	      start = Math.min(lastFrame + 1, trackLen - 1);
	
	      for (frame = start; frame >= 0; frame--) {
	        if (kfPercents[frame] <= percent) {
	          break;
	        }
	      } // PENDING really need to do this ?
	
	
	      frame = Math.min(frame, trackLen - 2);
	    } else {
	      for (frame = lastFrame; frame < trackLen; frame++) {
	        if (kfPercents[frame] > percent) {
	          break;
	        }
	      }
	
	      frame = Math.min(frame - 1, trackLen - 2);
	    }
	
	    lastFrame = frame;
	    lastFramePercent = percent;
	    var range = kfPercents[frame + 1] - kfPercents[frame];
	
	    if (range === 0) {
	      return;
	    } else {
	      w = (percent - kfPercents[frame]) / range;
	    }
	
	    if (useSpline) {
	      p1 = kfValues[frame];
	      p0 = kfValues[frame === 0 ? frame : frame - 1];
	      p2 = kfValues[frame > trackLen - 2 ? trackLen - 1 : frame + 1];
	      p3 = kfValues[frame > trackLen - 3 ? trackLen - 1 : frame + 2];
	
	      if (isValueArray) {
	        catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, getter(target, propName), arrDim);
	      } else {
	        var value;
	
	        if (isValueColor) {
	          value = catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, rgba, 1);
	          value = rgba2String(rgba);
	        } else if (isValueString) {
	          // String is step(0.5)
	          return interpolateString(p1, p2, w);
	        } else {
	          value = catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
	        }
	
	        setter(target, propName, value);
	      }
	    } else {
	      if (isValueArray) {
	        interpolateArray(kfValues[frame], kfValues[frame + 1], w, getter(target, propName), arrDim);
	      } else {
	        var value;
	
	        if (isValueColor) {
	          interpolateArray(kfValues[frame], kfValues[frame + 1], w, rgba, 1);
	          value = rgba2String(rgba);
	        } else if (isValueString) {
	          // String is step(0.5)
	          return interpolateString(kfValues[frame], kfValues[frame + 1], w);
	        } else {
	          value = interpolateNumber(kfValues[frame], kfValues[frame + 1], w);
	        }
	
	        setter(target, propName, value);
	      }
	    }
	  };
	
	  var clip = new Clip({
	    target: animator._target,
	    life: trackMaxTime,
	    loop: animator._loop,
	    delay: animator._delay,
	    onframe: onframe,
	    ondestroy: oneTrackDone
	  });
	
	  if (easing && easing !== 'spline') {
	    clip.easing = easing;
	  }
	
	  return clip;
	}
	/**
	 * @alias module:zrender/animation/Animator
	 * @constructor
	 * @param {Object} target
	 * @param {boolean} loop
	 * @param {Function} getter
	 * @param {Function} setter
	 */
	
	
	var Animator = function (target, loop, getter, setter) {
	  this._tracks = {};
	  this._target = target;
	  this._loop = loop || false;
	  this._getter = getter || defaultGetter;
	  this._setter = setter || defaultSetter;
	  this._clipCount = 0;
	  this._delay = 0;
	  this._doneList = [];
	  this._onframeList = [];
	  this._clipList = [];
	};
	
	Animator.prototype = {
	  /**
	   * 设置动画关键帧
	   * @param  {number} time 关键帧时间，单位是ms
	   * @param  {Object} props 关键帧的属性值，key-value表示
	   * @return {module:zrender/animation/Animator}
	   */
	  when: function (time
	  /* ms */
	  , props) {
	    var tracks = this._tracks;
	
	    for (var propName in props) {
	      if (!props.hasOwnProperty(propName)) {
	        continue;
	      }
	
	      if (!tracks[propName]) {
	        tracks[propName] = []; // Invalid value
	
	        var value = this._getter(this._target, propName);
	
	        if (value == null) {
	          // zrLog('Invalid property ' + propName);
	          continue;
	        } // If time is 0
	        //  Then props is given initialize value
	        // Else
	        //  Initialize value from current prop value
	
	
	        if (time !== 0) {
	          tracks[propName].push({
	            time: 0,
	            value: cloneValue(value)
	          });
	        }
	      }
	
	      tracks[propName].push({
	        time: time,
	        value: props[propName]
	      });
	    }
	
	    return this;
	  },
	
	  /**
	   * 添加动画每一帧的回调函数
	   * @param  {Function} callback
	   * @return {module:zrender/animation/Animator}
	   */
	  during: function (callback) {
	    this._onframeList.push(callback);
	
	    return this;
	  },
	  pause: function () {
	    for (var i = 0; i < this._clipList.length; i++) {
	      this._clipList[i].pause();
	    }
	
	    this._paused = true;
	  },
	  resume: function () {
	    for (var i = 0; i < this._clipList.length; i++) {
	      this._clipList[i].resume();
	    }
	
	    this._paused = false;
	  },
	  isPaused: function () {
	    return !!this._paused;
	  },
	  _doneCallback: function () {
	    // Clear all tracks
	    this._tracks = {}; // Clear all clips
	
	    this._clipList.length = 0;
	    var doneList = this._doneList;
	    var len = doneList.length;
	
	    for (var i = 0; i < len; i++) {
	      doneList[i].call(this);
	    }
	  },
	
	  /**
	   * 开始执行动画
	   * @param  {string|Function} [easing]
	   *         动画缓动函数，详见{@link module:zrender/animation/easing}
	   * @param  {boolean} forceAnimate
	   * @return {module:zrender/animation/Animator}
	   */
	  start: function (easing, forceAnimate) {
	    var self = this;
	    var clipCount = 0;
	
	    var oneTrackDone = function () {
	      clipCount--;
	
	      if (!clipCount) {
	        self._doneCallback();
	      }
	    };
	
	    var lastClip;
	
	    for (var propName in this._tracks) {
	      if (!this._tracks.hasOwnProperty(propName)) {
	        continue;
	      }
	
	      var clip = createTrackClip(this, easing, oneTrackDone, this._tracks[propName], propName, forceAnimate);
	
	      if (clip) {
	        this._clipList.push(clip);
	
	        clipCount++; // If start after added to animation
	
	        if (this.animation) {
	          this.animation.addClip(clip);
	        }
	
	        lastClip = clip;
	      }
	    } // Add during callback on the last clip
	
	
	    if (lastClip) {
	      var oldOnFrame = lastClip.onframe;
	
	      lastClip.onframe = function (target, percent) {
	        oldOnFrame(target, percent);
	
	        for (var i = 0; i < self._onframeList.length; i++) {
	          self._onframeList[i](target, percent);
	        }
	      };
	    } // This optimization will help the case that in the upper application
	    // the view may be refreshed frequently, where animation will be
	    // called repeatly but nothing changed.
	
	
	    if (!clipCount) {
	      this._doneCallback();
	    }
	
	    return this;
	  },
	
	  /**
	   * 停止动画
	   * @param {boolean} forwardToLast If move to last frame before stop
	   */
	  stop: function (forwardToLast) {
	    var clipList = this._clipList;
	    var animation = this.animation;
	
	    for (var i = 0; i < clipList.length; i++) {
	      var clip = clipList[i];
	
	      if (forwardToLast) {
	        // Move to last frame before stop
	        clip.onframe(this._target, 1);
	      }
	
	      animation && animation.removeClip(clip);
	    }
	
	    clipList.length = 0;
	  },
	
	  /**
	   * 设置动画延迟开始的时间
	   * @param  {number} time 单位ms
	   * @return {module:zrender/animation/Animator}
	   */
	  delay: function (time) {
	    this._delay = time;
	    return this;
	  },
	
	  /**
	   * 添加动画结束的回调
	   * @param  {Function} cb
	   * @return {module:zrender/animation/Animator}
	   */
	  done: function (cb) {
	    if (cb) {
	      this._doneList.push(cb);
	    }
	
	    return this;
	  },
	
	  /**
	   * @return {Array.<module:zrender/animation/Clip>}
	   */
	  getClips: function () {
	    return this._clipList;
	  }
	};
	var _default = Animator;
	module.exports = _default;

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	var _default = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || // https://github.com/ecomfe/zrender/issues/189#issuecomment-224919809
	window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function (func) {
	  setTimeout(func, 16);
	};
	
	module.exports = _default;

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	/**
	 * 线段包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth;
	  var _a = 0;
	  var _b = x0; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) {
	    return false;
	  }
	
	  if (x0 !== x1) {
	    _a = (y0 - y1) / (x0 - x1);
	    _b = (x0 * y1 - x1 * y0) / (x0 - x1);
	  } else {
	    return Math.abs(x - x0) <= _l / 2;
	  }
	
	  var tmp = _a * x - y + _b;
	
	  var _s = tmp * tmp / (_a * _a + 1);
	
	  return _s <= _l / 2 * _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var windingLine = __webpack_require__(220);
	
	var EPSILON = 1e-8;
	
	function isAroundEqual(a, b) {
	  return Math.abs(a - b) < EPSILON;
	}
	
	function contain(points, x, y) {
	  var w = 0;
	  var p = points[0];
	
	  if (!p) {
	    return false;
	  }
	
	  for (var i = 1; i < points.length; i++) {
	    var p2 = points[i];
	    w += windingLine(p[0], p[1], p2[0], p2[1], x, y);
	    p = p2;
	  } // Close polygon
	
	
	  var p0 = points[0];
	
	  if (!isAroundEqual(p[0], p0[0]) || !isAroundEqual(p[1], p0[1])) {
	    w += windingLine(p[0], p[1], p0[0], p0[1], x, y);
	  }
	
	  return w !== 0;
	}
	
	exports.contain = contain;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var _curve = __webpack_require__(40);
	
	var quadraticProjectPoint = _curve.quadraticProjectPoint;
	
	/**
	 * 二次贝塞尔曲线描边包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  x2
	 * @param  {number}  y2
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) {
	    return false;
	  }
	
	  var d = quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, null);
	  return d <= _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	var PI2 = Math.PI * 2;
	
	function normalizeRadian(angle) {
	  angle %= PI2;
	
	  if (angle < 0) {
	    angle += PI2;
	  }
	
	  return angle;
	}
	
	exports.normalizeRadian = normalizeRadian;

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	function windingLine(x0, y0, x1, y1, x, y) {
	  if (y > y0 && y > y1 || y < y0 && y < y1) {
	    return 0;
	  } // Ignore horizontal line
	
	
	  if (y1 === y0) {
	    return 0;
	  }
	
	  var dir = y1 < y0 ? 1 : -1;
	  var t = (y - y0) / (y1 - y0); // Avoid winding error when intersection point is the connect point of two line of polygon
	
	  if (t === 1 || t === 0) {
	    dir = y1 < y0 ? 0.5 : -0.5;
	  }
	
	  var x_ = t * (x1 - x0) + x0;
	  return x_ > x ? dir : 0;
	}
	
	module.exports = windingLine;

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	// Simple LRU cache use doubly linked list
	// @module zrender/core/LRU
	
	/**
	 * Simple double linked list. Compared with array, it has O(1) remove operation.
	 * @constructor
	 */
	var LinkedList = function () {
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	  this.head = null;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.tail = null;
	  this._len = 0;
	};
	
	var linkedListProto = LinkedList.prototype;
	/**
	 * Insert a new value at the tail
	 * @param  {} val
	 * @return {module:zrender/core/LRU~Entry}
	 */
	
	linkedListProto.insert = function (val) {
	  var entry = new Entry(val);
	  this.insertEntry(entry);
	  return entry;
	};
	/**
	 * Insert an entry at the tail
	 * @param  {module:zrender/core/LRU~Entry} entry
	 */
	
	
	linkedListProto.insertEntry = function (entry) {
	  if (!this.head) {
	    this.head = this.tail = entry;
	  } else {
	    this.tail.next = entry;
	    entry.prev = this.tail;
	    entry.next = null;
	    this.tail = entry;
	  }
	
	  this._len++;
	};
	/**
	 * Remove entry.
	 * @param  {module:zrender/core/LRU~Entry} entry
	 */
	
	
	linkedListProto.remove = function (entry) {
	  var prev = entry.prev;
	  var next = entry.next;
	
	  if (prev) {
	    prev.next = next;
	  } else {
	    // Is head
	    this.head = next;
	  }
	
	  if (next) {
	    next.prev = prev;
	  } else {
	    // Is tail
	    this.tail = prev;
	  }
	
	  entry.next = entry.prev = null;
	  this._len--;
	};
	/**
	 * @return {number}
	 */
	
	
	linkedListProto.len = function () {
	  return this._len;
	};
	/**
	 * Clear list
	 */
	
	
	linkedListProto.clear = function () {
	  this.head = this.tail = null;
	  this._len = 0;
	};
	/**
	 * @constructor
	 * @param {} val
	 */
	
	
	var Entry = function (val) {
	  /**
	   * @type {}
	   */
	  this.value = val;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.next;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.prev;
	};
	/**
	 * LRU Cache
	 * @constructor
	 * @alias module:zrender/core/LRU
	 */
	
	
	var LRU = function (maxSize) {
	  this._list = new LinkedList();
	  this._map = {};
	  this._maxSize = maxSize || 10;
	  this._lastRemovedEntry = null;
	};
	
	var LRUProto = LRU.prototype;
	/**
	 * @param  {string} key
	 * @param  {} value
	 * @return {} Removed value
	 */
	
	LRUProto.put = function (key, value) {
	  var list = this._list;
	  var map = this._map;
	  var removed = null;
	
	  if (map[key] == null) {
	    var len = list.len(); // Reuse last removed entry
	
	    var entry = this._lastRemovedEntry;
	
	    if (len >= this._maxSize && len > 0) {
	      // Remove the least recently used
	      var leastUsedEntry = list.head;
	      list.remove(leastUsedEntry);
	      delete map[leastUsedEntry.key];
	      removed = leastUsedEntry.value;
	      this._lastRemovedEntry = leastUsedEntry;
	    }
	
	    if (entry) {
	      entry.value = value;
	    } else {
	      entry = new Entry(value);
	    }
	
	    entry.key = key;
	    list.insertEntry(entry);
	    map[key] = entry;
	  }
	
	  return removed;
	};
	/**
	 * @param  {string} key
	 * @return {}
	 */
	
	
	LRUProto.get = function (key) {
	  var entry = this._map[key];
	  var list = this._list;
	
	  if (entry != null) {
	    // Put the latest used entry in the tail
	    if (entry !== list.tail) {
	      list.remove(entry);
	      list.insertEntry(entry);
	    }
	
	    return entry.value;
	  }
	};
	/**
	 * Clear the cache
	 */
	
	
	LRUProto.clear = function () {
	  this._list.clear();
	
	  this._map = {};
	};
	
	var _default = LRU;
	module.exports = _default;

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	/**
	 * zrender: 生成唯一id
	 *
	 * @author errorrik (errorrik@gmail.com)
	 */
	var idStart = 0x0907;
	
	function _default() {
	  return idStart++;
	}
	
	module.exports = _default;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Gradient = __webpack_require__(99);
	
	/**
	 * x, y, x2, y2 are all percent from 0 to 1
	 * @param {number} [x=0]
	 * @param {number} [y=0]
	 * @param {number} [x2=1]
	 * @param {number} [y2=0]
	 * @param {Array.<Object>} colorStops
	 * @param {boolean} [globalCoord=false]
	 */
	var LinearGradient = function (x, y, x2, y2, colorStops, globalCoord) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {type: 'linear', colorStops: ...}`, where
	  // this constructor will not be called.
	  this.x = x == null ? 0 : x;
	  this.y = y == null ? 0 : y;
	  this.x2 = x2 == null ? 1 : x2;
	  this.y2 = y2 == null ? 0 : y2; // Can be cloned
	
	  this.type = 'linear'; // If use global coord
	
	  this.global = globalCoord || false;
	  Gradient.call(this, colorStops);
	};
	
	LinearGradient.prototype = {
	  constructor: LinearGradient
	};
	zrUtil.inherits(LinearGradient, Gradient);
	var _default = LinearGradient;
	module.exports = _default;

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	var Pattern = function (image, repeat) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {image: ...}`, where this constructor will not be called.
	  this.image = image;
	  this.repeat = repeat; // Can be cloned
	
	  this.type = 'pattern';
	};
	
	Pattern.prototype.getCanvasPattern = function (ctx) {
	  return ctx.createPattern(this.image, this.repeat || 'repeat');
	};
	
	var _default = Pattern;
	module.exports = _default;

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	var STYLE_COMMON_PROPS = [['shadowBlur', 0], ['shadowOffsetX', 0], ['shadowOffsetY', 0], ['shadowColor', '#000'], ['lineCap', 'butt'], ['lineJoin', 'miter'], ['miterLimit', 10]]; // var SHADOW_PROPS = STYLE_COMMON_PROPS.slice(0, 4);
	// var LINE_PROPS = STYLE_COMMON_PROPS.slice(4);
	
	var Style = function (opts, host) {
	  this.extendFrom(opts, false);
	  this.host = host;
	};
	
	function createLinearGradient(ctx, obj, rect) {
	  var x = obj.x == null ? 0 : obj.x;
	  var x2 = obj.x2 == null ? 1 : obj.x2;
	  var y = obj.y == null ? 0 : obj.y;
	  var y2 = obj.y2 == null ? 0 : obj.y2;
	
	  if (!obj.global) {
	    x = x * rect.width + rect.x;
	    x2 = x2 * rect.width + rect.x;
	    y = y * rect.height + rect.y;
	    y2 = y2 * rect.height + rect.y;
	  }
	
	  var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
	  return canvasGradient;
	}
	
	function createRadialGradient(ctx, obj, rect) {
	  var width = rect.width;
	  var height = rect.height;
	  var min = Math.min(width, height);
	  var x = obj.x == null ? 0.5 : obj.x;
	  var y = obj.y == null ? 0.5 : obj.y;
	  var r = obj.r == null ? 0.5 : obj.r;
	
	  if (!obj.global) {
	    x = x * width + rect.x;
	    y = y * height + rect.y;
	    r = r * min;
	  }
	
	  var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
	  return canvasGradient;
	}
	
	Style.prototype = {
	  constructor: Style,
	
	  /**
	   * @type {module:zrender/graphic/Displayable}
	   */
	  host: null,
	
	  /**
	   * @type {string}
	   */
	  fill: '#000',
	
	  /**
	   * @type {string}
	   */
	  stroke: null,
	
	  /**
	   * @type {number}
	   */
	  opacity: 1,
	
	  /**
	   * @type {Array.<number>}
	   */
	  lineDash: null,
	
	  /**
	   * @type {number}
	   */
	  lineDashOffset: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowOffsetY: 0,
	
	  /**
	   * @type {number}
	   */
	  lineWidth: 1,
	
	  /**
	   * If stroke ignore scale
	   * @type {Boolean}
	   */
	  strokeNoScale: false,
	  // Bounding rect text configuration
	  // Not affected by element transform
	
	  /**
	   * @type {string}
	   */
	  text: null,
	
	  /**
	   * If `fontSize` or `fontFamily` exists, `font` will be reset by
	   * `fontSize`, `fontStyle`, `fontWeight`, `fontFamily`.
	   * So do not visit it directly in upper application (like echarts),
	   * but use `contain/text#makeFont` instead.
	   * @type {string}
	   */
	  font: null,
	
	  /**
	   * The same as font. Use font please.
	   * @deprecated
	   * @type {string}
	   */
	  textFont: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontStyle: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontWeight: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * Should be 12 but not '12px'.
	   * @type {number}
	   */
	  fontSize: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontFamily: null,
	
	  /**
	   * Reserved for special functinality, like 'hr'.
	   * @type {string}
	   */
	  textTag: null,
	
	  /**
	   * @type {string}
	   */
	  textFill: '#000',
	
	  /**
	   * @type {string}
	   */
	  textStroke: null,
	
	  /**
	   * @type {number}
	   */
	  textWidth: null,
	
	  /**
	   * Only for textBackground.
	   * @type {number}
	   */
	  textHeight: null,
	
	  /**
	   * textStroke may be set as some color as a default
	   * value in upper applicaion, where the default value
	   * of textStrokeWidth should be 0 to make sure that
	   * user can choose to do not use text stroke.
	   * @type {number}
	   */
	  textStrokeWidth: 0,
	
	  /**
	   * @type {number}
	   */
	  textLineHeight: null,
	
	  /**
	   * 'inside', 'left', 'right', 'top', 'bottom'
	   * [x, y]
	   * Based on x, y of rect.
	   * @type {string|Array.<number>}
	   * @default 'inside'
	   */
	  textPosition: 'inside',
	
	  /**
	   * If not specified, use the boundingRect of a `displayable`.
	   * @type {Object}
	   */
	  textRect: null,
	
	  /**
	   * [x, y]
	   * @type {Array.<number>}
	   */
	  textOffset: null,
	
	  /**
	   * @type {string}
	   */
	  textAlign: null,
	
	  /**
	   * @type {string}
	   */
	  textVerticalAlign: null,
	
	  /**
	   * @type {number}
	   */
	  textDistance: 5,
	
	  /**
	   * @type {string}
	   */
	  textShadowColor: 'transparent',
	
	  /**
	   * @type {number}
	   */
	  textShadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  textShadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  textShadowOffsetY: 0,
	
	  /**
	   * @type {string}
	   */
	  textBoxShadowColor: 'transparent',
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowOffsetY: 0,
	
	  /**
	   * Whether transform text.
	   * Only useful in Path and Image element
	   * @type {boolean}
	   */
	  transformText: false,
	
	  /**
	   * Text rotate around position of Path or Image
	   * Only useful in Path and Image element and transformText is false.
	   */
	  textRotation: 0,
	
	  /**
	   * Text origin of text rotation, like [10, 40].
	   * Based on x, y of rect.
	   * Useful in label rotation of circular symbol.
	   * By default, this origin is textPosition.
	   * Can be 'center'.
	   * @type {string|Array.<number>}
	   */
	  textOrigin: null,
	
	  /**
	   * @type {string}
	   */
	  textBackgroundColor: null,
	
	  /**
	   * @type {string}
	   */
	  textBorderColor: null,
	
	  /**
	   * @type {number}
	   */
	  textBorderWidth: 0,
	
	  /**
	   * @type {number}
	   */
	  textBorderRadius: 0,
	
	  /**
	   * Can be `2` or `[2, 4]` or `[2, 3, 4, 5]`
	   * @type {number|Array.<number>}
	   */
	  textPadding: null,
	
	  /**
	   * Text styles for rich text.
	   * @type {Object}
	   */
	  rich: null,
	
	  /**
	   * {outerWidth, outerHeight, ellipsis, placeholder}
	   * @type {Object}
	   */
	  truncate: null,
	
	  /**
	   * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
	   * @type {string}
	   */
	  blend: null,
	
	  /**
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  bind: function (ctx, el, prevEl) {
	    var style = this;
	    var prevStyle = prevEl && prevEl.style;
	    var firstDraw = !prevStyle;
	
	    for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
	      var prop = STYLE_COMMON_PROPS[i];
	      var styleName = prop[0];
	
	      if (firstDraw || style[styleName] !== prevStyle[styleName]) {
	        // FIXME Invalid property value will cause style leak from previous element.
	        ctx[styleName] = style[styleName] || prop[1];
	      }
	    }
	
	    if (firstDraw || style.fill !== prevStyle.fill) {
	      ctx.fillStyle = style.fill;
	    }
	
	    if (firstDraw || style.stroke !== prevStyle.stroke) {
	      ctx.strokeStyle = style.stroke;
	    }
	
	    if (firstDraw || style.opacity !== prevStyle.opacity) {
	      ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
	    }
	
	    if (firstDraw || style.blend !== prevStyle.blend) {
	      ctx.globalCompositeOperation = style.blend || 'source-over';
	    }
	
	    if (this.hasStroke()) {
	      var lineWidth = style.lineWidth;
	      ctx.lineWidth = lineWidth / (this.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
	    }
	  },
	  hasFill: function () {
	    var fill = this.fill;
	    return fill != null && fill !== 'none';
	  },
	  hasStroke: function () {
	    var stroke = this.stroke;
	    return stroke != null && stroke !== 'none' && this.lineWidth > 0;
	  },
	
	  /**
	   * Extend from other style
	   * @param {zrender/graphic/Style} otherStyle
	   * @param {boolean} overwrite true: overwrirte any way.
	   *                            false: overwrite only when !target.hasOwnProperty
	   *                            others: overwrite when property is not null/undefined.
	   */
	  extendFrom: function (otherStyle, overwrite) {
	    if (otherStyle) {
	      for (var name in otherStyle) {
	        if (otherStyle.hasOwnProperty(name) && (overwrite === true || (overwrite === false ? !this.hasOwnProperty(name) : otherStyle[name] != null))) {
	          this[name] = otherStyle[name];
	        }
	      }
	    }
	  },
	
	  /**
	   * Batch setting style with a given object
	   * @param {Object|string} obj
	   * @param {*} [obj]
	   */
	  set: function (obj, value) {
	    if (typeof obj === 'string') {
	      this[obj] = value;
	    } else {
	      this.extendFrom(obj, true);
	    }
	  },
	
	  /**
	   * Clone
	   * @return {zrender/graphic/Style} [description]
	   */
	  clone: function () {
	    var newStyle = new this.constructor();
	    newStyle.extendFrom(this, true);
	    return newStyle;
	  },
	  getGradient: function (ctx, obj, rect) {
	    var method = obj.type === 'radial' ? createRadialGradient : createLinearGradient;
	    var canvasGradient = method(ctx, obj, rect);
	    var colorStops = obj.colorStops;
	
	    for (var i = 0; i < colorStops.length; i++) {
	      canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
	    }
	
	    return canvasGradient;
	  }
	};
	var styleProto = Style.prototype;
	
	for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
	  var prop = STYLE_COMMON_PROPS[i];
	
	  if (!(prop[0] in styleProto)) {
	    styleProto[prop[0]] = prop[1];
	  }
	} // Provide for others
	
	
	Style.getGradient = styleProto.getGradient;
	var _default = Style;
	module.exports = _default;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var env = __webpack_require__(18);
	
	// Fix weird bug in some version of IE11 (like 11.0.9600.178**),
	// where exception "unexpected call to method or property access"
	// might be thrown when calling ctx.fill or ctx.stroke after a path
	// whose area size is zero is drawn and ctx.clip() is called and
	// shadowBlur is set. See #4572, #3112, #5777.
	// (e.g.,
	//  ctx.moveTo(10, 10);
	//  ctx.lineTo(20, 10);
	//  ctx.closePath();
	//  ctx.clip();
	//  ctx.shadowBlur = 10;
	//  ...
	//  ctx.fill();
	// )
	var shadowTemp = [['shadowBlur', 0], ['shadowColor', '#000'], ['shadowOffsetX', 0], ['shadowOffsetY', 0]];
	
	function _default(orignalBrush) {
	  // version string can be: '11.0'
	  return env.browser.ie && env.browser.version >= 11 ? function () {
	    var clipPaths = this.__clipPaths;
	    var style = this.style;
	    var modified;
	
	    if (clipPaths) {
	      for (var i = 0; i < clipPaths.length; i++) {
	        var clipPath = clipPaths[i];
	        var shape = clipPath && clipPath.shape;
	        var type = clipPath && clipPath.type;
	
	        if (shape && (type === 'sector' && shape.startAngle === shape.endAngle || type === 'rect' && (!shape.width || !shape.height))) {
	          for (var j = 0; j < shadowTemp.length; j++) {
	            // It is save to put shadowTemp static, because shadowTemp
	            // will be all modified each item brush called.
	            shadowTemp[j][2] = style[shadowTemp[j][0]];
	            style[shadowTemp[j][0]] = shadowTemp[j][1];
	          }
	
	          modified = true;
	          break;
	        }
	      }
	    }
	
	    orignalBrush.apply(this, arguments);
	
	    if (modified) {
	      for (var j = 0; j < shadowTemp.length; j++) {
	        style[shadowTemp[j][0]] = shadowTemp[j][2];
	      }
	    }
	  } : orignalBrush;
	}
	
	module.exports = _default;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	var smoothSpline = __webpack_require__(748);
	
	var smoothBezier = __webpack_require__(747);
	
	function buildPath(ctx, shape, closePath) {
	  var points = shape.points;
	  var smooth = shape.smooth;
	
	  if (points && points.length >= 2) {
	    if (smooth && smooth !== 'spline') {
	      var controlPoints = smoothBezier(points, smooth, closePath, shape.smoothConstraint);
	      ctx.moveTo(points[0][0], points[0][1]);
	      var len = points.length;
	
	      for (var i = 0; i < (closePath ? len : len - 1); i++) {
	        var cp1 = controlPoints[i * 2];
	        var cp2 = controlPoints[i * 2 + 1];
	        var p = points[(i + 1) % len];
	        ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
	      }
	    } else {
	      if (smooth === 'spline') {
	        points = smoothSpline(points, closePath);
	      }
	
	      ctx.moveTo(points[0][0], points[0][1]);
	
	      for (var i = 1, l = points.length; i < l; i++) {
	        ctx.lineTo(points[i][0], points[i][1]);
	      }
	    }
	
	    closePath && ctx.closePath();
	  }
	}
	
	exports.buildPath = buildPath;

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	function buildPath(ctx, shape) {
	  var x = shape.x;
	  var y = shape.y;
	  var width = shape.width;
	  var height = shape.height;
	  var r = shape.r;
	  var r1;
	  var r2;
	  var r3;
	  var r4; // Convert width and height to positive for better borderRadius
	
	  if (width < 0) {
	    x = x + width;
	    width = -width;
	  }
	
	  if (height < 0) {
	    y = y + height;
	    height = -height;
	  }
	
	  if (typeof r === 'number') {
	    r1 = r2 = r3 = r4 = r;
	  } else if (r instanceof Array) {
	    if (r.length === 1) {
	      r1 = r2 = r3 = r4 = r[0];
	    } else if (r.length === 2) {
	      r1 = r3 = r[0];
	      r2 = r4 = r[1];
	    } else if (r.length === 3) {
	      r1 = r[0];
	      r2 = r4 = r[1];
	      r3 = r[2];
	    } else {
	      r1 = r[0];
	      r2 = r[1];
	      r3 = r[2];
	      r4 = r[3];
	    }
	  } else {
	    r1 = r2 = r3 = r4 = 0;
	  }
	
	  var total;
	
	  if (r1 + r2 > width) {
	    total = r1 + r2;
	    r1 *= width / total;
	    r2 *= width / total;
	  }
	
	  if (r3 + r4 > width) {
	    total = r3 + r4;
	    r3 *= width / total;
	    r4 *= width / total;
	  }
	
	  if (r2 + r3 > height) {
	    total = r2 + r3;
	    r2 *= height / total;
	    r3 *= height / total;
	  }
	
	  if (r1 + r4 > height) {
	    total = r1 + r4;
	    r1 *= height / total;
	    r4 *= height / total;
	  }
	
	  ctx.moveTo(x + r1, y);
	  ctx.lineTo(x + width - r2, y);
	  r2 !== 0 && ctx.quadraticCurveTo(x + width, y, x + width, y + r2);
	  ctx.lineTo(x + width, y + height - r3);
	  r3 !== 0 && ctx.quadraticCurveTo(x + width, y + height, x + width - r3, y + height);
	  ctx.lineTo(x + r4, y + height);
	  r4 !== 0 && ctx.quadraticCurveTo(x, y + height, x, y + height - r4);
	  ctx.lineTo(x, y + r1);
	  r1 !== 0 && ctx.quadraticCurveTo(x, y, x + r1, y);
	}
	
	exports.buildPath = buildPath;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	var textHelper = __webpack_require__(100);
	
	var BoundingRect = __webpack_require__(13);
	
	/**
	 * Mixin for drawing text in a element bounding rect
	 * @module zrender/mixin/RectText
	 */
	var tmpRect = new BoundingRect();
	
	var RectText = function () {};
	
	RectText.prototype = {
	  constructor: RectText,
	
	  /**
	   * Draw text in a rect with specified position.
	   * @param  {CanvasRenderingContext2D} ctx
	   * @param  {Object} rect Displayable rect
	   */
	  drawRectText: function (ctx, rect) {
	    var style = this.style;
	    rect = style.textRect || rect; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	    var text = style.text; // Convert to string
	
	    text != null && (text += '');
	
	    if (!textHelper.needDrawText(text, style)) {
	      return;
	    } // FIXME
	
	
	    ctx.save(); // Transform rect to view space
	
	    var transform = this.transform;
	
	    if (!style.transformText) {
	      if (transform) {
	        tmpRect.copy(rect);
	        tmpRect.applyTransform(transform);
	        rect = tmpRect;
	      }
	    } else {
	      this.setTransform(ctx);
	    } // transformText and textRotation can not be used at the same time.
	
	
	    textHelper.renderText(this, ctx, text, style, rect);
	    ctx.restore();
	  }
	};
	var _default = RectText;
	module.exports = _default;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(140);
	
	var createElement = _core.createElement;
	
	var zrUtil = __webpack_require__(1);
	
	var Path = __webpack_require__(19);
	
	var ZImage = __webpack_require__(75);
	
	var ZText = __webpack_require__(76);
	
	var _graphic = __webpack_require__(141);
	
	var svgPath = _graphic.path;
	var svgImage = _graphic.image;
	var svgText = _graphic.text;
	
	/**
	 * @file Manages elements that can be defined in <defs> in SVG,
	 *       e.g., gradients, clip path, etc.
	 * @author Zhang Wenli
	 */
	var MARK_UNUSED = '0';
	var MARK_USED = '1';
	/**
	 * Manages elements that can be defined in <defs> in SVG,
	 * e.g., gradients, clip path, etc.
	 *
	 * @class
	 * @param {SVGElement}      svgRoot   root of SVG document
	 * @param {string|string[]} tagNames  possible tag names
	 * @param {string}          markLabel label name to make if the element
	 *                                    is used
	 */
	
	function Definable(svgRoot, tagNames, markLabel) {
	  this._svgRoot = svgRoot;
	  this._tagNames = typeof tagNames === 'string' ? [tagNames] : tagNames;
	  this._markLabel = markLabel;
	  this.nextId = 0;
	}
	
	Definable.prototype.createElement = createElement;
	/**
	 * Get the <defs> tag for svgRoot; optionally creates one if not exists.
	 *
	 * @param {boolean} isForceCreating if need to create when not exists
	 * @return {SVGDefsElement} SVG <defs> element, null if it doesn't
	 * exist and isForceCreating is false
	 */
	
	Definable.prototype.getDefs = function (isForceCreating) {
	  var svgRoot = this._svgRoot;
	
	  var defs = this._svgRoot.getElementsByTagName('defs');
	
	  if (defs.length === 0) {
	    // Not exist
	    if (isForceCreating) {
	      defs = svgRoot.insertBefore(this.createElement('defs'), // Create new tag
	      svgRoot.firstChild // Insert in the front of svg
	      );
	
	      if (!defs.contains) {
	        // IE doesn't support contains method
	        defs.contains = function (el) {
	          var children = defs.children;
	
	          if (!children) {
	            return false;
	          }
	
	          for (var i = children.length - 1; i >= 0; --i) {
	            if (children[i] === el) {
	              return true;
	            }
	          }
	
	          return false;
	        };
	      }
	
	      return defs;
	    } else {
	      return null;
	    }
	  } else {
	    return defs[0];
	  }
	};
	/**
	 * Update DOM element if necessary.
	 *
	 * @param {Object|string} element style element. e.g., for gradient,
	 *                                it may be '#ccc' or {type: 'linear', ...}
	 * @param {Function|undefined} onUpdate update callback
	 */
	
	
	Definable.prototype.update = function (element, onUpdate) {
	  if (!element) {
	    return;
	  }
	
	  var defs = this.getDefs(false);
	
	  if (element._dom && defs.contains(element._dom)) {
	    // Update DOM
	    if (typeof onUpdate === 'function') {
	      onUpdate();
	    }
	  } else {
	    // No previous dom, create new
	    var dom = this.add(element);
	
	    if (dom) {
	      element._dom = dom;
	    }
	  }
	};
	/**
	 * Add gradient dom to defs
	 *
	 * @param {SVGElement} dom DOM to be added to <defs>
	 */
	
	
	Definable.prototype.addDom = function (dom) {
	  var defs = this.getDefs(true);
	  defs.appendChild(dom);
	};
	/**
	 * Remove DOM of a given element.
	 *
	 * @param {SVGElement} element element to remove dom
	 */
	
	
	Definable.prototype.removeDom = function (element) {
	  var defs = this.getDefs(false);
	  defs.removeChild(element._dom);
	};
	/**
	 * Get DOMs of this element.
	 *
	 * @return {HTMLDomElement} doms of this defineable elements in <defs>
	 */
	
	
	Definable.prototype.getDoms = function () {
	  var defs = this.getDefs(false);
	
	  if (!defs) {
	    // No dom when defs is not defined
	    return [];
	  }
	
	  var doms = [];
	  zrUtil.each(this._tagNames, function (tagName) {
	    var tags = defs.getElementsByTagName(tagName); // Note that tags is HTMLCollection, which is array-like
	    // rather than real array.
	    // So `doms.concat(tags)` add tags as one object.
	
	    doms = doms.concat([].slice.call(tags));
	  });
	  return doms;
	};
	/**
	 * Mark DOMs to be unused before painting, and clear unused ones at the end
	 * of the painting.
	 */
	
	
	Definable.prototype.markAllUnused = function () {
	  var doms = this.getDoms();
	  var that = this;
	  zrUtil.each(doms, function (dom) {
	    dom[that._markLabel] = MARK_UNUSED;
	  });
	};
	/**
	 * Mark a single DOM to be used.
	 *
	 * @param {SVGElement} dom DOM to mark
	 */
	
	
	Definable.prototype.markUsed = function (dom) {
	  if (dom) {
	    dom[this._markLabel] = MARK_USED;
	  }
	};
	/**
	 * Remove unused DOMs defined in <defs>
	 */
	
	
	Definable.prototype.removeUnused = function () {
	  var defs = this.getDefs(false);
	
	  if (!defs) {
	    // Nothing to remove
	    return;
	  }
	
	  var doms = this.getDoms();
	  var that = this;
	  zrUtil.each(doms, function (dom) {
	    if (dom[that._markLabel] !== MARK_USED) {
	      // Remove gradient
	      defs.removeChild(dom);
	    }
	  });
	};
	/**
	 * Get SVG proxy.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {Path|Image|Text} svg proxy of given element
	 */
	
	
	Definable.prototype.getSvgProxy = function (displayable) {
	  if (displayable instanceof Path) {
	    return svgPath;
	  } else if (displayable instanceof ZImage) {
	    return svgImage;
	  } else if (displayable instanceof ZText) {
	    return svgText;
	  } else {
	    return svgPath;
	  }
	};
	/**
	 * Get text SVG element.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {SVGElement} SVG element of text
	 */
	
	
	Definable.prototype.getTextSvgElement = function (displayable) {
	  return displayable.__textSvgEl;
	};
	/**
	 * Get SVG element.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {SVGElement} SVG element
	 */
	
	
	Definable.prototype.getSvgElement = function (displayable) {
	  return displayable.__svgEl;
	};
	
	var _default = Definable;
	module.exports = _default;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	var env = __webpack_require__(18);
	
	var urn = 'urn:schemas-microsoft-com:vml';
	var win = typeof window === 'undefined' ? null : window;
	var vmlInited = false;
	var doc = win && win.document;
	
	function createNode(tagName) {
	  return doCreateNode(tagName);
	} // Avoid assign to an exported variable, for transforming to cjs.
	
	
	var doCreateNode;
	
	if (doc && !env.canvasSupported) {
	  try {
	    !doc.namespaces.zrvml && doc.namespaces.add('zrvml', urn);
	
	    doCreateNode = function (tagName) {
	      return doc.createElement('<zrvml:' + tagName + ' class="zrvml">');
	    };
	  } catch (e) {
	    doCreateNode = function (tagName) {
	      return doc.createElement('<' + tagName + ' xmlns="' + urn + '" class="zrvml">');
	    };
	  }
	} // From raphael
	
	
	function initVML() {
	  if (vmlInited || !doc) {
	    return;
	  }
	
	  vmlInited = true;
	  var styleSheets = doc.styleSheets;
	
	  if (styleSheets.length < 31) {
	    doc.createStyleSheet().addRule('.zrvml', 'behavior:url(#default#VML)');
	  } else {
	    // http://msdn.microsoft.com/en-us/library/ms531194%28VS.85%29.aspx
	    styleSheets[0].addRule('.zrvml', 'behavior:url(#default#VML)');
	  }
	}
	
	exports.doc = doc;
	exports.createNode = createNode;
	exports.initVML = initVML;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(275);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _DateLanguages = __webpack_require__(142);
	
	var _DateLanguages2 = _interopRequireDefault(_DateLanguages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  isValidDate: function isValidDate(date) {
	    if (Object.prototype.toString.call(date) !== '[object Date]') {
	      return false;
	    }
	    return !isNaN(date.getTime());
	  },
	  getDayNameAbbr: function getDayNameAbbr(date, days) {
	    if ((typeof date === 'undefined' ? 'undefined' : (0, _typeof3.default)(date)) !== 'object') {
	      throw TypeError('Invalid Type');
	    }
	    return days[date.getDay()];
	  },
	  getMonthName: function getMonthName(month, months) {
	    if (!months) {
	      throw Error('missing 2nd parameter Months array');
	    }
	    if ((typeof month === 'undefined' ? 'undefined' : (0, _typeof3.default)(month)) === 'object') {
	      return months[month.getMonth()];
	    }
	    if (typeof month === 'number') {
	      return months[month];
	    }
	    throw TypeError('Invalid type');
	  },
	  getMonthNameAbbr: function getMonthNameAbbr(month, monthsAbbr) {
	    if (!monthsAbbr) {
	      throw Error('missing 2nd paramter Months array');
	    }
	    if ((typeof month === 'undefined' ? 'undefined' : (0, _typeof3.default)(month)) === 'object') {
	      return monthsAbbr[month.getMonth()];
	    }
	    if (typeof month === 'number') {
	      return monthsAbbr[month];
	    }
	    throw TypeError('Invalid type');
	  },
	  convertToUTC: function convertToUTC(date) {
	    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
	  },
	  daysInMonth: function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	  },
	  dayDiff: function dayDiff(start, end) {
	    var MS_PER_DAY = 1000 * 60 * 60 * 24;
	
	    var utc1 = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
	    var utc2 = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
	
	    return Math.floor((utc2 - utc1) / MS_PER_DAY);
	  },
	  getNthSuffix: function getNthSuffix(day) {
	    switch (day) {
	      case 1:
	      case 21:
	      case 31:
	        return 'st';
	      case 2:
	      case 22:
	        return 'nd';
	      case 3:
	      case 23:
	        return 'rd';
	      default:
	        return 'th';
	    }
	  },
	  formatDate: function formatDate(date, format, translation) {
	    translation = !translation ? _DateLanguages2.default.translations.en : translation;
	    var year = date.getFullYear();
	    var month = date.getMonth() + 1;
	    var day = date.getDate();
	    var str = format.replace(/yyyy/, year).replace(/yy/, String(year).slice(2)).replace(/MMMM/, this.getMonthName(date.getMonth(), translation.months.original)).replace(/MMM/, this.getMonthNameAbbr(date.getMonth(), translation.months.abbr)).replace(/MM/, ('0' + month).slice(-2)).replace(/M(?!a)/, month).replace(/dd/, ('0' + day).slice(-2)).replace(/d/, day).replace(/su/, this.getNthSuffix(date.getDate())).replace(/D(?!e)/, this.getDayNameAbbr(date, translation.days));
	    return str;
	  },
	  createDateArray: function createDateArray(start, end) {
	    var dates = [];
	    while (start <= end) {
	      dates.push(new Date(start));
	      start = new Date(start).setDate(new Date(start).getDate() + 1);
	    }
	    return dates;
	  }
	};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Vue = __webpack_require__(212);
	var echarts = __webpack_require__(345);
	
	module.exports = {
	    deep: true,
	    params: ['loading'],
	    paramWatchers: {
	        loading: function loading(val, oldVal) {
	            var self = this;
	
	            if (val === true) {
	                self.instance.showLoading();
	            } else {
	                self.instance.hideLoading();
	            }
	        }
	    },
	    bind: function bind() {
	        var self = this;
	
	        Vue.nextTick(function () {
	            self.instance = echarts.init(self.el);
	
	            if (self.params.loading === true) {
	                self.instance.showLoading({
	                    text: 'laden...',
	                    color: '#ad1457',
	                    textColor: '#7F4757'
	                });
	            }
	
	            var resizeEvent = new Event('resize');
	
	            self.resizeEventHandler = function () {
	                self.instance.resize();
	            };
	
	            self.el.addEventListener('resize', self.resizeEventHandler, false);
	
	            window.onresize = function () {
	                self.el.dispatchEvent(resizeEvent);
	            };
	        });
	    },
	    update: function update(val, oldVal) {
	        var self = this;
	        var options = val;
	
	        Vue.nextTick(function () {
	            self.instance.setOption(options);
	        });
	    },
	    unbind: function unbind() {
	        var self = this;
	
	        self.instance.dispose();
	
	        self.el.removeEventListener('resize', self.resizeEventHandler, false);
	    }
	};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationHeader = __webpack_require__(704);
	
	var _NavigationHeader2 = _interopRequireDefault(_NavigationHeader);
	
	var _Footer = __webpack_require__(703);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _banner = __webpack_require__(682);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  replace: false,
	  components: {
	    'v-header': _NavigationHeader2.default,
	    'v-footer': _Footer2.default,
	    'v-banner': _banner2.default
	  },
	  data: function data() {
	    return {
	      store: _store2.default
	    };
	  },
	  created: function created() {
	    _store2.default.checkAuth();
	    _store2.default.checkBanner();
	    if (sessionStorage.getItem('winkelwagen')) {
	      this.store.cart = JSON.parse(sessionStorage.getItem('winkelwagen'));
	    }
	  },
	
	  methods: {}
	};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _ProductCard = __webpack_require__(135);
	
	var _ProductCard2 = _interopRequireDefault(_ProductCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  route: {
	    canReuse: false
	  },
	  components: {
	    ProductCard: _ProductCard2.default
	  },
	  data: function data() {
	    return {
	      store: _store2.default,
	      products: {},
	      category: '',
	      loaded: false
	    };
	  },
	
	  methods: {},
	  ready: function ready() {},
	  created: function created() {
	    $.ajax({
	      type: 'GET',
	      url: _store2.default.root + 'api/products/category/' + this.$route.params.id,
	      dataType: 'json',
	      xhrFields: {
	        withCredentials: true
	      },
	      success: function (response) {
	        this.loaded = true;
	        this.category = response.Category;
	        this.products = response.Products;
	      }.bind(this)
	    });
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    type: {
	      type: String,
	      required: true
	    },
	    dismissible: {
	      type: Boolean,
	      default: true
	    },
	    animation: {
	      type: Boolean,
	      default: true
	    },
	    timeout: {
	      type: Number,
	      default: -1
	    },
	    onClosed: {
	      type: Function,
	      default: function _default() {}
	    }
	  },
	  methods: {
	    dismiss: function dismiss() {
	      $(this.$el).alert('close');
	    }
	  },
	  ready: function ready() {
	    var _this = this;
	
	    if (this.timeout >= 0) {
	      setTimeout(function () {
	        _this.dismiss();
	      }, this.timeout);
	    }
	    $(this.$el).on('closed.bs.alert', function () {
	      _this.onClosed();
	    });
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInteger = __webpack_require__(270);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    title: {
	      type: String,
	      default: ''
	    },
	    show: {
	      require: true,
	      type: Boolean,
	      twoWay: true
	    },
	    width: {
	      default: null
	    },
	    callback: {
	      type: Function,
	      default: function _default() {}
	    },
	    effect: {
	      type: String,
	      default: null
	    },
	    backdrop: {
	      type: Boolean,
	      default: true
	    },
	    large: {
	      type: Boolean,
	      default: false
	    },
	    small: {
	      type: Boolean,
	      default: false
	    },
	    centered: {
	      type: Boolean,
	      default: false
	    },
	    btnright: {
	      type: String
	    },
	    btnleft: {
	      type: String
	    },
	    indicators: {
	      type: Boolean,
	      default: false
	    },
	    indicatorright: {
	      type: Function,
	      default: function _default() {}
	    },
	    indicatorleft: {
	      type: Function,
	      default: function _default() {}
	    }
	  },
	  ready: function ready() {
	    var _this = this;
	
	    this.$watch('show', function (val) {
	      var el = _this.$el;
	      var body = document.body;
	      var scrollBarWidth = _this.getScrollBarWidth();
	      if (val) {
	        el.querySelector('.modal-content').focus();
	        el.style.display = 'block';
	        setTimeout(function () {
	          return el.classList.add('in');
	        }, 0);
	        body.classList.add('modal-open');
	        if (scrollBarWidth !== 0) {
	          body.style.paddingRight = scrollBarWidth + 'px';
	        }
	        if (_this.backdrop) {
	          _this._blurModalContentEvent = _this.listen(_this.$el, 'click', function (e) {
	            if (e.target === el) _this.show = false;
	          });
	        }
	      } else {
	        if (_this._blurModalContentEvent) _this._blurModalContentEvent.remove();
	        el.classList.remove('in');
	        setTimeout(function () {
	          el.style.display = 'none';
	          body.classList.remove('modal-open');
	          body.style.paddingRight = '0';
	        }, 300);
	      }
	    }, { immediate: true });
	  },
	
	  computed: {
	    optionalWidth: function optionalWidth() {
	      if (this.width === null) {
	        return null;
	      } else if ((0, _isInteger2.default)(this.width)) {
	        return this.width + 'px';
	      }
	      return this.width;
	    }
	  },
	  methods: {
	    close: function close() {
	      this.show = false;
	    },
	    listen: function listen(target, eventType, callback) {
	      if (target.addEventListener) {
	        target.addEventListener(eventType, callback, false);
	        return {
	          remove: function remove() {
	            target.removeEventListener(eventType, callback, false);
	          }
	        };
	      } else if (target.attachEvent) {
	        target.attachEvent('on' + eventType, callback);
	        return {
	          remove: function remove() {
	            target.detachEvent('on' + eventType, callback);
	          }
	        };
	      }
	    },
	    getScrollBarWidth: function getScrollBarWidth() {
	      if (document.documentElement.scrollHeight <= document.documentElement.clientHeight) {
	        return 0;
	      }
	      var inner = document.createElement('p');
	      inner.style.width = '100%';
	      inner.style.height = '200px';
	      var outer = document.createElement('div');
	      outer.style.position = 'absolute';
	      outer.style.top = '0px';
	      outer.style.left = '0px';
	      outer.style.visibility = 'hidden';
	      outer.style.width = '200px';
	      outer.style.height = '150px';
	      outer.style.overflow = 'hidden';
	      outer.appendChild(inner);
	      document.body.appendChild(outer);
	      var w1 = inner.offsetWidth;
	      outer.style.overflow = 'scroll';
	      var w2 = inner.offsetWidth;
	      if (w1 === w2) w2 = outer.clientWidth;
	      document.body.removeChild(outer);
	      return w1 - w2;
	    }
	  }
	};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(61);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  route: {
	    canReuse: false
	  },
	  props: {
	    product: Object
	  },
	  data: function data() {
	    return {
	      store: _store2.default,
	      loaded: false
	    };
	  },
	
	  methods: {
	    addToShoppingCart: function addToShoppingCart() {
	      if (!this.containsProduct(this.product, this.store.cart)) {
	        this.store.cart.push(this.product);
	        sessionStorage.setItem('winkelwagen', (0, _stringify2.default)(this.store.cart));
	      }
	    },
	    containsProduct: function containsProduct(obj, list) {
	      for (var i = 0; i < list.length; i++) {
	        if (list[i].ProductId === obj.ProductId) {
	          return true;
	        }
	      }
	      return false;
	    }
	  },
	  created: function created() {}
	};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(269);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var coerceBoolean = function coerceBoolean(val) {
	  return typeof val !== 'string' ? val : val === 'true' ? true : val === 'false' ? false : val === 'null' ? false : val === 'undefined' ? false : val;
	};
	exports.default = {
	  props: {
	    options: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    value: {
	      twoWay: true
	    },
	    placeholder: {
	      type: String,
	      default: 'Niet geselecteerd!'
	    },
	    multiple: {
	      type: Boolean,
	      coerce: coerceBoolean,
	      default: false
	    },
	    search: {
	      type: Boolean,
	      coerce: coerceBoolean,
	      default: false
	    },
	    limit: {
	      type: Number,
	      default: 1024
	    },
	    closeOnSelect: {
	      type: Boolean,
	      coerce: coerceBoolean,
	      default: true
	    },
	    disabled: {
	      type: Boolean,
	      coerce: coerceBoolean,
	      default: false
	    }
	  },
	  ready: function ready() {
	    if (this.value.constructor !== Array) {
	      if (this.value.length === 0) {
	        this.value = [];
	      } else {
	        this.value = [this.value];
	      }
	    } else {
	      if (!this.multiple && this.value.length > 1) {
	        this.value = this.value.slice(0, 1);
	      } else if (this.multiple && this.value.length > this.limit) {
	        this.value = this.value.slice(0, this.limit);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      searchText: null,
	      show: false,
	      showNotify: false
	    };
	  },
	
	  computed: {
	    selectedItems: function selectedItems() {
	      var foundItems = [];
	      if (this.value.length) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var item = _step.value;
	
	            if (this.options.length === 0) {
	              foundItems = this.value;
	            } else {
	              if (typeof item === 'string') {
	                var option = void 0;
	                this.options.some(function (o) {
	                  if (o.value === item) {
	                    option = o;
	                    return true;
	                  }
	                });
	                option && foundItems.push(option.label);
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return foundItems.join(', ');
	      }
	    },
	    showPlaceholder: function showPlaceholder() {
	      return this.value.length === 0;
	    }
	  },
	  watch: {
	    value: function value(val) {
	      if (val.length > this.limit) {
	        this.showNotify = true;
	        this.value.pop();
	        setTimeout(function () {
	          this.showNotify = false;
	        }, 1000);
	      }
	    }
	  },
	  methods: {
	    select: function select(v) {
	      if (this.value.indexOf(v) === -1) {
	        if (this.multiple) {
	          this.value.push(v);
	        } else {
	          this.value = [v];
	        }
	      } else {
	        if (this.multiple) {
	          this.value.$remove(v);
	        }
	      }
	      if (this.closeOnSelect) {
	        this.toggleDropdown();
	      }
	    },
	    isSelected: function isSelected(v) {
	      if (this.value.constructor !== Array) {
	        return this.value === v;
	      } else {
	        return this.value.indexOf(v) !== -1;
	      }
	    },
	    toggleDropdown: function toggleDropdown() {
	      this.show = !this.show;
	    }
	  }
	};

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    checked: {
	      type: Boolean,
	      default: false
	    },
	    name: {
	      type: String
	    }
	  }
	};

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(61);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    url: { type: String, default: 'api/products/uploadphoto' },
	    files: { type: Array, twoWay: true }
	  },
	  data: function data() {
	    return {
	      store: _store2.default,
	      showspinner: false,
	      options: {
	        handle: '.image-move',
	        animation: 100,
	        scrollSensitivity: 10,
	        scrollSpeed: 10,
	        onUpdate: function onUpdate(evt) {
	          this.el._vue_directives[0].vm._sort(evt.oldIndex, evt.newIndex);
	        }
	      }
	    };
	  },
	
	  methods: {
	    _sort: function _sort(oldindex, newindex) {
	      var content = this.files[oldindex];
	      this.files.splice(oldindex, 1);
	      this.files.splice(newindex, 0, content);
	      this.orderArray();
	    },
	    orderArray: function orderArray() {
	      for (var i = 0; i < this.files.length; i++) {
	        this.files[i].Order = i;
	      }
	    },
	    onFileChange: function onFileChange(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      if (files.length > 0) {
	        for (var i = 0; i < files.length; i++) {
	          this.createFile(files[i]);
	        }
	      }
	    },
	    createFile: function createFile(file, index) {},
	
	    handleUpload: function handleUpload(e) {
	      var formData = new FormData();
	      var totalFiles = document.getElementById('upload').files.length;
	      if (totalFiles > 0) {
	        for (var i = 0; i < totalFiles; i++) {
	          this.showspinner = true;
	          var file = document.getElementById('upload').files[i];
	          formData.append('upload' + i, file);
	        }
	        $.ajax({
	          type: 'POST',
	          url: _store2.default.root + this.url,
	          data: formData,
	          dataType: 'json',
	          contentType: false,
	          processData: false,
	          xhrFields: {
	            withCredentials: true
	          },
	          success: function (response) {
	            for (var i = 0; i < response.length; i++) {
	              this.files.push(response[i]);
	            }
	            this.showspinner = false;
	            this.orderArray();
	          }.bind(this),
	          error: function (error) {
	            this.$dispatch('error', (0, _stringify2.default)(error));
	          }.bind(this)
	        });
	      }
	    },
	    fileInfo: function fileInfo(file) {
	      var jobject = {};
	      jobject.name = file.name;
	      jobject.size = file.size;
	      jobject.src = '';
	      return jobject;
	    },
	    removeFile: function removeFile(e) {
	      var data = this.files[e].URL;
	      $.ajax({
	        type: 'POST',
	        url: _store2.default.root + 'api/products/deletephoto',
	        data: data,
	        dataType: 'text',
	        xhrFields: {
	          withCredentials: true
	        },
	        success: function (response) {
	          this.files.splice(e, 1);
	          this.orderArray();
	        }.bind(this),
	        error: function (error) {
	          this.$dispatch('error', (0, _stringify2.default)(error));
	        }.bind(this)
	      });
	    }
	  },
	  computed: {
	    filesLength: function filesLength() {
	      return this.files.length < 5;
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(61);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(271);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _driftZoom = __webpack_require__(341);
	
	var _driftZoom2 = _interopRequireDefault(_driftZoom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    src: {
	      type: String,
	      required: true
	    },
	    srcZoom: String,
	    options: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  data: function data() {
	    return { drift: null };
	  },
	  computed: {
	    _srcZoom: function _srcZoom() {
	      return this.srcZoom || this.src;
	    }
	  },
	  methods: {
	    setDrift: function setDrift(opts) {
	      if (document) {
	        var _opts = {};
	
	        if (opts.paneContainer) {
	          _opts.paneContainer = document.querySelector(opts.paneContainer);
	        }
	        if (opts.inlineContainer) {
	          _opts.inlineContainer = document.querySelector(opts.inlineContainer);
	        }
	        if (opts.boundingBoxContainer) {
	          _opts.boundingBoxContainer = document.querySelector(opts.boundingBoxContainer);
	        }
	        console.log(this.$el);
	        this.drift = new _driftZoom2.default(this.$el, (0, _assign2.default)({}, opts, _opts));
	      }
	    }
	  },
	  ready: function ready() {
	    this.setDrift(this.options);
	  },
	  destroyed: function destroyed() {
	    this.drift && this.drift.destroy();
	  },
	
	  watch: {
	    options: function options(newValue, oldValue) {
	      if ((0, _stringify2.default)(newValue) !== (0, _stringify2.default)(oldValue)) {
	        this.drift && this.drift.destroy();
	        this.setDrift(newValue);
	      }
	    },
	    srcZoom: function srcZoom(newValue, oldValue) {
	      if (newValue && newValue !== oldValue) {
	        this.drift && this.drift.setZoomImageURL(newValue);
	      }
	    }
	  }
	};

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    show: {
	      type: Boolean,
	      default: false,
	      twoWay: true
	    },
	    banner: {
	      type: Object
	    }
	  },
	  data: function data() {
	    return {};
	  },
	  methods: {
	    close: function close() {
	      this.show = false;
	    }
	  }
	};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(39);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DeleteSweetAlert',
	  props: {
	    callback: {
	      type: Function,
	      default: function _default() {}
	    },
	    show: {
	      type: Boolean
	    }
	  },
	  components: {
	    'v-modal': _Modal2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	  ready: function ready() {},
	
	  methods: {}
	};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CallbackAlert = __webpack_require__(29);
	
	var _CallbackAlert2 = _interopRequireDefault(_CallbackAlert);
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    'vc-alert': _CallbackAlert2.default,
	    store: _store2.default
	  },
	  data: function data() {
	    return {
	      reviews: {},
	      review: {
	        Name: '',
	        Content: '',
	        Rating: 5
	      },
	      error: false,
	      success: false,
	      isValid: true
	    };
	  },
	
	  methods: {
	    onVerify: function onVerify(response) {
	      this.error = false;
	      this.isValid = true;
	      console.log('Verify: ' + response);
	    },
	    onExpired: function onExpired() {
	      console.log('reCAPTHA Expired');
	    },
	    SubmitForm: function SubmitForm() {
	      if (!this.isValid) {
	        this.error = true;
	        this.errorMessage = 'Valideer je gegevens!';
	      } else {
	        $.ajax({
	          type: 'POST',
	          url: _store2.default.root + 'api/Reviews',
	          data: this.review,
	          xhrFields: {
	            withCredentials: true
	          }
	        }).done(function () {
	          this.success = true;
	          this.error = false;
	          this.review = {};
	        }.bind(this)).fail(function (response) {
	          console.log(response);
	          this.success = false;
	          this.error = true;
	          this.errorMessage = 'Er is een fout opgetreden, probeer later opnieuw!';
	        }.bind(this));
	      }
	    },
	    getReviews: function getReviews() {
	      $.ajax({
	        type: 'GET',
	        url: _store2.default.root + 'api/reviews',
	        dataType: 'json',
	        xhrFields: {
	          withCredentials: true
	        },
	        success: function (response) {
	          this.reviews = response;
	        }.bind(this)
	      });
	    }
	  },
	  created: function created() {
	    this.getReviews();
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _flickity = __webpack_require__(603);
	
	var _flickity2 = _interopRequireDefault(_flickity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  data: function data() {
	    return {
	      msg: 'Catootjes kraam staat voor Antiek, Brocante en Curiosa.',
	      store: _store2.default,
	      products: {}
	    };
	  },
	
	  methods: {
	    getProducts: function getProducts() {
	      $.ajax({
	        type: 'GET',
	        url: _store2.default.root + 'api/Products/last',
	        dataType: 'json',
	        xhrFields: {
	          withCredentials: true
	        },
	        success: function (response) {
	          this.products = response;
	        }.bind(this)
	      });
	    },
	    initSlider: function initSlider() {
	      var elem = document.querySelector('.slider');
	      return new _flickity2.default(elem, {
	        contain: true,
	        autoPlay: 2500,
	        pauseAutoPlayOnHover: false
	      });
	    }
	  },
	  created: function created() {
	    this.getProducts();
	  },
	  ready: function ready() {
	    this.initSlider();
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(61);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Modal = __webpack_require__(39);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _CallbackAlert = __webpack_require__(29);
	
	var _CallbackAlert2 = _interopRequireDefault(_CallbackAlert);
	
	var _ZoomImage = __webpack_require__(681);
	
	var _ZoomImage2 = _interopRequireDefault(_ZoomImage);
	
	var _ProductCard = __webpack_require__(135);
	
	var _ProductCard2 = _interopRequireDefault(_ProductCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  route: {
	    canReuse: false
	  },
	  components: {
	    modal: _Modal2.default,
	    'vc-alert': _CallbackAlert2.default,
	    zoomimage: _ZoomImage2.default,
	    ProductCard: _ProductCard2.default
	  },
	  data: function data() {
	    return {
	      store: _store2.default,
	      product: {},
	      selectedImageURL: '',
	      selectedImageIndex: 0,
	      showModal: false,
	      showCartModal: false,
	      showRequestModal: false,
	      loaded: false,
	      rloaded: false,
	      customer: {
	        Name: '',
	        Email: '',
	        ProductName: ''
	      },
	      error: false,
	      success: false,
	      isValid: true
	    };
	  },
	
	  methods: {
	    changeSelectedImage: function changeSelectedImage(index) {
	      this.selectedImageURL = this.product.Photos[index].URL;
	      this.selectedImageIndex = index;
	    },
	    addToShoppingCart: function addToShoppingCart() {
	      this.showCartModal = true;
	      if (!this.containsProduct(this.product, this.store.cart)) {
	        this.store.cart.push(this.product);
	        sessionStorage.setItem('winkelwagen', (0, _stringify2.default)(this.store.cart));
	      }
	    },
	    containsProduct: function containsProduct(obj, list) {
	      for (var i = 0; i < list.length; i++) {
	        if (list[i].ProductId === obj.ProductId) {
	          return true;
	        }
	      }
	      return false;
	    },
	    zoomModal: function zoomModal() {
	      this.showModal = true;
	    },
	    changeImageToNext: function changeImageToNext() {
	      this.selectedImageIndex++;
	      var maxIndex = this.product.Photos.length - 1;
	      if (this.selectedImageIndex > maxIndex) {
	        this.selectedImageIndex = 0;
	        this.changeSelectedImage(this.selectedImageIndex);
	      } else {
	        this.changeSelectedImage(this.selectedImageIndex);
	      }
	    },
	    changeImageToPrev: function changeImageToPrev() {
	      this.selectedImageIndex--;
	      var maxIndex = this.product.Photos.length - 1;
	      if (this.selectedImageIndex >= 0) {
	        this.changeSelectedImage(this.selectedImageIndex);
	      } else {
	        this.changeSelectedImage(maxIndex);
	      }
	    },
	    close: function close() {
	      this.showCartModal = false;
	    },
	    SubmitForm: function SubmitForm() {
	      if (!this.isValid) {
	        this.error = true;
	        this.errorMessage = 'Valideer je gegevens!';
	      } else {
	        this.customer.ProductName = this.product.Name;
	        $.ajax({
	          type: 'POST',
	          url: _store2.default.root + 'api/Contact/priceRequest',
	          data: this.customer,
	          xhrFields: {
	            withCredentials: true
	          }
	        }).done(function () {
	          this.success = true;
	          this.error = false;
	          this.customer = {};
	          document.getElementById('sendButton').disabled = true;
	        }.bind(this)).fail(function (response) {
	          console.log(response);
	          this.success = false;
	          this.error = true;
	          this.errorMessage = 'Er is een fout opgetreden, probeer later opnieuw!';
	        }.bind(this));
	      }
	    }
	  },
	  created: function created() {
	    $.ajax({
	      type: 'GET',
	      url: _store2.default.root + 'api/products/' + this.$route.params.id,
	      dataType: 'json',
	      xhrFields: {
	        withCredentials: true
	      },
	      success: function (response) {
	        this.loaded = true;
	        this.product = response;
	        this.selectedImageURL = this.product.Photos[0].URL;
	      }.bind(this)
	    });
	    $.ajax({
	      type: 'GET',
	      url: _store2.default.root + 'api/products/random',
	      dataType: 'json',
	      xhrFields: {
	        withCredentials: true
	      },
	      success: function (response) {
	        this.rloaded = true;
	        this.randomproducts = response;
	      }.bind(this)
	    });
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _ProductCard = __webpack_require__(135);
	
	var _ProductCard2 = _interopRequireDefault(_ProductCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  route: {
	    canReuse: false
	  },
	  components: {
	    ProductCard: _ProductCard2.default
	  },
	  data: function data() {
	    return {
	      store: _store2.default,
	      products: {},
	      loaded: false
	    };
	  },
	  created: function created() {},
	  ready: function ready() {
	    $.ajax({
	      type: 'GET',
	      url: _store2.default.root + 'api/products/search/' + this.$route.params.term,
	      dataType: 'json',
	      xhrFields: {
	        withCredentials: true
	      },
	      success: function (response) {
	        this.loaded = true;
	        this.products = response;
	      }.bind(this)
	    });
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    products: {
	      type: Array,
	      required: true
	    },
	    subtotal: {
	      type: Number,
	      required: true,
	      twoWay: true
	    },
	    shippingcost: {
	      type: Number,
	      required: true,
	      twoWay: true
	    },
	    totalprice: {
	      type: Number,
	      required: true,
	      twoWay: true
	    }
	  },
	  created: function created() {},
	
	  components: {},
	  data: function data() {
	    return {};
	  },
	
	  methods: {}
	};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Modal = __webpack_require__(39);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _betalenCart = __webpack_require__(211);
	
	var _betalenCart2 = _interopRequireDefault(_betalenCart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    var self = this;
	    $.ajax({
	      type: 'GET',
	      url: _store2.default.root + 'api/Invoices/' + self.$route.params.burl,
	      dataType: 'json',
	      xhrFields: {
	        withCredentials: true
	      }
	    }).done(function (response) {
	      self.order = response;
	      self.loaded = true;
	    }).fail(function () {
	      self.$route.router.go('/');
	    });
	  },
	
	  components: {
	    store: _store2.default,
	    'v-modal': _Modal2.default,
	    overzicht: _betalenCart2.default
	  },
	  data: function data() {
	    return {
	      order: {},
	      paymentmethod: '',
	      IdealChecked: false,
	      loaded: false,
	      submited: false,
	      show: false
	    };
	  },
	
	  methods: {
	    setIdeal: function setIdeal(bool) {
	      this.IdealChecked = bool;
	      if (this.IdealChecked) {
	        this.paymentmethod = '';
	      }
	    },
	    checkout: function checkout() {
	      var self = this;
	      self.submited = true;
	      $.ajax({
	        type: 'POST',
	        url: _store2.default.root + 'api/checkout?id=' + self.order.Id + '&paymentmethod=' + self.paymentmethod,
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function (response) {
	        window.location.replace(response.payment_url);
	      }).fail(function (response) {
	        self.error = true;
	      });
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    var self = this;
	    var burl = self.$route.params.burl;
	    var date = self.$route.params.date;
	    $.ajax({
	      type: 'POST',
	      url: _store2.default.root + 'api/checkout/postback?burl=' + burl + '&date=' + date,
	      xhrFields: {
	        withCredentials: true
	      }
	    }).done(function () {
	      self.success = true;
	      self.error = false;
	      self.loaded = true;
	    }).fail(function (response) {
	      self.success = false;
	      self.error = true;
	      self.loaded = false;
	    });
	  },
	
	  components: {
	    store: _store2.default
	  },
	  data: function data() {
	    return {
	      loaded: false
	    };
	  },
	
	  methods: {}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _shippingRates = __webpack_require__(72);
	
	var _shippingRates2 = _interopRequireDefault(_shippingRates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      shippingRates: _shippingRates2.default
	    };
	  }
	};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _shippingRates = __webpack_require__(72);
	
	var _shippingRates2 = _interopRequireDefault(_shippingRates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      shippingRates: _shippingRates2.default
	    };
	  }
	};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _CallbackAlert = __webpack_require__(29);
	
	var _CallbackAlert2 = _interopRequireDefault(_CallbackAlert);
	
	var _Modal = __webpack_require__(39);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  route: {
	    canReuse: false
	  },
	  created: function created() {
	    this.getRubrieks();
	  },
	  ready: function ready() {},
	
	  components: {
	    'vc-alert': _CallbackAlert2.default,
	    'v-modal': _Modal2.default
	  },
	  data: function data() {
	    return {
	      store: _store2.default,
	      rubrieks: [],
	      modalsuccess: false,
	      modalerror: false,
	      editsuccess: false,
	      editerror: false,
	      showCustomModal: false,
	      selectedParent: 0
	    };
	  },
	
	  methods: {
	    getRubrieks: function getRubrieks() {
	      $.ajax({
	        type: 'GET',
	        url: _store2.default.root + 'api/MenuItems/',
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function (data) {
	        for (var i = 0; i < data.length; i++) {
	          data[i].Editable = false;
	          for (var c = 0; c < data[i].Children.length; c++) {
	            data[i].Children[c].Editable = false;
	          }
	        }
	        this.rubrieks = data;
	      }.bind(this));
	    },
	    handleRubriek: function handleRubriek(newCategory) {
	      $.ajax({
	        type: 'POST',
	        url: _store2.default.root + 'api/MenuItems',
	        data: newCategory,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        this.modalsuccess = true;
	        this.modalerror = false;
	        setTimeout(function () {
	          location.reload(true);
	        }, 2000);
	      }.bind(this)).fail(function (response) {
	        console.log(response);
	        this.modalsuccess = false;
	        this.modalerror = true;
	      }.bind(this));
	    },
	    refresh: function refresh() {
	      location.reload(true);
	    },
	    save: function save() {
	      var newCategory;
	      if (this.selectedParent > 0) {
	        newCategory = { MenuText: this.newCategoryName, ParentMenuItemId: this.selectedParent, MenuId: 1 };
	      } else {
	        newCategory = { MenuText: this.newCategoryName, MenuId: 1 };
	      }
	      this.handleRubriek(newCategory);
	    },
	    setModal: function setModal(id) {
	      this.newCategoryName = '';
	      this.selectedParent = id;
	      this.showCustomModal = true;
	    },
	    edit: function edit(item) {
	      $.ajax({
	        type: 'PUT',
	        url: _store2.default.root + 'api/MenuItems',
	        data: item,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        this.editsuccess = true;
	        this.editerror = false;
	        setTimeout(function () {
	          location.reload(true);
	        }, 2000);
	      }.bind(this)).fail(function (response) {
	        console.log(response);
	        this.editsuccess = false;
	        this.editerror = true;
	      }.bind(this));
	    },
	    deleteCategory: function deleteCategory(id) {
	      $.ajax({
	        type: 'DELETE',
	        url: _store2.default.root + 'api/MenuItems/' + id,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        location.reload(true);
	      }.bind()).fail(function (response) {
	        console.log(response);
	        this.editsuccess = false;
	        this.editerror = true;
	      }.bind(this));
	    }
	  },
	  computed: {}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Select = __webpack_require__(679);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Upload = __webpack_require__(680);
	
	var _Upload2 = _interopRequireDefault(_Upload);
	
	var _CallbackAlert = __webpack_require__(29);
	
	var _CallbackAlert2 = _interopRequireDefault(_CallbackAlert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  route: {
	    canReuse: false
	  },
	  created: function created() {
	    this.getRubrieks();
	    if (this.$route.params.id !== undefined) {
	      this.update = true;
	      this.getProduct(this.$route.params.id);
	    } else {
	      this.loaded = true;
	    }
	  },
	  ready: function ready() {
	    document.body.scrollTop = document.documentElement.scrollTop = 0;
	  },
	
	  components: {
	    'v-select': _Select2.default,
	    'v-upload': _Upload2.default,
	    'vc-alert': _CallbackAlert2.default
	  },
	  data: function data() {
	    return {
	      store: _store2.default,
	      rubrieks: [],
	      product: {
	        MenuItemId: '',
	        Name: '',
	        Photos: [],
	        Description: '',
	        Price: '',
	        PriceOnRequest: false
	      },
	      success: false,
	      error: false,
	      update: false,
	      loaded: false
	    };
	  },
	
	  methods: {
	    getRubrieks: function getRubrieks() {
	      $.ajax({
	        type: 'GET',
	        url: _store2.default.root + 'api/MenuItems/all',
	        dataType: 'json',
	        xhrFields: {
	          withCredentials: true
	        },
	        success: function (response) {
	          this.rubrieks = response;
	        }.bind(this)
	      });
	    },
	    handleProduct: function handleProduct() {
	      if (this.product.Price === '') {
	        this.product.Price = 0.0;
	      }
	      $.ajax({
	        type: 'POST',
	        url: _store2.default.root + 'api/Products',
	        data: this.product,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        this.success = true;
	        this.error = false;
	      }.bind(this)).fail(function (response) {
	        console.log(response);
	        this.success = false;
	        this.error = true;
	      }.bind(this));
	    },
	    updateProduct: function updateProduct() {
	      $.ajax({
	        type: 'PUT',
	        url: _store2.default.root + 'api/Products/' + this.product.ProductId,
	        data: this.product,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        this.success = true;
	        this.error = false;
	      }.bind(this)).fail(function (response) {
	        console.log(response);
	        this.success = false;
	        this.error = true;
	      }.bind(this));
	    },
	    refresh: function refresh() {
	      location.reload();
	    },
	    getProduct: function getProduct(id) {
	      $.ajax({
	        type: 'GET',
	        url: _store2.default.root + 'api/products/' + id,
	        dataType: 'json',
	        xhrFields: {
	          withCredentials: true
	        },
	        success: function (response) {
	          response.MenuItemId = ['' + response.MenuItemId];
	          this.product = response;
	          this.loaded = true;
	        }.bind(this)
	      });
	    }
	  },
	  computed: {
	    selectOptions: function selectOptions() {
	      return this.rubrieks.map(function (item) {
	        return { value: '' + item.MenuItemId, label: item.MenuText };
	      });
	    },
	    successMessage: function successMessage() {
	      if (this.update) {
	        return 'Advertentie is succesvol bijgewerkt!';
	      } else {
	        return 'Advertentie is succesvol toegevoegd!';
	      }
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _CallbackAlert = __webpack_require__(29);
	
	var _CallbackAlert2 = _interopRequireDefault(_CallbackAlert);
	
	var _Toggle = __webpack_require__(94);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _deleteSweetAlert = __webpack_require__(95);
	
	var _deleteSweetAlert2 = _interopRequireDefault(_deleteSweetAlert);
	
	var _Modal = __webpack_require__(39);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  route: {
	    canReuse: false
	  },
	  components: {
	    'vc-alert': _CallbackAlert2.default,
	    'vui-toggle': _Toggle2.default,
	    'vm-delete': _deleteSweetAlert2.default,
	    'v-modal': _Modal2.default
	  },
	  data: function data() {
	    return {
	      store: _store2.default,
	      adminConfigs: {},
	      success: false,
	      error: false,
	      successMessage: 'Banner succesvol bijgewerkt!',
	      columns: {
	        'Titel': 'Type',
	        'Omschrijving': 'Description',
	        'Status': 'Enabled',
	        ' ': 'Actions'
	      },
	      sortKey: '',
	      reverse: 1,
	      showdeltemodal: false,
	      selectedBanner: null,
	      filterKey: '',
	      showCustomModal: false,
	      edit: false
	    };
	  },
	  created: function created() {
	    this.getAdminConfigs();
	  },
	
	  methods: {
	    getAdminConfigs: function getAdminConfigs() {
	      $.ajax({
	        type: 'GET',
	        url: _store2.default.root + 'api/AdminConfigs',
	        dataType: 'json',
	        xhrFields: {
	          withCredentials: true
	        },
	        success: function (response) {
	          this.adminConfigs = response;
	        }.bind(this)
	      });
	    },
	    remove: function remove() {
	      console.log('Verwijderd~!');
	      $.ajax({
	        type: 'DELETE',
	        url: _store2.default.root + 'api/AdminConfigs/' + this.selectedBanner.ConfigId,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        this.success = true;
	        this.error = false;
	        this.AdminConfigs.$remove(this.selectedBanner);
	        this.selectedBanner = null;
	        this.showdeltemodal = false;
	        console.log('Verwijderd~!');
	      }.bind(this)).fail(function (response) {
	        console.log(response);
	        this.success = false;
	        this.error = true;
	      }.bind(this));
	    },
	    sortBy: function sortBy(sortKey) {
	      this.reverse = this.sortKey === sortKey ? this.reverse * -1 : -1;
	      this.sortKey = sortKey;
	    },
	    setAvailable: function setAvailable(item) {
	      $.ajax({
	        type: 'PUT',
	        url: _store2.default.root + 'api/AdminConfigs/' + item.ConfigId,
	        data: item,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        console.log('change Available succesfully done!');
	      }).fail(function (response) {
	        console.log(response);
	      });
	    },
	    selectBanner: function selectBanner(val) {
	      this.selectedBanner = val;
	      this.showdeltemodal = true;
	    },
	    save: function save() {
	      $.ajax({
	        type: 'POST',
	        url: _store2.default.root + 'api/AdminConfigs',
	        data: this.newBanner,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        this.modalsuccess = true;
	        this.modalerror = false;
	        setTimeout(function () {
	          location.reload(true);
	        }, 2000);
	      }.bind(this)).fail(function (response) {
	        console.log(response);
	        this.modalsuccess = false;
	        this.modalerror = true;
	      }.bind(this));
	    },
	    updateBanner: function updateBanner(item) {
	      $.ajax({
	        type: 'PUT',
	        url: _store2.default.root + 'api/AdminConfigs/' + item.ConfigId,
	        data: item,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        this.success = true;
	        this.error = false;
	        this.edit = false;
	      }.bind(this)).fail(function (response) {
	        console.log(response);
	        this.error = true;
	        this.success = false;
	      }.bind(this));
	    }
	  },
	  computed: {
	    total: function total() {
	      return this.adminConfigs.length;
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Datepicker = __webpack_require__(701);
	
	var _Datepicker2 = _interopRequireDefault(_Datepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  route: {
	    canReuse: false
	  },
	  components: {
	    datepicker: _Datepicker2.default
	  },
	  data: function data() {
	    return {
	      store: _store2.default,
	      analystics: {},
	      columns: {
	        'Dag': 'Day',
	        'Datum': 'Date',
	        'Aantal Gebruikers': 'Value'
	      },
	      sortKey: '',
	      reverse: 1,
	      showdeltemodal: false,
	      filterKey: '',
	      showCustomModal: false,
	      edit: false,
	      barChartLoading: true,
	      barChartOption: null,
	      selectedStartDate: null,
	      selectedEndDate: new Date(),
	      selectedButton: 0,
	      period: '',
	      datepicker: {
	        disabled: {
	          to: new Date(2016, 9, 4)
	        }
	      }
	    };
	  },
	  created: function created() {
	    var self = this;
	    self.selectedStartDate = self.getPrevWeek();
	    self.barChartOption = {
	      backgroundColor: 'rgb(249, 249, 249)',
	      color: ['#ad1457', '#7F4757'],
	      tooltip: {
	        trigger: 'axis',
	        axisPointer: {
	          type: 'line',
	          lineStyle: {
	            color: '#48b',
	            width: 2,
	            type: 'solid'
	          },
	          crossStyle: {
	            color: '#1e90ff',
	            width: 1,
	            type: 'dashed'
	          },
	          shadowStyle: {
	            color: 'rgba(150,150,150,0.3)',
	            width: 'auto',
	            type: 'default'
	          }
	        }
	      },
	      toolbox: {
	        show: true,
	        feature: {
	          dataZoom: {
	            yAxisIndex: 'none',
	            title: {
	              zoom: 'selecteren',
	              back: 'herstel'
	            }
	          },
	          magicType: {
	            show: true,
	            title: {
	              line: 'lijn',
	              bar: 'staaf'
	            },
	            type: ['line', 'bar']
	          },
	          saveAsImage: {
	            show: true,
	            title: 'opslaan',
	            type: 'png',
	            name: 'catootjeskraam_gebruikers',
	            pixelRatio: 10
	          }
	        }
	      },
	      xAxis: {
	        data: []
	      },
	      yAxis: {},
	      series: [{
	        name: 'Gebruikers',
	        type: 'line',
	        data: [],
	        markPoint: {
	          data: [{ type: 'max', name: 'max' }, { type: 'min', name: 'min' }]
	        }
	      }],
	      dataZoom: {
	        show: true,
	        start: 0,
	        end: 100
	      }
	    };
	    self.getAnalystics();
	  },
	  ready: function ready() {
	    var self = this;
	    self.$on('datepicker.updatedBegin', function (val) {
	      self.getAnalystics(self.period);
	    });
	    self.$on('datepicker.updatedEnd', function (val) {
	      self.getAnalystics(self.period);
	    });
	  },
	
	  methods: {
	    getAnalystics: function getAnalystics(period) {
	      var self = this;
	      self.barChartLoading = true;
	      var startDate = 'startdate=' + self.formatDate(self.selectedStartDate, 'yyyy-MM-dd') + '&';
	      var endDate = 'enddate=' + self.formatDate(self.selectedEndDate, 'yyyy-MM-dd') + '&';
	      period = 'period=' + period;
	      var query = startDate + endDate + period;
	      $.ajax({
	        type: 'GET',
	        url: _store2.default.root + 'api/Analystics?' + query,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function (response) {
	        self.analystics = response;
	        self.fillChart(self.analystics);
	      }).fail(function (response) {
	        self.success = false;
	        self.error = true;
	        self.loaded = false;
	      });
	    },
	    fillChart: function fillChart(response) {
	      var self = this;
	      var reveredResponse = response.slice(0);
	      reveredResponse.reverse();
	      self.barChartOption.xAxis.data = [];
	      self.barChartOption.series[0].data = [];
	      for (var j = 0; j < reveredResponse.length; j++) {
	        self.barChartOption.xAxis.data.push(reveredResponse[j].DateSubmitted);
	        self.barChartOption.series[0].data.push(parseInt(reveredResponse[j].Value));
	      }
	      self.barChartLoading = false;
	    },
	    sortBy: function sortBy(sortKey) {
	      this.reverse = this.sortKey === sortKey ? this.reverse * -1 : -1;
	      this.sortKey = sortKey;
	    },
	    isSelectedButton: function isSelectedButton(i) {
	      var self = this;
	      return i === self.selectedButton;
	    },
	    getPrevWeek: function getPrevWeek() {
	      var datetimer = new Date();
	      var res = datetimer.setDate(datetimer.getDate() - 7);
	      return new Date(res);
	    },
	    formatDate: function formatDate(date, format) {
	      var year = date.getFullYear();
	      var month = date.getMonth() + 1;
	      var day = date.getDate();
	      var str = format.replace(/yyyy/, year).replace(/yy/, String(year).slice(2)).replace(/MM/, ('0' + month).slice(-2)).replace(/M(?!a)/, month).replace(/dd/, ('0' + day).slice(-2)).replace(/d/, day);
	      return str;
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _CallbackAlert = __webpack_require__(29);
	
	var _CallbackAlert2 = _interopRequireDefault(_CallbackAlert);
	
	var _Toggle = __webpack_require__(94);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _deleteSweetAlert = __webpack_require__(95);
	
	var _deleteSweetAlert2 = _interopRequireDefault(_deleteSweetAlert);
	
	var _Modal = __webpack_require__(39);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  route: {
	    canReuse: false
	  },
	  components: {
	    'vc-alert': _CallbackAlert2.default,
	    'vui-toggle': _Toggle2.default,
	    'vm-delete': _deleteSweetAlert2.default,
	    'vm-offer': _Modal2.default
	  },
	  data: function data() {
	    return {
	      store: _store2.default,
	      products: {},
	      success: false,
	      error: false,
	      successMessage: 'Advertentie succesvol verwijderd!',
	      columns: {
	        '': 'Photos',
	        'Naam': 'Name',
	        'Prijs': 'Price',
	        'Status': 'Available',
	        'Datum': 'DatePlaced',
	        ' ': 'Actions'
	      },
	      sortKey: '',
	      reverse: 1,
	      showdeltemodal: false,
	      selectedProduct: null,
	      filterKey: ''
	    };
	  },
	  created: function created() {
	    this.getProducts();
	  },
	
	  methods: {
	    getProducts: function getProducts() {
	      $.ajax({
	        type: 'GET',
	        url: _store2.default.root + 'api/products',
	        dataType: 'json',
	        xhrFields: {
	          withCredentials: true
	        },
	        success: function (response) {
	          this.products = response;
	        }.bind(this)
	      });
	    },
	    remove: function remove() {
	      console.log('Verwijderd~!');
	      $.ajax({
	        type: 'DELETE',
	        url: _store2.default.root + 'api/Products/' + this.selectedProduct.ProductId,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        this.success = true;
	        this.error = false;
	        this.products.$remove(this.selectedProduct);
	        this.selectedProduct = null;
	        this.showdeltemodal = false;
	        console.log('Verwijderd~!');
	      }.bind(this)).fail(function (response) {
	        console.log(response);
	        this.success = false;
	        this.error = true;
	      }.bind(this));
	    },
	    sortBy: function sortBy(sortKey) {
	      this.reverse = this.sortKey === sortKey ? this.reverse * -1 : -1;
	      this.sortKey = sortKey;
	    },
	    setAvailable: function setAvailable(item) {
	      $.ajax({
	        type: 'PUT',
	        url: _store2.default.root + 'api/Products/' + item.ProductId,
	        data: item,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        console.log('change Available succesfully done!');
	      }).fail(function (response) {
	        console.log(response);
	      });
	    },
	    selectProduct: function selectProduct(val, type) {
	      this.selectedProduct = val;
	      console.log(type);
	      if (type === 'delete') {
	        this.showdeltemodal = true;
	      }
	      if (type === 'offer') {
	        val.Offered = true;
	        this.setAvailable(val);
	      }
	      if (type === 'offerOff') {
	        val.Offered = false;
	        this.setAvailable(val);
	      }
	    },
	    filterOnIsOffered: function filterOnIsOffered() {
	      this.sortBy('Offered');
	    }
	  },
	  computed: {
	    total: function total() {
	      return this.products.length;
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _CallbackAlert = __webpack_require__(29);
	
	var _CallbackAlert2 = _interopRequireDefault(_CallbackAlert);
	
	var _Toggle = __webpack_require__(94);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _deleteSweetAlert = __webpack_require__(95);
	
	var _deleteSweetAlert2 = _interopRequireDefault(_deleteSweetAlert);
	
	var _Modal = __webpack_require__(39);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  route: {
	    canReuse: false
	  },
	  components: {
	    'vc-alert': _CallbackAlert2.default,
	    'vui-toggle': _Toggle2.default,
	    'vm-delete': _deleteSweetAlert2.default,
	    'v-modal': _Modal2.default
	  },
	  data: function data() {
	    return {
	      store: _store2.default,
	      Reviews: {},
	      success: false,
	      error: false,
	      successMessage: 'review succesvol bijgewerkt!',
	      columns: {
	        'Naam': 'Type',
	        'Omschrijving': 'Description',
	        'Status': 'Enabled',
	        ' ': 'Actions'
	      },
	      sortKey: '',
	      reverse: 1,
	      showdeltemodal: false,
	      selectedreview: null,
	      filterKey: '',
	      showCustomModal: false,
	      edit: false
	    };
	  },
	  created: function created() {
	    this.getReviews();
	  },
	
	  methods: {
	    getReviews: function getReviews() {
	      $.ajax({
	        type: 'GET',
	        url: _store2.default.root + 'api/reviews/GetAll',
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        dataType: 'json',
	        xhrFields: {
	          withCredentials: true
	        },
	        success: function (response) {
	          this.Reviews = response;
	        }.bind(this)
	      });
	    },
	    remove: function remove() {
	      console.log('Verwijderd~!');
	      $.ajax({
	        type: 'DELETE',
	        url: _store2.default.root + 'api/reviews/' + this.selectedreview.ReviewId,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        this.success = true;
	        this.error = false;
	        this.Reviews.$remove(this.selectedreview);
	        this.selectedreview = null;
	        this.showdeltemodal = false;
	        console.log('Verwijderd~!');
	      }.bind(this)).fail(function (response) {
	        console.log(response);
	        this.success = false;
	        this.error = true;
	      }.bind(this));
	    },
	    sortBy: function sortBy(sortKey) {
	      this.reverse = this.sortKey === sortKey ? this.reverse * -1 : -1;
	      this.sortKey = sortKey;
	    },
	    setAvailable: function setAvailable(item) {
	      $.ajax({
	        type: 'PUT',
	        url: _store2.default.root + 'api/reviews/' + item.ReviewId,
	        data: item,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        console.log('change Available succesfully done!');
	      }).fail(function (response) {
	        console.log(response);
	      });
	    },
	    selectreview: function selectreview(val) {
	      this.selectedreview = val;
	      this.showdeltemodal = true;
	    },
	    save: function save() {
	      $.ajax({
	        type: 'POST',
	        url: _store2.default.root + 'api/Reviews',
	        data: this.newreview,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        this.modalsuccess = true;
	        this.modalerror = false;
	        setTimeout(function () {
	          location.reload(true);
	        }, 2000);
	      }.bind(this)).fail(function (response) {
	        console.log(response);
	        this.modalsuccess = false;
	        this.modalerror = true;
	      }.bind(this));
	    },
	    updatereview: function updatereview(item) {
	      $.ajax({
	        type: 'PUT',
	        url: _store2.default.root + 'api/Reviews/' + item.ConfigId,
	        data: item,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        this.success = true;
	        this.error = false;
	        this.edit = false;
	      }.bind(this)).fail(function (response) {
	        console.log(response);
	        this.error = true;
	        this.success = false;
	      }.bind(this));
	    }
	  },
	  computed: {
	    total: function total() {
	      return this.Reviews.length;
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _CallbackAlert = __webpack_require__(29);
	
	var _CallbackAlert2 = _interopRequireDefault(_CallbackAlert);
	
	var _Toggle = __webpack_require__(94);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _deleteSweetAlert = __webpack_require__(95);
	
	var _deleteSweetAlert2 = _interopRequireDefault(_deleteSweetAlert);
	
	var _Modal = __webpack_require__(39);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _betalenCart = __webpack_require__(211);
	
	var _betalenCart2 = _interopRequireDefault(_betalenCart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  route: {
	    canReuse: false
	  },
	  components: {
	    'vc-alert': _CallbackAlert2.default,
	    'vui-toggle': _Toggle2.default,
	    'vm-delete': _deleteSweetAlert2.default,
	    'v-modal': _Modal2.default,
	    overzicht: _betalenCart2.default
	  },
	  data: function data() {
	    return {
	      store: _store2.default,
	      Orders: {},
	      success: false,
	      error: false,
	      successMessage: 'order succesvol bijgewerkt!',
	      columns: {
	        'Klantnaam': 'CustomerName',
	        'Email': 'CustomerMail',
	        'Adres': 'Address',
	        'Datum': 'DateSubmitted',
	        'Subtotaal': 'SubTotal',
	        'Verzendkosten': 'ShipCosts',
	        'Totaal': 'Total',
	
	        ' ': 'Actions'
	      },
	      sortKey: '',
	      reverse: 1,
	      showdeltemodal: false,
	      selectedorder: null,
	      filterKey: '',
	      showCustomModal: false,
	      edit: false
	    };
	  },
	  created: function created() {
	    this.getOrders();
	  },
	
	  methods: {
	    getOrders: function getOrders() {
	      $.ajax({
	        type: 'GET',
	        url: _store2.default.root + 'api/invoices',
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        dataType: 'json',
	        xhrFields: {
	          withCredentials: true
	        },
	        success: function (response) {
	          this.Orders = response;
	        }.bind(this)
	      });
	    },
	    remove: function remove() {
	      console.log('Verwijderen~!');
	      $.ajax({
	        type: 'DELETE',
	        url: _store2.default.root + 'api/Invoices/' + this.selectedorder.Id,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        this.success = true;
	        this.error = false;
	        this.Orders.$remove(this.selectedorder);
	        this.selectedorder = null;
	        this.showdeltemodal = false;
	        console.log('Verwijderd~!');
	      }.bind(this)).fail(function (response) {
	        console.log(response);
	        this.success = false;
	        this.error = true;
	      }.bind(this));
	    },
	    sortBy: function sortBy(sortKey) {
	      this.reverse = this.sortKey === sortKey ? this.reverse * -1 : -1;
	      this.sortKey = sortKey;
	    },
	    setAvailable: function setAvailable(item) {
	      $.ajax({
	        type: 'PUT',
	        url: _store2.default.root + 'api/invoices/' + item.Id,
	        data: item,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        this.success = true;
	        console.log('change Available succesfully done!');
	      }).fail(function (response) {
	        console.log(response);
	      });
	    },
	    selectorder: function selectorder(val, type) {
	      this.selectedorder = val;
	      if (type === 'delete') {
	        this.showdeltemodal = true;
	      } else {
	        this.showCustomModal = true;
	      }
	    },
	    updateorder: function updateorder() {
	      $.ajax({
	        type: 'PUT',
	        url: _store2.default.root + 'api/Invoices/' + this.selectedorder.Id,
	        data: this.selectedorder,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'Bearer ' + _store2.default.token);
	        },
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        this.success = true;
	        this.error = false;
	        this.edit = false;
	        this.selectedorder = null;
	        this.showCustomModal = false;
	      }.bind(this)).fail(function (response) {
	        console.log(response);
	        this.error = true;
	        this.success = false;
	      }.bind(this));
	    }
	  },
	  computed: {
	    total: function total() {
	      return this.Orders.length;
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DateUtils = __webpack_require__(232);
	
	var _DateUtils2 = _interopRequireDefault(_DateUtils);
	
	var _DateLanguages = __webpack_require__(142);
	
	var _DateLanguages2 = _interopRequireDefault(_DateLanguages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  props: {
	    value: {
	      validator: function validator(val) {
	        return val === null || val instanceof Date;
	      }
	    },
	    name: {
	      value: String
	    },
	    format: {
	      value: String,
	      default: 'dd-MM-yyyy'
	    },
	    language: {
	      value: String,
	      default: 'en'
	    },
	    disabled: {
	      type: Object
	    },
	    placeholder: {
	      type: String
	    },
	    inline: {
	      type: Boolean
	    }
	  },
	  data: function data() {
	    return {
	      currDate: new Date().getTime(),
	
	      selectedDate: null,
	
	      showDayView: false,
	      showMonthView: false,
	      showYearView: false,
	
	      translation: _DateLanguages2.default.translations[this.language],
	      formattedValue: null,
	
	      calendarHeight: 0
	    };
	  },
	
	  watch: {
	    value: function value(_value) {
	      this.setValue(_value);
	    }
	  },
	  computed: {
	    currMonthName: function currMonthName() {
	      var d = new Date(this.currDate);
	      return _DateUtils2.default.getMonthNameAbbr(d.getMonth(), this.translation.months.abbr);
	    },
	    currYear: function currYear() {
	      var d = new Date(this.currDate);
	      return d.getFullYear();
	    },
	    blankDays: function blankDays() {
	      var d = new Date(this.currDate);
	      var dObj = new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
	      return dObj.getDay();
	    },
	    days: function days() {
	      var d = new Date(this.currDate);
	      var days = [];
	
	      var dObj = new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
	      var daysInMonth = _DateUtils2.default.daysInMonth(dObj.getFullYear(), dObj.getMonth());
	      for (var i = 0; i < daysInMonth; i++) {
	        days.push({
	          date: dObj.getDate(),
	          timestamp: dObj.getTime(),
	          isSelected: this.isSelectedDate(dObj),
	          isDisabled: this.isDisabledDate(dObj)
	        });
	        dObj.setDate(dObj.getDate() + 1);
	      }
	      return days;
	    },
	    months: function months() {
	      var d = new Date(this.currDate);
	      var months = [];
	
	      var dObj = new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes());
	      for (var i = 0; i < 12; i++) {
	        months.push({
	          month: _DateUtils2.default.getMonthName(i, this.translation.months.original),
	          timestamp: dObj.getTime(),
	          isSelected: this.isSelectedMonth(dObj),
	          isDisabled: this.isDisabledMonth(dObj)
	        });
	        dObj.setMonth(dObj.getMonth() + 1);
	      }
	      return months;
	    },
	    years: function years() {
	      var d = new Date(this.currDate);
	      var years = [];
	
	      var dObj = new Date(Math.floor(d.getFullYear() / 10) * 10, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());
	      for (var i = 0; i < 10; i++) {
	        years.push({
	          year: dObj.getFullYear(),
	          timestamp: dObj.getTime(),
	          isSelected: this.isSelectedYear(dObj),
	          isDisabled: this.isDisabledYear(dObj)
	        });
	        dObj.setFullYear(dObj.getFullYear() + 1);
	      }
	      return years;
	    },
	    calendarStyle: function calendarStyle() {
	      var elSize = this.$el.getBoundingClientRect();
	      var heightNeeded = elSize.top + elSize.height + this.calendarHeight;
	      var styles = {};
	
	      if (heightNeeded > window.innerHeight) {
	        styles = {
	          'bottom': elSize.height + 'px'
	        };
	      }
	      if (this.isInline()) {
	        styles.position = 'static';
	      }
	
	      return styles;
	    },
	    calendarStyleSecondary: function calendarStyleSecondary() {
	      return this.isInline() ? { 'position': 'static' } : {};
	    }
	  },
	  methods: {
	    close: function close() {
	      this.showDayView = this.showMonthView = this.showYearView = false;
	    },
	    isOpen: function isOpen() {
	      return this.showDayView || this.showMonthView || this.showYearView;
	    },
	    isInline: function isInline() {
	      return typeof this.inline !== 'undefined' && this.inline;
	    },
	    showCalendar: function showCalendar() {
	      if (this.isInline()) {
	        return false;
	      }
	      this.isOpen() ? this.close() : this.showDayCalendar();
	    },
	    showDayCalendar: function showDayCalendar() {
	      this.close();
	      this.showDayView = true;
	      this.dispatchOpenEvent();
	    },
	    showMonthCalendar: function showMonthCalendar() {
	      this.close();
	      this.showMonthView = true;
	    },
	    showYearCalendar: function showYearCalendar() {
	      this.close();
	      this.showYearView = true;
	    },
	    setDate: function setDate(timestamp) {
	      this.value = this.selectedDate = new Date(timestamp);
	      this.currDate = timestamp;
	
	      var d = new Date(timestamp);
	      this.formattedValue = _DateUtils2.default.formatDate(d, this.format, this.translation);
	
	      this.dispatchSelectEvent(timestamp);
	    },
	    dispatchSelectEvent: function dispatchSelectEvent(timestamp) {
	      if (this.name) {
	        this.$dispatch('datepicker.' + this.name, {
	          value: timestamp
	        });
	      }
	    },
	    dispatchOpenEvent: function dispatchOpenEvent() {
	      if (this.name) {
	        this.$dispatch('datepicker.' + this.name + '.open');
	      }
	    },
	    selectDate: function selectDate(day) {
	      if (day.isDisabled) {
	        return false;
	      }
	      this.setDate(day.timestamp);
	      this.isInline() ? this.showDayCalendar() : this.close();
	    },
	    selectMonth: function selectMonth(month) {
	      if (month.isDisabled) {
	        return false;
	      }
	      this.currDate = month.timestamp;
	      this.showDayCalendar();
	    },
	    selectYear: function selectYear(year) {
	      if (year.isDisabled) {
	        return false;
	      }
	      this.currDate = year.timestamp;
	      this.showMonthCalendar();
	    },
	    getMonth: function getMonth() {
	      var d = new Date(this.currDate);
	      return d.getMonth();
	    },
	    getYear: function getYear() {
	      var d = new Date(this.currDate);
	      return d.getFullYear();
	    },
	    getDecade: function getDecade() {
	      var d = new Date(this.currDate);
	      var sD = Math.floor(d.getFullYear() / 10) * 10;
	      return sD + '\'s';
	    },
	    previousMonth: function previousMonth() {
	      if (this.previousMonthDisabled()) {
	        return false;
	      }
	      var d = new Date(this.currDate);
	      d.setMonth(d.getMonth() - 1);
	      this.currDate = d.getTime();
	    },
	    previousMonthDisabled: function previousMonthDisabled() {
	      if (typeof this.disabled === 'undefined' || typeof this.disabled.to === 'undefined' || !this.disabled.to) {
	        return false;
	      }
	      var d = new Date(this.currDate);
	      if (this.disabled.to.getMonth() >= d.getMonth() && this.disabled.to.getFullYear() >= d.getFullYear()) {
	        return true;
	      }
	      return false;
	    },
	    nextMonth: function nextMonth() {
	      if (this.nextMonthDisabled()) {
	        return false;
	      }
	      var d = new Date(this.currDate);
	      d.setMonth(d.getMonth() + 1);
	      this.currDate = d.getTime();
	    },
	    nextMonthDisabled: function nextMonthDisabled() {
	      if (typeof this.disabled === 'undefined' || typeof this.disabled.from === 'undefined' || !this.disabled.from) {
	        return false;
	      }
	      var d = new Date(this.currDate);
	      if (this.disabled.from.getMonth() <= d.getMonth() && this.disabled.from.getFullYear() <= d.getFullYear()) {
	        return true;
	      }
	      return false;
	    },
	    previousYear: function previousYear() {
	      if (this.previousYearDisabled()) {
	        return false;
	      }
	      var d = new Date(this.currDate);
	      d.setYear(d.getFullYear() - 1);
	      this.currDate = d.getTime();
	    },
	    previousYearDisabled: function previousYearDisabled() {
	      if (typeof this.disabled === 'undefined' || typeof this.disabled.to === 'undefined' || !this.disabled.to) {
	        return false;
	      }
	      var d = new Date(this.currDate);
	      if (this.disabled.to.getFullYear() >= d.getFullYear()) {
	        return true;
	      }
	      return false;
	    },
	    nextYear: function nextYear() {
	      if (this.nextYearDisabled()) {
	        return false;
	      }
	      var d = new Date(this.currDate);
	      d.setYear(d.getFullYear() + 1);
	      this.currDate = d.getTime();
	    },
	    nextYearDisabled: function nextYearDisabled() {
	      if (typeof this.disabled === 'undefined' || typeof this.disabled.from === 'undefined' || !this.disabled.from) {
	        return false;
	      }
	      var d = new Date(this.currDate);
	      if (this.disabled.from.getFullYear() <= d.getFullYear()) {
	        return true;
	      }
	      return false;
	    },
	    previousDecade: function previousDecade() {
	      if (this.previousDecadeDisabled()) {
	        return false;
	      }
	      var d = new Date(this.currDate);
	      d.setYear(d.getFullYear() - 10);
	      this.currDate = d.getTime();
	    },
	    previousDecadeDisabled: function previousDecadeDisabled() {
	      if (typeof this.disabled === 'undefined' || typeof this.disabled.to === 'undefined' || !this.disabled.to) {
	        return false;
	      }
	      var d = new Date(this.currDate);
	      if (Math.floor(this.disabled.to.getFullYear() / 10) * 10 <= Math.floor(d.getFullYear() / 10) * 10) {
	        return true;
	      }
	      return false;
	    },
	    nextDecade: function nextDecade() {
	      if (this.nextDecadeDisabled()) {
	        return false;
	      }
	      var d = new Date(this.currDate);
	      d.setYear(d.getFullYear() + 10);
	      this.currDate = d.getTime();
	    },
	    nextDecadeDisabled: function nextDecadeDisabled() {
	      if (typeof this.disabled === 'undefined' || typeof this.disabled.from === 'undefined' || !this.disabled.from) {
	        return false;
	      }
	      var d = new Date(this.currDate);
	      if (Math.ceil(this.disabled.from.getFullYear() / 10) * 10 >= Math.ceil(d.getFullYear() / 10) * 10) {
	        return true;
	      }
	      return false;
	    },
	    isSelectedDate: function isSelectedDate(dObj) {
	      return this.selectedDate && this.selectedDate.toDateString() === dObj.toDateString();
	    },
	    isDisabledDate: function isDisabledDate(date) {
	      var disabled = false;
	
	      if (typeof this.disabled === 'undefined') {
	        return false;
	      }
	
	      if (typeof this.disabled.dates !== 'undefined') {
	        this.disabled.dates.forEach(function (d) {
	          if (date.toDateString() === d.toDateString()) {
	            disabled = true;
	            return true;
	          }
	        });
	      }
	      if (typeof this.disabled.to !== 'undefined' && this.disabled.to && date < this.disabled.to) {
	        disabled = true;
	      }
	      if (typeof this.disabled.from !== 'undefined' && this.disabled.from && date > this.disabled.from) {
	        disabled = true;
	      }
	      if (typeof this.disabled.days !== 'undefined' && this.disabled.days.indexOf(date.getDay()) !== -1) {
	        disabled = true;
	      }
	      return disabled;
	    },
	    isSelectedMonth: function isSelectedMonth(date) {
	      return this.selectedDate && this.selectedDate.getFullYear() === date.getFullYear() && this.selectedDate.getMonth() === date.getMonth();
	    },
	    isDisabledMonth: function isDisabledMonth(date) {
	      var disabled = false;
	
	      if (typeof this.disabled === 'undefined') {
	        return false;
	      }
	
	      if (typeof this.disabled.to !== 'undefined' && this.disabled.to) {
	        if (date.getMonth() < this.disabled.to.getMonth() && date.getFullYear() <= this.disabled.to.getFullYear() || date.getFullYear() < this.disabled.to.getFullYear()) {
	          disabled = true;
	        }
	      }
	      if (typeof this.disabled.from !== 'undefined' && this.disabled.from) {
	        if (this.disabled.from && date.getMonth() > this.disabled.from.getMonth() && date.getFullYear() >= this.disabled.from.getFullYear() || date.getFullYear() > this.disabled.from.getFullYear()) {
	          disabled = true;
	        }
	      }
	      return disabled;
	    },
	    isSelectedYear: function isSelectedYear(date) {
	      return this.selectedDate && this.selectedDate.getFullYear() === date.getFullYear();
	    },
	    isDisabledYear: function isDisabledYear(date) {
	      var disabled = false;
	      if (typeof this.disabled === 'undefined' || !this.disabled) {
	        return false;
	      }
	
	      if (typeof this.disabled.to !== 'undefined' && this.disabled.to) {
	        if (date.getFullYear() < this.disabled.to.getFullYear()) {
	          disabled = true;
	        }
	      }
	      if (typeof this.disabled.from !== 'undefined' && this.disabled.from) {
	        if (date.getFullYear() > this.disabled.from.getFullYear()) {
	          disabled = true;
	        }
	      }
	
	      return disabled;
	    },
	    setValue: function setValue(date) {
	      if (!date) {
	        var d = new Date();
	        this.currDate = new Date(d.getFullYear(), d.getMonth(), 1).getTime();
	        this.selectedDate = this.formattedValue = null;
	        return;
	      }
	      this.selectedDate = date;
	      this.currDate = new Date(date.getFullYear(), date.getMonth(), 1).getTime();
	      this.formattedValue = _DateUtils2.default.formatDate(date, this.format, this.translation);
	    }
	  },
	  ready: function ready() {
	    var _this = this;
	
	    if (this.value) {
	      this.setValue(this.value);
	    }
	    if (this.isInline()) {
	      this.showDayCalendar();
	    }
	
	    this.$nextTick(function () {
	      _this.calendarHeight = _this.$el.querySelector('.calendar').getBoundingClientRect().height;
	    });
	
	    document.addEventListener('click', function (e) {
	      if (_this.$el && !_this.$el.contains(e.target)) {
	        _this.isInline() ? _this.showDayCalendar() : _this.close();
	      }
	    }, false);
	  }
	};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(272);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  data: function data() {
	    return {
	      store: _store2.default,
	      username: '',
	      password: '',
	      error: ''
	    };
	  },
	  methods: {
	    login: function login(e) {
	      e.preventDefault();
	      var self = this;
	      var checkforQuery = (0, _keys2.default)(self.$route.query).length === 0 && self.$route.query.constructor === Object;
	      _store2.default.login(self.username, self.password, function (success, message) {
	        if (success) {
	          if (!checkforQuery) {
	            var query = self.$route.query;
	            console.log(query);
	            self.$route.router.go(query);
	          }
	          self.$route.router.go({ name: 'Dashboard' });
	        } else {
	          self.error = JSON.parse(message.responseText).error_description;
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    this.getMenuItems();
	  },
	
	  components: {},
	  data: function data() {
	    return {
	      store: _store2.default,
	      MenuItems: null,
	      searchTerm: ''
	    };
	  },
	  methods: {
	    getMenuItems: function getMenuItems() {
	      $.ajax({
	        type: 'GET',
	        url: _store2.default.root + 'api/MenuItems',
	        dataType: 'json',
	        xhrFields: {
	          withCredentials: true
	        },
	        success: function (response) {
	          this.MenuItems = response;
	        }.bind(this)
	      });
	    },
	    logout: function logout() {
	      _store2.default.logout();
	      this.$route.router.go({ name: 'Welkom' });
	    },
	    search: function search(e) {
	      this.$route.router.go({ path: '/search/' + this.searchTerm });
	    },
	    selectCat: function selectCat(name) {
	      _store2.default.selectedCat = name;
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(61);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _accounting = __webpack_require__(102);
	
	var _accounting2 = _interopRequireDefault(_accounting);
	
	var _shippingRates = __webpack_require__(72);
	
	var _shippingRates2 = _interopRequireDefault(_shippingRates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {},
	  route: {
	    canReuse: false
	  },
	  components: {},
	  data: function data() {
	    return {
	      store: _store2.default,
	      shippingCost: _shippingRates2.default.shipping_rates[0].price
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove(index) {
	      this.products.splice(index, 1);
	      sessionStorage.setItem('winkelwagen', (0, _stringify2.default)(this.products));
	    }
	  },
	  computed: {
	    products: function products() {
	      return this.store.cart;
	    },
	    subtotal: function subtotal() {
	      var total = 0;
	      for (var i = 0; i < this.products.length; ++i) {
	        if (this.products[i].Quantity < 1) {
	          this.products[i].Quantity = 1;
	        }
	        total += parseFloat(_accounting2.default.unformat(this.products[i].Price, ',')) * this.products[i].Quantity;
	      }
	      return total;
	    },
	    totalPrice: function totalPrice() {
	      return (this.subtotal || 0) + (this.shippingCost || 0);
	    }
	  }
	};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _accounting = __webpack_require__(102);
	
	var _accounting2 = _interopRequireDefault(_accounting);
	
	var _shippingRates = __webpack_require__(72);
	
	var _shippingRates2 = _interopRequireDefault(_shippingRates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    invoice: {
	      type: Object,
	      twoWay: true
	    }
	  },
	  route: {
	    canReuse: false
	  },
	  components: {},
	  data: function data() {
	    return {
	      shippingCost: _shippingRates2.default.shipping_rates[0].price
	    };
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: {
	    products: function products() {
	      return this.invoice.products;
	    },
	    subtotal: function subtotal() {
	      var total = 0;
	      for (var i = 0; i < this.products.length; ++i) {
	        if (this.products[i].Quantity < 1) {
	          this.products[i].Quantity = 1;
	        }
	        total += parseFloat(_accounting2.default.unformat(this.products[i].Price, ',')) * this.products[i].Quantity;
	      }
	      return total;
	    },
	    totalPrice: function totalPrice() {
	      return (this.subtotal || 0) + (this.shippingCost || 0);
	    }
	  }
	};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cart = __webpack_require__(705);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _wizard = __webpack_require__(709);
	
	var _wizard2 = _interopRequireDefault(_wizard);
	
	var _wizardStep = __webpack_require__(708);
	
	var _wizardStep2 = _interopRequireDefault(_wizardStep);
	
	var _confirm = __webpack_require__(706);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _CallbackAlert = __webpack_require__(29);
	
	var _CallbackAlert2 = _interopRequireDefault(_CallbackAlert);
	
	var _shippingRates = __webpack_require__(72);
	
	var _shippingRates2 = _interopRequireDefault(_shippingRates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  route: {
	    canReuse: false
	  },
	  components: {
	    'v-cart': _cart2.default,
	    'v-confirm': _confirm2.default,
	    'vs-wizard': _wizard2.default,
	    'vs-wizard-step': _wizardStep2.default,
	    'vc-alert': _CallbackAlert2.default
	  },
	  data: function data() {
	    return {
	      store: _store2.default,
	
	      invoice: {
	        customer: {
	          sex: '',
	          firstname: '',
	          lastname: '',
	          email: '',
	          street: '',
	          housenumber: '',
	          housenumberr: '',
	          housenumberaddition: '',
	          zipcode: '',
	          city: ''
	        },
	        shipCosts: _shippingRates2.default.shipping_rates[0].price,
	        products: []
	      },
	      progress: {
	        step1: 0,
	        step2: 0,
	        step3: 0
	      },
	      currentStep: 0,
	      confirmed: false,
	      sending: false,
	      success: false,
	      sended: false
	    };
	  },
	  created: function created() {
	    var self = this;
	    if (self.currentStep === 0) {
	      self.progress.step1 = 0;
	      setTimeout(function () {
	        if (self.store.cart.length > 0) {
	          self.progress.step1 = 100;
	        }
	      }, 10);
	    }
	  },
	
	  methods: {
	    startAgain: function startAgain() {
	      this.invoice = {
	        shipCosts: _shippingRates2.default.shipping_rates[0].price,
	        products: []
	      };
	      this.invoice.customer = {
	        sex: '',
	        firstname: '',
	        lastname: '',
	        email: '',
	        street: '',
	        housenumber: '',
	        housenumberr: '',
	        housenumberaddition: '',
	        zipcode: '',
	        city: ''
	      };
	      this.progress = {
	        step2: 0,
	        step3: 0
	      };
	      this.currentStep = 0;
	    },
	    GoToConfirm: function GoToConfirm() {
	      this.invoice.customer.housenumber = [this.invoice.customer.housenumberr, this.invoice.customer.housenumberaddition.toUpperCase()].filter(Boolean).join(' ');
	      this.invoice.products = this.store.cart;
	      window.scrollTo(0, 0);
	      this.currentStep++;
	    },
	    removeSpaces: function removeSpaces() {
	      this.invoice.customer.zipcode = this.invoice.customer.zipcode.replace(/ /g, '').toUpperCase();
	    },
	    handleInvoice: function handleInvoice() {
	      this.sending = true;
	
	      $.ajax({
	        type: 'POST',
	        url: _store2.default.root + 'api/Invoices',
	        data: this.invoice,
	        xhrFields: {
	          withCredentials: true
	        }
	      }).done(function () {
	        sessionStorage.removeItem('winkelwagen');
	        this.store.cart = [];
	        this.success = true;
	        this.error = false;
	        this.sending = false;
	        this.confirmed = false;
	        this.sended = true;
	      }.bind(this)).fail(function (response) {
	        this.success = false;
	        this.error = true;
	      }.bind(this));
	    }
	  },
	  watch: {
	    invoice: {
	      handler: function handler() {
	        if (this.currentStep === 1) {
	          this.progress.step2 = 0;
	          if (this.invoice.customer.sex.length) {
	            this.progress.step2 += 100 / 8;
	          }
	          if (this.invoice.customer.firstname.length) {
	            this.progress.step2 += 100 / 8;
	          }
	          if (this.invoice.customer.lastname.length) {
	            this.progress.step2 += 100 / 8;
	          }
	          if (this.invoice.customer.email.length) {
	            this.progress.step2 += 100 / 8;
	          }
	          if (this.invoice.customer.street.length) {
	            this.progress.step2 += 100 / 8;
	          }
	          if (this.invoice.customer.housenumber.length) {
	            this.progress.step2 += 100 / 8;
	          }
	          if (this.invoice.customer.zipcode.length) {
	            this.progress.step2 += 100 / 8;
	          }
	          if (this.invoice.customer.city.length) {
	            this.progress.step2 += 100 / 8;
	          }
	          if (this.progress.step2 === 100) {
	            if (this.$customerValidation.valid) {
	              this.progress.step2 = 100;
	            } else {
	              this.progress.step2 = 99;
	            }
	          }
	        }
	      },
	
	      deep: true
	    },
	    store: {
	      handler: function handler(val, oldVal) {
	        var self = this;
	
	        if (self.store.cart.length < 1) {
	          self.progress.step1 = 0;
	        }
	      },
	      deep: true
	    }
	  },
	  computed: {
	    checkSex: function checkSex() {
	      return this.$customerValidation.sex.required && this.$customerValidation.sex.touched;
	    },
	    checkFirstname: function checkFirstname() {
	      return this.$customerValidation.firstname.required && this.$customerValidation.firstname.touched;
	    },
	    checkLastname: function checkLastname() {
	      return this.$customerValidation.lastname.required && this.$customerValidation.lastname.touched;
	    },
	    checkEmail: function checkEmail() {
	      return this.$customerValidation.email.email && this.$customerValidation.email.touched;
	    },
	    checkStreet: function checkStreet() {
	      return this.$customerValidation.street.required && this.$customerValidation.street.touched;
	    },
	    checkHousenumber: function checkHousenumber() {
	      return this.$customerValidation.housenumber.housenumber && this.$customerValidation.housenumber.touched;
	    },
	    checkZip: function checkZip() {
	      return this.$customerValidation.zip.touched && this.$customerValidation.zip.dutchzip;
	    },
	    checkCity: function checkCity() {
	      return this.$customerValidation.city.required && this.$customerValidation.city.touched;
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(208);
	
	exports.default = {
	  replace: true,
	  data: function data() {
	    return {
	      index: null,
	      active: false
	    };
	  },
	
	  computed: {
	    isActive: function isActive() {
	      return this.$parent.currentIndex === this.index;
	    },
	    isPrevious: function isPrevious() {
	      return this.$parent.currentIndex > this.index;
	    },
	    isNext: function isNext() {
	      return this.$parent.currentIndex < this.index;
	    }
	  },
	  props: {
	    link: {
	      type: String,
	      default: ''
	    },
	    icon: {
	      type: String,
	      default: false
	    },
	    iconNumber: {
	      type: String,
	      default: false
	    },
	    title: {
	      type: String,
	      default: false
	    },
	    description: {
	      type: String,
	      default: false
	    },
	    progress: {
	      type: Number
	    },
	    valid: {
	      type: Boolean,
	      default: false
	    },
	    disablePrevious: {
	      type: Boolean,
	      default: false
	    }
	  },
	  methods: {
	    changeCurrentIndex: function changeCurrentIndex() {
	      if (this.$parent.changeCurrentIndex(this.index) && this.link) {
	        this.changeLocation(this.$router, this.link);
	      }
	    },
	    changeLocation: function changeLocation(router, link) {
	      if (!link) return;
	      if (router) {
	        router.go(link);
	      } else {
	        window.location.href = link;
	      }
	    }
	  },
	  watch: {
	    progress: function progress(val) {
	      this._progressBar.style.width = val + '%';
	      if (val === 100) {
	        this.valid = true;
	      } else {
	        this.valid = false;
	      }
	    },
	    valid: function valid(val) {
	      if (val) {
	        this.progress = 100;
	      }
	    }
	  },
	  components: {},
	  ready: function ready() {
	    this._progressBar = this.$el.querySelector('.wizard-progress-value');
	  }
	};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(208);
	
	exports.default = {
	  replace: true,
	  props: {
	    currentIndex: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      countItems: 0
	    };
	  },
	
	  methods: {
	    changeCurrentIndex: function changeCurrentIndex(index) {
	      if (this.$children[this.currentIndex].disablePrevious && this.currentIndex > index) return false;
	      if (this.$children[index - 1] && this.$children[index - 1].valid || index < this.currentIndex) {
	        this.currentIndex = index;
	        return true;
	      }
	      return false;
	    }
	  },
	  ready: function ready() {
	    this.countItems = this.$children.length;
	
	    this.$children.forEach(function (item, index) {
	      item.index = index;
	    });
	  }
	};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(277), __esModule: true };

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(279), __esModule: true };

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(280), __esModule: true };

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(281), __esModule: true };

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(282), __esModule: true };

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(283), __esModule: true };

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(274);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(273);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * Bootstrap v3.4.1 (https://getbootstrap.com/)
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	
	if (typeof jQuery === 'undefined') {
	  throw new Error('Bootstrap\'s JavaScript requires jQuery')
	}
	
	+function ($) {
	  'use strict';
	  var version = $.fn.jquery.split(' ')[0].split('.')
	  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
	    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
	  }
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: https://modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // https://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.4.1'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    selector    = selector === '#' ? [] : selector
	    var $parent = $(document).find(selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.4.1'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.4.1'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      if (typeof $next === 'object' && $next.length) {
	        $next[0].offsetWidth // force reflow
	      }
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    if (href) {
	      href = href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	    }
	
	    var target  = $this.attr('data-target') || href
	    var $target = $(document).find(target)
	
	    if (!$target.hasClass('carousel')) return
	
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.4.1'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(document).find(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(document).find(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.4.1'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector !== '#' ? $(document).find(selector) : null
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options = options
	    this.$body = $(document.body)
	    this.$element = $(element)
	    this.$dialog = this.$element.find('.modal-dialog')
	    this.$backdrop = null
	    this.isShown = null
	    this.originalBodyPad = null
	    this.scrollbarWidth = 0
	    this.ignoreBackdropClick = false
	    this.fixedContent = '.navbar-fixed-top, .navbar-fixed-bottom'
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION = '3.4.1'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	          this.$element[0] !== e.target &&
	          !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    var scrollbarWidth = this.scrollbarWidth
	    if (this.bodyIsOverflowing) {
	      this.$body.css('padding-right', bodyPad + scrollbarWidth)
	      $(this.fixedContent).each(function (index, element) {
	        var actualPadding = element.style.paddingRight
	        var calculatedPadding = $(element).css('padding-right')
	        $(element)
	          .data('padding-right', actualPadding)
	          .css('padding-right', parseFloat(calculatedPadding) + scrollbarWidth + 'px')
	      })
	    }
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	    $(this.fixedContent).each(function (index, element) {
	      var padding = $(element).data('padding-right')
	      $(element).removeData('padding-right')
	      element.style.paddingRight = padding ? padding : ''
	    })
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this = $(this)
	      var data = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this = $(this)
	    var href = $this.attr('href')
	    var target = $this.attr('data-target') ||
	      (href && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	
	    var $target = $(document).find(target)
	    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn']
	
	  var uriAttrs = [
	    'background',
	    'cite',
	    'href',
	    'itemtype',
	    'longdesc',
	    'poster',
	    'src',
	    'xlink:href'
	  ]
	
	  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i
	
	  var DefaultWhitelist = {
	    // Global attributes allowed on any supplied element below.
	    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
	    a: ['target', 'href', 'title', 'rel'],
	    area: [],
	    b: [],
	    br: [],
	    col: [],
	    code: [],
	    div: [],
	    em: [],
	    hr: [],
	    h1: [],
	    h2: [],
	    h3: [],
	    h4: [],
	    h5: [],
	    h6: [],
	    i: [],
	    img: ['src', 'alt', 'title', 'width', 'height'],
	    li: [],
	    ol: [],
	    p: [],
	    pre: [],
	    s: [],
	    small: [],
	    span: [],
	    sub: [],
	    sup: [],
	    strong: [],
	    u: [],
	    ul: []
	  }
	
	  /**
	   * A pattern that recognizes a commonly useful subset of URLs that are safe.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi
	
	  /**
	   * A pattern that matches safe data URLs. Only matches image, video and audio types.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i
	
	  function allowedAttribute(attr, allowedAttributeList) {
	    var attrName = attr.nodeName.toLowerCase()
	
	    if ($.inArray(attrName, allowedAttributeList) !== -1) {
	      if ($.inArray(attrName, uriAttrs) !== -1) {
	        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
	      }
	
	      return true
	    }
	
	    var regExp = $(allowedAttributeList).filter(function (index, value) {
	      return value instanceof RegExp
	    })
	
	    // Check if a regular expression validates the attribute.
	    for (var i = 0, l = regExp.length; i < l; i++) {
	      if (attrName.match(regExp[i])) {
	        return true
	      }
	    }
	
	    return false
	  }
	
	  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
	    if (unsafeHtml.length === 0) {
	      return unsafeHtml
	    }
	
	    if (sanitizeFn && typeof sanitizeFn === 'function') {
	      return sanitizeFn(unsafeHtml)
	    }
	
	    // IE 8 and below don't support createHTMLDocument
	    if (!document.implementation || !document.implementation.createHTMLDocument) {
	      return unsafeHtml
	    }
	
	    var createdDocument = document.implementation.createHTMLDocument('sanitization')
	    createdDocument.body.innerHTML = unsafeHtml
	
	    var whitelistKeys = $.map(whiteList, function (el, i) { return i })
	    var elements = $(createdDocument.body).find('*')
	
	    for (var i = 0, len = elements.length; i < len; i++) {
	      var el = elements[i]
	      var elName = el.nodeName.toLowerCase()
	
	      if ($.inArray(elName, whitelistKeys) === -1) {
	        el.parentNode.removeChild(el)
	
	        continue
	      }
	
	      var attributeList = $.map(el.attributes, function (el) { return el })
	      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || [])
	
	      for (var j = 0, len2 = attributeList.length; j < len2; j++) {
	        if (!allowedAttribute(attributeList[j], whitelistedAttributes)) {
	          el.removeAttribute(attributeList[j].nodeName)
	        }
	      }
	    }
	
	    return createdDocument.body.innerHTML
	  }
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.4.1'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    },
	    sanitize : true,
	    sanitizeFn : null,
	    whiteList : DefaultWhitelist
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $(document).find($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    var dataAttributes = this.$element.data()
	
	    for (var dataAttr in dataAttributes) {
	      if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
	        delete dataAttributes[dataAttr]
	      }
	    }
	
	    options = $.extend({}, this.getDefaults(), dataAttributes, options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    if (options.sanitize) {
	      options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn)
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo($(document).find(this.options.container)) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    if (this.options.html) {
	      if (this.options.sanitize) {
	        title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn)
	      }
	
	      $tip.find('.tooltip-inner').html(title)
	    } else {
	      $tip.find('.tooltip-inner').text(title)
	    }
	
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	  Tooltip.prototype.sanitizeHtml = function (unsafeHtml) {
	    return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn)
	  }
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.4.1'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    if (this.options.html) {
	      var typeContent = typeof content
	
	      if (this.options.sanitize) {
	        title = this.sanitizeHtml(title)
	
	        if (typeContent === 'string') {
	          content = this.sanitizeHtml(content)
	        }
	      }
	
	      $tip.find('.popover-title').html(title)
	      $tip.find('.popover-content').children().detach().end()[
	        typeContent === 'string' ? 'html' : 'append'
	      ](content)
	    } else {
	      $tip.find('.popover-title').text(title)
	      $tip.find('.popover-content').children().detach().end().text(content)
	    }
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	        o.content.call($e[0]) :
	        o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.4.1'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.4.1'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(document).find(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	        .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	          .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    var target = this.options.target === Affix.DEFAULTS.target ? $(this.options.target) : $(document).find(this.options.target)
	
	    this.$target = target
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.4.1'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(152);
	__webpack_require__(151);
	module.exports = __webpack_require__(306);


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(24);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(308);
	module.exports = __webpack_require__(24).Number.isInteger;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(309);
	module.exports = __webpack_require__(24).Object.assign;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(310);
	module.exports = __webpack_require__(24).Object.keys;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(312);
	__webpack_require__(311);
	__webpack_require__(313);
	__webpack_require__(314);
	module.exports = __webpack_require__(24).Symbol;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(151);
	__webpack_require__(152);
	module.exports = __webpack_require__(113).f('iterator');


/***/ }),
/* 284 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 285 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(54);
	var toLength = __webpack_require__(304);
	var toAbsoluteIndex = __webpack_require__(303);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(103);
	var TAG = __webpack_require__(33)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(284);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(64);
	var gOPS = __webpack_require__(106);
	var pIE = __webpack_require__(79);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(32).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(103);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(52);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(147);
	var descriptor = __webpack_require__(80);
	var setToStringTag = __webpack_require__(107);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(51)(IteratorPrototype, __webpack_require__(33)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 294 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(82)('meta');
	var isObject = __webpack_require__(52);
	var has = __webpack_require__(42);
	var setDesc = __webpack_require__(53).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(50)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(41);
	var getKeys = __webpack_require__(64);
	var gOPS = __webpack_require__(106);
	var pIE = __webpack_require__(79);
	var toObject = __webpack_require__(81);
	var IObject = __webpack_require__(145);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(50)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(53);
	var anObject = __webpack_require__(62);
	var getKeys = __webpack_require__(64);
	
	module.exports = __webpack_require__(41) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(79);
	var createDesc = __webpack_require__(80);
	var toIObject = __webpack_require__(54);
	var toPrimitive = __webpack_require__(111);
	var has = __webpack_require__(42);
	var IE8_DOM_DEFINE = __webpack_require__(144);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(41) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(54);
	var gOPN = __webpack_require__(148).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(42);
	var toObject = __webpack_require__(81);
	var IE_PROTO = __webpack_require__(108)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(63);
	var core = __webpack_require__(24);
	var fails = __webpack_require__(50);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(110);
	var defined = __webpack_require__(104);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(110);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(110);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(287);
	var ITERATOR = __webpack_require__(33)('iterator');
	var Iterators = __webpack_require__(77);
	module.exports = __webpack_require__(24).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(62);
	var get = __webpack_require__(305);
	module.exports = __webpack_require__(24).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(285);
	var step = __webpack_require__(294);
	var Iterators = __webpack_require__(77);
	var toIObject = __webpack_require__(54);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(146)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(63);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(292) });


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(63);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(296) });


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(81);
	var $keys = __webpack_require__(64);
	
	__webpack_require__(301)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 311 */
/***/ (function(module, exports) {



/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(32);
	var has = __webpack_require__(42);
	var DESCRIPTORS = __webpack_require__(41);
	var $export = __webpack_require__(63);
	var redefine = __webpack_require__(150);
	var META = __webpack_require__(295).KEY;
	var $fails = __webpack_require__(50);
	var shared = __webpack_require__(109);
	var setToStringTag = __webpack_require__(107);
	var uid = __webpack_require__(82);
	var wks = __webpack_require__(33);
	var wksExt = __webpack_require__(113);
	var wksDefine = __webpack_require__(112);
	var enumKeys = __webpack_require__(289);
	var isArray = __webpack_require__(291);
	var anObject = __webpack_require__(62);
	var isObject = __webpack_require__(52);
	var toObject = __webpack_require__(81);
	var toIObject = __webpack_require__(54);
	var toPrimitive = __webpack_require__(111);
	var createDesc = __webpack_require__(80);
	var _create = __webpack_require__(147);
	var gOPNExt = __webpack_require__(299);
	var $GOPD = __webpack_require__(298);
	var $GOPS = __webpack_require__(106);
	var $DP = __webpack_require__(53);
	var $keys = __webpack_require__(64);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(148).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(79).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(78)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(51)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(112)('asyncIterator');


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(112)('observable');


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.4.1 (https://getbootstrap.com/)\n * Copyright 2011-2019 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;-moz-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}\n/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{color:#000!important;text-shadow:none!important;background:transparent!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(209) + ");src:url(" + __webpack_require__(209) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(619) + ") format(\"woff2\"),url(" + __webpack_require__(618) + ") format(\"woff\"),url(" + __webpack_require__(617) + ") format(\"truetype\"),url(" + __webpack_require__(616) + "#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{margin-right:-15px;margin-left:-15px}.row-no-gutters{margin-right:0;margin-left:0}.row-no-gutters [class*=col-]{padding-right:0;padding-left:0}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover,.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0;margin:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box;-moz-appearance:none;appearance:none}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{background-color:transparent;border:0}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox.disabled label,.radio.disabled label,fieldset[disabled] .checkbox label,fieldset[disabled] .radio label{cursor:not-allowed}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline.disabled,.radio-inline.disabled,fieldset[disabled] .checkbox-inline,fieldset[disabled] .radio-inline{cursor:not-allowed}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.form-control-static{min-height:34px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm{padding-right:0;padding-left:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;background-color:#dff0d8;border-color:#3c763d}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;background-color:#f2dede;border-color:#a94442}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;padding:6px 12px;font-size:14px;line-height:1.42857143;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;filter:alpha(opacity=65);opacity:.65;box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default:hover{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;background-image:none;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary:hover{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;background-image:none;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success:hover{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#449d44;background-image:none;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info:hover{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;background-image:none;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning:hover{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ec971f;background-image:none;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger:hover{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#c9302c;background-image:none;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{font-weight:400;color:#337ab7;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;background-color:#337ab7;outline:0}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false)}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{right:auto;left:0}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-right:8px;padding-left:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-right:12px;padding-left:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-top-right-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{display:table-cell;float:none;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;cursor:not-allowed;background-color:transparent}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;cursor:default;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{padding-right:15px;padding-left:15px;overflow-x:visible;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-right:0;padding-left:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-brand{float:left;height:50px;padding:15px;font-size:18px;line-height:20px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;padding:9px 10px;margin-right:15px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{padding:10px 15px;margin:8px -15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;padding-top:0;padding-bottom:0;margin-right:0;margin-left:0;border:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-left-radius:0;border-top-right-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-right:15px;margin-left:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#555;background-color:#e7e7e7}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{color:#fff;background-color:#080808}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{padding:0 5px;color:#ccc;content:\"/\\A0\"}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.42857143;color:#337ab7;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#337ab7;border-color:#337ab7}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;cursor:not-allowed;background-color:#fff;border-color:#ddd}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-top-left-radius:6px;border-bottom-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-top-right-radius:6px;border-bottom-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px}.pager{padding-left:0;margin:20px 0;text-align:center;list-style:none}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:middle;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{padding-right:15px;padding-left:15px;border-radius:6px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-right:60px;padding-left:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-right:auto;margin-left:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.thumbnail .caption{padding:9px;color:#333}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{overflow:hidden;zoom:1}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:20px}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#777;cursor:not-allowed;background-color:#eee}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{color:#555;text-decoration:none;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-left-radius:3px;border-top-right-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-right:15px;padding-left:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{margin-bottom:0;border:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}button.close{padding:0;cursor:pointer;background:transparent;border:0;-moz-appearance:none;appearance:none}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{transform:translateY(-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;background-clip:padding-box;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{filter:alpha(opacity=0);opacity:0}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;line-height:1.42857143;line-break:auto;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;font-size:12px;filter:alpha(opacity=0);opacity:0}.tooltip.in{filter:alpha(opacity=90);opacity:.9}.tooltip.top{padding:5px 0;margin-top:-3px}.tooltip.right{padding:0 5px;margin-left:3px}.tooltip.bottom{padding:5px 0;margin-top:3px}.tooltip.left{padding:0 5px;margin-left:-3px}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;line-height:1.42857143;line-break:auto;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover>.arrow{border-width:11px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow:after{content:\"\";border-width:10px}.popover.top>.arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:#999;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.top>.arrow:after{bottom:1px;margin-left:-10px;content:\" \";border-top-color:#fff;border-bottom-width:0}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:#999;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.right>.arrow:after{bottom:-10px;left:1px;content:\" \";border-right-color:#fff;border-left-width:0}.popover.bottom>.arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25)}.popover.bottom>.arrow:after{top:1px;margin-left:-10px;content:\" \";border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{right:1px;bottom:-10px;content:\" \";border-right-width:0;border-left-color:#fff}.popover-title{padding:8px 14px;margin:0;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.item{position:relative;display:none;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;backface-visibility:hidden;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent;filter:alpha(opacity=50);opacity:.5}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1);background-repeat:repeat-x}.carousel-control.right{right:0;left:auto;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;outline:0;filter:alpha(opacity=90);opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-10px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;font-family:serif;line-height:1}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:#000\\9;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{display:table;content:\" \"}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-right:auto;margin-left:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}", ""]);
	
	// exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "@keyframes drift-fadeZoomIn{0%{transform:scale(1.5);opacity:0}to{transform:scale(1);opacity:1}}@keyframes drift-fadeZoomOut{0%{transform:scale(1);opacity:1}15%{transform:scale(1.1);opacity:1}to{transform:scale(.5);opacity:0}}@keyframes drift-loader-rotate{0%{transform:translate(-50%,-50%) rotate(0)}50%{transform:translate(-50%,-50%) rotate(-180deg)}to{transform:translate(-50%,-50%) rotate(-1turn)}}@keyframes drift-loader-before{0%{transform:scale(1)}10%{transform:scale(1.2) translateX(6px)}25%{transform:scale(1.3) translateX(8px)}40%{transform:scale(1.2) translateX(6px)}50%{transform:scale(1)}60%{transform:scale(.8) translateX(6px)}75%{transform:scale(.7) translateX(8px)}90%{transform:scale(.8) translateX(6px)}to{transform:scale(1)}}@keyframes drift-loader-after{0%{transform:scale(1)}10%{transform:scale(1.2) translateX(-6px)}25%{transform:scale(1.3) translateX(-8px)}40%{transform:scale(1.2) translateX(-6px)}50%{transform:scale(1)}60%{transform:scale(.8) translateX(-6px)}75%{transform:scale(.7) translateX(-8px)}90%{transform:scale(.8) translateX(-6px)}to{transform:scale(1)}}.drift-zoom-pane{background:rgba(0,0,0,.5);transform:translateZ(0);-webkit-transform:translateZ(0)}.drift-zoom-pane.drift-opening{animation:drift-fadeZoomIn .18s ease-out;-webkit-animation:drift-fadeZoomIn .18s ease-out}.drift-zoom-pane.drift-closing{animation:drift-fadeZoomOut .21s ease-in;-webkit-animation:drift-fadeZoomOut .21s ease-in}.drift-zoom-pane.drift-inline{position:absolute;width:150px;height:150px;border-radius:75px;box-shadow:0 6px 18px rgba(0,0,0,.3)}.drift-loading .drift-zoom-pane-loader{display:block;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);width:66px;height:20px;animation:drift-loader-rotate 1.8s infinite linear;-webkit-animation:drift-loader-rotate 1.8s infinite linear}.drift-zoom-pane-loader:after,.drift-zoom-pane-loader:before{content:\"\";display:block;width:20px;height:20px;position:absolute;top:50%;margin-top:-10px;border-radius:20px;background:hsla(0,0%,100%,.9)}.drift-zoom-pane-loader:before{left:0;animation:drift-loader-before 1.8s infinite linear;-webkit-animation:drift-loader-before 1.8s infinite linear}.drift-zoom-pane-loader:after{right:0;animation:drift-loader-after 1.8s infinite linear;-webkit-animation:drift-loader-after 1.8s infinite linear;animation-delay:-.9s;-webkit-animation-delay:-.9s}.drift-bounding-box{background-color:rgba(0,0,0,.4)}", ""]);
	
	// exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(621) + ");src:url(" + __webpack_require__(620) + "?#iefix&v=4.7.0) format(\"embedded-opentype\"),url(" + __webpack_require__(624) + ") format(\"woff2\"),url(" + __webpack_require__(625) + ") format(\"woff\"),url(" + __webpack_require__(623) + ") format(\"truetype\"),url(" + __webpack_require__(622) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{animation:fa-spin 2s infinite linear}.fa-pulse{animation:fa-spin 1s infinite steps(8)}@keyframes fa-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}", ""]);
	
	// exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "/*! Flickity v2.0.2\nhttp://flickity.metafizzy.co\n---------------------------------------------- */.flickity-enabled{position:relative}.flickity-enabled:focus{outline:none}.flickity-viewport{overflow:hidden;position:relative;height:100%}.flickity-slider{position:absolute;width:100%;height:100%}.flickity-enabled.is-draggable{-webkit-tap-highlight-color:transparent;tap-highlight-color:transparent;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.flickity-enabled.is-draggable .flickity-viewport{cursor:move;cursor:grab}.flickity-enabled.is-draggable .flickity-viewport.is-pointer-down{cursor:grabbing}.flickity-prev-next-button{position:absolute;top:50%;width:44px;height:44px;border:none;border-radius:50%;background:#fff;background:hsla(0,0%,100%,.75);cursor:pointer;transform:translateY(-50%)}.flickity-prev-next-button:hover{background:#fff}.flickity-prev-next-button:focus{outline:none;box-shadow:0 0 0 5px #09f}.flickity-prev-next-button:active{opacity:.6}.flickity-prev-next-button.previous{left:10px}.flickity-prev-next-button.next{right:10px}.flickity-rtl .flickity-prev-next-button.previous{left:auto;right:10px}.flickity-rtl .flickity-prev-next-button.next{right:auto;left:10px}.flickity-prev-next-button:disabled{opacity:.3;cursor:auto}.flickity-prev-next-button svg{position:absolute;left:20%;top:20%;width:60%;height:60%}.flickity-prev-next-button .arrow{fill:#333}.flickity-page-dots{position:absolute;width:100%;bottom:-25px;padding:0;margin:0;list-style:none;text-align:center;line-height:1}.flickity-rtl .flickity-page-dots{direction:rtl}.flickity-page-dots .dot{display:inline-block;width:10px;height:10px;margin:0 8px;background:#333;border-radius:50%;opacity:.25;cursor:pointer}.flickity-page-dots .dot.is-selected{opacity:1}", ""]);
	
	// exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "body{overflow-x:hidden;font-size:12px;background:url(" + __webpack_require__(626) + ") repeat!important}p{font-size:14px}h1{color:#ad1457;font-style:italic}.thumnail{padding:0!important}.category-credit .post-content{text-align:left}.category-credit .post-meta{text-align:right}.category-credit .post-content h4{font-weight:700;margin:0}.category-credit .post-meta .price{font-weight:700;font-size:16px}.category-credit .post-content span{font-weight:700}.review-block{background-color:#fafafa;border:1px solid #efefef;padding:15px;border-radius:3px;margin-bottom:15px}.review-block-name{font-size:12px;margin:10px 0;text-decoration:underline;color:#6495ed;font-weight:700}.review-block-date{font-size:12px}.review-block-rate{font-size:13px;margin-bottom:15px}.review-block-title{font-size:15px;font-weight:700;margin-bottom:10px}.review-block-description{font-size:13px}.card-content.text-box,.card-content h1,.card-content h2,.card-content h3,.card-content h4,.card-content h5{padding-bottom:0;padding-top:15px}.card{clear:both;margin-bottom:25px;margin-top:0;padding:0;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.card.collapsed .card-content{display:none;background-color:#e8eef0}.card.collapsed .fa.fa-chevron-up:before{content:\"\\F078\"}.card.collapsed .fa.fa-chevron-down:before{content:\"\\F077\"}.card:after,.card:before{display:table}.card-title{border:none;border-color:#e7eaec;border-style:none;margin-bottom:0;padding:14px 15px 7px;min-height:48px}.card-content,.card-title{background-color:#fff;color:inherit;background-color:#e8eef0}.card-content{padding:15px 20px 20px;border-color:#e7eaec;border-image:none;border-style:none}.card-footer{color:inherit;border-top:1px solid #e7eaec;font-size:90%;background:#fff;padding:10px 15px}.card-content{clear:both}.card-heading{background-color:#f3f6fb;border-bottom:none}.card-heading h3{font-weight:200;font-size:24px}.card-title h5{display:inline-block;font-size:14px;margin:0 0 7px;padding:0;text-overflow:ellipsis;float:left}.card-header{background-color:#2c3e50}.card-header h5,.card-header label{color:#fff}.card-title .label{float:left;margin-left:4px}.card-tools{display:block;float:none;margin-top:0;position:relative;padding:0;text-align:right}.card-tools a{cursor:pointer;margin-left:5px;color:#c4c4c4}.card-tools a.btn-primary{color:#fff}.card-tools .dropdown-menu>li>a{padding:4px 10px;font-size:12px}.card .card-tools.open>.dropdown-menu{left:auto;right:0}.card.border-bottom{border-bottom:none!important}.float-e-margins{margin-bottom:5px}.header-wrapper{background-color:#aaa}.header-wrapper>img{max-height:200px}.navbar-default{background-color:#2c3e50;border-color:#ad1457}.navbar-default .navbar-brand{color:#ecf0f1}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#000}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#ecf0f1}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#000}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover,.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#000;background-color:#ad1457}.navbar-default .navbar-toggle{border-color:#ad1457}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ad1457}.navbar-default .navbar-toggle .icon-bar{background-color:#ecf0f1}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#ecf0f1}.navbar-default .navbar-link{color:#ecf0f1}.navbar-default .navbar-link:hover{color:#000}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#ecf0f1}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#000}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#000;background-color:#ad1457}}.dropdown-submenu{position:relative}.dropdown-submenu>.dropdown-menu{top:0;left:100%;margin-top:-6px;margin-left:-1px;border-radius:0 6px 6px 6px}.dropdown-submenu:hover>.dropdown-menu{display:block}.dropdown-submenu>a:after{display:block;content:\" \";float:right;width:0;height:0;border-color:transparent;border-style:solid;border-width:5px 0 5px 5px;border-left-color:#ccc;margin-top:5px;margin-right:-10px}.dropdown-submenu:hover>a:after{border-left-color:#fff}.dropdown-submenu.pull-left{float:none}.dropdown-submenu.pull-left>.dropdown-menu{left:-100%;margin-left:10px;border-radius:6px 0 6px 6px}", ""]);
	
	// exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".glyphicon-refresh-animate{-animation:spin .7s infinite linear;-webkit-animation:spin2 .7s infinite linear}@keyframes spin{0%{transform:scale(1) rotate(0deg)}to{transform:scale(1) rotate(1turn)}}.gritcode-wizard{overflow:hidden;display:table;table-layout:fixed;width:100%;font-size:.8rem}.gritcode-wizard .wizard-step{display:none;width:auto;border:0;text-align:center;position:relative;cursor:pointer}.gritcode-wizard .wizard-step.active{display:table-cell}.gritcode-wizard .wizard-step .wizard-icon{display:table;width:3em;height:3em;background-color:#eaeaea;text-align:center;color:#a9a9a9;border:2px solid #d9d9d9;position:relative;z-index:1;border-radius:50%;z-index:22;margin:auto;margin-bottom:1em}.gritcode-wizard .wizard-step .wizard-icon .icon-icon,.gritcode-wizard .wizard-step .wizard-icon .icon-number{display:table-cell;vertical-align:middle}.gritcode-wizard .wizard-step .wizard-icon .icon-number{line-height:1em}.gritcode-wizard .wizard-step .title{font-size:1.8em;color:#464646}.gritcode-wizard .wizard-step .description,.gritcode-wizard .wizard-step .step-info{font-size:1em;color:#a8a8a8}.gritcode-wizard .wizard-step .description{margin-bottom:2em}.gritcode-wizard .wizard-step .wizard-progress,.gritcode-wizard .wizard-step .wizard-progress-value{position:absolute;bottom:2em;left:0;width:100%;height:2px;background:#d9d9d9;z-index:10}.gritcode-wizard .wizard-step .wizard-progress-value{top:0;left:0;width:0;background:#ad1457;z-index:11;padding:0;transition:width .45s ease}.gritcode-wizard .wizard-step .step-info{text-align:right}.gritcode-wizard .wizard-step.active .wizard-icon,.gritcode-wizard .wizard-step.previous .wizard-icon{border-color:#ad1457;color:#ad1457}.gritcode-wizard .wizard-step.active .icon,.gritcode-wizard .wizard-step.previous .icon{fill:#ad1457}.gritcode-wizard .wizard-step:last-child .wizard-progress-value{width:100%!important}@media (min-width:544px){.gritcode-wizard{font-size:.9rem}.gritcode-wizard .wizard-step{display:table-cell}.gritcode-wizard .wizard-step .description{margin-bottom:0}.gritcode-wizard .wizard-step .wizard-progress,.gritcode-wizard .wizard-step .wizard-progress-value{top:1.45em;left:49%}.gritcode-wizard .wizard-step .wizard-progress-value{top:0;left:0;padding:0 .75em}.gritcode-wizard .wizard-step .step-info,.gritcode-wizard .wizard-step:last-child .wizard-progress{display:none}.gritcode-wizard .wizard-step:last-child .wizard-progress-value{width:100%!important}}@media (min-width:768px){.gritcode-wizard{font-size:1.2rem}}", ""]);
	
	// exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".modal{transition:all .3s ease}.modal.in{background-color:transparent}.modal.zoom .modal-dialog{transform:scale(.1);top:300px;opacity:0;transition:all .3s}.modal.zoom.in .modal-dialog{transform:scale(1);transform:translate3d(0,-300px,0);opacity:1}.modal-dialog-centered{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;min-height:calc(100% - 1rem)}.modal-dialog-centered:before{display:block;height:calc(100vh - 1rem);content:\"\"}@media (min-width:576px){.modal-dialog-centered{min-height:calc(100% - 3.5rem)}.modal-dialog-centered:before{height:calc(100vh - 3.5rem)}.modal-sm{max-width:300px}}", "", {"version":3,"sources":["/./src/components/Common/Modal.vue"],"names":[],"mappings":"AAwLA,OACE,uBAA0B,CAC3B,AACD,UACE,4BAAgC,CACjC,AACD,0BACI,oBAAsB,AACtB,UAAW,AACX,UAAW,AACX,kBAAqB,CACxB,AACD,6BACI,mBAAoB,AACpB,kCAAqC,AACrC,SAAW,CACd,AAED,uBACE,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AACxB,4BAA8B,CAC/B,AAED,8BACE,cAAe,AACf,0BAA2B,AAC3B,UAAY,CACb,AAED,yBACE,uBACE,8BAAgC,CACjC,AACD,8BACE,2BAA6B,CAC9B,AACD,UACE,eAAiB,CAClB,CACF","file":"Modal.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.modal {\n  transition: all 0.3s ease;\n}\n.modal.in {\n  background-color: rgba(0,0,0,0);\n}\n.modal.zoom .modal-dialog {\n    transform: scale(0.1);\n    top: 300px;\n    opacity: 0;\n    transition: all 0.3s;\n}\n.modal.zoom.in .modal-dialog {\n    transform: scale(1);\n    transform: translate3d(0, -300px, 0);\n    opacity: 1;\n}\n\n.modal-dialog-centered {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  min-height: calc(100% - 1rem);\n}\n\n.modal-dialog-centered::before {\n  display: block;\n  height: calc(100vh - 1rem);\n  content: \"\";\n}\n\n@media (min-width: 576px) {\n  .modal-dialog-centered {\n    min-height: calc(100% - 3.5rem);\n  }\n  .modal-dialog-centered::before {\n    height: calc(100vh - 3.5rem);\n  }\n  .modal-sm {\n    max-width: 300px;\n  }\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--vui-green:#42b983;--ios-green:#4cd964;--ios-blue:#027afb;--android-green:#009a57;--menu-button-color:#aaa;--range-slider-color:#027afb}.ios .v-toggle{width:51px}.ios .v-toggle--checked.v-toggle{background:var(--ios-green);border-color:var(--ios-green)}.ios .v-toggle .v-toggle_handle{box-shadow:0 2px 7px rgba(0,0,0,.35),0 1px 1px rgba(0,0,0,.15)}.ios .v-toggle--checked .v-toggle_handle{transform:translate3d(20px,0,0)}.ios .v-toggle:before{content:\"\";position:absolute;display:block;left:0;top:0;width:100%;height:100%;border-radius:20px;background:#e6e6e6;transition:opacity .3s}.ios .v-toggle--checked:before{opacity:0}.ios .v-toggle:after{content:\"\";position:absolute;display:block;left:0;top:0;width:100%;height:100%;background:#fff;border-radius:20px;transform:scaleX(1);transition:transform .3s}.ios .v-toggle--checked:after{transform:scale3d(0,0,0);opacity:1}.ios .v-range-slider input::-webkit-slider-runnable-track{height:1px}.ios .v-range-slider input::-webkit-slider-thumb:before{background:var(--ios-blue);height:1px}.ios .v-range-slider input::-webkit-slider-thumb{box-shadow:0 0 1px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2)}.ios .v-radio input:before{opacity:0}.ios .v-radio li{border-bottom:1px solid #ddd;margin-left:2em;padding:.6em 0 .4em}.ios .v-radio li:last-of-type{border-bottom:0}.ios .v-radio li input{margin-left:-2.2em}.ios .v-radio input:checked:before{opacity:1;border-color:var(--ios-blue)}label.v-toggle{position:relative;display:inline-block;height:31px;width:68px;border-radius:20px;box-sizing:border-box;background:#e6e6e6;border:2px solid #e6e6e6;cursor:pointer;vertical-align:middle;pointer-events:auto;-webkit-tap-highlight-color:transparent}label.v-toggle input{display:none}label.v-toggle--checked.v-toggle{background:var(--vui-green);border-color:var(--vui-green)}.v-toggle .v-toggle_handle{position:absolute;left:0;top:0;display:inline-block;background:#fff;border-radius:100%;width:27px;height:27px;z-index:99;transition:transform .3s}.v-toggle--checked .v-toggle_handle{transform:translate3d(37px,0,0)}.v-toggle:after,.v-toggle:before{position:absolute;top:0;font-size:12px;line-height:28px}.v-toggle:before{left:5px;content:\"ON\";color:#fff;opacity:0}.v-toggle:after{right:5px;content:\"OFF\";color:#aaa}.v-toggle--checked.v-toggle:before{opacity:1}.v-toggle--checked.v-toggle:after{opacity:0}", "", {"version":3,"sources":["/./src/components/Common/Toggle.vue"],"names":[],"mappings":"AAsBA,MACE,oBAAqB,AACrB,oBAAqB,AACrB,mBAAoB,AACpB,wBAAyB,AACzB,yBAA0B,AAC1B,4BAA8B,CAC/B,AAGD,eACE,UAAY,CACb,AACD,iCACE,4BAA6B,AAC7B,6BAA+B,CAChC,AACD,gCACE,8DAAyE,CAC1E,AACD,yCACE,+BAAmC,CACpC,AACD,sBACE,WAAY,AACZ,kBAAmB,AACnB,cAAe,AACf,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,mBAAoB,AACpB,sBAAyB,CAC1B,AACD,+BACE,SAAW,CACZ,AACD,qBACE,WAAY,AACZ,kBAAmB,AACnB,cAAe,AACf,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,gBAAkB,AAClB,mBAAoB,AACpB,oBAA4B,AAC5B,wBAA2B,CAC5B,AACD,8BACE,yBAA4B,AAC5B,SAAW,CACZ,AAID,0DACE,UAAY,CACb,AACD,wDACE,2BAA4B,AAC5B,UAAY,CACb,AACD,iDACE,0DAA8D,CAC/D,AAGD,2BACE,SAAW,CACZ,AACD,iBACE,6BAA8B,AAC9B,gBAAiB,AACjB,mBAAuB,CACxB,AACD,8BACE,eAAiB,CAClB,AACD,uBACE,kBAAoB,CACrB,AACD,mCACE,UAAW,AACX,4BAA8B,CAC/B,AAED,eACE,kBAAmB,AACnB,qBAAsB,AACtB,YAAa,AACb,WAAY,AACZ,mBAAoB,AACpB,sBAAuB,AACvB,mBAAoB,AACpB,yBAA0B,AAC1B,eAAgB,AAChB,sBAAuB,AACvB,oBAAqB,AACrB,uCAAyC,CAC1C,AACD,qBACE,YAAc,CACf,AACD,iCACE,4BAA6B,AAC7B,6BAA+B,CAChC,AACD,2BACE,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,qBAAsB,AACtB,gBAAkB,AAClB,mBAAoB,AACpB,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,wBAA2B,CAC5B,AACD,oCACE,+BAAmC,CACpC,AACD,iCAEE,kBAAmB,AACnB,MAAO,AACP,eAAgB,AAChB,gBAAkB,CACnB,AACD,iBACE,SAAU,AACV,aAAc,AACd,WAAa,AACb,SAAW,CACZ,AACD,gBACE,UAAW,AACX,cAAe,AACf,UAAY,CACb,AACD,mCACE,SAAW,CACZ,AACD,kCACE,SAAW,CACZ","file":"Toggle.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n:root {\n  --vui-green: #42b983;\n  --ios-green: #4cd964;\n  --ios-blue: #027AFB;\n  --android-green: #009A57;\n  --menu-button-color: #aaa;\n  --range-slider-color: #027AFB;\n}\n\n/** Toggle */\n.ios .v-toggle {\n  width: 51px;\n}\n.ios .v-toggle--checked.v-toggle {\n  background: var(--ios-green);\n  border-color: var(--ios-green);\n}\n.ios .v-toggle .v-toggle_handle {\n  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.35), 0 1px 1px rgba(0, 0, 0, 0.15);\n}\n.ios .v-toggle--checked .v-toggle_handle {\n  transform: translate3d(20px, 0, 0);\n}\n.ios .v-toggle:before {\n  content: '';\n  position: absolute;\n  display: block;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 20px;\n  background: #e6e6e6;\n  transition: opacity 0.3s;\n}\n.ios .v-toggle--checked:before {\n  opacity: 0;\n}\n.ios .v-toggle:after {\n  content: '';\n  position: absolute;\n  display: block;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: white;\n  border-radius: 20px;\n  transform: scale3d(1, 1, 1);\n  transition: transform 0.3s;\n}\n.ios .v-toggle--checked:after {\n  transform: scale3d(0, 0, 0);\n  opacity: 1;\n}\n\n\n/** Range Slider */\n.ios .v-range-slider input::-webkit-slider-runnable-track {\n  height: 1px;\n}\n.ios .v-range-slider input::-webkit-slider-thumb:before {\n  background: var(--ios-blue);\n  height: 1px;\n}\n.ios .v-range-slider input::-webkit-slider-thumb {\n  box-shadow: 0 0 1px rgba(0,0,0,.3), 0 3px 5px rgba(0,0,0,0.2);\n}\n\n/** Radio Group */\n.ios .v-radio input:before {\n  opacity: 0;\n}\n.ios .v-radio li {\n  border-bottom: 1px solid #ddd;\n  margin-left: 2em;\n  padding: 0.6em 0 0.4em;\n}\n.ios .v-radio li:last-of-type {\n  border-bottom: 0;\n}\n.ios .v-radio li input {\n  margin-left: -2.2em;\n}\n.ios .v-radio input:checked:before {\n  opacity: 1;\n  border-color: var(--ios-blue);\n}\n\nlabel.v-toggle {\n  position: relative;\n  display: inline-block;\n  height: 31px;\n  width: 68px;\n  border-radius: 20px;\n  box-sizing: border-box;\n  background: #e6e6e6;\n  border: solid 2px #e6e6e6;\n  cursor: pointer;\n  vertical-align: middle;\n  pointer-events: auto;\n  -webkit-tap-highlight-color: transparent;\n}\nlabel.v-toggle input {\n  display: none;\n}\nlabel.v-toggle--checked.v-toggle {\n  background: var(--vui-green);\n  border-color: var(--vui-green);\n}\n.v-toggle .v-toggle_handle {\n  position: absolute;\n  left: 0;\n  top: 0;\n  display: inline-block;\n  background: white;\n  border-radius: 100%;\n  width: 27px;\n  height: 27px;\n  z-index: 99;\n  transition: transform 0.3s;\n}\n.v-toggle--checked .v-toggle_handle {\n  transform: translate3d(37px, 0, 0);\n}\n.v-toggle::before,\n.v-toggle::after {\n  position: absolute;\n  top: 0;\n  font-size: 12px;\n  line-height: 28px;\n}\n.v-toggle::before {\n  left: 5px;\n  content: 'ON';\n  color: white;\n  opacity: 0;\n}\n.v-toggle::after {\n  right: 5px;\n  content: 'OFF';\n  color: #aaa;\n}\n.v-toggle--checked.v-toggle::before {\n  opacity: 1;\n}\n.v-toggle--checked.v-toggle::after {\n  opacity: 0;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".btn-gray{color:#fff;background:gray;border:1px solid #e7eaec}", "", {"version":3,"sources":["/./src/components/Common/deleteSweetAlert.vue"],"names":[],"mappings":"AACA,UACI,WAAa,AACb,gBAAiB,AACjB,wBAA0B,CAC7B","file":"deleteSweetAlert.vue","sourcesContent":["\n.btn-gray {\n    color: white;\n    background: gray;\n    border: 1px solid #e7eaec;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "*{box-sizing:border-box}.datepicker{position:relative}.calendar{position:absolute;z-index:100;background:#fff;width:300px;border:1px solid #ccc}.calendar header{display:block;line-height:40px}.calendar header span{display:inline-block;text-align:center;width:71.42857142857143%;float:left}.calendar header .next,.calendar header .prev{width:14.285714285714286%;float:left;text-indent:-10000px;position:relative}.calendar header .next:after,.calendar header .prev:after{content:\"\";position:absolute;left:50%;top:50%;transform:translateX(-50%) translateY(-50%);border:6px solid transparent}.calendar header .prev:after{border-right:10px solid #000;margin-left:-5px}.calendar header .prev.disabled:after{border-right:10px solid #ddd}.calendar header .next:after{border-left:10px solid #000;margin-left:5px}.calendar header .next.disabled:after{border-left:10px solid #ddd}.calendar header .next:not(.disabled),.calendar header .prev:not(.disabled),.calendar header .up:not(.disabled){cursor:pointer}.calendar header .next:not(.disabled):hover,.calendar header .prev:not(.disabled):hover,.calendar header .up:not(.disabled):hover{background:#eee}.calendar .disabled{color:#ddd;cursor:default}.calendar .cell{display:inline-block;padding:0 5px;width:14.285714285714286%;height:40px;line-height:40px;text-align:center;vertical-align:middle;border:1px solid transparent}.calendar .cell:not(.blank):not(.disabled).day,.calendar .cell:not(.blank):not(.disabled).month,.calendar .cell:not(.blank):not(.disabled).year{cursor:pointer}.calendar .cell:not(.blank):not(.disabled).day:hover,.calendar .cell:not(.blank):not(.disabled).month:hover,.calendar .cell:not(.blank):not(.disabled).year:hover{border:1px solid #4bd}.calendar .cell.selected,.calendar .cell.selected:hover{background:#4bd}.calendar .cell.grey{color:#888}.calendar .cell.grey:hover{background:inherit}.calendar .cell.day-header{font-size:75%;cursor:inherit}.calendar .cell.day-header:hover{background:inherit}.calendar .month,.calendar .year{width:33.333%}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#fff}", "", {"version":3,"sources":["/./src/components/datepicker/Datepicker.vue"],"names":[],"mappings":"AAonBA,EACE,qBAAuB,CACxB,AACD,YACE,iBAAmB,CACpB,AACD,UACE,kBAAmB,AACnB,YAAa,AACb,gBAAiB,AACjB,YAAa,AACb,qBAAuB,CACxB,AACD,iBACE,cAAe,AACf,gBAAkB,CACnB,AACD,sBACE,qBAAsB,AACtB,kBAAmB,AACnB,yBAA0B,AAC1B,UAAY,CACb,AACD,8CAEE,0BAA2B,AAC3B,WAAY,AACZ,qBAAsB,AACtB,iBAAmB,CACpB,AACD,0DAEE,WAAY,AACZ,kBAAmB,AACnB,SAAU,AACV,QAAS,AACT,4CAA6C,AAC7C,4BAA8B,CAC/B,AACD,6BACE,6BAA8B,AAC9B,gBAAkB,CACnB,AACD,sCACE,4BAA8B,CAC/B,AACD,6BACE,4BAA6B,AAC7B,eAAiB,CAClB,AACD,sCACE,2BAA6B,CAC9B,AACD,gHAGE,cAAgB,CACjB,AACD,kIAGE,eAAiB,CAClB,AACD,oBACE,WAAY,AACZ,cAAgB,CACjB,AACD,gBACE,qBAAsB,AACtB,cAAe,AACf,0BAA2B,AAC3B,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,sBAAuB,AACvB,4BAA8B,CAC/B,AACD,gJAGE,cAAgB,CACjB,AACD,kKAGE,qBAAuB,CACxB,AAID,wDACE,eAAiB,CAClB,AACD,qBACE,UAAY,CACb,AACD,2BACE,kBAAoB,CACrB,AACD,2BACE,cAAe,AACf,cAAgB,CACjB,AACD,iCACE,kBAAoB,CACrB,AACD,iCAEE,aAAe,CAChB,AAED,iFACE,qBAAuB,CACxB","file":"Datepicker.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n* {\n  box-sizing: border-box;\n}\n.datepicker {\n  position: relative;\n}\n.calendar {\n  position: absolute;\n  z-index: 100;\n  background: #fff;\n  width: 300px;\n  border: 1px solid #ccc;\n}\n.calendar header {\n  display: block;\n  line-height: 40px;\n}\n.calendar header span {\n  display: inline-block;\n  text-align: center;\n  width: 71.42857142857143%;\n  float: left;\n}\n.calendar header .prev,\n.calendar header .next {\n  width: 14.285714285714286%;\n  float: left;\n  text-indent: -10000px;\n  position: relative;\n}\n.calendar header .prev:after,\n.calendar header .next:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  border: 6px solid transparent;\n}\n.calendar header .prev:after {\n  border-right: 10px solid #000;\n  margin-left: -5px;\n}\n.calendar header .prev.disabled:after {\n  border-right: 10px solid #ddd;\n}\n.calendar header .next:after {\n  border-left: 10px solid #000;\n  margin-left: 5px;\n}\n.calendar header .next.disabled:after {\n  border-left: 10px solid #ddd;\n}\n.calendar header .prev:not(.disabled),\n.calendar header .next:not(.disabled),\n.calendar header .up:not(.disabled) {\n  cursor: pointer;\n}\n.calendar header .prev:not(.disabled):hover,\n.calendar header .next:not(.disabled):hover,\n.calendar header .up:not(.disabled):hover {\n  background: #eee;\n}\n.calendar .disabled {\n  color: #ddd;\n  cursor: default;\n}\n.calendar .cell {\n  display: inline-block;\n  padding: 0 5px;\n  width: 14.285714285714286%;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n}\n.calendar .cell:not(.blank):not(.disabled).day,\n.calendar .cell:not(.blank):not(.disabled).month,\n.calendar .cell:not(.blank):not(.disabled).year {\n  cursor: pointer;\n}\n.calendar .cell:not(.blank):not(.disabled).day:hover,\n.calendar .cell:not(.blank):not(.disabled).month:hover,\n.calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #4bd;\n}\n.calendar .cell.selected {\n  background: #4bd;\n}\n.calendar .cell.selected:hover {\n  background: #4bd;\n}\n.calendar .cell.grey {\n  color: #888;\n}\n.calendar .cell.grey:hover {\n  background: inherit;\n}\n.calendar .cell.day-header {\n  font-size: 75%;\n  cursor: inherit;\n}\n.calendar .cell.day-header:hover {\n  background: inherit;\n}\n.calendar .month,\n.calendar .year {\n  width: 33.333%;\n}\n\n.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control{\n  background-color: #fff;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "footer{color:#fff;margin-top:50px;width:100%}footer h3{margin-bottom:30px}footer .footer-above{padding-top:50px;background-color:#2c3e50}footer .footer-col{margin-bottom:50px}footer .footer-below{padding:25px 0;background-color:#e8eef0;color:#000}", "", {"version":3,"sources":["/./src/components/navigation/Footer.vue"],"names":[],"mappings":"AAiEA,OACI,WAAa,AACb,gBAAiB,AACjB,UAAY,CACf,AAED,UACI,kBAAoB,CACvB,AAED,qBACI,iBAAkB,AAClB,wBAA0B,CAC7B,AAED,mBACI,kBAAoB,CACvB,AAED,qBACI,eAAgB,AAChB,yBAA0B,AAC1B,UAAa,CAChB","file":"Footer.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nfooter {\n    color: white;\n    margin-top: 50px;\n    width: 100%;\n}\n\nfooter h3 {\n    margin-bottom: 30px;\n}\n\nfooter .footer-above {\n    padding-top: 50px;\n    background-color: #2c3e50;\n}\n\nfooter .footer-col {\n    margin-bottom: 50px;\n}\n\nfooter .footer-below {\n    padding: 25px 0;\n    background-color: #E8EEF0;\n    color: black;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".current-menu-parent{background-color:#f22853}.current-menu-parent>a{color:#fff!important}.menu-blue{color:#337ab7!important}", "", {"version":3,"sources":["/./src/components/navigation/NavigationHeader.vue"],"names":[],"mappings":"AAyJA,qBACA,wBAAyB,CAAE,AAC3B,uBACI,oBAA0B,CAC7B,AACD,WACE,uBAAyB,CAC1B","file":"NavigationHeader.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.current-menu-parent {\nbackground-color:#f22853; }\n.current-menu-parent > a {\n    color: #ffffff !important;\n}\n.menu-blue {\n  color:#337ab7 !important;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".showbanner[_v-243d033a]{position:fixed;z-index:99999;bottom:2%;left:2%;padding:10px;text-align:left;color:#333;font-size:16px;width:400px;max-width:80%;box-shadow:0 0 15px rgba(0,0,0,.0980392);transition:all .4s ease;background:hsla(0,43%,91%,.95)}", "", {"version":3,"sources":["/./src/components/Common/banner.vue"],"names":[],"mappings":"AAqCA,yBACE,eAAgB,AAChB,cAAe,AACf,UAAW,AACX,QAAS,AACT,aAAc,AACd,gBAAiB,AACjB,WAAuB,AACvB,eAAgB,AAChB,YAAa,AACb,cAAe,AACf,yCAAkD,AAClD,wBAA0B,AAC1B,8BAAmC,CACpC","file":"banner.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.showbanner[_v-243d033a] {\n  position: fixed;\n  z-index: 99999;\n  bottom: 2%;\n  left: 2%;\n  padding: 10px;\n  text-align: left;\n  color: rgb(51, 51, 51);\n  font-size: 16px;\n  width: 400px;\n  max-width: 80%;\n  box-shadow: rgba(0, 0, 0, 0.0980392) 0px 0px 15px;\n  transition: all 0.4s ease;\n  background: rgba(242,222,222,0.95);\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".float-e-margins .btn[_v-2ea8af5c]{margin-bottom:0!important}", "", {"version":3,"sources":["/./src/components/dashboard/addEditRubrics.vue"],"names":[],"mappings":"AA2QA,mCACE,yBAA4B,CAC7B","file":"addEditRubrics.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.float-e-margins .btn[_v-2ea8af5c] {\n  margin-bottom: 0 !important;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "@media screen and (max-width:768px){p[_v-4ae6ca21]{font-size:3.2vw}}", "", {"version":3,"sources":["/./src/components/Categorie.vue"],"names":[],"mappings":"AA4FA,oCACE,eACE,eAAiB,CAClB,CACF","file":"Categorie.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 768px){\n  p[_v-4ae6ca21]{\n    font-size: 3.2vw;\n  }\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".chart[_v-4fc3ab56]{width:100%;height:400px}", "", {"version":3,"sources":["/./src/components/dashboard/analytics.vue"],"names":[],"mappings":"AAqQE,oBACE,WAAY,AACZ,YAAc,CACjB","file":"analytics.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n  .chart[_v-4fc3ab56] {\n    width: 100%;\n    height: 400px;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".form-signin[_v-52410873]{max-width:330px;padding:15px;margin:0 auto}.form-signin .checkbox[_v-52410873],.form-signin .form-signin-heading[_v-52410873]{margin-bottom:10px}.form-signin .checkbox[_v-52410873]{font-weight:400}.form-signin .form-control[_v-52410873]{position:relative;font-size:16px;height:auto;padding:10px;box-sizing:border-box}.form-signin .form-control[_v-52410873]:focus{z-index:2}.form-signin input[type=text][_v-52410873]{margin-bottom:-1px;border-bottom-left-radius:0;border-bottom-right-radius:0}.form-signin input[type=password][_v-52410873]{margin-bottom:10px;border-top-left-radius:0;border-top-right-radius:0}.account-wall[_v-52410873]{padding:10px 0 20px;background-color:#f7f7f7;box-shadow:0 2px 2px rgba(0,0,0,.3)}.login-title[_v-52410873]{color:#555;font-size:18px;font-weight:400;display:block}.profile-img[_v-52410873]{width:96px;height:96px;margin:0 auto 10px;display:block}", "", {"version":3,"sources":["/./src/components/login.vue"],"names":[],"mappings":"AA6DA,0BAEI,gBAAiB,AACjB,aAAc,AACd,aAAe,CAClB,AACD,mFAEI,kBAAoB,CACvB,AACD,oCAEI,eAAoB,CACvB,AACD,wCAEI,kBAAmB,AACnB,eAAgB,AAChB,YAAa,AACb,aAAc,AACd,qBAAuB,CAC1B,AACD,8CAEI,SAAW,CACd,AACD,2CAEI,mBAAoB,AACpB,4BAA6B,AAC7B,4BAA8B,CACjC,AACD,+CAEI,mBAAoB,AACpB,yBAA0B,AAC1B,yBAA2B,CAC9B,AACD,2BAEI,oBAA2B,AAC3B,yBAA0B,AAC1B,mCAA2C,CAC9C,AACD,0BAEI,WAAY,AACZ,eAAgB,AAChB,gBAAiB,AACjB,aAAe,CAClB,AACD,0BAEI,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,aAAe,CAClB","file":"login.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.form-signin[_v-52410873]\n{\n    max-width: 330px;\n    padding: 15px;\n    margin: 0 auto;\n}\n.form-signin .form-signin-heading[_v-52410873], .form-signin .checkbox[_v-52410873]\n{\n    margin-bottom: 10px;\n}\n.form-signin .checkbox[_v-52410873]\n{\n    font-weight: normal;\n}\n.form-signin .form-control[_v-52410873]\n{\n    position: relative;\n    font-size: 16px;\n    height: auto;\n    padding: 10px;\n    box-sizing: border-box;\n}\n.form-signin .form-control[_v-52410873]:focus\n{\n    z-index: 2;\n}\n.form-signin input[type=\"text\"][_v-52410873]\n{\n    margin-bottom: -1px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n}\n.form-signin input[type=\"password\"][_v-52410873]\n{\n    margin-bottom: 10px;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n}\n.account-wall[_v-52410873]\n{\n    padding: 10px 0px 20px 0px;\n    background-color: #f7f7f7;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n}\n.login-title[_v-52410873]\n{\n    color: #555;\n    font-size: 18px;\n    font-weight: 400;\n    display: block;\n}\n.profile-img[_v-52410873]\n{\n    width: 96px;\n    height: 96px;\n    margin: 0 auto 10px;\n    display: block;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".upload-drop-zone[_v-6be008a2]{color:#ccc;border-style:dashed;border-color:#ccc;text-align:center;width:100%;height:auto}.upload-drop-zone span[_v-6be008a2]{color:#ccc;font-size:5em;text-align:center}.uploaded-zone[_v-6be008a2]{border:2px groove #ccc;text-align:center}.btn-circle[_v-6be008a2]{width:30px;height:30px;text-align:center;padding:6px 0;font-size:12px;line-height:1.428571429;border-radius:15px;border-color:#ccc}", "", {"version":3,"sources":["/./src/components/Common/Upload.vue"],"names":[],"mappings":"AA6JA,+BACE,WAAY,AACZ,oBAAqB,AACrB,kBAAmB,AACnB,kBAAmB,AACnB,WAAY,AACZ,WAAa,CACd,AACD,oCACE,WAAY,AACZ,cAAe,AACf,iBAAmB,CACpB,AACD,4BAEE,uBAAmB,AACnB,iBAAmB,CAEpB,AACD,yBACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,cAAe,AACf,eAAgB,AAChB,wBAAyB,AACzB,mBAAoB,AACpB,iBAAmB,CACpB","file":"Upload.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.upload-drop-zone[_v-6be008a2] {\n  color: #ccc;\n  border-style: dashed;\n  border-color: #ccc;\n  text-align: center;\n  width: 100%;\n  height: auto;\n}\n.upload-drop-zone span[_v-6be008a2] {\n  color: #ccc;\n  font-size: 5em;\n  text-align: center;\n}\n.uploaded-zone[_v-6be008a2] {\n  border-style: groove;\n  border-color: #ccc;\n  text-align: center;\n  border-width: 2px;\n}\n.btn-circle[_v-6be008a2] {\n  width: 30px;\n  height: 30px;\n  text-align: center;\n  padding: 6px 0;\n  font-size: 12px;\n  line-height: 1.428571429;\n  border-radius: 15px;\n  border-color: #ccc;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".bs-searchbox[_v-75d92d2a]{padding:4px 8px}.btn-group .dropdown-menu .notify[_v-75d92d2a]{position:absolute;bottom:5px;width:96%;margin:0 2%;min-height:26px;padding:3px 5px;background:#f5f5f5;border:1px solid #e3e3e3;box-shadow:inset 0 1px 1px rgba(0,0,0,.05);pointer-events:none;opacity:.9}", "", {"version":3,"sources":["/./src/components/Common/Select.vue"],"names":[],"mappings":"AAoKA,2BACE,eAAiB,CAClB,AACD,+CACE,kBAAmB,AACnB,WAAY,AACZ,UAAW,AACX,YAAa,AACb,gBAAiB,AACjB,gBAAiB,AACjB,mBAAoB,AACpB,yBAA0B,AAC1B,2CAA4C,AAC3C,oBAAqB,AACtB,UAAY,CACb","file":"Select.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.bs-searchbox[_v-75d92d2a] {\n  padding: 4px 8px;\n}\n.btn-group .dropdown-menu .notify[_v-75d92d2a] {\n  position: absolute;\n  bottom: 5px;\n  width: 96%;\n  margin: 0 2%;\n  min-height: 26px;\n  padding: 3px 5px;\n  background: #f5f5f5;\n  border: 1px solid #e3e3e3;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.05);\n   pointer-events: none;\n  opacity: .9;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".slider[_v-7781753c]{background:#eee}.carousel-cell[_v-7781753c]{width:400px;height:250px;margin-right:10px;border-radius:5px;counter-increment:gallery-cell}.carousel-cell[_v-7781753c]:before{display:block;text-align:center;content:counter(gallery-cell);line-height:250px;font-size:80px;color:#fff}.flickity-prev-next-button[_v-7781753c]:focus{outline:none;box-shadow:0 0 0 5px #09f}p[_v-7781753c]{font-size:130%}", "", {"version":3,"sources":["/./src/components/Hello.vue"],"names":[],"mappings":"AA4GA,qBACE,eAAiB,CAClB,AAED,4BACE,YAAa,AACb,aAAc,AACd,kBAAmB,AACnB,kBAAmB,AACnB,8BAAgC,CACjC,AAGD,mCACE,cAAe,AACf,kBAAmB,AACnB,8BAA+B,AAC/B,kBAAmB,AACnB,eAAgB,AAChB,UAAa,CACd,AACD,8CACE,aAAc,AACd,yBAA2B,CAC5B,AAED,eACE,cAAgB,CACjB","file":"Hello.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.slider[_v-7781753c] {\n  background: #EEE;\n}\n\n.carousel-cell[_v-7781753c] {\n  width: 400px;\n  height: 250px;\n  margin-right: 10px;\n  border-radius: 5px;\n  counter-increment: gallery-cell;\n}\n\n/* cell number */\n.carousel-cell[_v-7781753c]:before {\n  display: block;\n  text-align: center;\n  content: counter(gallery-cell);\n  line-height: 250px;\n  font-size: 80px;\n  color: white;\n}\n.flickity-prev-next-button[_v-7781753c]:focus {\n  outline: none;\n  box-shadow: 0 0 0 5px #09F;\n}\n\np[_v-7781753c] {\n  font-size: 130%;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".table>tbody>tr>td[_v-77d75885],.table>tfoot>tr>td[_v-77d75885]{vertical-align:middle}@media screen and (max-width:768px){table#cart tbody td .form-control[_v-77d75885]{width:20%;display:inline!important}.actions .btn[_v-77d75885]{width:36%;margin:1.5em 0}.actions .btn-info[_v-77d75885]{float:left}.actions .btn-danger[_v-77d75885]{float:right}table#cart thead[_v-77d75885]{display:none}table#cart tbody tr td[_v-77d75885]:first-child{background:#333;color:#fff}table#cart tbody td[_v-77d75885]:before{content:attr(data-th);font-weight:700;display:inline-block;width:8rem}table#cart tfoot td .btn[_v-77d75885],table#cart tfoot td[_v-77d75885]{display:block}}.v-tooltip[_v-77d75885]{position:relative;display:inline-block;border-bottom:1px dotted #000;cursor:pointer}.v-tooltip .v-tooltiptext[_v-77d75885]{visibility:hidden;width:120px;background-color:#000;color:#fff;text-align:center;border-radius:6px;padding:5px 0;right:-20px;position:absolute;z-index:9999999999999}.v-tooltip:hover .v-tooltiptext[_v-77d75885]{visibility:visible}", "", {"version":3,"sources":["/./src/components/ordering/cart.vue"],"names":[],"mappings":"AAsHC,gEACG,qBAAuB,CAC1B,AACD,oCACI,+CACA,UAAU,AACV,wBAA2B,CAC5B,AACD,2BACE,UAAU,AACV,cAAe,CAChB,AAED,gCACE,UAAW,CACZ,AACD,kCACE,WAAY,CACb,AAED,8BAAgC,YAAc,CAAE,AAChD,gDAAkD,gBAAiB,AAAC,UAAY,CAAE,AAClF,wCACE,sBAAuB,AAAC,gBAAkB,AAC1C,qBAAsB,AAAC,UAAY,CACpC,AAKD,uEAAsC,aAAc,CAAC,CAEtD,AAED,wBACI,kBAAmB,AACnB,qBAAsB,AACtB,8BAAgC,AAChC,cAAgB,CACnB,AAED,uCACI,kBAAmB,AACnB,YAAa,AACb,sBAAwB,AACxB,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,cAAe,AACf,YAAa,AAGb,kBAAmB,AACnB,qBAAuB,CAC1B,AAED,6CACI,kBAAoB,CACvB","file":"cart.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n .table>tbody>tr>td[_v-77d75885], .table>tfoot>tr>td[_v-77d75885]{\n    vertical-align: middle;\n}\n@media screen and (max-width: 768px) {\n    table#cart tbody td .form-control[_v-77d75885]{\n    width:20%;\n    display: inline !important;\n  }\n  .actions .btn[_v-77d75885]{\n    width:36%;\n    margin:1.5em 0;\n  }\n  \n  .actions .btn-info[_v-77d75885]{\n    float:left;\n  }\n  .actions .btn-danger[_v-77d75885]{\n    float:right;\n  }\n  \n  table#cart thead[_v-77d75885] { display: none; }\n  table#cart tbody tr td[_v-77d75885]:first-child { background: #333; color: #fff; }\n  table#cart tbody td[_v-77d75885]:before {\n    content: attr(data-th); font-weight: bold;\n    display: inline-block; width: 8rem;\n  }\n  \n  \n  \n  table#cart tfoot td[_v-77d75885]{display:block; }\n  table#cart tfoot td .btn[_v-77d75885]{display:block;}\n  \n}\n\n.v-tooltip[_v-77d75885] {\n    position: relative;\n    display: inline-block;\n    border-bottom: 1px dotted black;\n    cursor: pointer;\n}\n\n.v-tooltip .v-tooltiptext[_v-77d75885] {\n    visibility: hidden;\n    width: 120px;\n    background-color: black;\n    color: #fff;\n    text-align: center;\n    border-radius: 6px;\n    padding: 5px 0;\n    right: -20px;\n\n    /* Position the v-tooltip */\n    position: absolute;\n    z-index: 9999999999999;\n}\n\n.v-tooltip:hover .v-tooltiptext[_v-77d75885] {\n    visibility: visible;\n}\n\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".recommhr[_v-7d91334e]{margin:0;height:1px;background-color:#ad1457;color:#ad1457}.gold[_v-7d91334e]{color:#ffbf00}.product[_v-7d91334e]{border:1px solid #ddd;height:321px}.product>img[_v-7d91334e]{max-width:230px}.product-rating[_v-7d91334e]{font-size:20px;margin-bottom:25px}.product-title[_v-7d91334e]{font-size:20px}.product-desc[_v-7d91334e]{font-size:14px}.product-price[_v-7d91334e]{font-size:22px}.product-stock[_v-7d91334e]{font-size:20px;margin-top:10px}.product-info[_v-7d91334e]{margin-top:50px}.content-wrapper[_v-7d91334e]{max-width:1140px;background:#fff;margin:0 auto;margin-top:25px;margin-bottom:10px;border:0;border-radius:0}.container-fluid[_v-7d91334e]{max-width:1140px;margin:0 auto}.view-wrapper[_v-7d91334e]{float:right;max-width:70%;margin-top:25px}.container[_v-7d91334e]{padding-left:0;padding-right:0;max-width:100%}.service1-items[_v-7d91334e]{padding:0;float:left;position:relative;overflow:hidden;max-width:100%;height:321px;width:130px}.service1-item[_v-7d91334e]{height:107px;width:120px;display:block;float:left;position:relative;padding-right:20px;border-right:1px solid #ddd;border-top:1px solid #ddd;border-bottom:1px solid #ddd}.service1-item>img[_v-7d91334e]{max-height:110px;max-width:110px;opacity:.6;transition:all .2s ease-in;-o-transition:all .2s ease-in;-moz-transition:all .2s ease-in;-webkit-transition:all .2s ease-in}.service1-item>img[_v-7d91334e]:hover{cursor:pointer;opacity:1}.service-image-left[_v-7d91334e]{padding-right:50px}.service-image-right[_v-7d91334e]{padding-left:50px}.service-image-left>center>img[_v-7d91334e],.service-image-right>center>img[_v-7d91334e]{max-height:155px}", "", {"version":3,"sources":["/./src/components/Product.vue"],"names":[],"mappings":"AAoVE,uBACE,SAAY,AACZ,WAAY,AACZ,yBAAyB,AACzB,aAAc,CACf,AAKH,mBACE,aAAe,CAChB,AAMD,sBACE,sBAA0B,AAC1B,YAAc,CACf,AAED,0BACE,eAAiB,CAClB,AAED,6BACE,eAAgB,AAChB,kBAAoB,CACrB,AAED,4BACE,cAAgB,CACjB,AAED,2BACE,cAAgB,CACjB,AAED,4BACE,cAAgB,CACjB,AAED,4BACE,eAAgB,AAChB,eAAiB,CAClB,AAED,2BACI,eAAiB,CACpB,AAMD,8BACE,iBAAkB,AAClB,gBAAiB,AACjB,cAAe,AACf,gBAAiB,AACjB,mBAAoB,AACpB,SAAY,AACZ,eAAmB,CACpB,AAED,8BACE,iBAAkB,AAClB,aAAe,CAChB,AAED,2BACE,YAAa,AACb,cAAe,AACf,eAAiB,CAClB,AAED,wBACE,eAAkB,AAClB,gBAAmB,AACnB,cAAgB,CACjB,AAMD,6BACE,UAAqB,AACrB,WAAY,AACZ,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,aAAc,AACd,WAAa,CACd,AAED,4BACE,aAAc,AACd,YAAa,AACb,cAAe,AACf,WAAY,AACZ,kBAAmB,AACnB,mBAAoB,AACpB,4BAA6B,AAC7B,0BAA2B,AAC3B,4BAA8B,CAC/B,AAED,gCACE,iBAAkB,AAClB,gBAAiB,AACjB,WAAa,AACb,2BAA4B,AAC5B,8BAA+B,AAC/B,gCAAiC,AACjC,kCAAoC,CACrC,AAED,sCACE,eAAgB,AAChB,SAAW,CACZ,AAED,iCACE,kBAAoB,CACrB,AAED,kCACE,iBAAmB,CACpB,AAED,yFACE,gBAAkB,CACnB","file":"Product.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n  \n  .recommhr[_v-7d91334e] {\n    margin: 0px;\n    height: 1px;\n    background-color:#ad1457;\n    color:#ad1457;\n  }\n/*********************************************\n            Theme Elements\n*********************************************/\n\n.gold[_v-7d91334e]{\n  color: #FFBF00;\n}\n\n/*********************************************\n          PRODUCTS\n*********************************************/\n\n.product[_v-7d91334e]{\n  border: 1px solid #dddddd;\n  height: 321px;\n}\n\n.product>img[_v-7d91334e]{\n  max-width: 230px;\n}\n\n.product-rating[_v-7d91334e]{\n  font-size: 20px;\n  margin-bottom: 25px;\n}\n\n.product-title[_v-7d91334e]{\n  font-size: 20px;\n}\n\n.product-desc[_v-7d91334e]{\n  font-size: 14px;\n}\n\n.product-price[_v-7d91334e]{\n  font-size: 22px;\n}\n\n.product-stock[_v-7d91334e]{\n  font-size: 20px;\n  margin-top: 10px;\n}\n\n.product-info[_v-7d91334e]{\n    margin-top: 50px;\n}\n\n/*********************************************\n          VIEW\n*********************************************/\n\n.content-wrapper[_v-7d91334e] {\n  max-width: 1140px;\n  background: #fff;\n  margin: 0 auto;\n  margin-top: 25px;\n  margin-bottom: 10px;\n  border: 0px;\n  border-radius: 0px;\n}\n\n.container-fluid[_v-7d91334e]{\n  max-width: 1140px;\n  margin: 0 auto;\n}\n\n.view-wrapper[_v-7d91334e] {\n  float: right;\n  max-width: 70%;\n  margin-top: 25px;\n}\n\n.container[_v-7d91334e] {\n  padding-left: 0px;\n  padding-right: 0px;\n  max-width: 100%;\n}\n\n/*********************************************\n        ITEM \n*********************************************/\n\n.service1-items[_v-7d91334e] {\n  padding: 0px 0 0px 0;\n  float: left;\n  position: relative;\n  overflow: hidden;\n  max-width: 100%;\n  height: 321px;\n  width: 130px;\n}\n\n.service1-item[_v-7d91334e] {\n  height: 107px;\n  width: 120px;\n  display: block;\n  float: left;\n  position: relative;\n  padding-right: 20px;\n  border-right: 1px solid #DDD;\n  border-top: 1px solid #DDD;\n  border-bottom: 1px solid #DDD;\n}\n\n.service1-item > img[_v-7d91334e] {\n  max-height: 110px;\n  max-width: 110px;\n  opacity: 0.6;\n  transition: all .2s ease-in;\n  -o-transition: all .2s ease-in;\n  -moz-transition: all .2s ease-in;\n  -webkit-transition: all .2s ease-in;\n}\n\n.service1-item > img[_v-7d91334e]:hover {\n  cursor: pointer;\n  opacity: 1;\n}\n\n.service-image-left[_v-7d91334e] {\n  padding-right: 50px;\n}\n\n.service-image-right[_v-7d91334e] {\n  padding-left: 50px;\n}\n\n.service-image-left > center > img[_v-7d91334e],.service-image-right > center > img[_v-7d91334e]{\n  max-height: 155px;\n}\n\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "#content input[disabled][_v-a30f0f62]{color:#DDDD;padding:2px;margin:0;background-image:none}", "", {"version":3,"sources":["/./src/components/dashboard/addProduct.vue"],"names":[],"mappings":"AAiRA,sCACI,YAAa,AACb,YAAa,AACb,SAAgB,AAChB,qBAAuB,CAC1B","file":"addProduct.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n#content input[disabled][_v-a30f0f62] {\n    color: #DDDD;\n    padding: 2px;\n    margin: 0 0 0 0;\n    background-image: none;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "@media screen and (max-width:768px){p[_v-c830bc3e]{font-size:3.2vw}.dress-card-img-top[_v-c830bc3e]{width:100%;height:100%;border-radius:7px 7px 0 0}body[_v-c830bc3e]{background-color:#000}}.isDisabled[_v-c830bc3e]{cursor:not-allowed;opacity:.5}.isDisabled>a[_v-c830bc3e]{pointer-events:none;text-decoration:none}.dress-card-img-top[_v-c830bc3e]{width:100%;height:33.3vh;border-radius:7px 7px 0 0}.dress-card-body[_v-c830bc3e]{padding:1rem;background:#fff;border-radius:0 0 7px 7px;margin-bottom:7px}.dress-card-title[_v-c830bc3e]{overflow:hidden;white-space:nowrap;height:2.2em;color:#000}.dress-card-crossed[_v-c830bc3e]{text-decoration:line-through}.dress-card-price[_v-c830bc3e]{font-size:1rem;font-weight:700}.dress-card-off[_v-c830bc3e]{color:#ad1457}.dress-card-para[_v-c830bc3e]{margin-bottom:.2rem;font-size:1rem;margin-bottom:0}.dress-card[_v-c830bc3e]{border-radius:14px}.dress-card-heart[_v-c830bc3e]{font-size:1em;color:#db2763;margin:4.5px;position:absolute;left:4px;top:0}.card-button[_v-c830bc3e]{text-align:center;font-size:15px;padding:9px;vertical-align:bottom}.card-button a[_v-c830bc3e]{text-decoration:none}.card-button-inner[_v-c830bc3e]{padding:10px;border-radius:3px}.bag-button[_v-c830bc3e]{background:#aaa;color:#fff}.wish-button[_v-c830bc3e]{border:1px solid #ad1457;color:#ad1457}", "", {"version":3,"sources":["/./src/components/Common/ProductCard.vue"],"names":[],"mappings":"AAsEE,oCACE,eACE,eAAiB,CAClB,AACD,iCACE,WAAY,AACZ,YAAa,AACb,yBAA2B,CAC5B,AACD,kBACA,qBAAwB,CACzB,CACA,AAEH,yBACE,mBAAoB,AACpB,UAAa,CACd,AAED,2BACE,oBAAqB,AACrB,oBAAsB,CACvB,AAED,iCACE,WAAY,AACZ,cAAe,AACf,yBAA2B,CAC5B,AAED,8BACE,aAAa,AACb,gBAAiB,AACjB,0BAA2B,AAC3B,iBAAmB,CACpB,AAED,+BACE,gBAAiB,AACjB,mBAAoB,AACpB,aAAc,AACd,UAAa,CACd,AAED,iCACE,4BAA8B,CAC/B,AAED,+BACE,eAAgB,AAChB,eAAkB,CACnB,AAED,6BACE,aAAe,CAChB,AAED,8BACE,oBAAsB,AACtB,eAAkB,AAClB,eAAoB,CACrB,AAED,yBACE,kBAAoB,CACrB,AAED,+BACE,cAAe,AACf,cAAe,AACf,aAAc,AACd,kBAAmB,AACnB,SAAU,AACV,KAAS,CAEV,AAED,0BACE,kBAAmB,AACnB,eAAgB,AAChB,YAAa,AACb,qBAAqB,CACtB,AAED,4BACE,oBAAsB,CACvB,AAED,gCACE,aAAc,AACd,iBAAmB,CACpB,AAED,yBACE,gBAAoB,AACpB,UAAa,CACd,AAED,0BACE,yBAA0B,AAC1B,aAAe,CAChB","file":"ProductCard.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n  @media screen and (max-width: 768px){\n    p[_v-c830bc3e]{\n      font-size: 3.2vw;\n    }\n    .dress-card-img-top[_v-c830bc3e] {\n      width: 100%;\n      height: 100%;\n      border-radius: 7px 7px 0 0;\n    }\n    body[_v-c830bc3e] {\n    background-color: black;\n  }\n  }\n\n.isDisabled[_v-c830bc3e] {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.isDisabled > a[_v-c830bc3e] {\n  pointer-events: none;\n  text-decoration: none;\n}\n/* card */\n.dress-card-img-top[_v-c830bc3e] {\n  width: 100%;\n  height: 33.3vh;\n  border-radius: 7px 7px 0 0;\n}\n\n.dress-card-body[_v-c830bc3e] {\n  padding:1rem;\n  background: #fff;\n  border-radius: 0 0 7px 7px;\n  margin-bottom: 7px;\n}\n\n.dress-card-title[_v-c830bc3e] {\n  overflow: hidden;\n  white-space: nowrap;\n  height: 2.2em;\n  color: black;\n}\n\n.dress-card-crossed[_v-c830bc3e] {\n  text-decoration: line-through;\n}\n\n.dress-card-price[_v-c830bc3e] {\n  font-size: 1rem;\n  font-weight: bold;\n}\n\n.dress-card-off[_v-c830bc3e] {\n  color: #ad1457;\n}\n\n.dress-card-para[_v-c830bc3e] {\n  margin-bottom: 0.2rem;\n  font-size: 1.0rem;\n  margin-bottom: 0rem;\n}\n\n.dress-card[_v-c830bc3e] {\n  border-radius: 14px;\n}\n\n.dress-card-heart[_v-c830bc3e] {\n  font-size: 1em;\n  color: #DB2763;\n  margin: 4.5px;\n  position: absolute;\n  left: 4px;\n  top: 0px;\n  \n}\n\n.card-button[_v-c830bc3e] {\n  text-align: center;\n  font-size: 15px;\n  padding: 9px;\n  vertical-align:bottom\n}\n\n.card-button a[_v-c830bc3e] {\n  text-decoration: none;\n}\n\n.card-button-inner[_v-c830bc3e] {\n  padding: 10px;\n  border-radius: 3px;\n}\n\n.bag-button[_v-c830bc3e] {\n  background: #aaaaaa;\n  color: white;\n}\n\n.wish-button[_v-c830bc3e] {\n  border: 1px solid #ad1457;\n  color: #ad1457;\n}\n\n\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * matchesSelector v2.0.2
	 * matchesSelector( element, '.selector' )
	 * MIT license
	 */
	
	/*jshint browser: true, strict: true, undef: true, unused: true */
	
	( function( window, factory ) {
	  /*global define: false, module: false */
	  'use strict';
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // browser global
	    window.matchesSelector = factory();
	  }
	
	}( window, function factory() {
	  'use strict';
	
	  var matchesMethod = ( function() {
	    var ElemProto = window.Element.prototype;
	    // check for the standard method name first
	    if ( ElemProto.matches ) {
	      return 'matches';
	    }
	    // check un-prefixed
	    if ( ElemProto.matchesSelector ) {
	      return 'matchesSelector';
	    }
	    // check vendor prefixes
	    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];
	
	    for ( var i=0; i < prefixes.length; i++ ) {
	      var prefix = prefixes[i];
	      var method = prefix + 'MatchesSelector';
	      if ( ElemProto[ method ] ) {
	        return method;
	      }
	    }
	  })();
	
	  return function matchesSelector( elem, selector ) {
	    return elem[ matchesMethod ]( selector );
	  };
	
	}));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _throwIfMissing = _interopRequireDefault(__webpack_require__(115));
	
	var _dom = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	var BoundingBox = /*#__PURE__*/function () {
	  function BoundingBox(options) {
	    _classCallCheck(this, BoundingBox);
	
	    this.isShowing = false;
	    var _options$namespace = options.namespace,
	        namespace = _options$namespace === void 0 ? null : _options$namespace,
	        _options$zoomFactor = options.zoomFactor,
	        zoomFactor = _options$zoomFactor === void 0 ? (0, _throwIfMissing.default)() : _options$zoomFactor,
	        _options$containerEl = options.containerEl,
	        containerEl = _options$containerEl === void 0 ? (0, _throwIfMissing.default)() : _options$containerEl;
	    this.settings = {
	      namespace: namespace,
	      zoomFactor: zoomFactor,
	      containerEl: containerEl
	    };
	    this.openClasses = this._buildClasses("open");
	
	    this._buildElement();
	  }
	
	  _createClass(BoundingBox, [{
	    key: "_buildClasses",
	    value: function _buildClasses(suffix) {
	      var classes = ["drift-".concat(suffix)];
	      var ns = this.settings.namespace;
	
	      if (ns) {
	        classes.push("".concat(ns, "-").concat(suffix));
	      }
	
	      return classes;
	    }
	  }, {
	    key: "_buildElement",
	    value: function _buildElement() {
	      this.el = document.createElement("div");
	      (0, _dom.addClasses)(this.el, this._buildClasses("bounding-box"));
	    }
	  }, {
	    key: "show",
	    value: function show(zoomPaneWidth, zoomPaneHeight) {
	      this.isShowing = true;
	      this.settings.containerEl.appendChild(this.el);
	      var style = this.el.style;
	      style.width = "".concat(Math.round(zoomPaneWidth / this.settings.zoomFactor), "px");
	      style.height = "".concat(Math.round(zoomPaneHeight / this.settings.zoomFactor), "px");
	      (0, _dom.addClasses)(this.el, this.openClasses);
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (this.isShowing) {
	        this.settings.containerEl.removeChild(this.el);
	      }
	
	      this.isShowing = false;
	      (0, _dom.removeClasses)(this.el, this.openClasses);
	    }
	  }, {
	    key: "setPosition",
	    value: function setPosition(percentageOffsetX, percentageOffsetY, triggerRect) {
	      var pageXOffset = window.pageXOffset;
	      var pageYOffset = window.pageYOffset;
	      var inlineLeft = triggerRect.left + percentageOffsetX * triggerRect.width - this.el.clientWidth / 2 + pageXOffset;
	      var inlineTop = triggerRect.top + percentageOffsetY * triggerRect.height - this.el.clientHeight / 2 + pageYOffset;
	
	      if (inlineLeft < triggerRect.left + pageXOffset) {
	        inlineLeft = triggerRect.left + pageXOffset;
	      } else if (inlineLeft + this.el.clientWidth > triggerRect.left + triggerRect.width + pageXOffset) {
	        inlineLeft = triggerRect.left + triggerRect.width - this.el.clientWidth + pageXOffset;
	      }
	
	      if (inlineTop < triggerRect.top + pageYOffset) {
	        inlineTop = triggerRect.top + pageYOffset;
	      } else if (inlineTop + this.el.clientHeight > triggerRect.top + triggerRect.height + pageYOffset) {
	        inlineTop = triggerRect.top + triggerRect.height - this.el.clientHeight + pageYOffset;
	      }
	
	      this.el.style.left = "".concat(inlineLeft, "px");
	      this.el.style.top = "".concat(inlineTop, "px");
	    }
	  }]);
	
	  return BoundingBox;
	}();
	
	exports.default = BoundingBox;
	//# sourceMappingURL=BoundingBox.js.map

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _dom = __webpack_require__(114);
	
	var _injectBaseStylesheet = _interopRequireDefault(__webpack_require__(344));
	
	var _Trigger = _interopRequireDefault(__webpack_require__(342));
	
	var _ZoomPane = _interopRequireDefault(__webpack_require__(343));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	var Drift = /*#__PURE__*/function () {
	  function Drift(triggerEl) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Drift);
	
	    this.VERSION = "1.5.1";
	    this.triggerEl = triggerEl;
	    this.destroy = this.destroy.bind(this);
	
	    if (!(0, _dom.isDOMElement)(this.triggerEl)) {
	      throw new TypeError("`new Drift` requires a DOM element as its first argument.");
	    } // Prefix for generated element class names (e.g. `my-ns` will
	    // result in classes such as `my-ns-pane`. Default `drift-`
	    // prefixed classes will always be added as well.
	
	
	    var namespace = options["namespace"] || null; // Whether the ZoomPane should show whitespace when near the edges.
	
	    var showWhitespaceAtEdges = options["showWhitespaceAtEdges"] || false; // Whether the inline ZoomPane should stay inside
	    // the bounds of its image.
	
	    var containInline = options["containInline"] || false; // How much to offset the ZoomPane from the
	    // interaction point when inline.
	
	    var inlineOffsetX = options["inlineOffsetX"] || 0;
	    var inlineOffsetY = options["inlineOffsetY"] || 0; // A DOM element to append the inline ZoomPane to
	
	    var inlineContainer = options["inlineContainer"] || document.body; // Which trigger attribute to pull the ZoomPane image source from.
	
	    var sourceAttribute = options["sourceAttribute"] || "data-zoom"; // How much to magnify the trigger by in the ZoomPane.
	    // (e.g., `zoomFactor: 3` will result in a 900 px wide ZoomPane imag
	    // if the trigger is displayed at 300 px wide)
	
	    var zoomFactor = options["zoomFactor"] || 3; // A DOM element to append the non-inline ZoomPane to.
	    // Required if `inlinePane !== true`.
	
	    var paneContainer = options["paneContainer"] === undefined ? document.body : options["paneContainer"]; // When to switch to an inline ZoomPane. This can be a boolean or
	    // an integer. If `true`, the ZoomPane will always be inline,
	    // if `false`, it will switch to inline when `windowWidth <= inlinePane`
	
	    var inlinePane = options["inlinePane"] || 375; // If `true`, touch events will trigger the zoom, like mouse events.
	
	    var handleTouch = "handleTouch" in options ? !!options["handleTouch"] : true; // If present (and a function), this will be called
	    // whenever the ZoomPane is shown.
	
	    var onShow = options["onShow"] || null; // If present (and a function), this will be called
	    // whenever the ZoomPane is hidden.
	
	    var onHide = options["onHide"] || null; // Add base styles to the page. See the "Theming"
	    // section of README.md for more information.
	
	    var injectBaseStyles = "injectBaseStyles" in options ? !!options["injectBaseStyles"] : true; // An optional number that determines how long to wait before
	    // showing the ZoomPane because of a `mouseenter` event.
	
	    var hoverDelay = options["hoverDelay"] || 0; // An optional number that determines how long to wait before
	    // showing the ZoomPane because of a `touchstart` event.
	    // It's unlikely that you would want to use this option, since
	    // "tap and hold" is much more intentional than a hover event.
	
	    var touchDelay = options["touchDelay"] || 0; // If true, a bounding box will show the area currently being previewed
	    // during mouse hover
	
	    var hoverBoundingBox = options["hoverBoundingBox"] || false; // If true, a bounding box will show the area currently being previewed
	    // during touch events
	
	    var touchBoundingBox = options["touchBoundingBox"] || false; // A DOM element to append the bounding box to.
	
	    var boundingBoxContainer = options["boundingBoxContainer"] || document.body; // If true, the events related to handleTouch use passive listeners in
	    // order to improve performance for touch devices.
	
	    var passive = options["passive"] || false;
	
	    if (inlinePane !== true && !(0, _dom.isDOMElement)(paneContainer)) {
	      throw new TypeError("`paneContainer` must be a DOM element when `inlinePane !== true`");
	    }
	
	    if (!(0, _dom.isDOMElement)(inlineContainer)) {
	      throw new TypeError("`inlineContainer` must be a DOM element");
	    }
	
	    this.settings = {
	      namespace: namespace,
	      showWhitespaceAtEdges: showWhitespaceAtEdges,
	      containInline: containInline,
	      inlineOffsetX: inlineOffsetX,
	      inlineOffsetY: inlineOffsetY,
	      inlineContainer: inlineContainer,
	      sourceAttribute: sourceAttribute,
	      zoomFactor: zoomFactor,
	      paneContainer: paneContainer,
	      inlinePane: inlinePane,
	      handleTouch: handleTouch,
	      onShow: onShow,
	      onHide: onHide,
	      injectBaseStyles: injectBaseStyles,
	      hoverDelay: hoverDelay,
	      touchDelay: touchDelay,
	      hoverBoundingBox: hoverBoundingBox,
	      touchBoundingBox: touchBoundingBox,
	      boundingBoxContainer: boundingBoxContainer,
	      passive: passive
	    };
	
	    if (this.settings.injectBaseStyles) {
	      (0, _injectBaseStylesheet.default)();
	    }
	
	    this._buildZoomPane();
	
	    this._buildTrigger();
	  }
	
	  _createClass(Drift, [{
	    key: "_buildZoomPane",
	    value: function _buildZoomPane() {
	      this.zoomPane = new _ZoomPane.default({
	        container: this.settings.paneContainer,
	        zoomFactor: this.settings.zoomFactor,
	        showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
	        containInline: this.settings.containInline,
	        inline: this.settings.inlinePane,
	        namespace: this.settings.namespace,
	        inlineOffsetX: this.settings.inlineOffsetX,
	        inlineOffsetY: this.settings.inlineOffsetY,
	        inlineContainer: this.settings.inlineContainer
	      });
	    }
	  }, {
	    key: "_buildTrigger",
	    value: function _buildTrigger() {
	      this.trigger = new _Trigger.default({
	        el: this.triggerEl,
	        zoomPane: this.zoomPane,
	        handleTouch: this.settings.handleTouch,
	        onShow: this.settings.onShow,
	        onHide: this.settings.onHide,
	        sourceAttribute: this.settings.sourceAttribute,
	        hoverDelay: this.settings.hoverDelay,
	        touchDelay: this.settings.touchDelay,
	        hoverBoundingBox: this.settings.hoverBoundingBox,
	        touchBoundingBox: this.settings.touchBoundingBox,
	        namespace: this.settings.namespace,
	        zoomFactor: this.settings.zoomFactor,
	        boundingBoxContainer: this.settings.boundingBoxContainer,
	        passive: this.settings.passive
	      });
	    }
	  }, {
	    key: "setZoomImageURL",
	    value: function setZoomImageURL(imageURL) {
	      this.zoomPane._setImageURL(imageURL);
	    }
	  }, {
	    key: "disable",
	    value: function disable() {
	      this.trigger.enabled = false;
	    }
	  }, {
	    key: "enable",
	    value: function enable() {
	      this.trigger.enabled = true;
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      this.trigger._hide();
	
	      this.trigger._unbindEvents();
	    }
	  }, {
	    key: "isShowing",
	    get: function get() {
	      return this.zoomPane.isShowing;
	    }
	  }, {
	    key: "zoomFactor",
	    get: function get() {
	      return this.settings.zoomFactor;
	    },
	    set: function set(zf) {
	      this.settings.zoomFactor = zf;
	      this.zoomPane.settings.zoomFactor = zf;
	      this.trigger.settings.zoomFactor = zf;
	      this.boundingBox.settings.zoomFactor = zf;
	    }
	  }]);
	
	  return Drift;
	}(); // Public API
	
	/* eslint-disable no-self-assign */
	
	
	exports.default = Drift;
	Object.defineProperty(Drift.prototype, "isShowing", {
	  get: function get() {
	    return this.isShowing;
	  }
	});
	Object.defineProperty(Drift.prototype, "zoomFactor", {
	  get: function get() {
	    return this.zoomFactor;
	  },
	  set: function set(value) {
	    this.zoomFactor = value;
	  }
	});
	Drift.prototype["setZoomImageURL"] = Drift.prototype.setZoomImageURL;
	Drift.prototype["disable"] = Drift.prototype.disable;
	Drift.prototype["enable"] = Drift.prototype.enable;
	Drift.prototype["destroy"] = Drift.prototype.destroy;
	/* eslint-enable no-self-assign */
	//# sourceMappingURL=Drift.js.map

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _throwIfMissing = _interopRequireDefault(__webpack_require__(115));
	
	var _BoundingBox = _interopRequireDefault(__webpack_require__(340));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	var Trigger = /*#__PURE__*/function () {
	  function Trigger() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Trigger);
	
	    this._show = this._show.bind(this);
	    this._hide = this._hide.bind(this);
	    this._handleEntry = this._handleEntry.bind(this);
	    this._handleMovement = this._handleMovement.bind(this);
	    var _options$el = options.el,
	        el = _options$el === void 0 ? (0, _throwIfMissing.default)() : _options$el,
	        _options$zoomPane = options.zoomPane,
	        zoomPane = _options$zoomPane === void 0 ? (0, _throwIfMissing.default)() : _options$zoomPane,
	        _options$sourceAttrib = options.sourceAttribute,
	        sourceAttribute = _options$sourceAttrib === void 0 ? (0, _throwIfMissing.default)() : _options$sourceAttrib,
	        _options$handleTouch = options.handleTouch,
	        handleTouch = _options$handleTouch === void 0 ? (0, _throwIfMissing.default)() : _options$handleTouch,
	        _options$onShow = options.onShow,
	        onShow = _options$onShow === void 0 ? null : _options$onShow,
	        _options$onHide = options.onHide,
	        onHide = _options$onHide === void 0 ? null : _options$onHide,
	        _options$hoverDelay = options.hoverDelay,
	        hoverDelay = _options$hoverDelay === void 0 ? 0 : _options$hoverDelay,
	        _options$touchDelay = options.touchDelay,
	        touchDelay = _options$touchDelay === void 0 ? 0 : _options$touchDelay,
	        _options$hoverBoundin = options.hoverBoundingBox,
	        hoverBoundingBox = _options$hoverBoundin === void 0 ? (0, _throwIfMissing.default)() : _options$hoverBoundin,
	        _options$touchBoundin = options.touchBoundingBox,
	        touchBoundingBox = _options$touchBoundin === void 0 ? (0, _throwIfMissing.default)() : _options$touchBoundin,
	        _options$namespace = options.namespace,
	        namespace = _options$namespace === void 0 ? null : _options$namespace,
	        _options$zoomFactor = options.zoomFactor,
	        zoomFactor = _options$zoomFactor === void 0 ? (0, _throwIfMissing.default)() : _options$zoomFactor,
	        _options$boundingBoxC = options.boundingBoxContainer,
	        boundingBoxContainer = _options$boundingBoxC === void 0 ? (0, _throwIfMissing.default)() : _options$boundingBoxC,
	        _options$passive = options.passive,
	        passive = _options$passive === void 0 ? false : _options$passive;
	    this.settings = {
	      el: el,
	      zoomPane: zoomPane,
	      sourceAttribute: sourceAttribute,
	      handleTouch: handleTouch,
	      onShow: onShow,
	      onHide: onHide,
	      hoverDelay: hoverDelay,
	      touchDelay: touchDelay,
	      hoverBoundingBox: hoverBoundingBox,
	      touchBoundingBox: touchBoundingBox,
	      namespace: namespace,
	      zoomFactor: zoomFactor,
	      boundingBoxContainer: boundingBoxContainer,
	      passive: passive
	    };
	
	    if (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) {
	      this.boundingBox = new _BoundingBox.default({
	        namespace: this.settings.namespace,
	        zoomFactor: this.settings.zoomFactor,
	        containerEl: this.settings.boundingBoxContainer
	      });
	    }
	
	    this.enabled = true;
	
	    this._bindEvents();
	  }
	
	  _createClass(Trigger, [{
	    key: "_preventDefault",
	    value: function _preventDefault(event) {
	      event.preventDefault();
	    }
	  }, {
	    key: "_preventDefaultAllowTouchScroll",
	    value: function _preventDefaultAllowTouchScroll(event) {
	      if (!this.settings.touchDelay || !this._isTouchEvent(event) || this.isShowing) {
	        event.preventDefault();
	      }
	    }
	  }, {
	    key: "_isTouchEvent",
	    value: function _isTouchEvent(event) {
	      return !!event.touches;
	    }
	  }, {
	    key: "_bindEvents",
	    value: function _bindEvents() {
	      this.settings.el.addEventListener("mouseenter", this._handleEntry);
	      this.settings.el.addEventListener("mouseleave", this._hide);
	      this.settings.el.addEventListener("mousemove", this._handleMovement);
	      var isPassive = {
	        passive: this.settings.passive
	      };
	
	      if (this.settings.handleTouch) {
	        this.settings.el.addEventListener("touchstart", this._handleEntry, isPassive);
	        this.settings.el.addEventListener("touchend", this._hide);
	        this.settings.el.addEventListener("touchmove", this._handleMovement, isPassive);
	      } else {
	        this.settings.el.addEventListener("touchstart", this._preventDefault, isPassive);
	        this.settings.el.addEventListener("touchend", this._preventDefault);
	        this.settings.el.addEventListener("touchmove", this._preventDefault, isPassive);
	      }
	    }
	  }, {
	    key: "_unbindEvents",
	    value: function _unbindEvents() {
	      this.settings.el.removeEventListener("mouseenter", this._handleEntry);
	      this.settings.el.removeEventListener("mouseleave", this._hide);
	      this.settings.el.removeEventListener("mousemove", this._handleMovement);
	
	      if (this.settings.handleTouch) {
	        this.settings.el.removeEventListener("touchstart", this._handleEntry);
	        this.settings.el.removeEventListener("touchend", this._hide);
	        this.settings.el.removeEventListener("touchmove", this._handleMovement);
	      } else {
	        this.settings.el.removeEventListener("touchstart", this._preventDefault);
	        this.settings.el.removeEventListener("touchend", this._preventDefault);
	        this.settings.el.removeEventListener("touchmove", this._preventDefault);
	      }
	    }
	  }, {
	    key: "_handleEntry",
	    value: function _handleEntry(e) {
	      this._preventDefaultAllowTouchScroll(e);
	
	      this._lastMovement = e;
	
	      if (e.type == "mouseenter" && this.settings.hoverDelay) {
	        this.entryTimeout = setTimeout(this._show, this.settings.hoverDelay);
	      } else if (this.settings.touchDelay) {
	        this.entryTimeout = setTimeout(this._show, this.settings.touchDelay);
	      } else {
	        this._show();
	      }
	    }
	  }, {
	    key: "_show",
	    value: function _show() {
	      if (!this.enabled) {
	        return;
	      }
	
	      var onShow = this.settings.onShow;
	
	      if (onShow && typeof onShow === "function") {
	        onShow();
	      }
	
	      this.settings.zoomPane.show(this.settings.el.getAttribute(this.settings.sourceAttribute), this.settings.el.clientWidth, this.settings.el.clientHeight);
	
	      if (this._lastMovement) {
	        var touchActivated = this._lastMovement.touches;
	
	        if (touchActivated && this.settings.touchBoundingBox || !touchActivated && this.settings.hoverBoundingBox) {
	          this.boundingBox.show(this.settings.zoomPane.el.clientWidth, this.settings.zoomPane.el.clientHeight);
	        }
	      }
	
	      this._handleMovement();
	    }
	  }, {
	    key: "_hide",
	    value: function _hide(e) {
	      if (e) {
	        this._preventDefaultAllowTouchScroll(e);
	      }
	
	      this._lastMovement = null;
	
	      if (this.entryTimeout) {
	        clearTimeout(this.entryTimeout);
	      }
	
	      if (this.boundingBox) {
	        this.boundingBox.hide();
	      }
	
	      var onHide = this.settings.onHide;
	
	      if (onHide && typeof onHide === "function") {
	        onHide();
	      }
	
	      this.settings.zoomPane.hide();
	    }
	  }, {
	    key: "_handleMovement",
	    value: function _handleMovement(e) {
	      if (e) {
	        this._preventDefaultAllowTouchScroll(e);
	
	        this._lastMovement = e;
	      } else if (this._lastMovement) {
	        e = this._lastMovement;
	      } else {
	        return;
	      }
	
	      var movementX;
	      var movementY;
	
	      if (e.touches) {
	        var firstTouch = e.touches[0];
	        movementX = firstTouch.clientX;
	        movementY = firstTouch.clientY;
	      } else {
	        movementX = e.clientX;
	        movementY = e.clientY;
	      }
	
	      var el = this.settings.el;
	      var rect = el.getBoundingClientRect();
	      var offsetX = movementX - rect.left;
	      var offsetY = movementY - rect.top;
	      var percentageOffsetX = offsetX / this.settings.el.clientWidth;
	      var percentageOffsetY = offsetY / this.settings.el.clientHeight;
	
	      if (this.boundingBox) {
	        this.boundingBox.setPosition(percentageOffsetX, percentageOffsetY, rect);
	      }
	
	      this.settings.zoomPane.setPosition(percentageOffsetX, percentageOffsetY, rect);
	    }
	  }, {
	    key: "isShowing",
	    get: function get() {
	      return this.settings.zoomPane.isShowing;
	    }
	  }]);
	
	  return Trigger;
	}();
	
	exports.default = Trigger;
	//# sourceMappingURL=Trigger.js.map

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _throwIfMissing = _interopRequireDefault(__webpack_require__(115));
	
	var _dom = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	var ZoomPane = /*#__PURE__*/function () {
	  function ZoomPane() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, ZoomPane);
	
	    // All officially-supported browsers have this, but it's easy to
	    // account for, just in case.
	    this.HAS_ANIMATION = false;
	
	    if (typeof document !== "undefined") {
	      var divStyle = document.createElement("div").style;
	      this.HAS_ANIMATION = "animation" in divStyle || "webkitAnimation" in divStyle;
	    }
	
	    this._completeShow = this._completeShow.bind(this);
	    this._completeHide = this._completeHide.bind(this);
	    this._handleLoad = this._handleLoad.bind(this);
	    this.isShowing = false;
	    var _options$container = options.container,
	        container = _options$container === void 0 ? null : _options$container,
	        _options$zoomFactor = options.zoomFactor,
	        zoomFactor = _options$zoomFactor === void 0 ? (0, _throwIfMissing.default)() : _options$zoomFactor,
	        _options$inline = options.inline,
	        inline = _options$inline === void 0 ? (0, _throwIfMissing.default)() : _options$inline,
	        _options$namespace = options.namespace,
	        namespace = _options$namespace === void 0 ? null : _options$namespace,
	        _options$showWhitespa = options.showWhitespaceAtEdges,
	        showWhitespaceAtEdges = _options$showWhitespa === void 0 ? (0, _throwIfMissing.default)() : _options$showWhitespa,
	        _options$containInlin = options.containInline,
	        containInline = _options$containInlin === void 0 ? (0, _throwIfMissing.default)() : _options$containInlin,
	        _options$inlineOffset = options.inlineOffsetX,
	        inlineOffsetX = _options$inlineOffset === void 0 ? 0 : _options$inlineOffset,
	        _options$inlineOffset2 = options.inlineOffsetY,
	        inlineOffsetY = _options$inlineOffset2 === void 0 ? 0 : _options$inlineOffset2,
	        _options$inlineContai = options.inlineContainer,
	        inlineContainer = _options$inlineContai === void 0 ? document.body : _options$inlineContai;
	    this.settings = {
	      container: container,
	      zoomFactor: zoomFactor,
	      inline: inline,
	      namespace: namespace,
	      showWhitespaceAtEdges: showWhitespaceAtEdges,
	      containInline: containInline,
	      inlineOffsetX: inlineOffsetX,
	      inlineOffsetY: inlineOffsetY,
	      inlineContainer: inlineContainer
	    };
	    this.openClasses = this._buildClasses("open");
	    this.openingClasses = this._buildClasses("opening");
	    this.closingClasses = this._buildClasses("closing");
	    this.inlineClasses = this._buildClasses("inline");
	    this.loadingClasses = this._buildClasses("loading");
	
	    this._buildElement();
	  }
	
	  _createClass(ZoomPane, [{
	    key: "_buildClasses",
	    value: function _buildClasses(suffix) {
	      var classes = ["drift-".concat(suffix)];
	      var ns = this.settings.namespace;
	
	      if (ns) {
	        classes.push("".concat(ns, "-").concat(suffix));
	      }
	
	      return classes;
	    }
	  }, {
	    key: "_buildElement",
	    value: function _buildElement() {
	      this.el = document.createElement("div");
	      (0, _dom.addClasses)(this.el, this._buildClasses("zoom-pane"));
	      var loaderEl = document.createElement("div");
	      (0, _dom.addClasses)(loaderEl, this._buildClasses("zoom-pane-loader"));
	      this.el.appendChild(loaderEl);
	      this.imgEl = document.createElement("img");
	      this.el.appendChild(this.imgEl);
	    }
	  }, {
	    key: "_setImageURL",
	    value: function _setImageURL(imageURL) {
	      this.imgEl.setAttribute("src", imageURL);
	    }
	  }, {
	    key: "_setImageSize",
	    value: function _setImageSize(triggerWidth, triggerHeight) {
	      this.imgEl.style.width = "".concat(triggerWidth * this.settings.zoomFactor, "px");
	      this.imgEl.style.height = "".concat(triggerHeight * this.settings.zoomFactor, "px");
	    } // `percentageOffsetX` and `percentageOffsetY` must be percentages
	    // expressed as floats between `0' and `1`.
	
	  }, {
	    key: "setPosition",
	    value: function setPosition(percentageOffsetX, percentageOffsetY, triggerRect) {
	      var imgElWidth = this.imgEl.offsetWidth;
	      var imgElHeight = this.imgEl.offsetHeight;
	      var elWidth = this.el.offsetWidth;
	      var elHeight = this.el.offsetHeight;
	      var centreOfContainerX = elWidth / 2;
	      var centreOfContainerY = elHeight / 2;
	      var targetImgXToBeCentre = imgElWidth * percentageOffsetX;
	      var targetImgYToBeCentre = imgElHeight * percentageOffsetY;
	      var left = centreOfContainerX - targetImgXToBeCentre;
	      var top = centreOfContainerY - targetImgYToBeCentre;
	      var differenceBetweenContainerWidthAndImgWidth = elWidth - imgElWidth;
	      var differenceBetweenContainerHeightAndImgHeight = elHeight - imgElHeight;
	      var isContainerLargerThanImgX = differenceBetweenContainerWidthAndImgWidth > 0;
	      var isContainerLargerThanImgY = differenceBetweenContainerHeightAndImgHeight > 0;
	      var minLeft = isContainerLargerThanImgX ? differenceBetweenContainerWidthAndImgWidth / 2 : 0;
	      var minTop = isContainerLargerThanImgY ? differenceBetweenContainerHeightAndImgHeight / 2 : 0;
	      var maxLeft = isContainerLargerThanImgX ? differenceBetweenContainerWidthAndImgWidth / 2 : differenceBetweenContainerWidthAndImgWidth;
	      var maxTop = isContainerLargerThanImgY ? differenceBetweenContainerHeightAndImgHeight / 2 : differenceBetweenContainerHeightAndImgHeight;
	
	      if (this.el.parentElement === this.settings.inlineContainer) {
	        // This may be needed in the future to deal with browser event
	        // inconsistencies, but it's difficult to tell for sure.
	        // let scrollX = isTouch ? 0 : window.scrollX;
	        // let scrollY = isTouch ? 0 : window.scrollY;
	        var scrollX = window.pageXOffset;
	        var scrollY = window.pageYOffset;
	        var inlineLeft = triggerRect.left + percentageOffsetX * triggerRect.width - elWidth / 2 + this.settings.inlineOffsetX + scrollX;
	        var inlineTop = triggerRect.top + percentageOffsetY * triggerRect.height - elHeight / 2 + this.settings.inlineOffsetY + scrollY;
	
	        if (this.settings.containInline) {
	          if (inlineLeft < triggerRect.left + scrollX) {
	            inlineLeft = triggerRect.left + scrollX;
	          } else if (inlineLeft + elWidth > triggerRect.left + triggerRect.width + scrollX) {
	            inlineLeft = triggerRect.left + triggerRect.width - elWidth + scrollX;
	          }
	
	          if (inlineTop < triggerRect.top + scrollY) {
	            inlineTop = triggerRect.top + scrollY;
	          } else if (inlineTop + elHeight > triggerRect.top + triggerRect.height + scrollY) {
	            inlineTop = triggerRect.top + triggerRect.height - elHeight + scrollY;
	          }
	        }
	
	        this.el.style.left = "".concat(inlineLeft, "px");
	        this.el.style.top = "".concat(inlineTop, "px");
	      }
	
	      if (!this.settings.showWhitespaceAtEdges) {
	        if (left > minLeft) {
	          left = minLeft;
	        } else if (left < maxLeft) {
	          left = maxLeft;
	        }
	
	        if (top > minTop) {
	          top = minTop;
	        } else if (top < maxTop) {
	          top = maxTop;
	        }
	      }
	
	      this.imgEl.style.transform = "translate(".concat(left, "px, ").concat(top, "px)");
	      this.imgEl.style.webkitTransform = "translate(".concat(left, "px, ").concat(top, "px)");
	    }
	  }, {
	    key: "_removeListenersAndResetClasses",
	    value: function _removeListenersAndResetClasses() {
	      this.el.removeEventListener("animationend", this._completeShow);
	      this.el.removeEventListener("animationend", this._completeHide);
	      this.el.removeEventListener("webkitAnimationEnd", this._completeShow);
	      this.el.removeEventListener("webkitAnimationEnd", this._completeHide);
	      (0, _dom.removeClasses)(this.el, this.openClasses);
	      (0, _dom.removeClasses)(this.el, this.closingClasses);
	    }
	  }, {
	    key: "show",
	    value: function show(imageURL, triggerWidth, triggerHeight) {
	      this._removeListenersAndResetClasses();
	
	      this.isShowing = true;
	      (0, _dom.addClasses)(this.el, this.openClasses);
	
	      if (this.imgEl.getAttribute("src") != imageURL) {
	        (0, _dom.addClasses)(this.el, this.loadingClasses);
	        this.imgEl.addEventListener("load", this._handleLoad);
	
	        this._setImageURL(imageURL);
	      }
	
	      this._setImageSize(triggerWidth, triggerHeight);
	
	      if (this._isInline) {
	        this._showInline();
	      } else {
	        this._showInContainer();
	      }
	
	      if (this.HAS_ANIMATION) {
	        this.el.addEventListener("animationend", this._completeShow);
	        this.el.addEventListener("webkitAnimationEnd", this._completeShow);
	        (0, _dom.addClasses)(this.el, this.openingClasses);
	      }
	    }
	  }, {
	    key: "_showInline",
	    value: function _showInline() {
	      this.settings.inlineContainer.appendChild(this.el);
	      (0, _dom.addClasses)(this.el, this.inlineClasses);
	    }
	  }, {
	    key: "_showInContainer",
	    value: function _showInContainer() {
	      this.settings.container.appendChild(this.el);
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this._removeListenersAndResetClasses();
	
	      this.isShowing = false;
	
	      if (this.HAS_ANIMATION) {
	        this.el.addEventListener("animationend", this._completeHide);
	        this.el.addEventListener("webkitAnimationEnd", this._completeHide);
	        (0, _dom.addClasses)(this.el, this.closingClasses);
	      } else {
	        (0, _dom.removeClasses)(this.el, this.openClasses);
	        (0, _dom.removeClasses)(this.el, this.inlineClasses);
	      }
	    }
	  }, {
	    key: "_completeShow",
	    value: function _completeShow() {
	      this.el.removeEventListener("animationend", this._completeShow);
	      this.el.removeEventListener("webkitAnimationEnd", this._completeShow);
	      (0, _dom.removeClasses)(this.el, this.openingClasses);
	    }
	  }, {
	    key: "_completeHide",
	    value: function _completeHide() {
	      this.el.removeEventListener("animationend", this._completeHide);
	      this.el.removeEventListener("webkitAnimationEnd", this._completeHide);
	      (0, _dom.removeClasses)(this.el, this.openClasses);
	      (0, _dom.removeClasses)(this.el, this.closingClasses);
	      (0, _dom.removeClasses)(this.el, this.inlineClasses);
	      this.el.style.left = "";
	      this.el.style.top = ""; // The window could have been resized above or below `inline`
	      // limits since the ZoomPane was shown. Because of this, we
	      // can't rely on `this._isInline` here.
	
	      if (this.el.parentElement === this.settings.container) {
	        this.settings.container.removeChild(this.el);
	      } else if (this.el.parentElement === this.settings.inlineContainer) {
	        this.settings.inlineContainer.removeChild(this.el);
	      }
	    }
	  }, {
	    key: "_handleLoad",
	    value: function _handleLoad() {
	      this.imgEl.removeEventListener("load", this._handleLoad);
	      (0, _dom.removeClasses)(this.el, this.loadingClasses);
	    }
	  }, {
	    key: "_isInline",
	    get: function get() {
	      var inline = this.settings.inline;
	      return inline === true || typeof inline === "number" && window.innerWidth <= inline;
	    }
	  }]);
	
	  return ZoomPane;
	}();
	
	exports.default = ZoomPane;
	//# sourceMappingURL=ZoomPane.js.map

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = injectBaseStylesheet;
	
	/* UNMINIFIED RULES
	
	const RULES = `
	@keyframes noop {
	  0% { zoom: 1; }
	}
	
	@-webkit-keyframes noop {
	  0% { zoom: 1; }
	}
	
	.drift-zoom-pane.drift-open {
	  display: block;
	}
	
	.drift-zoom-pane.drift-opening, .drift-zoom-pane.drift-closing {
	  animation: noop 1ms;
	  -webkit-animation: noop 1ms;
	}
	
	.drift-zoom-pane {
	  position: absolute;
	  overflow: hidden;
	  width: 100%;
	  height: 100%;
	  top: 0;
	  left: 0;
	  pointer-events: none;
	}
	
	.drift-zoom-pane-loader {
	  display: none;
	}
	
	.drift-zoom-pane img {
	  position: absolute;
	  display: block;
	  max-width: none;
	  max-height: none;
	}
	
	.drift-bounding-box {
	  position: absolute;
	  pointer-events: none;
	}
	`;
	
	*/
	var RULES = ".drift-bounding-box,.drift-zoom-pane{position:absolute;pointer-events:none}@keyframes noop{0%{zoom:1}}@-webkit-keyframes noop{0%{zoom:1}}.drift-zoom-pane.drift-open{display:block}.drift-zoom-pane.drift-closing,.drift-zoom-pane.drift-opening{animation:noop 1ms;-webkit-animation:noop 1ms}.drift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.drift-zoom-pane-loader{display:none}.drift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}";
	
	function injectBaseStylesheet() {
	  if (document.querySelector(".drift-base-styles")) {
	    return;
	  }
	
	  var styleEl = document.createElement("style");
	  styleEl.type = "text/css";
	  styleEl.classList.add("drift-base-styles");
	  styleEl.appendChild(document.createTextNode(RULES));
	  var head = document.head;
	  head.insertBefore(styleEl, head.firstChild);
	}
	//# sourceMappingURL=injectBaseStylesheet.js.map

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	var _echarts = __webpack_require__(2);
	
	(function () {
	  for (var key in _echarts) {
	    if (_echarts == null || !_echarts.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
	    exports[key] = _echarts[key];
	  }
	})();
	
	var _export = __webpack_require__(201);
	
	(function () {
	  for (var key in _export) {
	    if (_export == null || !_export.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
	    exports[key] = _export[key];
	  }
	})();
	
	__webpack_require__(399);
	
	__webpack_require__(347);
	
	__webpack_require__(420);
	
	__webpack_require__(435);
	
	__webpack_require__(425);
	
	__webpack_require__(408);
	
	__webpack_require__(443);
	
	__webpack_require__(450);
	
	__webpack_require__(376);
	
	__webpack_require__(372);
	
	__webpack_require__(368);
	
	__webpack_require__(415);
	
	__webpack_require__(430);
	
	__webpack_require__(353);
	
	__webpack_require__(358);
	
	__webpack_require__(365);
	
	__webpack_require__(403);
	
	__webpack_require__(389);
	
	__webpack_require__(419);
	
	__webpack_require__(438);
	
	__webpack_require__(364);
	
	__webpack_require__(491);
	
	__webpack_require__(492);
	
	__webpack_require__(499);
	
	__webpack_require__(533);
	
	__webpack_require__(67);
	
	__webpack_require__(510);
	
	__webpack_require__(489);
	
	__webpack_require__(184);
	
	__webpack_require__(185);
	
	__webpack_require__(470);
	
	__webpack_require__(477);
	
	__webpack_require__(523);
	
	__webpack_require__(479);
	
	__webpack_require__(537);
	
	__webpack_require__(502);
	
	__webpack_require__(501);
	
	__webpack_require__(500);
	
	__webpack_require__(514);
	
	__webpack_require__(524);
	
	__webpack_require__(768);
	
	__webpack_require__(763);

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var echartsAPIList = ['getDom', 'getZr', 'getWidth', 'getHeight', 'getDevicePixelRatio', 'dispatchAction', 'isDisposed', 'on', 'off', 'getDataURL', 'getConnectedDataURL', 'getModel', 'getOption', 'getViewOfComponentModel', 'getViewOfSeriesModel']; // And `getCoordinateSystems` and `getComponentByElement` will be injected in echarts.js
	
	function ExtensionAPI(chartInstance) {
	  zrUtil.each(echartsAPIList, function (name) {
	    this[name] = zrUtil.bind(chartInstance[name], chartInstance);
	  }, this);
	}
	
	var _default = ExtensionAPI;
	module.exports = _default;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var barLayoutGrid = __webpack_require__(128);
	
	__webpack_require__(126);
	
	__webpack_require__(348);
	
	__webpack_require__(349);
	
	__webpack_require__(70);
	
	// In case developer forget to include grid component
	echarts.registerLayout(zrUtil.curry(barLayoutGrid, 'bar')); // Visual coding for legend
	
	echarts.registerVisual(function (ecModel) {
	  ecModel.eachSeriesByType('bar', function (seriesModel) {
	    var data = seriesModel.getData();
	    data.setVisual('legendSymbol', 'roundRect');
	  });
	});

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseBarSeries = __webpack_require__(156);
	
	var _default = BaseBarSeries.extend({
	  type: 'series.bar',
	  dependencies: ['grid', 'polar'],
	  brushSelector: 'rect'
	});
	
	module.exports = _default;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var _helper = __webpack_require__(157);
	
	var setLabel = _helper.setLabel;
	
	var Model = __webpack_require__(14);
	
	var barItemStyle = __webpack_require__(352);
	
	var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'normal', 'barBorderWidth']; // FIXME
	// Just for compatible with ec2.
	
	zrUtil.extend(Model.prototype, barItemStyle);
	
	var _default = echarts.extendChartView({
	  type: 'bar',
	  render: function (seriesModel, ecModel, api) {
	    var coordinateSystemType = seriesModel.get('coordinateSystem');
	
	    if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
	      this._render(seriesModel, ecModel, api);
	    } else {}
	
	    return this.group;
	  },
	  dispose: zrUtil.noop,
	  _render: function (seriesModel, ecModel, api) {
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var coord = seriesModel.coordinateSystem;
	    var baseAxis = coord.getBaseAxis();
	    var isHorizontalOrRadial;
	
	    if (coord.type === 'cartesian2d') {
	      isHorizontalOrRadial = baseAxis.isHorizontal();
	    } else if (coord.type === 'polar') {
	      isHorizontalOrRadial = baseAxis.dim === 'angle';
	    }
	
	    var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
	    data.diff(oldData).add(function (dataIndex) {
	      if (!data.hasValue(dataIndex)) {
	        return;
	      }
	
	      var itemModel = data.getItemModel(dataIndex);
	      var layout = getLayout[coord.type](data, dataIndex, itemModel);
	      var el = elementCreator[coord.type](data, dataIndex, itemModel, layout, isHorizontalOrRadial, animationModel);
	      data.setItemGraphicEl(dataIndex, el);
	      group.add(el);
	      updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
	    }).update(function (newIndex, oldIndex) {
	      var el = oldData.getItemGraphicEl(oldIndex);
	
	      if (!data.hasValue(newIndex)) {
	        group.remove(el);
	        return;
	      }
	
	      var itemModel = data.getItemModel(newIndex);
	      var layout = getLayout[coord.type](data, newIndex, itemModel);
	
	      if (el) {
	        graphic.updateProps(el, {
	          shape: layout
	        }, animationModel, newIndex);
	      } else {
	        el = elementCreator[coord.type](data, newIndex, itemModel, layout, isHorizontalOrRadial, animationModel, true);
	      }
	
	      data.setItemGraphicEl(newIndex, el); // Add back
	
	      group.add(el);
	      updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
	    }).remove(function (dataIndex) {
	      var el = oldData.getItemGraphicEl(dataIndex);
	
	      if (coord.type === 'cartesian2d') {
	        el && removeRect(dataIndex, animationModel, el);
	      } else {
	        el && removeSector(dataIndex, animationModel, el);
	      }
	    }).execute();
	    this._data = data;
	  },
	  remove: function (ecModel, api) {
	    var group = this.group;
	    var data = this._data;
	
	    if (ecModel.get('animation')) {
	      if (data) {
	        data.eachItemGraphicEl(function (el) {
	          if (el.type === 'sector') {
	            removeSector(el.dataIndex, ecModel, el);
	          } else {
	            removeRect(el.dataIndex, ecModel, el);
	          }
	        });
	      }
	    } else {
	      group.removeAll();
	    }
	  }
	});
	
	var elementCreator = {
	  cartesian2d: function (data, dataIndex, itemModel, layout, isHorizontal, animationModel, isUpdate) {
	    var rect = new graphic.Rect({
	      shape: zrUtil.extend({}, layout)
	    }); // Animation
	
	    if (animationModel) {
	      var rectShape = rect.shape;
	      var animateProperty = isHorizontal ? 'height' : 'width';
	      var animateTarget = {};
	      rectShape[animateProperty] = 0;
	      animateTarget[animateProperty] = layout[animateProperty];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](rect, {
	        shape: animateTarget
	      }, animationModel, dataIndex);
	    }
	
	    return rect;
	  },
	  polar: function (data, dataIndex, itemModel, layout, isRadial, animationModel, isUpdate) {
	    var sector = new graphic.Sector({
	      shape: zrUtil.extend({}, layout)
	    }); // Animation
	
	    if (animationModel) {
	      var sectorShape = sector.shape;
	      var animateProperty = isRadial ? 'r' : 'endAngle';
	      var animateTarget = {};
	      sectorShape[animateProperty] = isRadial ? 0 : layout.startAngle;
	      animateTarget[animateProperty] = layout[animateProperty];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](sector, {
	        shape: animateTarget
	      }, animationModel, dataIndex);
	    }
	
	    return sector;
	  }
	};
	
	function removeRect(dataIndex, animationModel, el) {
	  // Not show text when animating
	  el.style.text = null;
	  graphic.updateProps(el, {
	    shape: {
	      width: 0
	    }
	  }, animationModel, dataIndex, function () {
	    el.parent && el.parent.remove(el);
	  });
	}
	
	function removeSector(dataIndex, animationModel, el) {
	  // Not show text when animating
	  el.style.text = null;
	  graphic.updateProps(el, {
	    shape: {
	      r: el.shape.r0
	    }
	  }, animationModel, dataIndex, function () {
	    el.parent && el.parent.remove(el);
	  });
	}
	
	var getLayout = {
	  cartesian2d: function (data, dataIndex, itemModel) {
	    var layout = data.getItemLayout(dataIndex);
	    var fixedLineWidth = getLineWidth(itemModel, layout); // fix layout with lineWidth
	
	    var signX = layout.width > 0 ? 1 : -1;
	    var signY = layout.height > 0 ? 1 : -1;
	    return {
	      x: layout.x + signX * fixedLineWidth / 2,
	      y: layout.y + signY * fixedLineWidth / 2,
	      width: layout.width - signX * fixedLineWidth,
	      height: layout.height - signY * fixedLineWidth
	    };
	  },
	  polar: function (data, dataIndex, itemModel) {
	    var layout = data.getItemLayout(dataIndex);
	    return {
	      cx: layout.cx,
	      cy: layout.cy,
	      r0: layout.r0,
	      r: layout.r,
	      startAngle: layout.startAngle,
	      endAngle: layout.endAngle
	    };
	  }
	};
	
	function updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontal, isPolar) {
	  var color = data.getItemVisual(dataIndex, 'color');
	  var opacity = data.getItemVisual(dataIndex, 'opacity');
	  var itemStyleModel = itemModel.getModel('itemStyle.normal');
	  var hoverStyle = itemModel.getModel('itemStyle.emphasis').getBarItemStyle();
	
	  if (!isPolar) {
	    el.setShape('r', itemStyleModel.get('barBorderRadius') || 0);
	  }
	
	  el.useStyle(zrUtil.defaults({
	    fill: color,
	    opacity: opacity
	  }, itemStyleModel.getBarItemStyle()));
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && el.attr('cursor', cursorStyle);
	  var labelPositionOutside = isHorizontal ? layout.height > 0 ? 'bottom' : 'top' : layout.width > 0 ? 'left' : 'right';
	
	  if (!isPolar) {
	    setLabel(el.style, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside);
	  }
	
	  graphic.setHoverStyle(el, hoverStyle);
	} // In case width or height are too small.
	
	
	function getLineWidth(itemModel, rawLayout) {
	  var lineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0;
	  return Math.min(lineWidth, Math.abs(rawLayout.width), Math.abs(rawLayout.height));
	}
	
	module.exports = _default;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseBarSeries = __webpack_require__(156);
	
	var PictorialBarSeries = BaseBarSeries.extend({
	  type: 'series.pictorialBar',
	  dependencies: ['grid'],
	  defaultOption: {
	    symbol: 'circle',
	    // Customized bar shape
	    symbolSize: null,
	    // Can be ['100%', '100%'], null means auto.
	    symbolRotate: null,
	    symbolPosition: null,
	    // 'start' or 'end' or 'center', null means auto.
	    symbolOffset: null,
	    symbolMargin: null,
	    // start margin and end margin. Can be a number or a percent string.
	    // Auto margin by defualt.
	    symbolRepeat: false,
	    // false/null/undefined, means no repeat.
	    // Can be true, means auto calculate repeat times and cut by data.
	    // Can be a number, specifies repeat times, and do not cut by data.
	    // Can be 'fixed', means auto calculate repeat times but do not cut by data.
	    symbolRepeatDirection: 'end',
	    // 'end' means from 'start' to 'end'.
	    symbolClip: false,
	    symbolBoundingData: null,
	    // Can be 60 or -40 or [-40, 60]
	    symbolPatternSize: 400,
	    // 400 * 400 px
	    barGap: '-100%',
	    // In most case, overlap is needed.
	    // z can be set in data item, which is z2 actually.
	    // Disable progressive
	    progressive: 0,
	    hoverAnimation: false // Open only when needed.
	
	  },
	  getInitialData: function (option) {
	    // Disable stack.
	    option.stack = null;
	    return PictorialBarSeries.superApply(this, 'getInitialData', arguments);
	  }
	});
	var _default = PictorialBarSeries;
	module.exports = _default;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var _symbol = __webpack_require__(22);
	
	var createSymbol = _symbol.createSymbol;
	
	var _number = __webpack_require__(4);
	
	var parsePercent = _number.parsePercent;
	var isNumeric = _number.isNumeric;
	
	var _helper = __webpack_require__(157);
	
	var setLabel = _helper.setLabel;
	var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'normal', 'borderWidth']; // index: +isHorizontal
	
	var LAYOUT_ATTRS = [{
	  xy: 'x',
	  wh: 'width',
	  index: 0,
	  posDesc: ['left', 'right']
	}, {
	  xy: 'y',
	  wh: 'height',
	  index: 1,
	  posDesc: ['top', 'bottom']
	}];
	var pathForLineWidth = new graphic.Circle();
	var BarView = echarts.extendChartView({
	  type: 'pictorialBar',
	  render: function (seriesModel, ecModel, api) {
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var isHorizontal = !!baseAxis.isHorizontal();
	    var coordSysRect = cartesian.grid.getRect();
	    var opt = {
	      ecSize: {
	        width: api.getWidth(),
	        height: api.getHeight()
	      },
	      seriesModel: seriesModel,
	      coordSys: cartesian,
	      coordSysExtent: [[coordSysRect.x, coordSysRect.x + coordSysRect.width], [coordSysRect.y, coordSysRect.y + coordSysRect.height]],
	      isHorizontal: isHorizontal,
	      valueDim: LAYOUT_ATTRS[+isHorizontal],
	      categoryDim: LAYOUT_ATTRS[1 - isHorizontal]
	    };
	    data.diff(oldData).add(function (dataIndex) {
	      if (!data.hasValue(dataIndex)) {
	        return;
	      }
	
	      var itemModel = getItemModel(data, dataIndex);
	      var symbolMeta = getSymbolMeta(data, dataIndex, itemModel, opt);
	      var bar = createBar(data, opt, symbolMeta);
	      data.setItemGraphicEl(dataIndex, bar);
	      group.add(bar);
	      updateCommon(bar, opt, symbolMeta);
	    }).update(function (newIndex, oldIndex) {
	      var bar = oldData.getItemGraphicEl(oldIndex);
	
	      if (!data.hasValue(newIndex)) {
	        group.remove(bar);
	        return;
	      }
	
	      var itemModel = getItemModel(data, newIndex);
	      var symbolMeta = getSymbolMeta(data, newIndex, itemModel, opt);
	      var pictorialShapeStr = getShapeStr(data, symbolMeta);
	
	      if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
	        group.remove(bar);
	        data.setItemGraphicEl(newIndex, null);
	        bar = null;
	      }
	
	      if (bar) {
	        updateBar(bar, opt, symbolMeta);
	      } else {
	        bar = createBar(data, opt, symbolMeta, true);
	      }
	
	      data.setItemGraphicEl(newIndex, bar);
	      bar.__pictorialSymbolMeta = symbolMeta; // Add back
	
	      group.add(bar);
	      updateCommon(bar, opt, symbolMeta);
	    }).remove(function (dataIndex) {
	      var bar = oldData.getItemGraphicEl(dataIndex);
	      bar && removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
	    }).execute();
	    this._data = data;
	    return this.group;
	  },
	  dispose: zrUtil.noop,
	  remove: function (ecModel, api) {
	    var group = this.group;
	    var data = this._data;
	
	    if (ecModel.get('animation')) {
	      if (data) {
	        data.eachItemGraphicEl(function (bar) {
	          removeBar(data, bar.dataIndex, ecModel, bar);
	        });
	      }
	    } else {
	      group.removeAll();
	    }
	  }
	}); // Set or calculate default value about symbol, and calculate layout info.
	
	function getSymbolMeta(data, dataIndex, itemModel, opt) {
	  var layout = data.getItemLayout(dataIndex);
	  var symbolRepeat = itemModel.get('symbolRepeat');
	  var symbolClip = itemModel.get('symbolClip');
	  var symbolPosition = itemModel.get('symbolPosition') || 'start';
	  var symbolRotate = itemModel.get('symbolRotate');
	  var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	  var symbolPatternSize = itemModel.get('symbolPatternSize') || 2;
	  var isAnimationEnabled = itemModel.isAnimationEnabled();
	  var symbolMeta = {
	    dataIndex: dataIndex,
	    layout: layout,
	    itemModel: itemModel,
	    symbolType: data.getItemVisual(dataIndex, 'symbol') || 'circle',
	    color: data.getItemVisual(dataIndex, 'color'),
	    symbolClip: symbolClip,
	    symbolRepeat: symbolRepeat,
	    symbolRepeatDirection: itemModel.get('symbolRepeatDirection'),
	    symbolPatternSize: symbolPatternSize,
	    rotation: rotation,
	    animationModel: isAnimationEnabled ? itemModel : null,
	    hoverAnimation: isAnimationEnabled && itemModel.get('hoverAnimation'),
	    z2: itemModel.getShallow('z', true) || 0
	  };
	  prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
	  prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
	  prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
	  var symbolSize = symbolMeta.symbolSize;
	  var symbolOffset = itemModel.get('symbolOffset');
	
	  if (zrUtil.isArray(symbolOffset)) {
	    symbolOffset = [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])];
	  }
	
	  prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
	  return symbolMeta;
	} // bar length can be negative.
	
	
	function prepareBarLength(itemModel, symbolRepeat, layout, opt, output) {
	  var valueDim = opt.valueDim;
	  var symbolBoundingData = itemModel.get('symbolBoundingData');
	  var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
	  var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
	  var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
	  var boundingLength;
	
	  if (zrUtil.isArray(symbolBoundingData)) {
	    var symbolBoundingExtent = [convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx, convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx];
	    symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
	    boundingLength = symbolBoundingExtent[pxSignIdx];
	  } else if (symbolBoundingData != null) {
	    boundingLength = convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
	  } else if (symbolRepeat) {
	    boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
	  } else {
	    boundingLength = layout[valueDim.wh];
	  }
	
	  output.boundingLength = boundingLength;
	
	  if (symbolRepeat) {
	    output.repeatCutLength = layout[valueDim.wh];
	  }
	
	  output.pxSign = boundingLength > 0 ? 1 : boundingLength < 0 ? -1 : 0;
	}
	
	function convertToCoordOnAxis(axis, value) {
	  return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
	} // Support ['100%', '100%']
	
	
	function prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, output) {
	  var valueDim = opt.valueDim;
	  var categoryDim = opt.categoryDim;
	  var categorySize = Math.abs(layout[categoryDim.wh]);
	  var symbolSize = data.getItemVisual(dataIndex, 'symbolSize');
	
	  if (zrUtil.isArray(symbolSize)) {
	    symbolSize = symbolSize.slice();
	  } else {
	    if (symbolSize == null) {
	      symbolSize = '100%';
	    }
	
	    symbolSize = [symbolSize, symbolSize];
	  } // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
	  // to complicated to calculate real percent value if considering scaled lineWidth.
	  // So the actual size will bigger than layout size if lineWidth is bigger than zero,
	  // which can be tolerated in pictorial chart.
	
	
	  symbolSize[categoryDim.index] = parsePercent(symbolSize[categoryDim.index], categorySize);
	  symbolSize[valueDim.index] = parsePercent(symbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
	  output.symbolSize = symbolSize; // If x or y is less than zero, show reversed shape.
	
	  var symbolScale = output.symbolScale = [symbolSize[0] / symbolPatternSize, symbolSize[1] / symbolPatternSize]; // Follow convention, 'right' and 'top' is the normal scale.
	
	  symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
	}
	
	function prepareLineWidth(itemModel, symbolScale, rotation, opt, output) {
	  // In symbols are drawn with scale, so do not need to care about the case that width
	  // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
	  // be calculated.
	  var valueLineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0;
	
	  if (valueLineWidth) {
	    pathForLineWidth.attr({
	      scale: symbolScale.slice(),
	      rotation: rotation
	    });
	    pathForLineWidth.updateTransform();
	    valueLineWidth /= pathForLineWidth.getLineScale();
	    valueLineWidth *= symbolScale[opt.valueDim.index];
	  }
	
	  output.valueLineWidth = valueLineWidth;
	}
	
	function prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, output) {
	  var categoryDim = opt.categoryDim;
	  var valueDim = opt.valueDim;
	  var pxSign = output.pxSign;
	  var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
	  var pathLen = unitLength; // Note: rotation will not effect the layout of symbols, because user may
	  // want symbols to rotate on its center, which should not be translated
	  // when rotating.
	
	  if (symbolRepeat) {
	    var absBoundingLength = Math.abs(boundingLength);
	    var symbolMargin = zrUtil.retrieve(itemModel.get('symbolMargin'), '15%') + '';
	    var hasEndGap = false;
	
	    if (symbolMargin.lastIndexOf('!') === symbolMargin.length - 1) {
	      hasEndGap = true;
	      symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
	    }
	
	    symbolMargin = parsePercent(symbolMargin, symbolSize[valueDim.index]);
	    var uLenWithMargin = Math.max(unitLength + symbolMargin * 2, 0); // When symbol margin is less than 0, margin at both ends will be subtracted
	    // to ensure that all of the symbols will not be overflow the given area.
	
	    var endFix = hasEndGap ? 0 : symbolMargin * 2; // Both final repeatTimes and final symbolMargin area calculated based on
	    // boundingLength.
	
	    var repeatSpecified = isNumeric(symbolRepeat);
	    var repeatTimes = repeatSpecified ? symbolRepeat : toIntTimes((absBoundingLength + endFix) / uLenWithMargin); // Adjust calculate margin, to ensure each symbol is displayed
	    // entirely in the given layout area.
	
	    var mDiff = absBoundingLength - repeatTimes * unitLength;
	    symbolMargin = mDiff / 2 / (hasEndGap ? repeatTimes : repeatTimes - 1);
	    uLenWithMargin = unitLength + symbolMargin * 2;
	    endFix = hasEndGap ? 0 : symbolMargin * 2; // Update repeatTimes when not all symbol will be shown.
	
	    if (!repeatSpecified && symbolRepeat !== 'fixed') {
	      repeatTimes = repeatCutLength ? toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
	    }
	
	    pathLen = repeatTimes * uLenWithMargin - endFix;
	    output.repeatTimes = repeatTimes;
	    output.symbolMargin = symbolMargin;
	  }
	
	  var sizeFix = pxSign * (pathLen / 2);
	  var pathPosition = output.pathPosition = [];
	  pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
	  pathPosition[valueDim.index] = symbolPosition === 'start' ? sizeFix : symbolPosition === 'end' ? boundingLength - sizeFix : boundingLength / 2; // 'center'
	
	  if (symbolOffset) {
	    pathPosition[0] += symbolOffset[0];
	    pathPosition[1] += symbolOffset[1];
	  }
	
	  var bundlePosition = output.bundlePosition = [];
	  bundlePosition[categoryDim.index] = layout[categoryDim.xy];
	  bundlePosition[valueDim.index] = layout[valueDim.xy];
	  var barRectShape = output.barRectShape = zrUtil.extend({}, layout);
	  barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
	  barRectShape[categoryDim.wh] = layout[categoryDim.wh];
	  var clipShape = output.clipShape = {}; // Consider that symbol may be overflow layout rect.
	
	  clipShape[categoryDim.xy] = -layout[categoryDim.xy];
	  clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
	  clipShape[valueDim.xy] = 0;
	  clipShape[valueDim.wh] = layout[valueDim.wh];
	}
	
	function createPath(symbolMeta) {
	  var symbolPatternSize = symbolMeta.symbolPatternSize;
	  var path = createSymbol( // Consider texture img, make a big size.
	  symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize, symbolMeta.color);
	  path.attr({
	    culling: true
	  });
	  path.type !== 'image' && path.setStyle({
	    strokeNoScale: true
	  });
	  return path;
	}
	
	function createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
	  var bundle = bar.__pictorialBundle;
	  var symbolSize = symbolMeta.symbolSize;
	  var valueLineWidth = symbolMeta.valueLineWidth;
	  var pathPosition = symbolMeta.pathPosition;
	  var valueDim = opt.valueDim;
	  var repeatTimes = symbolMeta.repeatTimes || 0;
	  var index = 0;
	  var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
	  eachPath(bar, function (path) {
	    path.__pictorialAnimationIndex = index;
	    path.__pictorialRepeatTimes = repeatTimes;
	
	    if (index < repeatTimes) {
	      updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
	    } else {
	      updateAttr(path, null, {
	        scale: [0, 0]
	      }, symbolMeta, isUpdate, function () {
	        bundle.remove(path);
	      });
	    }
	
	    updateHoverAnimation(path, symbolMeta);
	    index++;
	  });
	
	  for (; index < repeatTimes; index++) {
	    var path = createPath(symbolMeta);
	    path.__pictorialAnimationIndex = index;
	    path.__pictorialRepeatTimes = repeatTimes;
	    bundle.add(path);
	    var target = makeTarget(index);
	    updateAttr(path, {
	      position: target.position,
	      scale: [0, 0]
	    }, {
	      scale: target.scale,
	      rotation: target.rotation
	    }, symbolMeta, isUpdate); // FIXME
	    // If all emphasis/normal through action.
	
	    path.on('mouseover', onMouseOver).on('mouseout', onMouseOut);
	    updateHoverAnimation(path, symbolMeta);
	  }
	
	  function makeTarget(index) {
	    var position = pathPosition.slice(); // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
	    // Otherwise: i = index;
	
	    var pxSign = symbolMeta.pxSign;
	    var i = index;
	
	    if (symbolMeta.symbolRepeatDirection === 'start' ? pxSign > 0 : pxSign < 0) {
	      i = repeatTimes - 1 - index;
	    }
	
	    position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
	    return {
	      position: position,
	      scale: symbolMeta.symbolScale.slice(),
	      rotation: symbolMeta.rotation
	    };
	  }
	
	  function onMouseOver() {
	    eachPath(bar, function (path) {
	      path.trigger('emphasis');
	    });
	  }
	
	  function onMouseOut() {
	    eachPath(bar, function (path) {
	      path.trigger('normal');
	    });
	  }
	}
	
	function createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
	  var bundle = bar.__pictorialBundle;
	  var mainPath = bar.__pictorialMainPath;
	
	  if (!mainPath) {
	    mainPath = bar.__pictorialMainPath = createPath(symbolMeta);
	    bundle.add(mainPath);
	    updateAttr(mainPath, {
	      position: symbolMeta.pathPosition.slice(),
	      scale: [0, 0],
	      rotation: symbolMeta.rotation
	    }, {
	      scale: symbolMeta.symbolScale.slice()
	    }, symbolMeta, isUpdate);
	    mainPath.on('mouseover', onMouseOver).on('mouseout', onMouseOut);
	  } else {
	    updateAttr(mainPath, null, {
	      position: symbolMeta.pathPosition.slice(),
	      scale: symbolMeta.symbolScale.slice(),
	      rotation: symbolMeta.rotation
	    }, symbolMeta, isUpdate);
	  }
	
	  updateHoverAnimation(mainPath, symbolMeta);
	
	  function onMouseOver() {
	    this.trigger('emphasis');
	  }
	
	  function onMouseOut() {
	    this.trigger('normal');
	  }
	} // bar rect is used for label.
	
	
	function createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
	  var rectShape = zrUtil.extend({}, symbolMeta.barRectShape);
	  var barRect = bar.__pictorialBarRect;
	
	  if (!barRect) {
	    barRect = bar.__pictorialBarRect = new graphic.Rect({
	      z2: 2,
	      shape: rectShape,
	      silent: true,
	      style: {
	        stroke: 'transparent',
	        fill: 'transparent',
	        lineWidth: 0
	      }
	    });
	    bar.add(barRect);
	  } else {
	    updateAttr(barRect, null, {
	      shape: rectShape
	    }, symbolMeta, isUpdate);
	  }
	}
	
	function createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
	  // If not clip, symbol will be remove and rebuilt.
	  if (symbolMeta.symbolClip) {
	    var clipPath = bar.__pictorialClipPath;
	    var clipShape = zrUtil.extend({}, symbolMeta.clipShape);
	    var valueDim = opt.valueDim;
	    var animationModel = symbolMeta.animationModel;
	    var dataIndex = symbolMeta.dataIndex;
	
	    if (clipPath) {
	      graphic.updateProps(clipPath, {
	        shape: clipShape
	      }, animationModel, dataIndex);
	    } else {
	      clipShape[valueDim.wh] = 0;
	      clipPath = new graphic.Rect({
	        shape: clipShape
	      });
	
	      bar.__pictorialBundle.setClipPath(clipPath);
	
	      bar.__pictorialClipPath = clipPath;
	      var target = {};
	      target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](clipPath, {
	        shape: target
	      }, animationModel, dataIndex);
	    }
	  }
	}
	
	function getItemModel(data, dataIndex) {
	  var itemModel = data.getItemModel(dataIndex);
	  itemModel.getAnimationDelayParams = getAnimationDelayParams;
	  itemModel.isAnimationEnabled = isAnimationEnabled;
	  return itemModel;
	}
	
	function getAnimationDelayParams(path) {
	  // The order is the same as the z-order, see `symbolRepeatDiretion`.
	  return {
	    index: path.__pictorialAnimationIndex,
	    count: path.__pictorialRepeatTimes
	  };
	}
	
	function isAnimationEnabled() {
	  // `animation` prop can be set on itemModel in pictorial bar chart.
	  return this.parentModel.isAnimationEnabled() && !!this.getShallow('animation');
	}
	
	function updateHoverAnimation(path, symbolMeta) {
	  path.off('emphasis').off('normal');
	  var scale = symbolMeta.symbolScale.slice();
	  symbolMeta.hoverAnimation && path.on('emphasis', function () {
	    this.animateTo({
	      scale: [scale[0] * 1.1, scale[1] * 1.1]
	    }, 400, 'elasticOut');
	  }).on('normal', function () {
	    this.animateTo({
	      scale: scale.slice()
	    }, 400, 'elasticOut');
	  });
	}
	
	function createBar(data, opt, symbolMeta, isUpdate) {
	  // bar is the main element for each data.
	  var bar = new graphic.Group(); // bundle is used for location and clip.
	
	  var bundle = new graphic.Group();
	  bar.add(bundle);
	  bar.__pictorialBundle = bundle;
	  bundle.attr('position', symbolMeta.bundlePosition.slice());
	
	  if (symbolMeta.symbolRepeat) {
	    createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
	  } else {
	    createOrUpdateSingleSymbol(bar, opt, symbolMeta);
	  }
	
	  createOrUpdateBarRect(bar, symbolMeta, isUpdate);
	  createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
	  bar.__pictorialShapeStr = getShapeStr(data, symbolMeta);
	  bar.__pictorialSymbolMeta = symbolMeta;
	  return bar;
	}
	
	function updateBar(bar, opt, symbolMeta) {
	  var animationModel = symbolMeta.animationModel;
	  var dataIndex = symbolMeta.dataIndex;
	  var bundle = bar.__pictorialBundle;
	  graphic.updateProps(bundle, {
	    position: symbolMeta.bundlePosition.slice()
	  }, animationModel, dataIndex);
	
	  if (symbolMeta.symbolRepeat) {
	    createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
	  } else {
	    createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
	  }
	
	  createOrUpdateBarRect(bar, symbolMeta, true);
	  createOrUpdateClip(bar, opt, symbolMeta, true);
	}
	
	function removeBar(data, dataIndex, animationModel, bar) {
	  // Not show text when animating
	  var labelRect = bar.__pictorialBarRect;
	  labelRect && (labelRect.style.text = null);
	  var pathes = [];
	  eachPath(bar, function (path) {
	    pathes.push(path);
	  });
	  bar.__pictorialMainPath && pathes.push(bar.__pictorialMainPath); // I do not find proper remove animation for clip yet.
	
	  bar.__pictorialClipPath && (animationModel = null);
	  zrUtil.each(pathes, function (path) {
	    graphic.updateProps(path, {
	      scale: [0, 0]
	    }, animationModel, dataIndex, function () {
	      bar.parent && bar.parent.remove(bar);
	    });
	  });
	  data.setItemGraphicEl(dataIndex, null);
	}
	
	function getShapeStr(data, symbolMeta) {
	  return [data.getItemVisual(symbolMeta.dataIndex, 'symbol') || 'none', !!symbolMeta.symbolRepeat, !!symbolMeta.symbolClip].join(':');
	}
	
	function eachPath(bar, cb, context) {
	  // Do not use Group#eachChild, because it do not support remove.
	  zrUtil.each(bar.__pictorialBundle.children(), function (el) {
	    el !== bar.__pictorialBarRect && cb.call(context, el);
	  });
	}
	
	function updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
	  immediateAttrs && el.attr(immediateAttrs); // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.
	
	  if (symbolMeta.symbolClip && !isUpdate) {
	    animationAttrs && el.attr(animationAttrs);
	  } else {
	    animationAttrs && graphic[isUpdate ? 'updateProps' : 'initProps'](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
	  }
	}
	
	function updateCommon(bar, opt, symbolMeta) {
	  var color = symbolMeta.color;
	  var dataIndex = symbolMeta.dataIndex;
	  var itemModel = symbolMeta.itemModel; // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var normalStyle = itemModel.getModel('itemStyle.normal').getItemStyle(['color']);
	  var hoverStyle = itemModel.getModel('itemStyle.emphasis').getItemStyle();
	  var cursorStyle = itemModel.getShallow('cursor');
	  eachPath(bar, function (path) {
	    // PENDING setColor should be before setStyle!!!
	    path.setColor(color);
	    path.setStyle(zrUtil.defaults({
	      fill: color,
	      opacity: symbolMeta.opacity
	    }, normalStyle));
	    graphic.setHoverStyle(path, hoverStyle);
	    cursorStyle && (path.cursor = cursorStyle);
	    path.z2 = symbolMeta.z2;
	  });
	  var barRectHoverStyle = {};
	  var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
	  var barRect = bar.__pictorialBarRect;
	  setLabel(barRect.style, barRectHoverStyle, itemModel, color, opt.seriesModel, dataIndex, barPositionOutside);
	  graphic.setHoverStyle(barRect, barRectHoverStyle);
	}
	
	function toIntTimes(times) {
	  var roundedTimes = Math.round(times); // Escapse accurate error
	
	  return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
	}
	
	var _default = BarView;
	module.exports = _default;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var makeStyleMapper = __webpack_require__(58);
	
	var getBarItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], // Compatitable with 2
	['stroke', 'barBorderColor'], ['lineWidth', 'barBorderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	var _default = {
	  getBarItemStyle: function (excludes) {
	    var style = getBarItemStyle(this, excludes);
	
	    if (this.getBorderLineDash) {
	      var lineDash = this.getBorderLineDash();
	      lineDash && (style.lineDash = lineDash);
	    }
	
	    return style;
	  }
	};
	module.exports = _default;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	__webpack_require__(354);
	
	__webpack_require__(355);
	
	var boxplotVisual = __webpack_require__(357);
	
	var boxplotLayout = __webpack_require__(356);
	
	echarts.registerVisual(boxplotVisual);
	echarts.registerLayout(boxplotLayout);

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var SeriesModel = __webpack_require__(20);
	
	var _whiskerBoxCommon = __webpack_require__(84);
	
	var seriesModelMixin = _whiskerBoxCommon.seriesModelMixin;
	var BoxplotSeries = SeriesModel.extend({
	  type: 'series.boxplot',
	  dependencies: ['xAxis', 'yAxis', 'grid'],
	  // TODO
	  // box width represents group size, so dimension should have 'size'.
	
	  /**
	   * @see <https://en.wikipedia.org/wiki/Box_plot>
	   * The meanings of 'min' and 'max' depend on user,
	   * and echarts do not need to know it.
	   * @readOnly
	   */
	  defaultValueDimensions: ['min', 'Q1', 'median', 'Q3', 'max'],
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * @override
	   */
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    layout: null,
	    // 'horizontal' or 'vertical'
	    boxWidth: [7, 50],
	    // [min, max] can be percent of band width.
	    itemStyle: {
	      normal: {
	        color: '#fff',
	        borderWidth: 1
	      },
	      emphasis: {
	        borderWidth: 2,
	        shadowBlur: 5,
	        shadowOffsetX: 2,
	        shadowOffsetY: 2,
	        shadowColor: 'rgba(0,0,0,0.4)'
	      }
	    },
	    animationEasing: 'elasticOut',
	    animationDuration: 800
	  }
	});
	zrUtil.mixin(BoxplotSeries, seriesModelMixin, true);
	var _default = BoxplotSeries;
	module.exports = _default;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var ChartView = __webpack_require__(37);
	
	var graphic = __webpack_require__(3);
	
	var _whiskerBoxCommon = __webpack_require__(84);
	
	var viewMixin = _whiskerBoxCommon.viewMixin;
	var BoxplotView = ChartView.extend({
	  type: 'boxplot',
	  getStyleUpdater: function () {
	    return updateStyle;
	  },
	  dispose: zrUtil.noop
	});
	zrUtil.mixin(BoxplotView, viewMixin, true); // Update common properties
	
	var normalStyleAccessPath = ['itemStyle', 'normal'];
	var emphasisStyleAccessPath = ['itemStyle', 'emphasis'];
	
	function updateStyle(itemGroup, data, idx) {
	  var itemModel = data.getItemModel(idx);
	  var normalItemStyleModel = itemModel.getModel(normalStyleAccessPath);
	  var borderColor = data.getItemVisual(idx, 'color'); // Exclude borderColor.
	
	  var itemStyle = normalItemStyleModel.getItemStyle(['borderColor']);
	  var whiskerEl = itemGroup.childAt(itemGroup.whiskerIndex);
	  whiskerEl.style.set(itemStyle);
	  whiskerEl.style.stroke = borderColor;
	  whiskerEl.dirty();
	  var bodyEl = itemGroup.childAt(itemGroup.bodyIndex);
	  bodyEl.style.set(itemStyle);
	  bodyEl.style.stroke = borderColor;
	  bodyEl.dirty();
	  var hoverStyle = itemModel.getModel(emphasisStyleAccessPath).getItemStyle();
	  graphic.setHoverStyle(itemGroup, hoverStyle);
	}
	
	var _default = BoxplotView;
	module.exports = _default;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var _number = __webpack_require__(4);
	
	var parsePercent = _number.parsePercent;
	var each = zrUtil.each;
	
	function _default(ecModel) {
	  var groupResult = groupSeriesByAxis(ecModel);
	  each(groupResult, function (groupItem) {
	    var seriesModels = groupItem.seriesModels;
	
	    if (!seriesModels.length) {
	      return;
	    }
	
	    calculateBase(groupItem);
	    each(seriesModels, function (seriesModel, idx) {
	      layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
	    });
	  });
	}
	/**
	 * Group series by axis.
	 */
	
	
	function groupSeriesByAxis(ecModel) {
	  var result = [];
	  var axisList = [];
	  ecModel.eachSeriesByType('boxplot', function (seriesModel) {
	    var baseAxis = seriesModel.getBaseAxis();
	    var idx = zrUtil.indexOf(axisList, baseAxis);
	
	    if (idx < 0) {
	      idx = axisList.length;
	      axisList[idx] = baseAxis;
	      result[idx] = {
	        axis: baseAxis,
	        seriesModels: []
	      };
	    }
	
	    result[idx].seriesModels.push(seriesModel);
	  });
	  return result;
	}
	/**
	 * Calculate offset and box width for each series.
	 */
	
	
	function calculateBase(groupItem) {
	  var extent;
	  var baseAxis = groupItem.axis;
	  var seriesModels = groupItem.seriesModels;
	  var seriesCount = seriesModels.length;
	  var boxWidthList = groupItem.boxWidthList = [];
	  var boxOffsetList = groupItem.boxOffsetList = [];
	  var boundList = [];
	  var bandWidth;
	
	  if (baseAxis.type === 'category') {
	    bandWidth = baseAxis.getBandWidth();
	  } else {
	    var maxDataCount = 0;
	    each(seriesModels, function (seriesModel) {
	      maxDataCount = Math.max(maxDataCount, seriesModel.getData().count());
	    });
	    extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / maxDataCount;
	  }
	
	  each(seriesModels, function (seriesModel) {
	    var boxWidthBound = seriesModel.get('boxWidth');
	
	    if (!zrUtil.isArray(boxWidthBound)) {
	      boxWidthBound = [boxWidthBound, boxWidthBound];
	    }
	
	    boundList.push([parsePercent(boxWidthBound[0], bandWidth) || 0, parsePercent(boxWidthBound[1], bandWidth) || 0]);
	  });
	  var availableWidth = bandWidth * 0.8 - 2;
	  var boxGap = availableWidth / seriesCount * 0.3;
	  var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
	  var base = boxWidth / 2 - availableWidth / 2;
	  each(seriesModels, function (seriesModel, idx) {
	    boxOffsetList.push(base);
	    base += boxGap + boxWidth;
	    boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
	  });
	}
	/**
	 * Calculate points location for each series.
	 */
	
	
	function layoutSingleSeries(seriesModel, offset, boxWidth) {
	  var coordSys = seriesModel.coordinateSystem;
	  var data = seriesModel.getData();
	  var halfWidth = boxWidth / 2;
	  var chartLayout = seriesModel.get('layout');
	  var variableDim = chartLayout === 'horizontal' ? 0 : 1;
	  var constDim = 1 - variableDim;
	  var coordDims = ['x', 'y'];
	  var vDims = [];
	  var cDim;
	  zrUtil.each(data.dimensions, function (dimName) {
	    var dimInfo = data.getDimensionInfo(dimName);
	    var coordDim = dimInfo.coordDim;
	
	    if (coordDim === coordDims[constDim]) {
	      vDims.push(dimName);
	    } else if (coordDim === coordDims[variableDim]) {
	      cDim = dimName;
	    }
	  });
	
	  if (cDim == null || vDims.length < 5) {
	    return;
	  }
	
	  data.each([cDim].concat(vDims), function () {
	    var args = arguments;
	    var axisDimVal = args[0];
	    var idx = args[vDims.length + 1];
	    var median = getPoint(args[3]);
	    var end1 = getPoint(args[1]);
	    var end5 = getPoint(args[5]);
	    var whiskerEnds = [[end1, getPoint(args[2])], [end5, getPoint(args[4])]];
	    layEndLine(end1);
	    layEndLine(end5);
	    layEndLine(median);
	    var bodyEnds = [];
	    addBodyEnd(whiskerEnds[0][1], 0);
	    addBodyEnd(whiskerEnds[1][1], 1);
	    data.setItemLayout(idx, {
	      chartLayout: chartLayout,
	      initBaseline: median[constDim],
	      median: median,
	      bodyEnds: bodyEnds,
	      whiskerEnds: whiskerEnds
	    });
	
	    function getPoint(val) {
	      var p = [];
	      p[variableDim] = axisDimVal;
	      p[constDim] = val;
	      var point;
	
	      if (isNaN(axisDimVal) || isNaN(val)) {
	        point = [NaN, NaN];
	      } else {
	        point = coordSys.dataToPoint(p);
	        point[variableDim] += offset;
	      }
	
	      return point;
	    }
	
	    function addBodyEnd(point, start) {
	      var point1 = point.slice();
	      var point2 = point.slice();
	      point1[variableDim] += halfWidth;
	      point2[variableDim] -= halfWidth;
	      start ? bodyEnds.push(point1, point2) : bodyEnds.push(point2, point1);
	    }
	
	    function layEndLine(endCenter) {
	      var line = [endCenter.slice(), endCenter.slice()];
	      line[0][variableDim] -= halfWidth;
	      line[1][variableDim] += halfWidth;
	      whiskerEnds.push(line);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	var borderColorQuery = ['itemStyle', 'normal', 'borderColor'];
	
	function _default(ecModel, api) {
	  var globalColors = ecModel.get('color');
	  ecModel.eachRawSeriesByType('boxplot', function (seriesModel) {
	    var defaulColor = globalColors[seriesModel.seriesIndex % globalColors.length];
	    var data = seriesModel.getData();
	    data.setVisual({
	      legendSymbol: 'roundRect',
	      // Use name 'color' but not 'borderColor' for legend usage and
	      // visual coding from other component like dataRange.
	      color: seriesModel.get(borderColorQuery) || defaulColor
	    }); // Only visible series has each data be visual encoded
	
	    if (!ecModel.isSeriesFiltered(seriesModel)) {
	      data.each(function (idx) {
	        var itemModel = data.getItemModel(idx);
	        data.setItemVisual(idx, {
	          color: itemModel.get(borderColorQuery, true)
	        });
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	__webpack_require__(359);
	
	__webpack_require__(360);
	
	var preprocessor = __webpack_require__(363);
	
	var candlestickVisual = __webpack_require__(362);
	
	var candlestickLayout = __webpack_require__(361);
	
	echarts.registerPreprocessor(preprocessor);
	echarts.registerVisual(candlestickVisual);
	echarts.registerLayout(candlestickLayout);

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var SeriesModel = __webpack_require__(20);
	
	var _whiskerBoxCommon = __webpack_require__(84);
	
	var seriesModelMixin = _whiskerBoxCommon.seriesModelMixin;
	var CandlestickSeries = SeriesModel.extend({
	  type: 'series.candlestick',
	  dependencies: ['xAxis', 'yAxis', 'grid'],
	
	  /**
	   * @readOnly
	   */
	  defaultValueDimensions: ['open', 'close', 'lowest', 'highest'],
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * @override
	   */
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    layout: null,
	    // 'horizontal' or 'vertical'
	    itemStyle: {
	      normal: {
	        color: '#c23531',
	        // 阳线 positive
	        color0: '#314656',
	        // 阴线 negative     '#c23531', '#314656'
	        borderWidth: 1,
	        // FIXME
	        // ec2中使用的是lineStyle.color 和 lineStyle.color0
	        borderColor: '#c23531',
	        borderColor0: '#314656'
	      },
	      emphasis: {
	        borderWidth: 2
	      }
	    },
	    barMaxWidth: null,
	    barMinWidth: null,
	    barWidth: null,
	    animationUpdate: false,
	    animationEasing: 'linear',
	    animationDuration: 300
	  },
	
	  /**
	   * Get dimension for shadow in dataZoom
	   * @return {string} dimension name
	   */
	  getShadowDim: function () {
	    return 'open';
	  },
	  brushSelector: function (dataIndex, data, selectors) {
	    var itemLayout = data.getItemLayout(dataIndex);
	    return selectors.rect(itemLayout.brushRect);
	  }
	});
	zrUtil.mixin(CandlestickSeries, seriesModelMixin, true);
	var _default = CandlestickSeries;
	module.exports = _default;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var ChartView = __webpack_require__(37);
	
	var graphic = __webpack_require__(3);
	
	var _whiskerBoxCommon = __webpack_require__(84);
	
	var viewMixin = _whiskerBoxCommon.viewMixin;
	var CandlestickView = ChartView.extend({
	  type: 'candlestick',
	  getStyleUpdater: function () {
	    return updateStyle;
	  },
	  dispose: zrUtil.noop
	});
	zrUtil.mixin(CandlestickView, viewMixin, true); // Update common properties
	
	var normalStyleAccessPath = ['itemStyle', 'normal'];
	var emphasisStyleAccessPath = ['itemStyle', 'emphasis'];
	
	function updateStyle(itemGroup, data, idx) {
	  var itemModel = data.getItemModel(idx);
	  var normalItemStyleModel = itemModel.getModel(normalStyleAccessPath);
	  var color = data.getItemVisual(idx, 'color');
	  var borderColor = data.getItemVisual(idx, 'borderColor') || color; // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var itemStyle = normalItemStyleModel.getItemStyle(['color', 'color0', 'borderColor', 'borderColor0']);
	  var whiskerEl = itemGroup.childAt(itemGroup.whiskerIndex);
	  whiskerEl.useStyle(itemStyle);
	  whiskerEl.style.stroke = borderColor;
	  var bodyEl = itemGroup.childAt(itemGroup.bodyIndex);
	  bodyEl.useStyle(itemStyle);
	  bodyEl.style.fill = color;
	  bodyEl.style.stroke = borderColor;
	  var hoverStyle = itemModel.getModel(emphasisStyleAccessPath).getItemStyle();
	  graphic.setHoverStyle(itemGroup, hoverStyle);
	}
	
	var _default = CandlestickView;
	module.exports = _default;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var _number = __webpack_require__(4);
	
	var parsePercent = _number.parsePercent;
	
	var _graphic = __webpack_require__(3);
	
	var subPixelOptimize = _graphic.subPixelOptimize;
	var retrieve2 = zrUtil.retrieve2;
	
	function _default(ecModel) {
	  ecModel.eachSeriesByType('candlestick', function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var data = seriesModel.getData();
	    var candleWidth = calculateCandleWidth(seriesModel, data);
	    var chartLayout = seriesModel.get('layout');
	    var variableDim = chartLayout === 'horizontal' ? 0 : 1;
	    var constDim = 1 - variableDim;
	    var coordDims = ['x', 'y'];
	    var vDims = [];
	    var cDim;
	    zrUtil.each(data.dimensions, function (dimName) {
	      var dimInfo = data.getDimensionInfo(dimName);
	      var coordDim = dimInfo.coordDim;
	
	      if (coordDim === coordDims[constDim]) {
	        vDims.push(dimName);
	      } else if (coordDim === coordDims[variableDim]) {
	        cDim = dimName;
	      }
	    });
	
	    if (cDim == null || vDims.length < 4) {
	      return;
	    }
	
	    var dataIndex = 0;
	    data.each([cDim].concat(vDims), function () {
	      var args = arguments;
	      var axisDimVal = args[0];
	      var idx = args[vDims.length + 1];
	      var openVal = args[1];
	      var closeVal = args[2];
	      var lowestVal = args[3];
	      var highestVal = args[4];
	      var ocLow = Math.min(openVal, closeVal);
	      var ocHigh = Math.max(openVal, closeVal);
	      var ocLowPoint = getPoint(ocLow);
	      var ocHighPoint = getPoint(ocHigh);
	      var lowestPoint = getPoint(lowestVal);
	      var highestPoint = getPoint(highestVal);
	      var whiskerEnds = [[subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint)], [subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint)]];
	      var bodyEnds = [];
	      addBodyEnd(ocHighPoint, 0);
	      addBodyEnd(ocLowPoint, 1);
	      var sign;
	
	      if (openVal > closeVal) {
	        sign = -1;
	      } else if (openVal < closeVal) {
	        sign = 1;
	      } else {
	        // If close === open, compare with close of last record
	        if (dataIndex > 0) {
	          sign = data.getItemModel(dataIndex - 1).get()[2] <= closeVal ? 1 : -1;
	        } else {
	          // No record of previous, set to be positive
	          sign = 1;
	        }
	      }
	
	      data.setItemLayout(idx, {
	        chartLayout: chartLayout,
	        sign: sign,
	        initBaseline: openVal > closeVal ? ocHighPoint[constDim] : ocLowPoint[constDim],
	        // open point.
	        bodyEnds: bodyEnds,
	        whiskerEnds: whiskerEnds,
	        brushRect: makeBrushRect()
	      });
	      ++dataIndex;
	
	      function getPoint(val) {
	        var p = [];
	        p[variableDim] = axisDimVal;
	        p[constDim] = val;
	        return isNaN(axisDimVal) || isNaN(val) ? [NaN, NaN] : coordSys.dataToPoint(p);
	      }
	
	      function addBodyEnd(point, start) {
	        var point1 = point.slice();
	        var point2 = point.slice();
	        point1[variableDim] = subPixelOptimize(point1[variableDim] + candleWidth / 2, 1, false);
	        point2[variableDim] = subPixelOptimize(point2[variableDim] - candleWidth / 2, 1, true);
	        start ? bodyEnds.push(point1, point2) : bodyEnds.push(point2, point1);
	      }
	
	      function makeBrushRect() {
	        var pmin = getPoint(Math.min(openVal, closeVal, lowestVal, highestVal));
	        var pmax = getPoint(Math.max(openVal, closeVal, lowestVal, highestVal));
	        pmin[variableDim] -= candleWidth / 2;
	        pmax[variableDim] -= candleWidth / 2;
	        return {
	          x: pmin[0],
	          y: pmin[1],
	          width: constDim ? candleWidth : pmax[0] - pmin[0],
	          height: constDim ? pmax[1] - pmin[1] : candleWidth
	        };
	      }
	
	      function subPixelOptimizePoint(point) {
	        point[variableDim] = subPixelOptimize(point[variableDim], 1);
	        return point;
	      }
	    }, true);
	  });
	}
	
	function calculateCandleWidth(seriesModel, data) {
	  var baseAxis = seriesModel.getBaseAxis();
	  var extent;
	  var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
	  var barMaxWidth = parsePercent(retrieve2(seriesModel.get('barMaxWidth'), bandWidth), bandWidth);
	  var barMinWidth = parsePercent(retrieve2(seriesModel.get('barMinWidth'), 1), bandWidth);
	  var barWidth = seriesModel.get('barWidth');
	  return barWidth != null ? parsePercent(barWidth, bandWidth) // Put max outer to ensure bar visible in spite of overlap.
	  : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
	}
	
	module.exports = _default;

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	var positiveBorderColorQuery = ['itemStyle', 'normal', 'borderColor'];
	var negativeBorderColorQuery = ['itemStyle', 'normal', 'borderColor0'];
	var positiveColorQuery = ['itemStyle', 'normal', 'color'];
	var negativeColorQuery = ['itemStyle', 'normal', 'color0'];
	
	function _default(ecModel, api) {
	  ecModel.eachRawSeriesByType('candlestick', function (seriesModel) {
	    var data = seriesModel.getData();
	    data.setVisual({
	      legendSymbol: 'roundRect'
	    }); // Only visible series has each data be visual encoded
	
	    if (!ecModel.isSeriesFiltered(seriesModel)) {
	      data.each(function (idx) {
	        var itemModel = data.getItemModel(idx);
	        var sign = data.getItemLayout(idx).sign;
	        data.setItemVisual(idx, {
	          color: itemModel.get(sign > 0 ? positiveColorQuery : negativeColorQuery),
	          borderColor: itemModel.get(sign > 0 ? positiveBorderColorQuery : negativeBorderColorQuery)
	        });
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	function _default(option) {
	  if (!option || !zrUtil.isArray(option.series)) {
	    return;
	  } // Translate 'k' to 'candlestick'.
	
	
	  zrUtil.each(option.series, function (seriesItem) {
	    if (zrUtil.isObject(seriesItem) && seriesItem.type === 'k') {
	      seriesItem.type = 'candlestick';
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var graphicUtil = __webpack_require__(3);
	
	var _labelHelper = __webpack_require__(163);
	
	var findLabelValueDim = _labelHelper.findLabelValueDim;
	
	var createListFromArray = __webpack_require__(34);
	
	var barGrid = __webpack_require__(128);
	
	var DataDiffer = __webpack_require__(56);
	
	var prepareCartesian2d = __webpack_require__(551);
	
	var prepareGeo = __webpack_require__(558);
	
	var prepareSingleAxis = __webpack_require__(576);
	
	var preparePolar = __webpack_require__(569);
	
	var prepareCalendar = __webpack_require__(546);
	
	var ITEM_STYLE_NORMAL_PATH = ['itemStyle', 'normal'];
	var ITEM_STYLE_EMPHASIS_PATH = ['itemStyle', 'emphasis'];
	var LABEL_NORMAL = ['label', 'normal'];
	var LABEL_EMPHASIS = ['label', 'emphasis']; // Use prefix to avoid index to be the same as el.name,
	// which will cause weird udpate animation.
	
	var GROUP_DIFF_PREFIX = 'e\0\0';
	/**
	 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
	 * of each coordinate systems are not required by each coordinate systems directly, but
	 * required by the module `custom`.
	 *
	 * prepareInfoForCustomSeries {Function}: optional
	 *     @return {Object} {coordSys: {...}, api: {
	 *         coord: function (data, clamp) {}, // return point in global.
	 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
	 *     }}
	 */
	
	var prepareCustoms = {
	  cartesian2d: prepareCartesian2d,
	  geo: prepareGeo,
	  singleAxis: prepareSingleAxis,
	  polar: preparePolar,
	  calendar: prepareCalendar
	}; // ------
	// Model
	// ------
	
	echarts.extendSeriesModel({
	  type: 'series.custom',
	  dependencies: ['grid', 'polar', 'geo', 'singleAxis', 'calendar'],
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    // Can be set as 'none'
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // label: {}
	    // itemStyle: {}
	
	  },
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(option.data, this, ecModel);
	  }
	}); // -----
	// View
	// -----
	
	echarts.extendChartView({
	  type: 'custom',
	
	  /**
	   * @private
	   * @type {module:echarts/data/List}
	   */
	  _data: null,
	
	  /**
	   * @override
	   */
	  render: function (customSeries, ecModel, api) {
	    var oldData = this._data;
	    var data = customSeries.getData();
	    var group = this.group;
	    var renderItem = makeRenderItem(customSeries, data, ecModel, api);
	    data.diff(oldData).add(function (newIdx) {
	      data.hasValue(newIdx) && createOrUpdate(null, newIdx, renderItem(newIdx), customSeries, group, data);
	    }).update(function (newIdx, oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      data.hasValue(newIdx) ? createOrUpdate(el, newIdx, renderItem(newIdx), customSeries, group, data) : el && group.remove(el);
	    }).remove(function (oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      el && group.remove(el);
	    }).execute();
	    this._data = data;
	  },
	
	  /**
	   * @override
	   */
	  dispose: zrUtil.noop
	});
	
	function createEl(elOption) {
	  var graphicType = elOption.type;
	  var el;
	
	  if (graphicType === 'path') {
	    var shape = elOption.shape;
	    el = graphicUtil.makePath(shape.pathData, null, {
	      x: shape.x || 0,
	      y: shape.y || 0,
	      width: shape.width || 0,
	      height: shape.height || 0
	    }, 'center');
	    el.__customPathData = elOption.pathData;
	  } else if (graphicType === 'image') {
	    el = new graphicUtil.Image({});
	    el.__customImagePath = elOption.style.image;
	  } else if (graphicType === 'text') {
	    el = new graphicUtil.Text({});
	    el.__customText = elOption.style.text;
	  } else {
	    var Clz = graphicUtil[graphicType.charAt(0).toUpperCase() + graphicType.slice(1)];
	    el = new Clz();
	  }
	
	  el.__customGraphicType = graphicType;
	  el.name = elOption.name;
	  return el;
	}
	
	function updateEl(el, dataIndex, elOption, animatableModel, data, isInit) {
	  var targetProps = {};
	  var elOptionStyle = elOption.style || {};
	  elOption.shape && (targetProps.shape = zrUtil.clone(elOption.shape));
	  elOption.position && (targetProps.position = elOption.position.slice());
	  elOption.scale && (targetProps.scale = elOption.scale.slice());
	  elOption.origin && (targetProps.origin = elOption.origin.slice());
	  elOption.rotation && (targetProps.rotation = elOption.rotation);
	
	  if (el.type === 'image' && elOption.style) {
	    var targetStyle = targetProps.style = {};
	    zrUtil.each(['x', 'y', 'width', 'height'], function (prop) {
	      prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
	    });
	  }
	
	  if (el.type === 'text' && elOption.style) {
	    var targetStyle = targetProps.style = {};
	    zrUtil.each(['x', 'y'], function (prop) {
	      prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
	    }); // Compatible with previous: both support
	    // textFill and fill, textStroke and stroke in 'text' element.
	
	    !elOptionStyle.hasOwnProperty('textFill') && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
	    !elOptionStyle.hasOwnProperty('textStroke') && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
	  }
	
	  if (el.type !== 'group') {
	    el.useStyle(elOptionStyle); // Init animation.
	
	    if (isInit) {
	      el.style.opacity = 0;
	      var targetOpacity = elOptionStyle.opacity;
	      targetOpacity == null && (targetOpacity = 1);
	      graphicUtil.initProps(el, {
	        style: {
	          opacity: targetOpacity
	        }
	      }, animatableModel, dataIndex);
	    }
	  }
	
	  if (isInit) {
	    el.attr(targetProps);
	  } else {
	    graphicUtil.updateProps(el, targetProps, animatableModel, dataIndex);
	  } // z2 must not be null/undefined, otherwise sort error may occur.
	
	
	  el.attr({
	    z2: elOption.z2 || 0,
	    silent: elOption.silent
	  });
	  elOption.styleEmphasis !== false && graphicUtil.setHoverStyle(el, elOption.styleEmphasis);
	}
	
	function prepareStyleTransition(prop, targetStyle, elOptionStyle, oldElStyle, isInit) {
	  if (elOptionStyle[prop] != null && !isInit) {
	    targetStyle[prop] = elOptionStyle[prop];
	    elOptionStyle[prop] = oldElStyle[prop];
	  }
	}
	
	function makeRenderItem(customSeries, data, ecModel, api) {
	  var renderItem = customSeries.get('renderItem');
	  var coordSys = customSeries.coordinateSystem;
	  var prepareResult = {};
	
	  if (coordSys) {
	    prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms() : prepareCustoms[coordSys.type](coordSys);
	  }
	
	  var userAPI = zrUtil.defaults({
	    getWidth: api.getWidth,
	    getHeight: api.getHeight,
	    getZr: api.getZr,
	    getDevicePixelRatio: api.getDevicePixelRatio,
	    value: value,
	    style: style,
	    styleEmphasis: styleEmphasis,
	    visual: visual,
	    barLayout: barLayout,
	    currentSeriesIndices: currentSeriesIndices,
	    font: font
	  }, prepareResult.api || {});
	  var userParams = {
	    context: {},
	    seriesId: customSeries.id,
	    seriesName: customSeries.name,
	    seriesIndex: customSeries.seriesIndex,
	    coordSys: prepareResult.coordSys,
	    dataInsideLength: data.count(),
	    encode: wrapEncodeDef(customSeries.getData())
	  }; // Do not support call `api` asynchronously without dataIndexInside input.
	
	  var currDataIndexInside;
	  var currDirty = true;
	  var currItemModel;
	  var currLabelNormalModel;
	  var currLabelEmphasisModel;
	  var currLabelValueDim;
	  var currVisualColor;
	  return function (dataIndexInside) {
	    currDataIndexInside = dataIndexInside;
	    currDirty = true;
	    return renderItem && renderItem(zrUtil.defaults({
	      dataIndexInside: dataIndexInside,
	      dataIndex: data.getRawIndex(dataIndexInside)
	    }, userParams), userAPI) || {};
	  }; // Do not update cache until api called.
	
	  function updateCache(dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	
	    if (currDirty) {
	      currItemModel = data.getItemModel(dataIndexInside);
	      currLabelNormalModel = currItemModel.getModel(LABEL_NORMAL);
	      currLabelEmphasisModel = currItemModel.getModel(LABEL_EMPHASIS);
	      currLabelValueDim = findLabelValueDim(data);
	      currVisualColor = data.getItemVisual(dataIndexInside, 'color');
	      currDirty = false;
	    }
	  }
	  /**
	   * @public
	   * @param {number|string} dim
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   * @return {number|string} value
	   */
	
	
	  function value(dim, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    return data.get(data.getDimension(dim || 0), dataIndexInside);
	  }
	  /**
	   * By default, `visual` is applied to style (to support visualMap).
	   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
	   * it can be implemented as:
	   * `api.style({stroke: api.visual('color'), fill: null})`;
	   * @public
	   * @param {Object} [extra]
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function style(extra, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    updateCache(dataIndexInside);
	    var itemStyle = currItemModel.getModel(ITEM_STYLE_NORMAL_PATH).getItemStyle();
	    currVisualColor != null && (itemStyle.fill = currVisualColor);
	    var opacity = data.getItemVisual(dataIndexInside, 'opacity');
	    opacity != null && (itemStyle.opacity = opacity);
	
	    if (currLabelValueDim != null) {
	      graphicUtil.setTextStyle(itemStyle, currLabelNormalModel, null, {
	        autoColor: currVisualColor,
	        isRectText: true
	      });
	      itemStyle.text = currLabelNormalModel.getShallow('show') ? zrUtil.retrieve2(customSeries.getFormattedLabel(dataIndexInside, 'normal'), data.get(currLabelValueDim, dataIndexInside)) : null;
	    }
	
	    extra && zrUtil.extend(itemStyle, extra);
	    return itemStyle;
	  }
	  /**
	   * @public
	   * @param {Object} [extra]
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function styleEmphasis(extra, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    updateCache(dataIndexInside);
	    var itemStyle = currItemModel.getModel(ITEM_STYLE_EMPHASIS_PATH).getItemStyle();
	
	    if (currLabelValueDim != null) {
	      graphicUtil.setTextStyle(itemStyle, currLabelEmphasisModel, null, {
	        isRectText: true
	      }, true);
	      itemStyle.text = currLabelEmphasisModel.getShallow('show') ? zrUtil.retrieve3(customSeries.getFormattedLabel(dataIndexInside, 'emphasis'), customSeries.getFormattedLabel(dataIndexInside, 'normal'), data.get(currLabelValueDim, dataIndexInside)) : null;
	    }
	
	    extra && zrUtil.extend(itemStyle, extra);
	    return itemStyle;
	  }
	  /**
	   * @public
	   * @param {string} visualType
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function visual(visualType, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    return data.getItemVisual(dataIndexInside, visualType);
	  }
	  /**
	   * @public
	   * @param {number} opt.count Positive interger.
	   * @param {number} [opt.barWidth]
	   * @param {number} [opt.barMaxWidth]
	   * @param {number} [opt.barGap]
	   * @param {number} [opt.barCategoryGap]
	   * @return {Object} {width, offset, offsetCenter} is not support, return undefined.
	   */
	
	
	  function barLayout(opt) {
	    if (coordSys.getBaseAxis) {
	      var baseAxis = coordSys.getBaseAxis();
	      return barGrid.getLayoutOnAxis(zrUtil.defaults({
	        axis: baseAxis
	      }, opt), api);
	    }
	  }
	  /**
	   * @public
	   * @return {Array.<number>}
	   */
	
	
	  function currentSeriesIndices() {
	    return ecModel.getCurrentSeriesIndices();
	  }
	  /**
	   * @public
	   * @param {Object} opt
	   * @param {string} [opt.fontStyle]
	   * @param {number} [opt.fontWeight]
	   * @param {number} [opt.fontSize]
	   * @param {string} [opt.fontFamily]
	   * @return {string} font string
	   */
	
	
	  function font(opt) {
	    return graphicUtil.getFont(opt, ecModel);
	  }
	}
	
	function wrapEncodeDef(data) {
	  var encodeDef = {};
	  zrUtil.each(data.dimensions, function (dimName, dataDimIndex) {
	    var dimInfo = data.getDimensionInfo(dimName);
	
	    if (!dimInfo.isExtraCoord) {
	      var coordDim = dimInfo.coordDim;
	      var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
	      dataDims[dimInfo.coordDimIndex] = dataDimIndex;
	    }
	  });
	  return encodeDef;
	}
	
	function createOrUpdate(el, dataIndex, elOption, animatableModel, group, data) {
	  el = doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data);
	  el && data.setItemGraphicEl(dataIndex, el);
	}
	
	function doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data) {
	  var elOptionType = elOption.type;
	
	  if (el && elOptionType !== el.__customGraphicType && (elOptionType !== 'path' || elOption.pathData !== el.__customPathData) && (elOptionType !== 'image' || elOption.style.image !== el.__customImagePath) && (elOptionType !== 'text' || elOption.style.text !== el.__customText)) {
	    group.remove(el);
	    el = null;
	  } // `elOption.type` is undefined when `renderItem` returns nothing.
	
	
	  if (elOptionType == null) {
	    return;
	  }
	
	  var isInit = !el;
	  !el && (el = createEl(elOption));
	  updateEl(el, dataIndex, elOption, animatableModel, data, isInit);
	
	  if (elOptionType === 'group') {
	    var oldChildren = el.children() || [];
	    var newChildren = elOption.children || [];
	
	    if (elOption.diffChildrenByName) {
	      // lower performance.
	      diffGroupChildren({
	        oldChildren: oldChildren,
	        newChildren: newChildren,
	        dataIndex: dataIndex,
	        animatableModel: animatableModel,
	        group: el,
	        data: data
	      });
	    } else {
	      // better performance.
	      var index = 0;
	
	      for (; index < newChildren.length; index++) {
	        doCreateOrUpdate(el.childAt(index), dataIndex, newChildren[index], animatableModel, el, data);
	      }
	
	      for (; index < oldChildren.length; index++) {
	        oldChildren[index] && el.remove(oldChildren[index]);
	      }
	    }
	  }
	
	  group.add(el);
	  return el;
	}
	
	function diffGroupChildren(context) {
	  new DataDiffer(context.oldChildren, context.newChildren, getKey, getKey, context).add(processAddUpdate).update(processAddUpdate).remove(processRemove).execute();
	}
	
	function getKey(item, idx) {
	  var name = item && item.name;
	  return name != null ? name : GROUP_DIFF_PREFIX + idx;
	}
	
	function processAddUpdate(newIndex, oldIndex) {
	  var context = this.context;
	  var childOption = newIndex != null ? context.newChildren[newIndex] : null;
	  var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
	  doCreateOrUpdate(child, context.dataIndex, childOption, context.animatableModel, context.group, context.data);
	}
	
	function processRemove(oldIndex) {
	  var context = this.context;
	  var child = context.oldChildren[oldIndex];
	  child && context.group.remove(child);
	}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	__webpack_require__(366);
	
	__webpack_require__(367);
	
	var visualSymbol = __webpack_require__(47);
	
	var layoutPoints = __webpack_require__(129);
	
	echarts.registerVisual(zrUtil.curry(visualSymbol, 'effectScatter', 'circle', null));
	echarts.registerLayout(zrUtil.curry(layoutPoints, 'effectScatter'));

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var createListFromArray = __webpack_require__(34);
	
	var SeriesModel = __webpack_require__(20);
	
	var _default = SeriesModel.extend({
	  type: 'series.effectScatter',
	  dependencies: ['grid', 'polar'],
	  getInitialData: function (option, ecModel) {
	    var list = createListFromArray(option.data, this, ecModel);
	    return list;
	  },
	  brushSelector: 'point',
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    effectType: 'ripple',
	    progressive: 0,
	    // When to show the effect, option: 'render'|'emphasis'
	    showEffectOn: 'render',
	    // Ripple effect config
	    rippleEffect: {
	      period: 4,
	      // Scale of ripple
	      scale: 2.5,
	      // Brush type can be fill or stroke
	      brushType: 'fill'
	    },
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // symbol: null,        // 图形类型
	    symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
	    // symbolRotate: null,  // 图形旋转控制
	    // large: false,
	    // Available when large is true
	    // largeThreshold: 2000,
	    // itemStyle: {
	    //     normal: {
	    //         opacity: 1
	    //     }
	    // }
	
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var SymbolDraw = __webpack_require__(65);
	
	var EffectSymbol = __webpack_require__(394);
	
	var _default = echarts.extendChartView({
	  type: 'effectScatter',
	  init: function () {
	    this._symbolDraw = new SymbolDraw(EffectSymbol);
	  },
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var effectSymbolDraw = this._symbolDraw;
	    effectSymbolDraw.updateData(data);
	    this.group.add(effectSymbolDraw.group);
	  },
	  updateLayout: function () {
	    this._symbolDraw.updateLayout();
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove(api);
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	__webpack_require__(369);
	
	__webpack_require__(370);
	
	var dataColor = __webpack_require__(132);
	
	var funnelLayout = __webpack_require__(371);
	
	var dataFilter = __webpack_require__(90);
	
	echarts.registerVisual(zrUtil.curry(dataColor, 'funnel'));
	echarts.registerLayout(funnelLayout);
	echarts.registerProcessor(zrUtil.curry(dataFilter, 'funnel'));

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var List = __webpack_require__(15);
	
	var _model = __webpack_require__(6);
	
	var defaultEmphasis = _model.defaultEmphasis;
	
	var completeDimensions = __webpack_require__(25);
	
	var FunnelSeries = echarts.extendSeriesModel({
	  type: 'series.funnel',
	  init: function (option) {
	    FunnelSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendDataProvider = function () {
	      return this.getRawData();
	    }; // Extend labelLine emphasis
	
	
	    this._defaultLabelLine(option);
	  },
	  getInitialData: function (option, ecModel) {
	    var dimensions = completeDimensions(['value'], option.data);
	    var list = new List(dimensions, this);
	    list.initData(option.data);
	    return list;
	  },
	  _defaultLabelLine: function (option) {
	    // Extend labelLine emphasis
	    defaultEmphasis(option.labelLine, ['show']);
	    var labelLineNormalOpt = option.labelLine.normal;
	    var labelLineEmphasisOpt = option.labelLine.emphasis; // Not show label line if `label.normal.show = false`
	
	    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.normal.show;
	    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.label.emphasis.show;
	  },
	  // Overwrite
	  getDataParams: function (dataIndex) {
	    var data = this.getData();
	    var params = FunnelSeries.superCall(this, 'getDataParams', dataIndex);
	    var sum = data.getSum('value'); // Percent is 0 if sum is 0
	
	    params.percent = !sum ? 0 : +(data.get('value', dataIndex) / sum * 100).toFixed(2);
	    params.$vars.push('percent');
	    return params;
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    legendHoverLink: true,
	    left: 80,
	    top: 60,
	    right: 80,
	    bottom: 60,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    // 默认取数据最小最大值
	    // min: 0,
	    // max: 100,
	    minSize: '0%',
	    maxSize: '100%',
	    sort: 'descending',
	    // 'ascending', 'descending'
	    gap: 0,
	    funnelAlign: 'center',
	    label: {
	      normal: {
	        show: true,
	        position: 'outer' // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	
	      },
	      emphasis: {
	        show: true
	      }
	    },
	    labelLine: {
	      normal: {
	        show: true,
	        length: 20,
	        lineStyle: {
	          // color: 各异,
	          width: 1,
	          type: 'solid'
	        }
	      },
	      emphasis: {}
	    },
	    itemStyle: {
	      normal: {
	        // color: 各异,
	        borderColor: '#fff',
	        borderWidth: 1
	      },
	      emphasis: {// color: 各异,
	      }
	    }
	  }
	});
	var _default = FunnelSeries;
	module.exports = _default;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var graphic = __webpack_require__(3);
	
	var zrUtil = __webpack_require__(1);
	
	var ChartView = __webpack_require__(37);
	
	/**
	 * Piece of pie including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	function FunnelPiece(data, idx) {
	  graphic.Group.call(this);
	  var polygon = new graphic.Polygon();
	  var labelLine = new graphic.Polyline();
	  var text = new graphic.Text();
	  this.add(polygon);
	  this.add(labelLine);
	  this.add(text);
	  this.updateData(data, idx, true); // Hover to change label and labelLine
	
	  function onEmphasis() {
	    labelLine.ignore = labelLine.hoverIgnore;
	    text.ignore = text.hoverIgnore;
	  }
	
	  function onNormal() {
	    labelLine.ignore = labelLine.normalIgnore;
	    text.ignore = text.normalIgnore;
	  }
	
	  this.on('emphasis', onEmphasis).on('normal', onNormal).on('mouseover', onEmphasis).on('mouseout', onNormal);
	}
	
	var funnelPieceProto = FunnelPiece.prototype;
	var opacityAccessPath = ['itemStyle', 'normal', 'opacity'];
	
	funnelPieceProto.updateData = function (data, idx, firstCreate) {
	  var polygon = this.childAt(0);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var opacity = data.getItemModel(idx).get(opacityAccessPath);
	  opacity = opacity == null ? 1 : opacity; // Reset style
	
	  polygon.useStyle({});
	
	  if (firstCreate) {
	    polygon.setShape({
	      points: layout.points
	    });
	    polygon.setStyle({
	      opacity: 0
	    });
	    graphic.initProps(polygon, {
	      style: {
	        opacity: opacity
	      }
	    }, seriesModel, idx);
	  } else {
	    graphic.updateProps(polygon, {
	      style: {
	        opacity: opacity
	      },
	      shape: {
	        points: layout.points
	      }
	    }, seriesModel, idx);
	  } // Update common style
	
	
	  var itemStyleModel = itemModel.getModel('itemStyle');
	  var visualColor = data.getItemVisual(idx, 'color');
	  polygon.setStyle(zrUtil.defaults({
	    lineJoin: 'round',
	    fill: visualColor
	  }, itemStyleModel.getModel('normal').getItemStyle(['opacity'])));
	  polygon.hoverStyle = itemStyleModel.getModel('emphasis').getItemStyle();
	
	  this._updateLabel(data, idx);
	
	  graphic.setHoverStyle(this);
	};
	
	funnelPieceProto._updateLabel = function (data, idx) {
	  var labelLine = this.childAt(1);
	  var labelText = this.childAt(2);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var labelLayout = layout.label;
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.updateProps(labelLine, {
	    shape: {
	      points: labelLayout.linePoints || labelLayout.linePoints
	    }
	  }, seriesModel, idx);
	  graphic.updateProps(labelText, {
	    style: {
	      x: labelLayout.x,
	      y: labelLayout.y
	    }
	  }, seriesModel, idx);
	  labelText.attr({
	    rotation: labelLayout.rotation,
	    origin: [labelLayout.x, labelLayout.y],
	    z2: 10
	  });
	  var labelModel = itemModel.getModel('label.normal');
	  var labelHoverModel = itemModel.getModel('label.emphasis');
	  var labelLineModel = itemModel.getModel('labelLine.normal');
	  var labelLineHoverModel = itemModel.getModel('labelLine.emphasis');
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
	    labelFetcher: data.hostModel,
	    labelDataIndex: idx,
	    defaultText: data.getName(idx),
	    autoColor: visualColor,
	    useInsideStyle: !!labelLayout.inside
	  }, {
	    textAlign: labelLayout.textAlign,
	    textVerticalAlign: labelLayout.verticalAlign
	  });
	  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
	  labelText.hoverIgnore = !labelHoverModel.get('show');
	  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
	  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color
	
	  labelLine.setStyle({
	    stroke: visualColor
	  });
	  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
	  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
	};
	
	zrUtil.inherits(FunnelPiece, graphic.Group);
	var FunnelView = ChartView.extend({
	  type: 'funnel',
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    data.diff(oldData).add(function (idx) {
	      var funnelPiece = new FunnelPiece(data, idx);
	      data.setItemGraphicEl(idx, funnelPiece);
	      group.add(funnelPiece);
	    }).update(function (newIdx, oldIdx) {
	      var piePiece = oldData.getItemGraphicEl(oldIdx);
	      piePiece.updateData(data, newIdx);
	      group.add(piePiece);
	      data.setItemGraphicEl(newIdx, piePiece);
	    }).remove(function (idx) {
	      var piePiece = oldData.getItemGraphicEl(idx);
	      group.remove(piePiece);
	    }).execute();
	    this._data = data;
	  },
	  remove: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: function () {}
	});
	var _default = FunnelView;
	module.exports = _default;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var layout = __webpack_require__(7);
	
	var _number = __webpack_require__(4);
	
	var parsePercent = _number.parsePercent;
	var linearMap = _number.linearMap;
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function getSortedIndices(data, sort) {
	  var valueArr = data.mapArray('value', function (val) {
	    return val;
	  });
	  var indices = [];
	  var isAscending = sort === 'ascending';
	
	  for (var i = 0, len = data.count(); i < len; i++) {
	    indices[i] = i;
	  } // Add custom sortable function & none sortable opetion by "options.sort"
	
	
	  if (typeof sort === 'function') {
	    indices.sort(sort);
	  } else if (sort !== 'none') {
	    indices.sort(function (a, b) {
	      return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
	    });
	  }
	
	  return indices;
	}
	
	function labelLayout(data) {
	  data.each(function (idx) {
	    var itemModel = data.getItemModel(idx);
	    var labelModel = itemModel.getModel('label.normal');
	    var labelPosition = labelModel.get('position');
	    var labelLineModel = itemModel.getModel('labelLine.normal');
	    var layout = data.getItemLayout(idx);
	    var points = layout.points;
	    var isLabelInside = labelPosition === 'inner' || labelPosition === 'inside' || labelPosition === 'center';
	    var textAlign;
	    var textX;
	    var textY;
	    var linePoints;
	
	    if (isLabelInside) {
	      textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
	      textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
	      textAlign = 'center';
	      linePoints = [[textX, textY], [textX, textY]];
	    } else {
	      var x1;
	      var y1;
	      var x2;
	      var labelLineLen = labelLineModel.get('length');
	
	      if (labelPosition === 'left') {
	        // Left side
	        x1 = (points[3][0] + points[0][0]) / 2;
	        y1 = (points[3][1] + points[0][1]) / 2;
	        x2 = x1 - labelLineLen;
	        textX = x2 - 5;
	        textAlign = 'right';
	      } else {
	        // Right side
	        x1 = (points[1][0] + points[2][0]) / 2;
	        y1 = (points[1][1] + points[2][1]) / 2;
	        x2 = x1 + labelLineLen;
	        textX = x2 + 5;
	        textAlign = 'left';
	      }
	
	      var y2 = y1;
	      linePoints = [[x1, y1], [x2, y2]];
	      textY = y2;
	    }
	
	    layout.label = {
	      linePoints: linePoints,
	      x: textX,
	      y: textY,
	      verticalAlign: 'middle',
	      textAlign: textAlign,
	      inside: isLabelInside
	    };
	  });
	}
	
	function _default(ecModel, api, payload) {
	  ecModel.eachSeriesByType('funnel', function (seriesModel) {
	    var data = seriesModel.getData();
	    var sort = seriesModel.get('sort');
	    var viewRect = getViewRect(seriesModel, api);
	    var indices = getSortedIndices(data, sort);
	    var sizeExtent = [parsePercent(seriesModel.get('minSize'), viewRect.width), parsePercent(seriesModel.get('maxSize'), viewRect.width)];
	    var dataExtent = data.getDataExtent('value');
	    var min = seriesModel.get('min');
	    var max = seriesModel.get('max');
	
	    if (min == null) {
	      min = Math.min(dataExtent[0], 0);
	    }
	
	    if (max == null) {
	      max = dataExtent[1];
	    }
	
	    var funnelAlign = seriesModel.get('funnelAlign');
	    var gap = seriesModel.get('gap');
	    var itemHeight = (viewRect.height - gap * (data.count() - 1)) / data.count();
	    var y = viewRect.y;
	
	    var getLinePoints = function (idx, offY) {
	      // End point index is data.count() and we assign it 0
	      var val = data.get('value', idx) || 0;
	      var itemWidth = linearMap(val, [min, max], sizeExtent, true);
	      var x0;
	
	      switch (funnelAlign) {
	        case 'left':
	          x0 = viewRect.x;
	          break;
	
	        case 'center':
	          x0 = viewRect.x + (viewRect.width - itemWidth) / 2;
	          break;
	
	        case 'right':
	          x0 = viewRect.x + viewRect.width - itemWidth;
	          break;
	      }
	
	      return [[x0, offY], [x0 + itemWidth, offY]];
	    };
	
	    if (sort === 'ascending') {
	      // From bottom to top
	      itemHeight = -itemHeight;
	      gap = -gap;
	      y += viewRect.height;
	      indices = indices.reverse();
	    }
	
	    for (var i = 0; i < indices.length; i++) {
	      var idx = indices[i];
	      var nextIdx = indices[i + 1];
	      var start = getLinePoints(idx, y);
	      var end = getLinePoints(nextIdx, y + itemHeight);
	      y += itemHeight + gap;
	      data.setItemLayout(idx, {
	        points: start.concat(end.slice().reverse())
	      });
	    }
	
	    labelLayout(data);
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(373);
	
	__webpack_require__(374);

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	var List = __webpack_require__(15);
	
	var SeriesModel = __webpack_require__(20);
	
	var zrUtil = __webpack_require__(1);
	
	var GaugeSeries = SeriesModel.extend({
	  type: 'series.gauge',
	  getInitialData: function (option, ecModel) {
	    var list = new List(['value'], this);
	    var dataOpt = option.data || [];
	
	    if (!zrUtil.isArray(dataOpt)) {
	      dataOpt = [dataOpt];
	    } // Only use the first data item
	
	
	    list.initData(dataOpt);
	    return list;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    legendHoverLink: true,
	    radius: '75%',
	    startAngle: 225,
	    endAngle: -45,
	    clockwise: true,
	    // 最小值
	    min: 0,
	    // 最大值
	    max: 100,
	    // 分割段数，默认为10
	    splitNumber: 10,
	    // 坐标轴线
	    axisLine: {
	      // 默认显示，属性show控制显示与否
	      show: true,
	      lineStyle: {
	        // 属性lineStyle控制线条样式
	        color: [[0.2, '#91c7ae'], [0.8, '#63869e'], [1, '#c23531']],
	        width: 30
	      }
	    },
	    // 分隔线
	    splitLine: {
	      // 默认显示，属性show控制显示与否
	      show: true,
	      // 属性length控制线长
	      length: 30,
	      // 属性lineStyle（详见lineStyle）控制线条样式
	      lineStyle: {
	        color: '#eee',
	        width: 2,
	        type: 'solid'
	      }
	    },
	    // 坐标轴小标记
	    axisTick: {
	      // 属性show控制显示与否，默认不显示
	      show: true,
	      // 每份split细分多少段
	      splitNumber: 5,
	      // 属性length控制线长
	      length: 8,
	      // 属性lineStyle控制线条样式
	      lineStyle: {
	        color: '#eee',
	        width: 1,
	        type: 'solid'
	      }
	    },
	    axisLabel: {
	      show: true,
	      distance: 5,
	      // formatter: null,
	      color: 'auto'
	    },
	    pointer: {
	      show: true,
	      length: '80%',
	      width: 8
	    },
	    itemStyle: {
	      normal: {
	        color: 'auto'
	      }
	    },
	    title: {
	      show: true,
	      // x, y，单位px
	      offsetCenter: [0, '-40%'],
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: '#333',
	      fontSize: 15
	    },
	    detail: {
	      show: true,
	      backgroundColor: 'rgba(0,0,0,0)',
	      borderWidth: 0,
	      borderColor: '#ccc',
	      width: 100,
	      height: null,
	      // self-adaption
	      padding: [5, 10],
	      // x, y，单位px
	      offsetCenter: [0, '40%'],
	      // formatter: null,
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: 'auto',
	      fontSize: 30
	    }
	  }
	});
	var _default = GaugeSeries;
	module.exports = _default;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var PointerPath = __webpack_require__(375);
	
	var graphic = __webpack_require__(3);
	
	var ChartView = __webpack_require__(37);
	
	var _number = __webpack_require__(4);
	
	var parsePercent = _number.parsePercent;
	var round = _number.round;
	var linearMap = _number.linearMap;
	
	function parsePosition(seriesModel, api) {
	  var center = seriesModel.get('center');
	  var width = api.getWidth();
	  var height = api.getHeight();
	  var size = Math.min(width, height);
	  var cx = parsePercent(center[0], api.getWidth());
	  var cy = parsePercent(center[1], api.getHeight());
	  var r = parsePercent(seriesModel.get('radius'), size / 2);
	  return {
	    cx: cx,
	    cy: cy,
	    r: r
	  };
	}
	
	function formatLabel(label, labelFormatter) {
	  if (labelFormatter) {
	    if (typeof labelFormatter === 'string') {
	      label = labelFormatter.replace('{value}', label != null ? label : '');
	    } else if (typeof labelFormatter === 'function') {
	      label = labelFormatter(label);
	    }
	  }
	
	  return label;
	}
	
	var PI2 = Math.PI * 2;
	var GaugeView = ChartView.extend({
	  type: 'gauge',
	  render: function (seriesModel, ecModel, api) {
	    this.group.removeAll();
	    var colorList = seriesModel.get('axisLine.lineStyle.color');
	    var posInfo = parsePosition(seriesModel, api);
	
	    this._renderMain(seriesModel, ecModel, api, colorList, posInfo);
	  },
	  dispose: function () {},
	  _renderMain: function (seriesModel, ecModel, api, colorList, posInfo) {
	    var group = this.group;
	    var axisLineModel = seriesModel.getModel('axisLine');
	    var lineStyleModel = axisLineModel.getModel('lineStyle');
	    var clockwise = seriesModel.get('clockwise');
	    var startAngle = -seriesModel.get('startAngle') / 180 * Math.PI;
	    var endAngle = -seriesModel.get('endAngle') / 180 * Math.PI;
	    var angleRangeSpan = (endAngle - startAngle) % PI2;
	    var prevEndAngle = startAngle;
	    var axisLineWidth = lineStyleModel.get('width');
	
	    for (var i = 0; i < colorList.length; i++) {
	      // Clamp
	      var percent = Math.min(Math.max(colorList[i][0], 0), 1);
	      var endAngle = startAngle + angleRangeSpan * percent;
	      var sector = new graphic.Sector({
	        shape: {
	          startAngle: prevEndAngle,
	          endAngle: endAngle,
	          cx: posInfo.cx,
	          cy: posInfo.cy,
	          clockwise: clockwise,
	          r0: posInfo.r - axisLineWidth,
	          r: posInfo.r
	        },
	        silent: true
	      });
	      sector.setStyle({
	        fill: colorList[i][1]
	      });
	      sector.setStyle(lineStyleModel.getLineStyle( // Because we use sector to simulate arc
	      // so the properties for stroking are useless
	      ['color', 'borderWidth', 'borderColor']));
	      group.add(sector);
	      prevEndAngle = endAngle;
	    }
	
	    var getColor = function (percent) {
	      // Less than 0
	      if (percent <= 0) {
	        return colorList[0][1];
	      }
	
	      for (var i = 0; i < colorList.length; i++) {
	        if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) {
	          return colorList[i][1];
	        }
	      } // More than 1
	
	
	      return colorList[i - 1][1];
	    };
	
	    if (!clockwise) {
	      var tmp = startAngle;
	      startAngle = endAngle;
	      endAngle = tmp;
	    }
	
	    this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);
	
	    this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);
	
	    this._renderTitle(seriesModel, ecModel, api, getColor, posInfo);
	
	    this._renderDetail(seriesModel, ecModel, api, getColor, posInfo);
	  },
	  _renderTicks: function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
	    var group = this.group;
	    var cx = posInfo.cx;
	    var cy = posInfo.cy;
	    var r = posInfo.r;
	    var minVal = +seriesModel.get('min');
	    var maxVal = +seriesModel.get('max');
	    var splitLineModel = seriesModel.getModel('splitLine');
	    var tickModel = seriesModel.getModel('axisTick');
	    var labelModel = seriesModel.getModel('axisLabel');
	    var splitNumber = seriesModel.get('splitNumber');
	    var subSplitNumber = tickModel.get('splitNumber');
	    var splitLineLen = parsePercent(splitLineModel.get('length'), r);
	    var tickLen = parsePercent(tickModel.get('length'), r);
	    var angle = startAngle;
	    var step = (endAngle - startAngle) / splitNumber;
	    var subStep = step / subSplitNumber;
	    var splitLineStyle = splitLineModel.getModel('lineStyle').getLineStyle();
	    var tickLineStyle = tickModel.getModel('lineStyle').getLineStyle();
	
	    for (var i = 0; i <= splitNumber; i++) {
	      var unitX = Math.cos(angle);
	      var unitY = Math.sin(angle); // Split line
	
	      if (splitLineModel.get('show')) {
	        var splitLine = new graphic.Line({
	          shape: {
	            x1: unitX * r + cx,
	            y1: unitY * r + cy,
	            x2: unitX * (r - splitLineLen) + cx,
	            y2: unitY * (r - splitLineLen) + cy
	          },
	          style: splitLineStyle,
	          silent: true
	        });
	
	        if (splitLineStyle.stroke === 'auto') {
	          splitLine.setStyle({
	            stroke: getColor(i / splitNumber)
	          });
	        }
	
	        group.add(splitLine);
	      } // Label
	
	
	      if (labelModel.get('show')) {
	        var label = formatLabel(round(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get('formatter'));
	        var distance = labelModel.get('distance');
	        var autoColor = getColor(i / splitNumber);
	        group.add(new graphic.Text({
	          style: graphic.setTextStyle({}, labelModel, {
	            text: label,
	            x: unitX * (r - splitLineLen - distance) + cx,
	            y: unitY * (r - splitLineLen - distance) + cy,
	            textVerticalAlign: unitY < -0.4 ? 'top' : unitY > 0.4 ? 'bottom' : 'middle',
	            textAlign: unitX < -0.4 ? 'left' : unitX > 0.4 ? 'right' : 'center'
	          }, {
	            autoColor: autoColor
	          }),
	          silent: true
	        }));
	      } // Axis tick
	
	
	      if (tickModel.get('show') && i !== splitNumber) {
	        for (var j = 0; j <= subSplitNumber; j++) {
	          var unitX = Math.cos(angle);
	          var unitY = Math.sin(angle);
	          var tickLine = new graphic.Line({
	            shape: {
	              x1: unitX * r + cx,
	              y1: unitY * r + cy,
	              x2: unitX * (r - tickLen) + cx,
	              y2: unitY * (r - tickLen) + cy
	            },
	            silent: true,
	            style: tickLineStyle
	          });
	
	          if (tickLineStyle.stroke === 'auto') {
	            tickLine.setStyle({
	              stroke: getColor((i + j / subSplitNumber) / splitNumber)
	            });
	          }
	
	          group.add(tickLine);
	          angle += subStep;
	        }
	
	        angle -= subStep;
	      } else {
	        angle += step;
	      }
	    }
	  },
	  _renderPointer: function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
	    var group = this.group;
	    var oldData = this._data;
	
	    if (!seriesModel.get('pointer.show')) {
	      // Remove old element
	      oldData && oldData.eachItemGraphicEl(function (el) {
	        group.remove(el);
	      });
	      return;
	    }
	
	    var valueExtent = [+seriesModel.get('min'), +seriesModel.get('max')];
	    var angleExtent = [startAngle, endAngle];
	    var data = seriesModel.getData();
	    data.diff(oldData).add(function (idx) {
	      var pointer = new PointerPath({
	        shape: {
	          angle: startAngle
	        }
	      });
	      graphic.initProps(pointer, {
	        shape: {
	          angle: linearMap(data.get('value', idx), valueExtent, angleExtent, true)
	        }
	      }, seriesModel);
	      group.add(pointer);
	      data.setItemGraphicEl(idx, pointer);
	    }).update(function (newIdx, oldIdx) {
	      var pointer = oldData.getItemGraphicEl(oldIdx);
	      graphic.updateProps(pointer, {
	        shape: {
	          angle: linearMap(data.get('value', newIdx), valueExtent, angleExtent, true)
	        }
	      }, seriesModel);
	      group.add(pointer);
	      data.setItemGraphicEl(newIdx, pointer);
	    }).remove(function (idx) {
	      var pointer = oldData.getItemGraphicEl(idx);
	      group.remove(pointer);
	    }).execute();
	    data.eachItemGraphicEl(function (pointer, idx) {
	      var itemModel = data.getItemModel(idx);
	      var pointerModel = itemModel.getModel('pointer');
	      pointer.setShape({
	        x: posInfo.cx,
	        y: posInfo.cy,
	        width: parsePercent(pointerModel.get('width'), posInfo.r),
	        r: parsePercent(pointerModel.get('length'), posInfo.r)
	      });
	      pointer.useStyle(itemModel.getModel('itemStyle.normal').getItemStyle());
	
	      if (pointer.style.fill === 'auto') {
	        pointer.setStyle('fill', getColor(linearMap(data.get('value', idx), valueExtent, [0, 1], true)));
	      }
	
	      graphic.setHoverStyle(pointer, itemModel.getModel('itemStyle.emphasis').getItemStyle());
	    });
	    this._data = data;
	  },
	  _renderTitle: function (seriesModel, ecModel, api, getColor, posInfo) {
	    var titleModel = seriesModel.getModel('title');
	
	    if (titleModel.get('show')) {
	      var offsetCenter = titleModel.get('offsetCenter');
	      var x = posInfo.cx + parsePercent(offsetCenter[0], posInfo.r);
	      var y = posInfo.cy + parsePercent(offsetCenter[1], posInfo.r);
	      var minVal = +seriesModel.get('min');
	      var maxVal = +seriesModel.get('max');
	      var value = seriesModel.getData().get('value', 0);
	      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
	      this.group.add(new graphic.Text({
	        silent: true,
	        style: graphic.setTextStyle({}, titleModel, {
	          x: x,
	          y: y,
	          // FIXME First data name ?
	          text: seriesModel.getData().getName(0),
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        }, {
	          autoColor: autoColor,
	          forceRich: true
	        })
	      }));
	    }
	  },
	  _renderDetail: function (seriesModel, ecModel, api, getColor, posInfo) {
	    var detailModel = seriesModel.getModel('detail');
	    var minVal = +seriesModel.get('min');
	    var maxVal = +seriesModel.get('max');
	
	    if (detailModel.get('show')) {
	      var offsetCenter = detailModel.get('offsetCenter');
	      var x = posInfo.cx + parsePercent(offsetCenter[0], posInfo.r);
	      var y = posInfo.cy + parsePercent(offsetCenter[1], posInfo.r);
	      var width = parsePercent(detailModel.get('width'), posInfo.r);
	      var height = parsePercent(detailModel.get('height'), posInfo.r);
	      var value = seriesModel.getData().get('value', 0);
	      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
	      this.group.add(new graphic.Text({
	        silent: true,
	        style: graphic.setTextStyle({}, detailModel, {
	          x: x,
	          y: y,
	          text: formatLabel( // FIXME First data name ?
	          value, detailModel.get('formatter')),
	          textWidth: isNaN(width) ? null : width,
	          textHeight: isNaN(height) ? null : height,
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        }, {
	          autoColor: autoColor,
	          forceRich: true
	        })
	      }));
	    }
	  }
	});
	var _default = GaugeView;
	module.exports = _default;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(19);
	
	var _default = Path.extend({
	  type: 'echartsGaugePointer',
	  shape: {
	    angle: 0,
	    width: 10,
	    r: 10,
	    x: 0,
	    y: 0
	  },
	  buildPath: function (ctx, shape) {
	    var mathCos = Math.cos;
	    var mathSin = Math.sin;
	    var r = shape.r;
	    var width = shape.width;
	    var angle = shape.angle;
	    var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
	    var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
	    angle = shape.angle - Math.PI / 2;
	    ctx.moveTo(x, y);
	    ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
	    ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
	    ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
	    ctx.lineTo(x, y);
	    return;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	__webpack_require__(377);
	
	__webpack_require__(378);
	
	__webpack_require__(387);
	
	var categoryFilter = __webpack_require__(380);
	
	var visualSymbol = __webpack_require__(47);
	
	var categoryVisual = __webpack_require__(381);
	
	var edgeVisual = __webpack_require__(384);
	
	var simpleLayout = __webpack_require__(388);
	
	var circularLayout = __webpack_require__(382);
	
	var forceLayout = __webpack_require__(386);
	
	var createView = __webpack_require__(383);
	
	echarts.registerProcessor(categoryFilter);
	echarts.registerVisual(zrUtil.curry(visualSymbol, 'graph', 'circle', null));
	echarts.registerVisual(categoryVisual);
	echarts.registerVisual(edgeVisual);
	echarts.registerLayout(simpleLayout);
	echarts.registerLayout(circularLayout);
	echarts.registerLayout(forceLayout); // Graph view coordinate system
	
	echarts.registerCoordinateSystem('graphView', {
	  create: createView
	});

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var List = __webpack_require__(15);
	
	var zrUtil = __webpack_require__(1);
	
	var _model = __webpack_require__(6);
	
	var defaultEmphasis = _model.defaultEmphasis;
	
	var Model = __webpack_require__(14);
	
	var _format = __webpack_require__(9);
	
	var encodeHTML = _format.encodeHTML;
	
	var createGraphFromNodeEdge = __webpack_require__(162);
	
	var GraphSeries = echarts.extendSeriesModel({
	  type: 'series.graph',
	  init: function (option) {
	    GraphSeries.superApply(this, 'init', arguments); // Provide data for legend select
	
	    this.legendDataProvider = function () {
	      return this._categoriesData;
	    };
	
	    this.fillDataTextStyle(option.edges || option.links);
	
	    this._updateCategoriesData();
	  },
	  mergeOption: function (option) {
	    GraphSeries.superApply(this, 'mergeOption', arguments);
	    this.fillDataTextStyle(option.edges || option.links);
	
	    this._updateCategoriesData();
	  },
	  mergeDefaultAndTheme: function (option) {
	    GraphSeries.superApply(this, 'mergeDefaultAndTheme', arguments);
	    defaultEmphasis(option.edgeLabel, ['show']);
	  },
	  getInitialData: function (option, ecModel) {
	    var edges = option.edges || option.links || [];
	    var nodes = option.data || option.nodes || [];
	    var self = this;
	
	    if (nodes && edges) {
	      return createGraphFromNodeEdge(nodes, edges, this, true, beforeLink).data;
	    }
	
	    function beforeLink(nodeData, edgeData) {
	      // Overwrite nodeData.getItemModel to
	      nodeData.wrapMethod('getItemModel', function (model) {
	        var categoriesModels = self._categoriesModels;
	        var categoryIdx = model.getShallow('category');
	        var categoryModel = categoriesModels[categoryIdx];
	
	        if (categoryModel) {
	          categoryModel.parentModel = model.parentModel;
	          model.parentModel = categoryModel;
	        }
	
	        return model;
	      });
	      var edgeLabelModel = self.getModel('edgeLabel'); // For option `edgeLabel` can be found by label.xxx.xxx on item mode.
	
	      var fakeSeriesModel = new Model({
	        label: edgeLabelModel.option
	      }, edgeLabelModel.parentModel, ecModel);
	      edgeData.wrapMethod('getItemModel', function (model) {
	        model.customizeGetParent(edgeGetParent);
	        return model;
	      });
	
	      function edgeGetParent(path) {
	        path = this.parsePath(path);
	        return path && path[0] === 'label' ? fakeSeriesModel : this.parentModel;
	      }
	    }
	  },
	
	  /**
	   * @return {module:echarts/data/Graph}
	   */
	  getGraph: function () {
	    return this.getData().graph;
	  },
	
	  /**
	   * @return {module:echarts/data/List}
	   */
	  getEdgeData: function () {
	    return this.getGraph().edgeData;
	  },
	
	  /**
	   * @return {module:echarts/data/List}
	   */
	  getCategoriesData: function () {
	    return this._categoriesData;
	  },
	
	  /**
	   * @override
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType) {
	    if (dataType === 'edge') {
	      var nodeData = this.getData();
	      var params = this.getDataParams(dataIndex, dataType);
	      var edge = nodeData.graph.getEdgeByIndex(dataIndex);
	      var sourceName = nodeData.getName(edge.node1.dataIndex);
	      var targetName = nodeData.getName(edge.node2.dataIndex);
	      var html = [];
	      sourceName != null && html.push(sourceName);
	      targetName != null && html.push(targetName);
	      html = encodeHTML(html.join(' > '));
	
	      if (params.value) {
	        html += ' : ' + encodeHTML(params.value);
	      }
	
	      return html;
	    } else {
	      // dataType === 'node' or empty
	      return GraphSeries.superApply(this, 'formatTooltip', arguments);
	    }
	  },
	  _updateCategoriesData: function () {
	    var categories = zrUtil.map(this.option.categories || [], function (category) {
	      // Data must has value
	      return category.value != null ? category : zrUtil.extend({
	        value: 0
	      }, category);
	    });
	    var categoriesData = new List(['value'], this);
	    categoriesData.initData(categories);
	    this._categoriesData = categoriesData;
	    this._categoriesModels = categoriesData.mapArray(function (idx) {
	      return categoriesData.getItemModel(idx, true);
	    });
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	  isAnimationEnabled: function () {
	    return GraphSeries.superCall(this, 'isAnimationEnabled') // Not enable animation when do force layout
	    && !(this.get('layout') === 'force' && this.get('force.layoutAnimation'));
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    // Default option for all coordinate systems
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // polarIndex: 0,
	    // geoIndex: 0,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    layout: null,
	    focusNodeAdjacency: false,
	    // Configuration of circular layout
	    circular: {
	      rotateLabel: false
	    },
	    // Configuration of force directed layout
	    force: {
	      initLayout: null,
	      // Node repulsion. Can be an array to represent range.
	      repulsion: [0, 50],
	      gravity: 0.1,
	      // Edge length. Can be an array to represent range.
	      edgeLength: 30,
	      layoutAnimation: true
	    },
	    left: 'center',
	    top: 'center',
	    // right: null,
	    // bottom: null,
	    // width: '80%',
	    // height: '80%',
	    symbol: 'circle',
	    symbolSize: 10,
	    edgeSymbol: ['none', 'none'],
	    edgeSymbolSize: 10,
	    edgeLabel: {
	      normal: {
	        position: 'middle'
	      },
	      emphasis: {}
	    },
	    draggable: false,
	    roam: false,
	    // Default on center of graph
	    center: null,
	    zoom: 1,
	    // Symbol size scale ratio in roam
	    nodeScaleRatio: 0.6,
	    // cursor: null,
	    // categories: [],
	    // data: []
	    // Or
	    // nodes: []
	    //
	    // links: []
	    // Or
	    // edges: []
	    label: {
	      normal: {
	        show: false,
	        formatter: '{b}'
	      },
	      emphasis: {
	        show: true
	      }
	    },
	    itemStyle: {
	      normal: {},
	      emphasis: {}
	    },
	    lineStyle: {
	      normal: {
	        color: '#aaa',
	        width: 1,
	        curveness: 0,
	        opacity: 0.5
	      },
	      emphasis: {}
	    }
	  }
	});
	var _default = GraphSeries;
	module.exports = _default;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var SymbolDraw = __webpack_require__(65);
	
	var LineDraw = __webpack_require__(117);
	
	var RoamController = __webpack_require__(87);
	
	var roamHelper = __webpack_require__(181);
	
	var _cursorHelper = __webpack_require__(121);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphic = __webpack_require__(3);
	
	var adjustEdge = __webpack_require__(379);
	
	var nodeOpacityPath = ['itemStyle', 'normal', 'opacity'];
	var lineOpacityPath = ['lineStyle', 'normal', 'opacity'];
	
	function getItemOpacity(item, opacityPath) {
	  return item.getVisual('opacity') || item.getModel().get(opacityPath);
	}
	
	function fadeOutItem(item, opacityPath, opacityRatio) {
	  var el = item.getGraphicEl();
	  var opacity = getItemOpacity(item, opacityPath);
	
	  if (opacityRatio != null) {
	    opacity == null && (opacity = 1);
	    opacity *= opacityRatio;
	  }
	
	  el.downplay && el.downplay();
	  el.traverse(function (child) {
	    if (child.type !== 'group') {
	      child.setStyle('opacity', opacity);
	    }
	  });
	}
	
	function fadeInItem(item, opacityPath) {
	  var opacity = getItemOpacity(item, opacityPath);
	  var el = item.getGraphicEl();
	  el.highlight && el.highlight();
	  el.traverse(function (child) {
	    if (child.type !== 'group') {
	      child.setStyle('opacity', opacity);
	    }
	  });
	}
	
	var _default = echarts.extendChartView({
	  type: 'graph',
	  init: function (ecModel, api) {
	    var symbolDraw = new SymbolDraw();
	    var lineDraw = new LineDraw();
	    var group = this.group;
	    this._controller = new RoamController(api.getZr());
	    this._controllerHost = {
	      target: group
	    };
	    group.add(symbolDraw.group);
	    group.add(lineDraw.group);
	    this._symbolDraw = symbolDraw;
	    this._lineDraw = lineDraw;
	    this._firstRender = true;
	  },
	  render: function (seriesModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    this._model = seriesModel;
	    this._nodeScaleRatio = seriesModel.get('nodeScaleRatio');
	    var symbolDraw = this._symbolDraw;
	    var lineDraw = this._lineDraw;
	    var group = this.group;
	
	    if (coordSys.type === 'view') {
	      var groupNewProp = {
	        position: coordSys.position,
	        scale: coordSys.scale
	      };
	
	      if (this._firstRender) {
	        group.attr(groupNewProp);
	      } else {
	        graphic.updateProps(group, groupNewProp, seriesModel);
	      }
	    } // Fix edge contact point with node
	
	
	    adjustEdge(seriesModel.getGraph(), this._getNodeGlobalScale(seriesModel));
	    var data = seriesModel.getData();
	    symbolDraw.updateData(data);
	    var edgeData = seriesModel.getEdgeData();
	    lineDraw.updateData(edgeData);
	
	    this._updateNodeAndLinkScale();
	
	    this._updateController(seriesModel, ecModel, api);
	
	    clearTimeout(this._layoutTimeout);
	    var forceLayout = seriesModel.forceLayout;
	    var layoutAnimation = seriesModel.get('force.layoutAnimation');
	
	    if (forceLayout) {
	      this._startForceLayoutIteration(forceLayout, layoutAnimation);
	    }
	
	    data.eachItemGraphicEl(function (el, idx) {
	      var itemModel = data.getItemModel(idx); // Update draggable
	
	      el.off('drag').off('dragend');
	      var draggable = data.getItemModel(idx).get('draggable');
	
	      if (draggable) {
	        el.on('drag', function () {
	          if (forceLayout) {
	            forceLayout.warmUp();
	            !this._layouting && this._startForceLayoutIteration(forceLayout, layoutAnimation);
	            forceLayout.setFixed(idx); // Write position back to layout
	
	            data.setItemLayout(idx, el.position);
	          }
	        }, this).on('dragend', function () {
	          if (forceLayout) {
	            forceLayout.setUnfixed(idx);
	          }
	        }, this);
	      }
	
	      el.setDraggable(draggable && forceLayout);
	      el.off('mouseover', el.__focusNodeAdjacency);
	      el.off('mouseout', el.__unfocusNodeAdjacency);
	
	      if (itemModel.get('focusNodeAdjacency')) {
	        el.on('mouseover', el.__focusNodeAdjacency = function () {
	          api.dispatchAction({
	            type: 'focusNodeAdjacency',
	            seriesId: seriesModel.id,
	            dataIndex: el.dataIndex
	          });
	        });
	        el.on('mouseout', el.__unfocusNodeAdjacency = function () {
	          api.dispatchAction({
	            type: 'unfocusNodeAdjacency',
	            seriesId: seriesModel.id
	          });
	        });
	      }
	    }, this);
	    data.graph.eachEdge(function (edge) {
	      var el = edge.getGraphicEl();
	      el.off('mouseover', el.__focusNodeAdjacency);
	      el.off('mouseout', el.__unfocusNodeAdjacency);
	
	      if (edge.getModel().get('focusNodeAdjacency')) {
	        el.on('mouseover', el.__focusNodeAdjacency = function () {
	          api.dispatchAction({
	            type: 'focusNodeAdjacency',
	            seriesId: seriesModel.id,
	            edgeDataIndex: edge.dataIndex
	          });
	        });
	        el.on('mouseout', el.__unfocusNodeAdjacency = function () {
	          api.dispatchAction({
	            type: 'unfocusNodeAdjacency',
	            seriesId: seriesModel.id
	          });
	        });
	      }
	    });
	    var circularRotateLabel = seriesModel.get('layout') === 'circular' && seriesModel.get('circular.rotateLabel');
	    var cx = data.getLayout('cx');
	    var cy = data.getLayout('cy');
	    data.eachItemGraphicEl(function (el, idx) {
	      var symbolPath = el.getSymbolPath();
	
	      if (circularRotateLabel) {
	        var pos = data.getItemLayout(idx);
	        var rad = Math.atan2(pos[1] - cy, pos[0] - cx);
	
	        if (rad < 0) {
	          rad = Math.PI * 2 + rad;
	        }
	
	        var isLeft = pos[0] < cx;
	
	        if (isLeft) {
	          rad = rad - Math.PI;
	        }
	
	        var textPosition = isLeft ? 'left' : 'right';
	        symbolPath.setStyle({
	          textRotation: -rad,
	          textPosition: textPosition,
	          textOrigin: 'center'
	        });
	        symbolPath.hoverStyle && (symbolPath.hoverStyle.textPosition = textPosition);
	      } else {
	        symbolPath.setStyle({
	          textRotation: 0
	        });
	      }
	    });
	    this._firstRender = false;
	  },
	  dispose: function () {
	    this._controller && this._controller.dispose();
	    this._controllerHost = {};
	  },
	  focusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var data = this._model.getData();
	
	    var graph = data.graph;
	    var dataIndex = payload.dataIndex;
	    var edgeDataIndex = payload.edgeDataIndex;
	    var node = graph.getNodeByIndex(dataIndex);
	    var edge = graph.getEdgeByIndex(edgeDataIndex);
	
	    if (!node && !edge) {
	      return;
	    }
	
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath, 0.1);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath, 0.1);
	    });
	
	    if (node) {
	      fadeInItem(node, nodeOpacityPath);
	      zrUtil.each(node.edges, function (adjacentEdge) {
	        if (adjacentEdge.dataIndex < 0) {
	          return;
	        }
	
	        fadeInItem(adjacentEdge, lineOpacityPath);
	        fadeInItem(adjacentEdge.node1, nodeOpacityPath);
	        fadeInItem(adjacentEdge.node2, nodeOpacityPath);
	      });
	    }
	
	    if (edge) {
	      fadeInItem(edge, lineOpacityPath);
	      fadeInItem(edge.node1, nodeOpacityPath);
	      fadeInItem(edge.node2, nodeOpacityPath);
	    }
	  },
	  unfocusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var graph = this._model.getData().graph;
	
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath);
	    });
	  },
	  _startForceLayoutIteration: function (forceLayout, layoutAnimation) {
	    var self = this;
	
	    (function step() {
	      forceLayout.step(function (stopped) {
	        self.updateLayout(self._model);
	        (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
	      });
	    })();
	  },
	  _updateController: function (seriesModel, ecModel, api) {
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    var group = this.group;
	    controller.setPointerChecker(function (e, x, y) {
	      var rect = group.getBoundingRect();
	      rect.applyTransform(group.transform);
	      return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
	    });
	
	    if (seriesModel.coordinateSystem.type !== 'view') {
	      controller.disable();
	      return;
	    }
	
	    controller.enable(seriesModel.get('roam'));
	    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
	    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
	    controller.off('pan').off('zoom').on('pan', function (dx, dy) {
	      roamHelper.updateViewOnPan(controllerHost, dx, dy);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'graphRoam',
	        dx: dx,
	        dy: dy
	      });
	    }).on('zoom', function (zoom, mouseX, mouseY) {
	      roamHelper.updateViewOnZoom(controllerHost, zoom, mouseX, mouseY);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'graphRoam',
	        zoom: zoom,
	        originX: mouseX,
	        originY: mouseY
	      });
	
	      this._updateNodeAndLinkScale();
	
	      adjustEdge(seriesModel.getGraph(), this._getNodeGlobalScale(seriesModel));
	
	      this._lineDraw.updateLayout();
	    }, this);
	  },
	  _updateNodeAndLinkScale: function () {
	    var seriesModel = this._model;
	    var data = seriesModel.getData();
	
	    var nodeScale = this._getNodeGlobalScale(seriesModel);
	
	    var invScale = [nodeScale, nodeScale];
	    data.eachItemGraphicEl(function (el, idx) {
	      el.attr('scale', invScale);
	    });
	  },
	  _getNodeGlobalScale: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys.type !== 'view') {
	      return 1;
	    }
	
	    var nodeScaleRatio = this._nodeScaleRatio;
	    var groupScale = coordSys.scale;
	    var groupZoom = groupScale && groupScale[0] || 1; // Scale node when zoom changes
	
	    var roamZoom = coordSys.getZoom();
	    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
	    return nodeScale / groupZoom;
	  },
	  updateLayout: function (seriesModel) {
	    adjustEdge(seriesModel.getGraph(), this._getNodeGlobalScale(seriesModel));
	
	    this._symbolDraw.updateLayout();
	
	    this._lineDraw.updateLayout();
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove();
	    this._lineDraw && this._lineDraw.remove();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	var curveTool = __webpack_require__(40);
	
	var vec2 = __webpack_require__(8);
	
	var v1 = [];
	var v2 = [];
	var v3 = [];
	var quadraticAt = curveTool.quadraticAt;
	var v2DistSquare = vec2.distSquare;
	var mathAbs = Math.abs;
	
	function intersectCurveCircle(curvePoints, center, radius) {
	  var p0 = curvePoints[0];
	  var p1 = curvePoints[1];
	  var p2 = curvePoints[2];
	  var d = Infinity;
	  var t;
	  var radiusSquare = radius * radius;
	  var interval = 0.1;
	
	  for (var _t = 0.1; _t <= 0.9; _t += 0.1) {
	    v1[0] = quadraticAt(p0[0], p1[0], p2[0], _t);
	    v1[1] = quadraticAt(p0[1], p1[1], p2[1], _t);
	    var diff = mathAbs(v2DistSquare(v1, center) - radiusSquare);
	
	    if (diff < d) {
	      d = diff;
	      t = _t;
	    }
	  } // Assume the segment is monotone，Find root through Bisection method
	  // At most 32 iteration
	
	
	  for (var i = 0; i < 32; i++) {
	    // var prev = t - interval;
	    var next = t + interval; // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
	    // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);
	
	    v2[0] = quadraticAt(p0[0], p1[0], p2[0], t);
	    v2[1] = quadraticAt(p0[1], p1[1], p2[1], t);
	    v3[0] = quadraticAt(p0[0], p1[0], p2[0], next);
	    v3[1] = quadraticAt(p0[1], p1[1], p2[1], next);
	    var diff = v2DistSquare(v2, center) - radiusSquare;
	
	    if (mathAbs(diff) < 1e-2) {
	      break;
	    } // var prevDiff = v2DistSquare(v1, center) - radiusSquare;
	
	
	    var nextDiff = v2DistSquare(v3, center) - radiusSquare;
	    interval /= 2;
	
	    if (diff < 0) {
	      if (nextDiff >= 0) {
	        t = t + interval;
	      } else {
	        t = t - interval;
	      }
	    } else {
	      if (nextDiff >= 0) {
	        t = t - interval;
	      } else {
	        t = t + interval;
	      }
	    }
	  }
	
	  return t;
	} // Adjust edge to avoid
	
	
	function _default(graph, scale) {
	  var tmp0 = [];
	  var quadraticSubdivide = curveTool.quadraticSubdivide;
	  var pts = [[], [], []];
	  var pts2 = [[], []];
	  var v = [];
	  scale /= 2;
	
	  function getSymbolSize(node) {
	    var symbolSize = node.getVisual('symbolSize');
	
	    if (symbolSize instanceof Array) {
	      symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
	    }
	
	    return symbolSize;
	  }
	
	  graph.eachEdge(function (edge, idx) {
	    var linePoints = edge.getLayout();
	    var fromSymbol = edge.getVisual('fromSymbol');
	    var toSymbol = edge.getVisual('toSymbol');
	
	    if (!linePoints.__original) {
	      linePoints.__original = [vec2.clone(linePoints[0]), vec2.clone(linePoints[1])];
	
	      if (linePoints[2]) {
	        linePoints.__original.push(vec2.clone(linePoints[2]));
	      }
	    }
	
	    var originalPoints = linePoints.__original; // Quadratic curve
	
	    if (linePoints[2] != null) {
	      vec2.copy(pts[0], originalPoints[0]);
	      vec2.copy(pts[1], originalPoints[2]);
	      vec2.copy(pts[2], originalPoints[1]);
	
	      if (fromSymbol && fromSymbol != 'none') {
	        var symbolSize = getSymbolSize(edge.node1);
	        var t = intersectCurveCircle(pts, originalPoints[0], symbolSize * scale); // Subdivide and get the second
	
	        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
	        pts[0][0] = tmp0[3];
	        pts[1][0] = tmp0[4];
	        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
	        pts[0][1] = tmp0[3];
	        pts[1][1] = tmp0[4];
	      }
	
	      if (toSymbol && toSymbol != 'none') {
	        var symbolSize = getSymbolSize(edge.node2);
	        var t = intersectCurveCircle(pts, originalPoints[1], symbolSize * scale); // Subdivide and get the first
	
	        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
	        pts[1][0] = tmp0[1];
	        pts[2][0] = tmp0[2];
	        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
	        pts[1][1] = tmp0[1];
	        pts[2][1] = tmp0[2];
	      } // Copy back to layout
	
	
	      vec2.copy(linePoints[0], pts[0]);
	      vec2.copy(linePoints[1], pts[2]);
	      vec2.copy(linePoints[2], pts[1]);
	    } // Line
	    else {
	        vec2.copy(pts2[0], originalPoints[0]);
	        vec2.copy(pts2[1], originalPoints[1]);
	        vec2.sub(v, pts2[1], pts2[0]);
	        vec2.normalize(v, v);
	
	        if (fromSymbol && fromSymbol != 'none') {
	          var symbolSize = getSymbolSize(edge.node1);
	          vec2.scaleAndAdd(pts2[0], pts2[0], v, symbolSize * scale);
	        }
	
	        if (toSymbol && toSymbol != 'none') {
	          var symbolSize = getSymbolSize(edge.node2);
	          vec2.scaleAndAdd(pts2[1], pts2[1], v, -symbolSize * scale);
	        }
	
	        vec2.copy(linePoints[0], pts2[0]);
	        vec2.copy(linePoints[1], pts2[1]);
	      }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	function _default(ecModel) {
	  var legendModels = ecModel.findComponents({
	    mainType: 'legend'
	  });
	
	  if (!legendModels || !legendModels.length) {
	    return;
	  }
	
	  ecModel.eachSeriesByType('graph', function (graphSeries) {
	    var categoriesData = graphSeries.getCategoriesData();
	    var graph = graphSeries.getGraph();
	    var data = graph.data;
	    var categoryNames = categoriesData.mapArray(categoriesData.getName);
	    data.filterSelf(function (idx) {
	      var model = data.getItemModel(idx);
	      var category = model.getShallow('category');
	
	      if (category != null) {
	        if (typeof category === 'number') {
	          category = categoryNames[category];
	        } // If in any legend component the status is not selected.
	
	
	        for (var i = 0; i < legendModels.length; i++) {
	          if (!legendModels[i].isSelected(category)) {
	            return false;
	          }
	        }
	      }
	
	      return true;
	    });
	  }, this);
	}
	
	module.exports = _default;

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	function _default(ecModel) {
	  var paletteScope = {};
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var categoriesData = seriesModel.getCategoriesData();
	    var data = seriesModel.getData();
	    var categoryNameIdxMap = {};
	    categoriesData.each(function (idx) {
	      var name = categoriesData.getName(idx); // Add prefix to avoid conflict with Object.prototype.
	
	      categoryNameIdxMap['ec-' + name] = idx;
	      var itemModel = categoriesData.getItemModel(idx);
	      var color = itemModel.get('itemStyle.normal.color') || seriesModel.getColorFromPalette(name, paletteScope);
	      categoriesData.setItemVisual(idx, 'color', color);
	    }); // Assign category color to visual
	
	    if (categoriesData.count()) {
	      data.each(function (idx) {
	        var model = data.getItemModel(idx);
	        var category = model.getShallow('category');
	
	        if (category != null) {
	          if (typeof category === 'string') {
	            category = categoryNameIdxMap['ec-' + category];
	          }
	
	          if (!data.getItemVisual(idx, 'color', true)) {
	            data.setItemVisual(idx, 'color', categoriesData.getItemVisual(category, 'color'));
	          }
	        }
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var _circularLayoutHelper = __webpack_require__(158);
	
	var circularLayout = _circularLayoutHelper.circularLayout;
	
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    if (seriesModel.get('layout') === 'circular') {
	      circularLayout(seriesModel);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var View = __webpack_require__(193);
	
	var _layout = __webpack_require__(7);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var bbox = __webpack_require__(136);
	
	// FIXME Where to create the simple view coordinate system
	function getViewRect(seriesModel, api, aspect) {
	  var option = seriesModel.getBoxLayoutParams();
	  option.aspect = aspect;
	  return getLayoutRect(option, {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function _default(ecModel, api) {
	  var viewList = [];
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var coordSysType = seriesModel.get('coordinateSystem');
	
	    if (!coordSysType || coordSysType === 'view') {
	      var data = seriesModel.getData();
	      var positions = data.mapArray(function (idx) {
	        var itemModel = data.getItemModel(idx);
	        return [+itemModel.get('x'), +itemModel.get('y')];
	      });
	      var min = [];
	      var max = [];
	      bbox.fromPoints(positions, min, max); // If width or height is 0
	
	      if (max[0] - min[0] === 0) {
	        max[0] += 1;
	        min[0] -= 1;
	      }
	
	      if (max[1] - min[1] === 0) {
	        max[1] += 1;
	        min[1] -= 1;
	      }
	
	      var aspect = (max[0] - min[0]) / (max[1] - min[1]); // FIXME If get view rect after data processed?
	
	      var viewRect = getViewRect(seriesModel, api, aspect); // Position may be NaN, use view rect instead
	
	      if (isNaN(aspect)) {
	        min = [viewRect.x, viewRect.y];
	        max = [viewRect.x + viewRect.width, viewRect.y + viewRect.height];
	      }
	
	      var bbWidth = max[0] - min[0];
	      var bbHeight = max[1] - min[1];
	      var viewWidth = viewRect.width;
	      var viewHeight = viewRect.height;
	      var viewCoordSys = seriesModel.coordinateSystem = new View();
	      viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
	      viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
	      viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewWidth, viewHeight); // Update roam info
	
	      viewCoordSys.setCenter(seriesModel.get('center'));
	      viewCoordSys.setZoom(seriesModel.get('zoom'));
	      viewList.push(viewCoordSys);
	    }
	  });
	  return viewList;
	}
	
	module.exports = _default;

/***/ }),
/* 384 */
/***/ (function(module, exports) {

	function normalize(a) {
	  if (!(a instanceof Array)) {
	    a = [a, a];
	  }
	
	  return a;
	}
	
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var graph = seriesModel.getGraph();
	    var edgeData = seriesModel.getEdgeData();
	    var symbolType = normalize(seriesModel.get('edgeSymbol'));
	    var symbolSize = normalize(seriesModel.get('edgeSymbolSize'));
	    var colorQuery = 'lineStyle.normal.color'.split('.');
	    var opacityQuery = 'lineStyle.normal.opacity'.split('.');
	    edgeData.setVisual('fromSymbol', symbolType && symbolType[0]);
	    edgeData.setVisual('toSymbol', symbolType && symbolType[1]);
	    edgeData.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
	    edgeData.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
	    edgeData.setVisual('color', seriesModel.get(colorQuery));
	    edgeData.setVisual('opacity', seriesModel.get(opacityQuery));
	    edgeData.each(function (idx) {
	      var itemModel = edgeData.getItemModel(idx);
	      var edge = graph.getEdgeByIndex(idx);
	      var symbolType = normalize(itemModel.getShallow('symbol', true));
	      var symbolSize = normalize(itemModel.getShallow('symbolSize', true)); // Edge visual must after node visual
	
	      var color = itemModel.get(colorQuery);
	      var opacity = itemModel.get(opacityQuery);
	
	      switch (color) {
	        case 'source':
	          color = edge.node1.getVisual('color');
	          break;
	
	        case 'target':
	          color = edge.node2.getVisual('color');
	          break;
	      }
	
	      symbolType[0] && edge.setVisual('fromSymbol', symbolType[0]);
	      symbolType[1] && edge.setVisual('toSymbol', symbolType[1]);
	      symbolSize[0] && edge.setVisual('fromSymbolSize', symbolSize[0]);
	      symbolSize[1] && edge.setVisual('toSymbolSize', symbolSize[1]);
	      edge.setVisual('color', color);
	      edge.setVisual('opacity', opacity);
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	var vec2 = __webpack_require__(8);
	
	var scaleAndAdd = vec2.scaleAndAdd; // function adjacentNode(n, e) {
	//     return e.n1 === n ? e.n2 : e.n1;
	// }
	
	function forceLayout(nodes, edges, opts) {
	  var rect = opts.rect;
	  var width = rect.width;
	  var height = rect.height;
	  var center = [rect.x + width / 2, rect.y + height / 2]; // var scale = opts.scale || 1;
	
	  var gravity = opts.gravity == null ? 0.1 : opts.gravity; // for (var i = 0; i < edges.length; i++) {
	  //     var e = edges[i];
	  //     var n1 = e.n1;
	  //     var n2 = e.n2;
	  //     n1.edges = n1.edges || [];
	  //     n2.edges = n2.edges || [];
	  //     n1.edges.push(e);
	  //     n2.edges.push(e);
	  // }
	  // Init position
	
	  for (var i = 0; i < nodes.length; i++) {
	    var n = nodes[i];
	
	    if (!n.p) {
	      // Use the position from first adjecent node with defined position
	      // Or use a random position
	      // From d3
	      // if (n.edges) {
	      //     var j = -1;
	      //     while (++j < n.edges.length) {
	      //         var e = n.edges[j];
	      //         var other = adjacentNode(n, e);
	      //         if (other.p) {
	      //             n.p = vec2.clone(other.p);
	      //             break;
	      //         }
	      //     }
	      // }
	      // if (!n.p) {
	      n.p = vec2.create(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]); // }
	    }
	
	    n.pp = vec2.clone(n.p);
	    n.edges = null;
	  } // Formula in 'Graph Drawing by Force-directed Placement'
	  // var k = scale * Math.sqrt(width * height / nodes.length);
	  // var k2 = k * k;
	
	
	  var friction = 0.6;
	  return {
	    warmUp: function () {
	      friction = 0.5;
	    },
	    setFixed: function (idx) {
	      nodes[idx].fixed = true;
	    },
	    setUnfixed: function (idx) {
	      nodes[idx].fixed = false;
	    },
	    step: function (cb) {
	      var v12 = [];
	      var nLen = nodes.length;
	
	      for (var i = 0; i < edges.length; i++) {
	        var e = edges[i];
	        var n1 = e.n1;
	        var n2 = e.n2;
	        vec2.sub(v12, n2.p, n1.p);
	        var d = vec2.len(v12) - e.d;
	        var w = n2.w / (n1.w + n2.w);
	
	        if (isNaN(w)) {
	          w = 0;
	        }
	
	        vec2.normalize(v12, v12);
	        !n1.fixed && scaleAndAdd(n1.p, n1.p, v12, w * d * friction);
	        !n2.fixed && scaleAndAdd(n2.p, n2.p, v12, -(1 - w) * d * friction);
	      } // Gravity
	
	
	      for (var i = 0; i < nLen; i++) {
	        var n = nodes[i];
	
	        if (!n.fixed) {
	          vec2.sub(v12, center, n.p); // var d = vec2.len(v12);
	          // vec2.scale(v12, v12, 1 / d);
	          // var gravityFactor = gravity;
	
	          scaleAndAdd(n.p, n.p, v12, gravity * friction);
	        }
	      } // Repulsive
	      // PENDING
	
	
	      for (var i = 0; i < nLen; i++) {
	        var n1 = nodes[i];
	
	        for (var j = i + 1; j < nLen; j++) {
	          var n2 = nodes[j];
	          vec2.sub(v12, n2.p, n1.p);
	          var d = vec2.len(v12);
	
	          if (d === 0) {
	            // Random repulse
	            vec2.set(v12, Math.random() - 0.5, Math.random() - 0.5);
	            d = 1;
	          }
	
	          var repFact = (n1.rep + n2.rep) / d / d;
	          !n1.fixed && scaleAndAdd(n1.pp, n1.pp, v12, repFact);
	          !n2.fixed && scaleAndAdd(n2.pp, n2.pp, v12, -repFact);
	        }
	      }
	
	      var v = [];
	
	      for (var i = 0; i < nLen; i++) {
	        var n = nodes[i];
	
	        if (!n.fixed) {
	          vec2.sub(v, n.p, n.pp);
	          scaleAndAdd(n.p, n.p, v, friction);
	          vec2.copy(n.pp, n.p);
	        }
	      }
	
	      friction = friction * 0.992;
	      cb && cb(nodes, edges, friction < 0.01);
	    }
	  };
	}
	
	exports.forceLayout = forceLayout;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var _forceHelper = __webpack_require__(385);
	
	var forceLayout = _forceHelper.forceLayout;
	
	var _simpleLayoutHelper = __webpack_require__(159);
	
	var simpleLayout = _simpleLayoutHelper.simpleLayout;
	
	var _circularLayoutHelper = __webpack_require__(158);
	
	var circularLayout = _circularLayoutHelper.circularLayout;
	
	var _number = __webpack_require__(4);
	
	var linearMap = _number.linearMap;
	
	var vec2 = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(1);
	
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (graphSeries) {
	    var coordSys = graphSeries.coordinateSystem;
	
	    if (coordSys && coordSys.type !== 'view') {
	      return;
	    }
	
	    if (graphSeries.get('layout') === 'force') {
	      var preservedPoints = graphSeries.preservedPoints || {};
	      var graph = graphSeries.getGraph();
	      var nodeData = graph.data;
	      var edgeData = graph.edgeData;
	      var forceModel = graphSeries.getModel('force');
	      var initLayout = forceModel.get('initLayout');
	
	      if (graphSeries.preservedPoints) {
	        nodeData.each(function (idx) {
	          var id = nodeData.getId(idx);
	          nodeData.setItemLayout(idx, preservedPoints[id] || [NaN, NaN]);
	        });
	      } else if (!initLayout || initLayout === 'none') {
	        simpleLayout(graphSeries);
	      } else if (initLayout === 'circular') {
	        circularLayout(graphSeries);
	      }
	
	      var nodeDataExtent = nodeData.getDataExtent('value');
	      var edgeDataExtent = edgeData.getDataExtent('value'); // var edgeDataExtent = edgeData.getDataExtent('value');
	
	      var repulsion = forceModel.get('repulsion');
	      var edgeLength = forceModel.get('edgeLength');
	
	      if (!zrUtil.isArray(repulsion)) {
	        repulsion = [repulsion, repulsion];
	      }
	
	      if (!zrUtil.isArray(edgeLength)) {
	        edgeLength = [edgeLength, edgeLength];
	      } // Larger value has smaller length
	
	
	      edgeLength = [edgeLength[1], edgeLength[0]];
	      var nodes = nodeData.mapArray('value', function (value, idx) {
	        var point = nodeData.getItemLayout(idx);
	        var rep = linearMap(value, nodeDataExtent, repulsion);
	
	        if (isNaN(rep)) {
	          rep = (repulsion[0] + repulsion[1]) / 2;
	        }
	
	        return {
	          w: rep,
	          rep: rep,
	          fixed: nodeData.getItemModel(idx).get('fixed'),
	          p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
	        };
	      });
	      var edges = edgeData.mapArray('value', function (value, idx) {
	        var edge = graph.getEdgeByIndex(idx);
	        var d = linearMap(value, edgeDataExtent, edgeLength);
	
	        if (isNaN(d)) {
	          d = (edgeLength[0] + edgeLength[1]) / 2;
	        }
	
	        return {
	          n1: nodes[edge.node1.dataIndex],
	          n2: nodes[edge.node2.dataIndex],
	          d: d,
	          curveness: edge.getModel().get('lineStyle.normal.curveness') || 0
	        };
	      });
	      var coordSys = graphSeries.coordinateSystem;
	      var rect = coordSys.getBoundingRect();
	      var forceInstance = forceLayout(nodes, edges, {
	        rect: rect,
	        gravity: forceModel.get('gravity')
	      });
	      var oldStep = forceInstance.step;
	
	      forceInstance.step = function (cb) {
	        for (var i = 0, l = nodes.length; i < l; i++) {
	          if (nodes[i].fixed) {
	            // Write back to layout instance
	            vec2.copy(nodes[i].p, graph.getNodeByIndex(i).getLayout());
	          }
	        }
	
	        oldStep(function (nodes, edges, stopped) {
	          for (var i = 0, l = nodes.length; i < l; i++) {
	            if (!nodes[i].fixed) {
	              graph.getNodeByIndex(i).setLayout(nodes[i].p);
	            }
	
	            preservedPoints[nodeData.getId(i)] = nodes[i].p;
	          }
	
	          for (var i = 0, l = edges.length; i < l; i++) {
	            var e = edges[i];
	            var edge = graph.getEdgeByIndex(i);
	            var p1 = e.n1.p;
	            var p2 = e.n2.p;
	            var points = edge.getLayout();
	            points = points ? points.slice() : [];
	            points[0] = points[0] || [];
	            points[1] = points[1] || [];
	            vec2.copy(points[0], p1);
	            vec2.copy(points[1], p2);
	
	            if (+e.curveness) {
	              points[2] = [(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness];
	            }
	
	            edge.setLayout(points);
	          } // Update layout
	
	
	          cb && cb(stopped);
	        });
	      };
	
	      graphSeries.forceLayout = forceInstance;
	      graphSeries.preservedPoints = preservedPoints; // Step to get the layout
	
	      forceInstance.step();
	    } else {
	      // Remove prev injected forceLayout instance
	      graphSeries.forceLayout = null;
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var _roamHelper = __webpack_require__(155);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	var actionInfo = {
	  type: 'graphRoam',
	  event: 'graphRoam',
	  update: 'none'
	};
	/**
	 * @payload
	 * @property {string} name Series name
	 * @property {number} [dx]
	 * @property {number} [dy]
	 * @property {number} [zoom]
	 * @property {number} [originX]
	 * @property {number} [originY]
	 */
	
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    query: payload
	  }, function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var res = updateCenterAndZoom(coordSys, payload);
	    seriesModel.setCenter && seriesModel.setCenter(res.center);
	    seriesModel.setZoom && seriesModel.setZoom(res.zoom);
	  });
	});
	/**
	 * @payload
	 * @property {number} [seriesIndex]
	 * @property {string} [seriesId]
	 * @property {string} [seriesName]
	 * @property {number} [dataIndex]
	 */
	
	echarts.registerAction({
	  type: 'focusNodeAdjacency',
	  event: 'focusNodeAdjacency',
	  update: 'series.graph:focusNodeAdjacency'
	}, function () {});
	/**
	 * @payload
	 * @property {number} [seriesIndex]
	 * @property {string} [seriesId]
	 * @property {string} [seriesName]
	 */
	
	echarts.registerAction({
	  type: 'unfocusNodeAdjacency',
	  event: 'unfocusNodeAdjacency',
	  update: 'series.graph:unfocusNodeAdjacency'
	}, function () {});

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var _simpleLayoutHelper = __webpack_require__(159);
	
	var simpleLayout = _simpleLayoutHelper.simpleLayout;
	var simpleLayoutEdge = _simpleLayoutHelper.simpleLayoutEdge;
	
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var layout = seriesModel.get('layout');
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.type !== 'view') {
	      var data = seriesModel.getData();
	      var dimensions = coordSys.dimensions;
	      data.each(dimensions, function () {
	        var hasValue;
	        var args = arguments;
	        var value = [];
	
	        for (var i = 0; i < dimensions.length; i++) {
	          if (!isNaN(args[i])) {
	            hasValue = true;
	          }
	
	          value.push(args[i]);
	        }
	
	        var idx = args[args.length - 1];
	
	        if (hasValue) {
	          data.setItemLayout(idx, coordSys.dataToPoint(value));
	        } else {
	          // Also {Array.<number>}, not undefined to avoid if...else... statement
	          data.setItemLayout(idx, [NaN, NaN]);
	        }
	      });
	      simpleLayoutEdge(data.graph);
	    } else if (!layout || layout === 'none') {
	      simpleLayout(seriesModel);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(391);
	
	__webpack_require__(392);

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	/**
	 * @file defines echarts Heatmap Chart
	 * @author Ovilia (me@zhangwenli.com)
	 * Inspired by https://github.com/mourner/simpleheat
	 *
	 * @module
	 */
	var GRADIENT_LEVELS = 256;
	/**
	 * Heatmap Chart
	 *
	 * @class
	 */
	
	function Heatmap() {
	  var canvas = zrUtil.createCanvas();
	  this.canvas = canvas;
	  this.blurSize = 30;
	  this.pointSize = 20;
	  this.maxOpacity = 1;
	  this.minOpacity = 0;
	  this._gradientPixels = {};
	}
	
	Heatmap.prototype = {
	  /**
	   * Renders Heatmap and returns the rendered canvas
	   * @param {Array} data array of data, each has x, y, value
	   * @param {number} width canvas width
	   * @param {number} height canvas height
	   */
	  update: function (data, width, height, normalize, colorFunc, isInRange) {
	    var brush = this._getBrush();
	
	    var gradientInRange = this._getGradient(data, colorFunc, 'inRange');
	
	    var gradientOutOfRange = this._getGradient(data, colorFunc, 'outOfRange');
	
	    var r = this.pointSize + this.blurSize;
	    var canvas = this.canvas;
	    var ctx = canvas.getContext('2d');
	    var len = data.length;
	    canvas.width = width;
	    canvas.height = height;
	
	    for (var i = 0; i < len; ++i) {
	      var p = data[i];
	      var x = p[0];
	      var y = p[1];
	      var value = p[2]; // calculate alpha using value
	
	      var alpha = normalize(value); // draw with the circle brush with alpha
	
	      ctx.globalAlpha = alpha;
	      ctx.drawImage(brush, x - r, y - r);
	    }
	
	    if (!canvas.width || !canvas.height) {
	      // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
	      // 'CanvasRenderingContext2D': The source height is 0."
	      return canvas;
	    } // colorize the canvas using alpha value and set with gradient
	
	
	    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
	    var pixels = imageData.data;
	    var offset = 0;
	    var pixelLen = pixels.length;
	    var minOpacity = this.minOpacity;
	    var maxOpacity = this.maxOpacity;
	    var diffOpacity = maxOpacity - minOpacity;
	
	    while (offset < pixelLen) {
	      var alpha = pixels[offset + 3] / 256;
	      var gradientOffset = Math.floor(alpha * (GRADIENT_LEVELS - 1)) * 4; // Simple optimize to ignore the empty data
	
	      if (alpha > 0) {
	        var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange; // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]
	
	        alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
	        pixels[offset++] = gradient[gradientOffset];
	        pixels[offset++] = gradient[gradientOffset + 1];
	        pixels[offset++] = gradient[gradientOffset + 2];
	        pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
	      } else {
	        offset += 4;
	      }
	    }
	
	    ctx.putImageData(imageData, 0, 0);
	    return canvas;
	  },
	
	  /**
	   * get canvas of a black circle brush used for canvas to draw later
	   * @private
	   * @returns {Object} circle brush canvas
	   */
	  _getBrush: function () {
	    var brushCanvas = this._brushCanvas || (this._brushCanvas = zrUtil.createCanvas()); // set brush size
	
	    var r = this.pointSize + this.blurSize;
	    var d = r * 2;
	    brushCanvas.width = d;
	    brushCanvas.height = d;
	    var ctx = brushCanvas.getContext('2d');
	    ctx.clearRect(0, 0, d, d); // in order to render shadow without the distinct circle,
	    // draw the distinct circle in an invisible place,
	    // and use shadowOffset to draw shadow in the center of the canvas
	
	    ctx.shadowOffsetX = d;
	    ctx.shadowBlur = this.blurSize; // draw the shadow in black, and use alpha and shadow blur to generate
	    // color in color map
	
	    ctx.shadowColor = '#000'; // draw circle in the left to the canvas
	
	    ctx.beginPath();
	    ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
	    ctx.closePath();
	    ctx.fill();
	    return brushCanvas;
	  },
	
	  /**
	   * get gradient color map
	   * @private
	   */
	  _getGradient: function (data, colorFunc, state) {
	    var gradientPixels = this._gradientPixels;
	    var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(256 * 4));
	    var color = [0, 0, 0, 0];
	    var off = 0;
	
	    for (var i = 0; i < 256; i++) {
	      colorFunc[state](i / 255, true, color);
	      pixelsSingleState[off++] = color[0];
	      pixelsSingleState[off++] = color[1];
	      pixelsSingleState[off++] = color[2];
	      pixelsSingleState[off++] = color[3];
	    }
	
	    return pixelsSingleState;
	  }
	};
	var _default = Heatmap;
	module.exports = _default;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var SeriesModel = __webpack_require__(20);
	
	var createListFromArray = __webpack_require__(34);
	
	var _default = SeriesModel.extend({
	  type: 'series.heatmap',
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(option.data, this, ecModel);
	  },
	  defaultOption: {
	    // Cartesian2D or geo
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Geo coordinate system
	    geoIndex: 0,
	    blurSize: 30,
	    pointSize: 20,
	    maxOpacity: 1,
	    minOpacity: 0
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(2);
	
	var graphic = __webpack_require__(3);
	
	var HeatmapLayer = __webpack_require__(390);
	
	var zrUtil = __webpack_require__(1);
	
	function getIsInPiecewiseRange(dataExtent, pieceList, selected) {
	  var dataSpan = dataExtent[1] - dataExtent[0];
	  pieceList = zrUtil.map(pieceList, function (piece) {
	    return {
	      interval: [(piece.interval[0] - dataExtent[0]) / dataSpan, (piece.interval[1] - dataExtent[0]) / dataSpan]
	    };
	  });
	  var len = pieceList.length;
	  var lastIndex = 0;
	  return function (val) {
	    // Try to find in the location of the last found
	    for (var i = lastIndex; i < len; i++) {
	      var interval = pieceList[i].interval;
	
	      if (interval[0] <= val && val <= interval[1]) {
	        lastIndex = i;
	        break;
	      }
	    }
	
	    if (i === len) {
	      // Not found, back interation
	      for (var i = lastIndex - 1; i >= 0; i--) {
	        var interval = pieceList[i].interval;
	
	        if (interval[0] <= val && val <= interval[1]) {
	          lastIndex = i;
	          break;
	        }
	      }
	    }
	
	    return i >= 0 && i < len && selected[i];
	  };
	}
	
	function getIsInContinuousRange(dataExtent, range) {
	  var dataSpan = dataExtent[1] - dataExtent[0];
	  range = [(range[0] - dataExtent[0]) / dataSpan, (range[1] - dataExtent[0]) / dataSpan];
	  return function (val) {
	    return val >= range[0] && val <= range[1];
	  };
	}
	
	function isGeoCoordSys(coordSys) {
	  var dimensions = coordSys.dimensions; // Not use coorSys.type === 'geo' because coordSys maybe extended
	
	  return dimensions[0] === 'lng' && dimensions[1] === 'lat';
	}
	
	var _default = echarts.extendChartView({
	  type: 'heatmap',
	  render: function (seriesModel, ecModel, api) {
	    var visualMapOfThisSeries;
	    ecModel.eachComponent('visualMap', function (visualMap) {
	      visualMap.eachTargetSeries(function (targetSeries) {
	        if (targetSeries === seriesModel) {
	          visualMapOfThisSeries = visualMap;
	        }
	      });
	    });
	    this.group.removeAll();
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys.type === 'cartesian2d' || coordSys.type === 'calendar') {
	      this._renderOnCartesianAndCalendar(coordSys, seriesModel, api);
	    } else if (isGeoCoordSys(coordSys)) {
	      this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
	    }
	  },
	  dispose: function () {},
	  _renderOnCartesianAndCalendar: function (coordSys, seriesModel, api) {
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      var width = xAxis.getBandWidth();
	      var height = yAxis.getBandWidth();
	    }
	
	    var group = this.group;
	    var data = seriesModel.getData();
	    var itemStyleQuery = 'itemStyle.normal';
	    var hoverItemStyleQuery = 'itemStyle.emphasis';
	    var labelQuery = 'label.normal';
	    var hoverLabelQuery = 'label.emphasis';
	    var style = seriesModel.getModel(itemStyleQuery).getItemStyle(['color']);
	    var hoverStl = seriesModel.getModel(hoverItemStyleQuery).getItemStyle();
	    var labelModel = seriesModel.getModel('label.normal');
	    var hoverLabelModel = seriesModel.getModel('label.emphasis');
	    var coordSysType = coordSys.type;
	    var dataDims = coordSysType === 'cartesian2d' ? [seriesModel.coordDimToDataDim('x')[0], seriesModel.coordDimToDataDim('y')[0], seriesModel.coordDimToDataDim('value')[0]] : [seriesModel.coordDimToDataDim('time')[0], seriesModel.coordDimToDataDim('value')[0]];
	    data.each(function (idx) {
	      var rect;
	
	      if (coordSysType === 'cartesian2d') {
	        // Ignore empty data
	        if (isNaN(data.get(dataDims[2], idx))) {
	          return;
	        }
	
	        var point = coordSys.dataToPoint([data.get(dataDims[0], idx), data.get(dataDims[1], idx)]);
	        rect = new graphic.Rect({
	          shape: {
	            x: point[0] - width / 2,
	            y: point[1] - height / 2,
	            width: width,
	            height: height
	          },
	          style: {
	            fill: data.getItemVisual(idx, 'color'),
	            opacity: data.getItemVisual(idx, 'opacity')
	          }
	        });
	      } else {
	        // Ignore empty data
	        if (isNaN(data.get(dataDims[1], idx))) {
	          return;
	        }
	
	        rect = new graphic.Rect({
	          z2: 1,
	          shape: coordSys.dataToRect([data.get(dataDims[0], idx)]).contentShape,
	          style: {
	            fill: data.getItemVisual(idx, 'color'),
	            opacity: data.getItemVisual(idx, 'opacity')
	          }
	        });
	      }
	
	      var itemModel = data.getItemModel(idx); // Optimization for large datset
	
	      if (data.hasItemOption) {
	        style = itemModel.getModel(itemStyleQuery).getItemStyle(['color']);
	        hoverStl = itemModel.getModel(hoverItemStyleQuery).getItemStyle();
	        labelModel = itemModel.getModel(labelQuery);
	        hoverLabelModel = itemModel.getModel(hoverLabelQuery);
	      }
	
	      var rawValue = seriesModel.getRawValue(idx);
	      var defaultText = '-';
	
	      if (rawValue && rawValue[2] != null) {
	        defaultText = rawValue[2];
	      }
	
	      graphic.setLabelStyle(style, hoverStl, labelModel, hoverLabelModel, {
	        labelFetcher: seriesModel,
	        labelDataIndex: idx,
	        defaultText: defaultText,
	        isRectText: true
	      });
	      rect.setStyle(style);
	      graphic.setHoverStyle(rect, data.hasItemOption ? hoverStl : zrUtil.extend({}, hoverStl));
	      group.add(rect);
	      data.setItemGraphicEl(idx, rect);
	    });
	  },
	  _renderOnGeo: function (geo, seriesModel, visualMapModel, api) {
	    var inRangeVisuals = visualMapModel.targetVisuals.inRange;
	    var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange; // if (!visualMapping) {
	    //     throw new Error('Data range must have color visuals');
	    // }
	
	    var data = seriesModel.getData();
	    var hmLayer = this._hmLayer || this._hmLayer || new HeatmapLayer();
	    hmLayer.blurSize = seriesModel.get('blurSize');
	    hmLayer.pointSize = seriesModel.get('pointSize');
	    hmLayer.minOpacity = seriesModel.get('minOpacity');
	    hmLayer.maxOpacity = seriesModel.get('maxOpacity');
	    var rect = geo.getViewRect().clone();
	    var roamTransform = geo.getRoamTransform().transform;
	    rect.applyTransform(roamTransform); // Clamp on viewport
	
	    var x = Math.max(rect.x, 0);
	    var y = Math.max(rect.y, 0);
	    var x2 = Math.min(rect.width + rect.x, api.getWidth());
	    var y2 = Math.min(rect.height + rect.y, api.getHeight());
	    var width = x2 - x;
	    var height = y2 - y;
	    var points = data.mapArray(['lng', 'lat', 'value'], function (lng, lat, value) {
	      var pt = geo.dataToPoint([lng, lat]);
	      pt[0] -= x;
	      pt[1] -= y;
	      pt.push(value);
	      return pt;
	    });
	    var dataExtent = visualMapModel.getExtent();
	    var isInRange = visualMapModel.type === 'visualMap.continuous' ? getIsInContinuousRange(dataExtent, visualMapModel.option.range) : getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
	    hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
	      inRange: inRangeVisuals.color.getColorMapper(),
	      outOfRange: outOfRangeVisuals.color.getColorMapper()
	    }, isInRange);
	    var img = new graphic.Image({
	      style: {
	        width: width,
	        height: height,
	        x: x,
	        y: y,
	        image: hmLayer.canvas
	      },
	      silent: true
	    });
	    this.group.add(img);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	var Polyline = __webpack_require__(161);
	
	var zrUtil = __webpack_require__(1);
	
	var EffectLine = __webpack_require__(160);
	
	var vec2 = __webpack_require__(8);
	
	/**
	 * Provide effect for line
	 * @module echarts/chart/helper/EffectLine
	 */
	
	/**
	 * @constructor
	 * @extends {module:echarts/chart/helper/EffectLine}
	 * @alias {module:echarts/chart/helper/Polyline}
	 */
	function EffectPolyline(lineData, idx, seriesScope) {
	  EffectLine.call(this, lineData, idx, seriesScope);
	  this._lastFrame = 0;
	  this._lastFramePercent = 0;
	}
	
	var effectPolylineProto = EffectPolyline.prototype; // Overwrite
	
	effectPolylineProto.createLine = function (lineData, idx, seriesScope) {
	  return new Polyline(lineData, idx, seriesScope);
	}; // Overwrite
	
	
	effectPolylineProto.updateAnimationPoints = function (symbol, points) {
	  this._points = points;
	  var accLenArr = [0];
	  var len = 0;
	
	  for (var i = 1; i < points.length; i++) {
	    var p1 = points[i - 1];
	    var p2 = points[i];
	    len += vec2.dist(p1, p2);
	    accLenArr.push(len);
	  }
	
	  if (len === 0) {
	    return;
	  }
	
	  for (var i = 0; i < accLenArr.length; i++) {
	    accLenArr[i] /= len;
	  }
	
	  this._offsets = accLenArr;
	  this._length = len;
	}; // Overwrite
	
	
	effectPolylineProto.getLineLength = function (symbol) {
	  return this._length;
	}; // Overwrite
	
	
	effectPolylineProto.updateSymbolPosition = function (symbol) {
	  var t = symbol.__t;
	  var points = this._points;
	  var offsets = this._offsets;
	  var len = points.length;
	
	  if (!offsets) {
	    // Has length 0
	    return;
	  }
	
	  var lastFrame = this._lastFrame;
	  var frame;
	
	  if (t < this._lastFramePercent) {
	    // Start from the next frame
	    // PENDING start from lastFrame ?
	    var start = Math.min(lastFrame + 1, len - 1);
	
	    for (frame = start; frame >= 0; frame--) {
	      if (offsets[frame] <= t) {
	        break;
	      }
	    } // PENDING really need to do this ?
	
	
	    frame = Math.min(frame, len - 2);
	  } else {
	    for (var frame = lastFrame; frame < len; frame++) {
	      if (offsets[frame] > t) {
	        break;
	      }
	    }
	
	    frame = Math.min(frame - 1, len - 2);
	  }
	
	  vec2.lerp(symbol.position, points[frame], points[frame + 1], (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]));
	  var tx = points[frame + 1][0] - points[frame][0];
	  var ty = points[frame + 1][1] - points[frame][1];
	  symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
	  this._lastFrame = frame;
	  this._lastFramePercent = t;
	  symbol.ignore = false;
	};
	
	zrUtil.inherits(EffectPolyline, EffectLine);
	var _default = EffectPolyline;
	module.exports = _default;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var _symbol = __webpack_require__(22);
	
	var createSymbol = _symbol.createSymbol;
	
	var _graphic = __webpack_require__(3);
	
	var Group = _graphic.Group;
	
	var _number = __webpack_require__(4);
	
	var parsePercent = _number.parsePercent;
	
	var SymbolClz = __webpack_require__(83);
	
	/**
	 * Symbol with ripple effect
	 * @module echarts/chart/helper/EffectSymbol
	 */
	var EFFECT_RIPPLE_NUMBER = 3;
	
	function normalizeSymbolSize(symbolSize) {
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [+symbolSize, +symbolSize];
	  }
	
	  return symbolSize;
	}
	
	function updateRipplePath(rippleGroup, effectCfg) {
	  rippleGroup.eachChild(function (ripplePath) {
	    ripplePath.attr({
	      z: effectCfg.z,
	      zlevel: effectCfg.zlevel,
	      style: {
	        stroke: effectCfg.brushType === 'stroke' ? effectCfg.color : null,
	        fill: effectCfg.brushType === 'fill' ? effectCfg.color : null
	      }
	    });
	  });
	}
	/**
	 * @constructor
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @extends {module:zrender/graphic/Group}
	 */
	
	
	function EffectSymbol(data, idx) {
	  Group.call(this);
	  var symbol = new SymbolClz(data, idx);
	  var rippleGroup = new Group();
	  this.add(symbol);
	  this.add(rippleGroup);
	
	  rippleGroup.beforeUpdate = function () {
	    this.attr(symbol.getScale());
	  };
	
	  this.updateData(data, idx);
	}
	
	var effectSymbolProto = EffectSymbol.prototype;
	
	effectSymbolProto.stopEffectAnimation = function () {
	  this.childAt(1).removeAll();
	};
	
	effectSymbolProto.startEffectAnimation = function (effectCfg) {
	  var symbolType = effectCfg.symbolType;
	  var color = effectCfg.color;
	  var rippleGroup = this.childAt(1);
	
	  for (var i = 0; i < EFFECT_RIPPLE_NUMBER; i++) {
	    // var ripplePath = createSymbol(
	    //     symbolType, -0.5, -0.5, 1, 1, color
	    // );
	    // If width/height are set too small (e.g., set to 1) on ios10
	    // and macOS Sierra, a circle stroke become a rect, no matter what
	    // the scale is set. So we set width/height as 2. See #4136.
	    var ripplePath = createSymbol(symbolType, -1, -1, 2, 2, color);
	    ripplePath.attr({
	      style: {
	        strokeNoScale: true
	      },
	      z2: 99,
	      silent: true,
	      scale: [0.5, 0.5]
	    });
	    var delay = -i / EFFECT_RIPPLE_NUMBER * effectCfg.period + effectCfg.effectOffset; // TODO Configurable effectCfg.period
	
	    ripplePath.animate('', true).when(effectCfg.period, {
	      scale: [effectCfg.rippleScale / 2, effectCfg.rippleScale / 2]
	    }).delay(delay).start();
	    ripplePath.animateStyle(true).when(effectCfg.period, {
	      opacity: 0
	    }).delay(delay).start();
	    rippleGroup.add(ripplePath);
	  }
	
	  updateRipplePath(rippleGroup, effectCfg);
	};
	/**
	 * Update effect symbol
	 */
	
	
	effectSymbolProto.updateEffectAnimation = function (effectCfg) {
	  var oldEffectCfg = this._effectCfg;
	  var rippleGroup = this.childAt(1); // Must reinitialize effect if following configuration changed
	
	  var DIFFICULT_PROPS = ['symbolType', 'period', 'rippleScale'];
	
	  for (var i = 0; i < DIFFICULT_PROPS.length; i++) {
	    var propName = DIFFICULT_PROPS[i];
	
	    if (oldEffectCfg[propName] !== effectCfg[propName]) {
	      this.stopEffectAnimation();
	      this.startEffectAnimation(effectCfg);
	      return;
	    }
	  }
	
	  updateRipplePath(rippleGroup, effectCfg);
	};
	/**
	 * Highlight symbol
	 */
	
	
	effectSymbolProto.highlight = function () {
	  this.trigger('emphasis');
	};
	/**
	 * Downplay symbol
	 */
	
	
	effectSymbolProto.downplay = function () {
	  this.trigger('normal');
	};
	/**
	 * Update symbol properties
	 * @param  {module:echarts/data/List} data
	 * @param  {number} idx
	 */
	
	
	effectSymbolProto.updateData = function (data, idx) {
	  var seriesModel = data.hostModel;
	  this.childAt(0).updateData(data, idx);
	  var rippleGroup = this.childAt(1);
	  var itemModel = data.getItemModel(idx);
	  var symbolType = data.getItemVisual(idx, 'symbol');
	  var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
	  var color = data.getItemVisual(idx, 'color');
	  rippleGroup.attr('scale', symbolSize);
	  rippleGroup.traverse(function (ripplePath) {
	    ripplePath.attr({
	      fill: color
	    });
	  });
	  var symbolOffset = itemModel.getShallow('symbolOffset');
	
	  if (symbolOffset) {
	    var pos = rippleGroup.position;
	    pos[0] = parsePercent(symbolOffset[0], symbolSize[0]);
	    pos[1] = parsePercent(symbolOffset[1], symbolSize[1]);
	  }
	
	  rippleGroup.rotation = (itemModel.getShallow('symbolRotate') || 0) * Math.PI / 180 || 0;
	  var effectCfg = {};
	  effectCfg.showEffectOn = seriesModel.get('showEffectOn');
	  effectCfg.rippleScale = itemModel.get('rippleEffect.scale');
	  effectCfg.brushType = itemModel.get('rippleEffect.brushType');
	  effectCfg.period = itemModel.get('rippleEffect.period') * 1000;
	  effectCfg.effectOffset = idx / data.count();
	  effectCfg.z = itemModel.getShallow('z') || 0;
	  effectCfg.zlevel = itemModel.getShallow('zlevel') || 0;
	  effectCfg.symbolType = symbolType;
	  effectCfg.color = color;
	  this.off('mouseover').off('mouseout').off('emphasis').off('normal');
	
	  if (effectCfg.showEffectOn === 'render') {
	    this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
	    this._effectCfg = effectCfg;
	  } else {
	    // Not keep old effect config
	    this._effectCfg = null;
	    this.stopEffectAnimation();
	    var symbol = this.childAt(0);
	
	    var onEmphasis = function () {
	      symbol.highlight();
	
	      if (effectCfg.showEffectOn !== 'render') {
	        this.startEffectAnimation(effectCfg);
	      }
	    };
	
	    var onNormal = function () {
	      symbol.downplay();
	
	      if (effectCfg.showEffectOn !== 'render') {
	        this.stopEffectAnimation();
	      }
	    };
	
	    this.on('mouseover', onEmphasis, this).on('mouseout', onNormal, this).on('emphasis', onEmphasis, this).on('normal', onNormal, this);
	  }
	
	  this._effectCfg = effectCfg;
	};
	
	effectSymbolProto.fadeOut = function (cb) {
	  this.off('mouseover').off('mouseout').off('emphasis').off('normal');
	  cb && cb();
	};
	
	zrUtil.inherits(EffectSymbol, Group);
	var _default = EffectSymbol;
	module.exports = _default;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var graphic = __webpack_require__(3);
	
	var lineContain = __webpack_require__(216);
	
	var quadraticContain = __webpack_require__(218);
	
	// TODO Batch by color
	var LargeLineShape = graphic.extendShape({
	  shape: {
	    polyline: false,
	    segs: []
	  },
	  buildPath: function (path, shape) {
	    var segs = shape.segs;
	    var isPolyline = shape.polyline;
	
	    for (var i = 0; i < segs.length; i++) {
	      var seg = segs[i];
	
	      if (isPolyline) {
	        path.moveTo(seg[0][0], seg[0][1]);
	
	        for (var j = 1; j < seg.length; j++) {
	          path.lineTo(seg[j][0], seg[j][1]);
	        }
	      } else {
	        path.moveTo(seg[0][0], seg[0][1]);
	
	        if (seg.length > 2) {
	          path.quadraticCurveTo(seg[2][0], seg[2][1], seg[1][0], seg[1][1]);
	        } else {
	          path.lineTo(seg[1][0], seg[1][1]);
	        }
	      }
	    }
	  },
	  findDataIndex: function (x, y) {
	    var shape = this.shape;
	    var segs = shape.segs;
	    var isPolyline = shape.polyline;
	    var lineWidth = Math.max(this.style.lineWidth, 1); // Not consider transform
	
	    for (var i = 0; i < segs.length; i++) {
	      var seg = segs[i];
	
	      if (isPolyline) {
	        for (var j = 1; j < seg.length; j++) {
	          if (lineContain.containStroke(seg[j - 1][0], seg[j - 1][1], seg[j][0], seg[j][1], lineWidth, x, y)) {
	            return i;
	          }
	        }
	      } else {
	        if (seg.length > 2) {
	          if (quadraticContain.containStroke(seg[0][0], seg[0][1], seg[2][0], seg[2][1], seg[1][0], seg[1][1], lineWidth, x, y)) {
	            return i;
	          }
	        } else {
	          if (lineContain.containStroke(seg[0][0], seg[0][1], seg[1][0], seg[1][1], lineWidth, x, y)) {
	            return i;
	          }
	        }
	      }
	    }
	
	    return -1;
	  }
	});
	
	function LargeLineDraw() {
	  this.group = new graphic.Group();
	  this._lineEl = new LargeLineShape();
	}
	
	var largeLineProto = LargeLineDraw.prototype;
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 */
	
	largeLineProto.updateData = function (data) {
	  this.group.removeAll();
	  var lineEl = this._lineEl;
	  var seriesModel = data.hostModel;
	  lineEl.setShape({
	    segs: data.mapArray(data.getItemLayout),
	    polyline: seriesModel.get('polyline')
	  });
	  lineEl.useStyle(seriesModel.getModel('lineStyle.normal').getLineStyle());
	  var visualColor = data.getVisual('color');
	
	  if (visualColor) {
	    lineEl.setStyle('stroke', visualColor);
	  }
	
	  lineEl.setStyle('fill'); // Enable tooltip
	  // PENDING May have performance issue when path is extremely large
	
	  lineEl.seriesIndex = seriesModel.seriesIndex;
	  lineEl.on('mousemove', function (e) {
	    lineEl.dataIndex = null;
	    var dataIndex = lineEl.findDataIndex(e.offsetX, e.offsetY);
	
	    if (dataIndex > 0) {
	      // Provide dataIndex for tooltip
	      lineEl.dataIndex = dataIndex;
	    }
	  }); // Add back
	
	  this.group.add(lineEl);
	};
	
	largeLineProto.updateLayout = function (seriesModel) {
	  var data = seriesModel.getData();
	
	  this._lineEl.setShape({
	    segs: data.mapArray(data.getItemLayout)
	  });
	};
	
	largeLineProto.remove = function () {
	  this.group.removeAll();
	};
	
	var _default = LargeLineDraw;
	module.exports = _default;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	var graphic = __webpack_require__(3);
	
	var _symbol = __webpack_require__(22);
	
	var createSymbol = _symbol.createSymbol;
	// TODO Batch by color
	var LargeSymbolPath = graphic.extendShape({
	  shape: {
	    points: null,
	    sizes: null
	  },
	  symbolProxy: null,
	  buildPath: function (path, shape) {
	    var points = shape.points;
	    var sizes = shape.sizes;
	    var symbolProxy = this.symbolProxy;
	    var symbolProxyShape = symbolProxy.shape;
	
	    for (var i = 0; i < points.length; i++) {
	      var pt = points[i];
	
	      if (isNaN(pt[0]) || isNaN(pt[1])) {
	        continue;
	      }
	
	      var size = sizes[i];
	
	      if (size[0] < 4) {
	        // Optimize for small symbol
	        path.rect(pt[0] - size[0] / 2, pt[1] - size[1] / 2, size[0], size[1]);
	      } else {
	        symbolProxyShape.x = pt[0] - size[0] / 2;
	        symbolProxyShape.y = pt[1] - size[1] / 2;
	        symbolProxyShape.width = size[0];
	        symbolProxyShape.height = size[1];
	        symbolProxy.buildPath(path, symbolProxyShape, true);
	      }
	    }
	  },
	  findDataIndex: function (x, y) {
	    var shape = this.shape;
	    var points = shape.points;
	    var sizes = shape.sizes; // Not consider transform
	    // Treat each element as a rect
	    // top down traverse
	
	    for (var i = points.length - 1; i >= 0; i--) {
	      var pt = points[i];
	      var size = sizes[i];
	      var x0 = pt[0] - size[0] / 2;
	      var y0 = pt[1] - size[1] / 2;
	
	      if (x >= x0 && y >= y0 && x <= x0 + size[0] && y <= y0 + size[1]) {
	        // i is dataIndex
	        return i;
	      }
	    }
	
	    return -1;
	  }
	});
	
	function LargeSymbolDraw() {
	  this.group = new graphic.Group();
	  this._symbolEl = new LargeSymbolPath({// rectHover: true,
	    // cursor: 'default'
	  });
	}
	
	var largeSymbolProto = LargeSymbolDraw.prototype;
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 */
	
	largeSymbolProto.updateData = function (data) {
	  this.group.removeAll();
	  var symbolEl = this._symbolEl;
	  var seriesModel = data.hostModel;
	  symbolEl.setShape({
	    points: data.mapArray(data.getItemLayout),
	    sizes: data.mapArray(function (idx) {
	      var size = data.getItemVisual(idx, 'symbolSize');
	
	      if (!(size instanceof Array)) {
	        size = [size, size];
	      }
	
	      return size;
	    })
	  }); // Create symbolProxy to build path for each data
	
	  symbolEl.symbolProxy = createSymbol(data.getVisual('symbol'), 0, 0, 0, 0); // Use symbolProxy setColor method
	
	  symbolEl.setColor = symbolEl.symbolProxy.setColor;
	  symbolEl.useStyle(seriesModel.getModel('itemStyle.normal').getItemStyle(['color']));
	  var visualColor = data.getVisual('color');
	
	  if (visualColor) {
	    symbolEl.setColor(visualColor);
	  } // Enable tooltip
	  // PENDING May have performance issue when path is extremely large
	
	
	  symbolEl.seriesIndex = seriesModel.seriesIndex;
	  symbolEl.on('mousemove', function (e) {
	    symbolEl.dataIndex = null;
	    var dataIndex = symbolEl.findDataIndex(e.offsetX, e.offsetY);
	
	    if (dataIndex >= 0) {
	      // Provide dataIndex for tooltip
	      symbolEl.dataIndex = dataIndex;
	    }
	  }); // Add back
	
	  this.group.add(symbolEl);
	};
	
	largeSymbolProto.updateLayout = function (seriesModel) {
	  var data = seriesModel.getData();
	
	  this._symbolEl.setShape({
	    points: data.mapArray(data.getItemLayout)
	  });
	};
	
	largeSymbolProto.remove = function () {
	  this.group.removeAll();
	};
	
	var _default = LargeSymbolDraw;
	module.exports = _default;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	var graphic = __webpack_require__(3);
	
	var vec2 = __webpack_require__(8);
	
	/**
	 * Line path for bezier and straight line draw
	 */
	var straightLineProto = graphic.Line.prototype;
	var bezierCurveProto = graphic.BezierCurve.prototype;
	
	function isLine(shape) {
	  return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
	}
	
	var _default = graphic.extendShape({
	  type: 'ec-line',
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    percent: 1,
	    cpx1: null,
	    cpy1: null
	  },
	  buildPath: function (ctx, shape) {
	    (isLine(shape) ? straightLineProto : bezierCurveProto).buildPath(ctx, shape);
	  },
	  pointAt: function (t) {
	    return isLine(this.shape) ? straightLineProto.pointAt.call(this, t) : bezierCurveProto.pointAt.call(this, t);
	  },
	  tangentAt: function (t) {
	    var shape = this.shape;
	    var p = isLine(shape) ? [shape.x2 - shape.x1, shape.y2 - shape.y1] : bezierCurveProto.tangentAt.call(this, t);
	    return vec2.normalize(p, p);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var Path = __webpack_require__(19);
	
	/**
	 * @module echarts/chart/helper/Symbol
	 */
	var WhiskerPath = Path.extend({
	  type: 'whiskerInBox',
	  shape: {},
	  buildPath: function (ctx, shape) {
	    for (var i in shape) {
	      if (shape.hasOwnProperty(i) && i.indexOf('ends') === 0) {
	        var pts = shape[i];
	        ctx.moveTo(pts[0][0], pts[0][1]);
	        ctx.lineTo(pts[1][0], pts[1][1]);
	      }
	    }
	  }
	});
	/**
	 * @constructor
	 * @alias {module:echarts/chart/helper/WhiskerBox}
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @param {Function} styleUpdater
	 * @param {boolean} isInit
	 * @extends {module:zrender/graphic/Group}
	 */
	
	function WhiskerBox(data, idx, styleUpdater, isInit) {
	  graphic.Group.call(this);
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.bodyIndex;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.whiskerIndex;
	  /**
	   * @type {Function}
	   */
	
	  this.styleUpdater = styleUpdater;
	
	  this._createContent(data, idx, isInit);
	
	  this.updateData(data, idx, isInit);
	  /**
	   * Last series model.
	   * @type {module:echarts/model/Series}
	   */
	
	  this._seriesModel;
	}
	
	var whiskerBoxProto = WhiskerBox.prototype;
	
	whiskerBoxProto._createContent = function (data, idx, isInit) {
	  var itemLayout = data.getItemLayout(idx);
	  var constDim = itemLayout.chartLayout === 'horizontal' ? 1 : 0;
	  var count = 0; // Whisker element.
	
	  this.add(new graphic.Polygon({
	    shape: {
	      points: isInit ? transInit(itemLayout.bodyEnds, constDim, itemLayout) : itemLayout.bodyEnds
	    },
	    style: {
	      strokeNoScale: true
	    },
	    z2: 100
	  }));
	  this.bodyIndex = count++; // Box element.
	
	  var whiskerEnds = zrUtil.map(itemLayout.whiskerEnds, function (ends) {
	    return isInit ? transInit(ends, constDim, itemLayout) : ends;
	  });
	  this.add(new WhiskerPath({
	    shape: makeWhiskerEndsShape(whiskerEnds),
	    style: {
	      strokeNoScale: true
	    },
	    z2: 100
	  }));
	  this.whiskerIndex = count++;
	};
	
	function transInit(points, dim, itemLayout) {
	  return zrUtil.map(points, function (point) {
	    point = point.slice();
	    point[dim] = itemLayout.initBaseline;
	    return point;
	  });
	}
	
	function makeWhiskerEndsShape(whiskerEnds) {
	  // zr animation only support 2-dim array.
	  var shape = {};
	  zrUtil.each(whiskerEnds, function (ends, i) {
	    shape['ends' + i] = ends;
	  });
	  return shape;
	}
	/**
	 * Update symbol properties
	 * @param  {module:echarts/data/List} data
	 * @param  {number} idx
	 */
	
	
	whiskerBoxProto.updateData = function (data, idx, isInit) {
	  var seriesModel = this._seriesModel = data.hostModel;
	  var itemLayout = data.getItemLayout(idx);
	  var updateMethod = graphic[isInit ? 'initProps' : 'updateProps']; // this.childAt(this.bodyIndex).stopAnimation(true);
	  // this.childAt(this.whiskerIndex).stopAnimation(true);
	
	  updateMethod(this.childAt(this.bodyIndex), {
	    shape: {
	      points: itemLayout.bodyEnds
	    }
	  }, seriesModel, idx);
	  updateMethod(this.childAt(this.whiskerIndex), {
	    shape: makeWhiskerEndsShape(itemLayout.whiskerEnds)
	  }, seriesModel, idx);
	  this.styleUpdater.call(null, this, data, idx);
	};
	
	zrUtil.inherits(WhiskerBox, graphic.Group);
	/**
	 * @constructor
	 * @alias module:echarts/chart/helper/WhiskerBoxDraw
	 */
	
	function WhiskerBoxDraw(styleUpdater) {
	  this.group = new graphic.Group();
	  this.styleUpdater = styleUpdater;
	}
	
	var whiskerBoxDrawProto = WhiskerBoxDraw.prototype;
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 */
	
	whiskerBoxDrawProto.updateData = function (data) {
	  var group = this.group;
	  var oldData = this._data;
	  var styleUpdater = this.styleUpdater;
	  data.diff(oldData).add(function (newIdx) {
	    if (data.hasValue(newIdx)) {
	      var symbolEl = new WhiskerBox(data, newIdx, styleUpdater, true);
	      data.setItemGraphicEl(newIdx, symbolEl);
	      group.add(symbolEl);
	    }
	  }).update(function (newIdx, oldIdx) {
	    var symbolEl = oldData.getItemGraphicEl(oldIdx); // Empty data
	
	    if (!data.hasValue(newIdx)) {
	      group.remove(symbolEl);
	      return;
	    }
	
	    if (!symbolEl) {
	      symbolEl = new WhiskerBox(data, newIdx, styleUpdater);
	    } else {
	      symbolEl.updateData(data, newIdx);
	    } // Add back
	
	
	    group.add(symbolEl);
	    data.setItemGraphicEl(newIdx, symbolEl);
	  }).remove(function (oldIdx) {
	    var el = oldData.getItemGraphicEl(oldIdx);
	    el && group.remove(el);
	  }).execute();
	  this._data = data;
	};
	/**
	 * Remove symbols.
	 * @param {module:echarts/data/List} data
	 */
	
	
	whiskerBoxDrawProto.remove = function () {
	  var group = this.group;
	  var data = this._data;
	  this._data = null;
	  data && data.eachItemGraphicEl(function (el) {
	    el && group.remove(el);
	  });
	};
	
	var _default = WhiskerBoxDraw;
	module.exports = _default;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	__webpack_require__(400);
	
	__webpack_require__(401);
	
	var visualSymbol = __webpack_require__(47);
	
	var layoutPoints = __webpack_require__(129);
	
	var dataSample = __webpack_require__(592);
	
	__webpack_require__(70);
	
	// In case developer forget to include grid component
	echarts.registerVisual(zrUtil.curry(visualSymbol, 'line', 'circle', 'line'));
	echarts.registerLayout(zrUtil.curry(layoutPoints, 'line')); // Down sample after filter
	
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, zrUtil.curry(dataSample, 'line'));

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var createListFromArray = __webpack_require__(34);
	
	var SeriesModel = __webpack_require__(20);
	
	var _default = SeriesModel.extend({
	  type: 'series.line',
	  dependencies: ['grid', 'polar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(option.data, this, ecModel);
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // stack: null
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // polarIndex: 0,
	    // If clip the overflow value
	    clipOverflow: true,
	    // cursor: null,
	    label: {
	      normal: {
	        position: 'top'
	      }
	    },
	    // itemStyle: {
	    //     normal: {},
	    //     emphasis: {}
	    // },
	    lineStyle: {
	      normal: {
	        width: 2,
	        type: 'solid'
	      }
	    },
	    // areaStyle: {},
	    // false, 'start', 'end', 'middle'
	    step: false,
	    // Disabled if step is true
	    smooth: false,
	    smoothMonotone: null,
	    // 拐点图形类型
	    symbol: 'emptyCircle',
	    // 拐点图形大小
	    symbolSize: 4,
	    // 拐点图形旋转控制
	    symbolRotate: null,
	    // 是否显示 symbol, 只有在 tooltip hover 的时候显示
	    showSymbol: true,
	    // 标志图形默认只有主轴显示（随主轴标签间隔隐藏策略）
	    showAllSymbol: false,
	    // 是否连接断点
	    connectNulls: false,
	    // 数据过滤，'average', 'max', 'min', 'sum'
	    sampling: 'none',
	    animationEasing: 'linear',
	    // Disable progressive
	    progressive: 0,
	    hoverLayerThreshold: Infinity
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(1);
	
	var SymbolDraw = __webpack_require__(65);
	
	var SymbolClz = __webpack_require__(83);
	
	var lineAnimationDiff = __webpack_require__(402);
	
	var graphic = __webpack_require__(3);
	
	var modelUtil = __webpack_require__(6);
	
	var _poly = __webpack_require__(164);
	
	var Polyline = _poly.Polyline;
	var Polygon = _poly.Polygon;
	
	var ChartView = __webpack_require__(37);
	
	// FIXME step not support polar
	function isPointsSame(points1, points2) {
	  if (points1.length !== points2.length) {
	    return;
	  }
	
	  for (var i = 0; i < points1.length; i++) {
	    var p1 = points1[i];
	    var p2 = points2[i];
	
	    if (p1[0] !== p2[0] || p1[1] !== p2[1]) {
	      return;
	    }
	  }
	
	  return true;
	}
	
	function getSmooth(smooth) {
	  return typeof smooth === 'number' ? smooth : smooth ? 0.3 : 0;
	}
	
	function getAxisExtentWithGap(axis) {
	  var extent = axis.getGlobalExtent();
	
	  if (axis.onBand) {
	    // Remove extra 1px to avoid line miter in clipped edge
	    var halfBandWidth = axis.getBandWidth() / 2 - 1;
	    var dir = extent[1] > extent[0] ? 1 : -1;
	    extent[0] += dir * halfBandWidth;
	    extent[1] -= dir * halfBandWidth;
	  }
	
	  return extent;
	}
	
	function sign(val) {
	  return val >= 0 ? 1 : -1;
	}
	/**
	 * @param {module:echarts/coord/cartesian/Cartesian2D|module:echarts/coord/polar/Polar} coordSys
	 * @param {module:echarts/data/List} data
	 * @param {Array.<Array.<number>>} points
	 * @private
	 */
	
	
	function getStackedOnPoints(coordSys, data) {
	  var baseAxis = coordSys.getBaseAxis();
	  var valueAxis = coordSys.getOtherAxis(baseAxis);
	  var valueStart = 0;
	
	  if (!baseAxis.onZero) {
	    var extent = valueAxis.scale.getExtent();
	
	    if (extent[0] > 0) {
	      // Both positive
	      valueStart = extent[0];
	    } else if (extent[1] < 0) {
	      // Both negative
	      valueStart = extent[1];
	    } // If is one positive, and one negative, onZero shall be true
	
	  }
	
	  var valueDim = valueAxis.dim;
	  var baseDataOffset = valueDim === 'x' || valueDim === 'radius' ? 1 : 0;
	  return data.mapArray([valueDim], function (val, idx) {
	    var stackedOnSameSign;
	    var stackedOn = data.stackedOn; // Find first stacked value with same sign
	
	    while (stackedOn && sign(stackedOn.get(valueDim, idx)) === sign(val)) {
	      stackedOnSameSign = stackedOn;
	      break;
	    }
	
	    var stackedData = [];
	    stackedData[baseDataOffset] = data.get(baseAxis.dim, idx);
	    stackedData[1 - baseDataOffset] = stackedOnSameSign ? stackedOnSameSign.get(valueDim, idx, true) : valueStart;
	    return coordSys.dataToPoint(stackedData);
	  }, true);
	}
	
	function createGridClipShape(cartesian, hasAnimation, seriesModel) {
	  var xExtent = getAxisExtentWithGap(cartesian.getAxis('x'));
	  var yExtent = getAxisExtentWithGap(cartesian.getAxis('y'));
	  var isHorizontal = cartesian.getBaseAxis().isHorizontal();
	  var x = Math.min(xExtent[0], xExtent[1]);
	  var y = Math.min(yExtent[0], yExtent[1]);
	  var width = Math.max(xExtent[0], xExtent[1]) - x;
	  var height = Math.max(yExtent[0], yExtent[1]) - y;
	  var lineWidth = seriesModel.get('lineStyle.normal.width') || 2; // Expand clip shape to avoid clipping when line value exceeds axis
	
	  var expandSize = seriesModel.get('clipOverflow') ? lineWidth / 2 : Math.max(width, height);
	
	  if (isHorizontal) {
	    y -= expandSize;
	    height += expandSize * 2;
	  } else {
	    x -= expandSize;
	    width += expandSize * 2;
	  }
	
	  var clipPath = new graphic.Rect({
	    shape: {
	      x: x,
	      y: y,
	      width: width,
	      height: height
	    }
	  });
	
	  if (hasAnimation) {
	    clipPath.shape[isHorizontal ? 'width' : 'height'] = 0;
	    graphic.initProps(clipPath, {
	      shape: {
	        width: width,
	        height: height
	      }
	    }, seriesModel);
	  }
	
	  return clipPath;
	}
	
	function createPolarClipShape(polar, hasAnimation, seriesModel) {
	  var angleAxis = polar.getAngleAxis();
	  var radiusAxis = polar.getRadiusAxis();
	  var radiusExtent = radiusAxis.getExtent();
	  var angleExtent = angleAxis.getExtent();
	  var RADIAN = Math.PI / 180;
	  var clipPath = new graphic.Sector({
	    shape: {
	      cx: polar.cx,
	      cy: polar.cy,
	      r0: radiusExtent[0],
	      r: radiusExtent[1],
	      startAngle: -angleExtent[0] * RADIAN,
	      endAngle: -angleExtent[1] * RADIAN,
	      clockwise: angleAxis.inverse
	    }
	  });
	
	  if (hasAnimation) {
	    clipPath.shape.endAngle = -angleExtent[0] * RADIAN;
	    graphic.initProps(clipPath, {
	      shape: {
	        endAngle: -angleExtent[1] * RADIAN
	      }
	    }, seriesModel);
	  }
	
	  return clipPath;
	}
	
	function createClipShape(coordSys, hasAnimation, seriesModel) {
	  return coordSys.type === 'polar' ? createPolarClipShape(coordSys, hasAnimation, seriesModel) : createGridClipShape(coordSys, hasAnimation, seriesModel);
	}
	
	function turnPointsIntoStep(points, coordSys, stepTurnAt) {
	  var baseAxis = coordSys.getBaseAxis();
	  var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
	  var stepPoints = [];
	
	  for (var i = 0; i < points.length - 1; i++) {
	    var nextPt = points[i + 1];
	    var pt = points[i];
	    stepPoints.push(pt);
	    var stepPt = [];
	
	    switch (stepTurnAt) {
	      case 'end':
	        stepPt[baseIndex] = nextPt[baseIndex];
	        stepPt[1 - baseIndex] = pt[1 - baseIndex]; // default is start
	
	        stepPoints.push(stepPt);
	        break;
	
	      case 'middle':
	        // default is start
	        var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
	        var stepPt2 = [];
	        stepPt[baseIndex] = stepPt2[baseIndex] = middle;
	        stepPt[1 - baseIndex] = pt[1 - baseIndex];
	        stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
	        stepPoints.push(stepPt);
	        stepPoints.push(stepPt2);
	        break;
	
	      default:
	        stepPt[baseIndex] = pt[baseIndex];
	        stepPt[1 - baseIndex] = nextPt[1 - baseIndex]; // default is start
	
	        stepPoints.push(stepPt);
	    }
	  } // Last points
	
	
	  points[i] && stepPoints.push(points[i]);
	  return stepPoints;
	}
	
	function getVisualGradient(data, coordSys) {
	  var visualMetaList = data.getVisual('visualMeta');
	
	  if (!visualMetaList || !visualMetaList.length || !data.count()) {
	    // When data.count() is 0, gradient range can not be calculated.
	    return;
	  }
	
	  var visualMeta;
	
	  for (var i = visualMetaList.length - 1; i >= 0; i--) {
	    // Can only be x or y
	    if (visualMetaList[i].dimension < 2) {
	      visualMeta = visualMetaList[i];
	      break;
	    }
	  }
	
	  if (!visualMeta || coordSys.type !== 'cartesian2d') {
	    return;
	  } // If the area to be rendered is bigger than area defined by LinearGradient,
	  // the canvas spec prescribes that the color of the first stop and the last
	  // stop should be used. But if two stops are added at offset 0, in effect
	  // browsers use the color of the second stop to render area outside
	  // LinearGradient. So we can only infinitesimally extend area defined in
	  // LinearGradient to render `outerColors`.
	
	
	  var dimension = visualMeta.dimension;
	  var dimName = data.dimensions[dimension];
	  var axis = coordSys.getAxis(dimName); // dataToCoor mapping may not be linear, but must be monotonic.
	
	  var colorStops = zrUtil.map(visualMeta.stops, function (stop) {
	    return {
	      coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
	      color: stop.color
	    };
	  });
	  var stopLen = colorStops.length;
	  var outerColors = visualMeta.outerColors.slice();
	
	  if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
	    colorStops.reverse();
	    outerColors.reverse();
	  }
	
	  var tinyExtent = 10; // Arbitrary value: 10px
	
	  var minCoord = colorStops[0].coord - tinyExtent;
	  var maxCoord = colorStops[stopLen - 1].coord + tinyExtent;
	  var coordSpan = maxCoord - minCoord;
	
	  if (coordSpan < 1e-3) {
	    return 'transparent';
	  }
	
	  zrUtil.each(colorStops, function (stop) {
	    stop.offset = (stop.coord - minCoord) / coordSpan;
	  });
	  colorStops.push({
	    offset: stopLen ? colorStops[stopLen - 1].offset : 0.5,
	    color: outerColors[1] || 'transparent'
	  });
	  colorStops.unshift({
	    // notice colorStops.length have been changed.
	    offset: stopLen ? colorStops[0].offset : 0.5,
	    color: outerColors[0] || 'transparent'
	  }); // zrUtil.each(colorStops, function (colorStop) {
	  //     // Make sure each offset has rounded px to avoid not sharp edge
	  //     colorStop.offset = (Math.round(colorStop.offset * (end - start) + start) - start) / (end - start);
	  // });
	
	  var gradient = new graphic.LinearGradient(0, 0, 0, 0, colorStops, true);
	  gradient[dimName] = minCoord;
	  gradient[dimName + '2'] = maxCoord;
	  return gradient;
	}
	
	var _default = ChartView.extend({
	  type: 'line',
	  init: function () {
	    var lineGroup = new graphic.Group();
	    var symbolDraw = new SymbolDraw();
	    this.group.add(symbolDraw.group);
	    this._symbolDraw = symbolDraw;
	    this._lineGroup = lineGroup;
	  },
	  render: function (seriesModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var group = this.group;
	    var data = seriesModel.getData();
	    var lineStyleModel = seriesModel.getModel('lineStyle.normal');
	    var areaStyleModel = seriesModel.getModel('areaStyle.normal');
	    var points = data.mapArray(data.getItemLayout, true);
	    var isCoordSysPolar = coordSys.type === 'polar';
	    var prevCoordSys = this._coordSys;
	    var symbolDraw = this._symbolDraw;
	    var polyline = this._polyline;
	    var polygon = this._polygon;
	    var lineGroup = this._lineGroup;
	    var hasAnimation = seriesModel.get('animation');
	    var isAreaChart = !areaStyleModel.isEmpty();
	    var stackedOnPoints = getStackedOnPoints(coordSys, data);
	    var showSymbol = seriesModel.get('showSymbol');
	
	    var isSymbolIgnore = showSymbol && !isCoordSysPolar && !seriesModel.get('showAllSymbol') && this._getSymbolIgnoreFunc(data, coordSys); // Remove temporary symbols
	
	
	    var oldData = this._data;
	    oldData && oldData.eachItemGraphicEl(function (el, idx) {
	      if (el.__temp) {
	        group.remove(el);
	        oldData.setItemGraphicEl(idx, null);
	      }
	    }); // Remove previous created symbols if showSymbol changed to false
	
	    if (!showSymbol) {
	      symbolDraw.remove();
	    }
	
	    group.add(lineGroup); // FIXME step not support polar
	
	    var step = !isCoordSysPolar && seriesModel.get('step'); // Initialization animation or coordinate system changed
	
	    if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
	      showSymbol && symbolDraw.updateData(data, isSymbolIgnore);
	
	      if (step) {
	        // TODO If stacked series is not step
	        points = turnPointsIntoStep(points, coordSys, step);
	        stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
	      }
	
	      polyline = this._newPolyline(points, coordSys, hasAnimation);
	
	      if (isAreaChart) {
	        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
	      }
	
	      lineGroup.setClipPath(createClipShape(coordSys, true, seriesModel));
	    } else {
	      if (isAreaChart && !polygon) {
	        // If areaStyle is added
	        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
	      } else if (polygon && !isAreaChart) {
	        // If areaStyle is removed
	        lineGroup.remove(polygon);
	        polygon = this._polygon = null;
	      } // Update clipPath
	
	
	      lineGroup.setClipPath(createClipShape(coordSys, false, seriesModel)); // Always update, or it is wrong in the case turning on legend
	      // because points are not changed
	
	      showSymbol && symbolDraw.updateData(data, isSymbolIgnore); // Stop symbol animation and sync with line points
	      // FIXME performance?
	
	      data.eachItemGraphicEl(function (el) {
	        el.stopAnimation(true);
	      }); // In the case data zoom triggerred refreshing frequently
	      // Data may not change if line has a category axis. So it should animate nothing
	
	      if (!isPointsSame(this._stackedOnPoints, stackedOnPoints) || !isPointsSame(this._points, points)) {
	        if (hasAnimation) {
	          this._updateAnimation(data, stackedOnPoints, coordSys, api, step);
	        } else {
	          // Not do it in update with animation
	          if (step) {
	            // TODO If stacked series is not step
	            points = turnPointsIntoStep(points, coordSys, step);
	            stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
	          }
	
	          polyline.setShape({
	            points: points
	          });
	          polygon && polygon.setShape({
	            points: points,
	            stackedOnPoints: stackedOnPoints
	          });
	        }
	      }
	    }
	
	    var visualColor = getVisualGradient(data, coordSys) || data.getVisual('color');
	    polyline.useStyle(zrUtil.defaults( // Use color in lineStyle first
	    lineStyleModel.getLineStyle(), {
	      fill: 'none',
	      stroke: visualColor,
	      lineJoin: 'bevel'
	    }));
	    var smooth = seriesModel.get('smooth');
	    smooth = getSmooth(seriesModel.get('smooth'));
	    polyline.setShape({
	      smooth: smooth,
	      smoothMonotone: seriesModel.get('smoothMonotone'),
	      connectNulls: seriesModel.get('connectNulls')
	    });
	
	    if (polygon) {
	      var stackedOn = data.stackedOn;
	      var stackedOnSmooth = 0;
	      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
	        fill: visualColor,
	        opacity: 0.7,
	        lineJoin: 'bevel'
	      }));
	
	      if (stackedOn) {
	        var stackedOnSeries = stackedOn.hostModel;
	        stackedOnSmooth = getSmooth(stackedOnSeries.get('smooth'));
	      }
	
	      polygon.setShape({
	        smooth: smooth,
	        stackedOnSmooth: stackedOnSmooth,
	        smoothMonotone: seriesModel.get('smoothMonotone'),
	        connectNulls: seriesModel.get('connectNulls')
	      });
	    }
	
	    this._data = data; // Save the coordinate system for transition animation when data changed
	
	    this._coordSys = coordSys;
	    this._stackedOnPoints = stackedOnPoints;
	    this._points = points;
	    this._step = step;
	  },
	  dispose: function () {},
	  highlight: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var dataIndex = modelUtil.queryDataIndex(data, payload);
	
	    if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
	      var symbol = data.getItemGraphicEl(dataIndex);
	
	      if (!symbol) {
	        // Create a temporary symbol if it is not exists
	        var pt = data.getItemLayout(dataIndex);
	
	        if (!pt) {
	          // Null data
	          return;
	        }
	
	        symbol = new SymbolClz(data, dataIndex);
	        symbol.position = pt;
	        symbol.setZ(seriesModel.get('zlevel'), seriesModel.get('z'));
	        symbol.ignore = isNaN(pt[0]) || isNaN(pt[1]);
	        symbol.__temp = true;
	        data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation
	
	        symbol.stopSymbolAnimation(true);
	        this.group.add(symbol);
	      }
	
	      symbol.highlight();
	    } else {
	      // Highlight whole series
	      ChartView.prototype.highlight.call(this, seriesModel, ecModel, api, payload);
	    }
	  },
	  downplay: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var dataIndex = modelUtil.queryDataIndex(data, payload);
	
	    if (dataIndex != null && dataIndex >= 0) {
	      var symbol = data.getItemGraphicEl(dataIndex);
	
	      if (symbol) {
	        if (symbol.__temp) {
	          data.setItemGraphicEl(dataIndex, null);
	          this.group.remove(symbol);
	        } else {
	          symbol.downplay();
	        }
	      }
	    } else {
	      // FIXME
	      // can not downplay completely.
	      // Downplay whole series
	      ChartView.prototype.downplay.call(this, seriesModel, ecModel, api, payload);
	    }
	  },
	
	  /**
	   * @param {module:zrender/container/Group} group
	   * @param {Array.<Array.<number>>} points
	   * @private
	   */
	  _newPolyline: function (points) {
	    var polyline = this._polyline; // Remove previous created polyline
	
	    if (polyline) {
	      this._lineGroup.remove(polyline);
	    }
	
	    polyline = new Polyline({
	      shape: {
	        points: points
	      },
	      silent: true,
	      z2: 10
	    });
	
	    this._lineGroup.add(polyline);
	
	    this._polyline = polyline;
	    return polyline;
	  },
	
	  /**
	   * @param {module:zrender/container/Group} group
	   * @param {Array.<Array.<number>>} stackedOnPoints
	   * @param {Array.<Array.<number>>} points
	   * @private
	   */
	  _newPolygon: function (points, stackedOnPoints) {
	    var polygon = this._polygon; // Remove previous created polygon
	
	    if (polygon) {
	      this._lineGroup.remove(polygon);
	    }
	
	    polygon = new Polygon({
	      shape: {
	        points: points,
	        stackedOnPoints: stackedOnPoints
	      },
	      silent: true
	    });
	
	    this._lineGroup.add(polygon);
	
	    this._polygon = polygon;
	    return polygon;
	  },
	
	  /**
	   * @private
	   */
	  _getSymbolIgnoreFunc: function (data, coordSys) {
	    var categoryAxis = coordSys.getAxesByScale('ordinal')[0]; // `getLabelInterval` is provided by echarts/component/axis
	
	    if (categoryAxis && categoryAxis.isLabelIgnored) {
	      return zrUtil.bind(categoryAxis.isLabelIgnored, categoryAxis);
	    }
	  },
	
	  /**
	   * @private
	   */
	  // FIXME Two value axis
	  _updateAnimation: function (data, stackedOnPoints, coordSys, api, step) {
	    var polyline = this._polyline;
	    var polygon = this._polygon;
	    var seriesModel = data.hostModel;
	    var diff = lineAnimationDiff(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys);
	    var current = diff.current;
	    var stackedOnCurrent = diff.stackedOnCurrent;
	    var next = diff.next;
	    var stackedOnNext = diff.stackedOnNext;
	
	    if (step) {
	      // TODO If stacked series is not step
	      current = turnPointsIntoStep(diff.current, coordSys, step);
	      stackedOnCurrent = turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step);
	      next = turnPointsIntoStep(diff.next, coordSys, step);
	      stackedOnNext = turnPointsIntoStep(diff.stackedOnNext, coordSys, step);
	    } // `diff.current` is subset of `current` (which should be ensured by
	    // turnPointsIntoStep), so points in `__points` can be updated when
	    // points in `current` are update during animation.
	
	
	    polyline.shape.__points = diff.current;
	    polyline.shape.points = current;
	    graphic.updateProps(polyline, {
	      shape: {
	        points: next
	      }
	    }, seriesModel);
	
	    if (polygon) {
	      polygon.setShape({
	        points: current,
	        stackedOnPoints: stackedOnCurrent
	      });
	      graphic.updateProps(polygon, {
	        shape: {
	          points: next,
	          stackedOnPoints: stackedOnNext
	        }
	      }, seriesModel);
	    }
	
	    var updatedDataInfo = [];
	    var diffStatus = diff.status;
	
	    for (var i = 0; i < diffStatus.length; i++) {
	      var cmd = diffStatus[i].cmd;
	
	      if (cmd === '=') {
	        var el = data.getItemGraphicEl(diffStatus[i].idx1);
	
	        if (el) {
	          updatedDataInfo.push({
	            el: el,
	            ptIdx: i // Index of points
	
	          });
	        }
	      }
	    }
	
	    if (polyline.animators && polyline.animators.length) {
	      polyline.animators[0].during(function () {
	        for (var i = 0; i < updatedDataInfo.length; i++) {
	          var el = updatedDataInfo[i].el;
	          el.attr('position', polyline.shape.__points[updatedDataInfo[i].ptIdx]);
	        }
	      });
	    }
	  },
	  remove: function (ecModel) {
	    var group = this.group;
	    var oldData = this._data;
	
	    this._lineGroup.removeAll();
	
	    this._symbolDraw.remove(true); // Remove temporary created elements when highlighting
	
	
	    oldData && oldData.eachItemGraphicEl(function (el, idx) {
	      if (el.__temp) {
	        group.remove(el);
	        oldData.setItemGraphicEl(idx, null);
	      }
	    });
	    this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._data = null;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	// var arrayDiff = require('zrender/src/core/arrayDiff');
	// 'zrender/src/core/arrayDiff' has been used before, but it did
	// not do well in performance when roam with fixed dataZoom window.
	function sign(val) {
	  return val >= 0 ? 1 : -1;
	}
	
	function getStackedOnPoint(coordSys, data, idx) {
	  var baseAxis = coordSys.getBaseAxis();
	  var valueAxis = coordSys.getOtherAxis(baseAxis);
	  var valueStart = baseAxis.onZero ? 0 : valueAxis.scale.getExtent()[0];
	  var valueDim = valueAxis.dim;
	  var baseDataOffset = valueDim === 'x' || valueDim === 'radius' ? 1 : 0;
	  var stackedOnSameSign;
	  var stackedOn = data.stackedOn;
	  var val = data.get(valueDim, idx); // Find first stacked value with same sign
	
	  while (stackedOn && sign(stackedOn.get(valueDim, idx)) === sign(val)) {
	    stackedOnSameSign = stackedOn;
	    break;
	  }
	
	  var stackedData = [];
	  stackedData[baseDataOffset] = data.get(baseAxis.dim, idx);
	  stackedData[1 - baseDataOffset] = stackedOnSameSign ? stackedOnSameSign.get(valueDim, idx, true) : valueStart;
	  return coordSys.dataToPoint(stackedData);
	} // function convertToIntId(newIdList, oldIdList) {
	//     // Generate int id instead of string id.
	//     // Compare string maybe slow in score function of arrDiff
	//     // Assume id in idList are all unique
	//     var idIndicesMap = {};
	//     var idx = 0;
	//     for (var i = 0; i < newIdList.length; i++) {
	//         idIndicesMap[newIdList[i]] = idx;
	//         newIdList[i] = idx++;
	//     }
	//     for (var i = 0; i < oldIdList.length; i++) {
	//         var oldId = oldIdList[i];
	//         // Same with newIdList
	//         if (idIndicesMap[oldId]) {
	//             oldIdList[i] = idIndicesMap[oldId];
	//         }
	//         else {
	//             oldIdList[i] = idx++;
	//         }
	//     }
	// }
	
	
	function diffData(oldData, newData) {
	  var diffResult = [];
	  newData.diff(oldData).add(function (idx) {
	    diffResult.push({
	      cmd: '+',
	      idx: idx
	    });
	  }).update(function (newIdx, oldIdx) {
	    diffResult.push({
	      cmd: '=',
	      idx: oldIdx,
	      idx1: newIdx
	    });
	  }).remove(function (idx) {
	    diffResult.push({
	      cmd: '-',
	      idx: idx
	    });
	  }).execute();
	  return diffResult;
	}
	
	function _default(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys) {
	  var diff = diffData(oldData, newData); // var newIdList = newData.mapArray(newData.getId);
	  // var oldIdList = oldData.mapArray(oldData.getId);
	  // convertToIntId(newIdList, oldIdList);
	  // // FIXME One data ?
	  // diff = arrayDiff(oldIdList, newIdList);
	
	  var currPoints = [];
	  var nextPoints = []; // Points for stacking base line
	
	  var currStackedPoints = [];
	  var nextStackedPoints = [];
	  var status = [];
	  var sortedIndices = [];
	  var rawIndices = [];
	  var dims = newCoordSys.dimensions;
	
	  for (var i = 0; i < diff.length; i++) {
	    var diffItem = diff[i];
	    var pointAdded = true; // FIXME, animation is not so perfect when dataZoom window moves fast
	    // Which is in case remvoing or add more than one data in the tail or head
	
	    switch (diffItem.cmd) {
	      case '=':
	        var currentPt = oldData.getItemLayout(diffItem.idx);
	        var nextPt = newData.getItemLayout(diffItem.idx1); // If previous data is NaN, use next point directly
	
	        if (isNaN(currentPt[0]) || isNaN(currentPt[1])) {
	          currentPt = nextPt.slice();
	        }
	
	        currPoints.push(currentPt);
	        nextPoints.push(nextPt);
	        currStackedPoints.push(oldStackedOnPoints[diffItem.idx]);
	        nextStackedPoints.push(newStackedOnPoints[diffItem.idx1]);
	        rawIndices.push(newData.getRawIndex(diffItem.idx1));
	        break;
	
	      case '+':
	        var idx = diffItem.idx;
	        currPoints.push(oldCoordSys.dataToPoint([newData.get(dims[0], idx, true), newData.get(dims[1], idx, true)]));
	        nextPoints.push(newData.getItemLayout(idx).slice());
	        currStackedPoints.push(getStackedOnPoint(oldCoordSys, newData, idx));
	        nextStackedPoints.push(newStackedOnPoints[idx]);
	        rawIndices.push(newData.getRawIndex(idx));
	        break;
	
	      case '-':
	        var idx = diffItem.idx;
	        var rawIndex = oldData.getRawIndex(idx); // Data is replaced. In the case of dynamic data queue
	        // FIXME FIXME FIXME
	
	        if (rawIndex !== idx) {
	          currPoints.push(oldData.getItemLayout(idx));
	          nextPoints.push(newCoordSys.dataToPoint([oldData.get(dims[0], idx, true), oldData.get(dims[1], idx, true)]));
	          currStackedPoints.push(oldStackedOnPoints[idx]);
	          nextStackedPoints.push(getStackedOnPoint(newCoordSys, oldData, idx));
	          rawIndices.push(rawIndex);
	        } else {
	          pointAdded = false;
	        }
	
	    } // Original indices
	
	
	    if (pointAdded) {
	      status.push(diffItem);
	      sortedIndices.push(sortedIndices.length);
	    }
	  } // Diff result may be crossed if all items are changed
	  // Sort by data index
	
	
	  sortedIndices.sort(function (a, b) {
	    return rawIndices[a] - rawIndices[b];
	  });
	  var sortedCurrPoints = [];
	  var sortedNextPoints = [];
	  var sortedCurrStackedPoints = [];
	  var sortedNextStackedPoints = [];
	  var sortedStatus = [];
	
	  for (var i = 0; i < sortedIndices.length; i++) {
	    var idx = sortedIndices[i];
	    sortedCurrPoints[i] = currPoints[idx];
	    sortedNextPoints[i] = nextPoints[idx];
	    sortedCurrStackedPoints[i] = currStackedPoints[idx];
	    sortedNextStackedPoints[i] = nextStackedPoints[idx];
	    sortedStatus[i] = status[idx];
	  }
	
	  return {
	    current: sortedCurrPoints,
	    next: sortedNextPoints,
	    stackedOnCurrent: sortedCurrStackedPoints,
	    stackedOnNext: sortedNextStackedPoints,
	    status: sortedStatus
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	__webpack_require__(404);
	
	__webpack_require__(405);
	
	var linesLayout = __webpack_require__(406);
	
	var linesVisual = __webpack_require__(407);
	
	echarts.registerLayout(linesLayout);
	echarts.registerVisual(linesVisual);

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var SeriesModel = __webpack_require__(20);
	
	var List = __webpack_require__(15);
	
	var zrUtil = __webpack_require__(1);
	
	var _format = __webpack_require__(9);
	
	var encodeHTML = _format.encodeHTML;
	
	var CoordinateSystem = __webpack_require__(26);
	
	// Convert [ [{coord: []}, {coord: []}] ]
	// to [ { coords: [[]] } ]
	function preprocessOption(seriesOpt) {
	  var data = seriesOpt.data;
	
	  if (data && data[0] && data[0][0] && data[0][0].coord) {
	    seriesOpt.data = zrUtil.map(data, function (itemOpt) {
	      var coords = [itemOpt[0].coord, itemOpt[1].coord];
	      var target = {
	        coords: coords
	      };
	
	      if (itemOpt[0].name) {
	        target.fromName = itemOpt[0].name;
	      }
	
	      if (itemOpt[1].name) {
	        target.toName = itemOpt[1].name;
	      }
	
	      return zrUtil.mergeAll([target, itemOpt[0], itemOpt[1]]);
	    });
	  }
	}
	
	var LinesSeries = SeriesModel.extend({
	  type: 'series.lines',
	  dependencies: ['grid', 'polar'],
	  visualColorAccessPath: 'lineStyle.normal.color',
	  init: function (option) {
	    // Not using preprocessor because mergeOption may not have series.type
	    preprocessOption(option);
	    LinesSeries.superApply(this, 'init', arguments);
	  },
	  mergeOption: function (option) {
	    preprocessOption(option);
	    LinesSeries.superApply(this, 'mergeOption', arguments);
	  },
	  getInitialData: function (option, ecModel) {
	    var lineData = new List(['value'], this);
	    lineData.hasItemOption = false;
	    lineData.initData(option.data, [], function (dataItem, dimName, dataIndex, dimIndex) {
	      // dataItem is simply coords
	      if (dataItem instanceof Array) {
	        return NaN;
	      } else {
	        lineData.hasItemOption = true;
	        var value = dataItem.value;
	
	        if (value != null) {
	          return value instanceof Array ? value[dimIndex] : value;
	        }
	      }
	    });
	    return lineData;
	  },
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var itemModel = data.getItemModel(dataIndex);
	    var name = itemModel.get('name');
	
	    if (name) {
	      return name;
	    }
	
	    var fromName = itemModel.get('fromName');
	    var toName = itemModel.get('toName');
	    var html = [];
	    fromName != null && html.push(fromName);
	    toName != null && html.push(toName);
	    return encodeHTML(html.join(' > '));
	  },
	  defaultOption: {
	    coordinateSystem: 'geo',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // Cartesian coordinate system
	    xAxisIndex: 0,
	    yAxisIndex: 0,
	    symbol: ['none', 'none'],
	    symbolSize: [10, 10],
	    // Geo coordinate system
	    geoIndex: 0,
	    effect: {
	      show: false,
	      period: 4,
	      // Animation delay. support callback
	      // delay: 0,
	      // If move with constant speed px/sec
	      // period will be ignored if this property is > 0,
	      constantSpeed: 0,
	      symbol: 'circle',
	      symbolSize: 3,
	      loop: true,
	      // Length of trail, 0 - 1
	      trailLength: 0.2 // Same with lineStyle.normal.color
	      // color
	
	    },
	    large: false,
	    // Available when large is true
	    largeThreshold: 2000,
	    // If lines are polyline
	    // polyline not support curveness, label, animation
	    polyline: false,
	    label: {
	      normal: {
	        show: false,
	        position: 'end' // distance: 5,
	        // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	
	      }
	    },
	    lineStyle: {
	      normal: {
	        opacity: 0.5
	      }
	    }
	  }
	});
	var _default = LinesSeries;
	module.exports = _default;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(2);
	
	var LineDraw = __webpack_require__(117);
	
	var EffectLine = __webpack_require__(160);
	
	var Line = __webpack_require__(116);
	
	var Polyline = __webpack_require__(161);
	
	var EffectPolyline = __webpack_require__(393);
	
	var LargeLineDraw = __webpack_require__(395);
	
	var _default = echarts.extendChartView({
	  type: 'lines',
	  init: function () {},
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var lineDraw = this._lineDraw;
	    var hasEffect = seriesModel.get('effect.show');
	    var isPolyline = seriesModel.get('polyline');
	    var isLarge = seriesModel.get('large') && data.count() >= seriesModel.get('largeThreshold');
	
	    if (hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLarge !== this._isLarge) {
	      if (lineDraw) {
	        lineDraw.remove();
	      }
	
	      lineDraw = this._lineDraw = isLarge ? new LargeLineDraw() : new LineDraw(isPolyline ? hasEffect ? EffectPolyline : Polyline : hasEffect ? EffectLine : Line);
	      this._hasEffet = hasEffect;
	      this._isPolyline = isPolyline;
	      this._isLarge = isLarge;
	    }
	
	    var zlevel = seriesModel.get('zlevel');
	    var trailLength = seriesModel.get('effect.trailLength');
	    var zr = api.getZr(); // Avoid the drag cause ghost shadow
	    // FIXME Better way ?
	    // SVG doesn't support
	
	    var isSvg = zr.painter.getType() === 'svg';
	
	    if (!isSvg) {
	      zr.painter.getLayer(zlevel).clear(true);
	    } // Config layer with motion blur
	
	
	    if (this._lastZlevel != null && !isSvg) {
	      zr.configLayer(this._lastZlevel, {
	        motionBlur: false
	      });
	    }
	
	    if (hasEffect && trailLength) {
	      if (!isSvg) {
	        zr.configLayer(zlevel, {
	          motionBlur: true,
	          lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
	        });
	      }
	    }
	
	    this.group.add(lineDraw.group);
	    lineDraw.updateData(data);
	    this._lastZlevel = zlevel;
	  },
	  updateLayout: function (seriesModel, ecModel, api) {
	    this._lineDraw.updateLayout(seriesModel); // Not use motion when dragging or zooming
	
	
	    var zr = api.getZr();
	    var isSvg = zr.painter.getType() === 'svg';
	
	    if (!isSvg) {
	      zr.painter.getLayer(this._lastZlevel).clear(true);
	    }
	  },
	  remove: function (ecModel, api) {
	    this._lineDraw && this._lineDraw.remove(api, true); // Clear motion when lineDraw is removed
	
	    var zr = api.getZr();
	    var isSvg = zr.painter.getType() === 'svg';
	
	    if (!isSvg) {
	      zr.painter.getLayer(this._lastZlevel).clear(true);
	    }
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	function _default(ecModel) {
	  ecModel.eachSeriesByType('lines', function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var lineData = seriesModel.getData(); // FIXME Use data dimensions ?
	
	    lineData.each(function (idx) {
	      var itemModel = lineData.getItemModel(idx);
	      var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.get('coords');
	      var pts = [];
	
	      if (seriesModel.get('polyline')) {
	        for (var i = 0; i < coords.length; i++) {
	          pts.push(coordSys.dataToPoint(coords[i]));
	        }
	      } else {
	        pts[0] = coordSys.dataToPoint(coords[0]);
	        pts[1] = coordSys.dataToPoint(coords[1]);
	        var curveness = itemModel.get('lineStyle.normal.curveness');
	
	        if (+curveness) {
	          pts[2] = [(pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness, (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness];
	        }
	      }
	
	      lineData.setItemLayout(idx, pts);
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	function normalize(a) {
	  if (!(a instanceof Array)) {
	    a = [a, a];
	  }
	
	  return a;
	}
	
	function _default(ecModel) {
	  ecModel.eachSeriesByType('lines', function (seriesModel) {
	    var data = seriesModel.getData();
	    var symbolType = normalize(seriesModel.get('symbol'));
	    var symbolSize = normalize(seriesModel.get('symbolSize'));
	    var opacityQuery = 'lineStyle.normal.opacity'.split('.');
	    data.setVisual('fromSymbol', symbolType && symbolType[0]);
	    data.setVisual('toSymbol', symbolType && symbolType[1]);
	    data.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
	    data.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
	    data.setVisual('opacity', seriesModel.get(opacityQuery));
	    data.each(function (idx) {
	      var itemModel = data.getItemModel(idx);
	      var symbolType = normalize(itemModel.getShallow('symbol', true));
	      var symbolSize = normalize(itemModel.getShallow('symbolSize', true));
	      var opacity = itemModel.get(opacityQuery);
	      symbolType[0] && data.setItemVisual(idx, 'fromSymbol', symbolType[0]);
	      symbolType[1] && data.setItemVisual(idx, 'toSymbol', symbolType[1]);
	      symbolSize[0] && data.setItemVisual(idx, 'fromSymbolSize', symbolSize[0]);
	      symbolSize[1] && data.setItemVisual(idx, 'toSymbolSize', symbolSize[1]);
	      data.setItemVisual(idx, 'opacity', opacity);
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	__webpack_require__(409);
	
	__webpack_require__(410);
	
	__webpack_require__(154);
	
	__webpack_require__(89);
	
	var mapSymbolLayout = __webpack_require__(413);
	
	var mapVisual = __webpack_require__(414);
	
	var mapDataStatistic = __webpack_require__(412);
	
	var backwardCompat = __webpack_require__(411);
	
	var createDataSelectAction = __webpack_require__(153);
	
	echarts.registerLayout(mapSymbolLayout);
	echarts.registerVisual(mapVisual);
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, mapDataStatistic);
	echarts.registerPreprocessor(backwardCompat);
	createDataSelectAction('map', [{
	  type: 'mapToggleSelect',
	  event: 'mapselectchanged',
	  method: 'toggleSelected'
	}, {
	  type: 'mapSelect',
	  event: 'mapselected',
	  method: 'select'
	}, {
	  type: 'mapUnSelect',
	  event: 'mapunselected',
	  method: 'unSelect'
	}]);

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var List = __webpack_require__(15);
	
	var SeriesModel = __webpack_require__(20);
	
	var completeDimensions = __webpack_require__(25);
	
	var _format = __webpack_require__(9);
	
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	
	var dataSelectableMixin = __webpack_require__(122);
	
	var geoCreator = __webpack_require__(89);
	
	var MapSeries = SeriesModel.extend({
	  type: 'series.map',
	  dependencies: ['geo'],
	  layoutMode: 'box',
	
	  /**
	   * Only first map series of same mapType will drawMap
	   * @type {boolean}
	   */
	  needsDrawMap: false,
	
	  /**
	   * Group of all map series with same mapType
	   * @type {boolean}
	   */
	  seriesGroup: [],
	  init: function (option) {
	    this._fillOption(option, this.getMapType()); // this.option = option;
	
	
	    MapSeries.superApply(this, 'init', arguments);
	    this.updateSelectedMap(option.data);
	  },
	  getInitialData: function (option) {
	    var dimensions = completeDimensions(['value'], option.data || []);
	    var list = new List(dimensions, this);
	    list.initData(option.data);
	    return list;
	  },
	  mergeOption: function (newOption) {
	    this._fillOption(newOption, this.getMapType());
	
	    MapSeries.superApply(this, 'mergeOption', arguments);
	    this.updateSelectedMap(this.option.data);
	  },
	
	  /**
	   * If no host geo model, return null, which means using a
	   * inner exclusive geo model.
	   */
	  getHostGeoModel: function () {
	    var geoIndex = this.option.geoIndex;
	    return geoIndex != null ? this.dependentModels.geo[geoIndex] : null;
	  },
	  getMapType: function () {
	    return (this.getHostGeoModel() || this).option.map;
	  },
	  _fillOption: function (option, mapName) {
	    // Shallow clone
	    // option = zrUtil.extend({}, option);
	    option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap); // return option;
	  },
	  getRawValue: function (dataIndex) {
	    // Use value stored in data instead because it is calculated from multiple series
	    // FIXME Provide all value of multiple series ?
	    return this.getData().get('value', dataIndex);
	  },
	
	  /**
	   * Get model of region
	   * @param  {string} name
	   * @return {module:echarts/model/Model}
	   */
	  getRegionModel: function (regionName) {
	    var data = this.getData();
	    return data.getItemModel(data.indexOfName(regionName));
	  },
	
	  /**
	   * Map tooltip formatter
	   *
	   * @param {number} dataIndex
	   */
	  formatTooltip: function (dataIndex) {
	    // FIXME orignalData and data is a bit confusing
	    var data = this.getData();
	    var formattedValue = addCommas(this.getRawValue(dataIndex));
	    var name = data.getName(dataIndex);
	    var seriesGroup = this.seriesGroup;
	    var seriesNames = [];
	
	    for (var i = 0; i < seriesGroup.length; i++) {
	      var otherIndex = seriesGroup[i].originalData.indexOfName(name);
	
	      if (!isNaN(seriesGroup[i].originalData.get('value', otherIndex))) {
	        seriesNames.push(encodeHTML(seriesGroup[i].name));
	      }
	    }
	
	    return seriesNames.join(', ') + '<br />' + encodeHTML(name + ' : ' + formattedValue);
	  },
	
	  /**
	   * @implement
	   */
	  getTooltipPosition: function (dataIndex) {
	    if (dataIndex != null) {
	      var name = this.getData().getName(dataIndex);
	      var geo = this.coordinateSystem;
	      var region = geo.getRegion(name);
	      return region && geo.dataToPoint(region.center);
	    }
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 2,
	    coordinateSystem: 'geo',
	    // map should be explicitly specified since ec3.
	    map: '',
	    // If `geoIndex` is not specified, a exclusive geo will be
	    // created. Otherwise use the specified geo component, and
	    // `map` and `mapType` are ignored.
	    // geoIndex: 0,
	    // 'center' | 'left' | 'right' | 'x%' | {number}
	    left: 'center',
	    // 'center' | 'top' | 'bottom' | 'x%' | {number}
	    top: 'center',
	    // right
	    // bottom
	    // width:
	    // height
	    // Aspect is width / height. Inited to be geoJson bbox aspect
	    // This parameter is used for scale this aspect
	    aspectScale: 0.75,
	    ///// Layout with center and size
	    // If you wan't to put map in a fixed size box with right aspect ratio
	    // This two properties may more conveninet
	    // layoutCenter: [50%, 50%]
	    // layoutSize: 100
	    // 数值合并方式，默认加和，可选为：
	    // 'sum' | 'average' | 'max' | 'min'
	    // mapValueCalculation: 'sum',
	    // 地图数值计算结果小数精度
	    // mapValuePrecision: 0,
	    // 显示图例颜色标识（系列标识的小圆点），图例开启时有效
	    showLegendSymbol: true,
	    // 选择模式，默认关闭，可选single，multiple
	    // selectedMode: false,
	    dataRangeHoverLink: true,
	    // 是否开启缩放及漫游模式
	    // roam: false,
	    // Define left-top, right-bottom coords to control view
	    // For example, [ [180, 90], [-180, -90] ],
	    // higher priority than center and zoom
	    boundingCoords: null,
	    // Default on center of map
	    center: null,
	    zoom: 1,
	    scaleLimit: null,
	    label: {
	      normal: {
	        show: false,
	        color: '#000'
	      },
	      emphasis: {
	        show: true,
	        color: 'rgb(100,0,0)'
	      }
	    },
	    // scaleLimit: null,
	    itemStyle: {
	      normal: {
	        // color: 各异,
	        borderWidth: 0.5,
	        borderColor: '#444',
	        areaColor: '#eee'
	      },
	      // 也是选中样式
	      emphasis: {
	        areaColor: 'rgba(255,215,0,0.8)'
	      }
	    }
	  }
	});
	zrUtil.mixin(MapSeries, dataSelectableMixin);
	var _default = MapSeries;
	module.exports = _default;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var MapDraw = __webpack_require__(177);
	
	var _default = echarts.extendChartView({
	  type: 'map',
	  render: function (mapModel, ecModel, api, payload) {
	    // Not render if it is an toggleSelect action from self
	    if (payload && payload.type === 'mapToggleSelect' && payload.from === this.uid) {
	      return;
	    }
	
	    var group = this.group;
	    group.removeAll();
	
	    if (mapModel.getHostGeoModel()) {
	      return;
	    } // Not update map if it is an roam action from self
	
	
	    if (!(payload && payload.type === 'geoRoam' && payload.componentType === 'series' && payload.seriesId === mapModel.id)) {
	      if (mapModel.needsDrawMap) {
	        var mapDraw = this._mapDraw || new MapDraw(api, true);
	        group.add(mapDraw.group);
	        mapDraw.draw(mapModel, ecModel, api, this, payload);
	        this._mapDraw = mapDraw;
	      } else {
	        // Remove drawed map
	        this._mapDraw && this._mapDraw.remove();
	        this._mapDraw = null;
	      }
	    } else {
	      var mapDraw = this._mapDraw;
	      mapDraw && group.add(mapDraw.group);
	    }
	
	    mapModel.get('showLegendSymbol') && ecModel.getComponent('legend') && this._renderSymbols(mapModel, ecModel, api);
	  },
	  remove: function () {
	    this._mapDraw && this._mapDraw.remove();
	    this._mapDraw = null;
	    this.group.removeAll();
	  },
	  dispose: function () {
	    this._mapDraw && this._mapDraw.remove();
	    this._mapDraw = null;
	  },
	  _renderSymbols: function (mapModel, ecModel, api) {
	    var originalData = mapModel.originalData;
	    var group = this.group;
	    originalData.each('value', function (value, idx) {
	      if (isNaN(value)) {
	        return;
	      }
	
	      var layout = originalData.getItemLayout(idx);
	
	      if (!layout || !layout.point) {
	        // Not exists in map
	        return;
	      }
	
	      var point = layout.point;
	      var offset = layout.offset;
	      var circle = new graphic.Circle({
	        style: {
	          // Because the special of map draw.
	          // Which needs statistic of multiple series and draw on one map.
	          // And each series also need a symbol with legend color
	          //
	          // Layout and visual are put one the different data
	          fill: mapModel.getData().getVisual('color')
	        },
	        shape: {
	          cx: point[0] + offset * 9,
	          cy: point[1],
	          r: 3
	        },
	        silent: true,
	        // Do not overlap the first series, on which labels are displayed.
	        z2: !offset ? 10 : 8
	      }); // First data on the same region
	
	      if (!offset) {
	        var fullData = mapModel.mainSeries.getData();
	        var name = originalData.getName(idx);
	        var fullIndex = fullData.indexOfName(name);
	        var itemModel = originalData.getItemModel(idx);
	        var labelModel = itemModel.getModel('label.normal');
	        var hoverLabelModel = itemModel.getModel('label.emphasis');
	        var polygonGroups = fullData.getItemGraphicEl(fullIndex);
	        var normalText = zrUtil.retrieve2(mapModel.getFormattedLabel(idx, 'normal'), name);
	        var emphasisText = zrUtil.retrieve2(mapModel.getFormattedLabel(idx, 'emphasis'), normalText);
	
	        var onEmphasis = function () {
	          var hoverStyle = graphic.setTextStyle({}, hoverLabelModel, {
	            text: hoverLabelModel.get('show') ? emphasisText : null
	          }, {
	            isRectText: true,
	            useInsideStyle: false
	          }, true);
	          circle.style.extendFrom(hoverStyle); // Make label upper than others if overlaps.
	
	          circle.__mapOriginalZ2 = circle.z2;
	          circle.z2 += 1;
	        };
	
	        var onNormal = function () {
	          graphic.setTextStyle(circle.style, labelModel, {
	            text: labelModel.get('show') ? normalText : null,
	            textPosition: labelModel.getShallow('position') || 'bottom'
	          }, {
	            isRectText: true,
	            useInsideStyle: false
	          });
	
	          if (circle.__mapOriginalZ2 != null) {
	            circle.z2 = circle.__mapOriginalZ2;
	            circle.__mapOriginalZ2 = null;
	          }
	        };
	
	        polygonGroups.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal);
	        onNormal();
	      }
	
	      group.add(circle);
	    });
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	function _default(option) {
	  // Save geoCoord
	  var mapSeries = [];
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'map') {
	      mapSeries.push(seriesOpt);
	      seriesOpt.map = seriesOpt.map || seriesOpt.mapType; // Put x, y, width, height, x2, y2 in the top level
	
	      zrUtil.defaults(seriesOpt, seriesOpt.mapLocation);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	// FIXME 公用？
	
	/**
	 * @param {Array.<module:echarts/data/List>} datas
	 * @param {string} statisticType 'average' 'sum'
	 * @inner
	 */
	function dataStatistics(datas, statisticType) {
	  var dataNameMap = {};
	  var dims = ['value'];
	  zrUtil.each(datas, function (data) {
	    data.each(dims, function (value, idx) {
	      // Add prefix to avoid conflict with Object.prototype.
	      var mapKey = 'ec-' + data.getName(idx);
	      dataNameMap[mapKey] = dataNameMap[mapKey] || [];
	
	      if (!isNaN(value)) {
	        dataNameMap[mapKey].push(value);
	      }
	    });
	  });
	  return datas[0].map(dims, function (value, idx) {
	    var mapKey = 'ec-' + datas[0].getName(idx);
	    var sum = 0;
	    var min = Infinity;
	    var max = -Infinity;
	    var len = dataNameMap[mapKey].length;
	
	    for (var i = 0; i < len; i++) {
	      min = Math.min(min, dataNameMap[mapKey][i]);
	      max = Math.max(max, dataNameMap[mapKey][i]);
	      sum += dataNameMap[mapKey][i];
	    }
	
	    var result;
	
	    if (statisticType === 'min') {
	      result = min;
	    } else if (statisticType === 'max') {
	      result = max;
	    } else if (statisticType === 'average') {
	      result = sum / len;
	    } else {
	      result = sum;
	    }
	
	    return len === 0 ? NaN : result;
	  });
	}
	
	function _default(ecModel) {
	  var seriesGroups = {};
	  ecModel.eachSeriesByType('map', function (seriesModel) {
	    var hostGeoModel = seriesModel.getHostGeoModel();
	    var key = hostGeoModel ? 'o' + hostGeoModel.id : 'i' + seriesModel.getMapType();
	    (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
	  });
	  zrUtil.each(seriesGroups, function (seriesList, key) {
	    var data = dataStatistics(zrUtil.map(seriesList, function (seriesModel) {
	      return seriesModel.getData();
	    }), seriesList[0].get('mapValueCalculation'));
	
	    for (var i = 0; i < seriesList.length; i++) {
	      seriesList[i].originalData = seriesList[i].getData();
	    } // FIXME Put where?
	
	
	    for (var i = 0; i < seriesList.length; i++) {
	      seriesList[i].seriesGroup = seriesList;
	      seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
	      seriesList[i].setData(data.cloneShallow());
	      seriesList[i].mainSeries = seriesList[0];
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	function _default(ecModel) {
	  var processedMapType = {};
	  ecModel.eachSeriesByType('map', function (mapSeries) {
	    var mapType = mapSeries.getMapType();
	
	    if (mapSeries.getHostGeoModel() || processedMapType[mapType]) {
	      return;
	    }
	
	    var mapSymbolOffsets = {};
	    zrUtil.each(mapSeries.seriesGroup, function (subMapSeries) {
	      var geo = subMapSeries.coordinateSystem;
	      var data = subMapSeries.originalData;
	
	      if (subMapSeries.get('showLegendSymbol') && ecModel.getComponent('legend')) {
	        data.each('value', function (value, idx) {
	          var name = data.getName(idx);
	          var region = geo.getRegion(name); // If input series.data is [11, 22, '-'/null/undefined, 44],
	          // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
	          // not be drawn. So here must validate if value is NaN.
	
	          if (!region || isNaN(value)) {
	            return;
	          }
	
	          var offset = mapSymbolOffsets[name] || 0;
	          var point = geo.dataToPoint(region.center);
	          mapSymbolOffsets[name] = offset + 1;
	          data.setItemLayout(idx, {
	            point: point,
	            offset: offset
	          });
	        });
	      }
	    }); // Show label of those region not has legendSymbol(which is offset 0)
	
	    var data = mapSeries.getData();
	    data.each(function (idx) {
	      var name = data.getName(idx);
	      var layout = data.getItemLayout(idx) || {};
	      layout.showLabel = !mapSymbolOffsets[name];
	      data.setItemLayout(idx, layout);
	    });
	    processedMapType[mapType] = true;
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	function _default(ecModel) {
	  ecModel.eachSeriesByType('map', function (seriesModel) {
	    var colorList = seriesModel.get('color');
	    var itemStyleModel = seriesModel.getModel('itemStyle.normal');
	    var areaColor = itemStyleModel.get('areaColor');
	    var color = itemStyleModel.get('color') || colorList[seriesModel.seriesIndex % colorList.length];
	    seriesModel.getData().setVisual({
	      'areaColor': areaColor,
	      'color': color
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	__webpack_require__(184);
	
	__webpack_require__(416);
	
	__webpack_require__(417);
	
	var parallelVisual = __webpack_require__(418);
	
	echarts.registerVisual(parallelVisual);

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var List = __webpack_require__(15);
	
	var zrUtil = __webpack_require__(1);
	
	var SeriesModel = __webpack_require__(20);
	
	var completeDimensions = __webpack_require__(25);
	
	var _default = SeriesModel.extend({
	  type: 'series.parallel',
	  dependencies: ['parallel'],
	  visualColorAccessPath: 'lineStyle.normal.color',
	  getInitialData: function (option, ecModel) {
	    var parallelModel = ecModel.getComponent('parallel', this.get('parallelIndex'));
	    var parallelAxisIndices = parallelModel.parallelAxisIndex;
	    var rawData = option.data;
	    var modelDims = parallelModel.dimensions;
	    var dataDims = generateDataDims(modelDims, rawData);
	    var dataDimsInfo = zrUtil.map(dataDims, function (dim, dimIndex) {
	      var modelDimsIndex = zrUtil.indexOf(modelDims, dim);
	      var axisModel = modelDimsIndex >= 0 && ecModel.getComponent('parallelAxis', parallelAxisIndices[modelDimsIndex]);
	
	      if (axisModel && axisModel.get('type') === 'category') {
	        translateCategoryValue(axisModel, dim, rawData);
	        return {
	          name: dim,
	          type: 'ordinal'
	        };
	      } else if (modelDimsIndex < 0) {
	        return completeDimensions.guessOrdinal(rawData, dimIndex) ? {
	          name: dim,
	          type: 'ordinal'
	        } : dim;
	      } else {
	        return dim;
	      }
	    });
	    var list = new List(dataDimsInfo, this);
	    list.initData(rawData); // Anication is forbiden in progressive data mode.
	
	    if (this.option.progressive) {
	      this.option.animation = false;
	    }
	
	    return list;
	  },
	
	  /**
	   * User can get data raw indices on 'axisAreaSelected' event received.
	   *
	   * @public
	   * @param {string} activeState 'active' or 'inactive' or 'normal'
	   * @return {Array.<number>} Raw indices
	   */
	  getRawIndicesByActiveState: function (activeState) {
	    var coordSys = this.coordinateSystem;
	    var data = this.getData();
	    var indices = [];
	    coordSys.eachActiveState(data, function (theActiveState, dataIndex) {
	      if (activeState === theActiveState) {
	        indices.push(data.getRawIndex(dataIndex));
	      }
	    });
	    return indices;
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'parallel',
	    parallelIndex: 0,
	    label: {
	      normal: {
	        show: false
	      },
	      emphasis: {
	        show: false
	      }
	    },
	    inactiveOpacity: 0.05,
	    activeOpacity: 1,
	    lineStyle: {
	      normal: {
	        width: 1,
	        opacity: 0.45,
	        type: 'solid'
	      }
	    },
	    progressive: false,
	    // 100
	    smooth: false,
	    animationEasing: 'linear'
	  }
	});
	
	function translateCategoryValue(axisModel, dim, rawData) {
	  var axisData = axisModel.get('data');
	  var numberDim = convertDimNameToNumber(dim);
	
	  if (axisData && axisData.length) {
	    zrUtil.each(rawData, function (dataItem) {
	      if (!dataItem) {
	        return;
	      } // FIXME
	      // time consuming, should use hash?
	
	
	      var index = zrUtil.indexOf(axisData, dataItem[numberDim]);
	      dataItem[numberDim] = index >= 0 ? index : NaN;
	    });
	  } // FIXME
	  // 如果没有设置axis data, 应自动算出，或者提示。
	
	}
	
	function convertDimNameToNumber(dimName) {
	  return +dimName.replace('dim', '');
	}
	
	function generateDataDims(modelDims, rawData) {
	  // parallelModel.dimension should not be regarded as data
	  // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
	  // We detect max dim by parallelModel.dimensions and fist
	  // item in rawData arbitrarily.
	  var maxDimNum = 0;
	  zrUtil.each(modelDims, function (dimName) {
	    var numberDim = convertDimNameToNumber(dimName);
	    numberDim > maxDimNum && (maxDimNum = numberDim);
	  });
	  var firstItem = rawData[0];
	
	  if (firstItem && firstItem.length - 1 > maxDimNum) {
	    maxDimNum = firstItem.length - 1;
	  }
	
	  var dataDims = [];
	
	  for (var i = 0; i <= maxDimNum; i++) {
	    dataDims.push('dim' + i);
	  }
	
	  return dataDims;
	}
	
	module.exports = _default;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	var graphic = __webpack_require__(3);
	
	var zrUtil = __webpack_require__(1);
	
	var ChartView = __webpack_require__(37);
	
	var SMOOTH = 0.3;
	var ParallelView = ChartView.extend({
	  type: 'parallel',
	  init: function () {
	    /**
	     * @type {module:zrender/container/Group}
	     * @private
	     */
	    this._dataGroup = new graphic.Group();
	    this.group.add(this._dataGroup);
	    /**
	     * @type {module:echarts/data/List}
	     */
	
	    this._data;
	  },
	
	  /**
	   * @override
	   */
	  render: function (seriesModel, ecModel, api, payload) {
	    this._renderForNormal(seriesModel, payload); // this[
	    //     seriesModel.option.progressive
	    //         ? '_renderForProgressive'
	    //         : '_renderForNormal'
	    // ](seriesModel);
	
	  },
	  dispose: function () {},
	
	  /**
	   * @private
	   */
	  _renderForNormal: function (seriesModel, payload) {
	    var dataGroup = this._dataGroup;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var coordSys = seriesModel.coordinateSystem;
	    var dimensions = coordSys.dimensions;
	    var option = seriesModel.option;
	    var smooth = option.smooth ? SMOOTH : null; // Consider switch between progressive and not.
	    // oldData && oldData.__plProgressive && dataGroup.removeAll();
	
	    data.diff(oldData).add(add).update(update).remove(remove).execute(); // Update style
	
	    updateElCommon(data, smooth); // First create
	
	    if (!this._data) {
	      var clipPath = createGridClipShape(coordSys, seriesModel, function () {
	        // Callback will be invoked immediately if there is no animation
	        setTimeout(function () {
	          dataGroup.removeClipPath();
	        });
	      });
	      dataGroup.setClipPath(clipPath);
	    }
	
	    this._data = data;
	
	    function add(newDataIndex) {
	      addEl(data, dataGroup, newDataIndex, dimensions, coordSys, null, smooth);
	    }
	
	    function update(newDataIndex, oldDataIndex) {
	      var line = oldData.getItemGraphicEl(oldDataIndex);
	      var points = createLinePoints(data, newDataIndex, dimensions, coordSys);
	      data.setItemGraphicEl(newDataIndex, line);
	      var animationModel = payload && payload.animation === false ? null : seriesModel;
	      graphic.updateProps(line, {
	        shape: {
	          points: points
	        }
	      }, animationModel, newDataIndex);
	    }
	
	    function remove(oldDataIndex) {
	      var line = oldData.getItemGraphicEl(oldDataIndex);
	      dataGroup.remove(line);
	    }
	  },
	
	  /**
	   * @private
	   */
	  // _renderForProgressive: function (seriesModel) {
	  //     var dataGroup = this._dataGroup;
	  //     var data = seriesModel.getData();
	  //     var oldData = this._data;
	  //     var coordSys = seriesModel.coordinateSystem;
	  //     var dimensions = coordSys.dimensions;
	  //     var option = seriesModel.option;
	  //     var progressive = option.progressive;
	  //     var smooth = option.smooth ? SMOOTH : null;
	  //     // In progressive animation is disabled, so use simple data diff,
	  //     // which effects performance less.
	  //     // (Typically performance for data with length 7000+ like:
	  //     // simpleDiff: 60ms, addEl: 184ms,
	  //     // in RMBP 2.4GHz intel i7, OSX 10.9 chrome 50.0.2661.102 (64-bit))
	  //     if (simpleDiff(oldData, data, dimensions)) {
	  //         dataGroup.removeAll();
	  //         data.each(function (dataIndex) {
	  //             addEl(data, dataGroup, dataIndex, dimensions, coordSys);
	  //         });
	  //     }
	  //     updateElCommon(data, progressive, smooth);
	  //     // Consider switch between progressive and not.
	  //     data.__plProgressive = true;
	  //     this._data = data;
	  // },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._dataGroup && this._dataGroup.removeAll();
	    this._data = null;
	  }
	});
	
	function createGridClipShape(coordSys, seriesModel, cb) {
	  var parallelModel = coordSys.model;
	  var rect = coordSys.getRect();
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    }
	  });
	  var dim = parallelModel.get('layout') === 'horizontal' ? 'width' : 'height';
	  rectEl.setShape(dim, 0);
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width,
	      height: rect.height
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	function createLinePoints(data, dataIndex, dimensions, coordSys) {
	  var points = [];
	
	  for (var i = 0; i < dimensions.length; i++) {
	    var dimName = dimensions[i];
	    var value = data.get(dimName, dataIndex);
	
	    if (!isEmptyValue(value, coordSys.getAxis(dimName).type)) {
	      points.push(coordSys.dataToPoint(value, dimName));
	    }
	  }
	
	  return points;
	}
	
	function addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
	  var points = createLinePoints(data, dataIndex, dimensions, coordSys);
	  var line = new graphic.Polyline({
	    shape: {
	      points: points
	    },
	    silent: true,
	    z2: 10
	  });
	  dataGroup.add(line);
	  data.setItemGraphicEl(dataIndex, line);
	}
	
	function updateElCommon(data, smooth) {
	  var seriesStyleModel = data.hostModel.getModel('lineStyle.normal');
	  var lineStyle = seriesStyleModel.getLineStyle();
	  data.eachItemGraphicEl(function (line, dataIndex) {
	    if (data.hasItemOption) {
	      var itemModel = data.getItemModel(dataIndex);
	      var lineStyleModel = itemModel.getModel('lineStyle.normal', seriesStyleModel);
	      lineStyle = lineStyleModel.getLineStyle(['color', 'stroke']);
	    }
	
	    line.useStyle(zrUtil.extend(lineStyle, {
	      fill: null,
	      // lineStyle.color have been set to itemVisual in module:echarts/visual/seriesColor.
	      stroke: data.getItemVisual(dataIndex, 'color'),
	      // lineStyle.opacity have been set to itemVisual in parallelVisual.
	      opacity: data.getItemVisual(dataIndex, 'opacity')
	    }));
	    line.shape.smooth = smooth;
	  });
	} // function simpleDiff(oldData, newData, dimensions) {
	//     var oldLen;
	//     if (!oldData
	//         || !oldData.__plProgressive
	//         || (oldLen = oldData.count()) !== newData.count()
	//     ) {
	//         return true;
	//     }
	//     var dimLen = dimensions.length;
	//     for (var i = 0; i < oldLen; i++) {
	//         for (var j = 0; j < dimLen; j++) {
	//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
	//                 return true;
	//             }
	//         }
	//     }
	//     return false;
	// }
	// FIXME
	// 公用方法?
	
	
	function isEmptyValue(val, axisType) {
	  return axisType === 'category' ? val == null : val == null || isNaN(val); // axisType === 'value'
	}
	
	var _default = ParallelView;
	module.exports = _default;

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	var opacityAccessPath = ['lineStyle', 'normal', 'opacity'];
	
	function _default(ecModel) {
	  ecModel.eachSeriesByType('parallel', function (seriesModel) {
	    var itemStyleModel = seriesModel.getModel('itemStyle.normal');
	    var lineStyleModel = seriesModel.getModel('lineStyle.normal');
	    var globalColors = ecModel.get('color');
	    var color = lineStyleModel.get('color') || itemStyleModel.get('color') || globalColors[seriesModel.seriesIndex % globalColors.length];
	    var inactiveOpacity = seriesModel.get('inactiveOpacity');
	    var activeOpacity = seriesModel.get('activeOpacity');
	    var lineStyle = seriesModel.getModel('lineStyle.normal').getLineStyle();
	    var coordSys = seriesModel.coordinateSystem;
	    var data = seriesModel.getData();
	    var opacityMap = {
	      normal: lineStyle.opacity,
	      active: activeOpacity,
	      inactive: inactiveOpacity
	    };
	    coordSys.eachActiveState(data, function (activeState, dataIndex) {
	      var itemModel = data.getItemModel(dataIndex);
	      var opacity = opacityMap[activeState];
	
	      if (activeState === 'normal') {
	        var itemOpacity = itemModel.get(opacityAccessPath, true);
	        itemOpacity != null && (opacity = itemOpacity);
	      }
	
	      data.setItemVisual(dataIndex, 'opacity', opacity);
	    });
	    data.setVisual('color', color);
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	__webpack_require__(126);
	
	__webpack_require__(350);
	
	__webpack_require__(351);
	
	var barLayoutGrid = __webpack_require__(128);
	
	var visualSymbol = __webpack_require__(47);
	
	__webpack_require__(70);
	
	// In case developer forget to include grid component
	echarts.registerLayout(zrUtil.curry(barLayoutGrid, 'pictorialBar'));
	echarts.registerVisual(zrUtil.curry(visualSymbol, 'pictorialBar', 'roundRect', null));

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	__webpack_require__(421);
	
	__webpack_require__(422);
	
	var createDataSelectAction = __webpack_require__(153);
	
	var dataColor = __webpack_require__(132);
	
	var pieLayout = __webpack_require__(424);
	
	var dataFilter = __webpack_require__(90);
	
	createDataSelectAction('pie', [{
	  type: 'pieToggleSelect',
	  event: 'pieselectchanged',
	  method: 'toggleSelected'
	}, {
	  type: 'pieSelect',
	  event: 'pieselected',
	  method: 'select'
	}, {
	  type: 'pieUnSelect',
	  event: 'pieunselected',
	  method: 'unSelect'
	}]);
	echarts.registerVisual(zrUtil.curry(dataColor, 'pie'));
	echarts.registerLayout(zrUtil.curry(pieLayout, 'pie'));
	echarts.registerProcessor(zrUtil.curry(dataFilter, 'pie'));

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var List = __webpack_require__(15);
	
	var zrUtil = __webpack_require__(1);
	
	var modelUtil = __webpack_require__(6);
	
	var _number = __webpack_require__(4);
	
	var getPercentWithPrecision = _number.getPercentWithPrecision;
	
	var completeDimensions = __webpack_require__(25);
	
	var dataSelectableMixin = __webpack_require__(122);
	
	var PieSeries = echarts.extendSeriesModel({
	  type: 'series.pie',
	  // Overwrite
	  init: function (option) {
	    PieSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendDataProvider = function () {
	      return this.getRawData();
	    };
	
	    this.updateSelectedMap(option.data);
	
	    this._defaultLabelLine(option);
	  },
	  // Overwrite
	  mergeOption: function (newOption) {
	    PieSeries.superCall(this, 'mergeOption', newOption);
	    this.updateSelectedMap(this.option.data);
	  },
	  getInitialData: function (option, ecModel) {
	    var dimensions = completeDimensions(['value'], option.data);
	    var list = new List(dimensions, this);
	    list.initData(option.data);
	    return list;
	  },
	  // Overwrite
	  getDataParams: function (dataIndex) {
	    var data = this.getData();
	    var params = PieSeries.superCall(this, 'getDataParams', dataIndex); // FIXME toFixed?
	
	    var valueList = [];
	    data.each('value', function (value) {
	      valueList.push(value);
	    });
	    params.percent = getPercentWithPrecision(valueList, dataIndex, data.hostModel.get('percentPrecision'));
	    params.$vars.push('percent');
	    return params;
	  },
	  _defaultLabelLine: function (option) {
	    // Extend labelLine emphasis
	    modelUtil.defaultEmphasis(option.labelLine, ['show']);
	    var labelLineNormalOpt = option.labelLine.normal;
	    var labelLineEmphasisOpt = option.labelLine.emphasis; // Not show label line if `label.normal.show = false`
	
	    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.normal.show;
	    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.label.emphasis.show;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    radius: [0, '75%'],
	    // 默认顺时针
	    clockwise: true,
	    startAngle: 90,
	    // 最小角度改为0
	    minAngle: 0,
	    // 选中时扇区偏移量
	    selectedOffset: 10,
	    // 高亮扇区偏移量
	    hoverOffset: 10,
	    // If use strategy to avoid label overlapping
	    avoidLabelOverlap: true,
	    // 选择模式，默认关闭，可选single，multiple
	    // selectedMode: false,
	    // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
	    // roseType: null,
	    percentPrecision: 2,
	    // If still show when all data zero.
	    stillShowZeroSum: true,
	    // cursor: null,
	    label: {
	      normal: {
	        // If rotate around circle
	        rotate: false,
	        show: true,
	        // 'outer', 'inside', 'center'
	        position: 'outer' // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	        // 默认使用全局文本样式，详见TEXTSTYLE
	        // distance: 当position为inner时有效，为label位置到圆心的距离与圆半径(环状图为内外半径和)的比例系数
	
	      },
	      emphasis: {}
	    },
	    // Enabled when label.normal.position is 'outer'
	    labelLine: {
	      normal: {
	        show: true,
	        // 引导线两段中的第一段长度
	        length: 15,
	        // 引导线两段中的第二段长度
	        length2: 15,
	        smooth: false,
	        lineStyle: {
	          // color: 各异,
	          width: 1,
	          type: 'solid'
	        }
	      }
	    },
	    itemStyle: {
	      normal: {
	        borderWidth: 1
	      },
	      emphasis: {}
	    },
	    // Animation type canbe expansion, scale
	    animationType: 'expansion',
	    animationEasing: 'cubicOut',
	    data: []
	  }
	});
	zrUtil.mixin(PieSeries, dataSelectableMixin);
	var _default = PieSeries;
	module.exports = _default;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var ChartView = __webpack_require__(37);
	
	/**
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {boolean} hasAnimation
	 * @inner
	 */
	function updateDataSelected(uid, seriesModel, hasAnimation, api) {
	  var data = seriesModel.getData();
	  var dataIndex = this.dataIndex;
	  var name = data.getName(dataIndex);
	  var selectedOffset = seriesModel.get('selectedOffset');
	  api.dispatchAction({
	    type: 'pieToggleSelect',
	    from: uid,
	    name: name,
	    seriesId: seriesModel.id
	  });
	  data.each(function (idx) {
	    toggleItemSelected(data.getItemGraphicEl(idx), data.getItemLayout(idx), seriesModel.isSelected(data.getName(idx)), selectedOffset, hasAnimation);
	  });
	}
	/**
	 * @param {module:zrender/graphic/Sector} el
	 * @param {Object} layout
	 * @param {boolean} isSelected
	 * @param {number} selectedOffset
	 * @param {boolean} hasAnimation
	 * @inner
	 */
	
	
	function toggleItemSelected(el, layout, isSelected, selectedOffset, hasAnimation) {
	  var midAngle = (layout.startAngle + layout.endAngle) / 2;
	  var dx = Math.cos(midAngle);
	  var dy = Math.sin(midAngle);
	  var offset = isSelected ? selectedOffset : 0;
	  var position = [dx * offset, dy * offset];
	  hasAnimation // animateTo will stop revious animation like update transition
	  ? el.animate().when(200, {
	    position: position
	  }).start('bounceOut') : el.attr('position', position);
	}
	/**
	 * Piece of pie including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	
	
	function PiePiece(data, idx) {
	  graphic.Group.call(this);
	  var sector = new graphic.Sector({
	    z2: 2
	  });
	  var polyline = new graphic.Polyline();
	  var text = new graphic.Text();
	  this.add(sector);
	  this.add(polyline);
	  this.add(text);
	  this.updateData(data, idx, true); // Hover to change label and labelLine
	
	  function onEmphasis() {
	    polyline.ignore = polyline.hoverIgnore;
	    text.ignore = text.hoverIgnore;
	  }
	
	  function onNormal() {
	    polyline.ignore = polyline.normalIgnore;
	    text.ignore = text.normalIgnore;
	  }
	
	  this.on('emphasis', onEmphasis).on('normal', onNormal).on('mouseover', onEmphasis).on('mouseout', onNormal);
	}
	
	var piePieceProto = PiePiece.prototype;
	
	piePieceProto.updateData = function (data, idx, firstCreate) {
	  var sector = this.childAt(0);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var sectorShape = zrUtil.extend({}, layout);
	  sectorShape.label = null;
	
	  if (firstCreate) {
	    sector.setShape(sectorShape);
	    var animationType = seriesModel.getShallow('animationType');
	
	    if (animationType === 'scale') {
	      sector.shape.r = layout.r0;
	      graphic.initProps(sector, {
	        shape: {
	          r: layout.r
	        }
	      }, seriesModel, idx);
	    } // Expansion
	    else {
	        sector.shape.endAngle = layout.startAngle;
	        graphic.updateProps(sector, {
	          shape: {
	            endAngle: layout.endAngle
	          }
	        }, seriesModel, idx);
	      }
	  } else {
	    graphic.updateProps(sector, {
	      shape: sectorShape
	    }, seriesModel, idx);
	  } // Update common style
	
	
	  var itemStyleModel = itemModel.getModel('itemStyle');
	  var visualColor = data.getItemVisual(idx, 'color');
	  sector.useStyle(zrUtil.defaults({
	    lineJoin: 'bevel',
	    fill: visualColor
	  }, itemStyleModel.getModel('normal').getItemStyle()));
	  sector.hoverStyle = itemStyleModel.getModel('emphasis').getItemStyle();
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && sector.attr('cursor', cursorStyle); // Toggle selected
	
	  toggleItemSelected(this, data.getItemLayout(idx), itemModel.get('selected'), seriesModel.get('selectedOffset'), seriesModel.get('animation'));
	
	  function onEmphasis() {
	    // Sector may has animation of updating data. Force to move to the last frame
	    // Or it may stopped on the wrong shape
	    sector.stopAnimation(true);
	    sector.animateTo({
	      shape: {
	        r: layout.r + seriesModel.get('hoverOffset')
	      }
	    }, 300, 'elasticOut');
	  }
	
	  function onNormal() {
	    sector.stopAnimation(true);
	    sector.animateTo({
	      shape: {
	        r: layout.r
	      }
	    }, 300, 'elasticOut');
	  }
	
	  sector.off('mouseover').off('mouseout').off('emphasis').off('normal');
	
	  if (itemModel.get('hoverAnimation') && seriesModel.isAnimationEnabled()) {
	    sector.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal);
	  }
	
	  this._updateLabel(data, idx);
	
	  graphic.setHoverStyle(this);
	};
	
	piePieceProto._updateLabel = function (data, idx) {
	  var labelLine = this.childAt(1);
	  var labelText = this.childAt(2);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var labelLayout = layout.label;
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.updateProps(labelLine, {
	    shape: {
	      points: labelLayout.linePoints || [[labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y]]
	    }
	  }, seriesModel, idx);
	  graphic.updateProps(labelText, {
	    style: {
	      x: labelLayout.x,
	      y: labelLayout.y
	    }
	  }, seriesModel, idx);
	  labelText.attr({
	    rotation: labelLayout.rotation,
	    origin: [labelLayout.x, labelLayout.y],
	    z2: 10
	  });
	  var labelModel = itemModel.getModel('label.normal');
	  var labelHoverModel = itemModel.getModel('label.emphasis');
	  var labelLineModel = itemModel.getModel('labelLine.normal');
	  var labelLineHoverModel = itemModel.getModel('labelLine.emphasis');
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
	    labelFetcher: data.hostModel,
	    labelDataIndex: idx,
	    defaultText: data.getName(idx),
	    autoColor: visualColor,
	    useInsideStyle: !!labelLayout.inside
	  }, {
	    textAlign: labelLayout.textAlign,
	    textVerticalAlign: labelLayout.verticalAlign,
	    opacity: data.getItemVisual(idx, 'opacity')
	  });
	  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
	  labelText.hoverIgnore = !labelHoverModel.get('show');
	  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
	  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color
	
	  labelLine.setStyle({
	    stroke: visualColor,
	    opacity: data.getItemVisual(idx, 'opacity')
	  });
	  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
	  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
	  var smooth = labelLineModel.get('smooth');
	
	  if (smooth && smooth === true) {
	    smooth = 0.4;
	  }
	
	  labelLine.setShape({
	    smooth: smooth
	  });
	};
	
	zrUtil.inherits(PiePiece, graphic.Group); // Pie view
	
	var PieView = ChartView.extend({
	  type: 'pie',
	  init: function () {
	    var sectorGroup = new graphic.Group();
	    this._sectorGroup = sectorGroup;
	  },
	  render: function (seriesModel, ecModel, api, payload) {
	    if (payload && payload.from === this.uid) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    var hasAnimation = ecModel.get('animation');
	    var isFirstRender = !oldData;
	    var animationType = seriesModel.get('animationType');
	    var onSectorClick = zrUtil.curry(updateDataSelected, this.uid, seriesModel, hasAnimation, api);
	    var selectedMode = seriesModel.get('selectedMode');
	    data.diff(oldData).add(function (idx) {
	      var piePiece = new PiePiece(data, idx); // Default expansion animation
	
	      if (isFirstRender && animationType !== 'scale') {
	        piePiece.eachChild(function (child) {
	          child.stopAnimation(true);
	        });
	      }
	
	      selectedMode && piePiece.on('click', onSectorClick);
	      data.setItemGraphicEl(idx, piePiece);
	      group.add(piePiece);
	    }).update(function (newIdx, oldIdx) {
	      var piePiece = oldData.getItemGraphicEl(oldIdx);
	      piePiece.updateData(data, newIdx);
	      piePiece.off('click');
	      selectedMode && piePiece.on('click', onSectorClick);
	      group.add(piePiece);
	      data.setItemGraphicEl(newIdx, piePiece);
	    }).remove(function (idx) {
	      var piePiece = oldData.getItemGraphicEl(idx);
	      group.remove(piePiece);
	    }).execute();
	
	    if (hasAnimation && isFirstRender && data.count() > 0 // Default expansion animation
	    && animationType !== 'scale') {
	      var shape = data.getItemLayout(0);
	      var r = Math.max(api.getWidth(), api.getHeight()) / 2;
	      var removeClipPath = zrUtil.bind(group.removeClipPath, group);
	      group.setClipPath(this._createClipPath(shape.cx, shape.cy, r, shape.startAngle, shape.clockwise, removeClipPath, seriesModel));
	    }
	
	    this._data = data;
	  },
	  dispose: function () {},
	  _createClipPath: function (cx, cy, r, startAngle, clockwise, cb, seriesModel) {
	    var clipPath = new graphic.Sector({
	      shape: {
	        cx: cx,
	        cy: cy,
	        r0: 0,
	        r: r,
	        startAngle: startAngle,
	        endAngle: startAngle,
	        clockwise: clockwise
	      }
	    });
	    graphic.initProps(clipPath, {
	      shape: {
	        endAngle: startAngle + (clockwise ? 1 : -1) * Math.PI * 2
	      }
	    }, seriesModel, cb);
	    return clipPath;
	  },
	
	  /**
	   * @implement
	   */
	  containPoint: function (point, seriesModel) {
	    var data = seriesModel.getData();
	    var itemLayout = data.getItemLayout(0);
	
	    if (itemLayout) {
	      var dx = point[0] - itemLayout.cx;
	      var dy = point[1] - itemLayout.cy;
	      var radius = Math.sqrt(dx * dx + dy * dy);
	      return radius <= itemLayout.r && radius >= itemLayout.r0;
	    }
	  }
	});
	var _default = PieView;
	module.exports = _default;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	var textContain = __webpack_require__(27);
	
	// FIXME emphasis label position is not same with normal label position
	function adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight) {
	  list.sort(function (a, b) {
	    return a.y - b.y;
	  }); // 压
	
	  function shiftDown(start, end, delta, dir) {
	    for (var j = start; j < end; j++) {
	      list[j].y += delta;
	
	      if (j > start && j + 1 < end && list[j + 1].y > list[j].y + list[j].height) {
	        shiftUp(j, delta / 2);
	        return;
	      }
	    }
	
	    shiftUp(end - 1, delta / 2);
	  } // 弹
	
	
	  function shiftUp(end, delta) {
	    for (var j = end; j >= 0; j--) {
	      list[j].y -= delta;
	
	      if (j > 0 && list[j].y > list[j - 1].y + list[j - 1].height) {
	        break;
	      }
	    }
	  }
	
	  function changeX(list, isDownList, cx, cy, r, dir) {
	    var lastDeltaX = dir > 0 ? isDownList // 右侧
	    ? Number.MAX_VALUE // 下
	    : 0 // 上
	    : isDownList // 左侧
	    ? Number.MAX_VALUE // 下
	    : 0; // 上
	
	    for (var i = 0, l = list.length; i < l; i++) {
	      // Not change x for center label
	      if (list[i].position === 'center') {
	        continue;
	      }
	
	      var deltaY = Math.abs(list[i].y - cy);
	      var length = list[i].len;
	      var length2 = list[i].len2;
	      var deltaX = deltaY < r + length ? Math.sqrt((r + length + length2) * (r + length + length2) - deltaY * deltaY) : Math.abs(list[i].x - cx);
	
	      if (isDownList && deltaX >= lastDeltaX) {
	        // 右下，左下
	        deltaX = lastDeltaX - 10;
	      }
	
	      if (!isDownList && deltaX <= lastDeltaX) {
	        // 右上，左上
	        deltaX = lastDeltaX + 10;
	      }
	
	      list[i].x = cx + deltaX * dir;
	      lastDeltaX = deltaX;
	    }
	  }
	
	  var lastY = 0;
	  var delta;
	  var len = list.length;
	  var upList = [];
	  var downList = [];
	
	  for (var i = 0; i < len; i++) {
	    delta = list[i].y - lastY;
	
	    if (delta < 0) {
	      shiftDown(i, len, -delta, dir);
	    }
	
	    lastY = list[i].y + list[i].height;
	  }
	
	  if (viewHeight - lastY < 0) {
	    shiftUp(len - 1, lastY - viewHeight);
	  }
	
	  for (var i = 0; i < len; i++) {
	    if (list[i].y >= cy) {
	      downList.push(list[i]);
	    } else {
	      upList.push(list[i]);
	    }
	  }
	
	  changeX(upList, false, cx, cy, r, dir);
	  changeX(downList, true, cx, cy, r, dir);
	}
	
	function avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight) {
	  var leftList = [];
	  var rightList = [];
	
	  for (var i = 0; i < labelLayoutList.length; i++) {
	    if (labelLayoutList[i].x < cx) {
	      leftList.push(labelLayoutList[i]);
	    } else {
	      rightList.push(labelLayoutList[i]);
	    }
	  }
	
	  adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight);
	  adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight);
	
	  for (var i = 0; i < labelLayoutList.length; i++) {
	    var linePoints = labelLayoutList[i].linePoints;
	
	    if (linePoints) {
	      var dist = linePoints[1][0] - linePoints[2][0];
	
	      if (labelLayoutList[i].x < cx) {
	        linePoints[2][0] = labelLayoutList[i].x + 3;
	      } else {
	        linePoints[2][0] = labelLayoutList[i].x - 3;
	      }
	
	      linePoints[1][1] = linePoints[2][1] = labelLayoutList[i].y;
	      linePoints[1][0] = linePoints[2][0] + dist;
	    }
	  }
	}
	
	function _default(seriesModel, r, viewWidth, viewHeight) {
	  var data = seriesModel.getData();
	  var labelLayoutList = [];
	  var cx;
	  var cy;
	  var hasLabelRotate = false;
	  data.each(function (idx) {
	    var layout = data.getItemLayout(idx);
	    var itemModel = data.getItemModel(idx);
	    var labelModel = itemModel.getModel('label.normal'); // Use position in normal or emphasis
	
	    var labelPosition = labelModel.get('position') || itemModel.get('label.emphasis.position');
	    var labelLineModel = itemModel.getModel('labelLine.normal');
	    var labelLineLen = labelLineModel.get('length');
	    var labelLineLen2 = labelLineModel.get('length2');
	    var midAngle = (layout.startAngle + layout.endAngle) / 2;
	    var dx = Math.cos(midAngle);
	    var dy = Math.sin(midAngle);
	    var textX;
	    var textY;
	    var linePoints;
	    var textAlign;
	    cx = layout.cx;
	    cy = layout.cy;
	    var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';
	
	    if (labelPosition === 'center') {
	      textX = layout.cx;
	      textY = layout.cy;
	      textAlign = 'center';
	    } else {
	      var x1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dx : layout.r * dx) + cx;
	      var y1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dy : layout.r * dy) + cy;
	      textX = x1 + dx * 3;
	      textY = y1 + dy * 3;
	
	      if (!isLabelInside) {
	        // For roseType
	        var x2 = x1 + dx * (labelLineLen + r - layout.r);
	        var y2 = y1 + dy * (labelLineLen + r - layout.r);
	        var x3 = x2 + (dx < 0 ? -1 : 1) * labelLineLen2;
	        var y3 = y2;
	        textX = x3 + (dx < 0 ? -5 : 5);
	        textY = y3;
	        linePoints = [[x1, y1], [x2, y2], [x3, y3]];
	      }
	
	      textAlign = isLabelInside ? 'center' : dx > 0 ? 'left' : 'right';
	    }
	
	    var font = labelModel.getFont();
	    var labelRotate = labelModel.get('rotate') ? dx < 0 ? -midAngle + Math.PI : -midAngle : 0;
	    var text = seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx);
	    var textRect = textContain.getBoundingRect(text, font, textAlign, 'top');
	    hasLabelRotate = !!labelRotate;
	    layout.label = {
	      x: textX,
	      y: textY,
	      position: labelPosition,
	      height: textRect.height,
	      len: labelLineLen,
	      len2: labelLineLen2,
	      linePoints: linePoints,
	      textAlign: textAlign,
	      verticalAlign: 'middle',
	      rotation: labelRotate,
	      inside: isLabelInside
	    }; // Not layout the inside label
	
	    if (!isLabelInside) {
	      labelLayoutList.push(layout.label);
	    }
	  });
	
	  if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) {
	    avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight);
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	var _number = __webpack_require__(4);
	
	var parsePercent = _number.parsePercent;
	var linearMap = _number.linearMap;
	
	var labelLayout = __webpack_require__(423);
	
	var zrUtil = __webpack_require__(1);
	
	var PI2 = Math.PI * 2;
	var RADIAN = Math.PI / 180;
	
	function _default(seriesType, ecModel, api, payload) {
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    var center = seriesModel.get('center');
	    var radius = seriesModel.get('radius');
	
	    if (!zrUtil.isArray(radius)) {
	      radius = [0, radius];
	    }
	
	    if (!zrUtil.isArray(center)) {
	      center = [center, center];
	    }
	
	    var width = api.getWidth();
	    var height = api.getHeight();
	    var size = Math.min(width, height);
	    var cx = parsePercent(center[0], width);
	    var cy = parsePercent(center[1], height);
	    var r0 = parsePercent(radius[0], size / 2);
	    var r = parsePercent(radius[1], size / 2);
	    var data = seriesModel.getData();
	    var startAngle = -seriesModel.get('startAngle') * RADIAN;
	    var minAngle = seriesModel.get('minAngle') * RADIAN;
	    var validDataCount = 0;
	    data.each('value', function (value) {
	      !isNaN(value) && validDataCount++;
	    });
	    var sum = data.getSum('value'); // Sum may be 0
	
	    var unitRadian = Math.PI / (sum || validDataCount) * 2;
	    var clockwise = seriesModel.get('clockwise');
	    var roseType = seriesModel.get('roseType');
	    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // [0...max]
	
	    var extent = data.getDataExtent('value');
	    extent[0] = 0; // In the case some sector angle is smaller than minAngle
	
	    var restAngle = PI2;
	    var valueSumLargerThanMinAngle = 0;
	    var currentAngle = startAngle;
	    var dir = clockwise ? 1 : -1;
	    data.each('value', function (value, idx) {
	      var angle;
	
	      if (isNaN(value)) {
	        data.setItemLayout(idx, {
	          angle: NaN,
	          startAngle: NaN,
	          endAngle: NaN,
	          clockwise: clockwise,
	          cx: cx,
	          cy: cy,
	          r0: r0,
	          r: roseType ? NaN : r
	        });
	        return;
	      } // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
	
	
	      if (roseType !== 'area') {
	        angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
	      } else {
	        angle = PI2 / validDataCount;
	      }
	
	      if (angle < minAngle) {
	        angle = minAngle;
	        restAngle -= minAngle;
	      } else {
	        valueSumLargerThanMinAngle += value;
	      }
	
	      var endAngle = currentAngle + dir * angle;
	      data.setItemLayout(idx, {
	        angle: angle,
	        startAngle: currentAngle,
	        endAngle: endAngle,
	        clockwise: clockwise,
	        cx: cx,
	        cy: cy,
	        r0: r0,
	        r: roseType ? linearMap(value, extent, [r0, r]) : r
	      });
	      currentAngle = endAngle;
	    }, true); // Some sector is constrained by minAngle
	    // Rest sectors needs recalculate angle
	
	    if (restAngle < PI2 && validDataCount) {
	      // Average the angle if rest angle is not enough after all angles is
	      // Constrained by minAngle
	      if (restAngle <= 1e-3) {
	        var angle = PI2 / validDataCount;
	        data.each('value', function (value, idx) {
	          if (!isNaN(value)) {
	            var layout = data.getItemLayout(idx);
	            layout.angle = angle;
	            layout.startAngle = startAngle + dir * idx * angle;
	            layout.endAngle = startAngle + dir * (idx + 1) * angle;
	          }
	        });
	      } else {
	        unitRadian = restAngle / valueSumLargerThanMinAngle;
	        currentAngle = startAngle;
	        data.each('value', function (value, idx) {
	          if (!isNaN(value)) {
	            var layout = data.getItemLayout(idx);
	            var angle = layout.angle === minAngle ? minAngle : value * unitRadian;
	            layout.startAngle = currentAngle;
	            layout.endAngle = currentAngle + dir * angle;
	            currentAngle += dir * angle;
	          }
	        });
	      }
	    }
	
	    labelLayout(seriesModel, r, width, height);
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	__webpack_require__(511);
	
	__webpack_require__(426);
	
	__webpack_require__(427);
	
	var dataColor = __webpack_require__(132);
	
	var visualSymbol = __webpack_require__(47);
	
	var radarLayout = __webpack_require__(429);
	
	var dataFilter = __webpack_require__(90);
	
	var backwardCompat = __webpack_require__(428);
	
	// Must use radar component
	echarts.registerVisual(zrUtil.curry(dataColor, 'radar'));
	echarts.registerVisual(zrUtil.curry(visualSymbol, 'radar', 'circle', null));
	echarts.registerLayout(radarLayout);
	echarts.registerProcessor(zrUtil.curry(dataFilter, 'radar'));
	echarts.registerPreprocessor(backwardCompat);

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	var SeriesModel = __webpack_require__(20);
	
	var List = __webpack_require__(15);
	
	var completeDimensions = __webpack_require__(25);
	
	var zrUtil = __webpack_require__(1);
	
	var _format = __webpack_require__(9);
	
	var encodeHTML = _format.encodeHTML;
	var RadarSeries = SeriesModel.extend({
	  type: 'series.radar',
	  dependencies: ['radar'],
	  // Overwrite
	  init: function (option) {
	    RadarSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendDataProvider = function () {
	      return this.getRawData();
	    };
	  },
	  getInitialData: function (option, ecModel) {
	    var data = option.data || [];
	    var dimensions = completeDimensions([], data, {
	      extraPrefix: 'indicator_',
	      extraFromZero: true
	    });
	    var list = new List(dimensions, this);
	    list.initData(data);
	    return list;
	  },
	  formatTooltip: function (dataIndex) {
	    var value = this.getRawValue(dataIndex);
	    var coordSys = this.coordinateSystem;
	    var indicatorAxes = coordSys.getIndicatorAxes();
	    var name = this.getData().getName(dataIndex);
	    return encodeHTML(name === '' ? this.name : name) + '<br/>' + zrUtil.map(indicatorAxes, function (axis, idx) {
	      return encodeHTML(axis.name + ' : ' + value[idx]);
	    }).join('<br />');
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'radar',
	    legendHoverLink: true,
	    radarIndex: 0,
	    lineStyle: {
	      normal: {
	        width: 2,
	        type: 'solid'
	      }
	    },
	    label: {
	      normal: {
	        position: 'top'
	      }
	    },
	    // areaStyle: {
	    // },
	    // itemStyle: {}
	    symbol: 'emptyCircle',
	    symbolSize: 4 // symbolRotate: null
	
	  }
	});
	var _default = RadarSeries;
	module.exports = _default;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var graphic = __webpack_require__(3);
	
	var zrUtil = __webpack_require__(1);
	
	var symbolUtil = __webpack_require__(22);
	
	function normalizeSymbolSize(symbolSize) {
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [+symbolSize, +symbolSize];
	  }
	
	  return symbolSize;
	}
	
	var _default = echarts.extendChartView({
	  type: 'radar',
	  render: function (seriesModel, ecModel, api) {
	    var polar = seriesModel.coordinateSystem;
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	
	    function createSymbol(data, idx) {
	      var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
	      var color = data.getItemVisual(idx, 'color');
	
	      if (symbolType === 'none') {
	        return;
	      }
	
	      var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
	      var symbolPath = symbolUtil.createSymbol(symbolType, -1, -1, 2, 2, color);
	      symbolPath.attr({
	        style: {
	          strokeNoScale: true
	        },
	        z2: 100,
	        scale: [symbolSize[0] / 2, symbolSize[1] / 2]
	      });
	      return symbolPath;
	    }
	
	    function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
	      // Simply rerender all
	      symbolGroup.removeAll();
	
	      for (var i = 0; i < newPoints.length - 1; i++) {
	        var symbolPath = createSymbol(data, idx);
	
	        if (symbolPath) {
	          symbolPath.__dimIdx = i;
	
	          if (oldPoints[i]) {
	            symbolPath.attr('position', oldPoints[i]);
	            graphic[isInit ? 'initProps' : 'updateProps'](symbolPath, {
	              position: newPoints[i]
	            }, seriesModel, idx);
	          } else {
	            symbolPath.attr('position', newPoints[i]);
	          }
	
	          symbolGroup.add(symbolPath);
	        }
	      }
	    }
	
	    function getInitialPoints(points) {
	      return zrUtil.map(points, function (pt) {
	        return [polar.cx, polar.cy];
	      });
	    }
	
	    data.diff(oldData).add(function (idx) {
	      var points = data.getItemLayout(idx);
	
	      if (!points) {
	        return;
	      }
	
	      var polygon = new graphic.Polygon();
	      var polyline = new graphic.Polyline();
	      var target = {
	        shape: {
	          points: points
	        }
	      };
	      polygon.shape.points = getInitialPoints(points);
	      polyline.shape.points = getInitialPoints(points);
	      graphic.initProps(polygon, target, seriesModel, idx);
	      graphic.initProps(polyline, target, seriesModel, idx);
	      var itemGroup = new graphic.Group();
	      var symbolGroup = new graphic.Group();
	      itemGroup.add(polyline);
	      itemGroup.add(polygon);
	      itemGroup.add(symbolGroup);
	      updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
	      data.setItemGraphicEl(idx, itemGroup);
	    }).update(function (newIdx, oldIdx) {
	      var itemGroup = oldData.getItemGraphicEl(oldIdx);
	      var polyline = itemGroup.childAt(0);
	      var polygon = itemGroup.childAt(1);
	      var symbolGroup = itemGroup.childAt(2);
	      var target = {
	        shape: {
	          points: data.getItemLayout(newIdx)
	        }
	      };
	
	      if (!target.shape.points) {
	        return;
	      }
	
	      updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
	      graphic.updateProps(polyline, target, seriesModel);
	      graphic.updateProps(polygon, target, seriesModel);
	      data.setItemGraphicEl(newIdx, itemGroup);
	    }).remove(function (idx) {
	      group.remove(oldData.getItemGraphicEl(idx));
	    }).execute();
	    data.eachItemGraphicEl(function (itemGroup, idx) {
	      var itemModel = data.getItemModel(idx);
	      var polyline = itemGroup.childAt(0);
	      var polygon = itemGroup.childAt(1);
	      var symbolGroup = itemGroup.childAt(2);
	      var color = data.getItemVisual(idx, 'color');
	      group.add(itemGroup);
	      polyline.useStyle(zrUtil.defaults(itemModel.getModel('lineStyle.normal').getLineStyle(), {
	        fill: 'none',
	        stroke: color
	      }));
	      polyline.hoverStyle = itemModel.getModel('lineStyle.emphasis').getLineStyle();
	      var areaStyleModel = itemModel.getModel('areaStyle.normal');
	      var hoverAreaStyleModel = itemModel.getModel('areaStyle.emphasis');
	      var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
	      var hoverPolygonIgnore = hoverAreaStyleModel.isEmpty() && hoverAreaStyleModel.parentModel.isEmpty();
	      hoverPolygonIgnore = hoverPolygonIgnore && polygonIgnore;
	      polygon.ignore = polygonIgnore;
	      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
	        fill: color,
	        opacity: 0.7
	      }));
	      polygon.hoverStyle = hoverAreaStyleModel.getAreaStyle();
	      var itemStyle = itemModel.getModel('itemStyle.normal').getItemStyle(['color']);
	      var itemHoverStyle = itemModel.getModel('itemStyle.emphasis').getItemStyle();
	      var labelModel = itemModel.getModel('label.normal');
	      var labelHoverModel = itemModel.getModel('label.emphasis');
	      symbolGroup.eachChild(function (symbolPath) {
	        symbolPath.setStyle(itemStyle);
	        symbolPath.hoverStyle = zrUtil.clone(itemHoverStyle);
	        graphic.setLabelStyle(symbolPath.style, symbolPath.hoverStyle, labelModel, labelHoverModel, {
	          labelFetcher: data.hostModel,
	          labelDataIndex: idx,
	          labelDimIndex: symbolPath.__dimIdx,
	          defaultText: data.get(data.dimensions[symbolPath.__dimIdx], idx),
	          autoColor: color,
	          isRectText: true
	        });
	      });
	
	      function onEmphasis() {
	        polygon.attr('ignore', hoverPolygonIgnore);
	      }
	
	      function onNormal() {
	        polygon.attr('ignore', polygonIgnore);
	      }
	
	      itemGroup.off('mouseover').off('mouseout').off('normal').off('emphasis');
	      itemGroup.on('emphasis', onEmphasis).on('mouseover', onEmphasis).on('normal', onNormal).on('mouseout', onNormal);
	      graphic.setHoverStyle(itemGroup);
	    });
	    this._data = data;
	  },
	  remove: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	// Backward compat for radar chart in 2
	function _default(option) {
	  var polarOptArr = option.polar;
	
	  if (polarOptArr) {
	    if (!zrUtil.isArray(polarOptArr)) {
	      polarOptArr = [polarOptArr];
	    }
	
	    var polarNotRadar = [];
	    zrUtil.each(polarOptArr, function (polarOpt, idx) {
	      if (polarOpt.indicator) {
	        if (polarOpt.type && !polarOpt.shape) {
	          polarOpt.shape = polarOpt.type;
	        }
	
	        option.radar = option.radar || [];
	
	        if (!zrUtil.isArray(option.radar)) {
	          option.radar = [option.radar];
	        }
	
	        option.radar.push(polarOpt);
	      } else {
	        polarNotRadar.push(polarOpt);
	      }
	    });
	    option.polar = polarNotRadar;
	  }
	
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'radar' && seriesOpt.polarIndex) {
	      seriesOpt.radarIndex = seriesOpt.polarIndex;
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	function _default(ecModel) {
	  ecModel.eachSeriesByType('radar', function (seriesModel) {
	    var data = seriesModel.getData();
	    var points = [];
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (!coordSys) {
	      return;
	    }
	
	    function pointsConverter(val, idx) {
	      points[idx] = points[idx] || [];
	      points[idx][i] = coordSys.dataToPoint(val, i);
	    }
	
	    for (var i = 0; i < coordSys.getIndicatorAxes().length; i++) {
	      var dim = data.dimensions[i];
	      data.each(dim, pointsConverter);
	    }
	
	    data.each(function (idx) {
	      // Close polygon
	      points[idx][0] && points[idx].push(points[idx][0].slice());
	      data.setItemLayout(idx, points[idx]);
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	__webpack_require__(431);
	
	__webpack_require__(432);
	
	var sankeyLayout = __webpack_require__(433);
	
	var sankeyVisual = __webpack_require__(434);
	
	echarts.registerLayout(sankeyLayout);
	echarts.registerVisual(sankeyVisual);

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	var SeriesModel = __webpack_require__(20);
	
	var createGraphFromNodeEdge = __webpack_require__(162);
	
	var _format = __webpack_require__(9);
	
	var encodeHTML = _format.encodeHTML;
	
	/**
	 * @file Get initial data and define sankey view's series model
	 * @author Deqing Li(annong035@gmail.com)
	 */
	var SankeySeries = SeriesModel.extend({
	  type: 'series.sankey',
	  layoutInfo: null,
	
	  /**
	   * Init a graph data structure from data in option series
	   *
	   * @param  {Object} option  the object used to config echarts view
	   * @return {module:echarts/data/List} storage initial data
	   */
	  getInitialData: function (option) {
	    var links = option.edges || option.links;
	    var nodes = option.data || option.nodes;
	
	    if (nodes && links) {
	      var graph = createGraphFromNodeEdge(nodes, links, this, true);
	      return graph.data;
	    }
	  },
	
	  /**
	   * Return the graphic data structure
	   *
	   * @return {module:echarts/data/Graph} graphic data structure
	   */
	  getGraph: function () {
	    return this.getData().graph;
	  },
	
	  /**
	   * Get edge data of graphic data structure
	   *
	   * @return {module:echarts/data/List} data structure of list
	   */
	  getEdgeData: function () {
	    return this.getGraph().edgeData;
	  },
	
	  /**
	   * @override
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType) {
	    // dataType === 'node' or empty do not show tooltip by default
	    if (dataType === 'edge') {
	      var params = this.getDataParams(dataIndex, dataType);
	      var rawDataOpt = params.data;
	      var html = rawDataOpt.source + ' -- ' + rawDataOpt.target;
	
	      if (params.value) {
	        html += ' : ' + params.value;
	      }
	
	      return encodeHTML(html);
	    }
	
	    return SankeySeries.superCall(this, 'formatTooltip', dataIndex, multipleSeries);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    layout: null,
	    // the position of the whole view
	    left: '5%',
	    top: '5%',
	    right: '20%',
	    bottom: '5%',
	    // the dx of the node
	    nodeWidth: 20,
	    // the vertical distance between two nodes
	    nodeGap: 8,
	    // the number of iterations to change the position of the node
	    layoutIterations: 32,
	    label: {
	      normal: {
	        show: true,
	        position: 'right',
	        color: '#000',
	        fontSize: 12
	      },
	      emphasis: {
	        show: true
	      }
	    },
	    itemStyle: {
	      normal: {
	        borderWidth: 1,
	        borderColor: '#333'
	      }
	    },
	    lineStyle: {
	      normal: {
	        color: '#314656',
	        opacity: 0.2,
	        curveness: 0.5
	      },
	      emphasis: {
	        opacity: 0.6
	      }
	    },
	    animationEasing: 'linear',
	    animationDuration: 1000
	  }
	});
	var _default = SankeySeries;
	module.exports = _default;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	var graphic = __webpack_require__(3);
	
	var echarts = __webpack_require__(2);
	
	/**
	 * @file  The file used to draw sankey view
	 * @author  Deqing Li(annong035@gmail.com)
	 */
	var SankeyShape = graphic.extendShape({
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    cpx1: 0,
	    cpy1: 0,
	    cpx2: 0,
	    cpy2: 0,
	    extent: 0
	  },
	  buildPath: function (ctx, shape) {
	    var halfExtent = shape.extent / 2;
	    ctx.moveTo(shape.x1, shape.y1 - halfExtent);
	    ctx.bezierCurveTo(shape.cpx1, shape.cpy1 - halfExtent, shape.cpx2, shape.cpy2 - halfExtent, shape.x2, shape.y2 - halfExtent);
	    ctx.lineTo(shape.x2, shape.y2 + halfExtent);
	    ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + halfExtent, shape.cpx1, shape.cpy1 + halfExtent, shape.x1, shape.y1 + halfExtent);
	    ctx.closePath();
	  }
	});
	
	var _default = echarts.extendChartView({
	  type: 'sankey',
	
	  /**
	   * @private
	   * @type {module:echarts/chart/sankey/SankeySeries}
	   */
	  _model: null,
	  render: function (seriesModel, ecModel, api) {
	    var graph = seriesModel.getGraph();
	    var group = this.group;
	    var layoutInfo = seriesModel.layoutInfo;
	    var nodeData = seriesModel.getData();
	    var edgeData = seriesModel.getData('edge');
	    this._model = seriesModel;
	    group.removeAll();
	    group.attr('position', [layoutInfo.x, layoutInfo.y]); // generate a bezire Curve for each edge
	
	    graph.eachEdge(function (edge) {
	      var curve = new SankeyShape();
	      curve.dataIndex = edge.dataIndex;
	      curve.seriesIndex = seriesModel.seriesIndex;
	      curve.dataType = 'edge';
	      var lineStyleModel = edge.getModel('lineStyle.normal');
	      var curvature = lineStyleModel.get('curveness');
	      var n1Layout = edge.node1.getLayout();
	      var n2Layout = edge.node2.getLayout();
	      var edgeLayout = edge.getLayout();
	      curve.shape.extent = Math.max(1, edgeLayout.dy);
	      var x1 = n1Layout.x + n1Layout.dx;
	      var y1 = n1Layout.y + edgeLayout.sy + edgeLayout.dy / 2;
	      var x2 = n2Layout.x;
	      var y2 = n2Layout.y + edgeLayout.ty + edgeLayout.dy / 2;
	      var cpx1 = x1 * (1 - curvature) + x2 * curvature;
	      var cpy1 = y1;
	      var cpx2 = x1 * curvature + x2 * (1 - curvature);
	      var cpy2 = y2;
	      curve.setShape({
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2,
	        cpx1: cpx1,
	        cpy1: cpy1,
	        cpx2: cpx2,
	        cpy2: cpy2
	      });
	      curve.setStyle(lineStyleModel.getItemStyle()); // Special color, use source node color or target node color
	
	      switch (curve.style.fill) {
	        case 'source':
	          curve.style.fill = edge.node1.getVisual('color');
	          break;
	
	        case 'target':
	          curve.style.fill = edge.node2.getVisual('color');
	          break;
	      }
	
	      graphic.setHoverStyle(curve, edge.getModel('lineStyle.emphasis').getItemStyle());
	      group.add(curve);
	      edgeData.setItemGraphicEl(edge.dataIndex, curve);
	    }); // generate a rect  for each node
	
	    graph.eachNode(function (node) {
	      var layout = node.getLayout();
	      var itemModel = node.getModel();
	      var labelModel = itemModel.getModel('label.normal');
	      var labelHoverModel = itemModel.getModel('label.emphasis');
	      var rect = new graphic.Rect({
	        shape: {
	          x: layout.x,
	          y: layout.y,
	          width: node.getLayout().dx,
	          height: node.getLayout().dy
	        },
	        style: itemModel.getModel('itemStyle.normal').getItemStyle()
	      });
	      var hoverStyle = node.getModel('itemStyle.emphasis').getItemStyle();
	      graphic.setLabelStyle(rect.style, hoverStyle, labelModel, labelHoverModel, {
	        labelFetcher: seriesModel,
	        labelDataIndex: node.dataIndex,
	        defaultText: node.id,
	        isRectText: true
	      });
	      rect.setStyle('fill', node.getVisual('color'));
	      graphic.setHoverStyle(rect, hoverStyle);
	      group.add(rect);
	      nodeData.setItemGraphicEl(node.dataIndex, rect);
	      rect.dataType = 'node';
	    });
	
	    if (!this._data && seriesModel.get('animation')) {
	      group.setClipPath(createGridClipShape(group.getBoundingRect(), seriesModel, function () {
	        group.removeClipPath();
	      }));
	    }
	
	    this._data = seriesModel.getData();
	  },
	  dispose: function () {}
	}); // add animation to the view
	
	
	function createGridClipShape(rect, seriesModel, cb) {
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x - 10,
	      y: rect.y - 10,
	      width: 0,
	      height: rect.height + 20
	    }
	  });
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width + 20,
	      height: rect.height + 20
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	module.exports = _default;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	var layout = __webpack_require__(7);
	
	var nest = __webpack_require__(204);
	
	var zrUtil = __webpack_require__(1);
	
	/**
	 * @file The layout algorithm of sankey view
	 * @author  Deqing Li(annong035@gmail.com)
	 */
	function _default(ecModel, api, payload) {
	  ecModel.eachSeriesByType('sankey', function (seriesModel) {
	    var nodeWidth = seriesModel.get('nodeWidth');
	    var nodeGap = seriesModel.get('nodeGap');
	    var layoutInfo = getViewRect(seriesModel, api);
	    seriesModel.layoutInfo = layoutInfo;
	    var width = layoutInfo.width;
	    var height = layoutInfo.height;
	    var graph = seriesModel.getGraph();
	    var nodes = graph.nodes;
	    var edges = graph.edges;
	    computeNodeValues(nodes);
	    var filteredNodes = zrUtil.filter(nodes, function (node) {
	      return node.getLayout().value === 0;
	    });
	    var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get('layoutIterations');
	    layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations);
	  });
	}
	/**
	 * Get the layout position of the whole view
	 *
	 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
	 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
	 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
	 */
	
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations) {
	  computeNodeBreadths(nodes, nodeWidth, width);
	  computeNodeDepths(nodes, edges, height, nodeGap, iterations);
	  computeEdgeDepths(nodes);
	}
	/**
	 * Compute the value of each node by summing the associated edge's value
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 */
	
	
	function computeNodeValues(nodes) {
	  zrUtil.each(nodes, function (node) {
	    var value1 = sum(node.outEdges, getEdgeValue);
	    var value2 = sum(node.inEdges, getEdgeValue);
	    var value = Math.max(value1, value2);
	    node.setLayout({
	      value: value
	    }, true);
	  });
	}
	/**
	 * Compute the x-position for each node
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param  {number} nodeWidth  the dx of the node
	 * @param  {number} width  the whole width of the area to draw the view
	 */
	
	
	function computeNodeBreadths(nodes, nodeWidth, width) {
	  var remainNodes = nodes;
	  var nextNode = null;
	  var x = 0;
	  var kx = 0;
	
	  while (remainNodes.length) {
	    nextNode = [];
	
	    for (var i = 0, len = remainNodes.length; i < len; i++) {
	      var node = remainNodes[i];
	      node.setLayout({
	        x: x
	      }, true);
	      node.setLayout({
	        dx: nodeWidth
	      }, true);
	
	      for (var j = 0, lenj = node.outEdges.length; j < lenj; j++) {
	        nextNode.push(node.outEdges[j].node2);
	      }
	    }
	
	    remainNodes = nextNode;
	    ++x;
	  }
	
	  moveSinksRight(nodes, x);
	  kx = (width - nodeWidth) / (x - 1);
	  scaleNodeBreadths(nodes, kx);
	}
	/**
	 * All the node without outEgdes are assigned maximum x-position and
	 *     be aligned in the last column.
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {number} x  value (x-1) use to assign to node without outEdges
	 *     as x-position
	 */
	
	
	function moveSinksRight(nodes, x) {
	  zrUtil.each(nodes, function (node) {
	    if (!node.outEdges.length) {
	      node.setLayout({
	        x: x - 1
	      }, true);
	    }
	  });
	}
	/**
	 * Scale node x-position to the width
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {number} kx   multiple used to scale nodes
	 */
	
	
	function scaleNodeBreadths(nodes, kx) {
	  zrUtil.each(nodes, function (node) {
	    var nodeX = node.getLayout().x * kx;
	    node.setLayout({
	      x: nodeX
	    }, true);
	  });
	}
	/**
	 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
	 * @param {number} height  the whole height of the area to draw the view
	 * @param {number} nodeGap  the vertical distance between two nodes
	 *     in the same column.
	 * @param {number} iterations  the number of iterations for the algorithm
	 */
	
	
	function computeNodeDepths(nodes, edges, height, nodeGap, iterations) {
	  var nodesByBreadth = nest().key(function (d) {
	    return d.getLayout().x;
	  }).sortKeys(ascending).entries(nodes).map(function (d) {
	    return d.values;
	  });
	  initializeNodeDepth(nodes, nodesByBreadth, edges, height, nodeGap);
	  resolveCollisions(nodesByBreadth, nodeGap, height);
	
	  for (var alpha = 1; iterations > 0; iterations--) {
	    // 0.99 is a experience parameter, ensure that each iterations of
	    // changes as small as possible.
	    alpha *= 0.99;
	    relaxRightToLeft(nodesByBreadth, alpha);
	    resolveCollisions(nodesByBreadth, nodeGap, height);
	    relaxLeftToRight(nodesByBreadth, alpha);
	    resolveCollisions(nodesByBreadth, nodeGap, height);
	  }
	}
	/**
	 * Compute the original y-position for each node
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the nodes x-position.
	 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
	 * @param {number} height  the whole height of the area to draw the view
	 * @param {number} nodeGap  the vertical distance between two nodes
	 */
	
	
	function initializeNodeDepth(nodes, nodesByBreadth, edges, height, nodeGap) {
	  var kyArray = [];
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    var n = nodes.length;
	    var sum = 0;
	    zrUtil.each(nodes, function (node) {
	      sum += node.getLayout().value;
	    });
	    var ky = (height - (n - 1) * nodeGap) / sum;
	    kyArray.push(ky);
	  });
	  kyArray.sort(function (a, b) {
	    return a - b;
	  });
	  var ky0 = kyArray[0];
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    zrUtil.each(nodes, function (node, i) {
	      node.setLayout({
	        y: i
	      }, true);
	      var nodeDy = node.getLayout().value * ky0;
	      node.setLayout({
	        dy: nodeDy
	      }, true);
	    });
	  });
	  zrUtil.each(edges, function (edge) {
	    var edgeDy = +edge.getValue() * ky0;
	    edge.setLayout({
	      dy: edgeDy
	    }, true);
	  });
	}
	/**
	 * Resolve the collision of initialized depth (y-position)
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the nodes x-position.
	 * @param {number} nodeGap  the vertical distance between two nodes
	 * @param {number} height  the whole height of the area to draw the view
	 */
	
	
	function resolveCollisions(nodesByBreadth, nodeGap, height) {
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    var node;
	    var dy;
	    var y0 = 0;
	    var n = nodes.length;
	    var i;
	    nodes.sort(ascendingDepth);
	
	    for (i = 0; i < n; i++) {
	      node = nodes[i];
	      dy = y0 - node.getLayout().y;
	
	      if (dy > 0) {
	        var nodeY = node.getLayout().y + dy;
	        node.setLayout({
	          y: nodeY
	        }, true);
	      }
	
	      y0 = node.getLayout().y + node.getLayout().dy + nodeGap;
	    } // if the bottommost node goes outside the bounds, push it back up
	
	
	    dy = y0 - nodeGap - height;
	
	    if (dy > 0) {
	      var nodeY = node.getLayout().y - dy;
	      node.setLayout({
	        y: nodeY
	      }, true);
	      y0 = node.getLayout().y;
	
	      for (i = n - 2; i >= 0; --i) {
	        node = nodes[i];
	        dy = node.getLayout().y + node.getLayout().dy + nodeGap - y0;
	
	        if (dy > 0) {
	          nodeY = node.getLayout().y - dy;
	          node.setLayout({
	            y: nodeY
	          }, true);
	        }
	
	        y0 = node.getLayout().y;
	      }
	    }
	  });
	}
	/**
	 * Change the y-position of the nodes, except most the right side nodes
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the node x-position.
	 * @param {number} alpha  parameter used to adjust the nodes y-position
	 */
	
	
	function relaxRightToLeft(nodesByBreadth, alpha) {
	  zrUtil.each(nodesByBreadth.slice().reverse(), function (nodes) {
	    zrUtil.each(nodes, function (node) {
	      if (node.outEdges.length) {
	        var y = sum(node.outEdges, weightedTarget) / sum(node.outEdges, getEdgeValue);
	        var nodeY = node.getLayout().y + (y - center(node)) * alpha;
	        node.setLayout({
	          y: nodeY
	        }, true);
	      }
	    });
	  });
	}
	
	function weightedTarget(edge) {
	  return center(edge.node2) * edge.getValue();
	}
	/**
	 * Change the y-position of the nodes, except most the left side nodes
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the node x-position.
	 * @param {number} alpha  parameter used to adjust the nodes y-position
	 */
	
	
	function relaxLeftToRight(nodesByBreadth, alpha) {
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    zrUtil.each(nodes, function (node) {
	      if (node.inEdges.length) {
	        var y = sum(node.inEdges, weightedSource) / sum(node.inEdges, getEdgeValue);
	        var nodeY = node.getLayout().y + (y - center(node)) * alpha;
	        node.setLayout({
	          y: nodeY
	        }, true);
	      }
	    });
	  });
	}
	
	function weightedSource(edge) {
	  return center(edge.node1) * edge.getValue();
	}
	/**
	 * Compute the depth(y-position) of each edge
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 */
	
	
	function computeEdgeDepths(nodes) {
	  zrUtil.each(nodes, function (node) {
	    node.outEdges.sort(ascendingTargetDepth);
	    node.inEdges.sort(ascendingSourceDepth);
	  });
	  zrUtil.each(nodes, function (node) {
	    var sy = 0;
	    var ty = 0;
	    zrUtil.each(node.outEdges, function (edge) {
	      edge.setLayout({
	        sy: sy
	      }, true);
	      sy += edge.getLayout().dy;
	    });
	    zrUtil.each(node.inEdges, function (edge) {
	      edge.setLayout({
	        ty: ty
	      }, true);
	      ty += edge.getLayout().dy;
	    });
	  });
	}
	
	function ascendingTargetDepth(a, b) {
	  return a.node2.getLayout().y - b.node2.getLayout().y;
	}
	
	function ascendingSourceDepth(a, b) {
	  return a.node1.getLayout().y - b.node1.getLayout().y;
	}
	
	function sum(array, f) {
	  var sum = 0;
	  var len = array.length;
	  var i = -1;
	
	  while (++i < len) {
	    var value = +f.call(array, array[i], i);
	
	    if (!isNaN(value)) {
	      sum += value;
	    }
	  }
	
	  return sum;
	}
	
	function center(node) {
	  return node.getLayout().y + node.getLayout().dy / 2;
	}
	
	function ascendingDepth(a, b) {
	  return a.getLayout().y - b.getLayout().y;
	}
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a === b ? 0 : NaN;
	}
	
	function getEdgeValue(edge) {
	  return edge.getValue();
	}
	
	module.exports = _default;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	var VisualMapping = __webpack_require__(46);
	
	var zrUtil = __webpack_require__(1);
	
	/**
	 * @file Visual encoding for sankey view
	 * @author  Deqing Li(annong035@gmail.com)
	 */
	function _default(ecModel, payload) {
	  ecModel.eachSeriesByType('sankey', function (seriesModel) {
	    var graph = seriesModel.getGraph();
	    var nodes = graph.nodes;
	    nodes.sort(function (a, b) {
	      return a.getLayout().value - b.getLayout().value;
	    });
	    var minValue = nodes[0].getLayout().value;
	    var maxValue = nodes[nodes.length - 1].getLayout().value;
	    zrUtil.each(nodes, function (node) {
	      var mapping = new VisualMapping({
	        type: 'color',
	        mappingMethod: 'linear',
	        dataExtent: [minValue, maxValue],
	        visual: seriesModel.get('color')
	      });
	      var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
	      node.setVisual('color', mapValueToColor); // If set itemStyle.normal.color
	
	      var itemModel = node.getModel();
	      var customColor = itemModel.get('itemStyle.normal.color');
	
	      if (customColor != null) {
	        node.setVisual('color', customColor);
	      }
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	__webpack_require__(436);
	
	__webpack_require__(437);
	
	var visualSymbol = __webpack_require__(47);
	
	var layoutPoints = __webpack_require__(129);
	
	__webpack_require__(70);
	
	// In case developer forget to include grid component
	echarts.registerVisual(zrUtil.curry(visualSymbol, 'scatter', 'circle', null));
	echarts.registerLayout(zrUtil.curry(layoutPoints, 'scatter'));

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	var createListFromArray = __webpack_require__(34);
	
	var SeriesModel = __webpack_require__(20);
	
	var _default = SeriesModel.extend({
	  type: 'series.scatter',
	  dependencies: ['grid', 'polar', 'geo', 'singleAxis', 'calendar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(option.data, this, ecModel);
	  },
	  brushSelector: 'point',
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // symbol: null,        // 图形类型
	    symbolSize: 10,
	    // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
	    // symbolRotate: null,  // 图形旋转控制
	    large: false,
	    // Available when large is true
	    largeThreshold: 2000,
	    // cursor: null,
	    // label: {
	    // normal: {
	    // show: false
	    // distance: 5,
	    // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	    // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
	    //           'inside'|'left'|'right'|'top'|'bottom'
	    // 默认使用全局文本样式，详见TEXTSTYLE
	    //     }
	    // },
	    itemStyle: {
	      normal: {
	        opacity: 0.8 // color: 各异
	
	      }
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var SymbolDraw = __webpack_require__(65);
	
	var LargeSymbolDraw = __webpack_require__(396);
	
	echarts.extendChartView({
	  type: 'scatter',
	  init: function () {
	    this._normalSymbolDraw = new SymbolDraw();
	    this._largeSymbolDraw = new LargeSymbolDraw();
	  },
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var largeSymbolDraw = this._largeSymbolDraw;
	    var normalSymbolDraw = this._normalSymbolDraw;
	    var group = this.group;
	    var symbolDraw = seriesModel.get('large') && data.count() > seriesModel.get('largeThreshold') ? largeSymbolDraw : normalSymbolDraw;
	    this._symbolDraw = symbolDraw;
	    symbolDraw.updateData(data);
	    group.add(symbolDraw.group);
	    group.remove(symbolDraw === largeSymbolDraw ? normalSymbolDraw.group : largeSymbolDraw.group);
	  },
	  updateLayout: function (seriesModel) {
	    this._symbolDraw.updateLayout(seriesModel);
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove(api, true);
	  },
	  dispose: function () {}
	});

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	__webpack_require__(185);
	
	__webpack_require__(439);
	
	__webpack_require__(440);
	
	var themeRiverLayout = __webpack_require__(441);
	
	var themeRiverVisual = __webpack_require__(442);
	
	var dataFilter = __webpack_require__(90);
	
	echarts.registerLayout(themeRiverLayout);
	echarts.registerVisual(themeRiverVisual);
	echarts.registerProcessor(zrUtil.curry(dataFilter, 'themeRiver'));

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	var completeDimensions = __webpack_require__(25);
	
	var SeriesModel = __webpack_require__(20);
	
	var List = __webpack_require__(15);
	
	var zrUtil = __webpack_require__(1);
	
	var _format = __webpack_require__(9);
	
	var encodeHTML = _format.encodeHTML;
	
	var nest = __webpack_require__(204);
	
	/**
	 * @file  Define the themeRiver view's series model
	 * @author Deqing Li(annong035@gmail.com)
	 */
	var DATA_NAME_INDEX = 2;
	var ThemeRiverSeries = SeriesModel.extend({
	  type: 'series.themeRiver',
	  dependencies: ['singleAxis'],
	
	  /**
	   * @readOnly
	   * @type {module:zrender/core/util#HashMap}
	   */
	  nameMap: null,
	
	  /**
	   * @override
	   */
	  init: function (option) {
	    ThemeRiverSeries.superApply(this, 'init', arguments); // Put this function here is for the sake of consistency of code style.
	    // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendDataProvider = function () {
	      return this.getRawData();
	    };
	  },
	
	  /**
	   * If there is no value of a certain point in the time for some event,set it value to 0.
	   *
	   * @param {Array} data  initial data in the option
	   * @return {Array}
	   */
	  fixData: function (data) {
	    var rawDataLength = data.length; // grouped data by name
	
	    var dataByName = nest().key(function (dataItem) {
	      return dataItem[2];
	    }).entries(data); // data group in each layer
	
	    var layData = zrUtil.map(dataByName, function (d) {
	      return {
	        name: d.key,
	        dataList: d.values
	      };
	    });
	    var layerNum = layData.length;
	    var largestLayer = -1;
	    var index = -1;
	
	    for (var i = 0; i < layerNum; ++i) {
	      var len = layData[i].dataList.length;
	
	      if (len > largestLayer) {
	        largestLayer = len;
	        index = i;
	      }
	    }
	
	    for (var k = 0; k < layerNum; ++k) {
	      if (k === index) {
	        continue;
	      }
	
	      var name = layData[k].name;
	
	      for (var j = 0; j < largestLayer; ++j) {
	        var timeValue = layData[index].dataList[j][0];
	        var length = layData[k].dataList.length;
	        var keyIndex = -1;
	
	        for (var l = 0; l < length; ++l) {
	          var value = layData[k].dataList[l][0];
	
	          if (value === timeValue) {
	            keyIndex = l;
	            break;
	          }
	        }
	
	        if (keyIndex === -1) {
	          data[rawDataLength] = [];
	          data[rawDataLength][0] = timeValue;
	          data[rawDataLength][1] = 0;
	          data[rawDataLength][2] = name;
	          rawDataLength++;
	        }
	      }
	    }
	
	    return data;
	  },
	
	  /**
	   * @override
	   * @param  {Object} option  the initial option that user gived
	   * @param  {module:echarts/model/Model} ecModel  the model object for themeRiver option
	   * @return {module:echarts/data/List}
	   */
	  getInitialData: function (option, ecModel) {
	    var dimensions = [];
	    var singleAxisModel = ecModel.queryComponents({
	      mainType: 'singleAxis',
	      index: this.get('singleAxisIndex'),
	      id: this.get('singleAxisId')
	    })[0];
	    var axisType = singleAxisModel.get('type');
	    dimensions = [{
	      name: 'time',
	      // FIXME common?
	      type: axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float'
	    }, {
	      name: 'value',
	      type: 'float'
	    }, {
	      name: 'name',
	      type: 'ordinal'
	    }]; // filter the data item with the value of label is undefined
	
	    var filterData = zrUtil.filter(option.data, function (dataItem) {
	      return dataItem[2] !== undefined;
	    });
	    var data = this.fixData(filterData || []);
	    var nameList = [];
	    var nameMap = this.nameMap = zrUtil.createHashMap();
	    var count = 0;
	
	    for (var i = 0; i < data.length; ++i) {
	      nameList.push(data[i][DATA_NAME_INDEX]);
	
	      if (!nameMap.get(data[i][DATA_NAME_INDEX])) {
	        nameMap.set(data[i][DATA_NAME_INDEX], count);
	        count++;
	      }
	    }
	
	    dimensions = completeDimensions(dimensions, data);
	    var list = new List(dimensions, this);
	    list.initData(data, nameList);
	    return list;
	  },
	
	  /**
	   * Used by single coordinate
	   *
	   * @param {string} axisDim  the dimension for single coordinate
	   * @return {Array.<string> } specified dimensions on the axis.
	   */
	  coordDimToDataDim: function (axisDim) {
	    return ['time'];
	  },
	
	  /**
	   * The raw data is divided into multiple layers and each layer
	   *     has same name.
	   *
	   * @return {Array.<Array.<number>>}
	   */
	  getLayerSeries: function () {
	    var data = this.getData();
	    var lenCount = data.count();
	    var indexArr = [];
	
	    for (var i = 0; i < lenCount; ++i) {
	      indexArr[i] = i;
	    } // data group by name
	
	
	    var dataByName = nest().key(function (index) {
	      return data.get('name', index);
	    }).entries(indexArr);
	    var layerSeries = zrUtil.map(dataByName, function (d) {
	      return {
	        name: d.key,
	        indices: d.values
	      };
	    });
	
	    for (var j = 0; j < layerSeries.length; ++j) {
	      layerSeries[j].indices.sort(comparer);
	    }
	
	    function comparer(index1, index2) {
	      return data.get('time', index1) - data.get('time', index2);
	    }
	
	    return layerSeries;
	  },
	
	  /**
	   * Get data indices for show tooltip content
	   *
	   * @param {Array.<string>|string} dim  single coordinate dimension
	   * @param {number} value axis value
	   * @param {module:echarts/coord/single/SingleAxis} baseAxis  single Axis used
	   *     the themeRiver.
	   * @return {Object} {dataIndices, nestestValue}
	   */
	  getAxisTooltipData: function (dim, value, baseAxis) {
	    if (!zrUtil.isArray(dim)) {
	      dim = dim ? [dim] : [];
	    }
	
	    var data = this.getData();
	    var layerSeries = this.getLayerSeries();
	    var indices = [];
	    var layerNum = layerSeries.length;
	    var nestestValue;
	
	    for (var i = 0; i < layerNum; ++i) {
	      var minDist = Number.MAX_VALUE;
	      var nearestIdx = -1;
	      var pointNum = layerSeries[i].indices.length;
	
	      for (var j = 0; j < pointNum; ++j) {
	        var theValue = data.get(dim[0], layerSeries[i].indices[j]);
	        var dist = Math.abs(theValue - value);
	
	        if (dist <= minDist) {
	          nestestValue = theValue;
	          minDist = dist;
	          nearestIdx = layerSeries[i].indices[j];
	        }
	      }
	
	      indices.push(nearestIdx);
	    }
	
	    return {
	      dataIndices: indices,
	      nestestValue: nestestValue
	    };
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex  index of data
	   */
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var htmlName = data.get('name', dataIndex);
	    var htmlValue = data.get('value', dataIndex);
	
	    if (isNaN(htmlValue) || htmlValue == null) {
	      htmlValue = '-';
	    }
	
	    return encodeHTML(htmlName + ' : ' + htmlValue);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'singleAxis',
	    // gap in axis's orthogonal orientation
	    boundaryGap: ['10%', '10%'],
	    // legendHoverLink: true,
	    singleAxisIndex: 0,
	    animationEasing: 'linear',
	    label: {
	      normal: {
	        margin: 4,
	        textAlign: 'right',
	        show: true,
	        position: 'left',
	        color: '#000',
	        fontSize: 11
	      },
	      emphasis: {
	        show: true
	      }
	    }
	  }
	});
	var _default = ThemeRiverSeries;
	module.exports = _default;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var echarts = __webpack_require__(2);
	
	var _poly = __webpack_require__(164);
	
	var Polygon = _poly.Polygon;
	
	var graphic = __webpack_require__(3);
	
	var _util = __webpack_require__(1);
	
	var bind = _util.bind;
	var extend = _util.extend;
	
	var DataDiffer = __webpack_require__(56);
	
	/**
	 * @file  The file used to draw themeRiver view
	 * @author  Deqing Li(annong035@gmail.com)
	 */
	var _default = echarts.extendChartView({
	  type: 'themeRiver',
	  init: function () {
	    this._layers = [];
	  },
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var group = this.group;
	    var layerSeries = seriesModel.getLayerSeries();
	    var layoutInfo = data.getLayout('layoutInfo');
	    var rect = layoutInfo.rect;
	    var boundaryGap = layoutInfo.boundaryGap;
	    group.attr('position', [0, rect.y + boundaryGap[0]]);
	
	    function keyGetter(item) {
	      return item.name;
	    }
	
	    var dataDiffer = new DataDiffer(this._layersSeries || [], layerSeries, keyGetter, keyGetter);
	    var newLayersGroups = {};
	    dataDiffer.add(bind(process, this, 'add')).update(bind(process, this, 'update')).remove(bind(process, this, 'remove')).execute();
	
	    function process(status, idx, oldIdx) {
	      var oldLayersGroups = this._layers;
	
	      if (status === 'remove') {
	        group.remove(oldLayersGroups[idx]);
	        return;
	      }
	
	      var points0 = [];
	      var points1 = [];
	      var color;
	      var indices = layerSeries[idx].indices;
	
	      for (var j = 0; j < indices.length; j++) {
	        var layout = data.getItemLayout(indices[j]);
	        var x = layout.x;
	        var y0 = layout.y0;
	        var y = layout.y;
	        points0.push([x, y0]);
	        points1.push([x, y0 + y]);
	        color = data.getItemVisual(indices[j], 'color');
	      }
	
	      var polygon;
	      var text;
	      var textLayout = data.getItemLayout(indices[0]);
	      var itemModel = data.getItemModel(indices[j - 1]);
	      var labelModel = itemModel.getModel('label.normal');
	      var margin = labelModel.get('margin');
	
	      if (status === 'add') {
	        var layerGroup = newLayersGroups[idx] = new graphic.Group();
	        polygon = new Polygon({
	          shape: {
	            points: points0,
	            stackedOnPoints: points1,
	            smooth: 0.4,
	            stackedOnSmooth: 0.4,
	            smoothConstraint: false
	          },
	          z2: 0
	        });
	        text = new graphic.Text({
	          style: {
	            x: textLayout.x - margin,
	            y: textLayout.y0 + textLayout.y / 2
	          }
	        });
	        layerGroup.add(polygon);
	        layerGroup.add(text);
	        group.add(layerGroup);
	        polygon.setClipPath(createGridClipShape(polygon.getBoundingRect(), seriesModel, function () {
	          polygon.removeClipPath();
	        }));
	      } else {
	        var layerGroup = oldLayersGroups[oldIdx];
	        polygon = layerGroup.childAt(0);
	        text = layerGroup.childAt(1);
	        group.add(layerGroup);
	        newLayersGroups[idx] = layerGroup;
	        graphic.updateProps(polygon, {
	          shape: {
	            points: points0,
	            stackedOnPoints: points1
	          }
	        }, seriesModel);
	        graphic.updateProps(text, {
	          style: {
	            x: textLayout.x - margin,
	            y: textLayout.y0 + textLayout.y / 2
	          }
	        }, seriesModel);
	      }
	
	      var hoverItemStyleModel = itemModel.getModel('itemStyle.emphasis');
	      var itemStyleModel = itemModel.getModel('itemStyle.normal');
	      graphic.setTextStyle(text.style, labelModel, {
	        text: labelModel.get('show') ? seriesModel.getFormattedLabel(indices[j - 1], 'normal') || data.getName(indices[j - 1]) : null,
	        textVerticalAlign: 'middle'
	      });
	      polygon.setStyle(extend({
	        fill: color
	      }, itemStyleModel.getItemStyle(['color'])));
	      graphic.setHoverStyle(polygon, hoverItemStyleModel.getItemStyle());
	    }
	
	    this._layersSeries = layerSeries;
	    this._layers = newLayersGroups;
	  },
	  dispose: function () {}
	}); // add animation to the view
	
	
	function createGridClipShape(rect, seriesModel, cb) {
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x - 10,
	      y: rect.y - 10,
	      width: 0,
	      height: rect.height + 20
	    }
	  });
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width + 20,
	      height: rect.height + 20
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	module.exports = _default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(207)))

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var numberUtil = __webpack_require__(4);
	
	/**
	 * @file  Using layout algorithm transform the raw data to layout information.
	 * @author Deqing Li(annong035@gmail.com)
	 */
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
	    var data = seriesModel.getData();
	    var single = seriesModel.coordinateSystem;
	    var layoutInfo = {}; // use the axis boundingRect for view
	
	    var rect = single.getRect();
	    layoutInfo.rect = rect;
	    var boundaryGap = seriesModel.get('boundaryGap');
	    var axis = single.getAxis();
	    layoutInfo.boundaryGap = boundaryGap;
	
	    if (axis.orient === 'horizontal') {
	      boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], rect.height);
	      boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], rect.height);
	      var height = rect.height - boundaryGap[0] - boundaryGap[1];
	      themeRiverLayout(data, seriesModel, height);
	    } else {
	      boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], rect.width);
	      boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], rect.width);
	      var width = rect.width - boundaryGap[0] - boundaryGap[1];
	      themeRiverLayout(data, seriesModel, width);
	    }
	
	    data.setLayout('layoutInfo', layoutInfo);
	  });
	}
	/**
	 * The layout information about themeriver
	 *
	 * @param {module:echarts/data/List} data  data in the series
	 * @param {module:echarts/model/Series} seriesModel  the model object of themeRiver series
	 * @param {number} height  value used to compute every series height
	 */
	
	
	function themeRiverLayout(data, seriesModel, height) {
	  if (!data.count()) {
	    return;
	  }
	
	  var coordSys = seriesModel.coordinateSystem; // the data in each layer are organized into a series.
	
	  var layerSeries = seriesModel.getLayerSeries(); // the points in each layer.
	
	  var layerPoints = zrUtil.map(layerSeries, function (singleLayer) {
	    return zrUtil.map(singleLayer.indices, function (idx) {
	      var pt = coordSys.dataToPoint(data.get('time', idx));
	      pt[1] = data.get('value', idx);
	      return pt;
	    });
	  });
	  var base = computeBaseline(layerPoints);
	  var baseLine = base.y0;
	  var ky = height / base.max; // set layout information for each item.
	
	  var n = layerSeries.length;
	  var m = layerSeries[0].indices.length;
	  var baseY0;
	
	  for (var j = 0; j < m; ++j) {
	    baseY0 = baseLine[j] * ky;
	    data.setItemLayout(layerSeries[0].indices[j], {
	      layerIndex: 0,
	      x: layerPoints[0][j][0],
	      y0: baseY0,
	      y: layerPoints[0][j][1] * ky
	    });
	
	    for (var i = 1; i < n; ++i) {
	      baseY0 += layerPoints[i - 1][j][1] * ky;
	      data.setItemLayout(layerSeries[i].indices[j], {
	        layerIndex: i,
	        x: layerPoints[i][j][0],
	        y0: baseY0,
	        y: layerPoints[i][j][1] * ky
	      });
	    }
	  }
	}
	/**
	 * Compute the baseLine of the rawdata
	 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
	 *
	 * @param  {Array.<Array>} data  the points in each layer
	 * @return {Object}
	 */
	
	
	function computeBaseline(data) {
	  var layerNum = data.length;
	  var pointNum = data[0].length;
	  var sums = [];
	  var y0 = [];
	  var max = 0;
	  var temp;
	  var base = {};
	
	  for (var i = 0; i < pointNum; ++i) {
	    for (var j = 0, temp = 0; j < layerNum; ++j) {
	      temp += data[j][i][1];
	    }
	
	    if (temp > max) {
	      max = temp;
	    }
	
	    sums.push(temp);
	  }
	
	  for (var k = 0; k < pointNum; ++k) {
	    y0[k] = (max - sums[k]) / 2;
	  }
	
	  max = 0;
	
	  for (var l = 0; l < pointNum; ++l) {
	    var sum = sums[l] + y0[l];
	
	    if (sum > max) {
	      max = sum;
	    }
	  }
	
	  base.y0 = y0;
	  base.max = max;
	  return base;
	}
	
	module.exports = _default;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(1);
	
	var createHashMap = _util.createHashMap;
	
	/**
	 * @file Visual encoding for themeRiver view
	 * @author  Deqing Li(annong035@gmail.com)
	 */
	function _default(ecModel) {
	  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
	    var data = seriesModel.getData();
	    var rawData = seriesModel.getRawData();
	    var colorList = seriesModel.get('color');
	    var idxMap = createHashMap();
	    data.each(function (idx) {
	      idxMap.set(data.getRawIndex(idx), idx);
	    });
	    rawData.each(function (rawIndex) {
	      var name = rawData.getName(rawIndex);
	      var color = colorList[(seriesModel.nameMap.get(name) - 1) % colorList.length];
	      rawData.setItemVisual(rawIndex, 'color', color);
	      var idx = idxMap.get(rawIndex);
	
	      if (idx != null) {
	        data.setItemVisual(idx, 'color', color);
	      }
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	__webpack_require__(444);
	
	__webpack_require__(445);
	
	__webpack_require__(449);
	
	var visualSymbol = __webpack_require__(47);
	
	var orthogonalLayout = __webpack_require__(446);
	
	var radialLayout = __webpack_require__(447);
	
	echarts.registerVisual(zrUtil.curry(visualSymbol, 'tree', 'circle', null));
	echarts.registerLayout(orthogonalLayout);
	echarts.registerLayout(radialLayout);

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	var SeriesModel = __webpack_require__(20);
	
	var Tree = __webpack_require__(199);
	
	var _format = __webpack_require__(9);
	
	var encodeHTML = _format.encodeHTML;
	
	/**
	 * @file Create data struct and define tree view's series model
	 */
	var _default = SeriesModel.extend({
	  type: 'series.tree',
	  layoutInfo: null,
	  // can support the position parameters 'left', 'top','right','bottom', 'width',
	  // 'height' in the setOption() with 'merge' mode normal.
	  layoutMode: 'box',
	
	  /**
	   * Init a tree data structure from data in option series
	   * @param  {Object} option  the object used to config echarts view
	   * @return {module:echarts/data/List} storage initial data
	   */
	  getInitialData: function (option) {
	    //create an virtual root
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    var leaves = option.leaves || {};
	    var treeOption = {};
	    treeOption.leaves = leaves;
	    var tree = Tree.createTree(root, this, treeOption);
	    var treeDepth = 0;
	    tree.eachNode('preorder', function (node) {
	      if (node.depth > treeDepth) {
	        treeDepth = node.depth;
	      }
	    });
	    var expandAndCollapse = option.expandAndCollapse;
	    var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
	    tree.root.eachNode('preorder', function (node) {
	      var item = node.hostTree.data.getRawDataItem(node.dataIndex);
	      node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
	    });
	    return tree.data;
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex
	   */
	  formatTooltip: function (dataIndex) {
	    var tree = this.getData().tree;
	    var realRoot = tree.root.children[0];
	    var node = tree.getNodeByDataIndex(dataIndex);
	    var value = node.getValue();
	    var name = node.name;
	
	    while (node && node !== realRoot) {
	      name = node.parentNode.name + '.' + name;
	      node = node.parentNode;
	    }
	
	    return encodeHTML(name + (isNaN(value) || value == null ? '' : ' : ' + value));
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    // the position of the whole view
	    left: '12%',
	    top: '12%',
	    right: '12%',
	    bottom: '12%',
	    // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
	    layout: 'orthogonal',
	    // the orient of orthoginal layout, can be setted to 'horizontal' or 'vertical'
	    orient: 'horizontal',
	    symbol: 'emptyCircle',
	    symbolSize: 7,
	    expandAndCollapse: true,
	    initialTreeDepth: 2,
	    lineStyle: {
	      normal: {
	        color: '#ccc',
	        width: 1.5,
	        curveness: 0.5
	      }
	    },
	    itemStyle: {
	      normal: {
	        color: 'lightsteelblue',
	        borderColor: '#c23531',
	        borderWidth: 1.5
	      }
	    },
	    label: {
	      normal: {
	        show: true,
	        color: '#555'
	      }
	    },
	    leaves: {
	      label: {
	        normal: {
	          show: true
	        }
	      }
	    },
	    animationEasing: 'linear',
	    animationDuration: 700,
	    animationDurationUpdate: 1000
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var SymbolClz = __webpack_require__(83);
	
	var _layoutHelper = __webpack_require__(166);
	
	var radialCoordinate = _layoutHelper.radialCoordinate;
	
	var echarts = __webpack_require__(2);
	
	/**
	 * @file  This file used to draw tree view
	 */
	var _default = echarts.extendChartView({
	  type: 'tree',
	
	  /**
	   * Init the chart
	   * @override
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {module:echarts/data/Tree}
	     */
	    this._oldTree;
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	    this._mainGroup = new graphic.Group();
	    this.group.add(this._mainGroup);
	  },
	  render: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var layoutInfo = seriesModel.layoutInfo;
	    var group = this._mainGroup;
	    var layout = seriesModel.get('layout');
	
	    if (layout === 'radial') {
	      group.attr('position', [layoutInfo.x + layoutInfo.width / 2, layoutInfo.y + layoutInfo.height / 2]);
	    } else {
	      group.attr('position', [layoutInfo.x, layoutInfo.y]);
	    }
	
	    var oldData = this._data;
	    var seriesScope = {
	      expandAndCollapse: seriesModel.get('expandAndCollapse'),
	      layout: layout,
	      orient: seriesModel.get('orient'),
	      curvature: seriesModel.get('lineStyle.normal.curveness'),
	      symbolRotate: seriesModel.get('symbolRotate'),
	      symbolOffset: seriesModel.get('symbolOffset'),
	      hoverAnimation: seriesModel.get('hoverAnimation'),
	      useNameLabel: true,
	      fadeIn: true
	    };
	    data.diff(oldData).add(function (newIdx) {
	      if (symbolNeedsDraw(data, newIdx)) {
	        // create node and edge
	        updateNode(data, newIdx, null, group, seriesModel, seriesScope);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx);
	
	      if (!symbolNeedsDraw(data, newIdx)) {
	        symbolEl && removeNode(data, newIdx, symbolEl, group, seriesModel, seriesScope);
	        return;
	      } // update  node and edge
	
	
	      updateNode(data, newIdx, symbolEl, group, seriesModel, seriesScope);
	    }).remove(function (oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx);
	      removeNode(data, oldIdx, symbolEl, group, seriesModel, seriesScope);
	    }).execute();
	
	    if (seriesScope.expandAndCollapse === true) {
	      data.eachItemGraphicEl(function (el, dataIndex) {
	        el.off('click').on('click', function () {
	          api.dispatchAction({
	            type: 'treeExpandAndCollapse',
	            seriesId: seriesModel.id,
	            dataIndex: dataIndex
	          });
	        });
	      });
	    }
	
	    this._data = data;
	  },
	  dispose: function () {},
	  remove: function () {
	    this._mainGroup.removeAll();
	
	    this._data = null;
	  }
	});
	
	function symbolNeedsDraw(data, dataIndex) {
	  var layout = data.getItemLayout(dataIndex);
	  return layout && !isNaN(layout.x) && !isNaN(layout.y) && data.getItemVisual(dataIndex, 'symbol') !== 'none';
	}
	
	function getTreeNodeStyle(node, itemModel, seriesScope) {
	  seriesScope.itemModel = itemModel;
	  seriesScope.itemStyle = itemModel.getModel('itemStyle.normal').getItemStyle();
	  seriesScope.hoverItemStyle = itemModel.getModel('itemStyle.emphasis').getItemStyle();
	  seriesScope.lineStyle = itemModel.getModel('lineStyle.normal').getLineStyle();
	  seriesScope.labelModel = itemModel.getModel('label.normal');
	  seriesScope.hoverLabelModel = itemModel.getModel('label.emphasis');
	
	  if (node.isExpand === false && node.children.length !== 0) {
	    seriesScope.symbolInnerColor = seriesScope.itemStyle.fill;
	  } else {
	    seriesScope.symbolInnerColor = '#fff';
	  }
	
	  return seriesScope;
	}
	
	function updateNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
	  var isInit = !symbolEl;
	  var node = data.tree.getNodeByDataIndex(dataIndex);
	  var itemModel = node.getModel();
	  var seriesScope = getTreeNodeStyle(node, itemModel, seriesScope);
	  var virtualRoot = data.tree.root;
	  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
	  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
	  var sourceLayout = source.getLayout();
	  var sourceOldLayout = sourceSymbolEl ? {
	    x: sourceSymbolEl.position[0],
	    y: sourceSymbolEl.position[1],
	    rawX: sourceSymbolEl.__radialOldRawX,
	    rawY: sourceSymbolEl.__radialOldRawY
	  } : sourceLayout;
	  var targetLayout = node.getLayout();
	
	  if (isInit) {
	    symbolEl = new SymbolClz(data, dataIndex, seriesScope);
	    symbolEl.attr('position', [sourceOldLayout.x, sourceOldLayout.y]);
	  } else {
	    symbolEl.updateData(data, dataIndex, seriesScope);
	  }
	
	  symbolEl.__radialOldRawX = symbolEl.__radialRawX;
	  symbolEl.__radialOldRawY = symbolEl.__radialRawY;
	  symbolEl.__radialRawX = targetLayout.rawX;
	  symbolEl.__radialRawY = targetLayout.rawY;
	  group.add(symbolEl);
	  data.setItemGraphicEl(dataIndex, symbolEl);
	  graphic.updateProps(symbolEl, {
	    position: [targetLayout.x, targetLayout.y]
	  }, seriesModel);
	  var symbolPath = symbolEl.getSymbolPath();
	
	  if (seriesScope.layout === 'radial') {
	    var realRoot = virtualRoot.children[0];
	    var rootLayout = realRoot.getLayout();
	    var length = realRoot.children.length;
	    var rad;
	    var isLeft;
	
	    if (targetLayout.x === rootLayout.x && node.isExpand === true) {
	      var center = {};
	      center.x = (realRoot.children[0].getLayout().x + realRoot.children[length - 1].getLayout().x) / 2;
	      center.y = (realRoot.children[0].getLayout().y + realRoot.children[length - 1].getLayout().y) / 2;
	      rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);
	
	      if (rad < 0) {
	        rad = Math.PI * 2 + rad;
	      }
	
	      isLeft = center.x < rootLayout.x;
	
	      if (isLeft) {
	        rad = rad - Math.PI;
	      }
	    } else {
	      rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);
	
	      if (rad < 0) {
	        rad = Math.PI * 2 + rad;
	      }
	
	      if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
	        isLeft = targetLayout.x < rootLayout.x;
	
	        if (isLeft) {
	          rad = rad - Math.PI;
	        }
	      } else {
	        isLeft = targetLayout.x > rootLayout.x;
	
	        if (!isLeft) {
	          rad = rad - Math.PI;
	        }
	      }
	    }
	
	    var textPosition = isLeft ? 'left' : 'right';
	    symbolPath.setStyle({
	      textPosition: textPosition,
	      textRotation: -rad,
	      textOrigin: 'center',
	      verticalAlign: 'middle'
	    });
	  }
	
	  if (node.parentNode && node.parentNode !== virtualRoot) {
	    var edge = symbolEl.__edge;
	
	    if (!edge) {
	      edge = symbolEl.__edge = new graphic.BezierCurve({
	        shape: getEdgeShape(seriesScope, sourceOldLayout, sourceOldLayout),
	        style: zrUtil.defaults({
	          opacity: 0
	        }, seriesScope.lineStyle)
	      });
	    }
	
	    graphic.updateProps(edge, {
	      shape: getEdgeShape(seriesScope, sourceLayout, targetLayout),
	      style: {
	        opacity: 1
	      }
	    }, seriesModel);
	    group.add(edge);
	  }
	}
	
	function removeNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
	  var node = data.tree.getNodeByDataIndex(dataIndex);
	  var virtualRoot = data.tree.root;
	  var itemModel = node.getModel();
	  var seriesScope = getTreeNodeStyle(node, itemModel, seriesScope);
	  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
	  var sourceLayout;
	
	  while (sourceLayout = source.getLayout(), sourceLayout == null) {
	    source = source.parentNode === virtualRoot ? source : source.parentNode || source;
	  }
	
	  graphic.updateProps(symbolEl, {
	    position: [sourceLayout.x + 1, sourceLayout.y + 1]
	  }, seriesModel, function () {
	    group.remove(symbolEl);
	    data.setItemGraphicEl(dataIndex, null);
	  });
	  symbolEl.fadeOut(null, {
	    keepLabel: true
	  });
	  var edge = symbolEl.__edge;
	
	  if (edge) {
	    graphic.updateProps(edge, {
	      shape: getEdgeShape(seriesScope, sourceLayout, sourceLayout),
	      style: {
	        opacity: 0
	      }
	    }, seriesModel, function () {
	      group.remove(edge);
	    });
	  }
	}
	
	function getEdgeShape(seriesScope, sourceLayout, targetLayout) {
	  var cpx1;
	  var cpy1;
	  var cpx2;
	  var cpy2;
	  var orient = seriesScope.orient;
	
	  if (seriesScope.layout === 'radial') {
	    var x1 = sourceLayout.rawX;
	    var y1 = sourceLayout.rawY;
	    var x2 = targetLayout.rawX;
	    var y2 = targetLayout.rawY;
	    var radialCoor1 = radialCoordinate(x1, y1);
	    var radialCoor2 = radialCoordinate(x1, y1 + (y2 - y1) * seriesScope.curvature);
	    var radialCoor3 = radialCoordinate(x2, y2 + (y1 - y2) * seriesScope.curvature);
	    var radialCoor4 = radialCoordinate(x2, y2);
	    return {
	      x1: radialCoor1.x,
	      y1: radialCoor1.y,
	      x2: radialCoor4.x,
	      y2: radialCoor4.y,
	      cpx1: radialCoor2.x,
	      cpy1: radialCoor2.y,
	      cpx2: radialCoor3.x,
	      cpy2: radialCoor3.y
	    };
	  } else {
	    var x1 = sourceLayout.x;
	    var y1 = sourceLayout.y;
	    var x2 = targetLayout.x;
	    var y2 = targetLayout.y;
	
	    if (orient === 'horizontal') {
	      cpx1 = x1 + (x2 - x1) * seriesScope.curvature;
	      cpy1 = y1;
	      cpx2 = x2 + (x1 - x2) * seriesScope.curvature;
	      cpy2 = y2;
	    }
	
	    if (orient === 'vertical') {
	      cpx1 = x1;
	      cpy1 = y1 + (y2 - y1) * seriesScope.curvature;
	      cpx2 = x2;
	      cpy2 = y2 + (y1 - y2) * seriesScope.curvature;
	    }
	
	    return {
	      x1: x1,
	      y1: y1,
	      x2: x2,
	      y2: y2,
	      cpx1: cpx1,
	      cpy1: cpy1,
	      cpx2: cpx2,
	      cpy2: cpy2
	    };
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	var commonLayout = __webpack_require__(165);
	
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('tree', function (seriesModel) {
	    commonLayout(seriesModel, api);
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	var commonLayout = __webpack_require__(165);
	
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('tree', function (seriesModel) {
	    commonLayout(seriesModel, api);
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	/**
	 * Traverse the tree from bottom to top and do something
	 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
	 * @param  {Function} callback
	 */
	function eachAfter(root, callback, separation) {
	  var nodes = [root];
	  var next = [];
	  var node;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    next.push(node);
	
	    if (node.isExpand) {
	      var children = node.children;
	
	      if (children.length) {
	        for (var i = 0; i < children.length; i++) {
	          nodes.push(children[i]);
	        }
	      }
	    }
	  }
	
	  while (node = next.pop()) {
	    // jshint ignore:line
	    callback(node, separation);
	  }
	}
	/**
	 * Traverse the tree from top to bottom and do something
	 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
	 * @param  {Function} callback
	 */
	
	
	function eachBefore(root, callback) {
	  var nodes = [root];
	  var node;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    callback(node);
	
	    if (node.isExpand) {
	      var children = node.children;
	
	      if (children.length) {
	        for (var i = children.length - 1; i >= 0; i--) {
	          nodes.push(children[i]);
	        }
	      }
	    }
	  }
	}
	
	exports.eachAfter = eachAfter;
	exports.eachBefore = eachBefore;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	echarts.registerAction({
	  type: 'treeExpandAndCollapse',
	  event: 'treeExpandAndCollapse',
	  update: 'update'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'tree',
	    query: payload
	  }, function (seriesModel) {
	    var dataIndex = payload.dataIndex;
	    var tree = seriesModel.getData().tree;
	    var node = tree.getNodeByDataIndex(dataIndex);
	    node.isExpand = !node.isExpand;
	  });
	});

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	__webpack_require__(452);
	
	__webpack_require__(453);
	
	__webpack_require__(454);
	
	var treemapVisual = __webpack_require__(456);
	
	var treemapLayout = __webpack_require__(455);
	
	echarts.registerVisual(treemapVisual);
	echarts.registerLayout(treemapLayout);

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	var graphic = __webpack_require__(3);
	
	var layout = __webpack_require__(7);
	
	var zrUtil = __webpack_require__(1);
	
	var _helper = __webpack_require__(66);
	
	var wrapTreePathInfo = _helper.wrapTreePathInfo;
	var TEXT_PADDING = 8;
	var ITEM_GAP = 8;
	var ARRAY_LENGTH = 5;
	
	function Breadcrumb(containerGroup) {
	  /**
	   * @private
	   * @type {module:zrender/container/Group}
	   */
	  this.group = new graphic.Group();
	  containerGroup.add(this.group);
	}
	
	Breadcrumb.prototype = {
	  constructor: Breadcrumb,
	  render: function (seriesModel, api, targetNode, onSelect) {
	    var model = seriesModel.getModel('breadcrumb');
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	
	    if (!model.get('show') || !targetNode) {
	      return;
	    }
	
	    var normalStyleModel = model.getModel('itemStyle.normal'); // var emphasisStyleModel = model.getModel('itemStyle.emphasis');
	
	    var textStyleModel = normalStyleModel.getModel('textStyle');
	    var layoutParam = {
	      pos: {
	        left: model.get('left'),
	        right: model.get('right'),
	        top: model.get('top'),
	        bottom: model.get('bottom')
	      },
	      box: {
	        width: api.getWidth(),
	        height: api.getHeight()
	      },
	      emptyItemWidth: model.get('emptyItemWidth'),
	      totalWidth: 0,
	      renderList: []
	    };
	
	    this._prepare(targetNode, layoutParam, textStyleModel);
	
	    this._renderContent(seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect);
	
	    layout.positionElement(thisGroup, layoutParam.pos, layoutParam.box);
	  },
	
	  /**
	   * Prepare render list and total width
	   * @private
	   */
	  _prepare: function (targetNode, layoutParam, textStyleModel) {
	    for (var node = targetNode; node; node = node.parentNode) {
	      var text = node.getModel().get('name');
	      var textRect = textStyleModel.getTextRect(text);
	      var itemWidth = Math.max(textRect.width + TEXT_PADDING * 2, layoutParam.emptyItemWidth);
	      layoutParam.totalWidth += itemWidth + ITEM_GAP;
	      layoutParam.renderList.push({
	        node: node,
	        text: text,
	        width: itemWidth
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderContent: function (seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect) {
	    // Start rendering.
	    var lastX = 0;
	    var emptyItemWidth = layoutParam.emptyItemWidth;
	    var height = seriesModel.get('breadcrumb.height');
	    var availableSize = layout.getAvailableSize(layoutParam.pos, layoutParam.box);
	    var totalWidth = layoutParam.totalWidth;
	    var renderList = layoutParam.renderList;
	
	    for (var i = renderList.length - 1; i >= 0; i--) {
	      var item = renderList[i];
	      var itemNode = item.node;
	      var itemWidth = item.width;
	      var text = item.text; // Hdie text and shorten width if necessary.
	
	      if (totalWidth > availableSize.width) {
	        totalWidth -= itemWidth - emptyItemWidth;
	        itemWidth = emptyItemWidth;
	        text = null;
	      }
	
	      var el = new graphic.Polygon({
	        shape: {
	          points: makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
	        },
	        style: zrUtil.defaults(normalStyleModel.getItemStyle(), {
	          lineJoin: 'bevel',
	          text: text,
	          textFill: textStyleModel.getTextColor(),
	          textFont: textStyleModel.getFont()
	        }),
	        z: 10,
	        onclick: zrUtil.curry(onSelect, itemNode)
	      });
	      this.group.add(el);
	      packEventData(el, seriesModel, itemNode);
	      lastX += itemWidth + ITEM_GAP;
	    }
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this.group.removeAll();
	  }
	};
	
	function makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
	  var points = [[head ? x : x - ARRAY_LENGTH, y], [x + itemWidth, y], [x + itemWidth, y + itemHeight], [head ? x : x - ARRAY_LENGTH, y + itemHeight]];
	  !tail && points.splice(2, 0, [x + itemWidth + ARRAY_LENGTH, y + itemHeight / 2]);
	  !head && points.push([x, y + itemHeight / 2]);
	  return points;
	} // Package custom mouse event.
	
	
	function packEventData(el, seriesModel, itemNode) {
	  el.eventData = {
	    componentType: 'series',
	    componentSubType: 'treemap',
	    seriesIndex: seriesModel.componentIndex,
	    seriesName: seriesModel.name,
	    seriesType: 'treemap',
	    selfType: 'breadcrumb',
	    // Distinguish with click event on treemap node.
	    nodeData: {
	      dataIndex: itemNode && itemNode.dataIndex,
	      name: itemNode && itemNode.name
	    },
	    treePathInfo: itemNode && wrapTreePathInfo(itemNode, seriesModel)
	  };
	}
	
	var _default = Breadcrumb;
	module.exports = _default;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var SeriesModel = __webpack_require__(20);
	
	var Tree = __webpack_require__(199);
	
	var Model = __webpack_require__(14);
	
	var _format = __webpack_require__(9);
	
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	
	var _helper = __webpack_require__(66);
	
	var wrapTreePathInfo = _helper.wrapTreePathInfo;
	
	var _default = SeriesModel.extend({
	  type: 'series.treemap',
	  layoutMode: 'box',
	  dependencies: ['grid', 'polar'],
	
	  /**
	   * @type {module:echarts/data/Tree~Node}
	   */
	  _viewRoot: null,
	  defaultOption: {
	    // Disable progressive rendering
	    progressive: 0,
	    hoverLayerThreshold: Infinity,
	    // center: ['50%', '50%'],          // not supported in ec3.
	    // size: ['80%', '80%'],            // deprecated, compatible with ec2.
	    left: 'center',
	    top: 'middle',
	    right: null,
	    bottom: null,
	    width: '80%',
	    height: '80%',
	    sort: true,
	    // Can be null or false or true
	    // (order by desc default, asc not supported yet (strange effect))
	    clipWindow: 'origin',
	    // Size of clipped window when zooming. 'origin' or 'fullscreen'
	    squareRatio: 0.5 * (1 + Math.sqrt(5)),
	    // golden ratio
	    leafDepth: null,
	    // Nodes on depth from root are regarded as leaves.
	    // Count from zero (zero represents only view root).
	    drillDownIcon: '▶',
	    // Use html character temporarily because it is complicated
	    // to align specialized icon. ▷▶❒❐▼✚
	    zoomToNodeRatio: 0.32 * 0.32,
	    // Be effective when using zoomToNode. Specify the proportion of the
	    // target node area in the view area.
	    roam: true,
	    // true, false, 'scale' or 'zoom', 'move'.
	    nodeClick: 'zoomToNode',
	    // Leaf node click behaviour: 'zoomToNode', 'link', false.
	    // If leafDepth is set and clicking a node which has children but
	    // be on left depth, the behaviour would be changing root. Otherwise
	    // use behavious defined above.
	    animation: true,
	    animationDurationUpdate: 900,
	    animationEasing: 'quinticInOut',
	    breadcrumb: {
	      show: true,
	      height: 22,
	      left: 'center',
	      top: 'bottom',
	      // right
	      // bottom
	      emptyItemWidth: 25,
	      // Width of empty node.
	      itemStyle: {
	        normal: {
	          color: 'rgba(0,0,0,0.7)',
	          //'#5793f3',
	          borderColor: 'rgba(255,255,255,0.7)',
	          borderWidth: 1,
	          shadowColor: 'rgba(150,150,150,1)',
	          shadowBlur: 3,
	          shadowOffsetX: 0,
	          shadowOffsetY: 0,
	          textStyle: {
	            color: '#fff'
	          }
	        },
	        emphasis: {
	          textStyle: {}
	        }
	      }
	    },
	    label: {
	      normal: {
	        show: true,
	        // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
	        distance: 0,
	        padding: 5,
	        position: 'inside',
	        // Can be [5, '5%'] or position stirng like 'insideTopLeft', ...
	        // formatter: null,
	        color: '#fff',
	        ellipsis: true // align
	        // verticalAlign
	
	      }
	    },
	    upperLabel: {
	      // Label when node is parent.
	      normal: {
	        show: false,
	        position: [0, '50%'],
	        height: 20,
	        // formatter: null,
	        color: '#fff',
	        ellipsis: true,
	        // align: null,
	        verticalAlign: 'middle'
	      },
	      emphasis: {
	        show: true,
	        position: [0, '50%'],
	        color: '#fff',
	        ellipsis: true,
	        verticalAlign: 'middle'
	      }
	    },
	    itemStyle: {
	      normal: {
	        color: null,
	        // Can be 'none' if not necessary.
	        colorAlpha: null,
	        // Can be 'none' if not necessary.
	        colorSaturation: null,
	        // Can be 'none' if not necessary.
	        borderWidth: 0,
	        gapWidth: 0,
	        borderColor: '#fff',
	        borderColorSaturation: null // If specified, borderColor will be ineffective, and the
	        // border color is evaluated by color of current node and
	        // borderColorSaturation.
	
	      },
	      emphasis: {}
	    },
	    visualDimension: 0,
	    // Can be 0, 1, 2, 3.
	    visualMin: null,
	    visualMax: null,
	    color: [],
	    // + treemapSeries.color should not be modified. Please only modified
	    // level[n].color (if necessary).
	    // + Specify color list of each level. level[0].color would be global
	    // color list if not specified. (see method `setDefault`).
	    // + But set as a empty array to forbid fetch color from global palette
	    // when using nodeModel.get('color'), otherwise nodes on deep level
	    // will always has color palette set and are not able to inherit color
	    // from parent node.
	    // + TreemapSeries.color can not be set as 'none', otherwise effect
	    // legend color fetching (see seriesColor.js).
	    colorAlpha: null,
	    // Array. Specify color alpha range of each level, like [0.2, 0.8]
	    colorSaturation: null,
	    // Array. Specify color saturation of each level, like [0.2, 0.5]
	    colorMappingBy: 'index',
	    // 'value' or 'index' or 'id'.
	    visibleMin: 10,
	    // If area less than this threshold (unit: pixel^2), node will not
	    // be rendered. Only works when sort is 'asc' or 'desc'.
	    childrenVisibleMin: null,
	    // If area of a node less than this threshold (unit: pixel^2),
	    // grandchildren will not show.
	    // Why grandchildren? If not grandchildren but children,
	    // some siblings show children and some not,
	    // the appearance may be mess and not consistent,
	    levels: [] // Each item: {
	    //     visibleMin, itemStyle, visualDimension, label
	    // }
	    // data: {
	    //      value: [],
	    //      children: [],
	    //      link: 'http://xxx.xxx.xxx',
	    //      target: 'blank' or 'self'
	    // }
	
	  },
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    // Create a virtual root.
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    completeTreeValue(root);
	    var levels = option.levels || [];
	    levels = option.levels = setDefault(levels, ecModel);
	    var treeOption = {};
	    treeOption.levels = levels; // Make sure always a new tree is created when setOption,
	    // in TreemapView, we check whether oldTree === newTree
	    // to choose mappings approach among old shapes and new shapes.
	
	    return Tree.createTree(root, this, treeOption).data;
	  },
	  optionUpdated: function () {
	    this.resetViewRoot();
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex
	   * @param {boolean} [mutipleSeries=false]
	   */
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var value = this.getRawValue(dataIndex);
	    var formattedValue = zrUtil.isArray(value) ? addCommas(value[0]) : addCommas(value);
	    var name = data.getName(dataIndex);
	    return encodeHTML(name + ': ' + formattedValue);
	  },
	
	  /**
	   * Add tree path to tooltip param
	   *
	   * @override
	   * @param {number} dataIndex
	   * @return {Object}
	   */
	  getDataParams: function (dataIndex) {
	    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
	    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
	    params.treePathInfo = wrapTreePathInfo(node, this);
	    return params;
	  },
	
	  /**
	   * @public
	   * @param {Object} layoutInfo {
	   *                                x: containerGroup x
	   *                                y: containerGroup y
	   *                                width: containerGroup width
	   *                                height: containerGroup height
	   *                            }
	   */
	  setLayoutInfo: function (layoutInfo) {
	    /**
	     * @readOnly
	     * @type {Object}
	     */
	    this.layoutInfo = this.layoutInfo || {};
	    zrUtil.extend(this.layoutInfo, layoutInfo);
	  },
	
	  /**
	   * @param  {string} id
	   * @return {number} index
	   */
	  mapIdToIndex: function (id) {
	    // A feature is implemented:
	    // index is monotone increasing with the sequence of
	    // input id at the first time.
	    // This feature can make sure that each data item and its
	    // mapped color have the same index between data list and
	    // color list at the beginning, which is useful for user
	    // to adjust data-color mapping.
	
	    /**
	     * @private
	     * @type {Object}
	     */
	    var idIndexMap = this._idIndexMap;
	
	    if (!idIndexMap) {
	      idIndexMap = this._idIndexMap = zrUtil.createHashMap();
	      /**
	       * @private
	       * @type {number}
	       */
	
	      this._idIndexMapCount = 0;
	    }
	
	    var index = idIndexMap.get(id);
	
	    if (index == null) {
	      idIndexMap.set(id, index = this._idIndexMapCount++);
	    }
	
	    return index;
	  },
	  getViewRoot: function () {
	    return this._viewRoot;
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~Node} [viewRoot]
	   */
	  resetViewRoot: function (viewRoot) {
	    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
	    var root = this.getData().tree.root;
	
	    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
	      this._viewRoot = root;
	    }
	  }
	});
	/**
	 * @param {Object} dataNode
	 */
	
	
	function completeTreeValue(dataNode) {
	  // Postorder travel tree.
	  // If value of none-leaf node is not set,
	  // calculate it by suming up the value of all children.
	  var sum = 0;
	  zrUtil.each(dataNode.children, function (child) {
	    completeTreeValue(child);
	    var childValue = child.value;
	    zrUtil.isArray(childValue) && (childValue = childValue[0]);
	    sum += childValue;
	  });
	  var thisValue = dataNode.value;
	
	  if (zrUtil.isArray(thisValue)) {
	    thisValue = thisValue[0];
	  }
	
	  if (thisValue == null || isNaN(thisValue)) {
	    thisValue = sum;
	  } // Value should not less than 0.
	
	
	  if (thisValue < 0) {
	    thisValue = 0;
	  }
	
	  zrUtil.isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
	}
	/**
	 * set default to level configuration
	 */
	
	
	function setDefault(levels, ecModel) {
	  var globalColorList = ecModel.get('color');
	
	  if (!globalColorList) {
	    return;
	  }
	
	  levels = levels || [];
	  var hasColorDefine;
	  zrUtil.each(levels, function (levelDefine) {
	    var model = new Model(levelDefine);
	    var modelColor = model.get('color');
	
	    if (model.get('itemStyle.normal.color') || modelColor && modelColor !== 'none') {
	      hasColorDefine = true;
	    }
	  });
	
	  if (!hasColorDefine) {
	    var level0 = levels[0] || (levels[0] = {});
	    level0.color = globalColorList.slice();
	  }
	
	  return levels;
	}
	
	module.exports = _default;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var DataDiffer = __webpack_require__(56);
	
	var helper = __webpack_require__(66);
	
	var Breadcrumb = __webpack_require__(451);
	
	var RoamController = __webpack_require__(87);
	
	var BoundingRect = __webpack_require__(13);
	
	var matrix = __webpack_require__(23);
	
	var animationUtil = __webpack_require__(596);
	
	var makeStyleMapper = __webpack_require__(58);
	
	var bind = zrUtil.bind;
	var Group = graphic.Group;
	var Rect = graphic.Rect;
	var each = zrUtil.each;
	var DRAG_THRESHOLD = 3;
	var PATH_LABEL_NOAMAL = ['label', 'normal'];
	var PATH_LABEL_EMPHASIS = ['label', 'emphasis'];
	var PATH_UPPERLABEL_NORMAL = ['upperLabel', 'normal'];
	var PATH_UPPERLABEL_EMPHASIS = ['upperLabel', 'emphasis'];
	var Z_BASE = 10; // Should bigger than every z.
	
	var Z_BG = 1;
	var Z_CONTENT = 2;
	var getItemStyleEmphasis = makeStyleMapper([['fill', 'color'], // `borderColor` and `borderWidth` has been occupied,
	// so use `stroke` to indicate the stroke of the rect.
	['stroke', 'strokeColor'], ['lineWidth', 'strokeWidth'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	
	var getItemStyleNormal = function (model) {
	  // Normal style props should include emphasis style props.
	  var itemStyle = getItemStyleEmphasis(model); // Clear styles set by emphasis.
	
	  itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
	  return itemStyle;
	};
	
	var _default = echarts.extendChartView({
	  type: 'treemap',
	
	  /**
	   * @override
	   */
	  init: function (o, api) {
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	    this._containerGroup;
	    /**
	     * @private
	     * @type {Object.<string, Array.<module:zrender/container/Group>>}
	     */
	
	    this._storage = createStorage();
	    /**
	     * @private
	     * @type {module:echarts/data/Tree}
	     */
	
	    this._oldTree;
	    /**
	     * @private
	     * @type {module:echarts/chart/treemap/Breadcrumb}
	     */
	
	    this._breadcrumb;
	    /**
	     * @private
	     * @type {module:echarts/component/helper/RoamController}
	     */
	
	    this._controller;
	    /**
	     * 'ready', 'animating'
	     * @private
	     */
	
	    this._state = 'ready';
	  },
	
	  /**
	   * @override
	   */
	  render: function (seriesModel, ecModel, api, payload) {
	    var models = ecModel.findComponents({
	      mainType: 'series',
	      subType: 'treemap',
	      query: payload
	    });
	
	    if (zrUtil.indexOf(models, seriesModel) < 0) {
	      return;
	    }
	
	    this.seriesModel = seriesModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    var targetInfo = helper.retrieveTargetInfo(payload, seriesModel);
	    var payloadType = payload && payload.type;
	    var layoutInfo = seriesModel.layoutInfo;
	    var isInit = !this._oldTree;
	    var thisStorage = this._storage; // Mark new root when action is treemapRootToNode.
	
	    var reRoot = payloadType === 'treemapRootToNode' && targetInfo && thisStorage ? {
	      rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
	      direction: payload.direction
	    } : null;
	
	    var containerGroup = this._giveContainerGroup(layoutInfo);
	
	    var renderResult = this._doRender(containerGroup, seriesModel, reRoot);
	
	    !isInit && (!payloadType || payloadType === 'treemapZoomToNode' || payloadType === 'treemapRootToNode') ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();
	
	    this._resetController(api);
	
	    this._renderBreadcrumb(seriesModel, api, targetInfo);
	  },
	
	  /**
	   * @private
	   */
	  _giveContainerGroup: function (layoutInfo) {
	    var containerGroup = this._containerGroup;
	
	    if (!containerGroup) {
	      // FIXME
	      // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
	      containerGroup = this._containerGroup = new Group();
	
	      this._initEvents(containerGroup);
	
	      this.group.add(containerGroup);
	    }
	
	    containerGroup.attr('position', [layoutInfo.x, layoutInfo.y]);
	    return containerGroup;
	  },
	
	  /**
	   * @private
	   */
	  _doRender: function (containerGroup, seriesModel, reRoot) {
	    var thisTree = seriesModel.getData().tree;
	    var oldTree = this._oldTree; // Clear last shape records.
	
	    var lastsForAnimation = createStorage();
	    var thisStorage = createStorage();
	    var oldStorage = this._storage;
	    var willInvisibleEls = [];
	    var doRenderNode = zrUtil.curry(renderNode, seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls); // Notice: when thisTree and oldTree are the same tree (see list.cloneShallow),
	    // the oldTree is actually losted, so we can not find all of the old graphic
	    // elements from tree. So we use this stragegy: make element storage, move
	    // from old storage to new storage, clear old storage.
	
	    dualTravel(thisTree.root ? [thisTree.root] : [], oldTree && oldTree.root ? [oldTree.root] : [], containerGroup, thisTree === oldTree || !oldTree, 0); // Process all removing.
	
	    var willDeleteEls = clearStorage(oldStorage);
	    this._oldTree = thisTree;
	    this._storage = thisStorage;
	    return {
	      lastsForAnimation: lastsForAnimation,
	      willDeleteEls: willDeleteEls,
	      renderFinally: renderFinally
	    };
	
	    function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
	      // When 'render' is triggered by action,
	      // 'this' and 'old' may be the same tree,
	      // we use rawIndex in that case.
	      if (sameTree) {
	        oldViewChildren = thisViewChildren;
	        each(thisViewChildren, function (child, index) {
	          !child.isRemoved() && processNode(index, index);
	        });
	      } // Diff hierarchically (diff only in each subtree, but not whole).
	      // because, consistency of view is important.
	      else {
	          new DataDiffer(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove(zrUtil.curry(processNode, null)).execute();
	        }
	
	      function getKey(node) {
	        // Identify by name or raw index.
	        return node.getId();
	      }
	
	      function processNode(newIndex, oldIndex) {
	        var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
	        var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
	        var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
	        group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
	      }
	    }
	
	    function clearStorage(storage) {
	      var willDeleteEls = createStorage();
	      storage && each(storage, function (store, storageName) {
	        var delEls = willDeleteEls[storageName];
	        each(store, function (el) {
	          el && (delEls.push(el), el.__tmWillDelete = 1);
	        });
	      });
	      return willDeleteEls;
	    }
	
	    function renderFinally() {
	      each(willDeleteEls, function (els) {
	        each(els, function (el) {
	          el.parent && el.parent.remove(el);
	        });
	      });
	      each(willInvisibleEls, function (el) {
	        el.invisible = true; // Setting invisible is for optimizing, so no need to set dirty,
	        // just mark as invisible.
	
	        el.dirty();
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _doAnimation: function (containerGroup, renderResult, seriesModel, reRoot) {
	    if (!seriesModel.get('animation')) {
	      return;
	    }
	
	    var duration = seriesModel.get('animationDurationUpdate');
	    var easing = seriesModel.get('animationEasing');
	    var animationWrap = animationUtil.createWrap(); // Make delete animations.
	
	    each(renderResult.willDeleteEls, function (store, storageName) {
	      each(store, function (el, rawIndex) {
	        if (el.invisible) {
	          return;
	        }
	
	        var parent = el.parent; // Always has parent, and parent is nodeGroup.
	
	        var target;
	
	        if (reRoot && reRoot.direction === 'drillDown') {
	          target = parent === reRoot.rootNodeGroup // This is the content element of view root.
	          // Only `content` will enter this branch, because
	          // `background` and `nodeGroup` will not be deleted.
	          ? {
	            shape: {
	              x: 0,
	              y: 0,
	              width: parent.__tmNodeWidth,
	              height: parent.__tmNodeHeight
	            },
	            style: {
	              opacity: 0
	            } // Others.
	
	          } : {
	            style: {
	              opacity: 0
	            }
	          };
	        } else {
	          var targetX = 0;
	          var targetY = 0;
	
	          if (!parent.__tmWillDelete) {
	            // Let node animate to right-bottom corner, cooperating with fadeout,
	            // which is appropriate for user understanding.
	            // Divided by 2 for reRoot rolling up effect.
	            targetX = parent.__tmNodeWidth / 2;
	            targetY = parent.__tmNodeHeight / 2;
	          }
	
	          target = storageName === 'nodeGroup' ? {
	            position: [targetX, targetY],
	            style: {
	              opacity: 0
	            }
	          } : {
	            shape: {
	              x: targetX,
	              y: targetY,
	              width: 0,
	              height: 0
	            },
	            style: {
	              opacity: 0
	            }
	          };
	        }
	
	        target && animationWrap.add(el, target, duration, easing);
	      });
	    }); // Make other animations
	
	    each(this._storage, function (store, storageName) {
	      each(store, function (el, rawIndex) {
	        var last = renderResult.lastsForAnimation[storageName][rawIndex];
	        var target = {};
	
	        if (!last) {
	          return;
	        }
	
	        if (storageName === 'nodeGroup') {
	          if (last.old) {
	            target.position = el.position.slice();
	            el.attr('position', last.old);
	          }
	        } else {
	          if (last.old) {
	            target.shape = zrUtil.extend({}, el.shape);
	            el.setShape(last.old);
	          }
	
	          if (last.fadein) {
	            el.setStyle('opacity', 0);
	            target.style = {
	              opacity: 1
	            };
	          } // When animation is stopped for succedent animation starting,
	          // el.style.opacity might not be 1
	          else if (el.style.opacity !== 1) {
	              target.style = {
	                opacity: 1
	              };
	            }
	        }
	
	        animationWrap.add(el, target, duration, easing);
	      });
	    }, this);
	    this._state = 'animating';
	    animationWrap.done(bind(function () {
	      this._state = 'ready';
	      renderResult.renderFinally();
	    }, this)).start();
	  },
	
	  /**
	   * @private
	   */
	  _resetController: function (api) {
	    var controller = this._controller; // Init controller.
	
	    if (!controller) {
	      controller = this._controller = new RoamController(api.getZr());
	      controller.enable(this.seriesModel.get('roam'));
	      controller.on('pan', bind(this._onPan, this));
	      controller.on('zoom', bind(this._onZoom, this));
	    }
	
	    var rect = new BoundingRect(0, 0, api.getWidth(), api.getHeight());
	    controller.setPointerChecker(function (e, x, y) {
	      return rect.contain(x, y);
	    });
	  },
	
	  /**
	   * @private
	   */
	  _clearController: function () {
	    var controller = this._controller;
	
	    if (controller) {
	      controller.dispose();
	      controller = null;
	    }
	  },
	
	  /**
	   * @private
	   */
	  _onPan: function (dx, dy) {
	    if (this._state !== 'animating' && (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD)) {
	      // These param must not be cached.
	      var root = this.seriesModel.getData().tree.root;
	
	      if (!root) {
	        return;
	      }
	
	      var rootLayout = root.getLayout();
	
	      if (!rootLayout) {
	        return;
	      }
	
	      this.api.dispatchAction({
	        type: 'treemapMove',
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        rootRect: {
	          x: rootLayout.x + dx,
	          y: rootLayout.y + dy,
	          width: rootLayout.width,
	          height: rootLayout.height
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _onZoom: function (scale, mouseX, mouseY) {
	    if (this._state !== 'animating') {
	      // These param must not be cached.
	      var root = this.seriesModel.getData().tree.root;
	
	      if (!root) {
	        return;
	      }
	
	      var rootLayout = root.getLayout();
	
	      if (!rootLayout) {
	        return;
	      }
	
	      var rect = new BoundingRect(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
	      var layoutInfo = this.seriesModel.layoutInfo; // Transform mouse coord from global to containerGroup.
	
	      mouseX -= layoutInfo.x;
	      mouseY -= layoutInfo.y; // Scale root bounding rect.
	
	      var m = matrix.create();
	      matrix.translate(m, m, [-mouseX, -mouseY]);
	      matrix.scale(m, m, [scale, scale]);
	      matrix.translate(m, m, [mouseX, mouseY]);
	      rect.applyTransform(m);
	      this.api.dispatchAction({
	        type: 'treemapRender',
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        rootRect: {
	          x: rect.x,
	          y: rect.y,
	          width: rect.width,
	          height: rect.height
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _initEvents: function (containerGroup) {
	    containerGroup.on('click', function (e) {
	      if (this._state !== 'ready') {
	        return;
	      }
	
	      var nodeClick = this.seriesModel.get('nodeClick', true);
	
	      if (!nodeClick) {
	        return;
	      }
	
	      var targetInfo = this.findTarget(e.offsetX, e.offsetY);
	
	      if (!targetInfo) {
	        return;
	      }
	
	      var node = targetInfo.node;
	
	      if (node.getLayout().isLeafRoot) {
	        this._rootToNode(targetInfo);
	      } else {
	        if (nodeClick === 'zoomToNode') {
	          this._zoomToNode(targetInfo);
	        } else if (nodeClick === 'link') {
	          var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
	          var link = itemModel.get('link', true);
	          var linkTarget = itemModel.get('target', true) || 'blank';
	          link && window.open(link, linkTarget);
	        }
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderBreadcrumb: function (seriesModel, api, targetInfo) {
	    if (!targetInfo) {
	      targetInfo = seriesModel.get('leafDepth', true) != null ? {
	        node: seriesModel.getViewRoot() // FIXME
	        // better way?
	        // Find breadcrumb tail on center of containerGroup.
	
	      } : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);
	
	      if (!targetInfo) {
	        targetInfo = {
	          node: seriesModel.getData().tree.root
	        };
	      }
	    }
	
	    (this._breadcrumb || (this._breadcrumb = new Breadcrumb(this.group))).render(seriesModel, api, targetInfo.node, bind(onSelect, this));
	
	    function onSelect(node) {
	      if (this._state !== 'animating') {
	        helper.aboveViewRoot(seriesModel.getViewRoot(), node) ? this._rootToNode({
	          node: node
	        }) : this._zoomToNode({
	          node: node
	        });
	      }
	    }
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearController();
	
	    this._containerGroup && this._containerGroup.removeAll();
	    this._storage = createStorage();
	    this._state = 'ready';
	    this._breadcrumb && this._breadcrumb.remove();
	  },
	  dispose: function () {
	    this._clearController();
	  },
	
	  /**
	   * @private
	   */
	  _zoomToNode: function (targetInfo) {
	    this.api.dispatchAction({
	      type: 'treemapZoomToNode',
	      from: this.uid,
	      seriesId: this.seriesModel.id,
	      targetNode: targetInfo.node
	    });
	  },
	
	  /**
	   * @private
	   */
	  _rootToNode: function (targetInfo) {
	    this.api.dispatchAction({
	      type: 'treemapRootToNode',
	      from: this.uid,
	      seriesId: this.seriesModel.id,
	      targetNode: targetInfo.node
	    });
	  },
	
	  /**
	   * @public
	   * @param {number} x Global coord x.
	   * @param {number} y Global coord y.
	   * @return {Object} info If not found, return undefined;
	   * @return {number} info.node Target node.
	   * @return {number} info.offsetX x refer to target node.
	   * @return {number} info.offsetY y refer to target node.
	   */
	  findTarget: function (x, y) {
	    var targetInfo;
	    var viewRoot = this.seriesModel.getViewRoot();
	    viewRoot.eachNode({
	      attr: 'viewChildren',
	      order: 'preorder'
	    }, function (node) {
	      var bgEl = this._storage.background[node.getRawIndex()]; // If invisible, there might be no element.
	
	
	      if (bgEl) {
	        var point = bgEl.transformCoordToLocal(x, y);
	        var shape = bgEl.shape; // For performance consideration, dont use 'getBoundingRect'.
	
	        if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) {
	          targetInfo = {
	            node: node,
	            offsetX: point[0],
	            offsetY: point[1]
	          };
	        } else {
	          return false; // Suppress visit subtree.
	        }
	      }
	    }, this);
	    return targetInfo;
	  }
	});
	/**
	 * @inner
	 */
	
	
	function createStorage() {
	  return {
	    nodeGroup: [],
	    background: [],
	    content: []
	  };
	}
	/**
	 * @inner
	 * @return Return undefined means do not travel further.
	 */
	
	
	function renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
	  // Whether under viewRoot.
	  if (!thisNode) {
	    // Deleting nodes will be performed finally. This method just find
	    // element from old storage, or create new element, set them to new
	    // storage, and set styles.
	    return;
	  } // -------------------------------------------------------------------
	  // Start of closure variables available in "Procedures in renderNode".
	
	
	  var thisLayout = thisNode.getLayout();
	
	  if (!thisLayout || !thisLayout.isInView) {
	    return;
	  }
	
	  var thisWidth = thisLayout.width;
	  var thisHeight = thisLayout.height;
	  var borderWidth = thisLayout.borderWidth;
	  var thisInvisible = thisLayout.invisible;
	  var thisRawIndex = thisNode.getRawIndex();
	  var oldRawIndex = oldNode && oldNode.getRawIndex();
	  var thisViewChildren = thisNode.viewChildren;
	  var upperHeight = thisLayout.upperHeight;
	  var isParent = thisViewChildren && thisViewChildren.length;
	  var itemStyleNormalModel = thisNode.getModel('itemStyle.normal');
	  var itemStyleEmphasisModel = thisNode.getModel('itemStyle.emphasis'); // End of closure ariables available in "Procedures in renderNode".
	  // -----------------------------------------------------------------
	  // Node group
	
	  var group = giveGraphic('nodeGroup', Group);
	
	  if (!group) {
	    return;
	  }
	
	  parentGroup.add(group); // x,y are not set when el is above view root.
	
	  group.attr('position', [thisLayout.x || 0, thisLayout.y || 0]);
	  group.__tmNodeWidth = thisWidth;
	  group.__tmNodeHeight = thisHeight;
	
	  if (thisLayout.isAboveViewRoot) {
	    return group;
	  } // Background
	
	
	  var bg = giveGraphic('background', Rect, depth, Z_BG);
	  bg && renderBackground(group, bg, isParent && thisLayout.upperHeight); // No children, render content.
	
	  if (!isParent) {
	    var content = giveGraphic('content', Rect, depth, Z_CONTENT);
	    content && renderContent(group, content);
	  }
	
	  return group; // ----------------------------
	  // | Procedures in renderNode |
	  // ----------------------------
	
	  function renderBackground(group, bg, useUpperLabel) {
	    // For tooltip.
	    bg.dataIndex = thisNode.dataIndex;
	    bg.seriesIndex = seriesModel.seriesIndex;
	    bg.setShape({
	      x: 0,
	      y: 0,
	      width: thisWidth,
	      height: thisHeight
	    });
	    var visualBorderColor = thisNode.getVisual('borderColor', true);
	    var emphasisBorderColor = itemStyleEmphasisModel.get('borderColor');
	    updateStyle(bg, function () {
	      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
	      normalStyle.fill = visualBorderColor;
	      var emphasisStyle = getItemStyleEmphasis(itemStyleEmphasisModel);
	      emphasisStyle.fill = emphasisBorderColor;
	
	      if (useUpperLabel) {
	        var upperLabelWidth = thisWidth - 2 * borderWidth;
	        prepareText(normalStyle, emphasisStyle, visualBorderColor, upperLabelWidth, upperHeight, {
	          x: borderWidth,
	          y: 0,
	          width: upperLabelWidth,
	          height: upperHeight
	        });
	      } // For old bg.
	      else {
	          normalStyle.text = emphasisStyle.text = null;
	        }
	
	      bg.setStyle(normalStyle);
	      graphic.setHoverStyle(bg, emphasisStyle);
	    });
	    group.add(bg);
	  }
	
	  function renderContent(group, content) {
	    // For tooltip.
	    content.dataIndex = thisNode.dataIndex;
	    content.seriesIndex = seriesModel.seriesIndex;
	    var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
	    var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
	    content.culling = true;
	    content.setShape({
	      x: borderWidth,
	      y: borderWidth,
	      width: contentWidth,
	      height: contentHeight
	    });
	    var visualColor = thisNode.getVisual('color', true);
	    updateStyle(content, function () {
	      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
	      normalStyle.fill = visualColor;
	      var emphasisStyle = getItemStyleEmphasis(itemStyleEmphasisModel);
	      prepareText(normalStyle, emphasisStyle, visualColor, contentWidth, contentHeight);
	      content.setStyle(normalStyle);
	      graphic.setHoverStyle(content, emphasisStyle);
	    });
	    group.add(content);
	  }
	
	  function updateStyle(element, cb) {
	    if (!thisInvisible) {
	      // If invisible, do not set visual, otherwise the element will
	      // change immediately before animation. We think it is OK to
	      // remain its origin color when moving out of the view window.
	      cb();
	
	      if (!element.__tmWillVisible) {
	        element.invisible = false;
	      }
	    } else {
	      // Delay invisible setting utill animation finished,
	      // avoid element vanish suddenly before animation.
	      !element.invisible && willInvisibleEls.push(element);
	    }
	  }
	
	  function prepareText(normalStyle, emphasisStyle, visualColor, width, height, upperLabelRect) {
	    var nodeModel = thisNode.getModel();
	    var text = zrUtil.retrieve(seriesModel.getFormattedLabel(thisNode.dataIndex, 'normal', null, null, upperLabelRect ? 'upperLabel' : 'label'), nodeModel.get('name'));
	
	    if (!upperLabelRect && thisLayout.isLeafRoot) {
	      var iconChar = seriesModel.get('drillDownIcon', true);
	      text = iconChar ? iconChar + ' ' + text : text;
	    }
	
	    var normalLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_NORMAL : PATH_LABEL_NOAMAL);
	    var emphasisLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_EMPHASIS : PATH_LABEL_EMPHASIS);
	    var isShow = normalLabelModel.getShallow('show');
	    graphic.setLabelStyle(normalStyle, emphasisStyle, normalLabelModel, emphasisLabelModel, {
	      defaultText: isShow ? text : null,
	      autoColor: visualColor,
	      isRectText: true
	    });
	    upperLabelRect && (normalStyle.textRect = zrUtil.clone(upperLabelRect));
	    normalStyle.truncate = isShow && normalLabelModel.get('ellipsis') ? {
	      outerWidth: width,
	      outerHeight: height,
	      minChar: 2
	    } : null;
	  }
	
	  function giveGraphic(storageName, Ctor, depth, z) {
	    var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
	    var lasts = lastsForAnimation[storageName];
	
	    if (element) {
	      // Remove from oldStorage
	      oldStorage[storageName][oldRawIndex] = null;
	      prepareAnimationWhenHasOld(lasts, element, storageName);
	    } // If invisible and no old element, do not create new element (for optimizing).
	    else if (!thisInvisible) {
	        element = new Ctor({
	          z: calculateZ(depth, z)
	        });
	        element.__tmDepth = depth;
	        element.__tmStorageName = storageName;
	        prepareAnimationWhenNoOld(lasts, element, storageName);
	      } // Set to thisStorage
	
	
	    return thisStorage[storageName][thisRawIndex] = element;
	  }
	
	  function prepareAnimationWhenHasOld(lasts, element, storageName) {
	    var lastCfg = lasts[thisRawIndex] = {};
	    lastCfg.old = storageName === 'nodeGroup' ? element.position.slice() : zrUtil.extend({}, element.shape);
	  } // If a element is new, we need to find the animation start point carefully,
	  // otherwise it will looks strange when 'zoomToNode'.
	
	
	  function prepareAnimationWhenNoOld(lasts, element, storageName) {
	    var lastCfg = lasts[thisRawIndex] = {};
	    var parentNode = thisNode.parentNode;
	
	    if (parentNode && (!reRoot || reRoot.direction === 'drillDown')) {
	      var parentOldX = 0;
	      var parentOldY = 0; // New nodes appear from right-bottom corner in 'zoomToNode' animation.
	      // For convenience, get old bounding rect from background.
	
	      var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];
	
	      if (!reRoot && parentOldBg && parentOldBg.old) {
	        parentOldX = parentOldBg.old.width;
	        parentOldY = parentOldBg.old.height;
	      } // When no parent old shape found, its parent is new too,
	      // so we can just use {x:0, y:0}.
	
	
	      lastCfg.old = storageName === 'nodeGroup' ? [0, parentOldY] : {
	        x: parentOldX,
	        y: parentOldY,
	        width: 0,
	        height: 0
	      };
	    } // Fade in, user can be aware that these nodes are new.
	
	
	    lastCfg.fadein = storageName !== 'nodeGroup';
	  }
	} // We can not set all backgroud with the same z, Because the behaviour of
	// drill down and roll up differ background creation sequence from tree
	// hierarchy sequence, which cause that lowser background element overlap
	// upper ones. So we calculate z based on depth.
	// Moreover, we try to shrink down z interval to [0, 1] to avoid that
	// treemap with large z overlaps other components.
	
	
	function calculateZ(depth, zInLevel) {
	  var zb = depth * Z_BASE + zInLevel;
	  return (zb - 1) / zb;
	}
	
	module.exports = _default;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var helper = __webpack_require__(66);
	
	/**
	 * @file Treemap action
	 */
	var noop = function () {};
	
	var actionTypes = ['treemapZoomToNode', 'treemapRender', 'treemapMove'];
	
	for (var i = 0; i < actionTypes.length; i++) {
	  echarts.registerAction({
	    type: actionTypes[i],
	    update: 'updateView'
	  }, noop);
	}
	
	echarts.registerAction({
	  type: 'treemapRootToNode',
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'treemap',
	    query: payload
	  }, handleRootToNode);
	
	  function handleRootToNode(model, index) {
	    var targetInfo = helper.retrieveTargetInfo(payload, model);
	
	    if (targetInfo) {
	      var originViewRoot = model.getViewRoot();
	
	      if (originViewRoot) {
	        payload.direction = helper.aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
	      }
	
	      model.resetViewRoot(targetInfo.node);
	    }
	  }
	});

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var BoundingRect = __webpack_require__(13);
	
	var _number = __webpack_require__(4);
	
	var parsePercent = _number.parsePercent;
	var MAX_SAFE_INTEGER = _number.MAX_SAFE_INTEGER;
	
	var layout = __webpack_require__(7);
	
	var helper = __webpack_require__(66);
	
	var mathMax = Math.max;
	var mathMin = Math.min;
	var retrieveValue = zrUtil.retrieve;
	var each = zrUtil.each;
	var PATH_BORDER_WIDTH = ['itemStyle', 'normal', 'borderWidth'];
	var PATH_GAP_WIDTH = ['itemStyle', 'normal', 'gapWidth'];
	var PATH_UPPER_LABEL_SHOW = ['upperLabel', 'normal', 'show'];
	var PATH_UPPER_LABEL_HEIGHT = ['upperLabel', 'normal', 'height'];
	/**
	 * @public
	 */
	
	function _default(ecModel, api, payload) {
	  // Layout result in each node:
	  // {x, y, width, height, area, borderWidth}
	  var condition = {
	    mainType: 'series',
	    subType: 'treemap',
	    query: payload
	  };
	  ecModel.eachComponent(condition, function (seriesModel) {
	    var ecWidth = api.getWidth();
	    var ecHeight = api.getHeight();
	    var seriesOption = seriesModel.option;
	    var layoutInfo = layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	    var size = seriesOption.size || []; // Compatible with ec2.
	
	    var containerWidth = parsePercent(retrieveValue(layoutInfo.width, size[0]), ecWidth);
	    var containerHeight = parsePercent(retrieveValue(layoutInfo.height, size[1]), ecHeight); // Fetch payload info.
	
	    var payloadType = payload && payload.type;
	    var targetInfo = helper.retrieveTargetInfo(payload, seriesModel);
	    var rootRect = payloadType === 'treemapRender' || payloadType === 'treemapMove' ? payload.rootRect : null;
	    var viewRoot = seriesModel.getViewRoot();
	    var viewAbovePath = helper.getPathToRoot(viewRoot);
	
	    if (payloadType !== 'treemapMove') {
	      var rootSize = payloadType === 'treemapZoomToNode' ? estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [rootRect.width, rootRect.height] : [containerWidth, containerHeight];
	      var sort = seriesOption.sort;
	
	      if (sort && sort !== 'asc' && sort !== 'desc') {
	        sort = 'desc';
	      }
	
	      var options = {
	        squareRatio: seriesOption.squareRatio,
	        sort: sort,
	        leafDepth: seriesOption.leafDepth
	      }; // layout should be cleared because using updateView but not update.
	
	      viewRoot.hostTree.clearLayouts(); // TODO
	      // optimize: if out of view clip, do not layout.
	      // But take care that if do not render node out of view clip,
	      // how to calculate start po
	
	      var viewRootLayout = {
	        x: 0,
	        y: 0,
	        width: rootSize[0],
	        height: rootSize[1],
	        area: rootSize[0] * rootSize[1]
	      };
	      viewRoot.setLayout(viewRootLayout);
	      squarify(viewRoot, options, false, 0); // Supplement layout.
	
	      var viewRootLayout = viewRoot.getLayout();
	      each(viewAbovePath, function (node, index) {
	        var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
	        node.setLayout(zrUtil.extend({
	          dataExtent: [childValue, childValue],
	          borderWidth: 0,
	          upperHeight: 0
	        }, viewRootLayout));
	      });
	    }
	
	    var treeRoot = seriesModel.getData().tree.root;
	    treeRoot.setLayout(calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
	    seriesModel.setLayoutInfo(layoutInfo); // FIXME
	    // 现在没有clip功能，暂时取ec高宽。
	
	    prunning(treeRoot, // Transform to base element coordinate system.
	    new BoundingRect(-layoutInfo.x, -layoutInfo.y, ecWidth, ecHeight), viewAbovePath, viewRoot, 0);
	  });
	}
	/**
	 * Layout treemap with squarify algorithm.
	 * @see https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf
	 * @see https://github.com/mbostock/d3/blob/master/src/layout/treemap.js
	 *
	 * @protected
	 * @param {module:echarts/data/Tree~TreeNode} node
	 * @param {Object} options
	 * @param {string} options.sort 'asc' or 'desc'
	 * @param {number} options.squareRatio
	 * @param {boolean} hideChildren
	 * @param {number} depth
	 */
	
	
	function squarify(node, options, hideChildren, depth) {
	  var width;
	  var height;
	
	  if (node.isRemoved()) {
	    return;
	  }
	
	  var thisLayout = node.getLayout();
	  width = thisLayout.width;
	  height = thisLayout.height; // Considering border and gap
	
	  var nodeModel = node.getModel();
	  var borderWidth = nodeModel.get(PATH_BORDER_WIDTH);
	  var halfGapWidth = nodeModel.get(PATH_GAP_WIDTH) / 2;
	  var upperLabelHeight = getUpperLabelHeight(nodeModel);
	  var upperHeight = Math.max(borderWidth, upperLabelHeight);
	  var layoutOffset = borderWidth - halfGapWidth;
	  var layoutOffsetUpper = upperHeight - halfGapWidth;
	  var nodeModel = node.getModel();
	  node.setLayout({
	    borderWidth: borderWidth,
	    upperHeight: upperHeight,
	    upperLabelHeight: upperLabelHeight
	  }, true);
	  width = mathMax(width - 2 * layoutOffset, 0);
	  height = mathMax(height - layoutOffset - layoutOffsetUpper, 0);
	  var totalArea = width * height;
	  var viewChildren = initChildren(node, nodeModel, totalArea, options, hideChildren, depth);
	
	  if (!viewChildren.length) {
	    return;
	  }
	
	  var rect = {
	    x: layoutOffset,
	    y: layoutOffsetUpper,
	    width: width,
	    height: height
	  };
	  var rowFixedLength = mathMin(width, height);
	  var best = Infinity; // the best row score so far
	
	  var row = [];
	  row.area = 0;
	
	  for (var i = 0, len = viewChildren.length; i < len;) {
	    var child = viewChildren[i];
	    row.push(child);
	    row.area += child.getLayout().area;
	    var score = worst(row, rowFixedLength, options.squareRatio); // continue with this orientation
	
	    if (score <= best) {
	      i++;
	      best = score;
	    } // abort, and try a different orientation
	    else {
	        row.area -= row.pop().getLayout().area;
	        position(row, rowFixedLength, rect, halfGapWidth, false);
	        rowFixedLength = mathMin(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	  }
	
	  if (row.length) {
	    position(row, rowFixedLength, rect, halfGapWidth, true);
	  }
	
	  if (!hideChildren) {
	    var childrenVisibleMin = nodeModel.get('childrenVisibleMin');
	
	    if (childrenVisibleMin != null && totalArea < childrenVisibleMin) {
	      hideChildren = true;
	    }
	  }
	
	  for (var i = 0, len = viewChildren.length; i < len; i++) {
	    squarify(viewChildren[i], options, hideChildren, depth + 1);
	  }
	}
	/**
	 * Set area to each child, and calculate data extent for visual coding.
	 */
	
	
	function initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
	  var viewChildren = node.children || [];
	  var orderBy = options.sort;
	  orderBy !== 'asc' && orderBy !== 'desc' && (orderBy = null);
	  var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth; // leafDepth has higher priority.
	
	  if (hideChildren && !overLeafDepth) {
	    return node.viewChildren = [];
	  } // Sort children, order by desc.
	
	
	  viewChildren = zrUtil.filter(viewChildren, function (child) {
	    return !child.isRemoved();
	  });
	  sort(viewChildren, orderBy);
	  var info = statistic(nodeModel, viewChildren, orderBy);
	
	  if (info.sum === 0) {
	    return node.viewChildren = [];
	  }
	
	  info.sum = filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);
	
	  if (info.sum === 0) {
	    return node.viewChildren = [];
	  } // Set area to each child.
	
	
	  for (var i = 0, len = viewChildren.length; i < len; i++) {
	    var area = viewChildren[i].getValue() / info.sum * totalArea; // Do not use setLayout({...}, true), because it is needed to clear last layout.
	
	    viewChildren[i].setLayout({
	      area: area
	    });
	  }
	
	  if (overLeafDepth) {
	    viewChildren.length && node.setLayout({
	      isLeafRoot: true
	    }, true);
	    viewChildren.length = 0;
	  }
	
	  node.viewChildren = viewChildren;
	  node.setLayout({
	    dataExtent: info.dataExtent
	  }, true);
	  return viewChildren;
	}
	/**
	 * Consider 'visibleMin'. Modify viewChildren and get new sum.
	 */
	
	
	function filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
	  // visibleMin is not supported yet when no option.sort.
	  if (!orderBy) {
	    return sum;
	  }
	
	  var visibleMin = nodeModel.get('visibleMin');
	  var len = orderedChildren.length;
	  var deletePoint = len; // Always travel from little value to big value.
	
	  for (var i = len - 1; i >= 0; i--) {
	    var value = orderedChildren[orderBy === 'asc' ? len - i - 1 : i].getValue();
	
	    if (value / sum * totalArea < visibleMin) {
	      deletePoint = i;
	      sum -= value;
	    }
	  }
	
	  orderBy === 'asc' ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
	  return sum;
	}
	/**
	 * Sort
	 */
	
	
	function sort(viewChildren, orderBy) {
	  if (orderBy) {
	    viewChildren.sort(function (a, b) {
	      var diff = orderBy === 'asc' ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
	      return diff === 0 ? orderBy === 'asc' ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
	    });
	  }
	
	  return viewChildren;
	}
	/**
	 * Statistic
	 */
	
	
	function statistic(nodeModel, children, orderBy) {
	  // Calculate sum.
	  var sum = 0;
	
	  for (var i = 0, len = children.length; i < len; i++) {
	    sum += children[i].getValue();
	  } // Statistic data extent for latter visual coding.
	  // Notice: data extent should be calculate based on raw children
	  // but not filtered view children, otherwise visual mapping will not
	  // be stable when zoom (where children is filtered by visibleMin).
	
	
	  var dimension = nodeModel.get('visualDimension');
	  var dataExtent; // The same as area dimension.
	
	  if (!children || !children.length) {
	    dataExtent = [NaN, NaN];
	  } else if (dimension === 'value' && orderBy) {
	    dataExtent = [children[children.length - 1].getValue(), children[0].getValue()];
	    orderBy === 'asc' && dataExtent.reverse();
	  } // Other dimension.
	  else {
	      var dataExtent = [Infinity, -Infinity];
	      each(children, function (child) {
	        var value = child.getValue(dimension);
	        value < dataExtent[0] && (dataExtent[0] = value);
	        value > dataExtent[1] && (dataExtent[1] = value);
	      });
	    }
	
	  return {
	    sum: sum,
	    dataExtent: dataExtent
	  };
	}
	/**
	 * Computes the score for the specified row,
	 * as the worst aspect ratio.
	 */
	
	
	function worst(row, rowFixedLength, ratio) {
	  var areaMax = 0;
	  var areaMin = Infinity;
	
	  for (var i = 0, area, len = row.length; i < len; i++) {
	    area = row[i].getLayout().area;
	
	    if (area) {
	      area < areaMin && (areaMin = area);
	      area > areaMax && (areaMax = area);
	    }
	  }
	
	  var squareArea = row.area * row.area;
	  var f = rowFixedLength * rowFixedLength * ratio;
	  return squareArea ? mathMax(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
	}
	/**
	 * Positions the specified row of nodes. Modifies `rect`.
	 */
	
	
	function position(row, rowFixedLength, rect, halfGapWidth, flush) {
	  // When rowFixedLength === rect.width,
	  // it is horizontal subdivision,
	  // rowFixedLength is the width of the subdivision,
	  // rowOtherLength is the height of the subdivision,
	  // and nodes will be positioned from left to right.
	  // wh[idx0WhenH] means: when horizontal,
	  //      wh[idx0WhenH] => wh[0] => 'width'.
	  //      xy[idx1WhenH] => xy[1] => 'y'.
	  var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
	  var idx1WhenH = 1 - idx0WhenH;
	  var xy = ['x', 'y'];
	  var wh = ['width', 'height'];
	  var last = rect[xy[idx0WhenH]];
	  var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;
	
	  if (flush || rowOtherLength > rect[wh[idx1WhenH]]) {
	    rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
	  }
	
	  for (var i = 0, rowLen = row.length; i < rowLen; i++) {
	    var node = row[i];
	    var nodeLayout = {};
	    var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
	    var wh1 = nodeLayout[wh[idx1WhenH]] = mathMax(rowOtherLength - 2 * halfGapWidth, 0); // We use Math.max/min to avoid negative width/height when considering gap width.
	
	    var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
	    var modWH = i === rowLen - 1 || remain < step ? remain : step;
	    var wh0 = nodeLayout[wh[idx0WhenH]] = mathMax(modWH - 2 * halfGapWidth, 0);
	    nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + mathMin(halfGapWidth, wh1 / 2);
	    nodeLayout[xy[idx0WhenH]] = last + mathMin(halfGapWidth, wh0 / 2);
	    last += modWH;
	    node.setLayout(nodeLayout, true);
	  }
	
	  rect[xy[idx1WhenH]] += rowOtherLength;
	  rect[wh[idx1WhenH]] -= rowOtherLength;
	} // Return [containerWidth, containerHeight] as defualt.
	
	
	function estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
	  // If targetInfo.node exists, we zoom to the node,
	  // so estimate whold width and heigth by target node.
	  var currNode = (targetInfo || {}).node;
	  var defaultSize = [containerWidth, containerHeight];
	
	  if (!currNode || currNode === viewRoot) {
	    return defaultSize;
	  }
	
	  var parent;
	  var viewArea = containerWidth * containerHeight;
	  var area = viewArea * seriesModel.option.zoomToNodeRatio;
	
	  while (parent = currNode.parentNode) {
	    // jshint ignore:line
	    var sum = 0;
	    var siblings = parent.children;
	
	    for (var i = 0, len = siblings.length; i < len; i++) {
	      sum += siblings[i].getValue();
	    }
	
	    var currNodeValue = currNode.getValue();
	
	    if (currNodeValue === 0) {
	      return defaultSize;
	    }
	
	    area *= sum / currNodeValue; // Considering border, suppose aspect ratio is 1.
	
	    var parentModel = parent.getModel();
	    var borderWidth = parentModel.get(PATH_BORDER_WIDTH);
	    var upperHeight = Math.max(borderWidth, getUpperLabelHeight(parentModel, borderWidth));
	    area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
	    area > MAX_SAFE_INTEGER && (area = MAX_SAFE_INTEGER);
	    currNode = parent;
	  }
	
	  area < viewArea && (area = viewArea);
	  var scale = Math.pow(area / viewArea, 0.5);
	  return [containerWidth * scale, containerHeight * scale];
	} // Root postion base on coord of containerGroup
	
	
	function calculateRootPosition(layoutInfo, rootRect, targetInfo) {
	  if (rootRect) {
	    return {
	      x: rootRect.x,
	      y: rootRect.y
	    };
	  }
	
	  var defaultPosition = {
	    x: 0,
	    y: 0
	  };
	
	  if (!targetInfo) {
	    return defaultPosition;
	  } // If targetInfo is fetched by 'retrieveTargetInfo',
	  // old tree and new tree are the same tree,
	  // so the node still exists and we can visit it.
	
	
	  var targetNode = targetInfo.node;
	  var layout = targetNode.getLayout();
	
	  if (!layout) {
	    return defaultPosition;
	  } // Transform coord from local to container.
	
	
	  var targetCenter = [layout.width / 2, layout.height / 2];
	  var node = targetNode;
	
	  while (node) {
	    var nodeLayout = node.getLayout();
	    targetCenter[0] += nodeLayout.x;
	    targetCenter[1] += nodeLayout.y;
	    node = node.parentNode;
	  }
	
	  return {
	    x: layoutInfo.width / 2 - targetCenter[0],
	    y: layoutInfo.height / 2 - targetCenter[1]
	  };
	} // Mark nodes visible for prunning when visual coding and rendering.
	// Prunning depends on layout and root position, so we have to do it after layout.
	
	
	function prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
	  var nodeLayout = node.getLayout();
	  var nodeInViewAbovePath = viewAbovePath[depth];
	  var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;
	
	  if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) {
	    return;
	  }
	
	  node.setLayout({
	    // isInView means: viewRoot sub tree + viewAbovePath
	    isInView: true,
	    // invisible only means: outside view clip so that the node can not
	    // see but still layout for animation preparation but not render.
	    invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
	    isAboveViewRoot: isAboveViewRoot
	  }, true); // Transform to child coordinate.
	
	  var childClipRect = new BoundingRect(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
	  each(node.viewChildren || [], function (child) {
	    prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
	  });
	}
	
	function getUpperLabelHeight(model) {
	  return model.get(PATH_UPPER_LABEL_SHOW) ? model.get(PATH_UPPER_LABEL_HEIGHT) : 0;
	}
	
	module.exports = _default;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	var VisualMapping = __webpack_require__(46);
	
	var zrColor = __webpack_require__(31);
	
	var zrUtil = __webpack_require__(1);
	
	var isArray = zrUtil.isArray;
	var ITEM_STYLE_NORMAL = 'itemStyle.normal';
	
	function _default(ecModel, api, payload) {
	  var condition = {
	    mainType: 'series',
	    subType: 'treemap',
	    query: payload
	  };
	  ecModel.eachComponent(condition, function (seriesModel) {
	    var tree = seriesModel.getData().tree;
	    var root = tree.root;
	    var seriesItemStyleModel = seriesModel.getModel(ITEM_STYLE_NORMAL);
	
	    if (root.isRemoved()) {
	      return;
	    }
	
	    var levelItemStyles = zrUtil.map(tree.levelModels, function (levelModel) {
	      return levelModel ? levelModel.get(ITEM_STYLE_NORMAL) : null;
	    });
	    travelTree(root, // Visual should calculate from tree root but not view root.
	    {}, levelItemStyles, seriesItemStyleModel, seriesModel.getViewRoot().getAncestors(), seriesModel);
	  });
	}
	
	function travelTree(node, designatedVisual, levelItemStyles, seriesItemStyleModel, viewRootAncestors, seriesModel) {
	  var nodeModel = node.getModel();
	  var nodeLayout = node.getLayout(); // Optimize
	
	  if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) {
	    return;
	  }
	
	  var nodeItemStyleModel = node.getModel(ITEM_STYLE_NORMAL);
	  var levelItemStyle = levelItemStyles[node.depth];
	  var visuals = buildVisuals(nodeItemStyleModel, designatedVisual, levelItemStyle, seriesItemStyleModel); // calculate border color
	
	  var borderColor = nodeItemStyleModel.get('borderColor');
	  var borderColorSaturation = nodeItemStyleModel.get('borderColorSaturation');
	  var thisNodeColor;
	
	  if (borderColorSaturation != null) {
	    // For performance, do not always execute 'calculateColor'.
	    thisNodeColor = calculateColor(visuals, node);
	    borderColor = calculateBorderColor(borderColorSaturation, thisNodeColor);
	  }
	
	  node.setVisual('borderColor', borderColor);
	  var viewChildren = node.viewChildren;
	
	  if (!viewChildren || !viewChildren.length) {
	    thisNodeColor = calculateColor(visuals, node); // Apply visual to this node.
	
	    node.setVisual('color', thisNodeColor);
	  } else {
	    var mapping = buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren); // Designate visual to children.
	
	    zrUtil.each(viewChildren, function (child, index) {
	      // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
	      if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
	        var childVisual = mapVisual(nodeModel, visuals, child, index, mapping, seriesModel);
	        travelTree(child, childVisual, levelItemStyles, seriesItemStyleModel, viewRootAncestors, seriesModel);
	      }
	    });
	  }
	}
	
	function buildVisuals(nodeItemStyleModel, designatedVisual, levelItemStyle, seriesItemStyleModel) {
	  var visuals = zrUtil.extend({}, designatedVisual);
	  zrUtil.each(['color', 'colorAlpha', 'colorSaturation'], function (visualName) {
	    // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
	    var val = nodeItemStyleModel.get(visualName, true); // Ignore parent
	
	    val == null && levelItemStyle && (val = levelItemStyle[visualName]);
	    val == null && (val = designatedVisual[visualName]);
	    val == null && (val = seriesItemStyleModel.get(visualName));
	    val != null && (visuals[visualName] = val);
	  });
	  return visuals;
	}
	
	function calculateColor(visuals) {
	  var color = getValueVisualDefine(visuals, 'color');
	
	  if (color) {
	    var colorAlpha = getValueVisualDefine(visuals, 'colorAlpha');
	    var colorSaturation = getValueVisualDefine(visuals, 'colorSaturation');
	
	    if (colorSaturation) {
	      color = zrColor.modifyHSL(color, null, null, colorSaturation);
	    }
	
	    if (colorAlpha) {
	      color = zrColor.modifyAlpha(color, colorAlpha);
	    }
	
	    return color;
	  }
	}
	
	function calculateBorderColor(borderColorSaturation, thisNodeColor) {
	  return thisNodeColor != null ? zrColor.modifyHSL(thisNodeColor, null, null, borderColorSaturation) : null;
	}
	
	function getValueVisualDefine(visuals, name) {
	  var value = visuals[name];
	
	  if (value != null && value !== 'none') {
	    return value;
	  }
	}
	
	function buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
	  if (!viewChildren || !viewChildren.length) {
	    return;
	  }
	
	  var rangeVisual = getRangeVisual(nodeModel, 'color') || visuals.color != null && visuals.color !== 'none' && (getRangeVisual(nodeModel, 'colorAlpha') || getRangeVisual(nodeModel, 'colorSaturation'));
	
	  if (!rangeVisual) {
	    return;
	  }
	
	  var visualMin = nodeModel.get('visualMin');
	  var visualMax = nodeModel.get('visualMax');
	  var dataExtent = nodeLayout.dataExtent.slice();
	  visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
	  visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
	  var colorMappingBy = nodeModel.get('colorMappingBy');
	  var opt = {
	    type: rangeVisual.name,
	    dataExtent: dataExtent,
	    visual: rangeVisual.range
	  };
	
	  if (opt.type === 'color' && (colorMappingBy === 'index' || colorMappingBy === 'id')) {
	    opt.mappingMethod = 'category';
	    opt.loop = true; // categories is ordinal, so do not set opt.categories.
	  } else {
	    opt.mappingMethod = 'linear';
	  }
	
	  var mapping = new VisualMapping(opt);
	  mapping.__drColorMappingBy = colorMappingBy;
	  return mapping;
	} // Notice: If we dont have the attribute 'colorRange', but only use
	// attribute 'color' to represent both concepts of 'colorRange' and 'color',
	// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
	// this problem will be encountered:
	// If a level-1 node dont have children, and its siblings has children,
	// and colorRange is set on level-1, then the node can not be colored.
	// So we separate 'colorRange' and 'color' to different attributes.
	
	
	function getRangeVisual(nodeModel, name) {
	  // 'colorRange', 'colorARange', 'colorSRange'.
	  // If not exsits on this node, fetch from levels and series.
	  var range = nodeModel.get(name);
	  return isArray(range) && range.length ? {
	    name: name,
	    range: range
	  } : null;
	}
	
	function mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
	  var childVisuals = zrUtil.extend({}, visuals);
	
	  if (mapping) {
	    var mappingType = mapping.type;
	    var colorMappingBy = mappingType === 'color' && mapping.__drColorMappingBy;
	    var value = colorMappingBy === 'index' ? index : colorMappingBy === 'id' ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get('visualDimension'));
	    childVisuals[mappingType] = mapping.mapValueToVisual(value);
	  }
	
	  return childVisuals;
	}
	
	module.exports = _default;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(127);
	
	__webpack_require__(459);

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(195);
	
	__webpack_require__(460);

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var Model = __webpack_require__(14);
	
	var AxisView = __webpack_require__(44);
	
	var elementList = ['axisLine', 'axisLabel', 'axisTick', 'splitLine', 'splitArea'];
	
	function getAxisLineShape(polar, rExtent, angle) {
	  rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
	  var start = polar.coordToPoint([rExtent[0], angle]);
	  var end = polar.coordToPoint([rExtent[1], angle]);
	  return {
	    x1: start[0],
	    y1: start[1],
	    x2: end[0],
	    y2: end[1]
	  };
	}
	
	function getRadiusIdx(polar) {
	  var radiusAxis = polar.getRadiusAxis();
	  return radiusAxis.inverse ? 0 : 1;
	}
	
	var _default = AxisView.extend({
	  type: 'angleAxis',
	  axisPointerClass: 'PolarAxisPointer',
	  render: function (angleAxisModel, ecModel) {
	    this.group.removeAll();
	
	    if (!angleAxisModel.get('show')) {
	      return;
	    }
	
	    var angleAxis = angleAxisModel.axis;
	    var polar = angleAxis.polar;
	    var radiusExtent = polar.getRadiusAxis().getExtent();
	    var ticksAngles = angleAxis.getTicksCoords();
	
	    if (angleAxis.type !== 'category') {
	      // Remove the last tick which will overlap the first tick
	      ticksAngles.pop();
	    }
	
	    zrUtil.each(elementList, function (name) {
	      if (angleAxisModel.get(name + '.show') && (!angleAxis.scale.isBlank() || name === 'axisLine')) {
	        this['_' + name](angleAxisModel, polar, ticksAngles, radiusExtent);
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _axisLine: function (angleAxisModel, polar, ticksAngles, radiusExtent) {
	    var lineStyleModel = angleAxisModel.getModel('axisLine.lineStyle');
	    var circle = new graphic.Circle({
	      shape: {
	        cx: polar.cx,
	        cy: polar.cy,
	        r: radiusExtent[getRadiusIdx(polar)]
	      },
	      style: lineStyleModel.getLineStyle(),
	      z2: 1,
	      silent: true
	    });
	    circle.style.fill = null;
	    this.group.add(circle);
	  },
	
	  /**
	   * @private
	   */
	  _axisTick: function (angleAxisModel, polar, ticksAngles, radiusExtent) {
	    var tickModel = angleAxisModel.getModel('axisTick');
	    var tickLen = (tickModel.get('inside') ? -1 : 1) * tickModel.get('length');
	    var radius = radiusExtent[getRadiusIdx(polar)];
	    var lines = zrUtil.map(ticksAngles, function (tickAngle) {
	      return new graphic.Line({
	        shape: getAxisLineShape(polar, [radius, radius + tickLen], tickAngle)
	      });
	    });
	    this.group.add(graphic.mergePath(lines, {
	      style: zrUtil.defaults(tickModel.getModel('lineStyle').getLineStyle(), {
	        stroke: angleAxisModel.get('axisLine.lineStyle.color')
	      })
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _axisLabel: function (angleAxisModel, polar, ticksAngles, radiusExtent) {
	    var axis = angleAxisModel.axis;
	    var categoryData = angleAxisModel.get('data');
	    var labelModel = angleAxisModel.getModel('axisLabel');
	    var labels = angleAxisModel.getFormattedLabels();
	    var labelMargin = labelModel.get('margin');
	    var labelsAngles = axis.getLabelsCoords(); // Use length of ticksAngles because it may remove the last tick to avoid overlapping
	
	    for (var i = 0; i < ticksAngles.length; i++) {
	      var r = radiusExtent[getRadiusIdx(polar)];
	      var p = polar.coordToPoint([r + labelMargin, labelsAngles[i]]);
	      var cx = polar.cx;
	      var cy = polar.cy;
	      var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? 'center' : p[0] > cx ? 'left' : 'right';
	      var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? 'middle' : p[1] > cy ? 'top' : 'bottom';
	
	      if (categoryData && categoryData[i] && categoryData[i].textStyle) {
	        labelModel = new Model(categoryData[i].textStyle, labelModel, labelModel.ecModel);
	      }
	
	      var textEl = new graphic.Text({
	        silent: true
	      });
	      this.group.add(textEl);
	      graphic.setTextStyle(textEl.style, labelModel, {
	        x: p[0],
	        y: p[1],
	        textFill: labelModel.getTextColor() || angleAxisModel.get('axisLine.lineStyle.color'),
	        text: labels[i],
	        textAlign: labelTextAlign,
	        textVerticalAlign: labelTextVerticalAlign
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _splitLine: function (angleAxisModel, polar, ticksAngles, radiusExtent) {
	    var splitLineModel = angleAxisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    var lineCount = 0;
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var splitLines = [];
	
	    for (var i = 0; i < ticksAngles.length; i++) {
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Line({
	        shape: getAxisLineShape(polar, radiusExtent, ticksAngles[i])
	      }));
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitLines.length; i++) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: zrUtil.defaults({
	          stroke: lineColors[i % lineColors.length]
	        }, lineStyleModel.getLineStyle()),
	        silent: true,
	        z: angleAxisModel.get('z')
	      }));
	    }
	  },
	
	  /**
	   * @private
	   */
	  _splitArea: function (angleAxisModel, polar, ticksAngles, radiusExtent) {
	    var splitAreaModel = angleAxisModel.getModel('splitArea');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var areaColors = areaStyleModel.get('color');
	    var lineCount = 0;
	    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
	    var splitAreas = [];
	    var RADIAN = Math.PI / 180;
	    var prevAngle = -ticksAngles[0] * RADIAN;
	    var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
	    var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
	    var clockwise = angleAxisModel.get('clockwise');
	
	    for (var i = 1; i < ticksAngles.length; i++) {
	      var colorIndex = lineCount++ % areaColors.length;
	      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
	      splitAreas[colorIndex].push(new graphic.Sector({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r0: r0,
	          r: r1,
	          startAngle: prevAngle,
	          endAngle: -ticksAngles[i] * RADIAN,
	          clockwise: clockwise
	        },
	        silent: true
	      }));
	      prevAngle = -ticksAngles[i] * RADIAN;
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitAreas.length; i++) {
	      this.group.add(graphic.mergePath(splitAreas[i], {
	        style: zrUtil.defaults({
	          fill: areaColors[i % areaColors.length]
	        }, areaStyleModel.getAreaStyle()),
	        silent: true
	      }));
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var AxisBuilder = __webpack_require__(43);
	
	var AxisView = __webpack_require__(44);
	
	var cartesianAxisHelper = __webpack_require__(167);
	
	var ifIgnoreOnTick = AxisBuilder.ifIgnoreOnTick;
	var getInterval = AxisBuilder.getInterval;
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttrs = ['splitArea', 'splitLine']; // function getAlignWithLabel(model, axisModel) {
	//     var alignWithLabel = model.get('alignWithLabel');
	//     if (alignWithLabel === 'auto') {
	//         alignWithLabel = axisModel.get('axisTick.alignWithLabel');
	//     }
	//     return alignWithLabel;
	// }
	
	var CartesianAxisView = AxisView.extend({
	  type: 'cartesianAxis',
	  axisPointerClass: 'CartesianAxisPointer',
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    this.group.removeAll();
	    var oldAxisGroup = this._axisGroup;
	    this._axisGroup = new graphic.Group();
	    this.group.add(this._axisGroup);
	
	    if (!axisModel.get('show')) {
	      return;
	    }
	
	    var gridModel = axisModel.getCoordSysModel();
	    var layout = cartesianAxisHelper.layout(gridModel, axisModel);
	    var axisBuilder = new AxisBuilder(axisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	
	    this._axisGroup.add(axisBuilder.getGroup());
	
	    zrUtil.each(selfBuilderAttrs, function (name) {
	      if (axisModel.get(name + '.show')) {
	        this['_' + name](axisModel, gridModel, layout.labelInterval);
	      }
	    }, this);
	    graphic.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
	    CartesianAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
	  },
	
	  /**
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/coord/cartesian/GridModel} gridModel
	   * @param {number|Function} labelInterval
	   * @private
	   */
	  _splitLine: function (axisModel, gridModel, labelInterval) {
	    var axis = axisModel.axis;
	
	    if (axis.scale.isBlank()) {
	      return;
	    }
	
	    var splitLineModel = axisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    var lineInterval = getInterval(splitLineModel, labelInterval);
	    lineColors = zrUtil.isArray(lineColors) ? lineColors : [lineColors];
	    var gridRect = gridModel.coordinateSystem.getRect();
	    var isHorizontal = axis.isHorizontal();
	    var lineCount = 0;
	    var ticksCoords = axis.getTicksCoords();
	    var ticks = axis.scale.getTicks();
	    var showMinLabel = axisModel.get('axisLabel.showMinLabel');
	    var showMaxLabel = axisModel.get('axisLabel.showMaxLabel');
	    var p1 = [];
	    var p2 = []; // Simple optimization
	    // Batching the lines if color are the same
	
	    var lineStyle = lineStyleModel.getLineStyle();
	
	    for (var i = 0; i < ticksCoords.length; i++) {
	      if (ifIgnoreOnTick(axis, i, lineInterval, ticksCoords.length, showMinLabel, showMaxLabel)) {
	        continue;
	      }
	
	      var tickCoord = axis.toGlobalCoord(ticksCoords[i]);
	
	      if (isHorizontal) {
	        p1[0] = tickCoord;
	        p1[1] = gridRect.y;
	        p2[0] = tickCoord;
	        p2[1] = gridRect.y + gridRect.height;
	      } else {
	        p1[0] = gridRect.x;
	        p1[1] = tickCoord;
	        p2[0] = gridRect.x + gridRect.width;
	        p2[1] = tickCoord;
	      }
	
	      var colorIndex = lineCount++ % lineColors.length;
	
	      this._axisGroup.add(new graphic.Line(graphic.subPixelOptimizeLine({
	        anid: 'line_' + ticks[i],
	        shape: {
	          x1: p1[0],
	          y1: p1[1],
	          x2: p2[0],
	          y2: p2[1]
	        },
	        style: zrUtil.defaults({
	          stroke: lineColors[colorIndex]
	        }, lineStyle),
	        silent: true
	      })));
	    }
	  },
	
	  /**
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/coord/cartesian/GridModel} gridModel
	   * @param {number|Function} labelInterval
	   * @private
	   */
	  _splitArea: function (axisModel, gridModel, labelInterval) {
	    var axis = axisModel.axis;
	
	    if (axis.scale.isBlank()) {
	      return;
	    }
	
	    var splitAreaModel = axisModel.getModel('splitArea');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var areaColors = areaStyleModel.get('color');
	    var gridRect = gridModel.coordinateSystem.getRect();
	    var ticksCoords = axis.getTicksCoords();
	    var ticks = axis.scale.getTicks();
	    var prevX = axis.toGlobalCoord(ticksCoords[0]);
	    var prevY = axis.toGlobalCoord(ticksCoords[0]);
	    var count = 0;
	    var areaInterval = getInterval(splitAreaModel, labelInterval);
	    var areaStyle = areaStyleModel.getAreaStyle();
	    areaColors = zrUtil.isArray(areaColors) ? areaColors : [areaColors];
	    var showMinLabel = axisModel.get('axisLabel.showMinLabel');
	    var showMaxLabel = axisModel.get('axisLabel.showMaxLabel');
	
	    for (var i = 1; i < ticksCoords.length; i++) {
	      if (ifIgnoreOnTick(axis, i, areaInterval, ticksCoords.length, showMinLabel, showMaxLabel)) {
	        continue;
	      }
	
	      var tickCoord = axis.toGlobalCoord(ticksCoords[i]);
	      var x;
	      var y;
	      var width;
	      var height;
	
	      if (axis.isHorizontal()) {
	        x = prevX;
	        y = gridRect.y;
	        width = tickCoord - x;
	        height = gridRect.height;
	      } else {
	        x = gridRect.x;
	        y = prevY;
	        width = gridRect.width;
	        height = tickCoord - y;
	      }
	
	      var colorIndex = count++ % areaColors.length;
	
	      this._axisGroup.add(new graphic.Rect({
	        anid: 'area_' + ticks[i],
	        shape: {
	          x: x,
	          y: y,
	          width: width,
	          height: height
	        },
	        style: zrUtil.defaults({
	          fill: areaColors[colorIndex]
	        }, areaStyle),
	        silent: true
	      }));
	
	      prevX = x + width;
	      prevY = y + height;
	    }
	  }
	});
	CartesianAxisView.extend({
	  type: 'xAxis'
	});
	CartesianAxisView.extend({
	  type: 'yAxis'
	});

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var AxisBuilder = __webpack_require__(43);
	
	var BrushController = __webpack_require__(120);
	
	var brushHelper = __webpack_require__(178);
	
	var graphic = __webpack_require__(3);
	
	var elementList = ['axisLine', 'axisTickLabel', 'axisName'];
	var AxisView = echarts.extendComponentView({
	  type: 'parallelAxis',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    AxisView.superApply(this, 'init', arguments);
	    /**
	     * @type {module:echarts/component/helper/BrushController}
	     */
	
	    (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this));
	  },
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    if (fromAxisAreaSelect(axisModel, ecModel, payload)) {
	      return;
	    }
	
	    this.axisModel = axisModel;
	    this.api = api;
	    this.group.removeAll();
	    var oldAxisGroup = this._axisGroup;
	    this._axisGroup = new graphic.Group();
	    this.group.add(this._axisGroup);
	
	    if (!axisModel.get('show')) {
	      return;
	    }
	
	    var coordSysModel = getCoordSysModel(axisModel, ecModel);
	    var coordSys = coordSysModel.coordinateSystem;
	    var areaSelectStyle = axisModel.getAreaSelectStyle();
	    var areaWidth = areaSelectStyle.width;
	    var dim = axisModel.axis.dim;
	    var axisLayout = coordSys.getAxisLayout(dim);
	    var builderOpt = zrUtil.extend({
	      strokeContainThreshold: areaWidth
	    }, axisLayout);
	    var axisBuilder = new AxisBuilder(axisModel, builderOpt);
	    zrUtil.each(elementList, axisBuilder.add, axisBuilder);
	
	    this._axisGroup.add(axisBuilder.getGroup());
	
	    this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);
	
	    var animationModel = payload && payload.animation === false ? null : axisModel;
	    graphic.groupTransition(oldAxisGroup, this._axisGroup, animationModel);
	  },
	
	  /**
	   * @override
	   */
	  updateVisual: function (axisModel, ecModel, api, payload) {
	    this._brushController && this._brushController.updateCovers(getCoverInfoList(axisModel));
	  },
	  _refreshBrushController: function (builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
	    // After filtering, axis may change, select area needs to be update.
	    var extent = axisModel.axis.getExtent();
	    var extentLen = extent[1] - extent[0];
	    var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
	    // width/height might be negative, which will be
	    // normalized in BoundingRect.
	
	    var rect = graphic.BoundingRect.create({
	      x: extent[0],
	      y: -areaWidth / 2,
	      width: extentLen,
	      height: areaWidth
	    });
	    rect.x -= extra;
	    rect.width += 2 * extra;
	
	    this._brushController.mount({
	      enableGlobalPan: true,
	      rotation: builderOpt.rotation,
	      position: builderOpt.position
	    }).setPanels([{
	      panelId: 'pl',
	      clipPath: brushHelper.makeRectPanelClipPath(rect),
	      isTargetByCursor: brushHelper.makeRectIsTargetByCursor(rect, api, coordSysModel),
	      getLinearBrushOtherExtent: brushHelper.makeLinearBrushOtherExtent(rect, 0)
	    }]).enableBrush({
	      brushType: 'lineX',
	      brushStyle: areaSelectStyle,
	      removeOnClick: true
	    }).updateCovers(getCoverInfoList(axisModel));
	  },
	  _onBrush: function (coverInfoList, opt) {
	    // Do not cache these object, because the mey be changed.
	    var axisModel = this.axisModel;
	    var axis = axisModel.axis;
	    var intervals = zrUtil.map(coverInfoList, function (coverInfo) {
	      return [axis.coordToData(coverInfo.range[0], true), axis.coordToData(coverInfo.range[1], true)];
	    }); // If realtime is true, action is not dispatched on drag end, because
	    // the drag end emits the same params with the last drag move event,
	    // and may have some delay when using touch pad.
	
	    if (!axisModel.option.realtime === opt.isEnd || opt.removeOnClick) {
	      // jshint ignore:line
	      this.api.dispatchAction({
	        type: 'axisAreaSelect',
	        parallelAxisId: axisModel.id,
	        intervals: intervals
	      });
	    }
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._brushController.dispose();
	  }
	});
	
	function fromAxisAreaSelect(axisModel, ecModel, payload) {
	  return payload && payload.type === 'axisAreaSelect' && ecModel.findComponents({
	    mainType: 'parallelAxis',
	    query: payload
	  })[0] === axisModel;
	}
	
	function getCoverInfoList(axisModel) {
	  var axis = axisModel.axis;
	  return zrUtil.map(axisModel.activeIntervals, function (interval) {
	    return {
	      brushType: 'lineX',
	      panelId: 'pl',
	      range: [axis.dataToCoord(interval[0], true), axis.dataToCoord(interval[1], true)]
	    };
	  });
	}
	
	function getCoordSysModel(axisModel, ecModel) {
	  return ecModel.getComponent('parallel', axisModel.get('parallelIndex'));
	}
	
	var _default = AxisView;
	module.exports = _default;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var AxisBuilder = __webpack_require__(43);
	
	var AxisView = __webpack_require__(44);
	
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttrs = ['splitLine', 'splitArea'];
	
	var _default = AxisView.extend({
	  type: 'radiusAxis',
	  axisPointerClass: 'PolarAxisPointer',
	  render: function (radiusAxisModel, ecModel) {
	    this.group.removeAll();
	
	    if (!radiusAxisModel.get('show')) {
	      return;
	    }
	
	    var radiusAxis = radiusAxisModel.axis;
	    var polar = radiusAxis.polar;
	    var angleAxis = polar.getAngleAxis();
	    var ticksCoords = radiusAxis.getTicksCoords();
	    var axisAngle = angleAxis.getExtent()[0];
	    var radiusExtent = radiusAxis.getExtent();
	    var layout = layoutAxis(polar, radiusAxisModel, axisAngle);
	    var axisBuilder = new AxisBuilder(radiusAxisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	    this.group.add(axisBuilder.getGroup());
	    zrUtil.each(selfBuilderAttrs, function (name) {
	      if (radiusAxisModel.get(name + '.show') && !radiusAxis.scale.isBlank()) {
	        this['_' + name](radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords);
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _splitLine: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
	    var splitLineModel = radiusAxisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    var lineCount = 0;
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var splitLines = [];
	
	    for (var i = 0; i < ticksCoords.length; i++) {
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Circle({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r: ticksCoords[i]
	        },
	        silent: true
	      }));
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitLines.length; i++) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: zrUtil.defaults({
	          stroke: lineColors[i % lineColors.length],
	          fill: null
	        }, lineStyleModel.getLineStyle()),
	        silent: true
	      }));
	    }
	  },
	
	  /**
	   * @private
	   */
	  _splitArea: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
	    var splitAreaModel = radiusAxisModel.getModel('splitArea');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var areaColors = areaStyleModel.get('color');
	    var lineCount = 0;
	    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
	    var splitAreas = [];
	    var prevRadius = ticksCoords[0];
	
	    for (var i = 1; i < ticksCoords.length; i++) {
	      var colorIndex = lineCount++ % areaColors.length;
	      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
	      splitAreas[colorIndex].push(new graphic.Sector({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r0: prevRadius,
	          r: ticksCoords[i],
	          startAngle: 0,
	          endAngle: Math.PI * 2
	        },
	        silent: true
	      }));
	      prevRadius = ticksCoords[i];
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitAreas.length; i++) {
	      this.group.add(graphic.mergePath(splitAreas[i], {
	        style: zrUtil.defaults({
	          fill: areaColors[i % areaColors.length]
	        }, areaStyleModel.getAreaStyle()),
	        silent: true
	      }));
	    }
	  }
	});
	/**
	 * @inner
	 */
	
	
	function layoutAxis(polar, radiusAxisModel, axisAngle) {
	  return {
	    position: [polar.cx, polar.cy],
	    rotation: axisAngle / 180 * Math.PI,
	    labelDirection: -1,
	    tickDirection: -1,
	    nameDirection: 1,
	    labelRotate: radiusAxisModel.getModel('axisLabel').get('rotate'),
	    // Over splitLine and splitArea
	    z2: 1
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var AxisBuilder = __webpack_require__(43);
	
	var graphic = __webpack_require__(3);
	
	var singleAxisHelper = __webpack_require__(168);
	
	var AxisView = __webpack_require__(44);
	
	var getInterval = AxisBuilder.getInterval;
	var ifIgnoreOnTick = AxisBuilder.ifIgnoreOnTick;
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttr = 'splitLine';
	var SingleAxisView = AxisView.extend({
	  type: 'singleAxis',
	  axisPointerClass: 'SingleAxisPointer',
	  render: function (axisModel, ecModel, api, payload) {
	    var group = this.group;
	    group.removeAll();
	    var layout = singleAxisHelper.layout(axisModel);
	    var axisBuilder = new AxisBuilder(axisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	    group.add(axisBuilder.getGroup());
	
	    if (axisModel.get(selfBuilderAttr + '.show')) {
	      this['_' + selfBuilderAttr](axisModel, layout.labelInterval);
	    }
	
	    SingleAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
	  },
	  _splitLine: function (axisModel, labelInterval) {
	    var axis = axisModel.axis;
	
	    if (axis.scale.isBlank()) {
	      return;
	    }
	
	    var splitLineModel = axisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineWidth = lineStyleModel.get('width');
	    var lineColors = lineStyleModel.get('color');
	    var lineInterval = getInterval(splitLineModel, labelInterval);
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var gridRect = axisModel.coordinateSystem.getRect();
	    var isHorizontal = axis.isHorizontal();
	    var splitLines = [];
	    var lineCount = 0;
	    var ticksCoords = axis.getTicksCoords();
	    var p1 = [];
	    var p2 = [];
	    var showMinLabel = axisModel.get('axisLabel.showMinLabel');
	    var showMaxLabel = axisModel.get('axisLabel.showMaxLabel');
	
	    for (var i = 0; i < ticksCoords.length; ++i) {
	      if (ifIgnoreOnTick(axis, i, lineInterval, ticksCoords.length, showMinLabel, showMaxLabel)) {
	        continue;
	      }
	
	      var tickCoord = axis.toGlobalCoord(ticksCoords[i]);
	
	      if (isHorizontal) {
	        p1[0] = tickCoord;
	        p1[1] = gridRect.y;
	        p2[0] = tickCoord;
	        p2[1] = gridRect.y + gridRect.height;
	      } else {
	        p1[0] = gridRect.x;
	        p1[1] = tickCoord;
	        p2[0] = gridRect.x + gridRect.width;
	        p2[1] = tickCoord;
	      }
	
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Line(graphic.subPixelOptimizeLine({
	        shape: {
	          x1: p1[0],
	          y1: p1[1],
	          x2: p2[0],
	          y2: p2[1]
	        },
	        style: {
	          lineWidth: lineWidth
	        },
	        silent: true
	      })));
	    }
	
	    for (var i = 0; i < splitLines.length; ++i) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: {
	          stroke: lineColors[i % lineColors.length],
	          lineDash: lineStyleModel.getLineDash(lineWidth),
	          lineWidth: lineWidth
	        },
	        silent: true
	      }));
	    }
	  }
	});
	var _default = SingleAxisView;
	module.exports = _default;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	/**
	 * @payload
	 * @property {string} parallelAxisId
	 * @property {Array.<Array.<number>>} intervals
	 */
	var actionInfo = {
	  type: 'axisAreaSelect',
	  event: 'axisAreaSelected',
	  update: 'updateVisual'
	};
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'parallelAxis',
	    query: payload
	  }, function (parallelAxisModel) {
	    parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
	  });
	});
	/**
	 * @payload
	 */
	
	echarts.registerAction('parallelAxisExpand', function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'parallel',
	    query: payload
	  }, function (parallelModel) {
	    parallelModel.setAxisExpand(payload);
	  });
	});

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var AxisPointerModel = echarts.extendComponentModel({
	  type: 'axisPointer',
	  coordSysAxesInfo: null,
	  defaultOption: {
	    // 'auto' means that show when triggered by tooltip or handle.
	    show: 'auto',
	    // 'click' | 'mousemove' | 'none'
	    triggerOn: null,
	    // set default in AxisPonterView.js
	    zlevel: 0,
	    z: 50,
	    type: 'line',
	    // axispointer triggered by tootip determine snap automatically,
	    // see `modelHelper`.
	    snap: false,
	    triggerTooltip: true,
	    value: null,
	    status: null,
	    // Init value depends on whether handle is used.
	    // [group0, group1, ...]
	    // Each group can be: {
	    //      mapper: function () {},
	    //      singleTooltip: 'multiple',  // 'multiple' or 'single'
	    //      xAxisId: ...,
	    //      yAxisName: ...,
	    //      angleAxisIndex: ...
	    // }
	    // mapper: can be ignored.
	    //      input: {axisInfo, value}
	    //      output: {axisInfo, value}
	    link: [],
	    // Do not set 'auto' here, otherwise global animation: false
	    // will not effect at this axispointer.
	    animation: null,
	    animationDurationUpdate: 200,
	    lineStyle: {
	      color: '#aaa',
	      width: 1,
	      type: 'solid'
	    },
	    shadowStyle: {
	      color: 'rgba(150,150,150,0.3)'
	    },
	    label: {
	      show: true,
	      formatter: null,
	      // string | Function
	      precision: 'auto',
	      // Or a number like 0, 1, 2 ...
	      margin: 3,
	      color: '#fff',
	      padding: [5, 7, 5, 7],
	      backgroundColor: 'auto',
	      // default: axis line color
	      borderColor: null,
	      borderWidth: 0,
	      shadowBlur: 3,
	      shadowColor: '#aaa' // Considering applicability, common style should
	      // better not have shadowOffset.
	      // shadowOffsetX: 0,
	      // shadowOffsetY: 2
	
	    },
	    handle: {
	      show: false,
	      icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
	      // jshint ignore:line
	      size: 45,
	      // handle margin is from symbol center to axis, which is stable when circular move.
	      margin: 50,
	      // color: '#1b8bbd'
	      // color: '#2f4554'
	      color: '#333',
	      shadowBlur: 3,
	      shadowColor: '#aaa',
	      shadowOffsetX: 0,
	      shadowOffsetY: 2,
	      // For mobile performance
	      throttle: 40
	    }
	  }
	});
	var _default = AxisPointerModel;
	module.exports = _default;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var globalListener = __webpack_require__(171);
	
	var AxisPointerView = echarts.extendComponentView({
	  type: 'axisPointer',
	  render: function (globalAxisPointerModel, ecModel, api) {
	    var globalTooltipModel = ecModel.getComponent('tooltip');
	    var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
	    // AxisPointerView to be independent to Tooltip.
	
	    globalListener.register('axisPointer', api, function (currTrigger, e, dispatchAction) {
	      // If 'none', it is not controlled by mouse totally.
	      if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) {
	        dispatchAction({
	          type: 'updateAxisPointer',
	          currTrigger: currTrigger,
	          x: e && e.offsetX,
	          y: e && e.offsetY
	        });
	      }
	    });
	  },
	
	  /**
	   * @override
	   */
	  remove: function (ecModel, api) {
	    globalListener.unregister(api.getZr(), 'axisPointer');
	    AxisPointerView.superApply(this._model, 'remove', arguments);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function (ecModel, api) {
	    globalListener.unregister('axisPointer', api);
	    AxisPointerView.superApply(this._model, 'dispose', arguments);
	  }
	});
	var _default = AxisPointerView;
	module.exports = _default;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	var formatUtil = __webpack_require__(9);
	
	var BaseAxisPointer = __webpack_require__(118);
	
	var graphic = __webpack_require__(3);
	
	var viewHelper = __webpack_require__(86);
	
	var matrix = __webpack_require__(23);
	
	var AxisBuilder = __webpack_require__(43);
	
	var AxisView = __webpack_require__(44);
	
	var PolarAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	
	    if (axis.dim === 'angle') {
	      this.animationThreshold = Math.PI / 18;
	    }
	
	    var polar = axis.polar;
	    var otherAxis = polar.getOtherAxis(axis);
	    var otherExtent = otherAxis.getExtent();
	    var coordValue;
	    coordValue = axis['dataTo' + formatUtil.capitalFirst(axis.dim)](value);
	    var axisPointerType = axisPointerModel.get('type');
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, polar, coordValue, otherExtent, elStyle);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var labelMargin = axisPointerModel.get('label.margin');
	    var labelPos = getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
	    viewHelper.buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos);
	  } // Do not support handle, utill any user requires it.
	
	});
	
	function getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
	  var axis = axisModel.axis;
	  var coord = axis.dataToCoord(value);
	  var axisAngle = polar.getAngleAxis().getExtent()[0];
	  axisAngle = axisAngle / 180 * Math.PI;
	  var radiusExtent = polar.getRadiusAxis().getExtent();
	  var position;
	  var align;
	  var verticalAlign;
	
	  if (axis.dim === 'radius') {
	    var transform = matrix.create();
	    matrix.rotate(transform, transform, axisAngle);
	    matrix.translate(transform, transform, [polar.cx, polar.cy]);
	    position = graphic.applyTransform([coord, -labelMargin], transform);
	    var labelRotation = axisModel.getModel('axisLabel').get('rotate') || 0;
	    var labelLayout = AxisBuilder.innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
	    align = labelLayout.textAlign;
	    verticalAlign = labelLayout.textVerticalAlign;
	  } else {
	    // angle axis
	    var r = radiusExtent[1];
	    position = polar.coordToPoint([r + labelMargin, coord]);
	    var cx = polar.cx;
	    var cy = polar.cy;
	    align = Math.abs(position[0] - cx) / r < 0.3 ? 'center' : position[0] > cx ? 'left' : 'right';
	    verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? 'middle' : position[1] > cy ? 'top' : 'bottom';
	  }
	
	  return {
	    position: position,
	    align: align,
	    verticalAlign: verticalAlign
	  };
	}
	
	var pointerShapeBuilder = {
	  line: function (axis, polar, coordValue, otherExtent, elStyle) {
	    return axis.dim === 'angle' ? {
	      type: 'Line',
	      shape: viewHelper.makeLineShape(polar.coordToPoint([otherExtent[0], coordValue]), polar.coordToPoint([otherExtent[1], coordValue]))
	    } : {
	      type: 'Circle',
	      shape: {
	        cx: polar.cx,
	        cy: polar.cy,
	        r: coordValue
	      }
	    };
	  },
	  shadow: function (axis, polar, coordValue, otherExtent, elStyle) {
	    var bandWidth = axis.getBandWidth();
	    var radian = Math.PI / 180;
	    return axis.dim === 'angle' ? {
	      type: 'Sector',
	      shape: viewHelper.makeSectorShape(polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
	      (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
	    } : {
	      type: 'Sector',
	      shape: viewHelper.makeSectorShape(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
	    };
	  }
	};
	AxisView.registerAxisPointerClass('PolarAxisPointer', PolarAxisPointer);
	var _default = PolarAxisPointer;
	module.exports = _default;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	var graphic = __webpack_require__(3);
	
	var BaseAxisPointer = __webpack_require__(118);
	
	var viewHelper = __webpack_require__(86);
	
	var singleAxisHelper = __webpack_require__(168);
	
	var AxisView = __webpack_require__(44);
	
	var XY = ['x', 'y'];
	var WH = ['width', 'height'];
	var SingleAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	    var coordSys = axis.coordinateSystem;
	    var otherExtent = getGlobalExtent(coordSys, 1 - getPointDimIndex(axis));
	    var pixelValue = coordSys.dataToPoint(value)[0];
	    var axisPointerType = axisPointerModel.get('type');
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent, elStyle);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var layoutInfo = singleAxisHelper.layout(axisModel);
	    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
	  },
	
	  /**
	   * @override
	   */
	  getHandleTransform: function (value, axisModel, axisPointerModel) {
	    var layoutInfo = singleAxisHelper.layout(axisModel, {
	      labelInside: false
	    });
	    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
	    return {
	      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
	      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
	    };
	  },
	
	  /**
	   * @override
	   */
	  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
	    var axis = axisModel.axis;
	    var coordSys = axis.coordinateSystem;
	    var dimIndex = getPointDimIndex(axis);
	    var axisExtent = getGlobalExtent(coordSys, dimIndex);
	    var currPosition = transform.position;
	    currPosition[dimIndex] += delta[dimIndex];
	    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
	    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
	    var otherExtent = getGlobalExtent(coordSys, 1 - dimIndex);
	    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
	    var cursorPoint = [cursorOtherValue, cursorOtherValue];
	    cursorPoint[dimIndex] = currPosition[dimIndex];
	    return {
	      position: currPosition,
	      rotation: transform.rotation,
	      cursorPoint: cursorPoint,
	      tooltipOption: {
	        verticalAlign: 'middle'
	      }
	    };
	  }
	});
	var pointerShapeBuilder = {
	  line: function (axis, pixelValue, otherExtent, elStyle) {
	    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getPointDimIndex(axis));
	    graphic.subPixelOptimizeLine({
	      shape: targetShape,
	      style: elStyle
	    });
	    return {
	      type: 'Line',
	      shape: targetShape
	    };
	  },
	  shadow: function (axis, pixelValue, otherExtent, elStyle) {
	    var bandWidth = axis.getBandWidth();
	    var span = otherExtent[1] - otherExtent[0];
	    return {
	      type: 'Rect',
	      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getPointDimIndex(axis))
	    };
	  }
	};
	
	function getPointDimIndex(axis) {
	  return axis.isHorizontal() ? 0 : 1;
	}
	
	function getGlobalExtent(coordSys, dimIndex) {
	  var rect = coordSys.getRect();
	  return [rect[XY[dimIndex]], rect[XY[dimIndex]] + rect[WH[dimIndex]]];
	}
	
	AxisView.registerAxisPointerClass('SingleAxisPointer', SingleAxisPointer);
	var _default = SingleAxisPointer;
	module.exports = _default;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var modelUtil = __webpack_require__(6);
	
	var modelHelper = __webpack_require__(85);
	
	var findPointFromSeries = __webpack_require__(170);
	
	var each = zrUtil.each;
	var curry = zrUtil.curry;
	var get = modelUtil.makeGetter();
	/**
	 * Basic logic: check all axis, if they do not demand show/highlight,
	 * then hide/downplay them.
	 *
	 * @param {Object} coordSysAxesInfo
	 * @param {Object} payload
	 * @param {string} [payload.currTrigger] 'click' | 'mousemove' | 'leave'
	 * @param {Array.<number>} [payload.x] x and y, which are mandatory, specify a point to
	 *              trigger axisPointer and tooltip.
	 * @param {Array.<number>} [payload.y] x and y, which are mandatory, specify a point to
	 *              trigger axisPointer and tooltip.
	 * @param {Object} [payload.seriesIndex] finder, optional, restrict target axes.
	 * @param {Object} [payload.dataIndex] finder, restrict target axes.
	 * @param {Object} [payload.axesInfo] finder, restrict target axes.
	 *        [{
	 *          axisDim: 'x'|'y'|'angle'|...,
	 *          axisIndex: ...,
	 *          value: ...
	 *        }, ...]
	 * @param {Function} [payload.dispatchAction]
	 * @param {Object} [payload.tooltipOption]
	 * @param {Object|Array.<number>|Function} [payload.position] Tooltip position,
	 *        which can be specified in dispatchAction
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 * @return {Object} content of event obj for echarts.connect.
	 */
	
	function _default(payload, ecModel, api) {
	  var currTrigger = payload.currTrigger;
	  var point = [payload.x, payload.y];
	  var finder = payload;
	  var dispatchAction = payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
	  var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
	  // See #6121. But we are not able to reproduce it yet.
	
	  if (!coordSysAxesInfo) {
	    return;
	  }
	
	  if (illegalPoint(point)) {
	    // Used in the default behavior of `connection`: use the sample seriesIndex
	    // and dataIndex. And also used in the tooltipView trigger.
	    point = findPointFromSeries({
	      seriesIndex: finder.seriesIndex,
	      // Do not use dataIndexInside from other ec instance.
	      // FIXME: auto detect it?
	      dataIndex: finder.dataIndex
	    }, ecModel).point;
	  }
	
	  var isIllegalPoint = illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
	  // Notice: In this case, it is difficult to get the `point` (which is necessary to show
	  // tooltip, so if point is not given, we just use the point found by sample seriesIndex
	  // and dataIndex.
	
	  var inputAxesInfo = finder.axesInfo;
	  var axesInfo = coordSysAxesInfo.axesInfo;
	  var shouldHide = currTrigger === 'leave' || illegalPoint(point);
	  var outputFinder = {};
	  var showValueMap = {};
	  var dataByCoordSys = {
	    list: [],
	    map: {}
	  };
	  var updaters = {
	    showPointer: curry(showPointer, showValueMap),
	    showTooltip: curry(showTooltip, dataByCoordSys)
	  }; // Process for triggered axes.
	
	  each(coordSysAxesInfo.coordSysMap, function (coordSys, coordSysKey) {
	    // If a point given, it must be contained by the coordinate system.
	    var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
	    each(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function (axisInfo, key) {
	      var axis = axisInfo.axis;
	      var inputAxisInfo = findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.
	
	      if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
	        var val = inputAxisInfo && inputAxisInfo.value;
	
	        if (val == null && !isIllegalPoint) {
	          val = axis.pointToData(point);
	        }
	
	        val != null && processOnAxis(axisInfo, val, updaters, false, outputFinder);
	      }
	    });
	  }); // Process for linked axes.
	
	  var linkTriggers = {};
	  each(axesInfo, function (tarAxisInfo, tarKey) {
	    var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.
	
	    if (linkGroup && !showValueMap[tarKey]) {
	      each(linkGroup.axesInfo, function (srcAxisInfo, srcKey) {
	        var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.
	
	        if (srcAxisInfo !== tarAxisInfo && srcValItem) {
	          var val = srcValItem.value;
	          linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, makeMapperParam(srcAxisInfo), makeMapperParam(tarAxisInfo))));
	          linkTriggers[tarAxisInfo.key] = val;
	        }
	      });
	    }
	  });
	  each(linkTriggers, function (val, tarKey) {
	    processOnAxis(axesInfo[tarKey], val, updaters, true, outputFinder);
	  });
	  updateModelActually(showValueMap, axesInfo, outputFinder);
	  dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
	  dispatchHighDownActually(axesInfo, dispatchAction, api);
	  return outputFinder;
	}
	
	function processOnAxis(axisInfo, newValue, updaters, dontSnap, outputFinder) {
	  var axis = axisInfo.axis;
	
	  if (axis.scale.isBlank() || !axis.containData(newValue)) {
	    return;
	  }
	
	  if (!axisInfo.involveSeries) {
	    updaters.showPointer(axisInfo, newValue);
	    return;
	  } // Heavy calculation. So put it after axis.containData checking.
	
	
	  var payloadInfo = buildPayloadsBySeries(newValue, axisInfo);
	  var payloadBatch = payloadInfo.payloadBatch;
	  var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
	  // By defualt use the first involved series data as a sample to connect.
	
	  if (payloadBatch[0] && outputFinder.seriesIndex == null) {
	    zrUtil.extend(outputFinder, payloadBatch[0]);
	  } // If no linkSource input, this process is for collecting link
	  // target, where snap should not be accepted.
	
	
	  if (!dontSnap && axisInfo.snap) {
	    if (axis.containData(snapToValue) && snapToValue != null) {
	      newValue = snapToValue;
	    }
	  }
	
	  updaters.showPointer(axisInfo, newValue, payloadBatch, outputFinder); // Tooltip should always be snapToValue, otherwise there will be
	  // incorrect "axis value ~ series value" mapping displayed in tooltip.
	
	  updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
	}
	
	function buildPayloadsBySeries(value, axisInfo) {
	  var axis = axisInfo.axis;
	  var dim = axis.dim;
	  var snapToValue = value;
	  var payloadBatch = [];
	  var minDist = Number.MAX_VALUE;
	  var minDiff = -1;
	  each(axisInfo.seriesModels, function (series, idx) {
	    var dataDim = series.coordDimToDataDim(dim);
	    var seriesNestestValue;
	    var dataIndices;
	
	    if (series.getAxisTooltipData) {
	      var result = series.getAxisTooltipData(dataDim, value, axis);
	      dataIndices = result.dataIndices;
	      seriesNestestValue = result.nestestValue;
	    } else {
	      dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
	      // when data length is not same.
	      false, axis.type === 'category' ? 0.5 : null);
	
	      if (!dataIndices.length) {
	        return;
	      }
	
	      seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
	    }
	
	    if (seriesNestestValue == null || !isFinite(seriesNestestValue)) {
	      return;
	    }
	
	    var diff = value - seriesNestestValue;
	    var dist = Math.abs(diff); // Consider category case
	
	    if (dist <= minDist) {
	      if (dist < minDist || diff >= 0 && minDiff < 0) {
	        minDist = dist;
	        minDiff = diff;
	        snapToValue = seriesNestestValue;
	        payloadBatch.length = 0;
	      }
	
	      each(dataIndices, function (dataIndex) {
	        payloadBatch.push({
	          seriesIndex: series.seriesIndex,
	          dataIndexInside: dataIndex,
	          dataIndex: series.getData().getRawIndex(dataIndex)
	        });
	      });
	    }
	  });
	  return {
	    payloadBatch: payloadBatch,
	    snapToValue: snapToValue
	  };
	}
	
	function showPointer(showValueMap, axisInfo, value, payloadBatch) {
	  showValueMap[axisInfo.key] = {
	    value: value,
	    payloadBatch: payloadBatch
	  };
	}
	
	function showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
	  var payloadBatch = payloadInfo.payloadBatch;
	  var axis = axisInfo.axis;
	  var axisModel = axis.model;
	  var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
	  // whose length will be used to judge whether dispatch action.
	
	  if (!axisInfo.triggerTooltip || !payloadBatch.length) {
	    return;
	  }
	
	  var coordSysModel = axisInfo.coordSys.model;
	  var coordSysKey = modelHelper.makeKey(coordSysModel);
	  var coordSysItem = dataByCoordSys.map[coordSysKey];
	
	  if (!coordSysItem) {
	    coordSysItem = dataByCoordSys.map[coordSysKey] = {
	      coordSysId: coordSysModel.id,
	      coordSysIndex: coordSysModel.componentIndex,
	      coordSysType: coordSysModel.type,
	      coordSysMainType: coordSysModel.mainType,
	      dataByAxis: []
	    };
	    dataByCoordSys.list.push(coordSysItem);
	  }
	
	  coordSysItem.dataByAxis.push({
	    axisDim: axis.dim,
	    axisIndex: axisModel.componentIndex,
	    axisType: axisModel.type,
	    axisId: axisModel.id,
	    value: value,
	    // Caustion: viewHelper.getValueLabel is actually on "view stage", which
	    // depends that all models have been updated. So it should not be performed
	    // here. Considering axisPointerModel used here is volatile, which is hard
	    // to be retrieve in TooltipView, we prepare parameters here.
	    valueLabelOpt: {
	      precision: axisPointerModel.get('label.precision'),
	      formatter: axisPointerModel.get('label.formatter')
	    },
	    seriesDataIndices: payloadBatch.slice()
	  });
	}
	
	function updateModelActually(showValueMap, axesInfo, outputFinder) {
	  var outputAxesInfo = outputFinder.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.
	
	  each(axesInfo, function (axisInfo, key) {
	    var option = axisInfo.axisPointerModel.option;
	    var valItem = showValueMap[key];
	
	    if (valItem) {
	      !axisInfo.useHandle && (option.status = 'show');
	      option.value = valItem.value; // For label formatter param and highlight.
	
	      option.seriesDataIndices = (valItem.payloadBatch || []).slice();
	    } // When always show (e.g., handle used), remain
	    // original value and status.
	    else {
	        // If hide, value still need to be set, consider
	        // click legend to toggle axis blank.
	        !axisInfo.useHandle && (option.status = 'hide');
	      } // If status is 'hide', should be no info in payload.
	
	
	    option.status === 'show' && outputAxesInfo.push({
	      axisDim: axisInfo.axis.dim,
	      axisIndex: axisInfo.axis.model.componentIndex,
	      value: option.value
	    });
	  });
	}
	
	function dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
	  // Basic logic: If no showTip required, hideTip will be dispatched.
	  if (illegalPoint(point) || !dataByCoordSys.list.length) {
	    dispatchAction({
	      type: 'hideTip'
	    });
	    return;
	  } // In most case only one axis (or event one series is used). It is
	  // convinient to fetch payload.seriesIndex and payload.dataIndex
	  // dirtectly. So put the first seriesIndex and dataIndex of the first
	  // axis on the payload.
	
	
	  var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
	  dispatchAction({
	    type: 'showTip',
	    escapeConnect: true,
	    x: point[0],
	    y: point[1],
	    tooltipOption: payload.tooltipOption,
	    position: payload.position,
	    dataIndexInside: sampleItem.dataIndexInside,
	    dataIndex: sampleItem.dataIndex,
	    seriesIndex: sampleItem.seriesIndex,
	    dataByCoordSys: dataByCoordSys.list
	  });
	}
	
	function dispatchHighDownActually(axesInfo, dispatchAction, api) {
	  // FIXME
	  // highlight status modification shoule be a stage of main process?
	  // (Consider confilct (e.g., legend and axisPointer) and setOption)
	  var zr = api.getZr();
	  var highDownKey = 'axisPointerLastHighlights';
	  var lastHighlights = get(zr)[highDownKey] || {};
	  var newHighlights = get(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
	  // Build hash map and remove duplicate incidentally.
	
	  each(axesInfo, function (axisInfo, key) {
	    var option = axisInfo.axisPointerModel.option;
	    option.status === 'show' && each(option.seriesDataIndices, function (batchItem) {
	      var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
	      newHighlights[key] = batchItem;
	    });
	  }); // Diff.
	
	  var toHighlight = [];
	  var toDownplay = [];
	  zrUtil.each(lastHighlights, function (batchItem, key) {
	    !newHighlights[key] && toDownplay.push(batchItem);
	  });
	  zrUtil.each(newHighlights, function (batchItem, key) {
	    !lastHighlights[key] && toHighlight.push(batchItem);
	  });
	  toDownplay.length && api.dispatchAction({
	    type: 'downplay',
	    escapeConnect: true,
	    batch: toDownplay
	  });
	  toHighlight.length && api.dispatchAction({
	    type: 'highlight',
	    escapeConnect: true,
	    batch: toHighlight
	  });
	}
	
	function findInputAxisInfo(inputAxesInfo, axisInfo) {
	  for (var i = 0; i < (inputAxesInfo || []).length; i++) {
	    var inputAxisInfo = inputAxesInfo[i];
	
	    if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) {
	      return inputAxisInfo;
	    }
	  }
	}
	
	function makeMapperParam(axisInfo) {
	  var axisModel = axisInfo.axis.model;
	  var item = {};
	  var dim = item.axisDim = axisInfo.axis.dim;
	  item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
	  item.axisName = item[dim + 'AxisName'] = axisModel.name;
	  item.axisId = item[dim + 'AxisId'] = axisModel.id;
	  return item;
	}
	
	function illegalPoint(point) {
	  return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
	}
	
	module.exports = _default;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var preprocessor = __webpack_require__(474);
	
	__webpack_require__(476);
	
	__webpack_require__(471);
	
	__webpack_require__(472);
	
	__webpack_require__(473);
	
	__webpack_require__(527);
	
	/**
	 * Brush component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var visualSolution = __webpack_require__(93);
	
	var Model = __webpack_require__(14);
	
	var DEFAULT_OUT_OF_BRUSH_COLOR = ['#ddd'];
	var BrushModel = echarts.extendComponentModel({
	  type: 'brush',
	  dependencies: ['geo', 'grid', 'xAxis', 'yAxis', 'parallel', 'series'],
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    // inBrush: null,
	    // outOfBrush: null,
	    toolbox: null,
	    // Default value see preprocessor.
	    brushLink: null,
	    // Series indices array, broadcast using dataIndex.
	    // or 'all', which means all series. 'none' or null means no series.
	    seriesIndex: 'all',
	    // seriesIndex array, specify series controlled by this brush component.
	    geoIndex: null,
	    //
	    xAxisIndex: null,
	    yAxisIndex: null,
	    brushType: 'rect',
	    // Default brushType, see BrushController.
	    brushMode: 'single',
	    // Default brushMode, 'single' or 'multiple'
	    transformable: true,
	    // Default transformable.
	    brushStyle: {
	      // Default brushStyle
	      borderWidth: 1,
	      color: 'rgba(120,140,180,0.3)',
	      borderColor: 'rgba(120,140,180,0.8)'
	    },
	    throttleType: 'fixRate',
	    // Throttle in brushSelected event. 'fixRate' or 'debounce'.
	    // If null, no throttle. Valid only in the first brush component
	    throttleDelay: 0,
	    // Unit: ms, 0 means every event will be triggered.
	    // FIXME
	    // 试验效果
	    removeOnClick: true,
	    z: 10000
	  },
	
	  /**
	   * @readOnly
	   * @type {Array.<Object>}
	   */
	  areas: [],
	
	  /**
	   * Current activated brush type.
	   * If null, brush is inactived.
	   * see module:echarts/component/helper/BrushController
	   * @readOnly
	   * @type {string}
	   */
	  brushType: null,
	
	  /**
	   * Current brush opt.
	   * see module:echarts/component/helper/BrushController
	   * @readOnly
	   * @type {Object}
	   */
	  brushOption: {},
	
	  /**
	   * @readOnly
	   * @type {Array.<Object>}
	   */
	  coordInfoList: [],
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option;
	    !isInit && visualSolution.replaceVisualOption(thisOption, newOption, ['inBrush', 'outOfBrush']);
	    thisOption.inBrush = thisOption.inBrush || {}; // Always give default visual, consider setOption at the second time.
	
	    thisOption.outOfBrush = thisOption.outOfBrush || {
	      color: DEFAULT_OUT_OF_BRUSH_COLOR
	    };
	  },
	
	  /**
	   * If ranges is null/undefined, range state remain.
	   *
	   * @param {Array.<Object>} [ranges]
	   */
	  setAreas: function (areas) {
	    // If ranges is null/undefined, range state remain.
	    // This helps user to dispatchAction({type: 'brush'}) with no areas
	    // set but just want to get the current brush select info from a `brush` event.
	    if (!areas) {
	      return;
	    }
	
	    this.areas = zrUtil.map(areas, function (area) {
	      return generateBrushOption(this.option, area);
	    }, this);
	  },
	
	  /**
	   * see module:echarts/component/helper/BrushController
	   * @param {Object} brushOption
	   */
	  setBrushOption: function (brushOption) {
	    this.brushOption = generateBrushOption(this.option, brushOption);
	    this.brushType = this.brushOption.brushType;
	  }
	});
	
	function generateBrushOption(option, brushOption) {
	  return zrUtil.merge({
	    brushType: option.brushType,
	    brushMode: option.brushMode,
	    transformable: option.transformable,
	    brushStyle: new Model(option.brushStyle).getItemStyle(),
	    removeOnClick: option.removeOnClick,
	    z: option.z
	  }, brushOption, true);
	}
	
	var _default = BrushModel;
	module.exports = _default;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var BrushController = __webpack_require__(120);
	
	var _default = echarts.extendComponentView({
	  type: 'brush',
	  init: function (ecModel, api) {
	    /**
	     * @readOnly
	     * @type {module:echarts/model/Global}
	     */
	    this.ecModel = ecModel;
	    /**
	     * @readOnly
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this.api = api;
	    /**
	     * @readOnly
	     * @type {module:echarts/component/brush/BrushModel}
	     */
	
	    this.model;
	    /**
	     * @private
	     * @type {module:echarts/component/helper/BrushController}
	     */
	
	    (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this)).mount();
	  },
	
	  /**
	   * @override
	   */
	  render: function (brushModel) {
	    this.model = brushModel;
	    return updateController.apply(this, arguments);
	  },
	
	  /**
	   * @override
	   */
	  updateView: updateController,
	
	  /**
	   * @override
	   */
	  updateLayout: updateController,
	
	  /**
	   * @override
	   */
	  updateVisual: updateController,
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._brushController.dispose();
	  },
	
	  /**
	   * @private
	   */
	  _onBrush: function (areas, opt) {
	    var modelId = this.model.id;
	    this.model.brushTargetManager.setOutputRanges(areas, this.ecModel); // Action is not dispatched on drag end, because the drag end
	    // emits the same params with the last drag move event, and
	    // may have some delay when using touch pad, which makes
	    // animation not smooth (when using debounce).
	
	    (!opt.isEnd || opt.removeOnClick) && this.api.dispatchAction({
	      type: 'brush',
	      brushId: modelId,
	      areas: zrUtil.clone(areas),
	      $from: modelId
	    });
	  }
	});
	
	function updateController(brushModel, ecModel, api, payload) {
	  // Do not update controller when drawing.
	  (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
	}
	
	module.exports = _default;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	/**
	 * payload: {
	 *      brushIndex: number, or,
	 *      brushId: string, or,
	 *      brushName: string,
	 *      globalRanges: Array
	 * }
	 */
	echarts.registerAction({
	  type: 'brush',
	  event: 'brush',
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'brush',
	    query: payload
	  }, function (brushModel) {
	    brushModel.setAreas(payload.areas);
	  });
	});
	/**
	 * payload: {
	 *      brushComponents: [
	 *          {
	 *              brushId,
	 *              brushIndex,
	 *              brushName,
	 *              series: [
	 *                  {
	 *                      seriesId,
	 *                      seriesIndex,
	 *                      seriesName,
	 *                      rawIndices: [21, 34, ...]
	 *                  },
	 *                  ...
	 *              ]
	 *          },
	 *          ...
	 *      ]
	 * }
	 */
	
	echarts.registerAction({
	  type: 'brushSelect',
	  event: 'brushSelected',
	  update: 'none'
	}, function () {});

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var DEFAULT_TOOLBOX_BTNS = ['rect', 'polygon', 'keep', 'clear'];
	
	function _default(option, isNew) {
	  var brushComponents = option && option.brush;
	
	  if (!zrUtil.isArray(brushComponents)) {
	    brushComponents = brushComponents ? [brushComponents] : [];
	  }
	
	  if (!brushComponents.length) {
	    return;
	  }
	
	  var brushComponentSpecifiedBtns = [];
	  zrUtil.each(brushComponents, function (brushOpt) {
	    var tbs = brushOpt.hasOwnProperty('toolbox') ? brushOpt.toolbox : [];
	
	    if (tbs instanceof Array) {
	      brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
	    }
	  });
	  var toolbox = option && option.toolbox;
	
	  if (zrUtil.isArray(toolbox)) {
	    toolbox = toolbox[0];
	  }
	
	  if (!toolbox) {
	    toolbox = {
	      feature: {}
	    };
	    option.toolbox = [toolbox];
	  }
	
	  var toolboxFeature = toolbox.feature || (toolbox.feature = {});
	  var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
	  var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
	  brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
	  removeDuplicate(brushTypes);
	
	  if (isNew && !brushTypes.length) {
	    brushTypes.push.apply(brushTypes, DEFAULT_TOOLBOX_BTNS);
	  }
	}
	
	function removeDuplicate(arr) {
	  var map = {};
	  zrUtil.each(arr, function (val) {
	    map[val] = 1;
	  });
	  arr.length = 0;
	  zrUtil.each(map, function (flag, val) {
	    arr.push(val);
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	var polygonContain = __webpack_require__(217);
	
	var BoundingRect = __webpack_require__(13);
	
	// Key of the first level is brushType: `line`, `rect`, `polygon`.
	// Key of the second level is chart element type: `point`, `rect`.
	// See moudule:echarts/component/helper/BrushController
	// function param:
	//      {Object} itemLayout fetch from data.getItemLayout(dataIndex)
	//      {Object} selectors {point: selector, rect: selector, ...}
	//      {Object} area {range: [[], [], ..], boudingRect}
	// function return:
	//      {boolean} Whether in the given brush.
	var selector = {
	  lineX: getLineSelectors(0),
	  lineY: getLineSelectors(1),
	  rect: {
	    point: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
	    },
	    rect: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.intersect(itemLayout);
	    }
	  },
	  polygon: {
	    point: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && polygonContain.contain(area.range, itemLayout[0], itemLayout[1]);
	    },
	    rect: function (itemLayout, selectors, area) {
	      var points = area.range;
	
	      if (!itemLayout || points.length <= 1) {
	        return false;
	      }
	
	      var x = itemLayout.x;
	      var y = itemLayout.y;
	      var width = itemLayout.width;
	      var height = itemLayout.height;
	      var p = points[0];
	
	      if (polygonContain.contain(points, x, y) || polygonContain.contain(points, x + width, y) || polygonContain.contain(points, x, y + height) || polygonContain.contain(points, x + width, y + height) || BoundingRect.create(itemLayout).contain(p[0], p[1]) || lineIntersectPolygon(x, y, x + width, y, points) || lineIntersectPolygon(x, y, x, y + height, points) || lineIntersectPolygon(x + width, y, x + width, y + height, points) || lineIntersectPolygon(x, y + height, x + width, y + height, points)) {
	        return true;
	      }
	    }
	  }
	};
	
	function getLineSelectors(xyIndex) {
	  var xy = ['x', 'y'];
	  var wh = ['width', 'height'];
	  return {
	    point: function (itemLayout, selectors, area) {
	      if (itemLayout) {
	        var range = area.range;
	        var p = itemLayout[xyIndex];
	        return inLineRange(p, range);
	      }
	    },
	    rect: function (itemLayout, selectors, area) {
	      if (itemLayout) {
	        var range = area.range;
	        var layoutRange = [itemLayout[xy[xyIndex]], itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]];
	        layoutRange[1] < layoutRange[0] && layoutRange.reverse();
	        return inLineRange(layoutRange[0], range) || inLineRange(layoutRange[1], range) || inLineRange(range[0], layoutRange) || inLineRange(range[1], layoutRange);
	      }
	    }
	  };
	}
	
	function inLineRange(p, range) {
	  return range[0] <= p && p <= range[1];
	}
	
	function lineIntersectPolygon(lx, ly, l2x, l2y, points) {
	  for (var i = 0, p2 = points[points.length - 1]; i < points.length; i++) {
	    var p = points[i];
	
	    if (lineIntersect(lx, ly, l2x, l2y, p[0], p[1], p2[0], p2[1])) {
	      return true;
	    }
	
	    p2 = p;
	  }
	} // Code from <http://blog.csdn.net/rickliuxiao/article/details/6259322> with some fix.
	// See <https://en.wikipedia.org/wiki/Line%E2%80%93line_intersection>
	
	
	function lineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
	  var delta = determinant(a2x - a1x, b1x - b2x, a2y - a1y, b1y - b2y);
	
	  if (nearZero(delta)) {
	    // parallel
	    return false;
	  }
	
	  var namenda = determinant(b1x - a1x, b1x - b2x, b1y - a1y, b1y - b2y) / delta;
	
	  if (namenda < 0 || namenda > 1) {
	    return false;
	  }
	
	  var miu = determinant(a2x - a1x, b1x - a1x, a2y - a1y, b1y - a1y) / delta;
	
	  if (miu < 0 || miu > 1) {
	    return false;
	  }
	
	  return true;
	}
	
	function nearZero(val) {
	  return val <= 1e-6 && val >= -1e-6;
	}
	
	function determinant(v1, v2, v3, v4) {
	  return v1 * v4 - v2 * v3;
	}
	
	var _default = selector;
	module.exports = _default;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var BoundingRect = __webpack_require__(13);
	
	var visualSolution = __webpack_require__(93);
	
	var selector = __webpack_require__(475);
	
	var throttleUtil = __webpack_require__(45);
	
	var BrushTargetManager = __webpack_require__(176);
	
	var STATE_LIST = ['inBrush', 'outOfBrush'];
	var DISPATCH_METHOD = '__ecBrushSelect';
	var DISPATCH_FLAG = '__ecInBrushSelectEvent';
	var PRIORITY_BRUSH = echarts.PRIORITY.VISUAL.BRUSH;
	/**
	 * Layout for visual, the priority higher than other layout, and before brush visual.
	 */
	
	echarts.registerLayout(PRIORITY_BRUSH, function (ecModel, api, payload) {
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel) {
	    payload && payload.type === 'takeGlobalCursor' && brushModel.setBrushOption(payload.key === 'brush' ? payload.brushOption : {
	      brushType: false
	    });
	    var brushTargetManager = brushModel.brushTargetManager = new BrushTargetManager(brushModel.option, ecModel);
	    brushTargetManager.setInputRanges(brushModel.areas, ecModel);
	  });
	});
	/**
	 * Register the visual encoding if this modules required.
	 */
	
	echarts.registerVisual(PRIORITY_BRUSH, function (ecModel, api, payload) {
	  var brushSelected = [];
	  var throttleType;
	  var throttleDelay;
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel, brushIndex) {
	    var thisBrushSelected = {
	      brushId: brushModel.id,
	      brushIndex: brushIndex,
	      brushName: brushModel.name,
	      areas: zrUtil.clone(brushModel.areas),
	      selected: []
	    }; // Every brush component exists in event params, convenient
	    // for user to find by index.
	
	    brushSelected.push(thisBrushSelected);
	    var brushOption = brushModel.option;
	    var brushLink = brushOption.brushLink;
	    var linkedSeriesMap = [];
	    var selectedDataIndexForLink = [];
	    var rangeInfoBySeries = [];
	    var hasBrushExists = 0;
	
	    if (!brushIndex) {
	      // Only the first throttle setting works.
	      throttleType = brushOption.throttleType;
	      throttleDelay = brushOption.throttleDelay;
	    } // Add boundingRect and selectors to range.
	
	
	    var areas = zrUtil.map(brushModel.areas, function (area) {
	      return bindSelector(zrUtil.defaults({
	        boundingRect: boundingRectBuilders[area.brushType](area)
	      }, area));
	    });
	    var visualMappings = visualSolution.createVisualMappings(brushModel.option, STATE_LIST, function (mappingOption) {
	      mappingOption.mappingMethod = 'fixed';
	    });
	    zrUtil.isArray(brushLink) && zrUtil.each(brushLink, function (seriesIndex) {
	      linkedSeriesMap[seriesIndex] = 1;
	    });
	
	    function linkOthers(seriesIndex) {
	      return brushLink === 'all' || linkedSeriesMap[seriesIndex];
	    } // If no supported brush or no brush on the series,
	    // all visuals should be in original state.
	
	
	    function brushed(rangeInfoList) {
	      return !!rangeInfoList.length;
	    }
	    /**
	     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
	     *
	     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
	     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
	     *                └!hasBrushExist┘                                              └nothing.
	     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
	     *                └!hasBrushExist┘                                              └nothing.
	     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
	     *   !brushed┘                                                                  └nothing.
	     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
	     */
	    // Step A
	
	
	    ecModel.eachSeries(function (seriesModel, seriesIndex) {
	      var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
	      seriesModel.subType === 'parallel' ? stepAParallel(seriesModel, seriesIndex, rangeInfoList) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
	    });
	
	    function stepAParallel(seriesModel, seriesIndex) {
	      var coordSys = seriesModel.coordinateSystem;
	      hasBrushExists |= coordSys.hasAxisBrushed();
	      linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function (activeState, dataIndex) {
	        activeState === 'active' && (selectedDataIndexForLink[dataIndex] = 1);
	      });
	    }
	
	    function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
	      var selectorsByBrushType = getSelectorsByBrushType(seriesModel);
	
	      if (!selectorsByBrushType || brushModelNotControll(brushModel, seriesIndex)) {
	        return;
	      }
	
	      zrUtil.each(areas, function (area) {
	        selectorsByBrushType[area.brushType] && brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel) && rangeInfoList.push(area);
	        hasBrushExists |= brushed(rangeInfoList);
	      });
	
	      if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
	        var data = seriesModel.getData();
	        data.each(function (dataIndex) {
	          if (checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex)) {
	            selectedDataIndexForLink[dataIndex] = 1;
	          }
	        });
	      }
	    } // Step B
	
	
	    ecModel.eachSeries(function (seriesModel, seriesIndex) {
	      var seriesBrushSelected = {
	        seriesId: seriesModel.id,
	        seriesIndex: seriesIndex,
	        seriesName: seriesModel.name,
	        dataIndex: []
	      }; // Every series exists in event params, convenient
	      // for user to find series by seriesIndex.
	
	      thisBrushSelected.selected.push(seriesBrushSelected);
	      var selectorsByBrushType = getSelectorsByBrushType(seriesModel);
	      var rangeInfoList = rangeInfoBySeries[seriesIndex];
	      var data = seriesModel.getData();
	      var getValueState = linkOthers(seriesIndex) ? function (dataIndex) {
	        return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
	      } : function (dataIndex) {
	        return checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
	      }; // If no supported brush or no brush, all visuals are in original state.
	
	      (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && visualSolution.applyVisual(STATE_LIST, visualMappings, data, getValueState);
	    });
	  });
	  dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
	});
	
	function dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
	  // This event will not be triggered when `setOpion`, otherwise dead lock may
	  // triggered when do `setOption` in event listener, which we do not find
	  // satisfactory way to solve yet. Some considered resolutions:
	  // (a) Diff with prevoius selected data ant only trigger event when changed.
	  // But store previous data and diff precisely (i.e., not only by dataIndex, but
	  // also detect value changes in selected data) might bring complexity or fragility.
	  // (b) Use spectial param like `silent` to suppress event triggering.
	  // But such kind of volatile param may be weird in `setOption`.
	  if (!payload) {
	    return;
	  }
	
	  var zr = api.getZr();
	
	  if (zr[DISPATCH_FLAG]) {
	    return;
	  }
	
	  if (!zr[DISPATCH_METHOD]) {
	    zr[DISPATCH_METHOD] = doDispatch;
	  }
	
	  var fn = throttleUtil.createOrUpdate(zr, DISPATCH_METHOD, throttleDelay, throttleType);
	  fn(api, brushSelected);
	}
	
	function doDispatch(api, brushSelected) {
	  if (!api.isDisposed()) {
	    var zr = api.getZr();
	    zr[DISPATCH_FLAG] = true;
	    api.dispatchAction({
	      type: 'brushSelect',
	      batch: brushSelected
	    });
	    zr[DISPATCH_FLAG] = false;
	  }
	}
	
	function checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) {
	  for (var i = 0, len = rangeInfoList.length; i < len; i++) {
	    var area = rangeInfoList[i];
	
	    if (selectorsByBrushType[area.brushType](dataIndex, data, area.selectors, area)) {
	      return true;
	    }
	  }
	}
	
	function getSelectorsByBrushType(seriesModel) {
	  var brushSelector = seriesModel.brushSelector;
	
	  if (zrUtil.isString(brushSelector)) {
	    var sels = [];
	    zrUtil.each(selector, function (selectorsByElementType, brushType) {
	      sels[brushType] = function (dataIndex, data, selectors, area) {
	        var itemLayout = data.getItemLayout(dataIndex);
	        return selectorsByElementType[brushSelector](itemLayout, selectors, area);
	      };
	    });
	    return sels;
	  } else if (zrUtil.isFunction(brushSelector)) {
	    var bSelector = {};
	    zrUtil.each(selector, function (sel, brushType) {
	      bSelector[brushType] = brushSelector;
	    });
	    return bSelector;
	  }
	
	  return brushSelector;
	}
	
	function brushModelNotControll(brushModel, seriesIndex) {
	  var seriesIndices = brushModel.option.seriesIndex;
	  return seriesIndices != null && seriesIndices !== 'all' && (zrUtil.isArray(seriesIndices) ? zrUtil.indexOf(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
	}
	
	function bindSelector(area) {
	  var selectors = area.selectors = {};
	  zrUtil.each(selector[area.brushType], function (selFn, elType) {
	    // Do not use function binding or curry for performance.
	    selectors[elType] = function (itemLayout) {
	      return selFn(itemLayout, selectors, area);
	    };
	  });
	  return area;
	}
	
	var boundingRectBuilders = {
	  lineX: zrUtil.noop,
	  lineY: zrUtil.noop,
	  rect: function (area) {
	    return getBoundingRectFromMinMax(area.range);
	  },
	  polygon: function (area) {
	    var minMax;
	    var range = area.range;
	
	    for (var i = 0, len = range.length; i < len; i++) {
	      minMax = minMax || [[Infinity, -Infinity], [Infinity, -Infinity]];
	      var rg = range[i];
	      rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
	      rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
	      rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
	      rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
	    }
	
	    return minMax && getBoundingRectFromMinMax(minMax);
	  }
	};
	
	function getBoundingRectFromMinMax(minMax) {
	  return new BoundingRect(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
	}

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(544);
	
	__webpack_require__(545);
	
	__webpack_require__(478);

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var formatUtil = __webpack_require__(9);
	
	var numberUtil = __webpack_require__(4);
	
	var MONTH_TEXT = {
	  EN: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  CN: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
	};
	var WEEK_TEXT = {
	  EN: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  CN: ['日', '一', '二', '三', '四', '五', '六']
	};
	
	var _default = echarts.extendComponentView({
	  type: 'calendar',
	
	  /**
	   * top/left line points
	   *  @private
	   */
	  _tlpoints: null,
	
	  /**
	   * bottom/right line points
	   *  @private
	   */
	  _blpoints: null,
	
	  /**
	   * first day of month
	   *  @private
	   */
	  _firstDayOfMonth: null,
	
	  /**
	   * first day point of month
	   *  @private
	   */
	  _firstDayPoints: null,
	  render: function (calendarModel, ecModel, api) {
	    var group = this.group;
	    group.removeAll();
	    var coordSys = calendarModel.coordinateSystem; // range info
	
	    var rangeData = coordSys.getRangeInfo();
	    var orient = coordSys.getOrient();
	
	    this._renderDayRect(calendarModel, rangeData, group); // _renderLines must be called prior to following function
	
	
	    this._renderLines(calendarModel, rangeData, orient, group);
	
	    this._renderYearText(calendarModel, rangeData, orient, group);
	
	    this._renderMonthText(calendarModel, orient, group);
	
	    this._renderWeekText(calendarModel, rangeData, orient, group);
	  },
	  // render day rect
	  _renderDayRect: function (calendarModel, rangeData, group) {
	    var coordSys = calendarModel.coordinateSystem;
	    var itemRectStyleModel = calendarModel.getModel('itemStyle.normal').getItemStyle();
	    var sw = coordSys.getCellWidth();
	    var sh = coordSys.getCellHeight();
	
	    for (var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time) {
	      var point = coordSys.dataToRect([i], false).tl; // every rect
	
	      var rect = new graphic.Rect({
	        shape: {
	          x: point[0],
	          y: point[1],
	          width: sw,
	          height: sh
	        },
	        cursor: 'default',
	        style: itemRectStyleModel
	      });
	      group.add(rect);
	    }
	  },
	  // render separate line
	  _renderLines: function (calendarModel, rangeData, orient, group) {
	    var self = this;
	    var coordSys = calendarModel.coordinateSystem;
	    var lineStyleModel = calendarModel.getModel('splitLine.lineStyle').getLineStyle();
	    var show = calendarModel.get('splitLine.show');
	    var lineWidth = lineStyleModel.lineWidth;
	    this._tlpoints = [];
	    this._blpoints = [];
	    this._firstDayOfMonth = [];
	    this._firstDayPoints = [];
	    var firstDay = rangeData.start;
	
	    for (var i = 0; firstDay.time <= rangeData.end.time; i++) {
	      addPoints(firstDay.formatedDate);
	
	      if (i === 0) {
	        firstDay = coordSys.getDateInfo(rangeData.start.y + '-' + rangeData.start.m);
	      }
	
	      var date = firstDay.date;
	      date.setMonth(date.getMonth() + 1);
	      firstDay = coordSys.getDateInfo(date);
	    }
	
	    addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);
	
	    function addPoints(date) {
	      self._firstDayOfMonth.push(coordSys.getDateInfo(date));
	
	      self._firstDayPoints.push(coordSys.dataToRect([date], false).tl);
	
	      var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);
	
	      self._tlpoints.push(points[0]);
	
	      self._blpoints.push(points[points.length - 1]);
	
	      show && self._drawSplitline(points, lineStyleModel, group);
	    } // render top/left line
	
	
	    show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group); // render bottom/right line
	
	    show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
	  },
	  // get points at both ends
	  _getEdgesPoints: function (points, lineWidth, orient) {
	    var rs = [points[0].slice(), points[points.length - 1].slice()];
	    var idx = orient === 'horizontal' ? 0 : 1; // both ends of the line are extend half lineWidth
	
	    rs[0][idx] = rs[0][idx] - lineWidth / 2;
	    rs[1][idx] = rs[1][idx] + lineWidth / 2;
	    return rs;
	  },
	  // render split line
	  _drawSplitline: function (points, lineStyleModel, group) {
	    var poyline = new graphic.Polyline({
	      z2: 20,
	      shape: {
	        points: points
	      },
	      style: lineStyleModel
	    });
	    group.add(poyline);
	  },
	  // render month line of one week points
	  _getLinePointsOfOneWeek: function (calendarModel, date, orient) {
	    var coordSys = calendarModel.coordinateSystem;
	    date = coordSys.getDateInfo(date);
	    var points = [];
	
	    for (var i = 0; i < 7; i++) {
	      var tmpD = coordSys.getNextNDay(date.time, i);
	      var point = coordSys.dataToRect([tmpD.time], false);
	      points[2 * tmpD.day] = point.tl;
	      points[2 * tmpD.day + 1] = point[orient === 'horizontal' ? 'bl' : 'tr'];
	    }
	
	    return points;
	  },
	  _formatterLabel: function (formatter, params) {
	    if (typeof formatter === 'string' && formatter) {
	      return formatUtil.formatTplSimple(formatter, params);
	    }
	
	    if (typeof formatter === 'function') {
	      return formatter(params);
	    }
	
	    return params.nameMap;
	  },
	  _yearTextPositionControl: function (textEl, point, orient, position, margin) {
	    point = point.slice();
	    var aligns = ['center', 'bottom'];
	
	    if (position === 'bottom') {
	      point[1] += margin;
	      aligns = ['center', 'top'];
	    } else if (position === 'left') {
	      point[0] -= margin;
	    } else if (position === 'right') {
	      point[0] += margin;
	      aligns = ['center', 'top'];
	    } else {
	      // top
	      point[1] -= margin;
	    }
	
	    var rotate = 0;
	
	    if (position === 'left' || position === 'right') {
	      rotate = Math.PI / 2;
	    }
	
	    return {
	      rotation: rotate,
	      position: point,
	      style: {
	        textAlign: aligns[0],
	        textVerticalAlign: aligns[1]
	      }
	    };
	  },
	  // render year
	  _renderYearText: function (calendarModel, rangeData, orient, group) {
	    var yearLabel = calendarModel.getModel('yearLabel');
	
	    if (!yearLabel.get('show')) {
	      return;
	    }
	
	    var margin = yearLabel.get('margin');
	    var pos = yearLabel.get('position');
	
	    if (!pos) {
	      pos = orient !== 'horizontal' ? 'top' : 'left';
	    }
	
	    var points = [this._tlpoints[this._tlpoints.length - 1], this._blpoints[0]];
	    var xc = (points[0][0] + points[1][0]) / 2;
	    var yc = (points[0][1] + points[1][1]) / 2;
	    var idx = orient === 'horizontal' ? 0 : 1;
	    var posPoints = {
	      top: [xc, points[idx][1]],
	      bottom: [xc, points[1 - idx][1]],
	      left: [points[1 - idx][0], yc],
	      right: [points[idx][0], yc]
	    };
	    var name = rangeData.start.y;
	
	    if (+rangeData.end.y > +rangeData.start.y) {
	      name = name + '-' + rangeData.end.y;
	    }
	
	    var formatter = yearLabel.get('formatter');
	    var params = {
	      start: rangeData.start.y,
	      end: rangeData.end.y,
	      nameMap: name
	    };
	
	    var content = this._formatterLabel(formatter, params);
	
	    var yearText = new graphic.Text({
	      z2: 30
	    });
	    graphic.setTextStyle(yearText.style, yearLabel, {
	      text: content
	    }), yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
	    group.add(yearText);
	  },
	  _monthTextPositionControl: function (point, isCenter, orient, position, margin) {
	    var align = 'left';
	    var vAlign = 'top';
	    var x = point[0];
	    var y = point[1];
	
	    if (orient === 'horizontal') {
	      y = y + margin;
	
	      if (isCenter) {
	        align = 'center';
	      }
	
	      if (position === 'start') {
	        vAlign = 'bottom';
	      }
	    } else {
	      x = x + margin;
	
	      if (isCenter) {
	        vAlign = 'middle';
	      }
	
	      if (position === 'start') {
	        align = 'right';
	      }
	    }
	
	    return {
	      x: x,
	      y: y,
	      textAlign: align,
	      textVerticalAlign: vAlign
	    };
	  },
	  // render month and year text
	  _renderMonthText: function (calendarModel, orient, group) {
	    var monthLabel = calendarModel.getModel('monthLabel');
	
	    if (!monthLabel.get('show')) {
	      return;
	    }
	
	    var nameMap = monthLabel.get('nameMap');
	    var margin = monthLabel.get('margin');
	    var pos = monthLabel.get('position');
	    var align = monthLabel.get('align');
	    var termPoints = [this._tlpoints, this._blpoints];
	
	    if (zrUtil.isString(nameMap)) {
	      nameMap = MONTH_TEXT[nameMap.toUpperCase()] || [];
	    }
	
	    var idx = pos === 'start' ? 0 : 1;
	    var axis = orient === 'horizontal' ? 0 : 1;
	    margin = pos === 'start' ? -margin : margin;
	    var isCenter = align === 'center';
	
	    for (var i = 0; i < termPoints[idx].length - 1; i++) {
	      var tmp = termPoints[idx][i].slice();
	      var firstDay = this._firstDayOfMonth[i];
	
	      if (isCenter) {
	        var firstDayPoints = this._firstDayPoints[i];
	        tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
	      }
	
	      var formatter = monthLabel.get('formatter');
	      var name = nameMap[+firstDay.m - 1];
	      var params = {
	        yyyy: firstDay.y,
	        yy: (firstDay.y + '').slice(2),
	        MM: firstDay.m,
	        M: +firstDay.m,
	        nameMap: name
	      };
	
	      var content = this._formatterLabel(formatter, params);
	
	      var monthText = new graphic.Text({
	        z2: 30
	      });
	      zrUtil.extend(graphic.setTextStyle(monthText.style, monthLabel, {
	        text: content
	      }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin));
	      group.add(monthText);
	    }
	  },
	  _weekTextPositionControl: function (point, orient, position, margin, cellSize) {
	    var align = 'center';
	    var vAlign = 'middle';
	    var x = point[0];
	    var y = point[1];
	    var isStart = position === 'start';
	
	    if (orient === 'horizontal') {
	      x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
	      align = isStart ? 'right' : 'left';
	    } else {
	      y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
	      vAlign = isStart ? 'bottom' : 'top';
	    }
	
	    return {
	      x: x,
	      y: y,
	      textAlign: align,
	      textVerticalAlign: vAlign
	    };
	  },
	  // render weeks
	  _renderWeekText: function (calendarModel, rangeData, orient, group) {
	    var dayLabel = calendarModel.getModel('dayLabel');
	
	    if (!dayLabel.get('show')) {
	      return;
	    }
	
	    var coordSys = calendarModel.coordinateSystem;
	    var pos = dayLabel.get('position');
	    var nameMap = dayLabel.get('nameMap');
	    var margin = dayLabel.get('margin');
	    var firstDayOfWeek = coordSys.getFirstDayOfWeek();
	
	    if (zrUtil.isString(nameMap)) {
	      nameMap = WEEK_TEXT[nameMap.toUpperCase()] || [];
	    }
	
	    var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
	    var cellSize = [coordSys.getCellWidth(), coordSys.getCellHeight()];
	    margin = numberUtil.parsePercent(margin, cellSize[orient === 'horizontal' ? 0 : 1]);
	
	    if (pos === 'start') {
	      start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
	      margin = -margin;
	    }
	
	    for (var i = 0; i < 7; i++) {
	      var tmpD = coordSys.getNextNDay(start, i);
	      var point = coordSys.dataToRect([tmpD.time], false).center;
	      var day = i;
	      day = Math.abs((i + firstDayOfWeek) % 7);
	      var weekText = new graphic.Text({
	        z2: 30
	      });
	      zrUtil.extend(graphic.setTextStyle(weekText.style, dayLabel, {
	        text: nameMap[day]
	      }), this._weekTextPositionControl(point, orient, pos, margin, cellSize));
	      group.add(weekText);
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(175);
	
	__webpack_require__(68);
	
	__webpack_require__(69);
	
	__webpack_require__(485);
	
	__webpack_require__(486);
	
	__webpack_require__(481);
	
	__webpack_require__(482);
	
	__webpack_require__(173);
	
	__webpack_require__(172);

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var numberUtil = __webpack_require__(4);
	
	var helper = __webpack_require__(119);
	
	var each = zrUtil.each;
	var asc = numberUtil.asc;
	/**
	 * Operate single axis.
	 * One axis can only operated by one axis operator.
	 * Different dataZoomModels may be defined to operate the same axis.
	 * (i.e. 'inside' data zoom and 'slider' data zoom components)
	 * So dataZoomModels share one axisProxy in that case.
	 *
	 * @class
	 */
	
	var AxisProxy = function (dimName, axisIndex, dataZoomModel, ecModel) {
	  /**
	   * @private
	   * @type {string}
	   */
	  this._dimName = dimName;
	  /**
	   * @private
	   */
	
	  this._axisIndex = axisIndex;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._valueWindow;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._percentWindow;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._dataExtent;
	  /**
	   * {minSpan, maxSpan, minValueSpan, maxValueSpan}
	   * @private
	   * @type {Object}
	   */
	
	  this._minMaxSpan;
	  /**
	   * @readOnly
	   * @type {module: echarts/model/Global}
	   */
	
	  this.ecModel = ecModel;
	  /**
	   * @private
	   * @type {module: echarts/component/dataZoom/DataZoomModel}
	   */
	
	  this._dataZoomModel = dataZoomModel;
	};
	
	AxisProxy.prototype = {
	  constructor: AxisProxy,
	
	  /**
	   * Whether the axisProxy is hosted by dataZoomModel.
	   *
	   * @public
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   * @return {boolean}
	   */
	  hostedBy: function (dataZoomModel) {
	    return this._dataZoomModel === dataZoomModel;
	  },
	
	  /**
	   * @return {Array.<number>} Value can only be NaN or finite value.
	   */
	  getDataValueWindow: function () {
	    return this._valueWindow.slice();
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getDataPercentWindow: function () {
	    return this._percentWindow.slice();
	  },
	
	  /**
	   * @public
	   * @param {number} axisIndex
	   * @return {Array} seriesModels
	   */
	  getTargetSeriesModels: function () {
	    var seriesModels = [];
	    var ecModel = this.ecModel;
	    ecModel.eachSeries(function (seriesModel) {
	      if (helper.isCoordSupported(seriesModel.get('coordinateSystem'))) {
	        var dimName = this._dimName;
	        var axisModel = ecModel.queryComponents({
	          mainType: dimName + 'Axis',
	          index: seriesModel.get(dimName + 'AxisIndex'),
	          id: seriesModel.get(dimName + 'AxisId')
	        })[0];
	
	        if (this._axisIndex === (axisModel && axisModel.componentIndex)) {
	          seriesModels.push(seriesModel);
	        }
	      }
	    }, this);
	    return seriesModels;
	  },
	  getAxisModel: function () {
	    return this.ecModel.getComponent(this._dimName + 'Axis', this._axisIndex);
	  },
	  getOtherAxisModel: function () {
	    var axisDim = this._dimName;
	    var ecModel = this.ecModel;
	    var axisModel = this.getAxisModel();
	    var isCartesian = axisDim === 'x' || axisDim === 'y';
	    var otherAxisDim;
	    var coordSysIndexName;
	
	    if (isCartesian) {
	      coordSysIndexName = 'gridIndex';
	      otherAxisDim = axisDim === 'x' ? 'y' : 'x';
	    } else {
	      coordSysIndexName = 'polarIndex';
	      otherAxisDim = axisDim === 'angle' ? 'radius' : 'angle';
	    }
	
	    var foundOtherAxisModel;
	    ecModel.eachComponent(otherAxisDim + 'Axis', function (otherAxisModel) {
	      if ((otherAxisModel.get(coordSysIndexName) || 0) === (axisModel.get(coordSysIndexName) || 0)) {
	        foundOtherAxisModel = otherAxisModel;
	      }
	    });
	    return foundOtherAxisModel;
	  },
	  getMinMaxSpan: function () {
	    return zrUtil.clone(this._minMaxSpan);
	  },
	
	  /**
	   * Only calculate by given range and this._dataExtent, do not change anything.
	   *
	   * @param {Object} opt
	   * @param {number} [opt.start]
	   * @param {number} [opt.end]
	   * @param {number} [opt.startValue]
	   * @param {number} [opt.endValue]
	   */
	  calculateDataWindow: function (opt) {
	    var dataExtent = this._dataExtent;
	    var axisModel = this.getAxisModel();
	    var scale = axisModel.axis.scale;
	
	    var rangePropMode = this._dataZoomModel.getRangePropMode();
	
	    var percentExtent = [0, 100];
	    var percentWindow = [opt.start, opt.end];
	    var valueWindow = [];
	    each(['startValue', 'endValue'], function (prop) {
	      valueWindow.push(opt[prop] != null ? scale.parse(opt[prop]) : null);
	    }); // Normalize bound.
	
	    each([0, 1], function (idx) {
	      var boundValue = valueWindow[idx];
	      var boundPercent = percentWindow[idx]; // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
	      // on `valueProp` ('startValue', 'endValue'). The former one is suitable
	      // for cases that a dataZoom component controls multiple axes with different
	      // unit or extent, and the latter one is suitable for accurate zoom by pixel
	      // (e.g., in dataZoomSelect). `valueProp` can be calculated from `percentProp`,
	      // but it is awkward that `percentProp` can not be obtained from `valueProp`
	      // accurately (because all of values that are overflow the `dataExtent` will
	      // be calculated to percent '100%'). So we have to use
	      // `dataZoom.getRangePropMode()` to mark which prop is used.
	      // `rangePropMode` is updated only when setOption or dispatchAction, otherwise
	      // it remains its original value.
	
	      if (rangePropMode[idx] === 'percent') {
	        if (boundPercent == null) {
	          boundPercent = percentExtent[idx];
	        } // Use scale.parse to math round for category or time axis.
	
	
	        boundValue = scale.parse(numberUtil.linearMap(boundPercent, percentExtent, dataExtent, true));
	      } else {
	        // Calculating `percent` from `value` may be not accurate, because
	        // This calculation can not be inversed, because all of values that
	        // are overflow the `dataExtent` will be calculated to percent '100%'
	        boundPercent = numberUtil.linearMap(boundValue, dataExtent, percentExtent, true);
	      } // valueWindow[idx] = round(boundValue);
	      // percentWindow[idx] = round(boundPercent);
	
	
	      valueWindow[idx] = boundValue;
	      percentWindow[idx] = boundPercent;
	    });
	    return {
	      valueWindow: asc(valueWindow),
	      percentWindow: asc(percentWindow)
	    };
	  },
	
	  /**
	   * Notice: reset should not be called before series.restoreData() called,
	   * so it is recommanded to be called in "process stage" but not "model init
	   * stage".
	   *
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  reset: function (dataZoomModel) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    } // Culculate data window and data extent, and record them.
	
	
	    this._dataExtent = calculateDataExtent(this, this._dimName, this.getTargetSeriesModels());
	    var dataWindow = this.calculateDataWindow(dataZoomModel.option);
	    this._valueWindow = dataWindow.valueWindow;
	    this._percentWindow = dataWindow.percentWindow;
	    setMinMaxSpan(this); // Update axis setting then.
	
	    setAxisModel(this);
	  },
	
	  /**
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  restore: function (dataZoomModel) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    this._valueWindow = this._percentWindow = null;
	    setAxisModel(this, true);
	  },
	
	  /**
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  filterData: function (dataZoomModel) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    var axisDim = this._dimName;
	    var seriesModels = this.getTargetSeriesModels();
	    var filterMode = dataZoomModel.get('filterMode');
	    var valueWindow = this._valueWindow;
	
	    if (filterMode === 'none') {
	      return;
	    } // FIXME
	    // Toolbox may has dataZoom injected. And if there are stacked bar chart
	    // with NaN data, NaN will be filtered and stack will be wrong.
	    // So we need to force the mode to be set empty.
	    // In fect, it is not a big deal that do not support filterMode-'filter'
	    // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
	    // selection" some day, which might need "adapt to data extent on the
	    // otherAxis", which is disabled by filterMode-'empty'.
	
	
	    var otherAxisModel = this.getOtherAxisModel();
	
	    if (dataZoomModel.get('$fromToolbox') && otherAxisModel && otherAxisModel.get('type') === 'category') {
	      filterMode = 'empty';
	    } // Process series data
	
	
	    each(seriesModels, function (seriesModel) {
	      var seriesData = seriesModel.getData();
	      var dataDims = seriesModel.coordDimToDataDim(axisDim);
	
	      if (filterMode === 'weakFilter') {
	        seriesData && seriesData.filterSelf(function (dataIndex) {
	          var leftOut;
	          var rightOut;
	          var hasValue;
	
	          for (var i = 0; i < dataDims.length; i++) {
	            var value = seriesData.get(dataDims[i], dataIndex);
	            var thisHasValue = !isNaN(value);
	            var thisLeftOut = value < valueWindow[0];
	            var thisRightOut = value > valueWindow[1];
	
	            if (thisHasValue && !thisLeftOut && !thisRightOut) {
	              return true;
	            }
	
	            thisHasValue && (hasValue = true);
	            thisLeftOut && (leftOut = true);
	            thisRightOut && (rightOut = true);
	          } // If both left out and right out, do not filter.
	
	
	          return hasValue && leftOut && rightOut;
	        });
	      } else {
	        seriesData && each(dataDims, function (dim) {
	          if (filterMode === 'empty') {
	            seriesModel.setData(seriesData.map(dim, function (value) {
	              return !isInWindow(value) ? NaN : value;
	            }));
	          } else {
	            seriesData.filterSelf(dim, isInWindow);
	          }
	        });
	      }
	    });
	
	    function isInWindow(value) {
	      return value >= valueWindow[0] && value <= valueWindow[1];
	    }
	  }
	};
	
	function calculateDataExtent(axisProxy, axisDim, seriesModels) {
	  var dataExtent = [Infinity, -Infinity];
	  each(seriesModels, function (seriesModel) {
	    var seriesData = seriesModel.getData();
	
	    if (seriesData) {
	      each(seriesModel.coordDimToDataDim(axisDim), function (dim) {
	        var seriesExtent = seriesData.getDataExtent(dim);
	        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
	        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
	      });
	    }
	  });
	
	  if (dataExtent[1] < dataExtent[0]) {
	    dataExtent = [NaN, NaN];
	  } // It is important to get "consistent" extent when more then one axes is
	  // controlled by a `dataZoom`, otherwise those axes will not be synchronized
	  // when zooming. But it is difficult to know what is "consistent", considering
	  // axes have different type or even different meanings (For example, two
	  // time axes are used to compare data of the same date in different years).
	  // So basically dataZoom just obtains extent by series.data (in category axis
	  // extent can be obtained from axis.data).
	  // Nevertheless, user can set min/max/scale on axes to make extent of axes
	  // consistent.
	
	
	  fixExtentByAxis(axisProxy, dataExtent);
	  return dataExtent;
	}
	
	function fixExtentByAxis(axisProxy, dataExtent) {
	  var axisModel = axisProxy.getAxisModel();
	  var min = axisModel.getMin(true); // For category axis, if min/max/scale are not set, extent is determined
	  // by axis.data by default.
	
	  var isCategoryAxis = axisModel.get('type') === 'category';
	  var axisDataLen = isCategoryAxis && (axisModel.get('data') || []).length;
	
	  if (min != null && min !== 'dataMin' && typeof min !== 'function') {
	    dataExtent[0] = min;
	  } else if (isCategoryAxis) {
	    dataExtent[0] = axisDataLen > 0 ? 0 : NaN;
	  }
	
	  var max = axisModel.getMax(true);
	
	  if (max != null && max !== 'dataMax' && typeof max !== 'function') {
	    dataExtent[1] = max;
	  } else if (isCategoryAxis) {
	    dataExtent[1] = axisDataLen > 0 ? axisDataLen - 1 : NaN;
	  }
	
	  if (!axisModel.get('scale', true)) {
	    dataExtent[0] > 0 && (dataExtent[0] = 0);
	    dataExtent[1] < 0 && (dataExtent[1] = 0);
	  } // For value axis, if min/max/scale are not set, we just use the extent obtained
	  // by series data, which may be a little different from the extent calculated by
	  // `axisHelper.getScaleExtent`. But the different just affects the experience a
	  // little when zooming. So it will not be fixed until some users require it strongly.
	
	
	  return dataExtent;
	}
	
	function setAxisModel(axisProxy, isRestore) {
	  var axisModel = axisProxy.getAxisModel();
	  var percentWindow = axisProxy._percentWindow;
	  var valueWindow = axisProxy._valueWindow;
	
	  if (!percentWindow) {
	    return;
	  } // [0, 500]: arbitrary value, guess axis extent.
	
	
	  var precision = numberUtil.getPixelPrecision(valueWindow, [0, 500]);
	  precision = Math.min(precision, 20); // isRestore or isFull
	
	  var useOrigin = isRestore || percentWindow[0] === 0 && percentWindow[1] === 100;
	  axisModel.setRange(useOrigin ? null : +valueWindow[0].toFixed(precision), useOrigin ? null : +valueWindow[1].toFixed(precision));
	}
	
	function setMinMaxSpan(axisProxy) {
	  var minMaxSpan = axisProxy._minMaxSpan = {};
	  var dataZoomModel = axisProxy._dataZoomModel;
	  each(['min', 'max'], function (minMax) {
	    minMaxSpan[minMax + 'Span'] = dataZoomModel.get(minMax + 'Span'); // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan
	
	    var valueSpan = dataZoomModel.get(minMax + 'ValueSpan');
	
	    if (valueSpan != null) {
	      minMaxSpan[minMax + 'ValueSpan'] = valueSpan;
	      valueSpan = axisProxy.getAxisModel().axis.scale.parse(valueSpan);
	
	      if (valueSpan != null) {
	        var dataExtent = axisProxy._dataExtent;
	        minMaxSpan[minMax + 'Span'] = numberUtil.linearMap(dataExtent[0] + valueSpan, dataExtent, [0, 100], true);
	      }
	    }
	  });
	}
	
	var _default = AxisProxy;
	module.exports = _default;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	var DataZoomModel = __webpack_require__(68);
	
	var _default = DataZoomModel.extend({
	  type: 'dataZoom.inside',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    disabled: false,
	    // Whether disable this inside zoom.
	    zoomLock: false,
	    // Whether disable zoom but only pan.
	    zoomOnMouseWheel: true,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    moveOnMouseMove: true,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    preventDefaultMouseMove: true
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var DataZoomView = __webpack_require__(69);
	
	var sliderMove = __webpack_require__(71);
	
	var roams = __webpack_require__(487);
	
	var bind = zrUtil.bind;
	var InsideZoomView = DataZoomView.extend({
	  type: 'dataZoom.inside',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    /**
	     * 'throttle' is used in this.dispatchAction, so we save range
	     * to avoid missing some 'pan' info.
	     * @private
	     * @type {Array.<number>}
	     */
	    this._range;
	  },
	
	  /**
	   * @override
	   */
	  render: function (dataZoomModel, ecModel, api, payload) {
	    InsideZoomView.superApply(this, 'render', arguments); // Notice: origin this._range should be maintained, and should not be re-fetched
	    // from dataZoomModel when payload.type is 'dataZoom', otherwise 'pan' or 'zoom'
	    // info will be missed because of 'throttle' of this.dispatchAction.
	
	    if (roams.shouldRecordRange(payload, dataZoomModel.id)) {
	      this._range = dataZoomModel.getPercentRange();
	    } // Reset controllers.
	
	
	    zrUtil.each(this.getTargetCoordInfo(), function (coordInfoList, coordSysName) {
	      var allCoordIds = zrUtil.map(coordInfoList, function (coordInfo) {
	        return roams.generateCoordId(coordInfo.model);
	      });
	      zrUtil.each(coordInfoList, function (coordInfo) {
	        var coordModel = coordInfo.model;
	        var dataZoomOption = dataZoomModel.option;
	        roams.register(api, {
	          coordId: roams.generateCoordId(coordModel),
	          allCoordIds: allCoordIds,
	          containsPoint: function (e, x, y) {
	            return coordModel.coordinateSystem.containPoint([x, y]);
	          },
	          dataZoomId: dataZoomModel.id,
	          throttleRate: dataZoomModel.get('throttle', true),
	          panGetRange: bind(this._onPan, this, coordInfo, coordSysName),
	          zoomGetRange: bind(this._onZoom, this, coordInfo, coordSysName),
	          zoomLock: dataZoomOption.zoomLock,
	          disabled: dataZoomOption.disabled,
	          roamControllerOpt: {
	            zoomOnMouseWheel: dataZoomOption.zoomOnMouseWheel,
	            moveOnMouseMove: dataZoomOption.moveOnMouseMove,
	            preventDefaultMouseMove: dataZoomOption.preventDefaultMouseMove
	          }
	        });
	      }, this);
	    }, this);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    roams.unregister(this.api, this.dataZoomModel.id);
	    InsideZoomView.superApply(this, 'dispose', arguments);
	    this._range = null;
	  },
	
	  /**
	   * @private
	   */
	  _onPan: function (coordInfo, coordSysName, controller, dx, dy, oldX, oldY, newX, newY) {
	    var range = this._range.slice(); // Calculate transform by the first axis.
	
	
	    var axisModel = coordInfo.axisModels[0];
	
	    if (!axisModel) {
	      return;
	    }
	
	    var directionInfo = getDirectionInfo[coordSysName]([oldX, oldY], [newX, newY], axisModel, controller, coordInfo);
	    var percentDelta = directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
	    sliderMove(percentDelta, range, [0, 100], 'all');
	    return this._range = range;
	  },
	
	  /**
	   * @private
	   */
	  _onZoom: function (coordInfo, coordSysName, controller, scale, mouseX, mouseY) {
	    var range = this._range.slice(); // Calculate transform by the first axis.
	
	
	    var axisModel = coordInfo.axisModels[0];
	
	    if (!axisModel) {
	      return;
	    }
	
	    var directionInfo = getDirectionInfo[coordSysName](null, [mouseX, mouseY], axisModel, controller, coordInfo);
	    var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
	    scale = Math.max(1 / scale, 0);
	    range[0] = (range[0] - percentPoint) * scale + percentPoint;
	    range[1] = (range[1] - percentPoint) * scale + percentPoint; // Restrict range.
	
	    var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
	    sliderMove(0, range, [0, 100], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
	    return this._range = range;
	  }
	});
	var getDirectionInfo = {
	  grid: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var ret = {};
	    var rect = coordInfo.model.coordinateSystem.getRect();
	    oldPoint = oldPoint || [0, 0];
	
	    if (axis.dim === 'x') {
	      ret.pixel = newPoint[0] - oldPoint[0];
	      ret.pixelLength = rect.width;
	      ret.pixelStart = rect.x;
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // axis.dim === 'y'
	      ret.pixel = newPoint[1] - oldPoint[1];
	      ret.pixelLength = rect.height;
	      ret.pixelStart = rect.y;
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  },
	  polar: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var ret = {};
	    var polar = coordInfo.model.coordinateSystem;
	    var radiusExtent = polar.getRadiusAxis().getExtent();
	    var angleExtent = polar.getAngleAxis().getExtent();
	    oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [0, 0];
	    newPoint = polar.pointToCoord(newPoint);
	
	    if (axisModel.mainType === 'radiusAxis') {
	      ret.pixel = newPoint[0] - oldPoint[0]; // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
	      // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);
	
	      ret.pixelLength = radiusExtent[1] - radiusExtent[0];
	      ret.pixelStart = radiusExtent[0];
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // 'angleAxis'
	      ret.pixel = newPoint[1] - oldPoint[1]; // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
	      // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);
	
	      ret.pixelLength = angleExtent[1] - angleExtent[0];
	      ret.pixelStart = angleExtent[0];
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  },
	  singleAxis: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var rect = coordInfo.model.coordinateSystem.getRect();
	    var ret = {};
	    oldPoint = oldPoint || [0, 0];
	
	    if (axis.orient === 'horizontal') {
	      ret.pixel = newPoint[0] - oldPoint[0];
	      ret.pixelLength = rect.width;
	      ret.pixelStart = rect.x;
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // 'vertical'
	      ret.pixel = newPoint[1] - oldPoint[1];
	      ret.pixelLength = rect.height;
	      ret.pixelStart = rect.y;
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  }
	};
	var _default = InsideZoomView;
	module.exports = _default;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	var DataZoomModel = __webpack_require__(68);
	
	var _default = DataZoomModel.extend({
	  type: 'dataZoom.select'
	});
	
	module.exports = _default;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	var DataZoomView = __webpack_require__(69);
	
	var _default = DataZoomView.extend({
	  type: 'dataZoom.select'
	});
	
	module.exports = _default;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	var DataZoomModel = __webpack_require__(68);
	
	var SliderZoomModel = DataZoomModel.extend({
	  type: 'dataZoom.slider',
	  layoutMode: 'box',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    show: true,
	    // ph => placeholder. Using placehoder here because
	    // deault value can only be drived in view stage.
	    right: 'ph',
	    // Default align to grid rect.
	    top: 'ph',
	    // Default align to grid rect.
	    width: 'ph',
	    // Default align to grid rect.
	    height: 'ph',
	    // Default align to grid rect.
	    left: null,
	    // Default align to grid rect.
	    bottom: null,
	    // Default align to grid rect.
	    backgroundColor: 'rgba(47,69,84,0)',
	    // Background of slider zoom component.
	    // dataBackgroundColor: '#ddd',         // Background coor of data shadow and border of box,
	    // highest priority, remain for compatibility of
	    // previous version, but not recommended any more.
	    dataBackground: {
	      lineStyle: {
	        color: '#2f4554',
	        width: 0.5,
	        opacity: 0.3
	      },
	      areaStyle: {
	        color: 'rgba(47,69,84,0.3)',
	        opacity: 0.3
	      }
	    },
	    borderColor: '#ddd',
	    // border color of the box. For compatibility,
	    // if dataBackgroundColor is set, borderColor
	    // is ignored.
	    fillerColor: 'rgba(167,183,204,0.4)',
	    // Color of selected area.
	    // handleColor: 'rgba(89,170,216,0.95)',     // Color of handle.
	    // handleIcon: 'path://M4.9,17.8c0-1.4,4.5-10.5,5.5-12.4c0-0.1,0.6-1.1,0.9-1.1c0.4,0,0.9,1,0.9,1.1c1.1,2.2,5.4,11,5.4,12.4v17.8c0,1.5-0.6,2.1-1.3,2.1H6.1c-0.7,0-1.3-0.6-1.3-2.1V17.8z',
	    handleIcon: 'M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z M9.7,24.4H4.8v-1.4h4.9V24.4z M9.7,19.1H4.8v-1.4h4.9V19.1z',
	    // Percent of the slider height
	    handleSize: '100%',
	    handleStyle: {
	      color: '#a7b7cc'
	    },
	    labelPrecision: null,
	    labelFormatter: null,
	    showDetail: true,
	    showDataShadow: 'auto',
	    // Default auto decision.
	    realtime: true,
	    zoomLock: false,
	    // Whether disable zoom.
	    textStyle: {
	      color: '#333'
	    }
	  }
	});
	var _default = SliderZoomModel;
	module.exports = _default;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var eventTool = __webpack_require__(30);
	
	var graphic = __webpack_require__(3);
	
	var throttle = __webpack_require__(45);
	
	var DataZoomView = __webpack_require__(69);
	
	var numberUtil = __webpack_require__(4);
	
	var layout = __webpack_require__(7);
	
	var sliderMove = __webpack_require__(71);
	
	var Rect = graphic.Rect;
	var linearMap = numberUtil.linearMap;
	var asc = numberUtil.asc;
	var bind = zrUtil.bind;
	var each = zrUtil.each; // Constants
	
	var DEFAULT_LOCATION_EDGE_GAP = 7;
	var DEFAULT_FRAME_BORDER_WIDTH = 1;
	var DEFAULT_FILLER_SIZE = 30;
	var HORIZONTAL = 'horizontal';
	var VERTICAL = 'vertical';
	var LABEL_GAP = 5;
	var SHOW_DATA_SHADOW_SERIES_TYPE = ['line', 'bar', 'candlestick', 'scatter'];
	var SliderZoomView = DataZoomView.extend({
	  type: 'dataZoom.slider',
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {Object}
	     */
	    this._displayables = {};
	    /**
	     * @private
	     * @type {string}
	     */
	
	    this._orient;
	    /**
	     * [0, 100]
	     * @private
	     */
	
	    this._range;
	    /**
	     * [coord of the first handle, coord of the second handle]
	     * @private
	     */
	
	    this._handleEnds;
	    /**
	     * [length, thick]
	     * @private
	     * @type {Array.<number>}
	     */
	
	    this._size;
	    /**
	     * @private
	     * @type {number}
	     */
	
	    this._handleWidth;
	    /**
	     * @private
	     * @type {number}
	     */
	
	    this._handleHeight;
	    /**
	     * @private
	     */
	
	    this._location;
	    /**
	     * @private
	     */
	
	    this._dragging;
	    /**
	     * @private
	     */
	
	    this._dataShadowInfo;
	    this.api = api;
	  },
	
	  /**
	   * @override
	   */
	  render: function (dataZoomModel, ecModel, api, payload) {
	    SliderZoomView.superApply(this, 'render', arguments);
	    throttle.createOrUpdate(this, '_dispatchZoomAction', this.dataZoomModel.get('throttle'), 'fixRate');
	    this._orient = dataZoomModel.get('orient');
	
	    if (this.dataZoomModel.get('show') === false) {
	      this.group.removeAll();
	      return;
	    } // Notice: this._resetInterval() should not be executed when payload.type
	    // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
	    // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,
	
	
	    if (!payload || payload.type !== 'dataZoom' || payload.from !== this.uid) {
	      this._buildView();
	    }
	
	    this._updateView();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    SliderZoomView.superApply(this, 'remove', arguments);
	    throttle.clear(this, '_dispatchZoomAction');
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    SliderZoomView.superApply(this, 'dispose', arguments);
	    throttle.clear(this, '_dispatchZoomAction');
	  },
	  _buildView: function () {
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	
	    this._resetLocation();
	
	    this._resetInterval();
	
	    var barGroup = this._displayables.barGroup = new graphic.Group();
	
	    this._renderBackground();
	
	    this._renderHandle();
	
	    this._renderDataShadow();
	
	    thisGroup.add(barGroup);
	
	    this._positionGroup();
	  },
	
	  /**
	   * @private
	   */
	  _resetLocation: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var api = this.api; // If some of x/y/width/height are not specified,
	    // auto-adapt according to target grid.
	
	    var coordRect = this._findCoordRect();
	
	    var ecSize = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    }; // Default align by coordinate system rect.
	
	    var positionInfo = this._orient === HORIZONTAL ? {
	      // Why using 'right', because right should be used in vertical,
	      // and it is better to be consistent for dealing with position param merge.
	      right: ecSize.width - coordRect.x - coordRect.width,
	      top: ecSize.height - DEFAULT_FILLER_SIZE - DEFAULT_LOCATION_EDGE_GAP,
	      width: coordRect.width,
	      height: DEFAULT_FILLER_SIZE
	    } : {
	      // vertical
	      right: DEFAULT_LOCATION_EDGE_GAP,
	      top: coordRect.y,
	      width: DEFAULT_FILLER_SIZE,
	      height: coordRect.height
	    }; // Do not write back to option and replace value 'ph', because
	    // the 'ph' value should be recalculated when resize.
	
	    var layoutParams = layout.getLayoutParams(dataZoomModel.option); // Replace the placeholder value.
	
	    zrUtil.each(['right', 'top', 'width', 'height'], function (name) {
	      if (layoutParams[name] === 'ph') {
	        layoutParams[name] = positionInfo[name];
	      }
	    });
	    var layoutRect = layout.getLayoutRect(layoutParams, ecSize, dataZoomModel.padding);
	    this._location = {
	      x: layoutRect.x,
	      y: layoutRect.y
	    };
	    this._size = [layoutRect.width, layoutRect.height];
	    this._orient === VERTICAL && this._size.reverse();
	  },
	
	  /**
	   * @private
	   */
	  _positionGroup: function () {
	    var thisGroup = this.group;
	    var location = this._location;
	    var orient = this._orient; // Just use the first axis to determine mapping.
	
	    var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
	    var inverse = targetAxisModel && targetAxisModel.get('inverse');
	    var barGroup = this._displayables.barGroup;
	    var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse; // Transform barGroup.
	
	    barGroup.attr(orient === HORIZONTAL && !inverse ? {
	      scale: otherAxisInverse ? [1, 1] : [1, -1]
	    } : orient === HORIZONTAL && inverse ? {
	      scale: otherAxisInverse ? [-1, 1] : [-1, -1]
	    } : orient === VERTICAL && !inverse ? {
	      scale: otherAxisInverse ? [1, -1] : [1, 1],
	      rotation: Math.PI / 2 // Dont use Math.PI, considering shadow direction.
	
	    } : {
	      scale: otherAxisInverse ? [-1, -1] : [-1, 1],
	      rotation: Math.PI / 2
	    }); // Position barGroup
	
	    var rect = thisGroup.getBoundingRect([barGroup]);
	    thisGroup.attr('position', [location.x - rect.x, location.y - rect.y]);
	  },
	
	  /**
	   * @private
	   */
	  _getViewExtent: function () {
	    return [0, this._size[0]];
	  },
	  _renderBackground: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var size = this._size;
	    var barGroup = this._displayables.barGroup;
	    barGroup.add(new Rect({
	      silent: true,
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        fill: dataZoomModel.get('backgroundColor')
	      },
	      z2: -40
	    })); // Click panel, over shadow, below handles.
	
	    barGroup.add(new Rect({
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        fill: 'transparent'
	      },
	      z2: 0,
	      onclick: zrUtil.bind(this._onClickPanelClick, this)
	    }));
	  },
	  _renderDataShadow: function () {
	    var info = this._dataShadowInfo = this._prepareDataShadowInfo();
	
	    if (!info) {
	      return;
	    }
	
	    var size = this._size;
	    var seriesModel = info.series;
	    var data = seriesModel.getRawData();
	    var otherDim = seriesModel.getShadowDim ? seriesModel.getShadowDim() // @see candlestick
	    : info.otherDim;
	
	    if (otherDim == null) {
	      return;
	    }
	
	    var otherDataExtent = data.getDataExtent(otherDim); // Nice extent.
	
	    var otherOffset = (otherDataExtent[1] - otherDataExtent[0]) * 0.3;
	    otherDataExtent = [otherDataExtent[0] - otherOffset, otherDataExtent[1] + otherOffset];
	    var otherShadowExtent = [0, size[1]];
	    var thisShadowExtent = [0, size[0]];
	    var areaPoints = [[size[0], 0], [0, 0]];
	    var linePoints = [];
	    var step = thisShadowExtent[1] / (data.count() - 1);
	    var thisCoord = 0; // Optimize for large data shadow
	
	    var stride = Math.round(data.count() / size[0]);
	    var lastIsEmpty;
	    data.each([otherDim], function (value, index) {
	      if (stride > 0 && index % stride) {
	        thisCoord += step;
	        return;
	      } // FIXME
	      // Should consider axis.min/axis.max when drawing dataShadow.
	      // FIXME
	      // 应该使用统一的空判断？还是在list里进行空判断？
	
	
	      var isEmpty = value == null || isNaN(value) || value === ''; // See #4235.
	
	      var otherCoord = isEmpty ? 0 : linearMap(value, otherDataExtent, otherShadowExtent, true); // Attempt to draw data shadow precisely when there are empty value.
	
	      if (isEmpty && !lastIsEmpty && index) {
	        areaPoints.push([areaPoints[areaPoints.length - 1][0], 0]);
	        linePoints.push([linePoints[linePoints.length - 1][0], 0]);
	      } else if (!isEmpty && lastIsEmpty) {
	        areaPoints.push([thisCoord, 0]);
	        linePoints.push([thisCoord, 0]);
	      }
	
	      areaPoints.push([thisCoord, otherCoord]);
	      linePoints.push([thisCoord, otherCoord]);
	      thisCoord += step;
	      lastIsEmpty = isEmpty;
	    });
	    var dataZoomModel = this.dataZoomModel; // var dataBackgroundModel = dataZoomModel.getModel('dataBackground');
	
	    this._displayables.barGroup.add(new graphic.Polygon({
	      shape: {
	        points: areaPoints
	      },
	      style: zrUtil.defaults({
	        fill: dataZoomModel.get('dataBackgroundColor')
	      }, dataZoomModel.getModel('dataBackground.areaStyle').getAreaStyle()),
	      silent: true,
	      z2: -20
	    }));
	
	    this._displayables.barGroup.add(new graphic.Polyline({
	      shape: {
	        points: linePoints
	      },
	      style: dataZoomModel.getModel('dataBackground.lineStyle').getLineStyle(),
	      silent: true,
	      z2: -19
	    }));
	  },
	  _prepareDataShadowInfo: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var showDataShadow = dataZoomModel.get('showDataShadow');
	
	    if (showDataShadow === false) {
	      return;
	    } // Find a representative series.
	
	
	    var result;
	    var ecModel = this.ecModel;
	    dataZoomModel.eachTargetAxis(function (dimNames, axisIndex) {
	      var seriesModels = dataZoomModel.getAxisProxy(dimNames.name, axisIndex).getTargetSeriesModels();
	      zrUtil.each(seriesModels, function (seriesModel) {
	        if (result) {
	          return;
	        }
	
	        if (showDataShadow !== true && zrUtil.indexOf(SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get('type')) < 0) {
	          return;
	        }
	
	        var thisAxis = ecModel.getComponent(dimNames.axis, axisIndex).axis;
	        var otherDim = getOtherDim(dimNames.name);
	        var otherAxisInverse;
	        var coordSys = seriesModel.coordinateSystem;
	
	        if (otherDim != null && coordSys.getOtherAxis) {
	          otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
	        }
	
	        result = {
	          thisAxis: thisAxis,
	          series: seriesModel,
	          thisDim: dimNames.name,
	          otherDim: otherDim,
	          otherAxisInverse: otherAxisInverse
	        };
	      }, this);
	    }, this);
	    return result;
	  },
	  _renderHandle: function () {
	    var displaybles = this._displayables;
	    var handles = displaybles.handles = [];
	    var handleLabels = displaybles.handleLabels = [];
	    var barGroup = this._displayables.barGroup;
	    var size = this._size;
	    var dataZoomModel = this.dataZoomModel;
	    barGroup.add(displaybles.filler = new Rect({
	      draggable: true,
	      cursor: getCursor(this._orient),
	      drift: bind(this._onDragMove, this, 'all'),
	      onmousemove: function (e) {
	        // Fot mobile devicem, prevent screen slider on the button.
	        eventTool.stop(e.event);
	      },
	      ondragstart: bind(this._showDataInfo, this, true),
	      ondragend: bind(this._onDragEnd, this),
	      onmouseover: bind(this._showDataInfo, this, true),
	      onmouseout: bind(this._showDataInfo, this, false),
	      style: {
	        fill: dataZoomModel.get('fillerColor'),
	        textPosition: 'inside'
	      }
	    })); // Frame border.
	
	    barGroup.add(new Rect(graphic.subPixelOptimizeRect({
	      silent: true,
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        stroke: dataZoomModel.get('dataBackgroundColor') || dataZoomModel.get('borderColor'),
	        lineWidth: DEFAULT_FRAME_BORDER_WIDTH,
	        fill: 'rgba(0,0,0,0)'
	      }
	    })));
	    each([0, 1], function (handleIndex) {
	      var path = graphic.createIcon(dataZoomModel.get('handleIcon'), {
	        cursor: getCursor(this._orient),
	        draggable: true,
	        drift: bind(this._onDragMove, this, handleIndex),
	        onmousemove: function (e) {
	          // Fot mobile devicem, prevent screen slider on the button.
	          eventTool.stop(e.event);
	        },
	        ondragend: bind(this._onDragEnd, this),
	        onmouseover: bind(this._showDataInfo, this, true),
	        onmouseout: bind(this._showDataInfo, this, false)
	      }, {
	        x: -1,
	        y: 0,
	        width: 2,
	        height: 2
	      });
	      var bRect = path.getBoundingRect();
	      this._handleHeight = numberUtil.parsePercent(dataZoomModel.get('handleSize'), this._size[1]);
	      this._handleWidth = bRect.width / bRect.height * this._handleHeight;
	      path.setStyle(dataZoomModel.getModel('handleStyle').getItemStyle());
	      var handleColor = dataZoomModel.get('handleColor'); // Compatitable with previous version
	
	      if (handleColor != null) {
	        path.style.fill = handleColor;
	      }
	
	      barGroup.add(handles[handleIndex] = path);
	      var textStyleModel = dataZoomModel.textStyleModel;
	      this.group.add(handleLabels[handleIndex] = new graphic.Text({
	        silent: true,
	        invisible: true,
	        style: {
	          x: 0,
	          y: 0,
	          text: '',
	          textVerticalAlign: 'middle',
	          textAlign: 'center',
	          textFill: textStyleModel.getTextColor(),
	          textFont: textStyleModel.getFont()
	        },
	        z2: 10
	      }));
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _resetInterval: function () {
	    var range = this._range = this.dataZoomModel.getPercentRange();
	
	    var viewExtent = this._getViewExtent();
	
	    this._handleEnds = [linearMap(range[0], [0, 100], viewExtent, true), linearMap(range[1], [0, 100], viewExtent, true)];
	  },
	
	  /**
	   * @private
	   * @param {(number|string)} handleIndex 0 or 1 or 'all'
	   * @param {number} delta
	   */
	  _updateInterval: function (handleIndex, delta) {
	    var dataZoomModel = this.dataZoomModel;
	    var handleEnds = this._handleEnds;
	
	    var viewExtend = this._getViewExtent();
	
	    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
	    var percentExtent = [0, 100];
	    sliderMove(delta, handleEnds, viewExtend, dataZoomModel.get('zoomLock') ? 'all' : handleIndex, minMaxSpan.minSpan != null ? linearMap(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? linearMap(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
	    this._range = asc([linearMap(handleEnds[0], viewExtend, percentExtent, true), linearMap(handleEnds[1], viewExtend, percentExtent, true)]);
	  },
	
	  /**
	   * @private
	   */
	  _updateView: function (nonRealtime) {
	    var displaybles = this._displayables;
	    var handleEnds = this._handleEnds;
	    var handleInterval = asc(handleEnds.slice());
	    var size = this._size;
	    each([0, 1], function (handleIndex) {
	      // Handles
	      var handle = displaybles.handles[handleIndex];
	      var handleHeight = this._handleHeight;
	      handle.attr({
	        scale: [handleHeight / 2, handleHeight / 2],
	        position: [handleEnds[handleIndex], size[1] / 2 - handleHeight / 2]
	      });
	    }, this); // Filler
	
	    displaybles.filler.setShape({
	      x: handleInterval[0],
	      y: 0,
	      width: handleInterval[1] - handleInterval[0],
	      height: size[1]
	    });
	
	    this._updateDataInfo(nonRealtime);
	  },
	
	  /**
	   * @private
	   */
	  _updateDataInfo: function (nonRealtime) {
	    var dataZoomModel = this.dataZoomModel;
	    var displaybles = this._displayables;
	    var handleLabels = displaybles.handleLabels;
	    var orient = this._orient;
	    var labelTexts = ['', '']; // FIXME
	    // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）
	
	    if (dataZoomModel.get('showDetail')) {
	      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
	
	      if (axisProxy) {
	        var axis = axisProxy.getAxisModel().axis;
	        var range = this._range;
	        var dataInterval = nonRealtime // See #4434, data and axis are not processed and reset yet in non-realtime mode.
	        ? axisProxy.calculateDataWindow({
	          start: range[0],
	          end: range[1]
	        }).valueWindow : axisProxy.getDataValueWindow();
	        labelTexts = [this._formatLabel(dataInterval[0], axis), this._formatLabel(dataInterval[1], axis)];
	      }
	    }
	
	    var orderedHandleEnds = asc(this._handleEnds.slice());
	    setLabel.call(this, 0);
	    setLabel.call(this, 1);
	
	    function setLabel(handleIndex) {
	      // Label
	      // Text should not transform by barGroup.
	      // Ignore handlers transform
	      var barTransform = graphic.getTransform(displaybles.handles[handleIndex].parent, this.group);
	      var direction = graphic.transformDirection(handleIndex === 0 ? 'right' : 'left', barTransform);
	      var offset = this._handleWidth / 2 + LABEL_GAP;
	      var textPoint = graphic.applyTransform([orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset), this._size[1] / 2], barTransform);
	      handleLabels[handleIndex].setStyle({
	        x: textPoint[0],
	        y: textPoint[1],
	        textVerticalAlign: orient === HORIZONTAL ? 'middle' : direction,
	        textAlign: orient === HORIZONTAL ? direction : 'center',
	        text: labelTexts[handleIndex]
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _formatLabel: function (value, axis) {
	    var dataZoomModel = this.dataZoomModel;
	    var labelFormatter = dataZoomModel.get('labelFormatter');
	    var labelPrecision = dataZoomModel.get('labelPrecision');
	
	    if (labelPrecision == null || labelPrecision === 'auto') {
	      labelPrecision = axis.getPixelPrecision();
	    }
	
	    var valueStr = value == null || isNaN(value) ? '' // FIXME Glue code
	    : axis.type === 'category' || axis.type === 'time' ? axis.scale.getLabel(Math.round(value)) // param of toFixed should less then 20.
	    : value.toFixed(Math.min(labelPrecision, 20));
	    return zrUtil.isFunction(labelFormatter) ? labelFormatter(value, valueStr) : zrUtil.isString(labelFormatter) ? labelFormatter.replace('{value}', valueStr) : valueStr;
	  },
	
	  /**
	   * @private
	   * @param {boolean} showOrHide true: show, false: hide
	   */
	  _showDataInfo: function (showOrHide) {
	    // Always show when drgging.
	    showOrHide = this._dragging || showOrHide;
	    var handleLabels = this._displayables.handleLabels;
	    handleLabels[0].attr('invisible', !showOrHide);
	    handleLabels[1].attr('invisible', !showOrHide);
	  },
	  _onDragMove: function (handleIndex, dx, dy) {
	    this._dragging = true; // Transform dx, dy to bar coordination.
	
	    var barTransform = this._displayables.barGroup.getLocalTransform();
	
	    var vertex = graphic.applyTransform([dx, dy], barTransform, true);
	
	    this._updateInterval(handleIndex, vertex[0]);
	
	    var realtime = this.dataZoomModel.get('realtime');
	
	    this._updateView(!realtime);
	
	    if (realtime) {
	      realtime && this._dispatchZoomAction();
	    }
	  },
	  _onDragEnd: function () {
	    this._dragging = false;
	
	    this._showDataInfo(false);
	
	    this._dispatchZoomAction();
	  },
	  _onClickPanelClick: function (e) {
	    var size = this._size;
	
	    var localPoint = this._displayables.barGroup.transformCoordToLocal(e.offsetX, e.offsetY);
	
	    if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) {
	      return;
	    }
	
	    var handleEnds = this._handleEnds;
	    var center = (handleEnds[0] + handleEnds[1]) / 2;
	
	    this._updateInterval('all', localPoint[0] - center);
	
	    this._updateView();
	
	    this._dispatchZoomAction();
	  },
	
	  /**
	   * This action will be throttled.
	   * @private
	   */
	  _dispatchZoomAction: function () {
	    var range = this._range;
	    this.api.dispatchAction({
	      type: 'dataZoom',
	      from: this.uid,
	      dataZoomId: this.dataZoomModel.id,
	      start: range[0],
	      end: range[1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _findCoordRect: function () {
	    // Find the grid coresponding to the first axis referred by dataZoom.
	    var rect;
	    each(this.getTargetCoordInfo(), function (coordInfoList) {
	      if (!rect && coordInfoList.length) {
	        var coordSys = coordInfoList[0].model.coordinateSystem;
	        rect = coordSys.getRect && coordSys.getRect();
	      }
	    });
	
	    if (!rect) {
	      var width = this.api.getWidth();
	      var height = this.api.getHeight();
	      rect = {
	        x: width * 0.2,
	        y: height * 0.2,
	        width: width * 0.6,
	        height: height * 0.6
	      };
	    }
	
	    return rect;
	  }
	});
	
	function getOtherDim(thisDim) {
	  // FIXME
	  // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
	  var map = {
	    x: 'y',
	    y: 'x',
	    radius: 'angle',
	    angle: 'radius'
	  };
	  return map[thisDim];
	}
	
	function getCursor(orient) {
	  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
	}
	
	var _default = SliderZoomView;
	module.exports = _default;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var RoamController = __webpack_require__(87);
	
	var throttleUtil = __webpack_require__(45);
	
	// Only create one roam controller for each coordinate system.
	// one roam controller might be refered by two inside data zoom
	// components (for example, one for x and one for y). When user
	// pan or zoom, only dispatch one action for those data zoom
	// components.
	var curry = zrUtil.curry;
	var ATTR = '\0_ec_dataZoom_roams';
	/**
	 * @public
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Object} dataZoomInfo
	 * @param {string} dataZoomInfo.coordId
	 * @param {Function} dataZoomInfo.containsPoint
	 * @param {Array.<string>} dataZoomInfo.allCoordIds
	 * @param {string} dataZoomInfo.dataZoomId
	 * @param {number} dataZoomInfo.throttleRate
	 * @param {Function} dataZoomInfo.panGetRange
	 * @param {Function} dataZoomInfo.zoomGetRange
	 * @param {boolean} [dataZoomInfo.zoomLock]
	 * @param {boolean} [dataZoomInfo.disabled]
	 */
	
	function register(api, dataZoomInfo) {
	  var store = giveStore(api);
	  var theDataZoomId = dataZoomInfo.dataZoomId;
	  var theCoordId = dataZoomInfo.coordId; // Do clean when a dataZoom changes its target coordnate system.
	  // Avoid memory leak, dispose all not-used-registered.
	
	  zrUtil.each(store, function (record, coordId) {
	    var dataZoomInfos = record.dataZoomInfos;
	
	    if (dataZoomInfos[theDataZoomId] && zrUtil.indexOf(dataZoomInfo.allCoordIds, theCoordId) < 0) {
	      delete dataZoomInfos[theDataZoomId];
	      record.count--;
	    }
	  });
	  cleanStore(store);
	  var record = store[theCoordId]; // Create if needed.
	
	  if (!record) {
	    record = store[theCoordId] = {
	      coordId: theCoordId,
	      dataZoomInfos: {},
	      count: 0
	    };
	    record.controller = createController(api, record);
	    record.dispatchAction = zrUtil.curry(dispatchAction, api);
	  } // Update reference of dataZoom.
	
	
	  !record.dataZoomInfos[theDataZoomId] && record.count++;
	  record.dataZoomInfos[theDataZoomId] = dataZoomInfo;
	  var controllerParams = mergeControllerParams(record.dataZoomInfos);
	  record.controller.enable(controllerParams.controlType, controllerParams.opt); // Consider resize, area should be always updated.
	
	  record.controller.setPointerChecker(dataZoomInfo.containsPoint); // Update throttle.
	
	  throttleUtil.createOrUpdate(record, 'dispatchAction', dataZoomInfo.throttleRate, 'fixRate');
	}
	/**
	 * @public
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {string} dataZoomId
	 */
	
	
	function unregister(api, dataZoomId) {
	  var store = giveStore(api);
	  zrUtil.each(store, function (record) {
	    record.controller.dispose();
	    var dataZoomInfos = record.dataZoomInfos;
	
	    if (dataZoomInfos[dataZoomId]) {
	      delete dataZoomInfos[dataZoomId];
	      record.count--;
	    }
	  });
	  cleanStore(store);
	}
	/**
	 * @public
	 */
	
	
	function shouldRecordRange(payload, dataZoomId) {
	  if (payload && payload.type === 'dataZoom' && payload.batch) {
	    for (var i = 0, len = payload.batch.length; i < len; i++) {
	      if (payload.batch[i].dataZoomId === dataZoomId) {
	        return false;
	      }
	    }
	  }
	
	  return true;
	}
	/**
	 * @public
	 */
	
	
	function generateCoordId(coordModel) {
	  return coordModel.type + '\0_' + coordModel.id;
	}
	/**
	 * Key: coordId, value: {dataZoomInfos: [], count, controller}
	 * @type {Array.<Object>}
	 */
	
	
	function giveStore(api) {
	  // Mount store on zrender instance, so that we do not
	  // need to worry about dispose.
	  var zr = api.getZr();
	  return zr[ATTR] || (zr[ATTR] = {});
	}
	
	function createController(api, newRecord) {
	  var controller = new RoamController(api.getZr());
	  controller.on('pan', curry(onPan, newRecord));
	  controller.on('zoom', curry(onZoom, newRecord));
	  return controller;
	}
	
	function cleanStore(store) {
	  zrUtil.each(store, function (record, coordId) {
	    if (!record.count) {
	      record.controller.dispose();
	      delete store[coordId];
	    }
	  });
	}
	
	function onPan(record, dx, dy, oldX, oldY, newX, newY) {
	  wrapAndDispatch(record, function (info) {
	    return info.panGetRange(record.controller, dx, dy, oldX, oldY, newX, newY);
	  });
	}
	
	function onZoom(record, scale, mouseX, mouseY) {
	  wrapAndDispatch(record, function (info) {
	    return info.zoomGetRange(record.controller, scale, mouseX, mouseY);
	  });
	}
	
	function wrapAndDispatch(record, getRange) {
	  var batch = [];
	  zrUtil.each(record.dataZoomInfos, function (info) {
	    var range = getRange(info);
	    !info.disabled && range && batch.push({
	      dataZoomId: info.dataZoomId,
	      start: range[0],
	      end: range[1]
	    });
	  });
	  record.dispatchAction(batch);
	}
	/**
	 * This action will be throttled.
	 */
	
	
	function dispatchAction(api, batch) {
	  api.dispatchAction({
	    type: 'dataZoom',
	    batch: batch
	  });
	}
	/**
	 * Merge roamController settings when multiple dataZooms share one roamController.
	 */
	
	
	function mergeControllerParams(dataZoomInfos) {
	  var controlType;
	  var opt = {};
	  var typePriority = {
	    'true': 2,
	    'move': 1,
	    'false': 0,
	    'undefined': -1
	  };
	  zrUtil.each(dataZoomInfos, function (dataZoomInfo) {
	    var oneType = dataZoomInfo.disabled ? false : dataZoomInfo.zoomLock ? 'move' : true;
	    typePriority[oneType] > typePriority[controlType] && (controlType = oneType); // Do not support that different 'shift'/'ctrl'/'alt' setting used in one coord sys.
	
	    zrUtil.extend(opt, dataZoomInfo.roamControllerOpt);
	  });
	  return {
	    controlType: controlType,
	    opt: opt
	  };
	}
	
	exports.register = register;
	exports.unregister = unregister;
	exports.shouldRecordRange = shouldRecordRange;
	exports.generateCoordId = generateCoordId;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(175);
	
	__webpack_require__(68);
	
	__webpack_require__(69);
	
	__webpack_require__(483);
	
	__webpack_require__(484);
	
	__webpack_require__(173);
	
	__webpack_require__(172);

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	__webpack_require__(553);
	
	__webpack_require__(89);
	
	__webpack_require__(490);
	
	__webpack_require__(154);
	
	function makeAction(method, actionInfo) {
	  actionInfo.update = 'updateView';
	  echarts.registerAction(actionInfo, function (payload, ecModel) {
	    var selected = {};
	    ecModel.eachComponent({
	      mainType: 'geo',
	      query: payload
	    }, function (geoModel) {
	      geoModel[method](payload.name);
	      var geo = geoModel.coordinateSystem;
	      zrUtil.each(geo.regions, function (region) {
	        selected[region.name] = geoModel.isSelected(region.name) || false;
	      });
	    });
	    return {
	      selected: selected,
	      name: payload.name
	    };
	  });
	}
	
	makeAction('toggleSelected', {
	  type: 'geoToggleSelect',
	  event: 'geoselectchanged'
	});
	makeAction('select', {
	  type: 'geoSelect',
	  event: 'geoselected'
	});
	makeAction('unSelect', {
	  type: 'geoUnSelect',
	  event: 'geounselected'
	});

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	var MapDraw = __webpack_require__(177);
	
	var echarts = __webpack_require__(2);
	
	var _default = echarts.extendComponentView({
	  type: 'geo',
	  init: function (ecModel, api) {
	    var mapDraw = new MapDraw(api, true);
	    this._mapDraw = mapDraw;
	    this.group.add(mapDraw.group);
	  },
	  render: function (geoModel, ecModel, api, payload) {
	    // Not render if it is an toggleSelect action from self
	    if (payload && payload.type === 'geoToggleSelect' && payload.from === this.uid) {
	      return;
	    }
	
	    var mapDraw = this._mapDraw;
	
	    if (geoModel.get('show')) {
	      mapDraw.draw(geoModel, ecModel, api, this, payload);
	    } else {
	      this._mapDraw.group.removeAll();
	    }
	
	    this.group.silent = geoModel.get('silent');
	  },
	  dispose: function () {
	    this._mapDraw && this._mapDraw.remove();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var modelUtil = __webpack_require__(6);
	
	var graphicUtil = __webpack_require__(3);
	
	var layoutUtil = __webpack_require__(7);
	
	// -------------
	// Preprocessor
	// -------------
	echarts.registerPreprocessor(function (option) {
	  var graphicOption = option.graphic; // Convert
	  // {graphic: [{left: 10, type: 'circle'}, ...]}
	  // or
	  // {graphic: {left: 10, type: 'circle'}}
	  // to
	  // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}
	
	  if (zrUtil.isArray(graphicOption)) {
	    if (!graphicOption[0] || !graphicOption[0].elements) {
	      option.graphic = [{
	        elements: graphicOption
	      }];
	    } else {
	      // Only one graphic instance can be instantiated. (We dont
	      // want that too many views are created in echarts._viewMap)
	      option.graphic = [option.graphic[0]];
	    }
	  } else if (graphicOption && !graphicOption.elements) {
	    option.graphic = [{
	      elements: [graphicOption]
	    }];
	  }
	}); // ------
	// Model
	// ------
	
	var GraphicModel = echarts.extendComponentModel({
	  type: 'graphic',
	  defaultOption: {
	    // Extra properties for each elements:
	    //
	    // left/right/top/bottom: (like 12, '22%', 'center', default undefined)
	    //      If left/rigth is set, shape.x/shape.cx/position will not be used.
	    //      If top/bottom is set, shape.y/shape.cy/position will not be used.
	    //      This mechanism is useful when you want to position a group/element
	    //      against the right side or the center of this container.
	    //
	    // width/height: (can only be pixel value, default 0)
	    //      Only be used to specify contianer(group) size, if needed. And
	    //      can not be percentage value (like '33%'). See the reason in the
	    //      layout algorithm below.
	    //
	    // bounding: (enum: 'all' (default) | 'raw')
	    //      Specify how to calculate boundingRect when locating.
	    //      'all': Get uioned and transformed boundingRect
	    //          from both itself and its descendants.
	    //          This mode simplies confining a group of elements in the bounding
	    //          of their ancester container (e.g., using 'right: 0').
	    //      'raw': Only use the boundingRect of itself and before transformed.
	    //          This mode is similar to css behavior, which is useful when you
	    //          want an element to be able to overflow its container. (Consider
	    //          a rotated circle needs to be located in a corner.)
	    // Note: elements is always behind its ancestors in this elements array.
	    elements: [],
	    parentId: null
	  },
	
	  /**
	   * Save el options for the sake of the performance (only update modified graphics).
	   * The order is the same as those in option. (ancesters -> descendants)
	   *
	   * @private
	   * @type {Array.<Object>}
	   */
	  _elOptionsToUpdate: null,
	
	  /**
	   * @override
	   */
	  mergeOption: function (option) {
	    // Prevent default merge to elements
	    var elements = this.option.elements;
	    this.option.elements = null;
	    GraphicModel.superApply(this, 'mergeOption', arguments);
	    this.option.elements = elements;
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option;
	    var newList = (isInit ? thisOption : newOption).elements;
	    var existList = thisOption.elements = isInit ? [] : thisOption.elements;
	    var flattenedList = [];
	
	    this._flatten(newList, flattenedList);
	
	    var mappingResult = modelUtil.mappingToExists(existList, flattenedList);
	    modelUtil.makeIdAndName(mappingResult); // Clear elOptionsToUpdate
	
	    var elOptionsToUpdate = this._elOptionsToUpdate = [];
	    zrUtil.each(mappingResult, function (resultItem, index) {
	      var newElOption = resultItem.option;
	
	      if (!newElOption) {
	        return;
	      }
	
	      elOptionsToUpdate.push(newElOption);
	      setKeyInfoToNewElOption(resultItem, newElOption);
	      mergeNewElOptionToExist(existList, index, newElOption);
	      setLayoutInfoToExist(existList[index], newElOption);
	    }, this); // Clean
	
	    for (var i = existList.length - 1; i >= 0; i--) {
	      if (existList[i] == null) {
	        existList.splice(i, 1);
	      } else {
	        // $action should be volatile, otherwise option gotten from
	        // `getOption` will contain unexpected $action.
	        delete existList[i].$action;
	      }
	    }
	  },
	
	  /**
	   * Convert
	   * [{
	   *  type: 'group',
	   *  id: 'xx',
	   *  children: [{type: 'circle'}, {type: 'polygon'}]
	   * }]
	   * to
	   * [
	   *  {type: 'group', id: 'xx'},
	   *  {type: 'circle', parentId: 'xx'},
	   *  {type: 'polygon', parentId: 'xx'}
	   * ]
	   *
	   * @private
	   * @param {Array.<Object>} optionList option list
	   * @param {Array.<Object>} result result of flatten
	   * @param {Object} parentOption parent option
	   */
	  _flatten: function (optionList, result, parentOption) {
	    zrUtil.each(optionList, function (option) {
	      if (!option) {
	        return;
	      }
	
	      if (parentOption) {
	        option.parentOption = parentOption;
	      }
	
	      result.push(option);
	      var children = option.children;
	
	      if (option.type === 'group' && children) {
	        this._flatten(children, result, option);
	      } // Deleting for JSON output, and for not affecting group creation.
	
	
	      delete option.children;
	    }, this);
	  },
	  // FIXME
	  // Pass to view using payload? setOption has a payload?
	  useElOptionsToUpdate: function () {
	    var els = this._elOptionsToUpdate; // Clear to avoid render duplicately when zooming.
	
	    this._elOptionsToUpdate = null;
	    return els;
	  }
	}); // -----
	// View
	// -----
	
	echarts.extendComponentView({
	  type: 'graphic',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {module:zrender/core/util.HashMap}
	     */
	    this._elMap = zrUtil.createHashMap();
	    /**
	     * @private
	     * @type {module:echarts/graphic/GraphicModel}
	     */
	
	    this._lastGraphicModel;
	  },
	
	  /**
	   * @override
	   */
	  render: function (graphicModel, ecModel, api) {
	    // Having leveraged between use cases and algorithm complexity, a very
	    // simple layout mechanism is used:
	    // The size(width/height) can be determined by itself or its parent (not
	    // implemented yet), but can not by its children. (Top-down travel)
	    // The location(x/y) can be determined by the bounding rect of itself
	    // (can including its descendants or not) and the size of its parent.
	    // (Bottom-up travel)
	    // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
	    // view will be reused.
	    if (graphicModel !== this._lastGraphicModel) {
	      this._clear();
	    }
	
	    this._lastGraphicModel = graphicModel;
	
	    this._updateElements(graphicModel, api);
	
	    this._relocate(graphicModel, api);
	  },
	
	  /**
	   * Update graphic elements.
	   *
	   * @private
	   * @param {Object} graphicModel graphic model
	   * @param {module:echarts/ExtensionAPI} api extension API
	   */
	  _updateElements: function (graphicModel, api) {
	    var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();
	
	    if (!elOptionsToUpdate) {
	      return;
	    }
	
	    var elMap = this._elMap;
	    var rootGroup = this.group; // Top-down tranverse to assign graphic settings to each elements.
	
	    zrUtil.each(elOptionsToUpdate, function (elOption) {
	      var $action = elOption.$action;
	      var id = elOption.id;
	      var existEl = elMap.get(id);
	      var parentId = elOption.parentId;
	      var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
	
	      if (elOption.type === 'text') {
	        var elOptionStyle = elOption.style; // In top/bottom mode, textVerticalAlign should not be used, which cause
	        // inaccurately locating.
	
	        if (elOption.hv && elOption.hv[1]) {
	          elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = null;
	        } // Compatible with previous setting: both support fill and textFill,
	        // stroke and textStroke.
	
	
	        !elOptionStyle.hasOwnProperty('textFill') && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
	        !elOptionStyle.hasOwnProperty('textStroke') && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
	      } // Remove unnecessary props to avoid potential problems.
	
	
	      var elOptionCleaned = getCleanedElOption(elOption); // For simple, do not support parent change, otherwise reorder is needed.
	
	      if (!$action || $action === 'merge') {
	        existEl ? existEl.attr(elOptionCleaned) : createEl(id, targetElParent, elOptionCleaned, elMap);
	      } else if ($action === 'replace') {
	        removeEl(existEl, elMap);
	        createEl(id, targetElParent, elOptionCleaned, elMap);
	      } else if ($action === 'remove') {
	        removeEl(existEl, elMap);
	      }
	
	      var el = elMap.get(id);
	
	      if (el) {
	        el.__ecGraphicWidth = elOption.width;
	        el.__ecGraphicHeight = elOption.height;
	      }
	    });
	  },
	
	  /**
	   * Locate graphic elements.
	   *
	   * @private
	   * @param {Object} graphicModel graphic model
	   * @param {module:echarts/ExtensionAPI} api extension API
	   */
	  _relocate: function (graphicModel, api) {
	    var elOptions = graphicModel.option.elements;
	    var rootGroup = this.group;
	    var elMap = this._elMap; // Bottom-up tranvese all elements (consider ec resize) to locate elements.
	
	    for (var i = elOptions.length - 1; i >= 0; i--) {
	      var elOption = elOptions[i];
	      var el = elMap.get(elOption.id);
	
	      if (!el) {
	        continue;
	      }
	
	      var parentEl = el.parent;
	      var containerInfo = parentEl === rootGroup ? {
	        width: api.getWidth(),
	        height: api.getHeight()
	      } : {
	        // Like 'position:absolut' in css, default 0.
	        width: parentEl.__ecGraphicWidth || 0,
	        height: parentEl.__ecGraphicHeight || 0
	      };
	      layoutUtil.positionElement(el, elOption, containerInfo, null, {
	        hv: elOption.hv,
	        boundingMode: elOption.bounding
	      });
	    }
	  },
	
	  /**
	   * Clear all elements.
	   *
	   * @private
	   */
	  _clear: function () {
	    var elMap = this._elMap;
	    elMap.each(function (el) {
	      removeEl(el, elMap);
	    });
	    this._elMap = zrUtil.createHashMap();
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clear();
	  }
	});
	
	function createEl(id, targetElParent, elOption, elMap) {
	  var graphicType = elOption.type;
	  var Clz = graphicUtil[graphicType.charAt(0).toUpperCase() + graphicType.slice(1)];
	  var el = new Clz(elOption);
	  targetElParent.add(el);
	  elMap.set(id, el);
	  el.__ecGraphicId = id;
	}
	
	function removeEl(existEl, elMap) {
	  var existElParent = existEl && existEl.parent;
	
	  if (existElParent) {
	    existEl.type === 'group' && existEl.traverse(function (el) {
	      removeEl(el, elMap);
	    });
	    elMap.removeKey(existEl.__ecGraphicId);
	    existElParent.remove(existEl);
	  }
	} // Remove unnecessary props to avoid potential problems.
	
	
	function getCleanedElOption(elOption) {
	  elOption = zrUtil.extend({}, elOption);
	  zrUtil.each(['id', 'parentId', '$action', 'hv', 'bounding'].concat(layoutUtil.LOCATION_PARAMS), function (name) {
	    delete elOption[name];
	  });
	  return elOption;
	}
	
	function isSetLoc(obj, props) {
	  var isSet;
	  zrUtil.each(props, function (prop) {
	    obj[prop] != null && obj[prop] !== 'auto' && (isSet = true);
	  });
	  return isSet;
	}
	
	function setKeyInfoToNewElOption(resultItem, newElOption) {
	  var existElOption = resultItem.exist; // Set id and type after id assigned.
	
	  newElOption.id = resultItem.keyInfo.id;
	  !newElOption.type && existElOption && (newElOption.type = existElOption.type); // Set parent id if not specified
	
	  if (newElOption.parentId == null) {
	    var newElParentOption = newElOption.parentOption;
	
	    if (newElParentOption) {
	      newElOption.parentId = newElParentOption.id;
	    } else if (existElOption) {
	      newElOption.parentId = existElOption.parentId;
	    }
	  } // Clear
	
	
	  newElOption.parentOption = null;
	}
	
	function mergeNewElOptionToExist(existList, index, newElOption) {
	  // Update existing options, for `getOption` feature.
	  var newElOptCopy = zrUtil.extend({}, newElOption);
	  var existElOption = existList[index];
	  var $action = newElOption.$action || 'merge';
	
	  if ($action === 'merge') {
	    if (existElOption) {
	      // We can ensure that newElOptCopy and existElOption are not
	      // the same object, so `merge` will not change newElOptCopy.
	      zrUtil.merge(existElOption, newElOptCopy, true); // Rigid body, use ignoreSize.
	
	      layoutUtil.mergeLayoutParam(existElOption, newElOptCopy, {
	        ignoreSize: true
	      }); // Will be used in render.
	
	      layoutUtil.copyLayoutParams(newElOption, existElOption);
	    } else {
	      existList[index] = newElOptCopy;
	    }
	  } else if ($action === 'replace') {
	    existList[index] = newElOptCopy;
	  } else if ($action === 'remove') {
	    // null will be cleaned later.
	    existElOption && (existList[index] = null);
	  }
	}
	
	function setLayoutInfoToExist(existItem, newElOption) {
	  if (!existItem) {
	    return;
	  }
	
	  existItem.hv = newElOption.hv = [// Rigid body, dont care `width`.
	  isSetLoc(newElOption, ['left', 'right']), // Rigid body, dont care `height`.
	  isSetLoc(newElOption, ['top', 'bottom'])]; // Give default group size. Otherwise layout error may occur.
	
	  if (existItem.type === 'group') {
	    existItem.width == null && (existItem.width = newElOption.width = 0);
	    existItem.height == null && (existItem.height = newElOption.height = 0);
	  }
	}

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(70);
	
	__webpack_require__(169);
	
	__webpack_require__(67);

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	__webpack_require__(182);
	
	__webpack_require__(496);
	
	__webpack_require__(183);
	
	var legendFilter = __webpack_require__(497);
	
	var Component = __webpack_require__(16);
	
	// Do not contain scrollable legend, for sake of file size.
	// Series Filter
	echarts.registerProcessor(legendFilter);
	Component.registerSubTypeDefaulter('legend', function () {
	  // Default 'plain' when no type specified.
	  return 'plain';
	});

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	var LegendModel = __webpack_require__(182);
	
	var _layout = __webpack_require__(7);
	
	var mergeLayoutParam = _layout.mergeLayoutParam;
	var getLayoutParams = _layout.getLayoutParams;
	var ScrollableLegendModel = LegendModel.extend({
	  type: 'legend.scroll',
	
	  /**
	   * @param {number} scrollDataIndex
	   */
	  setScrollDataIndex: function (scrollDataIndex) {
	    this.option.scrollDataIndex = scrollDataIndex;
	  },
	  defaultOption: {
	    scrollDataIndex: 0,
	    pageButtonItemGap: 5,
	    pageButtonGap: null,
	    pageButtonPosition: 'end',
	    // 'start' or 'end'
	    pageFormatter: '{current}/{total}',
	    // If null/undefined, do not show page.
	    pageIcons: {
	      horizontal: ['M0,0L12,-10L12,10z', 'M0,0L-12,-10L-12,10z'],
	      vertical: ['M0,0L20,0L10,-20z', 'M0,0L20,0L10,20z']
	    },
	    pageIconColor: '#2f4554',
	    pageIconInactiveColor: '#aaa',
	    pageIconSize: 15,
	    // Can be [10, 3], which represents [width, height]
	    pageTextStyle: {
	      color: '#333'
	    },
	    animationDurationUpdate: 800
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel, extraOpt) {
	    var inputPositionParams = getLayoutParams(option);
	    ScrollableLegendModel.superCall(this, 'init', option, parentModel, ecModel, extraOpt);
	    mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option, extraOpt) {
	    ScrollableLegendModel.superCall(this, 'mergeOption', option, extraOpt);
	    mergeAndNormalizeLayoutParams(this, this.option, option);
	  },
	  getOrient: function () {
	    return this.get('orient') === 'vertical' ? {
	      index: 1,
	      name: 'vertical'
	    } : {
	      index: 0,
	      name: 'horizontal'
	    };
	  }
	}); // Do not `ignoreSize` to enable setting {left: 10, right: 10}.
	
	function mergeAndNormalizeLayoutParams(legendModel, target, raw) {
	  var orient = legendModel.getOrient();
	  var ignoreSize = [1, 1];
	  ignoreSize[orient.index] = 0;
	  mergeLayoutParam(target, raw, {
	    type: 'box',
	    ignoreSize: ignoreSize
	  });
	}
	
	var _default = ScrollableLegendModel;
	module.exports = _default;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var layoutUtil = __webpack_require__(7);
	
	var LegendView = __webpack_require__(183);
	
	/**
	 * Separate legend and scrollable legend to reduce package size.
	 */
	var Group = graphic.Group;
	var WH = ['width', 'height'];
	var XY = ['x', 'y'];
	var ScrollableLegendView = LegendView.extend({
	  type: 'legend.scroll',
	  newlineDisabled: true,
	  init: function () {
	    ScrollableLegendView.superCall(this, 'init');
	    /**
	     * @private
	     * @type {number} For `scroll`.
	     */
	
	    this._currentIndex = 0;
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	    this.group.add(this._containerGroup = new Group());
	
	    this._containerGroup.add(this.getContentGroup());
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	
	    this.group.add(this._controllerGroup = new Group());
	    /**
	     *
	     * @private
	     */
	
	    this._showController;
	  },
	
	  /**
	   * @override
	   */
	  resetInner: function () {
	    ScrollableLegendView.superCall(this, 'resetInner');
	
	    this._controllerGroup.removeAll();
	
	    this._containerGroup.removeClipPath();
	
	    this._containerGroup.__rectSize = null;
	  },
	
	  /**
	   * @override
	   */
	  renderInner: function (itemAlign, legendModel, ecModel, api) {
	    var me = this; // Render content items.
	
	    ScrollableLegendView.superCall(this, 'renderInner', itemAlign, legendModel, ecModel, api);
	    var controllerGroup = this._controllerGroup;
	    var pageIconSize = legendModel.get('pageIconSize', true);
	
	    if (!zrUtil.isArray(pageIconSize)) {
	      pageIconSize = [pageIconSize, pageIconSize];
	    }
	
	    createPageButton('pagePrev', 0);
	    var pageTextStyleModel = legendModel.getModel('pageTextStyle');
	    controllerGroup.add(new graphic.Text({
	      name: 'pageText',
	      style: {
	        textFill: pageTextStyleModel.getTextColor(),
	        font: pageTextStyleModel.getFont(),
	        textVerticalAlign: 'middle',
	        textAlign: 'center'
	      },
	      silent: true
	    }));
	    createPageButton('pageNext', 1);
	
	    function createPageButton(name, iconIdx) {
	      var pageDataIndexName = name + 'DataIndex';
	      var icon = graphic.createIcon(legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
	        // Buttons will be created in each render, so we do not need
	        // to worry about avoiding using legendModel kept in scope.
	        onclick: zrUtil.bind(me._pageGo, me, pageDataIndexName, legendModel, api)
	      }, {
	        x: -pageIconSize[0] / 2,
	        y: -pageIconSize[1] / 2,
	        width: pageIconSize[0],
	        height: pageIconSize[1]
	      });
	      icon.name = name;
	      controllerGroup.add(icon);
	    }
	  },
	
	  /**
	   * @override
	   */
	  layoutInner: function (legendModel, itemAlign, maxSize) {
	    var contentGroup = this.getContentGroup();
	    var containerGroup = this._containerGroup;
	    var controllerGroup = this._controllerGroup;
	    var orientIdx = legendModel.getOrient().index;
	    var wh = WH[orientIdx];
	    var hw = WH[1 - orientIdx];
	    var yx = XY[1 - orientIdx]; // Place items in contentGroup.
	
	    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
	    layoutUtil.box( // Buttons in controller are layout always horizontally.
	    'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
	    var contentRect = contentGroup.getBoundingRect();
	    var controllerRect = controllerGroup.getBoundingRect();
	    var showController = this._showController = contentRect[wh] > maxSize[wh];
	    var contentPos = [-contentRect.x, -contentRect.y]; // Remain contentPos when scroll animation perfroming.
	
	    contentPos[orientIdx] = contentGroup.position[orientIdx]; // Layout container group based on 0.
	
	    var containerPos = [0, 0];
	    var controllerPos = [-controllerRect.x, -controllerRect.y];
	    var pageButtonGap = zrUtil.retrieve2(legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true)); // Place containerGroup and controllerGroup and contentGroup.
	
	    if (showController) {
	      var pageButtonPosition = legendModel.get('pageButtonPosition', true); // controller is on the right / bottom.
	
	      if (pageButtonPosition === 'end') {
	        controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
	      } // controller is on the left / top.
	      else {
	          containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
	        }
	    } // Always align controller to content as 'middle'.
	
	
	    controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
	    contentGroup.attr('position', contentPos);
	    containerGroup.attr('position', containerPos);
	    controllerGroup.attr('position', controllerPos); // Calculate `mainRect` and set `clipPath`.
	    // mainRect should not be calculated by `this.group.getBoundingRect()`
	    // for sake of the overflow.
	
	    var mainRect = this.group.getBoundingRect();
	    var mainRect = {
	      x: 0,
	      y: 0
	    }; // Consider content may be overflow (should be clipped).
	
	    mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
	    mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]); // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
	
	    mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
	    containerGroup.__rectSize = maxSize[wh];
	
	    if (showController) {
	      var clipShape = {
	        x: 0,
	        y: 0
	      };
	      clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
	      clipShape[hw] = mainRect[hw];
	      containerGroup.setClipPath(new graphic.Rect({
	        shape: clipShape
	      })); // Consider content may be larger than container, container rect
	      // can not be obtained from `containerGroup.getBoundingRect()`.
	
	      containerGroup.__rectSize = clipShape[wh];
	    } else {
	      // Do not remove or ignore controller. Keep them set as place holders.
	      controllerGroup.eachChild(function (child) {
	        child.attr({
	          invisible: true,
	          silent: true
	        });
	      });
	    } // Content translate animation.
	
	
	    var pageInfo = this._getPageInfo(legendModel);
	
	    pageInfo.pageIndex != null && graphic.updateProps(contentGroup, {
	      position: pageInfo.contentPosition
	    }, // When switch from "show controller" to "not show controller", view should be
	    // updated immediately without animation, otherwise causes weird efffect.
	    showController ? legendModel : false);
	
	    this._updatePageInfoView(legendModel, pageInfo);
	
	    return mainRect;
	  },
	  _pageGo: function (to, legendModel, api) {
	    var scrollDataIndex = this._getPageInfo(legendModel)[to];
	
	    scrollDataIndex != null && api.dispatchAction({
	      type: 'legendScroll',
	      scrollDataIndex: scrollDataIndex,
	      legendId: legendModel.id
	    });
	  },
	  _updatePageInfoView: function (legendModel, pageInfo) {
	    var controllerGroup = this._controllerGroup;
	    zrUtil.each(['pagePrev', 'pageNext'], function (name) {
	      var canJump = pageInfo[name + 'DataIndex'] != null;
	      var icon = controllerGroup.childOfName(name);
	
	      if (icon) {
	        icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
	        icon.cursor = canJump ? 'pointer' : 'default';
	      }
	    });
	    var pageText = controllerGroup.childOfName('pageText');
	    var pageFormatter = legendModel.get('pageFormatter');
	    var pageIndex = pageInfo.pageIndex;
	    var current = pageIndex != null ? pageIndex + 1 : 0;
	    var total = pageInfo.pageCount;
	    pageText && pageFormatter && pageText.setStyle('text', zrUtil.isString(pageFormatter) ? pageFormatter.replace('{current}', current).replace('{total}', total) : pageFormatter({
	      current: current,
	      total: total
	    }));
	  },
	
	  /**
	   * @param {module:echarts/model/Model} legendModel
	   * @return {Object} {
	   *  contentPosition: Array.<number>, null when data item not found.
	   *  pageIndex: number, null when data item not found.
	   *  pageCount: number, always be a number, can be 0.
	   *  pagePrevDataIndex: number, null when no next page.
	   *  pageNextDataIndex: number, null when no previous page.
	   * }
	   */
	  _getPageInfo: function (legendModel) {
	    // Align left or top by the current dataIndex.
	    var currDataIndex = legendModel.get('scrollDataIndex', true);
	    var contentGroup = this.getContentGroup();
	    var contentRect = contentGroup.getBoundingRect();
	    var containerRectSize = this._containerGroup.__rectSize;
	    var orientIdx = legendModel.getOrient().index;
	    var wh = WH[orientIdx];
	    var hw = WH[1 - orientIdx];
	    var xy = XY[orientIdx];
	    var contentPos = contentGroup.position.slice();
	    var pageIndex;
	    var pagePrevDataIndex;
	    var pageNextDataIndex;
	    var targetItemGroup;
	
	    if (this._showController) {
	      contentGroup.eachChild(function (child) {
	        if (child.__legendDataIndex === currDataIndex) {
	          targetItemGroup = child;
	        }
	      });
	    } else {
	      targetItemGroup = contentGroup.childAt(0);
	    }
	
	    var pageCount = containerRectSize ? Math.ceil(contentRect[wh] / containerRectSize) : 0;
	
	    if (targetItemGroup) {
	      var itemRect = targetItemGroup.getBoundingRect();
	      var itemLoc = targetItemGroup.position[orientIdx] + itemRect[xy];
	      contentPos[orientIdx] = -itemLoc - contentRect[xy];
	      pageIndex = Math.floor(pageCount * (itemLoc + itemRect[xy] + containerRectSize / 2) / contentRect[wh]);
	      pageIndex = contentRect[wh] && pageCount ? Math.max(0, Math.min(pageCount - 1, pageIndex)) : -1;
	      var winRect = {
	        x: 0,
	        y: 0
	      };
	      winRect[wh] = containerRectSize;
	      winRect[hw] = contentRect[hw];
	      winRect[xy] = -contentPos[orientIdx] - contentRect[xy];
	      var startIdx;
	      var children = contentGroup.children();
	      contentGroup.eachChild(function (child, index) {
	        var itemRect = getItemRect(child);
	
	        if (itemRect.intersect(winRect)) {
	          startIdx == null && (startIdx = index); // It is user-friendly that the last item shown in the
	          // current window is shown at the begining of next window.
	
	          pageNextDataIndex = child.__legendDataIndex;
	        } // If the last item is shown entirely, no next page.
	
	
	        if (index === children.length - 1 && itemRect[xy] + itemRect[wh] <= winRect[xy] + winRect[wh]) {
	          pageNextDataIndex = null;
	        }
	      }); // Always align based on the left/top most item, so the left/top most
	      // item in the previous window is needed to be found here.
	
	      if (startIdx != null) {
	        var startItem = children[startIdx];
	        var startRect = getItemRect(startItem);
	        winRect[xy] = startRect[xy] + startRect[wh] - winRect[wh]; // If the first item is shown entirely, no previous page.
	
	        if (startIdx <= 0 && startRect[xy] >= winRect[xy]) {
	          pagePrevDataIndex = null;
	        } else {
	          while (startIdx > 0 && getItemRect(children[startIdx - 1]).intersect(winRect)) {
	            startIdx--;
	          }
	
	          pagePrevDataIndex = children[startIdx].__legendDataIndex;
	        }
	      }
	    }
	
	    return {
	      contentPosition: contentPos,
	      pageIndex: pageIndex,
	      pageCount: pageCount,
	      pagePrevDataIndex: pagePrevDataIndex,
	      pageNextDataIndex: pageNextDataIndex
	    };
	
	    function getItemRect(el) {
	      var itemRect = el.getBoundingRect().clone();
	      itemRect[xy] += el.position[orientIdx];
	      return itemRect;
	    }
	  }
	});
	var _default = ScrollableLegendView;
	module.exports = _default;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	function legendSelectActionHandler(methodName, payload, ecModel) {
	  var selectedMap = {};
	  var isToggleSelect = methodName === 'toggleSelected';
	  var isSelected; // Update all legend components
	
	  ecModel.eachComponent('legend', function (legendModel) {
	    if (isToggleSelect && isSelected != null) {
	      // Force other legend has same selected status
	      // Or the first is toggled to true and other are toggled to false
	      // In the case one legend has some item unSelected in option. And if other legend
	      // doesn't has the item, they will assume it is selected.
	      legendModel[isSelected ? 'select' : 'unSelect'](payload.name);
	    } else {
	      legendModel[methodName](payload.name);
	      isSelected = legendModel.isSelected(payload.name);
	    }
	
	    var legendData = legendModel.getData();
	    zrUtil.each(legendData, function (model) {
	      var name = model.get('name'); // Wrap element
	
	      if (name === '\n' || name === '') {
	        return;
	      }
	
	      var isItemSelected = legendModel.isSelected(name);
	
	      if (selectedMap.hasOwnProperty(name)) {
	        // Unselected if any legend is unselected
	        selectedMap[name] = selectedMap[name] && isItemSelected;
	      } else {
	        selectedMap[name] = isItemSelected;
	      }
	    });
	  }); // Return the event explicitly
	
	  return {
	    name: payload.name,
	    selected: selectedMap
	  };
	}
	/**
	 * @event legendToggleSelect
	 * @type {Object}
	 * @property {string} type 'legendToggleSelect'
	 * @property {string} [from]
	 * @property {string} name Series name or data item name
	 */
	
	
	echarts.registerAction('legendToggleSelect', 'legendselectchanged', zrUtil.curry(legendSelectActionHandler, 'toggleSelected'));
	/**
	 * @event legendSelect
	 * @type {Object}
	 * @property {string} type 'legendSelect'
	 * @property {string} name Series name or data item name
	 */
	
	echarts.registerAction('legendSelect', 'legendselected', zrUtil.curry(legendSelectActionHandler, 'select'));
	/**
	 * @event legendUnSelect
	 * @type {Object}
	 * @property {string} type 'legendUnSelect'
	 * @property {string} name Series name or data item name
	 */
	
	echarts.registerAction('legendUnSelect', 'legendunselected', zrUtil.curry(legendSelectActionHandler, 'unSelect'));

/***/ }),
/* 497 */
/***/ (function(module, exports) {

	function _default(ecModel) {
	  var legendModels = ecModel.findComponents({
	    mainType: 'legend'
	  });
	
	  if (legendModels && legendModels.length) {
	    ecModel.filterSeries(function (series) {
	      // If in any legend component the status is not selected.
	      // Because in legend series is assumed selected when it is not in the legend data.
	      for (var i = 0; i < legendModels.length; i++) {
	        if (!legendModels[i].isSelected(series.name)) {
	          return false;
	        }
	      }
	
	      return true;
	    });
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	/**
	 * @event legendScroll
	 * @type {Object}
	 * @property {string} type 'legendScroll'
	 * @property {string} scrollDataIndex
	 */
	echarts.registerAction('legendScroll', 'legendscroll', function (payload, ecModel) {
	  var scrollDataIndex = payload.scrollDataIndex;
	  scrollDataIndex != null && ecModel.eachComponent({
	    mainType: 'legend',
	    subType: 'scroll',
	    query: payload
	  }, function (legendModel) {
	    legendModel.setScrollDataIndex(scrollDataIndex);
	  });
	});

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(493);
	
	__webpack_require__(494);
	
	__webpack_require__(495);
	
	__webpack_require__(498);

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	__webpack_require__(503);
	
	__webpack_require__(504);
	
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markArea component is enabled
	  opt.markArea = opt.markArea || {};
	});

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	__webpack_require__(505);
	
	__webpack_require__(506);
	
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markLine component is enabled
	  opt.markLine = opt.markLine || {};
	});

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	__webpack_require__(507);
	
	__webpack_require__(508);
	
	// HINT Markpoint can't be used too much
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markPoint component is enabled
	  opt.markPoint = opt.markPoint || {};
	});

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	var MarkerModel = __webpack_require__(123);
	
	var _default = MarkerModel.extend({
	  type: 'markArea',
	  defaultOption: {
	    zlevel: 0,
	    // PENDING
	    z: 1,
	    tooltip: {
	      trigger: 'item'
	    },
	    // markArea should fixed on the coordinate system
	    animation: false,
	    label: {
	      normal: {
	        show: true,
	        position: 'top'
	      },
	      emphasis: {
	        show: true,
	        position: 'top'
	      }
	    },
	    itemStyle: {
	      normal: {
	        // color and borderColor default to use color from series
	        // color: 'auto'
	        // borderColor: 'auto'
	        borderWidth: 0
	      }
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var colorUtil = __webpack_require__(31);
	
	var List = __webpack_require__(15);
	
	var numberUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(3);
	
	var markerHelper = __webpack_require__(125);
	
	var MarkerView = __webpack_require__(124);
	
	// TODO Better on polar
	var markAreaTransform = function (seriesModel, coordSys, maModel, item) {
	  var lt = markerHelper.dataTransform(seriesModel, item[0]);
	  var rb = markerHelper.dataTransform(seriesModel, item[1]);
	  var retrieve = zrUtil.retrieve; // FIXME make sure lt is less than rb
	
	  var ltCoord = lt.coord;
	  var rbCoord = rb.coord;
	  ltCoord[0] = retrieve(ltCoord[0], -Infinity);
	  ltCoord[1] = retrieve(ltCoord[1], -Infinity);
	  rbCoord[0] = retrieve(rbCoord[0], Infinity);
	  rbCoord[1] = retrieve(rbCoord[1], Infinity); // Merge option into one
	
	  var result = zrUtil.mergeAll([{}, lt, rb]);
	  result.coord = [lt.coord, rb.coord];
	  result.x0 = lt.x;
	  result.y0 = lt.y;
	  result.x1 = rb.x;
	  result.y1 = rb.y;
	  return result;
	};
	
	function isInifinity(val) {
	  return !isNaN(val) && !isFinite(val);
	} // If a markArea has one dim
	
	
	function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
	  var otherDimIndex = 1 - dimIndex;
	  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]);
	}
	
	function markAreaFilter(coordSys, item) {
	  var fromCoord = item.coord[0];
	  var toCoord = item.coord[1];
	
	  if (coordSys.type === 'cartesian2d') {
	    // In case
	    // {
	    //  markArea: {
	    //    data: [{ yAxis: 2 }]
	    //  }
	    // }
	    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
	      return true;
	    }
	  }
	
	  return markerHelper.dataFilter(coordSys, {
	    coord: fromCoord,
	    x: item.x0,
	    y: item.y0
	  }) || markerHelper.dataFilter(coordSys, {
	    coord: toCoord,
	    x: item.x1,
	    y: item.y1
	  });
	} // dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']
	
	
	function getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  var itemModel = data.getItemModel(idx);
	  var point;
	  var xPx = numberUtil.parsePercent(itemModel.get(dims[0]), api.getWidth());
	  var yPx = numberUtil.parsePercent(itemModel.get(dims[1]), api.getHeight());
	
	  if (!isNaN(xPx) && !isNaN(yPx)) {
	    point = [xPx, yPx];
	  } else {
	    // Chart like bar may have there own marker positioning logic
	    if (seriesModel.getMarkerPosition) {
	      // Use the getMarkerPoisition
	      point = seriesModel.getMarkerPosition(data.getValues(dims, idx));
	    } else {
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	      point = coordSys.dataToPoint([x, y], true);
	    }
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	
	      if (isInifinity(x)) {
	        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === 'x0' ? 0 : 1]);
	      } else if (isInifinity(y)) {
	        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === 'y0' ? 0 : 1]);
	      }
	    } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	  }
	
	  return point;
	}
	
	var dimPermutations = [['x0', 'y0'], ['x1', 'y0'], ['x1', 'y1'], ['x0', 'y1']];
	MarkerView.extend({
	  type: 'markArea',
	  updateLayout: function (markAreaModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var maModel = seriesModel.markAreaModel;
	
	      if (maModel) {
	        var areaData = maModel.getData();
	        areaData.each(function (idx) {
	          var points = zrUtil.map(dimPermutations, function (dim) {
	            return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	          }); // Layout
	
	          areaData.setItemLayout(idx, points);
	          var el = areaData.getItemGraphicEl(idx);
	          el.setShape('points', points);
	        });
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, maModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesName = seriesModel.name;
	    var seriesData = seriesModel.getData();
	    var areaGroupMap = this.markerGroupMap;
	    var polygonGroup = areaGroupMap.get(seriesName) || areaGroupMap.set(seriesName, {
	      group: new graphic.Group()
	    });
	    this.group.add(polygonGroup.group);
	    polygonGroup.__keep = true;
	    var areaData = createList(coordSys, seriesModel, maModel); // Line data for tooltip and formatter
	
	    maModel.setData(areaData); // Update visual and layout of line
	
	    areaData.each(function (idx) {
	      // Layout
	      areaData.setItemLayout(idx, zrUtil.map(dimPermutations, function (dim) {
	        return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	      })); // Visual
	
	      areaData.setItemVisual(idx, {
	        color: seriesData.getVisual('color')
	      });
	    });
	    areaData.diff(polygonGroup.__data).add(function (idx) {
	      var polygon = new graphic.Polygon({
	        shape: {
	          points: areaData.getItemLayout(idx)
	        }
	      });
	      areaData.setItemGraphicEl(idx, polygon);
	      polygonGroup.group.add(polygon);
	    }).update(function (newIdx, oldIdx) {
	      var polygon = polygonGroup.__data.getItemGraphicEl(oldIdx);
	
	      graphic.updateProps(polygon, {
	        shape: {
	          points: areaData.getItemLayout(newIdx)
	        }
	      }, maModel, newIdx);
	      polygonGroup.group.add(polygon);
	      areaData.setItemGraphicEl(newIdx, polygon);
	    }).remove(function (idx) {
	      var polygon = polygonGroup.__data.getItemGraphicEl(idx);
	
	      polygonGroup.group.remove(polygon);
	    }).execute();
	    areaData.eachItemGraphicEl(function (polygon, idx) {
	      var itemModel = areaData.getItemModel(idx);
	      var labelModel = itemModel.getModel('label.normal');
	      var labelHoverModel = itemModel.getModel('label.emphasis');
	      var color = areaData.getItemVisual(idx, 'color');
	      polygon.useStyle(zrUtil.defaults(itemModel.getModel('itemStyle.normal').getItemStyle(), {
	        fill: colorUtil.modifyAlpha(color, 0.4),
	        stroke: color
	      }));
	      polygon.hoverStyle = itemModel.getModel('itemStyle.emphasis').getItemStyle();
	      graphic.setLabelStyle(polygon.style, polygon.hoverStyle, labelModel, labelHoverModel, {
	        labelFetcher: maModel,
	        labelDataIndex: idx,
	        defaultText: areaData.getName(idx) || '',
	        isRectText: true,
	        autoColor: color
	      });
	      graphic.setHoverStyle(polygon, {});
	      polygon.dataModel = maModel;
	    });
	    polygonGroup.__data = areaData;
	    polygonGroup.group.silent = maModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} coordSys
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	function createList(coordSys, seriesModel, maModel) {
	  var coordDimsInfos;
	  var areaData;
	  var dims = ['x0', 'y0', 'x1', 'y1'];
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var info = seriesModel.getData().getDimensionInfo(seriesModel.coordDimToDataDim(coordDim)[0]) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      info.name = coordDim;
	      return info;
	    });
	    areaData = new List(zrUtil.map(dims, function (dim, idx) {
	      return {
	        name: dim,
	        type: coordDimsInfos[idx % 2].type
	      };
	    }), maModel);
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	    areaData = new List(coordDimsInfos, maModel);
	  }
	
	  var optData = zrUtil.map(maModel.get('data'), zrUtil.curry(markAreaTransform, seriesModel, coordSys, maModel));
	
	  if (coordSys) {
	    optData = zrUtil.filter(optData, zrUtil.curry(markAreaFilter, coordSys));
	  }
	
	  var dimValueGetter = coordSys ? function (item, dimName, dataIndex, dimIndex) {
	    return item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
	  } : function (item) {
	    return item.value;
	  };
	  areaData.initData(optData, null, dimValueGetter);
	  areaData.hasItemOption = true;
	  return areaData;
	}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	var MarkerModel = __webpack_require__(123);
	
	var _default = MarkerModel.extend({
	  type: 'markLine',
	  defaultOption: {
	    zlevel: 0,
	    z: 5,
	    symbol: ['circle', 'arrow'],
	    symbolSize: [8, 16],
	    //symbolRotate: 0,
	    precision: 2,
	    tooltip: {
	      trigger: 'item'
	    },
	    label: {
	      normal: {
	        show: true,
	        position: 'end'
	      },
	      emphasis: {
	        show: true
	      }
	    },
	    lineStyle: {
	      normal: {
	        type: 'dashed'
	      },
	      emphasis: {
	        width: 3
	      }
	    },
	    animationEasing: 'linear'
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var List = __webpack_require__(15);
	
	var numberUtil = __webpack_require__(4);
	
	var markerHelper = __webpack_require__(125);
	
	var LineDraw = __webpack_require__(117);
	
	var MarkerView = __webpack_require__(124);
	
	var markLineTransform = function (seriesModel, coordSys, mlModel, item) {
	  var data = seriesModel.getData(); // Special type markLine like 'min', 'max', 'average'
	
	  var mlType = item.type;
	
	  if (!zrUtil.isArray(item) && (mlType === 'min' || mlType === 'max' || mlType === 'average' // In case
	  // data: [{
	  //   yAxis: 10
	  // }]
	  || item.xAxis != null || item.yAxis != null)) {
	    var valueAxis;
	    var valueDataDim;
	    var value;
	
	    if (item.yAxis != null || item.xAxis != null) {
	      valueDataDim = item.yAxis != null ? 'y' : 'x';
	      valueAxis = coordSys.getAxis(valueDataDim);
	      value = zrUtil.retrieve(item.yAxis, item.xAxis);
	    } else {
	      var axisInfo = markerHelper.getAxisInfo(item, data, coordSys, seriesModel);
	      valueDataDim = axisInfo.valueDataDim;
	      valueAxis = axisInfo.valueAxis;
	      value = markerHelper.numCalculate(data, valueDataDim, mlType);
	    }
	
	    var valueIndex = valueDataDim === 'x' ? 0 : 1;
	    var baseIndex = 1 - valueIndex;
	    var mlFrom = zrUtil.clone(item);
	    var mlTo = {};
	    mlFrom.type = null;
	    mlFrom.coord = [];
	    mlTo.coord = [];
	    mlFrom.coord[baseIndex] = -Infinity;
	    mlTo.coord[baseIndex] = Infinity;
	    var precision = mlModel.get('precision');
	
	    if (precision >= 0 && typeof value === 'number') {
	      value = +value.toFixed(Math.min(precision, 20));
	    }
	
	    mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
	    item = [mlFrom, mlTo, {
	      // Extra option for tooltip and label
	      type: mlType,
	      valueIndex: item.valueIndex,
	      // Force to use the value of calculated value.
	      value: value
	    }];
	  }
	
	  item = [markerHelper.dataTransform(seriesModel, item[0]), markerHelper.dataTransform(seriesModel, item[1]), zrUtil.extend({}, item[2])]; // Avoid line data type is extended by from(to) data type
	
	  item[2].type = item[2].type || ''; // Merge from option and to option into line option
	
	  zrUtil.merge(item[2], item[0]);
	  zrUtil.merge(item[2], item[1]);
	  return item;
	};
	
	function isInifinity(val) {
	  return !isNaN(val) && !isFinite(val);
	} // If a markLine has one dim
	
	
	function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
	  var otherDimIndex = 1 - dimIndex;
	  var dimName = coordSys.dimensions[dimIndex];
	  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
	}
	
	function markLineFilter(coordSys, item) {
	  if (coordSys.type === 'cartesian2d') {
	    var fromCoord = item[0].coord;
	    var toCoord = item[1].coord; // In case
	    // {
	    //  markLine: {
	    //    data: [{ yAxis: 2 }]
	    //  }
	    // }
	
	    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
	      return true;
	    }
	  }
	
	  return markerHelper.dataFilter(coordSys, item[0]) && markerHelper.dataFilter(coordSys, item[1]);
	}
	
	function updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  var itemModel = data.getItemModel(idx);
	  var point;
	  var xPx = numberUtil.parsePercent(itemModel.get('x'), api.getWidth());
	  var yPx = numberUtil.parsePercent(itemModel.get('y'), api.getHeight());
	
	  if (!isNaN(xPx) && !isNaN(yPx)) {
	    point = [xPx, yPx];
	  } else {
	    // Chart like bar may have there own marker positioning logic
	    if (seriesModel.getMarkerPosition) {
	      // Use the getMarkerPoisition
	      point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
	    } else {
	      var dims = coordSys.dimensions;
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	      point = coordSys.dataToPoint([x, y]);
	    } // Expand line to the edge of grid if value on one axis is Inifnity
	    // In case
	    //  markLine: {
	    //    data: [{
	    //      yAxis: 2
	    //      // or
	    //      type: 'average'
	    //    }]
	    //  }
	
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      var dims = coordSys.dimensions;
	
	      if (isInifinity(data.get(dims[0], idx))) {
	        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
	      } else if (isInifinity(data.get(dims[1], idx))) {
	        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
	      }
	    } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	  }
	
	  data.setItemLayout(idx, point);
	}
	
	var _default = MarkerView.extend({
	  type: 'markLine',
	  updateLayout: function (markLineModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var mlModel = seriesModel.markLineModel;
	
	      if (mlModel) {
	        var mlData = mlModel.getData();
	        var fromData = mlModel.__from;
	        var toData = mlModel.__to; // Update visual and layout of from symbol and to symbol
	
	        fromData.each(function (idx) {
	          updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
	          updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
	        }); // Update layout of line
	
	        mlData.each(function (idx) {
	          mlData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
	        });
	        this.markerGroupMap.get(seriesModel.id).updateLayout();
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, mlModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var lineDrawMap = this.markerGroupMap;
	    var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new LineDraw());
	    this.group.add(lineDraw.group);
	    var mlData = createList(coordSys, seriesModel, mlModel);
	    var fromData = mlData.from;
	    var toData = mlData.to;
	    var lineData = mlData.line;
	    mlModel.__from = fromData;
	    mlModel.__to = toData; // Line data for tooltip and formatter
	
	    mlModel.setData(lineData);
	    var symbolType = mlModel.get('symbol');
	    var symbolSize = mlModel.get('symbolSize');
	
	    if (!zrUtil.isArray(symbolType)) {
	      symbolType = [symbolType, symbolType];
	    }
	
	    if (typeof symbolSize === 'number') {
	      symbolSize = [symbolSize, symbolSize];
	    } // Update visual and layout of from symbol and to symbol
	
	
	    mlData.from.each(function (idx) {
	      updateDataVisualAndLayout(fromData, idx, true);
	      updateDataVisualAndLayout(toData, idx, false);
	    }); // Update visual and layout of line
	
	    lineData.each(function (idx) {
	      var lineColor = lineData.getItemModel(idx).get('lineStyle.normal.color');
	      lineData.setItemVisual(idx, {
	        color: lineColor || fromData.getItemVisual(idx, 'color')
	      });
	      lineData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
	      lineData.setItemVisual(idx, {
	        'fromSymbolSize': fromData.getItemVisual(idx, 'symbolSize'),
	        'fromSymbol': fromData.getItemVisual(idx, 'symbol'),
	        'toSymbolSize': toData.getItemVisual(idx, 'symbolSize'),
	        'toSymbol': toData.getItemVisual(idx, 'symbol')
	      });
	    });
	    lineDraw.updateData(lineData); // Set host model for tooltip
	    // FIXME
	
	    mlData.line.eachItemGraphicEl(function (el, idx) {
	      el.traverse(function (child) {
	        child.dataModel = mlModel;
	      });
	    });
	
	    function updateDataVisualAndLayout(data, idx, isFrom) {
	      var itemModel = data.getItemModel(idx);
	      updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
	      data.setItemVisual(idx, {
	        symbolSize: itemModel.get('symbolSize') || symbolSize[isFrom ? 0 : 1],
	        symbol: itemModel.get('symbol', true) || symbolType[isFrom ? 0 : 1],
	        color: itemModel.get('itemStyle.normal.color') || seriesData.getVisual('color')
	      });
	    }
	
	    lineDraw.__keep = true;
	    lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} coordSys
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	
	function createList(coordSys, seriesModel, mlModel) {
	  var coordDimsInfos;
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var info = seriesModel.getData().getDimensionInfo(seriesModel.coordDimToDataDim(coordDim)[0]) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      info.name = coordDim;
	      return info;
	    });
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	  }
	
	  var fromData = new List(coordDimsInfos, mlModel);
	  var toData = new List(coordDimsInfos, mlModel); // No dimensions
	
	  var lineData = new List([], mlModel);
	  var optData = zrUtil.map(mlModel.get('data'), zrUtil.curry(markLineTransform, seriesModel, coordSys, mlModel));
	
	  if (coordSys) {
	    optData = zrUtil.filter(optData, zrUtil.curry(markLineFilter, coordSys));
	  }
	
	  var dimValueGetter = coordSys ? markerHelper.dimValueGetter : function (item) {
	    return item.value;
	  };
	  fromData.initData(zrUtil.map(optData, function (item) {
	    return item[0];
	  }), null, dimValueGetter);
	  toData.initData(zrUtil.map(optData, function (item) {
	    return item[1];
	  }), null, dimValueGetter);
	  lineData.initData(zrUtil.map(optData, function (item) {
	    return item[2];
	  }));
	  lineData.hasItemOption = true;
	  return {
	    from: fromData,
	    to: toData,
	    line: lineData
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	var MarkerModel = __webpack_require__(123);
	
	var _default = MarkerModel.extend({
	  type: 'markPoint',
	  defaultOption: {
	    zlevel: 0,
	    z: 5,
	    symbol: 'pin',
	    symbolSize: 50,
	    //symbolRotate: 0,
	    //symbolOffset: [0, 0]
	    tooltip: {
	      trigger: 'item'
	    },
	    label: {
	      normal: {
	        show: true,
	        position: 'inside'
	      },
	      emphasis: {
	        show: true
	      }
	    },
	    itemStyle: {
	      normal: {
	        borderWidth: 2
	      }
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var SymbolDraw = __webpack_require__(65);
	
	var numberUtil = __webpack_require__(4);
	
	var List = __webpack_require__(15);
	
	var markerHelper = __webpack_require__(125);
	
	var MarkerView = __webpack_require__(124);
	
	function updateMarkerLayout(mpData, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  mpData.each(function (idx) {
	    var itemModel = mpData.getItemModel(idx);
	    var point;
	    var xPx = numberUtil.parsePercent(itemModel.get('x'), api.getWidth());
	    var yPx = numberUtil.parsePercent(itemModel.get('y'), api.getHeight());
	
	    if (!isNaN(xPx) && !isNaN(yPx)) {
	      point = [xPx, yPx];
	    } // Chart like bar may have there own marker positioning logic
	    else if (seriesModel.getMarkerPosition) {
	        // Use the getMarkerPoisition
	        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
	      } else if (coordSys) {
	        var x = mpData.get(coordSys.dimensions[0], idx);
	        var y = mpData.get(coordSys.dimensions[1], idx);
	        point = coordSys.dataToPoint([x, y]);
	      } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	
	    mpData.setItemLayout(idx, point);
	  });
	}
	
	var _default = MarkerView.extend({
	  type: 'markPoint',
	  updateLayout: function (markPointModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var mpModel = seriesModel.markPointModel;
	
	      if (mpModel) {
	        updateMarkerLayout(mpModel.getData(), seriesModel, api);
	        this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, mpModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var symbolDrawMap = this.markerGroupMap;
	    var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new SymbolDraw());
	    var mpData = createList(coordSys, seriesModel, mpModel); // FIXME
	
	    mpModel.setData(mpData);
	    updateMarkerLayout(mpModel.getData(), seriesModel, api);
	    mpData.each(function (idx) {
	      var itemModel = mpData.getItemModel(idx);
	      var symbolSize = itemModel.getShallow('symbolSize');
	
	      if (typeof symbolSize === 'function') {
	        // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
	        symbolSize = symbolSize(mpModel.getRawValue(idx), mpModel.getDataParams(idx));
	      }
	
	      mpData.setItemVisual(idx, {
	        symbolSize: symbolSize,
	        color: itemModel.get('itemStyle.normal.color') || seriesData.getVisual('color'),
	        symbol: itemModel.getShallow('symbol')
	      });
	    }); // TODO Text are wrong
	
	    symbolDraw.updateData(mpData);
	    this.group.add(symbolDraw.group); // Set host model for tooltip
	    // FIXME
	
	    mpData.eachItemGraphicEl(function (el) {
	      el.traverse(function (child) {
	        child.dataModel = mpModel;
	      });
	    });
	    symbolDraw.__keep = true;
	    symbolDraw.group.silent = mpModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} [coordSys]
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	
	function createList(coordSys, seriesModel, mpModel) {
	  var coordDimsInfos;
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var info = seriesModel.getData().getDimensionInfo(seriesModel.coordDimToDataDim(coordDim)[0]) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      info.name = coordDim;
	      return info;
	    });
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	  }
	
	  var mpData = new List(coordDimsInfos, mpModel);
	  var dataOpt = zrUtil.map(mpModel.get('data'), zrUtil.curry(markerHelper.dataTransform, seriesModel));
	
	  if (coordSys) {
	    dataOpt = zrUtil.filter(dataOpt, zrUtil.curry(markerHelper.dataFilter, coordSys));
	  }
	
	  mpData.initData(dataOpt, null, coordSys ? markerHelper.dimValueGetter : function (item) {
	    return item.value;
	  });
	  return mpData;
	}
	
	module.exports = _default;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(198);
	
	__webpack_require__(464);
	
	__webpack_require__(461);

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var barPolar = __webpack_require__(580);
	
	__webpack_require__(127);
	
	__webpack_require__(457);
	
	__webpack_require__(513);
	
	__webpack_require__(67);
	
	__webpack_require__(467);
	
	// For reducing size of echarts.min, barLayoutPolar is required by polar.
	echarts.registerLayout(zrUtil.curry(barPolar, 'bar')); // Polar view
	
	echarts.extendComponentView({
	  type: 'polar'
	});

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(571);
	
	__webpack_require__(572);
	
	__webpack_require__(512);

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var AxisBuilder = __webpack_require__(43);
	
	var graphic = __webpack_require__(3);
	
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	
	var _default = echarts.extendComponentView({
	  type: 'radar',
	  render: function (radarModel, ecModel, api) {
	    var group = this.group;
	    group.removeAll();
	
	    this._buildAxes(radarModel);
	
	    this._buildSplitLineAndArea(radarModel);
	  },
	  _buildAxes: function (radarModel) {
	    var radar = radarModel.coordinateSystem;
	    var indicatorAxes = radar.getIndicatorAxes();
	    var axisBuilders = zrUtil.map(indicatorAxes, function (indicatorAxis) {
	      var axisBuilder = new AxisBuilder(indicatorAxis.model, {
	        position: [radar.cx, radar.cy],
	        rotation: indicatorAxis.angle,
	        labelDirection: -1,
	        tickDirection: -1,
	        nameDirection: 1
	      });
	      return axisBuilder;
	    });
	    zrUtil.each(axisBuilders, function (axisBuilder) {
	      zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	      this.group.add(axisBuilder.getGroup());
	    }, this);
	  },
	  _buildSplitLineAndArea: function (radarModel) {
	    var radar = radarModel.coordinateSystem;
	    var indicatorAxes = radar.getIndicatorAxes();
	
	    if (!indicatorAxes.length) {
	      return;
	    }
	
	    var shape = radarModel.get('shape');
	    var splitLineModel = radarModel.getModel('splitLine');
	    var splitAreaModel = radarModel.getModel('splitArea');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var showSplitLine = splitLineModel.get('show');
	    var showSplitArea = splitAreaModel.get('show');
	    var splitLineColors = lineStyleModel.get('color');
	    var splitAreaColors = areaStyleModel.get('color');
	    splitLineColors = zrUtil.isArray(splitLineColors) ? splitLineColors : [splitLineColors];
	    splitAreaColors = zrUtil.isArray(splitAreaColors) ? splitAreaColors : [splitAreaColors];
	    var splitLines = [];
	    var splitAreas = [];
	
	    function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
	      var colorIndex = idx % areaOrLineColorList.length;
	      areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
	      return colorIndex;
	    }
	
	    if (shape === 'circle') {
	      var ticksRadius = indicatorAxes[0].getTicksCoords();
	      var cx = radar.cx;
	      var cy = radar.cy;
	
	      for (var i = 0; i < ticksRadius.length; i++) {
	        if (showSplitLine) {
	          var colorIndex = getColorIndex(splitLines, splitLineColors, i);
	          splitLines[colorIndex].push(new graphic.Circle({
	            shape: {
	              cx: cx,
	              cy: cy,
	              r: ticksRadius[i]
	            }
	          }));
	        }
	
	        if (showSplitArea && i < ticksRadius.length - 1) {
	          var colorIndex = getColorIndex(splitAreas, splitAreaColors, i);
	          splitAreas[colorIndex].push(new graphic.Ring({
	            shape: {
	              cx: cx,
	              cy: cy,
	              r0: ticksRadius[i],
	              r: ticksRadius[i + 1]
	            }
	          }));
	        }
	      }
	    } // Polyyon
	    else {
	        var realSplitNumber;
	        var axesTicksPoints = zrUtil.map(indicatorAxes, function (indicatorAxis, idx) {
	          var ticksCoords = indicatorAxis.getTicksCoords();
	          realSplitNumber = realSplitNumber == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber);
	          return zrUtil.map(ticksCoords, function (tickCoord) {
	            return radar.coordToPoint(tickCoord, idx);
	          });
	        });
	        var prevPoints = [];
	
	        for (var i = 0; i <= realSplitNumber; i++) {
	          var points = [];
	
	          for (var j = 0; j < indicatorAxes.length; j++) {
	            points.push(axesTicksPoints[j][i]);
	          } // Close
	
	
	          if (points[0]) {
	            points.push(points[0].slice());
	          } else {}
	
	          if (showSplitLine) {
	            var colorIndex = getColorIndex(splitLines, splitLineColors, i);
	            splitLines[colorIndex].push(new graphic.Polyline({
	              shape: {
	                points: points
	              }
	            }));
	          }
	
	          if (showSplitArea && prevPoints) {
	            var colorIndex = getColorIndex(splitAreas, splitAreaColors, i - 1);
	            splitAreas[colorIndex].push(new graphic.Polygon({
	              shape: {
	                points: points.concat(prevPoints)
	              }
	            }));
	          }
	
	          prevPoints = points.slice().reverse();
	        }
	      }
	
	    var lineStyle = lineStyleModel.getLineStyle();
	    var areaStyle = areaStyleModel.getAreaStyle(); // Add splitArea before splitLine
	
	    zrUtil.each(splitAreas, function (splitAreas, idx) {
	      this.group.add(graphic.mergePath(splitAreas, {
	        style: zrUtil.defaults({
	          stroke: 'none',
	          fill: splitAreaColors[idx % splitAreaColors.length]
	        }, areaStyle),
	        silent: true
	      }));
	    }, this);
	    zrUtil.each(splitLines, function (splitLines, idx) {
	      this.group.add(graphic.mergePath(splitLines, {
	        style: zrUtil.defaults({
	          fill: 'none',
	          stroke: splitLineColors[idx % splitLineColors.length]
	        }, lineStyle),
	        silent: true
	      }));
	    }, this);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(127);
	
	__webpack_require__(462);

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var preprocessor = __webpack_require__(520);
	
	__webpack_require__(522);
	
	__webpack_require__(521);
	
	__webpack_require__(515);
	
	__webpack_require__(516);
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var TimelineModel = __webpack_require__(518);
	
	var modelUtil = __webpack_require__(6);
	
	var SliderTimelineModel = TimelineModel.extend({
	  type: 'timeline.slider',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 时间轴背景颜色
	    borderColor: '#ccc',
	    // 时间轴边框颜色
	    borderWidth: 0,
	    // 时间轴边框线宽，单位px，默认为0（无边框）
	    orient: 'horizontal',
	    // 'vertical'
	    inverse: false,
	    tooltip: {
	      // boolean or Object
	      trigger: 'item' // data item may also have tootip attr.
	
	    },
	    symbol: 'emptyCircle',
	    symbolSize: 10,
	    lineStyle: {
	      show: true,
	      width: 2,
	      color: '#304654'
	    },
	    label: {
	      // 文本标签
	      position: 'auto',
	      // auto left right top bottom
	      // When using number, label position is not
	      // restricted by viewRect.
	      // positive: right/bottom, negative: left/top
	      normal: {
	        show: true,
	        interval: 'auto',
	        rotate: 0,
	        // formatter: null,
	        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	        color: '#304654'
	      },
	      emphasis: {
	        show: true,
	        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	        color: '#c23531'
	      }
	    },
	    itemStyle: {
	      normal: {
	        color: '#304654',
	        borderWidth: 1
	      },
	      emphasis: {
	        color: '#c23531'
	      }
	    },
	    checkpointStyle: {
	      symbol: 'circle',
	      symbolSize: 13,
	      color: '#c23531',
	      borderWidth: 5,
	      borderColor: 'rgba(194,53,49, 0.5)',
	      animation: true,
	      animationDuration: 300,
	      animationEasing: 'quinticInOut'
	    },
	    controlStyle: {
	      show: true,
	      showPlayBtn: true,
	      showPrevBtn: true,
	      showNextBtn: true,
	      itemSize: 22,
	      itemGap: 12,
	      position: 'left',
	      // 'left' 'right' 'top' 'bottom'
	      playIcon: 'path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z',
	      // jshint ignore:line
	      stopIcon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
	      // jshint ignore:line
	      nextIcon: 'path://M18.6,50.8l22.5-22.5c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7L18.7,4.4c-0.1-0.1-0.2-0.3-0.2-0.5 c0-0.4,0.3-0.8,0.8-0.8c0.2,0,0.5,0.1,0.6,0.3l23.5,23.5l0,0c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7l-0.1,0.1L19.7,52 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.8-0.3-0.8-0.8C18.4,51.2,18.5,51,18.6,50.8z',
	      // jshint ignore:line
	      prevIcon: 'path://M43,52.8L20.4,30.3c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.3,0.1-0.5,0.3-0.7L42.9,6.4c0.1-0.1,0.2-0.3,0.2-0.5 c0-0.4-0.3-0.8-0.8-0.8c-0.2,0-0.5,0.1-0.6,0.3L18.3,28.8l0,0c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7l0.1,0.1L41.9,54 c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.8-0.3,0.8-0.8C43.2,53.2,43.1,53,43,52.8z',
	      // jshint ignore:line
	      normal: {
	        color: '#304654',
	        borderColor: '#304654',
	        borderWidth: 1
	      },
	      emphasis: {
	        color: '#c23531',
	        borderColor: '#c23531',
	        borderWidth: 2
	      }
	    },
	    data: []
	  }
	});
	zrUtil.mixin(SliderTimelineModel, modelUtil.dataFormatMixin);
	var _default = SliderTimelineModel;
	module.exports = _default;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var BoundingRect = __webpack_require__(13);
	
	var matrix = __webpack_require__(23);
	
	var graphic = __webpack_require__(3);
	
	var layout = __webpack_require__(7);
	
	var TimelineView = __webpack_require__(519);
	
	var TimelineAxis = __webpack_require__(517);
	
	var _symbol = __webpack_require__(22);
	
	var createSymbol = _symbol.createSymbol;
	
	var axisHelper = __webpack_require__(21);
	
	var numberUtil = __webpack_require__(4);
	
	var _format = __webpack_require__(9);
	
	var encodeHTML = _format.encodeHTML;
	var bind = zrUtil.bind;
	var each = zrUtil.each;
	var PI = Math.PI;
	
	var _default = TimelineView.extend({
	  type: 'timeline.slider',
	  init: function (ecModel, api) {
	    this.api = api;
	    /**
	     * @private
	     * @type {module:echarts/component/timeline/TimelineAxis}
	     */
	
	    this._axis;
	    /**
	     * @private
	     * @type {module:zrender/core/BoundingRect}
	     */
	
	    this._viewRect;
	    /**
	     * @type {number}
	     */
	
	    this._timer;
	    /**
	     * @type {module:zrender/Element}
	     */
	
	    this._currentPointer;
	    /**
	     * @type {module:zrender/container/Group}
	     */
	
	    this._mainGroup;
	    /**
	     * @type {module:zrender/container/Group}
	     */
	
	    this._labelGroup;
	  },
	
	  /**
	   * @override
	   */
	  render: function (timelineModel, ecModel, api, payload) {
	    this.model = timelineModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    this.group.removeAll();
	
	    if (timelineModel.get('show', true)) {
	      var layoutInfo = this._layout(timelineModel, api);
	
	      var mainGroup = this._createGroup('mainGroup');
	
	      var labelGroup = this._createGroup('labelGroup');
	      /**
	       * @private
	       * @type {module:echarts/component/timeline/TimelineAxis}
	       */
	
	
	      var axis = this._axis = this._createAxis(layoutInfo, timelineModel);
	
	      timelineModel.formatTooltip = function (dataIndex) {
	        return encodeHTML(axis.scale.getLabel(dataIndex));
	      };
	
	      each(['AxisLine', 'AxisTick', 'Control', 'CurrentPointer'], function (name) {
	        this['_render' + name](layoutInfo, mainGroup, axis, timelineModel);
	      }, this);
	
	      this._renderAxisLabel(layoutInfo, labelGroup, axis, timelineModel);
	
	      this._position(layoutInfo, timelineModel);
	    }
	
	    this._doPlayStop();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearTimer();
	
	    this.group.removeAll();
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clearTimer();
	  },
	  _layout: function (timelineModel, api) {
	    var labelPosOpt = timelineModel.get('label.normal.position');
	    var orient = timelineModel.get('orient');
	    var viewRect = getViewRect(timelineModel, api); // Auto label offset.
	
	    if (labelPosOpt == null || labelPosOpt === 'auto') {
	      labelPosOpt = orient === 'horizontal' ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? '-' : '+' : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? '+' : '-';
	    } else if (isNaN(labelPosOpt)) {
	      labelPosOpt = {
	        horizontal: {
	          top: '-',
	          bottom: '+'
	        },
	        vertical: {
	          left: '-',
	          right: '+'
	        }
	      }[orient][labelPosOpt];
	    }
	
	    var labelAlignMap = {
	      horizontal: 'center',
	      vertical: labelPosOpt >= 0 || labelPosOpt === '+' ? 'left' : 'right'
	    };
	    var labelBaselineMap = {
	      horizontal: labelPosOpt >= 0 || labelPosOpt === '+' ? 'top' : 'bottom',
	      vertical: 'middle'
	    };
	    var rotationMap = {
	      horizontal: 0,
	      vertical: PI / 2
	    }; // Position
	
	    var mainLength = orient === 'vertical' ? viewRect.height : viewRect.width;
	    var controlModel = timelineModel.getModel('controlStyle');
	    var showControl = controlModel.get('show');
	    var controlSize = showControl ? controlModel.get('itemSize') : 0;
	    var controlGap = showControl ? controlModel.get('itemGap') : 0;
	    var sizePlusGap = controlSize + controlGap; // Special label rotate.
	
	    var labelRotation = timelineModel.get('label.normal.rotate') || 0;
	    labelRotation = labelRotation * PI / 180; // To radian.
	
	    var playPosition;
	    var prevBtnPosition;
	    var nextBtnPosition;
	    var axisExtent;
	    var controlPosition = controlModel.get('position', true);
	    var showControl = controlModel.get('show', true);
	    var showPlayBtn = showControl && controlModel.get('showPlayBtn', true);
	    var showPrevBtn = showControl && controlModel.get('showPrevBtn', true);
	    var showNextBtn = showControl && controlModel.get('showNextBtn', true);
	    var xLeft = 0;
	    var xRight = mainLength; // position[0] means left, position[1] means middle.
	
	    if (controlPosition === 'left' || controlPosition === 'bottom') {
	      showPlayBtn && (playPosition = [0, 0], xLeft += sizePlusGap);
	      showPrevBtn && (prevBtnPosition = [xLeft, 0], xLeft += sizePlusGap);
	      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	    } else {
	      // 'top' 'right'
	      showPlayBtn && (playPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	      showPrevBtn && (prevBtnPosition = [0, 0], xLeft += sizePlusGap);
	      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	    }
	
	    axisExtent = [xLeft, xRight];
	
	    if (timelineModel.get('inverse')) {
	      axisExtent.reverse();
	    }
	
	    return {
	      viewRect: viewRect,
	      mainLength: mainLength,
	      orient: orient,
	      rotation: rotationMap[orient],
	      labelRotation: labelRotation,
	      labelPosOpt: labelPosOpt,
	      labelAlign: timelineModel.get('label.normal.align') || labelAlignMap[orient],
	      labelBaseline: timelineModel.get('label.normal.verticalAlign') || timelineModel.get('label.normal.baseline') || labelBaselineMap[orient],
	      // Based on mainGroup.
	      playPosition: playPosition,
	      prevBtnPosition: prevBtnPosition,
	      nextBtnPosition: nextBtnPosition,
	      axisExtent: axisExtent,
	      controlSize: controlSize,
	      controlGap: controlGap
	    };
	  },
	  _position: function (layoutInfo, timelineModel) {
	    // Position is be called finally, because bounding rect is needed for
	    // adapt content to fill viewRect (auto adapt offset).
	    // Timeline may be not all in the viewRect when 'offset' is specified
	    // as a number, because it is more appropriate that label aligns at
	    // 'offset' but not the other edge defined by viewRect.
	    var mainGroup = this._mainGroup;
	    var labelGroup = this._labelGroup;
	    var viewRect = layoutInfo.viewRect;
	
	    if (layoutInfo.orient === 'vertical') {
	      // transfrom to horizontal, inverse rotate by left-top point.
	      var m = matrix.create();
	      var rotateOriginX = viewRect.x;
	      var rotateOriginY = viewRect.y + viewRect.height;
	      matrix.translate(m, m, [-rotateOriginX, -rotateOriginY]);
	      matrix.rotate(m, m, -PI / 2);
	      matrix.translate(m, m, [rotateOriginX, rotateOriginY]);
	      viewRect = viewRect.clone();
	      viewRect.applyTransform(m);
	    }
	
	    var viewBound = getBound(viewRect);
	    var mainBound = getBound(mainGroup.getBoundingRect());
	    var labelBound = getBound(labelGroup.getBoundingRect());
	    var mainPosition = mainGroup.position;
	    var labelsPosition = labelGroup.position;
	    labelsPosition[0] = mainPosition[0] = viewBound[0][0];
	    var labelPosOpt = layoutInfo.labelPosOpt;
	
	    if (isNaN(labelPosOpt)) {
	      // '+' or '-'
	      var mainBoundIdx = labelPosOpt === '+' ? 0 : 1;
	      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
	      toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
	    } else {
	      var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
	      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
	      labelsPosition[1] = mainPosition[1] + labelPosOpt;
	    }
	
	    mainGroup.attr('position', mainPosition);
	    labelGroup.attr('position', labelsPosition);
	    mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
	    setOrigin(mainGroup);
	    setOrigin(labelGroup);
	
	    function setOrigin(targetGroup) {
	      var pos = targetGroup.position;
	      targetGroup.origin = [viewBound[0][0] - pos[0], viewBound[1][0] - pos[1]];
	    }
	
	    function getBound(rect) {
	      // [[xmin, xmax], [ymin, ymax]]
	      return [[rect.x, rect.x + rect.width], [rect.y, rect.y + rect.height]];
	    }
	
	    function toBound(fromPos, from, to, dimIdx, boundIdx) {
	      fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
	    }
	  },
	  _createAxis: function (layoutInfo, timelineModel) {
	    var data = timelineModel.getData();
	    var axisType = timelineModel.get('axisType');
	    var scale = axisHelper.createScaleByModel(timelineModel, axisType);
	    var dataExtent = data.getDataExtent('value');
	    scale.setExtent(dataExtent[0], dataExtent[1]);
	
	    this._customizeScale(scale, data);
	
	    scale.niceTicks();
	    var axis = new TimelineAxis('value', scale, layoutInfo.axisExtent, axisType);
	    axis.model = timelineModel;
	    return axis;
	  },
	  _customizeScale: function (scale, data) {
	    scale.getTicks = function () {
	      return data.mapArray(['value'], function (value) {
	        return value;
	      });
	    };
	
	    scale.getTicksLabels = function () {
	      return zrUtil.map(this.getTicks(), scale.getLabel, scale);
	    };
	  },
	  _createGroup: function (name) {
	    var newGroup = this['_' + name] = new graphic.Group();
	    this.group.add(newGroup);
	    return newGroup;
	  },
	  _renderAxisLine: function (layoutInfo, group, axis, timelineModel) {
	    var axisExtent = axis.getExtent();
	
	    if (!timelineModel.get('lineStyle.show')) {
	      return;
	    }
	
	    group.add(new graphic.Line({
	      shape: {
	        x1: axisExtent[0],
	        y1: 0,
	        x2: axisExtent[1],
	        y2: 0
	      },
	      style: zrUtil.extend({
	        lineCap: 'round'
	      }, timelineModel.getModel('lineStyle').getLineStyle()),
	      silent: true,
	      z2: 1
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _renderAxisTick: function (layoutInfo, group, axis, timelineModel) {
	    var data = timelineModel.getData();
	    var ticks = axis.scale.getTicks();
	    each(ticks, function (value, dataIndex) {
	      var tickCoord = axis.dataToCoord(value);
	      var itemModel = data.getItemModel(dataIndex);
	      var itemStyleModel = itemModel.getModel('itemStyle.normal');
	      var hoverStyleModel = itemModel.getModel('itemStyle.emphasis');
	      var symbolOpt = {
	        position: [tickCoord, 0],
	        onclick: bind(this._changeTimeline, this, dataIndex)
	      };
	      var el = giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
	      graphic.setHoverStyle(el, hoverStyleModel.getItemStyle());
	
	      if (itemModel.get('tooltip')) {
	        el.dataIndex = dataIndex;
	        el.dataModel = timelineModel;
	      } else {
	        el.dataIndex = el.dataModel = null;
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderAxisLabel: function (layoutInfo, group, axis, timelineModel) {
	    var labelModel = timelineModel.getModel('label.normal');
	
	    if (!labelModel.get('show')) {
	      return;
	    }
	
	    var data = timelineModel.getData();
	    var ticks = axis.scale.getTicks();
	    var labels = axisHelper.getFormattedLabels(axis, labelModel.get('formatter'));
	    var labelInterval = axis.getLabelInterval();
	    each(ticks, function (tick, dataIndex) {
	      if (axis.isLabelIgnored(dataIndex, labelInterval)) {
	        return;
	      }
	
	      var itemModel = data.getItemModel(dataIndex);
	      var normalLabelModel = itemModel.getModel('label.normal');
	      var hoverLabelModel = itemModel.getModel('label.emphasis');
	      var tickCoord = axis.dataToCoord(tick);
	      var textEl = new graphic.Text({
	        position: [tickCoord, 0],
	        rotation: layoutInfo.labelRotation - layoutInfo.rotation,
	        onclick: bind(this._changeTimeline, this, dataIndex),
	        silent: false
	      });
	      graphic.setTextStyle(textEl.style, normalLabelModel, {
	        text: labels[dataIndex],
	        textAlign: layoutInfo.labelAlign,
	        textVerticalAlign: layoutInfo.labelBaseline
	      });
	      group.add(textEl);
	      graphic.setHoverStyle(textEl, graphic.setTextStyle({}, hoverLabelModel));
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderControl: function (layoutInfo, group, axis, timelineModel) {
	    var controlSize = layoutInfo.controlSize;
	    var rotation = layoutInfo.rotation;
	    var itemStyle = timelineModel.getModel('controlStyle.normal').getItemStyle();
	    var hoverStyle = timelineModel.getModel('controlStyle.emphasis').getItemStyle();
	    var rect = [0, -controlSize / 2, controlSize, controlSize];
	    var playState = timelineModel.getPlayState();
	    var inverse = timelineModel.get('inverse', true);
	    makeBtn(layoutInfo.nextBtnPosition, 'controlStyle.nextIcon', bind(this._changeTimeline, this, inverse ? '-' : '+'));
	    makeBtn(layoutInfo.prevBtnPosition, 'controlStyle.prevIcon', bind(this._changeTimeline, this, inverse ? '+' : '-'));
	    makeBtn(layoutInfo.playPosition, 'controlStyle.' + (playState ? 'stopIcon' : 'playIcon'), bind(this._handlePlayClick, this, !playState), true);
	
	    function makeBtn(position, iconPath, onclick, willRotate) {
	      if (!position) {
	        return;
	      }
	
	      var opt = {
	        position: position,
	        origin: [controlSize / 2, 0],
	        rotation: willRotate ? -rotation : 0,
	        rectHover: true,
	        style: itemStyle,
	        onclick: onclick
	      };
	      var btn = makeIcon(timelineModel, iconPath, rect, opt);
	      group.add(btn);
	      graphic.setHoverStyle(btn, hoverStyle);
	    }
	  },
	  _renderCurrentPointer: function (layoutInfo, group, axis, timelineModel) {
	    var data = timelineModel.getData();
	    var currentIndex = timelineModel.getCurrentIndex();
	    var pointerModel = data.getItemModel(currentIndex).getModel('checkpointStyle');
	    var me = this;
	    var callback = {
	      onCreate: function (pointer) {
	        pointer.draggable = true;
	        pointer.drift = bind(me._handlePointerDrag, me);
	        pointer.ondragend = bind(me._handlePointerDragend, me);
	        pointerMoveTo(pointer, currentIndex, axis, timelineModel, true);
	      },
	      onUpdate: function (pointer) {
	        pointerMoveTo(pointer, currentIndex, axis, timelineModel);
	      }
	    }; // Reuse when exists, for animation and drag.
	
	    this._currentPointer = giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
	  },
	  _handlePlayClick: function (nextState) {
	    this._clearTimer();
	
	    this.api.dispatchAction({
	      type: 'timelinePlayChange',
	      playState: nextState,
	      from: this.uid
	    });
	  },
	  _handlePointerDrag: function (dx, dy, e) {
	    this._clearTimer();
	
	    this._pointerChangeTimeline([e.offsetX, e.offsetY]);
	  },
	  _handlePointerDragend: function (e) {
	    this._pointerChangeTimeline([e.offsetX, e.offsetY], true);
	  },
	  _pointerChangeTimeline: function (mousePos, trigger) {
	    var toCoord = this._toAxisCoord(mousePos)[0];
	
	    var axis = this._axis;
	    var axisExtent = numberUtil.asc(axis.getExtent().slice());
	    toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
	    toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
	    this._currentPointer.position[0] = toCoord;
	
	    this._currentPointer.dirty();
	
	    var targetDataIndex = this._findNearestTick(toCoord);
	
	    var timelineModel = this.model;
	
	    if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get('realtime')) {
	      this._changeTimeline(targetDataIndex);
	    }
	  },
	  _doPlayStop: function () {
	    this._clearTimer();
	
	    if (this.model.getPlayState()) {
	      this._timer = setTimeout(bind(handleFrame, this), this.model.get('playInterval'));
	    }
	
	    function handleFrame() {
	      // Do not cache
	      var timelineModel = this.model;
	
	      this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get('rewind', true) ? -1 : 1));
	    }
	  },
	  _toAxisCoord: function (vertex) {
	    var trans = this._mainGroup.getLocalTransform();
	
	    return graphic.applyTransform(vertex, trans, true);
	  },
	  _findNearestTick: function (axisCoord) {
	    var data = this.model.getData();
	    var dist = Infinity;
	    var targetDataIndex;
	    var axis = this._axis;
	    data.each(['value'], function (value, dataIndex) {
	      var coord = axis.dataToCoord(value);
	      var d = Math.abs(coord - axisCoord);
	
	      if (d < dist) {
	        dist = d;
	        targetDataIndex = dataIndex;
	      }
	    });
	    return targetDataIndex;
	  },
	  _clearTimer: function () {
	    if (this._timer) {
	      clearTimeout(this._timer);
	      this._timer = null;
	    }
	  },
	  _changeTimeline: function (nextIndex) {
	    var currentIndex = this.model.getCurrentIndex();
	
	    if (nextIndex === '+') {
	      nextIndex = currentIndex + 1;
	    } else if (nextIndex === '-') {
	      nextIndex = currentIndex - 1;
	    }
	
	    this.api.dispatchAction({
	      type: 'timelineChange',
	      currentIndex: nextIndex,
	      from: this.uid
	    });
	  }
	});
	
	function getViewRect(model, api) {
	  return layout.getLayoutRect(model.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  }, model.get('padding'));
	}
	
	function makeIcon(timelineModel, objPath, rect, opts) {
	  var icon = graphic.makePath(timelineModel.get(objPath).replace(/^path:\/\//, ''), zrUtil.clone(opts || {}), new BoundingRect(rect[0], rect[1], rect[2], rect[3]), 'center');
	  return icon;
	}
	/**
	 * Create symbol or update symbol
	 * opt: basic position and event handlers
	 */
	
	
	function giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
	  var color = itemStyleModel.get('color');
	
	  if (!symbol) {
	    var symbolType = hostModel.get('symbol');
	    symbol = createSymbol(symbolType, -1, -1, 2, 2, color);
	    symbol.setStyle('strokeNoScale', true);
	    group.add(symbol);
	    callback && callback.onCreate(symbol);
	  } else {
	    symbol.setColor(color);
	    group.add(symbol); // Group may be new, also need to add.
	
	    callback && callback.onUpdate(symbol);
	  } // Style
	
	
	  var itemStyle = itemStyleModel.getItemStyle(['color', 'symbol', 'symbolSize']);
	  symbol.setStyle(itemStyle); // Transform and events.
	
	  opt = zrUtil.merge({
	    rectHover: true,
	    z2: 100
	  }, opt, true);
	  var symbolSize = hostModel.get('symbolSize');
	  symbolSize = symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
	  symbolSize[0] /= 2;
	  symbolSize[1] /= 2;
	  opt.scale = symbolSize;
	  var symbolOffset = hostModel.get('symbolOffset');
	
	  if (symbolOffset) {
	    var pos = opt.position = opt.position || [0, 0];
	    pos[0] += numberUtil.parsePercent(symbolOffset[0], symbolSize[0]);
	    pos[1] += numberUtil.parsePercent(symbolOffset[1], symbolSize[1]);
	  }
	
	  var symbolRotate = hostModel.get('symbolRotate');
	  opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	  symbol.attr(opt); // FIXME
	  // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
	  // getBoundingRect will return wrong result.
	  // (This is supposed to be resolved in zrender, but it is a little difficult to
	  // leverage performance and auto updateTransform)
	  // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.
	
	  symbol.updateTransform();
	  return symbol;
	}
	
	function pointerMoveTo(pointer, dataIndex, axis, timelineModel, noAnimation) {
	  if (pointer.dragging) {
	    return;
	  }
	
	  var pointerModel = timelineModel.getModel('checkpointStyle');
	  var toCoord = axis.dataToCoord(timelineModel.getData().get(['value'], dataIndex));
	
	  if (noAnimation || !pointerModel.get('animation', true)) {
	    pointer.attr({
	      position: [toCoord, 0]
	    });
	  } else {
	    pointer.stopAnimation(true);
	    pointer.animateTo({
	      position: [toCoord, 0]
	    }, pointerModel.get('animationDuration', true), pointerModel.get('animationEasing', true));
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Axis = __webpack_require__(36);
	
	var axisHelper = __webpack_require__(21);
	
	/**
	 * Extend axis 2d
	 * @constructor module:echarts/coord/cartesian/Axis2D
	 * @extends {module:echarts/coord/cartesian/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var TimelineAxis = function (dim, scale, coordExtent, axisType) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * @private
	   * @type {number}
	   */
	
	  this._autoLabelInterval;
	  /**
	   * Axis model
	   * @param {module:echarts/component/TimelineModel}
	   */
	
	  this.model = null;
	};
	
	TimelineAxis.prototype = {
	  constructor: TimelineAxis,
	
	  /**
	   * @public
	   * @return {number}
	   */
	  getLabelInterval: function () {
	    var timelineModel = this.model;
	    var labelModel = timelineModel.getModel('label.normal');
	    var labelInterval = labelModel.get('interval');
	
	    if (labelInterval != null && labelInterval != 'auto') {
	      return labelInterval;
	    }
	
	    var labelInterval = this._autoLabelInterval;
	
	    if (!labelInterval) {
	      labelInterval = this._autoLabelInterval = axisHelper.getAxisLabelInterval(zrUtil.map(this.scale.getTicks(), this.dataToCoord, this), axisHelper.getFormattedLabels(this, labelModel.get('formatter')), labelModel.getFont(), timelineModel.get('orient') === 'horizontal' ? 0 : 90, labelModel.get('rotate'));
	    }
	
	    return labelInterval;
	  },
	
	  /**
	   * If label is ignored.
	   * Automatically used when axis is category and label can not be all shown
	   * @public
	   * @param  {number} idx
	   * @return {boolean}
	   */
	  isLabelIgnored: function (idx) {
	    if (this.type === 'category') {
	      var labelInterval = this.getLabelInterval();
	      return typeof labelInterval === 'function' && !labelInterval(idx, this.scale.getLabel(idx)) || idx % (labelInterval + 1);
	    }
	  }
	};
	zrUtil.inherits(TimelineAxis, Axis);
	var _default = TimelineAxis;
	module.exports = _default;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var ComponentModel = __webpack_require__(16);
	
	var List = __webpack_require__(15);
	
	var modelUtil = __webpack_require__(6);
	
	var TimelineModel = ComponentModel.extend({
	  type: 'timeline',
	  layoutMode: 'box',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 4,
	    // 二级层叠
	    show: true,
	    axisType: 'time',
	    // 模式是时间类型，支持 value, category
	    realtime: true,
	    left: '20%',
	    top: null,
	    right: '20%',
	    bottom: 0,
	    width: null,
	    height: 40,
	    padding: 5,
	    controlPosition: 'left',
	    // 'left' 'right' 'top' 'bottom' 'none'
	    autoPlay: false,
	    rewind: false,
	    // 反向播放
	    loop: true,
	    playInterval: 2000,
	    // 播放时间间隔，单位ms
	    currentIndex: 0,
	    itemStyle: {
	      normal: {},
	      emphasis: {}
	    },
	    label: {
	      normal: {
	        color: '#000'
	      },
	      emphasis: {}
	    },
	    data: []
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * @private
	     * @type {module:echarts/data/List}
	     */
	    this._data;
	    /**
	     * @private
	     * @type {Array.<string>}
	     */
	
	    this._names;
	    this.mergeDefaultAndTheme(option, ecModel);
	
	    this._initData();
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option) {
	    TimelineModel.superApply(this, 'mergeOption', arguments);
	
	    this._initData();
	  },
	
	  /**
	   * @param {number} [currentIndex]
	   */
	  setCurrentIndex: function (currentIndex) {
	    if (currentIndex == null) {
	      currentIndex = this.option.currentIndex;
	    }
	
	    var count = this._data.count();
	
	    if (this.option.loop) {
	      currentIndex = (currentIndex % count + count) % count;
	    } else {
	      currentIndex >= count && (currentIndex = count - 1);
	      currentIndex < 0 && (currentIndex = 0);
	    }
	
	    this.option.currentIndex = currentIndex;
	  },
	
	  /**
	   * @return {number} currentIndex
	   */
	  getCurrentIndex: function () {
	    return this.option.currentIndex;
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isIndexMax: function () {
	    return this.getCurrentIndex() >= this._data.count() - 1;
	  },
	
	  /**
	   * @param {boolean} state true: play, false: stop
	   */
	  setPlayState: function (state) {
	    this.option.autoPlay = !!state;
	  },
	
	  /**
	   * @return {boolean} true: play, false: stop
	   */
	  getPlayState: function () {
	    return !!this.option.autoPlay;
	  },
	
	  /**
	   * @private
	   */
	  _initData: function () {
	    var thisOption = this.option;
	    var dataArr = thisOption.data || [];
	    var axisType = thisOption.axisType;
	    var names = this._names = [];
	
	    if (axisType === 'category') {
	      var idxArr = [];
	      zrUtil.each(dataArr, function (item, index) {
	        var value = modelUtil.getDataItemValue(item);
	        var newItem;
	
	        if (zrUtil.isObject(item)) {
	          newItem = zrUtil.clone(item);
	          newItem.value = index;
	        } else {
	          newItem = index;
	        }
	
	        idxArr.push(newItem);
	
	        if (!zrUtil.isString(value) && (value == null || isNaN(value))) {
	          value = '';
	        }
	
	        names.push(value + '');
	      });
	      dataArr = idxArr;
	    }
	
	    var dimType = {
	      category: 'ordinal',
	      time: 'time'
	    }[axisType] || 'number';
	    var data = this._data = new List([{
	      name: 'value',
	      type: dimType
	    }], this);
	    data.initData(dataArr, names);
	  },
	  getData: function () {
	    return this._data;
	  },
	
	  /**
	   * @public
	   * @return {Array.<string>} categoreis
	   */
	  getCategories: function () {
	    if (this.get('axisType') === 'category') {
	      return this._names.slice();
	    }
	  }
	});
	var _default = TimelineModel;
	module.exports = _default;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	var ComponentView = __webpack_require__(131);
	
	var _default = ComponentView.extend({
	  type: 'timeline'
	});
	
	module.exports = _default;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	function _default(option) {
	  var timelineOpt = option && option.timeline;
	
	  if (!zrUtil.isArray(timelineOpt)) {
	    timelineOpt = timelineOpt ? [timelineOpt] : [];
	  }
	
	  zrUtil.each(timelineOpt, function (opt) {
	    if (!opt) {
	      return;
	    }
	
	    compatibleEC2(opt);
	  });
	}
	
	function compatibleEC2(opt) {
	  var type = opt.type;
	  var ec2Types = {
	    'number': 'value',
	    'time': 'time'
	  }; // Compatible with ec2
	
	  if (ec2Types[type]) {
	    opt.axisType = ec2Types[type];
	    delete opt.type;
	  }
	
	  transferItem(opt);
	
	  if (has(opt, 'controlPosition')) {
	    var controlStyle = opt.controlStyle || (opt.controlStyle = {});
	
	    if (!has(controlStyle, 'position')) {
	      controlStyle.position = opt.controlPosition;
	    }
	
	    if (controlStyle.position === 'none' && !has(controlStyle, 'show')) {
	      controlStyle.show = false;
	      delete controlStyle.position;
	    }
	
	    delete opt.controlPosition;
	  }
	
	  zrUtil.each(opt.data || [], function (dataItem) {
	    if (zrUtil.isObject(dataItem) && !zrUtil.isArray(dataItem)) {
	      if (!has(dataItem, 'value') && has(dataItem, 'name')) {
	        // In ec2, using name as value.
	        dataItem.value = dataItem.name;
	      }
	
	      transferItem(dataItem);
	    }
	  });
	}
	
	function transferItem(opt) {
	  var itemStyle = opt.itemStyle || (opt.itemStyle = {});
	  var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {}); // Transfer label out
	
	  var label = opt.label || opt.label || {};
	  var labelNormal = label.normal || (label.normal = {});
	  var excludeLabelAttr = {
	    normal: 1,
	    emphasis: 1
	  };
	  zrUtil.each(label, function (value, name) {
	    if (!excludeLabelAttr[name] && !has(labelNormal, name)) {
	      labelNormal[name] = value;
	    }
	  });
	
	  if (itemStyleEmphasis.label && !has(label, 'emphasis')) {
	    label.emphasis = itemStyleEmphasis.label;
	    delete itemStyleEmphasis.label;
	  }
	}
	
	function has(obj, attr) {
	  return obj.hasOwnProperty(attr);
	}
	
	module.exports = _default;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	echarts.registerAction({
	  type: 'timelineChange',
	  event: 'timelineChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  var timelineModel = ecModel.getComponent('timeline');
	
	  if (timelineModel && payload.currentIndex != null) {
	    timelineModel.setCurrentIndex(payload.currentIndex);
	
	    if (!timelineModel.get('loop', true) && timelineModel.isIndexMax()) {
	      timelineModel.setPlayState(false);
	    }
	  } // Set normalized currentIndex to payload.
	
	
	  ecModel.resetOption('timeline');
	  return zrUtil.defaults({
	    currentIndex: timelineModel.option.currentIndex
	  }, payload);
	});
	echarts.registerAction({
	  type: 'timelinePlayChange',
	  event: 'timelinePlayChanged',
	  update: 'update'
	}, function (payload, ecModel) {
	  var timelineModel = ecModel.getComponent('timeline');
	
	  if (timelineModel && payload.playState != null) {
	    timelineModel.setPlayState(payload.playState);
	  }
	});

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(16);
	
	Component.registerSubTypeDefaulter('timeline', function () {
	  // Only slider now.
	  return 'slider';
	});

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var graphic = __webpack_require__(3);
	
	var _layout = __webpack_require__(7);
	
	var getLayoutRect = _layout.getLayoutRect;
	// Model
	echarts.extendComponentModel({
	  type: 'title',
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 6,
	    show: true,
	    text: '',
	    // 超链接跳转
	    // link: null,
	    // 仅支持self | blank
	    target: 'blank',
	    subtext: '',
	    // 超链接跳转
	    // sublink: null,
	    // 仅支持self | blank
	    subtarget: 'blank',
	    // 'center' ¦ 'left' ¦ 'right'
	    // ¦ {number}（x坐标，单位px）
	    left: 0,
	    // 'top' ¦ 'bottom' ¦ 'center'
	    // ¦ {number}（y坐标，单位px）
	    top: 0,
	    // 水平对齐
	    // 'auto' | 'left' | 'right' | 'center'
	    // 默认根据 left 的位置判断是左对齐还是右对齐
	    // textAlign: null
	    //
	    // 垂直对齐
	    // 'auto' | 'top' | 'bottom' | 'middle'
	    // 默认根据 top 位置判断是上对齐还是下对齐
	    // textBaseline: null
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 标题边框颜色
	    borderColor: '#ccc',
	    // 标题边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 标题内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // 主副标题纵向间隔，单位px，默认为10，
	    itemGap: 10,
	    textStyle: {
	      fontSize: 18,
	      fontWeight: 'bolder',
	      color: '#333'
	    },
	    subtextStyle: {
	      color: '#aaa'
	    }
	  }
	}); // View
	
	echarts.extendComponentView({
	  type: 'title',
	  render: function (titleModel, ecModel, api) {
	    this.group.removeAll();
	
	    if (!titleModel.get('show')) {
	      return;
	    }
	
	    var group = this.group;
	    var textStyleModel = titleModel.getModel('textStyle');
	    var subtextStyleModel = titleModel.getModel('subtextStyle');
	    var textAlign = titleModel.get('textAlign');
	    var textBaseline = titleModel.get('textBaseline');
	    var textEl = new graphic.Text({
	      style: graphic.setTextStyle({}, textStyleModel, {
	        text: titleModel.get('text'),
	        textFill: textStyleModel.getTextColor()
	      }, {
	        disableBox: true
	      }),
	      z2: 10
	    });
	    var textRect = textEl.getBoundingRect();
	    var subText = titleModel.get('subtext');
	    var subTextEl = new graphic.Text({
	      style: graphic.setTextStyle({}, subtextStyleModel, {
	        text: subText,
	        textFill: subtextStyleModel.getTextColor(),
	        y: textRect.height + titleModel.get('itemGap'),
	        textVerticalAlign: 'top'
	      }, {
	        disableBox: true
	      }),
	      z2: 10
	    });
	    var link = titleModel.get('link');
	    var sublink = titleModel.get('sublink');
	    textEl.silent = !link;
	    subTextEl.silent = !sublink;
	
	    if (link) {
	      textEl.on('click', function () {
	        window.open(link, '_' + titleModel.get('target'));
	      });
	    }
	
	    if (sublink) {
	      subTextEl.on('click', function () {
	        window.open(sublink, '_' + titleModel.get('subtarget'));
	      });
	    }
	
	    group.add(textEl);
	    subText && group.add(subTextEl); // If no subText, but add subTextEl, there will be an empty line.
	
	    var groupRect = group.getBoundingRect();
	    var layoutOption = titleModel.getBoxLayoutParams();
	    layoutOption.width = groupRect.width;
	    layoutOption.height = groupRect.height;
	    var layoutRect = getLayoutRect(layoutOption, {
	      width: api.getWidth(),
	      height: api.getHeight()
	    }, titleModel.get('padding')); // Adjust text align based on position
	
	    if (!textAlign) {
	      // Align left if title is on the left. center and right is same
	      textAlign = titleModel.get('left') || titleModel.get('right');
	
	      if (textAlign === 'middle') {
	        textAlign = 'center';
	      } // Adjust layout by text align
	
	
	      if (textAlign === 'right') {
	        layoutRect.x += layoutRect.width;
	      } else if (textAlign === 'center') {
	        layoutRect.x += layoutRect.width / 2;
	      }
	    }
	
	    if (!textBaseline) {
	      textBaseline = titleModel.get('top') || titleModel.get('bottom');
	
	      if (textBaseline === 'center') {
	        textBaseline = 'middle';
	      }
	
	      if (textBaseline === 'bottom') {
	        layoutRect.y += layoutRect.height;
	      } else if (textBaseline === 'middle') {
	        layoutRect.y += layoutRect.height / 2;
	      }
	
	      textBaseline = textBaseline || 'top';
	    }
	
	    group.attr('position', [layoutRect.x, layoutRect.y]);
	    var alignStyle = {
	      textAlign: textAlign,
	      textVerticalAlign: textBaseline
	    };
	    textEl.setStyle(alignStyle);
	    subTextEl.setStyle(alignStyle); // Render background
	    // Get groupRect again because textAlign has been changed
	
	    groupRect = group.getBoundingRect();
	    var padding = layoutRect.margin;
	    var style = titleModel.getItemStyle(['color', 'opacity']);
	    style.fill = titleModel.get('backgroundColor');
	    var rect = new graphic.Rect({
	      shape: {
	        x: groupRect.x - padding[3],
	        y: groupRect.y - padding[0],
	        width: groupRect.width + padding[1] + padding[3],
	        height: groupRect.height + padding[0] + padding[2],
	        r: titleModel.get('borderRadius')
	      },
	      style: style,
	      silent: true
	    });
	    graphic.subPixelOptimizeRect(rect);
	    group.add(rect);
	  }
	});

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(525);
	
	__webpack_require__(526);
	
	__webpack_require__(532);
	
	__webpack_require__(530);
	
	__webpack_require__(528);
	
	__webpack_require__(529);
	
	__webpack_require__(531);

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var featureManager = __webpack_require__(35);
	
	var ToolboxModel = echarts.extendComponentModel({
	  type: 'toolbox',
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	  mergeDefaultAndTheme: function (option) {
	    ToolboxModel.superApply(this, 'mergeDefaultAndTheme', arguments);
	    zrUtil.each(this.option.feature, function (featureOpt, featureName) {
	      var Feature = featureManager.get(featureName);
	      Feature && zrUtil.merge(featureOpt, Feature.defaultOption);
	    });
	  },
	  defaultOption: {
	    show: true,
	    z: 6,
	    zlevel: 0,
	    orient: 'horizontal',
	    left: 'right',
	    top: 'top',
	    // right
	    // bottom
	    backgroundColor: 'transparent',
	    borderColor: '#ccc',
	    borderRadius: 0,
	    borderWidth: 0,
	    padding: 5,
	    itemSize: 15,
	    itemGap: 8,
	    showTitle: true,
	    iconStyle: {
	      normal: {
	        borderColor: '#666',
	        color: 'none'
	      },
	      emphasis: {
	        borderColor: '#3E98C5'
	      } // textStyle: {},
	      // feature
	
	    }
	  }
	});
	var _default = ToolboxModel;
	module.exports = _default;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var textContain = __webpack_require__(27);
	
	var featureManager = __webpack_require__(35);
	
	var graphic = __webpack_require__(3);
	
	var Model = __webpack_require__(14);
	
	var DataDiffer = __webpack_require__(56);
	
	var listComponentHelper = __webpack_require__(180);
	
	var _default = echarts.extendComponentView({
	  type: 'toolbox',
	  render: function (toolboxModel, ecModel, api, payload) {
	    var group = this.group;
	    group.removeAll();
	
	    if (!toolboxModel.get('show')) {
	      return;
	    }
	
	    var itemSize = +toolboxModel.get('itemSize');
	    var featureOpts = toolboxModel.get('feature') || {};
	    var features = this._features || (this._features = {});
	    var featureNames = [];
	    zrUtil.each(featureOpts, function (opt, name) {
	      featureNames.push(name);
	    });
	    new DataDiffer(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove(zrUtil.curry(processFeature, null)).execute(); // Keep for diff.
	
	    this._featureNames = featureNames;
	
	    function processFeature(newIndex, oldIndex) {
	      var featureName = featureNames[newIndex];
	      var oldName = featureNames[oldIndex];
	      var featureOpt = featureOpts[featureName];
	      var featureModel = new Model(featureOpt, toolboxModel, toolboxModel.ecModel);
	      var feature;
	
	      if (featureName && !oldName) {
	        // Create
	        if (isUserFeatureName(featureName)) {
	          feature = {
	            model: featureModel,
	            onclick: featureModel.option.onclick,
	            featureName: featureName
	          };
	        } else {
	          var Feature = featureManager.get(featureName);
	
	          if (!Feature) {
	            return;
	          }
	
	          feature = new Feature(featureModel, ecModel, api);
	        }
	
	        features[featureName] = feature;
	      } else {
	        feature = features[oldName]; // If feature does not exsit.
	
	        if (!feature) {
	          return;
	        }
	
	        feature.model = featureModel;
	        feature.ecModel = ecModel;
	        feature.api = api;
	      }
	
	      if (!featureName && oldName) {
	        feature.dispose && feature.dispose(ecModel, api);
	        return;
	      }
	
	      if (!featureModel.get('show') || feature.unusable) {
	        feature.remove && feature.remove(ecModel, api);
	        return;
	      }
	
	      createIconPaths(featureModel, feature, featureName);
	
	      featureModel.setIconStatus = function (iconName, status) {
	        var option = this.option;
	        var iconPaths = this.iconPaths;
	        option.iconStatus = option.iconStatus || {};
	        option.iconStatus[iconName] = status; // FIXME
	
	        iconPaths[iconName] && iconPaths[iconName].trigger(status);
	      };
	
	      if (feature.render) {
	        feature.render(featureModel, ecModel, api, payload);
	      }
	    }
	
	    function createIconPaths(featureModel, feature, featureName) {
	      var iconStyleModel = featureModel.getModel('iconStyle'); // If one feature has mutiple icon. they are orginaized as
	      // {
	      //     icon: {
	      //         foo: '',
	      //         bar: ''
	      //     },
	      //     title: {
	      //         foo: '',
	      //         bar: ''
	      //     }
	      // }
	
	      var icons = feature.getIcons ? feature.getIcons() : featureModel.get('icon');
	      var titles = featureModel.get('title') || {};
	
	      if (typeof icons === 'string') {
	        var icon = icons;
	        var title = titles;
	        icons = {};
	        titles = {};
	        icons[featureName] = icon;
	        titles[featureName] = title;
	      }
	
	      var iconPaths = featureModel.iconPaths = {};
	      zrUtil.each(icons, function (iconStr, iconName) {
	        var path = graphic.createIcon(iconStr, {}, {
	          x: -itemSize / 2,
	          y: -itemSize / 2,
	          width: itemSize,
	          height: itemSize
	        });
	        path.setStyle(iconStyleModel.getModel('normal').getItemStyle());
	        path.hoverStyle = iconStyleModel.getModel('emphasis').getItemStyle();
	        graphic.setHoverStyle(path);
	
	        if (toolboxModel.get('showTitle')) {
	          path.__title = titles[iconName];
	          path.on('mouseover', function () {
	            // Should not reuse above hoverStyle, which might be modified.
	            var hoverStyle = iconStyleModel.getModel('emphasis').getItemStyle();
	            path.setStyle({
	              text: titles[iconName],
	              textPosition: hoverStyle.textPosition || 'bottom',
	              textFill: hoverStyle.fill || hoverStyle.stroke || '#000',
	              textAlign: hoverStyle.textAlign || 'center'
	            });
	          }).on('mouseout', function () {
	            path.setStyle({
	              textFill: null
	            });
	          });
	        }
	
	        path.trigger(featureModel.get('iconStatus.' + iconName) || 'normal');
	        group.add(path);
	        path.on('click', zrUtil.bind(feature.onclick, feature, ecModel, api, iconName));
	        iconPaths[iconName] = path;
	      });
	    }
	
	    listComponentHelper.layout(group, toolboxModel, api); // Render background after group is layout
	    // FIXME
	
	    group.add(listComponentHelper.makeBackground(group.getBoundingRect(), toolboxModel)); // Adjust icon title positions to avoid them out of screen
	
	    group.eachChild(function (icon) {
	      var titleText = icon.__title;
	      var hoverStyle = icon.hoverStyle; // May be background element
	
	      if (hoverStyle && titleText) {
	        var rect = textContain.getBoundingRect(titleText, textContain.makeFont(hoverStyle));
	        var offsetX = icon.position[0] + group.position[0];
	        var offsetY = icon.position[1] + group.position[1] + itemSize;
	        var needPutOnTop = false;
	
	        if (offsetY + rect.height > api.getHeight()) {
	          hoverStyle.textPosition = 'top';
	          needPutOnTop = true;
	        }
	
	        var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 8;
	
	        if (offsetX + rect.width / 2 > api.getWidth()) {
	          hoverStyle.textPosition = ['100%', topOffset];
	          hoverStyle.textAlign = 'right';
	        } else if (offsetX - rect.width / 2 < 0) {
	          hoverStyle.textPosition = [0, topOffset];
	          hoverStyle.textAlign = 'left';
	        }
	      }
	    });
	  },
	  updateView: function (toolboxModel, ecModel, api, payload) {
	    zrUtil.each(this._features, function (feature) {
	      feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
	    });
	  },
	  updateLayout: function (toolboxModel, ecModel, api, payload) {
	    zrUtil.each(this._features, function (feature) {
	      feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
	    });
	  },
	  remove: function (ecModel, api) {
	    zrUtil.each(this._features, function (feature) {
	      feature.remove && feature.remove(ecModel, api);
	    });
	    this.group.removeAll();
	  },
	  dispose: function (ecModel, api) {
	    zrUtil.each(this._features, function (feature) {
	      feature.dispose && feature.dispose(ecModel, api);
	    });
	  }
	});
	
	function isUserFeatureName(featureName) {
	  return featureName.indexOf('my') === 0;
	}
	
	module.exports = _default;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var featureManager = __webpack_require__(35);
	
	var lang = __webpack_require__(57);
	
	var brushLang = lang.toolbox.brush;
	
	function Brush(model, ecModel, api) {
	  this.model = model;
	  this.ecModel = ecModel;
	  this.api = api;
	  /**
	   * @private
	   * @type {string}
	   */
	
	  this._brushType;
	  /**
	   * @private
	   * @type {string}
	   */
	
	  this._brushMode;
	}
	
	Brush.defaultOption = {
	  show: true,
	  type: ['rect', 'polygon', 'lineX', 'lineY', 'keep', 'clear'],
	  icon: {
	    rect: 'M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13',
	    // jshint ignore:line
	    polygon: 'M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2',
	    // jshint ignore:line
	    lineX: 'M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4',
	    // jshint ignore:line
	    lineY: 'M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4',
	    // jshint ignore:line
	    keep: 'M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z',
	    // jshint ignore:line
	    clear: 'M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2' // jshint ignore:line
	
	  },
	  // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
	  title: zrUtil.clone(brushLang.title)
	};
	var proto = Brush.prototype;
	
	proto.render = proto.updateView = proto.updateLayout = function (featureModel, ecModel, api) {
	  var brushType;
	  var brushMode;
	  var isBrushed;
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel) {
	    brushType = brushModel.brushType;
	    brushMode = brushModel.brushOption.brushMode || 'single';
	    isBrushed |= brushModel.areas.length;
	  });
	  this._brushType = brushType;
	  this._brushMode = brushMode;
	  zrUtil.each(featureModel.get('type', true), function (type) {
	    featureModel.setIconStatus(type, (type === 'keep' ? brushMode === 'multiple' : type === 'clear' ? isBrushed : type === brushType) ? 'emphasis' : 'normal');
	  });
	};
	
	proto.getIcons = function () {
	  var model = this.model;
	  var availableIcons = model.get('icon', true);
	  var icons = {};
	  zrUtil.each(model.get('type', true), function (type) {
	    if (availableIcons[type]) {
	      icons[type] = availableIcons[type];
	    }
	  });
	  return icons;
	};
	
	proto.onclick = function (ecModel, api, type) {
	  var brushType = this._brushType;
	  var brushMode = this._brushMode;
	
	  if (type === 'clear') {
	    // Trigger parallel action firstly
	    api.dispatchAction({
	      type: 'axisAreaSelect',
	      intervals: []
	    });
	    api.dispatchAction({
	      type: 'brush',
	      command: 'clear',
	      // Clear all areas of all brush components.
	      areas: []
	    });
	  } else {
	    api.dispatchAction({
	      type: 'takeGlobalCursor',
	      key: 'brush',
	      brushOption: {
	        brushType: type === 'keep' ? brushType : brushType === type ? false : type,
	        brushMode: type === 'keep' ? brushMode === 'multiple' ? 'single' : 'multiple' : brushMode
	      }
	    });
	  }
	};
	
	featureManager.register('brush', Brush);
	var _default = Brush;
	module.exports = _default;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var eventTool = __webpack_require__(30);
	
	var lang = __webpack_require__(57);
	
	var featureManager = __webpack_require__(35);
	
	var dataViewLang = lang.toolbox.dataView;
	var BLOCK_SPLITER = new Array(60).join('-');
	var ITEM_SPLITER = '\t';
	/**
	 * Group series into two types
	 *  1. on category axis, like line, bar
	 *  2. others, like scatter, pie
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object}
	 * @inner
	 */
	
	function groupSeries(ecModel) {
	  var seriesGroupByCategoryAxis = {};
	  var otherSeries = [];
	  var meta = [];
	  ecModel.eachRawSeries(function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && (coordSys.type === 'cartesian2d' || coordSys.type === 'polar')) {
	      var baseAxis = coordSys.getBaseAxis();
	
	      if (baseAxis.type === 'category') {
	        var key = baseAxis.dim + '_' + baseAxis.index;
	
	        if (!seriesGroupByCategoryAxis[key]) {
	          seriesGroupByCategoryAxis[key] = {
	            categoryAxis: baseAxis,
	            valueAxis: coordSys.getOtherAxis(baseAxis),
	            series: []
	          };
	          meta.push({
	            axisDim: baseAxis.dim,
	            axisIndex: baseAxis.index
	          });
	        }
	
	        seriesGroupByCategoryAxis[key].series.push(seriesModel);
	      } else {
	        otherSeries.push(seriesModel);
	      }
	    } else {
	      otherSeries.push(seriesModel);
	    }
	  });
	  return {
	    seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
	    other: otherSeries,
	    meta: meta
	  };
	}
	/**
	 * Assemble content of series on cateogory axis
	 * @param {Array.<module:echarts/model/Series>} series
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleSeriesWithCategoryAxis(series) {
	  var tables = [];
	  zrUtil.each(series, function (group, key) {
	    var categoryAxis = group.categoryAxis;
	    var valueAxis = group.valueAxis;
	    var valueAxisDim = valueAxis.dim;
	    var headers = [' '].concat(zrUtil.map(group.series, function (series) {
	      return series.name;
	    }));
	    var columns = [categoryAxis.model.getCategories()];
	    zrUtil.each(group.series, function (series) {
	      columns.push(series.getRawData().mapArray(valueAxisDim, function (val) {
	        return val;
	      }));
	    }); // Assemble table content
	
	    var lines = [headers.join(ITEM_SPLITER)];
	
	    for (var i = 0; i < columns[0].length; i++) {
	      var items = [];
	
	      for (var j = 0; j < columns.length; j++) {
	        items.push(columns[j][i]);
	      }
	
	      lines.push(items.join(ITEM_SPLITER));
	    }
	
	    tables.push(lines.join('\n'));
	  });
	  return tables.join('\n\n' + BLOCK_SPLITER + '\n\n');
	}
	/**
	 * Assemble content of other series
	 * @param {Array.<module:echarts/model/Series>} series
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleOtherSeries(series) {
	  return zrUtil.map(series, function (series) {
	    var data = series.getRawData();
	    var lines = [series.name];
	    var vals = [];
	    data.each(data.dimensions, function () {
	      var argLen = arguments.length;
	      var dataIndex = arguments[argLen - 1];
	      var name = data.getName(dataIndex);
	
	      for (var i = 0; i < argLen - 1; i++) {
	        vals[i] = arguments[i];
	      }
	
	      lines.push((name ? name + ITEM_SPLITER : '') + vals.join(ITEM_SPLITER));
	    });
	    return lines.join('\n');
	  }).join('\n\n' + BLOCK_SPLITER + '\n\n');
	}
	/**
	 * @param {module:echarts/model/Global}
	 * @return {Object}
	 * @inner
	 */
	
	
	function getContentFromModel(ecModel) {
	  var result = groupSeries(ecModel);
	  return {
	    value: zrUtil.filter([assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis), assembleOtherSeries(result.other)], function (str) {
	      return str.replace(/[\n\t\s]/g, '');
	    }).join('\n\n' + BLOCK_SPLITER + '\n\n'),
	    meta: result.meta
	  };
	}
	
	function trim(str) {
	  return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	}
	/**
	 * If a block is tsv format
	 */
	
	
	function isTSVFormat(block) {
	  // Simple method to find out if a block is tsv format
	  var firstLine = block.slice(0, block.indexOf('\n'));
	
	  if (firstLine.indexOf(ITEM_SPLITER) >= 0) {
	    return true;
	  }
	}
	
	var itemSplitRegex = new RegExp('[' + ITEM_SPLITER + ']+', 'g');
	/**
	 * @param {string} tsv
	 * @return {Object}
	 */
	
	function parseTSVContents(tsv) {
	  var tsvLines = tsv.split(/\n+/g);
	  var headers = trim(tsvLines.shift()).split(itemSplitRegex);
	  var categories = [];
	  var series = zrUtil.map(headers, function (header) {
	    return {
	      name: header,
	      data: []
	    };
	  });
	
	  for (var i = 0; i < tsvLines.length; i++) {
	    var items = trim(tsvLines[i]).split(itemSplitRegex);
	    categories.push(items.shift());
	
	    for (var j = 0; j < items.length; j++) {
	      series[j] && (series[j].data[i] = items[j]);
	    }
	  }
	
	  return {
	    series: series,
	    categories: categories
	  };
	}
	/**
	 * @param {string} str
	 * @return {Array.<Object>}
	 * @inner
	 */
	
	
	function parseListContents(str) {
	  var lines = str.split(/\n+/g);
	  var seriesName = trim(lines.shift());
	  var data = [];
	
	  for (var i = 0; i < lines.length; i++) {
	    var items = trim(lines[i]).split(itemSplitRegex);
	    var name = '';
	    var value;
	    var hasName = false;
	
	    if (isNaN(items[0])) {
	      // First item is name
	      hasName = true;
	      name = items[0];
	      items = items.slice(1);
	      data[i] = {
	        name: name,
	        value: []
	      };
	      value = data[i].value;
	    } else {
	      value = data[i] = [];
	    }
	
	    for (var j = 0; j < items.length; j++) {
	      value.push(+items[j]);
	    }
	
	    if (value.length === 1) {
	      hasName ? data[i].value = value[0] : data[i] = value[0];
	    }
	  }
	
	  return {
	    name: seriesName,
	    data: data
	  };
	}
	/**
	 * @param {string} str
	 * @param {Array.<Object>} blockMetaList
	 * @return {Object}
	 * @inner
	 */
	
	
	function parseContents(str, blockMetaList) {
	  var blocks = str.split(new RegExp('\n*' + BLOCK_SPLITER + '\n*', 'g'));
	  var newOption = {
	    series: []
	  };
	  zrUtil.each(blocks, function (block, idx) {
	    if (isTSVFormat(block)) {
	      var result = parseTSVContents(block);
	      var blockMeta = blockMetaList[idx];
	      var axisKey = blockMeta.axisDim + 'Axis';
	
	      if (blockMeta) {
	        newOption[axisKey] = newOption[axisKey] || [];
	        newOption[axisKey][blockMeta.axisIndex] = {
	          data: result.categories
	        };
	        newOption.series = newOption.series.concat(result.series);
	      }
	    } else {
	      var result = parseListContents(block);
	      newOption.series.push(result);
	    }
	  });
	  return newOption;
	}
	/**
	 * @alias {module:echarts/component/toolbox/feature/DataView}
	 * @constructor
	 * @param {module:echarts/model/Model} model
	 */
	
	
	function DataView(model) {
	  this._dom = null;
	  this.model = model;
	}
	
	DataView.defaultOption = {
	  show: true,
	  readOnly: false,
	  optionToContent: null,
	  contentToOption: null,
	  icon: 'M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28',
	  title: zrUtil.clone(dataViewLang.title),
	  lang: zrUtil.clone(dataViewLang.lang),
	  backgroundColor: '#fff',
	  textColor: '#000',
	  textareaColor: '#fff',
	  textareaBorderColor: '#333',
	  buttonColor: '#c23531',
	  buttonTextColor: '#fff'
	};
	
	DataView.prototype.onclick = function (ecModel, api) {
	  var container = api.getDom();
	  var model = this.model;
	
	  if (this._dom) {
	    container.removeChild(this._dom);
	  }
	
	  var root = document.createElement('div');
	  root.style.cssText = 'position:absolute;left:5px;top:5px;bottom:5px;right:5px;';
	  root.style.backgroundColor = model.get('backgroundColor') || '#fff'; // Create elements
	
	  var header = document.createElement('h4');
	  var lang = model.get('lang') || [];
	  header.innerHTML = lang[0] || model.get('title');
	  header.style.cssText = 'margin: 10px 20px;';
	  header.style.color = model.get('textColor');
	  var viewMain = document.createElement('div');
	  var textarea = document.createElement('textarea');
	  viewMain.style.cssText = 'display:block;width:100%;overflow:auto;';
	  var optionToContent = model.get('optionToContent');
	  var contentToOption = model.get('contentToOption');
	  var result = getContentFromModel(ecModel);
	
	  if (typeof optionToContent === 'function') {
	    var htmlOrDom = optionToContent(api.getOption());
	
	    if (typeof htmlOrDom === 'string') {
	      viewMain.innerHTML = htmlOrDom;
	    } else if (zrUtil.isDom(htmlOrDom)) {
	      viewMain.appendChild(htmlOrDom);
	    }
	  } else {
	    // Use default textarea
	    viewMain.appendChild(textarea);
	    textarea.readOnly = model.get('readOnly');
	    textarea.style.cssText = 'width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;';
	    textarea.style.color = model.get('textColor');
	    textarea.style.borderColor = model.get('textareaBorderColor');
	    textarea.style.backgroundColor = model.get('textareaColor');
	    textarea.value = result.value;
	  }
	
	  var blockMetaList = result.meta;
	  var buttonContainer = document.createElement('div');
	  buttonContainer.style.cssText = 'position:absolute;bottom:0;left:0;right:0;';
	  var buttonStyle = 'float:right;margin-right:20px;border:none;' + 'cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px';
	  var closeButton = document.createElement('div');
	  var refreshButton = document.createElement('div');
	  buttonStyle += ';background-color:' + model.get('buttonColor');
	  buttonStyle += ';color:' + model.get('buttonTextColor');
	  var self = this;
	
	  function close() {
	    container.removeChild(root);
	    self._dom = null;
	  }
	
	  eventTool.addEventListener(closeButton, 'click', close);
	  eventTool.addEventListener(refreshButton, 'click', function () {
	    var newOption;
	
	    try {
	      if (typeof contentToOption === 'function') {
	        newOption = contentToOption(viewMain, api.getOption());
	      } else {
	        newOption = parseContents(textarea.value, blockMetaList);
	      }
	    } catch (e) {
	      close();
	      throw new Error('Data view format error ' + e);
	    }
	
	    if (newOption) {
	      api.dispatchAction({
	        type: 'changeDataView',
	        newOption: newOption
	      });
	    }
	
	    close();
	  });
	  closeButton.innerHTML = lang[1];
	  refreshButton.innerHTML = lang[2];
	  refreshButton.style.cssText = buttonStyle;
	  closeButton.style.cssText = buttonStyle;
	  !model.get('readOnly') && buttonContainer.appendChild(refreshButton);
	  buttonContainer.appendChild(closeButton); // http://stackoverflow.com/questions/6637341/use-tab-to-indent-in-textarea
	
	  eventTool.addEventListener(textarea, 'keydown', function (e) {
	    if ((e.keyCode || e.which) === 9) {
	      // get caret position/selection
	      var val = this.value;
	      var start = this.selectionStart;
	      var end = this.selectionEnd; // set textarea value to: text before caret + tab + text after caret
	
	      this.value = val.substring(0, start) + ITEM_SPLITER + val.substring(end); // put caret at right position again
	
	      this.selectionStart = this.selectionEnd = start + 1; // prevent the focus lose
	
	      eventTool.stop(e);
	    }
	  });
	  root.appendChild(header);
	  root.appendChild(viewMain);
	  root.appendChild(buttonContainer);
	  viewMain.style.height = container.clientHeight - 80 + 'px';
	  container.appendChild(root);
	  this._dom = root;
	};
	
	DataView.prototype.remove = function (ecModel, api) {
	  this._dom && api.getDom().removeChild(this._dom);
	};
	
	DataView.prototype.dispose = function (ecModel, api) {
	  this.remove(ecModel, api);
	};
	/**
	 * @inner
	 */
	
	
	function tryMergeDataOption(newData, originalData) {
	  return zrUtil.map(newData, function (newVal, idx) {
	    var original = originalData && originalData[idx];
	
	    if (zrUtil.isObject(original) && !zrUtil.isArray(original)) {
	      if (zrUtil.isObject(newVal) && !zrUtil.isArray(newVal)) {
	        newVal = newVal.value;
	      } // Original data has option
	
	
	      return zrUtil.defaults({
	        value: newVal
	      }, original);
	    } else {
	      return newVal;
	    }
	  });
	}
	
	featureManager.register('dataView', DataView);
	echarts.registerAction({
	  type: 'changeDataView',
	  event: 'dataViewChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  var newSeriesOptList = [];
	  zrUtil.each(payload.newOption.series, function (seriesOpt) {
	    var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];
	
	    if (!seriesModel) {
	      // New created series
	      // Geuss the series type
	      newSeriesOptList.push(zrUtil.extend({
	        // Default is scatter
	        type: 'scatter'
	      }, seriesOpt));
	    } else {
	      var originalData = seriesModel.get('data');
	      newSeriesOptList.push({
	        name: seriesOpt.name,
	        data: tryMergeDataOption(seriesOpt.data, originalData)
	      });
	    }
	  });
	  ecModel.mergeOption(zrUtil.defaults({
	    series: newSeriesOptList
	  }, payload.newOption));
	});
	var _default = DataView;
	module.exports = _default;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var BrushController = __webpack_require__(120);
	
	var BrushTargetManager = __webpack_require__(176);
	
	var history = __webpack_require__(174);
	
	var sliderMove = __webpack_require__(71);
	
	var lang = __webpack_require__(57);
	
	var featureManager = __webpack_require__(35);
	
	__webpack_require__(488);
	
	// Use dataZoomSelect
	var dataZoomLang = lang.toolbox.dataZoom;
	var each = zrUtil.each; // Spectial component id start with \0ec\0, see echarts/model/Global.js~hasInnerId
	
	var DATA_ZOOM_ID_BASE = '\0_ec_\0toolbox-dataZoom_';
	
	function DataZoom(model, ecModel, api) {
	  /**
	   * @private
	   * @type {module:echarts/component/helper/BrushController}
	   */
	  (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this)).mount();
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._isZoomActive;
	}
	
	DataZoom.defaultOption = {
	  show: true,
	  // Icon group
	  icon: {
	    zoom: 'M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1',
	    back: 'M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26'
	  },
	  // `zoom`, `back`
	  title: zrUtil.clone(dataZoomLang.title)
	};
	var proto = DataZoom.prototype;
	
	proto.render = function (featureModel, ecModel, api, payload) {
	  this.model = featureModel;
	  this.ecModel = ecModel;
	  this.api = api;
	  updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
	  updateBackBtnStatus(featureModel, ecModel);
	};
	
	proto.onclick = function (ecModel, api, type) {
	  handlers[type].call(this);
	};
	
	proto.remove = function (ecModel, api) {
	  this._brushController.unmount();
	};
	
	proto.dispose = function (ecModel, api) {
	  this._brushController.dispose();
	};
	/**
	 * @private
	 */
	
	
	var handlers = {
	  zoom: function () {
	    var nextActive = !this._isZoomActive;
	    this.api.dispatchAction({
	      type: 'takeGlobalCursor',
	      key: 'dataZoomSelect',
	      dataZoomSelectActive: nextActive
	    });
	  },
	  back: function () {
	    this._dispatchZoomAction(history.pop(this.ecModel));
	  }
	};
	/**
	 * @private
	 */
	
	proto._onBrush = function (areas, opt) {
	  if (!opt.isEnd || !areas.length) {
	    return;
	  }
	
	  var snapshot = {};
	  var ecModel = this.ecModel;
	
	  this._brushController.updateCovers([]); // remove cover
	
	
	  var brushTargetManager = new BrushTargetManager(retrieveAxisSetting(this.model.option), ecModel, {
	    include: ['grid']
	  });
	  brushTargetManager.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
	    if (coordSys.type !== 'cartesian2d') {
	      return;
	    }
	
	    var brushType = area.brushType;
	
	    if (brushType === 'rect') {
	      setBatch('x', coordSys, coordRange[0]);
	      setBatch('y', coordSys, coordRange[1]);
	    } else {
	      setBatch({
	        lineX: 'x',
	        lineY: 'y'
	      }[brushType], coordSys, coordRange);
	    }
	  });
	  history.push(ecModel, snapshot);
	
	  this._dispatchZoomAction(snapshot);
	
	  function setBatch(dimName, coordSys, minMax) {
	    var axis = coordSys.getAxis(dimName);
	    var axisModel = axis.model;
	    var dataZoomModel = findDataZoom(dimName, axisModel, ecModel); // Restrict range.
	
	    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();
	
	    if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) {
	      minMax = sliderMove(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
	    }
	
	    dataZoomModel && (snapshot[dataZoomModel.id] = {
	      dataZoomId: dataZoomModel.id,
	      startValue: minMax[0],
	      endValue: minMax[1]
	    });
	  }
	
	  function findDataZoom(dimName, axisModel, ecModel) {
	    var found;
	    ecModel.eachComponent({
	      mainType: 'dataZoom',
	      subType: 'select'
	    }, function (dzModel) {
	      var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
	      has && (found = dzModel);
	    });
	    return found;
	  }
	};
	/**
	 * @private
	 */
	
	
	proto._dispatchZoomAction = function (snapshot) {
	  var batch = []; // Convert from hash map to array.
	
	  each(snapshot, function (batchItem, dataZoomId) {
	    batch.push(zrUtil.clone(batchItem));
	  });
	  batch.length && this.api.dispatchAction({
	    type: 'dataZoom',
	    from: this.uid,
	    batch: batch
	  });
	};
	
	function retrieveAxisSetting(option) {
	  var setting = {}; // Compatible with previous setting: null => all axis, false => no axis.
	
	  zrUtil.each(['xAxisIndex', 'yAxisIndex'], function (name) {
	    setting[name] = option[name];
	    setting[name] == null && (setting[name] = 'all');
	    (setting[name] === false || setting[name] === 'none') && (setting[name] = []);
	  });
	  return setting;
	}
	
	function updateBackBtnStatus(featureModel, ecModel) {
	  featureModel.setIconStatus('back', history.count(ecModel) > 1 ? 'emphasis' : 'normal');
	}
	
	function updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
	  var zoomActive = view._isZoomActive;
	
	  if (payload && payload.type === 'takeGlobalCursor') {
	    zoomActive = payload.key === 'dataZoomSelect' ? payload.dataZoomSelectActive : false;
	  }
	
	  view._isZoomActive = zoomActive;
	  featureModel.setIconStatus('zoom', zoomActive ? 'emphasis' : 'normal');
	  var brushTargetManager = new BrushTargetManager(retrieveAxisSetting(featureModel.option), ecModel, {
	    include: ['grid']
	  });
	
	  view._brushController.setPanels(brushTargetManager.makePanelOpts(api, function (targetInfo) {
	    return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? 'lineX' : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? 'lineY' : 'rect';
	  })).enableBrush(zoomActive ? {
	    brushType: 'auto',
	    brushStyle: {
	      // FIXME user customized?
	      lineWidth: 0,
	      fill: 'rgba(0,0,0,0.2)'
	    }
	  } : false);
	}
	
	featureManager.register('dataZoom', DataZoom); // Create special dataZoom option for select
	
	echarts.registerPreprocessor(function (option) {
	  if (!option) {
	    return;
	  }
	
	  var dataZoomOpts = option.dataZoom || (option.dataZoom = []);
	
	  if (!zrUtil.isArray(dataZoomOpts)) {
	    option.dataZoom = dataZoomOpts = [dataZoomOpts];
	  }
	
	  var toolboxOpt = option.toolbox;
	
	  if (toolboxOpt) {
	    // Assume there is only one toolbox
	    if (zrUtil.isArray(toolboxOpt)) {
	      toolboxOpt = toolboxOpt[0];
	    }
	
	    if (toolboxOpt && toolboxOpt.feature) {
	      var dataZoomOpt = toolboxOpt.feature.dataZoom;
	      addForAxis('xAxis', dataZoomOpt);
	      addForAxis('yAxis', dataZoomOpt);
	    }
	  }
	
	  function addForAxis(axisName, dataZoomOpt) {
	    if (!dataZoomOpt) {
	      return;
	    } // Try not to modify model, because it is not merged yet.
	
	
	    var axisIndicesName = axisName + 'Index';
	    var givenAxisIndices = dataZoomOpt[axisIndicesName];
	
	    if (givenAxisIndices != null && givenAxisIndices != 'all' && !zrUtil.isArray(givenAxisIndices)) {
	      givenAxisIndices = givenAxisIndices === false || givenAxisIndices === 'none' ? [] : [givenAxisIndices];
	    }
	
	    forEachComponent(axisName, function (axisOpt, axisIndex) {
	      if (givenAxisIndices != null && givenAxisIndices != 'all' && zrUtil.indexOf(givenAxisIndices, axisIndex) === -1) {
	        return;
	      }
	
	      var newOpt = {
	        type: 'select',
	        $fromToolbox: true,
	        // Id for merge mapping.
	        id: DATA_ZOOM_ID_BASE + axisName + axisIndex
	      }; // FIXME
	      // Only support one axis now.
	
	      newOpt[axisIndicesName] = axisIndex;
	      dataZoomOpts.push(newOpt);
	    });
	  }
	
	  function forEachComponent(mainType, cb) {
	    var opts = option[mainType];
	
	    if (!zrUtil.isArray(opts)) {
	      opts = opts ? [opts] : [];
	    }
	
	    each(opts, cb);
	  }
	});
	var _default = DataZoom;
	module.exports = _default;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var lang = __webpack_require__(57);
	
	var featureManager = __webpack_require__(35);
	
	var magicTypeLang = lang.toolbox.magicType;
	
	function MagicType(model) {
	  this.model = model;
	}
	
	MagicType.defaultOption = {
	  show: true,
	  type: [],
	  // Icon group
	  icon: {
	    line: 'M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4',
	    bar: 'M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7',
	    stack: 'M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z',
	    // jshint ignore:line
	    tiled: 'M2.3,2.2h22.8V25H2.3V2.2z M35,2.2h22.8V25H35V2.2zM2.3,35h22.8v22.8H2.3V35z M35,35h22.8v22.8H35V35z'
	  },
	  // `line`, `bar`, `stack`, `tiled`
	  title: zrUtil.clone(magicTypeLang.title),
	  option: {},
	  seriesIndex: {}
	};
	var proto = MagicType.prototype;
	
	proto.getIcons = function () {
	  var model = this.model;
	  var availableIcons = model.get('icon');
	  var icons = {};
	  zrUtil.each(model.get('type'), function (type) {
	    if (availableIcons[type]) {
	      icons[type] = availableIcons[type];
	    }
	  });
	  return icons;
	};
	
	var seriesOptGenreator = {
	  'line': function (seriesType, seriesId, seriesModel, model) {
	    if (seriesType === 'bar') {
	      return zrUtil.merge({
	        id: seriesId,
	        type: 'line',
	        // Preserve data related option
	        data: seriesModel.get('data'),
	        stack: seriesModel.get('stack'),
	        markPoint: seriesModel.get('markPoint'),
	        markLine: seriesModel.get('markLine')
	      }, model.get('option.line') || {}, true);
	    }
	  },
	  'bar': function (seriesType, seriesId, seriesModel, model) {
	    if (seriesType === 'line') {
	      return zrUtil.merge({
	        id: seriesId,
	        type: 'bar',
	        // Preserve data related option
	        data: seriesModel.get('data'),
	        stack: seriesModel.get('stack'),
	        markPoint: seriesModel.get('markPoint'),
	        markLine: seriesModel.get('markLine')
	      }, model.get('option.bar') || {}, true);
	    }
	  },
	  'stack': function (seriesType, seriesId, seriesModel, model) {
	    if (seriesType === 'line' || seriesType === 'bar') {
	      return zrUtil.merge({
	        id: seriesId,
	        stack: '__ec_magicType_stack__'
	      }, model.get('option.stack') || {}, true);
	    }
	  },
	  'tiled': function (seriesType, seriesId, seriesModel, model) {
	    if (seriesType === 'line' || seriesType === 'bar') {
	      return zrUtil.merge({
	        id: seriesId,
	        stack: ''
	      }, model.get('option.tiled') || {}, true);
	    }
	  }
	};
	var radioTypes = [['line', 'bar'], ['stack', 'tiled']];
	
	proto.onclick = function (ecModel, api, type) {
	  var model = this.model;
	  var seriesIndex = model.get('seriesIndex.' + type); // Not supported magicType
	
	  if (!seriesOptGenreator[type]) {
	    return;
	  }
	
	  var newOption = {
	    series: []
	  };
	
	  var generateNewSeriesTypes = function (seriesModel) {
	    var seriesType = seriesModel.subType;
	    var seriesId = seriesModel.id;
	    var newSeriesOpt = seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);
	
	    if (newSeriesOpt) {
	      // PENDING If merge original option?
	      zrUtil.defaults(newSeriesOpt, seriesModel.option);
	      newOption.series.push(newSeriesOpt);
	    } // Modify boundaryGap
	
	
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.type === 'cartesian2d' && (type === 'line' || type === 'bar')) {
	      var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
	
	      if (categoryAxis) {
	        var axisDim = categoryAxis.dim;
	        var axisType = axisDim + 'Axis';
	        var axisModel = ecModel.queryComponents({
	          mainType: axisType,
	          index: seriesModel.get(name + 'Index'),
	          id: seriesModel.get(name + 'Id')
	        })[0];
	        var axisIndex = axisModel.componentIndex;
	        newOption[axisType] = newOption[axisType] || [];
	
	        for (var i = 0; i <= axisIndex; i++) {
	          newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
	        }
	
	        newOption[axisType][axisIndex].boundaryGap = type === 'bar' ? true : false;
	      }
	    }
	  };
	
	  zrUtil.each(radioTypes, function (radio) {
	    if (zrUtil.indexOf(radio, type) >= 0) {
	      zrUtil.each(radio, function (item) {
	        model.setIconStatus(item, 'normal');
	      });
	    }
	  });
	  model.setIconStatus(type, 'emphasis');
	  ecModel.eachComponent({
	    mainType: 'series',
	    query: seriesIndex == null ? null : {
	      seriesIndex: seriesIndex
	    }
	  }, generateNewSeriesTypes);
	  api.dispatchAction({
	    type: 'changeMagicType',
	    currentType: type,
	    newOption: newOption
	  });
	};
	
	echarts.registerAction({
	  type: 'changeMagicType',
	  event: 'magicTypeChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  ecModel.mergeOption(payload.newOption);
	});
	featureManager.register('magicType', MagicType);
	var _default = MagicType;
	module.exports = _default;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var history = __webpack_require__(174);
	
	var lang = __webpack_require__(57);
	
	var featureManager = __webpack_require__(35);
	
	var restoreLang = lang.toolbox.restore;
	
	function Restore(model) {
	  this.model = model;
	}
	
	Restore.defaultOption = {
	  show: true,
	  icon: 'M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5',
	  title: restoreLang.title
	};
	var proto = Restore.prototype;
	
	proto.onclick = function (ecModel, api, type) {
	  history.clear(ecModel);
	  api.dispatchAction({
	    type: 'restore',
	    from: this.uid
	  });
	};
	
	featureManager.register('restore', Restore);
	echarts.registerAction({
	  type: 'restore',
	  event: 'restore',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  ecModel.resetOption('recreate');
	});
	var _default = Restore;
	module.exports = _default;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	var env = __webpack_require__(18);
	
	var lang = __webpack_require__(57);
	
	var featureManager = __webpack_require__(35);
	
	var saveAsImageLang = lang.toolbox.saveAsImage;
	
	function SaveAsImage(model) {
	  this.model = model;
	}
	
	SaveAsImage.defaultOption = {
	  show: true,
	  icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
	  title: saveAsImageLang.title,
	  type: 'png',
	  // Default use option.backgroundColor
	  // backgroundColor: '#fff',
	  name: '',
	  excludeComponents: ['toolbox'],
	  pixelRatio: 1,
	  lang: saveAsImageLang.lang.slice()
	};
	SaveAsImage.prototype.unusable = !env.canvasSupported;
	var proto = SaveAsImage.prototype;
	
	proto.onclick = function (ecModel, api) {
	  var model = this.model;
	  var title = model.get('name') || ecModel.get('title.0.text') || 'echarts';
	  var $a = document.createElement('a');
	  var type = model.get('type', true) || 'png';
	  $a.download = title + '.' + type;
	  $a.target = '_blank';
	  var url = api.getConnectedDataURL({
	    type: type,
	    backgroundColor: model.get('backgroundColor', true) || ecModel.get('backgroundColor') || '#fff',
	    excludeComponents: model.get('excludeComponents'),
	    pixelRatio: model.get('pixelRatio')
	  });
	  $a.href = url; // Chrome and Firefox
	
	  if (typeof MouseEvent === 'function' && !env.browser.ie && !env.browser.edge) {
	    var evt = new MouseEvent('click', {
	      view: window,
	      bubbles: true,
	      cancelable: false
	    });
	    $a.dispatchEvent(evt);
	  } // IE
	  else {
	      if (window.navigator.msSaveOrOpenBlob) {
	        var bstr = atob(url.split(',')[1]);
	        var n = bstr.length;
	        var u8arr = new Uint8Array(n);
	
	        while (n--) {
	          u8arr[n] = bstr.charCodeAt(n);
	        }
	
	        var blob = new Blob([u8arr]);
	        window.navigator.msSaveOrOpenBlob(blob, title + '.' + type);
	      } else {
	        var lang = model.get('lang');
	        var html = '' + '<body style="margin:0;">' + '<img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || '') + '" />' + '</body>';
	        var tab = window.open();
	        tab.document.write(html);
	      }
	    }
	};
	
	featureManager.register('saveAsImage', SaveAsImage);
	var _default = SaveAsImage;
	module.exports = _default;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	__webpack_require__(67);
	
	__webpack_require__(535);
	
	__webpack_require__(536);
	
	// FIXME Better way to pack data in graphic element
	
	/**
	 * @action
	 * @property {string} type
	 * @property {number} seriesIndex
	 * @property {number} dataIndex
	 * @property {number} [x]
	 * @property {number} [y]
	 */
	echarts.registerAction({
	  type: 'showTip',
	  event: 'showTip',
	  update: 'tooltip:manuallyShowTip'
	}, // noop
	function () {});
	echarts.registerAction({
	  type: 'hideTip',
	  event: 'hideTip',
	  update: 'tooltip:manuallyHideTip'
	}, // noop
	function () {});

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var zrColor = __webpack_require__(31);
	
	var eventUtil = __webpack_require__(30);
	
	var env = __webpack_require__(18);
	
	var formatUtil = __webpack_require__(9);
	
	var each = zrUtil.each;
	var toCamelCase = formatUtil.toCamelCase;
	var vendors = ['', '-webkit-', '-moz-', '-o-'];
	var gCssText = 'position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;';
	/**
	 * @param {number} duration
	 * @return {string}
	 * @inner
	 */
	
	function assembleTransition(duration) {
	  var transitionCurve = 'cubic-bezier(0.23, 1, 0.32, 1)';
	  var transitionText = 'left ' + duration + 's ' + transitionCurve + ',' + 'top ' + duration + 's ' + transitionCurve;
	  return zrUtil.map(vendors, function (vendorPrefix) {
	    return vendorPrefix + 'transition:' + transitionText;
	  }).join(';');
	}
	/**
	 * @param {Object} textStyle
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleFont(textStyleModel) {
	  var cssText = [];
	  var fontSize = textStyleModel.get('fontSize');
	  var color = textStyleModel.getTextColor();
	  color && cssText.push('color:' + color);
	  cssText.push('font:' + textStyleModel.getFont());
	  fontSize && cssText.push('line-height:' + Math.round(fontSize * 3 / 2) + 'px');
	  each(['decoration', 'align'], function (name) {
	    var val = textStyleModel.get(name);
	    val && cssText.push('text-' + name + ':' + val);
	  });
	  return cssText.join(';');
	}
	/**
	 * @param {Object} tooltipModel
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleCssText(tooltipModel) {
	  var cssText = [];
	  var transitionDuration = tooltipModel.get('transitionDuration');
	  var backgroundColor = tooltipModel.get('backgroundColor');
	  var textStyleModel = tooltipModel.getModel('textStyle');
	  var padding = tooltipModel.get('padding'); // Animation transition. Do not animate when transitionDuration is 0.
	
	  transitionDuration && cssText.push(assembleTransition(transitionDuration));
	
	  if (backgroundColor) {
	    if (env.canvasSupported) {
	      cssText.push('background-Color:' + backgroundColor);
	    } else {
	      // for ie
	      cssText.push('background-Color:#' + zrColor.toHex(backgroundColor));
	      cssText.push('filter:alpha(opacity=70)');
	    }
	  } // Border style
	
	
	  each(['width', 'color', 'radius'], function (name) {
	    var borderName = 'border-' + name;
	    var camelCase = toCamelCase(borderName);
	    var val = tooltipModel.get(camelCase);
	    val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
	  }); // Text style
	
	  cssText.push(assembleFont(textStyleModel)); // Padding
	
	  if (padding != null) {
	    cssText.push('padding:' + formatUtil.normalizeCssArray(padding).join('px ') + 'px');
	  }
	
	  return cssText.join(';') + ';';
	}
	/**
	 * @alias module:echarts/component/tooltip/TooltipContent
	 * @constructor
	 */
	
	
	function TooltipContent(container, api) {
	  var el = document.createElement('div');
	  var zr = this._zr = api.getZr();
	  this.el = el;
	  this._x = api.getWidth() / 2;
	  this._y = api.getHeight() / 2;
	  container.appendChild(el);
	  this._container = container;
	  this._show = false;
	  /**
	   * @private
	   */
	
	  this._hideTimeout;
	  var self = this;
	
	  el.onmouseenter = function () {
	    // clear the timeout in hideLater and keep showing tooltip
	    if (self._enterable) {
	      clearTimeout(self._hideTimeout);
	      self._show = true;
	    }
	
	    self._inContent = true;
	  };
	
	  el.onmousemove = function (e) {
	    e = e || window.event;
	
	    if (!self._enterable) {
	      // Try trigger zrender event to avoid mouse
	      // in and out shape too frequently
	      var handler = zr.handler;
	      eventUtil.normalizeEvent(container, e, true);
	      handler.dispatch('mousemove', e);
	    }
	  };
	
	  el.onmouseleave = function () {
	    if (self._enterable) {
	      if (self._show) {
	        self.hideLater(self._hideDelay);
	      }
	    }
	
	    self._inContent = false;
	  };
	}
	
	TooltipContent.prototype = {
	  constructor: TooltipContent,
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  _enterable: true,
	
	  /**
	   * Update when tooltip is rendered
	   */
	  update: function () {
	    // FIXME
	    // Move this logic to ec main?
	    var container = this._container;
	    var stl = container.currentStyle || document.defaultView.getComputedStyle(container);
	    var domStyle = container.style;
	
	    if (domStyle.position !== 'absolute' && stl.position !== 'absolute') {
	      domStyle.position = 'relative';
	    } // Hide the tooltip
	    // PENDING
	    // this.hide();
	
	  },
	  show: function (tooltipModel) {
	    clearTimeout(this._hideTimeout);
	    var el = this.el;
	    el.style.cssText = gCssText + assembleCssText(tooltipModel) // http://stackoverflow.com/questions/21125587/css3-transition-not-working-in-chrome-anymore
	    + ';left:' + this._x + 'px;top:' + this._y + 'px;' + (tooltipModel.get('extraCssText') || '');
	    el.style.display = el.innerHTML ? 'block' : 'none';
	    this._show = true;
	  },
	  setContent: function (content) {
	    this.el.innerHTML = content == null ? '' : content;
	  },
	  setEnterable: function (enterable) {
	    this._enterable = enterable;
	  },
	  getSize: function () {
	    var el = this.el;
	    return [el.clientWidth, el.clientHeight];
	  },
	  moveTo: function (x, y) {
	    // xy should be based on canvas root. But tooltipContent is
	    // the sibling of canvas root. So padding of ec container
	    // should be considered here.
	    var zr = this._zr;
	    var viewportRootOffset;
	
	    if (zr && zr.painter && (viewportRootOffset = zr.painter.getViewportRootOffset())) {
	      x += viewportRootOffset.offsetLeft;
	      y += viewportRootOffset.offsetTop;
	    }
	
	    var style = this.el.style;
	    style.left = x + 'px';
	    style.top = y + 'px';
	    this._x = x;
	    this._y = y;
	  },
	  hide: function () {
	    this.el.style.display = 'none';
	    this._show = false;
	  },
	  hideLater: function (time) {
	    if (this._show && !(this._inContent && this._enterable)) {
	      if (time) {
	        this._hideDelay = time; // Set show false to avoid invoke hideLater mutiple times
	
	        this._show = false;
	        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
	      } else {
	        this.hide();
	      }
	    }
	  },
	  isShow: function () {
	    return this._show;
	  }
	};
	var _default = TooltipContent;
	module.exports = _default;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var _default = echarts.extendComponentModel({
	  type: 'tooltip',
	  dependencies: ['axisPointer'],
	  defaultOption: {
	    zlevel: 0,
	    z: 8,
	    show: true,
	    // tooltip主体内容
	    showContent: true,
	    // 'trigger' only works on coordinate system.
	    // 'item' | 'axis' | 'none'
	    trigger: 'item',
	    // 'click' | 'mousemove' | 'none'
	    triggerOn: 'mousemove|click',
	    alwaysShowContent: false,
	    displayMode: 'single',
	    // 'single' | 'multipleByCoordSys'
	    // 位置 {Array} | {Function}
	    // position: null
	    // Consider triggered from axisPointer handle, verticalAlign should be 'middle'
	    // align: null,
	    // verticalAlign: null,
	    // 是否约束 content 在 viewRect 中。默认 false 是为了兼容以前版本。
	    confine: false,
	    // 内容格式器：{string}（Template） ¦ {Function}
	    // formatter: null
	    showDelay: 0,
	    // 隐藏延迟，单位ms
	    hideDelay: 100,
	    // 动画变换时间，单位s
	    transitionDuration: 0.4,
	    enterable: false,
	    // 提示背景颜色，默认为透明度为0.7的黑色
	    backgroundColor: 'rgba(50,50,50,0.7)',
	    // 提示边框颜色
	    borderColor: '#333',
	    // 提示边框圆角，单位px，默认为4
	    borderRadius: 4,
	    // 提示边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 提示内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // Extra css text
	    extraCssText: '',
	    // 坐标轴指示器，坐标轴触发有效
	    axisPointer: {
	      // 默认为直线
	      // 可选为：'line' | 'shadow' | 'cross'
	      type: 'line',
	      // type 为 line 的时候有效，指定 tooltip line 所在的轴，可选
	      // 可选 'x' | 'y' | 'angle' | 'radius' | 'auto'
	      // 默认 'auto'，会选择类型为 cateogry 的轴，对于双数值轴，笛卡尔坐标系会默认选择 x 轴
	      // 极坐标系会默认选择 angle 轴
	      axis: 'auto',
	      animation: 'auto',
	      animationDurationUpdate: 200,
	      animationEasingUpdate: 'exponentialOut',
	      crossStyle: {
	        color: '#999',
	        width: 1,
	        type: 'dashed',
	        // TODO formatter
	        textStyle: {} // lineStyle and shadowStyle should not be specified here,
	        // otherwise it will always override those styles on option.axisPointer.
	
	      }
	    },
	    textStyle: {
	      color: '#fff',
	      fontSize: 14
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var env = __webpack_require__(18);
	
	var TooltipContent = __webpack_require__(534);
	
	var formatUtil = __webpack_require__(9);
	
	var numberUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(3);
	
	var findPointFromSeries = __webpack_require__(170);
	
	var layoutUtil = __webpack_require__(7);
	
	var Model = __webpack_require__(14);
	
	var globalListener = __webpack_require__(171);
	
	var axisHelper = __webpack_require__(21);
	
	var axisPointerViewHelper = __webpack_require__(86);
	
	var bind = zrUtil.bind;
	var each = zrUtil.each;
	var parsePercent = numberUtil.parsePercent;
	var proxyRect = new graphic.Rect({
	  shape: {
	    x: -1,
	    y: -1,
	    width: 2,
	    height: 2
	  }
	});
	
	var _default = echarts.extendComponentView({
	  type: 'tooltip',
	  init: function (ecModel, api) {
	    if (env.node) {
	      return;
	    }
	
	    var tooltipContent = new TooltipContent(api.getDom(), api);
	    this._tooltipContent = tooltipContent;
	  },
	  render: function (tooltipModel, ecModel, api) {
	    if (env.node) {
	      return;
	    } // Reset
	
	
	    this.group.removeAll();
	    /**
	     * @private
	     * @type {module:echarts/component/tooltip/TooltipModel}
	     */
	
	    this._tooltipModel = tooltipModel;
	    /**
	     * @private
	     * @type {module:echarts/model/Global}
	     */
	
	    this._ecModel = ecModel;
	    /**
	     * @private
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this._api = api;
	    /**
	     * Should be cleaned when render.
	     * @private
	     * @type {Array.<Array.<Object>>}
	     */
	
	    this._lastDataByCoordSys = null;
	    /**
	     * @private
	     * @type {boolean}
	     */
	
	    this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
	    var tooltipContent = this._tooltipContent;
	    tooltipContent.update();
	    tooltipContent.setEnterable(tooltipModel.get('enterable'));
	
	    this._initGlobalListener();
	
	    this._keepShow();
	  },
	  _initGlobalListener: function () {
	    var tooltipModel = this._tooltipModel;
	    var triggerOn = tooltipModel.get('triggerOn');
	    globalListener.register('itemTooltip', this._api, bind(function (currTrigger, e, dispatchAction) {
	      // If 'none', it is not controlled by mouse totally.
	      if (triggerOn !== 'none') {
	        if (triggerOn.indexOf(currTrigger) >= 0) {
	          this._tryShow(e, dispatchAction);
	        } else if (currTrigger === 'leave') {
	          this._hide(dispatchAction);
	        }
	      }
	    }, this));
	  },
	  _keepShow: function () {
	    var tooltipModel = this._tooltipModel;
	    var ecModel = this._ecModel;
	    var api = this._api; // Try to keep the tooltip show when refreshing
	
	    if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
	    // self.manuallyShowTip({x, y}) might cause tooltip hide,
	    // which is not expected.
	    && tooltipModel.get('triggerOn') !== 'none') {
	      var self = this;
	      clearTimeout(this._refreshUpdateTimeout);
	      this._refreshUpdateTimeout = setTimeout(function () {
	        // Show tip next tick after other charts are rendered
	        // In case highlight action has wrong result
	        // FIXME
	        self.manuallyShowTip(tooltipModel, ecModel, api, {
	          x: self._lastX,
	          y: self._lastY
	        });
	      });
	    }
	  },
	
	  /**
	   * Show tip manually by
	   * dispatchAction({
	   *     type: 'showTip',
	   *     x: 10,
	   *     y: 10
	   * });
	   * Or
	   * dispatchAction({
	   *      type: 'showTip',
	   *      seriesIndex: 0,
	   *      dataIndex or dataIndexInside or name
	   * });
	   *
	   *  TODO Batch
	   */
	  manuallyShowTip: function (tooltipModel, ecModel, api, payload) {
	    if (payload.from === this.uid || env.node) {
	      return;
	    }
	
	    var dispatchAction = makeDispatchAction(payload, api); // Reset ticket
	
	    this._ticket = ''; // When triggered from axisPointer.
	
	    var dataByCoordSys = payload.dataByCoordSys;
	
	    if (payload.tooltip && payload.x != null && payload.y != null) {
	      var el = proxyRect;
	      el.position = [payload.x, payload.y];
	      el.update();
	      el.tooltip = payload.tooltip; // Manually show tooltip while view is not using zrender elements.
	
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        target: el
	      }, dispatchAction);
	    } else if (dataByCoordSys) {
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        position: payload.position,
	        event: {},
	        dataByCoordSys: payload.dataByCoordSys,
	        tooltipOption: payload.tooltipOption
	      }, dispatchAction);
	    } else if (payload.seriesIndex != null) {
	      if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) {
	        return;
	      }
	
	      var pointInfo = findPointFromSeries(payload, ecModel);
	      var cx = pointInfo.point[0];
	      var cy = pointInfo.point[1];
	
	      if (cx != null && cy != null) {
	        this._tryShow({
	          offsetX: cx,
	          offsetY: cy,
	          position: payload.position,
	          target: pointInfo.el,
	          event: {}
	        }, dispatchAction);
	      }
	    } else if (payload.x != null && payload.y != null) {
	      // FIXME
	      // should wrap dispatchAction like `axisPointer/globalListener` ?
	      api.dispatchAction({
	        type: 'updateAxisPointer',
	        x: payload.x,
	        y: payload.y
	      });
	
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        position: payload.position,
	        target: api.getZr().findHover(payload.x, payload.y).target,
	        event: {}
	      }, dispatchAction);
	    }
	  },
	  manuallyHideTip: function (tooltipModel, ecModel, api, payload) {
	    var tooltipContent = this._tooltipContent;
	
	    if (!this._alwaysShowContent) {
	      tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
	    }
	
	    this._lastX = this._lastY = null;
	
	    if (payload.from !== this.uid) {
	      this._hide(makeDispatchAction(payload, api));
	    }
	  },
	  // Be compatible with previous design, that is, when tooltip.type is 'axis' and
	  // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
	  // and tooltip.
	  _manuallyAxisShowTip: function (tooltipModel, ecModel, api, payload) {
	    var seriesIndex = payload.seriesIndex;
	    var dataIndex = payload.dataIndex;
	    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
	
	    if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) {
	      return;
	    }
	
	    var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
	
	    if (!seriesModel) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), seriesModel, (seriesModel.coordinateSystem || {}).model, tooltipModel]);
	
	    if (tooltipModel.get('trigger') !== 'axis') {
	      return;
	    }
	
	    api.dispatchAction({
	      type: 'updateAxisPointer',
	      seriesIndex: seriesIndex,
	      dataIndex: dataIndex,
	      position: payload.position
	    });
	    return true;
	  },
	  _tryShow: function (e, dispatchAction) {
	    var el = e.target;
	    var tooltipModel = this._tooltipModel;
	
	    if (!tooltipModel) {
	      return;
	    } // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
	
	
	    this._lastX = e.offsetX;
	    this._lastY = e.offsetY;
	    var dataByCoordSys = e.dataByCoordSys;
	
	    if (dataByCoordSys && dataByCoordSys.length) {
	      this._showAxisTooltip(dataByCoordSys, e);
	    } // Always show item tooltip if mouse is on the element with dataIndex
	    else if (el && el.dataIndex != null) {
	        this._lastDataByCoordSys = null;
	
	        this._showSeriesItemTooltip(e, el, dispatchAction);
	      } // Tooltip provided directly. Like legend.
	      else if (el && el.tooltip) {
	          this._lastDataByCoordSys = null;
	
	          this._showComponentItemTooltip(e, el, dispatchAction);
	        } else {
	          this._lastDataByCoordSys = null;
	
	          this._hide(dispatchAction);
	        }
	  },
	  _showOrMove: function (tooltipModel, cb) {
	    // showDelay is used in this case: tooltip.enterable is set
	    // as true. User intent to move mouse into tooltip and click
	    // something. `showDelay` makes it easyer to enter the content
	    // but tooltip do not move immediately.
	    var delay = tooltipModel.get('showDelay');
	    cb = zrUtil.bind(cb, this);
	    clearTimeout(this._showTimout);
	    delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
	  },
	  _showAxisTooltip: function (dataByCoordSys, e) {
	    var ecModel = this._ecModel;
	    var globalTooltipModel = this._tooltipModel;
	    var point = [e.offsetX, e.offsetY];
	    var singleDefaultHTML = [];
	    var singleParamsList = [];
	    var singleTooltipModel = buildTooltipModel([e.tooltipOption, globalTooltipModel]);
	    each(dataByCoordSys, function (itemCoordSys) {
	      // var coordParamList = [];
	      // var coordDefaultHTML = [];
	      // var coordTooltipModel = buildTooltipModel([
	      //     e.tooltipOption,
	      //     itemCoordSys.tooltipOption,
	      //     ecModel.getComponent(itemCoordSys.coordSysMainType, itemCoordSys.coordSysIndex),
	      //     globalTooltipModel
	      // ]);
	      // var displayMode = coordTooltipModel.get('displayMode');
	      // var paramsList = displayMode === 'single' ? singleParamsList : [];
	      each(itemCoordSys.dataByAxis, function (item) {
	        var axisModel = ecModel.getComponent(item.axisDim + 'Axis', item.axisIndex);
	        var axisValue = item.value;
	        var seriesDefaultHTML = [];
	
	        if (!axisModel || axisValue == null) {
	          return;
	        }
	
	        var valueLabel = axisPointerViewHelper.getValueLabel(axisValue, axisModel.axis, ecModel, item.seriesDataIndices, item.valueLabelOpt);
	        zrUtil.each(item.seriesDataIndices, function (idxItem) {
	          var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
	          var dataIndex = idxItem.dataIndexInside;
	          var dataParams = series && series.getDataParams(dataIndex);
	          dataParams.axisDim = item.axisDim;
	          dataParams.axisIndex = item.axisIndex;
	          dataParams.axisType = item.axisType;
	          dataParams.axisId = item.axisId;
	          dataParams.axisValue = axisHelper.getAxisRawValue(axisModel.axis, axisValue);
	          dataParams.axisValueLabel = valueLabel;
	
	          if (dataParams) {
	            singleParamsList.push(dataParams);
	            seriesDefaultHTML.push(series.formatTooltip(dataIndex, true));
	          }
	        }); // Default tooltip content
	        // FIXME
	        // (1) shold be the first data which has name?
	        // (2) themeRiver, firstDataIndex is array, and first line is unnecessary.
	
	        var firstLine = valueLabel;
	        singleDefaultHTML.push((firstLine ? formatUtil.encodeHTML(firstLine) + '<br />' : '') + seriesDefaultHTML.join('<br />'));
	      });
	    }, this); // In most case, the second axis is shown upper than the first one.
	
	    singleDefaultHTML.reverse();
	    singleDefaultHTML = singleDefaultHTML.join('<br /><br />');
	    var positionExpr = e.position;
	
	    this._showOrMove(singleTooltipModel, function () {
	      if (this._updateContentNotChangedOnAxis(dataByCoordSys)) {
	        this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, singleParamsList);
	      } else {
	        this._showTooltipContent(singleTooltipModel, singleDefaultHTML, singleParamsList, Math.random(), point[0], point[1], positionExpr);
	      }
	    }); // Do not trigger events here, because this branch only be entered
	    // from dispatchAction.
	
	  },
	  _showSeriesItemTooltip: function (e, el, dispatchAction) {
	    var ecModel = this._ecModel; // Use dataModel in element if possible
	    // Used when mouseover on a element like markPoint or edge
	    // In which case, the data is not main data in series.
	
	    var seriesIndex = el.seriesIndex;
	    var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.
	
	    var dataModel = el.dataModel || seriesModel;
	    var dataIndex = el.dataIndex;
	    var dataType = el.dataType;
	    var data = dataModel.getData();
	    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), dataModel, seriesModel && (seriesModel.coordinateSystem || {}).model, this._tooltipModel]);
	    var tooltipTrigger = tooltipModel.get('trigger');
	
	    if (tooltipTrigger != null && tooltipTrigger !== 'item') {
	      return;
	    }
	
	    var params = dataModel.getDataParams(dataIndex, dataType);
	    var defaultHtml = dataModel.formatTooltip(dataIndex, false, dataType);
	    var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
	
	    this._showOrMove(tooltipModel, function () {
	      this._showTooltipContent(tooltipModel, defaultHtml, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target);
	    }); // FIXME
	    // duplicated showtip if manuallyShowTip is called from dispatchAction.
	
	
	    dispatchAction({
	      type: 'showTip',
	      dataIndexInside: dataIndex,
	      dataIndex: data.getRawIndex(dataIndex),
	      seriesIndex: seriesIndex,
	      from: this.uid
	    });
	  },
	  _showComponentItemTooltip: function (e, el, dispatchAction) {
	    var tooltipOpt = el.tooltip;
	
	    if (typeof tooltipOpt === 'string') {
	      var content = tooltipOpt;
	      tooltipOpt = {
	        content: content,
	        // Fixed formatter
	        formatter: content
	      };
	    }
	
	    var subTooltipModel = new Model(tooltipOpt, this._tooltipModel, this._ecModel);
	    var defaultHtml = subTooltipModel.get('content');
	    var asyncTicket = Math.random(); // Do not check whether `trigger` is 'none' here, because `trigger`
	    // only works on cooridinate system. In fact, we have not found case
	    // that requires setting `trigger` nothing on component yet.
	
	    this._showOrMove(subTooltipModel, function () {
	      this._showTooltipContent(subTooltipModel, defaultHtml, subTooltipModel.get('formatterParams') || {}, asyncTicket, e.offsetX, e.offsetY, e.position, el);
	    }); // If not dispatch showTip, tip may be hide triggered by axis.
	
	
	    dispatchAction({
	      type: 'showTip',
	      from: this.uid
	    });
	  },
	  _showTooltipContent: function (tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el) {
	    // Reset ticket
	    this._ticket = '';
	
	    if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) {
	      return;
	    }
	
	    var tooltipContent = this._tooltipContent;
	    var formatter = tooltipModel.get('formatter');
	    positionExpr = positionExpr || tooltipModel.get('position');
	    var html = defaultHtml;
	
	    if (formatter && typeof formatter === 'string') {
	      html = formatUtil.formatTpl(formatter, params, true);
	    } else if (typeof formatter === 'function') {
	      var callback = bind(function (cbTicket, html) {
	        if (cbTicket === this._ticket) {
	          tooltipContent.setContent(html);
	
	          this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
	        }
	      }, this);
	      this._ticket = asyncTicket;
	      html = formatter(params, asyncTicket, callback);
	    }
	
	    tooltipContent.setContent(html);
	    tooltipContent.show(tooltipModel);
	
	    this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
	  },
	
	  /**
	   * @param  {string|Function|Array.<number>|Object} positionExpr
	   * @param  {number} x Mouse x
	   * @param  {number} y Mouse y
	   * @param  {boolean} confine Whether confine tooltip content in view rect.
	   * @param  {Object|<Array.<Object>} params
	   * @param  {module:zrender/Element} el target element
	   * @param  {module:echarts/ExtensionAPI} api
	   * @return {Array.<number>}
	   */
	  _updatePosition: function (tooltipModel, positionExpr, x, y, content, params, el) {
	    var viewWidth = this._api.getWidth();
	
	    var viewHeight = this._api.getHeight();
	
	    positionExpr = positionExpr || tooltipModel.get('position');
	    var contentSize = content.getSize();
	    var align = tooltipModel.get('align');
	    var vAlign = tooltipModel.get('verticalAlign');
	    var rect = el && el.getBoundingRect().clone();
	    el && rect.applyTransform(el.transform);
	
	    if (typeof positionExpr === 'function') {
	      // Callback of position can be an array or a string specify the position
	      positionExpr = positionExpr([x, y], params, content.el, rect, {
	        viewSize: [viewWidth, viewHeight],
	        contentSize: contentSize.slice()
	      });
	    }
	
	    if (zrUtil.isArray(positionExpr)) {
	      x = parsePercent(positionExpr[0], viewWidth);
	      y = parsePercent(positionExpr[1], viewHeight);
	    } else if (zrUtil.isObject(positionExpr)) {
	      positionExpr.width = contentSize[0];
	      positionExpr.height = contentSize[1];
	      var layoutRect = layoutUtil.getLayoutRect(positionExpr, {
	        width: viewWidth,
	        height: viewHeight
	      });
	      x = layoutRect.x;
	      y = layoutRect.y;
	      align = null; // When positionExpr is left/top/right/bottom,
	      // align and verticalAlign will not work.
	
	      vAlign = null;
	    } // Specify tooltip position by string 'top' 'bottom' 'left' 'right' around graphic element
	    else if (typeof positionExpr === 'string' && el) {
	        var pos = calcTooltipPosition(positionExpr, rect, contentSize);
	        x = pos[0];
	        y = pos[1];
	      } else {
	        var pos = refixTooltipPosition(x, y, content.el, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
	        x = pos[0];
	        y = pos[1];
	      }
	
	    align && (x -= isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
	    vAlign && (y -= isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
	
	    if (tooltipModel.get('confine')) {
	      var pos = confineTooltipPosition(x, y, content.el, viewWidth, viewHeight);
	      x = pos[0];
	      y = pos[1];
	    }
	
	    content.moveTo(x, y);
	  },
	  // FIXME
	  // Should we remove this but leave this to user?
	  _updateContentNotChangedOnAxis: function (dataByCoordSys) {
	    var lastCoordSys = this._lastDataByCoordSys;
	    var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
	    contentNotChanged && each(lastCoordSys, function (lastItemCoordSys, indexCoordSys) {
	      var lastDataByAxis = lastItemCoordSys.dataByAxis || {};
	      var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
	      var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
	      contentNotChanged &= lastDataByAxis.length === thisDataByAxis.length;
	      contentNotChanged && each(lastDataByAxis, function (lastItem, indexAxis) {
	        var thisItem = thisDataByAxis[indexAxis] || {};
	        var lastIndices = lastItem.seriesDataIndices || [];
	        var newIndices = thisItem.seriesDataIndices || [];
	        contentNotChanged &= lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
	        contentNotChanged && each(lastIndices, function (lastIdxItem, j) {
	          var newIdxItem = newIndices[j];
	          contentNotChanged &= lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
	        });
	      });
	    });
	    this._lastDataByCoordSys = dataByCoordSys;
	    return !!contentNotChanged;
	  },
	  _hide: function (dispatchAction) {
	    // Do not directly hideLater here, because this behavior may be prevented
	    // in dispatchAction when showTip is dispatched.
	    // FIXME
	    // duplicated hideTip if manuallyHideTip is called from dispatchAction.
	    this._lastDataByCoordSys = null;
	    dispatchAction({
	      type: 'hideTip',
	      from: this.uid
	    });
	  },
	  dispose: function (ecModel, api) {
	    if (env.node) {
	      return;
	    }
	
	    this._tooltipContent.hide();
	
	    globalListener.unregister('itemTooltip', api);
	  }
	});
	/**
	 * @param {Array.<Object|module:echarts/model/Model>} modelCascade
	 * From top to bottom. (the last one should be globalTooltipModel);
	 */
	
	
	function buildTooltipModel(modelCascade) {
	  var resultModel = modelCascade.pop();
	
	  while (modelCascade.length) {
	    var tooltipOpt = modelCascade.pop();
	
	    if (tooltipOpt) {
	      if (tooltipOpt instanceof Model) {
	        tooltipOpt = tooltipOpt.get('tooltip', true);
	      } // In each data item tooltip can be simply write:
	      // {
	      //  value: 10,
	      //  tooltip: 'Something you need to know'
	      // }
	
	
	      if (typeof tooltipOpt === 'string') {
	        tooltipOpt = {
	          formatter: tooltipOpt
	        };
	      }
	
	      resultModel = new Model(tooltipOpt, resultModel, resultModel.ecModel);
	    }
	  }
	
	  return resultModel;
	}
	
	function makeDispatchAction(payload, api) {
	  return payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
	}
	
	function refixTooltipPosition(x, y, el, viewWidth, viewHeight, gapH, gapV) {
	  var size = getOuterSize(el);
	  var width = size.width;
	  var height = size.height;
	
	  if (gapH != null) {
	    if (x + width + gapH > viewWidth) {
	      x -= width + gapH;
	    } else {
	      x += gapH;
	    }
	  }
	
	  if (gapV != null) {
	    if (y + height + gapV > viewHeight) {
	      y -= height + gapV;
	    } else {
	      y += gapV;
	    }
	  }
	
	  return [x, y];
	}
	
	function confineTooltipPosition(x, y, el, viewWidth, viewHeight) {
	  var size = getOuterSize(el);
	  var width = size.width;
	  var height = size.height;
	  x = Math.min(x + width, viewWidth) - width;
	  y = Math.min(y + height, viewHeight) - height;
	  x = Math.max(x, 0);
	  y = Math.max(y, 0);
	  return [x, y];
	}
	
	function getOuterSize(el) {
	  var width = el.clientWidth;
	  var height = el.clientHeight; // Consider browser compatibility.
	  // IE8 does not support getComputedStyle.
	
	  if (document.defaultView && document.defaultView.getComputedStyle) {
	    var stl = document.defaultView.getComputedStyle(el);
	
	    if (stl) {
	      width += parseInt(stl.paddingLeft, 10) + parseInt(stl.paddingRight, 10) + parseInt(stl.borderLeftWidth, 10) + parseInt(stl.borderRightWidth, 10);
	      height += parseInt(stl.paddingTop, 10) + parseInt(stl.paddingBottom, 10) + parseInt(stl.borderTopWidth, 10) + parseInt(stl.borderBottomWidth, 10);
	    }
	  }
	
	  return {
	    width: width,
	    height: height
	  };
	}
	
	function calcTooltipPosition(position, rect, contentSize) {
	  var domWidth = contentSize[0];
	  var domHeight = contentSize[1];
	  var gap = 5;
	  var x = 0;
	  var y = 0;
	  var rectWidth = rect.width;
	  var rectHeight = rect.height;
	
	  switch (position) {
	    case 'inside':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	      break;
	
	    case 'top':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y - domHeight - gap;
	      break;
	
	    case 'bottom':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y + rectHeight + gap;
	      break;
	
	    case 'left':
	      x = rect.x - domWidth - gap;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	      break;
	
	    case 'right':
	      x = rect.x + rectWidth + gap;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	  }
	
	  return [x, y];
	}
	
	function isCenterAlign(align) {
	  return align === 'center' || align === 'middle';
	}
	
	module.exports = _default;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(542);
	
	__webpack_require__(543);

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var VisualMapModel = __webpack_require__(186);
	
	var numberUtil = __webpack_require__(4);
	
	// Constant
	var DEFAULT_BAR_BOUND = [20, 140];
	var ContinuousModel = VisualMapModel.extend({
	  type: 'visualMap.continuous',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    align: 'auto',
	    // 'auto', 'left', 'right', 'top', 'bottom'
	    calculable: false,
	    // This prop effect default component type determine,
	    // See echarts/component/visualMap/typeDefaulter.
	    range: null,
	    // selected range. In default case `range` is [min, max]
	    // and can auto change along with modification of min max,
	    // util use specifid a range.
	    realtime: true,
	    // Whether realtime update.
	    itemHeight: null,
	    // The length of the range control edge.
	    itemWidth: null,
	    // The length of the other side.
	    hoverLink: true,
	    // Enable hover highlight.
	    hoverLinkDataSize: null,
	    // The size of hovered data.
	    hoverLinkOnHandle: null // Whether trigger hoverLink when hover handle.
	    // If not specified, follow the value of `realtime`.
	
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    ContinuousModel.superApply(this, 'optionUpdated', arguments);
	    this.resetExtent();
	    this.resetVisual(function (mappingOption) {
	      mappingOption.mappingMethod = 'linear';
	      mappingOption.dataExtent = this.getExtent();
	    });
	
	    this._resetRange();
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  resetItemSize: function () {
	    ContinuousModel.superApply(this, 'resetItemSize', arguments);
	    var itemSize = this.itemSize;
	    this._orient === 'horizontal' && itemSize.reverse();
	    (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = DEFAULT_BAR_BOUND[0]);
	    (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = DEFAULT_BAR_BOUND[1]);
	  },
	
	  /**
	   * @private
	   */
	  _resetRange: function () {
	    var dataExtent = this.getExtent();
	    var range = this.option.range;
	
	    if (!range || range.auto) {
	      // `range` should always be array (so we dont use other
	      // value like 'auto') for user-friend. (consider getOption).
	      dataExtent.auto = 1;
	      this.option.range = dataExtent;
	    } else if (zrUtil.isArray(range)) {
	      if (range[0] > range[1]) {
	        range.reverse();
	      }
	
	      range[0] = Math.max(range[0], dataExtent[0]);
	      range[1] = Math.min(range[1], dataExtent[1]);
	    }
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  completeVisualOption: function () {
	    VisualMapModel.prototype.completeVisualOption.apply(this, arguments);
	    zrUtil.each(this.stateList, function (state) {
	      var symbolSize = this.option.controller[state].symbolSize;
	
	      if (symbolSize && symbolSize[0] !== symbolSize[1]) {
	        symbolSize[0] = 0; // For good looking.
	      }
	    }, this);
	  },
	
	  /**
	   * @override
	   */
	  setSelected: function (selected) {
	    this.option.range = selected.slice();
	
	    this._resetRange();
	  },
	
	  /**
	   * @public
	   */
	  getSelected: function () {
	    var dataExtent = this.getExtent();
	    var dataInterval = numberUtil.asc((this.get('range') || []).slice()); // Clamp
	
	    dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
	    dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
	    dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
	    dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
	    return dataInterval;
	  },
	
	  /**
	   * @override
	   */
	  getValueState: function (value) {
	    var range = this.option.range;
	    var dataExtent = this.getExtent(); // When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
	    // range[1] is processed likewise.
	
	    return (range[0] <= dataExtent[0] || range[0] <= value) && (range[1] >= dataExtent[1] || value <= range[1]) ? 'inRange' : 'outOfRange';
	  },
	
	  /**
	   * @params {Array.<number>} range target value: range[0] <= value && value <= range[1]
	   * @return {Array.<Object>} [{seriesId, dataIndices: <Array.<number>>}, ...]
	   */
	  findTargetDataIndices: function (range) {
	    var result = [];
	    this.eachTargetSeries(function (seriesModel) {
	      var dataIndices = [];
	      var data = seriesModel.getData();
	      data.each(this.getDataDimension(data), function (value, dataIndex) {
	        range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
	      }, true, this);
	      result.push({
	        seriesId: seriesModel.id,
	        dataIndex: dataIndices
	      });
	    }, this);
	    return result;
	  },
	
	  /**
	   * @implement
	   */
	  getVisualMeta: function (getColorVisual) {
	    var oVals = getColorStopValues(this, 'outOfRange', this.getExtent());
	    var iVals = getColorStopValues(this, 'inRange', this.option.range.slice());
	    var stops = [];
	
	    function setStop(value, valueState) {
	      stops.push({
	        value: value,
	        color: getColorVisual(value, valueState)
	      });
	    } // Format to: outOfRange -- inRange -- outOfRange.
	
	
	    var iIdx = 0;
	    var oIdx = 0;
	    var iLen = iVals.length;
	    var oLen = oVals.length;
	
	    for (; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++) {
	      // If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
	      if (oVals[oIdx] < iVals[iIdx]) {
	        setStop(oVals[oIdx], 'outOfRange');
	      }
	    }
	
	    for (var first = 1; iIdx < iLen; iIdx++, first = 0) {
	      // If range is full, value beyond min, max will be clamped.
	      // make a singularity
	      first && stops.length && setStop(iVals[iIdx], 'outOfRange');
	      setStop(iVals[iIdx], 'inRange');
	    }
	
	    for (var first = 1; oIdx < oLen; oIdx++) {
	      if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
	        // make a singularity
	        if (first) {
	          stops.length && setStop(stops[stops.length - 1].value, 'outOfRange');
	          first = 0;
	        }
	
	        setStop(oVals[oIdx], 'outOfRange');
	      }
	    }
	
	    var stopsLen = stops.length;
	    return {
	      stops: stops,
	      outerColors: [stopsLen ? stops[0].color : 'transparent', stopsLen ? stops[stopsLen - 1].color : 'transparent']
	    };
	  }
	});
	
	function getColorStopValues(visualMapModel, valueState, dataExtent) {
	  if (dataExtent[0] === dataExtent[1]) {
	    return dataExtent.slice();
	  } // When using colorHue mapping, it is not linear color any more.
	  // Moreover, canvas gradient seems not to be accurate linear.
	  // FIXME
	  // Should be arbitrary value 100? or based on pixel size?
	
	
	  var count = 200;
	  var step = (dataExtent[1] - dataExtent[0]) / count;
	  var value = dataExtent[0];
	  var stopValues = [];
	
	  for (var i = 0; i <= count && value < dataExtent[1]; i++) {
	    stopValues.push(value);
	    value += step;
	  }
	
	  stopValues.push(dataExtent[1]);
	  return stopValues;
	}
	
	var _default = ContinuousModel;
	module.exports = _default;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var LinearGradient = __webpack_require__(223);
	
	var eventTool = __webpack_require__(30);
	
	var VisualMapView = __webpack_require__(187);
	
	var graphic = __webpack_require__(3);
	
	var numberUtil = __webpack_require__(4);
	
	var sliderMove = __webpack_require__(71);
	
	var helper = __webpack_require__(188);
	
	var modelUtil = __webpack_require__(6);
	
	var linearMap = numberUtil.linearMap;
	var each = zrUtil.each;
	var mathMin = Math.min;
	var mathMax = Math.max; // Arbitrary value
	
	var HOVER_LINK_SIZE = 12;
	var HOVER_LINK_OUT = 6; // Notice:
	// Any "interval" should be by the order of [low, high].
	// "handle0" (handleIndex === 0) maps to
	// low data value: this._dataInterval[0] and has low coord.
	// "handle1" (handleIndex === 1) maps to
	// high data value: this._dataInterval[1] and has high coord.
	// The logic of transform is implemented in this._createBarGroup.
	
	var ContinuousView = VisualMapView.extend({
	  type: 'visualMap.continuous',
	
	  /**
	   * @override
	   */
	  init: function () {
	    ContinuousView.superApply(this, 'init', arguments);
	    /**
	     * @private
	     */
	
	    this._shapes = {};
	    /**
	     * @private
	     */
	
	    this._dataInterval = [];
	    /**
	     * @private
	     */
	
	    this._handleEnds = [];
	    /**
	     * @private
	     */
	
	    this._orient;
	    /**
	     * @private
	     */
	
	    this._useHandle;
	    /**
	     * @private
	     */
	
	    this._hoverLinkDataIndices = [];
	    /**
	     * @private
	     */
	
	    this._dragging;
	    /**
	     * @private
	     */
	
	    this._hovering;
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  doRender: function (visualMapModel, ecModel, api, payload) {
	    if (!payload || payload.type !== 'selectDataRange' || payload.from !== this.uid) {
	      this._buildView();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _buildView: function () {
	    this.group.removeAll();
	    var visualMapModel = this.visualMapModel;
	    var thisGroup = this.group;
	    this._orient = visualMapModel.get('orient');
	    this._useHandle = visualMapModel.get('calculable');
	
	    this._resetInterval();
	
	    this._renderBar(thisGroup);
	
	    var dataRangeText = visualMapModel.get('text');
	
	    this._renderEndsText(thisGroup, dataRangeText, 0);
	
	    this._renderEndsText(thisGroup, dataRangeText, 1); // Do this for background size calculation.
	
	
	    this._updateView(true); // After updating view, inner shapes is built completely,
	    // and then background can be rendered.
	
	
	    this.renderBackground(thisGroup); // Real update view
	
	    this._updateView();
	
	    this._enableHoverLinkToSeries();
	
	    this._enableHoverLinkFromSeries();
	
	    this.positionGroup(thisGroup);
	  },
	
	  /**
	   * @private
	   */
	  _renderEndsText: function (group, dataRangeText, endsIndex) {
	    if (!dataRangeText) {
	      return;
	    } // Compatible with ec2, text[0] map to high value, text[1] map low value.
	
	
	    var text = dataRangeText[1 - endsIndex];
	    text = text != null ? text + '' : '';
	    var visualMapModel = this.visualMapModel;
	    var textGap = visualMapModel.get('textGap');
	    var itemSize = visualMapModel.itemSize;
	    var barGroup = this._shapes.barGroup;
	
	    var position = this._applyTransform([itemSize[0] / 2, endsIndex === 0 ? -textGap : itemSize[1] + textGap], barGroup);
	
	    var align = this._applyTransform(endsIndex === 0 ? 'bottom' : 'top', barGroup);
	
	    var orient = this._orient;
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    this.group.add(new graphic.Text({
	      style: {
	        x: position[0],
	        y: position[1],
	        textVerticalAlign: orient === 'horizontal' ? 'middle' : align,
	        textAlign: orient === 'horizontal' ? align : 'center',
	        text: text,
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _renderBar: function (targetGroup) {
	    var visualMapModel = this.visualMapModel;
	    var shapes = this._shapes;
	    var itemSize = visualMapModel.itemSize;
	    var orient = this._orient;
	    var useHandle = this._useHandle;
	    var itemAlign = helper.getItemAlign(visualMapModel, this.api, itemSize);
	
	    var barGroup = shapes.barGroup = this._createBarGroup(itemAlign); // Bar
	
	
	    barGroup.add(shapes.outOfRange = createPolygon());
	    barGroup.add(shapes.inRange = createPolygon(null, useHandle ? getCursor(this._orient) : null, zrUtil.bind(this._dragHandle, this, 'all', false), zrUtil.bind(this._dragHandle, this, 'all', true)));
	    var textRect = visualMapModel.textStyleModel.getTextRect('国');
	    var textSize = mathMax(textRect.width, textRect.height); // Handle
	
	    if (useHandle) {
	      shapes.handleThumbs = [];
	      shapes.handleLabels = [];
	      shapes.handleLabelPoints = [];
	
	      this._createHandle(barGroup, 0, itemSize, textSize, orient, itemAlign);
	
	      this._createHandle(barGroup, 1, itemSize, textSize, orient, itemAlign);
	    }
	
	    this._createIndicator(barGroup, itemSize, textSize, orient);
	
	    targetGroup.add(barGroup);
	  },
	
	  /**
	   * @private
	   */
	  _createHandle: function (barGroup, handleIndex, itemSize, textSize, orient) {
	    var onDrift = zrUtil.bind(this._dragHandle, this, handleIndex, false);
	    var onDragEnd = zrUtil.bind(this._dragHandle, this, handleIndex, true);
	    var handleThumb = createPolygon(createHandlePoints(handleIndex, textSize), getCursor(this._orient), onDrift, onDragEnd);
	    handleThumb.position[0] = itemSize[0];
	    barGroup.add(handleThumb); // Text is always horizontal layout but should not be effected by
	    // transform (orient/inverse). So label is built separately but not
	    // use zrender/graphic/helper/RectText, and is located based on view
	    // group (according to handleLabelPoint) but not barGroup.
	
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    var handleLabel = new graphic.Text({
	      draggable: true,
	      drift: onDrift,
	      onmousemove: function (e) {
	        // Fot mobile devicem, prevent screen slider on the button.
	        eventTool.stop(e.event);
	      },
	      ondragend: onDragEnd,
	      style: {
	        x: 0,
	        y: 0,
	        text: '',
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    });
	    this.group.add(handleLabel);
	    var handleLabelPoint = [orient === 'horizontal' ? textSize / 2 : textSize * 1.5, orient === 'horizontal' ? handleIndex === 0 ? -(textSize * 1.5) : textSize * 1.5 : handleIndex === 0 ? -textSize / 2 : textSize / 2];
	    var shapes = this._shapes;
	    shapes.handleThumbs[handleIndex] = handleThumb;
	    shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
	    shapes.handleLabels[handleIndex] = handleLabel;
	  },
	
	  /**
	   * @private
	   */
	  _createIndicator: function (barGroup, itemSize, textSize, orient) {
	    var indicator = createPolygon([[0, 0]], 'move');
	    indicator.position[0] = itemSize[0];
	    indicator.attr({
	      invisible: true,
	      silent: true
	    });
	    barGroup.add(indicator);
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    var indicatorLabel = new graphic.Text({
	      silent: true,
	      invisible: true,
	      style: {
	        x: 0,
	        y: 0,
	        text: '',
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    });
	    this.group.add(indicatorLabel);
	    var indicatorLabelPoint = [orient === 'horizontal' ? textSize / 2 : HOVER_LINK_OUT + 3, 0];
	    var shapes = this._shapes;
	    shapes.indicator = indicator;
	    shapes.indicatorLabel = indicatorLabel;
	    shapes.indicatorLabelPoint = indicatorLabelPoint;
	  },
	
	  /**
	   * @private
	   */
	  _dragHandle: function (handleIndex, isEnd, dx, dy) {
	    if (!this._useHandle) {
	      return;
	    }
	
	    this._dragging = !isEnd;
	
	    if (!isEnd) {
	      // Transform dx, dy to bar coordination.
	      var vertex = this._applyTransform([dx, dy], this._shapes.barGroup, true);
	
	      this._updateInterval(handleIndex, vertex[1]); // Considering realtime, update view should be executed
	      // before dispatch action.
	
	
	      this._updateView();
	    } // dragEnd do not dispatch action when realtime.
	
	
	    if (isEnd === !this.visualMapModel.get('realtime')) {
	      // jshint ignore:line
	      this.api.dispatchAction({
	        type: 'selectDataRange',
	        from: this.uid,
	        visualMapId: this.visualMapModel.id,
	        selected: this._dataInterval.slice()
	      });
	    }
	
	    if (isEnd) {
	      !this._hovering && this._clearHoverLinkToSeries();
	    } else if (useHoverLinkOnHandle(this.visualMapModel)) {
	      this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _resetInterval: function () {
	    var visualMapModel = this.visualMapModel;
	    var dataInterval = this._dataInterval = visualMapModel.getSelected();
	    var dataExtent = visualMapModel.getExtent();
	    var sizeExtent = [0, visualMapModel.itemSize[1]];
	    this._handleEnds = [linearMap(dataInterval[0], dataExtent, sizeExtent, true), linearMap(dataInterval[1], dataExtent, sizeExtent, true)];
	  },
	
	  /**
	   * @private
	   * @param {(number|string)} handleIndex 0 or 1 or 'all'
	   * @param {number} dx
	   * @param {number} dy
	   */
	  _updateInterval: function (handleIndex, delta) {
	    delta = delta || 0;
	    var visualMapModel = this.visualMapModel;
	    var handleEnds = this._handleEnds;
	    var sizeExtent = [0, visualMapModel.itemSize[1]];
	    sliderMove(delta, handleEnds, sizeExtent, handleIndex, // cross is forbiden
	    0);
	    var dataExtent = visualMapModel.getExtent(); // Update data interval.
	
	    this._dataInterval = [linearMap(handleEnds[0], sizeExtent, dataExtent, true), linearMap(handleEnds[1], sizeExtent, dataExtent, true)];
	  },
	
	  /**
	   * @private
	   */
	  _updateView: function (forSketch) {
	    var visualMapModel = this.visualMapModel;
	    var dataExtent = visualMapModel.getExtent();
	    var shapes = this._shapes;
	    var outOfRangeHandleEnds = [0, visualMapModel.itemSize[1]];
	    var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;
	
	    var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, 'inRange');
	
	    var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, 'outOfRange');
	
	    shapes.inRange.setStyle({
	      fill: visualInRange.barColor,
	      opacity: visualInRange.opacity
	    }).setShape('points', visualInRange.barPoints);
	    shapes.outOfRange.setStyle({
	      fill: visualOutOfRange.barColor,
	      opacity: visualOutOfRange.opacity
	    }).setShape('points', visualOutOfRange.barPoints);
	
	    this._updateHandle(inRangeHandleEnds, visualInRange);
	  },
	
	  /**
	   * @private
	   */
	  _createBarVisual: function (dataInterval, dataExtent, handleEnds, forceState) {
	    var opts = {
	      forceState: forceState,
	      convertOpacityToAlpha: true
	    };
	
	    var colorStops = this._makeColorGradient(dataInterval, opts);
	
	    var symbolSizes = [this.getControllerVisual(dataInterval[0], 'symbolSize', opts), this.getControllerVisual(dataInterval[1], 'symbolSize', opts)];
	
	    var barPoints = this._createBarPoints(handleEnds, symbolSizes);
	
	    return {
	      barColor: new LinearGradient(0, 0, 0, 1, colorStops),
	      barPoints: barPoints,
	      handlesColor: [colorStops[0].color, colorStops[colorStops.length - 1].color]
	    };
	  },
	
	  /**
	   * @private
	   */
	  _makeColorGradient: function (dataInterval, opts) {
	    // Considering colorHue, which is not linear, so we have to sample
	    // to calculate gradient color stops, but not only caculate head
	    // and tail.
	    var sampleNumber = 100; // Arbitrary value.
	
	    var colorStops = [];
	    var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
	    colorStops.push({
	      color: this.getControllerVisual(dataInterval[0], 'color', opts),
	      offset: 0
	    });
	
	    for (var i = 1; i < sampleNumber; i++) {
	      var currValue = dataInterval[0] + step * i;
	
	      if (currValue > dataInterval[1]) {
	        break;
	      }
	
	      colorStops.push({
	        color: this.getControllerVisual(currValue, 'color', opts),
	        offset: i / sampleNumber
	      });
	    }
	
	    colorStops.push({
	      color: this.getControllerVisual(dataInterval[1], 'color', opts),
	      offset: 1
	    });
	    return colorStops;
	  },
	
	  /**
	   * @private
	   */
	  _createBarPoints: function (handleEnds, symbolSizes) {
	    var itemSize = this.visualMapModel.itemSize;
	    return [[itemSize[0] - symbolSizes[0], handleEnds[0]], [itemSize[0], handleEnds[0]], [itemSize[0], handleEnds[1]], [itemSize[0] - symbolSizes[1], handleEnds[1]]];
	  },
	
	  /**
	   * @private
	   */
	  _createBarGroup: function (itemAlign) {
	    var orient = this._orient;
	    var inverse = this.visualMapModel.get('inverse');
	    return new graphic.Group(orient === 'horizontal' && !inverse ? {
	      scale: itemAlign === 'bottom' ? [1, 1] : [-1, 1],
	      rotation: Math.PI / 2
	    } : orient === 'horizontal' && inverse ? {
	      scale: itemAlign === 'bottom' ? [-1, 1] : [1, 1],
	      rotation: -Math.PI / 2
	    } : orient === 'vertical' && !inverse ? {
	      scale: itemAlign === 'left' ? [1, -1] : [-1, -1]
	    } : {
	      scale: itemAlign === 'left' ? [1, 1] : [-1, 1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _updateHandle: function (handleEnds, visualInRange) {
	    if (!this._useHandle) {
	      return;
	    }
	
	    var shapes = this._shapes;
	    var visualMapModel = this.visualMapModel;
	    var handleThumbs = shapes.handleThumbs;
	    var handleLabels = shapes.handleLabels;
	    each([0, 1], function (handleIndex) {
	      var handleThumb = handleThumbs[handleIndex];
	      handleThumb.setStyle('fill', visualInRange.handlesColor[handleIndex]);
	      handleThumb.position[1] = handleEnds[handleIndex]; // Update handle label position.
	
	      var textPoint = graphic.applyTransform(shapes.handleLabelPoints[handleIndex], graphic.getTransform(handleThumb, this.group));
	      handleLabels[handleIndex].setStyle({
	        x: textPoint[0],
	        y: textPoint[1],
	        text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
	        textVerticalAlign: 'middle',
	        textAlign: this._applyTransform(this._orient === 'horizontal' ? handleIndex === 0 ? 'bottom' : 'top' : 'left', shapes.barGroup)
	      });
	    }, this);
	  },
	
	  /**
	   * @private
	   * @param {number} cursorValue
	   * @param {number} textValue
	   * @param {string} [rangeSymbol]
	   * @param {number} [halfHoverLinkSize]
	   */
	  _showIndicator: function (cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
	    var visualMapModel = this.visualMapModel;
	    var dataExtent = visualMapModel.getExtent();
	    var itemSize = visualMapModel.itemSize;
	    var sizeExtent = [0, itemSize[1]];
	    var pos = linearMap(cursorValue, dataExtent, sizeExtent, true);
	    var shapes = this._shapes;
	    var indicator = shapes.indicator;
	
	    if (!indicator) {
	      return;
	    }
	
	    indicator.position[1] = pos;
	    indicator.attr('invisible', false);
	    indicator.setShape('points', createIndicatorPoints(!!rangeSymbol, halfHoverLinkSize, pos, itemSize[1]));
	    var opts = {
	      convertOpacityToAlpha: true
	    };
	    var color = this.getControllerVisual(cursorValue, 'color', opts);
	    indicator.setStyle('fill', color); // Update handle label position.
	
	    var textPoint = graphic.applyTransform(shapes.indicatorLabelPoint, graphic.getTransform(indicator, this.group));
	    var indicatorLabel = shapes.indicatorLabel;
	    indicatorLabel.attr('invisible', false);
	
	    var align = this._applyTransform('left', shapes.barGroup);
	
	    var orient = this._orient;
	    indicatorLabel.setStyle({
	      text: (rangeSymbol ? rangeSymbol : '') + visualMapModel.formatValueText(textValue),
	      textVerticalAlign: orient === 'horizontal' ? align : 'middle',
	      textAlign: orient === 'horizontal' ? 'center' : align,
	      x: textPoint[0],
	      y: textPoint[1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLinkToSeries: function () {
	    var self = this;
	
	    this._shapes.barGroup.on('mousemove', function (e) {
	      self._hovering = true;
	
	      if (!self._dragging) {
	        var itemSize = self.visualMapModel.itemSize;
	
	        var pos = self._applyTransform([e.offsetX, e.offsetY], self._shapes.barGroup, true, true); // For hover link show when hover handle, which might be
	        // below or upper than sizeExtent.
	
	
	        pos[1] = mathMin(mathMax(0, pos[1]), itemSize[1]);
	
	        self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
	      }
	    }).on('mouseout', function () {
	      // When mouse is out of handle, hoverLink still need
	      // to be displayed when realtime is set as false.
	      self._hovering = false;
	      !self._dragging && self._clearHoverLinkToSeries();
	    });
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLinkFromSeries: function () {
	    var zr = this.api.getZr();
	
	    if (this.visualMapModel.option.hoverLink) {
	      zr.on('mouseover', this._hoverLinkFromSeriesMouseOver, this);
	      zr.on('mouseout', this._hideIndicator, this);
	    } else {
	      this._clearHoverLinkFromSeries();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _doHoverLinkToSeries: function (cursorPos, hoverOnBar) {
	    var visualMapModel = this.visualMapModel;
	    var itemSize = visualMapModel.itemSize;
	
	    if (!visualMapModel.option.hoverLink) {
	      return;
	    }
	
	    var sizeExtent = [0, itemSize[1]];
	    var dataExtent = visualMapModel.getExtent(); // For hover link show when hover handle, which might be below or upper than sizeExtent.
	
	    cursorPos = mathMin(mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
	    var halfHoverLinkSize = getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
	    var hoverRange = [cursorPos - halfHoverLinkSize, cursorPos + halfHoverLinkSize];
	    var cursorValue = linearMap(cursorPos, sizeExtent, dataExtent, true);
	    var valueRange = [linearMap(hoverRange[0], sizeExtent, dataExtent, true), linearMap(hoverRange[1], sizeExtent, dataExtent, true)]; // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
	    // where china and india has very large population.
	
	    hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
	    hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity); // Do not show indicator when mouse is over handle,
	    // otherwise labels overlap, especially when dragging.
	
	    if (hoverOnBar) {
	      if (valueRange[0] === -Infinity) {
	        this._showIndicator(cursorValue, valueRange[1], '< ', halfHoverLinkSize);
	      } else if (valueRange[1] === Infinity) {
	        this._showIndicator(cursorValue, valueRange[0], '> ', halfHoverLinkSize);
	      } else {
	        this._showIndicator(cursorValue, cursorValue, '≈ ', halfHoverLinkSize);
	      }
	    } // When realtime is set as false, handles, which are in barGroup,
	    // also trigger hoverLink, which help user to realize where they
	    // focus on when dragging. (see test/heatmap-large.html)
	    // When realtime is set as true, highlight will not show when hover
	    // handle, because the label on handle, which displays a exact value
	    // but not range, might mislead users.
	
	
	    var oldBatch = this._hoverLinkDataIndices;
	    var newBatch = [];
	
	    if (hoverOnBar || useHoverLinkOnHandle(visualMapModel)) {
	      newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
	    }
	
	    var resultBatches = modelUtil.compressBatches(oldBatch, newBatch);
	
	    this._dispatchHighDown('downplay', helper.convertDataIndex(resultBatches[0]));
	
	    this._dispatchHighDown('highlight', helper.convertDataIndex(resultBatches[1]));
	  },
	
	  /**
	   * @private
	   */
	  _hoverLinkFromSeriesMouseOver: function (e) {
	    var el = e.target;
	    var visualMapModel = this.visualMapModel;
	
	    if (!el || el.dataIndex == null) {
	      return;
	    }
	
	    var dataModel = this.ecModel.getSeriesByIndex(el.seriesIndex);
	
	    if (!visualMapModel.isTargetSeries(dataModel)) {
	      return;
	    }
	
	    var data = dataModel.getData(el.dataType);
	    var dim = data.getDimension(visualMapModel.getDataDimension(data));
	    var value = data.get(dim, el.dataIndex, true);
	
	    if (!isNaN(value)) {
	      this._showIndicator(value, value);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _hideIndicator: function () {
	    var shapes = this._shapes;
	    shapes.indicator && shapes.indicator.attr('invisible', true);
	    shapes.indicatorLabel && shapes.indicatorLabel.attr('invisible', true);
	  },
	
	  /**
	   * @private
	   */
	  _clearHoverLinkToSeries: function () {
	    this._hideIndicator();
	
	    var indices = this._hoverLinkDataIndices;
	
	    this._dispatchHighDown('downplay', helper.convertDataIndex(indices));
	
	    indices.length = 0;
	  },
	
	  /**
	   * @private
	   */
	  _clearHoverLinkFromSeries: function () {
	    this._hideIndicator();
	
	    var zr = this.api.getZr();
	    zr.off('mouseover', this._hoverLinkFromSeriesMouseOver);
	    zr.off('mouseout', this._hideIndicator);
	  },
	
	  /**
	   * @private
	   */
	  _applyTransform: function (vertex, element, inverse, global) {
	    var transform = graphic.getTransform(element, global ? null : this.group);
	    return graphic[zrUtil.isArray(vertex) ? 'applyTransform' : 'transformDirection'](vertex, transform, inverse);
	  },
	
	  /**
	   * @private
	   */
	  _dispatchHighDown: function (type, batch) {
	    batch && batch.length && this.api.dispatchAction({
	      type: type,
	      batch: batch
	    });
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clearHoverLinkFromSeries();
	
	    this._clearHoverLinkToSeries();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearHoverLinkFromSeries();
	
	    this._clearHoverLinkToSeries();
	  }
	});
	
	function createPolygon(points, cursor, onDrift, onDragEnd) {
	  return new graphic.Polygon({
	    shape: {
	      points: points
	    },
	    draggable: !!onDrift,
	    cursor: cursor,
	    drift: onDrift,
	    onmousemove: function (e) {
	      // Fot mobile devicem, prevent screen slider on the button.
	      eventTool.stop(e.event);
	    },
	    ondragend: onDragEnd
	  });
	}
	
	function createHandlePoints(handleIndex, textSize) {
	  return handleIndex === 0 ? [[0, 0], [textSize, 0], [textSize, -textSize]] : [[0, 0], [textSize, 0], [textSize, textSize]];
	}
	
	function createIndicatorPoints(isRange, halfHoverLinkSize, pos, extentMax) {
	  return isRange ? [// indicate range
	  [0, -mathMin(halfHoverLinkSize, mathMax(pos, 0))], [HOVER_LINK_OUT, 0], [0, mathMin(halfHoverLinkSize, mathMax(extentMax - pos, 0))]] : [// indicate single value
	  [0, 0], [5, -5], [5, 5]];
	}
	
	function getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
	  var halfHoverLinkSize = HOVER_LINK_SIZE / 2;
	  var hoverLinkDataSize = visualMapModel.get('hoverLinkDataSize');
	
	  if (hoverLinkDataSize) {
	    halfHoverLinkSize = linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
	  }
	
	  return halfHoverLinkSize;
	}
	
	function useHoverLinkOnHandle(visualMapModel) {
	  var hoverLinkOnHandle = visualMapModel.get('hoverLinkOnHandle');
	  return !!(hoverLinkOnHandle == null ? visualMapModel.get('realtime') : hoverLinkOnHandle);
	}
	
	function getCursor(orient) {
	  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
	}
	
	var _default = ContinuousView;
	module.exports = _default;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(1);
	
	var VisualMapModel = __webpack_require__(186);
	
	var VisualMapping = __webpack_require__(46);
	
	var visualDefault = __webpack_require__(205);
	
	var _number = __webpack_require__(4);
	
	var reformIntervals = _number.reformIntervals;
	var PiecewiseModel = VisualMapModel.extend({
	  type: 'visualMap.piecewise',
	
	  /**
	   * Order Rule:
	   *
	   * option.categories / option.pieces / option.text / option.selected:
	   *     If !option.inverse,
	   *     Order when vertical: ['top', ..., 'bottom'].
	   *     Order when horizontal: ['left', ..., 'right'].
	   *     If option.inverse, the meaning of
	   *     the order should be reversed.
	   *
	   * this._pieceList:
	   *     The order is always [low, ..., high].
	   *
	   * Mapping from location to low-high:
	   *     If !option.inverse
	   *     When vertical, top is high.
	   *     When horizontal, right is high.
	   *     If option.inverse, reverse.
	   */
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    selected: null,
	    // Object. If not specified, means selected.
	    // When pieces and splitNumber: {'0': true, '5': true}
	    // When categories: {'cate1': false, 'cate3': true}
	    // When selected === false, means all unselected.
	    minOpen: false,
	    // Whether include values that smaller than `min`.
	    maxOpen: false,
	    // Whether include values that bigger than `max`.
	    align: 'auto',
	    // 'auto', 'left', 'right'
	    itemWidth: 20,
	    // When put the controller vertically, it is the length of
	    // horizontal side of each item. Otherwise, vertical side.
	    itemHeight: 14,
	    // When put the controller vertically, it is the length of
	    // vertical side of each item. Otherwise, horizontal side.
	    itemSymbol: 'roundRect',
	    pieceList: null,
	    // Each item is Object, with some of those attrs:
	    // {min, max, lt, gt, lte, gte, value,
	    // color, colorSaturation, colorAlpha, opacity,
	    // symbol, symbolSize}, which customize the range or visual
	    // coding of the certain piece. Besides, see "Order Rule".
	    categories: null,
	    // category names, like: ['some1', 'some2', 'some3'].
	    // Attr min/max are ignored when categories set. See "Order Rule"
	    splitNumber: 5,
	    // If set to 5, auto split five pieces equally.
	    // If set to 0 and component type not set, component type will be
	    // determined as "continuous". (It is less reasonable but for ec2
	    // compatibility, see echarts/component/visualMap/typeDefaulter)
	    selectedMode: 'multiple',
	    // Can be 'multiple' or 'single'.
	    itemGap: 10,
	    // The gap between two items, in px.
	    hoverLink: true,
	    // Enable hover highlight.
	    showLabel: null // By default, when text is used, label will hide (the logic
	    // is remained for compatibility reason)
	
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    PiecewiseModel.superApply(this, 'optionUpdated', arguments);
	    /**
	     * The order is always [low, ..., high].
	     * [{text: string, interval: Array.<number>}, ...]
	     * @private
	     * @type {Array.<Object>}
	     */
	
	    this._pieceList = [];
	    this.resetExtent();
	    /**
	     * 'pieces', 'categories', 'splitNumber'
	     * @type {string}
	     */
	
	    var mode = this._mode = this._determineMode();
	
	    resetMethods[this._mode].call(this);
	
	    this._resetSelected(newOption, isInit);
	
	    var categories = this.option.categories;
	    this.resetVisual(function (mappingOption, state) {
	      if (mode === 'categories') {
	        mappingOption.mappingMethod = 'category';
	        mappingOption.categories = zrUtil.clone(categories);
	      } else {
	        mappingOption.dataExtent = this.getExtent();
	        mappingOption.mappingMethod = 'piecewise';
	        mappingOption.pieceList = zrUtil.map(this._pieceList, function (piece) {
	          var piece = zrUtil.clone(piece);
	
	          if (state !== 'inRange') {
	            // FIXME
	            // outOfRange do not support special visual in pieces.
	            piece.visual = null;
	          }
	
	          return piece;
	        });
	      }
	    });
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  completeVisualOption: function () {
	    // Consider this case:
	    // visualMap: {
	    //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
	    // }
	    // where no inRange/outOfRange set but only pieces. So we should make
	    // default inRange/outOfRange for this case, otherwise visuals that only
	    // appear in `pieces` will not be taken into account in visual encoding.
	    var option = this.option;
	    var visualTypesInPieces = {};
	    var visualTypes = VisualMapping.listVisualTypes();
	    var isCategory = this.isCategory();
	    zrUtil.each(option.pieces, function (piece) {
	      zrUtil.each(visualTypes, function (visualType) {
	        if (piece.hasOwnProperty(visualType)) {
	          visualTypesInPieces[visualType] = 1;
	        }
	      });
	    });
	    zrUtil.each(visualTypesInPieces, function (v, visualType) {
	      var exists = 0;
	      zrUtil.each(this.stateList, function (state) {
	        exists |= has(option, state, visualType) || has(option.target, state, visualType);
	      }, this);
	      !exists && zrUtil.each(this.stateList, function (state) {
	        (option[state] || (option[state] = {}))[visualType] = visualDefault.get(visualType, state === 'inRange' ? 'active' : 'inactive', isCategory);
	      });
	    }, this);
	
	    function has(obj, state, visualType) {
	      return obj && obj[state] && (zrUtil.isObject(obj[state]) ? obj[state].hasOwnProperty(visualType) : obj[state] === visualType // e.g., inRange: 'symbol'
	      );
	    }
	
	    VisualMapModel.prototype.completeVisualOption.apply(this, arguments);
	  },
	  _resetSelected: function (newOption, isInit) {
	    var thisOption = this.option;
	    var pieceList = this._pieceList; // Selected do not merge but all override.
	
	    var selected = (isInit ? thisOption : newOption).selected || {};
	    thisOption.selected = selected; // Consider 'not specified' means true.
	
	    zrUtil.each(pieceList, function (piece, index) {
	      var key = this.getSelectedMapKey(piece);
	
	      if (!selected.hasOwnProperty(key)) {
	        selected[key] = true;
	      }
	    }, this);
	
	    if (thisOption.selectedMode === 'single') {
	      // Ensure there is only one selected.
	      var hasSel = false;
	      zrUtil.each(pieceList, function (piece, index) {
	        var key = this.getSelectedMapKey(piece);
	
	        if (selected[key]) {
	          hasSel ? selected[key] = false : hasSel = true;
	        }
	      }, this);
	    } // thisOption.selectedMode === 'multiple', default: all selected.
	
	  },
	
	  /**
	   * @public
	   */
	  getSelectedMapKey: function (piece) {
	    return this._mode === 'categories' ? piece.value + '' : piece.index + '';
	  },
	
	  /**
	   * @public
	   */
	  getPieceList: function () {
	    return this._pieceList;
	  },
	
	  /**
	   * @private
	   * @return {string}
	   */
	  _determineMode: function () {
	    var option = this.option;
	    return option.pieces && option.pieces.length > 0 ? 'pieces' : this.option.categories ? 'categories' : 'splitNumber';
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  setSelected: function (selected) {
	    this.option.selected = zrUtil.clone(selected);
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  getValueState: function (value) {
	    var index = VisualMapping.findPieceIndex(value, this._pieceList);
	    return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? 'inRange' : 'outOfRange' : 'outOfRange';
	  },
	
	  /**
	   * @public
	   * @params {number} pieceIndex piece index in visualMapModel.getPieceList()
	   * @return {Array.<Object>} [{seriesId, dataIndices: <Array.<number>>}, ...]
	   */
	  findTargetDataIndices: function (pieceIndex) {
	    var result = [];
	    this.eachTargetSeries(function (seriesModel) {
	      var dataIndices = [];
	      var data = seriesModel.getData();
	      data.each(this.getDataDimension(data), function (value, dataIndex) {
	        // Should always base on model pieceList, because it is order sensitive.
	        var pIdx = VisualMapping.findPieceIndex(value, this._pieceList);
	        pIdx === pieceIndex && dataIndices.push(dataIndex);
	      }, true, this);
	      result.push({
	        seriesId: seriesModel.id,
	        dataIndex: dataIndices
	      });
	    }, this);
	    return result;
	  },
	
	  /**
	   * @private
	   * @param {Object} piece piece.value or piece.interval is required.
	   * @return {number} Can be Infinity or -Infinity
	   */
	  getRepresentValue: function (piece) {
	    var representValue;
	
	    if (this.isCategory()) {
	      representValue = piece.value;
	    } else {
	      if (piece.value != null) {
	        representValue = piece.value;
	      } else {
	        var pieceInterval = piece.interval || [];
	        representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
	      }
	    }
	
	    return representValue;
	  },
	  getVisualMeta: function (getColorVisual) {
	    // Do not support category. (category axis is ordinal, numerical)
	    if (this.isCategory()) {
	      return;
	    }
	
	    var stops = [];
	    var outerColors = [];
	    var visualMapModel = this;
	
	    function setStop(interval, valueState) {
	      var representValue = visualMapModel.getRepresentValue({
	        interval: interval
	      });
	
	      if (!valueState) {
	        valueState = visualMapModel.getValueState(representValue);
	      }
	
	      var color = getColorVisual(representValue, valueState);
	
	      if (interval[0] === -Infinity) {
	        outerColors[0] = color;
	      } else if (interval[1] === Infinity) {
	        outerColors[1] = color;
	      } else {
	        stops.push({
	          value: interval[0],
	          color: color
	        }, {
	          value: interval[1],
	          color: color
	        });
	      }
	    } // Suplement
	
	
	    var pieceList = this._pieceList.slice();
	
	    if (!pieceList.length) {
	      pieceList.push({
	        interval: [-Infinity, Infinity]
	      });
	    } else {
	      var edge = pieceList[0].interval[0];
	      edge !== -Infinity && pieceList.unshift({
	        interval: [-Infinity, edge]
	      });
	      edge = pieceList[pieceList.length - 1].interval[1];
	      edge !== Infinity && pieceList.push({
	        interval: [edge, Infinity]
	      });
	    }
	
	    var curr = -Infinity;
	    zrUtil.each(pieceList, function (piece) {
	      var interval = piece.interval;
	
	      if (interval) {
	        // Fulfill gap.
	        interval[0] > curr && setStop([curr, interval[0]], 'outOfRange');
	        setStop(interval.slice());
	        curr = interval[1];
	      }
	    }, this);
	    return {
	      stops: stops,
	      outerColors: outerColors
	    };
	  }
	});
	/**
	 * Key is this._mode
	 * @type {Object}
	 * @this {module:echarts/component/viusalMap/PiecewiseMode}
	 */
	
	var resetMethods = {
	  splitNumber: function () {
	    var thisOption = this.option;
	    var pieceList = this._pieceList;
	    var precision = Math.min(thisOption.precision, 20);
	    var dataExtent = this.getExtent();
	    var splitNumber = thisOption.splitNumber;
	    splitNumber = Math.max(parseInt(splitNumber, 10), 1);
	    thisOption.splitNumber = splitNumber;
	    var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber; // Precision auto-adaption
	
	    while (+splitStep.toFixed(precision) !== splitStep && precision < 5) {
	      precision++;
	    }
	
	    thisOption.precision = precision;
	    splitStep = +splitStep.toFixed(precision);
	    var index = 0;
	
	    if (thisOption.minOpen) {
	      pieceList.push({
	        index: index++,
	        interval: [-Infinity, dataExtent[0]],
	        close: [0, 0]
	      });
	    }
	
	    for (var curr = dataExtent[0], len = index + splitNumber; index < len; curr += splitStep) {
	      var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
	      pieceList.push({
	        index: index++,
	        interval: [curr, max],
	        close: [1, 1]
	      });
	    }
	
	    if (thisOption.maxOpen) {
	      pieceList.push({
	        index: index++,
	        interval: [dataExtent[1], Infinity],
	        close: [0, 0]
	      });
	    }
	
	    reformIntervals(pieceList);
	    zrUtil.each(pieceList, function (piece) {
	      piece.text = this.formatValueText(piece.interval);
	    }, this);
	  },
	  categories: function () {
	    var thisOption = this.option;
	    zrUtil.each(thisOption.categories, function (cate) {
	      // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
	      // 是否改一致。
	      this._pieceList.push({
	        text: this.formatValueText(cate, true),
	        value: cate
	      });
	    }, this); // See "Order Rule".
	
	    normalizeReverse(thisOption, this._pieceList);
	  },
	  pieces: function () {
	    var thisOption = this.option;
	    var pieceList = this._pieceList;
	    zrUtil.each(thisOption.pieces, function (pieceListItem, index) {
	      if (!zrUtil.isObject(pieceListItem)) {
	        pieceListItem = {
	          value: pieceListItem
	        };
	      }
	
	      var item = {
	        text: '',
	        index: index
	      };
	
	      if (pieceListItem.label != null) {
	        item.text = pieceListItem.label;
	      }
	
	      if (pieceListItem.hasOwnProperty('value')) {
	        var value = item.value = pieceListItem.value;
	        item.interval = [value, value];
	        item.close = [1, 1];
	      } else {
	        // `min` `max` is legacy option.
	        // `lt` `gt` `lte` `gte` is recommanded.
	        var interval = item.interval = [];
	        var close = item.close = [0, 0];
	        var closeList = [1, 0, 1];
	        var infinityList = [-Infinity, Infinity];
	        var useMinMax = [];
	
	        for (var lg = 0; lg < 2; lg++) {
	          var names = [['gte', 'gt', 'min'], ['lte', 'lt', 'max']][lg];
	
	          for (var i = 0; i < 3 && interval[lg] == null; i++) {
	            interval[lg] = pieceListItem[names[i]];
	            close[lg] = closeList[i];
	            useMinMax[lg] = i === 2;
	          }
	
	          interval[lg] == null && (interval[lg] = infinityList[lg]);
	        }
	
	        useMinMax[0] && interval[1] === Infinity && (close[0] = 0);
	        useMinMax[1] && interval[0] === -Infinity && (close[1] = 0);
	
	        if (interval[0] === interval[1] && close[0] && close[1]) {
	          // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
	          // we use value to lift the priority when min === max
	          item.value = interval[0];
	        }
	      }
	
	      item.visual = VisualMapping.retrieveVisuals(pieceListItem);
	      pieceList.push(item);
	    }, this); // See "Order Rule".
	
	    normalizeReverse(thisOption, pieceList); // Only pieces
	
	    reformIntervals(pieceList);
	    zrUtil.each(pieceList, function (piece) {
	      var close = piece.close;
	      var edgeSymbols = [['<', '≤'][close[1]], ['>', '≥'][close[0]]];
	      piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
	    }, this);
	  }
	};
	
	function normalizeReverse(thisOption, pieceList) {
	  var inverse = thisOption.inverse;
	
	  if (thisOption.orient === 'vertical' ? !inverse : inverse) {
	    pieceList.reverse();
	  }
	}
	
	var _default = PiecewiseModel;
	module.exports = _default;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var VisualMapView = __webpack_require__(187);
	
	var graphic = __webpack_require__(3);
	
	var _symbol = __webpack_require__(22);
	
	var createSymbol = _symbol.createSymbol;
	
	var layout = __webpack_require__(7);
	
	var helper = __webpack_require__(188);
	
	var PiecewiseVisualMapView = VisualMapView.extend({
	  type: 'visualMap.piecewise',
	
	  /**
	   * @protected
	   * @override
	   */
	  doRender: function () {
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	    var visualMapModel = this.visualMapModel;
	    var textGap = visualMapModel.get('textGap');
	    var textStyleModel = visualMapModel.textStyleModel;
	    var textFont = textStyleModel.getFont();
	    var textFill = textStyleModel.getTextColor();
	
	    var itemAlign = this._getItemAlign();
	
	    var itemSize = visualMapModel.itemSize;
	
	    var viewData = this._getViewData();
	
	    var endsText = viewData.endsText;
	    var showLabel = zrUtil.retrieve(visualMapModel.get('showLabel', true), !endsText);
	    endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
	    zrUtil.each(viewData.viewPieceList, renderItem, this);
	    endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
	    layout.box(visualMapModel.get('orient'), thisGroup, visualMapModel.get('itemGap'));
	    this.renderBackground(thisGroup);
	    this.positionGroup(thisGroup);
	
	    function renderItem(item) {
	      var piece = item.piece;
	      var itemGroup = new graphic.Group();
	      itemGroup.onclick = zrUtil.bind(this._onItemClick, this, piece);
	
	      this._enableHoverLink(itemGroup, item.indexInModelPieceList);
	
	      var representValue = visualMapModel.getRepresentValue(piece);
	
	      this._createItemSymbol(itemGroup, representValue, [0, 0, itemSize[0], itemSize[1]]);
	
	      if (showLabel) {
	        var visualState = this.visualMapModel.getValueState(representValue);
	        itemGroup.add(new graphic.Text({
	          style: {
	            x: itemAlign === 'right' ? -textGap : itemSize[0] + textGap,
	            y: itemSize[1] / 2,
	            text: piece.text,
	            textVerticalAlign: 'middle',
	            textAlign: itemAlign,
	            textFont: textFont,
	            textFill: textFill,
	            opacity: visualState === 'outOfRange' ? 0.5 : 1
	          }
	        }));
	      }
	
	      thisGroup.add(itemGroup);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLink: function (itemGroup, pieceIndex) {
	    itemGroup.on('mouseover', zrUtil.bind(onHoverLink, this, 'highlight')).on('mouseout', zrUtil.bind(onHoverLink, this, 'downplay'));
	
	    function onHoverLink(method) {
	      var visualMapModel = this.visualMapModel;
	      visualMapModel.option.hoverLink && this.api.dispatchAction({
	        type: method,
	        batch: helper.convertDataIndex(visualMapModel.findTargetDataIndices(pieceIndex))
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _getItemAlign: function () {
	    var visualMapModel = this.visualMapModel;
	    var modelOption = visualMapModel.option;
	
	    if (modelOption.orient === 'vertical') {
	      return helper.getItemAlign(visualMapModel, this.api, visualMapModel.itemSize);
	    } else {
	      // horizontal, most case left unless specifying right.
	      var align = modelOption.align;
	
	      if (!align || align === 'auto') {
	        align = 'left';
	      }
	
	      return align;
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderEndsText: function (group, text, itemSize, showLabel, itemAlign) {
	    if (!text) {
	      return;
	    }
	
	    var itemGroup = new graphic.Group();
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    itemGroup.add(new graphic.Text({
	      style: {
	        x: showLabel ? itemAlign === 'right' ? itemSize[0] : 0 : itemSize[0] / 2,
	        y: itemSize[1] / 2,
	        textVerticalAlign: 'middle',
	        textAlign: showLabel ? itemAlign : 'center',
	        text: text,
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    }));
	    group.add(itemGroup);
	  },
	
	  /**
	   * @private
	   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
	   */
	  _getViewData: function () {
	    var visualMapModel = this.visualMapModel;
	    var viewPieceList = zrUtil.map(visualMapModel.getPieceList(), function (piece, index) {
	      return {
	        piece: piece,
	        indexInModelPieceList: index
	      };
	    });
	    var endsText = visualMapModel.get('text'); // Consider orient and inverse.
	
	    var orient = visualMapModel.get('orient');
	    var inverse = visualMapModel.get('inverse'); // Order of model pieceList is always [low, ..., high]
	
	    if (orient === 'horizontal' ? inverse : !inverse) {
	      viewPieceList.reverse();
	    } // Origin order of endsText is [high, low]
	    else if (endsText) {
	        endsText = endsText.slice().reverse();
	      }
	
	    return {
	      viewPieceList: viewPieceList,
	      endsText: endsText
	    };
	  },
	
	  /**
	   * @private
	   */
	  _createItemSymbol: function (group, representValue, shapeParam) {
	    group.add(createSymbol(this.getControllerVisual(representValue, 'symbol'), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], this.getControllerVisual(representValue, 'color')));
	  },
	
	  /**
	   * @private
	   */
	  _onItemClick: function (piece) {
	    var visualMapModel = this.visualMapModel;
	    var option = visualMapModel.option;
	    var selected = zrUtil.clone(option.selected);
	    var newKey = visualMapModel.getSelectedMapKey(piece);
	
	    if (option.selectedMode === 'single') {
	      selected[newKey] = true;
	      zrUtil.each(selected, function (o, key) {
	        selected[key] = key === newKey;
	      });
	    } else {
	      selected[newKey] = !selected[newKey];
	    }
	
	    this.api.dispatchAction({
	      type: 'selectDataRange',
	      from: this.uid,
	      visualMapId: this.visualMapModel.id,
	      selected: selected
	    });
	  }
	});
	var _default = PiecewiseVisualMapView;
	module.exports = _default;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var preprocessor = __webpack_require__(189);
	
	__webpack_require__(190);
	
	__webpack_require__(191);
	
	__webpack_require__(538);
	
	__webpack_require__(539);
	
	__webpack_require__(192);
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var preprocessor = __webpack_require__(189);
	
	__webpack_require__(190);
	
	__webpack_require__(191);
	
	__webpack_require__(540);
	
	__webpack_require__(541);
	
	__webpack_require__(192);
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var layout = __webpack_require__(7);
	
	var numberUtil = __webpack_require__(4);
	
	var CoordinateSystem = __webpack_require__(26);
	
	// (24*60*60*1000)
	var PROXIMATE_ONE_DAY = 86400000;
	/**
	 * Calendar
	 *
	 * @constructor
	 *
	 * @param {Object} calendarModel calendarModel
	 * @param {Object} ecModel       ecModel
	 * @param {Object} api           api
	 */
	
	function Calendar(calendarModel, ecModel, api) {
	  this._model = calendarModel;
	}
	
	Calendar.prototype = {
	  constructor: Calendar,
	  type: 'calendar',
	  dimensions: ['time', 'value'],
	  // Required in createListFromData
	  getDimensionsInfo: function () {
	    return [{
	      name: 'time',
	      type: 'time'
	    }];
	  },
	  getRangeInfo: function () {
	    return this._rangeInfo;
	  },
	  getModel: function () {
	    return this._model;
	  },
	  getRect: function () {
	    return this._rect;
	  },
	  getCellWidth: function () {
	    return this._sw;
	  },
	  getCellHeight: function () {
	    return this._sh;
	  },
	  getOrient: function () {
	    return this._orient;
	  },
	
	  /**
	   * getFirstDayOfWeek
	   *
	   * @example
	   *     0 : start at Sunday
	   *     1 : start at Monday
	   *
	   * @return {number}
	   */
	  getFirstDayOfWeek: function () {
	    return this._firstDayOfWeek;
	  },
	
	  /**
	   * get date info
	   *
	   * @param  {string|number} date date
	   * @return {Object}
	   * {
	   *      y: string, local full year, eg., '1940',
	   *      m: string, local month, from '01' ot '12',
	   *      d: string, local date, from '01' to '31' (if exists),
	   *      day: It is not date.getDay(). It is the location of the cell in a week, from 0 to 6,
	   *      time: timestamp,
	   *      formatedDate: string, yyyy-MM-dd,
	   *      date: original date object.
	   * }
	   */
	  getDateInfo: function (date) {
	    date = numberUtil.parseDate(date);
	    var y = date.getFullYear();
	    var m = date.getMonth() + 1;
	    m = m < 10 ? '0' + m : m;
	    var d = date.getDate();
	    d = d < 10 ? '0' + d : d;
	    var day = date.getDay();
	    day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
	    return {
	      y: y,
	      m: m,
	      d: d,
	      day: day,
	      time: date.getTime(),
	      formatedDate: y + '-' + m + '-' + d,
	      date: date
	    };
	  },
	  getNextNDay: function (date, n) {
	    n = n || 0;
	
	    if (n === 0) {
	      return this.getDateInfo(date);
	    }
	
	    date = new Date(this.getDateInfo(date).time);
	    date.setDate(date.getDate() + n);
	    return this.getDateInfo(date);
	  },
	  update: function (ecModel, api) {
	    this._firstDayOfWeek = +this._model.getModel('dayLabel').get('firstDay');
	    this._orient = this._model.get('orient');
	    this._lineWidth = this._model.getModel('itemStyle.normal').getItemStyle().lineWidth || 0;
	    this._rangeInfo = this._getRangeInfo(this._initRangeOption());
	    var weeks = this._rangeInfo.weeks || 1;
	    var whNames = ['width', 'height'];
	
	    var cellSize = this._model.get('cellSize').slice();
	
	    var layoutParams = this._model.getBoxLayoutParams();
	
	    var cellNumbers = this._orient === 'horizontal' ? [weeks, 7] : [7, weeks];
	    zrUtil.each([0, 1], function (idx) {
	      if (cellSizeSpecified(cellSize, idx)) {
	        layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
	      }
	    });
	    var whGlobal = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    };
	    var calendarRect = this._rect = layout.getLayoutRect(layoutParams, whGlobal);
	    zrUtil.each([0, 1], function (idx) {
	      if (!cellSizeSpecified(cellSize, idx)) {
	        cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
	      }
	    });
	
	    function cellSizeSpecified(cellSize, idx) {
	      return cellSize[idx] != null && cellSize[idx] !== 'auto';
	    }
	
	    this._sw = cellSize[0];
	    this._sh = cellSize[1];
	  },
	
	  /**
	   * Convert a time data(time, value) item to (x, y) point.
	   *
	   * @override
	   * @param  {Array|number} data data
	   * @param  {boolean} [clamp=true] out of range
	   * @return {Array} point
	   */
	  dataToPoint: function (data, clamp) {
	    zrUtil.isArray(data) && (data = data[0]);
	    clamp == null && (clamp = true);
	    var dayInfo = this.getDateInfo(data);
	    var range = this._rangeInfo;
	    var date = dayInfo.formatedDate; // if not in range return [NaN, NaN]
	
	    if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time <= range.end.time)) {
	      return [NaN, NaN];
	    }
	
	    var week = dayInfo.day;
	
	    var nthWeek = this._getRangeInfo([range.start.time, date]).nthWeek;
	
	    if (this._orient === 'vertical') {
	      return [this._rect.x + week * this._sw + this._sw / 2, this._rect.y + nthWeek * this._sh + this._sh / 2];
	    }
	
	    return [this._rect.x + nthWeek * this._sw + this._sw / 2, this._rect.y + week * this._sh + this._sh / 2];
	  },
	
	  /**
	   * Convert a (x, y) point to time data
	   *
	   * @override
	   * @param  {string} point point
	   * @return {string}       data
	   */
	  pointToData: function (point) {
	    var date = this.pointToDate(point);
	    return date && date.time;
	  },
	
	  /**
	   * Convert a time date item to (x, y) four point.
	   *
	   * @param  {Array} data  date[0] is date
	   * @param  {boolean} [clamp=true]  out of range
	   * @return {Object}       point
	   */
	  dataToRect: function (data, clamp) {
	    var point = this.dataToPoint(data, clamp);
	    return {
	      contentShape: {
	        x: point[0] - (this._sw - this._lineWidth) / 2,
	        y: point[1] - (this._sh - this._lineWidth) / 2,
	        width: this._sw - this._lineWidth,
	        height: this._sh - this._lineWidth
	      },
	      center: point,
	      tl: [point[0] - this._sw / 2, point[1] - this._sh / 2],
	      tr: [point[0] + this._sw / 2, point[1] - this._sh / 2],
	      br: [point[0] + this._sw / 2, point[1] + this._sh / 2],
	      bl: [point[0] - this._sw / 2, point[1] + this._sh / 2]
	    };
	  },
	
	  /**
	   * Convert a (x, y) point to time date
	   *
	   * @param  {Array} point point
	   * @return {Object}       date
	   */
	  pointToDate: function (point) {
	    var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
	    var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
	    var range = this._rangeInfo.range;
	
	    if (this._orient === 'vertical') {
	      return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
	    }
	
	    return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
	  },
	
	  /**
	   * @inheritDoc
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @inheritDoc
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData'),
	
	  /**
	   * initRange
	   *
	   * @private
	   * @return {Array} [start, end]
	   */
	  _initRangeOption: function () {
	    var range = this._model.get('range');
	
	    var rg = range;
	
	    if (zrUtil.isArray(rg) && rg.length === 1) {
	      rg = rg[0];
	    }
	
	    if (/^\d{4}$/.test(rg)) {
	      range = [rg + '-01-01', rg + '-12-31'];
	    }
	
	    if (/^\d{4}[\/|-]\d{1,2}$/.test(rg)) {
	      var start = this.getDateInfo(rg);
	      var firstDay = start.date;
	      firstDay.setMonth(firstDay.getMonth() + 1);
	      var end = this.getNextNDay(firstDay, -1);
	      range = [start.formatedDate, end.formatedDate];
	    }
	
	    if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rg)) {
	      range = [rg, rg];
	    }
	
	    var tmp = this._getRangeInfo(range);
	
	    if (tmp.start.time > tmp.end.time) {
	      range.reverse();
	    }
	
	    return range;
	  },
	
	  /**
	   * range info
	   *
	   * @private
	   * @param  {Array} range range ['2017-01-01', '2017-07-08']
	   *  If range[0] > range[1], they will not be reversed.
	   * @return {Object}       obj
	   */
	  _getRangeInfo: function (range) {
	    range = [this.getDateInfo(range[0]), this.getDateInfo(range[1])];
	    var reversed;
	
	    if (range[0].time > range[1].time) {
	      reversed = true;
	      range.reverse();
	    }
	
	    var allDay = Math.floor(range[1].time / PROXIMATE_ONE_DAY) - Math.floor(range[0].time / PROXIMATE_ONE_DAY) + 1; // Consider case:
	    // Firstly set system timezone as "Time Zone: America/Toronto",
	    // ```
	    // var first = new Date(1478412000000 - 3600 * 1000 * 2.5);
	    // var second = new Date(1478412000000);
	    // var allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
	    // ```
	    // will get wrong result because of DST. So we should fix it.
	
	    var date = new Date(range[0].time);
	    var startDateNum = date.getDate();
	    var endDateNum = range[1].date.getDate();
	    date.setDate(startDateNum + allDay - 1); // The bias can not over a month, so just compare date.
	
	    if (date.getDate() !== endDateNum) {
	      var sign = date.getTime() - range[1].time > 0 ? 1 : -1;
	
	      while (date.getDate() !== endDateNum && (date.getTime() - range[1].time) * sign > 0) {
	        allDay -= sign;
	        date.setDate(startDateNum + allDay - 1);
	      }
	    }
	
	    var weeks = Math.floor((allDay + range[0].day + 6) / 7);
	    var nthWeek = reversed ? -weeks + 1 : weeks - 1;
	    reversed && range.reverse();
	    return {
	      range: [range[0].formatedDate, range[1].formatedDate],
	      start: range[0],
	      end: range[1],
	      allDay: allDay,
	      weeks: weeks,
	      // From 0.
	      nthWeek: nthWeek,
	      fweek: range[0].day,
	      lweek: range[1].day
	    };
	  },
	
	  /**
	   * get date by nthWeeks and week day in range
	   *
	   * @private
	   * @param  {number} nthWeek the week
	   * @param  {number} day   the week day
	   * @param  {Array} range [d1, d2]
	   * @return {Object}
	   */
	  _getDateByWeeksAndDay: function (nthWeek, day, range) {
	    var rangeInfo = this._getRangeInfo(range);
	
	    if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) {
	      return false;
	    }
	
	    var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
	    var date = new Date(rangeInfo.start.time);
	    date.setDate(rangeInfo.start.d + nthDay);
	    return this.getDateInfo(date);
	  }
	};
	Calendar.dimensions = Calendar.prototype.dimensions;
	Calendar.getDimensionsInfo = Calendar.prototype.getDimensionsInfo;
	
	Calendar.create = function (ecModel, api) {
	  var calendarList = [];
	  ecModel.eachComponent('calendar', function (calendarModel) {
	    var calendar = new Calendar(calendarModel, ecModel, api);
	    calendarList.push(calendar);
	    calendarModel.coordinateSystem = calendar;
	  });
	  ecModel.eachSeries(function (calendarSeries) {
	    if (calendarSeries.get('coordinateSystem') === 'calendar') {
	      // Inject coordinate system
	      calendarSeries.coordinateSystem = calendarList[calendarSeries.get('calendarIndex') || 0];
	    }
	  });
	  return calendarList;
	};
	
	function doConvert(methodName, ecModel, finder, value) {
	  var calendarModel = finder.calendarModel;
	  var seriesModel = finder.seriesModel;
	  var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	CoordinateSystem.register('calendar', Calendar);
	var _default = Calendar;
	module.exports = _default;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var ComponentModel = __webpack_require__(16);
	
	var _layout = __webpack_require__(7);
	
	var getLayoutParams = _layout.getLayoutParams;
	var sizeCalculable = _layout.sizeCalculable;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	var CalendarModel = ComponentModel.extend({
	  type: 'calendar',
	
	  /**
	   * @type {module:echarts/coord/calendar/Calendar}
	   */
	  coordinateSystem: null,
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    left: 80,
	    top: 60,
	    cellSize: 20,
	    // horizontal vertical
	    orient: 'horizontal',
	    // month separate line style
	    splitLine: {
	      show: true,
	      lineStyle: {
	        color: '#000',
	        width: 1,
	        type: 'solid'
	      }
	    },
	    // rect style  temporarily unused emphasis
	    itemStyle: {
	      normal: {
	        color: '#fff',
	        borderWidth: 1,
	        borderColor: '#ccc'
	      }
	    },
	    // week text style
	    dayLabel: {
	      show: true,
	      // a week first day
	      firstDay: 0,
	      // start end
	      position: 'start',
	      margin: '50%',
	      // 50% of cellSize
	      nameMap: 'en',
	      color: '#000'
	    },
	    // month text style
	    monthLabel: {
	      show: true,
	      // start end
	      position: 'start',
	      margin: 5,
	      // center or left
	      align: 'center',
	      // cn en []
	      nameMap: 'en',
	      formatter: null,
	      color: '#000'
	    },
	    // year text style
	    yearLabel: {
	      show: true,
	      // top bottom left right
	      position: null,
	      margin: 30,
	      formatter: null,
	      color: '#ccc',
	      fontFamily: 'sans-serif',
	      fontWeight: 'bolder',
	      fontSize: 20
	    }
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel, extraOpt) {
	    var inputPositionParams = getLayoutParams(option);
	    CalendarModel.superApply(this, 'init', arguments);
	    mergeAndNormalizeLayoutParams(option, inputPositionParams);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option, extraOpt) {
	    CalendarModel.superApply(this, 'mergeOption', arguments);
	    mergeAndNormalizeLayoutParams(this.option, option);
	  }
	});
	
	function mergeAndNormalizeLayoutParams(target, raw) {
	  // Normalize cellSize
	  var cellSize = target.cellSize;
	
	  if (!zrUtil.isArray(cellSize)) {
	    cellSize = target.cellSize = [cellSize, cellSize];
	  } else if (cellSize.length === 1) {
	    cellSize[1] = cellSize[0];
	  }
	
	  var ignoreSize = zrUtil.map([0, 1], function (hvIdx) {
	    // If user have set `width` or both `left` and `right`, cellSize
	    // will be automatically set to 'auto', otherwise the default
	    // setting of cellSize will make `width` setting not work.
	    if (sizeCalculable(raw, hvIdx)) {
	      cellSize[hvIdx] = 'auto';
	    }
	
	    return cellSize[hvIdx] != null && cellSize[hvIdx] !== 'auto';
	  });
	  mergeLayoutParam(target, raw, {
	    type: 'box',
	    ignoreSize: ignoreSize
	  });
	}
	
	var _default = CalendarModel;
	module.exports = _default;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	function _default(coordSys) {
	  var rect = coordSys.getRect();
	  var rangeInfo = coordSys.getRangeInfo();
	  return {
	    coordSys: {
	      type: 'calendar',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height,
	      cellWidth: coordSys.getCellWidth(),
	      cellHeight: coordSys.getCellHeight(),
	      rangeInfo: {
	        start: rangeInfo.start,
	        end: rangeInfo.end,
	        weeks: rangeInfo.weeks,
	        dayCount: rangeInfo.allDay
	      }
	    },
	    api: {
	      coord: zrUtil.bind(coordSys.dataToPoint, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Axis = __webpack_require__(36);
	
	/**
	 * Extend axis 2d
	 * @constructor module:echarts/coord/cartesian/Axis2D
	 * @extends {module:echarts/coord/cartesian/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var Axis2D = function (dim, scale, coordExtent, axisType, position) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis position
	   *  - 'top'
	   *  - 'bottom'
	   *  - 'left'
	   *  - 'right'
	   */
	
	  this.position = position || 'bottom';
	};
	
	Axis2D.prototype = {
	  constructor: Axis2D,
	
	  /**
	   * Index of axis, can be used as key
	   */
	  index: 0,
	
	  /**
	   * If axis is on the zero position of the other axis
	   * @type {boolean}
	   */
	  onZero: false,
	
	  /**
	   * Axis model
	   * @param {module:echarts/coord/cartesian/AxisModel}
	   */
	  model: null,
	  isHorizontal: function () {
	    var position = this.position;
	    return position === 'top' || position === 'bottom';
	  },
	
	  /**
	   * Each item cooresponds to this.getExtent(), which
	   * means globalExtent[0] may greater than globalExtent[1],
	   * unless `asc` is input.
	   *
	   * @param {boolean} [asc]
	   * @return {Array.<number>}
	   */
	  getGlobalExtent: function (asc) {
	    var ret = this.getExtent();
	    ret[0] = this.toGlobalCoord(ret[0]);
	    ret[1] = this.toGlobalCoord(ret[1]);
	    asc && ret[0] > ret[1] && ret.reverse();
	    return ret;
	  },
	  getOtherAxis: function () {
	    this.grid.getOtherAxis();
	  },
	
	  /**
	   * If label is ignored.
	   * Automatically used when axis is category and label can not be all shown
	   * @param  {number}  idx
	   * @return {boolean}
	   */
	  isLabelIgnored: function (idx) {
	    if (this.type === 'category') {
	      var labelInterval = this.getLabelInterval();
	      return typeof labelInterval === 'function' && !labelInterval(idx, this.scale.getLabel(idx)) || idx % (labelInterval + 1);
	    }
	  },
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
	  },
	
	  /**
	   * Transform global coord to local coord,
	   * i.e. var localCoord = axis.toLocalCoord(80);
	   * designate by module:echarts/coord/cartesian/Grid.
	   * @type {Function}
	   */
	  toLocalCoord: null,
	
	  /**
	   * Transform global coord to local coord,
	   * i.e. var globalCoord = axis.toLocalCoord(40);
	   * designate by module:echarts/coord/cartesian/Grid.
	   * @type {Function}
	   */
	  toGlobalCoord: null
	};
	zrUtil.inherits(Axis2D, Axis);
	var _default = Axis2D;
	module.exports = _default;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	/**
	 * Cartesian coordinate system
	 * @module  echarts/coord/Cartesian
	 *
	 */
	function dimAxisMapper(dim) {
	  return this._axes[dim];
	}
	/**
	 * @alias module:echarts/coord/Cartesian
	 * @constructor
	 */
	
	
	var Cartesian = function (name) {
	  this._axes = {};
	  this._dimList = [];
	  /**
	   * @type {string}
	   */
	
	  this.name = name || '';
	};
	
	Cartesian.prototype = {
	  constructor: Cartesian,
	  type: 'cartesian',
	
	  /**
	   * Get axis
	   * @param  {number|string} dim
	   * @return {module:echarts/coord/Cartesian~Axis}
	   */
	  getAxis: function (dim) {
	    return this._axes[dim];
	  },
	
	  /**
	   * Get axes list
	   * @return {Array.<module:echarts/coord/Cartesian~Axis>}
	   */
	  getAxes: function () {
	    return zrUtil.map(this._dimList, dimAxisMapper, this);
	  },
	
	  /**
	   * Get axes list by given scale type
	   */
	  getAxesByScale: function (scaleType) {
	    scaleType = scaleType.toLowerCase();
	    return zrUtil.filter(this.getAxes(), function (axis) {
	      return axis.scale.type === scaleType;
	    });
	  },
	
	  /**
	   * Add axis
	   * @param {module:echarts/coord/Cartesian.Axis}
	   */
	  addAxis: function (axis) {
	    var dim = axis.dim;
	    this._axes[dim] = axis;
	
	    this._dimList.push(dim);
	  },
	
	  /**
	   * Convert data to coord in nd space
	   * @param {Array.<number>|Object.<string, number>} val
	   * @return {Array.<number>|Object.<string, number>}
	   */
	  dataToCoord: function (val) {
	    return this._dataCoordConvert(val, 'dataToCoord');
	  },
	
	  /**
	   * Convert coord in nd space to data
	   * @param  {Array.<number>|Object.<string, number>} val
	   * @return {Array.<number>|Object.<string, number>}
	   */
	  coordToData: function (val) {
	    return this._dataCoordConvert(val, 'coordToData');
	  },
	  _dataCoordConvert: function (input, method) {
	    var dimList = this._dimList;
	    var output = input instanceof Array ? [] : {};
	
	    for (var i = 0; i < dimList.length; i++) {
	      var dim = dimList[i];
	      var axis = this._axes[dim];
	      output[dim] = axis[method](input[dim]);
	    }
	
	    return output;
	  }
	};
	var _default = Cartesian;
	module.exports = _default;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Cartesian = __webpack_require__(548);
	
	function Cartesian2D(name) {
	  Cartesian.call(this, name);
	}
	
	Cartesian2D.prototype = {
	  constructor: Cartesian2D,
	  type: 'cartesian2d',
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['x', 'y'],
	
	  /**
	   * Base axis will be used on stacking.
	   *
	   * @return {module:echarts/coord/cartesian/Axis2D}
	   */
	  getBaseAxis: function () {
	    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
	  },
	
	  /**
	   * If contain point
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var axisX = this.getAxis('x');
	    var axisY = this.getAxis('y');
	    return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
	  },
	
	  /**
	   * If contain data
	   * @param {Array.<number>} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
	  },
	
	  /**
	   * @param {Array.<number>} data
	   * @param {boolean} [clamp=false]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, clamp) {
	    var xAxis = this.getAxis('x');
	    var yAxis = this.getAxis('y');
	    return [xAxis.toGlobalCoord(xAxis.dataToCoord(data[0], clamp)), yAxis.toGlobalCoord(yAxis.dataToCoord(data[1], clamp))];
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @param {boolean} [clamp=false]
	   * @return {Array.<number>}
	   */
	  pointToData: function (point, clamp) {
	    var xAxis = this.getAxis('x');
	    var yAxis = this.getAxis('y');
	    return [xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp), yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp)];
	  },
	
	  /**
	   * Get other axis
	   * @param {module:echarts/coord/cartesian/Axis2D} axis
	   */
	  getOtherAxis: function (axis) {
	    return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
	  }
	};
	zrUtil.inherits(Cartesian2D, Cartesian);
	var _default = Cartesian2D;
	module.exports = _default;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(195);
	
	var ComponentModel = __webpack_require__(16);
	
	// Grid 是在有直角坐标系的时候必须要存在的
	// 所以这里也要被 Cartesian2D 依赖
	var _default = ComponentModel.extend({
	  type: 'grid',
	  dependencies: ['xAxis', 'yAxis'],
	  layoutMode: 'box',
	
	  /**
	   * @type {module:echarts/coord/cartesian/Grid}
	   */
	  coordinateSystem: null,
	  defaultOption: {
	    show: false,
	    zlevel: 0,
	    z: 0,
	    left: '10%',
	    top: 60,
	    right: '10%',
	    bottom: 60,
	    // If grid size contain label
	    containLabel: false,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    backgroundColor: 'rgba(0,0,0,0)',
	    borderWidth: 1,
	    borderColor: '#ccc'
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  dataItem = dataItem || [0, 0];
	  return zrUtil.map(['x', 'y'], function (dim, dimIdx) {
	    var axis = this.getAxis(dim);
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
	  }, this);
	}
	
	function _default(coordSys) {
	  var rect = coordSys.grid.getRect();
	  return {
	    coordSys: {
	      // The name exposed to user is always 'cartesian2d' but not 'grid'.
	      type: 'cartesian2d',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    api: {
	      coord: zrUtil.bind(coordSys.dataToPoint, coordSys),
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var BoundingRect = __webpack_require__(13);
	
	var parseGeoJson = __webpack_require__(197);
	
	var View = __webpack_require__(193);
	
	var fixNanhai = __webpack_require__(556);
	
	var fixTextCoord = __webpack_require__(557);
	
	var fixGeoCoord = __webpack_require__(555);
	
	var fixDiaoyuIsland = __webpack_require__(554);
	
	// Geo fix functions
	var geoFixFuncs = [fixNanhai, fixTextCoord, fixGeoCoord, fixDiaoyuIsland];
	/**
	 * [Geo description]
	 * @param {string} name Geo name
	 * @param {string} map Map type
	 * @param {Object} geoJson
	 * @param {Object} [specialAreas]
	 *        Specify the positioned areas by left, top, width, height
	 * @param {Object.<string, string>} [nameMap]
	 *        Specify name alias
	 */
	
	function Geo(name, map, geoJson, specialAreas, nameMap) {
	  View.call(this, name);
	  /**
	   * Map type
	   * @type {string}
	   */
	
	  this.map = map;
	  this._nameCoordMap = zrUtil.createHashMap();
	  this.loadGeoJson(geoJson, specialAreas, nameMap);
	}
	
	Geo.prototype = {
	  constructor: Geo,
	  type: 'geo',
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['lng', 'lat'],
	
	  /**
	   * If contain given lng,lat coord
	   * @param {Array.<number>}
	   * @readOnly
	   */
	  containCoord: function (coord) {
	    var regions = this.regions;
	
	    for (var i = 0; i < regions.length; i++) {
	      if (regions[i].contain(coord)) {
	        return true;
	      }
	    }
	
	    return false;
	  },
	
	  /**
	   * @param {Object} geoJson
	   * @param {Object} [specialAreas]
	   *        Specify the positioned areas by left, top, width, height
	   * @param {Object.<string, string>} [nameMap]
	   *        Specify name alias
	   */
	  loadGeoJson: function (geoJson, specialAreas, nameMap) {
	    // https://jsperf.com/try-catch-performance-overhead
	    try {
	      this.regions = geoJson ? parseGeoJson(geoJson) : [];
	    } catch (e) {
	      throw 'Invalid geoJson format\n' + e.message;
	    }
	
	    specialAreas = specialAreas || {};
	    nameMap = nameMap || {};
	    var regions = this.regions;
	    var regionsMap = zrUtil.createHashMap();
	
	    for (var i = 0; i < regions.length; i++) {
	      var regionName = regions[i].name; // Try use the alias in nameMap
	
	      regionName = nameMap.hasOwnProperty(regionName) ? nameMap[regionName] : regionName;
	      regions[i].name = regionName;
	      regionsMap.set(regionName, regions[i]); // Add geoJson
	
	      this.addGeoCoord(regionName, regions[i].center); // Some area like Alaska in USA map needs to be tansformed
	      // to look better
	
	      var specialArea = specialAreas[regionName];
	
	      if (specialArea) {
	        regions[i].transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
	      }
	    }
	
	    this._regionsMap = regionsMap;
	    this._rect = null;
	    zrUtil.each(geoFixFuncs, function (fixFunc) {
	      fixFunc(this);
	    }, this);
	  },
	  // Overwrite
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    rect = rect.clone(); // Longitute is inverted
	
	    rect.y = -rect.y - rect.height;
	    var viewTransform = this._viewTransform;
	    viewTransform.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
	    viewTransform.decomposeTransform();
	    var scale = viewTransform.scale;
	    scale[1] = -scale[1];
	    viewTransform.updateTransform();
	
	    this._updateTransform();
	  },
	
	  /**
	   * @param {string} name
	   * @return {module:echarts/coord/geo/Region}
	   */
	  getRegion: function (name) {
	    return this._regionsMap.get(name);
	  },
	  getRegionByCoord: function (coord) {
	    var regions = this.regions;
	
	    for (var i = 0; i < regions.length; i++) {
	      if (regions[i].contain(coord)) {
	        return regions[i];
	      }
	    }
	  },
	
	  /**
	   * Add geoCoord for indexing by name
	   * @param {string} name
	   * @param {Array.<number>} geoCoord
	   */
	  addGeoCoord: function (name, geoCoord) {
	    this._nameCoordMap.set(name, geoCoord);
	  },
	
	  /**
	   * Get geoCoord by name
	   * @param {string} name
	   * @return {Array.<number>}
	   */
	  getGeoCoord: function (name) {
	    return this._nameCoordMap.get(name);
	  },
	  // Overwrite
	  getBoundingRect: function () {
	    if (this._rect) {
	      return this._rect;
	    }
	
	    var rect;
	    var regions = this.regions;
	
	    for (var i = 0; i < regions.length; i++) {
	      var regionRect = regions[i].getBoundingRect();
	      rect = rect || regionRect.clone();
	      rect.union(regionRect);
	    } // FIXME Always return new ?
	
	
	    return this._rect = rect || new BoundingRect(0, 0, 0, 0);
	  },
	
	  /**
	   * @param {string|Array.<number>} data
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data) {
	    if (typeof data === 'string') {
	      // Map area name to geoCoord
	      data = this.getGeoCoord(data);
	    }
	
	    if (data) {
	      return View.prototype.dataToPoint.call(this, data);
	    }
	  },
	
	  /**
	   * @inheritDoc
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @inheritDoc
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData')
	};
	zrUtil.mixin(Geo, View);
	
	function doConvert(methodName, ecModel, finder, value) {
	  var geoModel = finder.geoModel;
	  var seriesModel = finder.seriesModel;
	  var coordSys = geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map.
	  || (seriesModel.getReferringComponents('geo')[0] || {}).coordinateSystem : null;
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	var _default = Geo;
	module.exports = _default;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var modelUtil = __webpack_require__(6);
	
	var ComponentModel = __webpack_require__(16);
	
	var Model = __webpack_require__(14);
	
	var selectableMixin = __webpack_require__(122);
	
	var geoCreator = __webpack_require__(89);
	
	var GeoModel = ComponentModel.extend({
	  type: 'geo',
	
	  /**
	   * @type {module:echarts/coord/geo/Geo}
	   */
	  coordinateSystem: null,
	  layoutMode: 'box',
	  init: function (option) {
	    ComponentModel.prototype.init.apply(this, arguments); // Default label emphasis `show`
	
	    modelUtil.defaultEmphasis(option.label, ['show']);
	  },
	  optionUpdated: function () {
	    var option = this.option;
	    var self = this;
	    option.regions = geoCreator.getFilledRegions(option.regions, option.map, option.nameMap);
	    this._optionModelMap = zrUtil.reduce(option.regions || [], function (optionModelMap, regionOpt) {
	      if (regionOpt.name) {
	        optionModelMap.set(regionOpt.name, new Model(regionOpt, self));
	      }
	
	      return optionModelMap;
	    }, zrUtil.createHashMap());
	    this.updateSelectedMap(option.regions);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    show: true,
	    left: 'center',
	    top: 'center',
	    // width:,
	    // height:,
	    // right
	    // bottom
	    // Aspect is width / height. Inited to be geoJson bbox aspect
	    // This parameter is used for scale this aspect
	    aspectScale: 0.75,
	    ///// Layout with center and size
	    // If you wan't to put map in a fixed size box with right aspect ratio
	    // This two properties may more conveninet
	    // layoutCenter: [50%, 50%]
	    // layoutSize: 100
	    silent: false,
	    // Map type
	    map: '',
	    // Define left-top, right-bottom coords to control view
	    // For example, [ [180, 90], [-180, -90] ]
	    boundingCoords: null,
	    // Default on center of map
	    center: null,
	    zoom: 1,
	    scaleLimit: null,
	    // selectedMode: false
	    label: {
	      normal: {
	        show: false,
	        color: '#000'
	      },
	      emphasis: {
	        show: true,
	        color: 'rgb(100,0,0)'
	      }
	    },
	    itemStyle: {
	      normal: {
	        // color: 各异,
	        borderWidth: 0.5,
	        borderColor: '#444',
	        color: '#eee'
	      },
	      emphasis: {
	        // 也是选中样式
	        color: 'rgba(255,215,0,0.8)'
	      }
	    },
	    regions: []
	  },
	
	  /**
	   * Get model of region
	   * @param  {string} name
	   * @return {module:echarts/model/Model}
	   */
	  getRegionModel: function (name) {
	    return this._optionModelMap.get(name) || new Model(null, this, this.ecModel);
	  },
	
	  /**
	   * Format label
	   * @param {string} name Region name
	   * @param {string} [status='normal'] 'normal' or 'emphasis'
	   * @return {string}
	   */
	  getFormattedLabel: function (name, status) {
	    var regionModel = this.getRegionModel(name);
	    var formatter = regionModel.get('label.' + status + '.formatter');
	    var params = {
	      name: name
	    };
	
	    if (typeof formatter === 'function') {
	      params.status = status;
	      return formatter(params);
	    } else if (typeof formatter === 'string') {
	      return formatter.replace('{a}', name != null ? name : '');
	    }
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  }
	});
	zrUtil.mixin(GeoModel, selectableMixin);
	var _default = GeoModel;
	module.exports = _default;

/***/ }),
/* 554 */
/***/ (function(module, exports) {

	// Fix for 钓鱼岛
	// var Region = require('../Region');
	// var zrUtil = require('zrender/src/core/util');
	// var geoCoord = [126, 25];
	var points = [[[123.45165252685547, 25.73527164402261], [123.49731445312499, 25.73527164402261], [123.49731445312499, 25.750734064600884], [123.45165252685547, 25.750734064600884], [123.45165252685547, 25.73527164402261]]];
	
	function _default(geo) {
	  if (geo.map === 'china') {
	    for (var i = 0, len = geo.regions.length; i < len; ++i) {
	      if (geo.regions[i].name === '台湾') {
	        geo.regions[i].geometries.push({
	          type: 'polygon',
	          exterior: points[0]
	        });
	      }
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var geoCoordMap = {
	  'Russia': [100, 60],
	  'United States': [-99, 38],
	  'United States of America': [-99, 38]
	};
	
	function _default(geo) {
	  zrUtil.each(geo.regions, function (region) {
	    var geoCoord = geoCoordMap[region.name];
	
	    if (geoCoord) {
	      var cp = region.center;
	      cp[0] = geoCoord[0];
	      cp[1] = geoCoord[1];
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Region = __webpack_require__(196);
	
	// Fix for 南海诸岛
	var geoCoord = [126, 25];
	var points = [[[0, 3.5], [7, 11.2], [15, 11.9], [30, 7], [42, 0.7], [52, 0.7], [56, 7.7], [59, 0.7], [64, 0.7], [64, 0], [5, 0], [0, 3.5]], [[13, 16.1], [19, 14.7], [16, 21.7], [11, 23.1], [13, 16.1]], [[12, 32.2], [14, 38.5], [15, 38.5], [13, 32.2], [12, 32.2]], [[16, 47.6], [12, 53.2], [13, 53.2], [18, 47.6], [16, 47.6]], [[6, 64.4], [8, 70], [9, 70], [8, 64.4], [6, 64.4]], [[23, 82.6], [29, 79.8], [30, 79.8], [25, 82.6], [23, 82.6]], [[37, 70.7], [43, 62.3], [44, 62.3], [39, 70.7], [37, 70.7]], [[48, 51.1], [51, 45.5], [53, 45.5], [50, 51.1], [48, 51.1]], [[51, 35], [51, 28.7], [53, 28.7], [53, 35], [51, 35]], [[52, 22.4], [55, 17.5], [56, 17.5], [53, 22.4], [52, 22.4]], [[58, 12.6], [62, 7], [63, 7], [60, 12.6], [58, 12.6]], [[0, 3.5], [0, 93.1], [64, 93.1], [64, 0], [63, 0], [63, 92.4], [1, 92.4], [1, 3.5], [0, 3.5]]];
	
	for (var i = 0; i < points.length; i++) {
	  for (var k = 0; k < points[i].length; k++) {
	    points[i][k][0] /= 10.5;
	    points[i][k][1] /= -10.5 / 0.75;
	    points[i][k][0] += geoCoord[0];
	    points[i][k][1] += geoCoord[1];
	  }
	}
	
	function _default(geo) {
	  if (geo.map === 'china') {
	    geo.regions.push(new Region('南海诸岛', zrUtil.map(points, function (exterior) {
	      return {
	        type: 'polygon',
	        exterior: exterior
	      };
	    }), geoCoord));
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var coordsOffsetMap = {
	  '南海诸岛': [32, 80],
	  // 全国
	  '广东': [0, -10],
	  '香港': [10, 5],
	  '澳门': [-10, 10],
	  //'北京': [-10, 0],
	  '天津': [5, 5]
	};
	
	function _default(geo) {
	  zrUtil.each(geo.regions, function (region) {
	    var coordFix = coordsOffsetMap[region.name];
	
	    if (coordFix) {
	      var cp = region.center;
	      cp[0] += coordFix[0] / 10.5;
	      cp[1] += -coordFix[1] / (10.5 / 0.75);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	function dataToCoordSize(dataSize, dataItem) {
	  dataItem = dataItem || [0, 0];
	  return zrUtil.map([0, 1], function (dimIdx) {
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    var p1 = [];
	    var p2 = [];
	    p1[dimIdx] = val - halfSize;
	    p2[dimIdx] = val + halfSize;
	    p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
	    return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
	  }, this);
	}
	
	function _default(coordSys) {
	  var rect = coordSys.getBoundingRect();
	  return {
	    coordSys: {
	      type: 'geo',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    api: {
	      coord: zrUtil.bind(coordSys.dataToPoint, coordSys),
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var ComponentModel = __webpack_require__(16);
	
	var makeStyleMapper = __webpack_require__(58);
	
	var axisModelCreator = __webpack_require__(88);
	
	var numberUtil = __webpack_require__(4);
	
	var axisModelCommonMixin = __webpack_require__(55);
	
	var AxisModel = ComponentModel.extend({
	  type: 'baseParallelAxis',
	
	  /**
	   * @type {module:echarts/coord/parallel/Axis}
	   */
	  axis: null,
	
	  /**
	   * @type {Array.<Array.<number>}
	   * @readOnly
	   */
	  activeIntervals: [],
	
	  /**
	   * @return {Object}
	   */
	  getAreaSelectStyle: function () {
	    return makeStyleMapper([['fill', 'color'], ['lineWidth', 'borderWidth'], ['stroke', 'borderColor'], ['width', 'width'], ['opacity', 'opacity']])(this.getModel('areaSelectStyle'));
	  },
	
	  /**
	   * The code of this feature is put on AxisModel but not ParallelAxis,
	   * because axisModel can be alive after echarts updating but instance of
	   * ParallelAxis having been disposed. this._activeInterval should be kept
	   * when action dispatched (i.e. legend click).
	   *
	   * @param {Array.<Array<number>>} intervals interval.length === 0
	   *                                          means set all active.
	   * @public
	   */
	  setActiveIntervals: function (intervals) {
	    var activeIntervals = this.activeIntervals = zrUtil.clone(intervals); // Normalize
	
	    if (activeIntervals) {
	      for (var i = activeIntervals.length - 1; i >= 0; i--) {
	        numberUtil.asc(activeIntervals[i]);
	      }
	    }
	  },
	
	  /**
	   * @param {number|string} [value] When attempting to detect 'no activeIntervals set',
	   *                         value can not be input.
	   * @return {string} 'normal': no activeIntervals set,
	   *                  'active',
	   *                  'inactive'.
	   * @public
	   */
	  getActiveState: function (value) {
	    var activeIntervals = this.activeIntervals;
	
	    if (!activeIntervals.length) {
	      return 'normal';
	    }
	
	    if (value == null) {
	      return 'inactive';
	    }
	
	    for (var i = 0, len = activeIntervals.length; i < len; i++) {
	      if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) {
	        return 'active';
	      }
	    }
	
	    return 'inactive';
	  }
	});
	var defaultOption = {
	  type: 'value',
	
	  /**
	   * @type {Array.<number>}
	   */
	  dim: null,
	  // 0, 1, 2, ...
	  // parallelIndex: null,
	  areaSelectStyle: {
	    width: 20,
	    borderWidth: 1,
	    borderColor: 'rgba(160,197,232)',
	    color: 'rgba(160,197,232)',
	    opacity: 0.3
	  },
	  realtime: true,
	  // Whether realtime update view when select.
	  z: 10
	};
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	
	function getAxisType(axisName, option) {
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	axisModelCreator('parallel', AxisModel, getAxisType, defaultOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var matrix = __webpack_require__(23);
	
	var layoutUtil = __webpack_require__(7);
	
	var axisHelper = __webpack_require__(21);
	
	var ParallelAxis = __webpack_require__(561);
	
	var graphic = __webpack_require__(3);
	
	var numberUtil = __webpack_require__(4);
	
	var sliderMove = __webpack_require__(71);
	
	/**
	 * Parallel Coordinates
	 * <https://en.wikipedia.org/wiki/Parallel_coordinates>
	 */
	var each = zrUtil.each;
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathFloor = Math.floor;
	var mathCeil = Math.ceil;
	var round = numberUtil.round;
	var PI = Math.PI;
	
	function Parallel(parallelModel, ecModel, api) {
	  /**
	   * key: dimension
	   * @type {Object.<string, module:echarts/coord/parallel/Axis>}
	   * @private
	   */
	  this._axesMap = zrUtil.createHashMap();
	  /**
	   * key: dimension
	   * value: {position: [], rotation, }
	   * @type {Object.<string, Object>}
	   * @private
	   */
	
	  this._axesLayout = {};
	  /**
	   * Always follow axis order.
	   * @type {Array.<string>}
	   * @readOnly
	   */
	
	  this.dimensions = parallelModel.dimensions;
	  /**
	   * @type {module:zrender/core/BoundingRect}
	   */
	
	  this._rect;
	  /**
	   * @type {module:echarts/coord/parallel/ParallelModel}
	   */
	
	  this._model = parallelModel;
	
	  this._init(parallelModel, ecModel, api);
	}
	
	Parallel.prototype = {
	  type: 'parallel',
	  constructor: Parallel,
	
	  /**
	   * Initialize cartesian coordinate systems
	   * @private
	   */
	  _init: function (parallelModel, ecModel, api) {
	    var dimensions = parallelModel.dimensions;
	    var parallelAxisIndex = parallelModel.parallelAxisIndex;
	    each(dimensions, function (dim, idx) {
	      var axisIndex = parallelAxisIndex[idx];
	      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
	
	      var axis = this._axesMap.set(dim, new ParallelAxis(dim, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisIndex));
	
	      var isCategory = axis.type === 'category';
	      axis.onBand = isCategory && axisModel.get('boundaryGap');
	      axis.inverse = axisModel.get('inverse'); // Injection
	
	      axisModel.axis = axis;
	      axis.model = axisModel;
	      axis.coordinateSystem = axisModel.coordinateSystem = this;
	    }, this);
	  },
	
	  /**
	   * Update axis scale after data processed
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  update: function (ecModel, api) {
	    this._updateAxesFromSeries(this._model, ecModel);
	  },
	
	  /**
	   * @override
	   */
	  containPoint: function (point) {
	    var layoutInfo = this._makeLayoutInfo();
	
	    var axisBase = layoutInfo.axisBase;
	    var layoutBase = layoutInfo.layoutBase;
	    var pixelDimIndex = layoutInfo.pixelDimIndex;
	    var pAxis = point[1 - pixelDimIndex];
	    var pLayout = point[pixelDimIndex];
	    return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
	  },
	  getModel: function () {
	    return this._model;
	  },
	
	  /**
	   * Update properties from series
	   * @private
	   */
	  _updateAxesFromSeries: function (parallelModel, ecModel) {
	    ecModel.eachSeries(function (seriesModel) {
	      if (!parallelModel.contains(seriesModel, ecModel)) {
	        return;
	      }
	
	      var data = seriesModel.getData();
	      each(this.dimensions, function (dim) {
	        var axis = this._axesMap.get(dim);
	
	        axis.scale.unionExtentFromData(data, dim);
	        axisHelper.niceScaleExtent(axis.scale, axis.model);
	      }, this);
	    }, this);
	  },
	
	  /**
	   * Resize the parallel coordinate system.
	   * @param {module:echarts/coord/parallel/ParallelModel} parallelModel
	   * @param {module:echarts/ExtensionAPI} api
	   */
	  resize: function (parallelModel, api) {
	    this._rect = layoutUtil.getLayoutRect(parallelModel.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	
	    this._layoutAxes();
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @private
	   */
	  _makeLayoutInfo: function () {
	    var parallelModel = this._model;
	    var rect = this._rect;
	    var xy = ['x', 'y'];
	    var wh = ['width', 'height'];
	    var layout = parallelModel.get('layout');
	    var pixelDimIndex = layout === 'horizontal' ? 0 : 1;
	    var layoutLength = rect[wh[pixelDimIndex]];
	    var layoutExtent = [0, layoutLength];
	    var axisCount = this.dimensions.length;
	    var axisExpandWidth = restrict(parallelModel.get('axisExpandWidth'), layoutExtent);
	    var axisExpandCount = restrict(parallelModel.get('axisExpandCount') || 0, [0, axisCount]);
	    var axisExpandable = parallelModel.get('axisExpandable') && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0; // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
	    // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
	    // where collapsed axes should be overlapped.
	
	    var axisExpandWindow = parallelModel.get('axisExpandWindow');
	    var winSize;
	
	    if (!axisExpandWindow) {
	      winSize = restrict(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
	      var axisExpandCenter = parallelModel.get('axisExpandCenter') || mathFloor(axisCount / 2);
	      axisExpandWindow = [axisExpandWidth * axisExpandCenter - winSize / 2];
	      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
	    } else {
	      winSize = restrict(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
	      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
	    }
	
	    var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount); // Avoid axisCollapseWidth is too small.
	
	    axisCollapseWidth < 3 && (axisCollapseWidth = 0); // Find the first and last indices > ewin[0] and < ewin[1].
	
	    var winInnerIndices = [mathFloor(round(axisExpandWindow[0] / axisExpandWidth, 1)) + 1, mathCeil(round(axisExpandWindow[1] / axisExpandWidth, 1)) - 1]; // Pos in ec coordinates.
	
	    var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
	    return {
	      layout: layout,
	      pixelDimIndex: pixelDimIndex,
	      layoutBase: rect[xy[pixelDimIndex]],
	      layoutLength: layoutLength,
	      axisBase: rect[xy[1 - pixelDimIndex]],
	      axisLength: rect[wh[1 - pixelDimIndex]],
	      axisExpandable: axisExpandable,
	      axisExpandWidth: axisExpandWidth,
	      axisCollapseWidth: axisCollapseWidth,
	      axisExpandWindow: axisExpandWindow,
	      axisCount: axisCount,
	      winInnerIndices: winInnerIndices,
	      axisExpandWindow0Pos: axisExpandWindow0Pos
	    };
	  },
	
	  /**
	   * @private
	   */
	  _layoutAxes: function () {
	    var rect = this._rect;
	    var axes = this._axesMap;
	    var dimensions = this.dimensions;
	
	    var layoutInfo = this._makeLayoutInfo();
	
	    var layout = layoutInfo.layout;
	    axes.each(function (axis) {
	      var axisExtent = [0, layoutInfo.axisLength];
	      var idx = axis.inverse ? 1 : 0;
	      axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
	    });
	    each(dimensions, function (dim, idx) {
	      var posInfo = (layoutInfo.axisExpandable ? layoutAxisWithExpand : layoutAxisWithoutExpand)(idx, layoutInfo);
	      var positionTable = {
	        horizontal: {
	          x: posInfo.position,
	          y: layoutInfo.axisLength
	        },
	        vertical: {
	          x: 0,
	          y: posInfo.position
	        }
	      };
	      var rotationTable = {
	        horizontal: PI / 2,
	        vertical: 0
	      };
	      var position = [positionTable[layout].x + rect.x, positionTable[layout].y + rect.y];
	      var rotation = rotationTable[layout];
	      var transform = matrix.create();
	      matrix.rotate(transform, transform, rotation);
	      matrix.translate(transform, transform, position); // TODO
	      // tick等排布信息。
	      // TODO
	      // 根据axis order 更新 dimensions顺序。
	
	      this._axesLayout[dim] = {
	        position: position,
	        rotation: rotation,
	        transform: transform,
	        axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
	        axisLabelShow: posInfo.axisLabelShow,
	        nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
	        tickDirection: 1,
	        labelDirection: 1,
	        labelInterval: axes.get(dim).getLabelInterval()
	      };
	    }, this);
	  },
	
	  /**
	   * Get axis by dim.
	   * @param {string} dim
	   * @return {module:echarts/coord/parallel/ParallelAxis} [description]
	   */
	  getAxis: function (dim) {
	    return this._axesMap.get(dim);
	  },
	
	  /**
	   * Convert a dim value of a single item of series data to Point.
	   * @param {*} value
	   * @param {string} dim
	   * @return {Array}
	   */
	  dataToPoint: function (value, dim) {
	    return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
	  },
	
	  /**
	   * Travel data for one time, get activeState of each data item.
	   * @param {module:echarts/data/List} data
	   * @param {Functio} cb param: {string} activeState 'active' or 'inactive' or 'normal'
	   *                            {number} dataIndex
	   * @param {Object} context
	   */
	  eachActiveState: function (data, callback, context) {
	    var dimensions = this.dimensions;
	    var axesMap = this._axesMap;
	    var hasActiveSet = this.hasAxisBrushed();
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      var values = data.getValues(dimensions, i);
	      var activeState;
	
	      if (!hasActiveSet) {
	        activeState = 'normal';
	      } else {
	        activeState = 'active';
	
	        for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
	          var dimName = dimensions[j];
	          var state = axesMap.get(dimName).model.getActiveState(values[j], j);
	
	          if (state === 'inactive') {
	            activeState = 'inactive';
	            break;
	          }
	        }
	      }
	
	      callback.call(context, activeState, i);
	    }
	  },
	
	  /**
	   * Whether has any activeSet.
	   * @return {boolean}
	   */
	  hasAxisBrushed: function () {
	    var dimensions = this.dimensions;
	    var axesMap = this._axesMap;
	    var hasActiveSet = false;
	
	    for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
	      if (axesMap.get(dimensions[j]).model.getActiveState() !== 'normal') {
	        hasActiveSet = true;
	      }
	    }
	
	    return hasActiveSet;
	  },
	
	  /**
	   * Convert coords of each axis to Point.
	   *  Return point. For example: [10, 20]
	   * @param {Array.<number>} coords
	   * @param {string} dim
	   * @return {Array.<number>}
	   */
	  axisCoordToPoint: function (coord, dim) {
	    var axisLayout = this._axesLayout[dim];
	    return graphic.applyTransform([coord, 0], axisLayout.transform);
	  },
	
	  /**
	   * Get axis layout.
	   */
	  getAxisLayout: function (dim) {
	    return zrUtil.clone(this._axesLayout[dim]);
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
	   */
	  getSlidedAxisExpandWindow: function (point) {
	    var layoutInfo = this._makeLayoutInfo();
	
	    var pixelDimIndex = layoutInfo.pixelDimIndex;
	    var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
	    var winSize = axisExpandWindow[1] - axisExpandWindow[0];
	    var extent = [0, layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)]; // Out of the area of coordinate system.
	
	    if (!this.containPoint(point)) {
	      return {
	        behavior: 'none',
	        axisExpandWindow: axisExpandWindow
	      };
	    } // Conver the point from global to expand coordinates.
	
	
	    var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos; // For dragging operation convenience, the window should not be
	    // slided when mouse is the center area of the window.
	
	    var delta;
	    var behavior = 'slide';
	    var axisCollapseWidth = layoutInfo.axisCollapseWidth;
	
	    var triggerArea = this._model.get('axisExpandSlideTriggerArea'); // But consider touch device, jump is necessary.
	
	
	    var useJump = triggerArea[0] != null;
	
	    if (axisCollapseWidth) {
	      if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
	        behavior = 'jump';
	        delta = pointCoord - winSize * triggerArea[2];
	      } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
	        behavior = 'jump';
	        delta = pointCoord - winSize * (1 - triggerArea[2]);
	      } else {
	        (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
	      }
	
	      delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
	      delta ? sliderMove(delta, axisExpandWindow, extent, 'all') // Avoid nonsense triger on mousemove.
	      : behavior = 'none';
	    } // When screen is too narrow, make it visible and slidable, although it is hard to interact.
	    else {
	        var winSize = axisExpandWindow[1] - axisExpandWindow[0];
	        var pos = extent[1] * pointCoord / winSize;
	        axisExpandWindow = [mathMax(0, pos - winSize / 2)];
	        axisExpandWindow[1] = mathMin(extent[1], axisExpandWindow[0] + winSize);
	        axisExpandWindow[0] = axisExpandWindow[1] - winSize;
	      }
	
	    return {
	      axisExpandWindow: axisExpandWindow,
	      behavior: behavior
	    };
	  }
	};
	
	function restrict(len, extent) {
	  return mathMin(mathMax(len, extent[0]), extent[1]);
	}
	
	function layoutAxisWithoutExpand(axisIndex, layoutInfo) {
	  var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
	  return {
	    position: step * axisIndex,
	    axisNameAvailableWidth: step,
	    axisLabelShow: true
	  };
	}
	
	function layoutAxisWithExpand(axisIndex, layoutInfo) {
	  var layoutLength = layoutInfo.layoutLength;
	  var axisExpandWidth = layoutInfo.axisExpandWidth;
	  var axisCount = layoutInfo.axisCount;
	  var axisCollapseWidth = layoutInfo.axisCollapseWidth;
	  var winInnerIndices = layoutInfo.winInnerIndices;
	  var position;
	  var axisNameAvailableWidth = axisCollapseWidth;
	  var axisLabelShow = false;
	  var nameTruncateMaxWidth;
	
	  if (axisIndex < winInnerIndices[0]) {
	    position = axisIndex * axisCollapseWidth;
	    nameTruncateMaxWidth = axisCollapseWidth;
	  } else if (axisIndex <= winInnerIndices[1]) {
	    position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
	    axisNameAvailableWidth = axisExpandWidth;
	    axisLabelShow = true;
	  } else {
	    position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
	    nameTruncateMaxWidth = axisCollapseWidth;
	  }
	
	  return {
	    position: position,
	    axisNameAvailableWidth: axisNameAvailableWidth,
	    axisLabelShow: axisLabelShow,
	    nameTruncateMaxWidth: nameTruncateMaxWidth
	  };
	}
	
	var _default = Parallel;
	module.exports = _default;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Axis = __webpack_require__(36);
	
	/**
	 * @constructor module:echarts/coord/parallel/ParallelAxis
	 * @extends {module:echarts/coord/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 */
	var ParallelAxis = function (dim, scale, coordExtent, axisType, axisIndex) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.axisIndex = axisIndex;
	};
	
	ParallelAxis.prototype = {
	  constructor: ParallelAxis,
	
	  /**
	   * Axis model
	   * @param {module:echarts/coord/parallel/AxisModel}
	   */
	  model: null,
	
	  /**
	   * @override
	   */
	  isHorizontal: function () {
	    return this.coordinateSystem.getModel().get('layout') !== 'horizontal';
	  }
	};
	zrUtil.inherits(ParallelAxis, Axis);
	var _default = ParallelAxis;
	module.exports = _default;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Component = __webpack_require__(16);
	
	__webpack_require__(559);
	
	var _default = Component.extend({
	  type: 'parallel',
	  dependencies: ['parallelAxis'],
	
	  /**
	   * @type {module:echarts/coord/parallel/Parallel}
	   */
	  coordinateSystem: null,
	
	  /**
	   * Each item like: 'dim0', 'dim1', 'dim2', ...
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * Coresponding to dimensions.
	   * @type {Array.<number>}
	   * @readOnly
	   */
	  parallelAxisIndex: null,
	  layoutMode: 'box',
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    left: 80,
	    top: 60,
	    right: 80,
	    bottom: 60,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    layout: 'horizontal',
	    // 'horizontal' or 'vertical'
	    // FIXME
	    // naming?
	    axisExpandable: false,
	    axisExpandCenter: null,
	    axisExpandCount: 0,
	    axisExpandWidth: 50,
	    // FIXME '10%' ?
	    axisExpandRate: 17,
	    axisExpandDebounce: 50,
	    // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
	    // Do not doc to user until necessary.
	    axisExpandSlideTriggerArea: [-0.15, 0.05, 0.4],
	    axisExpandTriggerOn: 'click',
	    // 'mousemove' or 'click'
	    parallelAxisDefault: null
	  },
	
	  /**
	   * @override
	   */
	  init: function () {
	    Component.prototype.init.apply(this, arguments);
	    this.mergeOption({});
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (newOption) {
	    var thisOption = this.option;
	    newOption && zrUtil.merge(thisOption, newOption, true);
	
	    this._initDimensions();
	  },
	
	  /**
	   * Whether series or axis is in this coordinate system.
	   * @param {module:echarts/model/Series|module:echarts/coord/parallel/AxisModel} model
	   * @param {module:echarts/model/Global} ecModel
	   */
	  contains: function (model, ecModel) {
	    var parallelIndex = model.get('parallelIndex');
	    return parallelIndex != null && ecModel.getComponent('parallel', parallelIndex) === this;
	  },
	  setAxisExpand: function (opt) {
	    zrUtil.each(['axisExpandable', 'axisExpandCenter', 'axisExpandCount', 'axisExpandWidth', 'axisExpandWindow'], function (name) {
	      if (opt.hasOwnProperty(name)) {
	        this.option[name] = opt[name];
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _initDimensions: function () {
	    var dimensions = this.dimensions = [];
	    var parallelAxisIndex = this.parallelAxisIndex = [];
	    var axisModels = zrUtil.filter(this.dependentModels.parallelAxis, function (axisModel) {
	      // Can not use this.contains here, because
	      // initialization has not been completed yet.
	      return (axisModel.get('parallelIndex') || 0) === this.componentIndex;
	    }, this);
	    zrUtil.each(axisModels, function (axisModel) {
	      dimensions.push('dim' + axisModel.get('dim'));
	      parallelAxisIndex.push(axisModel.componentIndex);
	    });
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var modelUtil = __webpack_require__(6);
	
	function _default(option) {
	  createParallelIfNeeded(option);
	  mergeAxisOptionFromParallel(option);
	}
	/**
	 * Create a parallel coordinate if not exists.
	 * @inner
	 */
	
	
	function createParallelIfNeeded(option) {
	  if (option.parallel) {
	    return;
	  }
	
	  var hasParallelSeries = false;
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'parallel') {
	      hasParallelSeries = true;
	    }
	  });
	
	  if (hasParallelSeries) {
	    option.parallel = [{}];
	  }
	}
	/**
	 * Merge aixs definition from parallel option (if exists) to axis option.
	 * @inner
	 */
	
	
	function mergeAxisOptionFromParallel(option) {
	  var axes = modelUtil.normalizeToArray(option.parallelAxis);
	  zrUtil.each(axes, function (axisOption) {
	    if (!zrUtil.isObject(axisOption)) {
	      return;
	    }
	
	    var parallelIndex = axisOption.parallelIndex || 0;
	    var parallelOption = modelUtil.normalizeToArray(option.parallel)[parallelIndex];
	
	    if (parallelOption && parallelOption.parallelAxisDefault) {
	      zrUtil.merge(axisOption, parallelOption.parallelAxisDefault, false);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Axis = __webpack_require__(36);
	
	function AngleAxis(scale, angleExtent) {
	  angleExtent = angleExtent || [0, 360];
	  Axis.call(this, 'angle', scale, angleExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'category';
	}
	
	AngleAxis.prototype = {
	  constructor: AngleAxis,
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
	  },
	  dataToAngle: Axis.prototype.dataToCoord,
	  angleToData: Axis.prototype.coordToData
	};
	zrUtil.inherits(AngleAxis, Axis);
	var _default = AngleAxis;
	module.exports = _default;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var ComponentModel = __webpack_require__(16);
	
	var axisModelCreator = __webpack_require__(88);
	
	var axisModelCommonMixin = __webpack_require__(55);
	
	var PolarAxisModel = ComponentModel.extend({
	  type: 'polarAxis',
	
	  /**
	   * @type {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  axis: null,
	
	  /**
	   * @override
	   */
	  getCoordSysModel: function () {
	    return this.ecModel.queryComponents({
	      mainType: 'polar',
	      index: this.option.polarIndex,
	      id: this.option.polarId
	    })[0];
	  }
	});
	zrUtil.merge(PolarAxisModel.prototype, axisModelCommonMixin);
	var polarAxisDefaultExtendedOption = {
	  angle: {
	    // polarIndex: 0,
	    // polarId: '',
	    startAngle: 90,
	    clockwise: true,
	    splitNumber: 12,
	    axisLabel: {
	      rotate: false
	    }
	  },
	  radius: {
	    // polarIndex: 0,
	    // polarId: '',
	    splitNumber: 5
	  }
	};
	
	function getAxisType(axisDim, option) {
	  // Default axis with data is category axis
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	axisModelCreator('angle', PolarAxisModel, getAxisType, polarAxisDefaultExtendedOption.angle);
	axisModelCreator('radius', PolarAxisModel, getAxisType, polarAxisDefaultExtendedOption.radius);

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	var RadiusAxis = __webpack_require__(568);
	
	var AngleAxis = __webpack_require__(564);
	
	/**
	 * @module echarts/coord/polar/Polar
	 */
	
	/**
	 * @alias {module:echarts/coord/polar/Polar}
	 * @constructor
	 * @param {string} name
	 */
	var Polar = function (name) {
	  /**
	   * @type {string}
	   */
	  this.name = name || '';
	  /**
	   * x of polar center
	   * @type {number}
	   */
	
	  this.cx = 0;
	  /**
	   * y of polar center
	   * @type {number}
	   */
	
	  this.cy = 0;
	  /**
	   * @type {module:echarts/coord/polar/RadiusAxis}
	   * @private
	   */
	
	  this._radiusAxis = new RadiusAxis();
	  /**
	   * @type {module:echarts/coord/polar/AngleAxis}
	   * @private
	   */
	
	  this._angleAxis = new AngleAxis();
	  this._radiusAxis.polar = this._angleAxis.polar = this;
	};
	
	Polar.prototype = {
	  type: 'polar',
	  axisPointerEnabled: true,
	  constructor: Polar,
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['radius', 'angle'],
	
	  /**
	   * @type {module:echarts/coord/PolarModel}
	   */
	  model: null,
	
	  /**
	   * If contain coord
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var coord = this.pointToCoord(point);
	    return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
	  },
	
	  /**
	   * If contain data
	   * @param {Array.<number>} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
	  },
	
	  /**
	   * @param {string} dim
	   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  getAxis: function (dim) {
	    return this['_' + dim + 'Axis'];
	  },
	
	  /**
	   * @return {Array.<module:echarts/coord/Axis>}
	   */
	  getAxes: function () {
	    return [this._radiusAxis, this._angleAxis];
	  },
	
	  /**
	   * Get axes by type of scale
	   * @param {string} scaleType
	   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  getAxesByScale: function (scaleType) {
	    var axes = [];
	    var angleAxis = this._angleAxis;
	    var radiusAxis = this._radiusAxis;
	    angleAxis.scale.type === scaleType && axes.push(angleAxis);
	    radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
	    return axes;
	  },
	
	  /**
	   * @return {module:echarts/coord/polar/AngleAxis}
	   */
	  getAngleAxis: function () {
	    return this._angleAxis;
	  },
	
	  /**
	   * @return {module:echarts/coord/polar/RadiusAxis}
	   */
	  getRadiusAxis: function () {
	    return this._radiusAxis;
	  },
	
	  /**
	   * @param {module:echarts/coord/polar/Axis}
	   * @return {module:echarts/coord/polar/Axis}
	   */
	  getOtherAxis: function (axis) {
	    var angleAxis = this._angleAxis;
	    return axis === angleAxis ? this._radiusAxis : angleAxis;
	  },
	
	  /**
	   * Base axis will be used on stacking.
	   *
	   * @return {module:echarts/coord/polar/Axis}
	   */
	  getBaseAxis: function () {
	    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAngleAxis();
	  },
	
	  /**
	   * @param {string} [dim] 'radius' or 'angle' or 'auto' or null/undefined
	   * @return {Object} {baseAxes: [], otherAxes: []}
	   */
	  getTooltipAxes: function (dim) {
	    var baseAxis = dim != null && dim !== 'auto' ? this.getAxis(dim) : this.getBaseAxis();
	    return {
	      baseAxes: [baseAxis],
	      otherAxes: [this.getOtherAxis(baseAxis)]
	    };
	  },
	
	  /**
	   * Convert a single data item to (x, y) point.
	   * Parameter data is an array which the first element is radius and the second is angle
	   * @param {Array.<number>} data
	   * @param {boolean} [clamp=false]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, clamp) {
	    return this.coordToPoint([this._radiusAxis.dataToRadius(data[0], clamp), this._angleAxis.dataToAngle(data[1], clamp)]);
	  },
	
	  /**
	   * Convert a (x, y) point to data
	   * @param {Array.<number>} point
	   * @param {boolean} [clamp=false]
	   * @return {Array.<number>}
	   */
	  pointToData: function (point, clamp) {
	    var coord = this.pointToCoord(point);
	    return [this._radiusAxis.radiusToData(coord[0], clamp), this._angleAxis.angleToData(coord[1], clamp)];
	  },
	
	  /**
	   * Convert a (x, y) point to (radius, angle) coord
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToCoord: function (point) {
	    var dx = point[0] - this.cx;
	    var dy = point[1] - this.cy;
	    var angleAxis = this.getAngleAxis();
	    var extent = angleAxis.getExtent();
	    var minAngle = Math.min(extent[0], extent[1]);
	    var maxAngle = Math.max(extent[0], extent[1]); // Fix fixed extent in polarCreator
	    // FIXME
	
	    angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
	    var radius = Math.sqrt(dx * dx + dy * dy);
	    dx /= radius;
	    dy /= radius;
	    var radian = Math.atan2(-dy, dx) / Math.PI * 180; // move to angleExtent
	
	    var dir = radian < minAngle ? 1 : -1;
	
	    while (radian < minAngle || radian > maxAngle) {
	      radian += dir * 360;
	    }
	
	    return [radius, radian];
	  },
	
	  /**
	   * Convert a (radius, angle) coord to (x, y) point
	   * @param {Array.<number>} coord
	   * @return {Array.<number>}
	   */
	  coordToPoint: function (coord) {
	    var radius = coord[0];
	    var radian = coord[1] / 180 * Math.PI;
	    var x = Math.cos(radian) * radius + this.cx; // Inverse the y
	
	    var y = -Math.sin(radian) * radius + this.cy;
	    return [x, y];
	  }
	};
	var _default = Polar;
	module.exports = _default;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	__webpack_require__(565);
	
	var _default = echarts.extendComponentModel({
	  type: 'polar',
	  dependencies: ['polarAxis', 'angleAxis'],
	
	  /**
	   * @type {module:echarts/coord/polar/Polar}
	   */
	  coordinateSystem: null,
	
	  /**
	   * @param {string} axisType
	   * @return {module:echarts/coord/polar/AxisModel}
	   */
	  findAxisModel: function (axisType) {
	    var foundAxisModel;
	    var ecModel = this.ecModel;
	    ecModel.eachComponent(axisType, function (axisModel) {
	      if (axisModel.getCoordSysModel() === this) {
	        foundAxisModel = axisModel;
	      }
	    }, this);
	    return foundAxisModel;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    center: ['50%', '50%'],
	    radius: '80%'
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Axis = __webpack_require__(36);
	
	function RadiusAxis(scale, radiusExtent) {
	  Axis.call(this, 'radius', scale, radiusExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'category';
	}
	
	RadiusAxis.prototype = {
	  constructor: RadiusAxis,
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
	  },
	  dataToRadius: Axis.prototype.dataToCoord,
	  radiusToData: Axis.prototype.coordToData
	};
	zrUtil.inherits(RadiusAxis, Axis);
	var _default = RadiusAxis;
	module.exports = _default;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  return zrUtil.map(['Radius', 'Angle'], function (dim, dimIdx) {
	    var axis = this['get' + dim + 'Axis']();
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    var method = 'dataTo' + dim;
	    var result = axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis[method](val - halfSize) - axis[method](val + halfSize));
	
	    if (dim === 'Angle') {
	      result = result * Math.PI / 180;
	    }
	
	    return result;
	  }, this);
	}
	
	function _default(coordSys) {
	  var radiusAxis = coordSys.getRadiusAxis();
	  var angleAxis = coordSys.getAngleAxis();
	  var radius = radiusAxis.getExtent();
	  radius[0] > radius[1] && radius.reverse();
	  return {
	    coordSys: {
	      type: 'polar',
	      cx: coordSys.cx,
	      cy: coordSys.cy,
	      r: radius[1],
	      r0: radius[0]
	    },
	    api: {
	      coord: zrUtil.bind(function (data) {
	        var radius = radiusAxis.dataToRadius(data[0]);
	        var angle = angleAxis.dataToAngle(data[1]);
	        var coord = coordSys.coordToPoint([radius, angle]);
	        coord.push(radius, angle * Math.PI / 180);
	        return coord;
	      }),
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Axis = __webpack_require__(36);
	
	function IndicatorAxis(dim, scale, radiusExtent) {
	  Axis.call(this, dim, scale, radiusExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'value';
	  this.angle = 0;
	  /**
	   * Indicator name
	   * @type {string}
	   */
	
	  this.name = '';
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.model;
	}
	
	zrUtil.inherits(IndicatorAxis, Axis);
	var _default = IndicatorAxis;
	module.exports = _default;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var IndicatorAxis = __webpack_require__(570);
	
	var IntervalScale = __webpack_require__(91);
	
	var numberUtil = __webpack_require__(4);
	
	var _axisHelper = __webpack_require__(21);
	
	var getScaleExtent = _axisHelper.getScaleExtent;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	
	var CoordinateSystem = __webpack_require__(26);
	
	// TODO clockwise
	function Radar(radarModel, ecModel, api) {
	  this._model = radarModel;
	  /**
	   * Radar dimensions
	   * @type {Array.<string>}
	   */
	
	  this.dimensions = [];
	  this._indicatorAxes = zrUtil.map(radarModel.getIndicatorModels(), function (indicatorModel, idx) {
	    var dim = 'indicator_' + idx;
	    var indicatorAxis = new IndicatorAxis(dim, new IntervalScale());
	    indicatorAxis.name = indicatorModel.get('name'); // Inject model and axis
	
	    indicatorAxis.model = indicatorModel;
	    indicatorModel.axis = indicatorAxis;
	    this.dimensions.push(dim);
	    return indicatorAxis;
	  }, this);
	  this.resize(radarModel, api);
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.cx;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.cy;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.r;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.startAngle;
	}
	
	Radar.prototype.getIndicatorAxes = function () {
	  return this._indicatorAxes;
	};
	
	Radar.prototype.dataToPoint = function (value, indicatorIndex) {
	  var indicatorAxis = this._indicatorAxes[indicatorIndex];
	  return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
	};
	
	Radar.prototype.coordToPoint = function (coord, indicatorIndex) {
	  var indicatorAxis = this._indicatorAxes[indicatorIndex];
	  var angle = indicatorAxis.angle;
	  var x = this.cx + coord * Math.cos(angle);
	  var y = this.cy - coord * Math.sin(angle);
	  return [x, y];
	};
	
	Radar.prototype.pointToData = function (pt) {
	  var dx = pt[0] - this.cx;
	  var dy = pt[1] - this.cy;
	  var radius = Math.sqrt(dx * dx + dy * dy);
	  dx /= radius;
	  dy /= radius;
	  var radian = Math.atan2(-dy, dx); // Find the closest angle
	  // FIXME index can calculated directly
	
	  var minRadianDiff = Infinity;
	  var closestAxis;
	  var closestAxisIdx = -1;
	
	  for (var i = 0; i < this._indicatorAxes.length; i++) {
	    var indicatorAxis = this._indicatorAxes[i];
	    var diff = Math.abs(radian - indicatorAxis.angle);
	
	    if (diff < minRadianDiff) {
	      closestAxis = indicatorAxis;
	      closestAxisIdx = i;
	      minRadianDiff = diff;
	    }
	  }
	
	  return [closestAxisIdx, +(closestAxis && closestAxis.coodToData(radius))];
	};
	
	Radar.prototype.resize = function (radarModel, api) {
	  var center = radarModel.get('center');
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  var viewSize = Math.min(viewWidth, viewHeight) / 2;
	  this.cx = numberUtil.parsePercent(center[0], viewWidth);
	  this.cy = numberUtil.parsePercent(center[1], viewHeight);
	  this.startAngle = radarModel.get('startAngle') * Math.PI / 180;
	  this.r = numberUtil.parsePercent(radarModel.get('radius'), viewSize);
	  zrUtil.each(this._indicatorAxes, function (indicatorAxis, idx) {
	    indicatorAxis.setExtent(0, this.r);
	    var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length; // Normalize to [-PI, PI]
	
	    angle = Math.atan2(Math.sin(angle), Math.cos(angle));
	    indicatorAxis.angle = angle;
	  }, this);
	};
	
	Radar.prototype.update = function (ecModel, api) {
	  var indicatorAxes = this._indicatorAxes;
	  var radarModel = this._model;
	  zrUtil.each(indicatorAxes, function (indicatorAxis) {
	    indicatorAxis.scale.setExtent(Infinity, -Infinity);
	  });
	  ecModel.eachSeriesByType('radar', function (radarSeries, idx) {
	    if (radarSeries.get('coordinateSystem') !== 'radar' || ecModel.getComponent('radar', radarSeries.get('radarIndex')) !== radarModel) {
	      return;
	    }
	
	    var data = radarSeries.getData();
	    zrUtil.each(indicatorAxes, function (indicatorAxis) {
	      indicatorAxis.scale.unionExtentFromData(data, indicatorAxis.dim);
	    });
	  }, this);
	  var splitNumber = radarModel.get('splitNumber');
	
	  function increaseInterval(interval) {
	    var exp10 = Math.pow(10, Math.floor(Math.log(interval) / Math.LN10)); // Increase interval
	
	    var f = interval / exp10;
	
	    if (f === 2) {
	      f = 5;
	    } else {
	      // f is 2 or 5
	      f *= 2;
	    }
	
	    return f * exp10;
	  } // Force all the axis fixing the maxSplitNumber.
	
	
	  zrUtil.each(indicatorAxes, function (indicatorAxis, idx) {
	    var rawExtent = getScaleExtent(indicatorAxis.scale, indicatorAxis.model);
	    niceScaleExtent(indicatorAxis.scale, indicatorAxis.model);
	    var axisModel = indicatorAxis.model;
	    var scale = indicatorAxis.scale;
	    var fixedMin = axisModel.getMin();
	    var fixedMax = axisModel.getMax();
	    var interval = scale.getInterval();
	
	    if (fixedMin != null && fixedMax != null) {
	      // User set min, max, divide to get new interval
	      scale.setExtent(+fixedMin, +fixedMax);
	      scale.setInterval((fixedMax - fixedMin) / splitNumber);
	    } else if (fixedMin != null) {
	      var max; // User set min, expand extent on the other side
	
	      do {
	        max = fixedMin + interval * splitNumber;
	        scale.setExtent(+fixedMin, max); // Interval must been set after extent
	        // FIXME
	
	        scale.setInterval(interval);
	        interval = increaseInterval(interval);
	      } while (max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1]));
	    } else if (fixedMax != null) {
	      var min; // User set min, expand extent on the other side
	
	      do {
	        min = fixedMax - interval * splitNumber;
	        scale.setExtent(min, +fixedMax);
	        scale.setInterval(interval);
	        interval = increaseInterval(interval);
	      } while (min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0]));
	    } else {
	      var nicedSplitNumber = scale.getTicks().length - 1;
	
	      if (nicedSplitNumber > splitNumber) {
	        interval = increaseInterval(interval);
	      } // PENDING
	
	
	      var center = Math.round((rawExtent[0] + rawExtent[1]) / 2 / interval) * interval;
	      var halfSplitNumber = Math.round(splitNumber / 2);
	      scale.setExtent(numberUtil.round(center - halfSplitNumber * interval), numberUtil.round(center + (splitNumber - halfSplitNumber) * interval));
	      scale.setInterval(interval);
	    }
	  });
	};
	/**
	 * Radar dimensions is based on the data
	 * @type {Array}
	 */
	
	
	Radar.dimensions = [];
	
	Radar.create = function (ecModel, api) {
	  var radarList = [];
	  ecModel.eachComponent('radar', function (radarModel) {
	    var radar = new Radar(radarModel, ecModel, api);
	    radarList.push(radar);
	    radarModel.coordinateSystem = radar;
	  });
	  ecModel.eachSeriesByType('radar', function (radarSeries) {
	    if (radarSeries.get('coordinateSystem') === 'radar') {
	      // Inject coordinate system
	      radarSeries.coordinateSystem = radarList[radarSeries.get('radarIndex') || 0];
	    }
	  });
	  return radarList;
	};
	
	CoordinateSystem.register('radar', Radar);
	var _default = Radar;
	module.exports = _default;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	var echarts = __webpack_require__(2);
	
	var zrUtil = __webpack_require__(1);
	
	var axisDefault = __webpack_require__(194);
	
	var Model = __webpack_require__(14);
	
	var axisModelCommonMixin = __webpack_require__(55);
	
	var valueAxisDefault = axisDefault.valueAxis;
	
	function defaultsShow(opt, show) {
	  return zrUtil.defaults({
	    show: show
	  }, opt);
	}
	
	var RadarModel = echarts.extendComponentModel({
	  type: 'radar',
	  optionUpdated: function () {
	    var boundaryGap = this.get('boundaryGap');
	    var splitNumber = this.get('splitNumber');
	    var scale = this.get('scale');
	    var axisLine = this.get('axisLine');
	    var axisTick = this.get('axisTick');
	    var axisLabel = this.get('axisLabel');
	    var nameTextStyle = this.get('name');
	    var showName = this.get('name.show');
	    var nameFormatter = this.get('name.formatter');
	    var nameGap = this.get('nameGap');
	    var triggerEvent = this.get('triggerEvent');
	    var indicatorModels = zrUtil.map(this.get('indicator') || [], function (indicatorOpt) {
	      // PENDING
	      if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) {
	        indicatorOpt.min = 0;
	      } else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) {
	        indicatorOpt.max = 0;
	      }
	
	      var iNameTextStyle = nameTextStyle;
	
	      if (indicatorOpt.color != null) {
	        iNameTextStyle = zrUtil.defaults({
	          color: indicatorOpt.color
	        }, nameTextStyle);
	      } // Use same configuration
	
	
	      indicatorOpt = zrUtil.merge(zrUtil.clone(indicatorOpt), {
	        boundaryGap: boundaryGap,
	        splitNumber: splitNumber,
	        scale: scale,
	        axisLine: axisLine,
	        axisTick: axisTick,
	        axisLabel: axisLabel,
	        // Competitable with 2 and use text
	        name: indicatorOpt.text,
	        nameLocation: 'end',
	        nameGap: nameGap,
	        // min: 0,
	        nameTextStyle: iNameTextStyle,
	        triggerEvent: triggerEvent
	      }, false);
	
	      if (!showName) {
	        indicatorOpt.name = '';
	      }
	
	      if (typeof nameFormatter === 'string') {
	        var indName = indicatorOpt.name;
	        indicatorOpt.name = nameFormatter.replace('{value}', indName != null ? indName : '');
	      } else if (typeof nameFormatter === 'function') {
	        indicatorOpt.name = nameFormatter(indicatorOpt.name, indicatorOpt);
	      }
	
	      var model = zrUtil.extend(new Model(indicatorOpt, null, this.ecModel), axisModelCommonMixin); // For triggerEvent.
	
	      model.mainType = 'radar';
	      model.componentIndex = this.componentIndex;
	      return model;
	    }, this);
	
	    this.getIndicatorModels = function () {
	      return indicatorModels;
	    };
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    center: ['50%', '50%'],
	    radius: '75%',
	    startAngle: 90,
	    name: {
	      show: true // formatter: null
	      // textStyle: {}
	
	    },
	    boundaryGap: [0, 0],
	    splitNumber: 5,
	    nameGap: 15,
	    scale: false,
	    // Polygon or circle
	    shape: 'polygon',
	    axisLine: zrUtil.merge({
	      lineStyle: {
	        color: '#bbb'
	      }
	    }, valueAxisDefault.axisLine),
	    axisLabel: defaultsShow(valueAxisDefault.axisLabel, false),
	    axisTick: defaultsShow(valueAxisDefault.axisTick, false),
	    splitLine: defaultsShow(valueAxisDefault.splitLine, true),
	    splitArea: defaultsShow(valueAxisDefault.splitArea, true),
	    // {text, min, max}
	    indicator: []
	  }
	});
	var _default = RadarModel;
	module.exports = _default;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var ComponentModel = __webpack_require__(16);
	
	var axisModelCreator = __webpack_require__(88);
	
	var axisModelCommonMixin = __webpack_require__(55);
	
	var AxisModel = ComponentModel.extend({
	  type: 'singleAxis',
	  layoutMode: 'box',
	
	  /**
	   * @type {module:echarts/coord/single/SingleAxis}
	   */
	  axis: null,
	
	  /**
	   * @type {module:echarts/coord/single/Single}
	   */
	  coordinateSystem: null,
	
	  /**
	   * @override
	   */
	  getCoordSysModel: function () {
	    return this;
	  }
	});
	var defaultOption = {
	  left: '5%',
	  top: '5%',
	  right: '5%',
	  bottom: '5%',
	  type: 'value',
	  position: 'bottom',
	  orient: 'horizontal',
	  axisLine: {
	    show: true,
	    lineStyle: {
	      width: 2,
	      type: 'solid'
	    }
	  },
	  // Single coordinate system and single axis is the,
	  // which is used as the parent tooltip model.
	  // same model, so we set default tooltip show as true.
	  tooltip: {
	    show: true
	  },
	  axisTick: {
	    show: true,
	    length: 6,
	    lineStyle: {
	      width: 2
	    }
	  },
	  axisLabel: {
	    show: true,
	    interval: 'auto'
	  },
	  splitLine: {
	    show: true,
	    lineStyle: {
	      type: 'dashed',
	      opacity: 0.2
	    }
	  }
	};
	
	function getAxisType(axisName, option) {
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	axisModelCreator('single', AxisModel, getAxisType, defaultOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	var SingleAxis = __webpack_require__(575);
	
	var axisHelper = __webpack_require__(21);
	
	var _layout = __webpack_require__(7);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	/**
	 * Single coordinates system.
	 */
	
	/**
	 * Create a single coordinates system.
	 *
	 * @param {module:echarts/coord/single/AxisModel} axisModel
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function Single(axisModel, ecModel, api) {
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  this.dimension = 'single';
	  /**
	   * Add it just for draw tooltip.
	   *
	   * @type {Array.<string>}
	   * @readOnly
	   */
	
	  this.dimensions = ['single'];
	  /**
	   * @private
	   * @type {module:echarts/coord/single/SingleAxis}.
	   */
	
	  this._axis = null;
	  /**
	   * @private
	   * @type {module:zrender/core/BoundingRect}
	   */
	
	  this._rect;
	
	  this._init(axisModel, ecModel, api);
	  /**
	   * @type {module:echarts/coord/single/AxisModel}
	   */
	
	
	  this.model = axisModel;
	}
	
	Single.prototype = {
	  type: 'singleAxis',
	  axisPointerEnabled: true,
	  constructor: Single,
	
	  /**
	   * Initialize single coordinate system.
	   *
	   * @param  {module:echarts/coord/single/AxisModel} axisModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @private
	   */
	  _init: function (axisModel, ecModel, api) {
	    var dim = this.dimension;
	    var axis = new SingleAxis(dim, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisModel.get('position'));
	    var isCategory = axis.type === 'category';
	    axis.onBand = isCategory && axisModel.get('boundaryGap');
	    axis.inverse = axisModel.get('inverse');
	    axis.orient = axisModel.get('orient');
	    axisModel.axis = axis;
	    axis.model = axisModel;
	    axis.coordinateSystem = this;
	    this._axis = axis;
	  },
	
	  /**
	   * Update axis scale after data processed
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  update: function (ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.coordinateSystem === this) {
	        var data = seriesModel.getData();
	        var dim = this.dimension;
	
	        this._axis.scale.unionExtentFromData(data, seriesModel.coordDimToDataDim(dim));
	
	        axisHelper.niceScaleExtent(this._axis.scale, this._axis.model);
	      }
	    }, this);
	  },
	
	  /**
	   * Resize the single coordinate system.
	   *
	   * @param  {module:echarts/coord/single/AxisModel} axisModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  resize: function (axisModel, api) {
	    this._rect = getLayoutRect({
	      left: axisModel.get('left'),
	      top: axisModel.get('top'),
	      right: axisModel.get('right'),
	      bottom: axisModel.get('bottom'),
	      width: axisModel.get('width'),
	      height: axisModel.get('height')
	    }, {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	
	    this._adjustAxis();
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @private
	   */
	  _adjustAxis: function () {
	    var rect = this._rect;
	    var axis = this._axis;
	    var isHorizontal = axis.isHorizontal();
	    var extent = isHorizontal ? [0, rect.width] : [0, rect.height];
	    var idx = axis.reverse ? 1 : 0;
	    axis.setExtent(extent[idx], extent[1 - idx]);
	
	    this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
	  },
	
	  /**
	   * @param  {module:echarts/coord/single/SingleAxis} axis
	   * @param  {number} coordBase
	   */
	  _updateAxisTransform: function (axis, coordBase) {
	    var axisExtent = axis.getExtent();
	    var extentSum = axisExtent[0] + axisExtent[1];
	    var isHorizontal = axis.isHorizontal();
	    axis.toGlobalCoord = isHorizontal ? function (coord) {
	      return coord + coordBase;
	    } : function (coord) {
	      return extentSum - coord + coordBase;
	    };
	    axis.toLocalCoord = isHorizontal ? function (coord) {
	      return coord - coordBase;
	    } : function (coord) {
	      return extentSum - coord + coordBase;
	    };
	  },
	
	  /**
	   * Get axis.
	   *
	   * @return {module:echarts/coord/single/SingleAxis}
	   */
	  getAxis: function () {
	    return this._axis;
	  },
	
	  /**
	   * Get axis, add it just for draw tooltip.
	   *
	   * @return {[type]} [description]
	   */
	  getBaseAxis: function () {
	    return this._axis;
	  },
	
	  /**
	   * @return {Array.<module:echarts/coord/Axis>}
	   */
	  getAxes: function () {
	    return [this._axis];
	  },
	
	  /**
	   * @return {Object} {baseAxes: [], otherAxes: []}
	   */
	  getTooltipAxes: function () {
	    return {
	      baseAxes: [this.getAxis()]
	    };
	  },
	
	  /**
	   * If contain point.
	   *
	   * @param  {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var rect = this.getRect();
	    var axis = this.getAxis();
	    var orient = axis.orient;
	
	    if (orient === 'horizontal') {
	      return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
	    } else {
	      return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
	    }
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToData: function (point) {
	    var axis = this.getAxis();
	    return [axis.coordToData(axis.toLocalCoord(point[axis.orient === 'horizontal' ? 0 : 1]))];
	  },
	
	  /**
	   * Convert the series data to concrete point.
	   *
	   * @param  {number|Array.<number>} val
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (val) {
	    var axis = this.getAxis();
	    var rect = this.getRect();
	    var pt = [];
	    var idx = axis.orient === 'horizontal' ? 0 : 1;
	
	    if (val instanceof Array) {
	      val = val[0];
	    }
	
	    pt[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
	    pt[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
	    return pt;
	  }
	};
	var _default = Single;
	module.exports = _default;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Axis = __webpack_require__(36);
	
	/**
	 * @constructor  module:echarts/coord/single/SingleAxis
	 * @extends {module:echarts/coord/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var SingleAxis = function (dim, scale, coordExtent, axisType, position) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   * - 'category'
	   * - 'value'
	   * - 'time'
	   * - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis position
	   *  - 'top'
	   *  - 'bottom'
	   *  - 'left'
	   *  - 'right'
	   *  @type {string}
	   */
	
	  this.position = position || 'bottom';
	  /**
	   * Axis orient
	   *  - 'horizontal'
	   *  - 'vertical'
	   * @type {[type]}
	   */
	
	  this.orient = null;
	  /**
	   * @type {number}
	   */
	
	  this._labelInterval = null;
	};
	
	SingleAxis.prototype = {
	  constructor: SingleAxis,
	
	  /**
	   * Axis model
	   * @type {module:echarts/coord/single/AxisModel}
	   */
	  model: null,
	
	  /**
	   * Judge the orient of the axis.
	   * @return {boolean}
	   */
	  isHorizontal: function () {
	    var position = this.position;
	    return position === 'top' || position === 'bottom';
	  },
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.coordinateSystem.pointToData(point, clamp)[0];
	  },
	
	  /**
	   * Convert the local coord(processed by dataToCoord())
	   * to global coord(concrete pixel coord).
	   * designated by module:echarts/coord/single/Single.
	   * @type {Function}
	   */
	  toGlobalCoord: null,
	
	  /**
	   * Convert the global coord to local coord.
	   * designated by module:echarts/coord/single/Single.
	   * @type {Function}
	   */
	  toLocalCoord: null
	};
	zrUtil.inherits(SingleAxis, Axis);
	var _default = SingleAxis;
	module.exports = _default;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  var axis = this.getAxis();
	  var val = dataItem instanceof Array ? dataItem[0] : dataItem;
	  var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
	  return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
	}
	
	function _default(coordSys) {
	  var rect = coordSys.getRect();
	  return {
	    coordSys: {
	      type: 'singleAxis',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    api: {
	      coord: zrUtil.bind(coordSys.dataToPoint, coordSys),
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	var Single = __webpack_require__(574);
	
	var CoordinateSystem = __webpack_require__(26);
	
	/**
	 * Single coordinate system creator.
	 */
	
	/**
	 * Create single coordinate system and inject it into seriesModel.
	 *
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 * @return {Array.<module:echarts/coord/single/Single>}
	 */
	function create(ecModel, api) {
	  var singles = [];
	  ecModel.eachComponent('singleAxis', function (axisModel, idx) {
	    var single = new Single(axisModel, ecModel, api);
	    single.name = 'single_' + idx;
	    single.resize(axisModel, api);
	    axisModel.coordinateSystem = single;
	    singles.push(single);
	  });
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.get('coordinateSystem') === 'singleAxis') {
	      var singleAxisModel = ecModel.queryComponents({
	        mainType: 'singleAxis',
	        index: seriesModel.get('singleAxisIndex'),
	        id: seriesModel.get('singleAxisId')
	      })[0];
	      seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
	    }
	  });
	  return singles;
	}
	
	CoordinateSystem.register('single', {
	  create: create,
	  dimensions: Single.prototype.dimensions
	});

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(1);
	
	/**
	 * Graph data structure
	 *
	 * @module echarts/data/Graph
	 * @author Yi Shen(https://www.github.com/pissang)
	 */
	// id may be function name of Object, add a prefix to avoid this problem.
	function generateNodeKey(id) {
	  return '_EC_' + id;
	}
	/**
	 * @alias module:echarts/data/Graph
	 * @constructor
	 * @param {boolean} directed
	 */
	
	
	var Graph = function (directed) {
	  /**
	   * 是否是有向图
	   * @type {boolean}
	   * @private
	   */
	  this._directed = directed || false;
	  /**
	   * @type {Array.<module:echarts/data/Graph.Node>}
	   * @readOnly
	   */
	
	  this.nodes = [];
	  /**
	   * @type {Array.<module:echarts/data/Graph.Edge>}
	   * @readOnly
	   */
	
	  this.edges = [];
	  /**
	   * @type {Object.<string, module:echarts/data/Graph.Node>}
	   * @private
	   */
	
	  this._nodesMap = {};
	  /**
	   * @type {Object.<string, module:echarts/data/Graph.Edge>}
	   * @private
	   */
	
	  this._edgesMap = {};
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.data;
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.edgeData;
	};
	
	var graphProto = Graph.prototype;
	/**
	 * @type {string}
	 */
	
	graphProto.type = 'graph';
	/**
	 * If is directed graph
	 * @return {boolean}
	 */
	
	graphProto.isDirected = function () {
	  return this._directed;
	};
	/**
	 * Add a new node
	 * @param {string} id
	 * @param {number} [dataIndex]
	 */
	
	
	graphProto.addNode = function (id, dataIndex) {
	  id = id || '' + dataIndex;
	  var nodesMap = this._nodesMap;
	
	  if (nodesMap[generateNodeKey(id)]) {
	    return;
	  }
	
	  var node = new Node(id, dataIndex);
	  node.hostGraph = this;
	  this.nodes.push(node);
	  nodesMap[generateNodeKey(id)] = node;
	  return node;
	};
	/**
	 * Get node by data index
	 * @param  {number} dataIndex
	 * @return {module:echarts/data/Graph~Node}
	 */
	
	
	graphProto.getNodeByIndex = function (dataIndex) {
	  var rawIdx = this.data.getRawIndex(dataIndex);
	  return this.nodes[rawIdx];
	};
	/**
	 * Get node by id
	 * @param  {string} id
	 * @return {module:echarts/data/Graph.Node}
	 */
	
	
	graphProto.getNodeById = function (id) {
	  return this._nodesMap[generateNodeKey(id)];
	};
	/**
	 * Add a new edge
	 * @param {number|string|module:echarts/data/Graph.Node} n1
	 * @param {number|string|module:echarts/data/Graph.Node} n2
	 * @param {number} [dataIndex=-1]
	 * @return {module:echarts/data/Graph.Edge}
	 */
	
	
	graphProto.addEdge = function (n1, n2, dataIndex) {
	  var nodesMap = this._nodesMap;
	  var edgesMap = this._edgesMap; // PNEDING
	
	  if (typeof n1 === 'number') {
	    n1 = this.nodes[n1];
	  }
	
	  if (typeof n2 === 'number') {
	    n2 = this.nodes[n2];
	  }
	
	  if (!(n1 instanceof Node)) {
	    n1 = nodesMap[generateNodeKey(n1)];
	  }
	
	  if (!(n2 instanceof Node)) {
	    n2 = nodesMap[generateNodeKey(n2)];
	  }
	
	  if (!n1 || !n2) {
	    return;
	  }
	
	  var key = n1.id + '-' + n2.id; // PENDING
	
	  if (edgesMap[key]) {
	    return;
	  }
	
	  var edge = new Edge(n1, n2, dataIndex);
	  edge.hostGraph = this;
	
	  if (this._directed) {
	    n1.outEdges.push(edge);
	    n2.inEdges.push(edge);
	  }
	
	  n1.edges.push(edge);
	
	  if (n1 !== n2) {
	    n2.edges.push(edge);
	  }
	
	  this.edges.push(edge);
	  edgesMap[key] = edge;
	  return edge;
	};
	/**
	 * Get edge by data index
	 * @param  {number} dataIndex
	 * @return {module:echarts/data/Graph~Node}
	 */
	
	
	graphProto.getEdgeByIndex = function (dataIndex) {
	  var rawIdx = this.edgeData.getRawIndex(dataIndex);
	  return this.edges[rawIdx];
	};
	/**
	 * Get edge by two linked nodes
	 * @param  {module:echarts/data/Graph.Node|string} n1
	 * @param  {module:echarts/data/Graph.Node|string} n2
	 * @return {module:echarts/data/Graph.Edge}
	 */
	
	
	graphProto.getEdge = function (n1, n2) {
	  if (n1 instanceof Node) {
	    n1 = n1.id;
	  }
	
	  if (n2 instanceof Node) {
	    n2 = n2.id;
	  }
	
	  var edgesMap = this._edgesMap;
	
	  if (this._directed) {
	    return edgesMap[n1 + '-' + n2];
	  } else {
	    return edgesMap[n1 + '-' + n2] || edgesMap[n2 + '-' + n1];
	  }
	};
	/**
	 * Iterate all nodes
	 * @param  {Function} cb
	 * @param  {*} [context]
	 */
	
	
	graphProto.eachNode = function (cb, context) {
	  var nodes = this.nodes;
	  var len = nodes.length;
	
	  for (var i = 0; i < len; i++) {
	    if (nodes[i].dataIndex >= 0) {
	      cb.call(context, nodes[i], i);
	    }
	  }
	};
	/**
	 * Iterate all edges
	 * @param  {Function} cb
	 * @param  {*} [context]
	 */
	
	
	graphProto.eachEdge = function (cb, context) {
	  var edges = this.edges;
	  var len = edges.length;
	
	  for (var i = 0; i < len; i++) {
	    if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) {
	      cb.call(context, edges[i], i);
	    }
	  }
	};
	/**
	 * Breadth first traverse
	 * @param {Function} cb
	 * @param {module:echarts/data/Graph.Node} startNode
	 * @param {string} [direction='none'] 'none'|'in'|'out'
	 * @param {*} [context]
	 */
	
	
	graphProto.breadthFirstTraverse = function (cb, startNode, direction, context) {
	  if (!(startNode instanceof Node)) {
	    startNode = this._nodesMap[generateNodeKey(startNode)];
	  }
	
	  if (!startNode) {
	    return;
	  }
	
	  var edgeType = direction === 'out' ? 'outEdges' : direction === 'in' ? 'inEdges' : 'edges';
	
	  for (var i = 0; i < this.nodes.length; i++) {
	    this.nodes[i].__visited = false;
	  }
	
	  if (cb.call(context, startNode, null)) {
	    return;
	  }
	
	  var queue = [startNode];
	
	  while (queue.length) {
	    var currentNode = queue.shift();
	    var edges = currentNode[edgeType];
	
	    for (var i = 0; i < edges.length; i++) {
	      var e = edges[i];
	      var otherNode = e.node1 === currentNode ? e.node2 : e.node1;
	
	      if (!otherNode.__visited) {
	        if (cb.call(context, otherNode, currentNode)) {
	          // Stop traversing
	          return;
	        }
	
	        queue.push(otherNode);
	        otherNode.__visited = true;
	      }
	    }
	  }
	}; // TODO
	// graphProto.depthFirstTraverse = function (
	//     cb, startNode, direction, context
	// ) {
	// };
	// Filter update
	
	
	graphProto.update = function () {
	  var data = this.data;
	  var edgeData = this.edgeData;
	  var nodes = this.nodes;
	  var edges = this.edges;
	
	  for (var i = 0, len = nodes.length; i < len; i++) {
	    nodes[i].dataIndex = -1;
	  }
	
	  for (var i = 0, len = data.count(); i < len; i++) {
	    nodes[data.getRawIndex(i)].dataIndex = i;
	  }
	
	  edgeData.filterSelf(function (idx) {
	    var edge = edges[edgeData.getRawIndex(idx)];
	    return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
	  }); // Update edge
	
	  for (var i = 0, len = edges.length; i < len; i++) {
	    edges[i].dataIndex = -1;
	  }
	
	  for (var i = 0, len = edgeData.count(); i < len; i++) {
	    edges[edgeData.getRawIndex(i)].dataIndex = i;
	  }
	};
	/**
	 * @return {module:echarts/data/Graph}
	 */
	
	
	graphProto.clone = function () {
	  var graph = new Graph(this._directed);
	  var nodes = this.nodes;
	  var edges = this.edges;
	
	  for (var i = 0; i < nodes.length; i++) {
	    graph.addNode(nodes[i].id, nodes[i].dataIndex);
	  }
	
	  for (var i = 0; i < edges.length; i++) {
	    var e = edges[i];
	    graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
	  }
	
	  return graph;
	};
	/**
	 * @alias module:echarts/data/Graph.Node
	 */
	
	
	function Node(id, dataIndex) {
	  /**
	  * @type {string}
	  */
	  this.id = id == null ? '' : id;
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.inEdges = [];
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.outEdges = [];
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.edges = [];
	  /**
	   * @type {module:echarts/data/Graph}
	   */
	
	  this.hostGraph;
	  /**
	   * @type {number}
	   */
	
	  this.dataIndex = dataIndex == null ? -1 : dataIndex;
	}
	
	Node.prototype = {
	  constructor: Node,
	
	  /**
	   * @return {number}
	   */
	  degree: function () {
	    return this.edges.length;
	  },
	
	  /**
	   * @return {number}
	   */
	  inDegree: function () {
	    return this.inEdges.length;
	  },
	
	  /**
	  * @return {number}
	  */
	  outDegree: function () {
	    return this.outEdges.length;
	  },
	
	  /**
	   * @param {string} [path]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path) {
	    if (this.dataIndex < 0) {
	      return;
	    }
	
	    var graph = this.hostGraph;
	    var itemModel = graph.data.getItemModel(this.dataIndex);
	    return itemModel.getModel(path);
	  }
	};
	/**
	 * 图边
	 * @alias module:echarts/data/Graph.Edge
	 * @param {module:echarts/data/Graph.Node} n1
	 * @param {module:echarts/data/Graph.Node} n2
	 * @param {number} [dataIndex=-1]
	 */
	
	function Edge(n1, n2, dataIndex) {
	  /**
	   * 节点1，如果是有向图则为源节点
	   * @type {module:echarts/data/Graph.Node}
	   */
	  this.node1 = n1;
	  /**
	   * 节点2，如果是有向图则为目标节点
	   * @type {module:echarts/data/Graph.Node}
	   */
	
	  this.node2 = n2;
	  this.dataIndex = dataIndex == null ? -1 : dataIndex;
	}
	/**
	 * @param {string} [path]
	 * @return {module:echarts/model/Model}
	 */
	
	
	Edge.prototype.getModel = function (path) {
	  if (this.dataIndex < 0) {
	    return;
	  }
	
	  var graph = this.hostGraph;
	  var itemModel = graph.edgeData.getItemModel(this.dataIndex);
	  return itemModel.getModel(path);
	};
	
	var createGraphDataProxyMixin = function (hostName, dataName) {
	  return {
	    /**
	     * @param {string=} [dimension='value'] Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
	     * @return {number}
	     */
	    getValue: function (dimension) {
	      var data = this[hostName][dataName];
	      return data.get(data.getDimension(dimension || 'value'), this.dataIndex);
	    },
	
	    /**
	     * @param {Object|string} key
	     * @param {*} [value]
	     */
	    setVisual: function (key, value) {
	      this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
	    },
	
	    /**
	     * @param {string} key
	     * @return {boolean}
	     */
	    getVisual: function (key, ignoreParent) {
	      return this[hostName][dataName].getItemVisual(this.dataIndex, key, ignoreParent);
	    },
	
	    /**
	     * @param {Object} layout
	     * @return {boolean} [merge=false]
	     */
	    setLayout: function (layout, merge) {
	      this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
	    },
	
	    /**
	     * @return {Object}
	     */
	    getLayout: function () {
	      return this[hostName][dataName].getItemLayout(this.dataIndex);
	    },
	
	    /**
	     * @return {module:zrender/Element}
	     */
	    getGraphicEl: function () {
	      return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
	    },
	
	    /**
	     * @return {number}
	     */
	    getRawIndex: function () {
	      return this[hostName][dataName].getRawIndex(this.dataIndex);
	    }
	  };
	};
	
	zrUtil.mixin(Node, createGraphDataProxyMixin('hostGraph', 'data'));
	zrUtil.mixin(Edge, createGraphDataProxyMixin('hostGraph', 'edgeData'));
	Graph.Node = Node;
	Graph.Edge = Edge;
	var _default = Graph;
	module.exports = _default;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var createListFromArray = __webpack_require__(34);
	
	var axisHelper = __webpack_require__(21);
	
	var axisModelCommonMixin = __webpack_require__(55);
	
	var Model = __webpack_require__(14);
	
	var _completeDimensions = __webpack_require__(25);
	
	exports.completeDimensions = _completeDimensions;
	
	var _symbol = __webpack_require__(22);
	
	exports.createSymbol = _symbol.createSymbol;
	
	/**
	 * Create a muti dimension List structure from seriesModel.
	 * @param  {module:echarts/model/Model} seriesModel
	 * @return {module:echarts/data/List} list
	 */
	function createList(seriesModel) {
	  var data = seriesModel.get('data');
	  return createListFromArray(data, seriesModel, seriesModel.ecModel);
	}
	/**
	 * @see {module:echarts/data/helper/completeDimensions}
	 */
	
	
	/**
	 * Create scale
	 * @param {Array.<number>} dataExtent
	 * @param {Object|module:echarts/Model} option
	 */
	function createScale(dataExtent, option) {
	  var axisModel = option;
	
	  if (!(option instanceof Model)) {
	    axisModel = new Model(option);
	    zrUtil.mixin(axisModel, axisModelCommonMixin);
	  }
	
	  var scale = axisHelper.createScaleByModel(axisModel);
	  scale.setExtent(dataExtent[0], dataExtent[1]);
	  axisHelper.niceScaleExtent(scale, axisModel);
	  return scale;
	}
	/**
	 * Mixin common methods to axis model,
	 *
	 * Inlcude methods
	 * `getFormattedLabels() => Array.<string>`
	 * `getCategories() => Array.<string>`
	 * `getMin(origin: boolean) => number`
	 * `getMax(origin: boolean) => number`
	 * `getNeedCrossZero() => boolean`
	 * `setRange(start: number, end: number)`
	 * `resetRange()`
	 */
	
	
	function mixinAxisModelCommonMethods(Model) {
	  zrUtil.mixin(Model, axisModelCommonMixin);
	}
	
	exports.createList = createList;
	exports.createScale = createScale;
	exports.mixinAxisModelCommonMethods = mixinAxisModelCommonMethods;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var _number = __webpack_require__(4);
	
	var parsePercent = _number.parsePercent;
	
	function getSeriesStackId(seriesModel) {
	  return seriesModel.get('stack') || '__ec_stack_' + seriesModel.seriesIndex;
	}
	
	function getAxisKey(axis) {
	  return axis.dim;
	}
	/**
	 * @param {string} seriesType
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	function barLayoutPolar(seriesType, ecModel, api) {
	  var width = api.getWidth();
	  var height = api.getHeight();
	  var lastStackCoords = {};
	  var lastStackCoordsOrigin = {};
	  var barWidthAndOffset = calRadialBar(zrUtil.filter(ecModel.getSeriesByType(seriesType), function (seriesModel) {
	    return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'polar';
	  }));
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    // Check series coordinate, do layout for polar only
	    if (seriesModel.coordinateSystem.type !== 'polar') {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var polar = seriesModel.coordinateSystem;
	    var angleAxis = polar.getAngleAxis();
	    var baseAxis = polar.getBaseAxis();
	    var stackId = getSeriesStackId(seriesModel);
	    var columnLayoutInfo = barWidthAndOffset[getAxisKey(baseAxis)][stackId];
	    var columnOffset = columnLayoutInfo.offset;
	    var columnWidth = columnLayoutInfo.width;
	    var valueAxis = polar.getOtherAxis(baseAxis);
	    var center = seriesModel.get('center') || ['50%', '50%'];
	    var cx = parsePercent(center[0], width);
	    var cy = parsePercent(center[1], height);
	    var barMinHeight = seriesModel.get('barMinHeight') || 0;
	    var barMinAngle = seriesModel.get('barMinAngle') || 0;
	    var valueAxisStart = valueAxis.getExtent()[0];
	    var valueMax = valueAxis.model.get('max');
	    var valueMin = valueAxis.model.get('min');
	    var coordDims = [seriesModel.coordDimToDataDim('radius')[0], seriesModel.coordDimToDataDim('angle')[0]];
	    var coords = data.mapArray(coordDims, function (radius, angle) {
	      return polar.dataToPoint([radius, angle]);
	    }, true);
	    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
	    lastStackCoordsOrigin[stackId] = lastStackCoordsOrigin[stackId] || []; // Fix #4243
	
	    data.each(seriesModel.coordDimToDataDim(valueAxis.dim)[0], function (value, idx) {
	      if (isNaN(value)) {
	        return;
	      }
	
	      if (!lastStackCoords[stackId][idx]) {
	        lastStackCoords[stackId][idx] = {
	          p: valueAxisStart,
	          // Positive stack
	          n: valueAxisStart // Negative stack
	
	        };
	        lastStackCoordsOrigin[stackId][idx] = {
	          p: valueAxisStart,
	          // Positive stack
	          n: valueAxisStart // Negative stack
	
	        };
	      }
	
	      var sign = value >= 0 ? 'p' : 'n';
	      var coord = polar.pointToCoord(coords[idx]);
	      var lastCoordOrigin = lastStackCoordsOrigin[stackId][idx][sign];
	      var r0;
	      var r;
	      var startAngle;
	      var endAngle;
	
	      if (valueAxis.dim === 'radius') {
	        // radial sector
	        r0 = lastCoordOrigin;
	        r = coord[0];
	        startAngle = (-coord[1] + columnOffset) * Math.PI / 180;
	        endAngle = startAngle + columnWidth * Math.PI / 180;
	
	        if (Math.abs(r) < barMinHeight) {
	          r = r0 + (r < 0 ? -1 : 1) * barMinHeight;
	        }
	
	        lastStackCoordsOrigin[stackId][idx][sign] = r;
	      } else {
	        // tangential sector
	        r0 = coord[0] + columnOffset;
	        r = r0 + columnWidth; // clamp data if min or max is defined for valueAxis
	
	        if (valueMax != null) {
	          value = Math.min(value, valueMax);
	        }
	
	        if (valueMin != null) {
	          value = Math.max(value, valueMin);
	        }
	
	        var angle = angleAxis.dataToAngle(value);
	
	        if (Math.abs(angle - lastCoordOrigin) < barMinAngle) {
	          angle = lastCoordOrigin - (value < 0 ? -1 : 1) * barMinAngle;
	        }
	
	        startAngle = -lastCoordOrigin * Math.PI / 180;
	        endAngle = -angle * Math.PI / 180; // if the previous stack is at the end of the ring,
	        // add a round to differentiate it from origin
	
	        var extent = angleAxis.getExtent();
	        var stackCoord = angle;
	
	        if (stackCoord === extent[0] && value > 0) {
	          stackCoord = extent[1];
	        } else if (stackCoord === extent[1] && value < 0) {
	          stackCoord = extent[0];
	        }
	
	        lastStackCoordsOrigin[stackId][idx][sign] = stackCoord;
	      }
	
	      data.setItemLayout(idx, {
	        cx: cx,
	        cy: cy,
	        r0: r0,
	        r: r,
	        startAngle: startAngle,
	        endAngle: endAngle
	      });
	    }, true);
	  }, this);
	}
	/**
	 * Calculate bar width and offset for radial bar charts
	 */
	
	
	function calRadialBar(barSeries, api) {
	  // Columns info on each category axis. Key is polar name
	  var columnsMap = {};
	  zrUtil.each(barSeries, function (seriesModel, idx) {
	    var data = seriesModel.getData();
	    var polar = seriesModel.coordinateSystem;
	    var baseAxis = polar.getBaseAxis();
	    var axisExtent = baseAxis.getExtent();
	    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
	    var columnsOnAxis = columnsMap[getAxisKey(baseAxis)] || {
	      bandWidth: bandWidth,
	      remainedWidth: bandWidth,
	      autoWidthCount: 0,
	      categoryGap: '20%',
	      gap: '30%',
	      stacks: {}
	    };
	    var stacks = columnsOnAxis.stacks;
	    columnsMap[getAxisKey(baseAxis)] = columnsOnAxis;
	    var stackId = getSeriesStackId(seriesModel);
	
	    if (!stacks[stackId]) {
	      columnsOnAxis.autoWidthCount++;
	    }
	
	    stacks[stackId] = stacks[stackId] || {
	      width: 0,
	      maxWidth: 0
	    };
	    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
	    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
	    var barGap = seriesModel.get('barGap');
	    var barCategoryGap = seriesModel.get('barCategoryGap');
	
	    if (barWidth && !stacks[stackId].width) {
	      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
	      stacks[stackId].width = barWidth;
	      columnsOnAxis.remainedWidth -= barWidth;
	    }
	
	    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
	    barGap != null && (columnsOnAxis.gap = barGap);
	    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
	  });
	  var result = {};
	  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
	    result[coordSysName] = {};
	    var stacks = columnsOnAxis.stacks;
	    var bandWidth = columnsOnAxis.bandWidth;
	    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
	    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
	    var remainedWidth = columnsOnAxis.remainedWidth;
	    var autoWidthCount = columnsOnAxis.autoWidthCount;
	    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
	
	    zrUtil.each(stacks, function (column, stack) {
	      var maxWidth = column.maxWidth;
	
	      if (maxWidth && maxWidth < autoWidth) {
	        maxWidth = Math.min(maxWidth, remainedWidth);
	
	        if (column.width) {
	          maxWidth = Math.min(maxWidth, column.width);
	        }
	
	        remainedWidth -= maxWidth;
	        column.width = maxWidth;
	        autoWidthCount--;
	      }
	    }); // Recalculate width again
	
	    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0);
	    var widthSum = 0;
	    var lastColumn;
	    zrUtil.each(stacks, function (column, idx) {
	      if (!column.width) {
	        column.width = autoWidth;
	      }
	
	      lastColumn = column;
	      widthSum += column.width * (1 + barGapPercent);
	    });
	
	    if (lastColumn) {
	      widthSum -= lastColumn.width * barGapPercent;
	    }
	
	    var offset = -widthSum / 2;
	    zrUtil.each(stacks, function (column, stackId) {
	      result[coordSysName][stackId] = result[coordSysName][stackId] || {
	        offset: offset,
	        width: column.width
	      };
	      offset += column.width * (1 + barGapPercent);
	    });
	  });
	  return result;
	}
	
	var _default = barLayoutPolar;
	module.exports = _default;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var graphic = __webpack_require__(3);
	
	var PI = Math.PI;
	/**
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Object} [opts]
	 * @param {string} [opts.text]
	 * @param {string} [opts.color]
	 * @param {string} [opts.textColor]
	 * @return {module:zrender/Element}
	 */
	
	function _default(api, opts) {
	  opts = opts || {};
	  zrUtil.defaults(opts, {
	    text: 'loading',
	    color: '#c23531',
	    textColor: '#000',
	    maskColor: 'rgba(255, 255, 255, 0.8)',
	    zlevel: 0
	  });
	  var mask = new graphic.Rect({
	    style: {
	      fill: opts.maskColor
	    },
	    zlevel: opts.zlevel,
	    z: 10000
	  });
	  var arc = new graphic.Arc({
	    shape: {
	      startAngle: -PI / 2,
	      endAngle: -PI / 2 + 0.1,
	      r: 10
	    },
	    style: {
	      stroke: opts.color,
	      lineCap: 'round',
	      lineWidth: 5
	    },
	    zlevel: opts.zlevel,
	    z: 10001
	  });
	  var labelRect = new graphic.Rect({
	    style: {
	      fill: 'none',
	      text: opts.text,
	      textPosition: 'right',
	      textDistance: 10,
	      textFill: opts.textColor
	    },
	    zlevel: opts.zlevel,
	    z: 10001
	  });
	  arc.animateShape(true).when(1000, {
	    endAngle: PI * 3 / 2
	  }).start('circularInOut');
	  arc.animateShape(true).when(1000, {
	    startAngle: PI * 3 / 2
	  }).delay(300).start('circularInOut');
	  var group = new graphic.Group();
	  group.add(arc);
	  group.add(labelRect);
	  group.add(mask); // Inject resize
	
	  group.resize = function () {
	    var cx = api.getWidth() / 2;
	    var cy = api.getHeight() / 2;
	    arc.setShape({
	      cx: cx,
	      cy: cy
	    });
	    var r = arc.shape.r;
	    labelRect.setShape({
	      x: cx - r,
	      y: cy - r,
	      width: r * 2,
	      height: r * 2
	    });
	    mask.setShape({
	      x: 0,
	      y: 0,
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	  };
	
	  group.resize();
	  return group;
	}
	
	module.exports = _default;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(5);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(1);
	
	var modelUtil = __webpack_require__(6);
	
	var Model = __webpack_require__(14);
	
	var ComponentModel = __webpack_require__(16);
	
	var globalDefault = __webpack_require__(584);
	
	var colorPaletteMinin = __webpack_require__(202);
	
	/**
	 * ECharts global model
	 *
	 * @module {echarts/model/Global}
	 */
	
	/**
	 * Caution: If the mechanism should be changed some day, these cases
	 * should be considered:
	 *
	 * (1) In `merge option` mode, if using the same option to call `setOption`
	 * many times, the result should be the same (try our best to ensure that).
	 * (2) In `merge option` mode, if a component has no id/name specified, it
	 * will be merged by index, and the result sequence of the components is
	 * consistent to the original sequence.
	 * (3) `reset` feature (in toolbox). Find detailed info in comments about
	 * `mergeOption` in module:echarts/model/OptionManager.
	 */
	var each = zrUtil.each;
	var filter = zrUtil.filter;
	var map = zrUtil.map;
	var isArray = zrUtil.isArray;
	var indexOf = zrUtil.indexOf;
	var isObject = zrUtil.isObject;
	var OPTION_INNER_KEY = '\0_ec_inner';
	/**
	 * @alias module:echarts/model/Global
	 *
	 * @param {Object} option
	 * @param {module:echarts/model/Model} parentModel
	 * @param {Object} theme
	 */
	
	var GlobalModel = Model.extend({
	  constructor: GlobalModel,
	  init: function (option, parentModel, theme, optionManager) {
	    theme = theme || {};
	    this.option = null; // Mark as not initialized.
	
	    /**
	     * @type {module:echarts/model/Model}
	     * @private
	     */
	
	    this._theme = new Model(theme);
	    /**
	     * @type {module:echarts/model/OptionManager}
	     */
	
	    this._optionManager = optionManager;
	  },
	  setOption: function (option, optionPreprocessorFuncs) {
	    zrUtil.assert(!(OPTION_INNER_KEY in option), 'please use chart.getOption()');
	
	    this._optionManager.setOption(option, optionPreprocessorFuncs);
	
	    this.resetOption(null);
	  },
	
	  /**
	   * @param {string} type null/undefined: reset all.
	   *                      'recreate': force recreate all.
	   *                      'timeline': only reset timeline option
	   *                      'media': only reset media query option
	   * @return {boolean} Whether option changed.
	   */
	  resetOption: function (type) {
	    var optionChanged = false;
	    var optionManager = this._optionManager;
	
	    if (!type || type === 'recreate') {
	      var baseOption = optionManager.mountOption(type === 'recreate');
	
	      if (!this.option || type === 'recreate') {
	        initBase.call(this, baseOption);
	      } else {
	        this.restoreData();
	        this.mergeOption(baseOption);
	      }
	
	      optionChanged = true;
	    }
	
	    if (type === 'timeline' || type === 'media') {
	      this.restoreData();
	    }
	
	    if (!type || type === 'recreate' || type === 'timeline') {
	      var timelineOption = optionManager.getTimelineOption(this);
	      timelineOption && (this.mergeOption(timelineOption), optionChanged = true);
	    }
	
	    if (!type || type === 'recreate' || type === 'media') {
	      var mediaOptions = optionManager.getMediaOption(this, this._api);
	
	      if (mediaOptions.length) {
	        each(mediaOptions, function (mediaOption) {
	          this.mergeOption(mediaOption, optionChanged = true);
	        }, this);
	      }
	    }
	
	    return optionChanged;
	  },
	
	  /**
	   * @protected
	   */
	  mergeOption: function (newOption) {
	    var option = this.option;
	    var componentsMap = this._componentsMap;
	    var newCptTypes = []; // 如果不存在对应的 component model 则直接 merge
	
	    each(newOption, function (componentOption, mainType) {
	      if (componentOption == null) {
	        return;
	      }
	
	      if (!ComponentModel.hasClass(mainType)) {
	        option[mainType] = option[mainType] == null ? zrUtil.clone(componentOption) : zrUtil.merge(option[mainType], componentOption, true);
	      } else {
	        newCptTypes.push(mainType);
	      }
	    }); // FIXME OPTION 同步是否要改回原来的
	
	    ComponentModel.topologicalTravel(newCptTypes, ComponentModel.getAllClassMainTypes(), visitComponent, this);
	    this._seriesIndices = this._seriesIndices || [];
	
	    function visitComponent(mainType, dependencies) {
	      var newCptOptionList = modelUtil.normalizeToArray(newOption[mainType]);
	      var mapResult = modelUtil.mappingToExists(componentsMap.get(mainType), newCptOptionList);
	      modelUtil.makeIdAndName(mapResult); // Set mainType and complete subType.
	
	      each(mapResult, function (item, index) {
	        var opt = item.option;
	
	        if (isObject(opt)) {
	          item.keyInfo.mainType = mainType;
	          item.keyInfo.subType = determineSubType(mainType, opt, item.exist);
	        }
	      });
	      var dependentModels = getComponentsByTypes(componentsMap, dependencies);
	      option[mainType] = [];
	      componentsMap.set(mainType, []);
	      each(mapResult, function (resultItem, index) {
	        var componentModel = resultItem.exist;
	        var newCptOption = resultItem.option;
	        zrUtil.assert(isObject(newCptOption) || componentModel, 'Empty component definition'); // Consider where is no new option and should be merged using {},
	        // see removeEdgeAndAdd in topologicalTravel and
	        // ComponentModel.getAllClassMainTypes.
	
	        if (!newCptOption) {
	          componentModel.mergeOption({}, this);
	          componentModel.optionUpdated({}, false);
	        } else {
	          var ComponentModelClass = ComponentModel.getClass(mainType, resultItem.keyInfo.subType, true);
	
	          if (componentModel && componentModel instanceof ComponentModelClass) {
	            componentModel.name = resultItem.keyInfo.name;
	            componentModel.mergeOption(newCptOption, this);
	            componentModel.optionUpdated(newCptOption, false);
	          } else {
	            // PENDING Global as parent ?
	            var extraOpt = zrUtil.extend({
	              dependentModels: dependentModels,
	              componentIndex: index
	            }, resultItem.keyInfo);
	            componentModel = new ComponentModelClass(newCptOption, this, this, extraOpt);
	            zrUtil.extend(componentModel, extraOpt);
	            componentModel.init(newCptOption, this, this, extraOpt); // Call optionUpdated after init.
	            // newCptOption has been used as componentModel.option
	            // and may be merged with theme and default, so pass null
	            // to avoid confusion.
	
	            componentModel.optionUpdated(null, true);
	          }
	        }
	
	        componentsMap.get(mainType)[index] = componentModel;
	        option[mainType][index] = componentModel.option;
	      }, this); // Backup series for filtering.
	
	      if (mainType === 'series') {
	        this._seriesIndices = createSeriesIndices(componentsMap.get('series'));
	      }
	    }
	  },
	
	  /**
	   * Get option for output (cloned option and inner info removed)
	   * @public
	   * @return {Object}
	   */
	  getOption: function () {
	    var option = zrUtil.clone(this.option);
	    each(option, function (opts, mainType) {
	      if (ComponentModel.hasClass(mainType)) {
	        var opts = modelUtil.normalizeToArray(opts);
	
	        for (var i = opts.length - 1; i >= 0; i--) {
	          // Remove options with inner id.
	          if (modelUtil.isIdInner(opts[i])) {
	            opts.splice(i, 1);
	          }
	        }
	
	        option[mainType] = opts;
	      }
	    });
	    delete option[OPTION_INNER_KEY];
	    return option;
	  },
	
	  /**
	   * @return {module:echarts/model/Model}
	   */
	  getTheme: function () {
	    return this._theme;
	  },
	
	  /**
	   * @param {string} mainType
	   * @param {number} [idx=0]
	   * @return {module:echarts/model/Component}
	   */
	  getComponent: function (mainType, idx) {
	    var list = this._componentsMap.get(mainType);
	
	    if (list) {
	      return list[idx || 0];
	    }
	  },
	
	  /**
	   * If none of index and id and name used, return all components with mainType.
	   * @param {Object} condition
	   * @param {string} condition.mainType
	   * @param {string} [condition.subType] If ignore, only query by mainType
	   * @param {number|Array.<number>} [condition.index] Either input index or id or name.
	   * @param {string|Array.<string>} [condition.id] Either input index or id or name.
	   * @param {string|Array.<string>} [condition.name] Either input index or id or name.
	   * @return {Array.<module:echarts/model/Component>}
	   */
	  queryComponents: function (condition) {
	    var mainType = condition.mainType;
	
	    if (!mainType) {
	      return [];
	    }
	
	    var index = condition.index;
	    var id = condition.id;
	    var name = condition.name;
	
	    var cpts = this._componentsMap.get(mainType);
	
	    if (!cpts || !cpts.length) {
	      return [];
	    }
	
	    var result;
	
	    if (index != null) {
	      if (!isArray(index)) {
	        index = [index];
	      }
	
	      result = filter(map(index, function (idx) {
	        return cpts[idx];
	      }), function (val) {
	        return !!val;
	      });
	    } else if (id != null) {
	      var isIdArray = isArray(id);
	      result = filter(cpts, function (cpt) {
	        return isIdArray && indexOf(id, cpt.id) >= 0 || !isIdArray && cpt.id === id;
	      });
	    } else if (name != null) {
	      var isNameArray = isArray(name);
	      result = filter(cpts, function (cpt) {
	        return isNameArray && indexOf(name, cpt.name) >= 0 || !isNameArray && cpt.name === name;
	      });
	    } else {
	      // Return all components with mainType
	      result = cpts.slice();
	    }
	
	    return filterBySubType(result, condition);
	  },
	
	  /**
	   * The interface is different from queryComponents,
	   * which is convenient for inner usage.
	   *
	   * @usage
	   * var result = findComponents(
	   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
	   * );
	   * var result = findComponents(
	   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
	   * );
	   * var result = findComponents(
	   *     {mainType: 'series'},
	   *     function (model, index) {...}
	   * );
	   * // result like [component0, componnet1, ...]
	   *
	   * @param {Object} condition
	   * @param {string} condition.mainType Mandatory.
	   * @param {string} [condition.subType] Optional.
	   * @param {Object} [condition.query] like {xxxIndex, xxxId, xxxName},
	   *        where xxx is mainType.
	   *        If query attribute is null/undefined or has no index/id/name,
	   *        do not filtering by query conditions, which is convenient for
	   *        no-payload situations or when target of action is global.
	   * @param {Function} [condition.filter] parameter: component, return boolean.
	   * @return {Array.<module:echarts/model/Component>}
	   */
	  findComponents: function (condition) {
	    var query = condition.query;
	    var mainType = condition.mainType;
	    var queryCond = getQueryCond(query);
	    var result = queryCond ? this.queryComponents(queryCond) : this._componentsMap.get(mainType);
	    return doFilter(filterBySubType(result, condition));
	
	    function getQueryCond(q) {
	      var indexAttr = mainType + 'Index';
	      var idAttr = mainType + 'Id';
	      var nameAttr = mainType + 'Name';
	      return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
	        mainType: mainType,
	        // subType will be filtered finally.
	        index: q[indexAttr],
	        id: q[idAttr],
	        name: q[nameAttr]
	      } : null;
	    }
	
	    function doFilter(res) {
	      return condition.filter ? filter(res, condition.filter) : res;
	    }
	  },
	
	  /**
	   * @usage
	   * eachComponent('legend', function (legendModel, index) {
	   *     ...
	   * });
	   * eachComponent(function (componentType, model, index) {
	   *     // componentType does not include subType
	   *     // (componentType is 'xxx' but not 'xxx.aa')
	   * });
	   * eachComponent(
	   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}},
	   *     function (model, index) {...}
	   * );
	   * eachComponent(
	   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}},
	   *     function (model, index) {...}
	   * );
	   *
	   * @param {string|Object=} mainType When mainType is object, the definition
	   *                                  is the same as the method 'findComponents'.
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachComponent: function (mainType, cb, context) {
	    var componentsMap = this._componentsMap;
	
	    if (typeof mainType === 'function') {
	      context = cb;
	      cb = mainType;
	      componentsMap.each(function (components, componentType) {
	        each(components, function (component, index) {
	          cb.call(context, componentType, component, index);
	        });
	      });
	    } else if (zrUtil.isString(mainType)) {
	      each(componentsMap.get(mainType), cb, context);
	    } else if (isObject(mainType)) {
	      var queryResult = this.findComponents(mainType);
	      each(queryResult, cb, context);
	    }
	  },
	
	  /**
	   * @param {string} name
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeriesByName: function (name) {
	    var series = this._componentsMap.get('series');
	
	    return filter(series, function (oneSeries) {
	      return oneSeries.name === name;
	    });
	  },
	
	  /**
	   * @param {number} seriesIndex
	   * @return {module:echarts/model/Series}
	   */
	  getSeriesByIndex: function (seriesIndex) {
	    return this._componentsMap.get('series')[seriesIndex];
	  },
	
	  /**
	   * @param {string} subType
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeriesByType: function (subType) {
	    var series = this._componentsMap.get('series');
	
	    return filter(series, function (oneSeries) {
	      return oneSeries.subType === subType;
	    });
	  },
	
	  /**
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeries: function () {
	    return this._componentsMap.get('series').slice();
	  },
	
	  /**
	   * After filtering, series may be different
	   * frome raw series.
	   *
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachSeries: function (cb, context) {
	    assertSeriesInitialized(this);
	    each(this._seriesIndices, function (rawSeriesIndex) {
	      var series = this._componentsMap.get('series')[rawSeriesIndex];
	
	      cb.call(context, series, rawSeriesIndex);
	    }, this);
	  },
	
	  /**
	   * Iterate raw series before filtered.
	   *
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachRawSeries: function (cb, context) {
	    each(this._componentsMap.get('series'), cb, context);
	  },
	
	  /**
	   * After filtering, series may be different.
	   * frome raw series.
	   *
	   * @parma {string} subType
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachSeriesByType: function (subType, cb, context) {
	    assertSeriesInitialized(this);
	    each(this._seriesIndices, function (rawSeriesIndex) {
	      var series = this._componentsMap.get('series')[rawSeriesIndex];
	
	      if (series.subType === subType) {
	        cb.call(context, series, rawSeriesIndex);
	      }
	    }, this);
	  },
	
	  /**
	   * Iterate raw series before filtered of given type.
	   *
	   * @parma {string} subType
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachRawSeriesByType: function (subType, cb, context) {
	    return each(this.getSeriesByType(subType), cb, context);
	  },
	
	  /**
	   * @param {module:echarts/model/Series} seriesModel
	   */
	  isSeriesFiltered: function (seriesModel) {
	    assertSeriesInitialized(this);
	    return zrUtil.indexOf(this._seriesIndices, seriesModel.componentIndex) < 0;
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getCurrentSeriesIndices: function () {
	    return (this._seriesIndices || []).slice();
	  },
	
	  /**
	   * @param {Function} cb
	   * @param {*} context
	   */
	  filterSeries: function (cb, context) {
	    assertSeriesInitialized(this);
	    var filteredSeries = filter(this._componentsMap.get('series'), cb, context);
	    this._seriesIndices = createSeriesIndices(filteredSeries);
	  },
	  restoreData: function () {
	    var componentsMap = this._componentsMap;
	    this._seriesIndices = createSeriesIndices(componentsMap.get('series'));
	    var componentTypes = [];
	    componentsMap.each(function (components, componentType) {
	      componentTypes.push(componentType);
	    });
	    ComponentModel.topologicalTravel(componentTypes, ComponentModel.getAllClassMainTypes(), function (componentType, dependencies) {
	      each(componentsMap.get(componentType), function (component) {
	        component.restoreData();
	      });
	    });
	  }
	});
	/**
	 * @inner
	 */
	
	function mergeTheme(option, theme) {
	  zrUtil.each(theme, function (themeItem, name) {
	    // 如果有 component model 则把具体的 merge 逻辑交给该 model 处理
	    if (!ComponentModel.hasClass(name)) {
	      if (typeof themeItem === 'object') {
	        option[name] = !option[name] ? zrUtil.clone(themeItem) : zrUtil.merge(option[name], themeItem, false);
	      } else {
	        if (option[name] == null) {
	          option[name] = themeItem;
	        }
	      }
	    }
	  });
	}
	
	function initBase(baseOption) {
	  baseOption = baseOption; // Using OPTION_INNER_KEY to mark that this option can not be used outside,
	  // i.e. `chart.setOption(chart.getModel().option);` is forbiden.
	
	  this.option = {};
	  this.option[OPTION_INNER_KEY] = 1;
	  /**
	   * Init with series: [], in case of calling findSeries method
	   * before series initialized.
	   * @type {Object.<string, Array.<module:echarts/model/Model>>}
	   * @private
	   */
	
	  this._componentsMap = zrUtil.createHashMap({
	    series: []
	  });
	  /**
	   * Mapping between filtered series list and raw series list.
	   * key: filtered series indices, value: raw series indices.
	   * @type {Array.<nubmer>}
	   * @private
	   */
	
	  this._seriesIndices = null;
	  mergeTheme(baseOption, this._theme.option); // TODO Needs clone when merging to the unexisted property
	
	  zrUtil.merge(baseOption, globalDefault, false);
	  this.mergeOption(baseOption);
	}
	/**
	 * @inner
	 * @param {Array.<string>|string} types model types
	 * @return {Object} key: {string} type, value: {Array.<Object>} models
	 */
	
	
	function getComponentsByTypes(componentsMap, types) {
	  if (!zrUtil.isArray(types)) {
	    types = types ? [types] : [];
	  }
	
	  var ret = {};
	  each(types, function (type) {
	    ret[type] = (componentsMap.get(type) || []).slice();
	  });
	  return ret;
	}
	/**
	 * @inner
	 */
	
	
	function determineSubType(mainType, newCptOption, existComponent) {
	  var subType = newCptOption.type ? newCptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
	  : ComponentModel.determineSubType(mainType, newCptOption); // tooltip, markline, markpoint may always has no subType
	
	  return subType;
	}
	/**
	 * @inner
	 */
	
	
	function createSeriesIndices(seriesModels) {
	  return map(seriesModels, function (series) {
	    return series.componentIndex;
	  }) || [];
	}
	/**
	 * @inner
	 */
	
	
	function filterBySubType(components, condition) {
	  // Using hasOwnProperty for restrict. Consider
	  // subType is undefined in user payload.
	  return condition.hasOwnProperty('subType') ? filter(components, function (cpt) {
	    return cpt.subType === condition.subType;
	  }) : components;
	}
	/**
	 * @inner
	 */
	
	
	function assertSeriesInitialized(ecModel) {}
	
	zrUtil.mixin(GlobalModel, colorPaletteMinin);
	var _default = GlobalModel;
	module.exports = _default;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var modelUtil = __webpack_require__(6);
	
	var ComponentModel = __webpack_require__(16);
	
	/**
	 * ECharts option manager
	 *
	 * @module {echarts/model/OptionManager}
	 */
	var each = zrUtil.each;
	var clone = zrUtil.clone;
	var map = zrUtil.map;
	var merge = zrUtil.merge;
	var QUERY_REG = /^(min|max)?(.+)$/;
	/**
	 * TERM EXPLANATIONS:
	 *
	 * [option]:
	 *
	 *     An object that contains definitions of components. For example:
	 *     var option = {
	 *         title: {...},
	 *         legend: {...},
	 *         visualMap: {...},
	 *         series: [
	 *             {data: [...]},
	 *             {data: [...]},
	 *             ...
	 *         ]
	 *     };
	 *
	 * [rawOption]:
	 *
	 *     An object input to echarts.setOption. 'rawOption' may be an
	 *     'option', or may be an object contains multi-options. For example:
	 *     var option = {
	 *         baseOption: {
	 *             title: {...},
	 *             legend: {...},
	 *             series: [
	 *                 {data: [...]},
	 *                 {data: [...]},
	 *                 ...
	 *             ]
	 *         },
	 *         timeline: {...},
	 *         options: [
	 *             {title: {...}, series: {data: [...]}},
	 *             {title: {...}, series: {data: [...]}},
	 *             ...
	 *         ],
	 *         media: [
	 *             {
	 *                 query: {maxWidth: 320},
	 *                 option: {series: {x: 20}, visualMap: {show: false}}
	 *             },
	 *             {
	 *                 query: {minWidth: 320, maxWidth: 720},
	 *                 option: {series: {x: 500}, visualMap: {show: true}}
	 *             },
	 *             {
	 *                 option: {series: {x: 1200}, visualMap: {show: true}}
	 *             }
	 *         ]
	 *     };
	 *
	 * @alias module:echarts/model/OptionManager
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	function OptionManager(api) {
	  /**
	   * @private
	   * @type {module:echarts/ExtensionAPI}
	   */
	  this._api = api;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._timelineOptions = [];
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	
	  this._mediaList = [];
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._mediaDefault;
	  /**
	   * -1, means default.
	   * empty means no media.
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._currentMediaIndices = [];
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._optionBackup;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._newBaseOption;
	} // timeline.notMerge is not supported in ec3. Firstly there is rearly
	// case that notMerge is needed. Secondly supporting 'notMerge' requires
	// rawOption cloned and backuped when timeline changed, which does no
	// good to performance. What's more, that both timeline and setOption
	// method supply 'notMerge' brings complex and some problems.
	// Consider this case:
	// (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
	// (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
	
	
	OptionManager.prototype = {
	  constructor: OptionManager,
	
	  /**
	   * @public
	   * @param {Object} rawOption Raw option.
	   * @param {module:echarts/model/Global} ecModel
	   * @param {Array.<Function>} optionPreprocessorFuncs
	   * @return {Object} Init option
	   */
	  setOption: function (rawOption, optionPreprocessorFuncs) {
	    rawOption = clone(rawOption, true); // FIXME
	    // 如果 timeline options 或者 media 中设置了某个属性，而baseOption中没有设置，则进行警告。
	
	    var oldOptionBackup = this._optionBackup;
	    var newParsedOption = parseRawOption.call(this, rawOption, optionPreprocessorFuncs, !oldOptionBackup);
	    this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);
	
	    if (oldOptionBackup) {
	      // Only baseOption can be merged.
	      mergeOption(oldOptionBackup.baseOption, newParsedOption.baseOption); // For simplicity, timeline options and media options do not support merge,
	      // that is, if you `setOption` twice and both has timeline options, the latter
	      // timeline opitons will not be merged to the formers, but just substitude them.
	
	      if (newParsedOption.timelineOptions.length) {
	        oldOptionBackup.timelineOptions = newParsedOption.timelineOptions;
	      }
	
	      if (newParsedOption.mediaList.length) {
	        oldOptionBackup.mediaList = newParsedOption.mediaList;
	      }
	
	      if (newParsedOption.mediaDefault) {
	        oldOptionBackup.mediaDefault = newParsedOption.mediaDefault;
	      }
	    } else {
	      this._optionBackup = newParsedOption;
	    }
	  },
	
	  /**
	   * @param {boolean} isRecreate
	   * @return {Object}
	   */
	  mountOption: function (isRecreate) {
	    var optionBackup = this._optionBackup; // TODO
	    // 如果没有reset功能则不clone。
	
	    this._timelineOptions = map(optionBackup.timelineOptions, clone);
	    this._mediaList = map(optionBackup.mediaList, clone);
	    this._mediaDefault = clone(optionBackup.mediaDefault);
	    this._currentMediaIndices = [];
	    return clone(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
	    // called, and is merged into every new option by inner method `mergeOption`
	    // each time `setOption` called, can be only used in `isRecreate`, because
	    // its reliability is under suspicion. In other cases option merge is
	    // performed by `model.mergeOption`.
	    ? optionBackup.baseOption : this._newBaseOption);
	  },
	
	  /**
	   * @param {module:echarts/model/Global} ecModel
	   * @return {Object}
	   */
	  getTimelineOption: function (ecModel) {
	    var option;
	    var timelineOptions = this._timelineOptions;
	
	    if (timelineOptions.length) {
	      // getTimelineOption can only be called after ecModel inited,
	      // so we can get currentIndex from timelineModel.
	      var timelineModel = ecModel.getComponent('timeline');
	
	      if (timelineModel) {
	        option = clone(timelineOptions[timelineModel.getCurrentIndex()], true);
	      }
	    }
	
	    return option;
	  },
	
	  /**
	   * @param {module:echarts/model/Global} ecModel
	   * @return {Array.<Object>}
	   */
	  getMediaOption: function (ecModel) {
	    var ecWidth = this._api.getWidth();
	
	    var ecHeight = this._api.getHeight();
	
	    var mediaList = this._mediaList;
	    var mediaDefault = this._mediaDefault;
	    var indices = [];
	    var result = []; // No media defined.
	
	    if (!mediaList.length && !mediaDefault) {
	      return result;
	    } // Multi media may be applied, the latter defined media has higher priority.
	
	
	    for (var i = 0, len = mediaList.length; i < len; i++) {
	      if (applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) {
	        indices.push(i);
	      }
	    } // FIXME
	    // 是否mediaDefault应该强制用户设置，否则可能修改不能回归。
	
	
	    if (!indices.length && mediaDefault) {
	      indices = [-1];
	    }
	
	    if (indices.length && !indicesEquals(indices, this._currentMediaIndices)) {
	      result = map(indices, function (index) {
	        return clone(index === -1 ? mediaDefault.option : mediaList[index].option);
	      });
	    } // Otherwise return nothing.
	
	
	    this._currentMediaIndices = indices;
	    return result;
	  }
	};
	
	function parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
	  var timelineOptions = [];
	  var mediaList = [];
	  var mediaDefault;
	  var baseOption; // Compatible with ec2.
	
	  var timelineOpt = rawOption.timeline;
	
	  if (rawOption.baseOption) {
	    baseOption = rawOption.baseOption;
	  } // For timeline
	
	
	  if (timelineOpt || rawOption.options) {
	    baseOption = baseOption || {};
	    timelineOptions = (rawOption.options || []).slice();
	  } // For media query
	
	
	  if (rawOption.media) {
	    baseOption = baseOption || {};
	    var media = rawOption.media;
	    each(media, function (singleMedia) {
	      if (singleMedia && singleMedia.option) {
	        if (singleMedia.query) {
	          mediaList.push(singleMedia);
	        } else if (!mediaDefault) {
	          // Use the first media default.
	          mediaDefault = singleMedia;
	        }
	      }
	    });
	  } // For normal option
	
	
	  if (!baseOption) {
	    baseOption = rawOption;
	  } // Set timelineOpt to baseOption in ec3,
	  // which is convenient for merge option.
	
	
	  if (!baseOption.timeline) {
	    baseOption.timeline = timelineOpt;
	  } // Preprocess.
	
	
	  each([baseOption].concat(timelineOptions).concat(zrUtil.map(mediaList, function (media) {
	    return media.option;
	  })), function (option) {
	    each(optionPreprocessorFuncs, function (preProcess) {
	      preProcess(option, isNew);
	    });
	  });
	  return {
	    baseOption: baseOption,
	    timelineOptions: timelineOptions,
	    mediaDefault: mediaDefault,
	    mediaList: mediaList
	  };
	}
	/**
	 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
	 * Support: width, height, aspectRatio
	 * Can use max or min as prefix.
	 */
	
	
	function applyMediaQuery(query, ecWidth, ecHeight) {
	  var realMap = {
	    width: ecWidth,
	    height: ecHeight,
	    aspectratio: ecWidth / ecHeight // lowser case for convenientce.
	
	  };
	  var applicatable = true;
	  zrUtil.each(query, function (value, attr) {
	    var matched = attr.match(QUERY_REG);
	
	    if (!matched || !matched[1] || !matched[2]) {
	      return;
	    }
	
	    var operator = matched[1];
	    var realAttr = matched[2].toLowerCase();
	
	    if (!compare(realMap[realAttr], value, operator)) {
	      applicatable = false;
	    }
	  });
	  return applicatable;
	}
	
	function compare(real, expect, operator) {
	  if (operator === 'min') {
	    return real >= expect;
	  } else if (operator === 'max') {
	    return real <= expect;
	  } else {
	    // Equals
	    return real === expect;
	  }
	}
	
	function indicesEquals(indices1, indices2) {
	  // indices is always order by asc and has only finite number.
	  return indices1.join(',') === indices2.join(',');
	}
	/**
	 * Consider case:
	 * `chart.setOption(opt1);`
	 * Then user do some interaction like dataZoom, dataView changing.
	 * `chart.setOption(opt2);`
	 * Then user press 'reset button' in toolbox.
	 *
	 * After doing that all of the interaction effects should be reset, the
	 * chart should be the same as the result of invoke
	 * `chart.setOption(opt1); chart.setOption(opt2);`.
	 *
	 * Although it is not able ensure that
	 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
	 * `chart.setOption(merge(opt1, opt2));` exactly,
	 * this might be the only simple way to implement that feature.
	 *
	 * MEMO: We've considered some other approaches:
	 * 1. Each model handle its self restoration but not uniform treatment.
	 *     (Too complex in logic and error-prone)
	 * 2. Use a shadow ecModel. (Performace expensive)
	 */
	
	
	function mergeOption(oldOption, newOption) {
	  newOption = newOption || {};
	  each(newOption, function (newCptOpt, mainType) {
	    if (newCptOpt == null) {
	      return;
	    }
	
	    var oldCptOpt = oldOption[mainType];
	
	    if (!ComponentModel.hasClass(mainType)) {
	      oldOption[mainType] = merge(oldCptOpt, newCptOpt, true);
	    } else {
	      newCptOpt = modelUtil.normalizeToArray(newCptOpt);
	      oldCptOpt = modelUtil.normalizeToArray(oldCptOpt);
	      var mapResult = modelUtil.mappingToExists(oldCptOpt, newCptOpt);
	      oldOption[mainType] = map(mapResult, function (item) {
	        return item.option && item.exist ? merge(item.exist, item.option, true) : item.exist || item.option;
	      });
	    }
	  });
	}
	
	var _default = OptionManager;
	module.exports = _default;

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	var platform = ''; // Navigator not exists in node
	
	if (typeof navigator !== 'undefined') {
	  platform = navigator.platform || '';
	}
	
	var _default = {
	  // 全图默认背景
	  // backgroundColor: 'rgba(0,0,0,0)',
	  // https://dribbble.com/shots/1065960-Infographic-Pie-chart-visualization
	  // color: ['#5793f3', '#d14a61', '#fd9c35', '#675bba', '#fec42c', '#dd4444', '#d4df5a', '#cd4870'],
	  // 浅色
	  // color: ['#bcd3bb', '#e88f70', '#edc1a5', '#9dc5c8', '#e1e8c8', '#7b7c68', '#e5b5b5', '#f0b489', '#928ea8', '#bda29a'],
	  // color: ['#cc5664', '#9bd6ec', '#ea946e', '#8acaaa', '#f1ec64', '#ee8686', '#a48dc1', '#5da6bc', '#b9dcae'],
	  // 深色
	  color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
	  // 默认需要 Grid 配置项
	  // grid: {},
	  // 主题，主题
	  textStyle: {
	    // color: '#000',
	    // decoration: 'none',
	    // PENDING
	    fontFamily: platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
	    // fontFamily: 'Arial, Verdana, sans-serif',
	    fontSize: 12,
	    fontStyle: 'normal',
	    fontWeight: 'normal'
	  },
	  // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
	  // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
	  // Default is source-over
	  blendMode: null,
	  animation: 'auto',
	  animationDuration: 1000,
	  animationDurationUpdate: 300,
	  animationEasing: 'exponentialOut',
	  animationEasingUpdate: 'cubicOut',
	  animationThreshold: 2000,
	  // Configuration for progressive/incremental rendering
	  progressiveThreshold: 3000,
	  progressive: 400,
	  // Threshold of if use single hover layer to optimize.
	  // It is recommended that `hoverLayerThreshold` is equivalent to or less than
	  // `progressiveThreshold`, otherwise hover will cause restart of progressive,
	  // which is unexpected.
	  // see example <echarts/test/heatmap-large.html>.
	  hoverLayerThreshold: 3000,
	  // See: module:echarts/scale/Time
	  useUTC: false
	};
	module.exports = _default;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	var makeStyleMapper = __webpack_require__(58);
	
	var getAreaStyle = makeStyleMapper([['fill', 'color'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['opacity'], ['shadowColor']]);
	var _default = {
	  getAreaStyle: function (excludes, includes) {
	    return getAreaStyle(this, excludes, includes);
	  }
	};
	module.exports = _default;

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	var _default = {
	  getBoxLayoutParams: function () {
	    return {
	      left: this.get('left'),
	      top: this.get('top'),
	      right: this.get('right'),
	      bottom: this.get('bottom'),
	      width: this.get('width'),
	      height: this.get('height')
	    };
	  }
	};
	module.exports = _default;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	var makeStyleMapper = __webpack_require__(58);
	
	var getItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'], ['textPosition'], ['textAlign']]);
	var _default = {
	  getItemStyle: function (excludes, includes) {
	    var style = getItemStyle(this, excludes, includes);
	    var lineDash = this.getBorderLineDash();
	    lineDash && (style.lineDash = lineDash);
	    return style;
	  },
	  getBorderLineDash: function () {
	    var lineType = this.get('borderType');
	    return lineType === 'solid' || lineType == null ? null : lineType === 'dashed' ? [5, 5] : [1, 1];
	  }
	};
	module.exports = _default;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	var makeStyleMapper = __webpack_require__(58);
	
	var getLineStyle = makeStyleMapper([['lineWidth', 'width'], ['stroke', 'color'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	var _default = {
	  getLineStyle: function (excludes) {
	    var style = getLineStyle(this, excludes);
	    var lineDash = this.getLineDash(style.lineWidth);
	    lineDash && (style.lineDash = lineDash);
	    return style;
	  },
	  getLineDash: function (lineWidth) {
	    if (lineWidth == null) {
	      lineWidth = 1;
	    }
	
	    var lineType = this.get('type');
	    var dotSize = Math.max(lineWidth, 2);
	    var dashSize = lineWidth * 4;
	    return lineType === 'solid' || lineType == null ? null : lineType === 'dashed' ? [dashSize, dashSize] : [dotSize, dotSize];
	  }
	};
	module.exports = _default;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	var textContain = __webpack_require__(27);
	
	var graphicUtil = __webpack_require__(3);
	
	var PATH_COLOR = ['textStyle', 'color'];
	var _default = {
	  /**
	   * Get color property or get color from option.textStyle.color
	   * @param {boolean} [isEmphasis]
	   * @return {string}
	   */
	  getTextColor: function (isEmphasis) {
	    var ecModel = this.ecModel;
	    return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get(PATH_COLOR) : null);
	  },
	
	  /**
	   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
	   * @return {string}
	   */
	  getFont: function () {
	    return graphicUtil.getFont({
	      fontStyle: this.getShallow('fontStyle'),
	      fontWeight: this.getShallow('fontWeight'),
	      fontSize: this.getShallow('fontSize'),
	      fontFamily: this.getShallow('fontFamily')
	    }, this.ecModel);
	  },
	  getTextRect: function (text) {
	    return textContain.getBoundingRect(text, this.getFont(), this.getShallow('align'), this.getShallow('verticalAlign') || this.getShallow('baseline'), this.getShallow('padding'), this.getShallow('rich'), this.getShallow('truncateText'));
	  }
	};
	module.exports = _default;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(1);
	
	var each = _util.each;
	var isArray = _util.isArray;
	var isObject = _util.isObject;
	
	var compatStyle = __webpack_require__(591);
	
	var _model = __webpack_require__(6);
	
	var normalizeToArray = _model.normalizeToArray;
	
	// Compatitable with 2.0
	function get(opt, path) {
	  path = path.split(',');
	  var obj = opt;
	
	  for (var i = 0; i < path.length; i++) {
	    obj = obj && obj[path[i]];
	
	    if (obj == null) {
	      break;
	    }
	  }
	
	  return obj;
	}
	
	function set(opt, path, val, overwrite) {
	  path = path.split(',');
	  var obj = opt;
	  var key;
	
	  for (var i = 0; i < path.length - 1; i++) {
	    key = path[i];
	
	    if (obj[key] == null) {
	      obj[key] = {};
	    }
	
	    obj = obj[key];
	  }
	
	  if (overwrite || obj[path[i]] == null) {
	    obj[path[i]] = val;
	  }
	}
	
	function compatLayoutProperties(option) {
	  each(LAYOUT_PROPERTIES, function (prop) {
	    if (prop[0] in option && !(prop[1] in option)) {
	      option[prop[1]] = option[prop[0]];
	    }
	  });
	}
	
	var LAYOUT_PROPERTIES = [['x', 'left'], ['y', 'top'], ['x2', 'right'], ['y2', 'bottom']];
	var COMPATITABLE_COMPONENTS = ['grid', 'geo', 'parallel', 'legend', 'toolbox', 'title', 'visualMap', 'dataZoom', 'timeline'];
	var COMPATITABLE_SERIES = ['bar', 'boxplot', 'candlestick', 'chord', 'effectScatter', 'funnel', 'gauge', 'lines', 'graph', 'heatmap', 'line', 'map', 'parallel', 'pie', 'radar', 'sankey', 'scatter', 'treemap'];
	
	function _default(option, isTheme) {
	  compatStyle(option, isTheme); // Make sure series array for model initialization.
	
	  option.series = normalizeToArray(option.series);
	  each(option.series, function (seriesOpt) {
	    if (!isObject(seriesOpt)) {
	      return;
	    }
	
	    var seriesType = seriesOpt.type;
	
	    if (seriesType === 'pie' || seriesType === 'gauge') {
	      if (seriesOpt.clockWise != null) {
	        seriesOpt.clockwise = seriesOpt.clockWise;
	      }
	    }
	
	    if (seriesType === 'gauge') {
	      var pointerColor = get(seriesOpt, 'pointer.color');
	      pointerColor != null && set(seriesOpt, 'itemStyle.normal.color', pointerColor);
	    }
	
	    for (var i = 0; i < COMPATITABLE_SERIES.length; i++) {
	      if (COMPATITABLE_SERIES[i] === seriesOpt.type) {
	        compatLayoutProperties(seriesOpt);
	        break;
	      }
	    }
	  }); // dataRange has changed to visualMap
	
	  if (option.dataRange) {
	    option.visualMap = option.dataRange;
	  }
	
	  each(COMPATITABLE_COMPONENTS, function (componentName) {
	    var options = option[componentName];
	
	    if (options) {
	      if (!isArray(options)) {
	        options = [options];
	      }
	
	      each(options, function (option) {
	        compatLayoutProperties(option);
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var modelUtil = __webpack_require__(6);
	
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var POSSIBLE_STYLES = ['areaStyle', 'lineStyle', 'nodeStyle', 'linkStyle', 'chordStyle', 'label', 'labelLine'];
	
	function compatItemStyle(opt) {
	  var itemStyleOpt = opt && opt.itemStyle;
	
	  if (!itemStyleOpt) {
	    return;
	  }
	
	  for (var i = 0, len = POSSIBLE_STYLES.length; i < len; i++) {
	    var styleName = POSSIBLE_STYLES[i];
	    var normalItemStyleOpt = itemStyleOpt.normal;
	    var emphasisItemStyleOpt = itemStyleOpt.emphasis;
	
	    if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
	      opt[styleName] = opt[styleName] || {};
	
	      if (!opt[styleName].normal) {
	        opt[styleName].normal = normalItemStyleOpt[styleName];
	      } else {
	        zrUtil.merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
	      }
	
	      normalItemStyleOpt[styleName] = null;
	    }
	
	    if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
	      opt[styleName] = opt[styleName] || {};
	
	      if (!opt[styleName].emphasis) {
	        opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
	      } else {
	        zrUtil.merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
	      }
	
	      emphasisItemStyleOpt[styleName] = null;
	    }
	  }
	}
	
	function compatTextStyle(opt, propName) {
	  var labelOptSingle = isObject(opt) && opt[propName];
	  var textStyle = isObject(labelOptSingle) && labelOptSingle.textStyle;
	
	  if (textStyle) {
	    for (var i = 0, len = modelUtil.TEXT_STYLE_OPTIONS.length; i < len; i++) {
	      var propName = modelUtil.TEXT_STYLE_OPTIONS[i];
	
	      if (textStyle.hasOwnProperty(propName)) {
	        labelOptSingle[propName] = textStyle[propName];
	      }
	    }
	  }
	}
	
	function compatLabelTextStyle(labelOpt) {
	  if (isObject(labelOpt)) {
	    compatTextStyle(labelOpt, 'normal');
	    compatTextStyle(labelOpt, 'emphasis');
	  }
	}
	
	function processSeries(seriesOpt) {
	  if (!isObject(seriesOpt)) {
	    return;
	  }
	
	  compatItemStyle(seriesOpt);
	  compatLabelTextStyle(seriesOpt.label); // treemap
	
	  compatLabelTextStyle(seriesOpt.upperLabel); // graph
	
	  compatLabelTextStyle(seriesOpt.edgeLabel);
	  var markPoint = seriesOpt.markPoint;
	  compatItemStyle(markPoint);
	  compatLabelTextStyle(markPoint && markPoint.label);
	  var markLine = seriesOpt.markLine;
	  compatItemStyle(seriesOpt.markLine);
	  compatLabelTextStyle(markLine && markLine.label);
	  var markArea = seriesOpt.markArea;
	  compatLabelTextStyle(markArea && markArea.label); // For gauge
	
	  compatTextStyle(seriesOpt, 'axisLabel');
	  compatTextStyle(seriesOpt, 'title');
	  compatTextStyle(seriesOpt, 'detail');
	  var data = seriesOpt.data;
	
	  if (data) {
	    for (var i = 0; i < data.length; i++) {
	      compatItemStyle(data[i]);
	      compatLabelTextStyle(data[i] && data[i].label);
	    }
	  } // mark point data
	
	
	  var markPoint = seriesOpt.markPoint;
	
	  if (markPoint && markPoint.data) {
	    var mpData = markPoint.data;
	
	    for (var i = 0; i < mpData.length; i++) {
	      compatItemStyle(mpData[i]);
	      compatLabelTextStyle(mpData[i] && mpData[i].label);
	    }
	  } // mark line data
	
	
	  var markLine = seriesOpt.markLine;
	
	  if (markLine && markLine.data) {
	    var mlData = markLine.data;
	
	    for (var i = 0; i < mlData.length; i++) {
	      if (zrUtil.isArray(mlData[i])) {
	        compatItemStyle(mlData[i][0]);
	        compatLabelTextStyle(mlData[i][0] && mlData[i][0].label);
	        compatItemStyle(mlData[i][1]);
	        compatLabelTextStyle(mlData[i][1] && mlData[i][1].label);
	      } else {
	        compatItemStyle(mlData[i]);
	        compatLabelTextStyle(mlData[i] && mlData[i].label);
	      }
	    }
	  }
	}
	
	function toArr(o) {
	  return zrUtil.isArray(o) ? o : o ? [o] : [];
	}
	
	function toObj(o) {
	  return (zrUtil.isArray(o) ? o[0] : o) || {};
	}
	
	function _default(option, isTheme) {
	  each(toArr(option.series), function (seriesOpt) {
	    isObject(seriesOpt) && processSeries(seriesOpt);
	  });
	  var axes = ['xAxis', 'yAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'parallelAxis', 'radar'];
	  isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
	  each(axes, function (axisName) {
	    each(toArr(option[axisName]), function (axisOpt) {
	      if (axisOpt) {
	        compatTextStyle(axisOpt, 'axisLabel');
	        compatTextStyle(axisOpt.axisPointer, 'label');
	      }
	    });
	  });
	  each(toArr(option.parallel), function (parallelOpt) {
	    var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
	    compatTextStyle(parallelAxisDefault, 'axisLabel');
	    compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
	  });
	  each(toArr(option.calendar), function (calendarOpt) {
	    compatTextStyle(calendarOpt, 'dayLabel');
	    compatTextStyle(calendarOpt, 'monthLabel');
	    compatTextStyle(calendarOpt, 'yearLabel');
	  }); // radar.name.textStyle
	
	  each(toArr(option.radar), function (radarOpt) {
	    compatTextStyle(radarOpt, 'name');
	  });
	  each(toArr(option.geo), function (geoOpt) {
	    if (isObject(geoOpt)) {
	      compatLabelTextStyle(geoOpt.label);
	      each(toArr(geoOpt.regions), function (regionObj) {
	        compatLabelTextStyle(regionObj.label);
	      });
	    }
	  });
	  compatLabelTextStyle(toObj(option.timeline).label);
	  compatTextStyle(toObj(option.axisPointer), 'label');
	  compatTextStyle(toObj(option.tooltip).axisPointer, 'label');
	}
	
	module.exports = _default;

/***/ }),
/* 592 */
/***/ (function(module, exports) {

	var samplers = {
	  average: function (frame) {
	    var sum = 0;
	    var count = 0;
	
	    for (var i = 0; i < frame.length; i++) {
	      if (!isNaN(frame[i])) {
	        sum += frame[i];
	        count++;
	      }
	    } // Return NaN if count is 0
	
	
	    return count === 0 ? NaN : sum / count;
	  },
	  sum: function (frame) {
	    var sum = 0;
	
	    for (var i = 0; i < frame.length; i++) {
	      // Ignore NaN
	      sum += frame[i] || 0;
	    }
	
	    return sum;
	  },
	  max: function (frame) {
	    var max = -Infinity;
	
	    for (var i = 0; i < frame.length; i++) {
	      frame[i] > max && (max = frame[i]);
	    }
	
	    return max;
	  },
	  min: function (frame) {
	    var min = Infinity;
	
	    for (var i = 0; i < frame.length; i++) {
	      frame[i] < min && (min = frame[i]);
	    }
	
	    return min;
	  },
	  // TODO
	  // Median
	  nearest: function (frame) {
	    return frame[0];
	  }
	};
	
	var indexSampler = function (frame, value) {
	  return Math.round(frame.length / 2);
	};
	
	function _default(seriesType, ecModel, api) {
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    var data = seriesModel.getData();
	    var sampling = seriesModel.get('sampling');
	    var coordSys = seriesModel.coordinateSystem; // Only cartesian2d support down sampling
	
	    if (coordSys.type === 'cartesian2d' && sampling) {
	      var baseAxis = coordSys.getBaseAxis();
	      var valueAxis = coordSys.getOtherAxis(baseAxis);
	      var extent = baseAxis.getExtent(); // Coordinste system has been resized
	
	      var size = extent[1] - extent[0];
	      var rate = Math.round(data.count() / size);
	
	      if (rate > 1) {
	        var sampler;
	
	        if (typeof sampling === 'string') {
	          sampler = samplers[sampling];
	        } else if (typeof sampling === 'function') {
	          sampler = sampling;
	        }
	
	        if (sampler) {
	          data = data.downSample(valueAxis.dim, 1 / rate, sampler, indexSampler);
	          seriesModel.setData(data);
	        }
	      }
	    }
	  }, this);
	}
	
	module.exports = _default;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Scale = __webpack_require__(92);
	
	var numberUtil = __webpack_require__(4);
	
	var IntervalScale = __webpack_require__(91);
	
	/**
	 * Log scale
	 * @module echarts/scale/Log
	 */
	// Use some method of IntervalScale
	var scaleProto = Scale.prototype;
	var intervalScaleProto = IntervalScale.prototype;
	var getPrecisionSafe = numberUtil.getPrecisionSafe;
	var roundingErrorFix = numberUtil.round;
	var mathFloor = Math.floor;
	var mathCeil = Math.ceil;
	var mathPow = Math.pow;
	var mathLog = Math.log;
	var LogScale = Scale.extend({
	  type: 'log',
	  base: 10,
	  $constructor: function () {
	    Scale.apply(this, arguments);
	    this._originalScale = new IntervalScale();
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getTicks: function () {
	    var originalScale = this._originalScale;
	    var extent = this._extent;
	    var originalExtent = originalScale.getExtent();
	    return zrUtil.map(intervalScaleProto.getTicks.call(this), function (val) {
	      var powVal = numberUtil.round(mathPow(this.base, val)); // Fix #4158
	
	      powVal = val === extent[0] && originalScale.__fixMin ? fixRoundingError(powVal, originalExtent[0]) : powVal;
	      powVal = val === extent[1] && originalScale.__fixMax ? fixRoundingError(powVal, originalExtent[1]) : powVal;
	      return powVal;
	    }, this);
	  },
	
	  /**
	   * @param {number} val
	   * @return {string}
	   */
	  getLabel: intervalScaleProto.getLabel,
	
	  /**
	   * @param  {number} val
	   * @return {number}
	   */
	  scale: function (val) {
	    val = scaleProto.scale.call(this, val);
	    return mathPow(this.base, val);
	  },
	
	  /**
	   * @param {number} start
	   * @param {number} end
	   */
	  setExtent: function (start, end) {
	    var base = this.base;
	    start = mathLog(start) / mathLog(base);
	    end = mathLog(end) / mathLog(base);
	    intervalScaleProto.setExtent.call(this, start, end);
	  },
	
	  /**
	   * @return {number} end
	   */
	  getExtent: function () {
	    var base = this.base;
	    var extent = scaleProto.getExtent.call(this);
	    extent[0] = mathPow(base, extent[0]);
	    extent[1] = mathPow(base, extent[1]); // Fix #4158
	
	    var originalScale = this._originalScale;
	    var originalExtent = originalScale.getExtent();
	    originalScale.__fixMin && (extent[0] = fixRoundingError(extent[0], originalExtent[0]));
	    originalScale.__fixMax && (extent[1] = fixRoundingError(extent[1], originalExtent[1]));
	    return extent;
	  },
	
	  /**
	   * @param  {Array.<number>} extent
	   */
	  unionExtent: function (extent) {
	    this._originalScale.unionExtent(extent);
	
	    var base = this.base;
	    extent[0] = mathLog(extent[0]) / mathLog(base);
	    extent[1] = mathLog(extent[1]) / mathLog(base);
	    scaleProto.unionExtent.call(this, extent);
	  },
	
	  /**
	   * @override
	   */
	  unionExtentFromData: function (data, dim) {
	    this.unionExtent(data.getDataExtent(dim, true, function (val) {
	      return val > 0;
	    }));
	  },
	
	  /**
	   * Update interval and extent of intervals for nice ticks
	   * @param  {number} [approxTickNum = 10] Given approx tick number
	   */
	  niceTicks: function (approxTickNum) {
	    approxTickNum = approxTickNum || 10;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	
	    if (span === Infinity || span <= 0) {
	      return;
	    }
	
	    var interval = numberUtil.quantity(span);
	    var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.
	
	    if (err <= 0.5) {
	      interval *= 10;
	    } // Interval should be integer
	
	
	    while (!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0) {
	      interval *= 10;
	    }
	
	    var niceExtent = [numberUtil.round(mathCeil(extent[0] / interval) * interval), numberUtil.round(mathFloor(extent[1] / interval) * interval)];
	    this._interval = interval;
	    this._niceExtent = niceExtent;
	  },
	
	  /**
	   * Nice extent.
	   * @override
	   */
	  niceExtent: function (opt) {
	    intervalScaleProto.niceExtent.call(this, opt);
	    var originalScale = this._originalScale;
	    originalScale.__fixMin = opt.fixMin;
	    originalScale.__fixMax = opt.fixMax;
	  }
	});
	zrUtil.each(['contain', 'normalize'], function (methodName) {
	  LogScale.prototype[methodName] = function (val) {
	    val = mathLog(val) / mathLog(this.base);
	    return scaleProto[methodName].call(this, val);
	  };
	});
	
	LogScale.create = function () {
	  return new LogScale();
	};
	
	function fixRoundingError(val, originalVal) {
	  return roundingErrorFix(val, getPrecisionSafe(originalVal));
	}
	
	var _default = LogScale;
	module.exports = _default;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Scale = __webpack_require__(92);
	
	/**
	 * Linear continuous scale
	 * @module echarts/coord/scale/Ordinal
	 *
	 * http://en.wikipedia.org/wiki/Level_of_measurement
	 */
	// FIXME only one data
	var scaleProto = Scale.prototype;
	var OrdinalScale = Scale.extend({
	  type: 'ordinal',
	  init: function (data, extent) {
	    this._data = data;
	    this._extent = extent || [0, data.length - 1];
	  },
	  parse: function (val) {
	    return typeof val === 'string' ? zrUtil.indexOf(this._data, val) // val might be float.
	    : Math.round(val);
	  },
	  contain: function (rank) {
	    rank = this.parse(rank);
	    return scaleProto.contain.call(this, rank) && this._data[rank] != null;
	  },
	
	  /**
	   * Normalize given rank or name to linear [0, 1]
	   * @param {number|string} [val]
	   * @return {number}
	   */
	  normalize: function (val) {
	    return scaleProto.normalize.call(this, this.parse(val));
	  },
	  scale: function (val) {
	    return Math.round(scaleProto.scale.call(this, val));
	  },
	
	  /**
	   * @return {Array}
	   */
	  getTicks: function () {
	    var ticks = [];
	    var extent = this._extent;
	    var rank = extent[0];
	
	    while (rank <= extent[1]) {
	      ticks.push(rank);
	      rank++;
	    }
	
	    return ticks;
	  },
	
	  /**
	   * Get item on rank n
	   * @param {number} n
	   * @return {string}
	   */
	  getLabel: function (n) {
	    return this._data[n];
	  },
	
	  /**
	   * @return {number}
	   */
	  count: function () {
	    return this._extent[1] - this._extent[0] + 1;
	  },
	
	  /**
	   * @override
	   */
	  unionExtentFromData: function (data, dim) {
	    this.unionExtent(data.getDataExtent(dim, false));
	  },
	  niceTicks: zrUtil.noop,
	  niceExtent: zrUtil.noop
	});
	/**
	 * @return {module:echarts/scale/Time}
	 */
	
	OrdinalScale.create = function () {
	  return new OrdinalScale();
	};
	
	var _default = OrdinalScale;
	module.exports = _default;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var numberUtil = __webpack_require__(4);
	
	var formatUtil = __webpack_require__(9);
	
	var scaleHelper = __webpack_require__(203);
	
	var IntervalScale = __webpack_require__(91);
	
	// [About UTC and local time zone]:
	// In most cases, `number.parseDate` will treat input data string as local time
	// (except time zone is specified in time string). And `format.formateTime` returns
	// local time by default. option.useUTC is false by default. This design have
	// concidered these common case:
	// (1) Time that is persistent in server is in UTC, but it is needed to be diplayed
	// in local time by default.
	// (2) By default, the input data string (e.g., '2011-01-02') should be displayed
	// as its original time, without any time difference.
	var intervalScaleProto = IntervalScale.prototype;
	var mathCeil = Math.ceil;
	var mathFloor = Math.floor;
	var ONE_SECOND = 1000;
	var ONE_MINUTE = ONE_SECOND * 60;
	var ONE_HOUR = ONE_MINUTE * 60;
	var ONE_DAY = ONE_HOUR * 24; // FIXME 公用？
	
	var bisect = function (a, x, lo, hi) {
	  while (lo < hi) {
	    var mid = lo + hi >>> 1;
	
	    if (a[mid][1] < x) {
	      lo = mid + 1;
	    } else {
	      hi = mid;
	    }
	  }
	
	  return lo;
	};
	/**
	 * @alias module:echarts/coord/scale/Time
	 * @constructor
	 */
	
	
	var TimeScale = IntervalScale.extend({
	  type: 'time',
	
	  /**
	   * @override
	   */
	  getLabel: function (val) {
	    var stepLvl = this._stepLvl;
	    var date = new Date(val);
	    return formatUtil.formatTime(stepLvl[0], date, this.getSetting('useUTC'));
	  },
	
	  /**
	   * @override
	   */
	  niceExtent: function (opt) {
	    var extent = this._extent; // If extent start and end are same, expand them
	
	    if (extent[0] === extent[1]) {
	      // Expand extent
	      extent[0] -= ONE_DAY;
	      extent[1] += ONE_DAY;
	    } // If there are no data and extent are [Infinity, -Infinity]
	
	
	    if (extent[1] === -Infinity && extent[0] === Infinity) {
	      var d = new Date();
	      extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
	      extent[0] = extent[1] - ONE_DAY;
	    }
	
	    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;
	
	    var interval = this._interval;
	
	    if (!opt.fixMin) {
	      extent[0] = numberUtil.round(mathFloor(extent[0] / interval) * interval);
	    }
	
	    if (!opt.fixMax) {
	      extent[1] = numberUtil.round(mathCeil(extent[1] / interval) * interval);
	    }
	  },
	
	  /**
	   * @override
	   */
	  niceTicks: function (approxTickNum, minInterval, maxInterval) {
	    approxTickNum = approxTickNum || 10;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	    var approxInterval = span / approxTickNum;
	
	    if (minInterval != null && approxInterval < minInterval) {
	      approxInterval = minInterval;
	    }
	
	    if (maxInterval != null && approxInterval > maxInterval) {
	      approxInterval = maxInterval;
	    }
	
	    var scaleLevelsLen = scaleLevels.length;
	    var idx = bisect(scaleLevels, approxInterval, 0, scaleLevelsLen);
	    var level = scaleLevels[Math.min(idx, scaleLevelsLen - 1)];
	    var interval = level[1]; // Same with interval scale if span is much larger than 1 year
	
	    if (level[0] === 'year') {
	      var yearSpan = span / interval; // From "Nice Numbers for Graph Labels" of Graphic Gems
	      // var niceYearSpan = numberUtil.nice(yearSpan, false);
	
	      var yearStep = numberUtil.nice(yearSpan / approxTickNum, true);
	      interval *= yearStep;
	    }
	
	    var timezoneOffset = this.getSetting('useUTC') ? 0 : new Date(+extent[0] || +extent[1]).getTimezoneOffset() * 60 * 1000;
	    var niceExtent = [Math.round(mathCeil((extent[0] - timezoneOffset) / interval) * interval + timezoneOffset), Math.round(mathFloor((extent[1] - timezoneOffset) / interval) * interval + timezoneOffset)];
	    scaleHelper.fixExtent(niceExtent, extent);
	    this._stepLvl = level; // Interval will be used in getTicks
	
	    this._interval = interval;
	    this._niceExtent = niceExtent;
	  },
	  parse: function (val) {
	    // val might be float.
	    return +numberUtil.parseDate(val);
	  }
	});
	zrUtil.each(['contain', 'normalize'], function (methodName) {
	  TimeScale.prototype[methodName] = function (val) {
	    return intervalScaleProto[methodName].call(this, this.parse(val));
	  };
	}); // Steps from d3
	
	var scaleLevels = [// Format              interval
	['hh:mm:ss', ONE_SECOND], // 1s
	['hh:mm:ss', ONE_SECOND * 5], // 5s
	['hh:mm:ss', ONE_SECOND * 10], // 10s
	['hh:mm:ss', ONE_SECOND * 15], // 15s
	['hh:mm:ss', ONE_SECOND * 30], // 30s
	['hh:mm\nMM-dd', ONE_MINUTE], // 1m
	['hh:mm\nMM-dd', ONE_MINUTE * 5], // 5m
	['hh:mm\nMM-dd', ONE_MINUTE * 10], // 10m
	['hh:mm\nMM-dd', ONE_MINUTE * 15], // 15m
	['hh:mm\nMM-dd', ONE_MINUTE * 30], // 30m
	['hh:mm\nMM-dd', ONE_HOUR], // 1h
	['hh:mm\nMM-dd', ONE_HOUR * 2], // 2h
	['hh:mm\nMM-dd', ONE_HOUR * 6], // 6h
	['hh:mm\nMM-dd', ONE_HOUR * 12], // 12h
	['MM-dd\nyyyy', ONE_DAY], // 1d
	['MM-dd\nyyyy', ONE_DAY * 2], // 2d
	['MM-dd\nyyyy', ONE_DAY * 3], // 3d
	['MM-dd\nyyyy', ONE_DAY * 4], // 4d
	['MM-dd\nyyyy', ONE_DAY * 5], // 5d
	['MM-dd\nyyyy', ONE_DAY * 6], // 6d
	['week', ONE_DAY * 7], // 7d
	['MM-dd\nyyyy', ONE_DAY * 10], // 10d
	['week', ONE_DAY * 14], // 2w
	['week', ONE_DAY * 21], // 3w
	['month', ONE_DAY * 31], // 1M
	['week', ONE_DAY * 42], // 6w
	['month', ONE_DAY * 62], // 2M
	['week', ONE_DAY * 42], // 10w
	['quarter', ONE_DAY * 380 / 4], // 3M
	['month', ONE_DAY * 31 * 4], // 4M
	['month', ONE_DAY * 31 * 5], // 5M
	['half-year', ONE_DAY * 380 / 2], // 6M
	['month', ONE_DAY * 31 * 8], // 8M
	['month', ONE_DAY * 31 * 10], // 10M
	['year', ONE_DAY * 380] // 1Y
	];
	/**
	 * @param {module:echarts/model/Model}
	 * @return {module:echarts/scale/Time}
	 */
	
	TimeScale.create = function (model) {
	  return new TimeScale({
	    useUTC: model.ecModel.get('useUTC')
	  });
	};
	
	var _default = TimeScale;
	module.exports = _default;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	/**
	 * @param {number} [time=500] Time in ms
	 * @param {string} [easing='linear']
	 * @param {number} [delay=0]
	 * @param {Function} [callback]
	 *
	 * @example
	 *  // Animate position
	 *  animation
	 *      .createWrap()
	 *      .add(el1, {position: [10, 10]})
	 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
	 *      .done(function () { // done })
	 *      .start('cubicOut');
	 */
	function createWrap() {
	  var storage = [];
	  var elExistsMap = {};
	  var doneCallback;
	  return {
	    /**
	     * Caution: a el can only be added once, otherwise 'done'
	     * might not be called. This method checks this (by el.id),
	     * suppresses adding and returns false when existing el found.
	     *
	     * @param {modele:zrender/Element} el
	     * @param {Object} target
	     * @param {number} [time=500]
	     * @param {number} [delay=0]
	     * @param {string} [easing='linear']
	     * @return {boolean} Whether adding succeeded.
	     *
	     * @example
	     *     add(el, target, time, delay, easing);
	     *     add(el, target, time, easing);
	     *     add(el, target, time);
	     *     add(el, target);
	     */
	    add: function (el, target, time, delay, easing) {
	      if (zrUtil.isString(delay)) {
	        easing = delay;
	        delay = 0;
	      }
	
	      if (elExistsMap[el.id]) {
	        return false;
	      }
	
	      elExistsMap[el.id] = 1;
	      storage.push({
	        el: el,
	        target: target,
	        time: time,
	        delay: delay,
	        easing: easing
	      });
	      return true;
	    },
	
	    /**
	     * Only execute when animation finished. Will not execute when any
	     * of 'stop' or 'stopAnimation' called.
	     *
	     * @param {Function} callback
	     */
	    done: function (callback) {
	      doneCallback = callback;
	      return this;
	    },
	
	    /**
	     * Will stop exist animation firstly.
	     */
	    start: function () {
	      var count = storage.length;
	
	      for (var i = 0, len = storage.length; i < len; i++) {
	        var item = storage[i];
	        item.el.animateTo(item.target, item.time, item.delay, item.easing, done);
	      }
	
	      return this;
	
	      function done() {
	        count--;
	
	        if (!count) {
	          storage.length = 0;
	          elExistsMap = {};
	          doneCallback && doneCallback();
	        }
	      }
	    }
	  };
	}
	
	exports.createWrap = createWrap;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	var Gradient = __webpack_require__(99);
	
	function _default(ecModel) {
	  function encodeColor(seriesModel) {
	    var colorAccessPath = (seriesModel.visualColorAccessPath || 'itemStyle.normal.color').split('.');
	    var data = seriesModel.getData();
	    var color = seriesModel.get(colorAccessPath) // Set in itemStyle
	    || seriesModel.getColorFromPalette(seriesModel.get('name')); // Default color
	    // FIXME Set color function or use the platte color
	
	    data.setVisual('color', color); // Only visible series has each data be visual encoded
	
	    if (!ecModel.isSeriesFiltered(seriesModel)) {
	      if (typeof color === 'function' && !(color instanceof Gradient)) {
	        data.each(function (idx) {
	          data.setItemVisual(idx, 'color', color(seriesModel.getDataParams(idx)));
	        });
	      } // itemStyle in each data item
	
	
	      data.each(function (idx) {
	        var itemModel = data.getItemModel(idx);
	        var color = itemModel.get(colorAccessPath, true);
	
	        if (color != null) {
	          data.setItemVisual(idx, 'color', color);
	        }
	      });
	    }
	  }
	
	  ecModel.eachRawSeries(encodeColor);
	}
	
	module.exports = _default;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   v4.2.8+1e68dce6
	 */
	
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  var type = typeof x;
	  return x !== null && (type === 'object' || type === 'function');
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	
	
	var _isArray = void 0;
	if (Array.isArray) {
	  _isArray = Array.isArray;
	} else {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = void 0;
	var customSchedulerFn = void 0;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  if (typeof vertxNext !== 'undefined') {
	    return function () {
	      vertxNext(flush);
	    };
	  }
	
	  return useSetTimeout();
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var vertx = Function('return this')().require('vertx');
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = void 0;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	
	  if (_state) {
	    var callback = arguments[_state - 1];
	    asap(function () {
	      return invokeCallback(_state, child, callback, parent._result);
	    });
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve$1(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(2);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then$$1.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then$$1) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then$$1, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return resolve(promise, value);
	    }, function (reason) {
	      return reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$1) {
	  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$1 === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$1)) {
	      handleForeignThenable(promise, maybeThenable, then$$1);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function resolve(promise, value) {
	  if (promise === value) {
	    reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    var then$$1 = void 0;
	    try {
	      then$$1 = value.then;
	    } catch (error) {
	      reject(promise, error);
	      return;
	    }
	    handleMaybeThenable(promise, value, then$$1);
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = void 0,
	      callback = void 0,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = void 0,
	      error = void 0,
	      succeeded = true;
	
	  if (hasCallback) {
	    try {
	      value = callback(detail);
	    } catch (e) {
	      succeeded = false;
	      error = e;
	    }
	
	    if (promise === value) {
	      reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	    resolve(promise, value);
	  } else if (succeeded === false) {
	    reject(promise, error);
	  } else if (settled === FULFILLED) {
	    fulfill(promise, value);
	  } else if (settled === REJECTED) {
	    reject(promise, value);
	  }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      resolve(promise, value);
	    }, function rejectPromise(reason) {
	      reject(promise, reason);
	    });
	  } catch (e) {
	    reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	}
	
	var Enumerator = function () {
	  function Enumerator(Constructor, input) {
	    this._instanceConstructor = Constructor;
	    this.promise = new Constructor(noop);
	
	    if (!this.promise[PROMISE_ID]) {
	      makePromise(this.promise);
	    }
	
	    if (isArray(input)) {
	      this.length = input.length;
	      this._remaining = input.length;
	
	      this._result = new Array(this.length);
	
	      if (this.length === 0) {
	        fulfill(this.promise, this._result);
	      } else {
	        this.length = this.length || 0;
	        this._enumerate(input);
	        if (this._remaining === 0) {
	          fulfill(this.promise, this._result);
	        }
	      }
	    } else {
	      reject(this.promise, validationError());
	    }
	  }
	
	  Enumerator.prototype._enumerate = function _enumerate(input) {
	    for (var i = 0; this._state === PENDING && i < input.length; i++) {
	      this._eachEntry(input[i], i);
	    }
	  };
	
	  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
	    var c = this._instanceConstructor;
	    var resolve$$1 = c.resolve;
	
	
	    if (resolve$$1 === resolve$1) {
	      var _then = void 0;
	      var error = void 0;
	      var didError = false;
	      try {
	        _then = entry.then;
	      } catch (e) {
	        didError = true;
	        error = e;
	      }
	
	      if (_then === then && entry._state !== PENDING) {
	        this._settledAt(entry._state, i, entry._result);
	      } else if (typeof _then !== 'function') {
	        this._remaining--;
	        this._result[i] = entry;
	      } else if (c === Promise$1) {
	        var promise = new c(noop);
	        if (didError) {
	          reject(promise, error);
	        } else {
	          handleMaybeThenable(promise, entry, _then);
	        }
	        this._willSettleAt(promise, i);
	      } else {
	        this._willSettleAt(new c(function (resolve$$1) {
	          return resolve$$1(entry);
	        }), i);
	      }
	    } else {
	      this._willSettleAt(resolve$$1(entry), i);
	    }
	  };
	
	  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
	    var promise = this.promise;
	
	
	    if (promise._state === PENDING) {
	      this._remaining--;
	
	      if (state === REJECTED) {
	        reject(promise, value);
	      } else {
	        this._result[i] = value;
	      }
	    }
	
	    if (this._remaining === 0) {
	      fulfill(promise, this._result);
	    }
	  };
	
	  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
	    var enumerator = this;
	
	    subscribe(promise, undefined, function (value) {
	      return enumerator._settledAt(FULFILLED, i, value);
	    }, function (reason) {
	      return enumerator._settledAt(REJECTED, i, reason);
	    });
	  };
	
	  return Enumerator;
	}();
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries) {
	  return new Enumerator(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject$1(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {Function} resolver
	  Useful for tooling.
	  @constructor
	*/
	
	var Promise$1 = function () {
	  function Promise(resolver) {
	    this[PROMISE_ID] = nextId();
	    this._result = this._state = undefined;
	    this._subscribers = [];
	
	    if (noop !== resolver) {
	      typeof resolver !== 'function' && needsResolver();
	      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	    }
	  }
	
	  /**
	  The primary way of interacting with a promise is through its `then` method,
	  which registers callbacks to receive either a promise's eventual value or the
	  reason why the promise cannot be fulfilled.
	   ```js
	  findUser().then(function(user){
	    // user is available
	  }, function(reason){
	    // user is unavailable, and you are given the reason why
	  });
	  ```
	   Chaining
	  --------
	   The return value of `then` is itself a promise.  This second, 'downstream'
	  promise is resolved with the return value of the first promise's fulfillment
	  or rejection handler, or rejected if the handler throws an exception.
	   ```js
	  findUser().then(function (user) {
	    return user.name;
	  }, function (reason) {
	    return 'default name';
	  }).then(function (userName) {
	    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	    // will be `'default name'`
	  });
	   findUser().then(function (user) {
	    throw new Error('Found user, but still unhappy');
	  }, function (reason) {
	    throw new Error('`findUser` rejected and we're unhappy');
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	  });
	  ```
	  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	   ```js
	  findUser().then(function (user) {
	    throw new PedagogicalException('Upstream error');
	  }).then(function (value) {
	    // never reached
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // The `PedgagocialException` is propagated all the way down to here
	  });
	  ```
	   Assimilation
	  ------------
	   Sometimes the value you want to propagate to a downstream promise can only be
	  retrieved asynchronously. This can be achieved by returning a promise in the
	  fulfillment or rejection handler. The downstream promise will then be pending
	  until the returned promise is settled. This is called *assimilation*.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // The user's comments are now available
	  });
	  ```
	   If the assimliated promise rejects, then the downstream promise will also reject.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // If `findCommentsByAuthor` fulfills, we'll have the value here
	  }, function (reason) {
	    // If `findCommentsByAuthor` rejects, we'll have the reason here
	  });
	  ```
	   Simple Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let result;
	   try {
	    result = findResult();
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	  findResult(function(result, err){
	    if (err) {
	      // failure
	    } else {
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findResult().then(function(result){
	    // success
	  }, function(reason){
	    // failure
	  });
	  ```
	   Advanced Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let author, books;
	   try {
	    author = findAuthor();
	    books  = findBooksByAuthor(author);
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	   function foundBooks(books) {
	   }
	   function failure(reason) {
	   }
	   findAuthor(function(author, err){
	    if (err) {
	      failure(err);
	      // failure
	    } else {
	      try {
	        findBoooksByAuthor(author, function(books, err) {
	          if (err) {
	            failure(err);
	          } else {
	            try {
	              foundBooks(books);
	            } catch(reason) {
	              failure(reason);
	            }
	          }
	        });
	      } catch(error) {
	        failure(err);
	      }
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findAuthor().
	    then(findBooksByAuthor).
	    then(function(books){
	      // found books
	  }).catch(function(reason){
	    // something went wrong
	  });
	  ```
	   @method then
	  @param {Function} onFulfilled
	  @param {Function} onRejected
	  Useful for tooling.
	  @return {Promise}
	  */
	
	  /**
	  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	  as the catch block of a try/catch statement.
	  ```js
	  function findAuthor(){
	  throw new Error('couldn't find that author');
	  }
	  // synchronous
	  try {
	  findAuthor();
	  } catch(reason) {
	  // something went wrong
	  }
	  // async with promises
	  findAuthor().catch(function(reason){
	  // something went wrong
	  });
	  ```
	  @method catch
	  @param {Function} onRejection
	  Useful for tooling.
	  @return {Promise}
	  */
	
	
	  Promise.prototype.catch = function _catch(onRejection) {
	    return this.then(null, onRejection);
	  };
	
	  /**
	    `finally` will be invoked regardless of the promise's fate just as native
	    try/catch/finally behaves
	  
	    Synchronous example:
	  
	    ```js
	    findAuthor() {
	      if (Math.random() > 0.5) {
	        throw new Error();
	      }
	      return new Author();
	    }
	  
	    try {
	      return findAuthor(); // succeed or fail
	    } catch(error) {
	      return findOtherAuther();
	    } finally {
	      // always runs
	      // doesn't affect the return value
	    }
	    ```
	  
	    Asynchronous example:
	  
	    ```js
	    findAuthor().catch(function(reason){
	      return findOtherAuther();
	    }).finally(function(){
	      // author was either found, or not
	    });
	    ```
	  
	    @method finally
	    @param {Function} callback
	    @return {Promise}
	  */
	
	
	  Promise.prototype.finally = function _finally(callback) {
	    var promise = this;
	    var constructor = promise.constructor;
	
	    if (isFunction(callback)) {
	      return promise.then(function (value) {
	        return constructor.resolve(callback()).then(function () {
	          return value;
	        });
	      }, function (reason) {
	        return constructor.resolve(callback()).then(function () {
	          throw reason;
	        });
	      });
	    }
	
	    return promise.then(callback, callback);
	  };
	
	  return Promise;
	}();
	
	Promise$1.prototype.then = then;
	Promise$1.all = all;
	Promise$1.race = race;
	Promise$1.resolve = resolve$1;
	Promise$1.reject = reject$1;
	Promise$1._setScheduler = setScheduler;
	Promise$1._setAsap = setAsap;
	Promise$1._asap = asap;
	
	/*global self*/
	function polyfill() {
	  var local = void 0;
	
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	
	  var P = local.Promise;
	
	  if (P) {
	    var promiseToString = null;
	    try {
	      promiseToString = Object.prototype.toString.call(P.resolve());
	    } catch (e) {
	      // silently ignored
	    }
	
	    if (promiseToString === '[object Promise]' && !P.cast) {
	      return;
	    }
	  }
	
	  local.Promise = Promise$1;
	}
	
	// Strange compat..
	Promise$1.polyfill = polyfill;
	Promise$1.Promise = Promise$1;
	
	return Promise$1;
	
	})));
	
	
	
	//# sourceMappingURL=es6-promise.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(207), (function() { return this; }())))

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// add, remove cell
	( function( window, factory ) {
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(48),
	      __webpack_require__(38),
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, utils ) {
	      return factory( window, Flickity, utils );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	        window,
	        require('./flickity'),
	        require('fizzy-ui-utils')
	    );
	  } else {
	    // browser global
	    factory(
	        window,
	        window.Flickity,
	        window.fizzyUIUtils
	    );
	  }
	
	}( window, function factory( window, Flickity, utils ) {
	
	'use strict';
	
	// append cells to a document fragment
	function getCellsFragment( cells ) {
	  var fragment = document.createDocumentFragment();
	  cells.forEach( function( cell ) {
	    fragment.appendChild( cell.element );
	  } );
	  return fragment;
	}
	
	// -------------------------- add/remove cell prototype -------------------------- //
	
	var proto = Flickity.prototype;
	
	/**
	 * Insert, prepend, or append cells
	 * @param {[Element, Array, NodeList]} elems - Elements to insert
	 * @param {Integer} index - Zero-based number to insert
	 */
	proto.insert = function( elems, index ) {
	  var cells = this._makeCells( elems );
	  if ( !cells || !cells.length ) {
	    return;
	  }
	  var len = this.cells.length;
	  // default to append
	  index = index === undefined ? len : index;
	  // add cells with document fragment
	  var fragment = getCellsFragment( cells );
	  // append to slider
	  var isAppend = index == len;
	  if ( isAppend ) {
	    this.slider.appendChild( fragment );
	  } else {
	    var insertCellElement = this.cells[ index ].element;
	    this.slider.insertBefore( fragment, insertCellElement );
	  }
	  // add to this.cells
	  if ( index === 0 ) {
	    // prepend, add to start
	    this.cells = cells.concat( this.cells );
	  } else if ( isAppend ) {
	    // append, add to end
	    this.cells = this.cells.concat( cells );
	  } else {
	    // insert in this.cells
	    var endCells = this.cells.splice( index, len - index );
	    this.cells = this.cells.concat( cells ).concat( endCells );
	  }
	
	  this._sizeCells( cells );
	  this.cellChange( index, true );
	};
	
	proto.append = function( elems ) {
	  this.insert( elems, this.cells.length );
	};
	
	proto.prepend = function( elems ) {
	  this.insert( elems, 0 );
	};
	
	/**
	 * Remove cells
	 * @param {[Element, Array, NodeList]} elems - ELements to remove
	 */
	proto.remove = function( elems ) {
	  var cells = this.getCells( elems );
	  if ( !cells || !cells.length ) {
	    return;
	  }
	
	  var minCellIndex = this.cells.length - 1;
	  // remove cells from collection & DOM
	  cells.forEach( function( cell ) {
	    cell.remove();
	    var index = this.cells.indexOf( cell );
	    minCellIndex = Math.min( index, minCellIndex );
	    utils.removeFrom( this.cells, cell );
	  }, this );
	
	  this.cellChange( minCellIndex, true );
	};
	
	/**
	 * logic to be run after a cell's size changes
	 * @param {Element} elem - cell's element
	 */
	proto.cellSizeChange = function( elem ) {
	  var cell = this.getCell( elem );
	  if ( !cell ) {
	    return;
	  }
	  cell.getSize();
	
	  var index = this.cells.indexOf( cell );
	  this.cellChange( index );
	};
	
	/**
	 * logic any time a cell is changed: added, removed, or size changed
	 * @param {Integer} changedCellIndex - index of the changed cell, optional
	 * @param {Boolean} isPositioningSlider - Positions slider after selection
	 */
	proto.cellChange = function( changedCellIndex, isPositioningSlider ) {
	  var prevSelectedElem = this.selectedElement;
	  this._positionCells( changedCellIndex );
	  this._getWrapShiftCells();
	  this.setGallerySize();
	  // update selectedIndex
	  // try to maintain position & select previous selected element
	  var cell = this.getCell( prevSelectedElem );
	  if ( cell ) {
	    this.selectedIndex = this.getCellSlideIndex( cell );
	  }
	  this.selectedIndex = Math.min( this.slides.length - 1, this.selectedIndex );
	
	  this.emitEvent( 'cellChange', [ changedCellIndex ] );
	  // position slider
	  this.select( this.selectedIndex );
	  // do not position slider after lazy load
	  if ( isPositioningSlider ) {
	    this.positionSliderAtSelected();
	  }
	};
	
	// -----  ----- //
	
	return Flickity;
	
	} ) );


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// animate
	( function( window, factory ) {
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(38),
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( utils ) {
	      return factory( window, utils );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	        window,
	        require('fizzy-ui-utils')
	    );
	  } else {
	    // browser global
	    window.Flickity = window.Flickity || {};
	    window.Flickity.animatePrototype = factory(
	        window,
	        window.fizzyUIUtils
	    );
	  }
	
	}( window, function factory( window, utils ) {
	
	'use strict';
	
	// -------------------------- animate -------------------------- //
	
	var proto = {};
	
	proto.startAnimation = function() {
	  if ( this.isAnimating ) {
	    return;
	  }
	
	  this.isAnimating = true;
	  this.restingFrames = 0;
	  this.animate();
	};
	
	proto.animate = function() {
	  this.applyDragForce();
	  this.applySelectedAttraction();
	
	  var previousX = this.x;
	
	  this.integratePhysics();
	  this.positionSlider();
	  this.settle( previousX );
	  // animate next frame
	  if ( this.isAnimating ) {
	    var _this = this;
	    requestAnimationFrame( function animateFrame() {
	      _this.animate();
	    } );
	  }
	};
	
	proto.positionSlider = function() {
	  var x = this.x;
	  // wrap position around
	  if ( this.options.wrapAround && this.cells.length > 1 ) {
	    x = utils.modulo( x, this.slideableWidth );
	    x -= this.slideableWidth;
	    this.shiftWrapCells( x );
	  }
	
	  this.setTranslateX( x, this.isAnimating );
	  this.dispatchScrollEvent();
	};
	
	proto.setTranslateX = function( x, is3d ) {
	  x += this.cursorPosition;
	  // reverse if right-to-left and using transform
	  x = this.options.rightToLeft ? -x : x;
	  var translateX = this.getPositionValue( x );
	  // use 3D transforms for hardware acceleration on iOS
	  // but use 2D when settled, for better font-rendering
	  this.slider.style.transform = is3d ?
	    'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
	};
	
	proto.dispatchScrollEvent = function() {
	  var firstSlide = this.slides[0];
	  if ( !firstSlide ) {
	    return;
	  }
	  var positionX = -this.x - firstSlide.target;
	  var progress = positionX / this.slidesWidth;
	  this.dispatchEvent( 'scroll', null, [ progress, positionX ] );
	};
	
	proto.positionSliderAtSelected = function() {
	  if ( !this.cells.length ) {
	    return;
	  }
	  this.x = -this.selectedSlide.target;
	  this.velocity = 0; // stop wobble
	  this.positionSlider();
	};
	
	proto.getPositionValue = function( position ) {
	  if ( this.options.percentPosition ) {
	    // percent position, round to 2 digits, like 12.34%
	    return ( Math.round( ( position / this.size.innerWidth ) * 10000 ) * 0.01 ) + '%';
	  } else {
	    // pixel positioning
	    return Math.round( position ) + 'px';
	  }
	};
	
	proto.settle = function( previousX ) {
	  // keep track of frames where x hasn't moved
	  var isResting = !this.isPointerDown &&
	      Math.round( this.x * 100 ) == Math.round( previousX * 100 );
	  if ( isResting ) {
	    this.restingFrames++;
	  }
	  // stop animating if resting for 3 or more frames
	  if ( this.restingFrames > 2 ) {
	    this.isAnimating = false;
	    delete this.isFreeScrolling;
	    // render position with translateX when settled
	    this.positionSlider();
	    this.dispatchEvent( 'settle', null, [ this.selectedIndex ] );
	  }
	};
	
	proto.shiftWrapCells = function( x ) {
	  // shift before cells
	  var beforeGap = this.cursorPosition + x;
	  this._shiftCells( this.beforeShiftCells, beforeGap, -1 );
	  // shift after cells
	  var afterGap = this.size.innerWidth - ( x + this.slideableWidth + this.cursorPosition );
	  this._shiftCells( this.afterShiftCells, afterGap, 1 );
	};
	
	proto._shiftCells = function( cells, gap, shift ) {
	  for ( var i = 0; i < cells.length; i++ ) {
	    var cell = cells[i];
	    var cellShift = gap > 0 ? shift : 0;
	    cell.wrapShift( cellShift );
	    gap -= cell.size.outerWidth;
	  }
	};
	
	proto._unshiftCells = function( cells ) {
	  if ( !cells || !cells.length ) {
	    return;
	  }
	  for ( var i = 0; i < cells.length; i++ ) {
	    cells[i].wrapShift( 0 );
	  }
	};
	
	// -------------------------- physics -------------------------- //
	
	proto.integratePhysics = function() {
	  this.x += this.velocity;
	  this.velocity *= this.getFrictionFactor();
	};
	
	proto.applyForce = function( force ) {
	  this.velocity += force;
	};
	
	proto.getFrictionFactor = function() {
	  return 1 - this.options[ this.isFreeScrolling ? 'freeScrollFriction' : 'friction' ];
	};
	
	proto.getRestingPosition = function() {
	  // my thanks to Steven Wittens, who simplified this math greatly
	  return this.x + this.velocity / ( 1 - this.getFrictionFactor() );
	};
	
	proto.applyDragForce = function() {
	  if ( !this.isDraggable || !this.isPointerDown ) {
	    return;
	  }
	  // change the position to drag position by applying force
	  var dragVelocity = this.dragX - this.x;
	  var dragForce = dragVelocity - this.velocity;
	  this.applyForce( dragForce );
	};
	
	proto.applySelectedAttraction = function() {
	  // do not attract if pointer down or no slides
	  var dragDown = this.isDraggable && this.isPointerDown;
	  if ( dragDown || this.isFreeScrolling || !this.slides.length ) {
	    return;
	  }
	  var distance = this.selectedSlide.target * -1 - this.x;
	  var force = distance * this.options.selectedAttraction;
	  this.applyForce( force );
	};
	
	return proto;
	
	} ) );


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity.Cell
	( function( window, factory ) {
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(206),
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( getSize ) {
	      return factory( window, getSize );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	        window,
	        require('get-size')
	    );
	  } else {
	    // browser global
	    window.Flickity = window.Flickity || {};
	    window.Flickity.Cell = factory(
	        window,
	        window.getSize
	    );
	  }
	
	}( window, function factory( window, getSize ) {
	
	'use strict';
	
	function Cell( elem, parent ) {
	  this.element = elem;
	  this.parent = parent;
	
	  this.create();
	}
	
	var proto = Cell.prototype;
	
	proto.create = function() {
	  this.element.style.position = 'absolute';
	  this.element.setAttribute( 'aria-hidden', 'true' );
	  this.x = 0;
	  this.shift = 0;
	  this.element.style[ this.parent.originSide ] = 0;
	};
	
	proto.destroy = function() {
	  // reset style
	  this.unselect();
	  this.element.style.position = '';
	  var side = this.parent.originSide;
	  this.element.style[ side ] = '';
	  this.element.style.transform = '';
	  this.element.removeAttribute('aria-hidden');
	};
	
	proto.getSize = function() {
	  this.size = getSize( this.element );
	};
	
	proto.setPosition = function( x ) {
	  this.x = x;
	  this.updateTarget();
	  this.renderPosition( x );
	};
	
	// setDefaultTarget v1 method, backwards compatibility, remove in v3
	proto.updateTarget = proto.setDefaultTarget = function() {
	  var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
	  this.target = this.x + this.size[ marginProperty ] +
	    this.size.width * this.parent.cellAlign;
	};
	
	proto.renderPosition = function( x ) {
	  // render position of cell with in slider
	  var sideOffset = this.parent.originSide === 'left' ? 1 : -1;
	
	  var adjustedX = this.parent.options.percentPosition ?
	    x * sideOffset * ( this.parent.size.innerWidth / this.size.width ) :
	    x * sideOffset;
	
	  this.element.style.transform = 'translateX(' +
	    this.parent.getPositionValue( adjustedX ) + ')';
	};
	
	proto.select = function() {
	  this.element.classList.add('is-selected');
	  this.element.removeAttribute('aria-hidden');
	};
	
	proto.unselect = function() {
	  this.element.classList.remove('is-selected');
	  this.element.setAttribute( 'aria-hidden', 'true' );
	};
	
	/**
	 * @param {Integer} shift - 0, 1, or -1
	 */
	proto.wrapShift = function( shift ) {
	  this.shift = shift;
	  this.renderPosition( this.x + this.parent.slideableWidth * shift );
	};
	
	proto.remove = function() {
	  this.element.parentNode.removeChild( this.element );
	};
	
	return Cell;
	
	} ) );


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// drag
	( function( window, factory ) {
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(48),
	      __webpack_require__(615),
	      __webpack_require__(38),
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, Unidragger, utils ) {
	      return factory( window, Flickity, Unidragger, utils );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	        window,
	        require('./flickity'),
	        require('unidragger'),
	        require('fizzy-ui-utils')
	    );
	  } else {
	    // browser global
	    window.Flickity = factory(
	        window,
	        window.Flickity,
	        window.Unidragger,
	        window.fizzyUIUtils
	    );
	  }
	
	}( window, function factory( window, Flickity, Unidragger, utils ) {
	
	'use strict';
	
	// ----- defaults ----- //
	
	utils.extend( Flickity.defaults, {
	  draggable: '>1',
	  dragThreshold: 3,
	} );
	
	// ----- create ----- //
	
	Flickity.createMethods.push('_createDrag');
	
	// -------------------------- drag prototype -------------------------- //
	
	var proto = Flickity.prototype;
	utils.extend( proto, Unidragger.prototype );
	proto._touchActionValue = 'pan-y';
	
	// --------------------------  -------------------------- //
	
	proto._createDrag = function() {
	  this.on( 'activate', this.onActivateDrag );
	  this.on( 'uiChange', this._uiChangeDrag );
	  this.on( 'deactivate', this.onDeactivateDrag );
	  this.on( 'cellChange', this.updateDraggable );
	  // TODO updateDraggable on resize? if groupCells & slides change
	};
	
	proto.onActivateDrag = function() {
	  this.handles = [ this.viewport ];
	  this.bindHandles();
	  this.updateDraggable();
	};
	
	proto.onDeactivateDrag = function() {
	  this.unbindHandles();
	  this.element.classList.remove('is-draggable');
	};
	
	proto.updateDraggable = function() {
	  // disable dragging if less than 2 slides. #278
	  if ( this.options.draggable == '>1' ) {
	    this.isDraggable = this.slides.length > 1;
	  } else {
	    this.isDraggable = this.options.draggable;
	  }
	  if ( this.isDraggable ) {
	    this.element.classList.add('is-draggable');
	  } else {
	    this.element.classList.remove('is-draggable');
	  }
	};
	
	// backwards compatibility
	proto.bindDrag = function() {
	  this.options.draggable = true;
	  this.updateDraggable();
	};
	
	proto.unbindDrag = function() {
	  this.options.draggable = false;
	  this.updateDraggable();
	};
	
	proto._uiChangeDrag = function() {
	  delete this.isFreeScrolling;
	};
	
	// -------------------------- pointer events -------------------------- //
	
	proto.pointerDown = function( event, pointer ) {
	  if ( !this.isDraggable ) {
	    this._pointerDownDefault( event, pointer );
	    return;
	  }
	  var isOkay = this.okayPointerDown( event );
	  if ( !isOkay ) {
	    return;
	  }
	
	  this._pointerDownPreventDefault( event );
	  this.pointerDownFocus( event );
	  // blur
	  if ( document.activeElement != this.element ) {
	    // do not blur if already focused
	    this.pointerDownBlur();
	  }
	
	  // stop if it was moving
	  this.dragX = this.x;
	  this.viewport.classList.add('is-pointer-down');
	  // track scrolling
	  this.pointerDownScroll = getScrollPosition();
	  window.addEventListener( 'scroll', this );
	
	  this._pointerDownDefault( event, pointer );
	};
	
	// default pointerDown logic, used for staticClick
	proto._pointerDownDefault = function( event, pointer ) {
	  // track start event position
	  // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
	  this.pointerDownPointer = {
	    pageX: pointer.pageX,
	    pageY: pointer.pageY,
	  };
	  // bind move and end events
	  this._bindPostStartEvents( event );
	  this.dispatchEvent( 'pointerDown', event, [ pointer ] );
	};
	
	var focusNodes = {
	  INPUT: true,
	  TEXTAREA: true,
	  SELECT: true,
	};
	
	proto.pointerDownFocus = function( event ) {
	  var isFocusNode = focusNodes[ event.target.nodeName ];
	  if ( !isFocusNode ) {
	    this.focus();
	  }
	};
	
	proto._pointerDownPreventDefault = function( event ) {
	  var isTouchStart = event.type == 'touchstart';
	  var isTouchPointer = event.pointerType == 'touch';
	  var isFocusNode = focusNodes[ event.target.nodeName ];
	  if ( !isTouchStart && !isTouchPointer && !isFocusNode ) {
	    event.preventDefault();
	  }
	};
	
	// ----- move ----- //
	
	proto.hasDragStarted = function( moveVector ) {
	  return Math.abs( moveVector.x ) > this.options.dragThreshold;
	};
	
	// ----- up ----- //
	
	proto.pointerUp = function( event, pointer ) {
	  delete this.isTouchScrolling;
	  this.viewport.classList.remove('is-pointer-down');
	  this.dispatchEvent( 'pointerUp', event, [ pointer ] );
	  this._dragPointerUp( event, pointer );
	};
	
	proto.pointerDone = function() {
	  window.removeEventListener( 'scroll', this );
	  delete this.pointerDownScroll;
	};
	
	// -------------------------- dragging -------------------------- //
	
	proto.dragStart = function( event, pointer ) {
	  if ( !this.isDraggable ) {
	    return;
	  }
	  this.dragStartPosition = this.x;
	  this.startAnimation();
	  window.removeEventListener( 'scroll', this );
	  this.dispatchEvent( 'dragStart', event, [ pointer ] );
	};
	
	proto.pointerMove = function( event, pointer ) {
	  var moveVector = this._dragPointerMove( event, pointer );
	  this.dispatchEvent( 'pointerMove', event, [ pointer, moveVector ] );
	  this._dragMove( event, pointer, moveVector );
	};
	
	proto.dragMove = function( event, pointer, moveVector ) {
	  if ( !this.isDraggable ) {
	    return;
	  }
	  event.preventDefault();
	
	  this.previousDragX = this.dragX;
	  // reverse if right-to-left
	  var direction = this.options.rightToLeft ? -1 : 1;
	  if ( this.options.wrapAround ) {
	    // wrap around move. #589
	    moveVector.x %= this.slideableWidth;
	  }
	  var dragX = this.dragStartPosition + moveVector.x * direction;
	
	  if ( !this.options.wrapAround && this.slides.length ) {
	    // slow drag
	    var originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
	    dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
	    var endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
	    dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
	  }
	
	  this.dragX = dragX;
	
	  this.dragMoveTime = new Date();
	  this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
	};
	
	proto.dragEnd = function( event, pointer ) {
	  if ( !this.isDraggable ) {
	    return;
	  }
	  if ( this.options.freeScroll ) {
	    this.isFreeScrolling = true;
	  }
	  // set selectedIndex based on where flick will end up
	  var index = this.dragEndRestingSelect();
	
	  if ( this.options.freeScroll && !this.options.wrapAround ) {
	    // if free-scroll & not wrap around
	    // do not free-scroll if going outside of bounding slides
	    // so bounding slides can attract slider, and keep it in bounds
	    var restingX = this.getRestingPosition();
	    this.isFreeScrolling = -restingX > this.slides[0].target &&
	      -restingX < this.getLastSlide().target;
	  } else if ( !this.options.freeScroll && index == this.selectedIndex ) {
	    // boost selection if selected index has not changed
	    index += this.dragEndBoostSelect();
	  }
	  delete this.previousDragX;
	  // apply selection
	  // TODO refactor this, selecting here feels weird
	  // HACK, set flag so dragging stays in correct direction
	  this.isDragSelect = this.options.wrapAround;
	  this.select( index );
	  delete this.isDragSelect;
	  this.dispatchEvent( 'dragEnd', event, [ pointer ] );
	};
	
	proto.dragEndRestingSelect = function() {
	  var restingX = this.getRestingPosition();
	  // how far away from selected slide
	  var distance = Math.abs( this.getSlideDistance( -restingX, this.selectedIndex ) );
	  // get closet resting going up and going down
	  var positiveResting = this._getClosestResting( restingX, distance, 1 );
	  var negativeResting = this._getClosestResting( restingX, distance, -1 );
	  // use closer resting for wrap-around
	  var index = positiveResting.distance < negativeResting.distance ?
	    positiveResting.index : negativeResting.index;
	  return index;
	};
	
	/**
	 * given resting X and distance to selected cell
	 * get the distance and index of the closest cell
	 * @param {Number} restingX - estimated post-flick resting position
	 * @param {Number} distance - distance to selected cell
	 * @param {Integer} increment - +1 or -1, going up or down
	 * @returns {Object} - { distance: {Number}, index: {Integer} }
	 */
	proto._getClosestResting = function( restingX, distance, increment ) {
	  var index = this.selectedIndex;
	  var minDistance = Infinity;
	  var condition = this.options.contain && !this.options.wrapAround ?
	    // if contain, keep going if distance is equal to minDistance
	    function( dist, minDist ) {
	      return dist <= minDist;
	    } : function( dist, minDist ) {
	      return dist < minDist;
	    };
	  while ( condition( distance, minDistance ) ) {
	    // measure distance to next cell
	    index += increment;
	    minDistance = distance;
	    distance = this.getSlideDistance( -restingX, index );
	    if ( distance === null ) {
	      break;
	    }
	    distance = Math.abs( distance );
	  }
	  return {
	    distance: minDistance,
	    // selected was previous index
	    index: index - increment,
	  };
	};
	
	/**
	 * measure distance between x and a slide target
	 * @param {Number} x - horizontal position
	 * @param {Integer} index - slide index
	 * @returns {Number} - slide distance
	 */
	proto.getSlideDistance = function( x, index ) {
	  var len = this.slides.length;
	  // wrap around if at least 2 slides
	  var isWrapAround = this.options.wrapAround && len > 1;
	  var slideIndex = isWrapAround ? utils.modulo( index, len ) : index;
	  var slide = this.slides[ slideIndex ];
	  if ( !slide ) {
	    return null;
	  }
	  // add distance for wrap-around slides
	  var wrap = isWrapAround ? this.slideableWidth * Math.floor( index/len ) : 0;
	  return x - ( slide.target + wrap );
	};
	
	proto.dragEndBoostSelect = function() {
	  // do not boost if no previousDragX or dragMoveTime
	  if ( this.previousDragX === undefined || !this.dragMoveTime ||
	    // or if drag was held for 100 ms
	    new Date() - this.dragMoveTime > 100 ) {
	    return 0;
	  }
	
	  var distance = this.getSlideDistance( -this.dragX, this.selectedIndex );
	  var delta = this.previousDragX - this.dragX;
	  if ( distance > 0 && delta > 0 ) {
	    // boost to next if moving towards the right, and positive velocity
	    return 1;
	  } else if ( distance < 0 && delta < 0 ) {
	    // boost to previous if moving towards the left, and negative velocity
	    return -1;
	  }
	  return 0;
	};
	
	// ----- staticClick ----- //
	
	proto.staticClick = function( event, pointer ) {
	  // get clickedCell, if cell was clicked
	  var clickedCell = this.getParentCell( event.target );
	  var cellElem = clickedCell && clickedCell.element;
	  var cellIndex = clickedCell && this.cells.indexOf( clickedCell );
	  this.dispatchEvent( 'staticClick', event, [ pointer, cellElem, cellIndex ] );
	};
	
	// ----- scroll ----- //
	
	proto.onscroll = function() {
	  var scroll = getScrollPosition();
	  var scrollMoveX = this.pointerDownScroll.x - scroll.x;
	  var scrollMoveY = this.pointerDownScroll.y - scroll.y;
	  // cancel click/tap if scroll is too much
	  if ( Math.abs( scrollMoveX ) > 3 || Math.abs( scrollMoveY ) > 3 ) {
	    this._pointerDone();
	  }
	};
	
	// ----- utils ----- //
	
	function getScrollPosition() {
	  return {
	    x: window.pageXOffset,
	    y: window.pageYOffset,
	  };
	}
	
	// -----  ----- //
	
	return Flickity;
	
	} ) );


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Flickity v2.3.0
	 * Touch, responsive, flickable carousels
	 *
	 * Licensed GPLv3 for open source use
	 * or Flickity Commercial License for commercial use
	 *
	 * https://flickity.metafizzy.co
	 * Copyright 2015-2021 Metafizzy
	 */
	
	( function( window, factory ) {
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(48),
	      __webpack_require__(602),
	      __webpack_require__(607),
	      __webpack_require__(605),
	      __webpack_require__(606),
	      __webpack_require__(599),
	      __webpack_require__(604),
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	        require('./flickity'),
	        require('./drag'),
	        require('./prev-next-button'),
	        require('./page-dots'),
	        require('./player'),
	        require('./add-remove-cell'),
	        require('./lazyload')
	    );
	  }
	
	} )( window, function factory( Flickity ) {
	  return Flickity;
	} );


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// lazyload
	( function( window, factory ) {
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(48),
	      __webpack_require__(38),
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, utils ) {
	      return factory( window, Flickity, utils );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	        window,
	        require('./flickity'),
	        require('fizzy-ui-utils')
	    );
	  } else {
	    // browser global
	    factory(
	        window,
	        window.Flickity,
	        window.fizzyUIUtils
	    );
	  }
	
	}( window, function factory( window, Flickity, utils ) {
	'use strict';
	
	Flickity.createMethods.push('_createLazyload');
	var proto = Flickity.prototype;
	
	proto._createLazyload = function() {
	  this.on( 'select', this.lazyLoad );
	};
	
	proto.lazyLoad = function() {
	  var lazyLoad = this.options.lazyLoad;
	  if ( !lazyLoad ) {
	    return;
	  }
	  // get adjacent cells, use lazyLoad option for adjacent count
	  var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
	  var cellElems = this.getAdjacentCellElements( adjCount );
	  // get lazy images in those cells
	  var lazyImages = [];
	  cellElems.forEach( function( cellElem ) {
	    var lazyCellImages = getCellLazyImages( cellElem );
	    lazyImages = lazyImages.concat( lazyCellImages );
	  } );
	  // load lazy images
	  lazyImages.forEach( function( img ) {
	    new LazyLoader( img, this );
	  }, this );
	};
	
	function getCellLazyImages( cellElem ) {
	  // check if cell element is lazy image
	  if ( cellElem.nodeName == 'IMG' ) {
	    var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
	    var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
	    var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
	    if ( lazyloadAttr || srcAttr || srcsetAttr ) {
	      return [ cellElem ];
	    }
	  }
	  // select lazy images in cell
	  var lazySelector = 'img[data-flickity-lazyload], ' +
	    'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
	  var imgs = cellElem.querySelectorAll( lazySelector );
	  return utils.makeArray( imgs );
	}
	
	// -------------------------- LazyLoader -------------------------- //
	
	/**
	 * class to handle loading images
	 * @param {Image} img - Image element
	 * @param {Flickity} flickity - Flickity instance
	 */
	function LazyLoader( img, flickity ) {
	  this.img = img;
	  this.flickity = flickity;
	  this.load();
	}
	
	LazyLoader.prototype.handleEvent = utils.handleEvent;
	
	LazyLoader.prototype.load = function() {
	  this.img.addEventListener( 'load', this );
	  this.img.addEventListener( 'error', this );
	  // get src & srcset
	  var src = this.img.getAttribute('data-flickity-lazyload') ||
	    this.img.getAttribute('data-flickity-lazyload-src');
	  var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
	  // set src & serset
	  this.img.src = src;
	  if ( srcset ) {
	    this.img.setAttribute( 'srcset', srcset );
	  }
	  // remove attr
	  this.img.removeAttribute('data-flickity-lazyload');
	  this.img.removeAttribute('data-flickity-lazyload-src');
	  this.img.removeAttribute('data-flickity-lazyload-srcset');
	};
	
	LazyLoader.prototype.onload = function( event ) {
	  this.complete( event, 'flickity-lazyloaded' );
	};
	
	LazyLoader.prototype.onerror = function( event ) {
	  this.complete( event, 'flickity-lazyerror' );
	};
	
	LazyLoader.prototype.complete = function( event, className ) {
	  // unbind events
	  this.img.removeEventListener( 'load', this );
	  this.img.removeEventListener( 'error', this );
	
	  var cell = this.flickity.getParentCell( this.img );
	  var cellElem = cell && cell.element;
	  this.flickity.cellSizeChange( cellElem );
	
	  this.img.classList.add( className );
	  this.flickity.dispatchEvent( 'lazyLoad', event, cellElem );
	};
	
	// -----  ----- //
	
	Flickity.LazyLoader = LazyLoader;
	
	return Flickity;
	
	} ) );


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// page dots
	( function( window, factory ) {
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(48),
	      __webpack_require__(134),
	      __webpack_require__(38),
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, Unipointer, utils ) {
	      return factory( window, Flickity, Unipointer, utils );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	        window,
	        require('./flickity'),
	        require('unipointer'),
	        require('fizzy-ui-utils')
	    );
	  } else {
	    // browser global
	    factory(
	        window,
	        window.Flickity,
	        window.Unipointer,
	        window.fizzyUIUtils
	    );
	  }
	
	}( window, function factory( window, Flickity, Unipointer, utils ) {
	
	// -------------------------- PageDots -------------------------- //
	
	'use strict';
	
	function PageDots( parent ) {
	  this.parent = parent;
	  this._create();
	}
	
	PageDots.prototype = Object.create( Unipointer.prototype );
	
	PageDots.prototype._create = function() {
	  // create holder element
	  this.holder = document.createElement('ol');
	  this.holder.className = 'flickity-page-dots';
	  // create dots, array of elements
	  this.dots = [];
	  // events
	  this.handleClick = this.onClick.bind( this );
	  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
	};
	
	PageDots.prototype.activate = function() {
	  this.setDots();
	  this.holder.addEventListener( 'click', this.handleClick );
	  this.bindStartEvent( this.holder );
	  // add to DOM
	  this.parent.element.appendChild( this.holder );
	};
	
	PageDots.prototype.deactivate = function() {
	  this.holder.removeEventListener( 'click', this.handleClick );
	  this.unbindStartEvent( this.holder );
	  // remove from DOM
	  this.parent.element.removeChild( this.holder );
	};
	
	PageDots.prototype.setDots = function() {
	  // get difference between number of slides and number of dots
	  var delta = this.parent.slides.length - this.dots.length;
	  if ( delta > 0 ) {
	    this.addDots( delta );
	  } else if ( delta < 0 ) {
	    this.removeDots( -delta );
	  }
	};
	
	PageDots.prototype.addDots = function( count ) {
	  var fragment = document.createDocumentFragment();
	  var newDots = [];
	  var length = this.dots.length;
	  var max = length + count;
	
	  for ( var i = length; i < max; i++ ) {
	    var dot = document.createElement('li');
	    dot.className = 'dot';
	    dot.setAttribute( 'aria-label', 'Page dot ' + ( i + 1 ) );
	    fragment.appendChild( dot );
	    newDots.push( dot );
	  }
	
	  this.holder.appendChild( fragment );
	  this.dots = this.dots.concat( newDots );
	};
	
	PageDots.prototype.removeDots = function( count ) {
	  // remove from this.dots collection
	  var removeDots = this.dots.splice( this.dots.length - count, count );
	  // remove from DOM
	  removeDots.forEach( function( dot ) {
	    this.holder.removeChild( dot );
	  }, this );
	};
	
	PageDots.prototype.updateSelected = function() {
	  // remove selected class on previous
	  if ( this.selectedDot ) {
	    this.selectedDot.className = 'dot';
	    this.selectedDot.removeAttribute('aria-current');
	  }
	  // don't proceed if no dots
	  if ( !this.dots.length ) {
	    return;
	  }
	  this.selectedDot = this.dots[ this.parent.selectedIndex ];
	  this.selectedDot.className = 'dot is-selected';
	  this.selectedDot.setAttribute( 'aria-current', 'step' );
	};
	
	PageDots.prototype.onTap = // old method name, backwards-compatible
	PageDots.prototype.onClick = function( event ) {
	  var target = event.target;
	  // only care about dot clicks
	  if ( target.nodeName != 'LI' ) {
	    return;
	  }
	
	  this.parent.uiChange();
	  var index = this.dots.indexOf( target );
	  this.parent.select( index );
	};
	
	PageDots.prototype.destroy = function() {
	  this.deactivate();
	  this.allOff();
	};
	
	Flickity.PageDots = PageDots;
	
	// -------------------------- Flickity -------------------------- //
	
	utils.extend( Flickity.defaults, {
	  pageDots: true,
	} );
	
	Flickity.createMethods.push('_createPageDots');
	
	var proto = Flickity.prototype;
	
	proto._createPageDots = function() {
	  if ( !this.options.pageDots ) {
	    return;
	  }
	  this.pageDots = new PageDots( this );
	  // events
	  this.on( 'activate', this.activatePageDots );
	  this.on( 'select', this.updateSelectedPageDots );
	  this.on( 'cellChange', this.updatePageDots );
	  this.on( 'resize', this.updatePageDots );
	  this.on( 'deactivate', this.deactivatePageDots );
	};
	
	proto.activatePageDots = function() {
	  this.pageDots.activate();
	};
	
	proto.updateSelectedPageDots = function() {
	  this.pageDots.updateSelected();
	};
	
	proto.updatePageDots = function() {
	  this.pageDots.setDots();
	};
	
	proto.deactivatePageDots = function() {
	  this.pageDots.deactivate();
	};
	
	// -----  ----- //
	
	Flickity.PageDots = PageDots;
	
	return Flickity;
	
	} ) );


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// player & autoPlay
	( function( window, factory ) {
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(133),
	      __webpack_require__(38),
	      __webpack_require__(48),
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter, utils, Flickity ) {
	      return factory( EvEmitter, utils, Flickity );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	        require('ev-emitter'),
	        require('fizzy-ui-utils'),
	        require('./flickity')
	    );
	  } else {
	    // browser global
	    factory(
	        window.EvEmitter,
	        window.fizzyUIUtils,
	        window.Flickity
	    );
	  }
	
	}( window, function factory( EvEmitter, utils, Flickity ) {
	
	'use strict';
	
	// -------------------------- Player -------------------------- //
	
	function Player( parent ) {
	  this.parent = parent;
	  this.state = 'stopped';
	  // visibility change event handler
	  this.onVisibilityChange = this.visibilityChange.bind( this );
	  this.onVisibilityPlay = this.visibilityPlay.bind( this );
	}
	
	Player.prototype = Object.create( EvEmitter.prototype );
	
	// start play
	Player.prototype.play = function() {
	  if ( this.state == 'playing' ) {
	    return;
	  }
	  // do not play if page is hidden, start playing when page is visible
	  var isPageHidden = document.hidden;
	  if ( isPageHidden ) {
	    document.addEventListener( 'visibilitychange', this.onVisibilityPlay );
	    return;
	  }
	
	  this.state = 'playing';
	  // listen to visibility change
	  document.addEventListener( 'visibilitychange', this.onVisibilityChange );
	  // start ticking
	  this.tick();
	};
	
	Player.prototype.tick = function() {
	  // do not tick if not playing
	  if ( this.state != 'playing' ) {
	    return;
	  }
	
	  var time = this.parent.options.autoPlay;
	  // default to 3 seconds
	  time = typeof time == 'number' ? time : 3000;
	  var _this = this;
	  // HACK: reset ticks if stopped and started within interval
	  this.clear();
	  this.timeout = setTimeout( function() {
	    _this.parent.next( true );
	    _this.tick();
	  }, time );
	};
	
	Player.prototype.stop = function() {
	  this.state = 'stopped';
	  this.clear();
	  // remove visibility change event
	  document.removeEventListener( 'visibilitychange', this.onVisibilityChange );
	};
	
	Player.prototype.clear = function() {
	  clearTimeout( this.timeout );
	};
	
	Player.prototype.pause = function() {
	  if ( this.state == 'playing' ) {
	    this.state = 'paused';
	    this.clear();
	  }
	};
	
	Player.prototype.unpause = function() {
	  // re-start play if paused
	  if ( this.state == 'paused' ) {
	    this.play();
	  }
	};
	
	// pause if page visibility is hidden, unpause if visible
	Player.prototype.visibilityChange = function() {
	  var isPageHidden = document.hidden;
	  this[ isPageHidden ? 'pause' : 'unpause' ]();
	};
	
	Player.prototype.visibilityPlay = function() {
	  this.play();
	  document.removeEventListener( 'visibilitychange', this.onVisibilityPlay );
	};
	
	// -------------------------- Flickity -------------------------- //
	
	utils.extend( Flickity.defaults, {
	  pauseAutoPlayOnHover: true,
	} );
	
	Flickity.createMethods.push('_createPlayer');
	var proto = Flickity.prototype;
	
	proto._createPlayer = function() {
	  this.player = new Player( this );
	
	  this.on( 'activate', this.activatePlayer );
	  this.on( 'uiChange', this.stopPlayer );
	  this.on( 'pointerDown', this.stopPlayer );
	  this.on( 'deactivate', this.deactivatePlayer );
	};
	
	proto.activatePlayer = function() {
	  if ( !this.options.autoPlay ) {
	    return;
	  }
	  this.player.play();
	  this.element.addEventListener( 'mouseenter', this );
	};
	
	// Player API, don't hate the ... thanks I know where the door is
	
	proto.playPlayer = function() {
	  this.player.play();
	};
	
	proto.stopPlayer = function() {
	  this.player.stop();
	};
	
	proto.pausePlayer = function() {
	  this.player.pause();
	};
	
	proto.unpausePlayer = function() {
	  this.player.unpause();
	};
	
	proto.deactivatePlayer = function() {
	  this.player.stop();
	  this.element.removeEventListener( 'mouseenter', this );
	};
	
	// ----- mouseenter/leave ----- //
	
	// pause auto-play on hover
	proto.onmouseenter = function() {
	  if ( !this.options.pauseAutoPlayOnHover ) {
	    return;
	  }
	  this.player.pause();
	  this.element.addEventListener( 'mouseleave', this );
	};
	
	// resume auto-play on hover off
	proto.onmouseleave = function() {
	  this.player.unpause();
	  this.element.removeEventListener( 'mouseleave', this );
	};
	
	// -----  ----- //
	
	Flickity.Player = Player;
	
	return Flickity;
	
	} ) );


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// prev/next buttons
	( function( window, factory ) {
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(48),
	      __webpack_require__(134),
	      __webpack_require__(38),
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, Unipointer, utils ) {
	      return factory( window, Flickity, Unipointer, utils );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	        window,
	        require('./flickity'),
	        require('unipointer'),
	        require('fizzy-ui-utils')
	    );
	  } else {
	    // browser global
	    factory(
	        window,
	        window.Flickity,
	        window.Unipointer,
	        window.fizzyUIUtils
	    );
	  }
	
	}( window, function factory( window, Flickity, Unipointer, utils ) {
	'use strict';
	
	var svgURI = 'http://www.w3.org/2000/svg';
	
	// -------------------------- PrevNextButton -------------------------- //
	
	function PrevNextButton( direction, parent ) {
	  this.direction = direction;
	  this.parent = parent;
	  this._create();
	}
	
	PrevNextButton.prototype = Object.create( Unipointer.prototype );
	
	PrevNextButton.prototype._create = function() {
	  // properties
	  this.isEnabled = true;
	  this.isPrevious = this.direction == -1;
	  var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
	  this.isLeft = this.direction == leftDirection;
	
	  var element = this.element = document.createElement('button');
	  element.className = 'flickity-button flickity-prev-next-button';
	  element.className += this.isPrevious ? ' previous' : ' next';
	  // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
	  element.setAttribute( 'type', 'button' );
	  // init as disabled
	  this.disable();
	
	  element.setAttribute( 'aria-label', this.isPrevious ? 'Previous' : 'Next' );
	
	  // create arrow
	  var svg = this.createSVG();
	  element.appendChild( svg );
	  // events
	  this.parent.on( 'select', this.update.bind( this ) );
	  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
	};
	
	PrevNextButton.prototype.activate = function() {
	  this.bindStartEvent( this.element );
	  this.element.addEventListener( 'click', this );
	  // add to DOM
	  this.parent.element.appendChild( this.element );
	};
	
	PrevNextButton.prototype.deactivate = function() {
	  // remove from DOM
	  this.parent.element.removeChild( this.element );
	  // click events
	  this.unbindStartEvent( this.element );
	  this.element.removeEventListener( 'click', this );
	};
	
	PrevNextButton.prototype.createSVG = function() {
	  var svg = document.createElementNS( svgURI, 'svg' );
	  svg.setAttribute( 'class', 'flickity-button-icon' );
	  svg.setAttribute( 'viewBox', '0 0 100 100' );
	  var path = document.createElementNS( svgURI, 'path' );
	  var pathMovements = getArrowMovements( this.parent.options.arrowShape );
	  path.setAttribute( 'd', pathMovements );
	  path.setAttribute( 'class', 'arrow' );
	  // rotate arrow
	  if ( !this.isLeft ) {
	    path.setAttribute( 'transform', 'translate(100, 100) rotate(180) ' );
	  }
	  svg.appendChild( path );
	  return svg;
	};
	
	// get SVG path movmement
	function getArrowMovements( shape ) {
	  // use shape as movement if string
	  if ( typeof shape == 'string' ) {
	    return shape;
	  }
	  // create movement string
	  return 'M ' + shape.x0 + ',50' +
	    ' L ' + shape.x1 + ',' + ( shape.y1 + 50 ) +
	    ' L ' + shape.x2 + ',' + ( shape.y2 + 50 ) +
	    ' L ' + shape.x3 + ',50 ' +
	    ' L ' + shape.x2 + ',' + ( 50 - shape.y2 ) +
	    ' L ' + shape.x1 + ',' + ( 50 - shape.y1 ) +
	    ' Z';
	}
	
	PrevNextButton.prototype.handleEvent = utils.handleEvent;
	
	PrevNextButton.prototype.onclick = function() {
	  if ( !this.isEnabled ) {
	    return;
	  }
	  this.parent.uiChange();
	  var method = this.isPrevious ? 'previous' : 'next';
	  this.parent[ method ]();
	};
	
	// -----  ----- //
	
	PrevNextButton.prototype.enable = function() {
	  if ( this.isEnabled ) {
	    return;
	  }
	  this.element.disabled = false;
	  this.isEnabled = true;
	};
	
	PrevNextButton.prototype.disable = function() {
	  if ( !this.isEnabled ) {
	    return;
	  }
	  this.element.disabled = true;
	  this.isEnabled = false;
	};
	
	PrevNextButton.prototype.update = function() {
	  // index of first or last slide, if previous or next
	  var slides = this.parent.slides;
	  // enable is wrapAround and at least 2 slides
	  if ( this.parent.options.wrapAround && slides.length > 1 ) {
	    this.enable();
	    return;
	  }
	  var lastIndex = slides.length ? slides.length - 1 : 0;
	  var boundIndex = this.isPrevious ? 0 : lastIndex;
	  var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
	  this[ method ]();
	};
	
	PrevNextButton.prototype.destroy = function() {
	  this.deactivate();
	  this.allOff();
	};
	
	// -------------------------- Flickity prototype -------------------------- //
	
	utils.extend( Flickity.defaults, {
	  prevNextButtons: true,
	  arrowShape: {
	    x0: 10,
	    x1: 60, y1: 50,
	    x2: 70, y2: 40,
	    x3: 30,
	  },
	} );
	
	Flickity.createMethods.push('_createPrevNextButtons');
	var proto = Flickity.prototype;
	
	proto._createPrevNextButtons = function() {
	  if ( !this.options.prevNextButtons ) {
	    return;
	  }
	
	  this.prevButton = new PrevNextButton( -1, this );
	  this.nextButton = new PrevNextButton( 1, this );
	
	  this.on( 'activate', this.activatePrevNextButtons );
	};
	
	proto.activatePrevNextButtons = function() {
	  this.prevButton.activate();
	  this.nextButton.activate();
	  this.on( 'deactivate', this.deactivatePrevNextButtons );
	};
	
	proto.deactivatePrevNextButtons = function() {
	  this.prevButton.deactivate();
	  this.nextButton.deactivate();
	  this.off( 'deactivate', this.deactivatePrevNextButtons );
	};
	
	// --------------------------  -------------------------- //
	
	Flickity.PrevNextButton = PrevNextButton;
	
	return Flickity;
	
	} ) );


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// slide
	( function( window, factory ) {
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // browser global
	    window.Flickity = window.Flickity || {};
	    window.Flickity.Slide = factory();
	  }
	
	}( window, function factory() {
	'use strict';
	
	function Slide( parent ) {
	  this.parent = parent;
	  this.isOriginLeft = parent.originSide == 'left';
	  this.cells = [];
	  this.outerWidth = 0;
	  this.height = 0;
	}
	
	var proto = Slide.prototype;
	
	proto.addCell = function( cell ) {
	  this.cells.push( cell );
	  this.outerWidth += cell.size.outerWidth;
	  this.height = Math.max( cell.size.outerHeight, this.height );
	  // first cell stuff
	  if ( this.cells.length == 1 ) {
	    this.x = cell.x; // x comes from first cell
	    var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
	    this.firstMargin = cell.size[ beginMargin ];
	  }
	};
	
	proto.updateTarget = function() {
	  var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
	  var lastCell = this.getLastCell();
	  var lastMargin = lastCell ? lastCell.size[ endMargin ] : 0;
	  var slideWidth = this.outerWidth - ( this.firstMargin + lastMargin );
	  this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
	};
	
	proto.getLastCell = function() {
	  return this.cells[ this.cells.length - 1 ];
	};
	
	proto.select = function() {
	  this.cells.forEach( function( cell ) {
	    cell.select();
	  } );
	};
	
	proto.unselect = function() {
	  this.cells.forEach( function( cell ) {
	    cell.unselect();
	  } );
	};
	
	proto.getCellElements = function() {
	  return this.cells.map( function( cell ) {
	    return cell.element;
	  } );
	};
	
	return Slide;
	
	} ) );


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, $) {/*! Sortable 1.15.6 - MIT | git://github.com/SortableJS/Sortable.git */
	!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):(t=t||self).Sortable=e()}(this,function(){"use strict";function e(e,t){var n,o=Object.keys(e);return Object.getOwnPropertySymbols&&(n=Object.getOwnPropertySymbols(e),t&&(n=n.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),o.push.apply(o,n)),o}function I(o){for(var t=1;t<arguments.length;t++){var i=null!=arguments[t]?arguments[t]:{};t%2?e(Object(i),!0).forEach(function(t){var e,n;e=o,t=i[n=t],n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t}):Object.getOwnPropertyDescriptors?Object.defineProperties(o,Object.getOwnPropertyDescriptors(i)):e(Object(i)).forEach(function(t){Object.defineProperty(o,t,Object.getOwnPropertyDescriptor(i,t))})}return o}function o(t){return(o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function a(){return(a=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n,o=arguments[e];for(n in o)Object.prototype.hasOwnProperty.call(o,n)&&(t[n]=o[n])}return t}).apply(this,arguments)}function i(t,e){if(null==t)return{};var n,o=function(t,e){if(null==t)return{};for(var n,o={},i=Object.keys(t),r=0;r<i.length;r++)n=i[r],0<=e.indexOf(n)||(o[n]=t[n]);return o}(t,e);if(Object.getOwnPropertySymbols)for(var i=Object.getOwnPropertySymbols(t),r=0;r<i.length;r++)n=i[r],0<=e.indexOf(n)||Object.prototype.propertyIsEnumerable.call(t,n)&&(o[n]=t[n]);return o}function r(t){return function(t){if(Array.isArray(t))return l(t)}(t)||function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(t)||function(t,e){if(t){if("string"==typeof t)return l(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Map"===(n="Object"===n&&t.constructor?t.constructor.name:n)||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?l(t,e):void 0}}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function l(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,o=new Array(e);n<e;n++)o[n]=t[n];return o}function t(t){if("undefined"!=typeof window&&window.navigator)return!!navigator.userAgent.match(t)}var y=t(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i),w=t(/Edge/i),s=t(/firefox/i),u=t(/safari/i)&&!t(/chrome/i)&&!t(/android/i),c=t(/iP(ad|od|hone)/i),n=t(/chrome/i)&&t(/android/i),d={capture:!1,passive:!1};function h(t,e,n){t.addEventListener(e,n,!y&&d)}function p(t,e,n){t.removeEventListener(e,n,!y&&d)}function f(t,e){if(e&&(">"===e[0]&&(e=e.substring(1)),t))try{if(t.matches)return t.matches(e);if(t.msMatchesSelector)return t.msMatchesSelector(e);if(t.webkitMatchesSelector)return t.webkitMatchesSelector(e)}catch(t){return}}function g(t){return t.host&&t!==document&&t.host.nodeType?t.host:t.parentNode}function P(t,e,n,o){if(t){n=n||document;do{if(null!=e&&(">"!==e[0]||t.parentNode===n)&&f(t,e)||o&&t===n)return t}while(t!==n&&(t=g(t)))}return null}var m,v=/\s+/g;function k(t,e,n){var o;t&&e&&(t.classList?t.classList[n?"add":"remove"](e):(o=(" "+t.className+" ").replace(v," ").replace(" "+e+" "," "),t.className=(o+(n?" "+e:"")).replace(v," ")))}function R(t,e,n){var o=t&&t.style;if(o){if(void 0===n)return document.defaultView&&document.defaultView.getComputedStyle?n=document.defaultView.getComputedStyle(t,""):t.currentStyle&&(n=t.currentStyle),void 0===e?n:n[e];o[e=!(e in o||-1!==e.indexOf("webkit"))?"-webkit-"+e:e]=n+("string"==typeof n?"":"px")}}function b(t,e){var n="";if("string"==typeof t)n=t;else do{var o=R(t,"transform")}while(o&&"none"!==o&&(n=o+" "+n),!e&&(t=t.parentNode));var i=window.DOMMatrix||window.WebKitCSSMatrix||window.CSSMatrix||window.MSCSSMatrix;return i&&new i(n)}function D(t,e,n){if(t){var o=t.getElementsByTagName(e),i=0,r=o.length;if(n)for(;i<r;i++)n(o[i],i);return o}return[]}function O(){var t=document.scrollingElement;return t||document.documentElement}function X(t,e,n,o,i){if(t.getBoundingClientRect||t===window){var r,a,l,s,c,u,d=t!==window&&t.parentNode&&t!==O()?(a=(r=t.getBoundingClientRect()).top,l=r.left,s=r.bottom,c=r.right,u=r.height,r.width):(l=a=0,s=window.innerHeight,c=window.innerWidth,u=window.innerHeight,window.innerWidth);if((e||n)&&t!==window&&(i=i||t.parentNode,!y))do{if(i&&i.getBoundingClientRect&&("none"!==R(i,"transform")||n&&"static"!==R(i,"position"))){var h=i.getBoundingClientRect();a-=h.top+parseInt(R(i,"border-top-width")),l-=h.left+parseInt(R(i,"border-left-width")),s=a+r.height,c=l+r.width;break}}while(i=i.parentNode);return o&&t!==window&&(o=(e=b(i||t))&&e.a,t=e&&e.d,e&&(s=(a/=t)+(u/=t),c=(l/=o)+(d/=o))),{top:a,left:l,bottom:s,right:c,width:d,height:u}}}function Y(t,e,n){for(var o=M(t,!0),i=X(t)[e];o;){var r=X(o)[n];if(!("top"===n||"left"===n?r<=i:i<=r))return o;if(o===O())break;o=M(o,!1)}return!1}function B(t,e,n,o){for(var i=0,r=0,a=t.children;r<a.length;){if("none"!==a[r].style.display&&a[r]!==jt.ghost&&(o||a[r]!==jt.dragged)&&P(a[r],n.draggable,t,!1)){if(i===e)return a[r];i++}r++}return null}function F(t,e){for(var n=t.lastElementChild;n&&(n===jt.ghost||"none"===R(n,"display")||e&&!f(n,e));)n=n.previousElementSibling;return n||null}function j(t,e){var n=0;if(!t||!t.parentNode)return-1;for(;t=t.previousElementSibling;)"TEMPLATE"===t.nodeName.toUpperCase()||t===jt.clone||e&&!f(t,e)||n++;return n}function E(t){var e=0,n=0,o=O();if(t)do{var i=b(t),r=i.a,i=i.d}while(e+=t.scrollLeft*r,n+=t.scrollTop*i,t!==o&&(t=t.parentNode));return[e,n]}function M(t,e){if(!t||!t.getBoundingClientRect)return O();var n=t,o=!1;do{if(n.clientWidth<n.scrollWidth||n.clientHeight<n.scrollHeight){var i=R(n);if(n.clientWidth<n.scrollWidth&&("auto"==i.overflowX||"scroll"==i.overflowX)||n.clientHeight<n.scrollHeight&&("auto"==i.overflowY||"scroll"==i.overflowY)){if(!n.getBoundingClientRect||n===document.body)return O();if(o||e)return n;o=!0}}}while(n=n.parentNode);return O()}function S(t,e){return Math.round(t.top)===Math.round(e.top)&&Math.round(t.left)===Math.round(e.left)&&Math.round(t.height)===Math.round(e.height)&&Math.round(t.width)===Math.round(e.width)}function _(e,n){return function(){var t;m||(1===(t=arguments).length?e.call(this,t[0]):e.apply(this,t),m=setTimeout(function(){m=void 0},n))}}function H(t,e,n){t.scrollLeft+=e,t.scrollTop+=n}function C(t){var e=window.Polymer,n=__webpack_provided_window_dot_jQuery||window.Zepto;return e&&e.dom?e.dom(t).cloneNode(!0):n?n(t).clone(!0)[0]:t.cloneNode(!0)}function T(t,e){R(t,"position","absolute"),R(t,"top",e.top),R(t,"left",e.left),R(t,"width",e.width),R(t,"height",e.height)}function x(t){R(t,"position",""),R(t,"top",""),R(t,"left",""),R(t,"width",""),R(t,"height","")}function L(n,o,i){var r={};return Array.from(n.children).forEach(function(t){var e;P(t,o.draggable,n,!1)&&!t.animated&&t!==i&&(e=X(t),r.left=Math.min(null!==(t=r.left)&&void 0!==t?t:1/0,e.left),r.top=Math.min(null!==(t=r.top)&&void 0!==t?t:1/0,e.top),r.right=Math.max(null!==(t=r.right)&&void 0!==t?t:-1/0,e.right),r.bottom=Math.max(null!==(t=r.bottom)&&void 0!==t?t:-1/0,e.bottom))}),r.width=r.right-r.left,r.height=r.bottom-r.top,r.x=r.left,r.y=r.top,r}var K="Sortable"+(new Date).getTime();function A(){var e,o=[];return{captureAnimationState:function(){o=[],this.options.animation&&[].slice.call(this.el.children).forEach(function(t){var e,n;"none"!==R(t,"display")&&t!==jt.ghost&&(o.push({target:t,rect:X(t)}),e=I({},o[o.length-1].rect),!t.thisAnimationDuration||(n=b(t,!0))&&(e.top-=n.f,e.left-=n.e),t.fromRect=e)})},addAnimationState:function(t){o.push(t)},removeAnimationState:function(t){o.splice(function(t,e){for(var n in t)if(t.hasOwnProperty(n))for(var o in e)if(e.hasOwnProperty(o)&&e[o]===t[n][o])return Number(n);return-1}(o,{target:t}),1)},animateAll:function(t){var c=this;if(!this.options.animation)return clearTimeout(e),void("function"==typeof t&&t());var u=!1,d=0;o.forEach(function(t){var e=0,n=t.target,o=n.fromRect,i=X(n),r=n.prevFromRect,a=n.prevToRect,l=t.rect,s=b(n,!0);s&&(i.top-=s.f,i.left-=s.e),n.toRect=i,n.thisAnimationDuration&&S(r,i)&&!S(o,i)&&(l.top-i.top)/(l.left-i.left)==(o.top-i.top)/(o.left-i.left)&&(t=l,s=r,r=a,a=c.options,e=Math.sqrt(Math.pow(s.top-t.top,2)+Math.pow(s.left-t.left,2))/Math.sqrt(Math.pow(s.top-r.top,2)+Math.pow(s.left-r.left,2))*a.animation),S(i,o)||(n.prevFromRect=o,n.prevToRect=i,e=e||c.options.animation,c.animate(n,l,i,e)),e&&(u=!0,d=Math.max(d,e),clearTimeout(n.animationResetTimer),n.animationResetTimer=setTimeout(function(){n.animationTime=0,n.prevFromRect=null,n.fromRect=null,n.prevToRect=null,n.thisAnimationDuration=null},e),n.thisAnimationDuration=e)}),clearTimeout(e),u?e=setTimeout(function(){"function"==typeof t&&t()},d):"function"==typeof t&&t(),o=[]},animate:function(t,e,n,o){var i,r;o&&(R(t,"transition",""),R(t,"transform",""),i=(r=b(this.el))&&r.a,r=r&&r.d,i=(e.left-n.left)/(i||1),r=(e.top-n.top)/(r||1),t.animatingX=!!i,t.animatingY=!!r,R(t,"transform","translate3d("+i+"px,"+r+"px,0)"),this.forRepaintDummy=t.offsetWidth,R(t,"transition","transform "+o+"ms"+(this.options.easing?" "+this.options.easing:"")),R(t,"transform","translate3d(0,0,0)"),"number"==typeof t.animated&&clearTimeout(t.animated),t.animated=setTimeout(function(){R(t,"transition",""),R(t,"transform",""),t.animated=!1,t.animatingX=!1,t.animatingY=!1},o))}}}var N=[],W={initializeByDefault:!0},z={mount:function(e){for(var t in W)!W.hasOwnProperty(t)||t in e||(e[t]=W[t]);N.forEach(function(t){if(t.pluginName===e.pluginName)throw"Sortable: Cannot mount plugin ".concat(e.pluginName," more than once")}),N.push(e)},pluginEvent:function(e,n,o){var t=this;this.eventCanceled=!1,o.cancel=function(){t.eventCanceled=!0};var i=e+"Global";N.forEach(function(t){n[t.pluginName]&&(n[t.pluginName][i]&&n[t.pluginName][i](I({sortable:n},o)),n.options[t.pluginName]&&n[t.pluginName][e]&&n[t.pluginName][e](I({sortable:n},o)))})},initializePlugins:function(n,o,i,t){for(var e in N.forEach(function(t){var e=t.pluginName;(n.options[e]||t.initializeByDefault)&&((t=new t(n,o,n.options)).sortable=n,t.options=n.options,n[e]=t,a(i,t.defaults))}),n.options){var r;n.options.hasOwnProperty(e)&&(void 0!==(r=this.modifyOption(n,e,n.options[e]))&&(n.options[e]=r))}},getEventProperties:function(e,n){var o={};return N.forEach(function(t){"function"==typeof t.eventProperties&&a(o,t.eventProperties.call(n[t.pluginName],e))}),o},modifyOption:function(e,n,o){var i;return N.forEach(function(t){e[t.pluginName]&&t.optionListeners&&"function"==typeof t.optionListeners[n]&&(i=t.optionListeners[n].call(e[t.pluginName],o))}),i}};function G(t){var e=t.sortable,n=t.rootEl,o=t.name,i=t.targetEl,r=t.cloneEl,a=t.toEl,l=t.fromEl,s=t.oldIndex,c=t.newIndex,u=t.oldDraggableIndex,d=t.newDraggableIndex,h=t.originalEvent,p=t.putSortable,f=t.extraEventProperties;if(e=e||n&&n[K]){var g,m=e.options,t="on"+o.charAt(0).toUpperCase()+o.substr(1);!window.CustomEvent||y||w?(g=document.createEvent("Event")).initEvent(o,!0,!0):g=new CustomEvent(o,{bubbles:!0,cancelable:!0}),g.to=a||n,g.from=l||n,g.item=i||n,g.clone=r,g.oldIndex=s,g.newIndex=c,g.oldDraggableIndex=u,g.newDraggableIndex=d,g.originalEvent=h,g.pullMode=p?p.lastPutMode:void 0;var v,b=I(I({},f),z.getEventProperties(o,e));for(v in b)g[v]=b[v];n&&n.dispatchEvent(g),m[t]&&m[t].call(e,g)}}function U(t,e){var n=(o=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{}).evt,o=i(o,q);z.pluginEvent.bind(jt)(t,e,I({dragEl:Z,parentEl:$,ghostEl:Q,rootEl:J,nextEl:tt,lastDownEl:et,cloneEl:nt,cloneHidden:ot,dragStarted:mt,putSortable:ct,activeSortable:jt.active,originalEvent:n,oldIndex:it,oldDraggableIndex:at,newIndex:rt,newDraggableIndex:lt,hideGhostForTarget:Xt,unhideGhostForTarget:Yt,cloneNowHidden:function(){ot=!0},cloneNowShown:function(){ot=!1},dispatchSortableEvent:function(t){V({sortable:e,name:t,originalEvent:n})}},o))}var q=["evt"];function V(t){G(I({putSortable:ct,cloneEl:nt,targetEl:Z,rootEl:J,oldIndex:it,oldDraggableIndex:at,newIndex:rt,newDraggableIndex:lt},t))}var Z,$,Q,J,tt,et,nt,ot,it,rt,at,lt,st,ct,ut,dt,ht,pt,ft,gt,mt,vt,bt,yt,wt,Dt=!1,Et=!1,St=[],_t=!1,Ct=!1,Tt=[],xt=!1,Ot=[],Mt="undefined"!=typeof document,At=c,Nt=w||y?"cssFloat":"float",It=Mt&&!n&&!c&&"draggable"in document.createElement("div"),Pt=function(){if(Mt){if(y)return!1;var t=document.createElement("x");return t.style.cssText="pointer-events:auto","auto"===t.style.pointerEvents}}(),kt=function(t,e){var n=R(t),o=parseInt(n.width)-parseInt(n.paddingLeft)-parseInt(n.paddingRight)-parseInt(n.borderLeftWidth)-parseInt(n.borderRightWidth),i=B(t,0,e),r=B(t,1,e),a=i&&R(i),l=r&&R(r),s=a&&parseInt(a.marginLeft)+parseInt(a.marginRight)+X(i).width,t=l&&parseInt(l.marginLeft)+parseInt(l.marginRight)+X(r).width;if("flex"===n.display)return"column"===n.flexDirection||"column-reverse"===n.flexDirection?"vertical":"horizontal";if("grid"===n.display)return n.gridTemplateColumns.split(" ").length<=1?"vertical":"horizontal";if(i&&a.float&&"none"!==a.float){e="left"===a.float?"left":"right";return!r||"both"!==l.clear&&l.clear!==e?"horizontal":"vertical"}return i&&("block"===a.display||"flex"===a.display||"table"===a.display||"grid"===a.display||o<=s&&"none"===n[Nt]||r&&"none"===n[Nt]&&o<s+t)?"vertical":"horizontal"},Rt=function(t){function l(r,a){return function(t,e,n,o){var i=t.options.group.name&&e.options.group.name&&t.options.group.name===e.options.group.name;if(null==r&&(a||i))return!0;if(null==r||!1===r)return!1;if(a&&"clone"===r)return r;if("function"==typeof r)return l(r(t,e,n,o),a)(t,e,n,o);e=(a?t:e).options.group.name;return!0===r||"string"==typeof r&&r===e||r.join&&-1<r.indexOf(e)}}var e={},n=t.group;n&&"object"==o(n)||(n={name:n}),e.name=n.name,e.checkPull=l(n.pull,!0),e.checkPut=l(n.put),e.revertClone=n.revertClone,t.group=e},Xt=function(){!Pt&&Q&&R(Q,"display","none")},Yt=function(){!Pt&&Q&&R(Q,"display","")};Mt&&!n&&document.addEventListener("click",function(t){if(Et)return t.preventDefault(),t.stopPropagation&&t.stopPropagation(),t.stopImmediatePropagation&&t.stopImmediatePropagation(),Et=!1},!0);function Bt(t){if(Z){t=t.touches?t.touches[0]:t;var e=(i=t.clientX,r=t.clientY,St.some(function(t){var e=t[K].options.emptyInsertThreshold;if(e&&!F(t)){var n=X(t),o=i>=n.left-e&&i<=n.right+e,e=r>=n.top-e&&r<=n.bottom+e;return o&&e?a=t:void 0}}),a);if(e){var n,o={};for(n in t)t.hasOwnProperty(n)&&(o[n]=t[n]);o.target=o.rootEl=e,o.preventDefault=void 0,o.stopPropagation=void 0,e[K]._onDragOver(o)}}var i,r,a}function Ft(t){Z&&Z.parentNode[K]._isOutsideThisEl(t.target)}function jt(t,e){if(!t||!t.nodeType||1!==t.nodeType)throw"Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(t));this.el=t,this.options=e=a({},e),t[K]=this;var n,o,i={group:null,sort:!0,disabled:!1,store:null,handle:null,draggable:/^[uo]l$/i.test(t.nodeName)?">li":">*",swapThreshold:1,invertSwap:!1,invertedSwapThreshold:null,removeCloneOnHide:!0,direction:function(){return kt(t,this.options)},ghostClass:"sortable-ghost",chosenClass:"sortable-chosen",dragClass:"sortable-drag",ignore:"a, img",filter:null,preventOnFilter:!0,animation:0,easing:null,setData:function(t,e){t.setData("Text",e.textContent)},dropBubble:!1,dragoverBubble:!1,dataIdAttr:"data-id",delay:0,delayOnTouchOnly:!1,touchStartThreshold:(Number.parseInt?Number:window).parseInt(window.devicePixelRatio,10)||1,forceFallback:!1,fallbackClass:"sortable-fallback",fallbackOnBody:!1,fallbackTolerance:0,fallbackOffset:{x:0,y:0},supportPointer:!1!==jt.supportPointer&&"PointerEvent"in window&&(!u||c),emptyInsertThreshold:5};for(n in z.initializePlugins(this,t,i),i)n in e||(e[n]=i[n]);for(o in Rt(e),this)"_"===o.charAt(0)&&"function"==typeof this[o]&&(this[o]=this[o].bind(this));this.nativeDraggable=!e.forceFallback&&It,this.nativeDraggable&&(this.options.touchStartThreshold=1),e.supportPointer?h(t,"pointerdown",this._onTapStart):(h(t,"mousedown",this._onTapStart),h(t,"touchstart",this._onTapStart)),this.nativeDraggable&&(h(t,"dragover",this),h(t,"dragenter",this)),St.push(this.el),e.store&&e.store.get&&this.sort(e.store.get(this)||[]),a(this,A())}function Ht(t,e,n,o,i,r,a,l){var s,c,u=t[K],d=u.options.onMove;return!window.CustomEvent||y||w?(s=document.createEvent("Event")).initEvent("move",!0,!0):s=new CustomEvent("move",{bubbles:!0,cancelable:!0}),s.to=e,s.from=t,s.dragged=n,s.draggedRect=o,s.related=i||e,s.relatedRect=r||X(e),s.willInsertAfter=l,s.originalEvent=a,t.dispatchEvent(s),c=d?d.call(u,s,a):c}function Lt(t){t.draggable=!1}function Kt(){xt=!1}function Wt(t){return setTimeout(t,0)}function zt(t){return clearTimeout(t)}jt.prototype={constructor:jt,_isOutsideThisEl:function(t){this.el.contains(t)||t===this.el||(vt=null)},_getDirection:function(t,e){return"function"==typeof this.options.direction?this.options.direction.call(this,t,e,Z):this.options.direction},_onTapStart:function(e){if(e.cancelable){var n=this,o=this.el,t=this.options,i=t.preventOnFilter,r=e.type,a=e.touches&&e.touches[0]||e.pointerType&&"touch"===e.pointerType&&e,l=(a||e).target,s=e.target.shadowRoot&&(e.path&&e.path[0]||e.composedPath&&e.composedPath()[0])||l,c=t.filter;if(!function(t){Ot.length=0;var e=t.getElementsByTagName("input"),n=e.length;for(;n--;){var o=e[n];o.checked&&Ot.push(o)}}(o),!Z&&!(/mousedown|pointerdown/.test(r)&&0!==e.button||t.disabled)&&!s.isContentEditable&&(this.nativeDraggable||!u||!l||"SELECT"!==l.tagName.toUpperCase())&&!((l=P(l,t.draggable,o,!1))&&l.animated||et===l)){if(it=j(l),at=j(l,t.draggable),"function"==typeof c){if(c.call(this,e,l,this))return V({sortable:n,rootEl:s,name:"filter",targetEl:l,toEl:o,fromEl:o}),U("filter",n,{evt:e}),void(i&&e.preventDefault())}else if(c=c&&c.split(",").some(function(t){if(t=P(s,t.trim(),o,!1))return V({sortable:n,rootEl:t,name:"filter",targetEl:l,fromEl:o,toEl:o}),U("filter",n,{evt:e}),!0}))return void(i&&e.preventDefault());t.handle&&!P(s,t.handle,o,!1)||this._prepareDragStart(e,a,l)}}},_prepareDragStart:function(t,e,n){var o,i=this,r=i.el,a=i.options,l=r.ownerDocument;n&&!Z&&n.parentNode===r&&(o=X(n),J=r,$=(Z=n).parentNode,tt=Z.nextSibling,et=n,st=a.group,ut={target:jt.dragged=Z,clientX:(e||t).clientX,clientY:(e||t).clientY},ft=ut.clientX-o.left,gt=ut.clientY-o.top,this._lastX=(e||t).clientX,this._lastY=(e||t).clientY,Z.style["will-change"]="all",o=function(){U("delayEnded",i,{evt:t}),jt.eventCanceled?i._onDrop():(i._disableDelayedDragEvents(),!s&&i.nativeDraggable&&(Z.draggable=!0),i._triggerDragStart(t,e),V({sortable:i,name:"choose",originalEvent:t}),k(Z,a.chosenClass,!0))},a.ignore.split(",").forEach(function(t){D(Z,t.trim(),Lt)}),h(l,"dragover",Bt),h(l,"mousemove",Bt),h(l,"touchmove",Bt),a.supportPointer?(h(l,"pointerup",i._onDrop),this.nativeDraggable||h(l,"pointercancel",i._onDrop)):(h(l,"mouseup",i._onDrop),h(l,"touchend",i._onDrop),h(l,"touchcancel",i._onDrop)),s&&this.nativeDraggable&&(this.options.touchStartThreshold=4,Z.draggable=!0),U("delayStart",this,{evt:t}),!a.delay||a.delayOnTouchOnly&&!e||this.nativeDraggable&&(w||y)?o():jt.eventCanceled?this._onDrop():(a.supportPointer?(h(l,"pointerup",i._disableDelayedDrag),h(l,"pointercancel",i._disableDelayedDrag)):(h(l,"mouseup",i._disableDelayedDrag),h(l,"touchend",i._disableDelayedDrag),h(l,"touchcancel",i._disableDelayedDrag)),h(l,"mousemove",i._delayedDragTouchMoveHandler),h(l,"touchmove",i._delayedDragTouchMoveHandler),a.supportPointer&&h(l,"pointermove",i._delayedDragTouchMoveHandler),i._dragStartTimer=setTimeout(o,a.delay)))},_delayedDragTouchMoveHandler:function(t){t=t.touches?t.touches[0]:t;Math.max(Math.abs(t.clientX-this._lastX),Math.abs(t.clientY-this._lastY))>=Math.floor(this.options.touchStartThreshold/(this.nativeDraggable&&window.devicePixelRatio||1))&&this._disableDelayedDrag()},_disableDelayedDrag:function(){Z&&Lt(Z),clearTimeout(this._dragStartTimer),this._disableDelayedDragEvents()},_disableDelayedDragEvents:function(){var t=this.el.ownerDocument;p(t,"mouseup",this._disableDelayedDrag),p(t,"touchend",this._disableDelayedDrag),p(t,"touchcancel",this._disableDelayedDrag),p(t,"pointerup",this._disableDelayedDrag),p(t,"pointercancel",this._disableDelayedDrag),p(t,"mousemove",this._delayedDragTouchMoveHandler),p(t,"touchmove",this._delayedDragTouchMoveHandler),p(t,"pointermove",this._delayedDragTouchMoveHandler)},_triggerDragStart:function(t,e){e=e||"touch"==t.pointerType&&t,!this.nativeDraggable||e?this.options.supportPointer?h(document,"pointermove",this._onTouchMove):h(document,e?"touchmove":"mousemove",this._onTouchMove):(h(Z,"dragend",this),h(J,"dragstart",this._onDragStart));try{document.selection?Wt(function(){document.selection.empty()}):window.getSelection().removeAllRanges()}catch(t){}},_dragStarted:function(t,e){var n;Dt=!1,J&&Z?(U("dragStarted",this,{evt:e}),this.nativeDraggable&&h(document,"dragover",Ft),n=this.options,t||k(Z,n.dragClass,!1),k(Z,n.ghostClass,!0),jt.active=this,t&&this._appendGhost(),V({sortable:this,name:"start",originalEvent:e})):this._nulling()},_emulateDragOver:function(){if(dt){this._lastX=dt.clientX,this._lastY=dt.clientY,Xt();for(var t=document.elementFromPoint(dt.clientX,dt.clientY),e=t;t&&t.shadowRoot&&(t=t.shadowRoot.elementFromPoint(dt.clientX,dt.clientY))!==e;)e=t;if(Z.parentNode[K]._isOutsideThisEl(t),e)do{if(e[K])if(e[K]._onDragOver({clientX:dt.clientX,clientY:dt.clientY,target:t,rootEl:e})&&!this.options.dragoverBubble)break}while(e=g(t=e));Yt()}},_onTouchMove:function(t){if(ut){var e=this.options,n=e.fallbackTolerance,o=e.fallbackOffset,i=t.touches?t.touches[0]:t,r=Q&&b(Q,!0),a=Q&&r&&r.a,l=Q&&r&&r.d,e=At&&wt&&E(wt),a=(i.clientX-ut.clientX+o.x)/(a||1)+(e?e[0]-Tt[0]:0)/(a||1),l=(i.clientY-ut.clientY+o.y)/(l||1)+(e?e[1]-Tt[1]:0)/(l||1);if(!jt.active&&!Dt){if(n&&Math.max(Math.abs(i.clientX-this._lastX),Math.abs(i.clientY-this._lastY))<n)return;this._onDragStart(t,!0)}Q&&(r?(r.e+=a-(ht||0),r.f+=l-(pt||0)):r={a:1,b:0,c:0,d:1,e:a,f:l},r="matrix(".concat(r.a,",").concat(r.b,",").concat(r.c,",").concat(r.d,",").concat(r.e,",").concat(r.f,")"),R(Q,"webkitTransform",r),R(Q,"mozTransform",r),R(Q,"msTransform",r),R(Q,"transform",r),ht=a,pt=l,dt=i),t.cancelable&&t.preventDefault()}},_appendGhost:function(){if(!Q){var t=this.options.fallbackOnBody?document.body:J,e=X(Z,!0,At,!0,t),n=this.options;if(At){for(wt=t;"static"===R(wt,"position")&&"none"===R(wt,"transform")&&wt!==document;)wt=wt.parentNode;wt!==document.body&&wt!==document.documentElement?(wt===document&&(wt=O()),e.top+=wt.scrollTop,e.left+=wt.scrollLeft):wt=O(),Tt=E(wt)}k(Q=Z.cloneNode(!0),n.ghostClass,!1),k(Q,n.fallbackClass,!0),k(Q,n.dragClass,!0),R(Q,"transition",""),R(Q,"transform",""),R(Q,"box-sizing","border-box"),R(Q,"margin",0),R(Q,"top",e.top),R(Q,"left",e.left),R(Q,"width",e.width),R(Q,"height",e.height),R(Q,"opacity","0.8"),R(Q,"position",At?"absolute":"fixed"),R(Q,"zIndex","100000"),R(Q,"pointerEvents","none"),jt.ghost=Q,t.appendChild(Q),R(Q,"transform-origin",ft/parseInt(Q.style.width)*100+"% "+gt/parseInt(Q.style.height)*100+"%")}},_onDragStart:function(t,e){var n=this,o=t.dataTransfer,i=n.options;U("dragStart",this,{evt:t}),jt.eventCanceled?this._onDrop():(U("setupClone",this),jt.eventCanceled||((nt=C(Z)).removeAttribute("id"),nt.draggable=!1,nt.style["will-change"]="",this._hideClone(),k(nt,this.options.chosenClass,!1),jt.clone=nt),n.cloneId=Wt(function(){U("clone",n),jt.eventCanceled||(n.options.removeCloneOnHide||J.insertBefore(nt,Z),n._hideClone(),V({sortable:n,name:"clone"}))}),e||k(Z,i.dragClass,!0),e?(Et=!0,n._loopId=setInterval(n._emulateDragOver,50)):(p(document,"mouseup",n._onDrop),p(document,"touchend",n._onDrop),p(document,"touchcancel",n._onDrop),o&&(o.effectAllowed="move",i.setData&&i.setData.call(n,o,Z)),h(document,"drop",n),R(Z,"transform","translateZ(0)")),Dt=!0,n._dragStartId=Wt(n._dragStarted.bind(n,e,t)),h(document,"selectstart",n),mt=!0,window.getSelection().removeAllRanges(),u&&R(document.body,"user-select","none"))},_onDragOver:function(n){var o,i,r,t,e,a=this.el,l=n.target,s=this.options,c=s.group,u=jt.active,d=st===c,h=s.sort,p=ct||u,f=this,g=!1;if(!xt){if(void 0!==n.preventDefault&&n.cancelable&&n.preventDefault(),l=P(l,s.draggable,a,!0),O("dragOver"),jt.eventCanceled)return g;if(Z.contains(n.target)||l.animated&&l.animatingX&&l.animatingY||f._ignoreWhileAnimating===l)return A(!1);if(Et=!1,u&&!s.disabled&&(d?h||(i=$!==J):ct===this||(this.lastPutMode=st.checkPull(this,u,Z,n))&&c.checkPut(this,u,Z,n))){if(r="vertical"===this._getDirection(n,l),o=X(Z),O("dragOverValid"),jt.eventCanceled)return g;if(i)return $=J,M(),this._hideClone(),O("revert"),jt.eventCanceled||(tt?J.insertBefore(Z,tt):J.appendChild(Z)),A(!0);var m=F(a,s.draggable);if(m&&(S=n,c=r,x=X(F((E=this).el,E.options.draggable)),E=L(E.el,E.options,Q),!(c?S.clientX>E.right+10||S.clientY>x.bottom&&S.clientX>x.left:S.clientY>E.bottom+10||S.clientX>x.right&&S.clientY>x.top)||m.animated)){if(m&&(t=n,e=r,C=X(B((_=this).el,0,_.options,!0)),_=L(_.el,_.options,Q),e?t.clientX<_.left-10||t.clientY<C.top&&t.clientX<C.right:t.clientY<_.top-10||t.clientY<C.bottom&&t.clientX<C.left)){var v=B(a,0,s,!0);if(v===Z)return A(!1);if(D=X(l=v),!1!==Ht(J,a,Z,o,l,D,n,!1))return M(),a.insertBefore(Z,v),$=a,N(),A(!0)}else if(l.parentNode===a){var b,y,w,D=X(l),E=Z.parentNode!==a,S=(S=Z.animated&&Z.toRect||o,x=l.animated&&l.toRect||D,_=(e=r)?S.left:S.top,t=e?S.right:S.bottom,C=e?S.width:S.height,v=e?x.left:x.top,S=e?x.right:x.bottom,x=e?x.width:x.height,!(_===v||t===S||_+C/2===v+x/2)),_=r?"top":"left",C=Y(l,"top","top")||Y(Z,"top","top"),v=C?C.scrollTop:void 0;if(vt!==l&&(y=D[_],_t=!1,Ct=!S&&s.invertSwap||E),0!==(b=function(t,e,n,o,i,r,a,l){var s=o?t.clientY:t.clientX,c=o?n.height:n.width,t=o?n.top:n.left,o=o?n.bottom:n.right,n=!1;if(!a)if(l&&yt<c*i){if(_t=!_t&&(1===bt?t+c*r/2<s:s<o-c*r/2)?!0:_t)n=!0;else if(1===bt?s<t+yt:o-yt<s)return-bt}else if(t+c*(1-i)/2<s&&s<o-c*(1-i)/2)return function(t){return j(Z)<j(t)?1:-1}(e);if((n=n||a)&&(s<t+c*r/2||o-c*r/2<s))return t+c/2<s?1:-1;return 0}(n,l,D,r,S?1:s.swapThreshold,null==s.invertedSwapThreshold?s.swapThreshold:s.invertedSwapThreshold,Ct,vt===l)))for(var T=j(Z);(w=$.children[T-=b])&&("none"===R(w,"display")||w===Q););if(0===b||w===l)return A(!1);bt=b;var x=(vt=l).nextElementSibling,E=!1,S=Ht(J,a,Z,o,l,D,n,E=1===b);if(!1!==S)return 1!==S&&-1!==S||(E=1===S),xt=!0,setTimeout(Kt,30),M(),E&&!x?a.appendChild(Z):l.parentNode.insertBefore(Z,E?x:l),C&&H(C,0,v-C.scrollTop),$=Z.parentNode,void 0===y||Ct||(yt=Math.abs(y-X(l)[_])),N(),A(!0)}}else{if(m===Z)return A(!1);if((l=m&&a===n.target?m:l)&&(D=X(l)),!1!==Ht(J,a,Z,o,l,D,n,!!l))return M(),m&&m.nextSibling?a.insertBefore(Z,m.nextSibling):a.appendChild(Z),$=a,N(),A(!0)}if(a.contains(Z))return A(!1)}return!1}function O(t,e){U(t,f,I({evt:n,isOwner:d,axis:r?"vertical":"horizontal",revert:i,dragRect:o,targetRect:D,canSort:h,fromSortable:p,target:l,completed:A,onMove:function(t,e){return Ht(J,a,Z,o,t,X(t),n,e)},changed:N},e))}function M(){O("dragOverAnimationCapture"),f.captureAnimationState(),f!==p&&p.captureAnimationState()}function A(t){return O("dragOverCompleted",{insertion:t}),t&&(d?u._hideClone():u._showClone(f),f!==p&&(k(Z,(ct||u).options.ghostClass,!1),k(Z,s.ghostClass,!0)),ct!==f&&f!==jt.active?ct=f:f===jt.active&&ct&&(ct=null),p===f&&(f._ignoreWhileAnimating=l),f.animateAll(function(){O("dragOverAnimationComplete"),f._ignoreWhileAnimating=null}),f!==p&&(p.animateAll(),p._ignoreWhileAnimating=null)),(l===Z&&!Z.animated||l===a&&!l.animated)&&(vt=null),s.dragoverBubble||n.rootEl||l===document||(Z.parentNode[K]._isOutsideThisEl(n.target),t||Bt(n)),!s.dragoverBubble&&n.stopPropagation&&n.stopPropagation(),g=!0}function N(){rt=j(Z),lt=j(Z,s.draggable),V({sortable:f,name:"change",toEl:a,newIndex:rt,newDraggableIndex:lt,originalEvent:n})}},_ignoreWhileAnimating:null,_offMoveEvents:function(){p(document,"mousemove",this._onTouchMove),p(document,"touchmove",this._onTouchMove),p(document,"pointermove",this._onTouchMove),p(document,"dragover",Bt),p(document,"mousemove",Bt),p(document,"touchmove",Bt)},_offUpEvents:function(){var t=this.el.ownerDocument;p(t,"mouseup",this._onDrop),p(t,"touchend",this._onDrop),p(t,"pointerup",this._onDrop),p(t,"pointercancel",this._onDrop),p(t,"touchcancel",this._onDrop),p(document,"selectstart",this)},_onDrop:function(t){var e=this.el,n=this.options;rt=j(Z),lt=j(Z,n.draggable),U("drop",this,{evt:t}),$=Z&&Z.parentNode,rt=j(Z),lt=j(Z,n.draggable),jt.eventCanceled||(_t=Ct=Dt=!1,clearInterval(this._loopId),clearTimeout(this._dragStartTimer),zt(this.cloneId),zt(this._dragStartId),this.nativeDraggable&&(p(document,"drop",this),p(e,"dragstart",this._onDragStart)),this._offMoveEvents(),this._offUpEvents(),u&&R(document.body,"user-select",""),R(Z,"transform",""),t&&(mt&&(t.cancelable&&t.preventDefault(),n.dropBubble||t.stopPropagation()),Q&&Q.parentNode&&Q.parentNode.removeChild(Q),(J===$||ct&&"clone"!==ct.lastPutMode)&&nt&&nt.parentNode&&nt.parentNode.removeChild(nt),Z&&(this.nativeDraggable&&p(Z,"dragend",this),Lt(Z),Z.style["will-change"]="",mt&&!Dt&&k(Z,(ct||this).options.ghostClass,!1),k(Z,this.options.chosenClass,!1),V({sortable:this,name:"unchoose",toEl:$,newIndex:null,newDraggableIndex:null,originalEvent:t}),J!==$?(0<=rt&&(V({rootEl:$,name:"add",toEl:$,fromEl:J,originalEvent:t}),V({sortable:this,name:"remove",toEl:$,originalEvent:t}),V({rootEl:$,name:"sort",toEl:$,fromEl:J,originalEvent:t}),V({sortable:this,name:"sort",toEl:$,originalEvent:t})),ct&&ct.save()):rt!==it&&0<=rt&&(V({sortable:this,name:"update",toEl:$,originalEvent:t}),V({sortable:this,name:"sort",toEl:$,originalEvent:t})),jt.active&&(null!=rt&&-1!==rt||(rt=it,lt=at),V({sortable:this,name:"end",toEl:$,originalEvent:t}),this.save())))),this._nulling()},_nulling:function(){U("nulling",this),J=Z=$=Q=tt=nt=et=ot=ut=dt=mt=rt=lt=it=at=vt=bt=ct=st=jt.dragged=jt.ghost=jt.clone=jt.active=null,Ot.forEach(function(t){t.checked=!0}),Ot.length=ht=pt=0},handleEvent:function(t){switch(t.type){case"drop":case"dragend":this._onDrop(t);break;case"dragenter":case"dragover":Z&&(this._onDragOver(t),function(t){t.dataTransfer&&(t.dataTransfer.dropEffect="move");t.cancelable&&t.preventDefault()}(t));break;case"selectstart":t.preventDefault()}},toArray:function(){for(var t,e=[],n=this.el.children,o=0,i=n.length,r=this.options;o<i;o++)P(t=n[o],r.draggable,this.el,!1)&&e.push(t.getAttribute(r.dataIdAttr)||function(t){var e=t.tagName+t.className+t.src+t.href+t.textContent,n=e.length,o=0;for(;n--;)o+=e.charCodeAt(n);return o.toString(36)}(t));return e},sort:function(t,e){var n={},o=this.el;this.toArray().forEach(function(t,e){e=o.children[e];P(e,this.options.draggable,o,!1)&&(n[t]=e)},this),e&&this.captureAnimationState(),t.forEach(function(t){n[t]&&(o.removeChild(n[t]),o.appendChild(n[t]))}),e&&this.animateAll()},save:function(){var t=this.options.store;t&&t.set&&t.set(this)},closest:function(t,e){return P(t,e||this.options.draggable,this.el,!1)},option:function(t,e){var n=this.options;if(void 0===e)return n[t];var o=z.modifyOption(this,t,e);n[t]=void 0!==o?o:e,"group"===t&&Rt(n)},destroy:function(){U("destroy",this);var t=this.el;t[K]=null,p(t,"mousedown",this._onTapStart),p(t,"touchstart",this._onTapStart),p(t,"pointerdown",this._onTapStart),this.nativeDraggable&&(p(t,"dragover",this),p(t,"dragenter",this)),Array.prototype.forEach.call(t.querySelectorAll("[draggable]"),function(t){t.removeAttribute("draggable")}),this._onDrop(),this._disableDelayedDragEvents(),St.splice(St.indexOf(this.el),1),this.el=t=null},_hideClone:function(){ot||(U("hideClone",this),jt.eventCanceled||(R(nt,"display","none"),this.options.removeCloneOnHide&&nt.parentNode&&nt.parentNode.removeChild(nt),ot=!0))},_showClone:function(t){"clone"===t.lastPutMode?ot&&(U("showClone",this),jt.eventCanceled||(Z.parentNode!=J||this.options.group.revertClone?tt?J.insertBefore(nt,tt):J.appendChild(nt):J.insertBefore(nt,Z),this.options.group.revertClone&&this.animate(Z,nt),R(nt,"display",""),ot=!1)):this._hideClone()}},Mt&&h(document,"touchmove",function(t){(jt.active||Dt)&&t.cancelable&&t.preventDefault()}),jt.utils={on:h,off:p,css:R,find:D,is:function(t,e){return!!P(t,e,t,!1)},extend:function(t,e){if(t&&e)for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);return t},throttle:_,closest:P,toggleClass:k,clone:C,index:j,nextTick:Wt,cancelNextTick:zt,detectDirection:kt,getChild:B,expando:K},jt.get=function(t){return t[K]},jt.mount=function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];(e=e[0].constructor===Array?e[0]:e).forEach(function(t){if(!t.prototype||!t.prototype.constructor)throw"Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(t));t.utils&&(jt.utils=I(I({},jt.utils),t.utils)),z.mount(t)})},jt.create=function(t,e){return new jt(t,e)};var Gt,Ut,qt,Vt,Zt,$t,Qt=[],Jt=!(jt.version="1.15.6");function te(){Qt.forEach(function(t){clearInterval(t.pid)}),Qt=[]}function ee(){clearInterval($t)}var ne,oe=_(function(n,t,e,o){if(t.scroll){var i,r=(n.touches?n.touches[0]:n).clientX,a=(n.touches?n.touches[0]:n).clientY,l=t.scrollSensitivity,s=t.scrollSpeed,c=O(),u=!1;Ut!==e&&(Ut=e,te(),Gt=t.scroll,i=t.scrollFn,!0===Gt&&(Gt=M(e,!0)));var d=0,h=Gt;do{var p=h,f=X(p),g=f.top,m=f.bottom,v=f.left,b=f.right,y=f.width,w=f.height,D=void 0,E=void 0,S=p.scrollWidth,_=p.scrollHeight,C=R(p),T=p.scrollLeft,f=p.scrollTop,E=p===c?(D=y<S&&("auto"===C.overflowX||"scroll"===C.overflowX||"visible"===C.overflowX),w<_&&("auto"===C.overflowY||"scroll"===C.overflowY||"visible"===C.overflowY)):(D=y<S&&("auto"===C.overflowX||"scroll"===C.overflowX),w<_&&("auto"===C.overflowY||"scroll"===C.overflowY)),T=D&&(Math.abs(b-r)<=l&&T+y<S)-(Math.abs(v-r)<=l&&!!T),f=E&&(Math.abs(m-a)<=l&&f+w<_)-(Math.abs(g-a)<=l&&!!f);if(!Qt[d])for(var x=0;x<=d;x++)Qt[x]||(Qt[x]={});Qt[d].vx==T&&Qt[d].vy==f&&Qt[d].el===p||(Qt[d].el=p,Qt[d].vx=T,Qt[d].vy=f,clearInterval(Qt[d].pid),0==T&&0==f||(u=!0,Qt[d].pid=setInterval(function(){o&&0===this.layer&&jt.active._onTouchMove(Zt);var t=Qt[this.layer].vy?Qt[this.layer].vy*s:0,e=Qt[this.layer].vx?Qt[this.layer].vx*s:0;"function"==typeof i&&"continue"!==i.call(jt.dragged.parentNode[K],e,t,n,Zt,Qt[this.layer].el)||H(Qt[this.layer].el,e,t)}.bind({layer:d}),24))),d++}while(t.bubbleScroll&&h!==c&&(h=M(h,!1)));Jt=u}},30),n=function(t){var e=t.originalEvent,n=t.putSortable,o=t.dragEl,i=t.activeSortable,r=t.dispatchSortableEvent,a=t.hideGhostForTarget,t=t.unhideGhostForTarget;e&&(i=n||i,a(),e=e.changedTouches&&e.changedTouches.length?e.changedTouches[0]:e,e=document.elementFromPoint(e.clientX,e.clientY),t(),i&&!i.el.contains(e)&&(r("spill"),this.onSpill({dragEl:o,putSortable:n})))};function ie(){}function re(){}ie.prototype={startIndex:null,dragStart:function(t){t=t.oldDraggableIndex;this.startIndex=t},onSpill:function(t){var e=t.dragEl,n=t.putSortable;this.sortable.captureAnimationState(),n&&n.captureAnimationState();t=B(this.sortable.el,this.startIndex,this.options);t?this.sortable.el.insertBefore(e,t):this.sortable.el.appendChild(e),this.sortable.animateAll(),n&&n.animateAll()},drop:n},a(ie,{pluginName:"revertOnSpill"}),re.prototype={onSpill:function(t){var e=t.dragEl,t=t.putSortable||this.sortable;t.captureAnimationState(),e.parentNode&&e.parentNode.removeChild(e),t.animateAll()},drop:n},a(re,{pluginName:"removeOnSpill"});var ae,le,se,ce,ue,de=[],he=[],pe=!1,fe=!1,ge=!1;function me(n,o){he.forEach(function(t,e){e=o.children[t.sortableIndex+(n?Number(e):0)];e?o.insertBefore(t,e):o.appendChild(t)})}function ve(){de.forEach(function(t){t!==se&&t.parentNode&&t.parentNode.removeChild(t)})}return jt.mount(new function(){function t(){for(var t in this.defaults={scroll:!0,forceAutoScrollFallback:!1,scrollSensitivity:30,scrollSpeed:10,bubbleScroll:!0},this)"_"===t.charAt(0)&&"function"==typeof this[t]&&(this[t]=this[t].bind(this))}return t.prototype={dragStarted:function(t){t=t.originalEvent;this.sortable.nativeDraggable?h(document,"dragover",this._handleAutoScroll):this.options.supportPointer?h(document,"pointermove",this._handleFallbackAutoScroll):t.touches?h(document,"touchmove",this._handleFallbackAutoScroll):h(document,"mousemove",this._handleFallbackAutoScroll)},dragOverCompleted:function(t){t=t.originalEvent;this.options.dragOverBubble||t.rootEl||this._handleAutoScroll(t)},drop:function(){this.sortable.nativeDraggable?p(document,"dragover",this._handleAutoScroll):(p(document,"pointermove",this._handleFallbackAutoScroll),p(document,"touchmove",this._handleFallbackAutoScroll),p(document,"mousemove",this._handleFallbackAutoScroll)),ee(),te(),clearTimeout(m),m=void 0},nulling:function(){Zt=Ut=Gt=Jt=$t=qt=Vt=null,Qt.length=0},_handleFallbackAutoScroll:function(t){this._handleAutoScroll(t,!0)},_handleAutoScroll:function(e,n){var o,i=this,r=(e.touches?e.touches[0]:e).clientX,a=(e.touches?e.touches[0]:e).clientY,t=document.elementFromPoint(r,a);Zt=e,n||this.options.forceAutoScrollFallback||w||y||u?(oe(e,this.options,t,n),o=M(t,!0),!Jt||$t&&r===qt&&a===Vt||($t&&ee(),$t=setInterval(function(){var t=M(document.elementFromPoint(r,a),!0);t!==o&&(o=t,te()),oe(e,i.options,t,n)},10),qt=r,Vt=a)):this.options.bubbleScroll&&M(t,!0)!==O()?oe(e,this.options,M(t,!1),!1):te()}},a(t,{pluginName:"scroll",initializeByDefault:!0})}),jt.mount(re,ie),jt.mount(new function(){function t(){this.defaults={swapClass:"sortable-swap-highlight"}}return t.prototype={dragStart:function(t){t=t.dragEl;ne=t},dragOverValid:function(t){var e=t.completed,n=t.target,o=t.onMove,i=t.activeSortable,r=t.changed,a=t.cancel;i.options.swap&&(t=this.sortable.el,i=this.options,n&&n!==t&&(t=ne,ne=!1!==o(n)?(k(n,i.swapClass,!0),n):null,t&&t!==ne&&k(t,i.swapClass,!1)),r(),e(!0),a())},drop:function(t){var e,n,o=t.activeSortable,i=t.putSortable,r=t.dragEl,a=i||this.sortable,l=this.options;ne&&k(ne,l.swapClass,!1),ne&&(l.swap||i&&i.options.swap)&&r!==ne&&(a.captureAnimationState(),a!==o&&o.captureAnimationState(),n=ne,t=(e=r).parentNode,l=n.parentNode,t&&l&&!t.isEqualNode(n)&&!l.isEqualNode(e)&&(i=j(e),r=j(n),t.isEqualNode(l)&&i<r&&r++,t.insertBefore(n,t.children[i]),l.insertBefore(e,l.children[r])),a.animateAll(),a!==o&&o.animateAll())},nulling:function(){ne=null}},a(t,{pluginName:"swap",eventProperties:function(){return{swapItem:ne}}})}),jt.mount(new function(){function t(o){for(var t in this)"_"===t.charAt(0)&&"function"==typeof this[t]&&(this[t]=this[t].bind(this));o.options.avoidImplicitDeselect||(o.options.supportPointer?h(document,"pointerup",this._deselectMultiDrag):(h(document,"mouseup",this._deselectMultiDrag),h(document,"touchend",this._deselectMultiDrag))),h(document,"keydown",this._checkKeyDown),h(document,"keyup",this._checkKeyUp),this.defaults={selectedClass:"sortable-selected",multiDragKey:null,avoidImplicitDeselect:!1,setData:function(t,e){var n="";de.length&&le===o?de.forEach(function(t,e){n+=(e?", ":"")+t.textContent}):n=e.textContent,t.setData("Text",n)}}}return t.prototype={multiDragKeyDown:!1,isMultiDrag:!1,delayStartGlobal:function(t){t=t.dragEl;se=t},delayEnded:function(){this.isMultiDrag=~de.indexOf(se)},setupClone:function(t){var e=t.sortable,t=t.cancel;if(this.isMultiDrag){for(var n=0;n<de.length;n++)he.push(C(de[n])),he[n].sortableIndex=de[n].sortableIndex,he[n].draggable=!1,he[n].style["will-change"]="",k(he[n],this.options.selectedClass,!1),de[n]===se&&k(he[n],this.options.chosenClass,!1);e._hideClone(),t()}},clone:function(t){var e=t.sortable,n=t.rootEl,o=t.dispatchSortableEvent,t=t.cancel;this.isMultiDrag&&(this.options.removeCloneOnHide||de.length&&le===e&&(me(!0,n),o("clone"),t()))},showClone:function(t){var e=t.cloneNowShown,n=t.rootEl,t=t.cancel;this.isMultiDrag&&(me(!1,n),he.forEach(function(t){R(t,"display","")}),e(),ue=!1,t())},hideClone:function(t){var e=this,n=(t.sortable,t.cloneNowHidden),t=t.cancel;this.isMultiDrag&&(he.forEach(function(t){R(t,"display","none"),e.options.removeCloneOnHide&&t.parentNode&&t.parentNode.removeChild(t)}),n(),ue=!0,t())},dragStartGlobal:function(t){t.sortable;!this.isMultiDrag&&le&&le.multiDrag._deselectMultiDrag(),de.forEach(function(t){t.sortableIndex=j(t)}),de=de.sort(function(t,e){return t.sortableIndex-e.sortableIndex}),ge=!0},dragStarted:function(t){var e,n=this,t=t.sortable;this.isMultiDrag&&(this.options.sort&&(t.captureAnimationState(),this.options.animation&&(de.forEach(function(t){t!==se&&R(t,"position","absolute")}),e=X(se,!1,!0,!0),de.forEach(function(t){t!==se&&T(t,e)}),pe=fe=!0)),t.animateAll(function(){pe=fe=!1,n.options.animation&&de.forEach(function(t){x(t)}),n.options.sort&&ve()}))},dragOver:function(t){var e=t.target,n=t.completed,t=t.cancel;fe&&~de.indexOf(e)&&(n(!1),t())},revert:function(t){var n,o,e=t.fromSortable,i=t.rootEl,r=t.sortable,a=t.dragRect;1<de.length&&(de.forEach(function(t){r.addAnimationState({target:t,rect:fe?X(t):a}),x(t),t.fromRect=a,e.removeAnimationState(t)}),fe=!1,n=!this.options.removeCloneOnHide,o=i,de.forEach(function(t,e){e=o.children[t.sortableIndex+(n?Number(e):0)];e?o.insertBefore(t,e):o.appendChild(t)}))},dragOverCompleted:function(t){var e,n=t.sortable,o=t.isOwner,i=t.insertion,r=t.activeSortable,a=t.parentEl,l=t.putSortable,t=this.options;i&&(o&&r._hideClone(),pe=!1,t.animation&&1<de.length&&(fe||!o&&!r.options.sort&&!l)&&(e=X(se,!1,!0,!0),de.forEach(function(t){t!==se&&(T(t,e),a.appendChild(t))}),fe=!0),o||(fe||ve(),1<de.length?(o=ue,r._showClone(n),r.options.animation&&!ue&&o&&he.forEach(function(t){r.addAnimationState({target:t,rect:ce}),t.fromRect=ce,t.thisAnimationDuration=null})):r._showClone(n)))},dragOverAnimationCapture:function(t){var e=t.dragRect,n=t.isOwner,t=t.activeSortable;de.forEach(function(t){t.thisAnimationDuration=null}),t.options.animation&&!n&&t.multiDrag.isMultiDrag&&(ce=a({},e),e=b(se,!0),ce.top-=e.f,ce.left-=e.e)},dragOverAnimationComplete:function(){fe&&(fe=!1,ve())},drop:function(t){var o,i,r,a,n,e,l,s=t.originalEvent,c=t.rootEl,u=t.parentEl,d=t.sortable,h=t.dispatchSortableEvent,p=t.oldIndex,t=t.putSortable,f=t||this.sortable;s&&(o=this.options,i=u.children,ge||(o.multiDragKey&&!this.multiDragKeyDown&&this._deselectMultiDrag(),k(se,o.selectedClass,!~de.indexOf(se)),~de.indexOf(se)?(de.splice(de.indexOf(se),1),ae=null,G({sortable:d,rootEl:c,name:"deselect",targetEl:se,originalEvent:s})):(de.push(se),G({sortable:d,rootEl:c,name:"select",targetEl:se,originalEvent:s}),s.shiftKey&&ae&&d.el.contains(ae)?(r=j(ae),a=j(se),~r&&~a&&r!==a&&function(){for(var e,t=r<a?(e=r,a):(e=a,r+1),n=o.filter;e<t;e++)~de.indexOf(i[e])||P(i[e],o.draggable,u,!1)&&(n&&("function"==typeof n?n.call(d,s,i[e],d):n.split(",").some(function(t){return P(i[e],t.trim(),u,!1)}))||(k(i[e],o.selectedClass,!0),de.push(i[e]),G({sortable:d,rootEl:c,name:"select",targetEl:i[e],originalEvent:s})))}()):ae=se,le=f)),ge&&this.isMultiDrag&&(fe=!1,(u[K].options.sort||u!==c)&&1<de.length&&(n=X(se),e=j(se,":not(."+this.options.selectedClass+")"),!pe&&o.animation&&(se.thisAnimationDuration=null),f.captureAnimationState(),pe||(o.animation&&(se.fromRect=n,de.forEach(function(t){var e;t.thisAnimationDuration=null,t!==se&&(e=fe?X(t):n,t.fromRect=e,f.addAnimationState({target:t,rect:e}))})),ve(),de.forEach(function(t){i[e]?u.insertBefore(t,i[e]):u.appendChild(t),e++}),p===j(se)&&(l=!1,de.forEach(function(t){t.sortableIndex!==j(t)&&(l=!0)}),l&&(h("update"),h("sort")))),de.forEach(function(t){x(t)}),f.animateAll()),le=f),(c===u||t&&"clone"!==t.lastPutMode)&&he.forEach(function(t){t.parentNode&&t.parentNode.removeChild(t)}))},nullingGlobal:function(){this.isMultiDrag=ge=!1,he.length=0},destroyGlobal:function(){this._deselectMultiDrag(),p(document,"pointerup",this._deselectMultiDrag),p(document,"mouseup",this._deselectMultiDrag),p(document,"touchend",this._deselectMultiDrag),p(document,"keydown",this._checkKeyDown),p(document,"keyup",this._checkKeyUp)},_deselectMultiDrag:function(t){if(!(void 0!==ge&&ge||le!==this.sortable||t&&P(t.target,this.options.draggable,this.sortable.el,!1)||t&&0!==t.button))for(;de.length;){var e=de[0];k(e,this.options.selectedClass,!1),de.shift(),G({sortable:this.sortable,rootEl:this.sortable.el,name:"deselect",targetEl:e,originalEvent:t})}},_checkKeyDown:function(t){t.key===this.options.multiDragKey&&(this.multiDragKeyDown=!0)},_checkKeyUp:function(t){t.key===this.options.multiDragKey&&(this.multiDragKeyDown=!1)}},a(t,{pluginName:"multiDrag",utils:{select:function(t){var e=t.parentNode[K];e&&e.options.multiDrag&&!~de.indexOf(t)&&(le&&le!==e&&(le.multiDrag._deselectMultiDrag(),le=e),k(t,e.options.selectedClass,!0),de.push(t))},deselect:function(t){var e=t.parentNode[K],n=de.indexOf(t);e&&e.options.multiDrag&&~n&&(k(t,e.options.selectedClass,!1),de.splice(n,1))}},eventProperties:function(){var n=this,o=[],i=[];return de.forEach(function(t){var e;o.push({multiDragElement:t,index:t.sortableIndex}),e=fe&&t!==se?-1:fe?j(t,":not(."+n.options.selectedClass+")"):j(t),i.push({multiDragElement:t,index:e})}),{items:r(de),clones:[].concat(he),oldIndicies:o,newIndicies:i}},optionListeners:{multiDragKey:function(t){return"ctrl"===(t=t.toLowerCase())?t="Control":1<t.length&&(t=t.charAt(0).toUpperCase()+t.substr(1)),t}}})}),jt});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(10)))

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(315);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(59)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js!./bootstrap.css", function() {
				var newContent = require("!!../../../css-loader/index.js!./bootstrap.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(316);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(59)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./drift-basic.css", function() {
				var newContent = require("!!../../css-loader/index.js!./drift-basic.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(317);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(59)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./font-awesome.css", function() {
				var newContent = require("!!../../css-loader/index.js!./font-awesome.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(318);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(59)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./flickity.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./flickity.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(319);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(59)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Unidragger v2.4.0
	 * Draggable base class
	 * MIT license
	 */
	
	/*jshint browser: true, unused: true, undef: true, strict: true */
	
	( function( window, factory ) {
	  // universal module definition
	  /*jshint strict: false */ /*globals define, module, require */
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(134)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Unipointer ) {
	      return factory( window, Unipointer );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('unipointer')
	    );
	  } else {
	    // browser global
	    window.Unidragger = factory(
	      window,
	      window.Unipointer
	    );
	  }
	
	}( window, function factory( window, Unipointer ) {
	
	'use strict';
	
	// -------------------------- Unidragger -------------------------- //
	
	function Unidragger() {}
	
	// inherit Unipointer & EvEmitter
	var proto = Unidragger.prototype = Object.create( Unipointer.prototype );
	
	// ----- bind start ----- //
	
	proto.bindHandles = function() {
	  this._bindHandles( true );
	};
	
	proto.unbindHandles = function() {
	  this._bindHandles( false );
	};
	
	/**
	 * Add or remove start event
	 * @param {Boolean} isAdd
	 */
	proto._bindHandles = function( isAdd ) {
	  // munge isAdd, default to true
	  isAdd = isAdd === undefined ? true : isAdd;
	  // bind each handle
	  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
	  var touchAction = isAdd ? this._touchActionValue : '';
	  for ( var i=0; i < this.handles.length; i++ ) {
	    var handle = this.handles[i];
	    this._bindStartEvent( handle, isAdd );
	    handle[ bindMethod ]( 'click', this );
	    // touch-action: none to override browser touch gestures. metafizzy/flickity#540
	    if ( window.PointerEvent ) {
	      handle.style.touchAction = touchAction;
	    }
	  }
	};
	
	// prototype so it can be overwriteable by Flickity
	proto._touchActionValue = 'none';
	
	// ----- start event ----- //
	
	/**
	 * pointer start
	 * @param {Event} event
	 * @param {Event or Touch} pointer
	 */
	proto.pointerDown = function( event, pointer ) {
	  var isOkay = this.okayPointerDown( event );
	  if ( !isOkay ) {
	    return;
	  }
	  // track start event position
	  // Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
	  this.pointerDownPointer = {
	    pageX: pointer.pageX,
	    pageY: pointer.pageY,
	  };
	
	  event.preventDefault();
	  this.pointerDownBlur();
	  // bind move and end events
	  this._bindPostStartEvents( event );
	  this.emitEvent( 'pointerDown', [ event, pointer ] );
	};
	
	// nodes that have text fields
	var cursorNodes = {
	  TEXTAREA: true,
	  INPUT: true,
	  SELECT: true,
	  OPTION: true,
	};
	
	// input types that do not have text fields
	var clickTypes = {
	  radio: true,
	  checkbox: true,
	  button: true,
	  submit: true,
	  image: true,
	  file: true,
	};
	
	// dismiss inputs with text fields. flickity#403, flickity#404
	proto.okayPointerDown = function( event ) {
	  var isCursorNode = cursorNodes[ event.target.nodeName ];
	  var isClickType = clickTypes[ event.target.type ];
	  var isOkay = !isCursorNode || isClickType;
	  if ( !isOkay ) {
	    this._pointerReset();
	  }
	  return isOkay;
	};
	
	// kludge to blur previously focused input
	proto.pointerDownBlur = function() {
	  var focused = document.activeElement;
	  // do not blur body for IE10, metafizzy/flickity#117
	  var canBlur = focused && focused.blur && focused != document.body;
	  if ( canBlur ) {
	    focused.blur();
	  }
	};
	
	// ----- move event ----- //
	
	/**
	 * drag move
	 * @param {Event} event
	 * @param {Event or Touch} pointer
	 */
	proto.pointerMove = function( event, pointer ) {
	  var moveVector = this._dragPointerMove( event, pointer );
	  this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
	  this._dragMove( event, pointer, moveVector );
	};
	
	// base pointer move logic
	proto._dragPointerMove = function( event, pointer ) {
	  var moveVector = {
	    x: pointer.pageX - this.pointerDownPointer.pageX,
	    y: pointer.pageY - this.pointerDownPointer.pageY
	  };
	  // start drag if pointer has moved far enough to start drag
	  if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
	    this._dragStart( event, pointer );
	  }
	  return moveVector;
	};
	
	// condition if pointer has moved far enough to start drag
	proto.hasDragStarted = function( moveVector ) {
	  return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
	};
	
	// ----- end event ----- //
	
	/**
	 * pointer up
	 * @param {Event} event
	 * @param {Event or Touch} pointer
	 */
	proto.pointerUp = function( event, pointer ) {
	  this.emitEvent( 'pointerUp', [ event, pointer ] );
	  this._dragPointerUp( event, pointer );
	};
	
	proto._dragPointerUp = function( event, pointer ) {
	  if ( this.isDragging ) {
	    this._dragEnd( event, pointer );
	  } else {
	    // pointer didn't move enough for drag to start
	    this._staticClick( event, pointer );
	  }
	};
	
	// -------------------------- drag -------------------------- //
	
	// dragStart
	proto._dragStart = function( event, pointer ) {
	  this.isDragging = true;
	  // prevent clicks
	  this.isPreventingClicks = true;
	  this.dragStart( event, pointer );
	};
	
	proto.dragStart = function( event, pointer ) {
	  this.emitEvent( 'dragStart', [ event, pointer ] );
	};
	
	// dragMove
	proto._dragMove = function( event, pointer, moveVector ) {
	  // do not drag if not dragging yet
	  if ( !this.isDragging ) {
	    return;
	  }
	
	  this.dragMove( event, pointer, moveVector );
	};
	
	proto.dragMove = function( event, pointer, moveVector ) {
	  event.preventDefault();
	  this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
	};
	
	// dragEnd
	proto._dragEnd = function( event, pointer ) {
	  // set flags
	  this.isDragging = false;
	  // re-enable clicking async
	  setTimeout( function() {
	    delete this.isPreventingClicks;
	  }.bind( this ) );
	
	  this.dragEnd( event, pointer );
	};
	
	proto.dragEnd = function( event, pointer ) {
	  this.emitEvent( 'dragEnd', [ event, pointer ] );
	};
	
	// ----- onclick ----- //
	
	// handle all clicks and prevent clicks when dragging
	proto.onclick = function( event ) {
	  if ( this.isPreventingClicks ) {
	    event.preventDefault();
	  }
	};
	
	// ----- staticClick ----- //
	
	// triggered after pointer down & up with no/tiny movement
	proto._staticClick = function( event, pointer ) {
	  // ignore emulated mouse up clicks
	  if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
	    return;
	  }
	
	  this.staticClick( event, pointer );
	
	  // set flag for emulated clicks 300ms after touchend
	  if ( event.type != 'mouseup' ) {
	    this.isIgnoringMouseUp = true;
	    // reset flag after 300ms
	    setTimeout( function() {
	      delete this.isIgnoringMouseUp;
	    }.bind( this ), 400 );
	  }
	};
	
	proto.staticClick = function( event, pointer ) {
	  this.emitEvent( 'staticClick', [ event, pointer ] );
	};
	
	// ----- utils ----- //
	
	Unidragger.getPointerPoint = Unipointer.getPointerPoint;
	
	// -----  ----- //
	
	return Unidragger;
	
	}));


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "glyphicons-halflings-regular.svg";

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "glyphicons-halflings-regular.ttf";

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "glyphicons-halflings-regular.woff";

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "glyphicons-halflings-regular.woff2";

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fontawesome-webfont.eot";

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fontawesome-webfont.eot";

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fontawesome-webfont.svg";

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fontawesome-webfont.ttf";

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fontawesome-webfont.woff2";

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fontawesome-webfont.woff";

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3d78866a.png";

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Logotjee.png";

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "icon.png";

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "24h.png";

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ideal_en_paypal.png";

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AkGEycm5EOmPgAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAE7klEQVR42u2bXSj7XxzH32bYUFghGcWVpxR5KHznca1wM4W4dOGKyFOrSYm4IEuttpGHXLhw4+nCU5jkYShciksPpRCmYdr+F/92st/Gvt8vu3I+N3aOcz7e39f5fD/ncw58jo+P7fjDJsAfNwqAAqAAKAAKgAKgACgACoACoAAoAAqAAqAAKAAKgAKgACgACoACoAAoAAqAAqAAKIC/C0Cv1yM3NxcjIyMeHby8vKChoQEMw2BmZsbl+/39/SgpKcH19TVncXNzc2AYBjqdzmsafdz9fUB2djbe39/h7+8Pk8n0pWO73Y6WlhYYjUYAQHBwMLa3t936amxsRF1dHeuHv7q6glKphNVqhUgkwt7enlc0uo2A9/d3p69fmV6vJ44BIDMz02VMaGgoAODw8JDT6o+OjsJqtQIAsrKyvKaRdw7Y2NhwCj+RSITW1laXcSkpKQCAk5MT8kCe7OnpCUtLS/8LFAjQ1NTkNY28AFxcXKCzs9OpT61WIzo62mWsY/VeX19ZR8H6+jpZ2eLiYsTHx3tNI2cAj4+PaG5uhsViIX0VFRUoLy93Oz4nJ4d8Xl5eZg3AYZWVlfCmRk4APj4+0NHRgaurK9KXlpYGlUr15ZyYmBiygpubmx5fg+fnZ5LUQkNDkZ6eDm9q5ASgr68PBwcHpC2VSjE4OAg/P79v5xUWFgIAzGYzdnZ2vh27vb2Nj48PAADDMPD19YU3NbIGMDY2htnZWdKWSCTQ6XSQSCQe5xYVFZHPq6ur345dWVlxAedNjawALCwsQKvVknZgYCC0Wi2kUikrYUlJSYiKigIAGI1GvL29fZn9d3d3AQBisdgpf3hLo4BNQuru7iZtoVCIoaEhJCYmclqd/Px8AIDFYsH+/v6XP8sR/jKZDAEBAayTJl+NHgGoVCrYbDbS7u3tRXZ2NufMnJeX57Q/u7PPu4RcLmft+ycaBWyyqsPa29uhUCh4FSUZGRkQiUQAgK2tLSe/AHB3d4ejoyNSsOTm5nLK/Hw1sk6CmZmZqK2t5X3qCggIIKvy+PjoUr+vra2RVZTJZAQWF+OjkTWAw8ND6PX6Hx09HXng32z/b/iXlJTw8s9HI6c6wGAwYGBgAHa7nTcAHx8fkgccu8HNzQ1OT09J+H/OF1yNq0aPAHp6epyKkenpaajVatYHm88mkUiQlpZGzuiOU9rn2oBhGIjFYk5+f6LRI4Dy8nJoNBqnd3JpaQmNjY0wm82cIXwO78XFReKPT/b/DY2sXgGGYWAwGBASEkL6TCYT6urqcHt7yxmA4zXY3d2FyWTC2dkZSZR8w5+vRtY5IDU1FRMTE4iMjCR95+fnqKmpwfHxMWuh4eHhyMjIILc1arXaqVbgGv4/1cgpCcbFxWFqagrJycmk7/7+HvX19RgeHsbDwwMrP6WlpU77v8P41hg/0cj5PiAiIgLj4+NQKpVOhcjk5CQUCgUMBoNHH3K53GWfDwsLQ0FBwa/c9HLRyOtGyN/fH11dXdBoNAgPDyf9VqsVk5OTHucHBQW5rHZZWZnHY7U3NP7o9wIFBQWYn59He3s7EhISIBaLUV1dzWpuVVWVU/vzav2medLo9lq8rKwM19fXEAqFnG9zuZrNZsPl5SViY2M5zfstjW4joK2tDSEhIbxLUk4CBALOD/+bGn3oP07+caMAKAAKgAL40/YfD9NhRCSXVmQAAAAASUVORK5CYII="

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "overons.png";

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "verkocht1.jpg";

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * vue-doctitle v0.0.3
	 * (c) 2016 bblue000
	 * https://github.com/vue-tool/vue-doctitle
	 * Released under the MIT License.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  global.VueDocTitle = factory();
	}(this, function () { 'use strict';
	
	  var babelHelpers = {};
	
	  babelHelpers.classCallCheck = function (instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  };
	  function warn(msg) {
	    /* istanbul ignore next */
	    if (typeof console !== 'undefined') {
	      console.error('[vue-doctitle] ' + msg);
	    }
	  }
	  function info(msg) {
	    /* istanbul ignore next */
	    if (typeof console !== 'undefined') {
	      console.log('[vue-doctitle] ' + msg);
	    }
	  }
	
	  var VueDocTitle = (function () {
	    function VueDocTitle() {
	      babelHelpers.classCallCheck(this, VueDocTitle);
	    }
	
	    /* Installation */
	
	    /**
	     * @options {Object} - plugin options-- {String} defTitle, default title; {function} filter, title filter (when non-default title)
	     */
	
	    VueDocTitle.wrap = function wrap(router, options) {
	      var filter = (options || {}).filter;
	      var defTitle = (options || {}).defTitle || '';
	      router.afterEach(function (transition) {
	        var title = transition.to.doctitle;
	        if (title && filter) {
	          title = filter(title);
	        }
	        document.title = title || defTitle;
	      });
	      return router;
	    };
	
	    return VueDocTitle;
	  })();
	
	  VueDocTitle.installed = false;
	
	  VueDocTitle.install = function (Vue, options) {
	    if (VueDocTitle.installed) {
	      warn('already installed.');
	      return;
	    }
	    Vue.directive('doctitle', {
	      bind: function bind() {
	        // 准备工作
	        // 例如，添加事件处理器或只需要运行一次的高耗任务
	      },
	      update: function update(newValue, oldValue) {
	        // 值更新时的工作
	        // 也会以初始值为参数调用一次
	        info('v-doctitle = ' + newValue);
	        document.title = newValue;
	      },
	      unbind: function unbind() {
	        // 清理工作
	        // 例如，删除 bind() 添加的事件监听器
	      }
	    });
	    VueDocTitle.installed = true;
	  };
	
	  return VueDocTitle;
	
	}));

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	module.exports = " <v-header></v-header> <div class=container-fluid id=allProducts> <v-banner :show.sync=store.banner.Enabled :banner=store.banner></v-banner> <router-view></router-view> </div> <v-footer></v-footer> ";

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=\"card float-e-margins\"> <div class=card-title> <h1>Over Ons</h1> </div> <div class=\"card-content no-padding\"> <div class=row> <div class=col-md-6> <img class=\"img-responsive img-rounded\" src=" + __webpack_require__(632) + " style=\"max-height: 600px\" alt=\"Catootjeskraam, Katinka en Marcel\"> </div> <div class=col-md-6> <p class=h3>Hoi, <br> Leuk dat je ons online gevonden hebt! <br> </p> <p class=h3> We willen ons graag even aan je voorstellen. Wij zijn Katinka en Marcel en al meer dan 30 jaar zijn wij met veel plezier op zoek naar unieke items. Dit is begonnen als hobby, en nu zoeken we deze speciaal voor jou! <br> </p> <p class=h3> Mede hierdoor hebben wij in 2016 een webshop opgezet om hierin alle door ons gevonden unieke items uit binnen- en buitenland met jou te kunnen delen. <br> </p> <p class=h3> Wekelijks staan er nieuwe vondsten in onze webshop, wie weet zit dat unieke item ertussen waarnaar jij al lang op zoek bent. <br> </p> <p class=h3> O ja, hoe we aan de naam Catootjeskraam komen? Deze is afgeleid van onze Britse Korthaar, die heet namelijk Catootje. <br> </p> <p class=h3> Veel kijkplezier in onze webshop! <br> </p> <p class=h3> Groetjes, <br> Katinka en Marcel </p> </div> </div> </div> </div>";

/***/ }),
/* 637 */
/***/ (function(module, exports) {

	module.exports = " <div class=alert :class=\"'alert-' + type\" :class=\"{ 'alert-dismissible': dismissible, fade: animation, in: animation }\" role=alert> <button v-if=dismissible type=button class=close data-dismiss=alert aria-label=Close> <span aria-hidden=true>&times;</span> <span class=sr-only>Close</span> </button> <slot></slot> </div> ";

/***/ }),
/* 638 */
/***/ (function(module, exports) {

	module.exports = " <div role=dialog v-bind:class=\"{\n  'modal':true,\n  'fade':effect === 'fade',\n  'zoom':effect === 'zoom'\n  }\"> <div v-bind:class=\"{'modal-dialog':true,'modal-lg':large,'modal-sm':small,'modal-dialog-centered':centered}\" role=document v-bind:style=\"{width: optionalWidth}\"> <div class=modal-content> <slot name=modal-header> <div class=modal-header> <button type=button class=close @click=close><span>&times;</span></button> <h4 class=modal-title>{{title}}</h4> </div> </slot> <slot name=modal-body> <div class=modal-body></div> </slot> <slot name=modal-footer> <div class=modal-footer> <button type=button class=\"btn btn-default\" @click=close>{{btnleft}}</button> <button type=button class=\"btn btn-primary\" @click=callback>{{btnright}}</button> </div> </slot> </div> <a v-if=indicators @click=indicatorleft class=\"left carousel-control\" role=button style=\"max-height: 50%;margin-top: 20%\"> <span class=\"fa fa-arrow-left\" aria-hidden=true style=\"margin-top: 125%\"></span> </a> <a v-if=indicators @click=indicatorright class=\"right carousel-control\" role=button style=\"max-height: 50%;margin-top: 20%\"> <span class=\"fa fa-arrow-right\" aria-hidden=true style=\"margin-top: 125%\"></span> </a> </div> </div> ";

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	module.exports = " <label class=v-toggle :class=\"{'v-toggle--checked': checked}\"> <input type=checkbox v-model=checked :name=name> <span class=v-toggle_handle></span> </label> ";

/***/ }),
/* 640 */
/***/ (function(module, exports) {

	module.exports = " <img :src=src :data-zoom=_srcZoom /> ";

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports = " <v-modal :show.sync=show effect=zoom> <div slot=modal-header class=modal-header style=\"display: none\"> <h4 class=modal-title> </h4> </div> <div slot=modal-body class=modal-body> <div class=\"row text-center\" id=danger-icon> <span class=\"fa-stack fa-5x\"> <i class=\"fa fa-circle-thin fa-stack-2x text-danger\" aria-hidden=true></i> <i class=\"fa fa-exclamation fa-stack-1x text-danger\"></i> </span> </div> <h2 class=text-center> Weet u het zeker? </h2> <div class=\"row text-center\"> <button type=button class=\"btn btn-lg btn-gray\" @click=\"show = false\">Annuleren</button> <button type=button class=\"btn btn-lg btn-danger\" @click=callback>Ja, Verwijder</button> </div> </div> <div slot=modal-footer class=modal-footer style=\"display: none\"> </div> </v-modal> ";

/***/ }),
/* 642 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"card float-e-margins\"> <div class=card-title> <h1>Gastenboek</h1> </div> <div class=\"card-content no-padding\"> <div class=row> <form class=form-horizontal name=contact-form v-on:submit.prevent=SubmitForm> <div class=form-group> <label for=name class=\"col-sm-1 control-label\">Naam</label> <div class=col-sm-8> <input type=text v-model=review.Name class=form-control id=name name=name placeholder=\"Voor- en Achternaam\" required> </div> </div> <div class=form-group> <label for=message class=\"col-sm-1 control-label\">Bericht</label> <div class=col-sm-8> <textarea class=form-control v-model=review.Content rows=4 name=message required></textarea> </div> </div> <div class=form-group> <label for=score class=\"col-sm-1 control-label\">Beoordeling</label> <div class=col-sm-1> <select class=form-control id=sel1 name=score v-model=review.Rating> <option selected=selected>5</option> <option>4</option> <option>3</option> <option>2</option> <option>1</option> </select> </div> </div> <div class=form-group> <div class=\"col-sm-4 col-sm-offset-8\"> <input id=submit name=submit type=submit value=Verzend class=\"btn btn-primary\"> </div> </div> <vc-alert v-if=success type=success :dismissible=false> Succesvol verzonden! Na goedkeuring verschijnt je reactie hieronder. </vc-alert> <vc-alert v-if=error type=danger :dismissible=false> {{errorMessage}} </vc-alert> </form> </div> <div class=row> <div class=col-md-12> <hr/> <div class=review-block> <div class=row v-for=\"rvw in reviews\"> <div class=col-sm-3> <div class=review-block-name>{{rvw.Name}}</div> <div class=review-block-date>{{rvw.DateSubmitted}}</div> </div> <div class=col-sm-9> <div class=review-block-rate> <button v-for=\"n in rvw.Rating\" type=button class=\"btn btn-warning btn-xs\" aria-label=\"Left Align\"> <span class=\"glyphicon glyphicon-star\" aria-hidden=true></span> </button> </div> <div class=review-block-description>{{rvw.Content}}</div> </div> </div> <hr/> </div> </div> </div> </div> </div> ";

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=\"card float-e-margins\"> <div class=card-title> <h1>Gevonden resultaten voor: <u><strong>{{ $route.params.term }}<strong><u></u></strong></strong></u></h1> </div> <div class=\"card-content no-padding\"> <div class=row v-if=!loaded> <div class=\"col-md-2 col-md-offset-5\"> <img v-else class=img-responsive src=" + __webpack_require__(73) + " style=max-height:200px> </div> </div> <div v-else class=\"row category-credit\" style=margin-top:20px> <div v-for=\"product in products\" class=\"col-lg-3 col-md-4 col-sm-6 col-xs-12\"> <product-card :product=product></product-card> </div> </div> </div> </div> ";

/***/ }),
/* 644 */
/***/ (function(module, exports) {

	module.exports = " <table id=cart class=\"table table-hover table-condensed\"> <thead> <tr> <th style=width:50%></th> <th style=width:10%></th> <th style=width:8%></th> <th style=width:22%></th> <th style=width:10%></th> </tr> </thead> <tbody v-for=\"product in products\" track-by=$index> <tr> <td data-th=\"\"> <div class=row> <div class=col-sm-4><img v-lazy=product.Photos[0].URL class=img-responsive /></div> <div class=col-sm-8> <h4 class=nomargin>{{product.Name}}</h4> </div> </div> </td> <td class=text-right> <h4 style=padding-top:0px><strong>{{product.Quantity}}x</strong></h4> </td> <td colspan=3 class=text-right> <h4 style=padding-top:0px><strong>{{product.Price | currencyDisplay}}</strong></h4> </td> </tr> </tbody> <tfoot> <tr> <td colspan=3 class=\"\"></td> <td colspan=2 class=text-right> <p><strong>subtotaal {{subtotal | currencyDisplay}}</strong></p> <p> <strong>Verzendkosten {{shippingcost | currencyDisplay}}</strong> </p> <h3><strong>Totaal {{totalprice | currencyDisplay}}</strong></h3> </td> </tr> </tfoot> </table> ";

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=\"col-sm-8 col-sm-offset-2\"> <div class=\"card float-e-margins\"> <div v-if=loaded class=\"card-title text-center\"> <h1>Betaalpagina</h1> <h2>order {{order.Id}}</h2> <h4>Prijs: <strong>{{order.Total | currencyDisplay}}</strong> <a @click=\"show = true\" style=cursor:pointer>(klik hier voor overzicht)</a></h4> </div> <div class=card-content> <div class=row v-if=!loaded> <div class=\"col-xs-2 col-xs-offset-5\"> <img v-else class=img-responsive src=" + __webpack_require__(73) + " style=max-height:50px> <div class=pull-left> <p>Laden..</p> </div> </div> </div> <form v-if=loaded v-on:submit.prevent=checkout()> <div class=form-group> <label for=email>e-mailadres:</label> <p id=email>{{order.CustomerMail}}</p> </div> <hr> <div class=content> <label for=paypal>Kies uw betaalmethode:</label> <div class=row> <div class=col-sm-6> <div class=\"box payment-method\"> <h4 id=paypal>Paypal</h4> <div class=col-sm-1> <input type=radio name=payment value=paypal/direct v-model=paymentmethod @click=setIdeal(false) required> </div> </div> </div> </div> <div class=row> <div class=col-sm-6> <div class=\"box payment-method\"> <h4>iDeal</h4> <div class=col-sm-1> <input type=radio name=payment @click=setIdeal(true)> </div> <div class=col-sm-11> <select class=form-control v-model=paymentmethod :disabled=!IdealChecked :required=IdealChecked> <option disabled=disabled selected=selected value></option> <option value=ideal/RABONL2U>Rabobank</option> <option value=ideal/INGBNL2A>ING</option> <option value=ideal/ABNANL2A>ABN AMRO</option> <option value=ideal/SNSBNL2A>SNS Bnk</option> <option value=ideal/RBRBNL21>RegiBank</option> <option value=ideal/ASNBNL21>ASN Bank</option> <option value=ideal/KNABNL2H>Knab</option> <option value=ideal/TRIONL2U>Triodos Bank</option> <option value=ideal/FVLBNL22>van Lanschot</option> </select> </div> </div> </div> </div> </div> <div class=row> <div class=\"form-group text-right\"> <div class=col-md-12> <button type=submit class=\"btn btn-success\" :disabled=submited style=\"margin-top: 15px\">Betalen</button> </div> </div> </div> </form> </div> </div> </div> <v-modal :show.sync=show effect=zoom> <div slot=modal-header class=modal-header> <button type=button class=\"btn btn-danger pull-right\" @click=\"show=false\"> &times; </button> </div> <div slot=modal-body class=modal-body> <overzicht :products=order.Products :subtotal.sync=order.SubTotal :shippingcost.sync=order.ShipCosts :totalprice=order.Total></overzicht> </div> <div slot=modal-footer class=modal-footer style=\"display: none\"> </div> </v-modal> ";

/***/ }),
/* 646 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"col-sm-8 col-sm-offset-2\"> <div class=\"card float-e-margins\"> <div class=card-content> <div class=row> <h1 class=text-center>Betaling geannuleerd!</h1> <h2 class=\"text-center text-danger\"><i class=\"fa fa-frown-o fa-5x\" aria-hidden=true></i></h2> <h4 class=text-center> U heeft de betaling geannuleerd! </h4> </div> </div> </div> </div> ";

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=\"col-sm-8 col-sm-offset-2\"> <div class=\"card float-e-margins\"> <div class=card-content> <div class=row v-if=!loaded> <div class=\"col-xs-2 col-xs-offset-5\"> <img class=img src=" + __webpack_require__(73) + " style=height:50px;width:50px> </div> <div class=\"col-xs-12 text-center\"> <p>U wordt doorverwezen, een ogenblik geduld aub..</p> </div> </div> <div class=row v-if=loaded> <h1 class=text-center>Betaling ontvangen!</h1> <h2 class=\"text-center text-success\"><i class=\"fa fa-check-circle-o fa-5x\" aria-hidden=true></i></h2> <h4> Hartelijk dank voor je bestelling. We hebben je betaling in goede orde ontvangen en zullen je bestelling zo snel mogelijk aan de vervoerder afleveren. </h4> <h4> Je ontvangt per e-mail een bevestiging van je bestelling. In deze e-mail vindt je ook de factuur. </h4> </div> </div> </div> </div> ";

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"card float-e-margins\"> <div class=card-title> <h1>ALGEMENE VOORWAARDEN \"CATOOTJES KRAAM\"</h1> </div> <div class=card-content> <div class=row> <div class=col-md-12> <p> <strong>Bestellen</strong> : </p> <p> Zodra je een bestelling hebt geplaatst ga je akkoord met de onderstaande algemene voorwaarden. </p> <p> Na het plaatsen van de bestelling krijg je van ons een bevestiging per e-mail met daarin de totaalprijs inclusief verzendkosten en het bankrekeningnummer. </p> <p> Als je een artikel besteld hebt ga je akkoord met de betalingsverplichting. </p> <p> Het is uiteraard ook mogelijk om een besteld artikel af te halen, hiervoor kun je contact met ons opnemen per e-mail. Als je besluit om een artikel af te halen dien je contant af te rekenen of per bank over te maken, het bestelde artikel kun je binnen 7 dagen afhalen of anders in overleg. Even voor de duidelijkheid : wij hebben geen winkel aan huis. </p> <p> Nadat we je betaling ontvangen hebben zullen we je bestelling binnen 5 dagen verzenden, soms kunnen we het de volgende (werk)dag al verzenden. </p> <p> <strong>Prijzen :</strong> </p> <p> Alle vermelde prijzen zijn in Euro’s en omdat het om tweedehands artikelen gaat wordt er geen 21% BTW verrekend. Alle vermelde prijzen in catootjes kraam zijn exclusief verzendkosten. </p> <p> <strong>Betalingstermijn:</strong> </p> <p> Als je een artikel hebt besteld dien je dit binnen 7 dagen nadat je een bevestigingsmail van ons hebt ontvangen betaald te hebben, als de betaling niet binnen 7 dagen ontvangen is wordt de bestelling geannuleerd. </p> <p> <strong>Producten :</strong> </p> <p> Veel van onze producten zijn 2<sup>e</sup> hands en gebruikt, deze worden geleverd zoals ze op de foto staan, en eventuele gebreken zijn duidelijk te zien, maar dat heeft juist zijn charme. Dit is geen reden om een artikel retour te nemen. Als er sporen van houtworm zichtbaar zijn hebben wij deze altijd behandeld met de juiste middelen zodat dit gestopt is. Omdat onze artikelen uniek zijn hebben wij hier maar 1 exemplaar van, en het kan dus voorkomen dat het artikel net verkocht is, mocht dat zo zijn dan laten we jou dat weten. Heb je eventueel nog vragen over een artikel dan kun je altijd contact opnemen. </p> <p> <strong>Verzendkosten:</strong> </p> <p> Wij versturen de artikelen via PostNL tegen de actuele geldende tarieven, kijk voor de verzendkosten en voorwaarden op <a href=http://www.postnlpakketten.nl/ >http://www.postnlpakketten.nl/</a> . Wil je je bestelling aangetekend of verzekerd verzonden hebben , geef dat dan aan bij je bestelling , want hiervoor gelden andere tarieven. </p> <p v-for=\"rate in shippingRates.shipping_rates\" :key=rate.price> <span> {{ rate.type }} : {{ rate.description }}. {{ rate.price | currencyDisplay }}: maximale afmetingen {{ rate.dimensions }}. </span> </p> <p> Wij verzenden ook naar het buitenland, heb je hierover een vraag , stuur dan een e-mail voor de tarieven van de verzendkosten. </p> <p> Gratis verzending (Standaard 0 - 10 kg) vanaf {{ shippingRates.special_rate.price | currencyDisplay }}! Dit geldt alleen binnen Nederland. </p> <p> Je bestelling wordt pas verzonden als het hele bedrag inclusief verzendkosten is voldaan. </p> <p> <strong> Wij verzenden wereldwijd - We offer global shipping </strong> </p> <p> <strong>Verpakken / verzenden:</strong> </p> <p> Zodra de betaling ontvangen is gaan wij het bestelde artikel verzendklaar maken, wij zullen elk artikel zeer goed verpakken zodat dit veilig verstuurd kan worden. Wij kunnen niet aansprakelijk gesteld worden als er tijdens de verzending breuk en / of transportschade optreedt , ook niet als deze veroorzaakt wordt door PostNL, zodra het artikel verzonden is stuur ik je per e-mail de (eventuele) track&amp;trace code zodat je het pakket online kunt volgen. Wij bewaren zelf ook het track&amp;trace bewijs zodat wij weten waar de zending zich bevindt. </p> <p> Wij zullen de bestelling binnen 5 werkdagen verzenden. Dit kan ook eerder plaats vinden. </p> <p> We zouden het leuk vinden als je na ontvangst van het artikel ons een berichtje stuurt via e-mail of een berichtje plaatst in het gastenboek wat je van het artikel vindt. </p> <p> <strong>Retour zenden:</strong> </p> <p>Als een artikel niet is zoals je verwacht had mag je het altijd terug sturen. <br> Wij storten het hele aankoopbedrag terug inclusief verzendkosten. Laat wel even weten waarom je het retour stuurt doe dit wel binnen 14 dagen. <br> Is het artikel in de zelfde staat door ons ontvangen zoals wij het naar jou verstuurt hebben zullen we het aankoopbedrag inclusief verzendkosten terug storten. <br> Om het artikel retour te zenden vragen we je het via Post NL te versturen en het track &amp; trace nummer te bewaren.</p> <p>Het retour zenden is voor eigen rekening.</p> <p> <strong>Privacy:</strong> </p> <p> Wij zullen met jouw gegevens zeer zorgvuldig omgaan, en nooit voor andere doeleinden gebruiken. </p> <p> Onze webshop heeft een SSL certificaat, dit betekend dat al het verkeer op onze site via een veilig gecodeerde verbinding tussen de server en bezoeker verloopt.</p><p> </p><p> Je gegevens worden volgens de richtlijnen van de AVG/GDPR veilig bijgehouden en worden deze vernietigd na de verplichte bewaartermijn</p> <p> Als je als klant een bestelling plaatst worden je persoonlijke gegevens, te weten voornaam, achternaam adres en e-mailgegevens veilig opgeslagen en deze worden na de verplichte bewaartermijn van 7 jaar vernietigd. </p> <p> <strong>Copyright:</strong> </p> <p> Je mag de inhoud van Catootjes kraam, inclusief de foto’s en teksten niet gebruiken, verspreiden, kopieëren of opslaan zonder onze schriftelijke toestemming. </p> <p> Eventuele drukfouten zijn niet bindend. </p> <p> Catootjes kraam behoud het recht voor wijziging van de algemene voorwaarden en ook de inhoud van haar website tussentijds te wijzigen. </p> <p> Catootjes kraam, September 2016. </p> </div> </div> </div> </div> ";

/***/ }),
/* 649 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"card float-e-margins\"> <div class=card-title> <h1>Kado service</h1> </div> <div class=\"card-content no-padding\"> <div class=row> <div class=col-md-12> <p> Wil je iets uit mijn kraam kado geven? <br> Dan kan ik het versturen naar het door jouw opgegeven adres en voorzien van een kadokaartje met een persoonlijke tekst. </p> </div> </div> </div> </div> ";

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"card float-e-margins\"> <div class=card-title> <h1>Betaling</h1> </div> <div class=card-content> <div class=row> <div class=col-md-12> <p> Na het plaatsen van de bestelling krijg je van ons een bevestiging <br> per e-mail met daarin de totaalprijs inclusief verzendkosten en het bankrekeningnummer. </p> </div> </div> </div> </div> ";

/***/ }),
/* 651 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"card float-e-margins\"> <div class=card-title> <h1>Verzenden en ophalen</h1> </div> <div class=card-content> <div class=row> <div class=col-md-12> <p> <strong>Verzenden</strong> : </p> <p> Nadat we je betaling ontvangen hebben zullen we je bestelling binnen 5 werkdagen verzenden , soms kunnen we het de volgende (werk)dag al verzenden. </p> <p> <strong>Verzendkosten:</strong> </p> <p> Wij versturen de artikelen via PostNL tegen de actuele geldende tarieven, kijk voor de verzendkosten en voorwaarden op <a href=http://www.postnlpakketten.nl/ >http://www.postnlpakketten.nl/</a> . Wil je je bestelling aangetekend of verzekerd verzonden hebben , geef dat dan aan bij je bestelling , want hiervoor gelden andere tarieven. </p> <p v-for=\"rate in shippingRates.shipping_rates\" :key=rate.price> <span> {{ rate.type }} : {{ rate.description }}. {{ rate.price | currencyDisplay }}: maximale afmetingen {{ rate.dimensions }}. </span> </p> <p> Wij verzenden ook naar het buitenland, heb je hierover een vraag , stuur dan een e-mail voor de tarieven van de verzendkosten. </p> <p> Gratis verzending (Standaard 0 - 10 kg) vanaf {{ shippingRates.special_rate.price | currencyDisplay }}! Dit geldt alleen binnen Nederland. </p> <p> Je bestelling wordt pas verzonden als het hele bedrag inclusief verzendkosten is voldaan. </p> <p> <strong> Wij verzenden wereldwijd - We offer global shipping </strong> </p> <p> <strong>Verpakken / verzenden:</strong> </p> <p> Zodra de betaling ontvangen is gaan wij het bestelde artikel verzendklaar maken, wij zullen elk artikel zeer goed verpakken zodat dit veilig verstuurd kan worden. Wij kunnen niet aansprakelijk gesteld worden als er tijdens de verzending breuk en / of transportschade optreedt , ook niet als deze veroorzaakt wordt door PostNL, zodra het artikel verzonden is stuur ik je per e-mail de (eventuele) track&amp;trace code zodat je het pakket online kunt volgen. Wij bewaren zelf ook het track&amp;trace bewijs zodat wij weten waar de zending zich bevindt. </p> <p> Wij zullen de bestelling binnen 5 werkdagen verzenden. Dit kan ook eerder plaats vinden. </p> <p> We zouden het leuk vinden als je na ontvangst van het artikel ons een berichtje stuurt via e-mail of een berichtje plaatst in het gastenboek wat je van het artikel vindt. </p> <p> <strong>Retour zenden:</strong> </p> <p>Als een artikel niet is zoals je verwacht had mag je het altijd terug sturen. <br> Wij storten het hele aankoopbedrag terug inclusief verzendkosten. Laat wel even weten waarom je het retour stuurt doe dit wel binnen 14 dagen. <br> Is het artikel in de zelfde staat door ons ontvangen zoals wij het naar jou verstuurt hebben zullen we het aankoopbedrag inclusief verzendkosten terug storten. <br> Om het artikel retour te zenden vragen we je het via Post NL te versturen en het track &amp; trace nummer te bewaren.</p> <p>Het retour zenden is voor eigen rekening.</p> <p> <strong>Ophalen:</strong> </p> <p> Artikelen kunnen soms te groot of te kwetsbaar zijn om te versturen, dan kun je deze na overleg op komen halen. Als dat van toepassing is kun je met ons <a v-link=\"{ path: '/klantenservice/contact'}\">contact</a> opnemen. </p> </div> </div> </div> </div> ";

/***/ }),
/* 652 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-xs-12> <div class=\"card float-e-margins\"> <div class=card-title> <h1>Banner</h1> </div> <div class=\"card-content no-padding\"> <vc-alert v-if=success type=success :timeout=4000> {{successMessage}} </vc-alert> <vc-alert v-if=error type=danger :dismissible=false> Er is een fout opgetreden! </vc-alert> <div class=table-responsive> <div class=\"card-title card-header form-horizontal\"> <label>Aantal banners: {{total}} </label> <div class=form-group> <label class=\"control-label col-sm-1\" style=text-align:left for=filter>Filter op : </label> <div class=col-sm-4> <input type=text class=form-control id=filter placeholder=Filter v-model=filterKey> </div> <button class=\"btn btn-success\" @click=\"showCustomModal = true\">Voeg banner toe</button> </div> </div> <table class=\"table table-striped table-hover\"> <thead> <tr> <th v-for=\"(key, val) in columns\"> <a @click=sortBy(val) class=arrow :class=\"active: sortKey == column\"> {{ key | capitalize }} </a> </th> </tr></thead> <tbody> <tr v-for=\"banner in adminConfigs | filterBy filterKey | orderBy sortKey reverse\"> <td> <input v-if=edit type=text class=form-control id=BannerDesc v-model=banner.Type> <p v-else style=white-space:pre-line><small>{{ banner.Type }}</small></p> </td> <td> <input v-if=edit type=text class=form-control id=BannerDesc v-model=banner.Description> <p v-else style=white-space:pre-line><small>{{ banner.Description }}</small></p> </td> <td> <div class=ios> <vui-toggle name=wifi :checked.sync=banner.Enabled @change=setAvailable(banner)></vui-toggle> </div> <p v-if=banner.Enabled class=text-success>Aan</p> <p v-else class=text-danger>Uit</p> </td> <td width=10%> <button type=button class=\"btn btn-danger\" @click=selectBanner(banner)>Verwijder</button> <button v-if=edit type=button class=\"btn btn-success\" @click=updateBanner(banner)>Opslaan</button> <button v-else type=button class=\"btn btn-primary\" @click=\"edit = true\">Wijzig</button> </td> </tr> </tbody> </table> </div> </div> </div> </div> <vm-delete :callback.sync=remove :show.sync=showdeltemodal></vm-delete> <v-modal :show.sync=showCustomModal effect=fade width=400> <div slot=modal-header class=modal-header> <h4 class=modal-title> <b>Nieuwe banner toevoegen</b> </h4> </div> <div slot=modal-body class=modal-body> <div class=form-group> <label for=BannerType>Banner Titel:</label> <input type=text class=form-control id=BannerType v-model=newBanner.Type placeholder=\"bijvoorbeeld: Vakantie, Actie etc.\"> </div> <div class=form-group> <label for=BannerDesc>Banner Beschrijving:</label> <input type=text class=form-control id=BannerDesc v-model=newBanner.Description> </div> <div class=form-group> <label for=BannerName>Banner direct aan?:</label> <label><input type=checkbox v-model=newBanner.Enabled></label> </div> </div> <div slot=modal-footer class=modal-footer> <button type=button class=\"btn btn-success\" @click=save()>Opslaan</button> <vc-alert v-if=modalsuccess type=success :timeout=4000> Banner succesvol toegevoegd! </vc-alert> <vc-alert v-if=modalerror type=danger :dismissible=false> Er is een fout opgetreden! </vc-alert> </div> </v-modal> ";

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-xs-12> <div class=\"card float-e-margins\"> <div class=card-title> <h1>Overzicht</h1> </div> <div class=\"card-content no-padding\"> <vc-alert v-if=success type=success :timeout=4000> {{successMessage}} </vc-alert> <vc-alert v-if=error type=danger :dismissible=false> Er is een fout opgetreden! </vc-alert> <div class=table-responsive> <div class=\"card-title card-header form-horizontal\"> <label>Aantal advertenties: {{total}} </label> <div class=form-group> <label class=\"control-label col-sm-1\" style=text-align:left for=filter>Filter op : </label> <div class=col-sm-4> <input type=text class=form-control id=filter placeholder=Filter v-model=filterKey> </div> </div> <a @click=filterOnIsOffered()>Aanbevolen producten</a> </div> <table class=\"table table-striped table-hover\"> <thead> <tr> <th v-for=\"(key, val) in columns\"> <a @click=sortBy(val) class=arrow :class=\"active: sortKey == column\"> {{ key | capitalize }} </a> </th> </tr></thead> <tbody> <tr v-for=\"product in products | filterBy filterKey | orderBy sortKey reverse\"> <td> <div class=pull-left> <img v-lazy=product.Photos[0].URL style=height:100px;width:100px> </div> </td> <td> <p><strong>{{ product.Name }}</strong></p> <p style=white-space:pre-line><small>{{ product.Description }}</small></p> </td> <td width=10%>{{ product.Price | currencyDisplay }}</td> <td> <div class=ios> <vui-toggle name=wifi :checked.sync=product.Available @change=setAvailable(product)></vui-toggle> </div> <p v-if=product.Available class=text-success>Beschikbaar</p> <p v-else class=text-danger>Verkocht</p> </td> <td width=10%>{{product.DateSubmitted}}</td> <td width=10%> <button type=button class=\"btn btn-danger\" @click=\"selectProduct(product, 'delete')\">Verwijder</button> <br> <button v-if=!product.Offered type=button class=\"btn btn-success\" @click=\"selectProduct(product, 'offer')\">Aanbevolen</button> <button v-else type=button class=\"btn btn-success\" @click=\"selectProduct(product, 'offerOff')\">UIT Aanbevolen</button> <br> <button type=button class=\"btn btn-primary\" v-link=\"{ name: 'AddProduct', params: { id: product.ProductId }}\">Wijzig</button> </td> </tr> </tbody> </table> </div> </div> </div> </div> <vm-delete :callback.sync=remove :show.sync=showdeltemodal></vm-delete> <vm-offer></vm-offer> ";

/***/ }),
/* 654 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-xs-12> <div class=\"card float-e-margins\"> <div class=card-title> <h1>Reacties goedkeuren</h1> </div> <div class=\"card-content no-padding\"> <vc-alert v-if=success type=success :timeout=4000> {{successMessage}} </vc-alert> <vc-alert v-if=error type=danger :dismissible=false> Er is een fout opgetreden! </vc-alert> <div class=table-responsive> <div class=\"card-title card-header form-horizontal\"> <label>Aantal reacties: {{total}} </label> <div class=form-group> <label class=\"control-label col-sm-1\" style=text-align:left for=filter>Filter op : </label> <div class=col-sm-4> <input type=text class=form-control id=filter placeholder=Filter v-model=filterKey> </div> </div> </div> <table class=\"table table-striped table-hover\"> <thead> <tr> <th v-for=\"(key, val) in columns\"> <a @click=sortBy(val) class=arrow :class=\"active: sortKey == column\"> {{ key | capitalize }} </a> </th> </tr></thead> <tbody> <tr v-for=\"review in Reviews | filterBy filterKey | orderBy sortKey reverse\"> <td> <input v-if=edit type=text class=form-control id=reviewDesc v-model=review.Type> <p v-else style=white-space:pre-line><small>{{ review.Name }}</small></p> </td> <td> <input v-if=edit type=text class=form-control id=reviewDesc v-model=review.Description> <p v-else style=white-space:pre-line><small>{{ review.Content }}</small></p> </td> <td> <div class=ios> <vui-toggle name=wifi :checked.sync=review.Approved @change=setAvailable(review)></vui-toggle> </div> <p v-if=review.Approved class=text-success>Aan</p> <p v-else class=text-danger>Verborgen</p> </td> <td width=10%> <button type=button class=\"btn btn-danger\" @click=selectreview(review)>Verwijder</button> </td> </tr> </tbody> </table> </div> </div> </div> </div> <vm-delete :callback.sync=remove :show.sync=showdeltemodal></vm-delete> ";

/***/ }),
/* 655 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-xs-12> <div class=\"card float-e-margins\"> <div class=card-title> <h1>Orders goedkeuren en verzendkosten invullen</h1> </div> <div class=\"card-content no-padding\"> <vc-alert v-if=success type=success :timeout=4000> {{successMessage}} </vc-alert> <vc-alert v-if=error type=danger :dismissible=false> Er is een fout opgetreden! </vc-alert> <div class=table-responsive> <div class=\"card-title card-header form-horizontal\"> <label>Aantal orders: {{total}} </label> <div class=form-group> <label class=\"control-label col-sm-1\" style=text-align:left for=filter>Filter op : </label> <div class=col-sm-4> <input type=text class=form-control id=filter placeholder=Filter v-model=filterKey> </div> </div> </div> <table class=\"table table-hover\"> <thead> <tr> <th v-for=\"(key, val) in columns\"> <a @click=sortBy(val) class=arrow :class=\"active: sortKey == column\"> {{ key | capitalize }} </a> </th> </tr></thead> <tbody> <tr v-for=\"order in Orders | filterBy filterKey | orderBy sortKey reverse\" :class=\"{ 'success': order.IsActive }\"> <td> <p style=white-space:pre-line><small>{{ order.CustomerName }}</small></p> </td> <td> <p style=white-space:pre-line><small>{{ order.CustomerMail }}</small></p> </td> <td> <p style=white-space:pre-line><small>{{ order.Address + ' ' + order.HouseNumber + ', ' + order.ZipCode + ' ' + order.Place}}</small> <small v-if=order.Remark>(Opmerking: {{order.Remark}})</small> </p> </td> <td> <p style=white-space:pre-line><small>{{ order.DateSubmitted }}</small></p> </td> <td> <p style=white-space:pre-line><small>{{ order.SubTotal | currencyDisplay }}</small></p> </td> <td> <p style=white-space:pre-line><small>{{ order.ShipCosts | currencyDisplay }}</small></p> </td> <td> <p style=white-space:pre-line><small>{{ (order.SubTotal + order.ShipCosts) | currencyDisplay }}</small></p> </td> <td width=10%> <button type=button class=\"btn btn-danger\" @click=\"selectorder(order, 'delete')\">Verwijder</button> <button type=button class=\"btn btn-primary\" @click=\"selectorder(order, 'update')\">Wijzig</button> </td> </tr> </tbody> </table> </div> </div> </div> </div> <vm-delete :callback.sync=remove :show.sync=showdeltemodal></vm-delete> <v-modal :show.sync=showCustomModal effect=fade width=400> <div slot=modal-header class=modal-header> <h4 class=modal-title> <b>Order aanpassen</b> </h4> </div> <div slot=modal-body class=modal-body> <div class=form-group> <label for=custName>Klant gegevens: </label> <p id=custName style=white-space:pre-line><small>{{ selectedorder.CustomerName }}</small></p> <p style=white-space:pre-line><small>{{ selectedorder.CustomerMail }}</small></p> <p style=white-space:pre-line><small>{{ selectedorder.Address + ' ' + selectedorder.HouseNumber + ', ' + selectedorder.ZipCode + ' ' + selectedorder.Place }}</small> <small v-if=order.Remark>(Opmerking: {{order.Remark}})</small></p> </div> <div class=form-group> <label for=subselected>Order details:</label> <overzicht :products=selectedorder.Products :subtotal.sync=selectedorder.SubTotal :shippingcost.sync=selectedorder.ShipCosts :totalprice=\"(selectedorder.SubTotal + selectedorder.ShipCosts)\"></overzicht> <p id=subselected style=white-space:pre-line><small>{{ selectedorder.SubTotal | currencyDisplay }}</small></p> <input type=text class=form-control id=selectedorderDesc v-model=\"selectedorder.ShipCosts | currencyDisplay\"> <hr> <p id=totalselected><strong>Totaal: </strong>{{ (selectedorder.SubTotal + selectedorder.ShipCosts) | currencyDisplay }}</p> </div> <div class=form-group> <label for=BannerName>Opslaan en mail versturen: </label> <label><input type=checkbox v-model=selectedorder.saved></label> </div> </div> <div slot=modal-footer class=modal-footer> <button type=button class=\"btn btn-success\" :disabled=!selectedorder.saved @click=updateorder()>Opslaan</button> </div> </v-modal> ";

/***/ }),
/* 656 */
/***/ (function(module, exports) {

	module.exports = " <div class=datepicker> <input :type=\"inline ? 'hidden' : 'text'\" class=\"form-control pull-left dateinput\" :name=name @click=showCalendar() :value=formattedValue :placeholder=placeholder readonly=readonly> <div class=calendar v-show=showDayView v-bind:style=calendarStyle> <header> <span @click=previousMonth class=prev v-bind:class=\"{ 'disabled' : previousMonthDisabled(currDate) }\">&lt;</span> <span @click=showMonthCalendar class=up>{{ currMonthName }} {{ currYear }}</span> <span @click=nextMonth class=next v-bind:class=\"{ 'disabled' : nextMonthDisabled(currDate) }\">&gt;</span> </header> <span class=\"cell day-header\" v-for=\"d in translation.days\">{{ d }}</span> <span class=\"cell day blank\" v-for=\"d in blankDays\"></span><span class=\"cell day\" v-for=\"day in days\" track-by=timestamp v-bind:class=\"{ 'selected':day.isSelected, 'disabled':day.isDisabled }\" @click=selectDate(day)>{{ day.date }}</span> </div> <div class=calendar v-show=showMonthView v-bind:style=calendarStyleSecondary> <header> <span @click=previousYear class=prev v-bind:class=\"{ 'disabled' : previousYearDisabled(currDate) }\">&lt;</span> <span @click=showYearCalendar class=up>{{ getYear() }}</span> <span @click=nextYear class=next v-bind:class=\"{ 'disabled' : nextYearDisabled(currDate) }\">&gt;</span> </header> <span class=\"cell month\" v-for=\"month in months\" track-by=timestamp v-bind:class=\"{ 'selected': month.isSelected, 'disabled': month.isDisabled }\" @click.stop=selectMonth(month)>{{ month.month }}</span> </div> <div class=calendar v-show=showYearView v-bind:style=calendarStyleSecondary> <header> <span @click=previousDecade class=prev v-bind:class=\"{ 'disabled' : previousDecadeDisabled(currDate) }\">&lt;</span> <span>{{ getDecade() }}</span> <span @click=nextDecade class=next v-bind:class=\"{ 'disabled' : nextMonthDisabled(currDate) }\">&gt;</span> </header> <span class=\"cell year\" v-for=\"year in years\" track-by=timestamp v-bind:class=\"{ 'selected': year.isSelected, 'disabled': year.isDisabled }\" @click.stop=selectYear(year)>{{ year.year }}</span> </div> </div> ";

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <footer> <div class=footer-above> <div class=container> <div class=row> <div class=\"footer-col col-md-2 text-left\"> <h3>Contact gegevens</h3> <p> <a style=\"color: white\" href=http://catootjeskraam.nl>catootjeskraam.nl</a> </p> <p> <a style=\"color: white\" href=mailto:info@catootjeskraam.nl>info@catootjeskraam.nl</a> </p> <p> <img src=" + __webpack_require__(629) + " height=24px width=24px> Openingstijden: <br> 24 uur per dag. <br> 7 dagen per week. <br> 365 dagen per jaar. </p> </div> <div class=\"footer-col col-md-2 text-left\"> <h3>Informatie</h3> <p> <img src=" + __webpack_require__(210) + " height=16px width=16px> <a style=\"color: white\" href=https://www.instagram.com/Catootjeskraam>@catootjeskraam</a> </p> <p> <img src=" + __webpack_require__(631) + " height=16px width=16px> <a style=\"color: white\" href=\"https://www.kvk.nl/orderstraat/product-kiezen/?kvknummer=666305410000\">66630541</a> </p> <p> % BTW : NL001485810B09 </p> <p> <i class=\"fa fa-university\" aria-hidden=true></i> IBAN : NL72KNAB0255457324 </p> <p> <i class=\"fa fa-university\" aria-hidden=true></i> BIC : KNABNL2H </p> <p> <img src=" + __webpack_require__(630) + " height=32px> </p> </div> <div class=\"footer-col col-md-4 text-left\"> <img src=" + __webpack_require__(210) + " height=32px width=32px> <a style=\"color: white\" href=https://www.instagram.com/Catootjeskraam>@catootjeskraam</a> </div> </div> </div> </div> <div class=footer-below> <div class=container> <div class=\"row text-center\"> <div class=col-lg-12> Copyright © Catootjeskraam.nl <p> <a v-link=\"{ path: '/login/' }\">Login</a> </p> </div> </div> </div> </div> </footer> ";

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <a href=/ > <div class=header-wrapper> <img src=" + __webpack_require__(627) + " class=\"img-responsive center-block\" href=/ > </div> </a> <header class=\"navbar navbar-default navbar-static-top\"> <div class=navbar-header> <button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navbar aria-expanded=false aria-controls=navbar> <span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span> </button> </div> <div id=navbar class=\"navbar-collapse collapse\"> <ul class=\"nav navbar-nav\"> <li href=/index><a href=/index>Welkom</a></li> <li class=dropdown v-link-active> <a style=\"color:#F589A7; font-size: x-large\" class=dropdown-toggle data-toggle=dropdown role=button aria-haspopup=true aria-expanded=false> Kraampjes<span class=caret></span></a> <ul class=dropdown-menu role=menu aria-labelledby=dropdownMenu> <li v-link-active> <a v-link=\"{name: 'categorie', params: {id: 50, cname: 'alles-in-1-kraampje'}}\">Alles-in-1 Kraampje</a> </li> <li v-link-active v-for=\"item in MenuItems\" :class=\"{ 'dropdown-submenu': item.Children.length > 0 }\"> <a :class=\"{ 'menu-blue': item.MenuItemId === 46 }\" v-link=\"{ name: 'categorie', params: { id: item.MenuItemId, cname: $options.filters.slugurl(item.MenuText) }}\" @click=selectCat(item)>{{item.MenuText}}</a> <ul class=dropdown-menu> <li v-link-active v-for=\"subitem in item.Children | orderBy 'MenuText'\"> <a v-link=\"{ name: 'categorie', params: { cname: $options.filters.slugurl(subitem.MenuText), id: subitem.MenuItemId }}\" @click=selectCat(subitem)>{{subitem.MenuText}}</a> </li> </ul> </li> <li v-link-active> <a v-link=\"{name: 'categorie', params: {id: 20, cname: 'jammer'}}\">JAMMER!!</a> </li> </ul> </li> <li v-link=\"{ path: '/gastenboek'}\"><a v-link=\"{ path: '/gastenboek'}\">Gastenboek</a></li> <li class=dropdown v-link-active> <a class=dropdown-toggle data-toggle=dropdown role=button aria-haspopup=true aria-expanded=false> Klantenservice<span class=caret></span></a> <ul class=dropdown-menu role=menu aria-labelledby=dropdownMenu> <li v-link-active v-link=\"{ name: 'algemeneVoorwaarden'}\"> <a v-link=\"{ name: 'algemeneVoorwaarden'}\">Algemene voorwaarden</a> </li> <li v-link-active v-link=\"{ name: 'giftService'}\"> <a v-link=\"{ name: 'giftService'}\">Kado Service</a> </li> <li v-link-active v-link=\"{ name: 'shipping'}\"> <a v-link=\"{ name: 'shipping'}\">Verzenden en ophalen</a> </li> <li v-link-active v-link=\"{ name: 'paying'}\"> <a v-link=\"{ name: 'paying'}\">Betaling</a> </li> </ul> </li> <li v-link=\"{ path: '/over-ons'}\"><a v-link=\"{ path: '/over-ons'}\">Over Ons</a></li> </ul> <div class=\"navbar-form navbar-right\" role=search> <div class=form-group> <input type=text class=form-control placeholder=Zoeken v-model=searchTerm @keyup.enter=search()> </div> <button type=submit class=\"btn btn-default\" @click=search()> <span class=\"glyphicon glyphicon-search\"></span> Zoeken</button> </div> <ul class=\"nav navbar-nav navbar-right\"> <li v-if=store.auth> <a href=# @click=logout()>Uitloggen</a> </li> <li v-if=store.auth class=dropdown v-link-active> <a class=dropdown-toggle data-toggle=dropdown role=button aria-haspopup=true aria-expanded=false> Overzicht<span class=caret></span></a> <ul class=dropdown-menu role=menu aria-labelledby=dropdownMenu> <li v-link=\"{ path: '/dashboard/'}\"> <a v-link=\"{ path: '/dashboard/'}\">Artikelen</a> </li> <li v-link=\"{ name: 'addRubrics'}\"> <a v-link=\"{ name: 'addRubrics'}\">Rubrieken</a> </li> <li v-link=\"{ name: 'banner'}\"> <a v-link=\"{ name: 'banner'}\">(vakantie)banner</a> </li> <li v-link=\"{ name: 'admin-gastenboek'}\"> <a v-link=\"{ name: 'admin-gastenboek'}\">Gastenboek goedkeuren</a> </li> <li v-link=\"{ name: 'admin-order-overzicht'}\"> <a v-link=\"{ name: 'admin-order-overzicht'}\">Overzicht orders</a> </li> <li v-link=\"{ name: 'admin-gebruikers-overzicht'}\"> <a v-link=\"{ name: 'admin-gebruikers-overzicht'}\">Gebruikersteller</a> </li> </ul> </li> <li v-if=store.auth v-link=\"{ path: '/addProduct'}\"> <a v-link=\"{ path: '/addProduct'}\">Nieuwe advertentie</a> </li> <li v-link=\"{ name: 'order'}\"> <a style=color:#F589A7;font-size:200% v-link=\"{ name: 'order'}\"> <span class=\"glyphicon glyphicon-shopping-cart\" aria-hidden=true></span> ({{store.cart.length}})</a> </li> </ul> </div> </header> <slot></slot> ";

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"col-xs-12 col-sm-6\"> <h3>Winkelwagen</h3> <table v-if=\"products.length > 0\" id=cart class=\"table table-condensed\"> <thead> <tr> <th style=width:50%></th> <th style=width:10%></th> <th style=width:8%></th> <th style=width:22%></th> <th style=width:10%></th> </tr> </thead> <tbody v-for=\"product in products\" track-by=$index> <tr> <td data-th=\"\"> <div class=row> <div class=col-sm-12> <p class=nomargin>{{product.Name}}</p> </div> </div> </td> <td colspan=3 class=text-right> <p><strong>{{product.Quantity}}x</strong></p> </td> <td colspan=3 class=text-right> <p><strong>{{product.Price | currencyDisplay}}</strong></p> </td> </tr> </tbody> <tfoot> <tr class=visible-xs> <td colspan=5 class=text-center> <p><strong>subtotaal {{subtotal | currencyDisplay}}</strong></p> <p> <strong>Verzendkosten {{shippingCost | currencyDisplay}}</strong> </p> <h3><strong>Totaal {{totalPrice | currencyDisplay}}</strong></h3> </td> </tr> <tr class=hidden-xs> <td colspan=2></td> <td colspan=3 class=text-right> <p><strong>subtotaal {{subtotal | currencyDisplay}}</strong></p> <p> <strong>Verzendkosten {{shippingCost | currencyDisplay}}</strong> </p> <h3><strong>Totaal {{totalPrice | currencyDisplay}}</strong></h3> </td> </tr> </tfoot> </table> </div> <div class=\"col-xs-12 col-sm-6\"> <h3> Aflevergegevens </h3> <p>{{invoice.customer.sex}} {{invoice.customer.firstname}} {{invoice.customer.lastname}} </p> <p>{{invoice.customer.street}} {{invoice.customer.housenumber}}</p> <p>{{invoice.customer.zipcode}} {{invoice.customer.city}}</p> </div> ";

/***/ }),
/* 660 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"card float-e-margins\"> <div class=\"card-content no-padding\"> <vs-wizard :current-index.sync=currentStep> <vs-wizard-step title=Winkelwagen description=\"\" :progress=progress.step1 icon=shopping-cart> </vs-wizard-step> <vs-wizard-step title=\"Uw gegevens\" description=\"\" :progress=progress.step2 icon=user> </vs-wizard-step> <vs-wizard-step title=Bevestigen description=\"\" :progress=progress.step3 icon=check> </vs-wizard-step> </vs-wizard> <hr class=hidden-xs-down> <form class=\"m-b row clearfix\" v-if=\"currentStep == 0\"> <div class=col-xs-12> <h1>Winkelwagen</h1> <div class=row> <v-cart></v-cart> <button class=\"btn btn-success pull-right\" :disabled=\"store.cart.length < 1\" @click.prevent=currentStep++>Verder</button> </div> <hr> </div> </form> <validator name=customerValidation> <form novalidate class=\"m-b row clearfix\" v-if=\"currentStep == 1\"> <div class=col-sm-12> <div class=\"col-xs-12 col-sm-6\"> <h1> Persoonlijke gegevens </h1> <fieldset class=form-group :class=\"{ 'has-error': checkSex }\"> <div class=col-sm-12> <label for=optradio>Aanhef*</label> <br> <label class=radio-inline> <input type=radio name=optradio value=Dhr. v-model=invoice.customer.sex v-validate:sex=\"{ required: true }\">Dhr. </label> <label class=radio-inline> <input type=radio name=optradio value=Mevr. v-model=invoice.customer.sex v-validate:sex>Mevr. </label> </div> </fieldset> <fieldset class=form-group :class=\"{ 'has-error': checkFirstname }\"> <div class=col-sm-12> <label for=firstname>Voornaam*</label> <input autocomplete=off type=text class=form-control id=firstname v-validate:firstname=\"['required']\" v-model=invoice.customer.firstname> </div> </fieldset> <fieldset class=form-group :class=\"{ 'has-error': checkLastname }\"> <div class=col-sm-12> <label for=lastname>Achternaam*</label> <input autocomplete=off type=text class=form-control id=lastname v-validate:lastname=\"['required']\" v-model=invoice.customer.lastname> </div> </fieldset> <fieldset class=form-group :class=\"{ 'has-error': checkEmail }\"> <div class=col-sm-12> <label for=email>E-mailadres*</label> <input autocomplete=off type=email class=form-control id=email v-validate:email=\"['email']\" v-model=invoice.customer.email> </div> </fieldset> <h1> Adres </h1> <fieldset class=\"form-group col-sm-8\" :class=\"{ 'has-error': checkStreet }\"> <label for=street>Straatnaam*</label> <input autocomplete=off type=text class=form-control id=street v-validate:street=\"['required']\" v-model=invoice.customer.street> </fieldset> <fieldset class=\"form-group col-sm-2 col-xs-6\" :class=\"{ 'has-error': checkHousenumber }\"> <label for=housenumber>Huisnummer*</label> <input autocomplete=off type=text class=form-control id=housenumber v-validate:housenumber=\"['required', 'housenumber']\" v-model=invoice.customer.housenumberr> </fieldset> <fieldset class=\"form-group col-sm-2 col-xs-6\"> <label for=housenumberaddition>Toevoeging</label> <input autocomplete=off type=text id=housenumberaddition class=form-control v-model=invoice.customer.housenumberaddition> </fieldset> <fieldset class=\"form-group col-sm-12 col-xs-12\"> <label for=remark>Opmerking</label> <input autocomplete=off type=text class=form-control id=remark v-model=invoice.customer.remark> </fieldset> <fieldset class=\"form-group col-sm-6\" :class=\"{ 'has-error': checkZip }\"> <label for=zipcode>Postcode*</label> <input @blur=removeSpaces() autocomplete=off type=text class=form-control id=zipcode v-validate:zip=\"['required', 'dutchzip']\" v-model=invoice.customer.zipcode> <label for=zipcode class=text-danger>Living outside the Netherlands? <br> Please fill in 4902PP and contact us.</label> </fieldset> <fieldset class=\"form-group col-sm-6\" :class=\"{ 'has-error': checkCity }\"> <label for=city>Plaatsnaam*</label> <input autocomplete=off type=text class=form-control id=city v-validate:city=\"['required']\" v-model=invoice.customer.city> </fieldset> <p class=col-sm-12><strong>* Verplichte velden</strong></p> </div> </div> <div class=col-sm-12> <button class=\"btn btn-success pull-right\" :disabled=$customerValidation.invalid @click.prevent=GoToConfirm()>Verder</button> </div> </form> </validator> <div class=\"m-b row clearfix\" v-if=\"currentStep == 2\"> <div class=row> <v-confirm :invoice.sync=invoice></v-confirm> </div> <div class=pull-right> <div class=checkbox> <label><input id=confirmbox type=checkbox v-model=confirmed :disabled=sending :class=\"{ hidden : sended }\"> Ik ga akkoord met de <a v-link=\"{ name: 'algemeneVoorwaarden'}\" target=_blank>algemene voorwaarden</a> </label> </div> <button id=sendButton class=\"btn btn-lg btn-warning\" :disabled=\"sending || !confirmed\" @click=handleInvoice()> <span v-if=sending class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> verzenden </button> </div> </div> <vc-alert v-if=success type=success> Je bestelling is ontvangen je krijgt op het opgegeven e-mailadres een bevestiging hiervan. <br> Mail niet ontvangen? Check je ongewenste mail folder of neem contact op met ons via info@catootjeskraam.nl <br> <a href=/ >klik hier om verder te winkelen</a> </vc-alert> </div> </div> ";

/***/ }),
/* 661 */
/***/ (function(module, exports) {

	module.exports = " <div v-bind:class=\"{'wizard-step': true, 'active': isActive, 'previous' : isPrevious, 'next' : isNext}\" v-on:click.prevent=changeCurrentIndex()> <div class=wizard-progress> <div class=wizard-progress-value></div> </div> <div class=wizard-icon> <div class=icon-icon><span class=info-box-icon><i class=\"fa fa-{{icon}} fa-1x\"></i></span></div> <div class=icon-number v-if=!icon>{{iconNumber || index +1}}</div> </div> <div class=wizard-content> <div class=title>{{title}}</div> <div class=description>{{description}}</div> </div> <div class=step-info> Stap {{index+1}}/{{$parent.countItems}} </div> </div> ";

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	module.exports = " <div class=gritcode-wizard> <slot></slot> </div> ";

/***/ }),
/* 663 */
/***/ (function(module, exports) {

	module.exports = " <div v-if=show class=showbanner _v-243d033a=\"\"> <p class=text-right _v-243d033a=\"\"> <a @click=close style=cursor:pointer _v-243d033a=\"\"><span class=\"glyphicon glyphicon-remove-circle\" _v-243d033a=\"\"></span></a> </p> <h3 _v-243d033a=\"\"><strong _v-243d033a=\"\">{{banner.Type}}</strong></h3> <p _v-243d033a=\"\"> {{banner.Description}} </p> </div> ";

/***/ }),
/* 664 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-xs-12 _v-2ea8af5c=\"\"> <div class=\"card float-e-margins\" _v-2ea8af5c=\"\"> <div class=card-title _v-2ea8af5c=\"\"> <h1 _v-2ea8af5c=\"\">Rubrieken aanpassen</h1> </div> <div class=\"card-content no-padding\" _v-2ea8af5c=\"\"> <div class=row _v-2ea8af5c=\"\"> <div class=col-xs-12 _v-2ea8af5c=\"\"> <div class=\"card float-e-margins\" _v-2ea8af5c=\"\"> <div class=card-title style=background-color:#2C3E50 _v-2ea8af5c=\"\"> <div class=col-lg-6 _v-2ea8af5c=\"\"> <h5 style=color:white _v-2ea8af5c=\"\"> Rubrieken </h5> </div> </div> <div class=row _v-2ea8af5c=\"\"> <div class=\"card-content no-padding\" _v-2ea8af5c=\"\"> <div class=panel-group id=accordion role=tablist aria-multiselectable=true _v-2ea8af5c=\"\"> <a @click=setModal(0) _v-2ea8af5c=\"\"><span class=\"glyphicon glyphicon-plus\" _v-2ea8af5c=\"\"></span>Nieuwe rubriek toevoegen</a> <div class=\"panel panel-default\" v-for=\"item in rubrieks\" _v-2ea8af5c=\"\"> <div class=panel-heading role=tab id=heading _v-2ea8af5c=\"\"> <h4 v-if=!item.Editable class=panel-title _v-2ea8af5c=\"\"> <a class=collapsed role=button data-toggle=collapse data-parent=#accordion href=#{{item.MenuItemId}} aria-expanded=false aria-controls={{item.MenuItemId}} _v-2ea8af5c=\"\"> {{item.MenuText}} </a> <p _v-2ea8af5c=\"\"> <a @click=\"item.Editable = true\" class=text-right _v-2ea8af5c=\"\"> <span class=\"glyphicon glyphicon-pencil\" _v-2ea8af5c=\"\"></span> Wijzigen </a> </p> </h4> <div v-else=\"\" class=panel-heading role=tab id=headingOne _v-2ea8af5c=\"\"> <div class=form-inline _v-2ea8af5c=\"\"> <div class=form-group _v-2ea8af5c=\"\"> <label class=sr-only for=categoryname _v-2ea8af5c=\"\">Rubriek naam</label> <input type=email class=form-control id=categoryname v-model=item.MenuText _v-2ea8af5c=\"\"> </div> <button type=button class=\"btn btn-success\" @click=edit(item) _v-2ea8af5c=\"\">Opslaan</button> <button type=button class=\"btn btn-default\" @click=refresh() _v-2ea8af5c=\"\">Annuleren</button> <button type=button class=\"btn btn-danger\" @click=deleteCategory(item.MenuItemId) _v-2ea8af5c=\"\">Verwijderen</button> <vc-alert successmessage=\"Rubriek succesvol bijgewerkt!\" :success.sync=editsuccess :error.sync=editerror _v-2ea8af5c=\"\"> </vc-alert> </div> </div> </div> <div id={{item.MenuItemId}} class=\"panel-collapse collapse\" role=tabpanel aria-labelledby=heading _v-2ea8af5c=\"\"> <div class=panel-body _v-2ea8af5c=\"\"> <a @click=setModal(item.MenuItemId) _v-2ea8af5c=\"\"> <span class=\"glyphicon glyphicon-plus\" _v-2ea8af5c=\"\"></span> Nieuwe subrubriek toevoegen voor {{item.MenuText}} </a> <div v-for=\"subitem in item.Children | orderBy 'MenuText'\" class=\"panel panel-default\" _v-2ea8af5c=\"\"> <div v-if=!subitem.Editable class=panel-heading role=tab id=headingOne _v-2ea8af5c=\"\"> <p class=panel-title _v-2ea8af5c=\"\"> {{subitem.MenuText}} </p> <a @click=\"subitem.Editable = true\" _v-2ea8af5c=\"\"> <span @click=\"subitem.Editable = true\" class=\"glyphicon glyphicon-pencil\" _v-2ea8af5c=\"\"></span> Wijzigen </a> </div> <div v-else=\"\" class=panel-heading role=tab id=headingOne _v-2ea8af5c=\"\"> <div class=form-inline _v-2ea8af5c=\"\"> <div class=form-group _v-2ea8af5c=\"\"> <label class=sr-only for=subcategoryname _v-2ea8af5c=\"\">Rubriek naam</label> <input type=email class=form-control id=subcategoryname v-model=subitem.MenuText _v-2ea8af5c=\"\"> </div> <button type=button class=\"btn btn-success\" @click=edit(subitem) _v-2ea8af5c=\"\">Opslaan</button> <button type=button class=\"btn btn-default\" @click=refresh() _v-2ea8af5c=\"\">Annuleren</button> <button type=button class=\"btn btn-danger\" @click=deleteCategory(subitem.MenuItemId) _v-2ea8af5c=\"\">Verwijderen</button> <vc-alert v-if=modalsuccess type=success :timeout=4000 _v-2ea8af5c=\"\"> Rubriek succesvol bijgewerkt! </vc-alert> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <v-modal :show.sync=showCustomModal effect=fade width=400 _v-2ea8af5c=\"\"> <div slot=modal-header class=modal-header _v-2ea8af5c=\"\"> <h4 class=modal-title _v-2ea8af5c=\"\"> <b _v-2ea8af5c=\"\">Nieuwe rubriek toevoegen</b> </h4> </div> <div slot=modal-body class=modal-body _v-2ea8af5c=\"\"> <div class=form-group _v-2ea8af5c=\"\"> <label for=rubriekName _v-2ea8af5c=\"\">Rubriek naam:</label> <input type=text class=form-control id=rubriekName v-model=newCategoryName _v-2ea8af5c=\"\"> </div> </div> <div slot=modal-footer class=modal-footer _v-2ea8af5c=\"\"> <button type=button class=\"btn btn-success\" @click=save() _v-2ea8af5c=\"\">Opslaan</button> <vc-alert v-if=modalsuccess type=success :timeout=4000 _v-2ea8af5c=\"\"> Rubriek succesvol toegevoegd! </vc-alert> <vc-alert v-if=modalerror type=danger :dismissible=false _v-2ea8af5c=\"\"> Er is een fout opgetreden! </vc-alert> </div> </v-modal> </div> ";

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <template v-doctitle=category></template> <div class=\"card float-e-margins\" _v-4ae6ca21=\"\"> <div class=card-title _v-4ae6ca21=\"\"> <h1 v-if=\"$route.params.id != 20\" _v-4ae6ca21=\"\">{{ category }}</h1> </div> <div class=card-content _v-4ae6ca21=\"\"> <div class=row v-if=\"$route.params.id == 20\" _v-4ae6ca21=\"\"> <div class=\"col-md-12 text-center\" _v-4ae6ca21=\"\"> <img v-else=\"\" class=\"img-responsive center-block\" src=" + __webpack_require__(633) + " style=\"max-height:200px;margin: 0 auto\" _v-4ae6ca21=\"\"> <h1 class=center-block _v-4ae6ca21=\"\">Jammer... maar helaas verkocht!!</h1> </div> </div> <div class=row v-if=!loaded _v-4ae6ca21=\"\"> <div class=\"col-xs-2 col-xs-offset-5\" _v-4ae6ca21=\"\"> <img v-else=\"\" class=img-responsive src=" + __webpack_require__(73) + " style=max-height:50px _v-4ae6ca21=\"\"> <div class=pull-left _v-4ae6ca21=\"\"> <p _v-4ae6ca21=\"\">Laden..</p> </div> </div> </div> <div class=row v-else=\"\" _v-4ae6ca21=\"\"> <div v-for=\"product in products\" class=\"col-lg-3 col-md-4 col-sm-6 col-xs-12\" _v-4ae6ca21=\"\"> <product-card :product=product _v-4ae6ca21=\"\"></product-card> </div> <div class=\"row category-credit\" v-if=loaded _v-4ae6ca21=\"\"> <div v-for=\"submenu in store.selectedCat.Children\" class=\"col-lg-3 col-md-4 col-sm-6 col-xs-12\" style=max-height:320px _v-4ae6ca21=\"\"> <div class=thumbnail _v-4ae6ca21=\"\"> <div class=wrapper _v-4ae6ca21=\"\"> <div class=\"caption post-content\" _v-4ae6ca21=\"\"> <a v-link=\"{ name: 'categorie', params: { id: submenu.MenuItemId, cname: $options.filters.slugurl(submenu.MenuText)}}\" _v-4ae6ca21=\"\"> <h3 _v-4ae6ca21=\"\">{{submenu.MenuText}}</h3> </a> </div> </div> <div class=wrapper _v-4ae6ca21=\"\"> <div class=post-meta _v-4ae6ca21=\"\"> <div class=price _v-4ae6ca21=\"\"></div> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 666 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-xs-12 _v-4fc3ab56=\"\"> <div class=\"card float-e-margins\" _v-4fc3ab56=\"\"> <div class=card-title _v-4fc3ab56=\"\"> <h1 _v-4fc3ab56=\"\">Gebruikersteller</h1> </div> <div class=\"card-content no-padding\" _v-4fc3ab56=\"\"> <div class=table-responsive _v-4fc3ab56=\"\"> <div class=\"card-title card-header form-horizontal\" _v-4fc3ab56=\"\"> <div class=form-group _v-4fc3ab56=\"\"> <label class=\"control-label col-sm-1\" style=text-align:left for=filter _v-4fc3ab56=\"\">Filter op : </label> <div class=col-sm-4 _v-4fc3ab56=\"\"> <input type=text class=form-control id=filter placeholder=Filter v-model=filterKey _v-4fc3ab56=\"\"> </div> </div> </div> <div class=\"col-md-12 text-right\" style=background:white _v-4fc3ab56=\"\"> <div class=form-inline _v-4fc3ab56=\"\"> <datepicker language=nl :disabled=datepicker.disabled placeholder=Begindatum :value.sync=selectedStartDate name=updatedBegin _v-4fc3ab56=\"\"></datepicker> <datepicker language=nl :disabled=datepicker.disabled placeholder=Einddatum :value.sync=selectedEndDate name=updatedEnd _v-4fc3ab56=\"\"></datepicker> <button type=button class=\"btn btn-primary\" :class=\"{ 'active' : isSelectedButton(0) }\" @click=\"period = 'Day', getAnalystics(period), selectedButton = 0\" _v-4fc3ab56=\"\"> Dagelijks </button> <button type=button class=\"btn btn-primary\" :class=\"{ 'active' : isSelectedButton(1) }\" @click=\"period = 'Month', getAnalystics(period), selectedButton = 1\" _v-4fc3ab56=\"\"> Maandelijks </button> <button type=button class=\"btn btn-primary\" :class=\"{ 'active' : isSelectedButton(2) }\" @click=\"period = 'Year', getAnalystics(period), selectedButton = 2\" _v-4fc3ab56=\"\"> Jaarlijks </button> </div> <div class=chart v-echarts=barChartOption :loading=barChartLoading _v-4fc3ab56=\"\"></div> </div> <table class=\"table table-striped table-hover\" _v-4fc3ab56=\"\"> <thead _v-4fc3ab56=\"\"> <tr _v-4fc3ab56=\"\"> <th v-for=\"(key, val) in columns\" _v-4fc3ab56=\"\"> <a @click=sortBy(val) class=arrow _v-4fc3ab56=\"\"> {{ key | capitalize }} </a> </th> </tr></thead> <tbody _v-4fc3ab56=\"\"> <tr v-for=\"analystic in analystics | filterBy filterKey | orderBy sortKey reverse\" _v-4fc3ab56=\"\"> <td _v-4fc3ab56=\"\"> <p v-else=\"\" style=white-space:pre-line _v-4fc3ab56=\"\"><small _v-4fc3ab56=\"\">{{ analystic.Day }}</small></p> </td> <td _v-4fc3ab56=\"\"> <p v-else=\"\" style=white-space:pre-line _v-4fc3ab56=\"\"><small _v-4fc3ab56=\"\">{{ analystic.DateSubmitted }}</small></p> </td> <td _v-4fc3ab56=\"\"> <p v-else=\"\" style=white-space:pre-line _v-4fc3ab56=\"\"><small _v-4fc3ab56=\"\">{{ analystic.Value }}</small></p> </td> </tr> </tbody> </table> </div> </div> </div> </div> ";

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=row _v-52410873=\"\"> <div class=\"col-sm-6 col-md-4 col-md-offset-4\" _v-52410873=\"\"> <div class=account-wall _v-52410873=\"\"> <h1 class=text-center _v-52410873=\"\"> Login </h1> <img class=profile-img src=" + __webpack_require__(628) + " alt=\"\" _v-52410873=\"\"> <form class=form-signin _v-52410873=\"\"> <input type=text class=form-control placeholder=Gebruikersnaam v-model=username required=\"\" autofocus=\"\" _v-52410873=\"\"> <input type=password class=form-control placeholder=Wachtwoord v-model=password required=\"\" _v-52410873=\"\"> <button class=\"btn btn-lg btn-primary btn-block\" type=submit @click=login($event) _v-52410873=\"\"> Login </button> <p class=text-danger v-if=error v-text=error _v-52410873=\"\"></p> </form> </div> </div> </div> ";

/***/ }),
/* 668 */
/***/ (function(module, exports) {

	module.exports = " <div v-if=filesLength class=\"col-md-3 col-sm-4 text-center\" style=height:250px _v-6be008a2=\"\"> <input type=file accept=image/* @change=handleUpload id=upload style=visibility:hidden multiple=\"\" _v-6be008a2=\"\"> <button class=\"btn btn-default upload-drop-zone\" onclick=\"document.getElementById('upload').click();\" id=drop-zone _v-6be008a2=\"\"> <span class=\"glyphicon glyphicon-plus\" aria-hidden=true _v-6be008a2=\"\"></span><br _v-6be008a2=\"\"> Voeg Foto's toe (max 5) <p _v-6be008a2=\"\">Uploaden <i v-show=showspinner class=\"fa fa-spinner fa-pulse\" _v-6be008a2=\"\"></i> </p> </button> </div> <div v-sortable=options class=\"sortable grid\" _v-6be008a2=\"\"> <div class=\"col-md-3 col-sm-4 text-center image-move\" style=\"border-style: groove;position: relative; height:250px\" v-for=\"item in files\" track-by=$index _v-6be008a2=\"\"> <img class=img-responsive :src=item.URL style=height:240px _v-6be008a2=\"\"> <button class=\"btn btn-default btn-circle fa fa-times\" style=\"color:red; position:absolute; top:5px;right:5px\" @click=removeFile($index) _v-6be008a2=\"\"></button> </div> </div> ";

/***/ }),
/* 669 */
/***/ (function(module, exports) {

	module.exports = " <div class=btn-group v-bind:class=\"{open: show}\" _v-75d92d2a=\"\"> <button v-el:btn=\"\" type=button class=\"btn btn-default dropdown-toggle\" @click=toggleDropdown @blur=\"show = (search ? show : false)\" v-bind=\"{disabled: disabled}\" _v-75d92d2a=\"\"> <span class=btn-placeholder v-show=showPlaceholder _v-75d92d2a=\"\">{{placeholder}}</span> <span class=btn-content _v-75d92d2a=\"\">{{ selectedItems }}</span> <span class=caret _v-75d92d2a=\"\"></span> </button> <ul class=dropdown-menu _v-75d92d2a=\"\"> <template v-if=options.length> <li v-if=search class=bs-searchbox _v-75d92d2a=\"\"> <input type=text placeholder=Search v-model=searchText class=form-control autocomplete=off _v-75d92d2a=\"\"> </li> <li v-for=\"option in options | filterBy searchText \" v-bind:id=option.value style=position:relative _v-75d92d2a=\"\"> <a @mousedown.prevent=select(option.value) style=cursor:pointer _v-75d92d2a=\"\"> {{ option.label }} <span class=\"glyphicon glyphicon-ok check-mark\" v-show=isSelected(option.value) _v-75d92d2a=\"\"></span> </a> </li> </template> <slot v-else=\"\" _v-75d92d2a=\"\"></slot> <div class=notify v-show=showNotify transition=fadein _v-75d92d2a=\"\">Limit reached ({{limit}} items max). </div> </ul> </div> ";

/***/ }),
/* 670 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"card float-e-margins\" _v-7781753c=\"\"> <div class=card-title _v-7781753c=\"\"> <h1 _v-7781753c=\"\">Speciaal voor jou gevonden deze week !</h1> </div> <div class=\"card-content no-padding\" _v-7781753c=\"\"> <div class=row _v-7781753c=\"\"> <div class=slider _v-7781753c=\"\"> <img v-for=\"i in 15\" class=carousel-cell :src=products[i].Photos[0].URL alt=\"\" v-link=\"{ name: 'Product', params: { id: products[i].ProductId, pname: $options.filters.slugurl(products[i].Name) }}\" style=cursor:pointer _v-7781753c=\"\"> </div> </div> <div class=row _v-7781753c=\"\"> <div class=col-md-6 _v-7781753c=\"\"> <h2 _v-7781753c=\"\">Welkom</h2> <p _v-7781753c=\"\"> bij Catootjeskraam. </p> <p _v-7781753c=\"\"> Catootjeskraam is een webshop in o.a. antiek, <a v-link=\"{ name: 'categorie', params: { id: 15, cname: 'stoer-' }}\" _v-7781753c=\"\">stoer</a>, <a v-link=\"{ name: 'categorie', params: { id: 3, cname: 'curiosa' }}\" _v-7781753c=\"\">curiosa</a>, <a v-link=\"{ name: 'categorie', params: { id: 100002, cname: 'diversen' }}\" _v-7781753c=\"\">diversen</a>, <a v-link=\"{ name: 'categorie', params: { id: 100003, cname: 'anton-pieck' }}\" _v-7781753c=\"\">Anton Pieck</a> en nog vele andere kraampjes die in September 2016 online is gegaan. </p> <p _v-7781753c=\"\"> Dagelijks zijn wij op zoek naar unieke items in binnen- en buitenland, zodat wij wekelijks onze collectie kunnen aanvullen. <br _v-7781753c=\"\"> Zo blijft het leuk om geregeld onze webshop te bezoeken. <br _v-7781753c=\"\"> In onze slideshow staan de laatste nieuwe aanwinsten die we speciaal voor jou gevonden hebben, <br _v-7781753c=\"\"> en waarmee je je interieur een eigen draai kunt geven. </p> <p _v-7781753c=\"\"> Veel kijkplezier in onze webshop! </p> <p _v-7781753c=\"\"> Oh ja, Catootjeskraam heeft de volgende openingstijden: <br _v-7781753c=\"\"> 24 uur per dag. <br _v-7781753c=\"\"> 7 dagen per week. <br _v-7781753c=\"\"> 365 dagen per jaar. </p> <p _v-7781753c=\"\"> <strong _v-7781753c=\"\"> Wij verzenden wereldwijd <br _v-7781753c=\"\"> We offer global shipping </strong> </p> <p _v-7781753c=\"\"> Heb je nog een vraag, stuur ons dan gerust een <a href=mailto:info@catootjeskraam.nl _v-7781753c=\"\">e-mailtje</a>. </p> </div> </div> </div> </div> ";

/***/ }),
/* 671 */
/***/ (function(module, exports) {

	module.exports = " <table v-if=\"products.length > 0\" id=cart class=\"table table-hover table-condensed\" _v-77d75885=\"\"> <thead _v-77d75885=\"\"> <tr _v-77d75885=\"\"> <th style=width:50% _v-77d75885=\"\"></th> <th style=width:10% _v-77d75885=\"\"></th> <th style=width:8% _v-77d75885=\"\"></th> <th style=width:22% _v-77d75885=\"\"></th> <th style=width:10% _v-77d75885=\"\"></th> </tr> </thead> <tbody v-for=\"product in products\" track-by=$index _v-77d75885=\"\"> <tr _v-77d75885=\"\"> <td data-th=\"\" _v-77d75885=\"\"> <div class=row _v-77d75885=\"\"> <a v-link=\"{ name: 'Product', params: { id: product.ProductId, pname: $options.filters.slugurl(product.Name) }}\" _v-77d75885=\"\"> <div class=col-sm-2 _v-77d75885=\"\"><img v-lazy=product.Photos[0].URL class=img-responsive _v-77d75885=\"\"></div> <div class=col-sm-10 _v-77d75885=\"\"> <h4 class=nomargin _v-77d75885=\"\">{{product.Name}}</h4> </div> </a> <div class=\"col-sm-6 visible-xs\" _v-77d75885=\"\"> {{(product.Price * product.Quantity) | currencyDisplay}} <button class=\"btn btn-danger btn-sm\" @click=remove($index) _v-77d75885=\"\"><i class=\"fa fa-trash-o\" _v-77d75885=\"\"></i> Verwijder</button> </div> </div> </td> <td colspan=1 class=\"\" _v-77d75885=\"\"> <input type=number class=form-control name=quantity value=1 min=1 max=10 v-if=\"product.MenuItemId===46\" v-model=product.Quantity _v-77d75885=\"\"> </td> <td colspan=2 class=\"hidden-xs text-right\" _v-77d75885=\"\"> <h4 style=padding-top:0px _v-77d75885=\"\"><strong _v-77d75885=\"\">{{(product.Price * product.Quantity) | currencyDisplay}}</strong></h4> </td> <td colspan=2 class=\"actions hidden-xs text-right\" data-th=\"\" _v-77d75885=\"\"> <button class=\"btn btn-danger\" @click=remove($index) _v-77d75885=\"\"><i class=\"fa fa-trash-o\" _v-77d75885=\"\"></i> Verwijder</button> </td> </tr> </tbody> <tfoot _v-77d75885=\"\"> <tr class=visible-xs _v-77d75885=\"\"> <td class=text-center _v-77d75885=\"\"> <p _v-77d75885=\"\"><strong _v-77d75885=\"\">subtotaal {{subtotal | currencyDisplay}}</strong></p> <p _v-77d75885=\"\"> <strong _v-77d75885=\"\">Verzendkosten {{shippingCost | currencyDisplay}}</strong> </p><div class=v-tooltip _v-77d75885=\"\">? <span class=v-tooltiptext _v-77d75885=\"\">De verzendkosten worden na verwerking van je order opnieuw berekend.</span> </div> <p _v-77d75885=\"\"></p> <h3 _v-77d75885=\"\"><strong _v-77d75885=\"\">Totaal {{totalPrice | currencyDisplay}}</strong></h3> </td> </tr> <tr _v-77d75885=\"\"> <td colspan=3 class=hidden-xs _v-77d75885=\"\"></td> <td colspan=2 class=\"hidden-xs text-right\" _v-77d75885=\"\"> <p _v-77d75885=\"\"><strong _v-77d75885=\"\">subtotaal {{subtotal | currencyDisplay}}</strong></p> <p _v-77d75885=\"\"> <strong _v-77d75885=\"\">Verzendkosten {{shippingCost | currencyDisplay}}</strong> </p><div class=v-tooltip _v-77d75885=\"\">? <span class=v-tooltiptext _v-77d75885=\"\">De verzendkosten worden na verwerking van je order opnieuw berekend.</span> </div> <p _v-77d75885=\"\"></p> <h3 _v-77d75885=\"\"><strong _v-77d75885=\"\">Totaal {{totalPrice | currencyDisplay}}</strong></h3> </td> </tr> </tfoot> </table> <div class=\"card-content no-padding\" v-if=\"products.length < 1\" _v-77d75885=\"\"> <h2 _v-77d75885=\"\">Geen Producten gevonden</h2> </div> ";

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=\"card float-e-margins\" _v-7d91334e=\"\"> <div class=card-title _v-7d91334e=\"\"> <h1 _v-7d91334e=\"\">{{product.Name}}</h1> </div> <div class=\"card-content no-padding\" v-if=loaded _v-7d91334e=\"\"> <div class=container style=margin:0 _v-7d91334e=\"\"> <div class=col-md-5 style=padding-right:5% _v-7d91334e=\"\"> <div class=row _v-7d91334e=\"\"> <a @click=zoomModal() _v-7d91334e=\"\"> <zoomimage class=\"img img-responsive thumbnail\" style=\"max-height:330px; width:auto;cursor: zoom-in\" :src=selectedImageURL :options=\"{\n                inlinePane: 900,\n                containInline: true,\n                hoverBoundingBox: true,\n                paneContainer: '#zoomContainer',\n                handleTouch: false,\n              }\" @show=\"log('show')\" @hide=\"log('hide')\" _v-7d91334e=\"\"></zoomimage> </a> </div> <div class=row _v-7d91334e=\"\"> <div class=\"row category-credit\" _v-7d91334e=\"\"> <div v-for=\"photo in product.Photos\" track-by=$index class=\"col-sm-3 col-md-3 col-xs-3\" style=padding:5px _v-7d91334e=\"\"> <div class=thumbnail style=max-height:100px;cursor:pointer _v-7d91334e=\"\"> <a @click=changeSelectedImage($index) _v-7d91334e=\"\"> <img class=img-responsive style=height:100px v-lazy=photo.URL alt=\"\" _v-7d91334e=\"\"> </a> </div> </div> </div> </div> </div> <div class=col-md-7 id=zoomContainer _v-7d91334e=\"\"> <div class=row _v-7d91334e=\"\"> <div class=product-title _v-7d91334e=\"\"> {{product.Name}} </div> <div class=product-desc style=white-space:pre-line _v-7d91334e=\"\"> {{product.Description}} </div> <hr _v-7d91334e=\"\"> <div v-if=\"product.Available &amp;&amp; !product.PriceOnRequest\" class=product-price _v-7d91334e=\"\"> {{product.Price | currencyDisplay}} </div> <div v-if=\"product.Available &amp;&amp; product.PriceOnRequest\" class=\"text-success product-stock\" _v-7d91334e=\"\"> Prijs op aanvraag <div _v-7d91334e=\"\"> <button type=button class=\"btn btn-success\" @click=\"showRequestModal=true\" _v-7d91334e=\"\"> <span class=\"fa fa-envelope\" aria-hidden=true _v-7d91334e=\"\"></span> Toon interesse! </button> </div> </div> <div v-if=product.Available class=\"text-success product-stock\" _v-7d91334e=\"\"> Beschikbaar </div> <div v-if=!product.Available class=\"text-danger product-stock\" _v-7d91334e=\"\"> Verkocht </div> <hr _v-7d91334e=\"\"> <div v-if=\"product.Available &amp;&amp; !product.PriceOnRequest\" class=\"btn-group cart\" _v-7d91334e=\"\"> <button type=button class=\"btn btn-success\" @click=addToShoppingCart() _v-7d91334e=\"\"> <span class=\"glyphicon glyphicon-shopping-cart\" aria-hidden=true _v-7d91334e=\"\"></span> Toevoegen aan winkelwagen </button> </div> <p _v-7d91334e=\"\"> <i class=\"fa fa-envelope\" _v-7d91334e=\"\"></i> <a :href=\"'mailto:?subject='+ product.Name + ' van Catootjes Kraam&amp;body=Hallo, \\nKijk wat ik gevonden heb op https://www.catootjeskraam.nl' + this.$route.path\" _v-7d91334e=\"\"> Mail dit door naar een vriend \\ vriendin</a> </p> <div id=fb-root _v-7d91334e=\"\"></div> <div class=fb-share-button :data-href=\"'https://www.catootjeskraam.nl' + this.$route.path\" data-layout=button _v-7d91334e=\"\"> </div> </div> <hr _v-7d91334e=\"\"> </div> </div> <hr class=recommhr _v-7d91334e=\"\"> <h4 _v-7d91334e=\"\"> Kijk ook eens naar..... </h4> <div class=row v-if=!rloaded _v-7d91334e=\"\"> <div v-for=\"i in 3\" class=\"col-sm-4 col-xs-12\" _v-7d91334e=\"\"> <div class=thumbnail style=height:100px _v-7d91334e=\"\"> <div class=\"col-xs-2 col-xs-offset-5\" _v-7d91334e=\"\"> <img v-else=\"\" class=img-responsive src=" + __webpack_require__(73) + " style=max-height:200px _v-7d91334e=\"\"> </div> </div> </div> </div> <div class=row v-if=rloaded _v-7d91334e=\"\"> <div v-for=\"randomproduct in randomproducts\" class=\"col-md-4 col-sm-6 col-xs-12\" _v-7d91334e=\"\"> <product-card :product=randomproduct _v-7d91334e=\"\"></product-card> </div> </div> </div> <modal :show.sync=showModal :width=\"'50%'\" :indicators=true :indicatorleft=changeImageToPrev :indicatorright=changeImageToNext _v-7d91334e=\"\"> <div slot=modal-header _v-7d91334e=\"\"> <button type=button class=\"btn btn-danger pull-right\" @click=\"showModal=false\" _v-7d91334e=\"\"> × </button> </div> <div slot=modal-body class=modal-body style=\"position: static\" _v-7d91334e=\"\"> <img width=100% v-lazy=selectedImageURL :alt=selectedImageURL _v-7d91334e=\"\"> </div> <div slot=modal-footer _v-7d91334e=\"\"></div> </modal> <modal :show.sync=showRequestModal large=\"\" _v-7d91334e=\"\"> <div slot=modal-header _v-7d91334e=\"\"> <button type=button class=\"btn btn-danger pull-right\" @click=\"showRequestModal=false\" _v-7d91334e=\"\"> × </button> <div class=col-md-12 _v-7d91334e=\"\"><h2 _v-7d91334e=\"\">Prijs Aanvraag '{{product.Name}}'</h2></div> </div> <div slot=modal-body class=modal-body style=\"position: static\" _v-7d91334e=\"\"> <div class=row _v-7d91334e=\"\"> <form class=form-horizontal name=contact-form v-on:submit.prevent=SubmitForm _v-7d91334e=\"\"> <div class=form-group _v-7d91334e=\"\"> <label for=name class=\"col-sm-1 control-label\" _v-7d91334e=\"\">Naam</label> <div class=col-sm-8 _v-7d91334e=\"\"> <input type=text v-model=customer.Name class=form-control id=name name=name placeholder=\"Voor- en Achternaam\" required=\"\" _v-7d91334e=\"\"> </div> </div> <div class=form-group _v-7d91334e=\"\"> <label for=email class=\"col-sm-1 control-label\" _v-7d91334e=\"\">Email</label> <div class=col-sm-8 _v-7d91334e=\"\"> <input type=email v-model=customer.Email class=form-control id=email name=email placeholder=voorbeeld@email.nl required=\"\" _v-7d91334e=\"\"> </div> </div> <div class=form-group _v-7d91334e=\"\"> <label for=message class=\"col-sm-1 control-label\" _v-7d91334e=\"\">Bericht</label> <div class=col-sm-8 _v-7d91334e=\"\"> <textarea class=form-control v-model=customer.Content rows=8 name=message required=\"\" _v-7d91334e=\"\">Hallo Catootjeskraam,\n\nIk heb interesse in het product: '{{product.Name}}'.\nGraag zou ik de prijs ervan willen weten.\n\nMet vriendelijke groet,\n{{customer.Name}}\n{{customer.Email}}</textarea> </div> </div> <div class=form-group _v-7d91334e=\"\"> <div class=\"col-sm-4 col-sm-offset-8\" _v-7d91334e=\"\"> <input id=submit name=submit type=submit value=Verzend class=\"btn btn-primary\" _v-7d91334e=\"\"> </div> </div> <vc-alert v-if=success type=success :dismissible=false _v-7d91334e=\"\"> Contactformulier succesvol verzonden! </vc-alert> <vc-alert v-if=error type=danger :dismissible=false _v-7d91334e=\"\"> {{errorMessage}} </vc-alert> </form> </div> </div> <div slot=modal-footer _v-7d91334e=\"\"></div> </modal> <modal :show.sync=showCartModal large=\"\" :centered=true _v-7d91334e=\"\"> <div slot=modal-header _v-7d91334e=\"\"> <button type=button class=\"btn btn-danger pull-right\" @click=\"showCartModal=false\" _v-7d91334e=\"\"> × </button> </div> <div slot=modal-body class=modal-body style=\"position: static\" _v-7d91334e=\"\"> <br _v-7d91334e=\"\"> <p _v-7d91334e=\"\"><strong _v-7d91334e=\"\">{{product.Name}}</strong> is succesvol in je winkelwagen geplaatst. </p> <p _v-7d91334e=\"\">Ga naar je winkelwagen om je bestelling af te ronden of klik op verder winkelen</p> </div> <div slot=modal-footer _v-7d91334e=\"\"> <div class=modal-footer _v-7d91334e=\"\"> <button type=button class=\"btn btn-default\" @click=close _v-7d91334e=\"\">Verder winkelen</button> <button type=button class=\"btn btn-primary\" onclick=\"location.href='./bestelling'\" _v-7d91334e=\"\">Naar winkelwagen</button> </div> </div> </modal> </div> ";

/***/ }),
/* 673 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-xs-12 _v-a30f0f62=\"\"> <div v-if=!loaded class=\"card float-e-margins\" _v-a30f0f62=\"\"> <div class=\"card-content no-padding text-center\" _v-a30f0f62=\"\"> <i class=\"fa fa-refresh fa-spin fa-5x fa-lg\" _v-a30f0f62=\"\"></i> <span class=sr-only _v-a30f0f62=\"\">Laden...</span> Laden... </div> </div> <div v-else=\"\" class=\"card float-e-margins\" _v-a30f0f62=\"\"> <div class=\"card-title header\" _v-a30f0f62=\"\"> <h1 v-if=update _v-a30f0f62=\"\">Advertentie aanpassen</h1> <h1 v-else=\"\" _v-a30f0f62=\"\">Advertentie plaatsen</h1> </div> <div class=\"card-content no-padding\" _v-a30f0f62=\"\"> <div class=row _v-a30f0f62=\"\"> <div class=col-xs-12 _v-a30f0f62=\"\"> <div class=\"card float-e-margins\" _v-a30f0f62=\"\"> <div class=\"card-title card-header\" _v-a30f0f62=\"\"> <div class=col-lg-6 _v-a30f0f62=\"\"> <h5 _v-a30f0f62=\"\"> 1. Kies rubriek </h5> </div> </div> <div class=row _v-a30f0f62=\"\"> <div class=\"card-content no-padding\" _v-a30f0f62=\"\"> <v-select :value.sync=product.MenuItemId :options=selectOptions :search=true _v-a30f0f62=\"\"> </v-select> </div> </div> </div> <div class=\"card float-e-margins\" _v-a30f0f62=\"\"> <div class=\"card-title card-header\" _v-a30f0f62=\"\"> <div class=col-lg-6 _v-a30f0f62=\"\"> <h5 _v-a30f0f62=\"\"> 2. Titel en kenmerken </h5> </div> </div> <div class=row _v-a30f0f62=\"\"> <div class=\"card-content no-padding\" _v-a30f0f62=\"\"> <div class=form-group _v-a30f0f62=\"\"> <label for=title _v-a30f0f62=\"\">Titel:</label> <input type=text class=form-control id=title v-model=product.Name _v-a30f0f62=\"\"> </div> </div> </div> </div> <div class=\"card float-e-margins\" _v-a30f0f62=\"\"> <div class=\"card-title card-header\" _v-a30f0f62=\"\"> <div class=col-lg-6 _v-a30f0f62=\"\"> <h5 _v-a30f0f62=\"\"> 3. Beschrijving </h5> </div> </div> <div class=row _v-a30f0f62=\"\"> <div class=\"card-content no-padding\" _v-a30f0f62=\"\"> <div class=\"form-group col-md-8\" _v-a30f0f62=\"\"> <label for=description _v-a30f0f62=\"\">Beschrijving:</label> <textarea class=form-control rows=10 v-model=product.Description id=description _v-a30f0f62=\"\"></textarea> </div> </div> </div> </div> <div class=\"card float-e-margins\" _v-a30f0f62=\"\"> <div class=\"card-title card-header\" _v-a30f0f62=\"\"> <div class=col-lg-6 _v-a30f0f62=\"\"> <h5 _v-a30f0f62=\"\"> 4. Upload Foto's </h5> </div> </div> <div class=row _v-a30f0f62=\"\"> <div class=\"card-content no-padding\" _v-a30f0f62=\"\"> <div class=form-group _v-a30f0f62=\"\"> <v-upload :files.sync=product.Photos _v-a30f0f62=\"\"></v-upload> </div> </div> </div> </div> <div class=\"card float-e-margins\" _v-a30f0f62=\"\"> <div class=\"card-title card-header\" _v-a30f0f62=\"\"> <div class=col-lg-6 _v-a30f0f62=\"\"> <h5 _v-a30f0f62=\"\"> 5. Prijs </h5> </div> </div> <div class=row _v-a30f0f62=\"\"> <div class=\"card-content no-padding\" _v-a30f0f62=\"\"> <div class=form-group _v-a30f0f62=\"\"> <label for=price _v-a30f0f62=\"\">Prijs</label> <input type=text class=form-control id=price :disabled=\"product.PriceOnRequest == 1\" :readonly=\"product.PriceOnRequest == 1\" v-model=\"product.Price | currencyDisplay\" _v-a30f0f62=\"\"> </div> <div class=checkbox _v-a30f0f62=\"\"> <label _v-a30f0f62=\"\"> <input type=checkbox v-model=product.PriceOnRequest _v-a30f0f62=\"\"><strong _v-a30f0f62=\"\">Prijs Op aanvraag</strong> </label> </div> </div> </div> </div> <button v-if=!update type=button class=\"btn btn-primary\" @click=handleProduct() _v-a30f0f62=\"\">Advertentie Plaatsen</button> <button v-else=\"\" type=button class=\"btn btn-primary\" @click=updateProduct() _v-a30f0f62=\"\">Advertentie Bijwerken</button> <button v-if=\"success &amp;&amp; !update\" type=button class=\"btn btn-primary\" @click=refresh() _v-a30f0f62=\"\"> Nog een advertentie plaatsen </button> <vc-alert v-if=success type=success :timeout=4000 _v-a30f0f62=\"\"> {{successMessage}} </vc-alert> <vc-alert v-if=error type=danger :dismissible=false _v-a30f0f62=\"\"> Er is een fout opgetreden! </vc-alert> </div> </div> </div> </div> </div> ";

/***/ }),
/* 674 */
/***/ (function(module, exports) {

	module.exports = " <div _v-c830bc3e=\"\"> <div class=dress-card _v-c830bc3e=\"\"> <div class=dress-card-head _v-c830bc3e=\"\"> <a v-link=\"($route.params.id != 20 &amp;&amp; product.Available)? { name: 'Product', params: { id: product.ProductId, pname: $options.filters.slugurl(product.Name) }} : '' \" _v-c830bc3e=\"\"> <img class=dress-card-img-top v-lazy=product.Photos[0].URL alt=\"\" _v-c830bc3e=\"\"> </a> <div class=dress-card-body _v-c830bc3e=\"\"> <a v-link=\"($route.params.id != 20 &amp;&amp; product.Available)? { name: 'Product', params: { id: product.ProductId, pname: $options.filters.slugurl(product.Name) }} : '' \" _v-c830bc3e=\"\"> <h4 class=dress-card-title _v-c830bc3e=\"\">{{product.Name}}</h4> </a> <div class=action-wrap _v-c830bc3e=\"\"> <span v-if=product.Available class=text-success _v-c830bc3e=\"\">Beschikbaar</span> <span v-else=\"\" class=text-danger _v-c830bc3e=\"\">Verkocht</span> <div class=\"price-wrap h3\" _v-c830bc3e=\"\"> <span class=price-new v-if=\"product.Available &amp;&amp; !product.PriceOnRequest\" _v-c830bc3e=\"\">{{product.Price | currencyDisplay}}</span> <span class=price-new v-if=\"product.Available &amp;&amp; product.PriceOnRequest\" _v-c830bc3e=\"\">Prijs Op Aanvraag</span> <span class=price-new v-else=\"\" _v-c830bc3e=\"\">&nbsp;</span> </div> </div> <div class=row _v-c830bc3e=\"\"> <div class=\"col-md-9 card-button\" :class=\"!product.Available ? 'isDisabled' : ''\" _v-c830bc3e=\"\"><a v-link=\"$route.params.id != 20 ? { name: 'Product', params: { id: product.ProductId, pname: $options.filters.slugurl(product.Name) }} : '' \" _v-c830bc3e=\"\"><div class=\"card-button-inner bag-button\" _v-c830bc3e=\"\">Bekijk en bestel</div></a></div> <div class=\"col-md-3 card-button\" :class=\"!product.Available ? 'isDisabled' : ''\" _v-c830bc3e=\"\"><a v-on:click.prevent=addToShoppingCart() href=# _v-c830bc3e=\"\"><div class=\"card-button-inner wish-button\" _v-c830bc3e=\"\">+<span class=\"glyphicon glyphicon-shopping-cart\" aria-hidden=true _v-c830bc3e=\"\"></span></div></a></div> </div> </div> </div> </div> </div>";

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Vue-Lazyload.js v1.3.5
	 * (c) 2023 Awe <hilongjw@gmail.com>
	 * Released under the MIT License.
	 */
	!function(t,e){ true?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t="undefined"!=typeof globalThis?globalThis:t||self).VueLazyload={})}(this,(function(t){"use strict";function e(t,e){return t(e={exports:{}},e.exports),e.exports}var n=e((function(t){var e=Object.prototype.toString,n=Object.prototype.propertyIsEnumerable,i=Object.getOwnPropertySymbols;t.exports=function(t){for(var r=arguments.length,o=Array(r>1?r-1:0),s=1;s<r;s++)o[s-1]=arguments[s];if("function"!=typeof(a=t)&&"[object Object]"!==e.call(a)&&!Array.isArray(a))throw new TypeError("expected the first argument to be an object");var a;if(0===o.length||"function"!=typeof Symbol||"function"!=typeof i)return t;var u=!0,l=!1,d=void 0;try{for(var c,h=o[Symbol.iterator]();!(u=(c=h.next()).done);u=!0){var f=c.value,v=i(f),p=!0,y=!1,g=void 0;try{for(var b,m=v[Symbol.iterator]();!(p=(b=m.next()).done);p=!0){var w=b.value;n.call(f,w)&&(t[w]=f[w])}}catch(t){y=!0,g=t}finally{try{!p&&m.return&&m.return()}finally{if(y)throw g}}}}catch(t){l=!0,d=t}finally{try{!u&&h.return&&h.return()}finally{if(l)throw d}}return t}})),i=Object.freeze({__proto__:null,default:n,__moduleExports:n}),r=i&&n||i,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},s=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")},a=function(){function t(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}}(),u=e((function(t){var e=Object.prototype.toString,n=function(t){return"__proto__"!==t&&"constructor"!==t&&"prototype"!==t},i=t.exports=function(t){for(var e=arguments.length,a=Array(e>1?e-1:0),u=1;u<e;u++)a[u-1]=arguments[u];var l,d=0;for(("object"===(void 0===(l=t)?"undefined":o(l))?null===l:"function"!=typeof l)&&(t=a[d++]),t||(t={});d<a.length;d++)if(s(a[d])){var c=!0,h=!1,f=void 0;try{for(var v,p=Object.keys(a[d])[Symbol.iterator]();!(c=(v=p.next()).done);c=!0){var y=v.value;n(y)&&(s(t[y])&&s(a[d][y])?i(t[y],a[d][y]):t[y]=a[d][y])}}catch(t){h=!0,f=t}finally{try{!c&&p.return&&p.return()}finally{if(h)throw f}}r(t,a[d])}return t};function s(t){return"function"==typeof t||"[object Object]"===e.call(t)}})),l="undefined"!=typeof window&&null!==window,d=function(){if(l&&"IntersectionObserver"in window&&"IntersectionObserverEntry"in window&&"intersectionRatio"in window.IntersectionObserverEntry.prototype)return"isIntersecting"in window.IntersectionObserverEntry.prototype||Object.defineProperty(window.IntersectionObserverEntry.prototype,"isIntersecting",{get:function(){return this.intersectionRatio>0}}),!0;return!1}();var c="event",h="observer",f=function(){if(l)return"function"==typeof window.CustomEvent?window.CustomEvent:(t.prototype=window.Event.prototype,t);function t(t,e){e=e||{bubbles:!1,cancelable:!1,detail:void 0};var n=document.createEvent("CustomEvent");return n.initCustomEvent(t,e.bubbles,e.cancelable,e.detail),n}}();function v(t,e){if(t.length){var n=t.indexOf(e);return n>-1?t.splice(n,1):void 0}}function p(t,e){if("IMG"===t.tagName&&t.getAttribute("data-srcset")){var n=t.getAttribute("data-srcset"),i=[],r=t.parentNode.offsetWidth*e,o=void 0,s=void 0,a=void 0;(n=n.trim().split(",")).map((function(t){t=t.trim(),-1===(o=t.lastIndexOf(" "))?(s=t,a=999998):(s=t.substr(0,o),a=parseInt(t.substr(o+1,t.length-o-2),10)),i.push([a,s])})),i.sort((function(t,e){if(t[0]<e[0])return 1;if(t[0]>e[0])return-1;if(t[0]===e[0]){if(-1!==e[1].indexOf(".webp",e[1].length-5))return 1;if(-1!==t[1].indexOf(".webp",t[1].length-5))return-1}return 0}));for(var u="",l=void 0,d=0;d<i.length;d++){u=(l=i[d])[1];var c=i[d+1];if(c&&c[0]<r){u=l[1];break}if(!c){u=l[1];break}}return u}}function y(t,e){for(var n=void 0,i=0,r=t.length;i<r;i++)if(e(t[i])){n=t[i];break}return n}var g=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;return l&&window.devicePixelRatio||t};function b(){if(!l)return!1;var t=!0;try{var e=document.createElement("canvas");e.getContext&&e.getContext("2d")&&(t=0===e.toDataURL("image/webp").indexOf("data:image/webp"))}catch(e){t=!1}return t}var m=function(){if(l){var t=!1;try{var e=Object.defineProperty({},"passive",{get:function(){t=!0}});window.addEventListener("test",null,e)}catch(t){}return t}}(),w={on:function(t,e,n){var i=arguments.length>3&&void 0!==arguments[3]&&arguments[3];m?t.addEventListener(e,n,{capture:i,passive:!0}):t.addEventListener(e,n,i)},off:function(t,e,n){var i=arguments.length>3&&void 0!==arguments[3]&&arguments[3];t.removeEventListener(e,n,i)}},L=function(t,e,n){var i=new Image;if(!t||!t.src){var r=new Error("image src is required");return n(r)}i.src=t.src,t.cors&&(i.crossOrigin=t.cors),i.onload=function(){e({naturalHeight:i.naturalHeight,naturalWidth:i.naturalWidth,src:i.src})},i.onerror=function(t){n(t)}},_=function(t,e){return"undefined"!=typeof getComputedStyle?getComputedStyle(t,null).getPropertyValue(e):t.style[e]},z=function(t){return _(t,"overflow")+_(t,"overflow-y")+_(t,"overflow-x")};function E(){}var k=function(){function t(e){var n=e.max;s(this,t),this.options={max:n||100},this._caches=[]}return a(t,[{key:"has",value:function(t){return this._caches.indexOf(t)>-1}},{key:"add",value:function(t){this.has(t)||(this._caches.push(t),this._caches.length>this.options.max&&this.free())}},{key:"free",value:function(){this._caches.shift()}}]),t}(),x=function(){function t(e){var n=e.el,i=e.src,r=e.error,o=e.loading,a=e.bindType,u=e.$parent,l=e.options,d=e.cors,c=e.elRenderer,h=e.imageCache;s(this,t),this.el=n,this.src=i,this.error=r,this.loading=o,this.bindType=a,this.attempt=0,this.cors=d,this.naturalHeight=0,this.naturalWidth=0,this.options=l,this.rect=null,this.$parent=u,this.elRenderer=c,this._imageCache=h,this.performanceData={init:Date.now(),loadStart:0,loadEnd:0},this.filter(),this.initState(),this.render("loading",!1)}return a(t,[{key:"initState",value:function(){"dataset"in this.el?this.el.dataset.src=this.src:this.el.setAttribute("data-src",this.src),this.state={loading:!1,error:!1,loaded:!1,rendered:!1}}},{key:"record",value:function(t){this.performanceData[t]=Date.now()}},{key:"update",value:function(t){var e=t.src,n=t.loading,i=t.error,r=this.src;this.src=e,this.loading=n,this.error=i,this.filter(),r!==this.src&&(this.attempt=0,this.initState())}},{key:"getRect",value:function(){this.rect=this.el.getBoundingClientRect()}},{key:"checkInView",value:function(){return this.getRect(),this.rect.top<window.innerHeight*this.options.preLoad&&this.rect.bottom>this.options.preLoadTop&&this.rect.left<window.innerWidth*this.options.preLoad&&this.rect.right>0}},{key:"filter",value:function(){var t=this;(function(t){if(!(t instanceof Object))return[];if(Object.keys)return Object.keys(t);var e=[];for(var n in t)t.hasOwnProperty(n)&&e.push(n);return e})(this.options.filter).map((function(e){t.options.filter[e](t,t.options)}))}},{key:"renderLoading",value:function(t){var e=this;this.state.loading=!0,L({src:this.loading,cors:this.cors},(function(n){e.render("loading",!1),e.state.loading=!1,t()}),(function(){t(),e.state.loading=!1,e.options.silent||console.warn("VueLazyload log: load failed with loading image("+e.loading+")")}))}},{key:"load",value:function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:E;return this.attempt>this.options.attempt-1&&this.state.error?(this.options.silent||console.log("VueLazyload log: "+this.src+" tried too more than "+this.options.attempt+" times"),void e()):this.state.rendered&&this.state.loaded?void 0:this._imageCache.has(this.src)?(this.state.loaded=!0,this.render("loaded",!0),this.state.rendered=!0,e()):void this.renderLoading((function(){t.attempt++,t.options.adapter.beforeLoad&&t.options.adapter.beforeLoad(t,t.options),t.record("loadStart"),L({src:t.src,cors:t.cors},(function(n){t.naturalHeight=n.naturalHeight,t.naturalWidth=n.naturalWidth,t.state.loaded=!0,t.state.error=!1,t.record("loadEnd"),t.render("loaded",!1),t.state.rendered=!0,t._imageCache.add(t.src),e()}),(function(e){!t.options.silent&&console.error(e),t.state.error=!0,t.state.loaded=!1,t.render("error",!1)}))}))}},{key:"render",value:function(t,e){this.elRenderer(this,t,e)}},{key:"performance",value:function(){var t="loading",e=0;return this.state.loaded&&(t="loaded",e=(this.performanceData.loadEnd-this.performanceData.loadStart)/1e3),this.state.error&&(t="error"),{src:this.src,state:t,time:e}}},{key:"$destroy",value:function(){this.el=null,this.src=null,this.error=null,this.loading=null,this.bindType=null,this.attempt=0}}]),t}(),A="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",T=["scroll","wheel","mousewheel","resize","animationend","transitionend","touchmove"],O={rootMargin:"0px",threshold:0};function $(t){return function(){function e(t){var n=t.preLoad,i=t.error,r=t.throttleWait,o=t.preLoadTop,a=t.dispatchEvent,u=t.loading,l=t.attempt,d=t.silent,f=void 0===d||d,v=t.scale,p=t.listenEvents;t.hasbind;var y,m,w,L,_,z,E=t.filter,x=t.adapter,$=t.observer,I=t.observerOptions;s(this,e),this.version='"1.3.5"',this.mode=c,this.ListenerQueue=[],this.TargetIndex=0,this.TargetQueue=[],this.options={silent:f,dispatchEvent:!!a,throttleWait:r||200,preLoad:n||1.3,preLoadTop:o||0,error:i||A,loading:u||A,attempt:l||3,scale:v||g(v),ListenEvents:p||T,hasbind:!1,supportWebp:b(),filter:E||{},adapter:x||{},observer:!!$,observerOptions:I||O},this._initEvent(),this._imageCache=new k({max:200}),this.lazyLoadHandler=(y=this._lazyLoadHandler.bind(this),m=this.options.throttleWait,w=null,L=null,_=0,z=!1,function(){if(z=!0,!w){var t=Date.now()-_,e=this,n=arguments,i=function(){_=Date.now(),w=!1,y.apply(e,n)};t>=m?i():w=setTimeout(i,m),z&&(clearTimeout(L),L=setTimeout(i,2*m))}}),this.setMode(this.options.observer?h:c)}return a(e,[{key:"config",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};u(this.options,t)}},{key:"performance",value:function(){var t=[];return this.ListenerQueue.map((function(e){t.push(e.performance())})),t}},{key:"addLazyBox",value:function(t){this.ListenerQueue.push(t),l&&(this._addListenerTarget(window),this._observer&&this._observer.observe(t.el),t.$el&&t.$el.parentNode&&this._addListenerTarget(t.$el.parentNode))}},{key:"add",value:function(e,n,i){var r=this;if(function(t,e){for(var n=!1,i=0,r=t.length;i<r;i++)if(e(t[i])){n=!0;break}return n}(this.ListenerQueue,(function(t){return t.el===e})))return this.update(e,n),t.nextTick(this.lazyLoadHandler);var o=this._valueFormatter(n.value),s=o.src,a=o.loading,u=o.error,d=o.cors;t.nextTick((function(){s=p(e,r.options.scale)||s,r._observer&&r._observer.observe(e);var o=Object.keys(n.modifiers)[0],c=void 0;o&&(c=(c=i.context.$refs[o])?c.$el||c:document.getElementById(o)),c||(c=function(t){if(l){if(!(t instanceof HTMLElement))return window;for(var e=t;e&&e!==document.body&&e!==document.documentElement&&e.parentNode;){if(/(scroll|auto)/.test(z(e)))return e;e=e.parentNode}return window}}(e));var h=new x({bindType:n.arg,$parent:c,el:e,loading:a,error:u,src:s,cors:d,elRenderer:r._elRenderer.bind(r),options:r.options,imageCache:r._imageCache});r.ListenerQueue.push(h),l&&(r._addListenerTarget(window),r._addListenerTarget(c)),r.lazyLoadHandler(),t.nextTick((function(){return r.lazyLoadHandler()}))}))}},{key:"update",value:function(e,n,i){var r=this,o=this._valueFormatter(n.value),s=o.src,a=o.loading,u=o.error;s=p(e,this.options.scale)||s;var l=y(this.ListenerQueue,(function(t){return t.el===e}));l?l.update({src:s,loading:a,error:u}):this.add(e,n,i),this._observer&&(this._observer.unobserve(e),this._observer.observe(e)),this.lazyLoadHandler(),t.nextTick((function(){return r.lazyLoadHandler()}))}},{key:"remove",value:function(t){if(t){this._observer&&this._observer.unobserve(t);var e=y(this.ListenerQueue,(function(e){return e.el===t}));e&&(this._removeListenerTarget(e.$parent),this._removeListenerTarget(window),v(this.ListenerQueue,e),e.$destroy())}}},{key:"removeComponent",value:function(t){t&&(v(this.ListenerQueue,t),this._observer&&this._observer.unobserve(t.el),t.$parent&&t.$el.parentNode&&this._removeListenerTarget(t.$el.parentNode),this._removeListenerTarget(window))}},{key:"setMode",value:function(t){var e=this;d||t!==h||(t=c),this.mode=t,t===c?(this._observer&&(this.ListenerQueue.forEach((function(t){e._observer.unobserve(t.el)})),this._observer=null),this.TargetQueue.forEach((function(t){e._initListen(t.el,!0)}))):(this.TargetQueue.forEach((function(t){e._initListen(t.el,!1)})),this._initIntersectionObserver())}},{key:"_addListenerTarget",value:function(t){if(t){var e=y(this.TargetQueue,(function(e){return e.el===t}));return e?e.childrenCount++:(e={el:t,id:++this.TargetIndex,childrenCount:1,listened:!0},this.mode===c&&this._initListen(e.el,!0),this.TargetQueue.push(e)),this.TargetIndex}}},{key:"_removeListenerTarget",value:function(t){var e=this;this.TargetQueue.forEach((function(n,i){n.el===t&&(n.childrenCount--,n.childrenCount||(e._initListen(n.el,!1),e.TargetQueue.splice(i,1),n=null))}))}},{key:"_initListen",value:function(t,e){var n=this;this.options.ListenEvents.forEach((function(i){return w[e?"on":"off"](t,i,n.lazyLoadHandler)}))}},{key:"_initEvent",value:function(){var t=this;this.Event={listeners:{loading:[],loaded:[],error:[]}},this.$on=function(e,n){t.Event.listeners[e]||(t.Event.listeners[e]=[]),t.Event.listeners[e].push(n)},this.$once=function(e,n){var i=t;t.$on(e,(function t(){i.$off(e,t),n.apply(i,arguments)}))},this.$off=function(e,n){if(n)v(t.Event.listeners[e],n);else{if(!t.Event.listeners[e])return;t.Event.listeners[e].length=0}},this.$emit=function(e,n,i){t.Event.listeners[e]&&t.Event.listeners[e].forEach((function(t){return t(n,i)}))}}},{key:"_lazyLoadHandler",value:function(){var t=this,e=[];this.ListenerQueue.forEach((function(t,n){t.el&&t.el.parentNode||e.push(t),t.checkInView()&&t.load()})),e.forEach((function(e){v(t.ListenerQueue,e),e.$destroy()}))}},{key:"_initIntersectionObserver",value:function(){var t=this;d&&(this._observer=new IntersectionObserver(this._observerHandler.bind(this),this.options.observerOptions),this.ListenerQueue.length&&this.ListenerQueue.forEach((function(e){t._observer.observe(e.el)})))}},{key:"_observerHandler",value:function(t,e){var n=this;t.forEach((function(t){t.isIntersecting&&n.ListenerQueue.forEach((function(e){if(e.el===t.target){if(e.state.loaded)return n._observer.unobserve(e.el);e.load()}}))}))}},{key:"_elRenderer",value:function(t,e,n){if(t.el){var i=t.el,r=t.bindType,o=void 0;switch(e){case"loading":o=t.loading;break;case"error":o=t.error;break;default:o=t.src}if(r?i.style[r]='url("'+o+'")':i.getAttribute("src")!==o&&i.setAttribute("src",o),i.setAttribute("lazy",e),this.$emit(e,t,n),this.options.adapter[e]&&this.options.adapter[e](t,this.options),this.options.dispatchEvent){var s=new f(e,{detail:t});i.dispatchEvent(s)}}}},{key:"_valueFormatter",value:function(t){var e,n=t,i=this.options.loading,r=this.options.error;return null!==(e=t)&&"object"===(void 0===e?"undefined":o(e))&&(t.src||this.options.silent||console.error("Vue Lazyload warning: miss src with "+t),n=t.src,i=t.loading||this.options.loading,r=t.error||this.options.error),{src:n,loading:i,error:r}}}]),e}()}$.install=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=new($(t))(e);"2"===t.version.split(".")[0]?t.directive("lazy",{bind:n.add.bind(n),update:n.update.bind(n),componentUpdated:n.lazyLoadHandler.bind(n),unbind:n.remove.bind(n)}):t.directive("lazy",{bind:n.lazyLoadHandler.bind(n),update:function(t,e){u(this.vm.$refs,this.vm.$els),n.add(this.el,{modifiers:this.modifiers||{},arg:this.arg,value:t,oldValue:e},{context:this.vm})},unbind:function(){n.remove(this.el)}})};var I=function(t){return{props:{tag:{type:String,default:"div"}},render:function(t){return t(this.tag,null,this.show?this.$slots.default:null)},data:function(){return{el:null,state:{loaded:!1},rect:{},show:!1}},mounted:function(){this.el=this.$el,t.addLazyBox(this),t.lazyLoadHandler()},beforeDestroy:function(){t.removeComponent(this)},methods:{getRect:function(){this.rect=this.$el.getBoundingClientRect()},checkInView:function(){return this.getRect(),l&&this.rect.top<window.innerHeight*t.options.preLoad&&this.rect.bottom>0&&this.rect.left<window.innerWidth*t.options.preLoad&&this.rect.right>0},load:function(){this.show=!0,this.state.loaded=!0,this.$emit("show",this)},destroy:function(){return this.$destroy}}}};I.install=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=new($(t))(e);t.component("lazy-component",I(n))};var C=function(){function t(e){var n=e.lazy;s(this,t),this.lazy=n,n.lazyContainerMananger=this,this._queue=[]}return a(t,[{key:"bind",value:function(t,e,n){var i=new H({el:t,binding:e,vnode:n,lazy:this.lazy});this._queue.push(i)}},{key:"update",value:function(t,e,n){var i=y(this._queue,(function(e){return e.el===t}));i&&i.update({el:t,binding:e,vnode:n})}},{key:"unbind",value:function(t,e,n){var i=y(this._queue,(function(e){return e.el===t}));i&&(i.clear(),v(this._queue,i))}}]),t}(),S={selector:"img"},H=function(){function t(e){var n=e.el,i=e.binding,r=e.vnode,o=e.lazy;s(this,t),this.el=null,this.vnode=r,this.binding=i,this.options={},this.lazy=o,this._queue=[],this.update({el:n,binding:i})}return a(t,[{key:"update",value:function(t){var e=this,n=t.el,i=t.binding;this.el=n,this.options=u({},S,i.value),this.getImgs().forEach((function(t){e.lazy.add(t,u({},e.binding,{value:{src:"dataset"in t?t.dataset.src:t.getAttribute("data-src"),error:("dataset"in t?t.dataset.error:t.getAttribute("data-error"))||e.options.error,loading:("dataset"in t?t.dataset.loading:t.getAttribute("data-loading"))||e.options.loading}}),e.vnode)}))}},{key:"getImgs",value:function(){return function(t){for(var e=t.length,n=[],i=0;i<e;i++)n.push(t[i]);return n}(this.el.querySelectorAll(this.options.selector))}},{key:"clear",value:function(){var t=this;this.getImgs().forEach((function(e){return t.lazy.remove(e)})),this.vnode=null,this.binding=null,this.lazy=null}}]),t}();H.install=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=new($(t))(e),i=new H({lazy:n});"2"===t.version.split(".")[0]?t.directive("lazy-container",{bind:i.bind.bind(i),componentUpdated:i.update.bind(i),unbind:i.unbind.bind(i)}):t.directive("lazy-container",{update:function(t,e){i.update(this.el,{modifiers:this.modifiers||{},arg:this.arg,value:t,oldValue:e},{context:this.vm})},unbind:function(){i.unbind(this.el)}})};var j=function(t){return{props:{src:[String,Object],tag:{type:String,default:"img"}},render:function(t){return t(this.tag,{attrs:{src:this.renderSrc}},this.$slots.default)},data:function(){return{el:null,options:{src:"",error:"",loading:"",attempt:t.options.attempt},state:{loaded:!1,error:!1,attempt:0},rect:{},renderSrc:""}},watch:{src:function(){this.init(),t.addLazyBox(this),t.lazyLoadHandler()}},created:function(){this.init(),this.renderSrc=this.options.loading},mounted:function(){this.el=this.$el,t.addLazyBox(this),t.lazyLoadHandler()},beforeDestroy:function(){t.removeComponent(this)},methods:{init:function(){var e=t._valueFormatter(this.src),n=e.src,i=e.loading,r=e.error;this.state.loaded=!1,this.options.src=n,this.options.error=r,this.options.loading=i,this.renderSrc=this.options.loading},getRect:function(){this.rect=this.$el.getBoundingClientRect()},checkInView:function(){return this.getRect(),l&&this.rect.top<window.innerHeight*t.options.preLoad&&this.rect.bottom>0&&this.rect.left<window.innerWidth*t.options.preLoad&&this.rect.right>0},load:function(){var e=this,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:E;if(this.state.attempt>this.options.attempt-1&&this.state.error)return t.options.silent||console.log("VueLazyload log: "+this.options.src+" tried too more than "+this.options.attempt+" times"),void n();var i=this.options.src;L({src:i},(function(t){var n=t.src;e.renderSrc=n,e.state.loaded=!0}),(function(t){e.state.attempt++,e.renderSrc=e.options.error,e.state.error=!0}))}}}};j.install=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=new($(t))(e);t.component("lazy-image",j(n))};var Q={install:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=new($(t))(e),i=new C({lazy:n}),r="2"===t.version.split(".")[0];t.prototype.$Lazyload=n,e.lazyComponent&&t.component("lazy-component",I(n)),e.lazyImage&&t.component("lazy-image",j(n)),r?(t.directive("lazy",{bind:n.add.bind(n),update:n.update.bind(n),componentUpdated:n.lazyLoadHandler.bind(n),unbind:n.remove.bind(n)}),t.directive("lazy-container",{bind:i.bind.bind(i),componentUpdated:i.update.bind(i),unbind:i.unbind.bind(i)})):(t.directive("lazy",{bind:n.lazyLoadHandler.bind(n),update:function(t,e){u(this.vm.$refs,this.vm.$els),n.add(this.el,{modifiers:this.modifiers||{},arg:this.arg,value:t,oldValue:e},{context:this.vm})},unbind:function(){n.remove(this.el)}}),t.directive("lazy-container",{update:function(t,e){i.update(this.el,{modifiers:this.modifiers||{},arg:this.arg,value:t,oldValue:e},{context:this.vm})},unbind:function(){i.unbind(this.el)}}))}};t.Lazy=$,t.LazyComponent=I,t.LazyContainer=C,t.LazyImage=j,t.default=Q,Object.defineProperty(t,"__esModule",{value:!0})}));


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(234)
	__vue_template__ = __webpack_require__(635)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_template__ = __webpack_require__(636)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(721)
	__vue_script__ = __webpack_require__(235)
	__vue_template__ = __webpack_require__(665)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(725)
	__vue_script__ = __webpack_require__(239)
	__vue_template__ = __webpack_require__(669)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(724)
	__vue_script__ = __webpack_require__(241)
	__vue_template__ = __webpack_require__(668)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(242)
	__vue_template__ = __webpack_require__(640)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(719)
	__vue_script__ = __webpack_require__(243)
	__vue_template__ = __webpack_require__(663)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(245)
	__vue_template__ = __webpack_require__(642)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(726)
	__vue_script__ = __webpack_require__(246)
	__vue_template__ = __webpack_require__(670)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(728)
	__vue_script__ = __webpack_require__(247)
	__vue_template__ = __webpack_require__(672)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(248)
	__vue_template__ = __webpack_require__(643)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(250)
	__vue_template__ = __webpack_require__(645)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_template__ = __webpack_require__(646)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(251)
	__vue_template__ = __webpack_require__(647)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(252)
	__vue_template__ = __webpack_require__(648)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_template__ = __webpack_require__(649)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_template__ = __webpack_require__(650)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(253)
	__vue_template__ = __webpack_require__(651)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(720)
	__vue_script__ = __webpack_require__(254)
	__vue_template__ = __webpack_require__(664)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(729)
	__vue_script__ = __webpack_require__(255)
	__vue_template__ = __webpack_require__(673)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(256)
	__vue_template__ = __webpack_require__(652)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(722)
	__vue_script__ = __webpack_require__(257)
	__vue_template__ = __webpack_require__(666)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(258)
	__vue_template__ = __webpack_require__(653)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(259)
	__vue_template__ = __webpack_require__(654)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(260)
	__vue_template__ = __webpack_require__(655)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(716)
	__vue_script__ = __webpack_require__(261)
	__vue_template__ = __webpack_require__(656)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(723)
	__vue_script__ = __webpack_require__(262)
	__vue_template__ = __webpack_require__(667)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(717)
	__vue_template__ = __webpack_require__(657)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(718)
	__vue_script__ = __webpack_require__(263)
	__vue_template__ = __webpack_require__(658)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(727)
	__vue_script__ = __webpack_require__(264)
	__vue_template__ = __webpack_require__(671)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(265)
	__vue_template__ = __webpack_require__(659)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(266)
	__vue_template__ = __webpack_require__(660)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(267)
	__vue_template__ = __webpack_require__(661)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(268)
	__vue_template__ = __webpack_require__(662)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 710 */
/***/ (function(module, exports) {

	/*!
	 * vue-resource v0.7.4
	 * https://github.com/vuejs/vue-resource
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	/**
	 * Utility functions.
	 */
	
	var util = {};
	var config = {};
	var array = [];
	var console = window.console;
	function Util (Vue) {
	    util = Vue.util;
	    config = Vue.config;
	}
	
	var isArray = Array.isArray;
	
	function warn(msg) {
	    if (console && util.warn && (!config.silent || config.debug)) {
	        console.warn('[VueResource warn]: ' + msg);
	    }
	}
	
	function error(msg) {
	    if (console) {
	        console.error(msg);
	    }
	}
	
	function nextTick(cb, ctx) {
	    return util.nextTick(cb, ctx);
	}
	
	function trim(str) {
	    return str.replace(/^\s*|\s*$/g, '');
	}
	
	function toLower(str) {
	    return str ? str.toLowerCase() : '';
	}
	
	function isString(val) {
	    return typeof val === 'string';
	}
	
	function isFunction(val) {
	    return typeof val === 'function';
	}
	
	function isObject(obj) {
	    return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	}
	
	function isPlainObject(obj) {
	    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
	}
	
	function options(fn, obj, opts) {
	
	    opts = opts || {};
	
	    if (isFunction(opts)) {
	        opts = opts.call(obj);
	    }
	
	    return merge(fn.bind({ $vm: obj, $options: opts }), fn, { $options: opts });
	}
	
	function each(obj, iterator) {
	
	    var i, key;
	
	    if (typeof obj.length == 'number') {
	        for (i = 0; i < obj.length; i++) {
	            iterator.call(obj[i], obj[i], i);
	        }
	    } else if (isObject(obj)) {
	        for (key in obj) {
	            if (obj.hasOwnProperty(key)) {
	                iterator.call(obj[key], obj[key], key);
	            }
	        }
	    }
	
	    return obj;
	}
	
	function extend(target) {
	
	    var args = array.slice.call(arguments, 1);
	
	    args.forEach(function (arg) {
	        _merge(target, arg);
	    });
	
	    return target;
	}
	
	function merge(target) {
	
	    var args = array.slice.call(arguments, 1);
	
	    args.forEach(function (arg) {
	        _merge(target, arg, true);
	    });
	
	    return target;
	}
	
	function _merge(target, source, deep) {
	    for (var key in source) {
	        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
	            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
	                target[key] = {};
	            }
	            if (isArray(source[key]) && !isArray(target[key])) {
	                target[key] = [];
	            }
	            _merge(target[key], source[key], deep);
	        } else if (source[key] !== undefined) {
	            target[key] = source[key];
	        }
	    }
	}
	
	function root (options, next) {
	
	    var url = next(options);
	
	    if (isString(options.root) && !url.match(/^(https?:)?\//)) {
	        url = options.root + '/' + url;
	    }
	
	    return url;
	}
	
	function query (options, next) {
	
	    var urlParams = Object.keys(Url.options.params),
	        query = {},
	        url = next(options);
	
	    each(options.params, function (value, key) {
	        if (urlParams.indexOf(key) === -1) {
	            query[key] = value;
	        }
	    });
	
	    query = Url.params(query);
	
	    if (query) {
	        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
	    }
	
	    return url;
	}
	
	function legacy (options, next) {
	
	    var variables = [],
	        url = next(options);
	
	    url = url.replace(/(\/?):([a-z]\w*)/gi, function (match, slash, name) {
	
	        warn('The `:' + name + '` parameter syntax has been deprecated. Use the `{' + name + '}` syntax instead.');
	
	        if (options.params[name]) {
	            variables.push(name);
	            return slash + encodeUriSegment(options.params[name]);
	        }
	
	        return '';
	    });
	
	    variables.forEach(function (key) {
	        delete options.params[key];
	    });
	
	    return url;
	}
	
	function encodeUriSegment(value) {
	
	    return encodeUriQuery(value, true).replace(/%26/gi, '&').replace(/%3D/gi, '=').replace(/%2B/gi, '+');
	}
	
	function encodeUriQuery(value, spaces) {
	
	    return encodeURIComponent(value).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, spaces ? '%20' : '+');
	}
	
	/**
	 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
	 */
	
	function expand(url, params, variables) {
	
	    var tmpl = parse(url),
	        expanded = tmpl.expand(params);
	
	    if (variables) {
	        variables.push.apply(variables, tmpl.vars);
	    }
	
	    return expanded;
	}
	
	function parse(template) {
	
	    var operators = ['+', '#', '.', '/', ';', '?', '&'],
	        variables = [];
	
	    return {
	        vars: variables,
	        expand: function expand(context) {
	            return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function (_, expression, literal) {
	                if (expression) {
	
	                    var operator = null,
	                        values = [];
	
	                    if (operators.indexOf(expression.charAt(0)) !== -1) {
	                        operator = expression.charAt(0);
	                        expression = expression.substr(1);
	                    }
	
	                    expression.split(/,/g).forEach(function (variable) {
	                        var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
	                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
	                        variables.push(tmp[1]);
	                    });
	
	                    if (operator && operator !== '+') {
	
	                        var separator = ',';
	
	                        if (operator === '?') {
	                            separator = '&';
	                        } else if (operator !== '#') {
	                            separator = operator;
	                        }
	
	                        return (values.length !== 0 ? operator : '') + values.join(separator);
	                    } else {
	                        return values.join(',');
	                    }
	                } else {
	                    return encodeReserved(literal);
	                }
	            });
	        }
	    };
	}
	
	function getValues(context, operator, key, modifier) {
	
	    var value = context[key],
	        result = [];
	
	    if (isDefined(value) && value !== '') {
	        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
	            value = value.toString();
	
	            if (modifier && modifier !== '*') {
	                value = value.substring(0, parseInt(modifier, 10));
	            }
	
	            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	        } else {
	            if (modifier === '*') {
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            result.push(encodeValue(operator, value[k], k));
	                        }
	                    });
	                }
	            } else {
	                var tmp = [];
	
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        tmp.push(encodeValue(operator, value));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            tmp.push(encodeURIComponent(k));
	                            tmp.push(encodeValue(operator, value[k].toString()));
	                        }
	                    });
	                }
	
	                if (isKeyOperator(operator)) {
	                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
	                } else if (tmp.length !== 0) {
	                    result.push(tmp.join(','));
	                }
	            }
	        }
	    } else {
	        if (operator === ';') {
	            result.push(encodeURIComponent(key));
	        } else if (value === '' && (operator === '&' || operator === '?')) {
	            result.push(encodeURIComponent(key) + '=');
	        } else if (value === '') {
	            result.push('');
	        }
	    }
	
	    return result;
	}
	
	function isDefined(value) {
	    return value !== undefined && value !== null;
	}
	
	function isKeyOperator(operator) {
	    return operator === ';' || operator === '&' || operator === '?';
	}
	
	function encodeValue(operator, value, key) {
	
	    value = operator === '+' || operator === '#' ? encodeReserved(value) : encodeURIComponent(value);
	
	    if (key) {
	        return encodeURIComponent(key) + '=' + value;
	    } else {
	        return value;
	    }
	}
	
	function encodeReserved(str) {
	    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
	        if (!/%[0-9A-Fa-f]/.test(part)) {
	            part = encodeURI(part);
	        }
	        return part;
	    }).join('');
	}
	
	function template (options) {
	
	    var variables = [],
	        url = expand(options.url, options.params, variables);
	
	    variables.forEach(function (key) {
	        delete options.params[key];
	    });
	
	    return url;
	}
	
	/**
	 * Service for URL templating.
	 */
	
	var ie = document.documentMode;
	var el = document.createElement('a');
	
	function Url(url, params) {
	
	    var self = this || {},
	        options = url,
	        transform;
	
	    if (isString(url)) {
	        options = { url: url, params: params };
	    }
	
	    options = merge({}, Url.options, self.$options, options);
	
	    Url.transforms.forEach(function (handler) {
	        transform = factory(handler, transform, self.$vm);
	    });
	
	    return transform(options);
	}
	
	/**
	 * Url options.
	 */
	
	Url.options = {
	    url: '',
	    root: null,
	    params: {}
	};
	
	/**
	 * Url transforms.
	 */
	
	Url.transforms = [template, legacy, query, root];
	
	/**
	 * Encodes a Url parameter string.
	 *
	 * @param {Object} obj
	 */
	
	Url.params = function (obj) {
	
	    var params = [],
	        escape = encodeURIComponent;
	
	    params.add = function (key, value) {
	
	        if (isFunction(value)) {
	            value = value();
	        }
	
	        if (value === null) {
	            value = '';
	        }
	
	        this.push(escape(key) + '=' + escape(value));
	    };
	
	    serialize(params, obj);
	
	    return params.join('&').replace(/%20/g, '+');
	};
	
	/**
	 * Parse a URL and return its components.
	 *
	 * @param {String} url
	 */
	
	Url.parse = function (url) {
	
	    if (ie) {
	        el.href = url;
	        url = el.href;
	    }
	
	    el.href = url;
	
	    return {
	        href: el.href,
	        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
	        port: el.port,
	        host: el.host,
	        hostname: el.hostname,
	        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
	        search: el.search ? el.search.replace(/^\?/, '') : '',
	        hash: el.hash ? el.hash.replace(/^#/, '') : ''
	    };
	};
	
	function factory(handler, next, vm) {
	    return function (options) {
	        return handler.call(vm, options, next);
	    };
	}
	
	function serialize(params, obj, scope) {
	
	    var array = isArray(obj),
	        plain = isPlainObject(obj),
	        hash;
	
	    each(obj, function (value, key) {
	
	        hash = isObject(value) || isArray(value);
	
	        if (scope) {
	            key = scope + '[' + (plain || hash ? key : '') + ']';
	        }
	
	        if (!scope && array) {
	            params.add(value.name, value.value);
	        } else if (hash) {
	            serialize(params, value, key);
	        } else {
	            params.add(key, value);
	        }
	    });
	}
	
	/**
	 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
	 */
	
	var RESOLVED = 0;
	var REJECTED = 1;
	var PENDING = 2;
	
	function Promise$2(executor) {
	
	    this.state = PENDING;
	    this.value = undefined;
	    this.deferred = [];
	
	    var promise = this;
	
	    try {
	        executor(function (x) {
	            promise.resolve(x);
	        }, function (r) {
	            promise.reject(r);
	        });
	    } catch (e) {
	        promise.reject(e);
	    }
	}
	
	Promise$2.reject = function (r) {
	    return new Promise$2(function (resolve, reject) {
	        reject(r);
	    });
	};
	
	Promise$2.resolve = function (x) {
	    return new Promise$2(function (resolve, reject) {
	        resolve(x);
	    });
	};
	
	Promise$2.all = function all(iterable) {
	    return new Promise$2(function (resolve, reject) {
	        var count = 0,
	            result = [];
	
	        if (iterable.length === 0) {
	            resolve(result);
	        }
	
	        function resolver(i) {
	            return function (x) {
	                result[i] = x;
	                count += 1;
	
	                if (count === iterable.length) {
	                    resolve(result);
	                }
	            };
	        }
	
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$2.resolve(iterable[i]).then(resolver(i), reject);
	        }
	    });
	};
	
	Promise$2.race = function race(iterable) {
	    return new Promise$2(function (resolve, reject) {
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$2.resolve(iterable[i]).then(resolve, reject);
	        }
	    });
	};
	
	var p$1 = Promise$2.prototype;
	
	p$1.resolve = function resolve(x) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (x === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        var called = false;
	
	        try {
	            var then = x && x['then'];
	
	            if (x !== null && (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && typeof then === 'function') {
	                then.call(x, function (x) {
	                    if (!called) {
	                        promise.resolve(x);
	                    }
	                    called = true;
	                }, function (r) {
	                    if (!called) {
	                        promise.reject(r);
	                    }
	                    called = true;
	                });
	                return;
	            }
	        } catch (e) {
	            if (!called) {
	                promise.reject(e);
	            }
	            return;
	        }
	
	        promise.state = RESOLVED;
	        promise.value = x;
	        promise.notify();
	    }
	};
	
	p$1.reject = function reject(reason) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (reason === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        promise.state = REJECTED;
	        promise.value = reason;
	        promise.notify();
	    }
	};
	
	p$1.notify = function notify() {
	    var promise = this;
	
	    nextTick(function () {
	        if (promise.state !== PENDING) {
	            while (promise.deferred.length) {
	                var deferred = promise.deferred.shift(),
	                    onResolved = deferred[0],
	                    onRejected = deferred[1],
	                    resolve = deferred[2],
	                    reject = deferred[3];
	
	                try {
	                    if (promise.state === RESOLVED) {
	                        if (typeof onResolved === 'function') {
	                            resolve(onResolved.call(undefined, promise.value));
	                        } else {
	                            resolve(promise.value);
	                        }
	                    } else if (promise.state === REJECTED) {
	                        if (typeof onRejected === 'function') {
	                            resolve(onRejected.call(undefined, promise.value));
	                        } else {
	                            reject(promise.value);
	                        }
	                    }
	                } catch (e) {
	                    reject(e);
	                }
	            }
	        }
	    });
	};
	
	p$1.then = function then(onResolved, onRejected) {
	    var promise = this;
	
	    return new Promise$2(function (resolve, reject) {
	        promise.deferred.push([onResolved, onRejected, resolve, reject]);
	        promise.notify();
	    });
	};
	
	p$1.catch = function (onRejected) {
	    return this.then(undefined, onRejected);
	};
	
	var PromiseObj = window.Promise || Promise$2;
	
	function Promise$1(executor, context) {
	
	    if (executor instanceof PromiseObj) {
	        this.promise = executor;
	    } else {
	        this.promise = new PromiseObj(executor.bind(context));
	    }
	
	    this.context = context;
	}
	
	Promise$1.all = function (iterable, context) {
	    return new Promise$1(PromiseObj.all(iterable), context);
	};
	
	Promise$1.resolve = function (value, context) {
	    return new Promise$1(PromiseObj.resolve(value), context);
	};
	
	Promise$1.reject = function (reason, context) {
	    return new Promise$1(PromiseObj.reject(reason), context);
	};
	
	Promise$1.race = function (iterable, context) {
	    return new Promise$1(PromiseObj.race(iterable), context);
	};
	
	var p = Promise$1.prototype;
	
	p.bind = function (context) {
	    this.context = context;
	    return this;
	};
	
	p.then = function (fulfilled, rejected) {
	
	    if (fulfilled && fulfilled.bind && this.context) {
	        fulfilled = fulfilled.bind(this.context);
	    }
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    this.promise = this.promise.then(fulfilled, rejected);
	
	    return this;
	};
	
	p.catch = function (rejected) {
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    this.promise = this.promise.catch(rejected);
	
	    return this;
	};
	
	p.finally = function (callback) {
	
	    return this.then(function (value) {
	        callback.call(this);
	        return value;
	    }, function (reason) {
	        callback.call(this);
	        return PromiseObj.reject(reason);
	    });
	};
	
	p.success = function (callback) {
	
	    warn('The `success` method has been deprecated. Use the `then` method instead.');
	
	    return this.then(function (response) {
	        return callback.call(this, response.data, response.status, response) || response;
	    });
	};
	
	p.error = function (callback) {
	
	    warn('The `error` method has been deprecated. Use the `catch` method instead.');
	
	    return this.catch(function (response) {
	        return callback.call(this, response.data, response.status, response) || response;
	    });
	};
	
	p.always = function (callback) {
	
	    warn('The `always` method has been deprecated. Use the `finally` method instead.');
	
	    var cb = function cb(response) {
	        return callback.call(this, response.data, response.status, response) || response;
	    };
	
	    return this.then(cb, cb);
	};
	
	function xdrClient (request) {
	    return new Promise$1(function (resolve) {
	
	        var xdr = new XDomainRequest(),
	            response = { request: request },
	            handler;
	
	        request.cancel = function () {
	            xdr.abort();
	        };
	
	        xdr.open(request.method, Url(request), true);
	
	        handler = function handler(event) {
	
	            response.data = xdr.responseText;
	            response.status = xdr.status;
	            response.statusText = xdr.statusText || '';
	
	            resolve(response);
	        };
	
	        xdr.timeout = 0;
	        xdr.onload = handler;
	        xdr.onabort = handler;
	        xdr.onerror = handler;
	        xdr.ontimeout = function () {};
	        xdr.onprogress = function () {};
	
	        xdr.send(request.data);
	    });
	}
	
	var originUrl = Url.parse(location.href);
	var supportCors = 'withCredentials' in new XMLHttpRequest();
	
	var exports$1 = {
	    request: function request(_request) {
	
	        if (_request.crossOrigin === null) {
	            _request.crossOrigin = crossOrigin(_request);
	        }
	
	        if (_request.crossOrigin) {
	
	            if (!supportCors) {
	                _request.client = xdrClient;
	            }
	
	            _request.emulateHTTP = false;
	        }
	
	        return _request;
	    }
	};
	
	function crossOrigin(request) {
	
	    var requestUrl = Url.parse(Url(request));
	
	    return requestUrl.protocol !== originUrl.protocol || requestUrl.host !== originUrl.host;
	}
	
	var exports$2 = {
	    request: function request(_request) {
	
	        if (_request.emulateJSON && isPlainObject(_request.data)) {
	            _request.headers['Content-Type'] = 'application/x-www-form-urlencoded';
	            _request.data = Url.params(_request.data);
	        }
	
	        if (isObject(_request.data) && /FormData/i.test(_request.data.toString())) {
	            delete _request.headers['Content-Type'];
	        }
	
	        if (isPlainObject(_request.data)) {
	            _request.data = JSON.stringify(_request.data);
	        }
	
	        return _request;
	    },
	    response: function response(_response) {
	
	        try {
	            _response.data = JSON.parse(_response.data);
	        } catch (e) {}
	
	        return _response;
	    }
	};
	
	function jsonpClient (request) {
	    return new Promise$1(function (resolve) {
	
	        var callback = '_jsonp' + Math.random().toString(36).substr(2),
	            response = { request: request, data: null },
	            handler,
	            script;
	
	        request.params[request.jsonp] = callback;
	        request.cancel = function () {
	            handler({ type: 'cancel' });
	        };
	
	        script = document.createElement('script');
	        script.src = Url(request);
	        script.type = 'text/javascript';
	        script.async = true;
	
	        window[callback] = function (data) {
	            response.data = data;
	        };
	
	        handler = function handler(event) {
	
	            if (event.type === 'load' && response.data !== null) {
	                response.status = 200;
	            } else if (event.type === 'error') {
	                response.status = 404;
	            } else {
	                response.status = 0;
	            }
	
	            resolve(response);
	
	            delete window[callback];
	            document.body.removeChild(script);
	        };
	
	        script.onload = handler;
	        script.onerror = handler;
	
	        document.body.appendChild(script);
	    });
	}
	
	var exports$3 = {
	    request: function request(_request) {
	
	        if (_request.method == 'JSONP') {
	            _request.client = jsonpClient;
	        }
	
	        return _request;
	    }
	};
	
	var exports$4 = {
	    request: function request(_request) {
	
	        if (isFunction(_request.beforeSend)) {
	            _request.beforeSend.call(this, _request);
	        }
	
	        return _request;
	    }
	};
	
	/**
	 * HTTP method override Interceptor.
	 */
	
	var exports$5 = {
	    request: function request(_request) {
	
	        if (_request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(_request.method)) {
	            _request.headers['X-HTTP-Method-Override'] = _request.method;
	            _request.method = 'POST';
	        }
	
	        return _request;
	    }
	};
	
	var exports$6 = {
	    request: function request(_request) {
	
	        _request.method = _request.method.toUpperCase();
	        _request.headers = extend({}, Http.headers.common, !_request.crossOrigin ? Http.headers.custom : {}, Http.headers[_request.method.toLowerCase()], _request.headers);
	
	        if (isPlainObject(_request.data) && /^(GET|JSONP)$/i.test(_request.method)) {
	            extend(_request.params, _request.data);
	            delete _request.data;
	        }
	
	        return _request;
	    }
	};
	
	/**
	 * Timeout Interceptor.
	 */
	
	var exports$7 = function exports() {
	
	    var timeout;
	
	    return {
	        request: function request(_request) {
	
	            if (_request.timeout) {
	                timeout = setTimeout(function () {
	                    _request.cancel();
	                }, _request.timeout);
	            }
	
	            return _request;
	        },
	        response: function response(_response) {
	
	            clearTimeout(timeout);
	
	            return _response;
	        }
	    };
	};
	
	function interceptor (handler, vm) {
	
	    return function (client) {
	
	        if (isFunction(handler)) {
	            handler = handler.call(vm, Promise$1);
	        }
	
	        return function (request) {
	
	            if (isFunction(handler.request)) {
	                request = handler.request.call(vm, request);
	            }
	
	            return when(request, function (request) {
	                return when(client(request), function (response) {
	
	                    if (isFunction(handler.response)) {
	                        response = handler.response.call(vm, response);
	                    }
	
	                    return response;
	                });
	            });
	        };
	    };
	}
	
	function when(value, fulfilled, rejected) {
	
	    var promise = Promise$1.resolve(value);
	
	    if (arguments.length < 2) {
	        return promise;
	    }
	
	    return promise.then(fulfilled, rejected);
	}
	
	function xhrClient (request) {
	    return new Promise$1(function (resolve) {
	
	        var xhr = new XMLHttpRequest(),
	            response = { request: request },
	            handler;
	
	        request.cancel = function () {
	            xhr.abort();
	        };
	
	        xhr.open(request.method, Url(request), true);
	
	        handler = function handler(event) {
	
	            response.data = 'response' in xhr ? xhr.response : xhr.responseText;
	            response.status = xhr.status === 1223 ? 204 : xhr.status; // IE9 status bug
	            response.statusText = trim(xhr.statusText || '');
	            response.headers = xhr.getAllResponseHeaders();
	
	            resolve(response);
	        };
	
	        xhr.timeout = 0;
	        xhr.onload = handler;
	        xhr.onabort = handler;
	        xhr.onerror = handler;
	        xhr.ontimeout = function () {};
	        xhr.onprogress = function () {};
	
	        if (isPlainObject(request.xhr)) {
	            extend(xhr, request.xhr);
	        }
	
	        if (isPlainObject(request.upload)) {
	            extend(xhr.upload, request.upload);
	        }
	
	        each(request.headers || {}, function (value, header) {
	            xhr.setRequestHeader(header, value);
	        });
	
	        xhr.send(request.data);
	    });
	}
	
	function Client (request) {
	
	    var response = (request.client || xhrClient)(request);
	
	    return Promise$1.resolve(response).then(function (response) {
	
	        if (response.headers) {
	
	            var headers = parseHeaders(response.headers);
	
	            response.headers = function (name) {
	
	                if (name) {
	                    return headers[toLower(name)];
	                }
	
	                return headers;
	            };
	        }
	
	        response.ok = response.status >= 200 && response.status < 300;
	
	        return response;
	    });
	}
	
	function parseHeaders(str) {
	
	    var headers = {},
	        value,
	        name,
	        i;
	
	    if (isString(str)) {
	        each(str.split('\n'), function (row) {
	
	            i = row.indexOf(':');
	            name = trim(toLower(row.slice(0, i)));
	            value = trim(row.slice(i + 1));
	
	            if (headers[name]) {
	
	                if (isArray(headers[name])) {
	                    headers[name].push(value);
	                } else {
	                    headers[name] = [headers[name], value];
	                }
	            } else {
	
	                headers[name] = value;
	            }
	        });
	    }
	
	    return headers;
	}
	
	/**
	 * Service for sending network requests.
	 */
	
	var jsonType = { 'Content-Type': 'application/json' };
	
	function Http(url, options) {
	
	    var self = this || {},
	        client = Client,
	        request,
	        promise;
	
	    Http.interceptors.forEach(function (handler) {
	        client = interceptor(handler, self.$vm)(client);
	    });
	
	    options = isObject(url) ? url : extend({ url: url }, options);
	    request = merge({}, Http.options, self.$options, options);
	    promise = client(request).bind(self.$vm).then(function (response) {
	
	        return response.ok ? response : Promise$1.reject(response);
	    }, function (response) {
	
	        if (response instanceof Error) {
	            error(response);
	        }
	
	        return Promise$1.reject(response);
	    });
	
	    if (request.success) {
	        promise.success(request.success);
	    }
	
	    if (request.error) {
	        promise.error(request.error);
	    }
	
	    return promise;
	}
	
	Http.options = {
	    method: 'get',
	    data: '',
	    params: {},
	    headers: {},
	    xhr: null,
	    upload: null,
	    jsonp: 'callback',
	    beforeSend: null,
	    crossOrigin: null,
	    emulateHTTP: false,
	    emulateJSON: false,
	    timeout: 0
	};
	
	Http.headers = {
	    put: jsonType,
	    post: jsonType,
	    patch: jsonType,
	    delete: jsonType,
	    common: { 'Accept': 'application/json, text/plain, */*' },
	    custom: { 'X-Requested-With': 'XMLHttpRequest' }
	};
	
	Http.interceptors = [exports$4, exports$7, exports$3, exports$5, exports$2, exports$6, exports$1];
	
	['get', 'put', 'post', 'patch', 'delete', 'jsonp'].forEach(function (method) {
	
	    Http[method] = function (url, data, success, options) {
	
	        if (isFunction(data)) {
	            options = success;
	            success = data;
	            data = undefined;
	        }
	
	        if (isObject(success)) {
	            options = success;
	            success = undefined;
	        }
	
	        return this(url, extend({ method: method, data: data, success: success }, options));
	    };
	});
	
	function Resource(url, params, actions, options) {
	
	    var self = this || {},
	        resource = {};
	
	    actions = extend({}, Resource.actions, actions);
	
	    each(actions, function (action, name) {
	
	        action = merge({ url: url, params: params || {} }, options, action);
	
	        resource[name] = function () {
	            return (self.$http || Http)(opts(action, arguments));
	        };
	    });
	
	    return resource;
	}
	
	function opts(action, args) {
	
	    var options = extend({}, action),
	        params = {},
	        data,
	        success,
	        error;
	
	    switch (args.length) {
	
	        case 4:
	
	            error = args[3];
	            success = args[2];
	
	        case 3:
	        case 2:
	
	            if (isFunction(args[1])) {
	
	                if (isFunction(args[0])) {
	
	                    success = args[0];
	                    error = args[1];
	
	                    break;
	                }
	
	                success = args[1];
	                error = args[2];
	            } else {
	
	                params = args[0];
	                data = args[1];
	                success = args[2];
	
	                break;
	            }
	
	        case 1:
	
	            if (isFunction(args[0])) {
	                success = args[0];
	            } else if (/^(POST|PUT|PATCH)$/i.test(options.method)) {
	                data = args[0];
	            } else {
	                params = args[0];
	            }
	
	            break;
	
	        case 0:
	
	            break;
	
	        default:
	
	            throw 'Expected up to 4 arguments [params, data, success, error], got ' + args.length + ' arguments';
	    }
	
	    options.data = data;
	    options.params = extend({}, options.params, params);
	
	    if (success) {
	        options.success = success;
	    }
	
	    if (error) {
	        options.error = error;
	    }
	
	    return options;
	}
	
	Resource.actions = {
	
	    get: { method: 'GET' },
	    save: { method: 'POST' },
	    query: { method: 'GET' },
	    update: { method: 'PUT' },
	    remove: { method: 'DELETE' },
	    delete: { method: 'DELETE' }
	
	};
	
	function plugin(Vue) {
	
	    if (plugin.installed) {
	        return;
	    }
	
	    Util(Vue);
	
	    Vue.url = Url;
	    Vue.http = Http;
	    Vue.resource = Resource;
	    Vue.Promise = Promise$1;
	
	    Object.defineProperties(Vue.prototype, {
	
	        $url: {
	            get: function get() {
	                return options(Vue.url, this, this.$options.url);
	            }
	        },
	
	        $http: {
	            get: function get() {
	                return options(Vue.http, this, this.$options.http);
	            }
	        },
	
	        $resource: {
	            get: function get() {
	                return Vue.resource.bind(this);
	            }
	        },
	
	        $promise: {
	            get: function get() {
	                var _this = this;
	
	                return function (executor) {
	                    return new Vue.Promise(executor, _this);
	                };
	            }
	        }
	
	    });
	}
	
	if (typeof window !== 'undefined' && window.Vue) {
	    window.Vue.use(plugin);
	}
	
	module.exports = plugin;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * vue-router v0.7.13
	 * (c) 2016 Evan You
	 * Released under the MIT License.
	 */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  global.VueRouter = factory();
	}(this, function () { 'use strict';
	
	  var babelHelpers = {};
	
	  babelHelpers.classCallCheck = function (instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  };
	  function Target(path, matcher, delegate) {
	    this.path = path;
	    this.matcher = matcher;
	    this.delegate = delegate;
	  }
	
	  Target.prototype = {
	    to: function to(target, callback) {
	      var delegate = this.delegate;
	
	      if (delegate && delegate.willAddRoute) {
	        target = delegate.willAddRoute(this.matcher.target, target);
	      }
	
	      this.matcher.add(this.path, target);
	
	      if (callback) {
	        if (callback.length === 0) {
	          throw new Error("You must have an argument in the function passed to `to`");
	        }
	        this.matcher.addChild(this.path, target, callback, this.delegate);
	      }
	      return this;
	    }
	  };
	
	  function Matcher(target) {
	    this.routes = {};
	    this.children = {};
	    this.target = target;
	  }
	
	  Matcher.prototype = {
	    add: function add(path, handler) {
	      this.routes[path] = handler;
	    },
	
	    addChild: function addChild(path, target, callback, delegate) {
	      var matcher = new Matcher(target);
	      this.children[path] = matcher;
	
	      var match = generateMatch(path, matcher, delegate);
	
	      if (delegate && delegate.contextEntered) {
	        delegate.contextEntered(target, match);
	      }
	
	      callback(match);
	    }
	  };
	
	  function generateMatch(startingPath, matcher, delegate) {
	    return function (path, nestedCallback) {
	      var fullPath = startingPath + path;
	
	      if (nestedCallback) {
	        nestedCallback(generateMatch(fullPath, matcher, delegate));
	      } else {
	        return new Target(startingPath + path, matcher, delegate);
	      }
	    };
	  }
	
	  function addRoute(routeArray, path, handler) {
	    var len = 0;
	    for (var i = 0, l = routeArray.length; i < l; i++) {
	      len += routeArray[i].path.length;
	    }
	
	    path = path.substr(len);
	    var route = { path: path, handler: handler };
	    routeArray.push(route);
	  }
	
	  function eachRoute(baseRoute, matcher, callback, binding) {
	    var routes = matcher.routes;
	
	    for (var path in routes) {
	      if (routes.hasOwnProperty(path)) {
	        var routeArray = baseRoute.slice();
	        addRoute(routeArray, path, routes[path]);
	
	        if (matcher.children[path]) {
	          eachRoute(routeArray, matcher.children[path], callback, binding);
	        } else {
	          callback.call(binding, routeArray);
	        }
	      }
	    }
	  }
	
	  function map (callback, addRouteCallback) {
	    var matcher = new Matcher();
	
	    callback(generateMatch("", matcher, this.delegate));
	
	    eachRoute([], matcher, function (route) {
	      if (addRouteCallback) {
	        addRouteCallback(this, route);
	      } else {
	        this.add(route);
	      }
	    }, this);
	  }
	
	  var specials = ['/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\'];
	
	  var escapeRegex = new RegExp('(\\' + specials.join('|\\') + ')', 'g');
	
	  var noWarning = false;
	  function warn(msg) {
	    if (!noWarning && typeof console !== 'undefined') {
	      console.error('[vue-router] ' + msg);
	    }
	  }
	
	  function tryDecode(uri, asComponent) {
	    try {
	      return asComponent ? decodeURIComponent(uri) : decodeURI(uri);
	    } catch (e) {
	      warn('malformed URI' + (asComponent ? ' component: ' : ': ') + uri);
	    }
	  }
	
	  function isArray(test) {
	    return Object.prototype.toString.call(test) === "[object Array]";
	  }
	
	  // A Segment represents a segment in the original route description.
	  // Each Segment type provides an `eachChar` and `regex` method.
	  //
	  // The `eachChar` method invokes the callback with one or more character
	  // specifications. A character specification consumes one or more input
	  // characters.
	  //
	  // The `regex` method returns a regex fragment for the segment. If the
	  // segment is a dynamic of star segment, the regex fragment also includes
	  // a capture.
	  //
	  // A character specification contains:
	  //
	  // * `validChars`: a String with a list of all valid characters, or
	  // * `invalidChars`: a String with a list of all invalid characters
	  // * `repeat`: true if the character specification can repeat
	
	  function StaticSegment(string) {
	    this.string = string;
	  }
	  StaticSegment.prototype = {
	    eachChar: function eachChar(callback) {
	      var string = this.string,
	          ch;
	
	      for (var i = 0, l = string.length; i < l; i++) {
	        ch = string.charAt(i);
	        callback({ validChars: ch });
	      }
	    },
	
	    regex: function regex() {
	      return this.string.replace(escapeRegex, '\\$1');
	    },
	
	    generate: function generate() {
	      return this.string;
	    }
	  };
	
	  function DynamicSegment(name) {
	    this.name = name;
	  }
	  DynamicSegment.prototype = {
	    eachChar: function eachChar(callback) {
	      callback({ invalidChars: "/", repeat: true });
	    },
	
	    regex: function regex() {
	      return "([^/]+)";
	    },
	
	    generate: function generate(params) {
	      var val = params[this.name];
	      return val == null ? ":" + this.name : val;
	    }
	  };
	
	  function StarSegment(name) {
	    this.name = name;
	  }
	  StarSegment.prototype = {
	    eachChar: function eachChar(callback) {
	      callback({ invalidChars: "", repeat: true });
	    },
	
	    regex: function regex() {
	      return "(.+)";
	    },
	
	    generate: function generate(params) {
	      var val = params[this.name];
	      return val == null ? ":" + this.name : val;
	    }
	  };
	
	  function EpsilonSegment() {}
	  EpsilonSegment.prototype = {
	    eachChar: function eachChar() {},
	    regex: function regex() {
	      return "";
	    },
	    generate: function generate() {
	      return "";
	    }
	  };
	
	  function parse(route, names, specificity) {
	    // normalize route as not starting with a "/". Recognition will
	    // also normalize.
	    if (route.charAt(0) === "/") {
	      route = route.substr(1);
	    }
	
	    var segments = route.split("/"),
	        results = [];
	
	    // A routes has specificity determined by the order that its different segments
	    // appear in. This system mirrors how the magnitude of numbers written as strings
	    // works.
	    // Consider a number written as: "abc". An example would be "200". Any other number written
	    // "xyz" will be smaller than "abc" so long as `a > z`. For instance, "199" is smaller
	    // then "200", even though "y" and "z" (which are both 9) are larger than "0" (the value
	    // of (`b` and `c`). This is because the leading symbol, "2", is larger than the other
	    // leading symbol, "1".
	    // The rule is that symbols to the left carry more weight than symbols to the right
	    // when a number is written out as a string. In the above strings, the leading digit
	    // represents how many 100's are in the number, and it carries more weight than the middle
	    // number which represents how many 10's are in the number.
	    // This system of number magnitude works well for route specificity, too. A route written as
	    // `a/b/c` will be more specific than `x/y/z` as long as `a` is more specific than
	    // `x`, irrespective of the other parts.
	    // Because of this similarity, we assign each type of segment a number value written as a
	    // string. We can find the specificity of compound routes by concatenating these strings
	    // together, from left to right. After we have looped through all of the segments,
	    // we convert the string to a number.
	    specificity.val = '';
	
	    for (var i = 0, l = segments.length; i < l; i++) {
	      var segment = segments[i],
	          match;
	
	      if (match = segment.match(/^:([^\/]+)$/)) {
	        results.push(new DynamicSegment(match[1]));
	        names.push(match[1]);
	        specificity.val += '3';
	      } else if (match = segment.match(/^\*([^\/]+)$/)) {
	        results.push(new StarSegment(match[1]));
	        specificity.val += '2';
	        names.push(match[1]);
	      } else if (segment === "") {
	        results.push(new EpsilonSegment());
	        specificity.val += '1';
	      } else {
	        results.push(new StaticSegment(segment));
	        specificity.val += '4';
	      }
	    }
	
	    specificity.val = +specificity.val;
	
	    return results;
	  }
	
	  // A State has a character specification and (`charSpec`) and a list of possible
	  // subsequent states (`nextStates`).
	  //
	  // If a State is an accepting state, it will also have several additional
	  // properties:
	  //
	  // * `regex`: A regular expression that is used to extract parameters from paths
	  //   that reached this accepting state.
	  // * `handlers`: Information on how to convert the list of captures into calls
	  //   to registered handlers with the specified parameters
	  // * `types`: How many static, dynamic or star segments in this route. Used to
	  //   decide which route to use if multiple registered routes match a path.
	  //
	  // Currently, State is implemented naively by looping over `nextStates` and
	  // comparing a character specification against a character. A more efficient
	  // implementation would use a hash of keys pointing at one or more next states.
	
	  function State(charSpec) {
	    this.charSpec = charSpec;
	    this.nextStates = [];
	  }
	
	  State.prototype = {
	    get: function get(charSpec) {
	      var nextStates = this.nextStates;
	
	      for (var i = 0, l = nextStates.length; i < l; i++) {
	        var child = nextStates[i];
	
	        var isEqual = child.charSpec.validChars === charSpec.validChars;
	        isEqual = isEqual && child.charSpec.invalidChars === charSpec.invalidChars;
	
	        if (isEqual) {
	          return child;
	        }
	      }
	    },
	
	    put: function put(charSpec) {
	      var state;
	
	      // If the character specification already exists in a child of the current
	      // state, just return that state.
	      if (state = this.get(charSpec)) {
	        return state;
	      }
	
	      // Make a new state for the character spec
	      state = new State(charSpec);
	
	      // Insert the new state as a child of the current state
	      this.nextStates.push(state);
	
	      // If this character specification repeats, insert the new state as a child
	      // of itself. Note that this will not trigger an infinite loop because each
	      // transition during recognition consumes a character.
	      if (charSpec.repeat) {
	        state.nextStates.push(state);
	      }
	
	      // Return the new state
	      return state;
	    },
	
	    // Find a list of child states matching the next character
	    match: function match(ch) {
	      // DEBUG "Processing `" + ch + "`:"
	      var nextStates = this.nextStates,
	          child,
	          charSpec,
	          chars;
	
	      // DEBUG "  " + debugState(this)
	      var returned = [];
	
	      for (var i = 0, l = nextStates.length; i < l; i++) {
	        child = nextStates[i];
	
	        charSpec = child.charSpec;
	
	        if (typeof (chars = charSpec.validChars) !== 'undefined') {
	          if (chars.indexOf(ch) !== -1) {
	            returned.push(child);
	          }
	        } else if (typeof (chars = charSpec.invalidChars) !== 'undefined') {
	          if (chars.indexOf(ch) === -1) {
	            returned.push(child);
	          }
	        }
	      }
	
	      return returned;
	    }
	
	    /** IF DEBUG
	    , debug: function() {
	      var charSpec = this.charSpec,
	          debug = "[",
	          chars = charSpec.validChars || charSpec.invalidChars;
	       if (charSpec.invalidChars) { debug += "^"; }
	      debug += chars;
	      debug += "]";
	       if (charSpec.repeat) { debug += "+"; }
	       return debug;
	    }
	    END IF **/
	  };
	
	  /** IF DEBUG
	  function debug(log) {
	    console.log(log);
	  }
	
	  function debugState(state) {
	    return state.nextStates.map(function(n) {
	      if (n.nextStates.length === 0) { return "( " + n.debug() + " [accepting] )"; }
	      return "( " + n.debug() + " <then> " + n.nextStates.map(function(s) { return s.debug() }).join(" or ") + " )";
	    }).join(", ")
	  }
	  END IF **/
	
	  // Sort the routes by specificity
	  function sortSolutions(states) {
	    return states.sort(function (a, b) {
	      return b.specificity.val - a.specificity.val;
	    });
	  }
	
	  function recognizeChar(states, ch) {
	    var nextStates = [];
	
	    for (var i = 0, l = states.length; i < l; i++) {
	      var state = states[i];
	
	      nextStates = nextStates.concat(state.match(ch));
	    }
	
	    return nextStates;
	  }
	
	  var oCreate = Object.create || function (proto) {
	    function F() {}
	    F.prototype = proto;
	    return new F();
	  };
	
	  function RecognizeResults(queryParams) {
	    this.queryParams = queryParams || {};
	  }
	  RecognizeResults.prototype = oCreate({
	    splice: Array.prototype.splice,
	    slice: Array.prototype.slice,
	    push: Array.prototype.push,
	    length: 0,
	    queryParams: null
	  });
	
	  function findHandler(state, path, queryParams) {
	    var handlers = state.handlers,
	        regex = state.regex;
	    var captures = path.match(regex),
	        currentCapture = 1;
	    var result = new RecognizeResults(queryParams);
	
	    for (var i = 0, l = handlers.length; i < l; i++) {
	      var handler = handlers[i],
	          names = handler.names,
	          params = {};
	
	      for (var j = 0, m = names.length; j < m; j++) {
	        params[names[j]] = captures[currentCapture++];
	      }
	
	      result.push({ handler: handler.handler, params: params, isDynamic: !!names.length });
	    }
	
	    return result;
	  }
	
	  function addSegment(currentState, segment) {
	    segment.eachChar(function (ch) {
	      var state;
	
	      currentState = currentState.put(ch);
	    });
	
	    return currentState;
	  }
	
	  function decodeQueryParamPart(part) {
	    // http://www.w3.org/TR/html401/interact/forms.html#h-17.13.4.1
	    part = part.replace(/\+/gm, '%20');
	    return tryDecode(part, true);
	  }
	
	  // The main interface
	
	  var RouteRecognizer = function RouteRecognizer() {
	    this.rootState = new State();
	    this.names = {};
	  };
	
	  RouteRecognizer.prototype = {
	    add: function add(routes, options) {
	      var currentState = this.rootState,
	          regex = "^",
	          specificity = {},
	          handlers = [],
	          allSegments = [],
	          name;
	
	      var isEmpty = true;
	
	      for (var i = 0, l = routes.length; i < l; i++) {
	        var route = routes[i],
	            names = [];
	
	        var segments = parse(route.path, names, specificity);
	
	        allSegments = allSegments.concat(segments);
	
	        for (var j = 0, m = segments.length; j < m; j++) {
	          var segment = segments[j];
	
	          if (segment instanceof EpsilonSegment) {
	            continue;
	          }
	
	          isEmpty = false;
	
	          // Add a "/" for the new segment
	          currentState = currentState.put({ validChars: "/" });
	          regex += "/";
	
	          // Add a representation of the segment to the NFA and regex
	          currentState = addSegment(currentState, segment);
	          regex += segment.regex();
	        }
	
	        var handler = { handler: route.handler, names: names };
	        handlers.push(handler);
	      }
	
	      if (isEmpty) {
	        currentState = currentState.put({ validChars: "/" });
	        regex += "/";
	      }
	
	      currentState.handlers = handlers;
	      currentState.regex = new RegExp(regex + "$");
	      currentState.specificity = specificity;
	
	      if (name = options && options.as) {
	        this.names[name] = {
	          segments: allSegments,
	          handlers: handlers
	        };
	      }
	    },
	
	    handlersFor: function handlersFor(name) {
	      var route = this.names[name],
	          result = [];
	      if (!route) {
	        throw new Error("There is no route named " + name);
	      }
	
	      for (var i = 0, l = route.handlers.length; i < l; i++) {
	        result.push(route.handlers[i]);
	      }
	
	      return result;
	    },
	
	    hasRoute: function hasRoute(name) {
	      return !!this.names[name];
	    },
	
	    generate: function generate(name, params) {
	      var route = this.names[name],
	          output = "";
	      if (!route) {
	        throw new Error("There is no route named " + name);
	      }
	
	      var segments = route.segments;
	
	      for (var i = 0, l = segments.length; i < l; i++) {
	        var segment = segments[i];
	
	        if (segment instanceof EpsilonSegment) {
	          continue;
	        }
	
	        output += "/";
	        output += segment.generate(params);
	      }
	
	      if (output.charAt(0) !== '/') {
	        output = '/' + output;
	      }
	
	      if (params && params.queryParams) {
	        output += this.generateQueryString(params.queryParams);
	      }
	
	      return output;
	    },
	
	    generateQueryString: function generateQueryString(params) {
	      var pairs = [];
	      var keys = [];
	      for (var key in params) {
	        if (params.hasOwnProperty(key)) {
	          keys.push(key);
	        }
	      }
	      keys.sort();
	      for (var i = 0, len = keys.length; i < len; i++) {
	        key = keys[i];
	        var value = params[key];
	        if (value == null) {
	          continue;
	        }
	        var pair = encodeURIComponent(key);
	        if (isArray(value)) {
	          for (var j = 0, l = value.length; j < l; j++) {
	            var arrayPair = key + '[]' + '=' + encodeURIComponent(value[j]);
	            pairs.push(arrayPair);
	          }
	        } else {
	          pair += "=" + encodeURIComponent(value);
	          pairs.push(pair);
	        }
	      }
	
	      if (pairs.length === 0) {
	        return '';
	      }
	
	      return "?" + pairs.join("&");
	    },
	
	    parseQueryString: function parseQueryString(queryString) {
	      var pairs = queryString.split("&"),
	          queryParams = {};
	      for (var i = 0; i < pairs.length; i++) {
	        var pair = pairs[i].split('='),
	            key = decodeQueryParamPart(pair[0]),
	            keyLength = key.length,
	            isArray = false,
	            value;
	        if (pair.length === 1) {
	          value = 'true';
	        } else {
	          //Handle arrays
	          if (keyLength > 2 && key.slice(keyLength - 2) === '[]') {
	            isArray = true;
	            key = key.slice(0, keyLength - 2);
	            if (!queryParams[key]) {
	              queryParams[key] = [];
	            }
	          }
	          value = pair[1] ? decodeQueryParamPart(pair[1]) : '';
	        }
	        if (isArray) {
	          queryParams[key].push(value);
	        } else {
	          queryParams[key] = value;
	        }
	      }
	      return queryParams;
	    },
	
	    recognize: function recognize(path, silent) {
	      noWarning = silent;
	      var states = [this.rootState],
	          pathLen,
	          i,
	          l,
	          queryStart,
	          queryParams = {},
	          isSlashDropped = false;
	
	      queryStart = path.indexOf('?');
	      if (queryStart !== -1) {
	        var queryString = path.substr(queryStart + 1, path.length);
	        path = path.substr(0, queryStart);
	        if (queryString) {
	          queryParams = this.parseQueryString(queryString);
	        }
	      }
	
	      path = tryDecode(path);
	      if (!path) return;
	
	      // DEBUG GROUP path
	
	      if (path.charAt(0) !== "/") {
	        path = "/" + path;
	      }
	
	      pathLen = path.length;
	      if (pathLen > 1 && path.charAt(pathLen - 1) === "/") {
	        path = path.substr(0, pathLen - 1);
	        isSlashDropped = true;
	      }
	
	      for (i = 0, l = path.length; i < l; i++) {
	        states = recognizeChar(states, path.charAt(i));
	        if (!states.length) {
	          break;
	        }
	      }
	
	      // END DEBUG GROUP
	
	      var solutions = [];
	      for (i = 0, l = states.length; i < l; i++) {
	        if (states[i].handlers) {
	          solutions.push(states[i]);
	        }
	      }
	
	      states = sortSolutions(solutions);
	
	      var state = solutions[0];
	
	      if (state && state.handlers) {
	        // if a trailing slash was dropped and a star segment is the last segment
	        // specified, put the trailing slash back
	        if (isSlashDropped && state.regex.source.slice(-5) === "(.+)$") {
	          path = path + "/";
	        }
	        return findHandler(state, path, queryParams);
	      }
	    }
	  };
	
	  RouteRecognizer.prototype.map = map;
	
	  var genQuery = RouteRecognizer.prototype.generateQueryString;
	
	  // export default for holding the Vue reference
	  var exports$1 = {};
	  /**
	   * Warn stuff.
	   *
	   * @param {String} msg
	   */
	
	  function warn$1(msg) {
	    /* istanbul ignore next */
	    if (typeof console !== 'undefined') {
	      console.error('[vue-router] ' + msg);
	    }
	  }
	
	  /**
	   * Resolve a relative path.
	   *
	   * @param {String} base
	   * @param {String} relative
	   * @param {Boolean} append
	   * @return {String}
	   */
	
	  function resolvePath(base, relative, append) {
	    var query = base.match(/(\?.*)$/);
	    if (query) {
	      query = query[1];
	      base = base.slice(0, -query.length);
	    }
	    // a query!
	    if (relative.charAt(0) === '?') {
	      return base + relative;
	    }
	    var stack = base.split('/');
	    // remove trailing segment if:
	    // - not appending
	    // - appending to trailing slash (last segment is empty)
	    if (!append || !stack[stack.length - 1]) {
	      stack.pop();
	    }
	    // resolve relative path
	    var segments = relative.replace(/^\//, '').split('/');
	    for (var i = 0; i < segments.length; i++) {
	      var segment = segments[i];
	      if (segment === '.') {
	        continue;
	      } else if (segment === '..') {
	        stack.pop();
	      } else {
	        stack.push(segment);
	      }
	    }
	    // ensure leading slash
	    if (stack[0] !== '') {
	      stack.unshift('');
	    }
	    return stack.join('/');
	  }
	
	  /**
	   * Forgiving check for a promise
	   *
	   * @param {Object} p
	   * @return {Boolean}
	   */
	
	  function isPromise(p) {
	    return p && typeof p.then === 'function';
	  }
	
	  /**
	   * Retrive a route config field from a component instance
	   * OR a component contructor.
	   *
	   * @param {Function|Vue} component
	   * @param {String} name
	   * @return {*}
	   */
	
	  function getRouteConfig(component, name) {
	    var options = component && (component.$options || component.options);
	    return options && options.route && options.route[name];
	  }
	
	  /**
	   * Resolve an async component factory. Have to do a dirty
	   * mock here because of Vue core's internal API depends on
	   * an ID check.
	   *
	   * @param {Object} handler
	   * @param {Function} cb
	   */
	
	  var resolver = undefined;
	
	  function resolveAsyncComponent(handler, cb) {
	    if (!resolver) {
	      resolver = {
	        resolve: exports$1.Vue.prototype._resolveComponent,
	        $options: {
	          components: {
	            _: handler.component
	          }
	        }
	      };
	    } else {
	      resolver.$options.components._ = handler.component;
	    }
	    resolver.resolve('_', function (Component) {
	      handler.component = Component;
	      cb(Component);
	    });
	  }
	
	  /**
	   * Map the dynamic segments in a path to params.
	   *
	   * @param {String} path
	   * @param {Object} params
	   * @param {Object} query
	   */
	
	  function mapParams(path, params, query) {
	    if (params === undefined) params = {};
	
	    path = path.replace(/:([^\/]+)/g, function (_, key) {
	      var val = params[key];
	      /* istanbul ignore if */
	      if (!val) {
	        warn$1('param "' + key + '" not found when generating ' + 'path for "' + path + '" with params ' + JSON.stringify(params));
	      }
	      return val || '';
	    });
	    if (query) {
	      path += genQuery(query);
	    }
	    return path;
	  }
	
	  var hashRE = /#.*$/;
	
	  var HTML5History = (function () {
	    function HTML5History(_ref) {
	      var root = _ref.root;
	      var onChange = _ref.onChange;
	      babelHelpers.classCallCheck(this, HTML5History);
	
	      if (root && root !== '/') {
	        // make sure there's the starting slash
	        if (root.charAt(0) !== '/') {
	          root = '/' + root;
	        }
	        // remove trailing slash
	        this.root = root.replace(/\/$/, '');
	        this.rootRE = new RegExp('^\\' + this.root);
	      } else {
	        this.root = null;
	      }
	      this.onChange = onChange;
	      // check base tag
	      var baseEl = document.querySelector('base');
	      this.base = baseEl && baseEl.getAttribute('href');
	    }
	
	    HTML5History.prototype.start = function start() {
	      var _this = this;
	
	      this.listener = function (e) {
	        var url = location.pathname + location.search;
	        if (_this.root) {
	          url = url.replace(_this.rootRE, '');
	        }
	        _this.onChange(url, e && e.state, location.hash);
	      };
	      window.addEventListener('popstate', this.listener);
	      this.listener();
	    };
	
	    HTML5History.prototype.stop = function stop() {
	      window.removeEventListener('popstate', this.listener);
	    };
	
	    HTML5History.prototype.go = function go(path, replace, append) {
	      var url = this.formatPath(path, append);
	      if (replace) {
	        history.replaceState({}, '', url);
	      } else {
	        // record scroll position by replacing current state
	        history.replaceState({
	          pos: {
	            x: window.pageXOffset,
	            y: window.pageYOffset
	          }
	        }, '', location.href);
	        // then push new state
	        history.pushState({}, '', url);
	      }
	      var hashMatch = path.match(hashRE);
	      var hash = hashMatch && hashMatch[0];
	      path = url
	      // strip hash so it doesn't mess up params
	      .replace(hashRE, '')
	      // remove root before matching
	      .replace(this.rootRE, '');
	      this.onChange(path, null, hash);
	    };
	
	    HTML5History.prototype.formatPath = function formatPath(path, append) {
	      return path.charAt(0) === '/'
	      // absolute path
	      ? this.root ? this.root + '/' + path.replace(/^\//, '') : path : resolvePath(this.base || location.pathname, path, append);
	    };
	
	    return HTML5History;
	  })();
	
	  var HashHistory = (function () {
	    function HashHistory(_ref) {
	      var hashbang = _ref.hashbang;
	      var onChange = _ref.onChange;
	      babelHelpers.classCallCheck(this, HashHistory);
	
	      this.hashbang = hashbang;
	      this.onChange = onChange;
	    }
	
	    HashHistory.prototype.start = function start() {
	      var self = this;
	      this.listener = function () {
	        var path = location.hash;
	        var raw = path.replace(/^#!?/, '');
	        // always
	        if (raw.charAt(0) !== '/') {
	          raw = '/' + raw;
	        }
	        var formattedPath = self.formatPath(raw);
	        if (formattedPath !== path) {
	          location.replace(formattedPath);
	          return;
	        }
	        // determine query
	        // note it's possible to have queries in both the actual URL
	        // and the hash fragment itself.
	        var query = location.search && path.indexOf('?') > -1 ? '&' + location.search.slice(1) : location.search;
	        self.onChange(path.replace(/^#!?/, '') + query);
	      };
	      window.addEventListener('hashchange', this.listener);
	      this.listener();
	    };
	
	    HashHistory.prototype.stop = function stop() {
	      window.removeEventListener('hashchange', this.listener);
	    };
	
	    HashHistory.prototype.go = function go(path, replace, append) {
	      path = this.formatPath(path, append);
	      if (replace) {
	        location.replace(path);
	      } else {
	        location.hash = path;
	      }
	    };
	
	    HashHistory.prototype.formatPath = function formatPath(path, append) {
	      var isAbsoloute = path.charAt(0) === '/';
	      var prefix = '#' + (this.hashbang ? '!' : '');
	      return isAbsoloute ? prefix + path : prefix + resolvePath(location.hash.replace(/^#!?/, ''), path, append);
	    };
	
	    return HashHistory;
	  })();
	
	  var AbstractHistory = (function () {
	    function AbstractHistory(_ref) {
	      var onChange = _ref.onChange;
	      babelHelpers.classCallCheck(this, AbstractHistory);
	
	      this.onChange = onChange;
	      this.currentPath = '/';
	    }
	
	    AbstractHistory.prototype.start = function start() {
	      this.onChange('/');
	    };
	
	    AbstractHistory.prototype.stop = function stop() {
	      // noop
	    };
	
	    AbstractHistory.prototype.go = function go(path, replace, append) {
	      path = this.currentPath = this.formatPath(path, append);
	      this.onChange(path);
	    };
	
	    AbstractHistory.prototype.formatPath = function formatPath(path, append) {
	      return path.charAt(0) === '/' ? path : resolvePath(this.currentPath, path, append);
	    };
	
	    return AbstractHistory;
	  })();
	
	  /**
	   * Determine the reusability of an existing router view.
	   *
	   * @param {Directive} view
	   * @param {Object} handler
	   * @param {Transition} transition
	   */
	
	  function canReuse(view, handler, transition) {
	    var component = view.childVM;
	    if (!component || !handler) {
	      return false;
	    }
	    // important: check view.Component here because it may
	    // have been changed in activate hook
	    if (view.Component !== handler.component) {
	      return false;
	    }
	    var canReuseFn = getRouteConfig(component, 'canReuse');
	    return typeof canReuseFn === 'boolean' ? canReuseFn : canReuseFn ? canReuseFn.call(component, {
	      to: transition.to,
	      from: transition.from
	    }) : true; // defaults to true
	  }
	
	  /**
	   * Check if a component can deactivate.
	   *
	   * @param {Directive} view
	   * @param {Transition} transition
	   * @param {Function} next
	   */
	
	  function canDeactivate(view, transition, next) {
	    var fromComponent = view.childVM;
	    var hook = getRouteConfig(fromComponent, 'canDeactivate');
	    if (!hook) {
	      next();
	    } else {
	      transition.callHook(hook, fromComponent, next, {
	        expectBoolean: true
	      });
	    }
	  }
	
	  /**
	   * Check if a component can activate.
	   *
	   * @param {Object} handler
	   * @param {Transition} transition
	   * @param {Function} next
	   */
	
	  function canActivate(handler, transition, next) {
	    resolveAsyncComponent(handler, function (Component) {
	      // have to check due to async-ness
	      if (transition.aborted) {
	        return;
	      }
	      // determine if this component can be activated
	      var hook = getRouteConfig(Component, 'canActivate');
	      if (!hook) {
	        next();
	      } else {
	        transition.callHook(hook, null, next, {
	          expectBoolean: true
	        });
	      }
	    });
	  }
	
	  /**
	   * Call deactivate hooks for existing router-views.
	   *
	   * @param {Directive} view
	   * @param {Transition} transition
	   * @param {Function} next
	   */
	
	  function deactivate(view, transition, next) {
	    var component = view.childVM;
	    var hook = getRouteConfig(component, 'deactivate');
	    if (!hook) {
	      next();
	    } else {
	      transition.callHooks(hook, component, next);
	    }
	  }
	
	  /**
	   * Activate / switch component for a router-view.
	   *
	   * @param {Directive} view
	   * @param {Transition} transition
	   * @param {Number} depth
	   * @param {Function} [cb]
	   */
	
	  function activate(view, transition, depth, cb, reuse) {
	    var handler = transition.activateQueue[depth];
	    if (!handler) {
	      saveChildView(view);
	      if (view._bound) {
	        view.setComponent(null);
	      }
	      cb && cb();
	      return;
	    }
	
	    var Component = view.Component = handler.component;
	    var activateHook = getRouteConfig(Component, 'activate');
	    var dataHook = getRouteConfig(Component, 'data');
	    var waitForData = getRouteConfig(Component, 'waitForData');
	
	    view.depth = depth;
	    view.activated = false;
	
	    var component = undefined;
	    var loading = !!(dataHook && !waitForData);
	
	    // "reuse" is a flag passed down when the parent view is
	    // either reused via keep-alive or as a child of a kept-alive view.
	    // of course we can only reuse if the current kept-alive instance
	    // is of the correct type.
	    reuse = reuse && view.childVM && view.childVM.constructor === Component;
	
	    if (reuse) {
	      // just reuse
	      component = view.childVM;
	      component.$loadingRouteData = loading;
	    } else {
	      saveChildView(view);
	
	      // unbuild current component. this step also destroys
	      // and removes all nested child views.
	      view.unbuild(true);
	
	      // build the new component. this will also create the
	      // direct child view of the current one. it will register
	      // itself as view.childView.
	      component = view.build({
	        _meta: {
	          $loadingRouteData: loading
	        },
	        created: function created() {
	          this._routerView = view;
	        }
	      });
	
	      // handle keep-alive.
	      // when a kept-alive child vm is restored, we need to
	      // add its cached child views into the router's view list,
	      // and also properly update current view's child view.
	      if (view.keepAlive) {
	        component.$loadingRouteData = loading;
	        var cachedChildView = component._keepAliveRouterView;
	        if (cachedChildView) {
	          view.childView = cachedChildView;
	          component._keepAliveRouterView = null;
	        }
	      }
	    }
	
	    // cleanup the component in case the transition is aborted
	    // before the component is ever inserted.
	    var cleanup = function cleanup() {
	      component.$destroy();
	    };
	
	    // actually insert the component and trigger transition
	    var insert = function insert() {
	      if (reuse) {
	        cb && cb();
	        return;
	      }
	      var router = transition.router;
	      if (router._rendered || router._transitionOnLoad) {
	        view.transition(component);
	      } else {
	        // no transition on first render, manual transition
	        /* istanbul ignore if */
	        if (view.setCurrent) {
	          // 0.12 compat
	          view.setCurrent(component);
	        } else {
	          // 1.0
	          view.childVM = component;
	        }
	        component.$before(view.anchor, null, false);
	      }
	      cb && cb();
	    };
	
	    var afterData = function afterData() {
	      // activate the child view
	      if (view.childView) {
	        activate(view.childView, transition, depth + 1, null, reuse || view.keepAlive);
	      }
	      insert();
	    };
	
	    // called after activation hook is resolved
	    var afterActivate = function afterActivate() {
	      view.activated = true;
	      if (dataHook && waitForData) {
	        // wait until data loaded to insert
	        loadData(component, transition, dataHook, afterData, cleanup);
	      } else {
	        // load data and insert at the same time
	        if (dataHook) {
	          loadData(component, transition, dataHook);
	        }
	        afterData();
	      }
	    };
	
	    if (activateHook) {
	      transition.callHooks(activateHook, component, afterActivate, {
	        cleanup: cleanup,
	        postActivate: true
	      });
	    } else {
	      afterActivate();
	    }
	  }
	
	  /**
	   * Reuse a view, just reload data if necessary.
	   *
	   * @param {Directive} view
	   * @param {Transition} transition
	   */
	
	  function reuse(view, transition) {
	    var component = view.childVM;
	    var dataHook = getRouteConfig(component, 'data');
	    if (dataHook) {
	      loadData(component, transition, dataHook);
	    }
	  }
	
	  /**
	   * Asynchronously load and apply data to component.
	   *
	   * @param {Vue} component
	   * @param {Transition} transition
	   * @param {Function} hook
	   * @param {Function} cb
	   * @param {Function} cleanup
	   */
	
	  function loadData(component, transition, hook, cb, cleanup) {
	    component.$loadingRouteData = true;
	    transition.callHooks(hook, component, function () {
	      component.$loadingRouteData = false;
	      component.$emit('route-data-loaded', component);
	      cb && cb();
	    }, {
	      cleanup: cleanup,
	      postActivate: true,
	      processData: function processData(data) {
	        // handle promise sugar syntax
	        var promises = [];
	        if (isPlainObject(data)) {
	          Object.keys(data).forEach(function (key) {
	            var val = data[key];
	            if (isPromise(val)) {
	              promises.push(val.then(function (resolvedVal) {
	                component.$set(key, resolvedVal);
	              }));
	            } else {
	              component.$set(key, val);
	            }
	          });
	        }
	        if (promises.length) {
	          return promises[0].constructor.all(promises);
	        }
	      }
	    });
	  }
	
	  /**
	   * Save the child view for a kept-alive view so that
	   * we can restore it when it is switched back to.
	   *
	   * @param {Directive} view
	   */
	
	  function saveChildView(view) {
	    if (view.keepAlive && view.childVM && view.childView) {
	      view.childVM._keepAliveRouterView = view.childView;
	    }
	    view.childView = null;
	  }
	
	  /**
	   * Check plain object.
	   *
	   * @param {*} val
	   */
	
	  function isPlainObject(val) {
	    return Object.prototype.toString.call(val) === '[object Object]';
	  }
	
	  /**
	   * A RouteTransition object manages the pipeline of a
	   * router-view switching process. This is also the object
	   * passed into user route hooks.
	   *
	   * @param {Router} router
	   * @param {Route} to
	   * @param {Route} from
	   */
	
	  var RouteTransition = (function () {
	    function RouteTransition(router, to, from) {
	      babelHelpers.classCallCheck(this, RouteTransition);
	
	      this.router = router;
	      this.to = to;
	      this.from = from;
	      this.next = null;
	      this.aborted = false;
	      this.done = false;
	    }
	
	    /**
	     * Abort current transition and return to previous location.
	     */
	
	    RouteTransition.prototype.abort = function abort() {
	      if (!this.aborted) {
	        this.aborted = true;
	        // if the root path throws an error during validation
	        // on initial load, it gets caught in an infinite loop.
	        var abortingOnLoad = !this.from.path && this.to.path === '/';
	        if (!abortingOnLoad) {
	          this.router.replace(this.from.path || '/');
	        }
	      }
	    };
	
	    /**
	     * Abort current transition and redirect to a new location.
	     *
	     * @param {String} path
	     */
	
	    RouteTransition.prototype.redirect = function redirect(path) {
	      if (!this.aborted) {
	        this.aborted = true;
	        if (typeof path === 'string') {
	          path = mapParams(path, this.to.params, this.to.query);
	        } else {
	          path.params = path.params || this.to.params;
	          path.query = path.query || this.to.query;
	        }
	        this.router.replace(path);
	      }
	    };
	
	    /**
	     * A router view transition's pipeline can be described as
	     * follows, assuming we are transitioning from an existing
	     * <router-view> chain [Component A, Component B] to a new
	     * chain [Component A, Component C]:
	     *
	     *  A    A
	     *  | => |
	     *  B    C
	     *
	     * 1. Reusablity phase:
	     *   -> canReuse(A, A)
	     *   -> canReuse(B, C)
	     *   -> determine new queues:
	     *      - deactivation: [B]
	     *      - activation: [C]
	     *
	     * 2. Validation phase:
	     *   -> canDeactivate(B)
	     *   -> canActivate(C)
	     *
	     * 3. Activation phase:
	     *   -> deactivate(B)
	     *   -> activate(C)
	     *
	     * Each of these steps can be asynchronous, and any
	     * step can potentially abort the transition.
	     *
	     * @param {Function} cb
	     */
	
	    RouteTransition.prototype.start = function start(cb) {
	      var transition = this;
	
	      // determine the queue of views to deactivate
	      var deactivateQueue = [];
	      var view = this.router._rootView;
	      while (view) {
	        deactivateQueue.unshift(view);
	        view = view.childView;
	      }
	      var reverseDeactivateQueue = deactivateQueue.slice().reverse();
	
	      // determine the queue of route handlers to activate
	      var activateQueue = this.activateQueue = toArray(this.to.matched).map(function (match) {
	        return match.handler;
	      });
	
	      // 1. Reusability phase
	      var i = undefined,
	          reuseQueue = undefined;
	      for (i = 0; i < reverseDeactivateQueue.length; i++) {
	        if (!canReuse(reverseDeactivateQueue[i], activateQueue[i], transition)) {
	          break;
	        }
	      }
	      if (i > 0) {
	        reuseQueue = reverseDeactivateQueue.slice(0, i);
	        deactivateQueue = reverseDeactivateQueue.slice(i).reverse();
	        activateQueue = activateQueue.slice(i);
	      }
	
	      // 2. Validation phase
	      transition.runQueue(deactivateQueue, canDeactivate, function () {
	        transition.runQueue(activateQueue, canActivate, function () {
	          transition.runQueue(deactivateQueue, deactivate, function () {
	            // 3. Activation phase
	
	            // Update router current route
	            transition.router._onTransitionValidated(transition);
	
	            // trigger reuse for all reused views
	            reuseQueue && reuseQueue.forEach(function (view) {
	              return reuse(view, transition);
	            });
	
	            // the root of the chain that needs to be replaced
	            // is the top-most non-reusable view.
	            if (deactivateQueue.length) {
	              var _view = deactivateQueue[deactivateQueue.length - 1];
	              var depth = reuseQueue ? reuseQueue.length : 0;
	              activate(_view, transition, depth, cb);
	            } else {
	              cb();
	            }
	          });
	        });
	      });
	    };
	
	    /**
	     * Asynchronously and sequentially apply a function to a
	     * queue.
	     *
	     * @param {Array} queue
	     * @param {Function} fn
	     * @param {Function} cb
	     */
	
	    RouteTransition.prototype.runQueue = function runQueue(queue, fn, cb) {
	      var transition = this;
	      step(0);
	      function step(index) {
	        if (index >= queue.length) {
	          cb();
	        } else {
	          fn(queue[index], transition, function () {
	            step(index + 1);
	          });
	        }
	      }
	    };
	
	    /**
	     * Call a user provided route transition hook and handle
	     * the response (e.g. if the user returns a promise).
	     *
	     * If the user neither expects an argument nor returns a
	     * promise, the hook is assumed to be synchronous.
	     *
	     * @param {Function} hook
	     * @param {*} [context]
	     * @param {Function} [cb]
	     * @param {Object} [options]
	     *                 - {Boolean} expectBoolean
	     *                 - {Boolean} postActive
	     *                 - {Function} processData
	     *                 - {Function} cleanup
	     */
	
	    RouteTransition.prototype.callHook = function callHook(hook, context, cb) {
	      var _ref = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	      var _ref$expectBoolean = _ref.expectBoolean;
	      var expectBoolean = _ref$expectBoolean === undefined ? false : _ref$expectBoolean;
	      var _ref$postActivate = _ref.postActivate;
	      var postActivate = _ref$postActivate === undefined ? false : _ref$postActivate;
	      var processData = _ref.processData;
	      var cleanup = _ref.cleanup;
	
	      var transition = this;
	      var nextCalled = false;
	
	      // abort the transition
	      var abort = function abort() {
	        cleanup && cleanup();
	        transition.abort();
	      };
	
	      // handle errors
	      var onError = function onError(err) {
	        postActivate ? next() : abort();
	        if (err && !transition.router._suppress) {
	          warn$1('Uncaught error during transition: ');
	          throw err instanceof Error ? err : new Error(err);
	        }
	      };
	
	      // since promise swallows errors, we have to
	      // throw it in the next tick...
	      var onPromiseError = function onPromiseError(err) {
	        try {
	          onError(err);
	        } catch (e) {
	          setTimeout(function () {
	            throw e;
	          }, 0);
	        }
	      };
	
	      // advance the transition to the next step
	      var next = function next() {
	        if (nextCalled) {
	          warn$1('transition.next() should be called only once.');
	          return;
	        }
	        nextCalled = true;
	        if (transition.aborted) {
	          cleanup && cleanup();
	          return;
	        }
	        cb && cb();
	      };
	
	      var nextWithBoolean = function nextWithBoolean(res) {
	        if (typeof res === 'boolean') {
	          res ? next() : abort();
	        } else if (isPromise(res)) {
	          res.then(function (ok) {
	            ok ? next() : abort();
	          }, onPromiseError);
	        } else if (!hook.length) {
	          next();
	        }
	      };
	
	      var nextWithData = function nextWithData(data) {
	        var res = undefined;
	        try {
	          res = processData(data);
	        } catch (err) {
	          return onError(err);
	        }
	        if (isPromise(res)) {
	          res.then(next, onPromiseError);
	        } else {
	          next();
	        }
	      };
	
	      // expose a clone of the transition object, so that each
	      // hook gets a clean copy and prevent the user from
	      // messing with the internals.
	      var exposed = {
	        to: transition.to,
	        from: transition.from,
	        abort: abort,
	        next: processData ? nextWithData : next,
	        redirect: function redirect() {
	          transition.redirect.apply(transition, arguments);
	        }
	      };
	
	      // actually call the hook
	      var res = undefined;
	      try {
	        res = hook.call(context, exposed);
	      } catch (err) {
	        return onError(err);
	      }
	
	      if (expectBoolean) {
	        // boolean hooks
	        nextWithBoolean(res);
	      } else if (isPromise(res)) {
	        // promise
	        if (processData) {
	          res.then(nextWithData, onPromiseError);
	        } else {
	          res.then(next, onPromiseError);
	        }
	      } else if (processData && isPlainOjbect(res)) {
	        // data promise sugar
	        nextWithData(res);
	      } else if (!hook.length) {
	        next();
	      }
	    };
	
	    /**
	     * Call a single hook or an array of async hooks in series.
	     *
	     * @param {Array} hooks
	     * @param {*} context
	     * @param {Function} cb
	     * @param {Object} [options]
	     */
	
	    RouteTransition.prototype.callHooks = function callHooks(hooks, context, cb, options) {
	      var _this = this;
	
	      if (Array.isArray(hooks)) {
	        this.runQueue(hooks, function (hook, _, next) {
	          if (!_this.aborted) {
	            _this.callHook(hook, context, next, options);
	          }
	        }, cb);
	      } else {
	        this.callHook(hooks, context, cb, options);
	      }
	    };
	
	    return RouteTransition;
	  })();
	
	  function isPlainOjbect(val) {
	    return Object.prototype.toString.call(val) === '[object Object]';
	  }
	
	  function toArray(val) {
	    return val ? Array.prototype.slice.call(val) : [];
	  }
	
	  var internalKeysRE = /^(component|subRoutes|fullPath)$/;
	
	  /**
	   * Route Context Object
	   *
	   * @param {String} path
	   * @param {Router} router
	   */
	
	  var Route = function Route(path, router) {
	    var _this = this;
	
	    babelHelpers.classCallCheck(this, Route);
	
	    var matched = router._recognizer.recognize(path);
	    if (matched) {
	      // copy all custom fields from route configs
	      [].forEach.call(matched, function (match) {
	        for (var key in match.handler) {
	          if (!internalKeysRE.test(key)) {
	            _this[key] = match.handler[key];
	          }
	        }
	      });
	      // set query and params
	      this.query = matched.queryParams;
	      this.params = [].reduce.call(matched, function (prev, cur) {
	        if (cur.params) {
	          for (var key in cur.params) {
	            prev[key] = cur.params[key];
	          }
	        }
	        return prev;
	      }, {});
	    }
	    // expose path and router
	    this.path = path;
	    // for internal use
	    this.matched = matched || router._notFoundHandler;
	    // internal reference to router
	    Object.defineProperty(this, 'router', {
	      enumerable: false,
	      value: router
	    });
	    // Important: freeze self to prevent observation
	    Object.freeze(this);
	  };
	
	  function applyOverride (Vue) {
	    var _Vue$util = Vue.util;
	    var extend = _Vue$util.extend;
	    var isArray = _Vue$util.isArray;
	    var defineReactive = _Vue$util.defineReactive;
	
	    // override Vue's init and destroy process to keep track of router instances
	    var init = Vue.prototype._init;
	    Vue.prototype._init = function (options) {
	      options = options || {};
	      var root = options._parent || options.parent || this;
	      var router = root.$router;
	      var route = root.$route;
	      if (router) {
	        // expose router
	        this.$router = router;
	        router._children.push(this);
	        /* istanbul ignore if */
	        if (this._defineMeta) {
	          // 0.12
	          this._defineMeta('$route', route);
	        } else {
	          // 1.0
	          defineReactive(this, '$route', route);
	        }
	      }
	      init.call(this, options);
	    };
	
	    var destroy = Vue.prototype._destroy;
	    Vue.prototype._destroy = function () {
	      if (!this._isBeingDestroyed && this.$router) {
	        this.$router._children.$remove(this);
	      }
	      destroy.apply(this, arguments);
	    };
	
	    // 1.0 only: enable route mixins
	    var strats = Vue.config.optionMergeStrategies;
	    var hooksToMergeRE = /^(data|activate|deactivate)$/;
	
	    if (strats) {
	      strats.route = function (parentVal, childVal) {
	        if (!childVal) return parentVal;
	        if (!parentVal) return childVal;
	        var ret = {};
	        extend(ret, parentVal);
	        for (var key in childVal) {
	          var a = ret[key];
	          var b = childVal[key];
	          // for data, activate and deactivate, we need to merge them into
	          // arrays similar to lifecycle hooks.
	          if (a && hooksToMergeRE.test(key)) {
	            ret[key] = (isArray(a) ? a : [a]).concat(b);
	          } else {
	            ret[key] = b;
	          }
	        }
	        return ret;
	      };
	    }
	  }
	
	  function View (Vue) {
	
	    var _ = Vue.util;
	    var componentDef =
	    // 0.12
	    Vue.directive('_component') ||
	    // 1.0
	    Vue.internalDirectives.component;
	    // <router-view> extends the internal component directive
	    var viewDef = _.extend({}, componentDef);
	
	    // with some overrides
	    _.extend(viewDef, {
	
	      _isRouterView: true,
	
	      bind: function bind() {
	        var route = this.vm.$route;
	        /* istanbul ignore if */
	        if (!route) {
	          warn$1('<router-view> can only be used inside a ' + 'router-enabled app.');
	          return;
	        }
	        // force dynamic directive so v-component doesn't
	        // attempt to build right now
	        this._isDynamicLiteral = true;
	        // finally, init by delegating to v-component
	        componentDef.bind.call(this);
	
	        // locate the parent view
	        var parentView = undefined;
	        var parent = this.vm;
	        while (parent) {
	          if (parent._routerView) {
	            parentView = parent._routerView;
	            break;
	          }
	          parent = parent.$parent;
	        }
	        if (parentView) {
	          // register self as a child of the parent view,
	          // instead of activating now. This is so that the
	          // child's activate hook is called after the
	          // parent's has resolved.
	          this.parentView = parentView;
	          parentView.childView = this;
	        } else {
	          // this is the root view!
	          var router = route.router;
	          router._rootView = this;
	        }
	
	        // handle late-rendered view
	        // two possibilities:
	        // 1. root view rendered after transition has been
	        //    validated;
	        // 2. child view rendered after parent view has been
	        //    activated.
	        var transition = route.router._currentTransition;
	        if (!parentView && transition.done || parentView && parentView.activated) {
	          var depth = parentView ? parentView.depth + 1 : 0;
	          activate(this, transition, depth);
	        }
	      },
	
	      unbind: function unbind() {
	        if (this.parentView) {
	          this.parentView.childView = null;
	        }
	        componentDef.unbind.call(this);
	      }
	    });
	
	    Vue.elementDirective('router-view', viewDef);
	  }
	
	  var trailingSlashRE = /\/$/;
	  var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
	  var queryStringRE = /\?.*$/;
	
	  // install v-link, which provides navigation support for
	  // HTML5 history mode
	  function Link (Vue) {
	    var _Vue$util = Vue.util;
	    var _bind = _Vue$util.bind;
	    var isObject = _Vue$util.isObject;
	    var addClass = _Vue$util.addClass;
	    var removeClass = _Vue$util.removeClass;
	
	    var onPriority = Vue.directive('on').priority;
	    var LINK_UPDATE = '__vue-router-link-update__';
	
	    var activeId = 0;
	
	    Vue.directive('link-active', {
	      priority: 9999,
	      bind: function bind() {
	        var _this = this;
	
	        var id = String(activeId++);
	        // collect v-links contained within this element.
	        // we need do this here before the parent-child relationship
	        // gets messed up by terminal directives (if, for, components)
	        var childLinks = this.el.querySelectorAll('[v-link]');
	        for (var i = 0, l = childLinks.length; i < l; i++) {
	          var link = childLinks[i];
	          var existingId = link.getAttribute(LINK_UPDATE);
	          var value = existingId ? existingId + ',' + id : id;
	          // leave a mark on the link element which can be persisted
	          // through fragment clones.
	          link.setAttribute(LINK_UPDATE, value);
	        }
	        this.vm.$on(LINK_UPDATE, this.cb = function (link, path) {
	          if (link.activeIds.indexOf(id) > -1) {
	            link.updateClasses(path, _this.el);
	          }
	        });
	      },
	      unbind: function unbind() {
	        this.vm.$off(LINK_UPDATE, this.cb);
	      }
	    });
	
	    Vue.directive('link', {
	      priority: onPriority - 2,
	
	      bind: function bind() {
	        var vm = this.vm;
	        /* istanbul ignore if */
	        if (!vm.$route) {
	          warn$1('v-link can only be used inside a router-enabled app.');
	          return;
	        }
	        this.router = vm.$route.router;
	        // update things when the route changes
	        this.unwatch = vm.$watch('$route', _bind(this.onRouteUpdate, this));
	        // check v-link-active ids
	        var activeIds = this.el.getAttribute(LINK_UPDATE);
	        if (activeIds) {
	          this.el.removeAttribute(LINK_UPDATE);
	          this.activeIds = activeIds.split(',');
	        }
	        // no need to handle click if link expects to be opened
	        // in a new window/tab.
	        /* istanbul ignore if */
	        if (this.el.tagName === 'A' && this.el.getAttribute('target') === '_blank') {
	          return;
	        }
	        // handle click
	        this.handler = _bind(this.onClick, this);
	        this.el.addEventListener('click', this.handler);
	      },
	
	      update: function update(target) {
	        this.target = target;
	        if (isObject(target)) {
	          this.append = target.append;
	          this.exact = target.exact;
	          this.prevActiveClass = this.activeClass;
	          this.activeClass = target.activeClass;
	        }
	        this.onRouteUpdate(this.vm.$route);
	      },
	
	      onClick: function onClick(e) {
	        // don't redirect with control keys
	        /* istanbul ignore if */
	        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
	        // don't redirect when preventDefault called
	        /* istanbul ignore if */
	        if (e.defaultPrevented) return;
	        // don't redirect on right click
	        /* istanbul ignore if */
	        if (e.button !== 0) return;
	
	        var target = this.target;
	        if (target) {
	          // v-link with expression, just go
	          e.preventDefault();
	          this.router.go(target);
	        } else {
	          // no expression, delegate for an <a> inside
	          var el = e.target;
	          while (el.tagName !== 'A' && el !== this.el) {
	            el = el.parentNode;
	          }
	          if (el.tagName === 'A' && sameOrigin(el)) {
	            e.preventDefault();
	            var path = el.pathname;
	            if (this.router.history.root) {
	              path = path.replace(this.router.history.rootRE, '');
	            }
	            this.router.go({
	              path: path,
	              replace: target && target.replace,
	              append: target && target.append
	            });
	          }
	        }
	      },
	
	      onRouteUpdate: function onRouteUpdate(route) {
	        // router.stringifyPath is dependent on current route
	        // and needs to be called again whenver route changes.
	        var newPath = this.router.stringifyPath(this.target);
	        if (this.path !== newPath) {
	          this.path = newPath;
	          this.updateActiveMatch();
	          this.updateHref();
	        }
	        if (this.activeIds) {
	          this.vm.$emit(LINK_UPDATE, this, route.path);
	        } else {
	          this.updateClasses(route.path, this.el);
	        }
	      },
	
	      updateActiveMatch: function updateActiveMatch() {
	        this.activeRE = this.path && !this.exact ? new RegExp('^' + this.path.replace(/\/$/, '').replace(queryStringRE, '').replace(regexEscapeRE, '\\$&') + '(\\/|$)') : null;
	      },
	
	      updateHref: function updateHref() {
	        if (this.el.tagName !== 'A') {
	          return;
	        }
	        var path = this.path;
	        var router = this.router;
	        var isAbsolute = path.charAt(0) === '/';
	        // do not format non-hash relative paths
	        var href = path && (router.mode === 'hash' || isAbsolute) ? router.history.formatPath(path, this.append) : path;
	        if (href) {
	          this.el.href = href;
	        } else {
	          this.el.removeAttribute('href');
	        }
	      },
	
	      updateClasses: function updateClasses(path, el) {
	        var activeClass = this.activeClass || this.router._linkActiveClass;
	        // clear old class
	        if (this.prevActiveClass && this.prevActiveClass !== activeClass) {
	          toggleClasses(el, this.prevActiveClass, removeClass);
	        }
	        // remove query string before matching
	        var dest = this.path.replace(queryStringRE, '');
	        path = path.replace(queryStringRE, '');
	        // add new class
	        if (this.exact) {
	          if (dest === path ||
	          // also allow additional trailing slash
	          dest.charAt(dest.length - 1) !== '/' && dest === path.replace(trailingSlashRE, '')) {
	            toggleClasses(el, activeClass, addClass);
	          } else {
	            toggleClasses(el, activeClass, removeClass);
	          }
	        } else {
	          if (this.activeRE && this.activeRE.test(path)) {
	            toggleClasses(el, activeClass, addClass);
	          } else {
	            toggleClasses(el, activeClass, removeClass);
	          }
	        }
	      },
	
	      unbind: function unbind() {
	        this.el.removeEventListener('click', this.handler);
	        this.unwatch && this.unwatch();
	      }
	    });
	
	    function sameOrigin(link) {
	      return link.protocol === location.protocol && link.hostname === location.hostname && link.port === location.port;
	    }
	
	    // this function is copied from v-bind:class implementation until
	    // we properly expose it...
	    function toggleClasses(el, key, fn) {
	      key = key.trim();
	      if (key.indexOf(' ') === -1) {
	        fn(el, key);
	        return;
	      }
	      var keys = key.split(/\s+/);
	      for (var i = 0, l = keys.length; i < l; i++) {
	        fn(el, keys[i]);
	      }
	    }
	  }
	
	  var historyBackends = {
	    abstract: AbstractHistory,
	    hash: HashHistory,
	    html5: HTML5History
	  };
	
	  // late bind during install
	  var Vue = undefined;
	
	  /**
	   * Router constructor
	   *
	   * @param {Object} [options]
	   */
	
	  var Router = (function () {
	    function Router() {
	      var _this = this;
	
	      var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      var _ref$hashbang = _ref.hashbang;
	      var hashbang = _ref$hashbang === undefined ? true : _ref$hashbang;
	      var _ref$abstract = _ref.abstract;
	      var abstract = _ref$abstract === undefined ? false : _ref$abstract;
	      var _ref$history = _ref.history;
	      var history = _ref$history === undefined ? false : _ref$history;
	      var _ref$saveScrollPosition = _ref.saveScrollPosition;
	      var saveScrollPosition = _ref$saveScrollPosition === undefined ? false : _ref$saveScrollPosition;
	      var _ref$transitionOnLoad = _ref.transitionOnLoad;
	      var transitionOnLoad = _ref$transitionOnLoad === undefined ? false : _ref$transitionOnLoad;
	      var _ref$suppressTransitionError = _ref.suppressTransitionError;
	      var suppressTransitionError = _ref$suppressTransitionError === undefined ? false : _ref$suppressTransitionError;
	      var _ref$root = _ref.root;
	      var root = _ref$root === undefined ? null : _ref$root;
	      var _ref$linkActiveClass = _ref.linkActiveClass;
	      var linkActiveClass = _ref$linkActiveClass === undefined ? 'v-link-active' : _ref$linkActiveClass;
	      babelHelpers.classCallCheck(this, Router);
	
	      /* istanbul ignore if */
	      if (!Router.installed) {
	        throw new Error('Please install the Router with Vue.use() before ' + 'creating an instance.');
	      }
	
	      // Vue instances
	      this.app = null;
	      this._children = [];
	
	      // route recognizer
	      this._recognizer = new RouteRecognizer();
	      this._guardRecognizer = new RouteRecognizer();
	
	      // state
	      this._started = false;
	      this._startCb = null;
	      this._currentRoute = {};
	      this._currentTransition = null;
	      this._previousTransition = null;
	      this._notFoundHandler = null;
	      this._notFoundRedirect = null;
	      this._beforeEachHooks = [];
	      this._afterEachHooks = [];
	
	      // trigger transition on initial render?
	      this._rendered = false;
	      this._transitionOnLoad = transitionOnLoad;
	
	      // history mode
	      this._root = root;
	      this._abstract = abstract;
	      this._hashbang = hashbang;
	
	      // check if HTML5 history is available
	      var hasPushState = typeof window !== 'undefined' && window.history && window.history.pushState;
	      this._history = history && hasPushState;
	      this._historyFallback = history && !hasPushState;
	
	      // create history object
	      var inBrowser = Vue.util.inBrowser;
	      this.mode = !inBrowser || this._abstract ? 'abstract' : this._history ? 'html5' : 'hash';
	
	      var History = historyBackends[this.mode];
	      this.history = new History({
	        root: root,
	        hashbang: this._hashbang,
	        onChange: function onChange(path, state, anchor) {
	          _this._match(path, state, anchor);
	        }
	      });
	
	      // other options
	      this._saveScrollPosition = saveScrollPosition;
	      this._linkActiveClass = linkActiveClass;
	      this._suppress = suppressTransitionError;
	    }
	
	    /**
	     * Allow directly passing components to a route
	     * definition.
	     *
	     * @param {String} path
	     * @param {Object} handler
	     */
	
	    // API ===================================================
	
	    /**
	    * Register a map of top-level paths.
	    *
	    * @param {Object} map
	    */
	
	    Router.prototype.map = function map(_map) {
	      for (var route in _map) {
	        this.on(route, _map[route]);
	      }
	      return this;
	    };
	
	    /**
	     * Register a single root-level path
	     *
	     * @param {String} rootPath
	     * @param {Object} handler
	     *                 - {String} component
	     *                 - {Object} [subRoutes]
	     *                 - {Boolean} [forceRefresh]
	     *                 - {Function} [before]
	     *                 - {Function} [after]
	     */
	
	    Router.prototype.on = function on(rootPath, handler) {
	      if (rootPath === '*') {
	        this._notFound(handler);
	      } else {
	        this._addRoute(rootPath, handler, []);
	      }
	      return this;
	    };
	
	    /**
	     * Set redirects.
	     *
	     * @param {Object} map
	     */
	
	    Router.prototype.redirect = function redirect(map) {
	      for (var path in map) {
	        this._addRedirect(path, map[path]);
	      }
	      return this;
	    };
	
	    /**
	     * Set aliases.
	     *
	     * @param {Object} map
	     */
	
	    Router.prototype.alias = function alias(map) {
	      for (var path in map) {
	        this._addAlias(path, map[path]);
	      }
	      return this;
	    };
	
	    /**
	     * Set global before hook.
	     *
	     * @param {Function} fn
	     */
	
	    Router.prototype.beforeEach = function beforeEach(fn) {
	      this._beforeEachHooks.push(fn);
	      return this;
	    };
	
	    /**
	     * Set global after hook.
	     *
	     * @param {Function} fn
	     */
	
	    Router.prototype.afterEach = function afterEach(fn) {
	      this._afterEachHooks.push(fn);
	      return this;
	    };
	
	    /**
	     * Navigate to a given path.
	     * The path can be an object describing a named path in
	     * the format of { name: '...', params: {}, query: {}}
	     * The path is assumed to be already decoded, and will
	     * be resolved against root (if provided)
	     *
	     * @param {String|Object} path
	     * @param {Boolean} [replace]
	     */
	
	    Router.prototype.go = function go(path) {
	      var replace = false;
	      var append = false;
	      if (Vue.util.isObject(path)) {
	        replace = path.replace;
	        append = path.append;
	      }
	      path = this.stringifyPath(path);
	      if (path) {
	        this.history.go(path, replace, append);
	      }
	    };
	
	    /**
	     * Short hand for replacing current path
	     *
	     * @param {String} path
	     */
	
	    Router.prototype.replace = function replace(path) {
	      if (typeof path === 'string') {
	        path = { path: path };
	      }
	      path.replace = true;
	      this.go(path);
	    };
	
	    /**
	     * Start the router.
	     *
	     * @param {VueConstructor} App
	     * @param {String|Element} container
	     * @param {Function} [cb]
	     */
	
	    Router.prototype.start = function start(App, container, cb) {
	      /* istanbul ignore if */
	      if (this._started) {
	        warn$1('already started.');
	        return;
	      }
	      this._started = true;
	      this._startCb = cb;
	      if (!this.app) {
	        /* istanbul ignore if */
	        if (!App || !container) {
	          throw new Error('Must start vue-router with a component and a ' + 'root container.');
	        }
	        /* istanbul ignore if */
	        if (App instanceof Vue) {
	          throw new Error('Must start vue-router with a component, not a ' + 'Vue instance.');
	        }
	        this._appContainer = container;
	        var Ctor = this._appConstructor = typeof App === 'function' ? App : Vue.extend(App);
	        // give it a name for better debugging
	        Ctor.options.name = Ctor.options.name || 'RouterApp';
	      }
	
	      // handle history fallback in browsers that do not
	      // support HTML5 history API
	      if (this._historyFallback) {
	        var _location = window.location;
	        var _history = new HTML5History({ root: this._root });
	        var path = _history.root ? _location.pathname.replace(_history.rootRE, '') : _location.pathname;
	        if (path && path !== '/') {
	          _location.assign((_history.root || '') + '/' + this.history.formatPath(path) + _location.search);
	          return;
	        }
	      }
	
	      this.history.start();
	    };
	
	    /**
	     * Stop listening to route changes.
	     */
	
	    Router.prototype.stop = function stop() {
	      this.history.stop();
	      this._started = false;
	    };
	
	    /**
	     * Normalize named route object / string paths into
	     * a string.
	     *
	     * @param {Object|String|Number} path
	     * @return {String}
	     */
	
	    Router.prototype.stringifyPath = function stringifyPath(path) {
	      var generatedPath = '';
	      if (path && typeof path === 'object') {
	        if (path.name) {
	          var extend = Vue.util.extend;
	          var currentParams = this._currentTransition && this._currentTransition.to.params;
	          var targetParams = path.params || {};
	          var params = currentParams ? extend(extend({}, currentParams), targetParams) : targetParams;
	          generatedPath = encodeURI(this._recognizer.generate(path.name, params));
	        } else if (path.path) {
	          generatedPath = encodeURI(path.path);
	        }
	        if (path.query) {
	          // note: the generated query string is pre-URL-encoded by the recognizer
	          var query = this._recognizer.generateQueryString(path.query);
	          if (generatedPath.indexOf('?') > -1) {
	            generatedPath += '&' + query.slice(1);
	          } else {
	            generatedPath += query;
	          }
	        }
	      } else {
	        generatedPath = encodeURI(path ? path + '' : '');
	      }
	      return generatedPath;
	    };
	
	    // Internal methods ======================================
	
	    /**
	    * Add a route containing a list of segments to the internal
	    * route recognizer. Will be called recursively to add all
	    * possible sub-routes.
	    *
	    * @param {String} path
	    * @param {Object} handler
	    * @param {Array} segments
	    */
	
	    Router.prototype._addRoute = function _addRoute(path, handler, segments) {
	      guardComponent(path, handler);
	      handler.path = path;
	      handler.fullPath = (segments.reduce(function (path, segment) {
	        return path + segment.path;
	      }, '') + path).replace('//', '/');
	      segments.push({
	        path: path,
	        handler: handler
	      });
	      this._recognizer.add(segments, {
	        as: handler.name
	      });
	      // add sub routes
	      if (handler.subRoutes) {
	        for (var subPath in handler.subRoutes) {
	          // recursively walk all sub routes
	          this._addRoute(subPath, handler.subRoutes[subPath],
	          // pass a copy in recursion to avoid mutating
	          // across branches
	          segments.slice());
	        }
	      }
	    };
	
	    /**
	     * Set the notFound route handler.
	     *
	     * @param {Object} handler
	     */
	
	    Router.prototype._notFound = function _notFound(handler) {
	      guardComponent('*', handler);
	      this._notFoundHandler = [{ handler: handler }];
	    };
	
	    /**
	     * Add a redirect record.
	     *
	     * @param {String} path
	     * @param {String} redirectPath
	     */
	
	    Router.prototype._addRedirect = function _addRedirect(path, redirectPath) {
	      if (path === '*') {
	        this._notFoundRedirect = redirectPath;
	      } else {
	        this._addGuard(path, redirectPath, this.replace);
	      }
	    };
	
	    /**
	     * Add an alias record.
	     *
	     * @param {String} path
	     * @param {String} aliasPath
	     */
	
	    Router.prototype._addAlias = function _addAlias(path, aliasPath) {
	      this._addGuard(path, aliasPath, this._match);
	    };
	
	    /**
	     * Add a path guard.
	     *
	     * @param {String} path
	     * @param {String} mappedPath
	     * @param {Function} handler
	     */
	
	    Router.prototype._addGuard = function _addGuard(path, mappedPath, _handler) {
	      var _this2 = this;
	
	      this._guardRecognizer.add([{
	        path: path,
	        handler: function handler(match, query) {
	          var realPath = mapParams(mappedPath, match.params, query);
	          _handler.call(_this2, realPath);
	        }
	      }]);
	    };
	
	    /**
	     * Check if a path matches any redirect records.
	     *
	     * @param {String} path
	     * @return {Boolean} - if true, will skip normal match.
	     */
	
	    Router.prototype._checkGuard = function _checkGuard(path) {
	      var matched = this._guardRecognizer.recognize(path, true);
	      if (matched) {
	        matched[0].handler(matched[0], matched.queryParams);
	        return true;
	      } else if (this._notFoundRedirect) {
	        matched = this._recognizer.recognize(path);
	        if (!matched) {
	          this.replace(this._notFoundRedirect);
	          return true;
	        }
	      }
	    };
	
	    /**
	     * Match a URL path and set the route context on vm,
	     * triggering view updates.
	     *
	     * @param {String} path
	     * @param {Object} [state]
	     * @param {String} [anchor]
	     */
	
	    Router.prototype._match = function _match(path, state, anchor) {
	      var _this3 = this;
	
	      if (this._checkGuard(path)) {
	        return;
	      }
	
	      var currentRoute = this._currentRoute;
	      var currentTransition = this._currentTransition;
	
	      if (currentTransition) {
	        if (currentTransition.to.path === path) {
	          // do nothing if we have an active transition going to the same path
	          return;
	        } else if (currentRoute.path === path) {
	          // We are going to the same path, but we also have an ongoing but
	          // not-yet-validated transition. Abort that transition and reset to
	          // prev transition.
	          currentTransition.aborted = true;
	          this._currentTransition = this._prevTransition;
	          return;
	        } else {
	          // going to a totally different path. abort ongoing transition.
	          currentTransition.aborted = true;
	        }
	      }
	
	      // construct new route and transition context
	      var route = new Route(path, this);
	      var transition = new RouteTransition(this, route, currentRoute);
	
	      // current transition is updated right now.
	      // however, current route will only be updated after the transition has
	      // been validated.
	      this._prevTransition = currentTransition;
	      this._currentTransition = transition;
	
	      if (!this.app) {
	        (function () {
	          // initial render
	          var router = _this3;
	          _this3.app = new _this3._appConstructor({
	            el: _this3._appContainer,
	            created: function created() {
	              this.$router = router;
	            },
	            _meta: {
	              $route: route
	            }
	          });
	        })();
	      }
	
	      // check global before hook
	      var beforeHooks = this._beforeEachHooks;
	      var startTransition = function startTransition() {
	        transition.start(function () {
	          _this3._postTransition(route, state, anchor);
	        });
	      };
	
	      if (beforeHooks.length) {
	        transition.runQueue(beforeHooks, function (hook, _, next) {
	          if (transition === _this3._currentTransition) {
	            transition.callHook(hook, null, next, {
	              expectBoolean: true
	            });
	          }
	        }, startTransition);
	      } else {
	        startTransition();
	      }
	
	      if (!this._rendered && this._startCb) {
	        this._startCb.call(null);
	      }
	
	      // HACK:
	      // set rendered to true after the transition start, so
	      // that components that are acitvated synchronously know
	      // whether it is the initial render.
	      this._rendered = true;
	    };
	
	    /**
	     * Set current to the new transition.
	     * This is called by the transition object when the
	     * validation of a route has succeeded.
	     *
	     * @param {Transition} transition
	     */
	
	    Router.prototype._onTransitionValidated = function _onTransitionValidated(transition) {
	      // set current route
	      var route = this._currentRoute = transition.to;
	      // update route context for all children
	      if (this.app.$route !== route) {
	        this.app.$route = route;
	        this._children.forEach(function (child) {
	          child.$route = route;
	        });
	      }
	      // call global after hook
	      if (this._afterEachHooks.length) {
	        this._afterEachHooks.forEach(function (hook) {
	          return hook.call(null, {
	            to: transition.to,
	            from: transition.from
	          });
	        });
	      }
	      this._currentTransition.done = true;
	    };
	
	    /**
	     * Handle stuff after the transition.
	     *
	     * @param {Route} route
	     * @param {Object} [state]
	     * @param {String} [anchor]
	     */
	
	    Router.prototype._postTransition = function _postTransition(route, state, anchor) {
	      // handle scroll positions
	      // saved scroll positions take priority
	      // then we check if the path has an anchor
	      var pos = state && state.pos;
	      if (pos && this._saveScrollPosition) {
	        Vue.nextTick(function () {
	          window.scrollTo(pos.x, pos.y);
	        });
	      } else if (anchor) {
	        Vue.nextTick(function () {
	          var el = document.getElementById(anchor.slice(1));
	          if (el) {
	            window.scrollTo(window.scrollX, el.offsetTop);
	          }
	        });
	      }
	    };
	
	    return Router;
	  })();
	
	  function guardComponent(path, handler) {
	    var comp = handler.component;
	    if (Vue.util.isPlainObject(comp)) {
	      comp = handler.component = Vue.extend(comp);
	    }
	    /* istanbul ignore if */
	    if (typeof comp !== 'function') {
	      handler.component = null;
	      warn$1('invalid component for route "' + path + '".');
	    }
	  }
	
	  /* Installation */
	
	  Router.installed = false;
	
	  /**
	   * Installation interface.
	   * Install the necessary directives.
	   */
	
	  Router.install = function (externalVue) {
	    /* istanbul ignore if */
	    if (Router.installed) {
	      warn$1('already installed.');
	      return;
	    }
	    Vue = externalVue;
	    applyOverride(Vue);
	    View(Vue);
	    Link(Vue);
	    exports$1.Vue = Vue;
	    Router.installed = true;
	  };
	
	  // auto install
	  /* istanbul ignore if */
	  if (typeof window !== 'undefined' && window.Vue) {
	    window.Vue.use(Router);
	  }
	
	  return Router;
	
	}));

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	;(function () {
	
	  var vSortable = {}
	  var Sortable =  true
	      ? __webpack_require__(609)
	      : window.Sortable
	
	  if (!Sortable) {
	    throw new Error('[vue-sortable] cannot locate Sortable.js.')
	  }
	
	  // exposed global options
	  vSortable.config = {}
	
	  vSortable.install = function (Vue) {
	    Vue.directive('sortable', function (options) {
	      options = options || {}
	
	      var sortable = new Sortable(this.el, options)
	
	      if (this.arg && !this.vm.sortable) {
	        this.vm.sortable = {}
	      }
	
	      //  Throw an error if the given ID is not unique
	      if (this.arg && this.vm.sortable[this.arg]) {
	        console.warn('[vue-sortable] cannot set already defined sortable id: \'' + this.arg + '\'')
	      } else if( this.arg ) {
	        this.vm.sortable[this.arg] = sortable
	      }
	    })
	  }
	
	  if (true) {
	    module.exports = vSortable
	  } else if (typeof define == "function" && define.amd) {
	    define([], function () {
	      return vSortable
	    })
	  } else if (window.Vue) {
	    window.vSortable = vSortable
	    Vue.use(vSortable)
	  }
	
	})()


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(321);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./Modal.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./Modal.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(322);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./Toggle.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./Toggle.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(323);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./deleteSweetAlert.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./deleteSweetAlert.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(324);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./Datepicker.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./Datepicker.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(325);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./Footer.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./Footer.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(326);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./NavigationHeader.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./NavigationHeader.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(327);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-243d033a&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./banner.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-243d033a&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./banner.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(328);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-2ea8af5c&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./addEditRubrics.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-2ea8af5c&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./addEditRubrics.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(329);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-4ae6ca21&scoped=true!../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../node_modules/eslint-loader/index.js!./Categorie.vue", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-4ae6ca21&scoped=true!../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../node_modules/eslint-loader/index.js!./Categorie.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(330);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-4fc3ab56&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./analytics.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-4fc3ab56&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./analytics.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(331);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-52410873&scoped=true!../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../node_modules/eslint-loader/index.js!./login.vue", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-52410873&scoped=true!../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../node_modules/eslint-loader/index.js!./login.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(332);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-6be008a2&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./Upload.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-6be008a2&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./Upload.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(333);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-75d92d2a&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./Select.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-75d92d2a&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./Select.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(334);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-7781753c&scoped=true!../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../node_modules/eslint-loader/index.js!./Hello.vue", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-7781753c&scoped=true!../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../node_modules/eslint-loader/index.js!./Hello.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(335);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-77d75885&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./cart.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-77d75885&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./cart.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(336);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-7d91334e&scoped=true!../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../node_modules/eslint-loader/index.js!./Product.vue", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-7d91334e&scoped=true!../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../node_modules/eslint-loader/index.js!./Product.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(337);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-a30f0f62&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./addProduct.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-a30f0f62&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./addProduct.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(338);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-c830bc3e&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./ProductCard.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-c830bc3e&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./ProductCard.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * vue-validator v2.1.7
	 * (c) 2016 kazuya kawaguchi
	 * Released under the MIT License.
	 */
	'use strict';
	
	var babelHelpers = {};
	babelHelpers.typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	babelHelpers.classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	babelHelpers.createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	babelHelpers.inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	babelHelpers.possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	babelHelpers;
	/**
	 * Utilties
	 */
	
	// export default for holding the Vue reference
	var exports$1 = {};
	/**
	 * warn
	 *
	 * @param {String} msg
	 * @param {Error} [err]
	 *
	 */
	
	function warn(msg, err) {
	  if (window.console) {
	    console.warn('[vue-validator] ' + msg);
	    if (err) {
	      console.warn(err.stack);
	    }
	  }
	}
	
	/**
	 * empty
	 *
	 * @param {Array|Object} target
	 * @return {Boolean}
	 */
	
	function empty(target) {
	  if (target === null || target === undefined) {
	    return true;
	  }
	
	  if (Array.isArray(target)) {
	    if (target.length > 0) {
	      return false;
	    }
	    if (target.length === 0) {
	      return true;
	    }
	  } else if (exports$1.Vue.util.isPlainObject(target)) {
	    for (var key in target) {
	      if (exports$1.Vue.util.hasOwn(target, key)) {
	        return false;
	      }
	    }
	  }
	
	  return true;
	}
	
	/**
	 * each
	 *
	 * @param {Array|Object} target
	 * @param {Function} iterator
	 * @param {Object} [context]
	 */
	
	function each(target, iterator, context) {
	  if (Array.isArray(target)) {
	    for (var i = 0; i < target.length; i++) {
	      iterator.call(context || target[i], target[i], i);
	    }
	  } else if (exports$1.Vue.util.isPlainObject(target)) {
	    var hasOwn = exports$1.Vue.util.hasOwn;
	    for (var key in target) {
	      if (hasOwn(target, key)) {
	        iterator.call(context || target[key], target[key], key);
	      }
	    }
	  }
	}
	
	/**
	 * pull
	 *
	 * @param {Array} arr
	 * @param {Object} item
	 * @return {Object|null}
	 */
	
	function pull(arr, item) {
	  var index = exports$1.Vue.util.indexOf(arr, item);
	  return ~index ? arr.splice(index, 1) : null;
	}
	
	/**
	 * trigger
	 *
	 * @param {Element} el
	 * @param {String} event
	 * @param {Object} [args]
	 */
	
	function trigger(el, event, args) {
	  var e = document.createEvent('HTMLEvents');
	  e.initEvent(event, true, false);
	
	  if (args) {
	    for (var prop in args) {
	      e[prop] = args[prop];
	    }
	  }
	
	  // Due to Firefox bug, events fired on disabled
	  // non-attached form controls can throw errors
	  try {
	    el.dispatchEvent(e);
	  } catch (e) {}
	}
	
	/**
	 * Forgiving check for a promise
	 *
	 * @param {Object} p
	 * @return {Boolean}
	 */
	
	function isPromise(p) {
	  return p && typeof p.then === 'function';
	}
	
	/**
	 * Togging classes
	 *
	 * @param {Element} el
	 * @param {String} key
	 * @param {Function} fn
	 */
	
	function toggleClasses(el, key, fn) {
	  key = key.trim();
	  if (key.indexOf(' ') === -1) {
	    fn(el, key);
	    return;
	  }
	
	  var keys = key.split(/\s+/);
	  for (var i = 0, l = keys.length; i < l; i++) {
	    fn(el, keys[i]);
	  }
	}
	
	/**
	 * Fundamental validate functions
	 */
	
	/**
	 * required
	 *
	 * This function validate whether the value has been filled out.
	 *
	 * @param {*} val
	 * @return {Boolean}
	 */
	
	function required(val) {
	  if (Array.isArray(val)) {
	    if (val.length !== 0) {
	      var valid = true;
	      for (var i = 0, l = val.length; i < l; i++) {
	        valid = required(val[i]);
	        if (!valid) {
	          break;
	        }
	      }
	      return valid;
	    } else {
	      return false;
	    }
	  } else if (typeof val === 'number' || typeof val === 'function') {
	    return true;
	  } else if (typeof val === 'boolean') {
	    return val;
	  } else if (typeof val === 'string') {
	    return val.length > 0;
	  } else if (val !== null && (typeof val === 'undefined' ? 'undefined' : babelHelpers.typeof(val)) === 'object') {
	    return Object.keys(val).length > 0;
	  } else if (val === null || val === undefined) {
	    return false;
	  }
	}
	
	/**
	 * pattern
	 *
	 * This function validate whether the value matches the regex pattern
	 *
	 * @param val
	 * @param {String} pat
	 * @return {Boolean}
	 */
	
	function pattern(val, pat) {
	  if (typeof pat !== 'string') {
	    return false;
	  }
	
	  var match = pat.match(new RegExp('^/(.*?)/([gimy]*)$'));
	  if (!match) {
	    return false;
	  }
	
	  return new RegExp(match[1], match[2]).test(val);
	}
	
	/**
	 * minlength
	 *
	 * This function validate whether the minimum length.
	 *
	 * @param {String|Array} val
	 * @param {String|Number} min
	 * @return {Boolean}
	 */
	
	function minlength(val, min) {
	  if (typeof val === 'string') {
	    return isInteger(min, 10) && val.length >= parseInt(min, 10);
	  } else if (Array.isArray(val)) {
	    return val.length >= parseInt(min, 10);
	  } else {
	    return false;
	  }
	}
	
	/**
	 * maxlength
	 *
	 * This function validate whether the maximum length.
	 *
	 * @param {String|Array} val
	 * @param {String|Number} max
	 * @return {Boolean}
	 */
	
	function maxlength(val, max) {
	  if (typeof val === 'string') {
	    return isInteger(max, 10) && val.length <= parseInt(max, 10);
	  } else if (Array.isArray(val)) {
	    return val.length <= parseInt(max, 10);
	  } else {
	    return false;
	  }
	}
	
	/**
	 * min
	 *
	 * This function validate whether the minimum value of the numberable value.
	 *
	 * @param {*} val
	 * @param {*} arg minimum
	 * @return {Boolean}
	 */
	
	function min(val, arg) {
	  return !isNaN(+val) && !isNaN(+arg) && +val >= +arg;
	}
	
	/**
	 * max
	 *
	 * This function validate whether the maximum value of the numberable value.
	 *
	 * @param {*} val
	 * @param {*} arg maximum
	 * @return {Boolean}
	 */
	
	function max(val, arg) {
	  return !isNaN(+val) && !isNaN(+arg) && +val <= +arg;
	}
	
	/**
	 * isInteger
	 *
	 * This function check whether the value of the string is integer.
	 *
	 * @param {String} val
	 * @return {Boolean}
	 * @private
	 */
	
	function isInteger(val) {
	  return (/^(-?[1-9]\d*|0)$/.test(val)
	  );
	}
	
	var validators = Object.freeze({
	  required: required,
	  pattern: pattern,
	  minlength: minlength,
	  maxlength: maxlength,
	  min: min,
	  max: max
	});
	
	function Asset (Vue) {
	  var extend = Vue.util.extend;
	
	  // set global validators asset
	  var assets = Object.create(null);
	  extend(assets, validators);
	  Vue.options.validators = assets;
	
	  // set option merge strategy
	  var strats = Vue.config.optionMergeStrategies;
	  if (strats) {
	    strats.validators = function (parent, child) {
	      if (!child) {
	        return parent;
	      }
	      if (!parent) {
	        return child;
	      }
	      var ret = Object.create(null);
	      extend(ret, parent);
	      for (var key in child) {
	        ret[key] = child[key];
	      }
	      return ret;
	    };
	  }
	
	  /**
	   * Register or retrieve a global validator definition.
	   *
	   * @param {String} id
	   * @param {Function} definition
	   */
	
	  Vue.validator = function (id, definition) {
	    if (!definition) {
	      return Vue.options['validators'][id];
	    } else {
	      Vue.options['validators'][id] = definition;
	    }
	  };
	}
	
	function Override (Vue) {
	  // override _init
	  var init = Vue.prototype._init;
	  Vue.prototype._init = function (options) {
	    if (!this._validatorMaps) {
	      this._validatorMaps = Object.create(null);
	    }
	    init.call(this, options);
	  };
	
	  // override _destroy
	  var destroy = Vue.prototype._destroy;
	  Vue.prototype._destroy = function () {
	    destroy.apply(this, arguments);
	    this._validatorMaps = null;
	  };
	}
	
	var VALIDATE_UPDATE = '__vue-validator-validate-update__';
	var PRIORITY_VALIDATE = 4096;
	var PRIORITY_VALIDATE_CLASS = 32;
	var REGEX_FILTER = /[^|]\|[^|]/;
	var REGEX_VALIDATE_DIRECTIVE = /^v-validate(?:$|:(.*)$)/;
	var REGEX_EVENT = /^v-on:|^@/;
	
	var classId = 0; // ID for validation class
	
	
	function ValidateClass (Vue) {
	  var vIf = Vue.directive('if');
	  var FragmentFactory = Vue.FragmentFactory;
	  var _Vue$util = Vue.util;
	  var toArray = _Vue$util.toArray;
	  var replace = _Vue$util.replace;
	  var createAnchor = _Vue$util.createAnchor;
	
	  /**
	   * `v-validate-class` directive
	   */
	
	  Vue.directive('validate-class', {
	    terminal: true,
	    priority: vIf.priority + PRIORITY_VALIDATE_CLASS,
	
	    bind: function bind() {
	      var _this = this;
	
	      var id = String(classId++);
	      this.setClassIds(this.el, id);
	
	      this.vm.$on(VALIDATE_UPDATE, this.cb = function (classIds, validation, results) {
	        if (classIds.indexOf(id) > -1) {
	          validation.updateClasses(results, _this.frag.node);
	        }
	      });
	
	      this.setupFragment();
	    },
	    unbind: function unbind() {
	      this.vm.$off(VALIDATE_UPDATE, this.cb);
	      this.teardownFragment();
	    },
	    setClassIds: function setClassIds(el, id) {
	      var childNodes = toArray(el.childNodes);
	      for (var i = 0, l = childNodes.length; i < l; i++) {
	        var element = childNodes[i];
	        if (element.nodeType === 1) {
	          var hasAttrs = element.hasAttributes();
	          var attrs = hasAttrs && toArray(element.attributes);
	          for (var k = 0, _l = attrs.length; k < _l; k++) {
	            var attr = attrs[k];
	            if (attr.name.match(REGEX_VALIDATE_DIRECTIVE)) {
	              var existingId = element.getAttribute(VALIDATE_UPDATE);
	              var value = existingId ? existingId + ',' + id : id;
	              element.setAttribute(VALIDATE_UPDATE, value);
	            }
	          }
	        }
	
	        if (element.hasChildNodes()) {
	          this.setClassIds(element, id);
	        }
	      }
	    },
	    setupFragment: function setupFragment() {
	      this.anchor = createAnchor('v-validate-class');
	      replace(this.el, this.anchor);
	
	      this.factory = new FragmentFactory(this.vm, this.el);
	      this.frag = this.factory.create(this._host, this._scope, this._frag);
	      this.frag.before(this.anchor);
	    },
	    teardownFragment: function teardownFragment() {
	      if (this.frag) {
	        this.frag.remove();
	        this.frag = null;
	        this.factory = null;
	      }
	
	      replace(this.anchor, this.el);
	      this.anchor = null;
	    }
	  });
	}
	
	function Validate (Vue) {
	  var FragmentFactory = Vue.FragmentFactory;
	  var parseDirective = Vue.parsers.directive.parseDirective;
	  var _Vue$util = Vue.util;
	  var inBrowser = _Vue$util.inBrowser;
	  var bind = _Vue$util.bind;
	  var on = _Vue$util.on;
	  var off = _Vue$util.off;
	  var createAnchor = _Vue$util.createAnchor;
	  var replace = _Vue$util.replace;
	  var camelize = _Vue$util.camelize;
	  var isPlainObject = _Vue$util.isPlainObject;
	
	  // Test for IE10/11 textarea placeholder clone bug
	
	  function checkTextareaCloneBug() {
	    if (inBrowser) {
	      var t = document.createElement('textarea');
	      t.placeholder = 't';
	      return t.cloneNode(true).value === 't';
	    } else {
	      return false;
	    }
	  }
	  var hasTextareaCloneBug = checkTextareaCloneBug();
	
	  /**
	   * `v-validate` directive
	   */
	
	  Vue.directive('validate', {
	    deep: true,
	    terminal: true,
	    priority: PRIORITY_VALIDATE,
	    params: ['group', 'field', 'detect-blur', 'detect-change', 'initial', 'classes'],
	
	    paramWatchers: {
	      detectBlur: function detectBlur(val, old) {
	        if (this._invalid) {
	          return;
	        }
	        this.validation.detectBlur = this.isDetectBlur(val);
	        this.validator.validate(this.field);
	      },
	      detectChange: function detectChange(val, old) {
	        if (this._invalid) {
	          return;
	        }
	        this.validation.detectChange = this.isDetectChange(val);
	        this.validator.validate(this.field);
	      }
	    },
	
	    bind: function bind() {
	      var el = this.el;
	
	      if (false) {
	        warn('v-validate="' + this.expression + '" cannot be used on an instance root element.');
	        this._invalid = true;
	        return;
	      }
	
	      if (false) {
	        warn('v-validate cannot be used `v-if` or `v-for` build-in terminal directive ' + 'on an element. these is wrapped with `<template>` or other tags: ' + '(e.g. <validator name="validator">' + '<template v-if="hidden">' + '<input type="text" v-validate:field1="[\'required\']">' + '</template>' + '</validator>).');
	        this._invalid = true;
	        return;
	      }
	
	      if (false) {
	        warn('you need specify field name for v-validate directive.');
	        this._invalid = true;
	        return;
	      }
	
	      var validatorName = this.vm.$options._validator;
	      if (false) {
	        warn('you need to wrap the elements to be validated in a <validator> element: ' + '(e.g. <validator name="validator">' + '<input type="text" v-validate:field1="[\'required\']">' + '</validator>).');
	        this._invalid = true;
	        return;
	      }
	
	      var raw = el.getAttribute('v-model');
	
	      var _parseModelRaw = this.parseModelRaw(raw);
	
	      var model = _parseModelRaw.model;
	      var filters = _parseModelRaw.filters;
	
	      this.model = model;
	
	      this.setupFragment();
	      this.setupValidate(validatorName, model, filters);
	      this.listen();
	    },
	    update: function update(value, old) {
	      if (!value || this._invalid) {
	        return;
	      }
	
	      if (isPlainObject(value) || old && isPlainObject(old)) {
	        this.handleObject(value, old, this.params.initial);
	      } else if (Array.isArray(value) || old && Array.isArray(old)) {
	        this.handleArray(value, old, this.params.initial);
	      }
	
	      var options = { field: this.field };
	      if (this.frag) {
	        options.el = this.frag.node;
	      }
	      this.validator.validate(options);
	    },
	    unbind: function unbind() {
	      if (this._invalid) {
	        return;
	      }
	
	      this.unlisten();
	      this.teardownValidate();
	      this.teardownFragment();
	
	      this.model = null;
	    },
	    parseModelRaw: function parseModelRaw(raw) {
	      if (REGEX_FILTER.test(raw)) {
	        var parsed = parseDirective(raw);
	        return { model: parsed.expression, filters: parsed.filters };
	      } else {
	        return { model: raw };
	      }
	    },
	    setupValidate: function setupValidate(name, model, filters) {
	      var params = this.params;
	      var validator = this.validator = this.vm._validatorMaps[name];
	
	      this.field = camelize(this.arg ? this.arg : params.field);
	
	      this.validation = validator.manageValidation(this.field, model, this.vm, this.getElementFrom(this.frag), this._scope, filters, params.initial, this.isDetectBlur(params.detectBlur), this.isDetectChange(params.detectChange));
	
	      isPlainObject(params.classes) && this.validation.setValidationClasses(params.classes);
	
	      params.group && validator.addGroupValidation(params.group, this.field);
	    },
	    listen: function listen() {
	      var model = this.model;
	      var validation = this.validation;
	      var el = this.getElementFrom(this.frag);
	
	      this.onBlur = bind(validation.listener, validation);
	      on(el, 'blur', this.onBlur);
	      if ((el.type === 'radio' || el.tagName === 'SELECT') && !model) {
	        this.onChange = bind(validation.listener, validation);
	        on(el, 'change', this.onChange);
	      } else if (el.type === 'checkbox') {
	        if (!model) {
	          this.onChange = bind(validation.listener, validation);
	          on(el, 'change', this.onChange);
	        } else {
	          this.onClick = bind(validation.listener, validation);
	          on(el, 'click', this.onClick);
	        }
	      } else {
	        if (!model) {
	          this.onInput = bind(validation.listener, validation);
	          on(el, 'input', this.onInput);
	        }
	      }
	    },
	    unlisten: function unlisten() {
	      var el = this.getElementFrom(this.frag);
	
	      if (this.onInput) {
	        off(el, 'input', this.onInput);
	        this.onInput = null;
	      }
	
	      if (this.onClick) {
	        off(el, 'click', this.onClick);
	        this.onClick = null;
	      }
	
	      if (this.onChange) {
	        off(el, 'change', this.onChange);
	        this.onChange = null;
	      }
	
	      if (this.onBlur) {
	        off(el, 'blur', this.onBlur);
	        this.onBlur = null;
	      }
	    },
	    teardownValidate: function teardownValidate() {
	      if (this.validator && this.validation) {
	        var el = this.getElementFrom(this.frag);
	
	        this.params.group && this.validator.removeGroupValidation(this.params.group, this.field);
	
	        this.validator.unmanageValidation(this.field, el);
	
	        this.validator = null;
	        this.validation = null;
	        this.field = null;
	      }
	    },
	    setupFragment: function setupFragment() {
	      this.anchor = createAnchor('v-validate');
	      replace(this.el, this.anchor);
	
	      this.factory = new FragmentFactory(this.vm, this.shimNode(this.el));
	      this.frag = this.factory.create(this._host, this._scope, this._frag);
	      this.frag.before(this.anchor);
	    },
	    teardownFragment: function teardownFragment() {
	      if (this.frag) {
	        this.frag.remove();
	        this.frag = null;
	        this.factory = null;
	      }
	
	      replace(this.anchor, this.el);
	      this.anchor = null;
	    },
	    handleArray: function handleArray(value, old, initial) {
	      var _this = this;
	
	      old && this.validation.resetValidation();
	
	      each(value, function (val) {
	        _this.validation.setValidation(val, undefined, undefined, initial);
	      });
	    },
	    handleObject: function handleObject(value, old, initial) {
	      var _this2 = this;
	
	      old && this.validation.resetValidation();
	
	      each(value, function (val, key) {
	        if (isPlainObject(val)) {
	          if ('rule' in val) {
	            var msg = 'message' in val ? val.message : null;
	            var init = 'initial' in val ? val.initial : null;
	            _this2.validation.setValidation(key, val.rule, msg, init || initial);
	          }
	        } else {
	          _this2.validation.setValidation(key, val, undefined, initial);
	        }
	      });
	    },
	    isDetectBlur: function isDetectBlur(detectBlur) {
	      return detectBlur === undefined || detectBlur === 'on' || detectBlur === true;
	    },
	    isDetectChange: function isDetectChange(detectChange) {
	      return detectChange === undefined || detectChange === 'on' || detectChange === true;
	    },
	    isInitialNoopValidation: function isInitialNoopValidation(initial) {
	      return initial === 'off' || initial === false;
	    },
	    shimNode: function shimNode(node) {
	      var ret = node;
	      if (hasTextareaCloneBug) {
	        if (node.tagName === 'TEXTAREA') {
	          ret = node.cloneNode(true);
	          ret.value = node.value;
	          var i = ret.childNodes.length;
	          while (i--) {
	            ret.removeChild(ret.childNodes[i]);
	          }
	        }
	      }
	      return ret;
	    },
	    getElementFrom: function getElementFrom(frag) {
	      return frag.single ? frag.node : frag.node.nextSibling;
	    }
	  });
	}
	
	/**
	 * BaseValidation class
	 */
	
	var BaseValidation = function () {
	  function BaseValidation(field, model, vm, el, scope, validator, filters, detectBlur, detectChange) {
	    babelHelpers.classCallCheck(this, BaseValidation);
	
	    this.field = field;
	    this.touched = false;
	    this.dirty = false;
	    this.modified = false;
	
	    this._modified = false;
	    this._model = model;
	    this._filters = filters;
	    this._validator = validator;
	    this._vm = vm;
	    this._el = el;
	    this._forScope = scope;
	    this._init = this._getValue(el);
	    this._validators = {};
	    this._detectBlur = detectBlur;
	    this._detectChange = detectChange;
	    this._classes = {};
	  }
	
	  BaseValidation.prototype.manageElement = function manageElement(el, initial) {
	    var _this = this;
	
	    var scope = this._getScope();
	    var model = this._model;
	
	    this._initial = initial;
	
	    var classIds = el.getAttribute(VALIDATE_UPDATE);
	    if (classIds) {
	      el.removeAttribute(VALIDATE_UPDATE);
	      this._classIds = classIds.split(',');
	    }
	
	    if (model) {
	      el.value = this._evalModel(model, this._filters);
	      this._unwatch = scope.$watch(model, function (val, old) {
	        if (val !== old) {
	          if (_this.guardValidate(el, 'input')) {
	            return;
	          }
	
	          _this.handleValidate(el, { noopable: _this._initial });
	          if (_this._initial) {
	            _this._initial = null;
	          }
	        }
	      }, { deep: true });
	    }
	  };
	
	  BaseValidation.prototype.unmanageElement = function unmanageElement(el) {
	    this._unwatch && this._unwatch();
	  };
	
	  BaseValidation.prototype.resetValidation = function resetValidation() {
	    var _this2 = this;
	
	    var keys = Object.keys(this._validators);
	    each(keys, function (key, index) {
	      _this2._validators[key] = null;
	      delete _this2._validators[key];
	    });
	  };
	
	  BaseValidation.prototype.resetValidationNoopable = function resetValidationNoopable() {
	    each(this._validators, function (descriptor, key) {
	      if (descriptor.initial && !descriptor._isNoopable) {
	        descriptor._isNoopable = true;
	      }
	    });
	  };
	
	  BaseValidation.prototype.setValidation = function setValidation(name, arg, msg, initial) {
	    var validator = this._validators[name];
	    if (!validator) {
	      validator = this._validators[name] = {};
	      validator.name = name;
	    }
	
	    validator.arg = arg;
	    if (msg) {
	      validator.msg = msg;
	    }
	
	    if (initial) {
	      validator.initial = initial;
	      validator._isNoopable = true;
	    }
	  };
	
	  BaseValidation.prototype.setValidationClasses = function setValidationClasses(classes) {
	    var _this3 = this;
	
	    each(classes, function (value, key) {
	      _this3._classes[key] = value;
	    });
	  };
	
	  BaseValidation.prototype.willUpdateFlags = function willUpdateFlags() {
	    var touched = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	    touched && this.willUpdateTouched(this._el, 'blur');
	    this.willUpdateDirty(this._el);
	    this.willUpdateModified(this._el);
	  };
	
	  BaseValidation.prototype.willUpdateTouched = function willUpdateTouched(el, type) {
	    if (type && type === 'blur') {
	      this.touched = true;
	      this._fireEvent(el, 'touched');
	    }
	  };
	
	  BaseValidation.prototype.willUpdateDirty = function willUpdateDirty(el) {
	    if (!this.dirty && this._checkModified(el)) {
	      this.dirty = true;
	      this._fireEvent(el, 'dirty');
	    }
	  };
	
	  BaseValidation.prototype.willUpdateModified = function willUpdateModified(el) {
	    this.modified = this._checkModified(el);
	    if (this._modified !== this.modified) {
	      this._fireEvent(el, 'modified', { modified: this.modified });
	      this._modified = this.modified;
	    }
	  };
	
	  BaseValidation.prototype.listener = function listener(e) {
	    if (this.guardValidate(e.target, e.type)) {
	      return;
	    }
	
	    this.handleValidate(e.target, { type: e.type });
	  };
	
	  BaseValidation.prototype.handleValidate = function handleValidate(el) {
	    var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var _ref$type = _ref.type;
	    var type = _ref$type === undefined ? null : _ref$type;
	    var _ref$noopable = _ref.noopable;
	    var noopable = _ref$noopable === undefined ? false : _ref$noopable;
	
	    this.willUpdateTouched(el, type);
	    this.willUpdateDirty(el);
	    this.willUpdateModified(el);
	
	    this._validator.validate({ field: this.field, el: el, noopable: noopable });
	  };
	
	  BaseValidation.prototype.validate = function validate(cb) {
	    var _this4 = this;
	
	    var noopable = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var el = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var _ = exports$1.Vue.util;
	
	    var results = {};
	    var errors = [];
	    var valid = true;
	
	    this._runValidators(function (descriptor, name, done) {
	      var asset = _this4._resolveValidator(name);
	      var validator = null;
	      var msg = null;
	
	      if (_.isPlainObject(asset)) {
	        if (asset.check && typeof asset.check === 'function') {
	          validator = asset.check;
	        }
	        if (asset.message) {
	          msg = asset.message;
	        }
	      } else if (typeof asset === 'function') {
	        validator = asset;
	      }
	
	      if (descriptor.msg) {
	        msg = descriptor.msg;
	      }
	
	      if (noopable) {
	        results[name] = false;
	        return done();
	      }
	
	      if (descriptor._isNoopable) {
	        results[name] = false;
	        descriptor._isNoopable = null;
	        return done();
	      }
	
	      if (validator) {
	        var value = _this4._getValue(_this4._el);
	        _this4._invokeValidator(_this4._vm, validator, value, descriptor.arg, function (ret, err) {
	          if (!ret) {
	            valid = false;
	            if (err) {
	              // async error message
	              errors.push({ validator: name, message: err });
	              results[name] = err;
	            } else if (msg) {
	              var error = { validator: name };
	              error.message = typeof msg === 'function' ? msg.call(_this4._vm, _this4.field, descriptor.arg) : msg;
	              errors.push(error);
	              results[name] = error.message;
	            } else {
	              results[name] = !ret;
	            }
	          } else {
	            results[name] = !ret;
	          }
	
	          done();
	        });
	      } else {
	        done();
	      }
	    }, function () {
	      // finished
	      _this4._fireEvent(_this4._el, valid ? 'valid' : 'invalid');
	
	      var props = {
	        valid: valid,
	        invalid: !valid,
	        touched: _this4.touched,
	        untouched: !_this4.touched,
	        dirty: _this4.dirty,
	        pristine: !_this4.dirty,
	        modified: _this4.modified
	      };
	      if (!empty(errors)) {
	        props.errors = errors;
	      }
	      _.extend(results, props);
	
	      _this4.willUpdateClasses(results, el);
	
	      cb(results);
	    });
	  };
	
	  BaseValidation.prototype.resetFlags = function resetFlags() {
	    this.touched = false;
	    this.dirty = false;
	    this.modified = false;
	    this._modified = false;
	  };
	
	  BaseValidation.prototype.reset = function reset() {
	    this.resetValidationNoopable();
	    this.resetFlags();
	    this._init = this._getValue(this._el);
	  };
	
	  BaseValidation.prototype.willUpdateClasses = function willUpdateClasses(results) {
	    var _this5 = this;
	
	    var el = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	    if (this._checkClassIds(el)) {
	      (function () {
	        var classIds = _this5._getClassIds(el);
	        _this5.vm.$nextTick(function () {
	          _this5.vm.$emit(VALIDATE_UPDATE, classIds, _this5, results);
	        });
	      })();
	    } else {
	      this.updateClasses(results);
	    }
	  };
	
	  BaseValidation.prototype.updateClasses = function updateClasses(results) {
	    var el = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	    this._updateClasses(el || this._el, results);
	  };
	
	  BaseValidation.prototype.guardValidate = function guardValidate(el, type) {
	    if (type && type === 'blur' && !this.detectBlur) {
	      return true;
	    }
	
	    if (type && type === 'input' && !this.detectChange) {
	      return true;
	    }
	
	    if (type && type === 'change' && !this.detectChange) {
	      return true;
	    }
	
	    if (type && type === 'click' && !this.detectChange) {
	      return true;
	    }
	
	    return false;
	  };
	
	  BaseValidation.prototype._getValue = function _getValue(el) {
	    return el.value;
	  };
	
	  BaseValidation.prototype._getScope = function _getScope() {
	    return this._forScope || this._vm;
	  };
	
	  BaseValidation.prototype._getClassIds = function _getClassIds(el) {
	    return this._classIds;
	  };
	
	  BaseValidation.prototype._checkModified = function _checkModified(target) {
	    return this._init !== this._getValue(target);
	  };
	
	  BaseValidation.prototype._checkClassIds = function _checkClassIds(el) {
	    return this._getClassIds(el);
	  };
	
	  BaseValidation.prototype._fireEvent = function _fireEvent(el, type, args) {
	    trigger(el, type, args);
	  };
	
	  BaseValidation.prototype._evalModel = function _evalModel(model, filters) {
	    var scope = this._getScope();
	
	    var val = null;
	    if (filters) {
	      val = scope.$get(model);
	      return filters ? this._applyFilters(val, null, filters) : val;
	    } else {
	      val = scope.$get(model);
	      return val === undefined || val === null ? '' : val;
	    }
	  };
	
	  BaseValidation.prototype._updateClasses = function _updateClasses(el, results) {
	    this._toggleValid(el, results.valid);
	    this._toggleTouched(el, results.touched);
	    this._togglePristine(el, results.pristine);
	    this._toggleModfied(el, results.modified);
	  };
	
	  BaseValidation.prototype._toggleValid = function _toggleValid(el, valid) {
	    var _util$Vue$util = exports$1.Vue.util;
	    var addClass = _util$Vue$util.addClass;
	    var removeClass = _util$Vue$util.removeClass;
	
	    var validClass = this._classes.valid || 'valid';
	    var invalidClass = this._classes.invalid || 'invalid';
	
	    if (valid) {
	      toggleClasses(el, validClass, addClass);
	      toggleClasses(el, invalidClass, removeClass);
	    } else {
	      toggleClasses(el, validClass, removeClass);
	      toggleClasses(el, invalidClass, addClass);
	    }
	  };
	
	  BaseValidation.prototype._toggleTouched = function _toggleTouched(el, touched) {
	    var _util$Vue$util2 = exports$1.Vue.util;
	    var addClass = _util$Vue$util2.addClass;
	    var removeClass = _util$Vue$util2.removeClass;
	
	    var touchedClass = this._classes.touched || 'touched';
	    var untouchedClass = this._classes.untouched || 'untouched';
	
	    if (touched) {
	      toggleClasses(el, touchedClass, addClass);
	      toggleClasses(el, untouchedClass, removeClass);
	    } else {
	      toggleClasses(el, touchedClass, removeClass);
	      toggleClasses(el, untouchedClass, addClass);
	    }
	  };
	
	  BaseValidation.prototype._togglePristine = function _togglePristine(el, pristine) {
	    var _util$Vue$util3 = exports$1.Vue.util;
	    var addClass = _util$Vue$util3.addClass;
	    var removeClass = _util$Vue$util3.removeClass;
	
	    var pristineClass = this._classes.pristine || 'pristine';
	    var dirtyClass = this._classes.dirty || 'dirty';
	
	    if (pristine) {
	      toggleClasses(el, pristineClass, addClass);
	      toggleClasses(el, dirtyClass, removeClass);
	    } else {
	      toggleClasses(el, pristineClass, removeClass);
	      toggleClasses(el, dirtyClass, addClass);
	    }
	  };
	
	  BaseValidation.prototype._toggleModfied = function _toggleModfied(el, modified) {
	    var _util$Vue$util4 = exports$1.Vue.util;
	    var addClass = _util$Vue$util4.addClass;
	    var removeClass = _util$Vue$util4.removeClass;
	
	    var modifiedClass = this._classes.modified || 'modified';
	
	    if (modified) {
	      toggleClasses(el, modifiedClass, addClass);
	    } else {
	      toggleClasses(el, modifiedClass, removeClass);
	    }
	  };
	
	  BaseValidation.prototype._applyFilters = function _applyFilters(value, oldValue, filters, write) {
	    var resolveAsset = exports$1.Vue.util.resolveAsset;
	    var scope = this._getScope();
	
	    var filter = void 0,
	        fn = void 0,
	        args = void 0,
	        arg = void 0,
	        offset = void 0,
	        i = void 0,
	        l = void 0,
	        j = void 0,
	        k = void 0;
	    for (i = 0, l = filters.length; i < l; i++) {
	      filter = filters[i];
	      fn = resolveAsset(this._vm.$options, 'filters', filter.name);
	      if (!fn) {
	        continue;
	      }
	
	      fn = write ? fn.write : fn.read || fn;
	      if (typeof fn !== 'function') {
	        continue;
	      }
	
	      args = write ? [value, oldValue] : [value];
	      offset = write ? 2 : 1;
	      if (filter.args) {
	        for (j = 0, k = filter.args.length; j < k; j++) {
	          arg = filter.args[j];
	          args[j + offset] = arg.dynamic ? scope.$get(arg.value) : arg.value;
	        }
	      }
	
	      value = fn.apply(this._vm, args);
	    }
	
	    return value;
	  };
	
	  BaseValidation.prototype._runValidators = function _runValidators(fn, cb) {
	    var validators = this._validators;
	    var length = Object.keys(validators).length;
	
	    var count = 0;
	    each(validators, function (descriptor, name) {
	      fn(descriptor, name, function () {
	        ++count;
	        count >= length && cb();
	      });
	    });
	  };
	
	  BaseValidation.prototype._invokeValidator = function _invokeValidator(vm, validator, val, arg, cb) {
	    var future = validator.call(this, val, arg);
	    if (typeof future === 'function') {
	      // function 
	      future(function () {
	        // resolve
	        cb(true);
	      }, function (msg) {
	        // reject
	        cb(false, msg);
	      });
	    } else if (isPromise(future)) {
	      // promise
	      future.then(function () {
	        // resolve
	        cb(true);
	      }, function (msg) {
	        // reject
	        cb(false, msg);
	      }).catch(function (err) {
	        cb(false, err.message);
	      });
	    } else {
	      // sync
	      cb(future);
	    }
	  };
	
	  BaseValidation.prototype._resolveValidator = function _resolveValidator(name) {
	    var resolveAsset = exports$1.Vue.util.resolveAsset;
	    return resolveAsset(this._vm.$options, 'validators', name);
	  };
	
	  babelHelpers.createClass(BaseValidation, [{
	    key: 'vm',
	    get: function get() {
	      return this._vm;
	    }
	  }, {
	    key: 'el',
	    get: function get() {
	      return this._el;
	    }
	  }, {
	    key: 'detectChange',
	    get: function get() {
	      return this._detectChange;
	    },
	    set: function set(val) {
	      this._detectChange = val;
	    }
	  }, {
	    key: 'detectBlur',
	    get: function get() {
	      return this._detectBlur;
	    },
	    set: function set(val) {
	      this._detectBlur = val;
	    }
	  }]);
	  return BaseValidation;
	}();
	
	/**
	 * CheckboxValidation class
	 */
	
	var CheckboxValidation = function (_BaseValidation) {
	  babelHelpers.inherits(CheckboxValidation, _BaseValidation);
	
	  function CheckboxValidation(field, model, vm, el, scope, validator, filters, detectBlur, detectChange) {
	    babelHelpers.classCallCheck(this, CheckboxValidation);
	
	    var _this = babelHelpers.possibleConstructorReturn(this, _BaseValidation.call(this, field, model, vm, el, scope, validator, filters, detectBlur, detectChange));
	
	    _this._inits = [];
	    return _this;
	  }
	
	  CheckboxValidation.prototype.manageElement = function manageElement(el, initial) {
	    var _this2 = this;
	
	    var scope = this._getScope();
	    var item = this._addItem(el, initial);
	
	    var model = item.model = this._model;
	    if (model) {
	      var value = this._evalModel(model, this._filters);
	      if (Array.isArray(value)) {
	        this._setChecked(value, item.el);
	        item.unwatch = scope.$watch(model, function (val, old) {
	          if (val !== old) {
	            if (_this2.guardValidate(item.el, 'change')) {
	              return;
	            }
	
	            _this2.handleValidate(item.el, { noopable: item.initial });
	            if (item.initial) {
	              item.initial = null;
	            }
	          }
	        });
	      } else {
	        el.checked = value || false;
	        this._init = el.checked;
	        item.init = el.checked;
	        item.value = el.value;
	        item.unwatch = scope.$watch(model, function (val, old) {
	          if (val !== old) {
	            if (_this2.guardValidate(el, 'change')) {
	              return;
	            }
	
	            _this2.handleValidate(el, { noopable: item.initial });
	            if (item.initial) {
	              item.initial = null;
	            }
	          }
	        });
	      }
	    } else {
	      var options = { field: this.field, noopable: initial };
	      if (this._checkClassIds(el)) {
	        options.el = el;
	      }
	      this._validator.validate(options);
	    }
	  };
	
	  CheckboxValidation.prototype.unmanageElement = function unmanageElement(el) {
	    var found = -1;
	    each(this._inits, function (item, index) {
	      if (item.el === el) {
	        found = index;
	        if (item.unwatch && item.model) {
	          item.unwatch();
	          item.unwatch = null;
	          item.model = null;
	        }
	      }
	    });
	    if (found === -1) {
	      return;
	    }
	
	    this._inits.splice(found, 1);
	    this._validator.validate({ field: this.field });
	  };
	
	  CheckboxValidation.prototype.willUpdateFlags = function willUpdateFlags() {
	    var _this3 = this;
	
	    var touched = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	    each(this._inits, function (item, index) {
	      touched && _this3.willUpdateTouched(item.el, 'blur');
	      _this3.willUpdateDirty(item.el);
	      _this3.willUpdateModified(item.el);
	    });
	  };
	
	  CheckboxValidation.prototype.reset = function reset() {
	    this.resetValidationNoopable();
	    this.resetFlags();
	    each(this._inits, function (item, index) {
	      item.init = item.el.checked;
	      item.value = item.el.value;
	    });
	  };
	
	  CheckboxValidation.prototype.updateClasses = function updateClasses(results) {
	    var _this4 = this;
	
	    var el = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	    if (el) {
	      // for another element
	      this._updateClasses(el, results);
	    } else {
	      each(this._inits, function (item, index) {
	        _this4._updateClasses(item.el, results);
	      });
	    }
	  };
	
	  CheckboxValidation.prototype._addItem = function _addItem(el, initial) {
	    var item = {
	      el: el,
	      init: el.checked,
	      value: el.value,
	      initial: initial
	    };
	
	    var classIds = el.getAttribute(VALIDATE_UPDATE);
	    if (classIds) {
	      el.removeAttribute(VALIDATE_UPDATE);
	      item.classIds = classIds.split(',');
	    }
	
	    this._inits.push(item);
	    return item;
	  };
	
	  CheckboxValidation.prototype._setChecked = function _setChecked(values, el) {
	    for (var i = 0, l = values.length; i < l; i++) {
	      var value = values[i];
	      if (!el.disabled && el.value === value && !el.checked) {
	        el.checked = true;
	      }
	    }
	  };
	
	  CheckboxValidation.prototype._getValue = function _getValue(el) {
	    var _this5 = this;
	
	    if (!this._inits || this._inits.length === 0) {
	      return el.checked;
	    } else {
	      var _ret = function () {
	        var vals = [];
	        each(_this5._inits, function (item, index) {
	          item.el.checked && vals.push(item.el.value);
	        });
	        return {
	          v: vals
	        };
	      }();
	
	      if ((typeof _ret === 'undefined' ? 'undefined' : babelHelpers.typeof(_ret)) === "object") return _ret.v;
	    }
	  };
	
	  CheckboxValidation.prototype._getClassIds = function _getClassIds(el) {
	    var classIds = void 0;
	    each(this._inits, function (item, index) {
	      if (item.el === el) {
	        classIds = item.classIds;
	      }
	    });
	    return classIds;
	  };
	
	  CheckboxValidation.prototype._checkModified = function _checkModified(target) {
	    var _this6 = this;
	
	    if (this._inits.length === 0) {
	      return this._init !== target.checked;
	    } else {
	      var _ret2 = function () {
	        var modified = false;
	        each(_this6._inits, function (item, index) {
	          if (!modified) {
	            modified = item.init !== item.el.checked;
	          }
	        });
	        return {
	          v: modified
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : babelHelpers.typeof(_ret2)) === "object") return _ret2.v;
	    }
	  };
	
	  return CheckboxValidation;
	}(BaseValidation);
	
	/**
	 * RadioValidation class
	 */
	
	var RadioValidation = function (_BaseValidation) {
	  babelHelpers.inherits(RadioValidation, _BaseValidation);
	
	  function RadioValidation(field, model, vm, el, scope, validator, filters, detectBlur, detectChange) {
	    babelHelpers.classCallCheck(this, RadioValidation);
	
	    var _this = babelHelpers.possibleConstructorReturn(this, _BaseValidation.call(this, field, model, vm, el, scope, validator, filters, detectBlur, detectChange));
	
	    _this._inits = [];
	    return _this;
	  }
	
	  RadioValidation.prototype.manageElement = function manageElement(el, initial) {
	    var _this2 = this;
	
	    var scope = this._getScope();
	    var item = this._addItem(el, initial);
	
	    var model = item.model = this._model;
	    if (model) {
	      var value = this._evalModel(model, this._filters);
	      this._setChecked(value, el, item);
	      item.unwatch = scope.$watch(model, function (val, old) {
	        if (val !== old) {
	          if (_this2.guardValidate(item.el, 'change')) {
	            return;
	          }
	
	          _this2.handleValidate(el, { noopable: item.initial });
	          if (item.initial) {
	            item.initial = null;
	          }
	        }
	      });
	    } else {
	      var options = { field: this.field, noopable: initial };
	      if (this._checkClassIds(el)) {
	        options.el = el;
	      }
	      this._validator.validate(options);
	    }
	  };
	
	  RadioValidation.prototype.unmanageElement = function unmanageElement(el) {
	    var found = -1;
	    each(this._inits, function (item, index) {
	      if (item.el === el) {
	        found = index;
	      }
	    });
	    if (found === -1) {
	      return;
	    }
	
	    this._inits.splice(found, 1);
	    this._validator.validate({ field: this.field });
	  };
	
	  RadioValidation.prototype.willUpdateFlags = function willUpdateFlags() {
	    var _this3 = this;
	
	    var touched = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	    each(this._inits, function (item, index) {
	      touched && _this3.willUpdateTouched(item.el, 'blur');
	      _this3.willUpdateDirty(item.el);
	      _this3.willUpdateModified(item.el);
	    });
	  };
	
	  RadioValidation.prototype.reset = function reset() {
	    this.resetValidationNoopable();
	    this.resetFlags();
	    each(this._inits, function (item, index) {
	      item.init = item.el.checked;
	      item.value = item.el.value;
	    });
	  };
	
	  RadioValidation.prototype.updateClasses = function updateClasses(results) {
	    var _this4 = this;
	
	    var el = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	    if (el) {
	      // for another element
	      this._updateClasses(el, results);
	    } else {
	      each(this._inits, function (item, index) {
	        _this4._updateClasses(item.el, results);
	      });
	    }
	  };
	
	  RadioValidation.prototype._addItem = function _addItem(el, initial) {
	    var item = {
	      el: el,
	      init: el.checked,
	      value: el.value,
	      initial: initial
	    };
	
	    var classIds = el.getAttribute(VALIDATE_UPDATE);
	    if (classIds) {
	      el.removeAttribute(VALIDATE_UPDATE);
	      item.classIds = classIds.split(',');
	    }
	
	    this._inits.push(item);
	    return item;
	  };
	
	  RadioValidation.prototype._setChecked = function _setChecked(value, el, item) {
	    if (el.value === value) {
	      el.checked = true;
	      this._init = el.checked;
	      item.init = el.checked;
	      item.value = value;
	    }
	  };
	
	  RadioValidation.prototype._getValue = function _getValue(el) {
	    var _this5 = this;
	
	    if (!this._inits || this._inits.length === 0) {
	      return el.checked;
	    } else {
	      var _ret = function () {
	        var vals = [];
	        each(_this5._inits, function (item, index) {
	          item.el.checked && vals.push(item.el.value);
	        });
	        return {
	          v: vals
	        };
	      }();
	
	      if ((typeof _ret === 'undefined' ? 'undefined' : babelHelpers.typeof(_ret)) === "object") return _ret.v;
	    }
	  };
	
	  RadioValidation.prototype._getClassIds = function _getClassIds(el) {
	    var classIds = void 0;
	    each(this._inits, function (item, index) {
	      if (item.el === el) {
	        classIds = item.classIds;
	      }
	    });
	    return classIds;
	  };
	
	  RadioValidation.prototype._checkModified = function _checkModified(target) {
	    var _this6 = this;
	
	    if (this._inits.length === 0) {
	      return this._init !== target.checked;
	    } else {
	      var _ret2 = function () {
	        var modified = false;
	        each(_this6._inits, function (item, index) {
	          if (!modified) {
	            modified = item.init !== item.el.checked;
	          }
	        });
	        return {
	          v: modified
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : babelHelpers.typeof(_ret2)) === "object") return _ret2.v;
	    }
	  };
	
	  return RadioValidation;
	}(BaseValidation);
	
	/**
	 * SelectValidation class
	 */
	
	var SelectValidation = function (_BaseValidation) {
	  babelHelpers.inherits(SelectValidation, _BaseValidation);
	
	  function SelectValidation(field, model, vm, el, scope, validator, filters, detectBlur, detectChange) {
	    babelHelpers.classCallCheck(this, SelectValidation);
	
	    var _this = babelHelpers.possibleConstructorReturn(this, _BaseValidation.call(this, field, model, vm, el, scope, validator, filters, detectBlur, detectChange));
	
	    _this._multiple = _this._el.hasAttribute('multiple');
	    return _this;
	  }
	
	  SelectValidation.prototype.manageElement = function manageElement(el, initial) {
	    var _this2 = this;
	
	    var scope = this._getScope();
	    var model = this._model;
	
	    this._initial = initial;
	
	    var classIds = el.getAttribute(VALIDATE_UPDATE);
	    if (classIds) {
	      el.removeAttribute(VALIDATE_UPDATE);
	      this._classIds = classIds.split(',');
	    }
	
	    if (model) {
	      var value = this._evalModel(model, this._filters);
	      var values = !Array.isArray(value) ? [value] : value;
	      this._setOption(values, el);
	      this._unwatch = scope.$watch(model, function (val, old) {
	        var values1 = !Array.isArray(val) ? [val] : val;
	        var values2 = !Array.isArray(old) ? [old] : old;
	        if (values1.slice().sort().toString() !== values2.slice().sort().toString()) {
	          if (_this2.guardValidate(el, 'change')) {
	            return;
	          }
	
	          _this2.handleValidate(el, { noopable: _this2._initial });
	          if (_this2._initial) {
	            _this2._initial = null;
	          }
	        }
	      });
	    }
	  };
	
	  SelectValidation.prototype.unmanageElement = function unmanageElement(el) {
	    this._unwatch && this._unwatch();
	  };
	
	  SelectValidation.prototype._getValue = function _getValue(el) {
	    var ret = [];
	
	    for (var i = 0, l = el.options.length; i < l; i++) {
	      var option = el.options[i];
	      if (!option.disabled && option.selected) {
	        ret.push(option.value);
	      }
	    }
	
	    return ret;
	  };
	
	  SelectValidation.prototype._setOption = function _setOption(values, el) {
	    for (var i = 0, l = values.length; i < l; i++) {
	      var value = values[i];
	      for (var j = 0, m = el.options.length; j < m; j++) {
	        var option = el.options[j];
	        if (!option.disabled && option.value === value && (!option.hasAttribute('selected') || !option.selected)) {
	          option.selected = true;
	        }
	      }
	    }
	  };
	
	  SelectValidation.prototype._checkModified = function _checkModified(target) {
	    var values = this._getValue(target).slice().sort();
	    if (this._init.length !== values.length) {
	      return true;
	    } else {
	      var inits = this._init.slice().sort();
	      return inits.toString() !== values.toString();
	    }
	  };
	
	  return SelectValidation;
	}(BaseValidation);
	
	/**
	 * Validator class
	 */
	
	var Validator$1 = function () {
	  function Validator(name, dir, groups, classes) {
	    var _this = this;
	
	    babelHelpers.classCallCheck(this, Validator);
	
	    this.name = name;
	
	    this._scope = {};
	    this._dir = dir;
	    this._validations = {};
	    this._checkboxValidations = {};
	    this._radioValidations = {};
	    this._groups = groups;
	    this._groupValidations = {};
	    this._events = {};
	    this._modified = false;
	    this._classes = classes;
	
	    each(groups, function (group) {
	      _this._groupValidations[group] = [];
	    });
	  }
	
	  Validator.prototype.enableReactive = function enableReactive() {
	    var vm = this._dir.vm;
	
	    // define the validation scope
	    exports$1.Vue.util.defineReactive(vm, this.name, this._scope);
	    vm._validatorMaps[this.name] = this;
	
	    // define the validation resetting meta method to vue instance
	    this._defineResetValidation();
	
	    // define the validate manually meta method to vue instance
	    this._defineValidate();
	
	    // define manually the validation errors
	    this._defineSetValidationErrors();
	  };
	
	  Validator.prototype.disableReactive = function disableReactive() {
	    var vm = this._dir.vm;
	    vm.$setValidationErrors = null;
	    delete vm['$setValidationErrors'];
	    vm.$validate = null;
	    delete vm['$validate'];
	    vm.$resetValidation = null;
	    delete vm['$resetValidation'];
	    vm._validatorMaps[this.name] = null;
	    delete vm._validatorMaps[this.name];
	    vm[this.name] = null;
	    delete vm[this.name];
	  };
	
	  Validator.prototype.registerEvents = function registerEvents() {
	    var isSimplePath = exports$1.Vue.parsers.expression.isSimplePath;
	
	    var attrs = this._dir.el.attributes;
	    for (var i = 0, l = attrs.length; i < l; i++) {
	      var event = attrs[i].name;
	      if (REGEX_EVENT.test(event)) {
	        var value = attrs[i].value;
	        if (isSimplePath(value)) {
	          value += '.apply(this, $arguments)';
	        }
	        event = event.replace(REGEX_EVENT, '');
	        this._events[this._getEventName(event)] = this._dir.vm.$eval(value, true);
	      }
	    }
	  };
	
	  Validator.prototype.unregisterEvents = function unregisterEvents() {
	    var _this2 = this;
	
	    each(this._events, function (handler, event) {
	      _this2._events[event] = null;
	      delete _this2._events[event];
	    });
	  };
	
	  Validator.prototype.manageValidation = function manageValidation(field, model, vm, el, scope, filters, initial, detectBlur, detectChange) {
	    var validation = null;
	
	    if (el.tagName === 'SELECT') {
	      validation = this._manageSelectValidation(field, model, vm, el, scope, filters, initial, detectBlur, detectChange);
	    } else if (el.type === 'checkbox') {
	      validation = this._manageCheckboxValidation(field, model, vm, el, scope, filters, initial, detectBlur, detectChange);
	    } else if (el.type === 'radio') {
	      validation = this._manageRadioValidation(field, model, vm, el, scope, filters, initial, detectBlur, detectChange);
	    } else {
	      validation = this._manageBaseValidation(field, model, vm, el, scope, filters, initial, detectBlur, detectChange);
	    }
	
	    validation.setValidationClasses(this._classes);
	
	    return validation;
	  };
	
	  Validator.prototype.unmanageValidation = function unmanageValidation(field, el) {
	    if (el.type === 'checkbox') {
	      this._unmanageCheckboxValidation(field, el);
	    } else if (el.type === 'radio') {
	      this._unmanageRadioValidation(field, el);
	    } else if (el.tagName === 'SELECT') {
	      this._unmanageSelectValidation(field, el);
	    } else {
	      this._unmanageBaseValidation(field, el);
	    }
	  };
	
	  Validator.prototype.addGroupValidation = function addGroupValidation(group, field) {
	    var indexOf = exports$1.Vue.util.indexOf;
	
	    var validation = this._getValidationFrom(field);
	    var validations = this._groupValidations[group];
	
	    validations && !~indexOf(validations, validation) && validations.push(validation);
	  };
	
	  Validator.prototype.removeGroupValidation = function removeGroupValidation(group, field) {
	    var validation = this._getValidationFrom(field);
	    var validations = this._groupValidations[group];
	
	    validations && pull(validations, validation);
	  };
	
	  Validator.prototype.validate = function validate() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var _ref$el = _ref.el;
	    var el = _ref$el === undefined ? null : _ref$el;
	    var _ref$field = _ref.field;
	    var field = _ref$field === undefined ? null : _ref$field;
	    var _ref$touched = _ref.touched;
	    var touched = _ref$touched === undefined ? false : _ref$touched;
	    var _ref$noopable = _ref.noopable;
	    var noopable = _ref$noopable === undefined ? false : _ref$noopable;
	    var _ref$cb = _ref.cb;
	    var cb = _ref$cb === undefined ? null : _ref$cb;
	
	    if (!field) {
	      // all
	      each(this.validations, function (validation, key) {
	        validation.willUpdateFlags(touched);
	      });
	      this._validates(cb);
	    } else {
	      // each field
	      this._validate(field, touched, noopable, el, cb);
	    }
	  };
	
	  Validator.prototype.setupScope = function setupScope() {
	    var _this3 = this;
	
	    this._defineProperties(function () {
	      return _this3.validations;
	    }, function () {
	      return _this3._scope;
	    });
	
	    each(this._groups, function (name) {
	      var validations = _this3._groupValidations[name];
	      var group = {};
	      exports$1.Vue.set(_this3._scope, name, group);
	      _this3._defineProperties(function () {
	        return validations;
	      }, function () {
	        return group;
	      });
	    });
	  };
	
	  Validator.prototype.waitFor = function waitFor(cb) {
	    var method = '$activateValidator';
	    var vm = this._dir.vm;
	
	    vm[method] = function () {
	      cb();
	      vm[method] = null;
	    };
	  };
	
	  Validator.prototype._defineResetValidation = function _defineResetValidation() {
	    var _this4 = this;
	
	    this._dir.vm.$resetValidation = function (cb) {
	      _this4._resetValidation(cb);
	    };
	  };
	
	  Validator.prototype._defineValidate = function _defineValidate() {
	    var _this5 = this;
	
	    this._dir.vm.$validate = function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var field = null;
	      var touched = false;
	      var cb = null;
	
	      each(args, function (arg, index) {
	        if (typeof arg === 'string') {
	          field = arg;
	        } else if (typeof arg === 'boolean') {
	          touched = arg;
	        } else if (typeof arg === 'function') {
	          cb = arg;
	        }
	      });
	
	      _this5.validate({ field: field, touched: touched, cb: cb });
	    };
	  };
	
	  Validator.prototype._defineSetValidationErrors = function _defineSetValidationErrors() {
	    var _this6 = this;
	
	    this._dir.vm.$setValidationErrors = function (errors) {
	      _this6._setValidationErrors(errors);
	    };
	  };
	
	  Validator.prototype._validate = function _validate(field) {
	    var touched = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var noopable = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	    var _this7 = this;
	
	    var el = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	    var cb = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
	
	    var scope = this._scope;
	
	    var validation = this._getValidationFrom(field);
	    if (validation) {
	      validation.willUpdateFlags(touched);
	      validation.validate(function (results) {
	        exports$1.Vue.set(scope, field, results);
	        _this7._fireEvents();
	        cb && cb();
	      }, noopable, el);
	    }
	  };
	
	  Validator.prototype._validates = function _validates(cb) {
	    var _this8 = this;
	
	    var scope = this._scope;
	
	    this._runValidates(function (validation, key, done) {
	      validation.validate(function (results) {
	        exports$1.Vue.set(scope, key, results);
	        done();
	      });
	    }, function () {
	      // finished
	      _this8._fireEvents();
	      cb && cb();
	    });
	  };
	
	  Validator.prototype._getValidationFrom = function _getValidationFrom(field) {
	    return this._validations[field] || this._checkboxValidations[field] && this._checkboxValidations[field].validation || this._radioValidations[field] && this._radioValidations[field].validation;
	  };
	
	  Validator.prototype._resetValidation = function _resetValidation(cb) {
	    each(this.validations, function (validation, key) {
	      validation.reset();
	    });
	    this._validates(cb);
	  };
	
	  Validator.prototype._setValidationErrors = function _setValidationErrors(errors) {
	    var _this9 = this;
	
	    var extend = exports$1.Vue.util.extend;
	
	    // make tempolaly errors
	
	    var temp = {};
	    each(errors, function (error, index) {
	      if (!temp[error.field]) {
	        temp[error.field] = [];
	      }
	      temp[error.field].push(error);
	    });
	
	    // set errors
	    each(temp, function (values, field) {
	      var results = _this9._scope[field];
	      var newResults = {};
	
	      each(values, function (error) {
	        if (error.validator) {
	          results[error.validator] = error.message;
	        }
	      });
	
	      results.valid = false;
	      results.invalid = true;
	      results.errors = values;
	      extend(newResults, results);
	
	      var validation = _this9._getValidationFrom(field);
	      validation.willUpdateClasses(newResults, validation.el);
	
	      exports$1.Vue.set(_this9._scope, field, newResults);
	    });
	  };
	
	  Validator.prototype._manageBaseValidation = function _manageBaseValidation(field, model, vm, el, scope, filters, initial, detectBlur, detectChange) {
	    var validation = this._validations[field] = new BaseValidation(field, model, vm, el, scope, this, filters, detectBlur, detectChange);
	    validation.manageElement(el, initial);
	    return validation;
	  };
	
	  Validator.prototype._unmanageBaseValidation = function _unmanageBaseValidation(field, el) {
	    var validation = this._validations[field];
	    if (validation) {
	      validation.unmanageElement(el);
	      exports$1.Vue.delete(this._scope, field);
	      this._validations[field] = null;
	      delete this._validations[field];
	    }
	  };
	
	  Validator.prototype._manageCheckboxValidation = function _manageCheckboxValidation(field, model, vm, el, scope, filters, initial, detectBlur, detectChange) {
	    var validationSet = this._checkboxValidations[field];
	    if (!validationSet) {
	      var validation = new CheckboxValidation(field, model, vm, el, scope, this, filters, detectBlur, detectChange);
	      validationSet = { validation: validation, elements: 0 };
	      this._checkboxValidations[field] = validationSet;
	    }
	
	    validationSet.elements++;
	    validationSet.validation.manageElement(el, initial);
	    return validationSet.validation;
	  };
	
	  Validator.prototype._unmanageCheckboxValidation = function _unmanageCheckboxValidation(field, el) {
	    var validationSet = this._checkboxValidations[field];
	    if (validationSet) {
	      validationSet.elements--;
	      validationSet.validation.unmanageElement(el);
	      if (validationSet.elements === 0) {
	        exports$1.Vue.delete(this._scope, field);
	        this._checkboxValidations[field] = null;
	        delete this._checkboxValidations[field];
	      }
	    }
	  };
	
	  Validator.prototype._manageRadioValidation = function _manageRadioValidation(field, model, vm, el, scope, filters, initial, detectBlur, detectChange) {
	    var validationSet = this._radioValidations[field];
	    if (!validationSet) {
	      var validation = new RadioValidation(field, model, vm, el, scope, this, filters, detectBlur, detectChange);
	      validationSet = { validation: validation, elements: 0 };
	      this._radioValidations[field] = validationSet;
	    }
	
	    validationSet.elements++;
	    validationSet.validation.manageElement(el, initial);
	    return validationSet.validation;
	  };
	
	  Validator.prototype._unmanageRadioValidation = function _unmanageRadioValidation(field, el) {
	    var validationSet = this._radioValidations[field];
	    if (validationSet) {
	      validationSet.elements--;
	      validationSet.validation.unmanageElement(el);
	      if (validationSet.elements === 0) {
	        exports$1.Vue.delete(this._scope, field);
	        this._radioValidations[field] = null;
	        delete this._radioValidations[field];
	      }
	    }
	  };
	
	  Validator.prototype._manageSelectValidation = function _manageSelectValidation(field, model, vm, el, scope, filters, initial, detectBlur, detectChange) {
	    var validation = this._validations[field] = new SelectValidation(field, model, vm, el, scope, this, filters, detectBlur, detectChange);
	    validation.manageElement(el, initial);
	    return validation;
	  };
	
	  Validator.prototype._unmanageSelectValidation = function _unmanageSelectValidation(field, el) {
	    var validation = this._validations[field];
	    if (validation) {
	      validation.unmanageElement(el);
	      exports$1.Vue.delete(this._scope, field);
	      this._validations[field] = null;
	      delete this._validations[field];
	    }
	  };
	
	  Validator.prototype._fireEvent = function _fireEvent(type) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    var handler = this._events[this._getEventName(type)];
	    handler && this._dir.vm.$nextTick(function () {
	      handler.apply(null, args);
	    });
	  };
	
	  Validator.prototype._fireEvents = function _fireEvents() {
	    var scope = this._scope;
	
	    scope.touched && this._fireEvent('touched');
	    scope.dirty && this._fireEvent('dirty');
	
	    if (this._modified !== scope.modified) {
	      this._fireEvent('modified', scope.modified);
	      this._modified = scope.modified;
	    }
	
	    var valid = scope.valid;
	    this._fireEvent(valid ? 'valid' : 'invalid');
	  };
	
	  Validator.prototype._getEventName = function _getEventName(type) {
	    return this.name + ':' + type;
	  };
	
	  Validator.prototype._defineProperties = function _defineProperties(validationsGetter, targetGetter) {
	    var _this10 = this;
	
	    var bind = exports$1.Vue.util.bind;
	
	    each({
	      valid: { fn: this._defineValid, arg: validationsGetter },
	      invalid: { fn: this._defineInvalid, arg: targetGetter },
	      touched: { fn: this._defineTouched, arg: validationsGetter },
	      untouched: { fn: this._defineUntouched, arg: targetGetter },
	      modified: { fn: this._defineModified, arg: validationsGetter },
	      dirty: { fn: this._defineDirty, arg: validationsGetter },
	      pristine: { fn: this._definePristine, arg: targetGetter },
	      errors: { fn: this._defineErrors, arg: validationsGetter }
	    }, function (descriptor, name) {
	      Object.defineProperty(targetGetter(), name, {
	        enumerable: true,
	        configurable: true,
	        get: function get() {
	          return bind(descriptor.fn, _this10)(descriptor.arg);
	        }
	      });
	    });
	  };
	
	  Validator.prototype._runValidates = function _runValidates(fn, cb) {
	    var length = Object.keys(this.validations).length;
	
	    var count = 0;
	    each(this.validations, function (validation, key) {
	      fn(validation, key, function () {
	        ++count;
	        count >= length && cb();
	      });
	    });
	  };
	
	  Validator.prototype._walkValidations = function _walkValidations(validations, property, condition) {
	    var _this11 = this;
	
	    var hasOwn = exports$1.Vue.util.hasOwn;
	    var ret = condition;
	
	    each(validations, function (validation, key) {
	      if (ret === !condition) {
	        return;
	      }
	      if (hasOwn(_this11._scope, validation.field)) {
	        var target = _this11._scope[validation.field];
	        if (target && target[property] === !condition) {
	          ret = !condition;
	        }
	      }
	    });
	
	    return ret;
	  };
	
	  Validator.prototype._defineValid = function _defineValid(validationsGetter) {
	    return this._walkValidations(validationsGetter(), 'valid', true);
	  };
	
	  Validator.prototype._defineInvalid = function _defineInvalid(scopeGetter) {
	    return !scopeGetter().valid;
	  };
	
	  Validator.prototype._defineTouched = function _defineTouched(validationsGetter) {
	    return this._walkValidations(validationsGetter(), 'touched', false);
	  };
	
	  Validator.prototype._defineUntouched = function _defineUntouched(scopeGetter) {
	    return !scopeGetter().touched;
	  };
	
	  Validator.prototype._defineModified = function _defineModified(validationsGetter) {
	    return this._walkValidations(validationsGetter(), 'modified', false);
	  };
	
	  Validator.prototype._defineDirty = function _defineDirty(validationsGetter) {
	    return this._walkValidations(validationsGetter(), 'dirty', false);
	  };
	
	  Validator.prototype._definePristine = function _definePristine(scopeGetter) {
	    return !scopeGetter().dirty;
	  };
	
	  Validator.prototype._defineErrors = function _defineErrors(validationsGetter) {
	    var _this12 = this;
	
	    var hasOwn = exports$1.Vue.util.hasOwn;
	    var isPlainObject = exports$1.Vue.util.isPlainObject;
	    var errors = [];
	
	    each(validationsGetter(), function (validation, key) {
	      if (hasOwn(_this12._scope, validation.field)) {
	        var target = _this12._scope[validation.field];
	        if (target && !empty(target.errors)) {
	          each(target.errors, function (err, index) {
	            var error = { field: validation.field };
	            if (isPlainObject(err)) {
	              if (err.validator) {
	                error.validator = err.validator;
	              }
	              error.message = err.message;
	            } else if (typeof err === 'string') {
	              error.message = err;
	            }
	            errors.push(error);
	          });
	        }
	      }
	    });
	
	    return empty(errors) ? undefined : errors.sort(function (a, b) {
	      return a.field < b.field ? -1 : 1;
	    });
	  };
	
	  babelHelpers.createClass(Validator, [{
	    key: 'validations',
	    get: function get() {
	      var extend = exports$1.Vue.util.extend;
	
	      var ret = {};
	      extend(ret, this._validations);
	
	      each(this._checkboxValidations, function (dataset, key) {
	        ret[key] = dataset.validation;
	      });
	
	      each(this._radioValidations, function (dataset, key) {
	        ret[key] = dataset.validation;
	      });
	
	      return ret;
	    }
	  }]);
	  return Validator;
	}();
	
	function Validator (Vue) {
	  var FragmentFactory = Vue.FragmentFactory;
	  var vIf = Vue.directive('if');
	  var _Vue$util = Vue.util;
	  var isArray = _Vue$util.isArray;
	  var isPlainObject = _Vue$util.isPlainObject;
	  var createAnchor = _Vue$util.createAnchor;
	  var replace = _Vue$util.replace;
	  var extend = _Vue$util.extend;
	  var camelize = _Vue$util.camelize;
	
	  /**
	   * `validator` element directive
	   */
	
	  Vue.elementDirective('validator', {
	    params: ['name', 'groups', 'lazy', 'classes'],
	
	    bind: function bind() {
	      var params = this.params;
	
	      if (false) {
	        warn('validator element requires a \'name\' attribute: ' + '(e.g. <validator name="validator1">...</validator>)');
	        return;
	      }
	
	      this.validatorName = '$' + camelize(params.name);
	      if (!this.vm._validatorMaps) {
	        throw new Error('Invalid validator management error');
	      }
	
	      var classes = {};
	      if (isPlainObject(this.params.classes)) {
	        classes = this.params.classes;
	      }
	
	      this.setupValidator(classes);
	      this.setupFragment(params.lazy);
	    },
	    unbind: function unbind() {
	      this.teardownFragment();
	      this.teardownValidator();
	    },
	    getGroups: function getGroups() {
	      var params = this.params;
	      var groups = [];
	
	      if (params.groups) {
	        if (isArray(params.groups)) {
	          groups = params.groups;
	        } else if (!isPlainObject(params.groups) && typeof params.groups === 'string') {
	          groups.push(params.groups);
	        }
	      }
	
	      return groups;
	    },
	    setupValidator: function setupValidator(classes) {
	      var validator = this.validator = new Validator$1(this.validatorName, this, this.getGroups(), classes);
	      validator.enableReactive();
	      validator.setupScope();
	      validator.registerEvents();
	    },
	    teardownValidator: function teardownValidator() {
	      this.validator.unregisterEvents();
	      this.validator.disableReactive();
	
	      if (this.validatorName) {
	        this.validatorName = null;
	        this.validator = null;
	      }
	    },
	    setupFragment: function setupFragment(lazy) {
	      var _this = this;
	
	      var vm = this.vm;
	
	      this.validator.waitFor(function () {
	        _this.anchor = createAnchor('vue-validator');
	        replace(_this.el, _this.anchor);
	        extend(vm.$options, { _validator: _this.validatorName });
	        _this.factory = new FragmentFactory(vm, _this.el.innerHTML);
	        vIf.insert.call(_this);
	      });
	
	      !lazy && vm.$activateValidator();
	    },
	    teardownFragment: function teardownFragment() {
	      vIf.unbind.call(this);
	    }
	  });
	}
	
	function ValidatorError (Vue) {
	  /**
	   * ValidatorError component
	   */
	
	  var error = {
	    name: 'validator-error',
	
	    props: {
	      field: {
	        type: String,
	        required: true
	      },
	      validator: {
	        type: String
	      },
	      message: {
	        type: String,
	        required: true
	      },
	      partial: {
	        type: String,
	        default: 'validator-error-default'
	      }
	    },
	
	    template: '<div><partial :name="partial"></partial></div>',
	
	    partials: {}
	  };
	
	  // only use ValidatorError component
	  error.partials['validator-error-default'] = '<p>{{field}}: {{message}}</p>';
	
	  return error;
	}
	
	function Errors (Vue) {
	  var _ = Vue.util;
	  var error = ValidatorError(Vue); // import ValidatorError component
	
	  /**
	   * ValidatorErrors component
	   */
	
	  var errors = {
	    name: 'validator-errors',
	
	    props: {
	      validation: {
	        type: Object,
	        required: true
	      },
	      group: {
	        type: String,
	        default: null
	      },
	      field: {
	        type: String,
	        default: null
	      },
	      component: {
	        type: String,
	        default: 'validator-error'
	      }
	    },
	
	    computed: {
	      errors: function errors() {
	        var _this = this;
	
	        if (this.group !== null) {
	          return this.validation[this.group].errors;
	        } else if (this.field !== null) {
	          var target = this.validation[this.field];
	          if (!target.errors) {
	            return;
	          }
	
	          return target.errors.map(function (error) {
	            var err = { field: _this.field };
	            if (_.isPlainObject(error)) {
	              if (error.validator) {
	                err.validator = error.validator;
	              }
	              err.message = error.message;
	            } else if (typeof error === 'string') {
	              err.message = error;
	            }
	            return err;
	          });
	        } else {
	          return this.validation.errors;
	        }
	      }
	    },
	
	    template: '<template v-for="error in errors">' + '<component :is="component" :partial="partial" :field="error.field" :validator="error.validator" :message="error.message">' + '</component>' + '</template>',
	
	    components: {}
	  };
	
	  // define 'partial' prop
	  errors.props['partial'] = error.props['partial'];
	
	  // only use ValidatorErrors component
	  errors.components[error.name] = error;
	
	  // install ValidatorErrors component
	  Vue.component(errors.name, errors);
	
	  return errors;
	}
	
	/**
	 * plugin
	 *
	 * @param {Function} Vue
	 * @param {Object} options
	 */
	
	function plugin(Vue) {
	  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  if (plugin.installed) {
	    warn('already installed.');
	    return;
	  }
	
	  exports$1.Vue = Vue;
	  Asset(Vue);
	  Errors(Vue);
	
	  Override(Vue);
	  Validator(Vue);
	  ValidateClass(Vue);
	  Validate(Vue);
	}
	
	plugin.version = '2.1.7';
	
	if (typeof window !== 'undefined' && window.Vue) {
	  window.Vue.use(plugin);
	}
	
	module.exports = plugin;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(1);
	
	var vec2 = __webpack_require__(8);
	
	var Draggable = __webpack_require__(759);
	
	var Eventful = __webpack_require__(49);
	
	/**
	 * Handler
	 * @module zrender/Handler
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         errorrik (errorrik@gmail.com)
	 *         pissang (shenyi.914@gmail.com)
	 */
	var SILENT = 'silent';
	
	function makeEventPacket(eveType, targetInfo, event) {
	  return {
	    type: eveType,
	    event: event,
	    // target can only be an element that is not silent.
	    target: targetInfo.target,
	    // topTarget can be a silent element.
	    topTarget: targetInfo.topTarget,
	    cancelBubble: false,
	    offsetX: event.zrX,
	    offsetY: event.zrY,
	    gestureEvent: event.gestureEvent,
	    pinchX: event.pinchX,
	    pinchY: event.pinchY,
	    pinchScale: event.pinchScale,
	    wheelDelta: event.zrDelta,
	    zrByTouch: event.zrByTouch,
	    which: event.which
	  };
	}
	
	function EmptyProxy() {}
	
	EmptyProxy.prototype.dispose = function () {};
	
	var handlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
	/**
	 * @alias module:zrender/Handler
	 * @constructor
	 * @extends module:zrender/mixin/Eventful
	 * @param {module:zrender/Storage} storage Storage instance.
	 * @param {module:zrender/Painter} painter Painter instance.
	 * @param {module:zrender/dom/HandlerProxy} proxy HandlerProxy instance.
	 * @param {HTMLElement} painterRoot painter.root (not painter.getViewportRoot()).
	 */
	
	var Handler = function (storage, painter, proxy, painterRoot) {
	  Eventful.call(this);
	  this.storage = storage;
	  this.painter = painter;
	  this.painterRoot = painterRoot;
	  proxy = proxy || new EmptyProxy();
	  /**
	   * Proxy of event. can be Dom, WebGLSurface, etc.
	   */
	
	  this.proxy = proxy; // Attach handler
	
	  proxy.handler = this;
	  /**
	   * {target, topTarget, x, y}
	   * @private
	   * @type {Object}
	   */
	
	  this._hovered = {};
	  /**
	   * @private
	   * @type {Date}
	   */
	
	  this._lastTouchMoment;
	  /**
	   * @private
	   * @type {number}
	   */
	
	  this._lastX;
	  /**
	   * @private
	   * @type {number}
	   */
	
	  this._lastY;
	  Draggable.call(this);
	  util.each(handlerNames, function (name) {
	    proxy.on && proxy.on(name, this[name], this);
	  }, this);
	};
	
	Handler.prototype = {
	  constructor: Handler,
	  mousemove: function (event) {
	    var x = event.zrX;
	    var y = event.zrY;
	    var lastHovered = this._hovered;
	    var lastHoveredTarget = lastHovered.target; // If lastHoveredTarget is removed from zr (detected by '__zr') by some API call
	    // (like 'setOption' or 'dispatchAction') in event handlers, we should find
	    // lastHovered again here. Otherwise 'mouseout' can not be triggered normally.
	    // See #6198.
	
	    if (lastHoveredTarget && !lastHoveredTarget.__zr) {
	      lastHovered = this.findHover(lastHovered.x, lastHovered.y);
	      lastHoveredTarget = lastHovered.target;
	    }
	
	    var hovered = this._hovered = this.findHover(x, y);
	    var hoveredTarget = hovered.target;
	    var proxy = this.proxy;
	    proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default'); // Mouse out on previous hovered element
	
	    if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) {
	      this.dispatchToElement(lastHovered, 'mouseout', event);
	    } // Mouse moving on one element
	
	
	    this.dispatchToElement(hovered, 'mousemove', event); // Mouse over on a new element
	
	    if (hoveredTarget && hoveredTarget !== lastHoveredTarget) {
	      this.dispatchToElement(hovered, 'mouseover', event);
	    }
	  },
	  mouseout: function (event) {
	    this.dispatchToElement(this._hovered, 'mouseout', event); // There might be some doms created by upper layer application
	    // at the same level of painter.getViewportRoot() (e.g., tooltip
	    // dom created by echarts), where 'globalout' event should not
	    // be triggered when mouse enters these doms. (But 'mouseout'
	    // should be triggered at the original hovered element as usual).
	
	    var element = event.toElement || event.relatedTarget;
	    var innerDom;
	
	    do {
	      element = element && element.parentNode;
	    } while (element && element.nodeType != 9 && !(innerDom = element === this.painterRoot));
	
	    !innerDom && this.trigger('globalout', {
	      event: event
	    });
	  },
	
	  /**
	   * Resize
	   */
	  resize: function (event) {
	    this._hovered = {};
	  },
	
	  /**
	   * Dispatch event
	   * @param {string} eventName
	   * @param {event=} eventArgs
	   */
	  dispatch: function (eventName, eventArgs) {
	    var handler = this[eventName];
	    handler && handler.call(this, eventArgs);
	  },
	
	  /**
	   * Dispose
	   */
	  dispose: function () {
	    this.proxy.dispose();
	    this.storage = this.proxy = this.painter = null;
	  },
	
	  /**
	   * 设置默认的cursor style
	   * @param {string} [cursorStyle='default'] 例如 crosshair
	   */
	  setCursorStyle: function (cursorStyle) {
	    var proxy = this.proxy;
	    proxy.setCursor && proxy.setCursor(cursorStyle);
	  },
	
	  /**
	   * 事件分发代理
	   *
	   * @private
	   * @param {Object} targetInfo {target, topTarget} 目标图形元素
	   * @param {string} eventName 事件名称
	   * @param {Object} event 事件对象
	   */
	  dispatchToElement: function (targetInfo, eventName, event) {
	    targetInfo = targetInfo || {};
	    var el = targetInfo.target;
	
	    if (el && el.silent) {
	      return;
	    }
	
	    var eventHandler = 'on' + eventName;
	    var eventPacket = makeEventPacket(eventName, targetInfo, event);
	
	    while (el) {
	      el[eventHandler] && (eventPacket.cancelBubble = el[eventHandler].call(el, eventPacket));
	      el.trigger(eventName, eventPacket);
	      el = el.parent;
	
	      if (eventPacket.cancelBubble) {
	        break;
	      }
	    }
	
	    if (!eventPacket.cancelBubble) {
	      // 冒泡到顶级 zrender 对象
	      this.trigger(eventName, eventPacket); // 分发事件到用户自定义层
	      // 用户有可能在全局 click 事件中 dispose，所以需要判断下 painter 是否存在
	
	      this.painter && this.painter.eachOtherLayer(function (layer) {
	        if (typeof layer[eventHandler] == 'function') {
	          layer[eventHandler].call(layer, eventPacket);
	        }
	
	        if (layer.trigger) {
	          layer.trigger(eventName, eventPacket);
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   * @param {number} x
	   * @param {number} y
	   * @param {module:zrender/graphic/Displayable} exclude
	   * @return {model:zrender/Element}
	   * @method
	   */
	  findHover: function (x, y, exclude) {
	    var list = this.storage.getDisplayList();
	    var out = {
	      x: x,
	      y: y
	    };
	
	    for (var i = list.length - 1; i >= 0; i--) {
	      var hoverCheckResult;
	
	      if (list[i] !== exclude // getDisplayList may include ignored item in VML mode
	      && !list[i].ignore && (hoverCheckResult = isHover(list[i], x, y))) {
	        !out.topTarget && (out.topTarget = list[i]);
	
	        if (hoverCheckResult !== SILENT) {
	          out.target = list[i];
	          break;
	        }
	      }
	    }
	
	    return out;
	  }
	}; // Common handlers
	
	util.each(['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
	  Handler.prototype[name] = function (event) {
	    // Find hover again to avoid click event is dispatched manually. Or click is triggered without mouseover
	    var hovered = this.findHover(event.zrX, event.zrY);
	    var hoveredTarget = hovered.target;
	
	    if (name === 'mousedown') {
	      this._downEl = hoveredTarget;
	      this._downPoint = [event.zrX, event.zrY]; // In case click triggered before mouseup
	
	      this._upEl = hoveredTarget;
	    } else if (name === 'mosueup') {
	      this._upEl = hoveredTarget;
	    } else if (name === 'click') {
	      if (this._downEl !== this._upEl // Original click event is triggered on the whole canvas element,
	      // including the case that `mousedown` - `mousemove` - `mouseup`,
	      // which should be filtered, otherwise it will bring trouble to
	      // pan and zoom.
	      || !this._downPoint // Arbitrary value
	      || vec2.dist(this._downPoint, [event.zrX, event.zrY]) > 4) {
	        return;
	      }
	
	      this._downPoint = null;
	    }
	
	    this.dispatchToElement(hovered, name, event);
	  };
	});
	
	function isHover(displayable, x, y) {
	  if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
	    var el = displayable;
	    var isSilent;
	
	    while (el) {
	      // If clipped by ancestor.
	      // FIXME: If clipPath has neither stroke nor fill,
	      // el.clipPath.contain(x, y) will always return false.
	      if (el.clipPath && !el.clipPath.contain(x, y)) {
	        return false;
	      }
	
	      if (el.silent) {
	        isSilent = true;
	      }
	
	      el = el.parent;
	    }
	
	    return isSilent ? SILENT : true;
	  }
	
	  return false;
	}
	
	util.mixin(Handler, Eventful);
	util.mixin(Handler, Draggable);
	var _default = Handler;
	module.exports = _default;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(1);
	
	var _config = __webpack_require__(96);
	
	var devicePixelRatio = _config.devicePixelRatio;
	
	var Style = __webpack_require__(225);
	
	var Pattern = __webpack_require__(224);
	
	/**
	 * @module zrender/Layer
	 * @author pissang(https://www.github.com/pissang)
	 */
	function returnFalse() {
	  return false;
	}
	/**
	 * 创建dom
	 *
	 * @inner
	 * @param {string} id dom id 待用
	 * @param {Painter} painter painter instance
	 * @param {number} number
	 */
	
	
	function createDom(id, painter, dpr) {
	  var newDom = util.createCanvas();
	  var width = painter.getWidth();
	  var height = painter.getHeight();
	  var newDomStyle = newDom.style; // 没append呢，请原谅我这样写，清晰~
	
	  newDomStyle.position = 'absolute';
	  newDomStyle.left = 0;
	  newDomStyle.top = 0;
	  newDomStyle.width = width + 'px';
	  newDomStyle.height = height + 'px';
	  newDom.width = width * dpr;
	  newDom.height = height * dpr; // id不作为索引用，避免可能造成的重名，定义为私有属性
	
	  newDom.setAttribute('data-zr-dom-id', id);
	  return newDom;
	}
	/**
	 * @alias module:zrender/Layer
	 * @constructor
	 * @extends module:zrender/mixin/Transformable
	 * @param {string} id
	 * @param {module:zrender/Painter} painter
	 * @param {number} [dpr]
	 */
	
	
	var Layer = function (id, painter, dpr) {
	  var dom;
	  dpr = dpr || devicePixelRatio;
	
	  if (typeof id === 'string') {
	    dom = createDom(id, painter, dpr);
	  } // Not using isDom because in node it will return false
	  else if (util.isObject(id)) {
	      dom = id;
	      id = dom.id;
	    }
	
	  this.id = id;
	  this.dom = dom;
	  var domStyle = dom.style;
	
	  if (domStyle) {
	    // Not in node
	    dom.onselectstart = returnFalse; // 避免页面选中的尴尬
	
	    domStyle['-webkit-user-select'] = 'none';
	    domStyle['user-select'] = 'none';
	    domStyle['-webkit-touch-callout'] = 'none';
	    domStyle['-webkit-tap-highlight-color'] = 'rgba(0,0,0,0)';
	    domStyle['padding'] = 0;
	    domStyle['margin'] = 0;
	    domStyle['border-width'] = 0;
	  }
	
	  this.domBack = null;
	  this.ctxBack = null;
	  this.painter = painter;
	  this.config = null; // Configs
	
	  /**
	   * 每次清空画布的颜色
	   * @type {string}
	   * @default 0
	   */
	
	  this.clearColor = 0;
	  /**
	   * 是否开启动态模糊
	   * @type {boolean}
	   * @default false
	   */
	
	  this.motionBlur = false;
	  /**
	   * 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
	   * @type {number}
	   * @default 0.7
	   */
	
	  this.lastFrameAlpha = 0.7;
	  /**
	   * Layer dpr
	   * @type {number}
	   */
	
	  this.dpr = dpr;
	};
	
	Layer.prototype = {
	  constructor: Layer,
	  elCount: 0,
	  __dirty: true,
	  initContext: function () {
	    this.ctx = this.dom.getContext('2d');
	    this.ctx.__currentValues = {};
	    this.ctx.dpr = this.dpr;
	  },
	  createBackBuffer: function () {
	    var dpr = this.dpr;
	    this.domBack = createDom('back-' + this.id, this.painter, dpr);
	    this.ctxBack = this.domBack.getContext('2d');
	    this.ctxBack.__currentValues = {};
	
	    if (dpr != 1) {
	      this.ctxBack.scale(dpr, dpr);
	    }
	  },
	
	  /**
	   * @param  {number} width
	   * @param  {number} height
	   */
	  resize: function (width, height) {
	    var dpr = this.dpr;
	    var dom = this.dom;
	    var domStyle = dom.style;
	    var domBack = this.domBack;
	    domStyle.width = width + 'px';
	    domStyle.height = height + 'px';
	    dom.width = width * dpr;
	    dom.height = height * dpr;
	
	    if (domBack) {
	      domBack.width = width * dpr;
	      domBack.height = height * dpr;
	
	      if (dpr != 1) {
	        this.ctxBack.scale(dpr, dpr);
	      }
	    }
	  },
	
	  /**
	   * 清空该层画布
	   * @param {boolean} clearAll Clear all with out motion blur
	   */
	  clear: function (clearAll) {
	    var dom = this.dom;
	    var ctx = this.ctx;
	    var width = dom.width;
	    var height = dom.height;
	    var clearColor = this.clearColor;
	    var haveMotionBLur = this.motionBlur && !clearAll;
	    var lastFrameAlpha = this.lastFrameAlpha;
	    var dpr = this.dpr;
	
	    if (haveMotionBLur) {
	      if (!this.domBack) {
	        this.createBackBuffer();
	      }
	
	      this.ctxBack.globalCompositeOperation = 'copy';
	      this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
	    }
	
	    ctx.clearRect(0, 0, width, height);
	
	    if (clearColor) {
	      var clearColorGradientOrPattern; // Gradient
	
	      if (clearColor.colorStops) {
	        // Cache canvas gradient
	        clearColorGradientOrPattern = clearColor.__canvasGradient || Style.getGradient(ctx, clearColor, {
	          x: 0,
	          y: 0,
	          width: width,
	          height: height
	        });
	        clearColor.__canvasGradient = clearColorGradientOrPattern;
	      } // Pattern
	      else if (clearColor.image) {
	          clearColorGradientOrPattern = Pattern.prototype.getCanvasPattern.call(clearColor, ctx);
	        }
	
	      ctx.save();
	      ctx.fillStyle = clearColorGradientOrPattern || clearColor;
	      ctx.fillRect(0, 0, width, height);
	      ctx.restore();
	    }
	
	    if (haveMotionBLur) {
	      var domBack = this.domBack;
	      ctx.save();
	      ctx.globalAlpha = lastFrameAlpha;
	      ctx.drawImage(domBack, 0, 0, width, height);
	      ctx.restore();
	    }
	  }
	};
	var _default = Layer;
	module.exports = _default;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(96);
	
	var devicePixelRatio = _config.devicePixelRatio;
	
	var util = __webpack_require__(1);
	
	var log = __webpack_require__(74);
	
	var BoundingRect = __webpack_require__(13);
	
	var timsort = __webpack_require__(137);
	
	var Layer = __webpack_require__(733);
	
	var requestAnimationFrame = __webpack_require__(215);
	
	var Image = __webpack_require__(75);
	
	/**
	 * Default canvas painter
	 * @module zrender/Painter
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         errorrik (errorrik@gmail.com)
	 *         pissang (https://www.github.com/pissang)
	 */
	// PENDIGN
	// Layer exceeds MAX_PROGRESSIVE_LAYER_NUMBER may have some problem when flush directly second time.
	//
	// Maximum progressive layer. When exceeding this number. All elements will be drawed in the last layer.
	var MAX_PROGRESSIVE_LAYER_NUMBER = 5;
	
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	
	function isLayerValid(layer) {
	  if (!layer) {
	    return false;
	  }
	
	  if (layer.__builtin__) {
	    return true;
	  }
	
	  if (typeof layer.resize !== 'function' || typeof layer.refresh !== 'function') {
	    return false;
	  }
	
	  return true;
	}
	
	function preProcessLayer(layer) {
	  layer.__unusedCount++;
	}
	
	function postProcessLayer(layer) {
	  if (layer.__unusedCount == 1) {
	    layer.clear();
	  }
	}
	
	var tmpRect = new BoundingRect(0, 0, 0, 0);
	var viewRect = new BoundingRect(0, 0, 0, 0);
	
	function isDisplayableCulled(el, width, height) {
	  tmpRect.copy(el.getBoundingRect());
	
	  if (el.transform) {
	    tmpRect.applyTransform(el.transform);
	  }
	
	  viewRect.width = width;
	  viewRect.height = height;
	  return !tmpRect.intersect(viewRect);
	}
	
	function isClipPathChanged(clipPaths, prevClipPaths) {
	  if (clipPaths == prevClipPaths) {
	    // Can both be null or undefined
	    return false;
	  }
	
	  if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) {
	    return true;
	  }
	
	  for (var i = 0; i < clipPaths.length; i++) {
	    if (clipPaths[i] !== prevClipPaths[i]) {
	      return true;
	    }
	  }
	}
	
	function doClip(clipPaths, ctx) {
	  for (var i = 0; i < clipPaths.length; i++) {
	    var clipPath = clipPaths[i];
	    clipPath.setTransform(ctx);
	    ctx.beginPath();
	    clipPath.buildPath(ctx, clipPath.shape);
	    ctx.clip(); // Transform back
	
	    clipPath.restoreTransform(ctx);
	  }
	}
	
	function createRoot(width, height) {
	  var domRoot = document.createElement('div'); // domRoot.onselectstart = returnFalse; // 避免页面选中的尴尬
	
	  domRoot.style.cssText = ['position:relative', 'overflow:hidden', 'width:' + width + 'px', 'height:' + height + 'px', 'padding:0', 'margin:0', 'border-width:0'].join(';') + ';';
	  return domRoot;
	}
	/**
	 * @alias module:zrender/Painter
	 * @constructor
	 * @param {HTMLElement} root 绘图容器
	 * @param {module:zrender/Storage} storage
	 * @param {Object} opts
	 */
	
	
	var Painter = function (root, storage, opts) {
	  this.type = 'canvas'; // In node environment using node-canvas
	
	  var singleCanvas = !root.nodeName // In node ?
	  || root.nodeName.toUpperCase() === 'CANVAS';
	  this._opts = opts = util.extend({}, opts || {});
	  /**
	   * @type {number}
	   */
	
	  this.dpr = opts.devicePixelRatio || devicePixelRatio;
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._singleCanvas = singleCanvas;
	  /**
	   * 绘图容器
	   * @type {HTMLElement}
	   */
	
	  this.root = root;
	  var rootStyle = root.style;
	
	  if (rootStyle) {
	    rootStyle['-webkit-tap-highlight-color'] = 'transparent';
	    rootStyle['-webkit-user-select'] = rootStyle['user-select'] = rootStyle['-webkit-touch-callout'] = 'none';
	    root.innerHTML = '';
	  }
	  /**
	   * @type {module:zrender/Storage}
	   */
	
	
	  this.storage = storage;
	  /**
	   * @type {Array.<number>}
	   * @private
	   */
	
	  var zlevelList = this._zlevelList = [];
	  /**
	   * @type {Object.<string, module:zrender/Layer>}
	   * @private
	   */
	
	  var layers = this._layers = {};
	  /**
	   * @type {Object.<string, Object>}
	   * @type {private}
	   */
	
	  this._layerConfig = {};
	
	  if (!singleCanvas) {
	    this._width = this._getSize(0);
	    this._height = this._getSize(1);
	    var domRoot = this._domRoot = createRoot(this._width, this._height);
	    root.appendChild(domRoot);
	  } else {
	    if (opts.width != null) {
	      root.width = opts.width;
	    }
	
	    if (opts.height != null) {
	      root.height = opts.height;
	    } // Use canvas width and height directly
	
	
	    var width = root.width;
	    var height = root.height;
	    this._width = width;
	    this._height = height; // Create layer if only one given canvas
	    // Device pixel ratio is fixed to 1 because given canvas has its specified width and height
	
	    var mainLayer = new Layer(root, this, 1);
	    mainLayer.initContext(); // FIXME Use canvas width and height
	    // mainLayer.resize(width, height);
	
	    layers[0] = mainLayer;
	    zlevelList.push(0);
	    this._domRoot = root;
	  } // Layers for progressive rendering
	
	
	  this._progressiveLayers = [];
	  /**
	   * @type {module:zrender/Layer}
	   * @private
	   */
	
	  this._hoverlayer;
	  this._hoverElements = [];
	};
	
	Painter.prototype = {
	  constructor: Painter,
	  getType: function () {
	    return 'canvas';
	  },
	
	  /**
	   * If painter use a single canvas
	   * @return {boolean}
	   */
	  isSingleCanvas: function () {
	    return this._singleCanvas;
	  },
	
	  /**
	   * @return {HTMLDivElement}
	   */
	  getViewportRoot: function () {
	    return this._domRoot;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	
	  /**
	   * 刷新
	   * @param {boolean} [paintAll=false] 强制绘制所有displayable
	   */
	  refresh: function (paintAll) {
	    var list = this.storage.getDisplayList(true);
	    var zlevelList = this._zlevelList;
	
	    this._paintList(list, paintAll); // Paint custum layers
	
	
	    for (var i = 0; i < zlevelList.length; i++) {
	      var z = zlevelList[i];
	      var layer = this._layers[z];
	
	      if (!layer.__builtin__ && layer.refresh) {
	        layer.refresh();
	      }
	    }
	
	    this.refreshHover();
	
	    if (this._progressiveLayers.length) {
	      this._startProgessive();
	    }
	
	    return this;
	  },
	  addHover: function (el, hoverStyle) {
	    if (el.__hoverMir) {
	      return;
	    }
	
	    var elMirror = new el.constructor({
	      style: el.style,
	      shape: el.shape
	    });
	    elMirror.__from = el;
	    el.__hoverMir = elMirror;
	    elMirror.setStyle(hoverStyle);
	
	    this._hoverElements.push(elMirror);
	  },
	  removeHover: function (el) {
	    var elMirror = el.__hoverMir;
	    var hoverElements = this._hoverElements;
	    var idx = util.indexOf(hoverElements, elMirror);
	
	    if (idx >= 0) {
	      hoverElements.splice(idx, 1);
	    }
	
	    el.__hoverMir = null;
	  },
	  clearHover: function (el) {
	    var hoverElements = this._hoverElements;
	
	    for (var i = 0; i < hoverElements.length; i++) {
	      var from = hoverElements[i].__from;
	
	      if (from) {
	        from.__hoverMir = null;
	      }
	    }
	
	    hoverElements.length = 0;
	  },
	  refreshHover: function () {
	    var hoverElements = this._hoverElements;
	    var len = hoverElements.length;
	    var hoverLayer = this._hoverlayer;
	    hoverLayer && hoverLayer.clear();
	
	    if (!len) {
	      return;
	    }
	
	    timsort(hoverElements, this.storage.displayableSortFunc); // Use a extream large zlevel
	    // FIXME?
	
	    if (!hoverLayer) {
	      hoverLayer = this._hoverlayer = this.getLayer(1e5);
	    }
	
	    var scope = {};
	    hoverLayer.ctx.save();
	
	    for (var i = 0; i < len;) {
	      var el = hoverElements[i];
	      var originalEl = el.__from; // Original el is removed
	      // PENDING
	
	      if (!(originalEl && originalEl.__zr)) {
	        hoverElements.splice(i, 1);
	        originalEl.__hoverMir = null;
	        len--;
	        continue;
	      }
	
	      i++; // Use transform
	      // FIXME style and shape ?
	
	      if (!originalEl.invisible) {
	        el.transform = originalEl.transform;
	        el.invTransform = originalEl.invTransform;
	        el.__clipPaths = originalEl.__clipPaths; // el.
	
	        this._doPaintEl(el, hoverLayer, true, scope);
	      }
	    }
	
	    hoverLayer.ctx.restore();
	  },
	  _startProgessive: function () {
	    var self = this;
	
	    if (!self._furtherProgressive) {
	      return;
	    } // Use a token to stop progress steps triggered by
	    // previous zr.refresh calling.
	
	
	    var token = self._progressiveToken = +new Date();
	    self._progress++;
	    requestAnimationFrame(step);
	
	    function step() {
	      // In case refreshed or disposed
	      if (token === self._progressiveToken && self.storage) {
	        self._doPaintList(self.storage.getDisplayList());
	
	        if (self._furtherProgressive) {
	          self._progress++;
	          requestAnimationFrame(step);
	        } else {
	          self._progressiveToken = -1;
	        }
	      }
	    }
	  },
	  _clearProgressive: function () {
	    this._progressiveToken = -1;
	    this._progress = 0;
	    util.each(this._progressiveLayers, function (layer) {
	      layer.__dirty && layer.clear();
	    });
	  },
	  _paintList: function (list, paintAll) {
	    if (paintAll == null) {
	      paintAll = false;
	    }
	
	    this._updateLayerStatus(list);
	
	    this._clearProgressive();
	
	    this.eachBuiltinLayer(preProcessLayer);
	
	    this._doPaintList(list, paintAll);
	
	    this.eachBuiltinLayer(postProcessLayer);
	  },
	  _doPaintList: function (list, paintAll) {
	    var currentLayer;
	    var currentZLevel;
	    var ctx; // var invTransform = [];
	
	    var scope;
	    var progressiveLayerIdx = 0;
	    var currentProgressiveLayer;
	    var width = this._width;
	    var height = this._height;
	    var layerProgress;
	    var frame = this._progress;
	
	    function flushProgressiveLayer(layer) {
	      var dpr = ctx.dpr || 1;
	      ctx.save();
	      ctx.globalAlpha = 1;
	      ctx.shadowBlur = 0; // Avoid layer don't clear in next progressive frame
	
	      currentLayer.__dirty = true;
	      ctx.setTransform(1, 0, 0, 1, 0, 0);
	      ctx.drawImage(layer.dom, 0, 0, width * dpr, height * dpr);
	      ctx.restore();
	    }
	
	    for (var i = 0, l = list.length; i < l; i++) {
	      var el = list[i];
	      var elZLevel = this._singleCanvas ? 0 : el.zlevel;
	      var elFrame = el.__frame; // Flush at current context
	      // PENDING
	
	      if (elFrame < 0 && currentProgressiveLayer) {
	        flushProgressiveLayer(currentProgressiveLayer);
	        currentProgressiveLayer = null;
	      } // Change draw layer
	
	
	      if (currentZLevel !== elZLevel) {
	        if (ctx) {
	          ctx.restore();
	        } // Reset scope
	
	
	        scope = {}; // Only 0 zlevel if only has one canvas
	
	        currentZLevel = elZLevel;
	        currentLayer = this.getLayer(currentZLevel);
	
	        if (!currentLayer.__builtin__) {
	          log('ZLevel ' + currentZLevel + ' has been used by unkown layer ' + currentLayer.id);
	        }
	
	        ctx = currentLayer.ctx;
	        ctx.save(); // Reset the count
	
	        currentLayer.__unusedCount = 0;
	
	        if (currentLayer.__dirty || paintAll) {
	          currentLayer.clear();
	        }
	      }
	
	      if (!(currentLayer.__dirty || paintAll)) {
	        continue;
	      }
	
	      if (elFrame >= 0) {
	        // Progressive layer changed
	        if (!currentProgressiveLayer) {
	          currentProgressiveLayer = this._progressiveLayers[Math.min(progressiveLayerIdx++, MAX_PROGRESSIVE_LAYER_NUMBER - 1)];
	          currentProgressiveLayer.ctx.save();
	          currentProgressiveLayer.renderScope = {};
	
	          if (currentProgressiveLayer && currentProgressiveLayer.__progress > currentProgressiveLayer.__maxProgress) {
	            // flushProgressiveLayer(currentProgressiveLayer);
	            // Quick jump all progressive elements
	            // All progressive element are not dirty, jump over and flush directly
	            i = currentProgressiveLayer.__nextIdxNotProg - 1; // currentProgressiveLayer = null;
	
	            continue;
	          }
	
	          layerProgress = currentProgressiveLayer.__progress;
	
	          if (!currentProgressiveLayer.__dirty) {
	            // Keep rendering
	            frame = layerProgress;
	          }
	
	          currentProgressiveLayer.__progress = frame + 1;
	        }
	
	        if (elFrame === frame) {
	          this._doPaintEl(el, currentProgressiveLayer, true, currentProgressiveLayer.renderScope);
	        }
	      } else {
	        this._doPaintEl(el, currentLayer, paintAll, scope);
	      }
	
	      el.__dirty = false;
	    }
	
	    if (currentProgressiveLayer) {
	      flushProgressiveLayer(currentProgressiveLayer);
	    } // Restore the lastLayer ctx
	
	
	    ctx && ctx.restore(); // If still has clipping state
	    // if (scope.prevElClipPaths) {
	    //     ctx.restore();
	    // }
	
	    this._furtherProgressive = false;
	    util.each(this._progressiveLayers, function (layer) {
	      if (layer.__maxProgress >= layer.__progress) {
	        this._furtherProgressive = true;
	      }
	    }, this);
	  },
	  _doPaintEl: function (el, currentLayer, forcePaint, scope) {
	    var ctx = currentLayer.ctx;
	    var m = el.transform;
	
	    if ((currentLayer.__dirty || forcePaint) && // Ignore invisible element
	    !el.invisible // Ignore transparent element
	    && el.style.opacity !== 0 // Ignore scale 0 element, in some environment like node-canvas
	    // Draw a scale 0 element can cause all following draw wrong
	    // And setTransform with scale 0 will cause set back transform failed.
	    && !(m && !m[0] && !m[3]) // Ignore culled element
	    && !(el.culling && isDisplayableCulled(el, this._width, this._height))) {
	      var clipPaths = el.__clipPaths; // Optimize when clipping on group with several elements
	
	      if (scope.prevClipLayer !== currentLayer || isClipPathChanged(clipPaths, scope.prevElClipPaths)) {
	        // If has previous clipping state, restore from it
	        if (scope.prevElClipPaths) {
	          scope.prevClipLayer.ctx.restore();
	          scope.prevClipLayer = scope.prevElClipPaths = null; // Reset prevEl since context has been restored
	
	          scope.prevEl = null;
	        } // New clipping state
	
	
	        if (clipPaths) {
	          ctx.save();
	          doClip(clipPaths, ctx);
	          scope.prevClipLayer = currentLayer;
	          scope.prevElClipPaths = clipPaths;
	        }
	      }
	
	      el.beforeBrush && el.beforeBrush(ctx);
	      el.brush(ctx, scope.prevEl || null);
	      scope.prevEl = el;
	      el.afterBrush && el.afterBrush(ctx);
	    }
	  },
	
	  /**
	   * 获取 zlevel 所在层，如果不存在则会创建一个新的层
	   * @param {number} zlevel
	   * @return {module:zrender/Layer}
	   */
	  getLayer: function (zlevel) {
	    if (this._singleCanvas) {
	      return this._layers[0];
	    }
	
	    var layer = this._layers[zlevel];
	
	    if (!layer) {
	      // Create a new layer
	      layer = new Layer('zr_' + zlevel, this, this.dpr);
	      layer.__builtin__ = true;
	
	      if (this._layerConfig[zlevel]) {
	        util.merge(layer, this._layerConfig[zlevel], true);
	      }
	
	      this.insertLayer(zlevel, layer); // Context is created after dom inserted to document
	      // Or excanvas will get 0px clientWidth and clientHeight
	
	      layer.initContext();
	    }
	
	    return layer;
	  },
	  insertLayer: function (zlevel, layer) {
	    var layersMap = this._layers;
	    var zlevelList = this._zlevelList;
	    var len = zlevelList.length;
	    var prevLayer = null;
	    var i = -1;
	    var domRoot = this._domRoot;
	
	    if (layersMap[zlevel]) {
	      log('ZLevel ' + zlevel + ' has been used already');
	      return;
	    } // Check if is a valid layer
	
	
	    if (!isLayerValid(layer)) {
	      log('Layer of zlevel ' + zlevel + ' is not valid');
	      return;
	    }
	
	    if (len > 0 && zlevel > zlevelList[0]) {
	      for (i = 0; i < len - 1; i++) {
	        if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) {
	          break;
	        }
	      }
	
	      prevLayer = layersMap[zlevelList[i]];
	    }
	
	    zlevelList.splice(i + 1, 0, zlevel);
	    layersMap[zlevel] = layer; // Vitual layer will not directly show on the screen.
	    // (It can be a WebGL layer and assigned to a ZImage element)
	    // But it still under management of zrender.
	
	    if (!layer.virtual) {
	      if (prevLayer) {
	        var prevDom = prevLayer.dom;
	
	        if (prevDom.nextSibling) {
	          domRoot.insertBefore(layer.dom, prevDom.nextSibling);
	        } else {
	          domRoot.appendChild(layer.dom);
	        }
	      } else {
	        if (domRoot.firstChild) {
	          domRoot.insertBefore(layer.dom, domRoot.firstChild);
	        } else {
	          domRoot.appendChild(layer.dom);
	        }
	      }
	    }
	  },
	  // Iterate each layer
	  eachLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      cb.call(context, this._layers[z], z);
	    }
	  },
	  // Iterate each buildin layer
	  eachBuiltinLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var layer;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      layer = this._layers[z];
	
	      if (layer.__builtin__) {
	        cb.call(context, layer, z);
	      }
	    }
	  },
	  // Iterate each other layer except buildin layer
	  eachOtherLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var layer;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      layer = this._layers[z];
	
	      if (!layer.__builtin__) {
	        cb.call(context, layer, z);
	      }
	    }
	  },
	
	  /**
	   * 获取所有已创建的层
	   * @param {Array.<module:zrender/Layer>} [prevLayer]
	   */
	  getLayers: function () {
	    return this._layers;
	  },
	  _updateLayerStatus: function (list) {
	    var layers = this._layers;
	    var progressiveLayers = this._progressiveLayers;
	    var elCountsLastFrame = {};
	    var progressiveElCountsLastFrame = {};
	    this.eachBuiltinLayer(function (layer, z) {
	      elCountsLastFrame[z] = layer.elCount;
	      layer.elCount = 0;
	      layer.__dirty = false;
	    });
	    util.each(progressiveLayers, function (layer, idx) {
	      progressiveElCountsLastFrame[idx] = layer.elCount;
	      layer.elCount = 0;
	      layer.__dirty = false;
	    });
	    var progressiveLayerCount = 0;
	    var currentProgressiveLayer;
	    var lastProgressiveKey;
	    var frameCount = 0;
	
	    for (var i = 0, l = list.length; i < l; i++) {
	      var el = list[i];
	      var zlevel = this._singleCanvas ? 0 : el.zlevel;
	      var layer = layers[zlevel];
	      var elProgress = el.progressive;
	
	      if (layer) {
	        layer.elCount++;
	        layer.__dirty = layer.__dirty || el.__dirty;
	      } /////// Update progressive
	
	
	      if (elProgress >= 0) {
	        // Fix wrong progressive sequence problem.
	        if (lastProgressiveKey !== elProgress) {
	          lastProgressiveKey = elProgress;
	          frameCount++;
	        }
	
	        var elFrame = el.__frame = frameCount - 1;
	
	        if (!currentProgressiveLayer) {
	          var idx = Math.min(progressiveLayerCount, MAX_PROGRESSIVE_LAYER_NUMBER - 1);
	          currentProgressiveLayer = progressiveLayers[idx];
	
	          if (!currentProgressiveLayer) {
	            currentProgressiveLayer = progressiveLayers[idx] = new Layer('progressive', this, this.dpr);
	            currentProgressiveLayer.initContext();
	          }
	
	          currentProgressiveLayer.__maxProgress = 0;
	        }
	
	        currentProgressiveLayer.__dirty = currentProgressiveLayer.__dirty || el.__dirty;
	        currentProgressiveLayer.elCount++;
	        currentProgressiveLayer.__maxProgress = Math.max(currentProgressiveLayer.__maxProgress, elFrame);
	
	        if (currentProgressiveLayer.__maxProgress >= currentProgressiveLayer.__progress) {
	          // Should keep rendering this  layer because progressive rendering is not finished yet
	          layer.__dirty = true;
	        }
	      } else {
	        el.__frame = -1;
	
	        if (currentProgressiveLayer) {
	          currentProgressiveLayer.__nextIdxNotProg = i;
	          progressiveLayerCount++;
	          currentProgressiveLayer = null;
	        }
	      }
	    }
	
	    if (currentProgressiveLayer) {
	      progressiveLayerCount++;
	      currentProgressiveLayer.__nextIdxNotProg = i;
	    } // 层中的元素数量有发生变化
	
	
	    this.eachBuiltinLayer(function (layer, z) {
	      if (elCountsLastFrame[z] !== layer.elCount) {
	        layer.__dirty = true;
	      }
	    });
	    progressiveLayers.length = Math.min(progressiveLayerCount, MAX_PROGRESSIVE_LAYER_NUMBER);
	    util.each(progressiveLayers, function (layer, idx) {
	      if (progressiveElCountsLastFrame[idx] !== layer.elCount) {
	        el.__dirty = true;
	      }
	
	      if (layer.__dirty) {
	        layer.__progress = 0;
	      }
	    });
	  },
	
	  /**
	   * 清除hover层外所有内容
	   */
	  clear: function () {
	    this.eachBuiltinLayer(this._clearLayer);
	    return this;
	  },
	  _clearLayer: function (layer) {
	    layer.clear();
	  },
	
	  /**
	   * 修改指定zlevel的绘制参数
	   *
	   * @param {string} zlevel
	   * @param {Object} config 配置对象
	   * @param {string} [config.clearColor=0] 每次清空画布的颜色
	   * @param {string} [config.motionBlur=false] 是否开启动态模糊
	   * @param {number} [config.lastFrameAlpha=0.7]
	   *                 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
	   */
	  configLayer: function (zlevel, config) {
	    if (config) {
	      var layerConfig = this._layerConfig;
	
	      if (!layerConfig[zlevel]) {
	        layerConfig[zlevel] = config;
	      } else {
	        util.merge(layerConfig[zlevel], config, true);
	      }
	
	      var layer = this._layers[zlevel];
	
	      if (layer) {
	        util.merge(layer, layerConfig[zlevel], true);
	      }
	    }
	  },
	
	  /**
	   * 删除指定层
	   * @param {number} zlevel 层所在的zlevel
	   */
	  delLayer: function (zlevel) {
	    var layers = this._layers;
	    var zlevelList = this._zlevelList;
	    var layer = layers[zlevel];
	
	    if (!layer) {
	      return;
	    }
	
	    layer.dom.parentNode.removeChild(layer.dom);
	    delete layers[zlevel];
	    zlevelList.splice(util.indexOf(zlevelList, zlevel), 1);
	  },
	
	  /**
	   * 区域大小变化后重绘
	   */
	  resize: function (width, height) {
	    var domRoot = this._domRoot; // FIXME Why ?
	
	    domRoot.style.display = 'none'; // Save input w/h
	
	    var opts = this._opts;
	    width != null && (opts.width = width);
	    height != null && (opts.height = height);
	    width = this._getSize(0);
	    height = this._getSize(1);
	    domRoot.style.display = ''; // 优化没有实际改变的resize
	
	    if (this._width != width || height != this._height) {
	      domRoot.style.width = width + 'px';
	      domRoot.style.height = height + 'px';
	
	      for (var id in this._layers) {
	        if (this._layers.hasOwnProperty(id)) {
	          this._layers[id].resize(width, height);
	        }
	      }
	
	      util.each(this._progressiveLayers, function (layer) {
	        layer.resize(width, height);
	      });
	      this.refresh(true);
	    }
	
	    this._width = width;
	    this._height = height;
	    return this;
	  },
	
	  /**
	   * 清除单独的一个层
	   * @param {number} zlevel
	   */
	  clearLayer: function (zlevel) {
	    var layer = this._layers[zlevel];
	
	    if (layer) {
	      layer.clear();
	    }
	  },
	
	  /**
	   * 释放
	   */
	  dispose: function () {
	    this.root.innerHTML = '';
	    this.root = this.storage = this._domRoot = this._layers = null;
	  },
	
	  /**
	   * Get canvas which has all thing rendered
	   * @param {Object} opts
	   * @param {string} [opts.backgroundColor]
	   * @param {number} [opts.pixelRatio]
	   */
	  getRenderedCanvas: function (opts) {
	    opts = opts || {};
	
	    if (this._singleCanvas) {
	      return this._layers[0].dom;
	    }
	
	    var imageLayer = new Layer('image', this, opts.pixelRatio || this.dpr);
	    imageLayer.initContext();
	    imageLayer.clearColor = opts.backgroundColor;
	    imageLayer.clear();
	    var displayList = this.storage.getDisplayList(true);
	    var scope = {};
	    var zlevel;
	    var self = this;
	
	    function findAndDrawOtherLayer(smaller, larger) {
	      var zlevelList = self._zlevelList;
	
	      if (smaller == null) {
	        smaller = -Infinity;
	      }
	
	      var intermediateLayer;
	
	      for (var i = 0; i < zlevelList.length; i++) {
	        var z = zlevelList[i];
	        var layer = self._layers[z];
	
	        if (!layer.__builtin__ && z > smaller && z < larger) {
	          intermediateLayer = layer;
	          break;
	        }
	      }
	
	      if (intermediateLayer && intermediateLayer.renderToCanvas) {
	        imageLayer.ctx.save();
	        intermediateLayer.renderToCanvas(imageLayer.ctx);
	        imageLayer.ctx.restore();
	      }
	    }
	
	    for (var i = 0; i < displayList.length; i++) {
	      var el = displayList[i];
	
	      if (el.zlevel !== zlevel) {
	        findAndDrawOtherLayer(zlevel, el.zlevel);
	        zlevel = el.zlevel;
	      }
	
	      this._doPaintEl(el, imageLayer, true, scope);
	    }
	
	    findAndDrawOtherLayer(zlevel, Infinity);
	    return imageLayer.dom;
	  },
	
	  /**
	   * 获取绘图区域宽度
	   */
	  getWidth: function () {
	    return this._width;
	  },
	
	  /**
	   * 获取绘图区域高度
	   */
	  getHeight: function () {
	    return this._height;
	  },
	  _getSize: function (whIdx) {
	    var opts = this._opts;
	    var wh = ['width', 'height'][whIdx];
	    var cwh = ['clientWidth', 'clientHeight'][whIdx];
	    var plt = ['paddingLeft', 'paddingTop'][whIdx];
	    var prb = ['paddingRight', 'paddingBottom'][whIdx];
	
	    if (opts[wh] != null && opts[wh] !== 'auto') {
	      return parseFloat(opts[wh]);
	    }
	
	    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.
	
	    var stl = document.defaultView.getComputedStyle(root);
	    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
	  },
	  pathToImage: function (path, dpr) {
	    dpr = dpr || this.dpr;
	    var canvas = document.createElement('canvas');
	    var ctx = canvas.getContext('2d');
	    var rect = path.getBoundingRect();
	    var style = path.style;
	    var shadowBlurSize = style.shadowBlur;
	    var shadowOffsetX = style.shadowOffsetX;
	    var shadowOffsetY = style.shadowOffsetY;
	    var lineWidth = style.hasStroke() ? style.lineWidth : 0;
	    var leftMargin = Math.max(lineWidth / 2, -shadowOffsetX + shadowBlurSize);
	    var rightMargin = Math.max(lineWidth / 2, shadowOffsetX + shadowBlurSize);
	    var topMargin = Math.max(lineWidth / 2, -shadowOffsetY + shadowBlurSize);
	    var bottomMargin = Math.max(lineWidth / 2, shadowOffsetY + shadowBlurSize);
	    var width = rect.width + leftMargin + rightMargin;
	    var height = rect.height + topMargin + bottomMargin;
	    canvas.width = width * dpr;
	    canvas.height = height * dpr;
	    ctx.scale(dpr, dpr);
	    ctx.clearRect(0, 0, width, height);
	    ctx.dpr = dpr;
	    var pathTransform = {
	      position: path.position,
	      rotation: path.rotation,
	      scale: path.scale
	    };
	    path.position = [leftMargin - rect.x, topMargin - rect.y];
	    path.rotation = 0;
	    path.scale = [1, 1];
	    path.updateTransform();
	
	    if (path) {
	      path.brush(ctx);
	    }
	
	    var ImageShape = Image;
	    var imgShape = new ImageShape({
	      style: {
	        x: 0,
	        y: 0,
	        image: canvas
	      }
	    });
	
	    if (pathTransform.position != null) {
	      imgShape.position = path.position = pathTransform.position;
	    }
	
	    if (pathTransform.rotation != null) {
	      imgShape.rotation = path.rotation = pathTransform.rotation;
	    }
	
	    if (pathTransform.scale != null) {
	      imgShape.scale = path.scale = pathTransform.scale;
	    }
	
	    return imgShape;
	  }
	};
	var _default = Painter;
	module.exports = _default;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(1);
	
	var env = __webpack_require__(18);
	
	var Group = __webpack_require__(97);
	
	var timsort = __webpack_require__(137);
	
	/**
	 * Storage内容仓库模块
	 * @module zrender/Storage
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 * @author errorrik (errorrik@gmail.com)
	 * @author pissang (https://github.com/pissang/)
	 */
	// Use timsort because in most case elements are partially sorted
	// https://jsfiddle.net/pissang/jr4x7mdm/8/
	function shapeCompareFunc(a, b) {
	  if (a.zlevel === b.zlevel) {
	    if (a.z === b.z) {
	      // if (a.z2 === b.z2) {
	      //     // FIXME Slow has renderidx compare
	      //     // http://stackoverflow.com/questions/20883421/sorting-in-javascript-should-every-compare-function-have-a-return-0-statement
	      //     // https://github.com/v8/v8/blob/47cce544a31ed5577ffe2963f67acb4144ee0232/src/js/array.js#L1012
	      //     return a.__renderidx - b.__renderidx;
	      // }
	      return a.z2 - b.z2;
	    }
	
	    return a.z - b.z;
	  }
	
	  return a.zlevel - b.zlevel;
	}
	/**
	 * 内容仓库 (M)
	 * @alias module:zrender/Storage
	 * @constructor
	 */
	
	
	var Storage = function () {
	  // jshint ignore:line
	  this._roots = [];
	  this._displayList = [];
	  this._displayListLen = 0;
	};
	
	Storage.prototype = {
	  constructor: Storage,
	
	  /**
	   * @param  {Function} cb
	   *
	   */
	  traverse: function (cb, context) {
	    for (var i = 0; i < this._roots.length; i++) {
	      this._roots[i].traverse(cb, context);
	    }
	  },
	
	  /**
	   * 返回所有图形的绘制队列
	   * @param {boolean} [update=false] 是否在返回前更新该数组
	   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组, 在 update 为 true 的时候有效
	   *
	   * 详见{@link module:zrender/graphic/Displayable.prototype.updateDisplayList}
	   * @return {Array.<module:zrender/graphic/Displayable>}
	   */
	  getDisplayList: function (update, includeIgnore) {
	    includeIgnore = includeIgnore || false;
	
	    if (update) {
	      this.updateDisplayList(includeIgnore);
	    }
	
	    return this._displayList;
	  },
	
	  /**
	   * 更新图形的绘制队列。
	   * 每次绘制前都会调用，该方法会先深度优先遍历整个树，更新所有Group和Shape的变换并且把所有可见的Shape保存到数组中，
	   * 最后根据绘制的优先级（zlevel > z > 插入顺序）排序得到绘制队列
	   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组
	   */
	  updateDisplayList: function (includeIgnore) {
	    this._displayListLen = 0;
	    var roots = this._roots;
	    var displayList = this._displayList;
	
	    for (var i = 0, len = roots.length; i < len; i++) {
	      this._updateAndAddDisplayable(roots[i], null, includeIgnore);
	    }
	
	    displayList.length = this._displayListLen; // for (var i = 0, len = displayList.length; i < len; i++) {
	    //     displayList[i].__renderidx = i;
	    // }
	    // displayList.sort(shapeCompareFunc);
	
	    env.canvasSupported && timsort(displayList, shapeCompareFunc);
	  },
	  _updateAndAddDisplayable: function (el, clipPaths, includeIgnore) {
	    if (el.ignore && !includeIgnore) {
	      return;
	    }
	
	    el.beforeUpdate();
	
	    if (el.__dirty) {
	      el.update();
	    }
	
	    el.afterUpdate();
	    var userSetClipPath = el.clipPath;
	
	    if (userSetClipPath) {
	      // FIXME 效率影响
	      if (clipPaths) {
	        clipPaths = clipPaths.slice();
	      } else {
	        clipPaths = [];
	      }
	
	      var currentClipPath = userSetClipPath;
	      var parentClipPath = el; // Recursively add clip path
	
	      while (currentClipPath) {
	        // clipPath 的变换是基于使用这个 clipPath 的元素
	        currentClipPath.parent = parentClipPath;
	        currentClipPath.updateTransform();
	        clipPaths.push(currentClipPath);
	        parentClipPath = currentClipPath;
	        currentClipPath = currentClipPath.clipPath;
	      }
	    }
	
	    if (el.isGroup) {
	      var children = el._children;
	
	      for (var i = 0; i < children.length; i++) {
	        var child = children[i]; // Force to mark as dirty if group is dirty
	        // FIXME __dirtyPath ?
	
	        if (el.__dirty) {
	          child.__dirty = true;
	        }
	
	        this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
	      } // Mark group clean here
	
	
	      el.__dirty = false;
	    } else {
	      el.__clipPaths = clipPaths;
	      this._displayList[this._displayListLen++] = el;
	    }
	  },
	
	  /**
	   * 添加图形(Shape)或者组(Group)到根节点
	   * @param {module:zrender/Element} el
	   */
	  addRoot: function (el) {
	    if (el.__storage === this) {
	      return;
	    }
	
	    if (el instanceof Group) {
	      el.addChildrenToStorage(this);
	    }
	
	    this.addToStorage(el);
	
	    this._roots.push(el);
	  },
	
	  /**
	   * 删除指定的图形(Shape)或者组(Group)
	   * @param {string|Array.<string>} [el] 如果为空清空整个Storage
	   */
	  delRoot: function (el) {
	    if (el == null) {
	      // 不指定el清空
	      for (var i = 0; i < this._roots.length; i++) {
	        var root = this._roots[i];
	
	        if (root instanceof Group) {
	          root.delChildrenFromStorage(this);
	        }
	      }
	
	      this._roots = [];
	      this._displayList = [];
	      this._displayListLen = 0;
	      return;
	    }
	
	    if (el instanceof Array) {
	      for (var i = 0, l = el.length; i < l; i++) {
	        this.delRoot(el[i]);
	      }
	
	      return;
	    }
	
	    var idx = util.indexOf(this._roots, el);
	
	    if (idx >= 0) {
	      this.delFromStorage(el);
	
	      this._roots.splice(idx, 1);
	
	      if (el instanceof Group) {
	        el.delChildrenFromStorage(this);
	      }
	    }
	  },
	  addToStorage: function (el) {
	    el.__storage = this;
	    el.dirty(false);
	    return this;
	  },
	  delFromStorage: function (el) {
	    if (el) {
	      el.__storage = null;
	    }
	
	    return this;
	  },
	
	  /**
	   * 清空并且释放Storage
	   */
	  dispose: function () {
	    this._renderList = this._roots = null;
	  },
	  displayableSortFunc: shapeCompareFunc
	};
	var _default = Storage;
	module.exports = _default;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(1);
	
	var _event = __webpack_require__(30);
	
	var Dispatcher = _event.Dispatcher;
	
	var requestAnimationFrame = __webpack_require__(215);
	
	var Animator = __webpack_require__(214);
	
	/**
	 * 动画主类, 调度和管理所有动画控制器
	 *
	 * @module zrender/animation/Animation
	 * @author pissang(https://github.com/pissang)
	 */
	// TODO Additive animation
	// http://iosoteric.com/additive-animations-animatewithduration-in-ios-8/
	// https://developer.apple.com/videos/wwdc2014/#236
	
	/**
	 * @typedef {Object} IZRenderStage
	 * @property {Function} update
	 */
	
	/**
	 * @alias module:zrender/animation/Animation
	 * @constructor
	 * @param {Object} [options]
	 * @param {Function} [options.onframe]
	 * @param {IZRenderStage} [options.stage]
	 * @example
	 *     var animation = new Animation();
	 *     var obj = {
	 *         x: 100,
	 *         y: 100
	 *     };
	 *     animation.animate(node.position)
	 *         .when(1000, {
	 *             x: 500,
	 *             y: 500
	 *         })
	 *         .when(2000, {
	 *             x: 100,
	 *             y: 100
	 *         })
	 *         .start('spline');
	 */
	var Animation = function (options) {
	  options = options || {};
	  this.stage = options.stage || {};
	
	  this.onframe = options.onframe || function () {}; // private properties
	
	
	  this._clips = [];
	  this._running = false;
	  this._time;
	  this._pausedTime;
	  this._pauseStart;
	  this._paused = false;
	  Dispatcher.call(this);
	};
	
	Animation.prototype = {
	  constructor: Animation,
	
	  /**
	   * 添加 clip
	   * @param {module:zrender/animation/Clip} clip
	   */
	  addClip: function (clip) {
	    this._clips.push(clip);
	  },
	
	  /**
	   * 添加 animator
	   * @param {module:zrender/animation/Animator} animator
	   */
	  addAnimator: function (animator) {
	    animator.animation = this;
	    var clips = animator.getClips();
	
	    for (var i = 0; i < clips.length; i++) {
	      this.addClip(clips[i]);
	    }
	  },
	
	  /**
	   * 删除动画片段
	   * @param {module:zrender/animation/Clip} clip
	   */
	  removeClip: function (clip) {
	    var idx = util.indexOf(this._clips, clip);
	
	    if (idx >= 0) {
	      this._clips.splice(idx, 1);
	    }
	  },
	
	  /**
	   * 删除动画片段
	   * @param {module:zrender/animation/Animator} animator
	   */
	  removeAnimator: function (animator) {
	    var clips = animator.getClips();
	
	    for (var i = 0; i < clips.length; i++) {
	      this.removeClip(clips[i]);
	    }
	
	    animator.animation = null;
	  },
	  _update: function () {
	    var time = new Date().getTime() - this._pausedTime;
	
	    var delta = time - this._time;
	    var clips = this._clips;
	    var len = clips.length;
	    var deferredEvents = [];
	    var deferredClips = [];
	
	    for (var i = 0; i < len; i++) {
	      var clip = clips[i];
	      var e = clip.step(time, delta); // Throw out the events need to be called after
	      // stage.update, like destroy
	
	      if (e) {
	        deferredEvents.push(e);
	        deferredClips.push(clip);
	      }
	    } // Remove the finished clip
	
	
	    for (var i = 0; i < len;) {
	      if (clips[i]._needsRemove) {
	        clips[i] = clips[len - 1];
	        clips.pop();
	        len--;
	      } else {
	        i++;
	      }
	    }
	
	    len = deferredEvents.length;
	
	    for (var i = 0; i < len; i++) {
	      deferredClips[i].fire(deferredEvents[i]);
	    }
	
	    this._time = time;
	    this.onframe(delta);
	    this.trigger('frame', delta);
	
	    if (this.stage.update) {
	      this.stage.update();
	    }
	  },
	  _startLoop: function () {
	    var self = this;
	    this._running = true;
	
	    function step() {
	      if (self._running) {
	        requestAnimationFrame(step);
	        !self._paused && self._update();
	      }
	    }
	
	    requestAnimationFrame(step);
	  },
	
	  /**
	   * 开始运行动画
	   */
	  start: function () {
	    this._time = new Date().getTime();
	    this._pausedTime = 0;
	
	    this._startLoop();
	  },
	
	  /**
	   * 停止运行动画
	   */
	  stop: function () {
	    this._running = false;
	  },
	
	  /**
	   * Pause
	   */
	  pause: function () {
	    if (!this._paused) {
	      this._pauseStart = new Date().getTime();
	      this._paused = true;
	    }
	  },
	
	  /**
	   * Resume
	   */
	  resume: function () {
	    if (this._paused) {
	      this._pausedTime += new Date().getTime() - this._pauseStart;
	      this._paused = false;
	    }
	  },
	
	  /**
	   * 清除所有动画片段
	   */
	  clear: function () {
	    this._clips = [];
	  },
	
	  /**
	   * 对一个目标创建一个animator对象，可以指定目标中的属性使用动画
	   * @param  {Object} target
	   * @param  {Object} options
	   * @param  {boolean} [options.loop=false] 是否循环播放动画
	   * @param  {Function} [options.getter=null]
	   *         如果指定getter函数，会通过getter函数取属性值
	   * @param  {Function} [options.setter=null]
	   *         如果指定setter函数，会通过setter函数设置属性值
	   * @return {module:zrender/animation/Animation~Animator}
	   */
	  // TODO Gap
	  animate: function (target, options) {
	    options = options || {};
	    var animator = new Animator(target, options.loop, options.getter, options.setter);
	    this.addAnimator(animator);
	    return animator;
	  }
	};
	util.mixin(Animation, Dispatcher);
	var _default = Animation;
	module.exports = _default;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	var easingFuncs = __webpack_require__(738);
	
	/**
	 * 动画主控制器
	 * @config target 动画对象，可以是数组，如果是数组的话会批量分发onframe等事件
	 * @config life(1000) 动画时长
	 * @config delay(0) 动画延迟时间
	 * @config loop(true)
	 * @config gap(0) 循环的间隔时间
	 * @config onframe
	 * @config easing(optional)
	 * @config ondestroy(optional)
	 * @config onrestart(optional)
	 *
	 * TODO pause
	 */
	function Clip(options) {
	  this._target = options.target; // 生命周期
	
	  this._life = options.life || 1000; // 延时
	
	  this._delay = options.delay || 0; // 开始时间
	  // this._startTime = new Date().getTime() + this._delay;// 单位毫秒
	
	  this._initialized = false; // 是否循环
	
	  this.loop = options.loop == null ? false : options.loop;
	  this.gap = options.gap || 0;
	  this.easing = options.easing || 'Linear';
	  this.onframe = options.onframe;
	  this.ondestroy = options.ondestroy;
	  this.onrestart = options.onrestart;
	  this._pausedTime = 0;
	  this._paused = false;
	}
	
	Clip.prototype = {
	  constructor: Clip,
	  step: function (globalTime, deltaTime) {
	    // Set startTime on first step, or _startTime may has milleseconds different between clips
	    // PENDING
	    if (!this._initialized) {
	      this._startTime = globalTime + this._delay;
	      this._initialized = true;
	    }
	
	    if (this._paused) {
	      this._pausedTime += deltaTime;
	      return;
	    }
	
	    var percent = (globalTime - this._startTime - this._pausedTime) / this._life; // 还没开始
	
	    if (percent < 0) {
	      return;
	    }
	
	    percent = Math.min(percent, 1);
	    var easing = this.easing;
	    var easingFunc = typeof easing == 'string' ? easingFuncs[easing] : easing;
	    var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
	    this.fire('frame', schedule); // 结束
	
	    if (percent == 1) {
	      if (this.loop) {
	        this.restart(globalTime); // 重新开始周期
	        // 抛出而不是直接调用事件直到 stage.update 后再统一调用这些事件
	
	        return 'restart';
	      } // 动画完成将这个控制器标识为待删除
	      // 在Animation.update中进行批量删除
	
	
	      this._needsRemove = true;
	      return 'destroy';
	    }
	
	    return null;
	  },
	  restart: function (globalTime) {
	    var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
	    this._startTime = globalTime - remainder + this.gap;
	    this._pausedTime = 0;
	    this._needsRemove = false;
	  },
	  fire: function (eventType, arg) {
	    eventType = 'on' + eventType;
	
	    if (this[eventType]) {
	      this[eventType](this._target, arg);
	    }
	  },
	  pause: function () {
	    this._paused = true;
	  },
	  resume: function () {
	    this._paused = false;
	  }
	};
	var _default = Clip;
	module.exports = _default;

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	/**
	 * 缓动代码来自 https://github.com/sole/tween.js/blob/master/src/Tween.js
	 * @see http://sole.github.io/tween.js/examples/03_graphs.html
	 * @exports zrender/animation/easing
	 */
	var easing = {
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  linear: function (k) {
	    return k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticIn: function (k) {
	    return k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticOut: function (k) {
	    return k * (2 - k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k;
	    }
	
	    return -0.5 * (--k * (k - 2) - 1);
	  },
	  // 三次方的缓动（t^3）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicIn: function (k) {
	    return k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicOut: function (k) {
	    return --k * k * k + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k;
	    }
	
	    return 0.5 * ((k -= 2) * k * k + 2);
	  },
	  // 四次方的缓动（t^4）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticIn: function (k) {
	    return k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticOut: function (k) {
	    return 1 - --k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k * k;
	    }
	
	    return -0.5 * ((k -= 2) * k * k * k - 2);
	  },
	  // 五次方的缓动（t^5）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticIn: function (k) {
	    return k * k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticOut: function (k) {
	    return --k * k * k * k * k + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k * k * k;
	    }
	
	    return 0.5 * ((k -= 2) * k * k * k * k + 2);
	  },
	  // 正弦曲线的缓动（sin(t)）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalIn: function (k) {
	    return 1 - Math.cos(k * Math.PI / 2);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalOut: function (k) {
	    return Math.sin(k * Math.PI / 2);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalInOut: function (k) {
	    return 0.5 * (1 - Math.cos(Math.PI * k));
	  },
	  // 指数曲线的缓动（2^t）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialIn: function (k) {
	    return k === 0 ? 0 : Math.pow(1024, k - 1);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialOut: function (k) {
	    return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialInOut: function (k) {
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if ((k *= 2) < 1) {
	      return 0.5 * Math.pow(1024, k - 1);
	    }
	
	    return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
	  },
	  // 圆形曲线的缓动（sqrt(1-t^2)）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularIn: function (k) {
	    return 1 - Math.sqrt(1 - k * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularOut: function (k) {
	    return Math.sqrt(1 - --k * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return -0.5 * (Math.sqrt(1 - k * k) - 1);
	    }
	
	    return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
	  },
	  // 创建类似于弹簧在停止前来回振荡的动画
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticIn: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticOut: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticInOut: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    if ((k *= 2) < 1) {
	      return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
	    }
	
	    return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
	  },
	  // 在某一动画开始沿指示的路径进行动画处理前稍稍收回该动画的移动
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backIn: function (k) {
	    var s = 1.70158;
	    return k * k * ((s + 1) * k - s);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backOut: function (k) {
	    var s = 1.70158;
	    return --k * k * ((s + 1) * k + s) + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backInOut: function (k) {
	    var s = 1.70158 * 1.525;
	
	    if ((k *= 2) < 1) {
	      return 0.5 * (k * k * ((s + 1) * k - s));
	    }
	
	    return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
	  },
	  // 创建弹跳效果
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceIn: function (k) {
	    return 1 - easing.bounceOut(1 - k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceOut: function (k) {
	    if (k < 1 / 2.75) {
	      return 7.5625 * k * k;
	    } else if (k < 2 / 2.75) {
	      return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
	    } else if (k < 2.5 / 2.75) {
	      return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
	    } else {
	      return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
	    }
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceInOut: function (k) {
	    if (k < 0.5) {
	      return easing.bounceIn(k * 2) * 0.5;
	    }
	
	    return easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
	  }
	};
	var _default = easing;
	module.exports = _default;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(219);
	
	var normalizeRadian = _util.normalizeRadian;
	var PI2 = Math.PI * 2;
	/**
	 * 圆弧描边包含判断
	 * @param  {number}  cx
	 * @param  {number}  cy
	 * @param  {number}  r
	 * @param  {number}  startAngle
	 * @param  {number}  endAngle
	 * @param  {boolean}  anticlockwise
	 * @param  {number} lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {Boolean}
	 */
	
	function containStroke(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth;
	  x -= cx;
	  y -= cy;
	  var d = Math.sqrt(x * x + y * y);
	
	  if (d - _l > r || d + _l < r) {
	    return false;
	  }
	
	  if (Math.abs(startAngle - endAngle) % PI2 < 1e-4) {
	    // Is a circle
	    return true;
	  }
	
	  if (anticlockwise) {
	    var tmp = startAngle;
	    startAngle = normalizeRadian(endAngle);
	    endAngle = normalizeRadian(tmp);
	  } else {
	    startAngle = normalizeRadian(startAngle);
	    endAngle = normalizeRadian(endAngle);
	  }
	
	  if (startAngle > endAngle) {
	    endAngle += PI2;
	  }
	
	  var angle = Math.atan2(y, x);
	
	  if (angle < 0) {
	    angle += PI2;
	  }
	
	  return angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle;
	}
	
	exports.containStroke = containStroke;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	var curve = __webpack_require__(40);
	
	/**
	 * 三次贝塞尔曲线描边包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  x2
	 * @param  {number}  y2
	 * @param  {number}  x3
	 * @param  {number}  y3
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) {
	    return false;
	  }
	
	  var d = curve.cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
	  return d <= _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	var PathProxy = __webpack_require__(60);
	
	var line = __webpack_require__(216);
	
	var cubic = __webpack_require__(740);
	
	var quadratic = __webpack_require__(218);
	
	var arc = __webpack_require__(739);
	
	var _util = __webpack_require__(219);
	
	var normalizeRadian = _util.normalizeRadian;
	
	var curve = __webpack_require__(40);
	
	var windingLine = __webpack_require__(220);
	
	var CMD = PathProxy.CMD;
	var PI2 = Math.PI * 2;
	var EPSILON = 1e-4;
	
	function isAroundEqual(a, b) {
	  return Math.abs(a - b) < EPSILON;
	} // 临时数组
	
	
	var roots = [-1, -1, -1];
	var extrema = [-1, -1];
	
	function swapExtrema() {
	  var tmp = extrema[0];
	  extrema[0] = extrema[1];
	  extrema[1] = tmp;
	}
	
	function windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
	  // Quick reject
	  if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) {
	    return 0;
	  }
	
	  var nRoots = curve.cubicRootAt(y0, y1, y2, y3, y, roots);
	
	  if (nRoots === 0) {
	    return 0;
	  } else {
	    var w = 0;
	    var nExtrema = -1;
	    var y0_, y1_;
	
	    for (var i = 0; i < nRoots; i++) {
	      var t = roots[i]; // Avoid winding error when intersection point is the connect point of two line of polygon
	
	      var unit = t === 0 || t === 1 ? 0.5 : 1;
	      var x_ = curve.cubicAt(x0, x1, x2, x3, t);
	
	      if (x_ < x) {
	        // Quick reject
	        continue;
	      }
	
	      if (nExtrema < 0) {
	        nExtrema = curve.cubicExtrema(y0, y1, y2, y3, extrema);
	
	        if (extrema[1] < extrema[0] && nExtrema > 1) {
	          swapExtrema();
	        }
	
	        y0_ = curve.cubicAt(y0, y1, y2, y3, extrema[0]);
	
	        if (nExtrema > 1) {
	          y1_ = curve.cubicAt(y0, y1, y2, y3, extrema[1]);
	        }
	      }
	
	      if (nExtrema == 2) {
	        // 分成三段单调函数
	        if (t < extrema[0]) {
	          w += y0_ < y0 ? unit : -unit;
	        } else if (t < extrema[1]) {
	          w += y1_ < y0_ ? unit : -unit;
	        } else {
	          w += y3 < y1_ ? unit : -unit;
	        }
	      } else {
	        // 分成两段单调函数
	        if (t < extrema[0]) {
	          w += y0_ < y0 ? unit : -unit;
	        } else {
	          w += y3 < y0_ ? unit : -unit;
	        }
	      }
	    }
	
	    return w;
	  }
	}
	
	function windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
	  // Quick reject
	  if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) {
	    return 0;
	  }
	
	  var nRoots = curve.quadraticRootAt(y0, y1, y2, y, roots);
	
	  if (nRoots === 0) {
	    return 0;
	  } else {
	    var t = curve.quadraticExtremum(y0, y1, y2);
	
	    if (t >= 0 && t <= 1) {
	      var w = 0;
	      var y_ = curve.quadraticAt(y0, y1, y2, t);
	
	      for (var i = 0; i < nRoots; i++) {
	        // Remove one endpoint.
	        var unit = roots[i] === 0 || roots[i] === 1 ? 0.5 : 1;
	        var x_ = curve.quadraticAt(x0, x1, x2, roots[i]);
	
	        if (x_ < x) {
	          // Quick reject
	          continue;
	        }
	
	        if (roots[i] < t) {
	          w += y_ < y0 ? unit : -unit;
	        } else {
	          w += y2 < y_ ? unit : -unit;
	        }
	      }
	
	      return w;
	    } else {
	      // Remove one endpoint.
	      var unit = roots[0] === 0 || roots[0] === 1 ? 0.5 : 1;
	      var x_ = curve.quadraticAt(x0, x1, x2, roots[0]);
	
	      if (x_ < x) {
	        // Quick reject
	        return 0;
	      }
	
	      return y2 < y0 ? unit : -unit;
	    }
	  }
	} // TODO
	// Arc 旋转
	
	
	function windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
	  y -= cy;
	
	  if (y > r || y < -r) {
	    return 0;
	  }
	
	  var tmp = Math.sqrt(r * r - y * y);
	  roots[0] = -tmp;
	  roots[1] = tmp;
	  var diff = Math.abs(startAngle - endAngle);
	
	  if (diff < 1e-4) {
	    return 0;
	  }
	
	  if (diff % PI2 < 1e-4) {
	    // Is a circle
	    startAngle = 0;
	    endAngle = PI2;
	    var dir = anticlockwise ? 1 : -1;
	
	    if (x >= roots[0] + cx && x <= roots[1] + cx) {
	      return dir;
	    } else {
	      return 0;
	    }
	  }
	
	  if (anticlockwise) {
	    var tmp = startAngle;
	    startAngle = normalizeRadian(endAngle);
	    endAngle = normalizeRadian(tmp);
	  } else {
	    startAngle = normalizeRadian(startAngle);
	    endAngle = normalizeRadian(endAngle);
	  }
	
	  if (startAngle > endAngle) {
	    endAngle += PI2;
	  }
	
	  var w = 0;
	
	  for (var i = 0; i < 2; i++) {
	    var x_ = roots[i];
	
	    if (x_ + cx > x) {
	      var angle = Math.atan2(y, x_);
	      var dir = anticlockwise ? 1 : -1;
	
	      if (angle < 0) {
	        angle = PI2 + angle;
	      }
	
	      if (angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle) {
	        if (angle > Math.PI / 2 && angle < Math.PI * 1.5) {
	          dir = -dir;
	        }
	
	        w += dir;
	      }
	    }
	  }
	
	  return w;
	}
	
	function containPath(data, lineWidth, isStroke, x, y) {
	  var w = 0;
	  var xi = 0;
	  var yi = 0;
	  var x0 = 0;
	  var y0 = 0;
	
	  for (var i = 0; i < data.length;) {
	    var cmd = data[i++]; // Begin a new subpath
	
	    if (cmd === CMD.M && i > 1) {
	      // Close previous subpath
	      if (!isStroke) {
	        w += windingLine(xi, yi, x0, y0, x, y);
	      } // 如果被任何一个 subpath 包含
	      // if (w !== 0) {
	      //     return true;
	      // }
	
	    }
	
	    if (i == 1) {
	      // 如果第一个命令是 L, C, Q
	      // 则 previous point 同绘制命令的第一个 point
	      //
	      // 第一个命令为 Arc 的情况下会在后面特殊处理
	      xi = data[i];
	      yi = data[i + 1];
	      x0 = xi;
	      y0 = yi;
	    }
	
	    switch (cmd) {
	      case CMD.M:
	        // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
	        // 在 closePath 的时候使用
	        x0 = data[i++];
	        y0 = data[i++];
	        xi = x0;
	        yi = y0;
	        break;
	
	      case CMD.L:
	        if (isStroke) {
	          if (line.containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // NOTE 在第一个命令为 L, C, Q 的时候会计算出 NaN
	          w += windingLine(xi, yi, data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.C:
	        if (isStroke) {
	          if (cubic.containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          w += windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.Q:
	        if (isStroke) {
	          if (quadratic.containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          w += windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.A:
	        // TODO Arc 判断的开销比较大
	        var cx = data[i++];
	        var cy = data[i++];
	        var rx = data[i++];
	        var ry = data[i++];
	        var theta = data[i++];
	        var dTheta = data[i++]; // TODO Arc 旋转
	
	        var psi = data[i++];
	        var anticlockwise = 1 - data[i++];
	        var x1 = Math.cos(theta) * rx + cx;
	        var y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令
	
	        if (i > 1) {
	          w += windingLine(xi, yi, x1, y1, x, y);
	        } else {
	          // 第一个命令起点还未定义
	          x0 = x1;
	          y0 = y1;
	        } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
	
	
	        var _x = (x - cx) * ry / rx + cx;
	
	        if (isStroke) {
	          if (arc.containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) {
	            return true;
	          }
	        } else {
	          w += windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
	        }
	
	        xi = Math.cos(theta + dTheta) * rx + cx;
	        yi = Math.sin(theta + dTheta) * ry + cy;
	        break;
	
	      case CMD.R:
	        x0 = xi = data[i++];
	        y0 = yi = data[i++];
	        var width = data[i++];
	        var height = data[i++];
	        var x1 = x0 + width;
	        var y1 = y0 + height;
	
	        if (isStroke) {
	          if (line.containStroke(x0, y0, x1, y0, lineWidth, x, y) || line.containStroke(x1, y0, x1, y1, lineWidth, x, y) || line.containStroke(x1, y1, x0, y1, lineWidth, x, y) || line.containStroke(x0, y1, x0, y0, lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // FIXME Clockwise ?
	          w += windingLine(x1, y0, x1, y1, x, y);
	          w += windingLine(x0, y1, x0, y0, x, y);
	        }
	
	        break;
	
	      case CMD.Z:
	        if (isStroke) {
	          if (line.containStroke(xi, yi, x0, y0, lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // Close a subpath
	          w += windingLine(xi, yi, x0, y0, x, y); // 如果被任何一个 subpath 包含
	          // FIXME subpaths may overlap
	          // if (w !== 0) {
	          //     return true;
	          // }
	        }
	
	        xi = x0;
	        yi = y0;
	        break;
	    }
	  }
	
	  if (!isStroke && !isAroundEqual(yi, y0)) {
	    w += windingLine(xi, yi, x0, y0, x, y) || 0;
	  }
	
	  return w !== 0;
	}
	
	function contain(pathData, x, y) {
	  return containPath(pathData, 0, false, x, y);
	}
	
	function containStroke(pathData, lineWidth, x, y) {
	  return containPath(pathData, lineWidth, true, x, y);
	}
	
	exports.contain = contain;
	exports.containStroke = containStroke;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	var eventUtil = __webpack_require__(30);
	
	/**
	 * Only implements needed gestures for mobile.
	 */
	var GestureMgr = function () {
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	  this._track = [];
	};
	
	GestureMgr.prototype = {
	  constructor: GestureMgr,
	  recognize: function (event, target, root) {
	    this._doTrack(event, target, root);
	
	    return this._recognize(event);
	  },
	  clear: function () {
	    this._track.length = 0;
	    return this;
	  },
	  _doTrack: function (event, target, root) {
	    var touches = event.touches;
	
	    if (!touches) {
	      return;
	    }
	
	    var trackItem = {
	      points: [],
	      touches: [],
	      target: target,
	      event: event
	    };
	
	    for (var i = 0, len = touches.length; i < len; i++) {
	      var touch = touches[i];
	      var pos = eventUtil.clientToLocal(root, touch, {});
	      trackItem.points.push([pos.zrX, pos.zrY]);
	      trackItem.touches.push(touch);
	    }
	
	    this._track.push(trackItem);
	  },
	  _recognize: function (event) {
	    for (var eventName in recognizers) {
	      if (recognizers.hasOwnProperty(eventName)) {
	        var gestureInfo = recognizers[eventName](this._track, event);
	
	        if (gestureInfo) {
	          return gestureInfo;
	        }
	      }
	    }
	  }
	};
	
	function dist(pointPair) {
	  var dx = pointPair[1][0] - pointPair[0][0];
	  var dy = pointPair[1][1] - pointPair[0][1];
	  return Math.sqrt(dx * dx + dy * dy);
	}
	
	function center(pointPair) {
	  return [(pointPair[0][0] + pointPair[1][0]) / 2, (pointPair[0][1] + pointPair[1][1]) / 2];
	}
	
	var recognizers = {
	  pinch: function (track, event) {
	    var trackLen = track.length;
	
	    if (!trackLen) {
	      return;
	    }
	
	    var pinchEnd = (track[trackLen - 1] || {}).points;
	    var pinchPre = (track[trackLen - 2] || {}).points || pinchEnd;
	
	    if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
	      var pinchScale = dist(pinchEnd) / dist(pinchPre);
	      !isFinite(pinchScale) && (pinchScale = 1);
	      event.pinchScale = pinchScale;
	      var pinchCenter = center(pinchEnd);
	      event.pinchX = pinchCenter[0];
	      event.pinchY = pinchCenter[1];
	      return {
	        type: 'pinch',
	        target: track[0].target,
	        event: event
	      };
	    }
	  } // Only pinch currently.
	
	};
	var _default = GestureMgr;
	module.exports = _default;

/***/ }),
/* 743 */
/***/ (function(module, exports) {

	// Myers' Diff Algorithm
	// Modified from https://github.com/kpdecker/jsdiff/blob/master/src/diff/base.js
	function Diff() {}
	
	Diff.prototype = {
	  diff: function (oldArr, newArr, equals) {
	    if (!equals) {
	      equals = function (a, b) {
	        return a === b;
	      };
	    }
	
	    this.equals = equals;
	    var self = this;
	    oldArr = oldArr.slice();
	    newArr = newArr.slice(); // Allow subclasses to massage the input prior to running
	
	    var newLen = newArr.length;
	    var oldLen = oldArr.length;
	    var editLength = 1;
	    var maxEditLength = newLen + oldLen;
	    var bestPath = [{
	      newPos: -1,
	      components: []
	    }]; // Seed editLength = 0, i.e. the content starts with the same values
	
	    var oldPos = this.extractCommon(bestPath[0], newArr, oldArr, 0);
	
	    if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
	      var indices = [];
	
	      for (var i = 0; i < newArr.length; i++) {
	        indices.push(i);
	      } // Identity per the equality and tokenizer
	
	
	      return [{
	        indices: indices,
	        count: newArr.length
	      }];
	    } // Main worker method. checks all permutations of a given edit length for acceptance.
	
	
	    function execEditLength() {
	      for (var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2) {
	        var basePath;
	        var addPath = bestPath[diagonalPath - 1];
	        var removePath = bestPath[diagonalPath + 1];
	        var oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
	
	        if (addPath) {
	          // No one else is going to attempt to use this value, clear it
	          bestPath[diagonalPath - 1] = undefined;
	        }
	
	        var canAdd = addPath && addPath.newPos + 1 < newLen;
	        var canRemove = removePath && 0 <= oldPos && oldPos < oldLen;
	
	        if (!canAdd && !canRemove) {
	          // If this path is a terminal then prune
	          bestPath[diagonalPath] = undefined;
	          continue;
	        } // Select the diagonal that we want to branch from. We select the prior
	        // path whose position in the new string is the farthest from the origin
	        // and does not pass the bounds of the diff graph
	
	
	        if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
	          basePath = clonePath(removePath);
	          self.pushComponent(basePath.components, undefined, true);
	        } else {
	          basePath = addPath; // No need to clone, we've pulled it from the list
	
	          basePath.newPos++;
	          self.pushComponent(basePath.components, true, undefined);
	        }
	
	        oldPos = self.extractCommon(basePath, newArr, oldArr, diagonalPath); // If we have hit the end of both strings, then we are done
	
	        if (basePath.newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
	          return buildValues(self, basePath.components, newArr, oldArr);
	        } else {
	          // Otherwise track this path as a potential candidate and continue.
	          bestPath[diagonalPath] = basePath;
	        }
	      }
	
	      editLength++;
	    }
	
	    while (editLength <= maxEditLength) {
	      var ret = execEditLength();
	
	      if (ret) {
	        return ret;
	      }
	    }
	  },
	  pushComponent: function (components, added, removed) {
	    var last = components[components.length - 1];
	
	    if (last && last.added === added && last.removed === removed) {
	      // We need to clone here as the component clone operation is just
	      // as shallow array clone
	      components[components.length - 1] = {
	        count: last.count + 1,
	        added: added,
	        removed: removed
	      };
	    } else {
	      components.push({
	        count: 1,
	        added: added,
	        removed: removed
	      });
	    }
	  },
	  extractCommon: function (basePath, newArr, oldArr, diagonalPath) {
	    var newLen = newArr.length;
	    var oldLen = oldArr.length;
	    var newPos = basePath.newPos;
	    var oldPos = newPos - diagonalPath;
	    var commonCount = 0;
	
	    while (newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newArr[newPos + 1], oldArr[oldPos + 1])) {
	      newPos++;
	      oldPos++;
	      commonCount++;
	    }
	
	    if (commonCount) {
	      basePath.components.push({
	        count: commonCount
	      });
	    }
	
	    basePath.newPos = newPos;
	    return oldPos;
	  },
	  tokenize: function (value) {
	    return value.slice();
	  },
	  join: function (value) {
	    return value.slice();
	  }
	};
	
	function buildValues(diff, components, newArr, oldArr) {
	  var componentPos = 0;
	  var componentLen = components.length;
	  var newPos = 0;
	  var oldPos = 0;
	
	  for (; componentPos < componentLen; componentPos++) {
	    var component = components[componentPos];
	
	    if (!component.removed) {
	      var indices = [];
	
	      for (var i = newPos; i < newPos + component.count; i++) {
	        indices.push(i);
	      }
	
	      component.indices = indices;
	      newPos += component.count; // Common case
	
	      if (!component.added) {
	        oldPos += component.count;
	      }
	    } else {
	      var indices = [];
	
	      for (var i = oldPos; i < oldPos + component.count; i++) {
	        indices.push(i);
	      }
	
	      component.indices = indices;
	      oldPos += component.count;
	    }
	  }
	
	  return components;
	}
	
	function clonePath(path) {
	  return {
	    newPos: path.newPos,
	    components: path.components.slice(0)
	  };
	}
	
	var arrayDiff = new Diff();
	
	function _default(oldArr, newArr, callback) {
	  return arrayDiff.diff(oldArr, newArr, callback);
	}
	
	module.exports = _default;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	var _event = __webpack_require__(30);
	
	var addEventListener = _event.addEventListener;
	var removeEventListener = _event.removeEventListener;
	var normalizeEvent = _event.normalizeEvent;
	
	var zrUtil = __webpack_require__(1);
	
	var Eventful = __webpack_require__(49);
	
	var env = __webpack_require__(18);
	
	var GestureMgr = __webpack_require__(742);
	
	var TOUCH_CLICK_DELAY = 300;
	var mouseHandlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
	var touchHandlerNames = ['touchstart', 'touchend', 'touchmove'];
	var pointerEventNames = {
	  pointerdown: 1,
	  pointerup: 1,
	  pointermove: 1,
	  pointerout: 1
	};
	var pointerHandlerNames = zrUtil.map(mouseHandlerNames, function (name) {
	  var nm = name.replace('mouse', 'pointer');
	  return pointerEventNames[nm] ? nm : name;
	});
	
	function eventNameFix(name) {
	  return name === 'mousewheel' && env.browser.firefox ? 'DOMMouseScroll' : name;
	}
	
	function processGesture(proxy, event, stage) {
	  var gestureMgr = proxy._gestureMgr;
	  stage === 'start' && gestureMgr.clear();
	  var gestureInfo = gestureMgr.recognize(event, proxy.handler.findHover(event.zrX, event.zrY, null).target, proxy.dom);
	  stage === 'end' && gestureMgr.clear(); // Do not do any preventDefault here. Upper application do that if necessary.
	
	  if (gestureInfo) {
	    var type = gestureInfo.type;
	    event.gestureEvent = type;
	    proxy.handler.dispatchToElement({
	      target: gestureInfo.target
	    }, type, gestureInfo.event);
	  }
	} // function onMSGestureChange(proxy, event) {
	//     if (event.translationX || event.translationY) {
	//         // mousemove is carried by MSGesture to reduce the sensitivity.
	//         proxy.handler.dispatchToElement(event.target, 'mousemove', event);
	//     }
	//     if (event.scale !== 1) {
	//         event.pinchX = event.offsetX;
	//         event.pinchY = event.offsetY;
	//         event.pinchScale = event.scale;
	//         proxy.handler.dispatchToElement(event.target, 'pinch', event);
	//     }
	// }
	
	/**
	 * Prevent mouse event from being dispatched after Touch Events action
	 * @see <https://github.com/deltakosh/handjs/blob/master/src/hand.base.js>
	 * 1. Mobile browsers dispatch mouse events 300ms after touchend.
	 * 2. Chrome for Android dispatch mousedown for long-touch about 650ms
	 * Result: Blocking Mouse Events for 700ms.
	 */
	
	
	function setTouchTimer(instance) {
	  instance._touching = true;
	  clearTimeout(instance._touchTimer);
	  instance._touchTimer = setTimeout(function () {
	    instance._touching = false;
	  }, 700);
	}
	
	var domHandlers = {
	  /**
	   * Mouse move handler
	   * @inner
	   * @param {Event} event
	   */
	  mousemove: function (event) {
	    event = normalizeEvent(this.dom, event);
	    this.trigger('mousemove', event);
	  },
	
	  /**
	   * Mouse out handler
	   * @inner
	   * @param {Event} event
	   */
	  mouseout: function (event) {
	    event = normalizeEvent(this.dom, event);
	    var element = event.toElement || event.relatedTarget;
	
	    if (element != this.dom) {
	      while (element && element.nodeType != 9) {
	        // 忽略包含在root中的dom引起的mouseOut
	        if (element === this.dom) {
	          return;
	        }
	
	        element = element.parentNode;
	      }
	    }
	
	    this.trigger('mouseout', event);
	  },
	
	  /**
	   * Touch开始响应函数
	   * @inner
	   * @param {Event} event
	   */
	  touchstart: function (event) {
	    // Default mouse behaviour should not be disabled here.
	    // For example, page may needs to be slided.
	    event = normalizeEvent(this.dom, event); // Mark touch, which is useful in distinguish touch and
	    // mouse event in upper applicatoin.
	
	    event.zrByTouch = true;
	    this._lastTouchMoment = new Date();
	    processGesture(this, event, 'start'); // In touch device, trigger `mousemove`(`mouseover`) should
	    // be triggered, and must before `mousedown` triggered.
	
	    domHandlers.mousemove.call(this, event);
	    domHandlers.mousedown.call(this, event);
	    setTouchTimer(this);
	  },
	
	  /**
	   * Touch移动响应函数
	   * @inner
	   * @param {Event} event
	   */
	  touchmove: function (event) {
	    event = normalizeEvent(this.dom, event); // Mark touch, which is useful in distinguish touch and
	    // mouse event in upper applicatoin.
	
	    event.zrByTouch = true;
	    processGesture(this, event, 'change'); // Mouse move should always be triggered no matter whether
	    // there is gestrue event, because mouse move and pinch may
	    // be used at the same time.
	
	    domHandlers.mousemove.call(this, event);
	    setTouchTimer(this);
	  },
	
	  /**
	   * Touch结束响应函数
	   * @inner
	   * @param {Event} event
	   */
	  touchend: function (event) {
	    event = normalizeEvent(this.dom, event); // Mark touch, which is useful in distinguish touch and
	    // mouse event in upper applicatoin.
	
	    event.zrByTouch = true;
	    processGesture(this, event, 'end');
	    domHandlers.mouseup.call(this, event); // Do not trigger `mouseout` here, in spite of `mousemove`(`mouseover`) is
	    // triggered in `touchstart`. This seems to be illogical, but by this mechanism,
	    // we can conveniently implement "hover style" in both PC and touch device just
	    // by listening to `mouseover` to add "hover style" and listening to `mouseout`
	    // to remove "hover style" on an element, without any additional code for
	    // compatibility. (`mouseout` will not be triggered in `touchend`, so "hover
	    // style" will remain for user view)
	    // click event should always be triggered no matter whether
	    // there is gestrue event. System click can not be prevented.
	
	    if (+new Date() - this._lastTouchMoment < TOUCH_CLICK_DELAY) {
	      domHandlers.click.call(this, event);
	    }
	
	    setTouchTimer(this);
	  },
	  pointerdown: function (event) {
	    domHandlers.mousedown.call(this, event); // if (useMSGuesture(this, event)) {
	    //     this._msGesture.addPointer(event.pointerId);
	    // }
	  },
	  pointermove: function (event) {
	    // FIXME
	    // pointermove is so sensitive that it always triggered when
	    // tap(click) on touch screen, which affect some judgement in
	    // upper application. So, we dont support mousemove on MS touch
	    // device yet.
	    if (!isPointerFromTouch(event)) {
	      domHandlers.mousemove.call(this, event);
	    }
	  },
	  pointerup: function (event) {
	    domHandlers.mouseup.call(this, event);
	  },
	  pointerout: function (event) {
	    // pointerout will be triggered when tap on touch screen
	    // (IE11+/Edge on MS Surface) after click event triggered,
	    // which is inconsistent with the mousout behavior we defined
	    // in touchend. So we unify them.
	    // (check domHandlers.touchend for detailed explanation)
	    if (!isPointerFromTouch(event)) {
	      domHandlers.mouseout.call(this, event);
	    }
	  }
	};
	
	function isPointerFromTouch(event) {
	  var pointerType = event.pointerType;
	  return pointerType === 'pen' || pointerType === 'touch';
	} // function useMSGuesture(handlerProxy, event) {
	//     return isPointerFromTouch(event) && !!handlerProxy._msGesture;
	// }
	// Common handlers
	
	
	zrUtil.each(['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
	  domHandlers[name] = function (event) {
	    event = normalizeEvent(this.dom, event);
	    this.trigger(name, event);
	  };
	});
	/**
	 * 为控制类实例初始化dom 事件处理函数
	 *
	 * @inner
	 * @param {module:zrender/Handler} instance 控制类实例
	 */
	
	function initDomHandler(instance) {
	  zrUtil.each(touchHandlerNames, function (name) {
	    instance._handlers[name] = zrUtil.bind(domHandlers[name], instance);
	  });
	  zrUtil.each(pointerHandlerNames, function (name) {
	    instance._handlers[name] = zrUtil.bind(domHandlers[name], instance);
	  });
	  zrUtil.each(mouseHandlerNames, function (name) {
	    instance._handlers[name] = makeMouseHandler(domHandlers[name], instance);
	  });
	
	  function makeMouseHandler(fn, instance) {
	    return function () {
	      if (instance._touching) {
	        return;
	      }
	
	      return fn.apply(instance, arguments);
	    };
	  }
	}
	
	function HandlerDomProxy(dom) {
	  Eventful.call(this);
	  this.dom = dom;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._touching = false;
	  /**
	   * @private
	   * @type {number}
	   */
	
	  this._touchTimer;
	  /**
	   * @private
	   * @type {module:zrender/core/GestureMgr}
	   */
	
	  this._gestureMgr = new GestureMgr();
	  this._handlers = {};
	  initDomHandler(this);
	
	  if (env.pointerEventsSupported) {
	    // Only IE11+/Edge
	    // 1. On devices that both enable touch and mouse (e.g., MS Surface and lenovo X240),
	    // IE11+/Edge do not trigger touch event, but trigger pointer event and mouse event
	    // at the same time.
	    // 2. On MS Surface, it probablely only trigger mousedown but no mouseup when tap on
	    // screen, which do not occurs in pointer event.
	    // So we use pointer event to both detect touch gesture and mouse behavior.
	    mountHandlers(pointerHandlerNames, this); // FIXME
	    // Note: MS Gesture require CSS touch-action set. But touch-action is not reliable,
	    // which does not prevent defuault behavior occasionally (which may cause view port
	    // zoomed in but use can not zoom it back). And event.preventDefault() does not work.
	    // So we have to not to use MSGesture and not to support touchmove and pinch on MS
	    // touch screen. And we only support click behavior on MS touch screen now.
	    // MS Gesture Event is only supported on IE11+/Edge and on Windows 8+.
	    // We dont support touch on IE on win7.
	    // See <https://msdn.microsoft.com/en-us/library/dn433243(v=vs.85).aspx>
	    // if (typeof MSGesture === 'function') {
	    //     (this._msGesture = new MSGesture()).target = dom; // jshint ignore:line
	    //     dom.addEventListener('MSGestureChange', onMSGestureChange);
	    // }
	  } else {
	    if (env.touchEventsSupported) {
	      mountHandlers(touchHandlerNames, this); // Handler of 'mouseout' event is needed in touch mode, which will be mounted below.
	      // addEventListener(root, 'mouseout', this._mouseoutHandler);
	    } // 1. Considering some devices that both enable touch and mouse event (like on MS Surface
	    // and lenovo X240, @see #2350), we make mouse event be always listened, otherwise
	    // mouse event can not be handle in those devices.
	    // 2. On MS Surface, Chrome will trigger both touch event and mouse event. How to prevent
	    // mouseevent after touch event triggered, see `setTouchTimer`.
	
	
	    mountHandlers(mouseHandlerNames, this);
	  }
	
	  function mountHandlers(handlerNames, instance) {
	    zrUtil.each(handlerNames, function (name) {
	      addEventListener(dom, eventNameFix(name), instance._handlers[name]);
	    }, instance);
	  }
	}
	
	var handlerDomProxyProto = HandlerDomProxy.prototype;
	
	handlerDomProxyProto.dispose = function () {
	  var handlerNames = mouseHandlerNames.concat(touchHandlerNames);
	
	  for (var i = 0; i < handlerNames.length; i++) {
	    var name = handlerNames[i];
	    removeEventListener(this.dom, eventNameFix(name), this._handlers[name]);
	  }
	};
	
	handlerDomProxyProto.setCursor = function (cursorStyle) {
	  this.dom.style.cursor = cursorStyle || 'default';
	};
	
	zrUtil.mixin(HandlerDomProxy, Eventful);
	var _default = HandlerDomProxy;
	module.exports = _default;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(19);
	
	// CompoundPath to improve performance
	var _default = Path.extend({
	  type: 'compound',
	  shape: {
	    paths: null
	  },
	  _updatePathDirty: function () {
	    var dirtyPath = this.__dirtyPath;
	    var paths = this.shape.paths;
	
	    for (var i = 0; i < paths.length; i++) {
	      // Mark as dirty if any subpath is dirty
	      dirtyPath = dirtyPath || paths[i].__dirtyPath;
	    }
	
	    this.__dirtyPath = dirtyPath;
	    this.__dirty = this.__dirty || dirtyPath;
	  },
	  beforeBrush: function () {
	    this._updatePathDirty();
	
	    var paths = this.shape.paths || [];
	    var scale = this.getGlobalScale(); // Update path scale
	
	    for (var i = 0; i < paths.length; i++) {
	      if (!paths[i].path) {
	        paths[i].createPathProxy();
	      }
	
	      paths[i].path.setScale(scale[0], scale[1]);
	    }
	  },
	  buildPath: function (ctx, shape) {
	    var paths = shape.paths || [];
	
	    for (var i = 0; i < paths.length; i++) {
	      paths[i].buildPath(ctx, paths[i].shape, true);
	    }
	  },
	  afterBrush: function () {
	    var paths = this.shape.paths || [];
	
	    for (var i = 0; i < paths.length; i++) {
	      paths[i].__dirtyPath = false;
	    }
	  },
	  getBoundingRect: function () {
	    this._updatePathDirty();
	
	    return Path.prototype.getBoundingRect.call(this);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(1);
	
	var Gradient = __webpack_require__(99);
	
	/**
	 * x, y, r are all percent from 0 to 1
	 * @param {number} [x=0.5]
	 * @param {number} [y=0.5]
	 * @param {number} [r=0.5]
	 * @param {Array.<Object>} [colorStops]
	 * @param {boolean} [globalCoord=false]
	 */
	var RadialGradient = function (x, y, r, colorStops, globalCoord) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {type: 'radial', colorStops: ...}`, where
	  // this constructor will not be called.
	  this.x = x == null ? 0.5 : x;
	  this.y = y == null ? 0.5 : y;
	  this.r = r == null ? 0.5 : r; // Can be cloned
	
	  this.type = 'radial'; // If use global coord
	
	  this.global = globalCoord || false;
	  Gradient.call(this, colorStops);
	};
	
	RadialGradient.prototype = {
	  constructor: RadialGradient
	};
	zrUtil.inherits(RadialGradient, Gradient);
	var _default = RadialGradient;
	module.exports = _default;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(8);
	
	var v2Min = _vector.min;
	var v2Max = _vector.max;
	var v2Scale = _vector.scale;
	var v2Distance = _vector.distance;
	var v2Add = _vector.add;
	var v2Clone = _vector.clone;
	var v2Sub = _vector.sub;
	
	/**
	 * 贝塞尔平滑曲线
	 * @module zrender/shape/util/smoothBezier
	 * @author pissang (https://www.github.com/pissang)
	 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         errorrik (errorrik@gmail.com)
	 */
	
	/**
	 * 贝塞尔平滑曲线
	 * @alias module:zrender/shape/util/smoothBezier
	 * @param {Array} points 线段顶点数组
	 * @param {number} smooth 平滑等级, 0-1
	 * @param {boolean} isLoop
	 * @param {Array} constraint 将计算出来的控制点约束在一个包围盒内
	 *                           比如 [[0, 0], [100, 100]], 这个包围盒会与
	 *                           整个折线的包围盒做一个并集用来约束控制点。
	 * @param {Array} 计算出来的控制点数组
	 */
	function _default(points, smooth, isLoop, constraint) {
	  var cps = [];
	  var v = [];
	  var v1 = [];
	  var v2 = [];
	  var prevPoint;
	  var nextPoint;
	  var min, max;
	
	  if (constraint) {
	    min = [Infinity, Infinity];
	    max = [-Infinity, -Infinity];
	
	    for (var i = 0, len = points.length; i < len; i++) {
	      v2Min(min, min, points[i]);
	      v2Max(max, max, points[i]);
	    } // 与指定的包围盒做并集
	
	
	    v2Min(min, min, constraint[0]);
	    v2Max(max, max, constraint[1]);
	  }
	
	  for (var i = 0, len = points.length; i < len; i++) {
	    var point = points[i];
	
	    if (isLoop) {
	      prevPoint = points[i ? i - 1 : len - 1];
	      nextPoint = points[(i + 1) % len];
	    } else {
	      if (i === 0 || i === len - 1) {
	        cps.push(v2Clone(points[i]));
	        continue;
	      } else {
	        prevPoint = points[i - 1];
	        nextPoint = points[i + 1];
	      }
	    }
	
	    v2Sub(v, nextPoint, prevPoint); // use degree to scale the handle length
	
	    v2Scale(v, v, smooth);
	    var d0 = v2Distance(point, prevPoint);
	    var d1 = v2Distance(point, nextPoint);
	    var sum = d0 + d1;
	
	    if (sum !== 0) {
	      d0 /= sum;
	      d1 /= sum;
	    }
	
	    v2Scale(v1, v, -d0);
	    v2Scale(v2, v, d1);
	    var cp0 = v2Add([], point, v1);
	    var cp1 = v2Add([], point, v2);
	
	    if (constraint) {
	      v2Max(cp0, cp0, min);
	      v2Min(cp0, cp0, max);
	      v2Max(cp1, cp1, min);
	      v2Min(cp1, cp1, max);
	    }
	
	    cps.push(cp0);
	    cps.push(cp1);
	  }
	
	  if (isLoop) {
	    cps.push(cps.shift());
	  }
	
	  return cps;
	}
	
	module.exports = _default;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(8);
	
	var v2Distance = _vector.distance;
	
	/**
	 * Catmull-Rom spline 插值折线
	 * @module zrender/shape/util/smoothSpline
	 * @author pissang (https://www.github.com/pissang)
	 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         errorrik (errorrik@gmail.com)
	 */
	
	/**
	 * @inner
	 */
	function interpolate(p0, p1, p2, p3, t, t2, t3) {
	  var v0 = (p2 - p0) * 0.5;
	  var v1 = (p3 - p1) * 0.5;
	  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
	}
	/**
	 * @alias module:zrender/shape/util/smoothSpline
	 * @param {Array} points 线段顶点数组
	 * @param {boolean} isLoop
	 * @return {Array}
	 */
	
	
	function _default(points, isLoop) {
	  var len = points.length;
	  var ret = [];
	  var distance = 0;
	
	  for (var i = 1; i < len; i++) {
	    distance += v2Distance(points[i - 1], points[i]);
	  }
	
	  var segs = distance / 2;
	  segs = segs < len ? len : segs;
	
	  for (var i = 0; i < segs; i++) {
	    var pos = i / (segs - 1) * (isLoop ? len : len - 1);
	    var idx = Math.floor(pos);
	    var w = pos - idx;
	    var p0;
	    var p1 = points[idx % len];
	    var p2;
	    var p3;
	
	    if (!isLoop) {
	      p0 = points[idx === 0 ? idx : idx - 1];
	      p2 = points[idx > len - 2 ? len - 1 : idx + 1];
	      p3 = points[idx > len - 3 ? len - 1 : idx + 2];
	    } else {
	      p0 = points[(idx - 1 + len) % len];
	      p2 = points[(idx + 1) % len];
	      p3 = points[(idx + 2) % len];
	    }
	
	    var w2 = w * w;
	    var w3 = w * w2;
	    ret.push([interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3), interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)]);
	  }
	
	  return ret;
	}
	
	module.exports = _default;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(19);
	
	/**
	 * 圆弧
	 * @module zrender/graphic/shape/Arc
	 */
	var _default = Path.extend({
	  type: 'arc',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0,
	    startAngle: 0,
	    endAngle: Math.PI * 2,
	    clockwise: true
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var r = Math.max(shape.r, 0);
	    var startAngle = shape.startAngle;
	    var endAngle = shape.endAngle;
	    var clockwise = shape.clockwise;
	    var unitX = Math.cos(startAngle);
	    var unitY = Math.sin(startAngle);
	    ctx.moveTo(unitX * r + x, unitY * r + y);
	    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(19);
	
	var vec2 = __webpack_require__(8);
	
	var _curve = __webpack_require__(40);
	
	var quadraticSubdivide = _curve.quadraticSubdivide;
	var cubicSubdivide = _curve.cubicSubdivide;
	var quadraticAt = _curve.quadraticAt;
	var cubicAt = _curve.cubicAt;
	var quadraticDerivativeAt = _curve.quadraticDerivativeAt;
	var cubicDerivativeAt = _curve.cubicDerivativeAt;
	
	/**
	 * 贝塞尔曲线
	 * @module zrender/shape/BezierCurve
	 */
	var out = [];
	
	function someVectorAt(shape, t, isTangent) {
	  var cpx2 = shape.cpx2;
	  var cpy2 = shape.cpy2;
	
	  if (cpx2 === null || cpy2 === null) {
	    return [(isTangent ? cubicDerivativeAt : cubicAt)(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t), (isTangent ? cubicDerivativeAt : cubicAt)(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)];
	  } else {
	    return [(isTangent ? quadraticDerivativeAt : quadraticAt)(shape.x1, shape.cpx1, shape.x2, t), (isTangent ? quadraticDerivativeAt : quadraticAt)(shape.y1, shape.cpy1, shape.y2, t)];
	  }
	}
	
	var _default = Path.extend({
	  type: 'bezier-curve',
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    cpx1: 0,
	    cpy1: 0,
	    // cpx2: 0,
	    // cpy2: 0
	    // Curve show percent, for animating
	    percent: 1
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x1 = shape.x1;
	    var y1 = shape.y1;
	    var x2 = shape.x2;
	    var y2 = shape.y2;
	    var cpx1 = shape.cpx1;
	    var cpy1 = shape.cpy1;
	    var cpx2 = shape.cpx2;
	    var cpy2 = shape.cpy2;
	    var percent = shape.percent;
	
	    if (percent === 0) {
	      return;
	    }
	
	    ctx.moveTo(x1, y1);
	
	    if (cpx2 == null || cpy2 == null) {
	      if (percent < 1) {
	        quadraticSubdivide(x1, cpx1, x2, percent, out);
	        cpx1 = out[1];
	        x2 = out[2];
	        quadraticSubdivide(y1, cpy1, y2, percent, out);
	        cpy1 = out[1];
	        y2 = out[2];
	      }
	
	      ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
	    } else {
	      if (percent < 1) {
	        cubicSubdivide(x1, cpx1, cpx2, x2, percent, out);
	        cpx1 = out[1];
	        cpx2 = out[2];
	        x2 = out[3];
	        cubicSubdivide(y1, cpy1, cpy2, y2, percent, out);
	        cpy1 = out[1];
	        cpy2 = out[2];
	        y2 = out[3];
	      }
	
	      ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
	    }
	  },
	
	  /**
	   * Get point at percent
	   * @param  {number} t
	   * @return {Array.<number>}
	   */
	  pointAt: function (t) {
	    return someVectorAt(this.shape, t, false);
	  },
	
	  /**
	   * Get tangent at percent
	   * @param  {number} t
	   * @return {Array.<number>}
	   */
	  tangentAt: function (t) {
	    var p = someVectorAt(this.shape, t, true);
	    return vec2.normalize(p, p);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(19);
	
	/**
	 * 圆形
	 * @module zrender/shape/Circle
	 */
	var _default = Path.extend({
	  type: 'circle',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0
	  },
	  buildPath: function (ctx, shape, inBundle) {
	    // Better stroking in ShapeBundle
	    // Always do it may have performence issue ( fill may be 2x more cost)
	    if (inBundle) {
	      ctx.moveTo(shape.cx + shape.r, shape.cy);
	    } // else {
	    //     if (ctx.allocate && !ctx.data.length) {
	    //         ctx.allocate(ctx.CMD_MEM_SIZE.A);
	    //     }
	    // }
	    // Better stroking in ShapeBundle
	    // ctx.moveTo(shape.cx + shape.r, shape.cy);
	
	
	    ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2, true);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(19);
	
	/**
	 * 直线
	 * @module zrender/graphic/shape/Line
	 */
	var _default = Path.extend({
	  type: 'line',
	  shape: {
	    // Start point
	    x1: 0,
	    y1: 0,
	    // End point
	    x2: 0,
	    y2: 0,
	    percent: 1
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x1 = shape.x1;
	    var y1 = shape.y1;
	    var x2 = shape.x2;
	    var y2 = shape.y2;
	    var percent = shape.percent;
	
	    if (percent === 0) {
	      return;
	    }
	
	    ctx.moveTo(x1, y1);
	
	    if (percent < 1) {
	      x2 = x1 * (1 - percent) + x2 * percent;
	      y2 = y1 * (1 - percent) + y2 * percent;
	    }
	
	    ctx.lineTo(x2, y2);
	  },
	
	  /**
	   * Get point at percent
	   * @param  {number} percent
	   * @return {Array.<number>}
	   */
	  pointAt: function (p) {
	    var shape = this.shape;
	    return [shape.x1 * (1 - p) + shape.x2 * p, shape.y1 * (1 - p) + shape.y2 * p];
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(19);
	
	var polyHelper = __webpack_require__(227);
	
	/**
	 * 多边形
	 * @module zrender/shape/Polygon
	 */
	var _default = Path.extend({
	  type: 'polygon',
	  shape: {
	    points: null,
	    smooth: false,
	    smoothConstraint: null
	  },
	  buildPath: function (ctx, shape) {
	    polyHelper.buildPath(ctx, shape, true);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(19);
	
	var polyHelper = __webpack_require__(227);
	
	/**
	 * @module zrender/graphic/shape/Polyline
	 */
	var _default = Path.extend({
	  type: 'polyline',
	  shape: {
	    points: null,
	    smooth: false,
	    smoothConstraint: null
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    polyHelper.buildPath(ctx, shape, false);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(19);
	
	var roundRectHelper = __webpack_require__(228);
	
	/**
	 * 矩形
	 * @module zrender/graphic/shape/Rect
	 */
	var _default = Path.extend({
	  type: 'rect',
	  shape: {
	    // 左上、右上、右下、左下角的半径依次为r1、r2、r3、r4
	    // r缩写为1         相当于 [1, 1, 1, 1]
	    // r缩写为[1]       相当于 [1, 1, 1, 1]
	    // r缩写为[1, 2]    相当于 [1, 2, 1, 2]
	    // r缩写为[1, 2, 3] 相当于 [1, 2, 3, 2]
	    r: 0,
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.x;
	    var y = shape.y;
	    var width = shape.width;
	    var height = shape.height;
	
	    if (!shape.r) {
	      ctx.rect(x, y, width, height);
	    } else {
	      roundRectHelper.buildPath(ctx, shape);
	    }
	
	    ctx.closePath();
	    return;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(19);
	
	/**
	 * 圆环
	 * @module zrender/graphic/shape/Ring
	 */
	var _default = Path.extend({
	  type: 'ring',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0,
	    r0: 0
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var PI2 = Math.PI * 2;
	    ctx.moveTo(x + shape.r, y);
	    ctx.arc(x, y, shape.r, 0, PI2, false);
	    ctx.moveTo(x + shape.r0, y);
	    ctx.arc(x, y, shape.r0, 0, PI2, true);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(19);
	
	var fixClipWithShadow = __webpack_require__(226);
	
	/**
	 * 扇形
	 * @module zrender/graphic/shape/Sector
	 */
	var _default = Path.extend({
	  type: 'sector',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r0: 0,
	    r: 0,
	    startAngle: 0,
	    endAngle: Math.PI * 2,
	    clockwise: true
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var r0 = Math.max(shape.r0 || 0, 0);
	    var r = Math.max(shape.r, 0);
	    var startAngle = shape.startAngle;
	    var endAngle = shape.endAngle;
	    var clockwise = shape.clockwise;
	    var unitX = Math.cos(startAngle);
	    var unitY = Math.sin(startAngle);
	    ctx.moveTo(unitX * r0 + x, unitY * r0 + y);
	    ctx.lineTo(unitX * r + x, unitY * r + y);
	    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	    ctx.lineTo(Math.cos(endAngle) * r0 + x, Math.sin(endAngle) * r0 + y);
	
	    if (r0 !== 0) {
	      ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
	    }
	
	    ctx.closePath();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	var Animator = __webpack_require__(214);
	
	var log = __webpack_require__(74);
	
	var _util = __webpack_require__(1);
	
	var isString = _util.isString;
	var isFunction = _util.isFunction;
	var isObject = _util.isObject;
	var isArrayLike = _util.isArrayLike;
	var indexOf = _util.indexOf;
	
	/**
	 * @alias modue:zrender/mixin/Animatable
	 * @constructor
	 */
	var Animatable = function () {
	  /**
	   * @type {Array.<module:zrender/animation/Animator>}
	   * @readOnly
	   */
	  this.animators = [];
	};
	
	Animatable.prototype = {
	  constructor: Animatable,
	
	  /**
	   * 动画
	   *
	   * @param {string} path The path to fetch value from object, like 'a.b.c'.
	   * @param {boolean} [loop] Whether to loop animation.
	   * @return {module:zrender/animation/Animator}
	   * @example:
	   *     el.animate('style', false)
	   *         .when(1000, {x: 10} )
	   *         .done(function(){ // Animation done })
	   *         .start()
	   */
	  animate: function (path, loop) {
	    var target;
	    var animatingShape = false;
	    var el = this;
	    var zr = this.__zr;
	
	    if (path) {
	      var pathSplitted = path.split('.');
	      var prop = el; // If animating shape
	
	      animatingShape = pathSplitted[0] === 'shape';
	
	      for (var i = 0, l = pathSplitted.length; i < l; i++) {
	        if (!prop) {
	          continue;
	        }
	
	        prop = prop[pathSplitted[i]];
	      }
	
	      if (prop) {
	        target = prop;
	      }
	    } else {
	      target = el;
	    }
	
	    if (!target) {
	      log('Property "' + path + '" is not existed in element ' + el.id);
	      return;
	    }
	
	    var animators = el.animators;
	    var animator = new Animator(target, loop);
	    animator.during(function (target) {
	      el.dirty(animatingShape);
	    }).done(function () {
	      // FIXME Animator will not be removed if use `Animator#stop` to stop animation
	      animators.splice(indexOf(animators, animator), 1);
	    });
	    animators.push(animator); // If animate after added to the zrender
	
	    if (zr) {
	      zr.animation.addAnimator(animator);
	    }
	
	    return animator;
	  },
	
	  /**
	   * 停止动画
	   * @param {boolean} forwardToLast If move to last frame before stop
	   */
	  stopAnimation: function (forwardToLast) {
	    var animators = this.animators;
	    var len = animators.length;
	
	    for (var i = 0; i < len; i++) {
	      animators[i].stop(forwardToLast);
	    }
	
	    animators.length = 0;
	    return this;
	  },
	
	  /**
	   * Caution: this method will stop previous animation.
	   * So do not use this method to one element twice before
	   * animation starts, unless you know what you are doing.
	   * @param {Object} target
	   * @param {number} [time=500] Time in ms
	   * @param {string} [easing='linear']
	   * @param {number} [delay=0]
	   * @param {Function} [callback]
	   * @param {Function} [forceAnimate] Prevent stop animation and callback
	   *        immediently when target values are the same as current values.
	   *
	   * @example
	   *  // Animate position
	   *  el.animateTo({
	   *      position: [10, 10]
	   *  }, function () { // done })
	   *
	   *  // Animate shape, style and position in 100ms, delayed 100ms, with cubicOut easing
	   *  el.animateTo({
	   *      shape: {
	   *          width: 500
	   *      },
	   *      style: {
	   *          fill: 'red'
	   *      }
	   *      position: [10, 10]
	   *  }, 100, 100, 'cubicOut', function () { // done })
	   */
	  // TODO Return animation key
	  animateTo: function (target, time, delay, easing, callback, forceAnimate) {
	    // animateTo(target, time, easing, callback);
	    if (isString(delay)) {
	      callback = easing;
	      easing = delay;
	      delay = 0;
	    } // animateTo(target, time, delay, callback);
	    else if (isFunction(easing)) {
	        callback = easing;
	        easing = 'linear';
	        delay = 0;
	      } // animateTo(target, time, callback);
	      else if (isFunction(delay)) {
	          callback = delay;
	          delay = 0;
	        } // animateTo(target, callback)
	        else if (isFunction(time)) {
	            callback = time;
	            time = 500;
	          } // animateTo(target)
	          else if (!time) {
	              time = 500;
	            } // Stop all previous animations
	
	
	    this.stopAnimation();
	
	    this._animateToShallow('', this, target, time, delay); // Animators may be removed immediately after start
	    // if there is nothing to animate
	
	
	    var animators = this.animators.slice();
	    var count = animators.length;
	
	    function done() {
	      count--;
	
	      if (!count) {
	        callback && callback();
	      }
	    } // No animators. This should be checked before animators[i].start(),
	    // because 'done' may be executed immediately if no need to animate.
	
	
	    if (!count) {
	      callback && callback();
	    } // Start after all animators created
	    // Incase any animator is done immediately when all animation properties are not changed
	
	
	    for (var i = 0; i < animators.length; i++) {
	      animators[i].done(done).start(easing, forceAnimate);
	    }
	  },
	
	  /**
	   * @private
	   * @param {string} path=''
	   * @param {Object} source=this
	   * @param {Object} target
	   * @param {number} [time=500]
	   * @param {number} [delay=0]
	   *
	   * @example
	   *  // Animate position
	   *  el._animateToShallow({
	   *      position: [10, 10]
	   *  })
	   *
	   *  // Animate shape, style and position in 100ms, delayed 100ms
	   *  el._animateToShallow({
	   *      shape: {
	   *          width: 500
	   *      },
	   *      style: {
	   *          fill: 'red'
	   *      }
	   *      position: [10, 10]
	   *  }, 100, 100)
	   */
	  _animateToShallow: function (path, source, target, time, delay) {
	    var objShallow = {};
	    var propertyCount = 0;
	
	    for (var name in target) {
	      if (!target.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (source[name] != null) {
	        if (isObject(target[name]) && !isArrayLike(target[name])) {
	          this._animateToShallow(path ? path + '.' + name : name, source[name], target[name], time, delay);
	        } else {
	          objShallow[name] = target[name];
	          propertyCount++;
	        }
	      } else if (target[name] != null) {
	        // Attr directly if not has property
	        // FIXME, if some property not needed for element ?
	        if (!path) {
	          this.attr(name, target[name]);
	        } else {
	          // Shape or style
	          var props = {};
	          props[path] = {};
	          props[path][name] = target[name];
	          this.attr(props);
	        }
	      }
	    }
	
	    if (propertyCount > 0) {
	      this.animate(path, false).when(time == null ? 500 : time, objShallow).delay(delay || 0);
	    }
	
	    return this;
	  }
	};
	var _default = Animatable;
	module.exports = _default;

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	// TODO Draggable for group
	// FIXME Draggable on element which has parent rotation or scale
	function Draggable() {
	  this.on('mousedown', this._dragStart, this);
	  this.on('mousemove', this._drag, this);
	  this.on('mouseup', this._dragEnd, this);
	  this.on('globalout', this._dragEnd, this); // this._dropTarget = null;
	  // this._draggingTarget = null;
	  // this._x = 0;
	  // this._y = 0;
	}
	
	Draggable.prototype = {
	  constructor: Draggable,
	  _dragStart: function (e) {
	    var draggingTarget = e.target;
	
	    if (draggingTarget && draggingTarget.draggable) {
	      this._draggingTarget = draggingTarget;
	      draggingTarget.dragging = true;
	      this._x = e.offsetX;
	      this._y = e.offsetY;
	      this.dispatchToElement(param(draggingTarget, e), 'dragstart', e.event);
	    }
	  },
	  _drag: function (e) {
	    var draggingTarget = this._draggingTarget;
	
	    if (draggingTarget) {
	      var x = e.offsetX;
	      var y = e.offsetY;
	      var dx = x - this._x;
	      var dy = y - this._y;
	      this._x = x;
	      this._y = y;
	      draggingTarget.drift(dx, dy, e);
	      this.dispatchToElement(param(draggingTarget, e), 'drag', e.event);
	      var dropTarget = this.findHover(x, y, draggingTarget).target;
	      var lastDropTarget = this._dropTarget;
	      this._dropTarget = dropTarget;
	
	      if (draggingTarget !== dropTarget) {
	        if (lastDropTarget && dropTarget !== lastDropTarget) {
	          this.dispatchToElement(param(lastDropTarget, e), 'dragleave', e.event);
	        }
	
	        if (dropTarget && dropTarget !== lastDropTarget) {
	          this.dispatchToElement(param(dropTarget, e), 'dragenter', e.event);
	        }
	      }
	    }
	  },
	  _dragEnd: function (e) {
	    var draggingTarget = this._draggingTarget;
	
	    if (draggingTarget) {
	      draggingTarget.dragging = false;
	    }
	
	    this.dispatchToElement(param(draggingTarget, e), 'dragend', e.event);
	
	    if (this._dropTarget) {
	      this.dispatchToElement(param(this._dropTarget, e), 'drop', e.event);
	    }
	
	    this._draggingTarget = null;
	    this._dropTarget = null;
	  }
	};
	
	function param(target, e) {
	  return {
	    target: target,
	    topTarget: e && e.topTarget
	  };
	}
	
	var _default = Draggable;
	module.exports = _default;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(140);
	
	var createElement = _core.createElement;
	
	var util = __webpack_require__(1);
	
	var each = util.each;
	
	var zrLog = __webpack_require__(74);
	
	var Path = __webpack_require__(19);
	
	var ZImage = __webpack_require__(75);
	
	var ZText = __webpack_require__(76);
	
	var arrayDiff = __webpack_require__(743);
	
	var GradientManager = __webpack_require__(762);
	
	var ClippathManager = __webpack_require__(761);
	
	var _graphic = __webpack_require__(141);
	
	var svgPath = _graphic.path;
	var svgImage = _graphic.image;
	var svgText = _graphic.text;
	
	/**
	 * SVG Painter
	 * @module zrender/svg/Painter
	 */
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	
	function getSvgProxy(el) {
	  if (el instanceof Path) {
	    return svgPath;
	  } else if (el instanceof ZImage) {
	    return svgImage;
	  } else if (el instanceof ZText) {
	    return svgText;
	  } else {
	    return svgPath;
	  }
	}
	
	function checkParentAvailable(parent, child) {
	  return child && parent && child.parentNode !== parent;
	}
	
	function insertAfter(parent, child, prevSibling) {
	  if (checkParentAvailable(parent, child) && prevSibling) {
	    var nextSibling = prevSibling.nextSibling;
	    nextSibling ? parent.insertBefore(child, nextSibling) : parent.appendChild(child);
	  }
	}
	
	function prepend(parent, child) {
	  if (checkParentAvailable(parent, child)) {
	    var firstChild = parent.firstChild;
	    firstChild ? parent.insertBefore(child, firstChild) : parent.appendChild(child);
	  }
	}
	
	function append(parent, child) {
	  if (checkParentAvailable(parent, child)) {
	    parent.appendChild(child);
	  }
	}
	
	function remove(parent, child) {
	  if (child && parent && child.parentNode === parent) {
	    parent.removeChild(child);
	  }
	}
	
	function getTextSvgElement(displayable) {
	  return displayable.__textSvgEl;
	}
	
	function getSvgElement(displayable) {
	  return displayable.__svgEl;
	}
	/**
	 * @alias module:zrender/svg/Painter
	 * @constructor
	 * @param {HTMLElement} root 绘图容器
	 * @param {module:zrender/Storage} storage
	 * @param {Object} opts
	 */
	
	
	var SVGPainter = function (root, storage, opts) {
	  this.root = root;
	  this.storage = storage;
	  this._opts = opts = util.extend({}, opts || {});
	  var svgRoot = createElement('svg');
	  svgRoot.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
	  svgRoot.setAttribute('version', '1.1');
	  svgRoot.setAttribute('baseProfile', 'full');
	  svgRoot.style['user-select'] = 'none';
	  svgRoot.style.cssText = 'position:absolute;left:0;top:0;';
	  this.gradientManager = new GradientManager(svgRoot);
	  this.clipPathManager = new ClippathManager(svgRoot);
	  var viewport = document.createElement('div');
	  viewport.style.cssText = 'overflow:hidden;position:relative';
	  this._svgRoot = svgRoot;
	  this._viewport = viewport;
	  root.appendChild(viewport);
	  viewport.appendChild(svgRoot);
	  this.resize(opts.width, opts.height);
	  this._visibleList = [];
	};
	
	SVGPainter.prototype = {
	  constructor: SVGPainter,
	  getType: function () {
	    return 'svg';
	  },
	  getViewportRoot: function () {
	    return this._viewport;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	  refresh: function () {
	    var list = this.storage.getDisplayList(true);
	
	    this._paintList(list);
	  },
	  _paintList: function (list) {
	    this.gradientManager.markAllUnused();
	    this.clipPathManager.markAllUnused();
	    var svgRoot = this._svgRoot;
	    var visibleList = this._visibleList;
	    var listLen = list.length;
	    var newVisibleList = [];
	    var i;
	
	    for (i = 0; i < listLen; i++) {
	      var displayable = list[i];
	      var svgProxy = getSvgProxy(displayable);
	
	      if (!displayable.invisible) {
	        if (displayable.__dirty) {
	          svgProxy && svgProxy.brush(displayable); // Update clipPath
	
	          this.clipPathManager.update(displayable); // Update gradient
	
	          if (displayable.style) {
	            this.gradientManager.update(displayable.style.fill);
	            this.gradientManager.update(displayable.style.stroke);
	          }
	
	          displayable.__dirty = false;
	        }
	
	        newVisibleList.push(displayable);
	      }
	    }
	
	    var diff = arrayDiff(visibleList, newVisibleList);
	    var prevSvgElement; // First do remove, in case element moved to the head and do remove
	    // after add
	
	    for (i = 0; i < diff.length; i++) {
	      var item = diff[i];
	
	      if (item.removed) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = visibleList[item.indices[k]];
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          remove(svgRoot, svgElement);
	          remove(svgRoot, textSvgElement);
	        }
	      }
	    }
	
	    for (i = 0; i < diff.length; i++) {
	      var item = diff[i];
	
	      if (item.added) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = newVisibleList[item.indices[k]];
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          prevSvgElement ? insertAfter(svgRoot, svgElement, prevSvgElement) : prepend(svgRoot, svgElement);
	
	          if (svgElement) {
	            insertAfter(svgRoot, textSvgElement, svgElement);
	          } else if (prevSvgElement) {
	            insertAfter(svgRoot, textSvgElement, prevSvgElement);
	          } else {
	            prepend(svgRoot, textSvgElement);
	          } // Insert text
	
	
	          insertAfter(svgRoot, textSvgElement, svgElement);
	          prevSvgElement = textSvgElement || svgElement || prevSvgElement;
	          this.gradientManager.addWithoutUpdate(svgElement, displayable);
	          this.clipPathManager.markUsed(displayable);
	        }
	      } else if (!item.removed) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = newVisibleList[item.indices[k]];
	          prevSvgElement = svgElement = getTextSvgElement(displayable) || getSvgElement(displayable) || prevSvgElement;
	          this.gradientManager.markUsed(displayable);
	          this.gradientManager.addWithoutUpdate(svgElement, displayable);
	          this.clipPathManager.markUsed(displayable);
	        }
	      }
	    }
	
	    this.gradientManager.removeUnused();
	    this.clipPathManager.removeUnused();
	    this._visibleList = newVisibleList;
	  },
	  _getDefs: function (isForceCreating) {
	    var svgRoot = this._svgRoot;
	
	    var defs = this._svgRoot.getElementsByTagName('defs');
	
	    if (defs.length === 0) {
	      // Not exist
	      if (isForceCreating) {
	        var defs = svgRoot.insertBefore(createElement('defs'), // Create new tag
	        svgRoot.firstChild // Insert in the front of svg
	        );
	
	        if (!defs.contains) {
	          // IE doesn't support contains method
	          defs.contains = function (el) {
	            var children = defs.children;
	
	            if (!children) {
	              return false;
	            }
	
	            for (var i = children.length - 1; i >= 0; --i) {
	              if (children[i] === el) {
	                return true;
	              }
	            }
	
	            return false;
	          };
	        }
	
	        return defs;
	      } else {
	        return null;
	      }
	    } else {
	      return defs[0];
	    }
	  },
	  resize: function (width, height) {
	    var viewport = this._viewport; // FIXME Why ?
	
	    viewport.style.display = 'none'; // Save input w/h
	
	    var opts = this._opts;
	    width != null && (opts.width = width);
	    height != null && (opts.height = height);
	    width = this._getSize(0);
	    height = this._getSize(1);
	    viewport.style.display = '';
	
	    if (this._width !== width && this._height !== height) {
	      this._width = width;
	      this._height = height;
	      var viewportStyle = viewport.style;
	      viewportStyle.width = width + 'px';
	      viewportStyle.height = height + 'px';
	      var svgRoot = this._svgRoot; // Set width by 'svgRoot.width = width' is invalid
	
	      svgRoot.setAttribute('width', width);
	      svgRoot.setAttribute('height', height);
	    }
	  },
	
	  /**
	   * 获取绘图区域宽度
	   */
	  getWidth: function () {
	    return this._width;
	  },
	
	  /**
	   * 获取绘图区域高度
	   */
	  getHeight: function () {
	    return this._height;
	  },
	  _getSize: function (whIdx) {
	    var opts = this._opts;
	    var wh = ['width', 'height'][whIdx];
	    var cwh = ['clientWidth', 'clientHeight'][whIdx];
	    var plt = ['paddingLeft', 'paddingTop'][whIdx];
	    var prb = ['paddingRight', 'paddingBottom'][whIdx];
	
	    if (opts[wh] != null && opts[wh] !== 'auto') {
	      return parseFloat(opts[wh]);
	    }
	
	    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.
	
	    var stl = document.defaultView.getComputedStyle(root);
	    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
	  },
	  dispose: function () {
	    this.root.innerHTML = '';
	    this._svgRoot = this._viewport = this.storage = null;
	  },
	  clear: function () {
	    if (this._viewport) {
	      this.root.removeChild(this._viewport);
	    }
	  },
	  pathToSvg: function () {
	    this.refresh();
	    var html = this._svgRoot.outerHTML;
	    return 'data:img/svg+xml;utf-8,' + unescape(html);
	  }
	}; // Not supported methods
	
	function createMethodNotSupport(method) {
	  return function () {
	    zrLog('In SVG mode painter not support method "' + method + '"');
	  };
	} // Unsuppoted methods
	
	
	each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'toDataURL', 'pathToImage'], function (name) {
	  SVGPainter.prototype[name] = createMethodNotSupport(name);
	});
	var _default = SVGPainter;
	module.exports = _default;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(230);
	
	var zrUtil = __webpack_require__(1);
	
	var matrix = __webpack_require__(23);
	
	/**
	 * @file Manages SVG clipPath elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG clipPath elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function ClippathManager(svgRoot) {
	  Definable.call(this, svgRoot, 'clipPath', '__clippath_in_use__');
	}
	
	zrUtil.inherits(ClippathManager, Definable);
	/**
	 * Update clipPath.
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	ClippathManager.prototype.update = function (displayable) {
	  var svgEl = this.getSvgElement(displayable);
	
	  if (svgEl) {
	    this.updateDom(svgEl, displayable.__clipPaths, false);
	  }
	
	  var textEl = this.getTextSvgElement(displayable);
	
	  if (textEl) {
	    // Make another clipPath for text, since it's transform
	    // matrix is not the same with svgElement
	    this.updateDom(textEl, displayable.__clipPaths, true);
	  }
	
	  this.markUsed(displayable);
	};
	/**
	 * Create an SVGElement of displayable and create a <clipPath> of its
	 * clipPath
	 *
	 * @param {Displayable} parentEl  parent element
	 * @param {ClipPath[]}  clipPaths clipPaths of parent element
	 * @param {boolean}     isText    if parent element is Text
	 */
	
	
	ClippathManager.prototype.updateDom = function (parentEl, clipPaths, isText) {
	  if (clipPaths && clipPaths.length > 0) {
	    // Has clipPath, create <clipPath> with the first clipPath
	    var defs = this.getDefs(true);
	    var clipPath = clipPaths[0];
	    var clipPathEl;
	    var id;
	    var dom = isText ? '_textDom' : '_dom';
	
	    if (clipPath[dom]) {
	      // Use a dom that is already in <defs>
	      id = clipPath[dom].getAttribute('id');
	      clipPathEl = clipPath[dom]; // Use a dom that is already in <defs>
	
	      if (!defs.contains(clipPathEl)) {
	        // This happens when set old clipPath that has
	        // been previously removed
	        defs.appendChild(clipPathEl);
	      }
	    } else {
	      // New <clipPath>
	      id = 'zr-clip-' + this.nextId;
	      ++this.nextId;
	      clipPathEl = this.createElement('clipPath');
	      clipPathEl.setAttribute('id', id);
	      defs.appendChild(clipPathEl);
	      clipPath[dom] = clipPathEl;
	    } // Build path and add to <clipPath>
	
	
	    var svgProxy = this.getSvgProxy(clipPath);
	
	    if (clipPath.transform && clipPath.parent.invTransform && !isText) {
	      /**
	       * If a clipPath has a parent with transform, the transform
	       * of parent should not be considered when setting transform
	       * of clipPath. So we need to transform back from parent's
	       * transform, which is done by multiplying parent's inverse
	       * transform.
	       */
	      // Store old transform
	      var transform = Array.prototype.slice.call(clipPath.transform); // Transform back from parent, and brush path
	
	      matrix.mul(clipPath.transform, clipPath.parent.invTransform, clipPath.transform);
	      svgProxy.brush(clipPath); // Set back transform of clipPath
	
	      clipPath.transform = transform;
	    } else {
	      svgProxy.brush(clipPath);
	    }
	
	    var pathEl = this.getSvgElement(clipPath);
	    /**
	     * Use `cloneNode()` here to appendChild to multiple parents,
	     * which may happend when Text and other shapes are using the same
	     * clipPath. Since Text will create an extra clipPath DOM due to
	     * different transform rules.
	     */
	
	    clipPathEl.appendChild(pathEl.cloneNode());
	    parentEl.setAttribute('clip-path', 'url(#' + id + ')');
	
	    if (clipPaths.length > 1) {
	      // Make the other clipPaths recursively
	      this.updateDom(clipPathEl, clipPaths.slice(1), isText);
	    }
	  } else {
	    // No clipPath
	    if (parentEl) {
	      parentEl.setAttribute('clip-path', 'none');
	    }
	  }
	};
	/**
	 * Mark a single clipPath to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	ClippathManager.prototype.markUsed = function (displayable) {
	  var that = this;
	
	  if (displayable.__clipPaths && displayable.__clipPaths.length > 0) {
	    zrUtil.each(displayable.__clipPaths, function (clipPath) {
	      if (clipPath._dom) {
	        Definable.prototype.markUsed.call(that, clipPath._dom);
	      }
	
	      if (clipPath._textDom) {
	        Definable.prototype.markUsed.call(that, clipPath._textDom);
	      }
	    });
	  }
	};
	
	var _default = ClippathManager;
	module.exports = _default;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(230);
	
	var zrUtil = __webpack_require__(1);
	
	var zrLog = __webpack_require__(74);
	
	/**
	 * @file Manages SVG gradient elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG gradient elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function GradientManager(svgRoot) {
	  Definable.call(this, svgRoot, ['linearGradient', 'radialGradient'], '__gradient_in_use__');
	}
	
	zrUtil.inherits(GradientManager, Definable);
	/**
	 * Create new gradient DOM for fill or stroke if not exist,
	 * but will not update gradient if exists.
	 *
	 * @param {SvgElement}  svgElement   SVG element to paint
	 * @param {Displayable} displayable  zrender displayable element
	 */
	
	GradientManager.prototype.addWithoutUpdate = function (svgElement, displayable) {
	  if (displayable && displayable.style) {
	    var that = this;
	    zrUtil.each(['fill', 'stroke'], function (fillOrStroke) {
	      if (displayable.style[fillOrStroke] && (displayable.style[fillOrStroke].type === 'linear' || displayable.style[fillOrStroke].type === 'radial')) {
	        var gradient = displayable.style[fillOrStroke];
	        var defs = that.getDefs(true); // Create dom in <defs> if not exists
	
	        var dom;
	
	        if (gradient._dom) {
	          // Gradient exists
	          dom = gradient._dom;
	
	          if (!defs.contains(gradient._dom)) {
	            // _dom is no longer in defs, recreate
	            that.addDom(dom);
	          }
	        } else {
	          // New dom
	          dom = that.add(gradient);
	        }
	
	        that.markUsed(displayable);
	        var id = dom.getAttribute('id');
	        svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
	      }
	    });
	  }
	};
	/**
	 * Add a new gradient tag in <defs>
	 *
	 * @param   {Gradient} gradient zr gradient instance
	 * @return {SVGLinearGradientElement | SVGRadialGradientElement}
	 *                            created DOM
	 */
	
	
	GradientManager.prototype.add = function (gradient) {
	  var dom;
	
	  if (gradient.type === 'linear') {
	    dom = this.createElement('linearGradient');
	  } else if (gradient.type === 'radial') {
	    dom = this.createElement('radialGradient');
	  } else {
	    zrLog('Illegal gradient type.');
	    return null;
	  } // Set dom id with gradient id, since each gradient instance
	  // will have no more than one dom element.
	  // id may exists before for those dirty elements, in which case
	  // id should remain the same, and other attributes should be
	  // updated.
	
	
	  gradient.id = gradient.id || this.nextId++;
	  dom.setAttribute('id', 'zr-gradient-' + gradient.id);
	  this.updateDom(gradient, dom);
	  this.addDom(dom);
	  return dom;
	};
	/**
	 * Update gradient.
	 *
	 * @param {Gradient} gradient zr gradient instance
	 */
	
	
	GradientManager.prototype.update = function (gradient) {
	  var that = this;
	  Definable.prototype.update.call(this, gradient, function () {
	    var type = gradient.type;
	    var tagName = gradient._dom.tagName;
	
	    if (type === 'linear' && tagName === 'linearGradient' || type === 'radial' && tagName === 'radialGradient') {
	      // Gradient type is not changed, update gradient
	      that.updateDom(gradient, gradient._dom);
	    } else {
	      // Remove and re-create if type is changed
	      that.removeDom(gradient);
	      that.add(gradient);
	    }
	  });
	};
	/**
	 * Update gradient dom
	 *
	 * @param {Gradient} gradient zr gradient instance
	 * @param {SVGLinearGradientElement | SVGRadialGradientElement} dom
	 *                            DOM to update
	 */
	
	
	GradientManager.prototype.updateDom = function (gradient, dom) {
	  if (gradient.type === 'linear') {
	    dom.setAttribute('x1', gradient.x);
	    dom.setAttribute('y1', gradient.y);
	    dom.setAttribute('x2', gradient.x2);
	    dom.setAttribute('y2', gradient.y2);
	  } else if (gradient.type === 'radial') {
	    dom.setAttribute('cx', gradient.x);
	    dom.setAttribute('cy', gradient.y);
	    dom.setAttribute('r', gradient.r);
	  } else {
	    zrLog('Illegal gradient type.');
	    return;
	  }
	
	  if (gradient.global) {
	    // x1, x2, y1, y2 in range of 0 to canvas width or height
	    dom.setAttribute('gradientUnits', 'userSpaceOnUse');
	  } else {
	    // x1, x2, y1, y2 in range of 0 to 1
	    dom.setAttribute('gradientUnits', 'objectBoundingBox');
	  } // Remove color stops if exists
	
	
	  dom.innerHTML = ''; // Add color stops
	
	  var colors = gradient.colorStops;
	
	  for (var i = 0, len = colors.length; i < len; ++i) {
	    var stop = this.createElement('stop');
	    stop.setAttribute('offset', colors[i].offset * 100 + '%');
	    stop.setAttribute('stop-color', colors[i].color);
	    dom.appendChild(stop);
	  } // Store dom element in gradient, to avoid creating multiple
	  // dom instances for the same gradient element
	
	
	  gradient._dom = dom;
	};
	/**
	 * Mark a single gradient to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	GradientManager.prototype.markUsed = function (displayable) {
	  if (displayable.style) {
	    var gradient = displayable.style.fill;
	
	    if (gradient && gradient._dom) {
	      Definable.prototype.markUsed.call(this, gradient._dom);
	    }
	
	    gradient = displayable.style.stroke;
	
	    if (gradient && gradient._dom) {
	      Definable.prototype.markUsed.call(this, gradient._dom);
	    }
	  }
	};
	
	var _default = GradientManager;
	module.exports = _default;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(141);
	
	var _zrender = __webpack_require__(101);
	
	var registerPainter = _zrender.registerPainter;
	
	var Painter = __webpack_require__(760);
	
	registerPainter('svg', Painter);

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(19);
	
	var PathProxy = __webpack_require__(60);
	
	var transformPath = __webpack_require__(765);
	
	// command chars
	var cc = ['m', 'M', 'l', 'L', 'v', 'V', 'h', 'H', 'z', 'Z', 'c', 'C', 'q', 'Q', 't', 'T', 's', 'S', 'a', 'A'];
	var mathSqrt = Math.sqrt;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI = Math.PI;
	
	var vMag = function (v) {
	  return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
	};
	
	var vRatio = function (u, v) {
	  return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
	};
	
	var vAngle = function (u, v) {
	  return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
	};
	
	function processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
	  var psi = psiDeg * (PI / 180.0);
	  var xp = mathCos(psi) * (x1 - x2) / 2.0 + mathSin(psi) * (y1 - y2) / 2.0;
	  var yp = -1 * mathSin(psi) * (x1 - x2) / 2.0 + mathCos(psi) * (y1 - y2) / 2.0;
	  var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
	
	  if (lambda > 1) {
	    rx *= mathSqrt(lambda);
	    ry *= mathSqrt(lambda);
	  }
	
	  var f = (fa === fs ? -1 : 1) * mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
	  var cxp = f * rx * yp / ry;
	  var cyp = f * -ry * xp / rx;
	  var cx = (x1 + x2) / 2.0 + mathCos(psi) * cxp - mathSin(psi) * cyp;
	  var cy = (y1 + y2) / 2.0 + mathSin(psi) * cxp + mathCos(psi) * cyp;
	  var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
	  var u = [(xp - cxp) / rx, (yp - cyp) / ry];
	  var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
	  var dTheta = vAngle(u, v);
	
	  if (vRatio(u, v) <= -1) {
	    dTheta = PI;
	  }
	
	  if (vRatio(u, v) >= 1) {
	    dTheta = 0;
	  }
	
	  if (fs === 0 && dTheta > 0) {
	    dTheta = dTheta - 2 * PI;
	  }
	
	  if (fs === 1 && dTheta < 0) {
	    dTheta = dTheta + 2 * PI;
	  }
	
	  path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
	}
	
	function createPathProxyFromString(data) {
	  if (!data) {
	    return [];
	  } // command string
	
	
	  var cs = data.replace(/-/g, ' -').replace(/  /g, ' ').replace(/ /g, ',').replace(/,,/g, ',');
	  var n; // create pipes so that we can split the data
	
	  for (n = 0; n < cc.length; n++) {
	    cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
	  } // create array
	
	
	  var arr = cs.split('|'); // init context point
	
	  var cpx = 0;
	  var cpy = 0;
	  var path = new PathProxy();
	  var CMD = PathProxy.CMD;
	  var prevCmd;
	
	  for (n = 1; n < arr.length; n++) {
	    var str = arr[n];
	    var c = str.charAt(0);
	    var off = 0;
	    var p = str.slice(1).replace(/e,-/g, 'e-').split(',');
	    var cmd;
	
	    if (p.length > 0 && p[0] === '') {
	      p.shift();
	    }
	
	    for (var i = 0; i < p.length; i++) {
	      p[i] = parseFloat(p[i]);
	    }
	
	    while (off < p.length && !isNaN(p[off])) {
	      if (isNaN(p[0])) {
	        break;
	      }
	
	      var ctlPtx;
	      var ctlPty;
	      var rx;
	      var ry;
	      var psi;
	      var fa;
	      var fs;
	      var x1 = cpx;
	      var y1 = cpy; // convert l, H, h, V, and v to L
	
	      switch (c) {
	        case 'l':
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'L':
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'm':
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.M;
	          path.addData(cmd, cpx, cpy);
	          c = 'l';
	          break;
	
	        case 'M':
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.M;
	          path.addData(cmd, cpx, cpy);
	          c = 'L';
	          break;
	
	        case 'h':
	          cpx += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'H':
	          cpx = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'v':
	          cpy += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'V':
	          cpy = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'C':
	          cmd = CMD.C;
	          path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
	          cpx = p[off - 2];
	          cpy = p[off - 1];
	          break;
	
	        case 'c':
	          cmd = CMD.C;
	          path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
	          cpx += p[off - 2];
	          cpy += p[off - 1];
	          break;
	
	        case 'S':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.C) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cmd = CMD.C;
	          x1 = p[off++];
	          y1 = p[off++];
	          cpx = p[off++];
	          cpy = p[off++];
	          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
	          break;
	
	        case 's':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.C) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cmd = CMD.C;
	          x1 = cpx + p[off++];
	          y1 = cpy + p[off++];
	          cpx += p[off++];
	          cpy += p[off++];
	          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
	          break;
	
	        case 'Q':
	          x1 = p[off++];
	          y1 = p[off++];
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, x1, y1, cpx, cpy);
	          break;
	
	        case 'q':
	          x1 = p[off++] + cpx;
	          y1 = p[off++] + cpy;
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, x1, y1, cpx, cpy);
	          break;
	
	        case 'T':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.Q) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
	          break;
	
	        case 't':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.Q) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
	          break;
	
	        case 'A':
	          rx = p[off++];
	          ry = p[off++];
	          psi = p[off++];
	          fa = p[off++];
	          fs = p[off++];
	          x1 = cpx, y1 = cpy;
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.A;
	          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
	          break;
	
	        case 'a':
	          rx = p[off++];
	          ry = p[off++];
	          psi = p[off++];
	          fa = p[off++];
	          fs = p[off++];
	          x1 = cpx, y1 = cpy;
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.A;
	          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
	          break;
	      }
	    }
	
	    if (c === 'z' || c === 'Z') {
	      cmd = CMD.Z;
	      path.addData(cmd);
	    }
	
	    prevCmd = cmd;
	  }
	
	  path.toStatic();
	  return path;
	} // TODO Optimize double memory cost problem
	
	
	function createPathOptions(str, opts) {
	  var pathProxy = createPathProxyFromString(str);
	  opts = opts || {};
	
	  opts.buildPath = function (path) {
	    if (path.setData) {
	      path.setData(pathProxy.data); // Svg and vml renderer don't have context
	
	      var ctx = path.getContext();
	
	      if (ctx) {
	        path.rebuildPath(ctx);
	      }
	    } else {
	      var ctx = path;
	      pathProxy.rebuildPath(ctx);
	    }
	  };
	
	  opts.applyTransform = function (m) {
	    transformPath(pathProxy, m);
	    this.dirty(true);
	  };
	
	  return opts;
	}
	/**
	 * Create a Path object from path string data
	 * http://www.w3.org/TR/SVG/paths.html#PathData
	 * @param  {Object} opts Other options
	 */
	
	
	function createFromString(str, opts) {
	  return new Path(createPathOptions(str, opts));
	}
	/**
	 * Create a Path class from path string data
	 * @param  {string} str
	 * @param  {Object} opts Other options
	 */
	
	
	function extendFromString(str, opts) {
	  return Path.extend(createPathOptions(str, opts));
	}
	/**
	 * Merge multiple paths
	 */
	// TODO Apply transform
	// TODO stroke dash
	// TODO Optimize double memory cost problem
	
	
	function mergePath(pathEls, opts) {
	  var pathList = [];
	  var len = pathEls.length;
	
	  for (var i = 0; i < len; i++) {
	    var pathEl = pathEls[i];
	
	    if (!pathEl.path) {
	      pathEl.createPathProxy();
	    }
	
	    if (pathEl.__dirtyPath) {
	      pathEl.buildPath(pathEl.path, pathEl.shape, true);
	    }
	
	    pathList.push(pathEl.path);
	  }
	
	  var pathBundle = new Path(opts); // Need path proxy.
	
	  pathBundle.createPathProxy();
	
	  pathBundle.buildPath = function (path) {
	    path.appendPath(pathList); // Svg and vml renderer don't have context
	
	    var ctx = path.getContext();
	
	    if (ctx) {
	      path.rebuildPath(ctx);
	    }
	  };
	
	  return pathBundle;
	}
	
	exports.createFromString = createFromString;
	exports.extendFromString = extendFromString;
	exports.mergePath = mergePath;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	var PathProxy = __webpack_require__(60);
	
	var _vector = __webpack_require__(8);
	
	var v2ApplyTransform = _vector.applyTransform;
	var CMD = PathProxy.CMD;
	var points = [[], [], []];
	var mathSqrt = Math.sqrt;
	var mathAtan2 = Math.atan2;
	
	function _default(path, m) {
	  var data = path.data;
	  var cmd;
	  var nPoint;
	  var i;
	  var j;
	  var k;
	  var p;
	  var M = CMD.M;
	  var C = CMD.C;
	  var L = CMD.L;
	  var R = CMD.R;
	  var A = CMD.A;
	  var Q = CMD.Q;
	
	  for (i = 0, j = 0; i < data.length;) {
	    cmd = data[i++];
	    j = i;
	    nPoint = 0;
	
	    switch (cmd) {
	      case M:
	        nPoint = 1;
	        break;
	
	      case L:
	        nPoint = 1;
	        break;
	
	      case C:
	        nPoint = 3;
	        break;
	
	      case Q:
	        nPoint = 2;
	        break;
	
	      case A:
	        var x = m[4];
	        var y = m[5];
	        var sx = mathSqrt(m[0] * m[0] + m[1] * m[1]);
	        var sy = mathSqrt(m[2] * m[2] + m[3] * m[3]);
	        var angle = mathAtan2(-m[1] / sy, m[0] / sx); // cx
	
	        data[i] *= sx;
	        data[i++] += x; // cy
	
	        data[i] *= sy;
	        data[i++] += y; // Scale rx and ry
	        // FIXME Assume psi is 0 here
	
	        data[i++] *= sx;
	        data[i++] *= sy; // Start angle
	
	        data[i++] += angle; // end angle
	
	        data[i++] += angle; // FIXME psi
	
	        i += 2;
	        j = i;
	        break;
	
	      case R:
	        // x0, y0
	        p[0] = data[i++];
	        p[1] = data[i++];
	        v2ApplyTransform(p, p, m);
	        data[j++] = p[0];
	        data[j++] = p[1]; // x1, y1
	
	        p[0] += data[i++];
	        p[1] += data[i++];
	        v2ApplyTransform(p, p, m);
	        data[j++] = p[0];
	        data[j++] = p[1];
	    }
	
	    for (k = 0; k < nPoint; k++) {
	      var p = points[k];
	      p[0] = data[i++];
	      p[1] = data[i++];
	      v2ApplyTransform(p, p, m); // Write back
	
	      data[j++] = p[0];
	      data[j++] = p[1];
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	var zrLog = __webpack_require__(74);
	
	var vmlCore = __webpack_require__(231);
	
	var _util = __webpack_require__(1);
	
	var each = _util.each;
	
	/**
	 * VML Painter.
	 *
	 * @module zrender/vml/Painter
	 */
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	/**
	 * @alias module:zrender/vml/Painter
	 */
	
	
	function VMLPainter(root, storage) {
	  vmlCore.initVML();
	  this.root = root;
	  this.storage = storage;
	  var vmlViewport = document.createElement('div');
	  var vmlRoot = document.createElement('div');
	  vmlViewport.style.cssText = 'display:inline-block;overflow:hidden;position:relative;width:300px;height:150px;';
	  vmlRoot.style.cssText = 'position:absolute;left:0;top:0;';
	  root.appendChild(vmlViewport);
	  this._vmlRoot = vmlRoot;
	  this._vmlViewport = vmlViewport;
	  this.resize(); // Modify storage
	
	  var oldDelFromStorage = storage.delFromStorage;
	  var oldAddToStorage = storage.addToStorage;
	
	  storage.delFromStorage = function (el) {
	    oldDelFromStorage.call(storage, el);
	
	    if (el) {
	      el.onRemove && el.onRemove(vmlRoot);
	    }
	  };
	
	  storage.addToStorage = function (el) {
	    // Displayable already has a vml node
	    el.onAdd && el.onAdd(vmlRoot);
	    oldAddToStorage.call(storage, el);
	  };
	
	  this._firstPaint = true;
	}
	
	VMLPainter.prototype = {
	  constructor: VMLPainter,
	  getType: function () {
	    return 'vml';
	  },
	
	  /**
	   * @return {HTMLDivElement}
	   */
	  getViewportRoot: function () {
	    return this._vmlViewport;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	
	  /**
	   * 刷新
	   */
	  refresh: function () {
	    var list = this.storage.getDisplayList(true, true);
	
	    this._paintList(list);
	  },
	  _paintList: function (list) {
	    var vmlRoot = this._vmlRoot;
	
	    for (var i = 0; i < list.length; i++) {
	      var el = list[i];
	
	      if (el.invisible || el.ignore) {
	        if (!el.__alreadyNotVisible) {
	          el.onRemove(vmlRoot);
	        } // Set as already invisible
	
	
	        el.__alreadyNotVisible = true;
	      } else {
	        if (el.__alreadyNotVisible) {
	          el.onAdd(vmlRoot);
	        }
	
	        el.__alreadyNotVisible = false;
	
	        if (el.__dirty) {
	          el.beforeBrush && el.beforeBrush();
	          (el.brushVML || el.brush).call(el, vmlRoot);
	          el.afterBrush && el.afterBrush();
	        }
	      }
	
	      el.__dirty = false;
	    }
	
	    if (this._firstPaint) {
	      // Detached from document at first time
	      // to avoid page refreshing too many times
	      // FIXME 如果每次都先 removeChild 可能会导致一些填充和描边的效果改变
	      this._vmlViewport.appendChild(vmlRoot);
	
	      this._firstPaint = false;
	    }
	  },
	  resize: function (width, height) {
	    var width = width == null ? this._getWidth() : width;
	    var height = height == null ? this._getHeight() : height;
	
	    if (this._width != width || this._height != height) {
	      this._width = width;
	      this._height = height;
	      var vmlViewportStyle = this._vmlViewport.style;
	      vmlViewportStyle.width = width + 'px';
	      vmlViewportStyle.height = height + 'px';
	    }
	  },
	  dispose: function () {
	    this.root.innerHTML = '';
	    this._vmlRoot = this._vmlViewport = this.storage = null;
	  },
	  getWidth: function () {
	    return this._width;
	  },
	  getHeight: function () {
	    return this._height;
	  },
	  clear: function () {
	    if (this._vmlViewport) {
	      this.root.removeChild(this._vmlViewport);
	    }
	  },
	  _getWidth: function () {
	    var root = this.root;
	    var stl = root.currentStyle;
	    return (root.clientWidth || parseInt10(stl.width)) - parseInt10(stl.paddingLeft) - parseInt10(stl.paddingRight) | 0;
	  },
	  _getHeight: function () {
	    var root = this.root;
	    var stl = root.currentStyle;
	    return (root.clientHeight || parseInt10(stl.height)) - parseInt10(stl.paddingTop) - parseInt10(stl.paddingBottom) | 0;
	  }
	}; // Not supported methods
	
	function createMethodNotSupport(method) {
	  return function () {
	    zrLog('In IE8.0 VML mode painter not support method "' + method + '"');
	  };
	} // Unsupported methods
	
	
	each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'toDataURL', 'pathToImage'], function (name) {
	  VMLPainter.prototype[name] = createMethodNotSupport(name);
	});
	var _default = VMLPainter;
	module.exports = _default;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	var env = __webpack_require__(18);
	
	var _vector = __webpack_require__(8);
	
	var applyTransform = _vector.applyTransform;
	
	var BoundingRect = __webpack_require__(13);
	
	var colorTool = __webpack_require__(31);
	
	var textContain = __webpack_require__(27);
	
	var textHelper = __webpack_require__(100);
	
	var RectText = __webpack_require__(229);
	
	var Displayable = __webpack_require__(98);
	
	var ZImage = __webpack_require__(75);
	
	var Text = __webpack_require__(76);
	
	var Path = __webpack_require__(19);
	
	var PathProxy = __webpack_require__(60);
	
	var Gradient = __webpack_require__(99);
	
	var vmlCore = __webpack_require__(231);
	
	// http://www.w3.org/TR/NOTE-VML
	// TODO Use proxy like svg instead of overwrite brush methods
	var CMD = PathProxy.CMD;
	var round = Math.round;
	var sqrt = Math.sqrt;
	var abs = Math.abs;
	var cos = Math.cos;
	var sin = Math.sin;
	var mathMax = Math.max;
	
	if (!env.canvasSupported) {
	  var comma = ',';
	  var imageTransformPrefix = 'progid:DXImageTransform.Microsoft';
	  var Z = 21600;
	  var Z2 = Z / 2;
	  var ZLEVEL_BASE = 100000;
	  var Z_BASE = 1000;
	
	  var initRootElStyle = function (el) {
	    el.style.cssText = 'position:absolute;left:0;top:0;width:1px;height:1px;';
	    el.coordsize = Z + ',' + Z;
	    el.coordorigin = '0,0';
	  };
	
	  var encodeHtmlAttribute = function (s) {
	    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
	  };
	
	  var rgb2Str = function (r, g, b) {
	    return 'rgb(' + [r, g, b].join(',') + ')';
	  };
	
	  var append = function (parent, child) {
	    if (child && parent && child.parentNode !== parent) {
	      parent.appendChild(child);
	    }
	  };
	
	  var remove = function (parent, child) {
	    if (child && parent && child.parentNode === parent) {
	      parent.removeChild(child);
	    }
	  };
	
	  var getZIndex = function (zlevel, z, z2) {
	    // z 的取值范围为 [0, 1000]
	    return (parseFloat(zlevel) || 0) * ZLEVEL_BASE + (parseFloat(z) || 0) * Z_BASE + z2;
	  };
	
	  var parsePercent = function (value, maxValue) {
	    if (typeof value === 'string') {
	      if (value.lastIndexOf('%') >= 0) {
	        return parseFloat(value) / 100 * maxValue;
	      }
	
	      return parseFloat(value);
	    }
	
	    return value;
	  };
	  /***************************************************
	   * PATH
	   **************************************************/
	
	
	  var setColorAndOpacity = function (el, color, opacity) {
	    var colorArr = colorTool.parse(color);
	    opacity = +opacity;
	
	    if (isNaN(opacity)) {
	      opacity = 1;
	    }
	
	    if (colorArr) {
	      el.color = rgb2Str(colorArr[0], colorArr[1], colorArr[2]);
	      el.opacity = opacity * colorArr[3];
	    }
	  };
	
	  var getColorAndAlpha = function (color) {
	    var colorArr = colorTool.parse(color);
	    return [rgb2Str(colorArr[0], colorArr[1], colorArr[2]), colorArr[3]];
	  };
	
	  var updateFillNode = function (el, style, zrEl) {
	    // TODO pattern
	    var fill = style.fill;
	
	    if (fill != null) {
	      // Modified from excanvas
	      if (fill instanceof Gradient) {
	        var gradientType;
	        var angle = 0;
	        var focus = [0, 0]; // additional offset
	
	        var shift = 0; // scale factor for offset
	
	        var expansion = 1;
	        var rect = zrEl.getBoundingRect();
	        var rectWidth = rect.width;
	        var rectHeight = rect.height;
	
	        if (fill.type === 'linear') {
	          gradientType = 'gradient';
	          var transform = zrEl.transform;
	          var p0 = [fill.x * rectWidth, fill.y * rectHeight];
	          var p1 = [fill.x2 * rectWidth, fill.y2 * rectHeight];
	
	          if (transform) {
	            applyTransform(p0, p0, transform);
	            applyTransform(p1, p1, transform);
	          }
	
	          var dx = p1[0] - p0[0];
	          var dy = p1[1] - p0[1];
	          angle = Math.atan2(dx, dy) * 180 / Math.PI; // The angle should be a non-negative number.
	
	          if (angle < 0) {
	            angle += 360;
	          } // Very small angles produce an unexpected result because they are
	          // converted to a scientific notation string.
	
	
	          if (angle < 1e-6) {
	            angle = 0;
	          }
	        } else {
	          gradientType = 'gradientradial';
	          var p0 = [fill.x * rectWidth, fill.y * rectHeight];
	          var transform = zrEl.transform;
	          var scale = zrEl.scale;
	          var width = rectWidth;
	          var height = rectHeight;
	          focus = [// Percent in bounding rect
	          (p0[0] - rect.x) / width, (p0[1] - rect.y) / height];
	
	          if (transform) {
	            applyTransform(p0, p0, transform);
	          }
	
	          width /= scale[0] * Z;
	          height /= scale[1] * Z;
	          var dimension = mathMax(width, height);
	          shift = 2 * 0 / dimension;
	          expansion = 2 * fill.r / dimension - shift;
	        } // We need to sort the color stops in ascending order by offset,
	        // otherwise IE won't interpret it correctly.
	
	
	        var stops = fill.colorStops.slice();
	        stops.sort(function (cs1, cs2) {
	          return cs1.offset - cs2.offset;
	        });
	        var length = stops.length; // Color and alpha list of first and last stop
	
	        var colorAndAlphaList = [];
	        var colors = [];
	
	        for (var i = 0; i < length; i++) {
	          var stop = stops[i];
	          var colorAndAlpha = getColorAndAlpha(stop.color);
	          colors.push(stop.offset * expansion + shift + ' ' + colorAndAlpha[0]);
	
	          if (i === 0 || i === length - 1) {
	            colorAndAlphaList.push(colorAndAlpha);
	          }
	        }
	
	        if (length >= 2) {
	          var color1 = colorAndAlphaList[0][0];
	          var color2 = colorAndAlphaList[1][0];
	          var opacity1 = colorAndAlphaList[0][1] * style.opacity;
	          var opacity2 = colorAndAlphaList[1][1] * style.opacity;
	          el.type = gradientType;
	          el.method = 'none';
	          el.focus = '100%';
	          el.angle = angle;
	          el.color = color1;
	          el.color2 = color2;
	          el.colors = colors.join(','); // When colors attribute is used, the meanings of opacity and o:opacity2
	          // are reversed.
	
	          el.opacity = opacity2; // FIXME g_o_:opacity ?
	
	          el.opacity2 = opacity1;
	        }
	
	        if (gradientType === 'radial') {
	          el.focusposition = focus.join(',');
	        }
	      } else {
	        // FIXME Change from Gradient fill to color fill
	        setColorAndOpacity(el, fill, style.opacity);
	      }
	    }
	  };
	
	  var updateStrokeNode = function (el, style) {
	    // if (style.lineJoin != null) {
	    //     el.joinstyle = style.lineJoin;
	    // }
	    // if (style.miterLimit != null) {
	    //     el.miterlimit = style.miterLimit * Z;
	    // }
	    // if (style.lineCap != null) {
	    //     el.endcap = style.lineCap;
	    // }
	    if (style.lineDash != null) {
	      el.dashstyle = style.lineDash.join(' ');
	    }
	
	    if (style.stroke != null && !(style.stroke instanceof Gradient)) {
	      setColorAndOpacity(el, style.stroke, style.opacity);
	    }
	  };
	
	  var updateFillAndStroke = function (vmlEl, type, style, zrEl) {
	    var isFill = type == 'fill';
	    var el = vmlEl.getElementsByTagName(type)[0]; // Stroke must have lineWidth
	
	    if (style[type] != null && style[type] !== 'none' && (isFill || !isFill && style.lineWidth)) {
	      vmlEl[isFill ? 'filled' : 'stroked'] = 'true'; // FIXME Remove before updating, or set `colors` will throw error
	
	      if (style[type] instanceof Gradient) {
	        remove(vmlEl, el);
	      }
	
	      if (!el) {
	        el = vmlCore.createNode(type);
	      }
	
	      isFill ? updateFillNode(el, style, zrEl) : updateStrokeNode(el, style);
	      append(vmlEl, el);
	    } else {
	      vmlEl[isFill ? 'filled' : 'stroked'] = 'false';
	      remove(vmlEl, el);
	    }
	  };
	
	  var points = [[], [], []];
	
	  var pathDataToString = function (path, m) {
	    var M = CMD.M;
	    var C = CMD.C;
	    var L = CMD.L;
	    var A = CMD.A;
	    var Q = CMD.Q;
	    var str = [];
	    var nPoint;
	    var cmdStr;
	    var cmd;
	    var i;
	    var xi;
	    var yi;
	    var data = path.data;
	    var dataLength = path.len();
	
	    for (i = 0; i < dataLength;) {
	      cmd = data[i++];
	      cmdStr = '';
	      nPoint = 0;
	
	      switch (cmd) {
	        case M:
	          cmdStr = ' m ';
	          nPoint = 1;
	          xi = data[i++];
	          yi = data[i++];
	          points[0][0] = xi;
	          points[0][1] = yi;
	          break;
	
	        case L:
	          cmdStr = ' l ';
	          nPoint = 1;
	          xi = data[i++];
	          yi = data[i++];
	          points[0][0] = xi;
	          points[0][1] = yi;
	          break;
	
	        case Q:
	        case C:
	          cmdStr = ' c ';
	          nPoint = 3;
	          var x1 = data[i++];
	          var y1 = data[i++];
	          var x2 = data[i++];
	          var y2 = data[i++];
	          var x3;
	          var y3;
	
	          if (cmd === Q) {
	            // Convert quadratic to cubic using degree elevation
	            x3 = x2;
	            y3 = y2;
	            x2 = (x2 + 2 * x1) / 3;
	            y2 = (y2 + 2 * y1) / 3;
	            x1 = (xi + 2 * x1) / 3;
	            y1 = (yi + 2 * y1) / 3;
	          } else {
	            x3 = data[i++];
	            y3 = data[i++];
	          }
	
	          points[0][0] = x1;
	          points[0][1] = y1;
	          points[1][0] = x2;
	          points[1][1] = y2;
	          points[2][0] = x3;
	          points[2][1] = y3;
	          xi = x3;
	          yi = y3;
	          break;
	
	        case A:
	          var x = 0;
	          var y = 0;
	          var sx = 1;
	          var sy = 1;
	          var angle = 0;
	
	          if (m) {
	            // Extract SRT from matrix
	            x = m[4];
	            y = m[5];
	            sx = sqrt(m[0] * m[0] + m[1] * m[1]);
	            sy = sqrt(m[2] * m[2] + m[3] * m[3]);
	            angle = Math.atan2(-m[1] / sy, m[0] / sx);
	          }
	
	          var cx = data[i++];
	          var cy = data[i++];
	          var rx = data[i++];
	          var ry = data[i++];
	          var startAngle = data[i++] + angle;
	          var endAngle = data[i++] + startAngle + angle; // FIXME
	          // var psi = data[i++];
	
	          i++;
	          var clockwise = data[i++];
	          var x0 = cx + cos(startAngle) * rx;
	          var y0 = cy + sin(startAngle) * ry;
	          var x1 = cx + cos(endAngle) * rx;
	          var y1 = cy + sin(endAngle) * ry;
	          var type = clockwise ? ' wa ' : ' at ';
	
	          if (Math.abs(x0 - x1) < 1e-4) {
	            // IE won't render arches drawn counter clockwise if x0 == x1.
	            if (Math.abs(endAngle - startAngle) > 1e-2) {
	              // Offset x0 by 1/80 of a pixel. Use something
	              // that can be represented in binary
	              if (clockwise) {
	                x0 += 270 / Z;
	              }
	            } else {
	              // Avoid case draw full circle
	              if (Math.abs(y0 - cy) < 1e-4) {
	                if (clockwise && x0 < cx || !clockwise && x0 > cx) {
	                  y1 -= 270 / Z;
	                } else {
	                  y1 += 270 / Z;
	                }
	              } else if (clockwise && y0 < cy || !clockwise && y0 > cy) {
	                x1 += 270 / Z;
	              } else {
	                x1 -= 270 / Z;
	              }
	            }
	          }
	
	          str.push(type, round(((cx - rx) * sx + x) * Z - Z2), comma, round(((cy - ry) * sy + y) * Z - Z2), comma, round(((cx + rx) * sx + x) * Z - Z2), comma, round(((cy + ry) * sy + y) * Z - Z2), comma, round((x0 * sx + x) * Z - Z2), comma, round((y0 * sy + y) * Z - Z2), comma, round((x1 * sx + x) * Z - Z2), comma, round((y1 * sy + y) * Z - Z2));
	          xi = x1;
	          yi = y1;
	          break;
	
	        case CMD.R:
	          var p0 = points[0];
	          var p1 = points[1]; // x0, y0
	
	          p0[0] = data[i++];
	          p0[1] = data[i++]; // x1, y1
	
	          p1[0] = p0[0] + data[i++];
	          p1[1] = p0[1] + data[i++];
	
	          if (m) {
	            applyTransform(p0, p0, m);
	            applyTransform(p1, p1, m);
	          }
	
	          p0[0] = round(p0[0] * Z - Z2);
	          p1[0] = round(p1[0] * Z - Z2);
	          p0[1] = round(p0[1] * Z - Z2);
	          p1[1] = round(p1[1] * Z - Z2);
	          str.push( // x0, y0
	          ' m ', p0[0], comma, p0[1], // x1, y0
	          ' l ', p1[0], comma, p0[1], // x1, y1
	          ' l ', p1[0], comma, p1[1], // x0, y1
	          ' l ', p0[0], comma, p1[1]);
	          break;
	
	        case CMD.Z:
	          // FIXME Update xi, yi
	          str.push(' x ');
	      }
	
	      if (nPoint > 0) {
	        str.push(cmdStr);
	
	        for (var k = 0; k < nPoint; k++) {
	          var p = points[k];
	          m && applyTransform(p, p, m); // 不 round 会非常慢
	
	          str.push(round(p[0] * Z - Z2), comma, round(p[1] * Z - Z2), k < nPoint - 1 ? comma : '');
	        }
	      }
	    }
	
	    return str.join('');
	  }; // Rewrite the original path method
	
	
	  Path.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	    var vmlEl = this._vmlEl;
	
	    if (!vmlEl) {
	      vmlEl = vmlCore.createNode('shape');
	      initRootElStyle(vmlEl);
	      this._vmlEl = vmlEl;
	    }
	
	    updateFillAndStroke(vmlEl, 'fill', style, this);
	    updateFillAndStroke(vmlEl, 'stroke', style, this);
	    var m = this.transform;
	    var needTransform = m != null;
	    var strokeEl = vmlEl.getElementsByTagName('stroke')[0];
	
	    if (strokeEl) {
	      var lineWidth = style.lineWidth; // Get the line scale.
	      // Determinant of this.m_ means how much the area is enlarged by the
	      // transformation. So its square root can be used as a scale factor
	      // for width.
	
	      if (needTransform && !style.strokeNoScale) {
	        var det = m[0] * m[3] - m[1] * m[2];
	        lineWidth *= sqrt(abs(det));
	      }
	
	      strokeEl.weight = lineWidth + 'px';
	    }
	
	    var path = this.path || (this.path = new PathProxy());
	
	    if (this.__dirtyPath) {
	      path.beginPath();
	      this.buildPath(path, this.shape);
	      path.toStatic();
	      this.__dirtyPath = false;
	    }
	
	    vmlEl.path = pathDataToString(path, this.transform);
	    vmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Append to root
	
	    append(vmlRoot, vmlEl); // Text
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, this.getBoundingRect());
	    } else {
	      this.removeRectText(vmlRoot);
	    }
	  };
	
	  Path.prototype.onRemove = function (vmlRoot) {
	    remove(vmlRoot, this._vmlEl);
	    this.removeRectText(vmlRoot);
	  };
	
	  Path.prototype.onAdd = function (vmlRoot) {
	    append(vmlRoot, this._vmlEl);
	    this.appendRectText(vmlRoot);
	  };
	  /***************************************************
	   * IMAGE
	   **************************************************/
	
	
	  var isImage = function (img) {
	    // FIXME img instanceof Image 如果 img 是一个字符串的时候，IE8 下会报错
	    return typeof img === 'object' && img.tagName && img.tagName.toUpperCase() === 'IMG'; // return img instanceof Image;
	  }; // Rewrite the original path method
	
	
	  ZImage.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	    var image = style.image; // Image original width, height
	
	    var ow;
	    var oh;
	
	    if (isImage(image)) {
	      var src = image.src;
	
	      if (src === this._imageSrc) {
	        ow = this._imageWidth;
	        oh = this._imageHeight;
	      } else {
	        var imageRuntimeStyle = image.runtimeStyle;
	        var oldRuntimeWidth = imageRuntimeStyle.width;
	        var oldRuntimeHeight = imageRuntimeStyle.height;
	        imageRuntimeStyle.width = 'auto';
	        imageRuntimeStyle.height = 'auto'; // get the original size
	
	        ow = image.width;
	        oh = image.height; // and remove overides
	
	        imageRuntimeStyle.width = oldRuntimeWidth;
	        imageRuntimeStyle.height = oldRuntimeHeight; // Caching image original width, height and src
	
	        this._imageSrc = src;
	        this._imageWidth = ow;
	        this._imageHeight = oh;
	      }
	
	      image = src;
	    } else {
	      if (image === this._imageSrc) {
	        ow = this._imageWidth;
	        oh = this._imageHeight;
	      }
	    }
	
	    if (!image) {
	      return;
	    }
	
	    var x = style.x || 0;
	    var y = style.y || 0;
	    var dw = style.width;
	    var dh = style.height;
	    var sw = style.sWidth;
	    var sh = style.sHeight;
	    var sx = style.sx || 0;
	    var sy = style.sy || 0;
	    var hasCrop = sw && sh;
	    var vmlEl = this._vmlEl;
	
	    if (!vmlEl) {
	      // FIXME 使用 group 在 left, top 都不是 0 的时候就无法显示了。
	      // vmlEl = vmlCore.createNode('group');
	      vmlEl = vmlCore.doc.createElement('div');
	      initRootElStyle(vmlEl);
	      this._vmlEl = vmlEl;
	    }
	
	    var vmlElStyle = vmlEl.style;
	    var hasRotation = false;
	    var m;
	    var scaleX = 1;
	    var scaleY = 1;
	
	    if (this.transform) {
	      m = this.transform;
	      scaleX = sqrt(m[0] * m[0] + m[1] * m[1]);
	      scaleY = sqrt(m[2] * m[2] + m[3] * m[3]);
	      hasRotation = m[1] || m[2];
	    }
	
	    if (hasRotation) {
	      // If filters are necessary (rotation exists), create them
	      // filters are bog-slow, so only create them if abbsolutely necessary
	      // The following check doesn't account for skews (which don't exist
	      // in the canvas spec (yet) anyway.
	      // From excanvas
	      var p0 = [x, y];
	      var p1 = [x + dw, y];
	      var p2 = [x, y + dh];
	      var p3 = [x + dw, y + dh];
	      applyTransform(p0, p0, m);
	      applyTransform(p1, p1, m);
	      applyTransform(p2, p2, m);
	      applyTransform(p3, p3, m);
	      var maxX = mathMax(p0[0], p1[0], p2[0], p3[0]);
	      var maxY = mathMax(p0[1], p1[1], p2[1], p3[1]);
	      var transformFilter = [];
	      transformFilter.push('M11=', m[0] / scaleX, comma, 'M12=', m[2] / scaleY, comma, 'M21=', m[1] / scaleX, comma, 'M22=', m[3] / scaleY, comma, 'Dx=', round(x * scaleX + m[4]), comma, 'Dy=', round(y * scaleY + m[5]));
	      vmlElStyle.padding = '0 ' + round(maxX) + 'px ' + round(maxY) + 'px 0'; // FIXME DXImageTransform 在 IE11 的兼容模式下不起作用
	
	      vmlElStyle.filter = imageTransformPrefix + '.Matrix(' + transformFilter.join('') + ', SizingMethod=clip)';
	    } else {
	      if (m) {
	        x = x * scaleX + m[4];
	        y = y * scaleY + m[5];
	      }
	
	      vmlElStyle.filter = '';
	      vmlElStyle.left = round(x) + 'px';
	      vmlElStyle.top = round(y) + 'px';
	    }
	
	    var imageEl = this._imageEl;
	    var cropEl = this._cropEl;
	
	    if (!imageEl) {
	      imageEl = vmlCore.doc.createElement('div');
	      this._imageEl = imageEl;
	    }
	
	    var imageELStyle = imageEl.style;
	
	    if (hasCrop) {
	      // Needs know image original width and height
	      if (!(ow && oh)) {
	        var tmpImage = new Image();
	        var self = this;
	
	        tmpImage.onload = function () {
	          tmpImage.onload = null;
	          ow = tmpImage.width;
	          oh = tmpImage.height; // Adjust image width and height to fit the ratio destinationSize / sourceSize
	
	          imageELStyle.width = round(scaleX * ow * dw / sw) + 'px';
	          imageELStyle.height = round(scaleY * oh * dh / sh) + 'px'; // Caching image original width, height and src
	
	          self._imageWidth = ow;
	          self._imageHeight = oh;
	          self._imageSrc = image;
	        };
	
	        tmpImage.src = image;
	      } else {
	        imageELStyle.width = round(scaleX * ow * dw / sw) + 'px';
	        imageELStyle.height = round(scaleY * oh * dh / sh) + 'px';
	      }
	
	      if (!cropEl) {
	        cropEl = vmlCore.doc.createElement('div');
	        cropEl.style.overflow = 'hidden';
	        this._cropEl = cropEl;
	      }
	
	      var cropElStyle = cropEl.style;
	      cropElStyle.width = round((dw + sx * dw / sw) * scaleX);
	      cropElStyle.height = round((dh + sy * dh / sh) * scaleY);
	      cropElStyle.filter = imageTransformPrefix + '.Matrix(Dx=' + -sx * dw / sw * scaleX + ',Dy=' + -sy * dh / sh * scaleY + ')';
	
	      if (!cropEl.parentNode) {
	        vmlEl.appendChild(cropEl);
	      }
	
	      if (imageEl.parentNode != cropEl) {
	        cropEl.appendChild(imageEl);
	      }
	    } else {
	      imageELStyle.width = round(scaleX * dw) + 'px';
	      imageELStyle.height = round(scaleY * dh) + 'px';
	      vmlEl.appendChild(imageEl);
	
	      if (cropEl && cropEl.parentNode) {
	        vmlEl.removeChild(cropEl);
	        this._cropEl = null;
	      }
	    }
	
	    var filterStr = '';
	    var alpha = style.opacity;
	
	    if (alpha < 1) {
	      filterStr += '.Alpha(opacity=' + round(alpha * 100) + ') ';
	    }
	
	    filterStr += imageTransformPrefix + '.AlphaImageLoader(src=' + image + ', SizingMethod=scale)';
	    imageELStyle.filter = filterStr;
	    vmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Append to root
	
	    append(vmlRoot, vmlEl); // Text
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, this.getBoundingRect());
	    }
	  };
	
	  ZImage.prototype.onRemove = function (vmlRoot) {
	    remove(vmlRoot, this._vmlEl);
	    this._vmlEl = null;
	    this._cropEl = null;
	    this._imageEl = null;
	    this.removeRectText(vmlRoot);
	  };
	
	  ZImage.prototype.onAdd = function (vmlRoot) {
	    append(vmlRoot, this._vmlEl);
	    this.appendRectText(vmlRoot);
	  };
	  /***************************************************
	   * TEXT
	   **************************************************/
	
	
	  var DEFAULT_STYLE_NORMAL = 'normal';
	  var fontStyleCache = {};
	  var fontStyleCacheCount = 0;
	  var MAX_FONT_CACHE_SIZE = 100;
	  var fontEl = document.createElement('div');
	
	  var getFontStyle = function (fontString) {
	    var fontStyle = fontStyleCache[fontString];
	
	    if (!fontStyle) {
	      // Clear cache
	      if (fontStyleCacheCount > MAX_FONT_CACHE_SIZE) {
	        fontStyleCacheCount = 0;
	        fontStyleCache = {};
	      }
	
	      var style = fontEl.style;
	      var fontFamily;
	
	      try {
	        style.font = fontString;
	        fontFamily = style.fontFamily.split(',')[0];
	      } catch (e) {}
	
	      fontStyle = {
	        style: style.fontStyle || DEFAULT_STYLE_NORMAL,
	        variant: style.fontVariant || DEFAULT_STYLE_NORMAL,
	        weight: style.fontWeight || DEFAULT_STYLE_NORMAL,
	        size: parseFloat(style.fontSize || 12) | 0,
	        family: fontFamily || 'Microsoft YaHei'
	      };
	      fontStyleCache[fontString] = fontStyle;
	      fontStyleCacheCount++;
	    }
	
	    return fontStyle;
	  };
	
	  var textMeasureEl; // Overwrite measure text method
	
	  textContain.$override('measureText', function (text, textFont) {
	    var doc = vmlCore.doc;
	
	    if (!textMeasureEl) {
	      textMeasureEl = doc.createElement('div');
	      textMeasureEl.style.cssText = 'position:absolute;top:-20000px;left:0;' + 'padding:0;margin:0;border:none;white-space:pre;';
	      vmlCore.doc.body.appendChild(textMeasureEl);
	    }
	
	    try {
	      textMeasureEl.style.font = textFont;
	    } catch (ex) {// Ignore failures to set to invalid font.
	    }
	
	    textMeasureEl.innerHTML = ''; // Don't use innerHTML or innerText because they allow markup/whitespace.
	
	    textMeasureEl.appendChild(doc.createTextNode(text));
	    return {
	      width: textMeasureEl.offsetWidth
	    };
	  });
	  var tmpRect = new BoundingRect();
	
	  var drawRectText = function (vmlRoot, rect, textRect, fromTextEl) {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	    var text = style.text; // Convert to string
	
	    text != null && (text += '');
	
	    if (!text) {
	      return;
	    } // Convert rich text to plain text. Rich text is not supported in
	    // IE8-, but tags in rich text template will be removed.
	
	
	    if (style.rich) {
	      var contentBlock = textContain.parseRichText(text, style);
	      text = [];
	
	      for (var i = 0; i < contentBlock.lines.length; i++) {
	        var tokens = contentBlock.lines[i].tokens;
	        var textLine = [];
	
	        for (var j = 0; j < tokens.length; j++) {
	          textLine.push(tokens[j].text);
	        }
	
	        text.push(textLine.join(''));
	      }
	
	      text = text.join('\n');
	    }
	
	    var x;
	    var y;
	    var align = style.textAlign;
	    var verticalAlign = style.textVerticalAlign;
	    var fontStyle = getFontStyle(style.font); // FIXME encodeHtmlAttribute ?
	
	    var font = fontStyle.style + ' ' + fontStyle.variant + ' ' + fontStyle.weight + ' ' + fontStyle.size + 'px "' + fontStyle.family + '"';
	    textRect = textRect || textContain.getBoundingRect(text, font, align, verticalAlign); // Transform rect to view space
	
	    var m = this.transform; // Ignore transform for text in other element
	
	    if (m && !fromTextEl) {
	      tmpRect.copy(rect);
	      tmpRect.applyTransform(m);
	      rect = tmpRect;
	    }
	
	    if (!fromTextEl) {
	      var textPosition = style.textPosition;
	      var distance = style.textDistance; // Text position represented by coord
	
	      if (textPosition instanceof Array) {
	        x = rect.x + parsePercent(textPosition[0], rect.width);
	        y = rect.y + parsePercent(textPosition[1], rect.height);
	        align = align || 'left';
	      } else {
	        var res = textContain.adjustTextPositionOnRect(textPosition, rect, distance);
	        x = res.x;
	        y = res.y; // Default align and baseline when has textPosition
	
	        align = align || res.textAlign;
	        verticalAlign = verticalAlign || res.textVerticalAlign;
	      }
	    } else {
	      x = rect.x;
	      y = rect.y;
	    }
	
	    x = textContain.adjustTextX(x, textRect.width, align);
	    y = textContain.adjustTextY(y, textRect.height, verticalAlign); // Force baseline 'middle'
	
	    y += textRect.height / 2; // var fontSize = fontStyle.size;
	    // 1.75 is an arbitrary number, as there is no info about the text baseline
	    // switch (baseline) {
	    // case 'hanging':
	    // case 'top':
	    //     y += fontSize / 1.75;
	    //     break;
	    //     case 'middle':
	    //         break;
	    //     default:
	    //     // case null:
	    //     // case 'alphabetic':
	    //     // case 'ideographic':
	    //     // case 'bottom':
	    //         y -= fontSize / 2.25;
	    //         break;
	    // }
	    // switch (align) {
	    //     case 'left':
	    //         break;
	    //     case 'center':
	    //         x -= textRect.width / 2;
	    //         break;
	    //     case 'right':
	    //         x -= textRect.width;
	    //         break;
	    // case 'end':
	    // align = elementStyle.direction == 'ltr' ? 'right' : 'left';
	    // break;
	    // case 'start':
	    // align = elementStyle.direction == 'rtl' ? 'right' : 'left';
	    // break;
	    // default:
	    //     align = 'left';
	    // }
	
	    var createNode = vmlCore.createNode;
	    var textVmlEl = this._textVmlEl;
	    var pathEl;
	    var textPathEl;
	    var skewEl;
	
	    if (!textVmlEl) {
	      textVmlEl = createNode('line');
	      pathEl = createNode('path');
	      textPathEl = createNode('textpath');
	      skewEl = createNode('skew'); // FIXME Why here is not cammel case
	      // Align 'center' seems wrong
	
	      textPathEl.style['v-text-align'] = 'left';
	      initRootElStyle(textVmlEl);
	      pathEl.textpathok = true;
	      textPathEl.on = true;
	      textVmlEl.from = '0 0';
	      textVmlEl.to = '1000 0.05';
	      append(textVmlEl, skewEl);
	      append(textVmlEl, pathEl);
	      append(textVmlEl, textPathEl);
	      this._textVmlEl = textVmlEl;
	    } else {
	      // 这里是在前面 appendChild 保证顺序的前提下
	      skewEl = textVmlEl.firstChild;
	      pathEl = skewEl.nextSibling;
	      textPathEl = pathEl.nextSibling;
	    }
	
	    var coords = [x, y];
	    var textVmlElStyle = textVmlEl.style; // Ignore transform for text in other element
	
	    if (m && fromTextEl) {
	      applyTransform(coords, coords, m);
	      skewEl.on = true;
	      skewEl.matrix = m[0].toFixed(3) + comma + m[2].toFixed(3) + comma + m[1].toFixed(3) + comma + m[3].toFixed(3) + ',0,0'; // Text position
	
	      skewEl.offset = (round(coords[0]) || 0) + ',' + (round(coords[1]) || 0); // Left top point as origin
	
	      skewEl.origin = '0 0';
	      textVmlElStyle.left = '0px';
	      textVmlElStyle.top = '0px';
	    } else {
	      skewEl.on = false;
	      textVmlElStyle.left = round(x) + 'px';
	      textVmlElStyle.top = round(y) + 'px';
	    }
	
	    textPathEl.string = encodeHtmlAttribute(text); // TODO
	
	    try {
	      textPathEl.style.font = font;
	    } // Error font format
	    catch (e) {}
	
	    updateFillAndStroke(textVmlEl, 'fill', {
	      fill: style.textFill,
	      opacity: style.opacity
	    }, this);
	    updateFillAndStroke(textVmlEl, 'stroke', {
	      stroke: style.textStroke,
	      opacity: style.opacity,
	      lineDash: style.lineDash
	    }, this);
	    textVmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Attached to root
	
	    append(vmlRoot, textVmlEl);
	  };
	
	  var removeRectText = function (vmlRoot) {
	    remove(vmlRoot, this._textVmlEl);
	    this._textVmlEl = null;
	  };
	
	  var appendRectText = function (vmlRoot) {
	    append(vmlRoot, this._textVmlEl);
	  };
	
	  var list = [RectText, Displayable, ZImage, Path, Text]; // In case Displayable has been mixed in RectText
	
	  for (var i = 0; i < list.length; i++) {
	    var proto = list[i].prototype;
	    proto.drawRectText = drawRectText;
	    proto.removeRectText = removeRectText;
	    proto.appendRectText = appendRectText;
	  }
	
	  Text.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, {
	        x: style.x || 0,
	        y: style.y || 0,
	        width: 0,
	        height: 0
	      }, this.getBoundingRect(), true);
	    } else {
	      this.removeRectText(vmlRoot);
	    }
	  };
	
	  Text.prototype.onRemove = function (vmlRoot) {
	    this.removeRectText(vmlRoot);
	  };
	
	  Text.prototype.onAdd = function (vmlRoot) {
	    this.appendRectText(vmlRoot);
	  };
	}

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(767);
	
	var _zrender = __webpack_require__(101);
	
	var registerPainter = _zrender.registerPainter;
	
	var Painter = __webpack_require__(766);
	
	registerPainter('vml', Painter);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.e51251e9815c343faaf5.js